export const products = [
  {
    id: "29",
    brand: "Apple",
    sku: "MTMH3J/A",
    product_eng: "iPhone 15 128GB Black",
    product_jpn: "iPhone 15 128GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMH3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "30",
    brand: "Apple",
    sku: "MTMJ3J/A",
    product_eng: "iPhone 15 128GB Pink",
    product_jpn: "iPhone 15 128GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMJ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "31",
    brand: "Apple",
    sku: "MTMK3J/A",
    product_eng: "iPhone 15 128GB Yellow",
    product_jpn: "iPhone 15 128GB イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMK3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "32",
    brand: "Apple",
    sku: "MTML3J/A",
    product_eng: "iPhone 15 128GB Blue",
    product_jpn: "iPhone 15 128GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTML3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "33",
    brand: "Apple",
    sku: "MTMM3J/A",
    product_eng: "iPhone 15 128GB Green",
    product_jpn: "iPhone 15 128GB グリーン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMM3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "34",
    brand: "Apple",
    sku: "MTMN3J/A",
    product_eng: "iPhone 15 256GB Black",
    product_jpn: "iPhone 15 256GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMN3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "35",
    brand: "Apple",
    sku: "MTMP3J/A",
    product_eng: "iPhone 15 256GB Pink",
    product_jpn: "iPhone 15 256GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMP3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "36",
    brand: "Apple",
    sku: "MTMQ3J/A",
    product_eng: "iPhone 15 256GB Yellow",
    product_jpn: "iPhone 15 256GB イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMQ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "37",
    brand: "Apple",
    sku: "MTMR3J/A",
    product_eng: "iPhone 15 256GB Blue",
    product_jpn: "iPhone 15 256GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMR3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "38",
    brand: "Apple",
    sku: "MTMT3J/A",
    product_eng: "iPhone 15 256GB Green",
    product_jpn: "iPhone 15 256GB グリーン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMT3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "39",
    brand: "Apple",
    sku: "MTMU3J/A",
    product_eng: "iPhone 15 512GB Black",
    product_jpn: "iPhone 15 512GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMU3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "40",
    brand: "Apple",
    sku: "MTMV3J/A",
    product_eng: "iPhone 15 512GB Pink",
    product_jpn: "iPhone 15 512GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMV3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "41",
    brand: "Apple",
    sku: "MTMW3J/A",
    product_eng: "iPhone 15 512GB Yellow",
    product_jpn: "iPhone 15 512GB イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMW3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "42",
    brand: "Apple",
    sku: "MTMX3J/A",
    product_eng: "iPhone 15 512GB Blue",
    product_jpn: "iPhone 15 512GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMX3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "43",
    brand: "Apple",
    sku: "MTMY3J/A",
    product_eng: "iPhone 15 512GB Green",
    product_jpn: "iPhone 15 512GB グリーン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.1-inch (diagonal) all-screen OLED display with 2,556 x 1,179 pixel resolution at 460 ppi ・Width: 71.6 mm / Height: 147.6 mm / Thickness: 7.80 mm / Weight: 171 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.1インチ（対角）オールスクリーンOLEDディスプレイ 2,556 x 1,179ピクセル解像度、460ppi ・幅：71.6 mm/高さ：147.6 mm/厚さ：7.80 mm/ 重量：171 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MTMY3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "44",
    brand: "Apple",
    sku: "MU083J/A",
    product_eng: "iPhone 15 Plus 128GB Black",
    product_jpn: "iPhone 15 Plus 128GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU083JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "45",
    brand: "Apple",
    sku: "MU093J/A",
    product_eng: "iPhone 15 Plus 128GB Pink",
    product_jpn: "iPhone 15 Plus 128GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU093JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "46",
    brand: "Apple",
    sku: "MU0A3J/A",
    product_eng: "iPhone 15 Plus 128GB Yellow",
    product_jpn: "iPhone 15 Plus 128GB イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0A3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "47",
    brand: "Apple",
    sku: "MU0D3J/A",
    product_eng: "iPhone 15 Plus 128GB Blue",
    product_jpn: "iPhone 15 Plus 128GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0D3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "48",
    brand: "Apple",
    sku: "MU0E3J/A",
    product_eng: "iPhone 15 Plus 128GB Green",
    product_jpn: "iPhone 15 Plus 128GB グリーン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0E3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "49",
    brand: "Apple",
    sku: "MU0F3J/A",
    product_eng: "iPhone 15 Plus 256GB Black",
    product_jpn: "iPhone 15 Plus 256GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0F3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "50",
    brand: "Apple",
    sku: "MU0H3J/A",
    product_eng: "iPhone 15 Plus 256GB Pink",
    product_jpn: "iPhone 15 Plus 256GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0H3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "51",
    brand: "Apple",
    sku: "MU0J3J/A",
    product_eng: "iPhone 15 Plus 256GB Yellow",
    product_jpn: "iPhone 15 Plus 256GB イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0J3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "52",
    brand: "Apple",
    sku: "MU0N3J/A",
    product_eng: "iPhone 15 Plus 256GB Blue",
    product_jpn: "iPhone 15 Plus 256GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0N3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "53",
    brand: "Apple",
    sku: "MU0Q3J/A",
    product_eng: "iPhone 15 Plus 256GB Green",
    product_jpn: "iPhone 15 Plus 256GB グリーン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0Q3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "54",
    brand: "Apple",
    sku: "MU0T3J/A",
    product_eng: "iPhone 15 Plus 512GB Black",
    product_jpn: "iPhone 15 Plus 512GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥168,000",
    rrp_with_vat: "¥184,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0T3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "55",
    brand: "Apple",
    sku: "MU0U3J/A",
    product_eng: "iPhone 15 Plus 512GB Pink",
    product_jpn: "iPhone 15 Plus 512GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥168,000",
    rrp_with_vat: "¥184,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0U3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "56",
    brand: "Apple",
    sku: "MU0V3J/A",
    product_eng: "iPhone 15 Plus 512GB Yellow",
    product_jpn: "iPhone 15 Plus 512GB イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥168,000",
    rrp_with_vat: "¥184,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0V3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "57",
    brand: "Apple",
    sku: "MU0W3J/A",
    product_eng: "iPhone 15 Plus 512GB Blue",
    product_jpn: "iPhone 15 Plus 512GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥168,000",
    rrp_with_vat: "¥184,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0W3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "58",
    brand: "Apple",
    sku: "MU0X3J/A",
    product_eng: "iPhone 15 Plus 512GB Green",
    product_jpn: "iPhone 15 Plus 512GB グリーン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥168,000",
    rrp_with_vat: "¥184,800",
    description_eng:
      "Dynamic Island for instant alerts and live activity, 48MP main camera that captures powerful details, and USB C.  ・With Dynamic Island, you can catch up on what you need to know even when you're doing something else. ・The back glass is made of a color-impregnated material. In addition, glass made with a proprietary dual ion-exchange process and an aerospace-grade aluminum enclosure make the iPhone 15 incredibly durable. ・with a new 48MP main camera that allows for ultra-high-resolution photography.    And ultra-high resolution. 2x telephoto. ・No more switching to portrait mode. If your subject is a person, dog, or cat, iPhone 15 automatically knows the depth-of-field information and creates a portrait with a clever blur effect in no time. ・Battery power for all-day enjoyment of your favorite activities. ・The A16 Bionic chip powers all the advanced features. ・The new USB-C connector allows you to use the same cable you use to charge your iPhone 15 with your Mac or iPad. You can also connect your Apple Watch or AirPods to iPhone 15 for charging.5 Say goodbye to cable-laden days. ・6.7 (diagonal) all-screen OLED display 2,796 x 1,290 pixel resolution, 460 ppi ・Height: 160.9 mm / Width: 77.8 mm / Thickness: 7.80 mm / Weight: 201 g",
    description_jpn:
      "アラートやライブアクティビティがパッと浮かび上がるDynamic Island。迫力のディテールをとらえる48MPのメインカメラ。そしてUSB-C。  ・画面のトップに浮かび上がるような動きで、アラートやライブアクティビティを表示。Dynamic Islandがあれば、別のことをしていても知りたい情報をキャッチできます。 ・素材に色を浸透させた背面ガラスです。さらに、独自の二重イオン交換プロセスで作られたガラスと、航空宇宙産業レベルのアルミニウムを採用した筐体によって、iPhone 15は信じられないほどの耐久性を持っています。 ・新しい48MPのメインカメラを使って、超高解像度での撮影ができるようになりました。    超高解像度も。2倍望遠も。 ・ポートレートモードに切り替える必要はもうありません。被写体が人物、犬、猫なら、iPhone 15が被写界深度に関する情報を自動的に把握するので、あっという間に巧みなぼかし効果を加えたポートレートのできあがり。 ・好きなことを一日中楽しむためのバッテリー。 ・A16 Bionicチップは、あらゆる先進的な機能をパワフルに動かします。 ・新しくUSB-Cコネクタを搭載。iPhone 15の充電に使うケーブルをMacやiPadにも使えるようになりました。さらに、Apple WatchやAirPodsをiPhone 15につないで充電することもできます5。これで、ケーブルだらけの毎日とはお別れです。 ・6.7インチ（対角）オールスクリーンOLEDディスプレイ 2,796 x 1,290ピクセル解像度、460ppi ・高さ：160.9 mm/幅：77.8 mm/厚さ：7.80 mm / 重量：201 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone15/Apple_MU0X3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "59",
    brand: "Apple",
    sku: "MPUD3J/A",
    product_eng: "iPhone 14 128GB Midnight",
    product_jpn: "iPhone 14 128GB ミッドナイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥102,545",
    rrp_with_vat: "¥112,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPUD3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "60",
    brand: "Apple",
    sku: "MPUQ3J/A",
    product_eng: "iPhone 14 128GB Starlight",
    product_jpn: "iPhone 14 128GB スターライト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥102,545",
    rrp_with_vat: "¥112,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPUQ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "61",
    brand: "Apple",
    sku: "MPV93J/A",
    product_eng: "iPhone 14 128GB RED",
    product_jpn: "iPhone 14 128GB RED",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥102,545",
    rrp_with_vat: "¥112,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPV93JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "62",
    brand: "Apple",
    sku: "MPVJ3J/A",
    product_eng: "iPhone 14 128GB Blue",
    product_jpn: "iPhone 14 128GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥102,545",
    rrp_with_vat: "¥112,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPVJ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "63",
    brand: "Apple",
    sku: "MPUY3J/A",
    product_eng: "iPhone 14 128GB Purple",
    product_jpn: "iPhone 14 128GB パープル",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥102,545",
    rrp_with_vat: "¥112,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPUY3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "64",
    brand: "Apple",
    sku: "MPVW3J/A",
    product_eng: "iPhone 14 256GB Midnight",
    product_jpn: "iPhone 14 256GB ミッドナイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥116,182",
    rrp_with_vat: "¥127,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPVW3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "65",
    brand: "Apple",
    sku: "MPW33J/A",
    product_eng: "iPhone 14 256GB Starlight",
    product_jpn: "iPhone 14 256GB スターライト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥116,182",
    rrp_with_vat: "¥127,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPW33JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "66",
    brand: "Apple",
    sku: "MPWG3J/A",
    product_eng: "iPhone 14 256GB RED",
    product_jpn: "iPhone 14 256GB RED",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥116,182",
    rrp_with_vat: "¥127,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPWG3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "67",
    brand: "Apple",
    sku: "MPWN3J/A",
    product_eng: "iPhone 14 256GB Blue",
    product_jpn: "iPhone 14 256GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥116,182",
    rrp_with_vat: "¥127,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPWN3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "68",
    brand: "Apple",
    sku: "MPW93J/A",
    product_eng: "iPhone 14 256GB Purple",
    product_jpn: "iPhone 14 256GB パープル",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥116,182",
    rrp_with_vat: "¥127,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPW93JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "69",
    brand: "Apple",
    sku: "MPWV3J/A",
    product_eng: "iPhone 14 512GB Midnight",
    product_jpn: "iPhone 14 512GB ミッドナイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥143,455",
    rrp_with_vat: "¥157,801",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPWV3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "70",
    brand: "Apple",
    sku: "MPX23J/A",
    product_eng: "iPhone 14 512GB Starlight",
    product_jpn: "iPhone 14 512GB スターライト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥143,455",
    rrp_with_vat: "¥157,801",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPX23JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "71",
    brand: "Apple",
    sku: "MPXF3J/A",
    product_eng: "iPhone 14 512GB (PRODUCT)RED",
    product_jpn: "iPhone 14 512GB (PRODUCT)RED",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥143,455",
    rrp_with_vat: "¥157,801",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPXF3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "72",
    brand: "Apple",
    sku: "MPXM3J/A",
    product_eng: "iPhone 14 512GB Blue",
    product_jpn: "iPhone 14 512GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥143,455",
    rrp_with_vat: "¥157,801",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPXM3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "73",
    brand: "Apple",
    sku: "MPX83J/A",
    product_eng: "iPhone 14 512GB Purple",
    product_jpn: "iPhone 14 512GB パープル",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥143,455",
    rrp_with_vat: "¥157,801",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 146.7 mm Width: 71.5 mm Thickness: 7.80 mm      Weight: 172 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MPX83JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "74",
    brand: "Apple",
    sku: "MQ4A3J/A",
    product_eng: "iPhone 14 Plus 128GB Midnight",
    product_jpn: "iPhone 14 Plus 128GB ミッドナイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,801",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4A3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "75",
    brand: "Apple",
    sku: "MQ4D3J/A",
    product_eng: "iPhone 14 Plus 128GB Starlight",
    product_jpn: "iPhone 14 Plus 128GB スターライト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,801",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4D3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "76",
    brand: "Apple",
    sku: "MQ4F3J/A",
    product_eng: "iPhone 14 Plus 128GB RED",
    product_jpn: "iPhone 14 Plus 128GB RED",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,801",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4F3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "77",
    brand: "Apple",
    sku: "MQ4H3J/A",
    product_eng: "iPhone 14 Plus 128GB Blue",
    product_jpn: "iPhone 14 Plus 128GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,801",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4H3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "78",
    brand: "Apple",
    sku: "MQ4E3J/A",
    product_eng: "iPhone 14 Plus 128GB Purple",
    product_jpn: "iPhone 14 Plus 128GB パープル",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,801",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4E3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "79",
    brand: "Apple",
    sku: "MQ4J3J/A",
    product_eng: "iPhone 14 Plus 256GB Midnight",
    product_jpn: "iPhone 14 Plus 256GB ミッドナイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4J3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "80",
    brand: "Apple",
    sku: "MQ4L3J/A",
    product_eng: "iPhone 14 Plus 256GB Starlight",
    product_jpn: "iPhone 14 Plus 256GB スターライト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4L3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "81",
    brand: "Apple",
    sku: "MQ4P3J/A",
    product_eng: "iPhone 14 Plus 256GB RED",
    product_jpn: "iPhone 14 Plus 256GB RED",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4P3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "82",
    brand: "Apple",
    sku: "MQ4Q3J/A",
    product_eng: "iPhone 14 Plus 256GB Blue",
    product_jpn: "iPhone 14 Plus 256GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4Q3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "83",
    brand: "Apple",
    sku: "MQ4M3J/A",
    product_eng: "iPhone 14 Plus 256GB Purple",
    product_jpn: "iPhone 14 Plus 256GB パープル",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4M3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "84",
    brand: "Apple",
    sku: "MQ4R3J/A",
    product_eng: "iPhone 14 Plus 512GB Midnight",
    product_jpn: "iPhone 14 Plus 512GB ミッドナイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4R3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "85",
    brand: "Apple",
    sku: "MQ4T3J/A",
    product_eng: "iPhone 14 Plus 512GB Starlight",
    product_jpn: "iPhone 14 Plus 512GB スターライト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4T3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "86",
    brand: "Apple",
    sku: "MQ4V3J/A",
    product_eng: "iPhone 14 Plus 512GB RED",
    product_jpn: "iPhone 14 Plus 512GB RED",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4V3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "87",
    brand: "Apple",
    sku: "MQ4W3J/A",
    product_eng: "iPhone 14 Plus 512GB Blue",
    product_jpn: "iPhone 14 Plus 512GB ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4W3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "88",
    brand: "Apple",
    sku: "MQ4U3J/A",
    product_eng: "iPhone 14 Plus 512GB Purple",
    product_jpn: "iPhone 14 Plus 512GB パープル",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Wonderfull. Longest battery life in the iPhone family. Equipped with collision detection. Beautifully beautiful photos even in dark places. <Specifications>     Super Retina XDR display     6.1-inch (diagonal) all-screen OLED display     2,532 x 1,170 pixel resolution, 460 ppi     HDR display     Supports simultaneous display of multiple languages and characters     Splash, water, and dust resistance IP68 rating per IEC standard 60529 (up to 30 minutes at a maximum depth of 6 meters)     A15 Bionic chip     Ceramic Shield. Tougher than any smartphone glass. <Size and Weight>     Height: 160.8 mm Width: 78.1 mm Thickness: 7.80 mm     Weight: 203 g  <What's included>     iPhone 14     USB-C to Lightning cable",
    description_jpn:
      "あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.1インチ（対角）オールスクリーンOLEDディスプレイ     2,532 x 1,170ピクセル解像度、460ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：146.7 mm  幅：71.5 mm  厚さ：7.80 mm      重量：172 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル  あふれるワンダフル。 iPhoneファミリーで最長のバッテリー駆動時間。 衝突事故検出を搭載。 暗い場所での撮影も見とれるほど美しく。 <仕様>     Super Retina XDRディスプレイ     6.7インチ（対角）オールスクリーンOLEDディスプレイ     2,778 x 1,284ピクセル解像度、458ppi     HDRディスプレイ     複数の言語と文字の同時表示をサポート     防沫性能、耐水性能、防塵性能 IEC規格60529にもとづくIP68等級（最大水深6メートルで最大30分間）     A15 Bionicチップ     Ceramic Shield。 どんなスマートフォンのガラスよりも頑丈。 <サイズと重量>     高さ：160.8 mm  幅：78.1 mm  厚さ：7.80 mm     重量：203 g  <同梱物>     iPhone 14     USB-C - Lightningケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhone14/Apple_MQ4U3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "107",
    brand: "Apple",
    sku: "MMYC3J/A",
    product_eng: "iPhone SE 64GB Midnight",
    product_jpn: "iPhone SE 64GB ミッドナイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥57,091",
    rrp_with_vat: "¥62,800",
    description_eng:
      "A15 Bionic power and 5G speed. 5G finally in the SE. A very satisfying battery. In the pocket size of 4.7 inches.  Size: Height x width x thickness 138.4 mm x 67.3 mm x 7.3 mm Weight: 144 g  Display:      Retina HD display     4.7 (diagonal) widescreen LCD Multi-Touch display with IPS technology     1,334 x 750 pixel resolution, 326ppi     1,400:1 contrast ratio (standard)     True Tone display     Wide color gamut display (P3)     Tactile touch     Max. brightness 625 nits (standard)     Fingerprint-resistant oleophobic coating     Enlarged view     Simplified Access Chip :.     A15 Bionic chip     6-core CPU with 2 high-performance cores and 4 high-efficiency cores     4-core GPU     16-core Neural Engine Water resistance: IP67 rating based on IEC standard 60529 (maximum depth of 1 meter for up to 30 minutes) Camera ：Camera     12MP wide-angle camera     ƒ/1.8 aperture     Up to 5x digital zoom     Advanced bokeh effects and depth control available     Portrait mode     Portrait lighting with 6 effects     (natural light, studio lighting, contour lighting, stage lighting, and     Stage lighting (mono), High key lighting (mono)     Optical image stabilization     6-element lens     LED True Tone flash and slow sync     Panorama (up to 63 MP)     Sapphire crystal lens cover     Autofocus with Focus Pixels     Wide gamut capture of Photos and Live Photos     Deep Fusion     Smart HDR 4 for photos     Photograph Style     Advanced red-eye correction     Automatic image stabilization     Burst mode     Attach geotags to photos     Image capture formats: HEIF, JPEG",
    description_jpn:
      "A15 Bionicのパワーと5Gのスピード。 5GがついにSEにも。 大満足のバッテリー。 そのすべてを、 4.7インチのポケットサイズに。  サイズ：縦×横×厚さ 138.4 mm×67.3 mm×7.3 mm 重量：144 g  ディスプレイ：     Retina HDディスプレイ     IPSテクノロジー搭載4.7インチ（対角）ワイドスクリーンLCD Multi‑Touchディスプレイ     1,334 x 750ピクセル解像度、326ppi     1,400:1コントラスト比（標準）     True Toneディスプレイ     広色域ディスプレイ（P3）     触覚タッチ     最大輝度625ニト（標準）     耐指紋性撥油コーティング     拡大表示     簡易アクセス チップ ：     A15 Bionicチップ     2つの高性能コアと4つの高効率コアを搭載した6コアCPU     4コアGPU     16コアNeural Engine 耐水性能：IEC規格60529にもとづくIP67等級（最大水深1メートルで最大30分間） カメラ ：      12MP広角カメラ     ƒ/1.8絞り値     最大5倍のデジタルズーム     進化したボケ効果と深度コントロールが使える     ポートレートモード     6つのエフェクトを備えたポートレートライティング     （自然光、スタジオ照明、輪郭強調照明、ステージ照明、     ステージ照明（モノ）、ハイキー照明（モノ））     光学式手ぶれ補正     6枚構成のレンズ     LED True Toneフラッシュとスローシンクロ     パノラマ（最大63MP）     サファイアクリスタル製レンズカバー     Focus Pixelsを使ったオートフォーカス     写真とLive Photosの広色域キャプチャ     Deep Fusion     写真のスマートHDR 4     フォトグラフスタイル     高度な赤目修正     自動手ぶれ補正     バーストモード     写真へのジオタグ添付     画像撮影フォーマット：HEIF、JPEG",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhoneSE/Apple_MMYC3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "108",
    brand: "Apple",
    sku: "MMYD3J/A",
    product_eng: "iPhone SE 64GB Starlight",
    product_jpn: "iPhone SE 64GB スターライト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥57,091",
    rrp_with_vat: "¥62,800",
    description_eng:
      "A15 Bionic power and 5G speed. 5G finally in the SE. A very satisfying battery. In the pocket size of 4.7 inches.  Size: Height x width x thickness 138.4 mm x 67.3 mm x 7.3 mm Weight: 144 g  Display:      Retina HD display     4.7 (diagonal) widescreen LCD Multi-Touch display with IPS technology     1,334 x 750 pixel resolution, 326ppi     1,400:1 contrast ratio (standard)     True Tone display     Wide color gamut display (P3)     Tactile touch     Max. brightness 625 nits (standard)     Fingerprint-resistant oleophobic coating     Enlarged view     Simplified Access Chip :.     A15 Bionic chip     6-core CPU with 2 high-performance cores and 4 high-efficiency cores     4-core GPU     16-core Neural Engine Water resistance: IP67 rating based on IEC standard 60529 (maximum depth of 1 meter for up to 30 minutes) Camera ：Camera     12MP wide-angle camera     ƒ/1.8 aperture     Up to 5x digital zoom     Advanced bokeh effects and depth control available     Portrait mode     Portrait lighting with 6 effects     (natural light, studio lighting, contour lighting, stage lighting, and     Stage lighting (mono), High key lighting (mono)     Optical image stabilization     6-element lens     LED True Tone flash and slow sync     Panorama (up to 63 MP)     Sapphire crystal lens cover     Autofocus with Focus Pixels     Wide gamut capture of Photos and Live Photos     Deep Fusion     Smart HDR 4 for photos     Photograph Style     Advanced red-eye correction     Automatic image stabilization     Burst mode     Attach geotags to photos     Image capture formats: HEIF, JPEG",
    description_jpn:
      "A15 Bionicのパワーと5Gのスピード。 5GがついにSEにも。 大満足のバッテリー。 そのすべてを、 4.7インチのポケットサイズに。  サイズ：縦×横×厚さ 138.4 mm×67.3 mm×7.3 mm 重量：144 g  ディスプレイ：     Retina HDディスプレイ     IPSテクノロジー搭載4.7インチ（対角）ワイドスクリーンLCD Multi‑Touchディスプレイ     1,334 x 750ピクセル解像度、326ppi     1,400:1コントラスト比（標準）     True Toneディスプレイ     広色域ディスプレイ（P3）     触覚タッチ     最大輝度625ニト（標準）     耐指紋性撥油コーティング     拡大表示     簡易アクセス チップ ：     A15 Bionicチップ     2つの高性能コアと4つの高効率コアを搭載した6コアCPU     4コアGPU     16コアNeural Engine 耐水性能：IEC規格60529にもとづくIP67等級（最大水深1メートルで最大30分間） カメラ ：      12MP広角カメラ     ƒ/1.8絞り値     最大5倍のデジタルズーム     進化したボケ効果と深度コントロールが使える     ポートレートモード     6つのエフェクトを備えたポートレートライティング     （自然光、スタジオ照明、輪郭強調照明、ステージ照明、     ステージ照明（モノ）、ハイキー照明（モノ））     光学式手ぶれ補正     6枚構成のレンズ     LED True Toneフラッシュとスローシンクロ     パノラマ（最大63MP）     サファイアクリスタル製レンズカバー     Focus Pixelsを使ったオートフォーカス     写真とLive Photosの広色域キャプチャ     Deep Fusion     写真のスマートHDR 4     フォトグラフスタイル     高度な赤目修正     自動手ぶれ補正     バーストモード     写真へのジオタグ添付     画像撮影フォーマット：HEIF、JPEG",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhoneSE/Apple_MMYD3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "109",
    brand: "Apple",
    sku: "MMYE3J/A",
    product_eng: "iPhone SE 64GB RED",
    product_jpn: "iPhone SE 64GB RED",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥57,091",
    rrp_with_vat: "¥62,800",
    description_eng:
      "A15 Bionic power and 5G speed. 5G finally in the SE. A very satisfying battery. In the pocket size of 4.7 inches.  Size: Height x width x thickness 138.4 mm x 67.3 mm x 7.3 mm Weight: 144 g  Display:      Retina HD display     4.7 (diagonal) widescreen LCD Multi-Touch display with IPS technology     1,334 x 750 pixel resolution, 326ppi     1,400:1 contrast ratio (standard)     True Tone display     Wide color gamut display (P3)     Tactile touch     Max. brightness 625 nits (standard)     Fingerprint-resistant oleophobic coating     Enlarged view     Simplified Access Chip :.     A15 Bionic chip     6-core CPU with 2 high-performance cores and 4 high-efficiency cores     4-core GPU     16-core Neural Engine Water resistance: IP67 rating based on IEC standard 60529 (maximum depth of 1 meter for up to 30 minutes) Camera ：Camera     12MP wide-angle camera     ƒ/1.8 aperture     Up to 5x digital zoom     Advanced bokeh effects and depth control available     Portrait mode     Portrait lighting with 6 effects     (natural light, studio lighting, contour lighting, stage lighting, and     Stage lighting (mono), High key lighting (mono)     Optical image stabilization     6-element lens     LED True Tone flash and slow sync     Panorama (up to 63 MP)     Sapphire crystal lens cover     Autofocus with Focus Pixels     Wide gamut capture of Photos and Live Photos     Deep Fusion     Smart HDR 4 for photos     Photograph Style     Advanced red-eye correction     Automatic image stabilization     Burst mode     Attach geotags to photos     Image capture formats: HEIF, JPEG",
    description_jpn:
      "A15 Bionicのパワーと5Gのスピード。 5GがついにSEにも。 大満足のバッテリー。 そのすべてを、 4.7インチのポケットサイズに。  サイズ：縦×横×厚さ 138.4 mm×67.3 mm×7.3 mm 重量：144 g  ディスプレイ：     Retina HDディスプレイ     IPSテクノロジー搭載4.7インチ（対角）ワイドスクリーンLCD Multi‑Touchディスプレイ     1,334 x 750ピクセル解像度、326ppi     1,400:1コントラスト比（標準）     True Toneディスプレイ     広色域ディスプレイ（P3）     触覚タッチ     最大輝度625ニト（標準）     耐指紋性撥油コーティング     拡大表示     簡易アクセス チップ ：     A15 Bionicチップ     2つの高性能コアと4つの高効率コアを搭載した6コアCPU     4コアGPU     16コアNeural Engine 耐水性能：IEC規格60529にもとづくIP67等級（最大水深1メートルで最大30分間） カメラ ：      12MP広角カメラ     ƒ/1.8絞り値     最大5倍のデジタルズーム     進化したボケ効果と深度コントロールが使える     ポートレートモード     6つのエフェクトを備えたポートレートライティング     （自然光、スタジオ照明、輪郭強調照明、ステージ照明、     ステージ照明（モノ）、ハイキー照明（モノ））     光学式手ぶれ補正     6枚構成のレンズ     LED True Toneフラッシュとスローシンクロ     パノラマ（最大63MP）     サファイアクリスタル製レンズカバー     Focus Pixelsを使ったオートフォーカス     写真とLive Photosの広色域キャプチャ     Deep Fusion     写真のスマートHDR 4     フォトグラフスタイル     高度な赤目修正     自動手ぶれ補正     バーストモード     写真へのジオタグ添付     画像撮影フォーマット：HEIF、JPEG",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhoneSE/Apple_MMYE3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "110",
    brand: "Apple",
    sku: "MMYF3J/A",
    product_eng: "iPhone SE 128GB Midnight",
    product_jpn: "iPhone SE 128GB ミッドナイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥63,455",
    rrp_with_vat: "¥69,800",
    description_eng:
      "A15 Bionic power and 5G speed. 5G finally in the SE. A very satisfying battery. In the pocket size of 4.7 inches.  Size: Height x width x thickness 138.4 mm x 67.3 mm x 7.3 mm Weight: 144 g  Display:      Retina HD display     4.7 (diagonal) widescreen LCD Multi-Touch display with IPS technology     1,334 x 750 pixel resolution, 326ppi     1,400:1 contrast ratio (standard)     True Tone display     Wide color gamut display (P3)     Tactile touch     Max. brightness 625 nits (standard)     Fingerprint-resistant oleophobic coating     Enlarged view     Simplified Access Chip :.     A15 Bionic chip     6-core CPU with 2 high-performance cores and 4 high-efficiency cores     4-core GPU     16-core Neural Engine Water resistance: IP67 rating based on IEC standard 60529 (maximum depth of 1 meter for up to 30 minutes) Camera ：Camera     12MP wide-angle camera     ƒ/1.8 aperture     Up to 5x digital zoom     Advanced bokeh effects and depth control available     Portrait mode     Portrait lighting with 6 effects     (natural light, studio lighting, contour lighting, stage lighting, and     Stage lighting (mono), High key lighting (mono)     Optical image stabilization     6-element lens     LED True Tone flash and slow sync     Panorama (up to 63 MP)     Sapphire crystal lens cover     Autofocus with Focus Pixels     Wide gamut capture of Photos and Live Photos     Deep Fusion     Smart HDR 4 for photos     Photograph Style     Advanced red-eye correction     Automatic image stabilization     Burst mode     Attach geotags to photos     Image capture formats: HEIF, JPEG",
    description_jpn:
      "A15 Bionicのパワーと5Gのスピード。 5GがついにSEにも。 大満足のバッテリー。 そのすべてを、 4.7インチのポケットサイズに。  サイズ：縦×横×厚さ 138.4 mm×67.3 mm×7.3 mm 重量：144 g  ディスプレイ：     Retina HDディスプレイ     IPSテクノロジー搭載4.7インチ（対角）ワイドスクリーンLCD Multi‑Touchディスプレイ     1,334 x 750ピクセル解像度、326ppi     1,400:1コントラスト比（標準）     True Toneディスプレイ     広色域ディスプレイ（P3）     触覚タッチ     最大輝度625ニト（標準）     耐指紋性撥油コーティング     拡大表示     簡易アクセス チップ ：     A15 Bionicチップ     2つの高性能コアと4つの高効率コアを搭載した6コアCPU     4コアGPU     16コアNeural Engine 耐水性能：IEC規格60529にもとづくIP67等級（最大水深1メートルで最大30分間） カメラ ：      12MP広角カメラ     ƒ/1.8絞り値     最大5倍のデジタルズーム     進化したボケ効果と深度コントロールが使える     ポートレートモード     6つのエフェクトを備えたポートレートライティング     （自然光、スタジオ照明、輪郭強調照明、ステージ照明、     ステージ照明（モノ）、ハイキー照明（モノ））     光学式手ぶれ補正     6枚構成のレンズ     LED True Toneフラッシュとスローシンクロ     パノラマ（最大63MP）     サファイアクリスタル製レンズカバー     Focus Pixelsを使ったオートフォーカス     写真とLive Photosの広色域キャプチャ     Deep Fusion     写真のスマートHDR 4     フォトグラフスタイル     高度な赤目修正     自動手ぶれ補正     バーストモード     写真へのジオタグ添付     画像撮影フォーマット：HEIF、JPEG",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhoneSE/Apple_MMYF3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "111",
    brand: "Apple",
    sku: "MMYG3J/A",
    product_eng: "iPhone SE 128GB Starlight",
    product_jpn: "iPhone SE 128GB スターライト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥63,455",
    rrp_with_vat: "¥69,800",
    description_eng:
      "A15 Bionic power and 5G speed. 5G finally in the SE. A very satisfying battery. In the pocket size of 4.7 inches.  Size: Height x width x thickness 138.4 mm x 67.3 mm x 7.3 mm Weight: 144 g  Display:      Retina HD display     4.7 (diagonal) widescreen LCD Multi-Touch display with IPS technology     1,334 x 750 pixel resolution, 326ppi     1,400:1 contrast ratio (standard)     True Tone display     Wide color gamut display (P3)     Tactile touch     Max. brightness 625 nits (standard)     Fingerprint-resistant oleophobic coating     Enlarged view     Simplified Access Chip :.     A15 Bionic chip     6-core CPU with 2 high-performance cores and 4 high-efficiency cores     4-core GPU     16-core Neural Engine Water resistance: IP67 rating based on IEC standard 60529 (maximum depth of 1 meter for up to 30 minutes) Camera ：Camera     12MP wide-angle camera     ƒ/1.8 aperture     Up to 5x digital zoom     Advanced bokeh effects and depth control available     Portrait mode     Portrait lighting with 6 effects     (natural light, studio lighting, contour lighting, stage lighting, and     Stage lighting (mono), High key lighting (mono)     Optical image stabilization     6-element lens     LED True Tone flash and slow sync     Panorama (up to 63 MP)     Sapphire crystal lens cover     Autofocus with Focus Pixels     Wide gamut capture of Photos and Live Photos     Deep Fusion     Smart HDR 4 for photos     Photograph Style     Advanced red-eye correction     Automatic image stabilization     Burst mode     Attach geotags to photos     Image capture formats: HEIF, JPEG",
    description_jpn:
      "A15 Bionicのパワーと5Gのスピード。 5GがついにSEにも。 大満足のバッテリー。 そのすべてを、 4.7インチのポケットサイズに。  サイズ：縦×横×厚さ 138.4 mm×67.3 mm×7.3 mm 重量：144 g  ディスプレイ：     Retina HDディスプレイ     IPSテクノロジー搭載4.7インチ（対角）ワイドスクリーンLCD Multi‑Touchディスプレイ     1,334 x 750ピクセル解像度、326ppi     1,400:1コントラスト比（標準）     True Toneディスプレイ     広色域ディスプレイ（P3）     触覚タッチ     最大輝度625ニト（標準）     耐指紋性撥油コーティング     拡大表示     簡易アクセス チップ ：     A15 Bionicチップ     2つの高性能コアと4つの高効率コアを搭載した6コアCPU     4コアGPU     16コアNeural Engine 耐水性能：IEC規格60529にもとづくIP67等級（最大水深1メートルで最大30分間） カメラ ：      12MP広角カメラ     ƒ/1.8絞り値     最大5倍のデジタルズーム     進化したボケ効果と深度コントロールが使える     ポートレートモード     6つのエフェクトを備えたポートレートライティング     （自然光、スタジオ照明、輪郭強調照明、ステージ照明、     ステージ照明（モノ）、ハイキー照明（モノ））     光学式手ぶれ補正     6枚構成のレンズ     LED True Toneフラッシュとスローシンクロ     パノラマ（最大63MP）     サファイアクリスタル製レンズカバー     Focus Pixelsを使ったオートフォーカス     写真とLive Photosの広色域キャプチャ     Deep Fusion     写真のスマートHDR 4     フォトグラフスタイル     高度な赤目修正     自動手ぶれ補正     バーストモード     写真へのジオタグ添付     画像撮影フォーマット：HEIF、JPEG",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhoneSE/Apple_MMYG3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "112",
    brand: "Apple",
    sku: "MMYH3J/A",
    product_eng: "iPhone SE 128GB (PRODUCT)RED",
    product_jpn: "iPhone SE 128GB (PRODUCT)RED",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥63,455",
    rrp_with_vat: "¥69,800",
    description_eng:
      "A15 Bionic power and 5G speed. 5G finally in the SE. A very satisfying battery. In the pocket size of 4.7 inches.  Size: Height x width x thickness 138.4 mm x 67.3 mm x 7.3 mm Weight: 144 g  Display:      Retina HD display     4.7 (diagonal) widescreen LCD Multi-Touch display with IPS technology     1,334 x 750 pixel resolution, 326ppi     1,400:1 contrast ratio (standard)     True Tone display     Wide color gamut display (P3)     Tactile touch     Max. brightness 625 nits (standard)     Fingerprint-resistant oleophobic coating     Enlarged view     Simplified Access Chip :.     A15 Bionic chip     6-core CPU with 2 high-performance cores and 4 high-efficiency cores     4-core GPU     16-core Neural Engine Water resistance: IP67 rating based on IEC standard 60529 (maximum depth of 1 meter for up to 30 minutes) Camera ：Camera     12MP wide-angle camera     ƒ/1.8 aperture     Up to 5x digital zoom     Advanced bokeh effects and depth control available     Portrait mode     Portrait lighting with 6 effects     (natural light, studio lighting, contour lighting, stage lighting, and     Stage lighting (mono), High key lighting (mono)     Optical image stabilization     6-element lens     LED True Tone flash and slow sync     Panorama (up to 63 MP)     Sapphire crystal lens cover     Autofocus with Focus Pixels     Wide gamut capture of Photos and Live Photos     Deep Fusion     Smart HDR 4 for photos     Photograph Style     Advanced red-eye correction     Automatic image stabilization     Burst mode     Attach geotags to photos     Image capture formats: HEIF, JPEG",
    description_jpn:
      "A15 Bionicのパワーと5Gのスピード。 5GがついにSEにも。 大満足のバッテリー。 そのすべてを、 4.7インチのポケットサイズに。  サイズ：縦×横×厚さ 138.4 mm×67.3 mm×7.3 mm 重量：144 g  ディスプレイ：     Retina HDディスプレイ     IPSテクノロジー搭載4.7インチ（対角）ワイドスクリーンLCD Multi‑Touchディスプレイ     1,334 x 750ピクセル解像度、326ppi     1,400:1コントラスト比（標準）     True Toneディスプレイ     広色域ディスプレイ（P3）     触覚タッチ     最大輝度625ニト（標準）     耐指紋性撥油コーティング     拡大表示     簡易アクセス チップ ：     A15 Bionicチップ     2つの高性能コアと4つの高効率コアを搭載した6コアCPU     4コアGPU     16コアNeural Engine 耐水性能：IEC規格60529にもとづくIP67等級（最大水深1メートルで最大30分間） カメラ ：      12MP広角カメラ     ƒ/1.8絞り値     最大5倍のデジタルズーム     進化したボケ効果と深度コントロールが使える     ポートレートモード     6つのエフェクトを備えたポートレートライティング     （自然光、スタジオ照明、輪郭強調照明、ステージ照明、     ステージ照明（モノ）、ハイキー照明（モノ））     光学式手ぶれ補正     6枚構成のレンズ     LED True Toneフラッシュとスローシンクロ     パノラマ（最大63MP）     サファイアクリスタル製レンズカバー     Focus Pixelsを使ったオートフォーカス     写真とLive Photosの広色域キャプチャ     Deep Fusion     写真のスマートHDR 4     フォトグラフスタイル     高度な赤目修正     自動手ぶれ補正     バーストモード     写真へのジオタグ添付     画像撮影フォーマット：HEIF、JPEG",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhoneSE/Apple_MMYH3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "113",
    brand: "Apple",
    sku: "MMYJ3J/A",
    product_eng: "iPhone SE 256GB Midnight",
    product_jpn: "iPhone SE 256GB ミッドナイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "A15 Bionic power and 5G speed. 5G finally in the SE. A very satisfying battery. In the pocket size of 4.7 inches.  Size: Height x width x thickness 138.4 mm x 67.3 mm x 7.3 mm Weight: 144 g  Display:      Retina HD display     4.7 (diagonal) widescreen LCD Multi-Touch display with IPS technology     1,334 x 750 pixel resolution, 326ppi     1,400:1 contrast ratio (standard)     True Tone display     Wide color gamut display (P3)     Tactile touch     Max. brightness 625 nits (standard)     Fingerprint-resistant oleophobic coating     Enlarged view     Simplified Access Chip :.     A15 Bionic chip     6-core CPU with 2 high-performance cores and 4 high-efficiency cores     4-core GPU     16-core Neural Engine Water resistance: IP67 rating based on IEC standard 60529 (maximum depth of 1 meter for up to 30 minutes) Camera ：Camera     12MP wide-angle camera     ƒ/1.8 aperture     Up to 5x digital zoom     Advanced bokeh effects and depth control available     Portrait mode     Portrait lighting with 6 effects     (natural light, studio lighting, contour lighting, stage lighting, and     Stage lighting (mono), High key lighting (mono)     Optical image stabilization     6-element lens     LED True Tone flash and slow sync     Panorama (up to 63 MP)     Sapphire crystal lens cover     Autofocus with Focus Pixels     Wide gamut capture of Photos and Live Photos     Deep Fusion     Smart HDR 4 for photos     Photograph Style     Advanced red-eye correction     Automatic image stabilization     Burst mode     Attach geotags to photos     Image capture formats: HEIF, JPEG",
    description_jpn:
      "A15 Bionicのパワーと5Gのスピード。 5GがついにSEにも。 大満足のバッテリー。 そのすべてを、 4.7インチのポケットサイズに。  サイズ：縦×横×厚さ 138.4 mm×67.3 mm×7.3 mm 重量：144 g  ディスプレイ：     Retina HDディスプレイ     IPSテクノロジー搭載4.7インチ（対角）ワイドスクリーンLCD Multi‑Touchディスプレイ     1,334 x 750ピクセル解像度、326ppi     1,400:1コントラスト比（標準）     True Toneディスプレイ     広色域ディスプレイ（P3）     触覚タッチ     最大輝度625ニト（標準）     耐指紋性撥油コーティング     拡大表示     簡易アクセス チップ ：     A15 Bionicチップ     2つの高性能コアと4つの高効率コアを搭載した6コアCPU     4コアGPU     16コアNeural Engine 耐水性能：IEC規格60529にもとづくIP67等級（最大水深1メートルで最大30分間） カメラ ：      12MP広角カメラ     ƒ/1.8絞り値     最大5倍のデジタルズーム     進化したボケ効果と深度コントロールが使える     ポートレートモード     6つのエフェクトを備えたポートレートライティング     （自然光、スタジオ照明、輪郭強調照明、ステージ照明、     ステージ照明（モノ）、ハイキー照明（モノ））     光学式手ぶれ補正     6枚構成のレンズ     LED True Toneフラッシュとスローシンクロ     パノラマ（最大63MP）     サファイアクリスタル製レンズカバー     Focus Pixelsを使ったオートフォーカス     写真とLive Photosの広色域キャプチャ     Deep Fusion     写真のスマートHDR 4     フォトグラフスタイル     高度な赤目修正     自動手ぶれ補正     バーストモード     写真へのジオタグ添付     画像撮影フォーマット：HEIF、JPEG",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhoneSE/Apple_MMYJ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "114",
    brand: "Apple",
    sku: "MMYK3J/A",
    product_eng: "iPhone SE 256GB Starlight",
    product_jpn: "iPhone SE 256GBスターライト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "A15 Bionic power and 5G speed. 5G finally in the SE. A very satisfying battery. In the pocket size of 4.7 inches.  Size: Height x width x thickness 138.4 mm x 67.3 mm x 7.3 mm Weight: 144 g  Display:      Retina HD display     4.7 (diagonal) widescreen LCD Multi-Touch display with IPS technology     1,334 x 750 pixel resolution, 326ppi     1,400:1 contrast ratio (standard)     True Tone display     Wide color gamut display (P3)     Tactile touch     Max. brightness 625 nits (standard)     Fingerprint-resistant oleophobic coating     Enlarged view     Simplified Access Chip :.     A15 Bionic chip     6-core CPU with 2 high-performance cores and 4 high-efficiency cores     4-core GPU     16-core Neural Engine Water resistance: IP67 rating based on IEC standard 60529 (maximum depth of 1 meter for up to 30 minutes) Camera ：Camera     12MP wide-angle camera     ƒ/1.8 aperture     Up to 5x digital zoom     Advanced bokeh effects and depth control available     Portrait mode     Portrait lighting with 6 effects     (natural light, studio lighting, contour lighting, stage lighting, and     Stage lighting (mono), High key lighting (mono)     Optical image stabilization     6-element lens     LED True Tone flash and slow sync     Panorama (up to 63 MP)     Sapphire crystal lens cover     Autofocus with Focus Pixels     Wide gamut capture of Photos and Live Photos     Deep Fusion     Smart HDR 4 for photos     Photograph Style     Advanced red-eye correction     Automatic image stabilization     Burst mode     Attach geotags to photos     Image capture formats: HEIF, JPEG",
    description_jpn:
      "A15 Bionicのパワーと5Gのスピード。 5GがついにSEにも。 大満足のバッテリー。 そのすべてを、 4.7インチのポケットサイズに。  サイズ：縦×横×厚さ 138.4 mm×67.3 mm×7.3 mm 重量：144 g  ディスプレイ：     Retina HDディスプレイ     IPSテクノロジー搭載4.7インチ（対角）ワイドスクリーンLCD Multi‑Touchディスプレイ     1,334 x 750ピクセル解像度、326ppi     1,400:1コントラスト比（標準）     True Toneディスプレイ     広色域ディスプレイ（P3）     触覚タッチ     最大輝度625ニト（標準）     耐指紋性撥油コーティング     拡大表示     簡易アクセス チップ ：     A15 Bionicチップ     2つの高性能コアと4つの高効率コアを搭載した6コアCPU     4コアGPU     16コアNeural Engine 耐水性能：IEC規格60529にもとづくIP67等級（最大水深1メートルで最大30分間） カメラ ：      12MP広角カメラ     ƒ/1.8絞り値     最大5倍のデジタルズーム     進化したボケ効果と深度コントロールが使える     ポートレートモード     6つのエフェクトを備えたポートレートライティング     （自然光、スタジオ照明、輪郭強調照明、ステージ照明、     ステージ照明（モノ）、ハイキー照明（モノ））     光学式手ぶれ補正     6枚構成のレンズ     LED True Toneフラッシュとスローシンクロ     パノラマ（最大63MP）     サファイアクリスタル製レンズカバー     Focus Pixelsを使ったオートフォーカス     写真とLive Photosの広色域キャプチャ     Deep Fusion     写真のスマートHDR 4     フォトグラフスタイル     高度な赤目修正     自動手ぶれ補正     バーストモード     写真へのジオタグ添付     画像撮影フォーマット：HEIF、JPEG",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhoneSE/Apple_MMYK3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "115",
    brand: "Apple",
    sku: "MMYL3J/A",
    product_eng: "iPhone SE 256GB (PRODUCT)RED",
    product_jpn: "iPhone SE 256GB (PRODUCT)RED",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "A15 Bionic power and 5G speed. 5G finally in the SE. A very satisfying battery. In the pocket size of 4.7 inches.  Size: Height x width x thickness 138.4 mm x 67.3 mm x 7.3 mm Weight: 144 g  Display:      Retina HD display     4.7 (diagonal) widescreen LCD Multi-Touch display with IPS technology     1,334 x 750 pixel resolution, 326ppi     1,400:1 contrast ratio (standard)     True Tone display     Wide color gamut display (P3)     Tactile touch     Max. brightness 625 nits (standard)     Fingerprint-resistant oleophobic coating     Enlarged view     Simplified Access Chip :.     A15 Bionic chip     6-core CPU with 2 high-performance cores and 4 high-efficiency cores     4-core GPU     16-core Neural Engine Water resistance: IP67 rating based on IEC standard 60529 (maximum depth of 1 meter for up to 30 minutes) Camera ：Camera     12MP wide-angle camera     ƒ/1.8 aperture     Up to 5x digital zoom     Advanced bokeh effects and depth control available     Portrait mode     Portrait lighting with 6 effects     (natural light, studio lighting, contour lighting, stage lighting, and     Stage lighting (mono), High key lighting (mono)     Optical image stabilization     6-element lens     LED True Tone flash and slow sync     Panorama (up to 63 MP)     Sapphire crystal lens cover     Autofocus with Focus Pixels     Wide gamut capture of Photos and Live Photos     Deep Fusion     Smart HDR 4 for photos     Photograph Style     Advanced red-eye correction     Automatic image stabilization     Burst mode     Attach geotags to photos     Image capture formats: HEIF, JPEG",
    description_jpn:
      "A15 Bionicのパワーと5Gのスピード。 5GがついにSEにも。 大満足のバッテリー。 そのすべてを、 4.7インチのポケットサイズに。  サイズ：縦×横×厚さ 138.4 mm×67.3 mm×7.3 mm 重量：144 g  ディスプレイ：     Retina HDディスプレイ     IPSテクノロジー搭載4.7インチ（対角）ワイドスクリーンLCD Multi‑Touchディスプレイ     1,334 x 750ピクセル解像度、326ppi     1,400:1コントラスト比（標準）     True Toneディスプレイ     広色域ディスプレイ（P3）     触覚タッチ     最大輝度625ニト（標準）     耐指紋性撥油コーティング     拡大表示     簡易アクセス チップ ：     A15 Bionicチップ     2つの高性能コアと4つの高効率コアを搭載した6コアCPU     4コアGPU     16コアNeural Engine 耐水性能：IEC規格60529にもとづくIP67等級（最大水深1メートルで最大30分間） カメラ ：      12MP広角カメラ     ƒ/1.8絞り値     最大5倍のデジタルズーム     進化したボケ効果と深度コントロールが使える     ポートレートモード     6つのエフェクトを備えたポートレートライティング     （自然光、スタジオ照明、輪郭強調照明、ステージ照明、     ステージ照明（モノ）、ハイキー照明（モノ））     光学式手ぶれ補正     6枚構成のレンズ     LED True Toneフラッシュとスローシンクロ     パノラマ（最大63MP）     サファイアクリスタル製レンズカバー     Focus Pixelsを使ったオートフォーカス     写真とLive Photosの広色域キャプチャ     Deep Fusion     写真のスマートHDR 4     フォトグラフスタイル     高度な赤目修正     自動手ぶれ補正     バーストモード     写真へのジオタグ添付     画像撮影フォーマット：HEIF、JPEG",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPhoneSE/Apple_MMYL3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "160",
    brand: "Apple",
    sku: "MQ6J3J/A",
    product_eng: "10.9inch iPad Wi-Fi + Cellular 64GB - Silver",
    product_jpn: "10.9インチ iPad Wi-Fi + Cellular 64GB - シルバー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi + Cellular model 481 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fi + Cellularモデル 481 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MQ6J3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "161",
    brand: "Apple",
    sku: "MQ6K3J/A",
    product_eng: "10.9inch iPad Wi-Fi + Cellular 64GB - Blue",
    product_jpn: "10.9インチ iPad Wi-Fi + Cellular 64GB - ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi + Cellular model 481 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fi + Cellularモデル 481 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MQ6K3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "162",
    brand: "Apple",
    sku: "MQ6L3J/A",
    product_eng: "10.9inch iPad Wi-Fi + Cellular 64GB - Yellow",
    product_jpn: "10.9インチ iPad Wi-Fi + Cellular 64GB - イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi + Cellular model 481 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fi + Cellularモデル 481 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MQ6L3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "163",
    brand: "Apple",
    sku: "MQ6M3J/A",
    product_eng: "10.9inch iPad Wi-Fi + Cellular 64GB - Pink",
    product_jpn: "10.9インチ iPad Wi-Fi + Cellular 64GB - ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi + Cellular model 481 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fi + Cellularモデル 481 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MQ6M3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "164",
    brand: "Apple",
    sku: "MQ6T3J/A",
    product_eng: "10.9inch iPad Wi-Fi + Cellular 256GB - Silver",
    product_jpn: "10.9インチ iPad Wi-Fi + Cellular 256GB - シルバー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥110,727",
    rrp_with_vat: "¥110,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi + Cellular model 481 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fi + Cellularモデル 481 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MQ6T3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "165",
    brand: "Apple",
    sku: "MQ6U3J/A",
    product_eng: "10.9inch iPad Wi-Fi + Cellular 256GB - Blue",
    product_jpn: "10.9インチ iPad Wi-Fi + Cellular 256GB - ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥110,727",
    rrp_with_vat: "¥110,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi + Cellular model 481 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fi + Cellularモデル 481 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MQ6U3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "166",
    brand: "Apple",
    sku: "MQ6V3J/A",
    product_eng: "10.9inch iPad Wi-Fi + Cellular 256GB - Yellow",
    product_jpn: "10.9インチ iPad Wi-Fi + Cellular 256GB - イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥110,727",
    rrp_with_vat: "¥110,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi + Cellular model 481 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fi + Cellularモデル 481 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MQ6V3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "167",
    brand: "Apple",
    sku: "MQ6W3J/A",
    product_eng: "10.9inch iPad Wi-Fi + Cellular 256GB - Pink",
    product_jpn: "10.9インチ iPad Wi-Fi + Cellular 256GB - ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥110,727",
    rrp_with_vat: "¥110,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi + Cellular model 481 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fi + Cellularモデル 481 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MQ6W3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "168",
    brand: "Apple",
    sku: "MPQ03J/A",
    product_eng: "10.9inch iPad Wi-Fi 64GB - Silver",
    product_jpn: "10.9インチ iPad Wi-Fi 64GB - シルバー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥53,455",
    rrp_with_vat: "¥58,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi model 477 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fiモデル 477 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MPQ03JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "169",
    brand: "Apple",
    sku: "MPQ13J/A",
    product_eng: "10.9inch iPad Wi-Fi 64GB - Blue",
    product_jpn: "10.9インチ iPad Wi-Fi 64GB - ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥53,455",
    rrp_with_vat: "¥58,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi model 477 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fiモデル 477 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MPQ13JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "170",
    brand: "Apple",
    sku: "MPQ23J/A",
    product_eng: "10.9inch iPad Wi-Fi 64GB - Yellow",
    product_jpn: "10.9インチ iPad Wi-Fi 64GB - イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥53,455",
    rrp_with_vat: "¥58,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi model 477 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fiモデル 477 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MPQ23JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "171",
    brand: "Apple",
    sku: "MPQ33J/A",
    product_eng: "10.9inch iPad Wi-Fi 64GB - Pink",
    product_jpn: "10.9インチ iPad Wi-Fi 64GB - ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥53,455",
    rrp_with_vat: "¥58,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi model 477 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fiモデル 477 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MPQ33JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "172",
    brand: "Apple",
    sku: "MPQ83J/A",
    product_eng: "10.9inch iPad Wi-Fi 256GB - Silver",
    product_jpn: "10.9インチ iPad Wi-Fi 256GB - シルバー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi model 477 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fiモデル 477 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MPQ83JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "173",
    brand: "Apple",
    sku: "MPQ93J/A",
    product_eng: "10.9inch iPad Wi-Fi 256GB - Blue",
    product_jpn: "10.9インチ iPad Wi-Fi 256GB - ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi model 477 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fiモデル 477 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MPQ93JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "174",
    brand: "Apple",
    sku: "MPQA3J/A",
    product_eng: "10.9inch iPad Wi-Fi 256GB - Yellow",
    product_jpn: "10.9インチ iPad Wi-Fi 256GB - イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi model 477 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fiモデル 477 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MPQA3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "175",
    brand: "Apple",
    sku: "MPQC3J/A",
    product_eng: "10.9inch iPad Wi-Fi 256GB - Pink",
    product_jpn: "10.9インチ iPad Wi-Fi 256GB - ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "● Four attractive colors. All-screen design, compatible with convenient accessories made for the iPad. ● Powerful A14 Bionic chip and all-day battery life. Multitasking, collaboration, and more, all at your fingertips. ● Shoot photos and videos with the 12MP wide-angle back camera, or annotate and edit with Apple Pencil. ● The landscape-facing 12MP ultra-wide-angle front camera supports a center frame. Adjust it so you're not off-center during a video call. ● Watch. Learn. Play. All on the beautiful 10.9-inch Liquid Retina display. ● Draw with the Apple Pencil and type with the Magic Keyboard Folio. ● The App Store has more than a million apps to choose from. ● Dimensions H x W x D 248.6 mm x 179.5 mm x 7 mm ● Wi-Fi model 477 g ● Included: iPad/USB-C charging cable/20W USB-C power adapter (supports high-speed charging)",
    description_jpn:
      "●4つの魅力的なカラー。オールスクリーンのデザイン。iPadのために作られた便利なアクセサリに対応。 ●パワフルなA14 Bionicチップと一日中使えるバッテリーを搭載。マルチタスキングや共同作業など、あらゆることが思いのまま。 ●12MP広角バックカメラで写真やビデオを撮影することも、Apple Pencilで注釈を加えたり編集することも。 ●横向きの12MP超広角フロントカメラはセンターフレームに対応。ビデオ通話中にあなたがフレームの中心から外れないように調整。 ●観る。学ぶ。遊ぶ。すべてを美しい10.9インチのLiquid Retinaディスプレイで。 ●Apple Pencilで描こう。Magic Keyboard Folioでタイプしよう。 ●優れたアプリを内蔵。App Storeには100万以上のアプリも勢ぞろい。 ●サイズ 縦×横×厚さ 248.6 mm×179.5 mm×7 mm ●Wi-Fiモデル 477 g ●同梱物 iPad/USB-C充電ケーブル/20W USB-C電源アダプタ（高速充電に対応)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iPad2022/Apple_MPQC3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "216",
    brand: "Apple",
    sku: "MN873J/A",
    product_eng: "Apple TV 4K 64GB Wi-Fi",
    product_jpn: "Apple TV 4K 64GBストレージ搭載Wi‑Fiモデル",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥18,000",
    rrp_with_vat: "¥19,800",
    description_eng:
      "Get the best TV experience with Apple TV 4K (3rd generation) and your favorite Apple devices and services. With 4K Dolby Vision, HDR10+, and Dolby Atmos, it's like being in a real movie theater.  The included USB-C compatible Siri Remote (3rd generation) makes it easy to control your Apple TV 4K with the touch-enabled click pad or just your voice. Apple TV 4K is also a great smart home hub. Connect and smartly control all your favorite smart home accessories.  ●Dimensions <Main unit> Weight (Wi-Fi model): 208 g   Height: 31 mm Width: 93 mm Depth: 93 mm <Remote control> Weight: 66 g Height: 136 mm Width: 35 mm Thickness: 9.25 mm",
    description_jpn:
      "Apple TV 4K（第3世代）と、お気に入りのApple製デバイスやサービスで、最高のテレビ体験を。 4Kドルビービジョン、HDR10+、ドルビーアトモスにより、本物の映画館にいるように楽しめます。  付属のUSB-C対応のSiri Remote（第3世代）を使うと、タッチ対応のクリックパッドやあなたの声だけでApple TV 4Kを簡単に操作できます。 Apple TV 4Kはスマートホームのハブとしても大活躍。 お気に入りのスマートホームアクセサリをすべて接続して、スマートにコントロールできます。  ●大きさ <本体> 重量（Wi-Fiモデル）：208 g   高さ：31 mm 幅：93 mm 奥行き：93 mm <リモコン> 重量：66 g 高さ：136 mm 幅：35 mm 厚さ：9.25 mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/AppleTV/Apple_MN873JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "217",
    brand: "Apple",
    sku: "MN893J/A",
    product_eng: "Apple TV 4K 128GB Wi-Fi+Ethernet",
    product_jpn: "Apple TV 4K 128GBストレージ搭載Wi‑Fi + Ethernetモデル",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥21,636",
    rrp_with_vat: "¥23,800",
    description_eng:
      "Get the best TV experience with Apple TV 4K (3rd generation) and your favorite Apple devices and services. With 4K Dolby Vision, HDR10+, and Dolby Atmos, it's like being in a real movie theater.  The included USB-C compatible Siri Remote (3rd generation) makes it easy to control your Apple TV 4K with the touch-enabled click pad or just your voice. Apple TV 4K is also a great smart home hub. Connect and smartly control all your favorite smart home accessories.  ●Dimensions <Main unit> Weight (Wi-Fi + Ethernet): 214 g  Height: 31 mm Width: 93 mm Depth: 93 mm <Remote control> Weight: 66 g Height: 136 mm Width: 35 mm Thickness: 9.25 mm",
    description_jpn:
      "Apple TV 4K（第3世代）と、お気に入りのApple製デバイスやサービスで、最高のテレビ体験を。 4Kドルビービジョン、HDR10+、ドルビーアトモスにより、本物の映画館にいるように楽しめます。  付属のUSB-C対応のSiri Remote（第3世代）を使うと、タッチ対応のクリックパッドやあなたの声だけでApple TV 4Kを簡単に操作できます。 Apple TV 4Kはスマートホームのハブとしても大活躍。 お気に入りのスマートホームアクセサリをすべて接続して、スマートにコントロールできます。 Threadネットワーク接続に対応しています。  ●大きさ <本体> 重量（Wi-Fi + Ethernetモデル）：214 g 高さ：31 mm 幅：93 mm 奥行き：93 mm <リモコン> 重量：66 g 高さ：136 mm 幅：35 mm 厚さ：9.25 mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/AppleTV/Apple_MN893JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "218",
    brand: "Apple",
    sku: "MQJ73J/A",
    product_eng: "Home Pod - Midnight",
    product_jpn: "Home Pod - ミッドナイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥40,727",
    rrp_with_vat: "¥44,800",
    description_eng:
      "Realistic and faithful to the original sound. Spatial audio. A smart assistant.  ・The deep, rich bass and crisp, clear highs produced by the highly polarized woofer and five tweeter array. ・Spatial Audio envelops you in sound and delivers an immersive listening experience. ・Advanced Computational Audio maximizes acoustic performance in real time. ・In-room detection: HomePod automatically detects where it is placed and fine-tunes the audio to deliver the best possible sound experience from anywhere. HomePod automatically detects where it is placed and fine-tunes the audio to deliver the best possible sound experience from anywhere. ・You can even create a stereo pair: place two HomePod speakers for even more immersive sound, or pair them with Apple TV 4K for a complete home theater system. ・Use the Home app and HomePod together for easy control of your smart accessories. ・Built-in privacy and security features.  <included thing> ・HomePod ・Power cable ・Manual",
    description_jpn:
      "臨場感あふれる、原音に忠実な音。空間オーディオ。賢いアシスタント。  ・高偏位ウーファーと5つのツイーターアレイから生み出される深みのある豊かな低音と鮮明でクリアな高音。 ・空間オーディオはあなたをサウンドで包み込み、どこまでも臨場感あふれるリスニング体験を届けます。 ・進化したコンピュテーショナルオーディオは、リアルタイムで音響性能を最大限に引き出します。 ・室内検知。HomePodは置かれた場所を自動的に検知し、オーディオを微調整。どこからでも最高の音響体験を届けます。 ・ステレオペアも作れます。2つのHomePodスピーカーを置けば、さらに臨場感あふれるサウンドに。Apple TV 4Kと組み合わせれば、完璧なホームシアターシステムが完成します。 ・ホームアプリとHomePodを一緒に使えば、スマートアクセサリを簡単にコントロールできます。 ・プライバシーとセキュリティの機能を内蔵しています。  同梱物 ・HomePod ・電源ケーブル ・マニュアル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/HomePod/Apple_MQJ73JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "219",
    brand: "Apple",
    sku: "MQJ83J/A",
    product_eng: "Home Pod - White",
    product_jpn: "Home Pod - ホワイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥40,727",
    rrp_with_vat: "¥44,800",
    description_eng:
      "Realistic and faithful to the original sound. Spatial audio. A smart assistant.  ・The deep, rich bass and crisp, clear highs produced by the highly polarized woofer and five tweeter array. ・Spatial Audio envelops you in sound and delivers an immersive listening experience. ・Advanced Computational Audio maximizes acoustic performance in real time. ・In-room detection: HomePod automatically detects where it is placed and fine-tunes the audio to deliver the best possible sound experience from anywhere. HomePod automatically detects where it is placed and fine-tunes the audio to deliver the best possible sound experience from anywhere. ・You can even create a stereo pair: place two HomePod speakers for even more immersive sound, or pair them with Apple TV 4K for a complete home theater system. ・Use the Home app and HomePod together for easy control of your smart accessories. ・Built-in privacy and security features.  <included thing> ・HomePod ・Power cable ・Manual",
    description_jpn:
      "臨場感あふれる、原音に忠実な音。空間オーディオ。賢いアシスタント。  ・高偏位ウーファーと5つのツイーターアレイから生み出される深みのある豊かな低音と鮮明でクリアな高音。 ・空間オーディオはあなたをサウンドで包み込み、どこまでも臨場感あふれるリスニング体験を届けます。 ・進化したコンピュテーショナルオーディオは、リアルタイムで音響性能を最大限に引き出します。 ・室内検知。HomePodは置かれた場所を自動的に検知し、オーディオを微調整。どこからでも最高の音響体験を届けます。 ・ステレオペアも作れます。2つのHomePodスピーカーを置けば、さらに臨場感あふれるサウンドに。Apple TV 4Kと組み合わせれば、完璧なホームシアターシステムが完成します。 ・ホームアプリとHomePodを一緒に使えば、スマートアクセサリを簡単にコントロールできます。 ・プライバシーとセキュリティの機能を内蔵しています。  同梱物 ・HomePod ・電源ケーブル ・マニュアル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/HomePod/Apple_MQJ83JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "221",
    brand: "Apple",
    sku: "MY5H2J/A",
    product_eng: "Home Pod mini - White",
    product_jpn: "Home Pod mini - ホワイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥13,455",
    rrp_with_vat: "¥14,801",
    description_eng:
      "The entire room will be enveloped in 360-degree sound. Place multiple HomePod mini's throughout your home to experience rich multi-room audio and use features like Intercom.  With Siri, HomePod mini turns into a smart assistant. With just your voice, you can check your calendar and weather, set alarms, and complete daily tasks.",
    description_jpn:
      "360度に広がるサウンドで部屋全体が包まれます。複数のHomePod miniを家中に置くと、豊かなマルチルームオーディオを体験したり、インターコムなどの機能を使えます。  Siriを使えば、HomePod miniが賢いアシスタントに変身。あなたの声だけで、カレンダーや天気を確認したり、アラームをセットしたり、毎日のタスクを完了できます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/HomePod/Apple_MY5H2JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "222",
    brand: "Apple",
    sku: "MJ2C3J/A",
    product_eng: "Home Pod mini - Blue",
    product_jpn: "Home Pod mini - ブルー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥13,455",
    rrp_with_vat: "¥14,801",
    description_eng:
      "The entire room will be enveloped in 360-degree sound. Place multiple HomePod mini's throughout your home to experience rich multi-room audio and use features like Intercom.  With Siri, HomePod mini turns into a smart assistant. With just your voice, you can check your calendar and weather, set alarms, and complete daily tasks.",
    description_jpn:
      "360度に広がるサウンドで部屋全体が包まれます。複数のHomePod miniを家中に置くと、豊かなマルチルームオーディオを体験したり、インターコムなどの機能を使えます。  Siriを使えば、HomePod miniが賢いアシスタントに変身。あなたの声だけで、カレンダーや天気を確認したり、アラームをセットしたり、毎日のタスクを完了できます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/HomePod/Apple_MJ2C3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "223",
    brand: "Apple",
    sku: "MJ2D3J/A",
    product_eng: "Home Pod mini - Orange",
    product_jpn: "Home Pod mini - オレンジ",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥13,455",
    rrp_with_vat: "¥14,801",
    description_eng:
      "The entire room will be enveloped in 360-degree sound. Place multiple HomePod mini's throughout your home to experience rich multi-room audio and use features like Intercom.  With Siri, HomePod mini turns into a smart assistant. With just your voice, you can check your calendar and weather, set alarms, and complete daily tasks.",
    description_jpn:
      "360度に広がるサウンドで部屋全体が包まれます。複数のHomePod miniを家中に置くと、豊かなマルチルームオーディオを体験したり、インターコムなどの機能を使えます。  Siriを使えば、HomePod miniが賢いアシスタントに変身。あなたの声だけで、カレンダーや天気を確認したり、アラームをセットしたり、毎日のタスクを完了できます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/HomePod/Apple_MJ2D3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "224",
    brand: "Apple",
    sku: "MJ2E3J/A",
    product_eng: "Home Pod mini - Yellow",
    product_jpn: "Home Pod mini - イエロー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥13,455",
    rrp_with_vat: "¥14,801",
    description_eng:
      "The entire room will be enveloped in 360-degree sound. Place multiple HomePod mini's throughout your home to experience rich multi-room audio and use features like Intercom.  With Siri, HomePod mini turns into a smart assistant. With just your voice, you can check your calendar and weather, set alarms, and complete daily tasks.",
    description_jpn:
      "360度に広がるサウンドで部屋全体が包まれます。複数のHomePod miniを家中に置くと、豊かなマルチルームオーディオを体験したり、インターコムなどの機能を使えます。  Siriを使えば、HomePod miniが賢いアシスタントに変身。あなたの声だけで、カレンダーや天気を確認したり、アラームをセットしたり、毎日のタスクを完了できます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/HomePod/Apple_MJ2E3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "226",
    brand: "Apple",
    sku: "MTJV3J/A",
    product_eng:
      "AirPods Pro (2nd generation) with MagSafe Charging Case (USB‑C)",
    product_jpn: "AirPods Pro(第2世代)MagSafe充電ケース(USB-C)",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥36,182",
    rrp_with_vat: "¥39,800",
    description_eng:
      "We've redesigned the magic.    The USB-C-enabled AirPods Pro (2nd generation) features active noise cancellation that eliminates up to twice as much noise as the previous generation model, an external sound capture mode that allows you to hear sounds around you, and all-new adaptive audio that adjusts noise control to the surrounding conditions. The Conversation Sensing feature lowers the media volume during a conversation to make it easier to hear the person in front of you. The battery lasts up to 6 hours on a single charge. Touch controls make it easy to adjust the volume with a swipe. You'll also appreciate the MagSafe charging case with a strap loop that supports the find the exact location feature and has a built-in speaker.  By far the best sound quality Advanced H2 chip delivers smarter noise cancellation and 3D sound. Adaptive Equalization adjusts music to your ear in real time. So whether you want clear, crystal-clear highs or deep, rich bass, you'll hear it in stunning clarity.  Intelligent Sound Active noise cancellation now removes twice as much unwanted noise. From now on, your listening experience will never be disturbed, whether you are on your way to work or school or just need to concentrate. Adaptive Environmental Noise Elimination reduces the intensity of noise by 48,000 times per second. So you can stay comfortably connected to your surroundings wherever you are.  size  Height: 30.9 mm / Width: 21.8 mm / Thickness: 24.0 mm / Weight: 5.3 g  Case size  Height: 45.2 mm / Width: 60.6 mm / Thickness: 21.7 mm / Weight: 50.8 g",
    description_jpn:
      "魔法を再設計しました   USB-C対応のAirPods Pro(第2世代)は、一世代前のモデルと比べて最大2倍の雑音を消すアクティブノイズキャンセリング、周囲の音が聞ける外部音取り込みモード、周囲の状況に合わせてノイズコントロールを調整するまったく新しい適応型オーディオを搭載。 会話感知機能は、会話中にメディアの音量を下げて、目の前にいる相手の声を聞き取りやすくします。バッテリーは1回の充電で最大6時間持続。タッチコントロールを使って、スワイプで簡単に音量を調節できます。 「正確な場所を見つける」機能に対応し、スピーカーを内蔵したストラップループ付きのMagSafe充電ケースも魅力です。  圧倒的に優れた音質 進化したH2チップが、よりスマートなノイズキャンセリングと3Dサウンドを届けます。アダプティブイコライゼーションは、あなたの耳に合わせて音楽をリアルタイムで調節。だから明瞭で透き通った高音も、深みのある豊かな低音も、驚くほどあざやかにあなたの耳に飛び込みます。  インテリジェントなサウンド アクティブノイズキャンセリングが、不要な雑音を2倍も取り除けるようになりました。これからは、通勤や通学の途中でも、集中力が必要な時でも、あなたのリスニング体験が邪魔されることはありません。適応型環境音除去は、毎秒48,000回も騒音を軽減してその強度を抑えます。だから、どこにいても周囲と快適につながっていられます。  本体サイズ  高さ：30.9 mm/幅：21.8 mm/厚さ：24.0 mm/重量：5.3 g  ケースサイズ  高さ：45.2 mm/幅：60.6 mm/厚さ：21.7 mm/重量：50.8 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/AirPods/Apple_MTJV3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "233",
    brand: "Apple",
    sku: "MX532ZP/A",
    product_eng: "Air Tag 1 pack",
    product_jpn: "Air Tag (1パック)",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥4,527",
    rrp_with_vat: "¥4,980",
    description_eng:
      "Lose your knack for losing things. AirTag is a supereasy way to keep track of your stuff. Attach one to your keys, slip another in your backpack.",
    description_jpn:
      "見つける天才です。 AirTagは、自分の持ち物を見つける簡単な方法。鍵に付けたり、バッグに入れておくだけで、それらを「探す」アプリでいつでも探知できるので安心です。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iphone_accessories/Apple_MX532ZPA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "234",
    brand: "Apple",
    sku: "MX542ZP/A",
    product_eng: "Air Tag 4 pack",
    product_jpn: "Air Tag (4パック)",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥15,436",
    rrp_with_vat: "¥16,980",
    description_eng:
      "Lose your knack for losing things. AirTag is a supereasy way to keep track of your stuff. Attach one to your keys, slip another in your backpack.",
    description_jpn:
      "見つける天才です。 AirTagは、自分の持ち物を見つける簡単な方法。鍵に付けたり、バッグに入れておくだけで、それらを「探す」アプリでいつでも探知できるので安心です。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/apple/iphone_accessories/Apple_MX542ZPA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  },
  {
    id: "939",
    brand: "Apple",
    sku: "MUXD3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 128GB Space Gray",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 128GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXD3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "940",
    brand: "Apple",
    sku: "MUXE3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 128GB Blue",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 128GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXE3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "941",
    brand: "Apple",
    sku: "MUXF3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 128GB Star Light",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 128GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXF3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "942",
    brand: "Apple",
    sku: "MUXG3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 128GB Purple",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 128GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXG3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "943",
    brand: "Apple",
    sku: "MUXH3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 256GB Space Gray",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 256GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥128,000",
    rrp_with_vat: "¥140,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXH3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "944",
    brand: "Apple",
    sku: "MUXJ3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 256GB Blue",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 256GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥128,000",
    rrp_with_vat: "¥140,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXJ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "945",
    brand: "Apple",
    sku: "MUXK3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 256GB Star Light",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 256GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥128,000",
    rrp_with_vat: "¥140,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXK3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "946",
    brand: "Apple",
    sku: "MUXL3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 256GB Purple",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 256GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥128,000",
    rrp_with_vat: "¥140,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXL3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "947",
    brand: "Apple",
    sku: "MUXM3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 512GB Space Gray",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 512GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥160,727",
    rrp_with_vat: "¥176,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXM3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "948",
    brand: "Apple",
    sku: "MUXN3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 512GB Blue",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 512GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥160,727",
    rrp_with_vat: "¥176,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXN3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "949",
    brand: "Apple",
    sku: "MUXP3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 512GB Star Light",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 512GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥160,727",
    rrp_with_vat: "¥176,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXP3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "950",
    brand: "Apple",
    sku: "MUXQ3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 512GB Purple",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 512GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥160,727",
    rrp_with_vat: "¥176,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXQ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "951",
    brand: "Apple",
    sku: "MUXR3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 1TB Space Gray",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 1TB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥193,455",
    rrp_with_vat: "¥212,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXR3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "952",
    brand: "Apple",
    sku: "MUXT3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 1TB Blue",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 1TB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥193,455",
    rrp_with_vat: "¥212,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXT3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "953",
    brand: "Apple",
    sku: "MUXU3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 1TB Star Light",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 1TB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥193,455",
    rrp_with_vat: "¥212,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXU3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "954",
    brand: "Apple",
    sku: "MUXV3J/A",
    product_eng: "iPad Air 11inch Wi-Fi+Cellular 1TB Purple",
    product_jpn: "iPad Air 11inch Wi-Fi+Cellular 1TB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥193,455",
    rrp_with_vat: "¥212,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUXV3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "955",
    brand: "Apple",
    sku: "MV6Q3J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 128GB Space Gray",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 128GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV6Q3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "956",
    brand: "Apple",
    sku: "MV6R3J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 128GB Blue",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 128GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV6R3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "957",
    brand: "Apple",
    sku: "MV6T3J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 128GB Star Light",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 128GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV6T3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "958",
    brand: "Apple",
    sku: "MV6U3J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 128GB Purple",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 128GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV6U3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "959",
    brand: "Apple",
    sku: "MV6V3J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 256GB Space Gray",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 256GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥155,273",
    rrp_with_vat: "¥170,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV6V3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "960",
    brand: "Apple",
    sku: "MV6W3J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 256GB Blue",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 256GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥155,273",
    rrp_with_vat: "¥170,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV6W3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "961",
    brand: "Apple",
    sku: "MV6X3J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 256GB Star Light",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 256GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥155,273",
    rrp_with_vat: "¥170,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV6X3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "962",
    brand: "Apple",
    sku: "MV6Y3J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 256GB Purple",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 256GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥155,273",
    rrp_with_vat: "¥170,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV6Y3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "963",
    brand: "Apple",
    sku: "MV703J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 512GB Space Gray",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 512GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥188,000",
    rrp_with_vat: "¥206,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV703JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "964",
    brand: "Apple",
    sku: "MV713J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 512GB Blue",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 512GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥188,000",
    rrp_with_vat: "¥206,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV713JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "965",
    brand: "Apple",
    sku: "MV723J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 512GB Star Light",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 512GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥188,000",
    rrp_with_vat: "¥206,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV723JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "966",
    brand: "Apple",
    sku: "MV733J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 512GB Purple",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 512GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥188,000",
    rrp_with_vat: "¥206,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV733JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "967",
    brand: "Apple",
    sku: "MV743J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 1TB Space Gray",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 1TB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥220,727",
    rrp_with_vat: "¥242,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV743JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "968",
    brand: "Apple",
    sku: "MV753J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 1TB Blue",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 1TB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥220,727",
    rrp_with_vat: "¥242,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV753JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "969",
    brand: "Apple",
    sku: "MV763J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 1TB Star Light",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 1TB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥220,727",
    rrp_with_vat: "¥242,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV763JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "970",
    brand: "Apple",
    sku: "MV773J/A",
    product_eng: "iPad Air 13inch Wi-Fi+Cellular 1TB Purple",
    product_jpn: "iPad Air 13inch Wi-Fi+Cellular 1TB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥220,727",
    rrp_with_vat: "¥242,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi + Cellular model 618 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi + Cellularモデル 618 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV773JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "971",
    brand: "Apple",
    sku: "MUWC3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 128GB Space Gray",
    product_jpn: "iPad Air 11inch Wi-Fi 128GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥89,818",
    rrp_with_vat: "¥98,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWC3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "972",
    brand: "Apple",
    sku: "MUWD3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 128GB Blue",
    product_jpn: "iPad Air 11inch Wi-Fi 128GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥89,818",
    rrp_with_vat: "¥98,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWD3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "973",
    brand: "Apple",
    sku: "MUWE3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 128GB Star Light",
    product_jpn: "iPad Air 11inch Wi-Fi 128GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥89,818",
    rrp_with_vat: "¥98,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWE3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "974",
    brand: "Apple",
    sku: "MUWF3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 128GB Purple",
    product_jpn: "iPad Air 11inch Wi-Fi 128GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥89,818",
    rrp_with_vat: "¥98,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWF3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "975",
    brand: "Apple",
    sku: "MUWG3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 256GB Space Gray",
    product_jpn: "iPad Air 11inch Wi-Fi 256GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥104,364",
    rrp_with_vat: "¥114,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWG3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "976",
    brand: "Apple",
    sku: "MUWH3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 256GB Blue",
    product_jpn: "iPad Air 11inch Wi-Fi 256GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥104,364",
    rrp_with_vat: "¥114,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWH3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "977",
    brand: "Apple",
    sku: "MUWJ3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 256GB Star Light",
    product_jpn: "iPad Air 11inch Wi-Fi 256GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥104,364",
    rrp_with_vat: "¥114,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWJ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "978",
    brand: "Apple",
    sku: "MUWK3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 256GB Purple",
    product_jpn: "iPad Air 11inch Wi-Fi 256GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥104,364",
    rrp_with_vat: "¥114,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWK3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "979",
    brand: "Apple",
    sku: "MUWL3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 512GB Space Gray",
    product_jpn: "iPad Air 11inch Wi-Fi 512GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥137,091",
    rrp_with_vat: "¥150,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWL3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "980",
    brand: "Apple",
    sku: "MUWM3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 512GB Blue",
    product_jpn: "iPad Air 11inch Wi-Fi 512GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥137,091",
    rrp_with_vat: "¥150,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWM3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "981",
    brand: "Apple",
    sku: "MUWN3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 512GB Star Light",
    product_jpn: "iPad Air 11inch Wi-Fi 512GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥137,091",
    rrp_with_vat: "¥150,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWN3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "982",
    brand: "Apple",
    sku: "MUWP3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 512GB Purple",
    product_jpn: "iPad Air 11inch Wi-Fi 512GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥137,091",
    rrp_with_vat: "¥150,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWP3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "983",
    brand: "Apple",
    sku: "MUWQ3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 1TB Space Gray",
    product_jpn: "iPad Air 11inch Wi-Fi 1TB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥169,818",
    rrp_with_vat: "¥186,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWQ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "984",
    brand: "Apple",
    sku: "MUWR3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 1TB Blue",
    product_jpn: "iPad Air 11inch Wi-Fi 1TB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥169,818",
    rrp_with_vat: "¥186,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWR3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "985",
    brand: "Apple",
    sku: "MUWT3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 1TB Star Light",
    product_jpn: "iPad Air 11inch Wi-Fi 1TB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥169,818",
    rrp_with_vat: "¥186,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWT3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "986",
    brand: "Apple",
    sku: "MUWU3J/A",
    product_eng: "iPad Air 11inch Wi-Fi 1TB Purple",
    product_jpn: "iPad Air 11inch Wi-Fi 1TB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥169,818",
    rrp_with_vat: "¥186,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 462 g (178.5 mm H x 247.6 mm W x 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 462 g  縦178.5 mm 横247.6 mm 厚み6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MUWU3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "987",
    brand: "Apple",
    sku: "MV273J/A",
    product_eng: "iPad Air 13inch Wi-Fi 128GB Space Gray",
    product_jpn: "iPad Air 13inch Wi-Fi 128GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥117,091",
    rrp_with_vat: "¥128,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV273JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "988",
    brand: "Apple",
    sku: "MV283J/A",
    product_eng: "iPad Air 13inch Wi-Fi 128GB Blue",
    product_jpn: "iPad Air 13inch Wi-Fi 128GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥117,091",
    rrp_with_vat: "¥128,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV283JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "989",
    brand: "Apple",
    sku: "MV293J/A",
    product_eng: "iPad Air 13inch Wi-Fi 128GB Star Light",
    product_jpn: "iPad Air 13inch Wi-Fi 128GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥117,091",
    rrp_with_vat: "¥128,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV293JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "990",
    brand: "Apple",
    sku: "MV2C3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 128GB Purple",
    product_jpn: "iPad Air 13inch Wi-Fi 128GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥117,091",
    rrp_with_vat: "¥128,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2C3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "991",
    brand: "Apple",
    sku: "MV2D3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 256GB Space Gray",
    product_jpn: "iPad Air 13inch Wi-Fi 256GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥131,636",
    rrp_with_vat: "¥144,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2D3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "992",
    brand: "Apple",
    sku: "MV2F3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 256GB Blue",
    product_jpn: "iPad Air 13inch Wi-Fi 256GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥131,636",
    rrp_with_vat: "¥144,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2F3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "993",
    brand: "Apple",
    sku: "MV2G3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 256GB Star Light",
    product_jpn: "iPad Air 13inch Wi-Fi 256GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥131,636",
    rrp_with_vat: "¥144,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2G3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "994",
    brand: "Apple",
    sku: "MV2H3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 256GB Purple",
    product_jpn: "iPad Air 13inch Wi-Fi 256GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥131,636",
    rrp_with_vat: "¥144,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2H3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "995",
    brand: "Apple",
    sku: "MV2J3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 512GB Space Gray",
    product_jpn: "iPad Air 13inch Wi-Fi 512GB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥164,364",
    rrp_with_vat: "¥180,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2J3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "996",
    brand: "Apple",
    sku: "MV2K3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 512GB Blue",
    product_jpn: "iPad Air 13inch Wi-Fi 512GB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥164,364",
    rrp_with_vat: "¥180,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2K3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "997",
    brand: "Apple",
    sku: "MV2L3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 512GB Star Light",
    product_jpn: "iPad Air 13inch Wi-Fi 512GB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥164,364",
    rrp_with_vat: "¥180,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2L3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "998",
    brand: "Apple",
    sku: "MV2N3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 512GB Purple",
    product_jpn: "iPad Air 13inch Wi-Fi 512GB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥164,364",
    rrp_with_vat: "¥180,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2N3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "999",
    brand: "Apple",
    sku: "MV2P3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 1TB Space Gray",
    product_jpn: "iPad Air 13inch Wi-Fi 1TB スペースグレー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥197,091",
    rrp_with_vat: "¥216,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2P3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1000",
    brand: "Apple",
    sku: "MV2Q3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 1TB Blue",
    product_jpn: "iPad Air 13inch Wi-Fi 1TB ブルー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥197,091",
    rrp_with_vat: "¥216,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2Q3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1001",
    brand: "Apple",
    sku: "MV2R3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 1TB Star Light",
    product_jpn: "iPad Air 13inch Wi-Fi 1TB スターライト",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥197,091",
    rrp_with_vat: "¥216,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2R3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1002",
    brand: "Apple",
    sku: "MV2T3J/A",
    product_eng: "iPad Air 13inch Wi-Fi 1TB Purple",
    product_jpn: "iPad Air 13inch Wi-Fi 1TB パープル",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥197,091",
    rrp_with_vat: "¥216,800",
    description_eng:
      "It has a beautiful high-resolution Liquid Retina display. It realistically reflects everything you love to do.  Brilliantly,responsive, and accurate colors pop into your eyes. Welcome to the new iPad Air. ■The incredible power of the M2 chip, built right in. ■The stunning CPU, graphics, Neural Engine, and powerful AI features. ■All-day battery life. ■12MP landscape-facing, ultra-wide-angle front camera. More comfortable video calling. ■Dimensions Wi-Fi model 617 g (214.9 mm H, 280.6 mm W, 6.1 mm D) ■Included in the box iPad Air/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "美しい高解像度のLiquid Retinaディスプレイを搭載。 あなたが好きなことすべてをリアルに映し出します。あざやかで、 反応が良くて、正確な色が目に飛び込む。新しいiPad Airへようこそ。 ■M2チップの驚異的なパワー、内蔵。 ■圧倒的なCPU、グラフィックス、Neural Engine、そして力強いAI機能。 ■一日中使えるバッテリー。 ■横向きの12MP超広角フロントカメラ。より快適なビデオ通話を。 ■サイズ Wi-Fi モデル 617 g 縦214.9 mm 横280.6 mm 厚み 6.1 mm ■同梱物 iPad Air/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Air/Apple_MV2T3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1003",
    brand: "Apple",
    sku: "MVW13J/A",
    product_eng:
      "iPad Pro 11-inch Wi-Fi+Cellular 256GB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi+Cellular 256GB （標準ガラス搭載） スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥186,182",
    rrp_with_vat: "¥204,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi + Cellular model 11inch 446 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi + Cellularモデル  11inch 446 g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVW13JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1004",
    brand: "Apple",
    sku: "MVW23J/A",
    product_eng:
      "iPad Pro 11-inch Wi-Fi+Cellular 256GB (Standard glass) Silver",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi+Cellular 256GB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥186,182",
    rrp_with_vat: "¥204,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi + Cellular model 11inch 446 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi + Cellularモデル  11inch 446 g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVW23JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1005",
    brand: "Apple",
    sku: "MVW33J/A",
    product_eng:
      "iPad Pro 11-inch Wi-Fi+Cellular 512GB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi+Cellular 512GB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥218,909",
    rrp_with_vat: "¥240,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi + Cellular model 11inch 446 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi + Cellularモデル  11inch 446 g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVW33JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1006",
    brand: "Apple",
    sku: "MVW43J/A",
    product_eng:
      "iPad Pro 11-inch Wi-Fi+Cellular 512GB (Standard glass) Silver",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi+Cellular 512GB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥218,909",
    rrp_with_vat: "¥240,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi + Cellular model 11inch 446 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi + Cellularモデル  11inch 446 g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVW43JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1007",
    brand: "Apple",
    sku: "MVW53J/A",
    product_eng:
      "iPad Pro 11-inch Wi-Fi+Cellular 1TB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi+Cellular 1TB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥280,727",
    rrp_with_vat: "¥308,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi + Cellular model 11inch 446 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi + Cellularモデル  11inch 446 g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVW53JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1008",
    brand: "Apple",
    sku: "MVW63J/A",
    product_eng: "iPad Pro 11-inch Wi-Fi+Cellular 1TB (Standard glass) Silver",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi+Cellular 1TB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥280,727",
    rrp_with_vat: "¥308,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi + Cellular model 11inch 446 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi + Cellularモデル  11inch 446 g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVW63JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1009",
    brand: "Apple",
    sku: "MVW73J/A",
    product_eng:
      "iPad Pro 11-inch Wi-Fi+Cellular 2TB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi+Cellular 2TB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥342,545",
    rrp_with_vat: "¥376,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi + Cellular model 11inch 446 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi + Cellularモデル  11inch 446 g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVW73JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1010",
    brand: "Apple",
    sku: "MVW83J/A",
    product_eng: "iPad Pro 11-inch Wi-Fi+Cellular 2TB (Standard glass) Silver",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi+Cellular 2TB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥342,545",
    rrp_with_vat: "¥376,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi + Cellular model 11inch 446 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi + Cellularモデル  11inch 446 g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVW83JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1011",
    brand: "Apple",
    sku: "MVXR3J/A",
    product_eng:
      "iPad Pro 13-inch Wi-Fi+Cellular 256GB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi+Cellular 256GB （標準ガラス搭載） スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥231,636",
    rrp_with_vat: "¥254,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi+Cellular 13inch 582 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi+Cellularモデル  13inch 582 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVXR3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1012",
    brand: "Apple",
    sku: "MVXT3J/A",
    product_eng:
      "iPad Pro 13-inch Wi-Fi+Cellular 256GB (Standard glass) Silver",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi+Cellular 256GB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥231,636",
    rrp_with_vat: "¥254,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi+Cellular 13inch 582 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi+Cellularモデル  13inch 582 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVXT3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1013",
    brand: "Apple",
    sku: "MVXU3J/A",
    product_eng:
      "iPad Pro 13-inch Wi-Fi+Cellular 512GB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi+Cellular 512GB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥264,364",
    rrp_with_vat: "¥290,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi+Cellular 13inch 582 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi+Cellularモデル  13inch 582 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVXU3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1014",
    brand: "Apple",
    sku: "MVXV3J/A",
    product_eng:
      "iPad Pro 13-inch Wi-Fi+Cellular 512GB (Standard glass) Silver",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi+Cellular 512GB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥264,364",
    rrp_with_vat: "¥290,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi+Cellular 13inch 582 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi+Cellularモデル  13inch 582 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVXV3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1015",
    brand: "Apple",
    sku: "MVXW3J/A",
    product_eng:
      "iPad Pro 13-inch Wi-Fi+Cellular 1TB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi+Cellular 1TB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥326,182",
    rrp_with_vat: "¥358,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi+Cellular 13inch 582 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi+Cellularモデル  13inch 582 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVXW3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1016",
    brand: "Apple",
    sku: "MVXX3J/A",
    product_eng: "iPad Pro 13-inch Wi-Fi+Cellular 1TB (Standard glass) Silver",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi+Cellular 1TB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥326,182",
    rrp_with_vat: "¥358,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi+Cellular 13inch 582 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi+Cellularモデル  13inch 582 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVXX3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1017",
    brand: "Apple",
    sku: "MVXY3J/A",
    product_eng:
      "iPad Pro 13-inch Wi-Fi+Cellular 2TB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi+Cellular 2TB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥388,000",
    rrp_with_vat: "¥426,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi+Cellular 13inch 582 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi+Cellularモデル  13inch 582 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVXY3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1018",
    brand: "Apple",
    sku: "MVY03J/A",
    product_eng: "iPad Pro 13-inch Wi-Fi+Cellular 2TB (Standard glass) Silver",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi+Cellular 2TB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥388,000",
    rrp_with_vat: "¥426,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi+Cellular 13inch 582 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fi+Cellularモデル  13inch 582 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVY03JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1019",
    brand: "Apple",
    sku: "MVV83J/A",
    product_eng: "iPad Pro 11-inch Wi-Fi 256GB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi 256GB （標準ガラス搭載） スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥153,455",
    rrp_with_vat: "¥168,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi 11inch 444 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  11inch 444 g g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVV83JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1020",
    brand: "Apple",
    sku: "MVV93J/A",
    product_eng: "iPad Pro 11-inch Wi-Fi 256GB (Standard glass) Silver",
    product_jpn: "iPad Pro 11-inch Wi-Fi 256GB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥153,455",
    rrp_with_vat: "¥168,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi 11inch 444 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  11inch 444 g g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVV93JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1021",
    brand: "Apple",
    sku: "MVVC3J/A",
    product_eng: "iPad Pro 11-inch Wi-Fi 512GB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi 512GB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥186,182",
    rrp_with_vat: "¥204,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi 11inch 444 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  11inch 444 g g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVVC3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1022",
    brand: "Apple",
    sku: "MVVD3J/A",
    product_eng: "iPad Pro 11-inch Wi-Fi 512GB (Standard glass) Silver",
    product_jpn: "iPad Pro 11-inch Wi-Fi 512GB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥186,182",
    rrp_with_vat: "¥204,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi 11inch 444 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  11inch 444 g g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVVD3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1023",
    brand: "Apple",
    sku: "MVVE3J/A",
    product_eng: "iPad Pro 11-inch Wi-Fi 1TB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi 1TB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥248,000",
    rrp_with_vat: "¥272,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi 11inch 444 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  11inch 444 g g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVVE3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1024",
    brand: "Apple",
    sku: "MVVF3J/A",
    product_eng: "iPad Pro 11-inch Wi-Fi 1TB (Standard glass) Silver",
    product_jpn: "iPad Pro 11-inch Wi-Fi 1TB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥248,000",
    rrp_with_vat: "¥272,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi 11inch 444 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  11inch 444 g g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVVF3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1025",
    brand: "Apple",
    sku: "MVVG3J/A",
    product_eng: "iPad Pro 11-inch Wi-Fi 2TB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 11-inch Wi-Fi 2TB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥309,818",
    rrp_with_vat: "¥340,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi 11inch 444 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  11inch 444 g g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVVG3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1026",
    brand: "Apple",
    sku: "MVVH3J/A",
    product_eng: "iPad Pro 11-inch Wi-Fi 2TB (Standard glass) Silver",
    product_jpn: "iPad Pro 11-inch Wi-Fi 2TB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥309,818",
    rrp_with_vat: "¥340,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi 11inch 444 g. 177.5 mm long, 249.7 mm wide, 5.3 mm thick ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 超ポータブルな11インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  11inch 444 g g 縦177.5 mm 横249.7 mm 厚み5.3 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVVH3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1027",
    brand: "Apple",
    sku: "MVX23J/A",
    product_eng: "iPad Pro 13-inch Wi-Fi 256GB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi 256GB （標準ガラス搭載） スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥198,909",
    rrp_with_vat: "¥218,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi model 13inch 579 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  13inch 579 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVX23JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1028",
    brand: "Apple",
    sku: "MVX33J/A",
    product_eng: "iPad Pro 13-inch Wi-Fi 256GB (Standard glass) Silver",
    product_jpn: "iPad Pro 13-inch Wi-Fi 256GB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥198,909",
    rrp_with_vat: "¥218,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi model 13inch 579 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  13inch 579 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVX33JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1029",
    brand: "Apple",
    sku: "MVX43J/A",
    product_eng: "iPad Pro 13-inch Wi-Fi 512GB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi 512GB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥231,636",
    rrp_with_vat: "¥254,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi model 13inch 579 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  13inch 579 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVX43JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1030",
    brand: "Apple",
    sku: "MVX53J/A",
    product_eng: "iPad Pro 13-inch Wi-Fi 512GB (Standard glass) Silver",
    product_jpn: "iPad Pro 13-inch Wi-Fi 512GB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥231,636",
    rrp_with_vat: "¥254,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi model 13inch 579 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  13inch 579 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVX53JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1031",
    brand: "Apple",
    sku: "MVX63J/A",
    product_eng: "iPad Pro 13-inch Wi-Fi 1TB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi 1TB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥293,455",
    rrp_with_vat: "¥322,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi model 13inch 579 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  13inch 579 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVX63JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1032",
    brand: "Apple",
    sku: "MVX73J/A",
    product_eng: "iPad Pro 13-inch Wi-Fi 1TB (Standard glass) Silver",
    product_jpn: "iPad Pro 13-inch Wi-Fi 1TB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥293,455",
    rrp_with_vat: "¥322,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi model 13inch 579 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  13inch 579 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVX73JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1033",
    brand: "Apple",
    sku: "MVX83J/A",
    product_eng: "iPad Pro 13-inch Wi-Fi 2TB (Standard glass) Space Black",
    product_jpn:
      "iPad Pro 13-inch Wi-Fi 2TB （標準ガラス搭載）スペースブラック",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥355,273",
    rrp_with_vat: "¥390,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi model 13inch 579 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  13inch 579 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVX83JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1034",
    brand: "Apple",
    sku: "MVX93J/A",
    product_eng: "iPad Pro 13-inch Wi-Fi 2TB (Standard glass) Silver",
    product_jpn: "iPad Pro 13-inch Wi-Fi 2TB （標準ガラス搭載）シルバー",
    category_1: "Electronics",
    category_2: "Tablet",
    rrp_ex_vat: "¥355,273",
    rrp_with_vat: "¥390,800",
    description_eng:
      "Thrill. Sleeker. The all-new iPad Pro packs astonishing power into an unbelievably thin, light, and portable design. Ultra Retina XDR display. Tandem OLED technology. Ultra-portable 11-inch model. ■Apple M4 chip. Jumping performance and graphics. And powerful AI capabilities. ■All-day battery life. Work, study, create, and play as much as you want. ■Intuitive iPad OS and advanced apps. Accelerate your professional work. ■Professional camera. 4K ProRes video, AR, document scanning. ■Dimensions Wi-Fi model 13inch 579 g (215.5 mm long, 281.6 mm wide, 5.1 mm thick) ■Included in the box iPad Pro/USB-C charging cable (1 m)/20W USB-C power adapter",
    description_jpn:
      "薄すぎる。軽すぎる。しかも、速すぎる。 Ultra Retina XDRディスプレイ。タンデムOLEDテクノロジーを採用。 大きなディスプレイを搭載し、史上最高に薄いApple製品として生まれた13インチモデル。 ■Apple M4チップ。飛び級のパフォーマンスとグラフィックス。そして、力強いAI機能。 ■一日中使えるバッテリー。 仕事も、勉強も、制作も、遊びも好きなだけ。 ■直感的なiPadOSと先進的なアプリ。プロの作業が加速する。 ■プロのカメラ。4K ProResビデオも、ARも、書類のスキャンも。 ■サイズ Wi-Fiモデル  13inch 579 g  縦215.5 mm 横281.6 mm 厚み5.1 mm ■同梱物 iPad Pro/USB-C充電ケーブル（1m）/20W USB-C電源アダプタ",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MVX93JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "1035",
    brand: "Apple",
    sku: "MX2D3ZA/A",
    product_eng: "Apple Pencil Pro",
    product_jpn: "Apple Pencil Pro",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥19,818",
    rrp_with_vat: "¥21,800",
    description_eng:
      "With the ability to do even more of the magic, Apple Pencil Pro helps you shape your ideas. With advanced new features, you can annotate, take notes, and create masterpieces more intuitively than ever before. Specifications Length: 166 mm Diameter: 8.9 mm Weight: 19.15 g Connection: Bluetooth Other features: Magnetic mounting, pairing, charging Compatibility iPad Pro (13-inch) (M4) iPad Pro (11-inch) (M4) iPad Air (13-inch) (M2) iPad Air (11-inch) (M2)",
    description_jpn:
      "魔法のようなことを一段と多くできるApple Pencil Proは、あなたのアイデアを形にするのに役立ちます。先進的な新機能を搭載しているので、かつてないほど直感的に、注釈を加えたり、メモを取ったり、傑作を生み出すことができます。 仕様 長さ：166 mm 直径：8.9 mm 重量：19.15 g 接続: Bluetooth その他機能: マグネットで取りつけ、ペアリング、充電 互換性 iPad Pro（13インチ）（M4） iPad Pro（11インチ）（M4） iPad Air（13インチ）（M2） iPad Air（11インチ）（M2）",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iPad_Pro/Apple_MX2D3ZAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple.png",
  },
  {
    id: "286",
    brand: "Beats",
    sku: "MYMC2PA/A",
    product_eng: "Beats Flex Black",
    product_jpn: "Beats Flex ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥8,909",
    rrp_with_vat: "¥9,800",
    description_eng:
      "Flex all day In your ears or around your neck, Beats Flex are as versatile as the life you lead. Whether you’re listening to music, taking calls, or scrolling your social feed, you’ll always be ready for what’s next. Magnetic earbuds make listening that much easier by automatically playing music when they’re in your ears and pausing when they’re attached around your neck¹. The Flex-Form cable provides all-day comfort with durable Nitinol construction while four eartip options offer a personalized fit. And when you’re not wearing them, the magnetic earbuds keep Beats Flex tangle-free as they easily coil up into your pocket or purse.The music stops when you do Less charging. More flexing. Beats Flex boasts up to 12 hours of listening time for all-day use. If you need a little extra power, 10-minute Fast Fuel charging gives 1.5 hours of playback when battery is low.²",
    description_jpn:
      "一日中着けても快適 Beats Flexは、アクティブな毎日にぴったりのワイヤレスイヤフォン。装着したり、首にかけたり、生活の様々なシーンに寄り添います。音楽にも通話にもソーシャルメディアをチェックする時も、いつでも準備万端です。マグネット式イヤーバッドは、耳に装着すると自動的に再生し、首の周りでイヤーバッド同士をくっつけると自動的に一時停止する¹ので、操作も簡単です。Flex-Formケーブルは一日中身につけていても快適で、ニチノール製なので耐久性にも優れています。イヤーチップはあらゆる人に合うように4種類のサイズが用意されています。身につけていない時は、マグネット式のイヤーバッドがイヤフォン同士のからまりを防ぐので、簡単にケーブルを巻いて、ポケットやバッグに入れて持ち運べます。 充電をあまり気にせずに、どんどん使えます。Beats Flexは最大12時間の再生が可能なので、ずっと音楽を聴き続けることができます。バッテリー残量が少なくなっても、Fast Fuel機能により10分の急速充電で1.5時間再生できます²。 低音域を緻密に再現し、歪みを低減する独自の音響プラットフォームにより、プレミアムサウンドを実現 風ノイズの低減機能を備えた内蔵マイクで、よりクリアな音声を実現",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/beats/Beats_MYMC2PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
  },
  {
    id: "287",
    brand: "Beats",
    sku: "MYME2PA/A",
    product_eng: "Beats Flex Smoke Gray ",
    product_jpn: "Beats Flex スモークグレー",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥8,909",
    rrp_with_vat: "¥9,800",
    description_eng:
      "Flex all day In your ears or around your neck, Beats Flex are as versatile as the life you lead. Whether you’re listening to music, taking calls, or scrolling your social feed, you’ll always be ready for what’s next. Magnetic earbuds make listening that much easier by automatically playing music when they’re in your ears and pausing when they’re attached around your neck¹. The Flex-Form cable provides all-day comfort with durable Nitinol construction while four eartip options offer a personalized fit. And when you’re not wearing them, the magnetic earbuds keep Beats Flex tangle-free as they easily coil up into your pocket or purse.The music stops when you do Less charging. More flexing. Beats Flex boasts up to 12 hours of listening time for all-day use. If you need a little extra power, 10-minute Fast Fuel charging gives 1.5 hours of playback when battery is low.²",
    description_jpn:
      "一日中着けても快適 Beats Flexは、アクティブな毎日にぴったりのワイヤレスイヤフォン。装着したり、首にかけたり、生活の様々なシーンに寄り添います。音楽にも通話にもソーシャルメディアをチェックする時も、いつでも準備万端です。マグネット式イヤーバッドは、耳に装着すると自動的に再生し、首の周りでイヤーバッド同士をくっつけると自動的に一時停止する¹ので、操作も簡単です。Flex-Formケーブルは一日中身につけていても快適で、ニチノール製なので耐久性にも優れています。イヤーチップはあらゆる人に合うように4種類のサイズが用意されています。身につけていない時は、マグネット式のイヤーバッドがイヤフォン同士のからまりを防ぐので、簡単にケーブルを巻いて、ポケットやバッグに入れて持ち運べます。 充電をあまり気にせずに、どんどん使えます。Beats Flexは最大12時間の再生が可能なので、ずっと音楽を聴き続けることができます。バッテリー残量が少なくなっても、Fast Fuel機能により10分の急速充電で1.5時間再生できます²。 低音域を緻密に再現し、歪みを低減する独自の音響プラットフォームにより、プレミアムサウンドを実現 風ノイズの低減機能を備えた内蔵マイクで、よりクリアな音声を実現",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/beats/Beats_MYME2PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
  },
  {
    id: "293",
    brand: "Beats",
    sku: "MK2F3PA/A",
    product_eng: "Beats Fit Pro-Noise Cancelling Earphones Black",
    product_jpn: "Beats Fit Pro-ノイズキャンセリングイヤフォン-ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥26,182",
    rrp_with_vat: "¥28,800",
    description_eng:
      "・Wingtips for a snug fit and all-day comfort and stability ・Unique acoustic platform for powerful, balanced sound ・Spatial audio with dynamic head-tracking for a sound experience that envelops you in movies, music, games, and any other content. ・Two playback modes: Active Noise Cancellation and External Sound Induction. ・Built-in Apple H1 chip enables automatic device-to-device switching, audio sharing with other Beats headphones or Apple AirPods, and Hey Siri ・Sweat-resistant (IPX4 rating) earbuds ・Up to 6 hours of playback (up to 24 hours with pocket-sized charging case) ・Built-in microphone for enhanced call performance and voice assistant quality ・Industry-leading Class 1 Bluetooth® technology for greater range and fewer dropouts ・Included - Beats Fit Pro wireless noise-canceling earbuds, matching charging case, ear tips in three sizes, USB-C to USB-C charging cable, Quick Start Guide, and warranty card (USB-C power adapter sold separately",
    description_jpn:
      "・ぴったりフィットするウィングチップで、一日中快適で安定した着け心地 ・パワフルでバランスに優れたサウンドを再現する独自のアコースティックプラットフォーム ・ダイナミックヘッドトラッキングによる空間オーディオで、映画、音楽、ゲーム、どんなコンテンツでも音に包まれるようなサウンド ・選べる2つの再生モード：アクティブノイズキャンセリングと外部音取り込みモード ・Apple H1チップを搭載し、デバイス間の自動切り替え、別のBeatsヘッドフォンやApple AirPodsとのオーディオ共有、「Hey Siri」が可能に ・耐汗耐水性能（IPX4等級）を備えたイヤーバッド ・最大6時間の再生が可能（ポケットサイズの充電ケースを使用した場合は最大24時間） ・通話性能やボイスアシスタントの品質を高める内蔵マイク ・業界最高クラスのClass 1 Bluetooth®テクノロジーにより、接続範囲が広く、ドロップアウトも減少 ・同梱物 – 完全ワイヤレスノイズキャンセリングイヤーバッドBeats Fit Pro、同色の充電ケース、3つのサイズから選べるイヤーチップ、USB-C - USB-C充電ケーブル、クイックスタートガイド、保証書（USB-C電源アダプタは別売りです）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/beats/Beats_MK2F3PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
  },
  {
    id: "294",
    brand: "Beats",
    sku: "MK2G3PA/A",
    product_eng: "Beats Fit Pro-Noise Cancelling Earphones White",
    product_jpn: "Beats Fit Pro-ノイズキャンセリングイヤフォン-ホワイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥26,182",
    rrp_with_vat: "¥28,800",
    description_eng:
      "・Wingtips for a snug fit and all-day comfort and stability ・Unique acoustic platform for powerful, balanced sound ・Spatial audio with dynamic head-tracking for a sound experience that envelops you in movies, music, games, and any other content. ・Two playback modes: Active Noise Cancellation and External Sound Induction. ・Built-in Apple H1 chip enables automatic device-to-device switching, audio sharing with other Beats headphones or Apple AirPods, and Hey Siri ・Sweat-resistant (IPX4 rating) earbuds ・Up to 6 hours of playback (up to 24 hours with pocket-sized charging case) ・Built-in microphone for enhanced call performance and voice assistant quality ・Industry-leading Class 1 Bluetooth® technology for greater range and fewer dropouts ・Included - Beats Fit Pro wireless noise-canceling earbuds, matching charging case, ear tips in three sizes, USB-C to USB-C charging cable, Quick Start Guide, and warranty card (USB-C power adapter sold separately",
    description_jpn:
      "・ぴったりフィットするウィングチップで、一日中快適で安定した着け心地 ・パワフルでバランスに優れたサウンドを再現する独自のアコースティックプラットフォーム ・ダイナミックヘッドトラッキングによる空間オーディオで、映画、音楽、ゲーム、どんなコンテンツでも音に包まれるようなサウンド ・選べる2つの再生モード：アクティブノイズキャンセリングと外部音取り込みモード ・Apple H1チップを搭載し、デバイス間の自動切り替え、別のBeatsヘッドフォンやApple AirPodsとのオーディオ共有、「Hey Siri」が可能に ・耐汗耐水性能（IPX4等級）を備えたイヤーバッド ・最大6時間の再生が可能（ポケットサイズの充電ケースを使用した場合は最大24時間） ・通話性能やボイスアシスタントの品質を高める内蔵マイク ・業界最高クラスのClass 1 Bluetooth®テクノロジーにより、接続範囲が広く、ドロップアウトも減少 ・同梱物 – 完全ワイヤレスノイズキャンセリングイヤーバッドBeats Fit Pro、同色の充電ケース、3つのサイズから選べるイヤーチップ、USB-C - USB-C充電ケーブル、クイックスタートガイド、保証書（USB-C電源アダプタは別売りです）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/beats/Beats_MK2G3PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
  },
  {
    id: "295",
    brand: "Beats",
    sku: "MK2J3PA/A",
    product_eng: "Beats Fit Pro-Noise Cancelling Earphones Sage Gray",
    product_jpn: "Beats Fit Pro-ノイズキャンセリングイヤフォン-セージグレイ",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥26,182",
    rrp_with_vat: "¥28,800",
    description_eng:
      "・Wingtips for a snug fit and all-day comfort and stability ・Unique acoustic platform for powerful, balanced sound ・Spatial audio with dynamic head-tracking for a sound experience that envelops you in movies, music, games, and any other content. ・Two playback modes: Active Noise Cancellation and External Sound Induction. ・Built-in Apple H1 chip enables automatic device-to-device switching, audio sharing with other Beats headphones or Apple AirPods, and Hey Siri ・Sweat-resistant (IPX4 rating) earbuds ・Up to 6 hours of playback (up to 24 hours with pocket-sized charging case) ・Built-in microphone for enhanced call performance and voice assistant quality ・Industry-leading Class 1 Bluetooth® technology for greater range and fewer dropouts ・Included - Beats Fit Pro wireless noise-canceling earbuds, matching charging case, ear tips in three sizes, USB-C to USB-C charging cable, Quick Start Guide, and warranty card (USB-C power adapter sold separately",
    description_jpn:
      "・ぴったりフィットするウィングチップで、一日中快適で安定した着け心地 ・パワフルでバランスに優れたサウンドを再現する独自のアコースティックプラットフォーム ・ダイナミックヘッドトラッキングによる空間オーディオで、映画、音楽、ゲーム、どんなコンテンツでも音に包まれるようなサウンド ・選べる2つの再生モード：アクティブノイズキャンセリングと外部音取り込みモード ・Apple H1チップを搭載し、デバイス間の自動切り替え、別のBeatsヘッドフォンやApple AirPodsとのオーディオ共有、「Hey Siri」が可能に ・耐汗耐水性能（IPX4等級）を備えたイヤーバッド ・最大6時間の再生が可能（ポケットサイズの充電ケースを使用した場合は最大24時間） ・通話性能やボイスアシスタントの品質を高める内蔵マイク ・業界最高クラスのClass 1 Bluetooth®テクノロジーにより、接続範囲が広く、ドロップアウトも減少 ・同梱物 – 完全ワイヤレスノイズキャンセリングイヤーバッドBeats Fit Pro、同色の充電ケース、3つのサイズから選べるイヤーチップ、USB-C - USB-C充電ケーブル、クイックスタートガイド、保証書（USB-C電源アダプタは別売りです）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/beats/Beats_MK2J3PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
  },
  {
    id: "298",
    brand: "Citizen",
    sku: "CB1120-50L",
    product_eng: "Citizen ATESSA CB1120-50L",
    product_jpn: "Citizen シチズン ATESSA CB1120-50L",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥60,000",
    rrp_with_vat: "¥66,000",
    description_eng:
      "Product Features         Glass : Sapphire glass (non-reflective coating)     Display type : Analog display     Case : Super titanium ,Duratekto titanium carbide (Silver color)     Band Material type : Titanium belt type Other Features     Equipped with PERFEX     Japan, China and Europe Radio Reception     Receiving station automatic selection    function     Scheduled reception function     Forced reception function     Impact detection function     Automatic needle correction function     Charge level display function     Charge warning function     Overcharge prevention function     World time function (26 cities)     Summer time function Weight 82g Thickness 9.3 mm Case size 38.0mm",
    description_jpn:
      "日本、中国、アメリカ、ヨーロッパの世界4エリアの標準電波に対応し、りゅうずを一段引いて秒針を都市名に合わせると、その選択した都市時刻とカレンダーの表示を瞬時に開始するワールドタイム機能搭載のエコ・ドライブ電波時計。 ケースやバンドはステンレスの約1/2の軽さで、肌に優しく、さびにくく、そしてキズに強いスーパーチタニウムを採用し、ガラスには高い透明度で視認性に優れたサファイアガラスを採用しています。 ビジネスウォッチとして定番のシンプルデザインを生かしながら、ミドルサイズウオッチへのニーズに対応できるようにサイズダウンすることで、より使い勝手の良いケース幅38mmサイズに仕上げています。 充実の機能性とデザイン性を兼ね備えたアテッサのエントリーモデルです。 パーペチュアルカレンダー  日中米欧電波受信 サファイアガラス（無反射コーティング） 耐ニッケル、耐磁１種 夜光（針＋インデックス） 10気圧防水 日本製 重量 \t82g  厚み \t9.3mm ケースサイズ 38.0mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_CB1120-50L.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "299",
    brand: "Citizen",
    sku: "CB1120-50E",
    product_eng: "Citizen ATESSA CB1120-50E",
    product_jpn: "Citizen シチズン ATESSA CB1120-50E",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥60,000",
    rrp_with_vat: "¥66,000",
    description_eng:
      "Product Features         Glass : Sapphire glass (non-reflective coating)     Display type : Analog display     Case : Super titanium ,Duratekto titanium carbide (Silver color)     Band Material type : Titanium belt type Other Features     Equipped with PERFEX     Japan, China and Europe Radio Reception     Receiving station automatic selection    function     Scheduled reception function     Forced reception function     Impact detection function     Automatic needle correction function     Charge level display function     Charge warning function     Overcharge prevention function     World time function (26 cities)     Summer time function Weight 82g Thickness 9.3 mm Case size 38.0mm",
    description_jpn:
      "日本、中国、アメリカ、ヨーロッパの世界4エリアの標準電波に対応し、りゅうずを一段引いて秒針を都市名に合わせると、その選択した都市時刻とカレンダーの表示を瞬時に開始するワールドタイム機能搭載のエコ・ドライブ電波時計。 ケースやバンドはステンレスの約1/2の軽さで、肌に優しく、さびにくく、そしてキズに強いスーパーチタニウムを採用し、ガラスには高い透明度で視認性に優れたサファイアガラスを採用しています。 ビジネスウォッチとして定番のシンプルデザインを生かしながら、ミドルサイズウオッチへのニーズに対応できるようにサイズダウンすることで、より使い勝手の良いケース幅38mmサイズに仕上げています。 充実の機能性とデザイン性を兼ね備えたアテッサのエントリーモデルです。 パーペチュアルカレンダー  日中米欧電波受信 サファイアガラス（無反射コーティング） 耐ニッケル、耐磁１種 夜光（針＋インデックス） 10気圧防水 日本製 重量 \t82g  厚み \t9.3mm ケースサイズ 38.0mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_CB1120-50E.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "300",
    brand: "Citizen",
    sku: "AT8040-57E",
    product_eng: "Citizen ATESSA AT8040-57E",
    product_jpn: "Citizen シチズン ATESSA AT8040-57E",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥110,000",
    rrp_with_vat: "¥121,000",
    description_eng:
      "Multi-station reception type radio clock compatible with radio transmission stations in 4 areas around the world It's light and comfortable to wear. Resistant to scratches and beautiful forever. Super Titanium Sophisticated beauty + slim body. A slim design with a thickness of 9.7 mm with multifunction. Equipped with a chronograph function (stopwatch) that can measure up to 60 minutes in 1/20 second  Japan-China-US-Europe radio reception Water resistant to 10 bar Super titanium Sapphire glass (99% clarity coating) Nickel resistance, magnetic resistance 1 type Luminous (needle + index) Fit adjuster made in Japan Weight 90g Thickness 9.7 mm Case size 41.5mm",
    description_jpn:
      "りゅうずを一段引いて、秒針を外周の都市名に合わせるだけの簡単操作のエコ・ドライブワールドタイム電波時計。1/20秒クロノグラフを搭載しつつも、多針時計ならではのサイズ感を改善するためにケースの小型化を図り、現行の多針多局受信電波時計のなかでも随一のスリムボディを実現しています。 縦三つ目のインダイヤル配置、細身の夜光処理を施したインデックス、整理してレイアウトされた文字情報など、徹底して文字板の見やすさを追求。 サファイアガラスに99% クラリティ・コーティングを施すことによって、さらに高い視認性を確保。耐久性と防汚性も優れています。 また、シチズン独自のスーパーチタニウムを採用しているので、キズに強く、軽く、肌にやさしく、サビにくいモデルになっています。 日中米欧電波受信 クロノグラフ機能（1/20秒, 60分計） 10気圧防水 スーパーチタニウム サファイアガラス （99% クラリティ・コーティング） 耐ニッケルアレルギー、耐磁１種 夜光（針+インデックス） フィットアジャスター 日本製 重量 \t90g  厚み \t9.7mm  ケースサイズ41.5mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_AT8040-57E.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "301",
    brand: "Citizen",
    sku: "AT8040-57L",
    product_eng: "Citizen ATESSA AT8040-57L",
    product_jpn: "Citizen シチズン ATESSA AT8040-57L",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥110,000",
    rrp_with_vat: "¥121,000",
    description_eng:
      "Multi-station reception type radio clock compatible with radio transmission stations in 4 areas around the world It's light and comfortable to wear. Resistant to scratches and beautiful forever. Super Titanium Sophisticated beauty + slim body. A slim design with a thickness of 9.7 mm with multifunction. Equipped with a chronograph function (stopwatch) that can measure up to 60 minutes in 1/20 second  Japan-China-US-Europe radio reception Water resistant to 10 bar Super titanium Sapphire glass (99% clarity coating) Nickel resistance, magnetic resistance 1 type Luminous (needle + index) Fit adjuster made in Japan Weight 90g Thickness 9.7 mm Case size 41.5mm",
    description_jpn:
      "りゅうずを一段引いて、秒針を外周の都市名に合わせるだけの簡単操作のエコ・ドライブワールドタイム電波時計。1/20秒クロノグラフを搭載しつつも、多針時計ならではのサイズ感を改善するためにケースの小型化を図り、現行の多針多局受信電波時計のなかでも随一のスリムボディを実現しています。 縦三つ目のインダイヤル配置、細身の夜光処理を施したインデックス、整理してレイアウトされた文字情報など、徹底して文字板の見やすさを追求。 サファイアガラスに99% クラリティ・コーティングを施すことによって、さらに高い視認性を確保。耐久性と防汚性も優れています。 また、シチズン独自のスーパーチタニウムを採用しているので、キズに強く、軽く、肌にやさしく、サビにくいモデルになっています。 日中米欧電波受信 クロノグラフ機能（1/20秒, 60分計） 10気圧防水 スーパーチタニウム サファイアガラス （99% クラリティ・コーティング） 耐ニッケルアレルギー、耐磁１種 夜光（針+インデックス） フィットアジャスター 日本製 重量 \t90g  厚み \t9.7mm  ケースサイズ41.5mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_AT8040-57L.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "302",
    brand: "Citizen",
    sku: "BV1120-15L",
    product_eng: "Citizen Citizen Collection BV1120-15L",
    product_jpn: "Citizen シチズンコレクション BV1120-15L",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥33,000",
    rrp_with_vat: "¥36,300",
    description_eng:
      "Simple and classical eco-drive watch.The dial has a delicate argyle pattern. Movable for about 9 months when fully charged Water resistant to 10 bar Spherical sapphire glass Date function made in Japan Weight 62g Thickness 11.2 mm Stainless steel case size 38.5mm Made in Japan",
    description_jpn:
      "スモールセコンドが特徴のシンプルでクラシカルなエコ・ドライブ搭載モデル。 文字板はローマ数字に繊細なアーガイルの模様を施し、スモールセコンドのデザインと共にクラシカルな印象に仕上げました。エレガントでシンプルなカラーを揃えたストラップモデルです。10気圧防水、球面サファイアガラス、デイト機能を搭載。さらに信頼と安心の「Made in Japan」。 フル充電時約9ヶ月可動 10気圧防水 球面サファイアガラス デイト機能 日本製 重量 \t62g  厚み \t11.2mm  ステンレスケースサイズ \t 38.5mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_BV1120-15L.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "303",
    brand: "Citizen",
    sku: "BM6770-51G",
    product_eng: "Citizen Citizen Collection BM6770-51G",
    product_jpn: "Citizen シチズンコレクション BM6770-51G",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥24,000",
    rrp_with_vat: "¥26,400",
    description_eng:
      "A standard item with a simple and beautiful design. It also has a date and an eco-drive function that does not require battery replacement. It is used sapphire glass that is not easily scratched, has high transparency, and has excellent visibility. Waterproof for everyday life Sapphire glass made in Japan Weight 105g Thickness 7.8 mm Case size 37.0mm",
    description_jpn:
      "シンプルで美しいデザインが印象的なスタンダードな一品。 日付も付いていて、もちろん電池交換不要のエコ・ドライブ機能付き。 一本あると便利なアイテムです。 キズがつきにくく、高い透明度で視認性に優れたサファイアガラスを採用しています。 日常生活防水 サファイアガラス 日本製 重量 \t105g  厚み \t7.8mm  ケースサイズ \t 37.0mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_BM6770-51G.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "304",
    brand: "Citizen",
    sku: "ES9435-51A",
    product_eng: "Citizen xC ES9435-51A",
    product_jpn: "Citizen シチズン クロスシー ES9435-51A",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥57,000",
    rrp_with_vat: "¥62,700",
    description_eng:
      "Xc is a best selling model. Citizen's original surface hardening technology Duratect is applied. Weight 46g Thickness 7.2 mm Case size 25.0 mm Case stainless steel Surface treatment plating (Sakura color) Glass sapphire glass (non-reflective coating) Band:Three-fold push type Nakadome Made in Japan",
    description_jpn:
      "クロスシーのなかで愛され続けるロングセラーモデルのデザインはそのままに、りゅうずを一段引いて、秒針を外周の都市名に合わせるだけの簡単操作のエコ・ドライブワールドタイム電波機能を搭載し、進化してリニューアル。世界24都市の時刻がすぐわかります。 ケースやバンドの素材表面には、シチズン独自の表面硬化技術デュラテクトを施しているので、キズから時計本来の美しさを守り続けます。 文字板のデザインは、透き通る花びらの重なりをイメージ。草花のような伸びやかで柔らかい印象のインデックス、光の角度によって淡く繊細に浮き出る花びらが、上品で華やかな手元を演出します。 パーペチュアルカレンダー 日中米欧電波受信 10気圧防水 サファイアガラス（無反射コーティング） 耐磁１種 夜光（針） 日本製 重量 \t46g  厚み \t7.2mm  ケースサイズ \t 25.0mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_ES9435-51A.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "305",
    brand: "Citizen",
    sku: "ES9434-53W",
    product_eng: "Citizen xC ES9434-53W",
    product_jpn: "Citizen シチズン クロスシー ES9434-53W",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥57,000",
    rrp_with_vat: "¥62,700",
    description_eng:
      "Xc is a best selling model. Citizen's original surface hardening technology Duratect is applied. Weight 44g Thickness 7.2 mm Case size 25.0 mm Case stainless steel Surface treatment Duratect platinum (partially plated) (Light silver color, pink gold color) Glass sapphire glass (non-reflective coating)",
    description_jpn:
      "クロスシーのなかで愛され続けるロングセラーモデルのデザインはそのままに、りゅうずを一段引いて、秒針を外周の都市名に合わせるだけの簡単操作のエコ・ドライブワールドタイム電波機能を搭載し、進化してリニューアル。世界24都市の時刻がすぐわかります。 ケースやバンドの素材表面には、シチズン独自の表面硬化技術デュラテクトを施しているので、キズから時計本来の美しさを守り続けます。 文字板のデザインは、透き通る花びらの重なりをイメージ。草花のような伸びやかで柔らかい印象のインデックス、光の角度によって淡く繊細に浮き出る花びらが、上品で華やかな手元を演出します。 パーペチュアルカレンダー 日中米欧電波受信 10気圧防水 サファイアガラス（無反射コーティング） 耐磁１種 夜光（針） 日本製 重量 \t44g  厚み \t7.2mm  ケースサイズ \t 25.0mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_ES9434-53W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "306",
    brand: "Citizen",
    sku: "EW5544-51W",
    product_eng: "Citizen xC EW5544-51W",
    product_jpn: "Citizen シチズン クロスシー EW5544-51W",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      "Delicate and elegant long-angle case. The curved sapphire glass makes it easy to see the time from any angle, and the hour and minute hands are lit up  in darkness. Weight 46g Thickness 7.6 mm Case size 19.5 mm Case stainless steel Surface treatment Duratect Platinum (Light silver color) Glass curve sapphire glass",
    description_jpn:
      "華奢でエレガントな長角ケース。ケースサイドのフローラインがしなやかな女性らしさを表現しています。文字板のインデックスはやわらかいローマフォントを採用。甘すぎず、年齢問わずお使い頂けるデザインに仕上げています。手持ちのアクセサリーやご自身の肌色に合わせて選べる、4種類のバリエーションが魅力です。 どの角度からみても時刻が見やすカーブサファイヤガラスと、暗い場所でも時刻が読み取りやすいように時分針には夜光を施しました。シンプルアジャストバンド採用でお客様ご自身でも長さの調整をすることができます。5気圧の日常生活防水付きなので、洗顔や水仕事でも着用してご使用いただけます。 信頼と安心の「Made in Japan」。 5気圧防水 カーブサファイアガラス 夜光（針） シンプルアジャスト 日本製 重量 \t46g  厚み \t7.6mm  ケースサイズ \t 19.5mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_EW5544-51W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "307",
    brand: "Citizen",
    sku: "EW5543-54A",
    product_eng: "Citizen xC EW5543-54A",
    product_jpn: "Citizen シチズン クロスシー EW5543-54A",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      "Delicate and elegant long-angle case. The curved sapphire glass makes it easy to see the time from any angle, and the hour and minute hands are lit up  in darkness. Weight 46g Thickness 7.6 mm Case size 19.5 mm Case stainless steel Surface treatment plating (Pink gold color) Glass curve sapphire glass Made in Japan",
    description_jpn:
      "華奢でエレガントな長角ケース。ケースサイドのフローラインがしなやかな女性らしさを表現しています。文字板のインデックスはやわらかいローマフォントを採用。甘すぎず、年齢問わずお使い頂けるデザインに仕上げています。手持ちのアクセサリーやご自身の肌色に合わせて選べる、4種類のバリエーションが魅力です。 どの角度からみても時刻が見やすカーブサファイヤガラスと、暗い場所でも時刻が読み取りやすいように時分針には夜光を施しました。シンプルアジャストバンド採用でお客様ご自身でも長さの調整をすることができます。5気圧の日常生活防水付きなので、洗顔や水仕事でも着用してご使用いただけます。 信頼と安心の「Made in Japan」。 5気圧防水  カーブサファイアガラス  夜光（針）  シンプルアジャスト  日本製 重量 \t46g  厚み \t7.6mm  ケースサイズ \t 19.5mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_EW5543-54A.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "308",
    brand: "Citizen",
    sku: "BJ6480-51B",
    product_eng: "Citizen Collection AM-BJ6480-51B",
    product_jpn:
      "Citizen シチズンコレクション AM-BJ6480-51B ペアウォッチ男性用",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥28,000",
    rrp_with_vat: "¥30,800",
    description_eng:
      "A simple, clean and classical  Eco-Drive watch. The length of the band can be easily adjusted by yourself. Weight 88g Thickness 7.1 mm Case size 37.2 mm Case stainless steel surface treatment\t  Glass sapphire glass This watch can also be paired with EM0400-51B.",
    description_jpn:
      "シンプルなデザインと機能性が特徴の、シチズンコレクションの薄型ペアモデル。オンでもオフでも気軽に使える、バーインデックスやローマ数字のインデックスを採用し、くせのないシンプルですっきりとしたクラシカルなイメージのデザインが特徴です。ケースの厚みを7.2mm（設計値）にまで抑えた薄型設計。風防には傷のつきにくいサファイアガラスを採用しています。シンプルアジャスト方式仕様のバンドは、ご自身で簡単に長さ調節ができ、プレゼントにもオススメです。信頼と安心のMade in Japan。 こちらの時計は品番：EM0400-51Bとペアウォッチとしてお使いいただけます。こちらは男性用時計になります。 5気圧防水 サファイアガラス フル充電時約6ヶ月可動 日本製  重量 \t88g  厚み \t7.1mm  ケースサイズ \t 37.2mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_BJ6480-51B.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "309",
    brand: "Citizen",
    sku: "EM0400-51B",
    product_eng: "Citizen Collection AL-EM0400-51B",
    product_jpn:
      "Citizen シチズンコレクション AL-EM0400-51B ペアウォッチ女性用",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥28,000",
    rrp_with_vat: "¥30,800",
    description_eng:
      "A simple, clean and classical  Eco-Drive watch. The length of the band can be easily adjusted by yourself. Weight 58g Thickness 7.1 mm Case size 27.7 mm Case stainless steel surface treatment\t  Glass sapphire glass This watch can also be paired with BJ6480-51BA.",
    description_jpn:
      "シンプルなデザインと機能性が特徴の、シチズンコレクションの薄型ペアモデル。オンでもオフでも気軽に使える、バーインデックスやローマ数字のインデックスを採用し、くせのないシンプルですっきりとしたクラシカルなイメージのデザインが特徴です。ケースの厚みを7.2mm（設計値）にまで抑えた薄型設計。風防には傷のつきにくいサファイアガラスを採用しています。シンプルアジャスト方式仕様のバンドは、ご自身で簡単に長さ調節ができ、プレゼントにもオススメです。信頼と安心のMade in Japan。 こちらの時計は品番：BJ6480-51Bとペアウォッチとしてお使い頂けます。こちらは女性用時計になります。 5気圧防水 サファイアガラス フル充電時約6ヶ月可動 日本製  重量 \t58g  厚み \t7.1mm  ケースサイズ \t 27.7mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_EM0400-51B.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "310",
    brand: "Citizen",
    sku: "BJ6482-04A",
    product_eng: "Citizen Collection BJ6482-04A",
    product_jpn:
      "Citizen シチズンコレクション BM-BJ6482-04A ペアウォッチ男性用",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥26,000",
    rrp_with_vat: "¥28,600",
    description_eng:
      "Citizen Collectin Eco-Drive Chronograph Weight 38g Thickness 7.1 mm Case size:37.2 mm Case stainless steel Surface treatment plating (Pink gold color) Glass sapphire glass Band:Calf leather This watch can also be paired with EM0402-05A.",
    description_jpn:
      "シンプルなデザインと機能性が特徴の、シチズンコレクションの薄型ペアモデル。オンでもオフでも気軽に使える、バーインデックスやローマ数字のインデックスを採用し、くせのないシンプルですっきりとしたクラシカルなイメージのデザインが特徴です。ケースの厚みを7.2mm（設計値）にまで抑えた薄型設計。風防には傷のつきにくいサファイアガラスを採用しています。シンプルアジャスト方式仕様のバンドは、ご自身で簡単に長さ調節ができ、プレゼントにもオススメです。信頼と安心のMade in Japan。 こちらの時計は品番：EM0402-05Aとペアウォッチとしてお使い頂けます。こちらは男性用時計になります。 5気圧防水 サファイアガラス フル充電時約6ヶ月可動 日本製  重量 \t38g  厚み \t7.1mm  ケースサイズ \t 37.2mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_BJ6482-04A.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "311",
    brand: "Citizen",
    sku: "EM0402-05A",
    product_eng: "Citizen Collection BL-EM0402-05A",
    product_jpn:
      "Citizen シチズンコレクション BL-EM0402-05A ペアウォッチ女性用",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥26,000",
    rrp_with_vat: "¥28,600",
    description_eng:
      "Citizen Collectin Eco-Drive Chronograph Weight 24g Thickness 7.1 mm Case size:27.7 mm Case stainless steel Surface treatment plating (Pink gold color) Glass sapphire glass Band:Calf leather This watch can also be paired with BJ6482-04A.",
    description_jpn:
      "シンプルなデザインと機能性が特徴の、シチズンコレクションの薄型ペアモデル。オンでもオフでも気軽に使える、バーインデックスやローマ数字のインデックスを採用し、くせのないシンプルですっきりとしたクラシカルなイメージのデザインが特徴です。ケースの厚みを7.2mm（設計値）にまで抑えた薄型設計。風防には傷のつきにくいサファイアガラスを採用しています。シンプルアジャスト方式仕様のバンドは、ご自身で簡単に長さ調節ができ、プレゼントにもオススメです。信頼と安心のMade in Japan。 こちらの時計は品番：BJ6482-04Aとペアウォッチとしてお使いいただけます。 5気圧防水 サファイアガラス フル充電時約6ヶ月可動 日本製 重量 \t24g  厚み \t7.1mm  ケースサイズ \t 27.7mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_EM0402-05A.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "312",
    brand: "Citizen",
    sku: "BM6774-51C",
    product_eng: "Citizen Collection CM-BM6774-51C",
    product_jpn:
      "Citizen シチズンコレクション CM-BM6774-51C ペアウォッチ男性用",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥24,000",
    rrp_with_vat: "¥26,400",
    description_eng:
      "Citizen Collectin Eco-Drive Chronograph Weight 104g Thickness 7.8 mm Case size 37.0 mm Case stainless steel surface treatment Glass sapphire glass This watch can also be paired with EW1584-59C.",
    description_jpn:
      "定期的な電池交換がいらないエコ・ドライブを搭載。無駄を省いたシンプルなデザインが魅力のモデルです。白文字板にローマ数字と棒字を組み合わせた見やすいインデックス、ゴールドが華やかな印象を与えるモデルです。 視認性のよいサファイヤガラスと便利な日付表示を採用しています。 中留もワンタッチで着け外しが簡単にできる三折れプッシュタイプになっています。 信頼と安心の「Made in Japan」 こちらの時計は品番：EW1584-59Cとペアウォッチとしてお使いいただけます。 日常生活防水 フル充電時約6ヶ月可動 サファイアガラス 日本製 重量 \t104g  厚み \t7.8mm  ケースサイズ \t 37.0mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_BM6774-51C.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "313",
    brand: "Citizen",
    sku: "EW1584-59C",
    product_eng: "Citizen Collection CL-EW1584-59C",
    product_jpn:
      "Citizen シチズンコレクション CL-EW1584-59C ペアウォッチ女性用",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥24,000",
    rrp_with_vat: "¥26,400",
    description_eng:
      "Citizen Collectin Eco-Drive Chronograph Weight 61g Thickness 7.3 mm Case size :27.0 mm Case: stainless steel This watch can also be paired with BM6774-51C.",
    description_jpn:
      "定期的な電池交換がいらないエコ・ドライブを搭載。無駄を省いたシンプルなデザインが魅力のモデルです。白文字板にローマ数字と棒字を組み合わせた見やすいインデックス、ゴールドが華やかな印象を与えるモデルです。 視認性のよいサファイヤガラスと便利な日付表示を採用しています。 中留もワンタッチで着け外しが簡単にできる三折れプッシュタイプになっています。 信頼と安心の「Made in Japan」 こちらの時計は品番：BM6774-51Cとペアウォッチとしてお使いいただけます。 日常生活防水 フル充電時約6ヶ月可動 サファイアガラス 日本製 重量 \t61g  厚み \t7.3mm  ケースサイズ \t 27.0mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_EW1584-59C.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "314",
    brand: "Citizen",
    sku: "BM6770-51B",
    product_eng: "Citizen Collection DM-BM6770-51B",
    product_jpn:
      "Citizen シチズンコレクション DM-BM6770-51B ペアウォッチ男性用",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥24,000",
    rrp_with_vat: "¥26,400",
    description_eng:
      "Citizen Collectin Eco-Drive Chronograph Weight 105g Thickness 7.8 mm Case size 37.0 mm Case stainless steel This watch can also be paired with EW1580-50B.",
    description_jpn:
      "定期的な電池交換がいらないエコ・ドライブを搭載。無駄を省いたシンプルなデザインが魅力のモデルです。白文字板にアラビア数字は様々なシーンとマッチします。視認性のよいサファイヤガラスと便利な日付表示を採用しています。 中留もワンタッチで着け外しが簡単にできる三折れプッシュタイプになっています。 信頼と安心の「Made in Japan」 こちらの時計は品番：EW1580-50Bとペアウォッチとしてお使いいただけます。 日常生活防水 フル充電時約6ヶ月可動 サファイアガラス 日本製 重量 \t105g  厚み \t7.8mm  ケースサイズ \t 37.0mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_BM6770-51B.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "315",
    brand: "Citizen",
    sku: "EW1580-50B",
    product_eng: "Citizen Collection DL-EW1580-50B",
    product_jpn:
      "Citizen シチズンコレクション DL-EW1580-50B ペアウォッチ女性用",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥24,000",
    rrp_with_vat: "¥26,400",
    description_eng:
      "Citizen Collectin Eco-Drive Chronograph Weight 62g Thickness 7.3 mm Case size 27.0 mm Case stainless steel surface treatment\t  Glass sapphire glass This watch can also be paired with BM6770-51B.",
    description_jpn:
      "定期的な電池交換がいらないエコ・ドライブを搭載。無駄を省いたシンプルなデザインが魅力のモデルです。白文字板にアラビア数字は様々なシーンとマッチします。視認性のよいサファイヤガラスと便利な日付表示を採用しています。 中留もワンタッチで着け外しが簡単にできる三折れプッシュタイプになっています。 信頼と安心の「Made in Japan」 こちらの時計は品番：BM6770-51Bとペアウォッチとしてお使いいただけます。 日常生活防水 フル充電時約6ヶ月可動 サファイアガラス 日本製 重量 \t62g  厚み \t7.3mm  ケースサイズ \t 27.0mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_EW1580-50B.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "316",
    brand: "Citizen",
    sku: "EC1165-51W",
    product_eng: "Citizen xC Basic collection 2tone model EC1165-51W",
    product_jpn: "Citizenシチズン クロスシー ツートーンモデル EC1165-51W",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥85,000",
    rrp_with_vat: "¥93,500",
    description_eng:
      "Elegant and sophisticated basic design that is easy to match with any style The slim, delicate case line and clean, elegant dial. The original font used for the indexes gives a gentle impression, and together with the sharp-looking cut parts, expresses the supple strength that women possess. This two-tone model is minimalist and elegant.  The combination of cherry pink and eternal platinum is easy to match with any occasion, style, and accessories.  -No need for periodic battery replacement Photo-power generation Eco-Drive is Citizen's unique technology that converts sunlight or a small amount of indoor light into electricity to keep the watch running. - Scratch-resistant, lightweight, and rust-resistant Super Titanium is a material made with our original titanium processing technology and surface hardening technology (Duratect). Super Titanium is 40% lighter than stainless steel and has a surface hardness more than five times greater. -Accurate timekeeping at all times The watch receives standard radio waves transmitted based on atomic clocks, which are said to have an error of 1 second in 100,000 years, and automatically corrects the time and calendar in four areas around the world: Japan, China, the United States, and Europe. -Shock- and magnetism-resistant watch that never deviates from its original position The unique Perfex technology, which combines JIS Class 1 magnetism resistance, a shock detection function, and an automatic hand correction function, prevents watch hands from shifting due to magnetism or shocks.  Case Shape/Circular Wind shield material/Sapphire crystal Display type/Analog Clasp /Three-fold push type Case Material/Titanium Case diameter and width/28 millimeters Case thickness/8.5 millimeters Band material / type Bracelet type Band color/Combi Dial color/Pink Calendar function Perpetual Other Functions Solar radio-controlled watch Movement Japanese quartz",
    description_jpn:
      "どんなスタイルにも合わせやすい、上品で洗練されたベーシックなデザイン 華奢で繊細なケースラインにすっきりエレガントな文字板。 インデックスにはやさしい印象のオリジナルフォントを採用、きりっとした表情のカットパーツと合わせて、女性が持つしなやかな強さを表現しました。 ミニマルでエレガントなツートーンモデル。サクラピンクとエターナルプラチナの組み合わせは、どんなシーンやスタイル、アクセサリーにも合わせやすいデザインです。  -定期的な電池交換は不要 光発電『エコ・ドライブ』は、太陽光や室内のわずかな光を電気に換え、時計を動かしつづけるシチズン独自の技術です。 - キズに強く、軽く、サビにくい 独自のチタニウム加工技術と表面硬化技術（デュラテクト）を施した素材『スーパーチタニウム』。ステンレスに比べて40%軽く、5倍以上の表面硬度を実現しています。 -いつでも正確な時刻を刻み続ける 10万年に1秒の誤差と言われる原子時計をもとに送信される標準電波を受信し、日本、中国、アメリカ、ヨーロッパの世界4エリアで自動的に時刻やカレンダーを修正します。 -衝撃にも磁気にも強い、ズレない時計 「JIS1種耐磁」「衝撃検知機能」「針自動補正機能」、3つの機能を一体化させた独自技術『パーフェックス』が、磁気や衝撃によって腕時計の針がズレるのを防ぎます。  ケースの形状 \t円形 風防素材 \tサファイアクリスタル 表示タイプ \tアナログ 留め金 \t三つ折れプッシュタイプ ケース素材 \tチタン ケース直径・幅 \t28 millimeters ケース厚 \t8.5 millimeters バンド素材･タイプ \tブレスレットタイプ バンドカラー \tコンビ 文字盤カラー \tピンク カレンダー機能 \tパーペチュアル その他 機能 \tソーラー電波時計 ムーブメント \t日本製クォーツ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_EC1165-51W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "317",
    brand: "Citizen",
    sku: "EC1164-53W",
    product_eng: "Citizen xC Basic collection Sakura model EC1164-53W",
    product_jpn: "Citizenシチズン クロスシー サクラモデル EC1164-53W",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥85,000",
    rrp_with_vat: "¥93,500",
    description_eng:
      "Elegant and sophisticated basic design that is easy to match with any style The slim, delicate case line and clean, elegant dial. The original font used for the indexes gives a gentle impression, and together with the sharp-looking cut parts, expresses the supple strength that women possess. The cherry pink model also has a slightly pink dial. The cherry pink color blends well with the skin and makes the skin color beautiful and attractive.   -No need for periodic battery replacement Photo-power generation Eco-Drive is Citizen's unique technology that converts sunlight or a small amount of indoor light into electricity to keep the watch running. - Scratch-resistant, lightweight, and rust-resistant Super Titanium is a material made with our original titanium processing technology and surface hardening technology (Duratect). Super Titanium is 40% lighter than stainless steel and has a surface hardness more than five times greater. -Accurate timekeeping at all times The watch receives standard radio waves transmitted based on atomic clocks, which are said to have an error of 1 second in 100,000 years, and automatically corrects the time and calendar in four areas around the world: Japan, China, the United States, and Europe. -Shock- and magnetism-resistant watch that never deviates from its original position The unique Perfex technology, which combines JIS Class 1 magnetism resistance, a shock detection function, and an automatic hand correction function, prevents watch hands from shifting due to magnetism or shocks.  Case Shape/Circular Wind shield material/Sapphire crystal Display type/Analog Clasp /Three-fold push type Case Material/Titanium Case diameter and width/28 millimeters Case thickness/8.5 millimeters Band material / type Bracelet type Band color/Combi Dial color/Pink Calendar function Perpetual Other Functions Solar radio-controlled watch Movement Japanese quartz",
    description_jpn:
      "どんなスタイルにも合わせやすい、上品で洗練されたベーシックなデザイン 華奢で繊細なケースラインにすっきりエレガントな文字板。 インデックスにはやさしい印象のオリジナルフォントを採用、きりっとした表情のカットパーツと合わせて、女性が持つしなやかな強さを表現しました。 サクラピンクのモデルは、文字板もほんのりピンク色に。肌なじみの良いサクラピンクが肌の色を綺麗に魅せてくれます。   -定期的な電池交換は不要 光発電『エコ・ドライブ』は、太陽光や室内のわずかな光を電気に換え、時計を動かしつづけるシチズン独自の技術です。 - キズに強く、軽く、サビにくい 独自のチタニウム加工技術と表面硬化技術（デュラテクト）を施した素材『スーパーチタニウム』。ステンレスに比べて40%軽く、5倍以上の表面硬度を実現しています。 -いつでも正確な時刻を刻み続ける 10万年に1秒の誤差と言われる原子時計をもとに送信される標準電波を受信し、日本、中国、アメリカ、ヨーロッパの世界4エリアで自動的に時刻やカレンダーを修正します。 -衝撃にも磁気にも強い、ズレない時計 「JIS1種耐磁」「衝撃検知機能」「針自動補正機能」、3つの機能を一体化させた独自技術『パーフェックス』が、磁気や衝撃によって腕時計の針がズレるのを防ぎます。  ケースの形状 \t円形 風防素材 \tサファイアクリスタル 表示タイプ \tアナログ 留め金 \t三つ折れプッシュタイプ ケース素材 \tチタン ケース直径・幅 \t28 millimeters ケース厚 \t8.5 millimeters バンド素材･タイプ \tブレスレットタイプ バンドカラー \tコンビ 文字盤カラー \tピンク カレンダー機能 \tパーペチュアル その他 機能 \tソーラー電波時計 ムーブメント \t日本製クォーツ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_EC1164-53W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "319",
    brand: "BULOVA",
    sku: "98A225",
    product_eng: "BULOVA Marine Star 98A225",
    product_jpn: "BULOVA マリンスター 98A225",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥61,000",
    rrp_with_vat: "¥67,100",
    description_eng:
      "The Marine Star is BULOVA's flagship collection created in the 1970s. While being a practical watch with excellent functions and water resistance to high pressure, it is characterized by its graceful, sporty look and luxurious design. The collection is available in a wide range of colors and can be worn both on and off the wrist. As a jeweler by trade, BULOVA offers a higher grade of beauty in its marine watches as well.  Movement: Automatic / 42 hours power reserve Case material: Stainless steel Strap material: calf leather + silicon rubber Case diameter: 45 mm Case thickness: 15 mm Glass material: Mineral glass Water resistance: 20 atmospheres Weight: Approx. 120g",
    description_jpn:
      "1970年代に誕生したブローバの代表コレクション、マリンスター。 高気圧防水で優れた機能を備える実用時計でありながら、気品にあふれたスポーティーな表情とラグジュアリーなデザインが特徴です。 豊富なカラーバリエーションが揃い、オン・オフを問わずたのしめるコレクション。 創業当時、宝飾店を生業としたブローバは、マリンウォッチにおいても、ワンランク上の美しさを提案します。  ムーブメント:自動巻き/42時間パワーリザーブ ケース素材:ステンレススチール ストラップ素材:カーフレザー＋シリコンラバー ケース径:45㎜ ケース厚:15㎜ ガラス素材:ミネラルガラス 防水性:20気圧防水 重量:約120g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bulova/BULOVA_98A225.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bulova2.png",
  },
  {
    id: "320",
    brand: "BULOVA",
    sku: "96A266",
    product_eng: "BULOVA Classic 96A266",
    product_jpn: "BULOVA クラシック 96A266",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥51,000",
    rrp_with_vat: "¥56,100",
    description_eng:
      "The BULOVA Classic Collection is a beautiful collection of simple and sophisticated designs from the 1960s.  Movement: Automatic / 42-hour power reserve Case material: Stainless steel Strap material: calf leather Case diameter: 43 mm Case thickness: 12.1 mm Glass material: Mineral glass Water resistance: 3 atmospheres Weight: approx. 87g",
    description_jpn:
      "1960 年代の意匠を現代に受け継ぎシンプルで洗練された美しいコレクション「ブローバ クラシック コレクション」  ムーブメント:自動巻き／42時間パワーリザーブ ケース素材:ステンレススチール ストラップ素材:カーフレザー ケース径:43㎜ ケース厚:12.1㎜ ガラス素材:ミネラルガラス 防水性:3気圧防水 重量:約87g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bulova/BULOVA_96A266.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bulova2.png",
  },
  {
    id: "920",
    brand: "BULOVA",
    sku: "98A227",
    product_eng: "BULOVA Marine Star 98A227",
    product_jpn: "BULOVA マリンスター 98A227",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥66,000",
    rrp_with_vat: "¥72,600",
    description_eng:
      "The Marine Star, Bulova's flagship collection, was created in the 1970s. While being a practical watch with high pressure water resistance, it is characterized by its graceful, sporty look and luxurious design. An open heart at the 7 o'clock position on the dial allows the wearer to enjoy watching the movement of a mechanical watch. The rubber strap has a different color scheme on the front and back, stimulating the playful spirit of adults.  Movement: Automatic winding / 42-hour power reserve Case material: Stainless steel (rose gold PVD + blue PVD) Strap material: silicon rubber Case diameter: 45 mm Case thickness: 13.45 mm Glass material: Mineral glass Water resistance: 20 atmospheres Weight: approx. 120g",
    description_jpn:
      "1970年代に誕生したブローバの代表コレクション、マリンスター。 高気圧防水を備える実用時計でありながら、気品にあふれたスポーティーな表情とラグジュアリーなデザインが特徴です。文字盤の7 時位置にはオープンハートを配し、機械式ならではのてんぷの動きを見て楽しむことができます。またラバーストラップは表面と裏面で異なる配色にするなど、大人の遊び心を刺激します。  ムーブメント:自動巻き／42時間パワーリザーブ ケース素材:ステンレススチール（ローズゴールドPVD＋ブルーPVD） ストラップ素材:シリコンラバー ケース径:45㎜ ケース厚:13.45㎜ ガラス素材:ミネラルガラス 防水性:20気圧防水 重量:約120g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bulova/BULOVA_98A227.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bulova/BULOVA_98A227_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bulova2.png",
    "": "https://s3.amazonaws.com/products.naganorewards.com/logos/bulova2.png",
  },
  {
    id: "921",
    brand: "BULOVA",
    sku: "98A303",
    product_eng: "BULOVA Marine Star 98A303",
    product_jpn: "BULOVA マリンスター 98A303",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥61,000",
    rrp_with_vat: "¥67,100",
    description_eng:
      "The Marine Star, Bulova's flagship collection, was created in the 1970s.  While being a practical watch with high pressure water resistance, it is characterized by its graceful, sporty look and luxurious design. An open heart at the 7 o'clock position on the dial allows the wearer to enjoy watching the movement of a mechanical watch. The rubber strap has a different color scheme on the front and back sides, stimulating the sense of fun and beauty in adults.   Movement: Automatic winding / 42-hour power reserve Case material: Stainless steel (stainless steel + blue PVD) Strap material: silicon rubber Case diameter: 45 mm Case Thickness: 13.45mm Glass material: Mineral glass Water resistance: 20 atmospheres Weight:Approx. 120g",
    description_jpn:
      "1970年代に誕生したブローバの代表コレクション、マリンスター。  高気圧防水を備える実用時計でありながら、気品にあふれたスポーティーな表情とラグジュアリーなデザインが特徴です。文字盤の7 時位置にはオープンハートを配し、機械式ならではのてんぷの動きを見て楽しむことができます。またラバーストラップは表面と裏面で異なる配色にするなど、大人の遊美心を刺激します。   ムーブメント:自動巻き/42時間パワーリザーブ ケース素材:ステンレススチール(ステンレス＋ブルーPVD） ストラップ素材:シリコンラバー ケース径:45㎜ ケース厚:13.45㎜ ガラス素材:ミネラルガラス 防水性:20気圧防水 重量:約120g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bulova/BULOVA_98A303.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bulova/BULOVA_98A303_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bulova2.png",
    "": "https://s3.amazonaws.com/products.naganorewards.com/logos/bulova2.png",
  },
  {
    id: "922",
    brand: "BULOVA",
    sku: "96A208",
    product_eng: "BULOVA Classic 96A208",
    product_jpn: "BULOVA クラシック 96A208",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥56,000",
    rrp_with_vat: "¥61,600",
    description_eng:
      "This skeleton model from the Classic Collection stands out for its distinctive and mature look. The beautiful perlage finish around the outer edge of the dial adds a classical and luxurious touch to the strong design, while the mirrored Bulova tuning fork mark at 12 o'clock and highly legible bar indexes set in the indexes add to the attention to detail of this watch.   Movement: Automatic winding / 42-hour power reserve Case material: Stainless steel Strap material: Stainless steel Case diameter: 43 mm Case thickness: 12.1 mm Glass material: Mineral glass Water resistance: 3 atmospheres Weight:Approx. 155g",
    description_jpn:
      "個性ある大人な雰囲気が際立つクラシックコレクションのスケルトンモデル。文字盤外周部には、美しいペルラージュ仕上げを施すことで、力強いデザインにクラシカルで高級な雰囲気を添えています。12時位置にはミラー仕上げのブローバの音叉マークを、インデックスは視認性の高いバーインデックスをセッティングし、ディテールにこだわった時計です。   ムーブメント:自動巻き／42時間パワーリザーブ ケース素材:ステンレススチール ストラップ素材:ステンレススチール ケース径:43㎜ ケース厚:12.1㎜ ガラス素材:ミネラルガラス 防水性:3気圧防水 重量:約155g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bulova/BULOVA_96A208.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bulova2.png",
    "": "https://s3.amazonaws.com/products.naganorewards.com/logos/bulova2.png",
  },
  {
    id: "323",
    brand: "Fossil",
    sku: "FS5512",
    product_eng: "Fossil NEUTRA  Chronograph Umber Leather Watch",
    product_jpn: "Fossil フォッシル NEUTRA クロノグラフ アンバー レザー腕時計",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥23,500",
    rrp_with_vat: "¥25,850",
    description_eng:
      "Case size: 44MM Movement: Quartz chronograph Platform: NEUTRA CHRONO Strap material: leather Water resistance: 5 bar Case color: smoke Dial color: gray Fashion color of the strap: Amber Flexible replacement: 22MM Strap width: 22MM Closure: Single prong strap buckle Inner diameter of strap: 200 +/- 5MM Battery type: SR621SW ＊This product will take 3 weeks to ship",
    description_jpn:
      "ケースのサイズ: 44MM  ムーブメント: クォーツクロノグラフ プラットフォーム: NEUTRA CHRONO ストラップの素材: レザー 耐水性: 5気圧 ケースの色: スモーク ダイヤルの色: グレー ストラップのファッションカラー: アンバー 柔軟に交換可能: 22MM ストラップの幅: 22MM クロージャ: シングルプロングストラップバックル ストラップの内径: 200+/- 5MM 電池の種類: SR621SW  ※こちらの商品は発送まで３週間程いただきます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/fossil/Fossil_FS5512.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fossil.png",
  },
  {
    id: "324",
    brand: "Fossil",
    sku: "FS5151",
    product_eng: "Fossil Grant Chronograph Light Brown Leather Watch",
    product_jpn:
      "Fossil フォッシル グラント クロノグラフ ライトブラウンレザー腕時計",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥23,500",
    rrp_with_vat: "¥25,850",
    description_eng:
      "Case size: 44MM Movement: Quartz chronograph Platform: Grant Strap material: leather Water resistance: 5 bar Case color: Two-tone Dial color: blue Fashion color of the strap: brown Flexible replacement: 22MM Strap width: 22MM Closure: Strap buckle Inner diameter of strap: 200 +/- 5MM Battery type: SR621SW ＊This product will take 3 weeks to ship",
    description_jpn:
      "ケースのサイズ: 44MM ムーブメント: クォーツクロノグラフ プラットフォーム: Grant ストラップの素材: レザー 耐水性: 5気圧 ケースの色: ツートーン ダイヤルの色: ブルー ストラップのファッションカラー: ブラウン 柔軟に交換可能: 22MM ストラップの幅: 22MM クロージャ: ストラップバックル ストラップの内径: 200+/- 5MM 電池の種類: SR621SW  ※こちらの商品は発送まで３週間程いただきます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/fossil/Fossil_FS5151.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fossil.png",
  },
  {
    id: "325",
    brand: "Fossil",
    sku: "ES4502",
    product_eng: "Fossil CARLIE MINI Navy Leather Watch",
    product_jpn: "Fossil フォッシル CARLIE MINI ネイビーレザー腕時計",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥14,000",
    rrp_with_vat: "¥15,400",
    description_eng:
      "Case size: 28MM Movement: Quartz Platform: CARLIE Strap material: leather Water resistance: 5 bar Case color: Rose gold Dial color: Multi Fashion color of the strap: navy Flexible replacement: 12MM Strap width: 12MM Closure: Single prong strap buckle Inner diameter of strap: 175 +/- 5MM Battery type: SR621SW ＊This product will take 3 weeks to ship",
    description_jpn:
      "ケースのサイズ: 28MM ムーブメント: クォーツ プラットフォーム: CARLIE ストラップの素材: レザー 耐水性: 5気圧 ケースの色: ローズゴールド ダイヤルの色: マルチ ストラップのファッションカラー: ネイビー 柔軟に交換可能: 12MM ストラップの幅: 12MM クロージャ: シングルプロングストラップバックル ストラップの内径: 175+/- 5MM 電池の種類: SR621SW  ※こちらの商品は発送まで３週間程いただきます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/fossil/Fossil_ES4502.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fossil.png",
  },
  {
    id: "326",
    brand: "Fossil",
    sku: "ES4433",
    product_eng: "Fossil CARLIE MINI Stainless Steel Mesh Watch",
    product_jpn: "Fossil フォッシル CARLIE MINI ステンレススチール腕時計",
    category_1: "Jewelry & Watches",
    category_2: "Smartphone",
    rrp_ex_vat: "¥17,500",
    rrp_with_vat: "¥19,250",
    description_eng:
      "Case size: 29MM Movement: Quartz Platform: Carlie Strap material: Stainless steel Water resistance: 5 bar Case color: Rose gold Dial color: Mother of pearl Fashion color of the strap: rose gold Strap width: 12MM Closure: Safety mesh buckle Inner diameter of strap: 175 +/- 5MM Battery type: SR621SW ＊This product will take 3 weeks to ship",
    description_jpn:
      "ケースのサイズ: 29MM ムーブメント: クォーツ プラットフォーム: Carlie ストラップの素材: ステンレススチール 耐水性: 5気圧 ケースの色: ローズゴールド ダイヤルの色: マザーオブパール ストラップのファッションカラー: ローズゴールド ストラップの幅: 12MM クロージャ: セーフティメッシュバックル ストラップの内径: 175+/- 5MM 電池の種類: SR621SW ※こちらの商品は発送まで３週間程いただきます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/fossil/Fossil_ES4433.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fossil.png",
  },
  {
    id: "327",
    brand: "Le Creuset",
    sku: "21001144202464",
    product_eng: "Le Creuset Cocotte ronde 14cm Bear Coastal Blue",
    product_jpn:
      "Le Creuset ル・クルーゼ ココット・ロンド 14cm ベアーツマミ（コースタルブルー）",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng:
      "This is an ideal size for preparing baby food, and comes in colours that are perfect for baby gifts. This small cast iron round french oven has excellent heat distribution, so you can prepare baby food in a short amount of time. It also which makes everyday cooking and cleaning stress-free. - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colours can be used as tableware as well. - Good Heat Retention - Energy Saving - Acid-resistant and does not pick up odours even after a long time. - Perfect on most of the heat sources e.g. gas, induction or oven(except Microwave)  - Diameter: 14 cm - Capacity: 0.9L - Weight: 1.67Kg",
    description_jpn:
      "離乳食作りに役立ち、お子様が成長されてからも永く活躍する小さめのお鍋にふんわりとやわらかい色合いのカラーがそろいました。 淡い色合いはお子様の食事作りにぴったり。 毎日の食事だけでなく特別な日の本格レシピもこなします。 ＊ツマミはステンレスです。 ＊オリジナルギフトボックス入り。 ＊底径が11cmと小さいため、IHクッキングヒーターの規格によっては使用できない場合があります。 直径(取込) 14(20.5)cm 高さ(フタ込) 7.3(11)cm 容量 \t0.9L 重量 \t1.9kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_21001144202464.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "328",
    brand: "Le Creuset",
    sku: "21001147774464",
    product_eng: "Le Creuset Cocotte ronde 14cm Bear Siffon Pink",
    product_jpn:
      "Le Creuset ル・クルーゼ ココット・ロンド 14cm ベアーツマミ（コースタルシェルピンク）",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng:
      "This is an ideal size for preparing baby food, and comes in colours that are perfect for baby gifts. This small cast iron round french oven has excellent heat distribution, so you can prepare baby food in a short amount of time. It also which makes everyday cooking and cleaning stress-free.  - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colours can be used as tableware as well. - Good Heat Retention - Energy Saving - Acid-resistant and does not pick up odours even after a long time. - Perfect on most of the heat sources e.g. gas, induction or oven(except Microwave)  - Diameter: 14 cm - Capacity: 0.9L - Weight: 1.67Kg",
    description_jpn:
      "離乳食作りに役立ち、お子様が成長されてからも永く活躍する小さめのお鍋にふんわりとやわらかい色合いのカラーがそろいました。 淡い色合いはお子様の食事作りにぴったり。 毎日の食事だけでなく特別な日の本格レシピもこなします。 ＊ツマミはステンレスです。 ＊オリジナルギフトボックス入り。 ＊底径が11cmと小さいため、IHクッキングヒーターの規格によっては使用できない場合があります。 直径(取込) 14(20.5)cm 高さ(フタ込) 7.3(11)cm 容量 \t0.9L 重量 \t1.9kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_21001147774464.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "329",
    brand: "Le Creuset",
    sku: "21177200902430",
    product_eng: "Le Creuset Cocotte Ronde 20cm Orange SS",
    product_jpn: "Le Creuset ル・クルーゼ  ココット・ロンド 20cm オレンジ SS",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥32,000",
    rrp_with_vat: "¥35,200",
    description_eng:
      "This piece is certainly great for stewing but is also good for rice cooking. Gentle heat brings the flavours out from the ingredients thoroughly. - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colours can be used as tableware as well. - Good heat Retention - Energy Saving - Acid-resistant and does not pick up odours Even after a long time. - Perfect on most of The heat sources e.g. gas, induction or oven (except Microwave) - Diameter: 18 cm - Capacity: 1.8L - Weight: 2.55kg",
    description_jpn:
      "ル・クルーゼの定番ココット・ロンドのモデル。 ムラのない熱まわりで、煮込み料理はもちろん炊飯にもおすすめです。 従来のココット・ロンドに比べ、ハンドルが握りやすく、ツマミも持ちやすいデザインになっています。 ----サイズ20CM----- 直径(取手込) 20(28.5)cm 高さ(フタ込) 9.5(14)cm 容量 \t2.4L 重量 \t3.1kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_21177200902430.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "330",
    brand: "Le Creuset",
    sku: "21177200602430",
    product_eng: "Le Creuset Cocotte Ronde 20cm Cherry Red SS",
    product_jpn:
      "Le Creuset ル・クルーゼ  ココット・ロンド 20cm チェリーレッド SS",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥32,000",
    rrp_with_vat: "¥35,200",
    description_eng:
      "This piece is certainly great for stewing but is also good for rice cooking. Gentle heat brings the flavours out from the ingredients thoroughly. - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colours can be used as tableware as well. - Good heat Retention - Energy Saving - Acid-resistant and does not pick up odours Even after a long time. - Perfect on most of The heat sources e.g. gas, induction or oven (except Microwave) - Diameter: 18 cm - Capacity: 1.8L - Weight: 2.55kg",
    description_jpn:
      "ル・クルーゼの定番ココット・ロンドのモデル。 ムラのない熱まわりで、煮込み料理はもちろん炊飯にもおすすめです。 従来のココット・ロンドに比べ、ハンドルが握りやすく、ツマミも持ちやすいデザインになっています。 ----サイズ20CM----- 直径(取手込) 20(28.5)cm 高さ(フタ込) 9.5(14)cm 容量 \t2.4L 重量 \t3.1kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_21177200602430.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "331",
    brand: "Le Creuset",
    sku: "21177204962430",
    product_eng: "Le Creuset Cocotte Ronde 20cm Cool Mint",
    product_jpn: "Le Creuset ル・クルーゼ  ココット・ロンド 20cm クールミント",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥32,000",
    rrp_with_vat: "¥35,200",
    description_eng:
      "This piece is certainly great for stewing but is also good for rice cooking. Gentle heat brings the flavours out from the ingredients thoroughly. - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colours can be used as tableware as well. - Good heat Retention - Energy Saving - Acid-resistant and does not pick up odours Even after a long time. - Perfect on most of The heat sources e.g. gas, induction or oven (except Microwave) - Diameter: 18 cm - Capacity: 1.8L - Weight: 2.55kg",
    description_jpn:
      "ル・クルーゼの定番ココット・ロンドのモデル。 ムラのない熱まわりで、煮込み料理はもちろん炊飯にもおすすめです。 従来のココット・ロンドに比べ、ハンドルが握りやすく、ツマミも持ちやすいデザインになっています。 ----サイズ20CM----- 直径(取手込) 20(28.5)cm 高さ(フタ込) 9.5(14)cm 容量 \t2.4L 重量 \t3.1kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_21177204962430.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "332",
    brand: "Le Creuset",
    sku: "21177220902430",
    product_eng: "Le Creuset Cocotte Ronde 22cm Orange SS",
    product_jpn: "Le Creuset ル・クルーゼ  ココット・ロンド 22cm オレンジ SS",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥37,000",
    rrp_with_vat: "¥40,700",
    description_eng:
      "This piece is certainly great for stewing but is also good for rice cooking. Gentle heat brings the flavours out from the ingredients thoroughly. - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colours can be used as tableware as well. - Good heat Retention - Energy Saving - Acid-resistant and does not pick up odours Even after a long time. - Perfect on most of The heat sources e.g. gas, induction or oven (except Microwave) - Diameter: 18 cm - Capacity: 1.8L - Weight: 2.55kg",
    description_jpn:
      "ル・クルーゼの定番ココット・ロンドのモデル。 ムラのない熱まわりで、煮込み料理はもちろん炊飯にもおすすめです。 従来のココット・ロンドに比べ、ハンドルが握りやすく、ツマミも持ちやすいデザインになっています。 ----サイズ22CM----- 直径(取手込) 22(30)cm 高さ(フタ込) 10(15)cm 容量 \t3.3L 重量 \t3.7kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_21177220902430.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "333",
    brand: "Le Creuset",
    sku: "21177220602430",
    product_eng: "Le Creuset Cocotte Ronde 22cm Cherry Red SS",
    product_jpn:
      "Le Creuset ル・クルーゼ  ココット・ロンド 22cm チェリーレッド SS",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥37,000",
    rrp_with_vat: "¥40,700",
    description_eng:
      "This piece is certainly great for stewing but is also good for rice cooking. Gentle heat brings the flavours out from the ingredients thoroughly. - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colours can be used as tableware as well. - Good heat Retention - Energy Saving - Acid-resistant and does not pick up odours Even after a long time. - Perfect on most of The heat sources e.g. gas, induction or oven (except Microwave) - Diameter: 18 cm - Capacity: 1.8L - Weight: 2.55kg",
    description_jpn:
      "ル・クルーゼの定番ココット・ロンドのモデル。 ムラのない熱まわりで、煮込み料理はもちろん炊飯にもおすすめです。 従来のココット・ロンドに比べ、ハンドルが握りやすく、ツマミも持ちやすいデザインになっています。 ----サイズ22CM----- 直径(取手込) 22(30)cm 高さ(フタ込) 10(15)cm 容量 \t3.3L 重量 \t3.7kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_21177220602430.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "334",
    brand: "Le Creuset",
    sku: "21177224962430",
    product_eng: "Le Creuset Cocotte Ronde 22cm Cool Mint",
    product_jpn: "Le Creuset ル・クルーゼ  ココット・ロンド 22cm クールミント",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥37,000",
    rrp_with_vat: "¥40,700",
    description_eng:
      "This piece is certainly great for stewing but is also good for rice cooking. Gentle heat brings the flavours out from the ingredients thoroughly. - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colours can be used as tableware as well. - Good heat Retention - Energy Saving - Acid-resistant and does not pick up odours Even after a long time. - Perfect on most of The heat sources e.g. gas, induction or oven (except Microwave) - Diameter: 18 cm - Capacity: 1.8L - Weight: 2.55kg",
    description_jpn:
      "ル・クルーゼの定番ココット・ロンドのモデル。 ムラのない熱まわりで、煮込み料理はもちろん炊飯にもおすすめです。 従来のココット・ロンドに比べ、ハンドルが握りやすく、ツマミも持ちやすいデザインになっています。 ----サイズ22CM----- 直径(取手込) 22(30)cm 高さ(フタ込) 10(15)cm 容量 \t3.3L 重量 \t3.7kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_21177224962430.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "335",
    brand: "Le Creuset",
    sku: "56001160600000",
    product_eng: "Le Creuset Saucepan 16cm Cherry Red",
    product_jpn: "Le Creuset ル・クルーゼ EOS ソースパン 16cm チェリーレッド",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥9,500",
    rrp_with_vat: "¥10,450",
    description_eng:
      "This pot is made of lightweight carbon steel and coated with colorful enamel. It is lightweight and heats up fast, and yet durable and easy-to-clean. The long handle is designed ergonomically for easy to grip. This is the perfect size for boiling pasta, noodles or vegetables for 2 people. Material: - Main body: Enamel on Steel - Knob, handle: Phenolic - Rim: Stainless Steel * Heat resistant temperature: 180 ° C * Don't use high heat with an empty pot. Dimension: 18cm (35cm with handle) (D) X 11cm (16cm with lid) (H) Capacity: 2.1L Weight: 1.2Kg",
    description_jpn:
      "軽量なカーボンスチールにエナメル加工を施した、EOS素材の片手鍋。 人間工学に基づいて設計された握りやすいロングハンドルで熱くなりにくく、鋳物ホーローウェアと比べて軽いため、手軽にお使いいただけます。 16cmは2名分のパスタや麺をゆでたり、野菜をさっとゆでるのに最適なサイズです。  ----サイズ16CM----- 直径(取手込) \t16(35)cm 高さ(フタ込) \t11(16)cm 容量 \t2.1L 重量 \t1.25kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_56001160600000.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "336",
    brand: "Le Creuset",
    sku: "56001160900000",
    product_eng: "Le Creuset Saucepan 16cm Orange",
    product_jpn: "Le Creuset ル・クルーゼ EOS ソースパン 16cm オレンジ",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥9,500",
    rrp_with_vat: "¥10,450",
    description_eng:
      "This pot is made of lightweight carbon steel and coated with colorful enamel. It is lightweight and heats up fast, and yet durable and easy-to-clean. The long handle is designed ergonomically for easy to grip. This is the perfect size for boiling pasta, noodles or vegetables for 2 people. Material: - Main body: Enamel on Steel - Knob, handle: Phenolic - Rim: Stainless Steel * Heat resistant temperature: 180 ° C * Don't use high heat with an empty pot. Dimension: 18cm (35cm with handle) (D) X 11cm (16cm with lid) (H) Capacity: 2.1L Weight: 1.2Kg",
    description_jpn:
      "軽量なカーボンスチールにエナメル加工を施した、EOS素材の片手鍋。 人間工学に基づいて設計された握りやすいロングハンドルで熱くなりにくく、鋳物ホーローウェアと比べて軽いため、手軽にお使いいただけます。 16cmは2名分のパスタや麺をゆでたり、野菜をさっとゆでるのに最適なサイズです。  ----サイズ16CM----- 直径(取手込) \t16(35)cm 高さ(フタ込) \t11(16)cm 容量 \t2.1L 重量 \t1.25kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_56001160900000.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "337",
    brand: "Le Creuset",
    sku: "56001165360000",
    product_eng: "Le Creuset Saucepan 16cm Marine Blue",
    product_jpn: "Le Creuset ル・クルーゼ EOSソースパン 16cm マリンブルー",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥9,500",
    rrp_with_vat: "¥10,450",
    description_eng:
      "This pot is made of lightweight carbon steel and coated with colorful enamel. It is lightweight and heats up fast, and yet durable and easy-to-clean. The long handle is designed ergonomically for easy to grip. This is the perfect size for boiling pasta, noodles or vegetables for 2 people. ----Size 16CM----- Diameter (with handle) 16(35)cm Height (with lid) 11(16)cm Capacity 2.1L Weight 1.25kg",
    description_jpn:
      "軽量なカーボンスチールにエナメル加工を施した、EOS素材の片手鍋。 人間工学に基づいて設計された握りやすいロングハンドルで熱くなりにくく、鋳物ホーローウェアと比べて軽いため、手軽にお使いいただけます。 16cmは2名分のパスタや麺をゆでたり、野菜をさっとゆでるのに最適なサイズです。  ----サイズ16CM----- 直径(取手込) \t16(35)cm 高さ(フタ込) \t11(16)cm 容量 \t2.1L 重量 \t1.25kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_56001165360000.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "338",
    brand: "Le Creuset",
    sku: "56002207770800",
    product_eng: "Le Creuset Casserole 20cm Shell Pink",
    product_jpn: "Le Creuset ル・クルーゼ EOS キャセロール 20cm シェルピンク",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥12,000",
    rrp_with_vat: "¥13,200",
    description_eng:
      "This casserole made by lightweight carbon steel with good heat conductivity. This size is convenient for small families. It is recommended for cooking noodles and soup. Material: ・ Main body: Enamel on Steel ・ Knob, handle: Phenolic ・ Rim: Stainless Steel * EOS stands for Enamel On Steel which means a material in which carbon steel is enameled. * Heat resistant temperature: 180 ° C * Don't use high heat with an empty pot. - Diameter: 20cm - Capacity: 3.7L",
    description_jpn:
      "軽量なカーボンスチールにエナメル加工を施した、EOS素材の両手鍋。 同サイズ(20cm)の鋳物ホーローウェアに比べると、重量が約1/2と軽いため、手軽にお使いいただけます。 熱伝導が早いため、湯通しなどの下処理や、パスタ・麺類・スープ・おでんなど水分をたっぷり使う料理に向いています。 煮込み料理を作る際には、まず「EOS キャセロール」の鍋で下ゆでやストック作りを行い、鋳物ホーロー鍋でじっくりと煮込んで仕上げる、そんな使い方もおすすめです。 日々の調理をサポートする頼れる相棒として、便利にお使いいただけます。  直径(取手込) \t20(29)cm 高さ(フタ込) \t12(17)cm 容量 \t3.7L 重量 \t1460g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_56002207770800.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_56002207770800_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_56002207770800_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "339",
    brand: "Le Creuset",
    sku: "56002200600000",
    product_eng: "Le Creuset Casserole 20cm Cherry Red",
    product_jpn: "Le Creuset ル・クルーゼ EOS キャセロール 20cm チェリーレッド",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥12,000",
    rrp_with_vat: "¥13,200",
    description_eng:
      "This casserole made by lightweight carbon steel with good heat conductivity. This size is convenient for small families. It is recommended for cooking noodles and soup. Material: ・ Main body: Enamel on Steel ・ Knob, handle: Phenolic ・ Rim: Stainless Steel * EOS stands for Enamel On Steel which means a material in which carbon steel is enameled. * Heat resistant temperature: 180 ° C * Don't use high heat with an empty pot. - Diameter: 20cm - Capacity: 3.7L",
    description_jpn:
      "軽量なカーボンスチールにエナメル加工を施した、EOS素材の両手鍋。 同サイズ(20cm)の鋳物ホーローウェアに比べると、重量が約1/2と軽いため、手軽にお使いいただけます。 熱伝導が早いため、湯通しなどの下処理や、パスタ・麺類・スープ・おでんなど水分をたっぷり使う料理に向いています。 煮込み料理を作る際には、まず「EOS キャセロール」の鍋で下ゆでやストック作りを行い、鋳物ホーロー鍋でじっくりと煮込んで仕上げる、そんな使い方もおすすめです。 日々の調理をサポートする頼れる相棒として、便利にお使いいただけます。  直径(取手込) \t20(29)cm 高さ(フタ込) \t12(17)cm 容量 \t3.7L 重量 \t1460g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_56002200600000.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "340",
    brand: "Le Creuset",
    sku: "56002205360000",
    product_eng: "Le Creuset Casserole 20cm Marine Blue",
    product_jpn: "Le Creuset ル・クルーゼ EOSキャセロール 20cm マリンブルー",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥12,000",
    rrp_with_vat: "¥13,200",
    description_eng:
      "This casserole made by lightweight carbon steel with good heat conductivity.  This size is convenient for small families.  It is recommended for cooking noodles and soup. Weight 1.5kg Full water capacity 3.7L Depth 23cm Width 28cm",
    description_jpn:
      "軽量なカーボンスチールにエナメル加工を施した、EOS素材の両手鍋。 同サイズ(20cm)の鋳物ホーローウェアに比べると、重量が約1/2と軽いため、手軽にお使いいただけます。 熱伝導が早いため、湯通しなどの下処理や、パスタ・麺類・スープ・おでんなど水分をたっぷり使う料理に向いています。 煮込み料理を作る際には、まず「EOS キャセロール」の鍋で下ゆでやストック作りを行い、鋳物ホーロー鍋でじっくりと煮込んで仕上げる、そんな使い方もおすすめです。 日々の調理をサポートする頼れる相棒として、便利にお使いいただけます。  重量\t1.5kg 満水容量 3.7L 奥行\t23cm 幅\t28cm 全高\t17cm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_56002205360000.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "341",
    brand: "Le Creuset",
    sku: "92000200060100",
    product_eng: "Le Creuset Kettle Cone Cherry Red",
    product_jpn: "Le Creuset ル・クルーゼ ケトルコーン（チェリーレッド）",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥14,000",
    rrp_with_vat: "¥15,400",
    description_eng:
      "Nothing beats the tempting aroma of freshly brewed tea or coffee. Elevate your everyday ritual with this stylish stovetop kettle. Crafted from enamelled steel, it adds a vibrant pop of colour to your home. And when your water’s ready, it whistles!   Capacity: 1.6 L Length: 25.6 cm Width: 19.9 cm Height: 24.3 cm",
    description_jpn:
      "熱効率のよいしっかりとしたスチールに、つややかなホーローコーティングを施したル･クルーゼのケトル。 ル･クルーゼならではの美しいカラーは、他の製品とのコーディネートもお楽しみいただけます。 三角形が特徴的なデザインのコーンケトルは、沸騰サインの笛付きで機能的にお使いいただけます。 フタが外れにくい安心設計。  底径 \t17.5cm 高さ(フタ込) \t18(24)cm 適正容量 \t1.6L 重量 \t1.12kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_92000200060100.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "342",
    brand: "Le Creuset",
    sku: "92000200090100",
    product_eng: "Le Creuset Kettle Cone Cherry Orange",
    product_jpn: "Le Creuset ル・クルーゼ ケトルコーン（オレンジ）",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥14,000",
    rrp_with_vat: "¥15,400",
    description_eng:
      "Nothing beats the tempting aroma of freshly brewed tea or coffee. Elevate your everyday ritual with this stylish stovetop kettle. Crafted from enamelled steel, it adds a vibrant pop of colour to your home. And when your water’s ready, it whistles!   Capacity: 1.6 L Length: 25.6 cm Width: 19.9 cm Height: 24.3 cm",
    description_jpn:
      "熱効率のよいしっかりとしたスチールに、つややかなホーローコーティングを施したル･クルーゼのケトル。 ル･クルーゼならではの美しいカラーは、他の製品とのコーディネートもお楽しみいただけます。 三角形が特徴的なデザインのコーンケトルは、沸騰サインの笛付きで機能的にお使いいただけます。 フタが外れにくい安心設計。  底径 \t17.5cm 高さ(フタ込) \t18(24)cm 適正容量 \t1.6L 重量 \t1.12kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_92000200090100.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "343",
    brand: "Le Creuset",
    sku: "40101035360001",
    product_eng: "Le Creuset Kettle Cone Marine Blue",
    product_jpn: "Le Creuset ル・クルーゼ ケトルコーン マリンブルー",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥14,000",
    rrp_with_vat: "¥15,400",
    description_eng:
      "The Le Creuset kettle is made of solid, thermally efficient steel with a glossy enamel coating. The beautiful colors of the Le Creuset kettle coordinate well with other Le Creuset products. The cone kettle has a distinctive triangular design and comes with a whistle to indicate boiling for functional use. The lid is designed to prevent the lid from coming off.  Bottom diameter 17.5cm Height (with lid) 18(24)cm Appropriate capacity 1.6L Weight 1.12kg",
    description_jpn:
      "熱効率のよいしっかりとしたスチールに、つややかなホーローコーティングを施したル･クルーゼのケトル。 ル･クルーゼならではの美しいカラーは、他の製品とのコーディネートもお楽しみいただけます。 三角形が特徴的なデザインのコーンケトルは、沸騰サインの笛付きで機能的にお使いいただけます。 フタが外れにくい安心設計。  底径 \t17.5cm 高さ(フタ込) \t18(24)cm 適正容量 \t1.6L 重量 \t1.12kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_40101035360001.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "344",
    brand: "Le Creuset",
    sku: "40101037770001",
    product_eng: "Le Creuset Kettle Cone Shell Pink",
    product_jpn: "Le Creuset ル・クルーゼ ケトルコーン シェルピンク",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥14,000",
    rrp_with_vat: "¥15,400",
    description_eng:
      "The Le Creuset kettle is made of solid, thermally efficient steel with a glossy enamel coating. The beautiful colors of the Le Creuset kettle coordinate well with other Le Creuset products. The cone kettle has a distinctive triangular design and comes with a whistle to indicate boiling for functional use. The lid is designed to prevent the lid from coming off.  Bottom diameter 17.5cm Height (with lid) 18(24)cm Appropriate capacity 1.6L Weight 1.12kg",
    description_jpn:
      "熱効率のよいしっかりとしたスチールに、つややかなホーローコーティングを施したル･クルーゼのケトル。 ル･クルーゼならではの美しいカラーは、他の製品とのコーディネートもお楽しみいただけます。 三角形が特徴的なデザインのコーンケトルは、沸騰サインの笛付きで機能的にお使いいただけます。 フタが外れにくい安心設計。  底径 \t17.5cm 高さ(フタ込) \t18(24)cm 適正容量 \t1.6L 重量 \t1.12kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_40101037770001.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "345",
    brand: "Le Creuset",
    sku: "21110184960460",
    product_eng: "Le Creuset Cocotte Every 18cm Cool Mint",
    product_jpn: "Le Creuset ル・クルーゼ ココット・エブリィ 18cm クールミント",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥26,000",
    rrp_with_vat: "¥28,600",
    description_eng:
      "An indispensable Cast Iron Casserole so versatile that can achieve your favourite cuisine, whether it is clay pot rice, soups, congee or deep fried dishes.  - A deep casserole with round bottom and domed lid distributes heat evenly throughout the interior. Cooking ingredients by convection of heat and steam and perfecting your favourite flavours. - Conceived with a space-conscious approach. - Deep in volume, small in size, this Casserole enable you to accomplish a variety of dishes - clay pot rice, stewing, soup-making, congee, deep frying and more. - Applying black enamelled interior, it has high resistance of heat, making it perfect for frying, especially for users new to Enamelled Cast Iron products.  Diameter:17cm (23cm incl. handle) Height:13cm (18cm incl. knob) Depth:12.5cm \t Volume:2L",
    description_jpn:
      "日本人のライフ・スタイルに合わせて、フランスの職人と一緒に取り組んで開発された鋳物ホーロー鍋。 エブリィ(Every)には、『毎日(Everyday)みんなに(Everyone)いろんな料理(Every menu)を作って欲しい』というル・クルーゼの想いが込められています。 ・底の角を丸くすることで、熱の対流を効率化するように設計されています。 ・収納スペースを極力少なくするよう、径を小さくする代わりに深さをもたせることで、コンパクトでありながらも18㎝は2Lの容量を備えたデザインになっています。 ・内側色がマットブラックのため、サンドカラーに比べ、ステイン(長期使用による色素沈着)やひび割れが目立ちにくくなっています。 ・深さがあるので、少量の揚げ物やパン作りにもおすすめです。 ・鋳物ホーロー初のインナーリッド(内蓋・別売り)使用で、煮物や炊飯時の吹きこぼれを防ぎ、調理中のストレスを軽減します。 ＊コットンはマット加工が施されたカラーです。 ＊底径が小さいため、五徳のサイズによっては安定しない場合があります。火にかける前に傾き等がないかを十分にご確認の上、ご使用ください。 ＜サイズ18㎝＞ 炊飯の目安：3合まで ＊IHクッキングヒーターは10㎝以上対応するものにお使いいただけます。 ----サイズ 18----- 直径(取手込) \t17(23)cm ※段落ち部分15.5cm 高さ(フタ込) \t13(18)cm 深さ \t12.5cm 底径 \t10.5cm 容量 \t2L ※インナーリッドまで1.7L 重量 \t2.7kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_21110184960460.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "346",
    brand: "Le Creuset",
    sku: "21110187770460",
    product_eng: "Le Creuset Cocotte Every 18cm Shell Pink",
    product_jpn: "Le Creuset ル・クルーゼ ココット・エブリィ 18cm シェルピンク",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥26,000",
    rrp_with_vat: "¥28,600",
    description_eng:
      "An indispensable Cast Iron Casserole so versatile that can achieve your favourite cuisine, whether it is clay pot rice, soups, congee or deep fried dishes.  - A deep casserole with round bottom and domed lid distributes heat evenly throughout the interior. Cooking ingredients by convection of heat and steam and perfecting your favourite flavours. - Conceived with a space-conscious approach. - Deep in volume, small in size, this Casserole enable you to accomplish a variety of dishes - clay pot rice, stewing, soup-making, congee, deep frying and more. - Applying black enamelled interior, it has high resistance of heat, making it perfect for frying, especially for users new to Enamelled Cast Iron products.  Diameter:17cm (23cm incl. handle) Height:13cm (18cm incl. knob) Depth:12.5cm \t Volume:2L",
    description_jpn:
      "日本人のライフ・スタイルに合わせて、フランスの職人と一緒に取り組んで開発された鋳物ホーロー鍋。 エブリィ(Every)には、『毎日(Everyday)みんなに(Everyone)いろんな料理(Every menu)を作って欲しい』というル・クルーゼの想いが込められています。 ・底の角を丸くすることで、熱の対流を効率化するように設計されています。 ・収納スペースを極力少なくするよう、径を小さくする代わりに深さをもたせることで、コンパクトでありながらも18㎝は2Lの容量を備えたデザインになっています。 ・内側色がマットブラックのため、サンドカラーに比べ、ステイン(長期使用による色素沈着)やひび割れが目立ちにくくなっています。 ・深さがあるので、少量の揚げ物やパン作りにもおすすめです。 ・鋳物ホーロー初のインナーリッド(内蓋・別売り)使用で、煮物や炊飯時の吹きこぼれを防ぎ、調理中のストレスを軽減します。 ＊コットンはマット加工が施されたカラーです。 ＊底径が小さいため、五徳のサイズによっては安定しない場合があります。火にかける前に傾き等がないかを十分にご確認の上、ご使用ください。 ＜サイズ18㎝＞ 炊飯の目安：3合まで ＊IHクッキングヒーターは10㎝以上対応するものにお使いいただけます。 ----サイズ 18----- 直径(取手込) \t17(23)cm ※段落ち部分15.5cm 高さ(フタ込) \t13(18)cm 深さ \t12.5cm 底径 \t10.5cm 容量 \t2L ※インナーリッドまで1.7L 重量 \t2.7kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_21110187770460.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "347",
    brand: "Le Creuset",
    sku: "21110204960460",
    product_eng: "Le Creuset Cocotte Every 20cm Cool Mint",
    product_jpn: "Le Creuset ル・クルーゼ ココット・エブリィ 20cm クールミント",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥30,000",
    rrp_with_vat: "¥33,000",
    description_eng:
      "An indispensable Cast Iron Casserole so versatile that can achieve your favourite cuisine, whether it is clay pot rice, soups, congee or deep fried dishes.  - A deep casserole with round bottom and domed lid distributes heat evenly throughout the interior. Cooking ingredients by convection of heat and steam and perfecting your favourite flavours. - Conceived with a space-conscious approach. - Deep in volume, small in size, this Casserole enable you to accomplish a variety of dishes - clay pot rice, stewing, soup-making, congee, deep frying and more. - Applying black enamelled interior, it has high resistance of heat, making it perfect for frying, especially for users new to Enamelled Cast Iron products.  Diameter:19cm (25cm incl. handle) \t Height:14cm (19cm incl. knob) \t Depth:13.5cm\t Volume:2.8L",
    description_jpn:
      "日本人のライフ・スタイルに合わせて、フランスの職人と一緒に取り組んで開発された鋳物ホーロー鍋。 エブリィ(Every)には、『毎日(Everyday)みんなに(Everyone)いろんな料理(Every menu)を作って欲しい』というル・クルーゼの想いが込められています。 ・底の角を丸くすることで、熱の対流を効率化するように設計されています。 ・収納スペースを極力少なくするよう、径を小さくする代わりに深さをもたせることで、コンパクトでありながらも20㎝は2.8Lの容量を備えたデザインになっています。 ・内側色がマットブラックのため、サンドカラーに比べ、ステイン(長期使用による色素沈着)やひび割れが目立ちにくくなっています。 ・深さがあるので、少量の揚げ物やパン作りにもおすすめです。 ・鋳物ホーロー初のインナーリッド(内蓋・別売り)使用で、煮物や炊飯時の吹きこぼれを防ぎ、調理中のストレスを軽減します。 ＊内側色はマットブラックホーロー ＊コットンはマット加工が施されたカラーです。 ＊底径が小さいため、五徳のサイズによっては安定しない場合があります。火にかける前に傾き等がないかを十分にご確認の上、ご使用ください。 ＜サイズ20cm＞ 炊飯の目安：5合まで ＊IHクッキングヒーターは12㎝以上対応するものにお使いいただけます。 ----サイズ 20----- 直径(取手込) \t19(25)cm ※段落ち部分17.5cm 高さ(フタ込) \t14(19)cm 深さ \t13.5cm 底径 \t12cm 容量 \t2.8L ※インナーリッドまで2.5L 重量 \t3.3kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_21110204960460.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "348",
    brand: "Le Creuset",
    sku: "21110207770460",
    product_eng: "Le Creuset Cocotte Every 20cm Shell Pink",
    product_jpn: "Le Creuset ル・クルーゼ ココット・エブリィ 20cm シェルピンク",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥30,000",
    rrp_with_vat: "¥33,000",
    description_eng:
      "An indispensable Cast Iron Casserole so versatile that can achieve your favourite cuisine, whether it is clay pot rice, soups, congee or deep fried dishes.  - A deep casserole with round bottom and domed lid distributes heat evenly throughout the interior. Cooking ingredients by convection of heat and steam and perfecting your favourite flavours. - Conceived with a space-conscious approach. - Deep in volume, small in size, this Casserole enable you to accomplish a variety of dishes - clay pot rice, stewing, soup-making, congee, deep frying and more. - Applying black enamelled interior, it has high resistance of heat, making it perfect for frying, especially for users new to Enamelled Cast Iron products.  Diameter:19cm (25cm incl. handle) \t Height:14cm (19cm incl. knob) \t Depth:13.5cm\t Volume:2.8L",
    description_jpn:
      "日本人のライフ・スタイルに合わせて、フランスの職人と一緒に取り組んで開発された鋳物ホーロー鍋。 エブリィ(Every)には、『毎日(Everyday)みんなに(Everyone)いろんな料理(Every menu)を作って欲しい』というル・クルーゼの想いが込められています。 ・底の角を丸くすることで、熱の対流を効率化するように設計されています。 ・収納スペースを極力少なくするよう、径を小さくする代わりに深さをもたせることで、コンパクトでありながらも20㎝は2.8Lの容量を備えたデザインになっています。 ・内側色がマットブラックのため、サンドカラーに比べ、ステイン(長期使用による色素沈着)やひび割れが目立ちにくくなっています。 ・深さがあるので、少量の揚げ物やパン作りにもおすすめです。 ・鋳物ホーロー初のインナーリッド(内蓋・別売り)使用で、煮物や炊飯時の吹きこぼれを防ぎ、調理中のストレスを軽減します。 ＊内側色はマットブラックホーロー ＊コットンはマット加工が施されたカラーです。 ＊底径が小さいため、五徳のサイズによっては安定しない場合があります。火にかける前に傾き等がないかを十分にご確認の上、ご使用ください。 ＜サイズ20cm＞ 炊飯の目安：5合まで ＊IHクッキングヒーターは12㎝以上対応するものにお使いいただけます。 ----サイズ 20----- 直径(取手込) \t19(25)cm ※段落ち部分17.5cm 高さ(フタ込) \t14(19)cm 深さ \t13.5cm 底径 \t12cm 容量 \t2.8L ※インナーリッドまで2.5L 重量 \t3.3kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_21110207770460.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "349",
    brand: "Le Creuset",
    sku: "21179240902430",
    product_eng: "Le Creuset Cocotte Japonaise 24cm Orange SS",
    product_jpn:
      "Le Creuset ル・クルーゼ  ココット・ジャポネーズ 24cm オレンジ SS",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥37,000",
    rrp_with_vat: "¥40,700",
    description_eng:
      "Perfect for frying, which can easily bring out the flavor and the essence of the food.  - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colors can be used as tableware as well. - Good Heat Retention. - Energy Saving. - Acid-resistant and does not pick up odors even after a long time. - Perfect on most of the heat sources e.g. gas, induction or oven (except Microwave) Diameter: 24cm Capacity: 3.1L Weight: 3.9kg",
    description_jpn:
      "浅型のジャポネーズは、別名ココットSUKIYAKIと海外で呼ばれており、 すき焼きはもちろん、鍋料理に最適なお鍋です。 和食だけでなくリゾットなどの洋食にも大活躍。タルトやケーキを作って、そのままテーブルに。 モデルはハンドルが握りやすく、ツマミも持ちやすいデザインになっています。 直径(取手込) 24(32.5)cm 高さ(フタ込) 8.5(13.5)cm 容量 \t3.1L 重量 \t3.9kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_21179240902430.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "350",
    brand: "Le Creuset",
    sku: "21179240602430",
    product_eng: "Le Creuset Cocotte Japonaise 24cm Cherry Red SS",
    product_jpn:
      "Le Creuset ル・クルーゼ  ココット・ジャポネーズ 24cm チェリーレッド SS",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥37,000",
    rrp_with_vat: "¥40,700",
    description_eng:
      "Perfect for frying, which can easily bring out the flavor and the essence of the food.  - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colors can be used as tableware as well. - Good Heat Retention. - Energy Saving. - Acid-resistant and does not pick up odors even after a long time. - Perfect on most of the heat sources e.g. gas, induction or oven (except Microwave) Diameter: 24cm Capacity: 3.1L Weight: 3.9kg",
    description_jpn:
      "浅型のジャポネーズは、別名ココットSUKIYAKIと海外で呼ばれており、 すき焼きはもちろん、鍋料理に最適なお鍋です。 和食だけでなくリゾットなどの洋食にも大活躍。タルトやケーキを作って、そのままテーブルに。 モデルはハンドルが握りやすく、ツマミも持ちやすいデザインになっています。 直径(取手込) 24(32.5)cm 高さ(フタ込) 8.5(13.5)cm 容量 \t3.1L 重量 \t3.9kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_21179240602430.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "351",
    brand: "Le Creuset",
    sku: "21179247774430",
    product_eng: "Le Creuset Cocotte Japonaise 24cm Shell Pink",
    product_jpn:
      "Le Creuset ル・クルーゼ  ココット・ジャポネーズ 24cm シェルピンク",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥37,000",
    rrp_with_vat: "¥40,700",
    description_eng:
      "Perfect for frying, which can easily bring out the flavor and the essence of the food.  - Even heat distribution of enamelled cast iron avoids hot spots. - The beautiful design and colors can be used as tableware as well. - Good Heat Retention. - Energy Saving. - Acid-resistant and does not pick up odors even after a long time. - Perfect on most of the heat sources e.g. gas, induction or oven (except Microwave) Diameter: 24cm Capacity: 3.1L Weight: 3.9kg",
    description_jpn:
      "浅型のジャポネーズは、別名ココットSUKIYAKIと海外で呼ばれており、 すき焼きはもちろん、鍋料理に最適なお鍋です。 和食だけでなくリゾットなどの洋食にも大活躍。タルトやケーキを作って、そのままテーブルに。 モデルはハンドルが握りやすく、ツマミも持ちやすいデザインになっています。 直径(取手込) 24(32.5)cm 高さ(フタ込) 8.5(13.5)cm 容量 \t3.1L 重量 \t3.9kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/LeCreuset_21179247774430.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "352",
    brand: "Le Creuset",
    sku: "51101260010202",
    product_eng: "Le Creuset TNS Deep Fry Pan NC 26cm",
    product_jpn: "Le Creuset ル・クルーゼ TNS ディープフライパン NC 26cm",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥19,000",
    rrp_with_vat: "¥20,900",
    description_eng:
      "It is moderately sized and deep, with a slightly rounded bottom. TNS＝Toughened Non Stick Cookware <Features> ・Foods do not stick to the pan and stains are easily removed, making washing easy. ・The coating is four times stronger than our conventional products*, making it more durable. (*Tested by our company for abrasion durability) ・The special aluminum finish ensures fast heat conduction and the thickness of the coating ensures even heat distribution and excellent heat retention. ・The uniquely designed angled edge makes it easy to transfer dishes to plates for smooth serving. ・The bowl can also be hung on a hook for display storage. The stylish form of the dish looks great on the dining table even when served as it is. ・Ergonomic design that fits comfortably in your hand. ・The easy-to-grip handle prevents heat buildup, making cooking time stress-free. ・The handle is easy to grip and does not get hot, making for a stress-free cooking time.  ---- Size 26CM----- Diameter (including handle) 27(51.5)cm Height 9.5 cm Capacity 2.7L Weight 1.5kg",
    description_jpn:
      "適度な大きさと深さがあり、底面にすこし丸みを帯びた形状です。 TNS＝Toughened Non Stick Cookware <特徴> ・食材がこびりつきにくく、汚れ落ちも良いので､洗い物が簡単です。 ・当社従来品に比べて4倍のコーティング強度*となり、耐久性がアップしました。（*当社摩耗耐久検査検証済） ・特殊なアルミ加工で熱伝導が早く、厚みがあるので熱まわりが均一かつ保温性がバツグンです。 ・独自に設計された角度のフチにより、お料理をお皿に移しやすくスムーズに盛り付けができます。 ・フックにかけて、見せる収納も叶います。 スタイリッシュなフォルムは、そのまま出しても食卓が映えます。 ・人間工学に基づいた、手になじむ使い勝手の良いデザイン。 ・握りやすいグリップのハンドルは熱くなりにくく、 ストレスフリーな料理タイムに。 ・環境ホルモン「PFOS/PFOA」不使用で、安全面にもこだわりました。  ----サイズ 26CM----- 直径(取っ手込) \t27(51.5)cm 高さ \t9.5cm 容量 \t2.7L 重量 \t1.5kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_51101260010202.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "353",
    brand: "Le Creuset",
    sku: "51112220010002",
    product_eng: "Le Creuset TNS Shallow Fry Pan NC 22cm",
    product_jpn: "Le Creuset ル・クルーゼ TNS シャロ―フライパン NC 22cm",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥13,000",
    rrp_with_vat: "¥14,300",
    description_eng:
      "This shallow frying pan features a large cooking surface. <Features> ・The food does not stick to the pan, and the pan cleans well, making washing up easy. ・The coating is four times stronger than our conventional products*, making it more durable. (*Tested by our abrasion durability test) ・The special aluminum finish ensures fast heat conduction and the thickness of the coating ensures even heat distribution and excellent heat retention. ・The uniquely designed angled edge makes it easy to transfer dishes to the plate for smooth serving. ・It can also be hung on a hook for showy storage. The stylish form of the tabletop looks great even when displayed as it is. ・Ergonomically designed to fit comfortably in your hand. ・The easy-to-grip handle prevents the pan from getting hot, making for a stress-free cooking time. ・The handle is easy to grip and does not get hot, making for a stress-free cooking experience. ・The product is free of environmental hormones PFOS/PFOA and is safe. ----Size 22CM----- Diameter (with handle) 23(40.5)cm Height 7cm Weight 0.79kg",
    description_jpn:
      "浅めのフライパンで、大きな調理面が特長です。 【製品特徴】 ・食材がこびりつきにくく、汚れ落ちも良いので､洗い物が簡単です。 ・当社従来品に比べて4倍のコーティング強度*となり、耐久性がアップしました。（*当社摩耗耐久検査検証済） ・特殊なアルミ加工で熱伝導が早く、厚みがあるので熱まわりが均一かつ保温性がバツグンです。 ・独自に設計された角度のフチにより、お料理をお皿に移しやすくスムーズに盛り付けができます。 ・フックにかけて、見せる収納も叶います。 スタイリッシュなフォルムは、そのまま出しても食卓が映えます。 ・人間工学に基づいた、手になじむ使い勝手の良いデザイン。 ・握りやすいグリップのハンドルは熱くなりにくく、 ストレスフリーな料理タイムに。 ・環境ホルモン「PFOS/PFOA」不使用で、安全面にもこだわりました。 ----サイズ 22CM----- 直径(取っ手込) \t23(40.5)cm 高さ \t7cm 重量 \t0.79kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_51112220010002.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_51112220010002_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "354",
    brand: "Le Creuset",
    sku: "51112200010002",
    product_eng: "Le Creuset TNS Shallow Fry Pan NC 20cm",
    product_jpn: "Le Creuset ル・クルーゼ TNS シャロ―フライパン NC 20cm",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥12,000",
    rrp_with_vat: "¥13,200",
    description_eng:
      "This shallow frying pan features a large cooking surface. <Features> ・The food does not stick to the pan, and the pan cleans well, making washing up easy. ・The coating is four times stronger than our conventional products*, making it more durable. (*Tested by our abrasion durability test) ・The special aluminum finish ensures fast heat conduction and the thickness of the coating ensures even heat distribution and excellent heat retention. ・The uniquely designed angled edge makes it easy to transfer dishes to the plate for smooth serving. ・It can also be hung on a hook for showy storage. The stylish form of the tabletop looks great even when displayed as it is. ・Ergonomically designed to fit comfortably in your hand. ・The easy-to-grip handle prevents the pan from getting hot, making for a stress-free cooking time. ・The handle is easy to grip and does not get hot, making for a stress-free cooking experience. ・The product is free of environmental hormones PFOS/PFOA and is safe. ----Size 20CM----- Diameter (with handle) 21(38.5)cm Height 6.5cm Weight 0.76kg",
    description_jpn:
      "浅めのフライパンで、大きな調理面が特長です。 【製品特徴】 ・食材がこびりつきにくく、汚れ落ちも良いので､洗い物が簡単です。 ・当社従来品に比べて4倍のコーティング強度*となり、耐久性がアップしました。（*当社摩耗耐久検査検証済） ・特殊なアルミ加工で熱伝導が早く、厚みがあるので熱まわりが均一かつ保温性がバツグンです。 ・独自に設計された角度のフチにより、お料理をお皿に移しやすくスムーズに盛り付けができます。 ・フックにかけて、見せる収納も叶います。 スタイリッシュなフォルムは、そのまま出しても食卓が映えます。 ・人間工学に基づいた、手になじむ使い勝手の良いデザイン。 ・握りやすいグリップのハンドルは熱くなりにくく、 ストレスフリーな料理タイムに。 ・環境ホルモン「PFOS/PFOA」不使用で、安全面にもこだわりました。 ----サイズ 20CM----- 直径(取っ手込) \t21(38.5)cm 高さ \t6.5cm 重量 \t0.76kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_51112200010002.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_51112200010002_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "355",
    brand: "Le Creuset",
    sku: "96500700000271",
    product_eng: "Le Creuset Maple Wood Turner",
    product_jpn: "Le Creuset ル・クルーゼ メープルウッド・ターナー",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥2,800",
    rrp_with_vat: "¥3,080",
    description_eng:
      "The Wood Ware series is made from North American maple wood, which is highly durable and resistant to deterioration and deformation. It is resistant to damage to your precious pots and pans, and is a perfect match for colorful Le Creuset products. The turner with an easy-to-hold handle is useful for returning boiled fish, stir-fried food, pancakes, etc.  Length x Width 27 x 6.5 cm Height 2cm Weight 40g",
    description_jpn:
      "変質・変形しにくく耐久性に優れた北米産のメープルウッドからつくられたウッド・ウェアシリーズ。 大切なお鍋を傷つけにくく、カラフルなル・クルーゼ製品との相性も抜群です。 持ちやすいハンドルのターナーは、煮魚や炒め物、ホットケーキなどを返す際に活躍します。  縦×横 \t27×6.5cm 高さ \t2cm 重量 \t40g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_96500700000271.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "356",
    brand: "Le Creuset",
    sku: "96500800000271",
    product_eng: "Le Creuset Maple Wood Serving Spoon",
    product_jpn: "Le Creuset ル・クルーゼ メープルウッド・サービングスプーン",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,300",
    description_eng:
      "The Wood Ware series is made from North American maple wood, which is highly durable and resistant to deterioration and deformation. It is resistant to damage to your precious pots and pans, and is a perfect match for colorful Le Creuset products. The large serving spoon can be used for serving gratins and simmered dishes, and is also ideal for serving dishes that tend to fall apart.  Length x width 27 x 6.5 cm Height 2.5cm Capacity 40ml Weight 50g",
    description_jpn:
      "変質・変形しにくく耐久性に優れた北米産のメープルウッドからつくられたウッド・ウェアシリーズ。 大切なお鍋を傷つけにくく、カラフルなル・クルーゼ製品との相性も抜群です。 グラタンや煮物の盛り付けに使える大きめサイズのサービングスプーンは、くずれやすいお料理の取り分けにも最適です。  縦×横 \t27×6.5cm 高さ \t2.5cm 容量 \t40ml 重量 \t50g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_96500800000271.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_96500800000271_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "357",
    brand: "Le Creuset",
    sku: "96502900000270",
    product_eng: "Le Creuset Maple wood Slim Tongs",
    product_jpn: "Le Creuset ル・クルーゼ メープルウッド・スリムトング",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥3,300",
    rrp_with_vat: "¥3,630",
    description_eng:
      "The Wood Ware series is made from North American maple wood, which is highly durable and resistant to deterioration and deformation. It is resistant to damage to your precious pots and pans, and is a perfect match for colorful Le Creuset products. Slender tongs with an easy-to-grip. The tongs have a stand to prevent the tip from touching the table top directly, ensuring hygienic use.  Length x Width 2 (when closed) x 23.5 cm Height 3.5 cm Weight 80g",
    description_jpn:
      "変質・変形しにくく耐久性に優れた北米産のメープルウッドからつくられたウッド・ウェアシリーズ。 大切なお鍋を傷つけにくく、カラフルなル・クルーゼ製品との相性も抜群です。 握りやすい細身のトング。 先がテーブルトップに直接つかないようにスタンドが付いているので、衛生的にお使いいただけます。  縦×横 \t2(閉じたとき)×23.5cm 高さ \t3.5cm 重量 \t80g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_96502900000270.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "358",
    brand: "Le Creuset",
    sku: "Le Creuset CT Set",
    product_eng: "Le Creuset Cooking Tool Set",
    product_jpn: "Le Creuset ル・クルーゼ  クッキングツールセット",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥9,100",
    rrp_with_vat: "¥10,010",
    description_eng:
      "This three-piece woodware series set is made from North American maple wood, which is highly durable and resistant to deterioration and deformation. It is resistant to damage to your precious pots and pans, and is a perfect match for colorful Le Creuset products.  ●Slender tongs with an easy-to-grip. The tongs have a stand to prevent the tip from touching the table top directly, ensuring hygienic use.  Length x Width 2 (when closed) x 23.5 cm Height 3.5 cm Weight 80g  ●The large serving spoon can be used for serving gratins and simmered dishes. Length x width 27 x 6.5 cm Height 2.5cm Capacity 40ml Weight 50g  ●The turner with an easy-to-hold handle Length x Width 27 x 6.5 cm Height 2cm Weight 40g",
    description_jpn:
      "変質・変形しにくく耐久性に優れた北米産のメープルウッドからつくられたウッド・ウェアシリーズ３点セットです。 大切なお鍋を傷つけにくく、カラフルなル・クルーゼ製品との相性も抜群です。  ●握りやすい細身のトング。 先がテーブルトップに直接つかないようにスタンドが付いているので、衛生的にお使いいただけます。  縦×横 \t2(閉じたとき)×23.5cm 高さ \t3.5cm 重量 \t80g  ●グラタンや煮物の盛り付けに使える大きめサイズのサービングスプーン 縦×横 \t27×6.5cm 高さ \t2.5cm 容量 \t40ml 重量 \t50g  ●持ちやすいハンドルのターナー 縦×横 \t27×6.5cm 高さ \t2cm 重量 \t40g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_Le_Creuset_CT_Set.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "359",
    brand: "Le Creuset",
    sku: "96500500000271",
    product_eng: "Le Creuset Maple Wood Cutting Board",
    product_jpn: "Le Creuset ル・クルーゼ メープルウッド・カッティングボード",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥6,000",
    rrp_with_vat: "¥6,600",
    description_eng:
      "The Wood Ware series is made from North American maple wood, which is highly durable and resistant to deterioration and deformation. The luster of the wood grain is beautiful, and the more it is used, the more the taste comes out.  Length x width 33.5 x 21cm Height 2cm Weight 840g",
    description_jpn:
      "変質・変形しにくく耐久性に優れた北米産のメープルウッドからつくられたウッド・ウェアシリーズ。 木目の光沢が美しく、使い込むほどに味わいが出てくるカッティングボード(まな板)は、水分の多い素材を切った際にこぼれず溝にたまる仕様になっています。  縦×横 \t33.5×21cm 高さ \t2cm 重量 \t840g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_96500500000271.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "360",
    brand: "Le Creuset",
    sku: "69266177849014",
    product_eng: "Le Creuset Oval serving bowl (5pcs) 17cm",
    product_jpn:
      "Le Creuset ル・クルーゼ オーバル・サービング・ボール(5個入)17cm",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥11,000",
    description_eng:
      "Perfectly sized for side dishes or salad bowls, the Oval Serving Bowl Oval is easy to serve and saves storage space, making it ideal for everyday use. Length x width 12 x 17 cm Weight 360g",
    description_jpn:
      "副菜やサラダボールとして最適サイズのオーバル・サービング・ボールオーバル型は盛り付しやすい上、収納スペースも削減できるので日常使いに最適。 縦 x 横  12 x 17cm 重量 \t 360",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_69266177849014.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "361",
    brand: "Le Creuset",
    sku: "69190127849013",
    product_eng: "Le Creuset Mini Round Plate (5pcs) Rainbow 12cm",
    product_jpn:
      "Le Creuset ル・クルーゼ ミニ・ラウンド・プレート(5枚入)レインボー12cm",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥6,000",
    rrp_with_vat: "¥6,600",
    description_eng:
      "A set of five plates. These plates are versatile enough to be used as dessert plates for petit cakes and other desserts, as well as for serving dishes and soy sauce dishes.  Diameter 12cm Height 2cm Weight 180g",
    description_jpn:
      "豆皿サイズのプレートの5枚セット。 取り皿や醤油皿にはもちろん、プチケーキなどのデザート皿として万能サイズのプレートです。  直径 \t12cm 高さ \t2cm 重量 \t180g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_69190127849013.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "362",
    brand: "Le Creuset",
    sku: "69264227849014",
    product_eng: "Le Creuset Neo Round Plate (5pcs) Rainbow 22cm",
    product_jpn:
      "Le Creuset ル・クルーゼ ネオ・ラウンド・プレート(5枚入)レインボー22cm",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥13,000",
    rrp_with_vat: "¥14,300",
    description_eng:
      "Ideal size for cake plates and serving plates. The Neo series (NEO=new in Greek) gives a modern and sharp impression, and is a stylish way to present food.  Diameter 22cm Height 3cm Weight 700g",
    description_jpn:
      "ケーキ皿や取り皿に最適なサイズ。 モダンでシャープな印象を与えるネオ・シリーズ（NEO=ギリシャ語で新しいという意）は料理をスタイリッシュに演出します。  直径 \t22cm 高さ \t3cm 重量 \t700g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_69264227849014.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_69264227849014_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "363",
    brand: "Le Creuset",
    sku: "95009900000097",
    product_eng: "Le Creuset Guest Chop Stick Set (5 sets) Rainbow",
    product_jpn:
      "Le Creuset ル・クルーゼ ゲストチョップスティックセット(5膳入)レインボー",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,500",
    description_eng:
      "Made from bamboo, these chopsticks have an elegant slender silhouette and are square in shape with corners that are said to be most comfortable in the hand.  The tips of the chopsticks are angled for easy grasping of food. Solid colors are used instead of gradation. Made in Japan.  Length: 23cm Width: 0.8cm Weight: 15g",
    description_jpn:
      "竹から作った、上品な細身のシルエットのお箸は手に最も馴染むといわれる、角をとった四角形を採用。箸先は食べ物をつかみやすい先角仕様になっています。 ※グラデーションではなくソリッドカラーになります。 日本製。  長さ： \t23cm 幅： \t0.8cm 重量： \t15g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_95009900000097.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "364",
    brand: "Le Creuset",
    sku: "69017000600013",
    product_eng: "Le Creuset Teapot&mug (ss x 2) Cherry Red",
    product_jpn:
      "Le Creuset ル・クルーゼ ティーポット&マグセット(SS) チェリーレッド",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥9,500",
    rrp_with_vat: "¥10,450",
    description_eng:
      "Tea pod & 2mugs Set 【Teapod】 Diameter:20cm incl. handle Height:12.5cm incl. knob Depth:11.5cm \t Volume:600ml Weight:610g 【mug(SS)】 Diameter:12cm incl. handle Height: 8.5cm  Volume:250ml    Weight:290g",
    description_jpn:
      "人気のティーポットとマグ(SS)のペアセットです。 【ティーポット】 縦×横(取手込)：12.5×20cm     高さ：11.5cm     容量：600ml     重量：610g 【マグ(SS)】     縦×横(取手込)：9×12cm     高さ：8.5cm     容量：250ml x2     重量：290g x2 対応機器 直火 IH 電子レンジ オーブン 食器洗い機 冷蔵・冷凍 圧力なべ 蒸し器 その他 熱源なし",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_69017000600013.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "365",
    brand: "Le Creuset",
    sku: "69017001780013",
    product_eng: "Le Creuset Teapot&mug (ss x 2) Rose",
    product_jpn:
      "Le Creuset ル・クルーゼ ティーポット&マグセット(SS) ローズクオーツ",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥9,500",
    rrp_with_vat: "¥10,450",
    description_eng:
      "Tea pod & 2mugs Set 【Teapod】 Diameter:20cm incl. handle Height:12.5cm incl. knob Depth:11.5cm \t Volume:600ml Weight:610g 【mug(SS)】 Diameter:12cm incl. handle Height: 8.5cm  Volume:250ml    Weight:290g",
    description_jpn:
      "人気のティーポットとマグ(SS)のペアセットです。 【ティーポット】 縦×横(取手込)：12.5×20cm     高さ：11.5cm     容量：600ml     重量：610g 【マグ(SS)】     縦×横(取手込)：9×12cm     高さ：8.5cm     容量：250ml x2     重量：290g x2 対応機器 直火 IH 電子レンジ オーブン 食器洗い機 冷蔵・冷凍 圧力なべ 蒸し器 その他 熱源なし",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_69017001780013.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "366",
    brand: "Le Creuset",
    sku: "69017002960040",
    product_eng: "Le Creuset Teapot&mug (ss x 2) White Luster",
    product_jpn:
      "Le Creuset ル・クルーゼ ティーポット&マグ(SS)2個入り ホワイトラスター",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥9,500",
    rrp_with_vat: "¥10,450",
    description_eng:
      "Pair set of popular teapot and mug (SS). <Teapot> Height x width (including handle): 12.5 x 20 cm     Height: 11.5cm     Capacity: 600ml     Weight: 610g <Mug (SS)>     Length x Width (with handle): 9 x 12cm     Height: 8.5cm     Capacity: 250ml     Weight: 290g *White Luster and Coastal Blue come in a glossy white bridal gift box.",
    description_jpn:
      "人気のティーポットとマグ(SS)のペアセットです。 【ティーポット】 縦×横(取手込)：12.5×20cm     高さ：11.5cm     容量：600ml     重量：610g 【マグ(SS)】     縦×横(取手込)：9×12cm     高さ：8.5cm     容量：250ml     重量：290g ※｢ホワイトラスター｣｢コースタルブルー｣は光沢のある白いブライダルギフトボックス入りです。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_69017002960040.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "367",
    brand: "Le Creuset",
    sku: "69017004200040",
    product_eng: "Le Creuset Teapot&mug (ss x 2) Coastal Blue",
    product_jpn:
      "Le Creuset ル・クルーゼ ティーポット&マグ(SS)2個入り コースタルブルー",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥9,500",
    rrp_with_vat: "¥10,450",
    description_eng:
      "Pair set of popular teapot and mug (SS). <Teapot> Height x width (including handle): 12.5 x 20 cm     Height: 11.5cm     Capacity: 600ml     Weight: 610g <Mug (SS)>     Length x Width (with handle): 9 x 12cm     Height: 8.5cm     Capacity: 250ml     Weight: 290g *White Luster and Coastal Blue come in a glossy white bridal gift box.",
    description_jpn:
      "人気のティーポットとマグ(SS)のペアセットです。 【ティーポット】 縦×横(取手込)：12.5×20cm     高さ：11.5cm     容量：600ml     重量：610g 【マグ(SS)】     縦×横(取手込)：9×12cm     高さ：8.5cm     容量：250ml     重量：290g ※｢ホワイトラスター｣｢コースタルブルー｣は光沢のある白いブライダルギフトボックス入りです。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/le_creuset/Lecreuset_69017004200040.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/le-creuset.png",
  },
  {
    id: "368",
    brand: "De'Longhi",
    sku: "ECP3220J-BK",
    product_eng: "De'Longhi ACTIVE espresso&cappuccino maker",
    product_jpn:
      "De'Longhi デロンギ アクティブ エスプレッソ＆カプチーノメーカー",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥25,273",
    rrp_with_vat: "¥27,800",
    description_eng:
      "Pump-type espresso machine with a focus on design and quality  A cafe pod that is made by pressing and packing pre-ground espresso beans in an ideal amount and pressure. Comes with a special filter specializing in extraction with cafe pods, so you can easily enjoy espresso. A powder filter is also included. You can extract up to 2 cups at the same time. For floss milk and steam milk, which are indispensable for cappuccino and latte, anyone can make fine and smooth foam without the need for tips with the high-performance steam nozzle with a double structure.   The 1.1L water tank can be easily attached and detached from the top for water supply and maintenance. It also has a convenient filter storage that allows you to store accessories inside the main unit.",
    description_jpn:
      "ポンプ式エスプレッソマシン。 二重構造高性能ミルクフロッサーカプチーノやカフェラテに欠かせないフロスミルクやスチームミルクも、二重構造の高性能スチームノズルなら 誰もがコツ要らずでキメ細かいなめらかな泡をお作りいただけます。 取り外し可能な水タンクとフィルター収納1.1Lの水タンクは上面から着脱して簡単に給水及びお手入れができます。また、付属品を本体の中に保管できる便利なフィルター収納を備えています。 コーヒーパウダーだけでなく、44mmカフェポッド対応あらかじめ極細挽きされたエスプレッソ用の豆を理想的な量と圧力で一杯分ずつプレス＆パックされたカフェポッド。 カフェポッドでの抽出に特化した専用フィルターを付属、手軽にエスプレッソが楽しめます。 また、パウダー専用フィルターも付属。2杯まで同時に抽出できます。 業務用マシンと同様のポンプ式抽出で、抽出時気圧はエスプレッソ抽出に最適な圧力＝９気圧を実現内部気圧最大15気圧の電磁ポンプとステンレス製のボイラーで、 美味しいエスプレッソの抽出に最適な圧力＝9気圧（抽出時）と最適な抽出温度＝90℃を作り出します。 幅：210mm 奥行：265mm 高さ：310mm 本体重量：4Kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/DeLonghi_ECP3220J-BK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "369",
    brand: "De'Longhi",
    sku: "ICM12011J-BK",
    product_eng: "De'Longhi ACTIVE filter coffee maker",
    product_jpn: "De'Longhi デロンギ アクティブ ドリップコーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥9,818",
    rrp_with_vat: "¥10,800",
    description_eng:
      "Drip coffee maker for 5 cups. Aroma function that brings out more flavor Close to the hand drip method of dripping while steaming Slowly take time to extract while maximizing the aroma. Paperless filter If you use a paperless filter, you can extract coffee oil without missing it.In addition, it is eco-friendly and economical because it does not require a paper filter. Simple water tank for water supply You can easily supply water to the water tank just by raising the lid. Width 155 x Depth 285 x Height 275",
    description_jpn:
      "５杯用ドリップコーヒーメーカー。 風味を更に引き出すアロマ機能 蒸らしながらドリップするハンドドリップの手法に近く ゆっくり時間をかけてアロマを最大限に引き出しながら抽出します。 ペーパーレスフィルター ペーパーレスフィルターを使えば、コーヒー油分を逃さず抽出が可能なため、 よりアロマを逃さず抽出することができます。 また、紙フィルターが必要ないので、エコで経済的。 給水の簡単な水タンク 蓋を上げるだけで給水タンクに簡単に給水できます。 幅155×奥行285×高さ275",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/DeLonghi_ICM12011J-BK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "370",
    brand: "De'Longhi",
    sku: "COX750J-BK",
    product_eng: "De'Longhi K-mix filter coffee maker",
    product_jpn: "De'Longhi デロンギ ケーミックス ドリップコーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥15,273",
    rrp_with_vat: "¥16,800",
    description_eng:
      "Relax with fragrant drip coffee Aroma switch that brings out more flavor Slowly take time to extract while maximizing the aroma. Stainless filter If you use a stainless steel filter, you can extract coffee oil without missing it.It maximizes the original flavor of coffee. In addition, it is eco-friendly and economical because it does not require a paper filter. Auto-off function With a function to prevent forgetting to turn off the heat insulation plate automatically 40 minutes after extraction. Drop prevention function It is designed to prevent coffee from leaking from the dripper even if the glass jug is moved during brewing. Equipped with shower lip function By supplying hot water from 9 holes, it is possible to extract delicious coffee evenly. Width 190 x Depth 255 x Height 305",
    description_jpn:
      "香り高いドリップコーヒーでくつろぎを  風味を更に引き出すアロマスイッチ 蒸らしながらドリップするハンドドリップの手法に近く ゆっくり時間をかけてアロマを最大限に引き出しながら抽出します。 ステンレスフィルター ステンレスフィルターを使えば、コーヒー油分を逃さず抽出が可能なため、 コーヒー本来の風味を最大限に引き出します。また、紙フィルターが必要ないので、エコで経済的。 オートオフ機能 抽出後40分で保温プレートの電源を自動オフする消し忘れ防止機能付き。 しずく防止機能 抽出中にガラスジャグを動かしても、ドリッパーからコーヒーが漏れにくいように設計されています。 シャワードリップ機能搭載 9つの穴から給湯することで、注ぎムラなく、おいしいコーヒー抽出を可能にします。 コーヒーパウダーにまんべんなくお湯を注げるため、ムラのない味わいを手軽に楽しめます。 幅190×奥行255×高さ305",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/DeLonghi_COX750J-BK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "371",
    brand: "De'Longhi",
    sku: "ICMI011J-BK",
    product_eng: "De'Longhi DISTINTA filter coffee maker",
    product_jpn: "De'Longhi デロンギ ディスティンタ ドリップコーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥20,727",
    rrp_with_vat: "¥22,800",
    description_eng:
      "Drip coffee maker with excellent design and function Titanium coated filter adopted By extracting the coffee oil as it is without missing it, you can enjoy the original taste of coffee. Equipped with aroma mode With intermittent extraction, coffee powder is extracted while steaming like a hand drip.Brings out the aroma of coffee more than in normal mode. Water tank with scale for easy water supply The water tank has a scale for up to 6 cups. You can easily supply the amount you want to brew. Width: 170mm Depth: 230mm Height: 285mm Body weight: 2.2Kg (body)",
    description_jpn:
      "デザインも機能も優れたドリップコーヒーメーカー チタンコートフィルター採用 コーヒー油分を逃さずそのまま抽出することで、コーヒー本来の旨み成分が味わえます。 アロマモード搭載 間欠抽出で、ハンドドリップのようにコーヒー粉を蒸らしながら抽出。 通常モードよりもコーヒーの持つ香りをさらに引き出します。 給水しやすい、目盛付の水タンク 水タンクは最大6杯分の目盛入り。 淹れたい分量を簡単に給水できます。 幅：170mm 奥行：230mm 高さ：285mm 本体重量：2.2Kg(本体)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/DeLonghi_ICMI011J-BK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "372",
    brand: "De'Longhi",
    sku: "KBOE1220J-GY",
    product_eng: "De'Longhi ICONA electric kettle",
    product_jpn: "De'Longhi デロンギ アイコナ 電気湯沸かし器",
    category_1: "Home & Garden",
    category_2: "Smartphone",
    rrp_ex_vat: "¥10,727",
    rrp_with_vat: "¥11,800",
    description_eng:
      "Pour precisely where you want, spill less hot water, and keep it from splashing around.  The first narrow-necked kettle in De'Longhi's history that focuses on ease of pouring and design.  The 1L capacity Icona has a refined De'Longhi design and finish.  ・The 1L capacity kettle is economical, with a minimum capacity of 200mL and a maximum capacity of 1.0L, allowing you to boil as much water as you need, when you need it. ・The water gauge on the handle side allows you to check the amount of water from the outside. Width: 270mm Depth: 170mm Height: 235mm Main unit weight: 1.1Kg (main unit + base)",
    description_jpn:
      "狙ったところに正確に注げ、お湯をこぼしにくく、まわりに飛び散らない。注ぎやすさとデザインにこだわった、デロンギ史上初の細口ケトル。デロンギらしい洗練されたデザインと仕上がりの1L容量のアイコナ。  ・最少200mL～最大1.0L容量で、欲しいときに欲しいだけ沸かして経済的。 ・取っ手側にある水量計で外側から水量を確認できます。 幅：270mm 奥行：170mm 高さ：235mm 本体重量：1.1Kg（本体＋ベース）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/DeLonghi_KBOE1220J-GY.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "373",
    brand: "De'Longhi",
    sku: "EC885J-GY",
    product_eng: "De'Longhi DEDICA ARTE Espresso Cappuccino Machine",
    product_jpn:
      "De'Longhi デロンギ デディカ アルテ エスプレッソ・カプチーノメーカー グレー",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥49,818",
    rrp_with_vat: "¥54,800",
    description_eng:
      "The machine not only provides optimal espresso extraction, but also produces fine and smooth milk foam, allowing you to enjoy latte art to the fullest.   Pump extraction similar to that of commercial machines, with an optimal pressure of 9 atmospheres for espresso extraction. Compatible not only with coffee powder but also with 44mm café pods. The espresso beans are ground very finely in advance and pressed and packed into cafepods for each cup at the ideal volume and pressure. A special filter for espresso extraction is included, making it easy to enjoy espresso.  Stylish design and slim body The slim 15cm wide body can be placed anywhere.  Simple operation with 3 buttons and easy one-touch extraction Simple operation with large buttons for 1 or 2 cups of espresso extraction and switching to steam.  Powerful steam tube for creating ideal milk foam  Dual structure steam tube The stainless steel steam tube is equipped with a plastic tube inside. The exterior is resistant to high temperatures and easy to clean.  Large capacity filter Large-capacity one- and two-cup filters are used to ensure that even shallow-roasted coffee beans can be used to make a full-flavored espresso.  Various Programs 1- and 2-cup fixed quantity settings are available. The machine can be set to brew the perfect amount of espresso at any time, according to the beans used and your preferences. The brewing temperature can be selected from three different levels to suit the season and your tastes. The sleep mode setting reduces unnecessary power consumption.  Fully equipped accessories for a rich barista latte art experience A milk jug and tamper are included as accessories, The milk jug and tamper are included in the package, allowing you to enjoy the barista latte art experience at home right away, whether you are making espresso or cappuccino.  Accessories  Filter holder, 1-cup filter, 2-cup filter, Cafe pod filter, measuring spoon, tamper, milk jug, flosser cleaning pin, water hardness checker, lime remover  Size and weight Main unit size (H x W x D) 305 x 150 x 330 mm Main unit weight 4kg",
    description_jpn:
      "最適なエスプレッソ抽出はもちろん、きめの細かい滑らかなフォームミルクを創り出し、存分にラテアートをお楽しみいただけます。   業務用マシンと同様のポンプ式抽出で、抽出時気圧はエスプレッソ抽出に最適な圧力＝９気圧を実現  コーヒーパウダーだけでなく、44mmカフェポッド対応 あらかじめ極細挽きされたエスプレッソ用の豆を理想的な量と圧力で一杯分ずつプレス＆パックされたカフェポッド。 カフェポッドでの抽出に特化した専用フィルターを付属、手軽にエスプレッソが楽しめます。  スタイリッシュなデザインとスリムなボディ 幅15cmのスリムなボディは置き場所を選びません。  ３つのボタンでシンプルな操作性とワンタッチで簡単定量抽出 1杯/2杯のエスプレッソ抽出も、スチームへの切り替えも、大きなボタンでシンプル操作。  理想的なフォームミルクを創り出すパワフルなスチーム管  二重構造のスチーム管 ステンレス製のスチーム管の内部にプラスチックチューブを備える、「二重構造」を採用。 外装が高温になりにくく、お手入れも簡単。  大容量のフィルター 浅煎りのコーヒー豆でもしっかりとした味のエスプレッソをお楽しみいただける大容量の1杯用・2杯用フィルターを採用しています。  多彩なプログラム 1杯/2杯の定量設定が可能。使用する豆、お好みに合わせて定量設定ができ、いつでも最適なエスプレッソが抽出できます。 抽出温度は3段階から選択可能で、季節や嗜好に合わせてお選びいただけます。 スリープモード設定により無駄な消費電力を抑えてくれます。  リッチなバリスタ・ラテアート体験を提供する充実の付属品 ミルクジャグとタンパーが付属品として同梱されており、 エスプレッソもカプチーノもすぐにご自宅でバリスタ・ラテアート体験をお楽しみいただけます  付属品 \tフィルターホルダー、1杯用フィルター、2杯用フィルター カフェポッド用フィルター、計量スプーン、タンパー、ミルクジャグ フロッサークリーニングピン、水硬度チェッカー、除石灰剤  サイズ・重さ 本体サイズ（高さ×幅×奥行） \t305×150×330mm 本体重量 \t4kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_EC885J-GY.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "374",
    brand: "De'Longhi",
    sku: "BCO410J-B",
    product_eng: "De'Longhi Combi Coffee Maker Black",
    product_jpn: "De'Longhi デロンギ コンビコーヒー ブラック",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥36,182",
    rrp_with_vat: "¥39,800",
    description_eng:
      "Espresso, cappuccino, and drip coffee in one machine.   New steam nozzle makes it easy to make fine, rich, frothy milk. Cappuccinos and café lattes taste much better when made from real milk. The new dual-structure steam nozzle makes it easier than ever to create fine, smooth foam milk. The steam knob can also be easily switched on and off. For cleaning, simply remove the steam nozzle and wash with water.  The 23.8 gold filter ensures that the original flavor of the coffee is extracted without losing it. The gold filter by Elfo of Switzerland, which is used by professional coffee tasters, is used. The mesh part of the filter is double coated. Compared to nylon, metal, paper filters, etc., the gold filter has almost no impurities unique to the filter part, so the original flavor of the coffee can be extracted straight from the filter. Also, since the oil content of the coffee is not filtered out, the aroma and flavor of the coffee can be extracted. Also, it is eco-friendly and economical because it does not require a paper filter.  Delonghi's unique aroma extraction mechanism The Flavor Savor system, patented in the U.S., brings out the aroma of the coffee. The unique filter basket shape allows for longer convection time during drip brewing, which in turn brings out the aroma and richness of the coffee.  Simultaneous drip and espresso extraction Drip coffee and espresso can be brewed at the same time. Milk frothing using the steam function can also be performed during drip brewing. This single machine can simultaneously meet various needs in the home.  Accessories  Tamper: Integrated body, activated carbon filter, ESE holder for cafepods, holder for powder, filter for cafepods, 1-cup filter, 2-cup filter, measuring spoon, gold filter, activated carbon filter case, glass jug (for drip coffee)  Size and weight Main unit size (H x W x D) Approx. 320 x 370 x 295 mm Main unit weight 5.0 kg",
    description_jpn:
      "3つの味を一台で エスプレッソ、カプチーノ、ドリップコーヒーが一台で。   新型スチームノズルで、きめ細かいリッチな泡立ちミルクも簡単に カプチーノやカフェラテは本物のミルクから作る方が断然美味しくできます。 二重構造の新型スチームノズルで、従来よりきめ細かくなめらかなフォームミルクを簡単に作ることができます。 スチームノブもON/OFF切り替えが簡単に。お手入れもスチームノズルを外して水洗いするだけ。  23.8金ゴールドフィルターで、コーヒー本来の風味を逃がさず抽出 プロのコーヒーテイスターも使用しているスイス・エルフォ社のゴールドフィルターを使用。フィルターのメッシュ部に二重塗装されています。 ゴールドはナイロンや金属、ペーパーフィルター等と比べ、フィルター部独特の雑味がほとんど混ざらないため、コーヒー本来の風味をストレートに抽出できます。また、コーヒーの油分をろ過しないのでアロマと旨みをしっかり引き出すことができます。 また、紙フィルターが必要ないのでエコで経済的です。  デロンギ独自のアロマ引き出し機構 米国で特許を取得した「Flavor Savor」システムにより、コーヒーのアロマをより引き出します。このデロンギ独自のフィルターバスケット形状は、ドリップ抽出時に対流時間を長くすることを可能にし、それによりよりコーヒーのアロマとコクを引き出すことが可能です。  ドリップとエスプレッソの同時抽出が可能 ドリップコーヒーとエスプレッソは同時に抽出することができます。 スチーム機能を使ったミルクの泡立て作業も、ドリップ抽出中に行うことができます。 本機1台で、ご家庭内の様々なニーズに同時にお答えすることができます。  付属品  タンパー：本体一体型、活性炭フィルター、カフェポッド用ESEホルダー、パウダー用ホルダー、カフェポッド用フィルター、1杯取りフィルター、2杯取りフィルター、計量スプーン、ゴールドフィルター、活性炭フィルターケース、ガラスジャグ（ドリップコーヒー用）  サイズ・重さ 本体サイズ（高さ×幅×奥行） \t約320×370×295mm 本体重量 \t5.0kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_BCO410J-B.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "375",
    brand: "De'Longhi",
    sku: "BCO410J-W",
    product_eng: "De'Longhi Combi Coffee Maker White",
    product_jpn: "De'Longhi デロンギ コンビコーヒー ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥36,182",
    rrp_with_vat: "¥39,800",
    description_eng:
      "Espresso, cappuccino, and drip coffee in one machine.   New steam nozzle makes it easy to make fine, rich, frothy milk. Cappuccinos and café lattes taste much better when made from real milk. The new dual-structure steam nozzle makes it easier than ever to create fine, smooth foam milk. The steam knob can also be easily switched on and off. For cleaning, simply remove the steam nozzle and wash with water.  The 23.8 gold filter ensures that the original flavor of the coffee is extracted without losing it. The gold filter by Elfo of Switzerland, which is used by professional coffee tasters, is used. The mesh part of the filter is double coated. Compared to nylon, metal, paper filters, etc., the gold filter has almost no impurities unique to the filter part, so the original flavor of the coffee can be extracted straight from the filter. Also, since the oil content of the coffee is not filtered out, the aroma and flavor of the coffee can be extracted. Also, it is eco-friendly and economical because it does not require a paper filter.  Delonghi's unique aroma extraction mechanism The Flavor Savor system, patented in the U.S., brings out the aroma of the coffee. The unique filter basket shape allows for longer convection time during drip brewing, which in turn brings out the aroma and richness of the coffee.  Simultaneous drip and espresso extraction Drip coffee and espresso can be brewed at the same time. Milk frothing using the steam function can also be performed during drip brewing. This single machine can simultaneously meet various needs in the home.  Accessories  Tamper: Integrated body, activated carbon filter, ESE holder for cafepods, holder for powder, filter for cafepods, 1-cup filter, 2-cup filter, measuring spoon, gold filter, activated carbon filter case, glass jug (for drip coffee)  Size and weight Main unit size (H x W x D) Approx. 320 x 370 x 295 mm Main unit weight 5.0 kg",
    description_jpn:
      "3つの味を一台で エスプレッソ、カプチーノ、ドリップコーヒーが一台で。   新型スチームノズルで、きめ細かいリッチな泡立ちミルクも簡単に カプチーノやカフェラテは本物のミルクから作る方が断然美味しくできます。 二重構造の新型スチームノズルで、従来よりきめ細かくなめらかなフォームミルクを簡単に作ることができます。 スチームノブもON/OFF切り替えが簡単に。お手入れもスチームノズルを外して水洗いするだけ。  23.8金ゴールドフィルターで、コーヒー本来の風味を逃がさず抽出 プロのコーヒーテイスターも使用しているスイス・エルフォ社のゴールドフィルターを使用。フィルターのメッシュ部に二重塗装されています。 ゴールドはナイロンや金属、ペーパーフィルター等と比べ、フィルター部独特の雑味がほとんど混ざらないため、コーヒー本来の風味をストレートに抽出できます。また、コーヒーの油分をろ過しないのでアロマと旨みをしっかり引き出すことができます。 また、紙フィルターが必要ないのでエコで経済的です。  デロンギ独自のアロマ引き出し機構 米国で特許を取得した「Flavor Savor」システムにより、コーヒーのアロマをより引き出します。このデロンギ独自のフィルターバスケット形状は、ドリップ抽出時に対流時間を長くすることを可能にし、それによりよりコーヒーのアロマとコクを引き出すことが可能です。  ドリップとエスプレッソの同時抽出が可能 ドリップコーヒーとエスプレッソは同時に抽出することができます。 スチーム機能を使ったミルクの泡立て作業も、ドリップ抽出中に行うことができます。 本機1台で、ご家庭内の様々なニーズに同時にお答えすることができます。  付属品  タンパー：本体一体型、活性炭フィルター、カフェポッド用ESEホルダー、パウダー用ホルダー、カフェポッド用フィルター、1杯取りフィルター、2杯取りフィルター、計量スプーン、ゴールドフィルター、活性炭フィルターケース、ガラスジャグ（ドリップコーヒー用）  サイズ・重さ 本体サイズ（高さ×幅×奥行） \t約320×370×295mm 本体重量 \t5.0kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_BCO410J-W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "376",
    brand: "De'Longhi",
    sku: "ICM17270J",
    product_eng: "De'Longhi CLESSIDRA Drip Coffee Maker",
    product_jpn: "De'Longhi デロンギ クレシドラ ドリップコーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥27,091",
    rrp_with_vat: "¥29,800",
    description_eng:
      " Unique exterior design that conveys elegance and lightness like an hourglass The straight design, in which water is heated in the upper water tank and poured directly into the coffee powder, makes the coffee brewing process look like the ticking of an hourglass, which is the styling concept of the coffee brewer.  ECBC certified mode High-definition extraction technology brings out the optimal taste of coffee and has been certified by the European Coffee Brewing Institute (ECBC). Precise control of extraction temperature (92-96°C) and extraction time ensures perfect coffee.  Iced Coffee Mode The unique Iced Coffee Mode carefully brews coffee based on ECBC (European Coffee Brewing Institute) certified design. The coffee is brewed thickly while steeping, and then cooled rapidly with ice to brew aromatic and rich iced coffee.  Pour Over Mode Steaming extraction reproduces hand drip brewing in the machine. The specially designed hot water outlet and extraction control allows you to brew aromatic and deep coffee with a single touch.  Warming plate The warming plate maintains the temperature of the coffee. The energy-saving design automatically turns off the power 40 minutes after extraction is complete.  Accessories \t Measuring spoon, 5 paper filters  Main unit size: W190 x D285 x H335 (mm)  Main unit weight: 2.5 kg (including glass jug)",
    description_jpn:
      " 砂時計のように優美さと軽やかさを伝える独創的な外観デザイン 上部の水タンクにて湯沸かしし直接コーヒー粉に注ぐストレート構造は、コーヒーを淹れる工程を、スタイリングコンセプトである砂時計で時を刻むかのように魅せる演出と  ECBC認証モード 高精細な抽出テクノロジーにより、コーヒーの最適な味を引き出し、ヨーロッパ コーヒー抽出研究所（ECBC）の認証を取得。抽出温度（92-96℃）や抽出時間の精密なコントロールにより、パーフェクトなコーヒーを実現します。  アイスコーヒーモード ECBC（ヨーロッパ コーヒー抽出研究所）認証設計に基づいて丁寧に抽出する独自の「アイスコーヒーモード」。蒸らしながら濃いめに抽出したコーヒーを氷で急冷することで、香り高くコクのあるアイスコーヒーが淹れられます。  プアオーバーモード ハンドドリップをマシンで再現した蒸らし抽出。特別に設計された形状の給湯口と抽出制御により、ワンタッチで香り高く深みのあるコーヒーが淹れられます。  保温プレート 保温プレートでコーヒーの温度をしっかり保ちます。抽出完了後40分で自動的に電源OFFにする省エネ設計。  付属品 \t 計量スプーン、ペーパーフィルター×5枚  本体サイズ：W190×D285×H335（mm）  本体重量：2.5kg（ガラスジャグ含む）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_ICM17270J.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "377",
    brand: "De'Longhi",
    sku: "ICMI011J-W",
    product_eng: "De'Longhi DISTINTA filter coffee maker White",
    product_jpn:
      "De'Longhi デロンギ ディスティンタ ドリップコーヒーメーカー ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥20,727",
    rrp_with_vat: "¥22,800",
    description_eng:
      "Drip coffee maker with excellent design and function Titanium coated filter adopted By extracting the coffee oil as it is without missing it, you can enjoy the original taste of coffee. Equipped with aroma mode With intermittent extraction, coffee powder is extracted while steaming like a hand drip.Brings out the aroma of coffee more than in normal mode. Water tank with scale for easy water supply The water tank has a scale for up to 6 cups. You can easily supply the amount you want to brew. Width: 170mm Depth: 230mm Height: 285mm Body weight: 2.2Kg (body)",
    description_jpn:
      "デザインも機能も優れたドリップコーヒーメーカー チタンコートフィルター採用 コーヒー油分を逃さずそのまま抽出することで、コーヒー本来の旨み成分が味わえます。 アロマモード搭載 間欠抽出で、ハンドドリップのようにコーヒー粉を蒸らしながら抽出。 通常モードよりもコーヒーの持つ香りをさらに引き出します。 給水しやすい、目盛付の水タンク 水タンクは最大6杯分の目盛入り。 淹れたい分量を簡単に給水できます。 幅：170mm 奥行：230mm 高さ：285mm 本体重量：2.2Kg(本体)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_ICMI011J-W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "378",
    brand: "De'Longhi",
    sku: "KG521J-M",
    product_eng: "De'Longhi DEDICA Coffee Grinder",
    product_jpn: "De'Longhi デロンギ デディカ コーン式 コーヒーグラインダー",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥27,091",
    rrp_with_vat: "¥29,800",
    description_eng:
      " Adoption of cone-type coffee grinder   The cone type grinder (2 blades) grinds coffee beans evenly.   High performance reduction (low speed rotation) motor minimizes frictional heat when grinding beans.   This allows the volatile coffee aroma to remain intact and the flavor to be preserved.  16-step fine grind setting   The 16-step grind setting is available in four stages: extra-fine, fine, medium-fine, and medium grind.   You can select your preferred grind level, such as for espresso, drip, or nerd drip.  Cups dial to grind as many cups as you want in no time   The amount of coffee beans to be ground can be selected from 1 to 12 cups.  Large capacity container   A convenient removable container that can hold approximately 110 g of medium ground coffee powder.  Large capacity bean hopper   A large-capacity bean hopper with a capacity of 310 g (60 g more than the previous model) is installed. The large diameter hopper makes it easy to refill the hopper with beans.  Power cord storage   The power cord can be stored in the bottom of the machine for compact and neat storage.  Easy to clean   The upper grinding blade can be removed for easy cleaning with the included cleaning brush.  Safety lock function   Safety lock function prevents operation unless the hopper is in place.  Dimensions: W135XD195XH290(mm)  Main unit weight: 1.6kg",
    description_jpn:
      " コーン式コーヒーグラインダー採用   コーン式挽き刃(2枚構成)により、豆を均一に挽くことができます。   高性能リダクション(低速回転)モーターの採用で、豆を挽く時の摩擦熱を最小限に抑えます。   これにより、揮発性のコーヒーアロマを損なわず風味を保つことができます。  16段階のきめ細かな粒度設定   極細挽き、細挽き、中細挽き、中挽きと4つのステージで16段階の粒度設定が可能です。   エスプレッソ、ドリップ、ネルドリップ用など、お好みの挽き具合を選択できます。  挽きたい分だけすぐに挽ける杯数ダイヤル   コーヒー豆を挽く量を、1～12杯分の間で杯数選択ができます。  大容量コンテナ   中挽きコーヒー粉が約110g入る便利な着脱式コンテナを採用。  大容量豆ホッパー   310g大容量豆ホッパー(従来モデル比60g増)を搭載。口径も大きく豆の補充も簡単。  電源コード収納   電源コードは底部に収納できるため、コンパクトにすっきり収めることができます。  お手入れ簡単   上部挽き刃は取り外しできるので、付属のクリーニングブラシで簡単にお手入れができます。  安全ロック機能   ホッパーが所定の位置に装着されていないと作動しない、安全ロック機能。  本体寸法：W135XD195XH290(mm)  本体重量：1.6kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_KG521J-M.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "379",
    brand: "De'Longhi",
    sku: "ECP3220J-W",
    product_eng: "De'Longhi ACTIVE espresso&cappuccino maker",
    product_jpn:
      "De'Longhi デロンギ アクティブ エスプレッソ＆カプチーノメーカー",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥25,273",
    rrp_with_vat: "¥27,800",
    description_eng:
      "Pump-type espresso machine with a focus on design and quality  A cafe pod that is made by pressing and packing pre-ground espresso beans in an ideal amount and pressure. Comes with a special filter specializing in extraction with cafe pods, so you can easily enjoy espresso. A powder filter is also included. You can extract up to 2 cups at the same time. For floss milk and steam milk, which are indispensable for cappuccino and latte, anyone can make fine and smooth foam without the need for tips with the high-performance steam nozzle with a double structure.   The 1.1L water tank can be easily attached and detached from the top for water supply and maintenance. It also has a convenient filter storage that allows you to store accessories inside the main unit.",
    description_jpn:
      "ポンプ式エスプレッソマシン。 二重構造高性能ミルクフロッサーカプチーノやカフェラテに欠かせないフロスミルクやスチームミルクも、二重構造の高性能スチームノズルなら 誰もがコツ要らずでキメ細かいなめらかな泡をお作りいただけます。 取り外し可能な水タンクとフィルター収納1.1Lの水タンクは上面から着脱して簡単に給水及びお手入れができます。また、付属品を本体の中に保管できる便利なフィルター収納を備えています。 コーヒーパウダーだけでなく、44mmカフェポッド対応あらかじめ極細挽きされたエスプレッソ用の豆を理想的な量と圧力で一杯分ずつプレス＆パックされたカフェポッド。 カフェポッドでの抽出に特化した専用フィルターを付属、手軽にエスプレッソが楽しめます。 また、パウダー専用フィルターも付属。2杯まで同時に抽出できます。 業務用マシンと同様のポンプ式抽出で、抽出時気圧はエスプレッソ抽出に最適な圧力＝９気圧を実現内部気圧最大15気圧の電磁ポンプとステンレス製のボイラーで、 美味しいエスプレッソの抽出に最適な圧力＝9気圧（抽出時）と最適な抽出温度＝90℃を作り出します。 幅：210mm 奥行：265mm 高さ：310mm 本体重量：4Kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_ECP3220J-W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "380",
    brand: "De'Longhi",
    sku: "EC235J-BK",
    product_eng: "De'Longhi STILOSA Espresso Cappuccino Machine",
    product_jpn:
      "De'Longhi デロンギ  スティローザ エスプレッソ ・カプチーノメーカー",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥18,000",
    rrp_with_vat: "¥19,800",
    description_eng:
      "STILOSA is named after the Italian word for stylish. This entry-level model has a simple, stylish exterior design and is easy to use. Equipped with a milk frother (frothing function), it can also be used for cappuccino and other milk menus.   Authentic espresso extraction The heart of the espresso maker is essential for espresso extraction. The optimal pressure (9 atmospheres) and temperature (90°C) for extracting delicious espresso are realized. Enjoy aromatic and authentic espresso every day at home. Compatible not only with coffee powder but also with café pods Two types of filters for coffee powder and café pods are included. -One filter holder -1 filter for 1 cup/cafe pod* x 1 -One 2-cup filter -1 tamper/measuring spoon   ※Compatible with E.S.E (Easy Serving Espresso) standard café pods.   Flosser (milk frothing function) A stainless steel milk frother is equipped and can be fine-tuned to suit menus and personal preferences. The high temperature steam jet from the frother nozzle froths milk or soy milk to a delicious froth.   Removable cup holder The cup holder is detachable, so it can be conveniently removed if you want to use large, tall cups. The cup holder and the tray underneath are also removable for easy cleaning.   Easy-to-clean water tank The water tank, with a maximum capacity of 1L, is removable for easy daily cleaning during water supply and cleaning.  Dimensions (mm): W 210 x D 265 x H 300 Body weight (kg): 3.2 Color: Black Power cord length (m): 2.0 Voltage/frequency: AC100V/50-60Hz Power consumption (W): 1100 Pump pressure (bar): 15 Extraction pressure (bar): 9 Water tank capacity (espresso) (L): 1.0",
    description_jpn:
      "イタリア語でスタイリッシュという名を持つ「スティローザ」。 シンプルでスタイリッシュな外観デザインと使いやすいエントリーモデル。 ミルクフロッサー（泡立て機能）を搭載し、カプチーノなどのミルクメニューも楽しめます。   本格エスプレッソ抽出 エスプレッソ抽出に不可欠なエスプレッソメーカーの心臓部。おいしいエスプレッソの抽出に最適な圧力＝９気圧と最適な温度＝90度を実現しています。香り豊かで本格的なエスプレッソをお家で毎日たのしめます。 caldaia_INOX_EC235J.BKDx_178.jpg コーヒーパウダーだけでなく、カフェポッドにも対応 コーヒーパウダーおよびカフェポッドに 対応した2種類のフィルターが付属されています。  ・フィルターホルダー x1本 ・1杯/カフェポッド*用フィルター x1個 ・2杯用フィルター x１個 ・タンパー/計量スプーン x1本  ※E.S.E (Easy Serving Espresso）規格のカフェポッドに対応しています。   フロッサー（ミルク泡立て機能） ステンレス製のミルクフロッサーを搭載し、メニューやお好みに合わせて微調整も可能です。フロッサーノズルから噴射される高温スチームで牛乳や豆乳を美味しく泡立てます。   取り外し可能なカップ受け カップ受け部分が着脱式となっているため、高さのある大き目のカップを使用したい場合は、取り外すことが出来て便利です。 カップ受けおよびその下のトレイも着脱式なので洗浄などお手入れも簡単です。   お手入れ簡単水タンク 最大容量1Lの水タンクは、着脱式なので給水時や洗浄時など日々のお手入れも簡単です。  外形寸法（mm）:\t幅210×奥行265×高さ300 本体質量（kg）:\t3.2 色:\tブラック 電源コードの長さ（m）:\t2.0 電圧/周波数:\tAC100V／50-60Hz 消費電力（W）:\t1100 ポンプ圧（気圧）:\t15 抽出気圧（気圧）:\t9 給水タンク容量（エスプレッソ）（L）:\t1.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_EC235J-BK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "381",
    brand: "De'Longhi",
    sku: "KBOE1220J-W",
    product_eng: "De'Longhi ICONA electric kettle White",
    product_jpn: "De'Longhi デロンギ アイコナ 電気湯沸かし器 ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥10,727",
    rrp_with_vat: "¥11,800",
    description_eng:
      "Pour precisely where you want, spill less hot water, and keep it from splashing around.  The first narrow-necked kettle in De'Longhi's history that focuses on ease of pouring and design.  The 1L capacity Icona has a refined De'Longhi design and finish.  ・The 1L capacity kettle is economical, with a minimum capacity of 200mL and a maximum capacity of 1.0L, allowing you to boil as much water as you need, when you need it. ・The water gauge on the handle side allows you to check the amount of water from the outside. Width: 270mm Depth: 170mm Height: 235mm Main unit weight: 1.1Kg (main unit + base)",
    description_jpn:
      "狙ったところに正確に注げ、お湯をこぼしにくく、まわりに飛び散らない。注ぎやすさとデザインにこだわった、デロンギ史上初の細口ケトル。デロンギらしい洗練されたデザインと仕上がりの1L容量のアイコナ。  ・最少200mL～最大1.0L容量で、欲しいときに欲しいだけ沸かして経済的。 ・取っ手側にある水量計で外側から水量を確認できます。 幅：270mm 奥行：170mm 高さ：235mm 本体重量：1.1Kg（本体＋ベース）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_KBOE1220J-W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "382",
    brand: "De'Longhi",
    sku: "KBOC1200J-Y",
    product_eng: "De'Longhi ICONA CAPITALS electric kettle New York Yellow",
    product_jpn:
      "De'Longhi デロンギ  アイコナ・キャピタルズ 電気ケトル ニューヨークイエロー ",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥10,727",
    rrp_with_vat: "¥11,800",
    description_eng:
      "Retro form combined with urban essence    Metal body that combines luxury, durability, and robustness  Stainless steel is used for the main body, providing both a luxurious feel and durability.  Automatic power off and anti-drying function  When the kettle is empty or low on water, the power is automatically turned off to prevent emptying.  Easy-to-use, easy-to-read water gauge  Compact, yet just the right size for a family with a 1.0L capacity  Economical with a minimum capacity of 200 ml and a maximum capacity of 1 L, allowing you to boil as much water as you need, when you need it.  Easy to clean The wide spout makes it easy to clean the inside of the kettle.  Power cord holder The power cord can be wrapped around the holder when the kettle is not in use.  Dimensions 210mm (width) x 165mm (depth) x 235mm (height) (main unit + base) Main unit weight 1.1kg (main unit + base) Power consumption 1200W Voltage/Frequency AC100V/50-60Hz Power cord length 1.3m Capacity (max) 1L",
    description_jpn:
      "レトロなフォルムに都会的なエッセンスを合わせたデザイン    高級感と耐久性・堅牢性を兼ね備えたメタルボディ  本体にはステンレスを使用し、高級感と耐久性を兼ね備えています。  自動電源オフ、空だき防止機能  ケトル内が空または水が少ない状態になったら、自動的に電源が切れて空だきを防止します。  使いやすく見やすい水量計  コンパクトながら容量1.0Lと家族にちょうど良いサイズ  最小200ml〜最大1L容量で、欲しいときに欲しいだけ沸かして経済的  お手入れ簡単 注水口も広いため中まで簡単にお手入れできます。  電源コードホルダー ケトルを使用しない時、電源コードをホルダーに巻き付けられます。  外形寸法 幅210mm×奥行き165mm×高さ235mm （本体＋ベース） 本体質量 1.1kg（本体＋ベース） 消費電力 1200W 電圧/周波数 AC100V/50-60Hz 電源コードの長さ 1.3m 容量（最大） 1L",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_KBOC1200J-Y.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "383",
    brand: "De'Longhi",
    sku: "KBOC1200J-R",
    product_eng: "De'Longhi ICONA CAPITALS electric kettle Tokyo Red",
    product_jpn:
      "De'Longhi デロンギ  アイコナ・キャピタルズ 電気ケトル トーキョーレッド",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥10,727",
    rrp_with_vat: "¥11,800",
    description_eng:
      "Retro form combined with urban essence    Metal body that combines luxury, durability, and robustness  Stainless steel is used for the main body, providing both a luxurious feel and durability.  Automatic power off and anti-drying function  When the kettle is empty or low on water, the power is automatically turned off to prevent emptying.  Easy-to-use, easy-to-read water gauge  Compact, yet just the right size for a family with a 1.0L capacity  Economical with a minimum capacity of 200 ml and a maximum capacity of 1 L, allowing you to boil as much water as you need, when you need it.  Easy to clean The wide spout makes it easy to clean the inside of the kettle.  Power cord holder The power cord can be wrapped around the holder when the kettle is not in use.  Dimensions 210mm (width) x 165mm (depth) x 235mm (height) (main unit + base) Main unit weight 1.1kg (main unit + base) Power consumption 1200W Voltage/Frequency AC100V/50-60Hz Power cord length 1.3m Capacity (max) 1L",
    description_jpn:
      "レトロなフォルムに都会的なエッセンスを合わせたデザイン    高級感と耐久性・堅牢性を兼ね備えたメタルボディ  本体にはステンレスを使用し、高級感と耐久性を兼ね備えています。  自動電源オフ、空だき防止機能  ケトル内が空または水が少ない状態になったら、自動的に電源が切れて空だきを防止します。  使いやすく見やすい水量計  コンパクトながら容量1.0Lと家族にちょうど良いサイズ  最小200ml〜最大1L容量で、欲しいときに欲しいだけ沸かして経済的  お手入れ簡単 注水口も広いため中まで簡単にお手入れできます。  電源コードホルダー ケトルを使用しない時、電源コードをホルダーに巻き付けられます。  外形寸法 幅210mm×奥行き165mm×高さ235mm （本体＋ベース） 本体質量 1.1kg（本体＋ベース） 消費電力 1200W 電圧/周波数 AC100V/50-60Hz 電源コードの長さ 1.3m 容量（最大） 1L",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_KBOC1200J-R.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "384",
    brand: "De'Longhi",
    sku: "EO90155J-W",
    product_eng: "De'Longhi ICONA SFORNATUTTO EVO Convection Ovens",
    product_jpn:
      "De'Longhi デロンギ  スフォルナトゥット・イーヴォ ミニコンベクションオーブン",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥20,727",
    rrp_with_vat: "¥22,800",
    description_eng:
      "Compact yet powerful. Surround convection system maximizes convection functionality. Hot air is spread to every corner of the oven for even and delicious baking.  1.Surround Convection System maximizes convection function A new fan circulates hot air to every corner of the oven, and a new fan cover increases air flow inside the oven by 40%*. Furthermore, the double-layered structure keeps the heat in to ensure even and delicious baking. (*Compared with our conventional products) 2. 2.Simple and easy operation Select the cooking mode with the button and set the cooking temperature with the temperature dial. Then, simply turn the timer dial to start cooking in no time. Preheating starts up quickly and is easy to use. 3.Compact yet spacious interior Despite its compact appearance, the 8.5L capacity inside the cabinet is spacious. Four slices of bread can be baked at the same time.  External Dimensions Width 440mm x Depth 355mm x Height 225mm Inner dimensions Width 265mm x Depth 245mm x Height 115mm [between upper and lower heaters]. Main unit weight 5.5Kg (main unit only) Power consumption 1400W Voltage/Frequency 100V/50-60Hz Power cord length 2.1m",
    description_jpn:
      "コンパクトなのにパワフル。コンベクション機能を最大限に引き出すサラウンドコンベクションシステム搭載。 熱風が庫内の隅々まで行き渡り、ムラなくおいしく焼きあがる、コンパクトなのに頼れる失敗知らずのコンベクションオーブン。  １．コンベクション機能を最大限引き出す、サラウンドコンベクションシステム 熱風を庫内の隅々まで循環させる新型ファンに、庫内の空気流量が40％※UPした新型ファンカバー。 さらに、熱を逃さない二重構造で、ムラなく美味しく焼き上げます。 ※従来品との当社比較 ２．シンプルで簡単な操作 調理モードをボタンで選択し、温度ダイヤルで調理温度を設定。 後は、タイマーダイヤルを回すだけであっという間に調理開始。 予熱の立ち上がりも早く、使い勝手に困りません。 ３．コンパクトなのに庫内ひろびろ コンパクトな見た目ながら、庫内容量は8.5Lとひろびろ。食パンが４枚同時に焼けます。  外形寸法 幅440mmx奥行355mmx高さ225mm 庫内寸法 幅265mmx奥行245mmx高さ115mm[上下ヒーター間] 本体質量 5.5Kg(本体のみ) 消費電力 1400W 電圧／周波数 100V/50-60Hz 電源コードの長さ 2.1m",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_EO90155J-W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "385",
    brand: "De'Longhi",
    sku: "EOI408J-PK",
    product_eng: "De'Longhi DISTINTA PERLA Collection Toaster Oven Pink",
    product_jpn:
      "De'Longhi デロンギ  ディスティンタ・ペルラ コレクション オーブン＆トースターピンク",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥19,818",
    rrp_with_vat: "¥21,800",
    description_eng:
      "Oven & Toaster combines the authentic functionality of an oven with the convenience of a toaster  ①Equipped with an M-shaped sheathed heater for even baking! The M-shaped sheathed heater distributes heat throughout the oven to bake 4 slices of bread at the same time, evenly and crispily. ➁Oven & Toaster with 8.5L compact size and spacious interior Despite its compact size of 8.5L, detailed temperature setting and control are possible. It is useful not only for toasting, but also for slow-cooking oven dishes and pastries. ➂3 simple operations Simple dial-type controls make cooking easy. Three cooking functions (oven, grill, and keep warm), temperature settings up to 220°C, and a 45-minute timer allow you to enjoy a wide range of cooking. The inside of the oven can be kept at approximately 60-70°C, allowing food to be kept warm.  External dimensions (mm) Width 435 mm × Depth 345 mm × Height 220 mm Effective internal dimensions (mm) Width 265 mm × Depth 245 mm × Height 115 mm Between upper and lower heaters Main unit weight (kg) 5.2kg (main unit only) Inner capacity 8.5L Power cord length 2m Power consumption 1200W Voltage/Frequency AC100V/50/60Hz",
    description_jpn:
      "オーブンの本格機能とトースターの手軽さを兼ね備えたオーブン&トースター  ①Ｍ字型シーズヒーター搭載でムラなく焼ける！ 庫内に熱をいきわたらせることができ、パンを同時に4枚、カリッとムラなく焼き上げます。 ➁8.5Lのコンパクトサイズ、庫内広々のオーブン&トースター 8.5Lのコンパクトサイズながら、細かな温度設定やコントロールが可能。トーストはもちろん、じっくり火を通す本格オーブン料理やお菓子にも活躍。 ➂３つのシンプル操作 ダイヤル式のシンプル操作でラクラク調理を実現。オーブン、グリル、保温の3つの調理機能、220℃までの温度設定と45分のタイマーにより幅広い料理作りが楽しめます。また、庫内を約60-70℃に保てるため、料理の保温も可能です。  外形寸法(mm) 幅435㎜ × 奥行345㎜ × 高さ220㎜ 庫内有効寸法(mm) 幅265㎜ × 奥行245㎜ × 高さ115㎜ ※上下ヒーター間 本体質量(kg) 5.2kg(本体のみ） 庫内容量 8.5L 電源コードの長さ 2m 消費電力 1200W 電圧／周波数 AC100V／50/60Hz",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_EOI408J-PK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "386",
    brand: "De'Longhi",
    sku: "EOI408J-S",
    product_eng: "De'Longhi DISTINTA PERLA Collection Toaster Oven Silver",
    product_jpn:
      "De'Longhi デロンギ  ディスティンタ・ペルラ コレクション オーブン＆トースターシルバー",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥19,818",
    rrp_with_vat: "¥21,800",
    description_eng:
      "Oven & Toaster combines the authentic functionality of an oven with the convenience of a toaster  ①Equipped with an M-shaped sheathed heater for even baking! The M-shaped sheathed heater distributes heat throughout the oven to bake 4 slices of bread at the same time, evenly and crispily. ➁Oven & Toaster with 8.5L compact size and spacious interior Despite its compact size of 8.5L, detailed temperature setting and control are possible. It is useful not only for toasting, but also for slow-cooking oven dishes and pastries. ➂3 simple operations Simple dial-type controls make cooking easy. Three cooking functions (oven, grill, and keep warm), temperature settings up to 220°C, and a 45-minute timer allow you to enjoy a wide range of cooking. The inside of the oven can be kept at approximately 60-70°C, allowing food to be kept warm.  External dimensions (mm) Width 435 mm × Depth 345 mm × Height 220 mm Effective internal dimensions (mm) Width 265 mm × Depth 245 mm × Height 115 mm Between upper and lower heaters Main unit weight (kg) 5.2kg (main unit only) Inner capacity 8.5L Power cord length 2m Power consumption 1200W Voltage/Frequency AC100V/50/60Hz",
    description_jpn:
      "オーブンの本格機能とトースターの手軽さを兼ね備えたオーブン&トースター  ①Ｍ字型シーズヒーター搭載でムラなく焼ける！ 庫内に熱をいきわたらせることができ、パンを同時に4枚、カリッとムラなく焼き上げます。 ➁8.5Lのコンパクトサイズ、庫内広々のオーブン&トースター 8.5Lのコンパクトサイズながら、細かな温度設定やコントロールが可能。トーストはもちろん、じっくり火を通す本格オーブン料理やお菓子にも活躍。 ➂３つのシンプル操作 ダイヤル式のシンプル操作でラクラク調理を実現。オーブン、グリル、保温の3つの調理機能、220℃までの温度設定と45分のタイマーにより幅広い料理作りが楽しめます。また、庫内を約60-70℃に保てるため、料理の保温も可能です。  外形寸法(mm) 幅435㎜ × 奥行345㎜ × 高さ220㎜ 庫内有効寸法(mm) 幅265㎜ × 奥行245㎜ × 高さ115㎜ ※上下ヒーター間 本体質量(kg) 5.2kg(本体のみ） 庫内容量 8.5L 電源コードの長さ 2m 消費電力 1200W 電圧／周波数 AC100V／50/60Hz",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/Delonghi_EOI408J-S.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "387",
    brand: "Tanita",
    sku: "TT-575",
    product_eng: "Tanita Digital Thermometer/Hygrometer",
    product_jpn: "Tanita タニタ デジタル温湿度計 ",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,200",
    description_eng:
      "Simple design that can be used anywhere. -A neat, thin and compact size with a thickness of 12 mm! ・ With magnet and stand ・ With record high / minimum temperature / humidity display function ・ With clock / date display function Product dimensions Width 85mm x Height 55mm x Depth 12mm Body weight approx. 46g (including batteries)",
    description_jpn:
      "場所を選ばないシンプルなデザイン。 ・厚さ12mmのスッキリした薄型コンパクトサイズ！ ・マグネット、スタンド付き ・過去の最高・最低温湿度表示機能付き ・時計/日付表示機能付き 商品寸法 \t幅 85mm ×  高さ 55mm ×  奥行 12mm 本体質量 \t約 46g(電池含む)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/tanita/Tanita_TT-575.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/tanita.png",
  },
  {
    id: "388",
    brand: "Tanita",
    sku: "KW-201",
    product_eng: "Tanita Washable Digital Cooking Scale ",
    product_jpn: "Tanita タニタ 洗えるクッキングスケール",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "It is waterproof (IP65 *) and can be washed completely, so even if you use it with dirty hands while cooking or your child gets dirty with powder, you can wash it immediately and keep it clean and clean at any time. It is a hygienic and safe cooking scale. The reaction is quick until the weight is displayed, and the screen display changes smoothly, so you can prevent overfilling of ingredients when adding flour or milk little by little. ・ Auto power off function (about 6 minutes) ・ 0 display function (additional weighing function) -With a hook hole that can be hung quickly and is convenient for storage ・ With non-slip silicone rubber legs Product dimensions Width 122mm x Height 39mm x Depth 194mm (Weighing pan: Approx. Width 120 x Depth 125mm) Body mass approx. 383g (including batteries)",
    description_jpn:
      "食器用洗剤で丸洗いできる！ 防水仕様（IP65※）で丸洗いができるから、料理中に汚れた手で使っても、お子さまが粉などで汚してしまっても、すぐに洗えて、いつでも簡単に清潔・キレイな状態に。衛生的にも安心なクッキングスケールです。 重さが表示されるまでの反応がはやく、画面表示もスムーズに変化するので、小麦粉や牛乳などを少しずつ足す際にも材料の入れすぎを防げます。 ・オートパワーオフ機能(約6分) ・0表示機能(追加計量機能) ・サッと掛けられる、収納に便利なフック穴付 ・滑りにくいシリコーンゴム脚付  商品寸法 \t幅 122mm ×  高さ 39mm ×  奥行 194mm (計量皿：約 幅120×奥行125mm) 本体質量 \t約 383g(乾電池含む)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/tanita/Tanita_KW-201.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/tanita.png",
  },
  {
    id: "909",
    brand: "Samsonite",
    sku: "QA7-09001",
    product_eng: "Samsonite LITE-FRAME 55cm Black",
    product_jpn: "Samsonite サムソナイト ライトフレーム 55 ブラック",
    category_1: "Travel",
    category_2: "Suitcases",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      '・A lightweight, tough frame case with a unique and innovative one-touch locking system. ・The newly developed "one-click multi-locking system" makes it easy to lock the case by simply locking one position. ・The frame is made of injection-molded ABS material for light weight. ・Aero-Trac™ suspension wheels absorb shocks for a smooth and stable ride. ・The interior has zippered dividers on both sides to prevent cargo collapse, and four pockets. ・The interior fabric is made of Recyclex™, a recycled material with an anti-bacterial finish. ・Carry-on size. ・Recommended for domestic travel by Shinkansen bullet trains, trains, etc., and for short-term business trips. <Specifications> Material: Polycarbonate Size 55.0 x 39.0 x 21.0 cm Capacity: 38L Weight: 3.5 kg',
    description_jpn:
      "・ワンタッチで開閉可能なユニークで革新的なロックシステムを搭載した軽量でタフなフレームケース。 ・ 新開発の“ワンクリックマルチロッキングシステム”により、1か所をロックするだけで簡単に施錠できます。 ・ フレームに射出成型したABS素材を採用し、軽量化を実現。 ・ Aero-Trac™サスペンションホイールにより、衝撃を吸収してスムーズで安定した走行性を発揮。 ・ 内装両面には荷崩れ防止のファスナー付きディバイダーが付属し、4か所のポケットを備えている。 ・ 内装生地には抗菌加工と再生素材Recyclex™を使用。 ・機内持ち込み対応サイズ。 ・新幹線・電車等で移動する国内旅行や短期の出張におすすめ。 <仕様> ・素材  ポリカーボネート ・サイズ 55.0 x 39.0 x 21.0 cm ・容量  38L ・重量  3.5kg",
    product_image_1:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QA7-09001.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QA7-09001_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "910",
    brand: "Samsonite",
    sku: "QA7-51001",
    product_eng: "Samsonite LITE-FRAME 55cm Ice Blue",
    product_jpn: "Samsonite サムソナイト ライトフレーム 55 アイスブルー",
    category_1: "Travel",
    category_2: "Suitcases",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      '・A lightweight, tough frame case with a unique and innovative one-touch locking system. ・The newly developed "one-click multi-locking system" makes it easy to lock the case by simply locking one position. ・The frame is made of injection-molded ABS material for light weight. ・Aero-Trac™ suspension wheels absorb shocks for a smooth and stable ride. ・The interior has zippered dividers on both sides to prevent cargo collapse, and four pockets. ・The interior fabric is made of Recyclex™, a recycled material with an anti-bacterial finish. ・Carry-on size. ・Recommended for domestic travel by Shinkansen bullet trains, trains, etc., and for short-term business trips. <Specifications> Material: Polycarbonate Size 55.0 x 39.0 x 21.0 cm Capacity: 38L Weight: 3.5 kg',
    description_jpn:
      "・ワンタッチで開閉可能なユニークで革新的なロックシステムを搭載した軽量でタフなフレームケース。 ・ 新開発の“ワンクリックマルチロッキングシステム”により、1か所をロックするだけで簡単に施錠できます。 ・ フレームに射出成型したABS素材を採用し、軽量化を実現。 ・ Aero-Trac™サスペンションホイールにより、衝撃を吸収してスムーズで安定した走行性を発揮。 ・ 内装両面には荷崩れ防止のファスナー付きディバイダーが付属し、4か所のポケットを備えている。 ・ 内装生地には抗菌加工と再生素材Recyclex™を使用。 ・機内持ち込み対応サイズ。 ・新幹線・電車等で移動する国内旅行や短期の出張におすすめ。 <仕様> ・素材  ポリカーボネート ・サイズ 55.0 x 39.0 x 21.0 cm ・容量  38L ・重量  3.5kg",
    product_image_1:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QA7-51001.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QA7-51001_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "911",
    brand: "Samsonite",
    sku: "QA7-09003",
    product_eng: "Samsonite LITE-FRAME 75cm Black",
    product_jpn: "Samsonite サムソナイト ライトフレーム 75 ブラック",
    category_1: "Travel",
    category_2: "Suitcases",
    rrp_ex_vat: "¥55,000",
    rrp_with_vat: "¥60,500",
    description_eng:
      '・A lightweight, tough frame case with a unique and innovative one-touch locking system. ・The newly developed "one-click multi-locking system" makes it easy to lock the case by simply locking one position. ・The frame is made of injection-molded ABS material for light weight. ・Aero-Trac™ suspension wheels absorb shocks for a smooth and stable ride. ・The interior has zippered dividers on both sides to prevent cargo collapse, and four pockets. ・The interior fabric is made of Recyclex™, a recycled material with an anti-bacterial finish. ・ Recommended for overseas travel and long business trips. <Specifications> Material: Polycarbonate Size 75.0 x 53.0 x 30.0 cm Capacity: 89L Weight: 5.2 kg',
    description_jpn:
      "・ワンタッチで開閉可能なユニークで革新的なロックシステムを搭載した軽量でタフなフレームケース。 ・ 新開発の“ワンクリックマルチロッキングシステム”により、1か所をロックするだけで簡単に施錠できます。 ・ フレームに射出成型したABS素材を採用し、軽量化を実現。 ・ Aero-Trac™サスペンションホイールにより、衝撃を吸収してスムーズで安定した走行性を発揮。 ・ 内装両面には荷崩れ防止のファスナー付きディバイダーが付属し、4か所のポケットを備えている。 ・ 内装生地には抗菌加工と再生素材Recyclex™を使用。 ・海外旅行や長期の出張にもおすすめ。 <仕様> ・素材  ポリカーボネート ・サイズ 75.0 x 53.0 x 30.0 cm ・容量  89L ・重量  5.2kg",
    product_image_1:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QA7-09003.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QA7-09003_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "912",
    brand: "Samsonite",
    sku: "QA7-51003",
    product_eng: "Samsonite LITE-FRAME 75cm Ice Blue",
    product_jpn: "Samsonite サムソナイト ライトフレーム 75 アイスブルー",
    category_1: "Travel",
    category_2: "Suitcases",
    rrp_ex_vat: "¥55,000",
    rrp_with_vat: "¥60,500",
    description_eng:
      '・A lightweight, tough frame case with a unique and innovative one-touch locking system. ・The newly developed "one-click multi-locking system" makes it easy to lock the case by simply locking one position. ・The frame is made of injection-molded ABS material for light weight. ・Aero-Trac™ suspension wheels absorb shocks for a smooth and stable ride. ・The interior has zippered dividers on both sides to prevent cargo collapse, and four pockets. ・The interior fabric is made of Recyclex™, a recycled material with an anti-bacterial finish. ・ Recommended for overseas travel and long business trips. <Specifications> Material: Polycarbonate Size 75.0 x 53.0 x 30.0 cm Capacity: 89L Weight: 5.2 kg',
    description_jpn:
      "・ワンタッチで開閉可能なユニークで革新的なロックシステムを搭載した軽量でタフなフレームケース。 ・ 新開発の“ワンクリックマルチロッキングシステム”により、1か所をロックするだけで簡単に施錠できます。 ・ フレームに射出成型したABS素材を採用し、軽量化を実現。 ・ Aero-Trac™サスペンションホイールにより、衝撃を吸収してスムーズで安定した走行性を発揮。 ・ 内装両面には荷崩れ防止のファスナー付きディバイダーが付属し、4か所のポケットを備えている。 ・ 内装生地には抗菌加工と再生素材Recyclex™を使用。 ・海外旅行や長期の出張にもおすすめ。 <仕様> ・素材  ポリカーボネート ・サイズ 75.0 x 53.0 x 30.0 cm ・容量  89L ・重量  5.2kg",
    product_image_1:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QA7-51003.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QA7-51003_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "913",
    brand: "Samsonite",
    sku: "KH3-09002",
    product_eng: "Samsonite NEOPOD 55cm Black",
    product_jpn: "Samsonite サムソナイト ネオポッド 55cm ブラック",
    category_1: "Travel",
    category_2: "Suitcases",
    rrp_ex_vat: "¥52,000",
    rrp_with_vat: "¥57,200",
    description_eng:
      '・The bag has a stylish design and a functional front pocket. ・The front compartment is made of water-repellent PU material and recycled material Recyclex. ・The bag is designed for business with a 15.6" PC, a 10" tablet compartment, and a variety of storage spaces. ・The interior lining can be removed for washing (*1). ・Double wheels, USB port, expandable function (*2), etc. support comfortable travel. *1 Hand wash in cold water and alone. When using a detergent, please use a neutral detergent. *2 The expandable function expands only on the right side of the front in a fan shape. The bag is designed to fit in carry-on baggage. <Specifications> Material: Polycarbonate Size 55.0 x 38.0 x 22.0 cm  Capacity: 41L Expandable: 26.0 cm Expandable capacity: 48 L Weight: 3.3 kg PC compartment up to 15.6" (reference size 37.5 x 26 x 2.5 cm)',
    description_jpn:
      "・ スタイリッシュなデザインと機能的なフロントポケットを備えています。 ・ フロント部に撥水加工ずみのPU素材と再生素材リサイクレックスを使用した収納部を装備。 ・ 15.6インチPCと10インチタブレット収納ポケット、多彩な収納スペースを持つビジネスにも適したデザイン。 ・ 内装の裏地は取り外して洗濯可能(※1)。 ・ ダブルホイール、USBポート、エキスパンダブル機能(※2)など、快適な旅行をサポート。 ※1 洗濯の際は冷水・単独で手洗いしてください 。 洗剤をご使用になる場合は、中性洗剤をお使いください。 ※2 エキスパンダブル機能は、扇状に正面向かって右側のみが拡張する仕様です。 ・機内持ち込み対応サイズ。 <仕様> ・素材 ポリカーボネート ・サイズ 55.0 x 38.0 x 22.0 cm  ・容量 41L ・エキスパンダブル（拡張） 26.0cm ・エキスパンダブル（拡張）容量 48 L ・重量 3.3kg ・PC収納 15.6インチまで（参考サイズ 37.5 x 26 x 2.5 cm）",
    product_image_1:
      "https://products.naganorewards.com/images/samsonite/Samsonite_KH3-09002.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/samsonite/Samsonite_KH3-09002_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "914",
    brand: "Samsonite",
    sku: "KH3-01002",
    product_eng: "Samsonite NEOPOD 55cm Midnight Blue",
    product_jpn: "Samsonite サムソナイト ネオポッド 55cm ミッドナイトブルー",
    category_1: "Travel",
    category_2: "Suitcases",
    rrp_ex_vat: "¥52,000",
    rrp_with_vat: "¥57,200",
    description_eng:
      '・The bag has a stylish design and a functional front pocket. ・The front compartment is made of water-repellent PU material and recycled material Recyclex. ・The bag is designed for business with a 15.6" PC, a 10" tablet compartment, and a variety of storage spaces. ・The interior lining can be removed for washing (*1). ・Double wheels, USB port, expandable function (*2), etc. support comfortable travel. *1 Hand wash in cold water and alone. When using a detergent, please use a neutral detergent. *2 The expandable function expands only on the right side of the front in a fan shape. The bag is designed to fit in carry-on baggage. <Specifications> Material: Polycarbonate Size 55.0 x 38.0 x 22.0 cm  Capacity: 41L Expandable: 26.0 cm Expandable capacity: 48 L Weight: 3.3 kg PC compartment up to 15.6" (reference size 37.5 x 26 x 2.5 cm)',
    description_jpn:
      "・ スタイリッシュなデザインと機能的なフロントポケットを備えています。 ・ フロント部に撥水加工ずみのPU素材と再生素材リサイクレックスを使用した収納部を装備。 ・ 15.6インチPCと10インチタブレット収納ポケット、多彩な収納スペースを持つビジネスにも適したデザイン。 ・ 内装の裏地は取り外して洗濯可能(※1)。 ・ ダブルホイール、USBポート、エキスパンダブル機能(※2)など、快適な旅行をサポート。 ※1 洗濯の際は冷水・単独で手洗いしてください 。 洗剤をご使用になる場合は、中性洗剤をお使いください。 ※2 エキスパンダブル機能は、扇状に正面向かって右側のみが拡張する仕様です。 ・機内持ち込み対応サイズ。 <仕様> ・素材 ポリカーボネート ・サイズ 55.0 x 38.0 x 22.0 cm  ・容量 41L ・エキスパンダブル（拡張） 26.0cm ・エキスパンダブル（拡張）容量 48 L ・重量 3.3kg ・PC収納 15.6インチまで（参考サイズ 37.5 x 26 x 2.5 cm）",
    product_image_1:
      "https://products.naganorewards.com/images/samsonite/Samsonite_KH3-01002.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/samsonite/Samsonite_KH3-01002_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "915",
    brand: "Samsonite",
    sku: "QS3-19001",
    product_eng: "Samsonite EPID4 EXP Briefcase Black/Orange",
    product_jpn:
      "Samsonite サムソナイト エピッド4 ブリーフケース  ブラック/オレンジ",
    category_1: "Business",
    category_2: "Bags",
    rrp_ex_vat: "¥41,000",
    rrp_with_vat: "¥45,100",
    description_eng:
      '・The EPID business collection is the fourth generation of the EPID series, designed around the concept of "Every Person Is Different. ・The elegant glossy body and the accent color on the back of the cowhide leather handle create a trustworthy style. ・In addition to the gadget compartment, a removable multi-pouch is included to hold an umbrella or bottle. ・Soft, comfortable Italian leather is used for the grip on the back side of the cowhide handle for a comfortable grip. ・The exterior and interior are made of recycled materials for an updated, sustainable look. ・Water-repellent finish to cope with sudden weather changes. ・Includes a 15.6" PC compartment and a tablet pocket. ・The bag is equipped with bottom studs and a smart sleeve that can be set up on the telescoping handle of a suitcase. ・The included multi-pouch can be washed according to the instructions. ・The detachable shoulder strap makes it easy to carry. <Specifications> Materials: Recycled polyester, polyurethane, cowhide Dimensions: 29.0 x 40.0 x 11.0 cm Expandable: 11.0 cm Weight 0.8 kg PC compartment up to 15.6" (reference size 37.5 x 26 x 2.5 cm)',
    description_jpn:
      "・“Every Person Is Different”をコンセプトにデザインされた“EPID”シリーズの4代目となるビジネスコレクション。 ・上品な光沢感のある本体と牛革ハンドル裏のアクセントカラーが信頼感のあるスタイルを演出。 ・ガジェットコンパートメントに加え、傘やボトルが収まる取り外し可能なマルチポーチが付属。 ・手なじみの良いソフトなイタリア製レザーを牛革ハンドル裏側のグリップ部分に採用し、握り心地にこだわりました。 ・外装と内装にはリサイクル素材を使用し、サステナブルな仕様にアップデート。 ・撥水加工で急な天候変化に対応。 ・15.6インチサイズのPC収納ポケットとタブレットポケットが付属。 ・底鋲と、スーツケースの伸縮ハンドルにセットアップ可能なスマートスリーブを装備。 ・付属のマルチポーチは取り扱い表記に従い洗濯が可能。 ・着脱式ショルダーストラップが付属していて、持ち運びが簡単。 <仕様> ・素材  リサイクルポリエステル、ポリウレタン、牛革 ・サイズ 29.0 x 40.0 x 11.0 cm ・エキスパンダブル（拡張） 11.0cm ・重量 0.8kg ・PC収納15.6インチまで（参考サイズ 37.5 x 26 x 2.5 cm）",
    product_image_1:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QS3-19001.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QS3-19001_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "916",
    brand: "Samsonite",
    sku: "QS3-19005",
    product_eng: "Samsonite EPID4 EXP 3-way Briefcase Black/Orange",
    product_jpn:
      "Samsonite サムソナイト エピッド4 エクスパンダブル 3ウェイブリーフケース  ブラック/オレンジ",
    category_1: "Business",
    category_2: "Bags",
    rrp_ex_vat: "¥52,000",
    rrp_with_vat: "¥57,200",
    description_eng:
      '・The EPID business collection is the fourth generation of the EPID series, designed around the concept of "Every Person Is Different. ・The elegant glossy body and the accent color on the back of the cowhide leather handle create a trustworthy style. ・In addition to the gadget compartment, a removable multi-pouch is included to hold an umbrella or bottle. ・Soft, comfortable Italian leather is used for the grip on the back side of the cowhide handle for a comfortable grip. ・The exterior and interior are made of recycled materials for an updated, sustainable look. ・Water-repellent finish to cope with sudden weather changes. ・Includes a 15.6" PC compartment and a tablet pocket. ・Bottom rivets and a smart sleeve that can be set up on the telescoping handle of a suitcase. ・3-way design, can be used as a briefcase or backpack. ・When used as a briefcase, the shoulder strap can be stored in a pocket on the back. ・The expandable function allows you to expand the capacity of the bag according to your needs. ・The included multi-pouch can be washed according to the instructions. ・The detachable shoulder strap is included. <Specifications> Materials: Recycled polyester, polyurethane, cowhide Dimensions 31.0 x 43.0 x 14.0 cm Expandable: 19.0 cm Weight: 1.3 kg PC compartment up to 15.6" (reference size 37.5 x 26 x 2.5 cm)',
    description_jpn:
      "・“Every Person Is Different”をコンセプトにデザインされた“EPID”シリーズの4代目となるビジネスコレクション。 ・上品な光沢感のある本体と牛革ハンドル裏のアクセントカラーが信頼感のあるスタイルを演出。 ・ガジェットコンパートメントに加え、傘やボトルが収まる取り外し可能なマルチポーチが付属。 ・手なじみの良いソフトなイタリア製レザーを牛革ハンドル裏側のグリップ部分に採用し、握り心地にこだわりました。 ・外装と内装にはリサイクル素材を使用し、サステナブルな仕様にアップデート。 ・撥水加工で急な天候変化に対応。 ・15.6インチサイズのPC収納ポケットとタブレットポケットが付属。 ・底鋲と、スーツケースの伸縮ハンドルにセットアップ可能なスマートスリーブを装備。 ・3ウェイ仕様で、ブリーフケース・バックパックとしても使い分けられます。 ・ブリーフケースとして使用する際には、背面のショルダーストラップをポケットに格納可能。 ・エキスパンダブル機能を搭載しており、用途に応じて容量を拡張できます。 ・付属のマルチポーチは取り扱い表記に従い洗濯が可能。 ・着脱式ショルダーストラップが付属。 <仕様> ・素材  リサイクルポリエステル、ポリウレタン、牛革 ・サイズ 31.0 x 43.0 x 14.0 cm ・エキスパンダブル（拡張） 19.0cm ・重量  1.3kg ・PC収納 15.6インチまで（参考サイズ 37.5 x 26 x 2.5 cm）",
    product_image_1:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QS3-19005.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QS3-19005_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "917",
    brand: "Samsonite",
    sku: "QS3-19003",
    product_eng: "Samsonite EPID4 EXP Backpack M black Black/Orange",
    product_jpn:
      "Samsonite サムソナイト エピッド4 バックパック M エキスパンダブル",
    category_1: "Business",
    category_2: "Bags",
    rrp_ex_vat: "¥42,000",
    rrp_with_vat: "¥46,200",
    description_eng:
      '・The EPID business collection is the fourth generation of the EPID series, designed around the concept of "Every Person Is Different. ・The elegant glossy body and the accent color on the back of the cowhide leather handle create a trustworthy style. ・In addition to the gadget compartment, a removable multi-pouch is included to hold an umbrella or bottle. ・Soft, comfortable Italian leather is used for the grip on the back side of the cowhide handle for a comfortable grip. ・The exterior and interior are made of recycled materials for an updated, sustainable look. ・Water-repellent finish to cope with sudden weather changes. ・Includes a 15.6" PC compartment and a tablet pocket. ・Bottom studs and a smart sleeve that can be set up on the telescoping handle of a suitcase. ・The included multi-pouch can be washed according to the instructions. ・The chest strap is removable to improve the fit of the shoulder straps. ・Expandable function allows you to expand the capacity of the bag according to your needs. <Specifications> Materials: Recycled polyester, polyurethane, cowhide Dimensions 42.0 x 30.0 x 13.0 cm Expandable: 18.0 cm Weight: 1 kg PC compartment up to 15.6" (reference size 37.5 x 26 x 2.5 cm)',
    description_jpn:
      "・“Every Person Is Different”をコンセプトにデザインされた“EPID”シリーズの4代目となるビジネスコレクション。 ・上品な光沢感のある本体と牛革ハンドル裏のアクセントカラーが信頼感のあるスタイルを演出。 ・ガジェットコンパートメントに加え、傘やボトルが収まる取り外し可能なマルチポーチが付属。 ・手なじみの良いソフトなイタリア製レザーを牛革ハンドル裏側のグリップ部分に採用し、握り心地にこだわりました。 ・外装と内装にはリサイクル素材を使用し、サステナブルな仕様にアップデート。 ・撥水加工で急な天候変化に対応。 ・15.6インチサイズのPC収納ポケットとタブレットポケットが付属。 ・底鋲と、スーツケースの伸縮ハンドルにセットアップ可能なスマートスリーブを装備。 ・付属のマルチポーチは取り扱い表記に従い洗濯が可能。 ・ショルダーストラップのフィット感を上げるチェストストラップは取り外し可能。 ・エキスパンダブル機能搭載で用途に応じて容量を拡張可能。 <仕様> ・素材   リサイクルポリエステル、ポリウレタン、牛革 ・サイズ  42.0 x 30.0 x 13.0 cm ・エキスパンダブル（拡張） 18.0cm ・重量   1kg ・PC収納  15.6インチまで（参考サイズ 37.5 x 26 x 2.5 cm）",
    product_image_1:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QS3-19003.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/samsonite/Samsonite_QS3-19003_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "389",
    brand: "Samsonite",
    sku: "DC0-89003",
    product_eng: "Samsonite Evao Spinner 55 Brushed black",
    product_jpn:
      "Samsonite サムソナイト エヴァオスピナー 55 ブラッシュドブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥58,000",
    rrp_with_vat: "¥63,800",
    description_eng:
      "EVOA, an evolutionary Makrolon®(Makrolon® is a registered trademark of Covestro Group) polycarbonate collection, will for sure catch your eye. Its striking modern design is featured with metallic corner protectors and enriched by the unique metal logo and brushed texture.  The expandability on the check-in sizes, the magnetic pullers and the integrated antitheft zipper will further enhance your travel experience.  Material     100% Polycarbonate, 100% Makrolon ® (Makrolon® is a registered trademark of Covestro Group) Dimensions:55 x 40 x 20 cm Volume  36 L Weight  3.1 kg",
    description_jpn:
      "THE EVOLUTION OF CRAFTMANSHIP エレガントで洗練された外観に機能をプラス  エレガントで、洗練された外観に機能をプラス。Evolutionという意味が込められたミニマルで機能的なハードケースコレクション。ビジネス用途とレジャートラベルどちらにもベストの使用感を提供します。ホイールには特許取得のAero-Trac(TM)サスペンションを搭載しており、凸凹道でも衝撃を吸収しスムーズな走行が可能。またジッパーを2重構造にすることで強度を高めました。メタル製のコーナープロテクションが洗練された雰囲気を醸し出します。容量が拡張できる便利なエキスパンダブル機能とリッチな内装、EVOAはデザインと実用的な機能を持ち合わせたベストなスーツケースです。 スピナー55は1～3泊程度の旅行に適したサイズで、機内持ち込み対応です(泊数は目安としてご利用下さい)。  幅 x 高 x 奥：39 × 55 × 21 容量：36L 重量：3.4kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_DC0-89003.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "393",
    brand: "Samsonite",
    sku: "HS3-09001",
    product_eng: "Samsonite Debonair5 Briefcase S black",
    product_jpn: "Samsonite サムソナイト デボネア5 ブリーフケースS ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥27,000",
    rrp_with_vat: "¥29,700",
    description_eng:
      "Debonair 5 is a lightweight, minimalist and functional business series. The main body is made of high quality nylon twill material with high water repellency, and the handle and zipper handle are made of cowhide leather that feels good in the hand.  The handle and zipper handle are made of comfortable cowhide leather. The simple design retains the necessary functions while eliminating waste to create a lightweight design. This briefcase is recommended for daily commuting. Despite its compact size, it has bottom rivets for a sense of stability. Shoulder strap included. Color: Black Material: Nylon Size: 27 x 37 x 10 cm Weight: approx. 0.6 kg PC storage: up to 14 (Reference size: 31 x 23 x 2 cm)",
    description_jpn:
      "“軽量”、“ミニマル”で“機能的”なビジネスシリーズ「デボネア5」。 本体には、高い撥水機能を備えた上質感のあるナイロンツイル素材を、ハンドル部とファスナー引手には手馴染みのよい牛革を採用。  シンプルなデザインは、必要な機能を残しつつ無駄を省くことで軽量な設計に仕上げています。 毎日の通勤におすすめのブリーフケース。コンパクトなサイズ感ながら、底鋲付きで安定感があります。ショルダーストラップ付属。  カラー: ブラック 素材: ナイロン サイズ: 27 x 37 x 10 cm 重量: 約 0.6kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HS3-09001.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "394",
    brand: "Samsonite",
    sku: "HS3-41001",
    product_eng: "Samsonite Debonair5 Briefcase S Navy",
    product_jpn: "Samsonite サムソナイト デボネア5 ブリーフケースS ネイビー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥27,000",
    rrp_with_vat: "¥29,700",
    description_eng:
      "Debonair 5 is a lightweight, minimalist and functional business series. The main body is made of high quality nylon twill material with high water repellency, and the handle and zipper handle are made of cowhide leather that feels good in the hand.  The handle and zipper handle are made of comfortable cowhide leather. The simple design retains the necessary functions while eliminating waste to create a lightweight design. This briefcase is recommended for daily commuting. Despite its compact size, it has bottom rivets for a sense of stability. Shoulder strap included. Color: Navy Material: Nylon Size: 27 x 37 x 10 cm Weight: approx. 0.6 kg PC storage: up to 14 (Reference size: 31 x 23 x 2 cm)",
    description_jpn:
      "“軽量”、“ミニマル”で“機能的”なビジネスシリーズ「デボネア5」。 本体には、高い撥水機能を備えた上質感のあるナイロンツイル素材を、ハンドル部とファスナー引手には手馴染みのよい牛革を採用。  シンプルなデザインは、必要な機能を残しつつ無駄を省くことで軽量な設計に仕上げています。 毎日の通勤におすすめのブリーフケース。コンパクトなサイズ感ながら、底鋲付きで安定感があります。ショルダーストラップ付属。 カラー: ネイビー 素材: ナイロン サイズ: 27 x 37 x 10 cm 重量: 約 0.6kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HS3-41001.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "395",
    brand: "Samsonite",
    sku: "HS3-09002",
    product_eng: "Samsonite Debonair5 Briefcase M EXP black",
    product_jpn:
      "Samsonite サムソナイト デボネア5 ブリーフケースM エクスパンダブル ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥32,000",
    rrp_with_vat: "¥35,200",
    description_eng:
      "Debonair 5 is a lightweight, minimalist and functional business series. The main body is made of high quality nylon twill material with high water repellency, and the handle and zipper handle are made of cowhide leather that feels good in the hand.  The handle and zipper handle are made of comfortable cowhide leather. The simple design retains the necessary functions while eliminating waste to create a lightweight design. With an expandable function, this briefcase is recommended for people with a lot of luggage. Equipped with a plastic bottle holder in the storage section. Shoulder strap included. Material: Nylon Size: 29 x 40 x 13/17 cm Weight: approx. 0.9 kg PC storage: Up to 14 (Reference size: 31 x 23 x 2 cm)",
    description_jpn:
      "“軽量”、“ミニマル”で“機能的”なビジネスシリーズ「デボネア5」。 本体には、高い撥水機能を備えた上質感のあるナイロンツイル素材を、ハンドル部とファスナー引手には手馴染みのよい牛革を採用。  シンプルなデザインは、必要な機能を残しつつ無駄を省くことで軽量な設計に仕上げています。  エキスパンダブル(拡張)機能付きで、荷物が多い方におすすめのブリーフケース。収納部にはペットボトルホルダーを装備しています。ショルダーストラップ付属。 カラー: ブラック 素材: ナイロン サイズ: 29 x 40 x 13/17 cm 重量: 約 0.9kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HS3-09002.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "396",
    brand: "Samsonite",
    sku: "HS3-41002",
    product_eng: "Samsonite Debonair5 Briefcase M EXPNavy",
    product_jpn:
      "Samsonite サムソナイト デボネア5 ブリーフケースM エクスパンダブル ネイビー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥32,000",
    rrp_with_vat: "¥35,200",
    description_eng:
      "Debonair 5 is a lightweight, minimalist and functional business series. The main body is made of high quality nylon twill material with high water repellency, and the handle and zipper handle are made of cowhide leather that feels good in the hand.  The handle and zipper handle are made of comfortable cowhide leather. The simple design retains the necessary functions while eliminating waste to create a lightweight design. With an expandable function, this briefcase is recommended for people with a lot of luggage. Equipped with a plastic bottle holder in the storage section. Shoulder strap included. Material: Nylon Size: 29 x 40 x 13/17 cm Weight: approx. 0.9 kg PC storage: Up to 14 (Reference size: 31 x 23 x 2 cm)",
    description_jpn:
      "“軽量”、“ミニマル”で“機能的”なビジネスシリーズ「デボネア5」。 本体には、高い撥水機能を備えた上質感のあるナイロンツイル素材を、ハンドル部とファスナー引手には手馴染みのよい牛革を採用。  シンプルなデザインは、必要な機能を残しつつ無駄を省くことで軽量な設計に仕上げています。  エキスパンダブル(拡張)機能付きで、荷物が多い方におすすめのブリーフケース。収納部にはペットボトルホルダーを装備しています。ショルダーストラップ付属。 カラー: ネイビー 素材: ナイロン サイズ: 29 x 40 x 13/17 cm 重量: 約 0.9kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HS3-41002.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "397",
    brand: "Samsonite",
    sku: "HS3-09004",
    product_eng: "Samsonite Debonair5 3-way Briefcase EXP Black",
    product_jpn:
      "Samsonite サムソナイト デボネア5 3ウェイブリーフケース エクスパンダブル ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥37,000",
    rrp_with_vat: "¥40,700",
    description_eng:
      "Debonair 5 is a lightweight, minimalist and functional business series. The main body is made of high quality nylon twill material with high water repellency, and the handle and zipper handle are made of cowhide leather that feels good in the hand.  The handle and zipper handle are made of comfortable cowhide leather. The simple design retains the necessary functions while eliminating waste to create a lightweight design. A 3-way brief that can store backpack straps in the back. With an expandable function, it can be used for overnight business trips. The front organizer pocket is cut diagonally to prevent spillage of luggage when carried on the back. It also has a button to compactly fasten the handle when you carry it on your back, and a plastic bottle holder in the compartment. Shoulder strap included. Material: Nylon Size: 30 x 42 x 14/18 cm Weight: approx. 1.3 kg PC Storage: Up to 15 (Reference size: 37.5 x 26 x 2.5 cm)",
    description_jpn:
      "“軽量”、“ミニマル”で“機能的”なビジネスシリーズ「デボネア5」。 本体には、高い撥水機能を備えた上質感のあるナイロンツイル素材を、ハンドル部とファスナー引手には手馴染みのよい牛革を採用。  シンプルなデザインは、必要な機能を残しつつ無駄を省くことで軽量な設計に仕上げています。  背面にバックパックのストラップを格納できる3ウェイブリーフ。エキスパンダブル(拡張)機能付きで、1泊程度の出張にも活躍します。フロントのオーガナイザーポケットは斜めにカットされており、背負った時の荷物のこぼれ落ちを防ぎます。 また、背負った時にハンドルをコンパクトに留められるボタンや、収納部にはペットボトルホルダーを装備しています。ショルダーストラップ付属。 カラー: ブラック 素材: ナイロン サイズ: 30 x 42 x 14/18 cm 重量: 約 1.3kg PC収納: 15インチまで（参考サイズ 37.5 x 26 x 2.5 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HS3-09004.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "398",
    brand: "Samsonite",
    sku: "HS3-41004",
    product_eng: "Samsonite Debonair5 3-way Briefcase EXP Navy",
    product_jpn:
      "Samsonite サムソナイト デボネア5 3ウェイブリーフケース エクスパンダブル ネイビー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥37,000",
    rrp_with_vat: "¥40,700",
    description_eng:
      "Debonair 5 is a lightweight, minimalist and functional business series. The main body is made of high quality nylon twill material with high water repellency, and the handle and zipper handle are made of cowhide leather that feels good in the hand.  The handle and zipper handle are made of comfortable cowhide leather. The simple design retains the necessary functions while eliminating waste to create a lightweight design. A 3-way brief that can store backpack straps in the back. With an expandable function, it can be used for overnight business trips. The front organizer pocket is cut diagonally to prevent spillage of luggage when carried on the back. It also has a button to compactly fasten the handle when you carry it on your back, and a plastic bottle holder in the compartment. Shoulder strap included. Material: Nylon Size: 30 x 42 x 14/18 cm Weight: approx. 1.3 kg PC Storage: Up to 15 (Reference size: 37.5 x 26 x 2.5 cm)",
    description_jpn:
      "“軽量”、“ミニマル”で“機能的”なビジネスシリーズ「デボネア5」。 本体には、高い撥水機能を備えた上質感のあるナイロンツイル素材を、ハンドル部とファスナー引手には手馴染みのよい牛革を採用。  シンプルなデザインは、必要な機能を残しつつ無駄を省くことで軽量な設計に仕上げています。  背面にバックパックのストラップを格納できる3ウェイブリーフ。エキスパンダブル(拡張)機能付きで、1泊程度の出張にも活躍します。フロントのオーガナイザーポケットは斜めにカットされており、背負った時の荷物のこぼれ落ちを防ぎます。 また、背負った時にハンドルをコンパクトに留められるボタンや、収納部にはペットボトルホルダーを装備しています。ショルダーストラップ付属。 カラー: ネイビー 素材: ナイロン サイズ: 30 x 42 x 14/18 cm 重量: 約 1.3kg PC収納: 15インチまで（参考サイズ 37.5 x 26 x 2.5 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HS3-41004.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "399",
    brand: "Samsonite",
    sku: "HS3-09005",
    product_eng: "Samsonite Debonair5 Backpack M black",
    product_jpn: "Samsonite サムソナイト デボネア5 バックパックM ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥33,000",
    rrp_with_vat: "¥36,300",
    description_eng:
      "Debonair 5 is a lightweight, minimalist and functional business series. The main body is made of high quality nylon twill material with high water repellency, and the handle and zipper handle are made of cowhide leather that feels good in the hand.  The handle and zipper handle are made of comfortable cowhide leather. The simple design retains the necessary functions while eliminating waste to create a lightweight design. This backpack is recommended for daily commuting. The front lower pocket lining is PVC coated and is convenient for temporary storage of The front lower pocket lining is PVC coated and is convenient for temporary storage of wet umbrellas, etc. Side pocket for a plastic bottle. Material: Nylon Size: 42 x 27 x 14 cm Weight: approx. 1kg PC storage: up to 14 (Reference size: 31 x 23 x 2 cm)",
    description_jpn:
      "“軽量”、“ミニマル”で“機能的”なビジネスシリーズ「デボネア5」。 本体には、高い撥水機能を備えた上質感のあるナイロンツイル素材を、ハンドル部とファスナー引手には手馴染みのよい牛革を採用。  シンプルなデザインは、必要な機能を残しつつ無駄を省くことで軽量な設計に仕上げています。 毎日の通勤におすすめのバックパック。フロント下部のポケット裏地はPVCコーティングされており、 濡れた傘等の一時的な収納に便利です。ペットボトルを収納可能なサイドポケット付き。 カラー: ブラック 素材: ナイロン サイズ: 42 x 27 x 14 cm 重量: 約 1kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HS3-09005.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "400",
    brand: "Samsonite",
    sku: "HS3-41005",
    product_eng: "Samsonite Debonair5 Backpack M Navy",
    product_jpn: "Samsonite サムソナイト デボネア5 バックパックM ネイビー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥33,000",
    rrp_with_vat: "¥36,300",
    description_eng:
      "Debonair 5 is a lightweight, minimalist and functional business series. The main body is made of high quality nylon twill material with high water repellency, and the handle and zipper handle are made of cowhide leather that feels good in the hand.  The handle and zipper handle are made of comfortable cowhide leather. The simple design retains the necessary functions while eliminating waste to create a lightweight design. This backpack is recommended for daily commuting. The front lower pocket lining is PVC coated and is convenient for temporary storage of The front lower pocket lining is PVC coated and is convenient for temporary storage of wet umbrellas, etc. Side pocket for a plastic bottle. Material: Nylon Size: 42 x 27 x 14 cm Weight: approx. 1kg PC storage: up to 14 (Reference size: 31 x 23 x 2 cm)",
    description_jpn:
      "“軽量”、“ミニマル”で“機能的”なビジネスシリーズ「デボネア5」。 本体には、高い撥水機能を備えた上質感のあるナイロンツイル素材を、ハンドル部とファスナー引手には手馴染みのよい牛革を採用。  シンプルなデザインは、必要な機能を残しつつ無駄を省くことで軽量な設計に仕上げています。 毎日の通勤におすすめのバックパック。フロント下部のポケット裏地はPVCコーティングされており、 濡れた傘等の一時的な収納に便利です。ペットボトルを収納可能なサイドポケット付き。 カラー: ネイビー 素材: ナイロン サイズ: 42 x 27 x 14 cm 重量: 約 1kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HS3-41005.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "401",
    brand: "Samsonite",
    sku: "HS3-09006",
    product_eng: "Samsonite Debonair5 Backpack L EXP black",
    product_jpn:
      "Samsonite サムソナイト デボネア5 バックパックL エクスパンダブル ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥35,000",
    rrp_with_vat: "¥38,500",
    description_eng:
      "Debonair 5 is a lightweight, minimalist and functional business series. The main body is made of high quality nylon twill material with high water repellency, and the handle and zipper handle are made of cowhide leather that feels good in the hand.  The handle and zipper handle are made of comfortable cowhide leather. The simple design retains the necessary functions while eliminating waste to create a lightweight design. This is a backpack with an expandable function that can be used for overnight business trips. The front lower pocket lining is PVC coated, which is convenient for temporary storage of wet umbrellas. Side pockets for storing plastic bottles. Material: Nylon Size: 44 x 30 x 18/22 cm Weight: approx. 1.2 kg PC storage: up to 14 (Reference size: 31 x 23 x 2 cm)",
    description_jpn:
      "“軽量”、“ミニマル”で“機能的”なビジネスシリーズ「デボネア5」。 本体には、高い撥水機能を備えた上質感のあるナイロンツイル素材を、ハンドル部とファスナー引手には手馴染みのよい牛革を採用。  シンプルなデザインは、必要な機能を残しつつ無駄を省くことで軽量な設計に仕上げています。 エキスパンダブル(拡張)機能付きで、1泊程度の出張にも活躍するバックパック。フロント下部のポケット裏地はPVCコーティングされており、濡れた傘等の一時的な収納に便利です。ペットボトルを収納可能なサイドポケット付き。 カラー: ブラック 素材: ナイロン サイズ: 44 x 30 x 18/22 cm 重量: 約 1.2kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HS3-09006.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "402",
    brand: "Samsonite",
    sku: "HS3-41006",
    product_eng: "Samsonite Debonair5 Backpack L EXP Navy",
    product_jpn:
      "Samsonite サムソナイト デボネア5 バックパックL エクスパンダブル ネイビー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥35,000",
    rrp_with_vat: "¥38,500",
    description_eng:
      "Debonair 5 is a lightweight, minimalist and functional business series. The main body is made of high quality nylon twill material with high water repellency, and the handle and zipper handle are made of cowhide leather that feels good in the hand.  The handle and zipper handle are made of comfortable cowhide leather. The simple design retains the necessary functions while eliminating waste to create a lightweight design. This is a backpack with an expandable function that can be used for overnight business trips. The front lower pocket lining is PVC coated, which is convenient for temporary storage of wet umbrellas. Side pockets for storing plastic bottles. Material: Nylon Size: 44 x 30 x 18/22 cm Weight: approx. 1.2 kg PC storage: up to 14 (Reference size: 31 x 23 x 2 cm)",
    description_jpn:
      "“軽量”、“ミニマル”で“機能的”なビジネスシリーズ「デボネア5」。 本体には、高い撥水機能を備えた上質感のあるナイロンツイル素材を、ハンドル部とファスナー引手には手馴染みのよい牛革を採用。  シンプルなデザインは、必要な機能を残しつつ無駄を省くことで軽量な設計に仕上げています。 エキスパンダブル(拡張)機能付きで、1泊程度の出張にも活躍するバックパック。フロント下部のポケット裏地はPVCコーティングされており、濡れた傘等の一時的な収納に便利です。ペットボトルを収納可能なサイドポケット付き。 カラー: ネイビー 素材: ナイロン サイズ: 44 x 30 x 18/22 cm 重量: 約 1.2kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HS3-41006.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "404",
    brand: "Samsonite",
    sku: "HH5-45001",
    product_eng: "Samsonite Minter suitcase 55cm Ivory",
    product_jpn: "Samsonite サムソナイト ミンター55cm アイボリー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥52,000",
    rrp_with_vat: "¥57,200",
    description_eng:
      "Spinner 55 is a carry-on size suitable for 1-3 nights travel. It is also recommended for domestic travel by Shinkansen bullet trains, trains, etc., and short-term business trips. The magnets on the zipper pulls prevent the pulls from coming apart when locked and keep them in place. *The Spinner 55 does not have an expandable function.  <About Minter> The MINTER travel collection combines sophisticated form and functionality. The aluminum logo bar around the front and the subtle straight lines of the matte shell give the Minter a modern, sleek look, while offering superior functionality to make travel more comfortable. The latest Aero-Trac™ II suspension wheels support smooth travel by reducing noise and vibration and providing comfort and ease of operation. The interior, lined with RECYCLEX™, a recycled material made from 100% recovered PET bottles, features a functional double-sided divider with multiple pockets. The right side divider is removable and can be hung up on the road with the included hook. The front of the bag has a hanging hook (*) for hanging small items between trips, as well as a packing cube for organizing your belongings. The Minter collection is ideal for the seasoned traveler.  Material: Polycarbonate Dimensions: 55 x 38 x 22 cm Capacity: approx. 33 liters Weight: approx. 3.3 kg",
    description_jpn:
      "スピナー55は、1～3泊程度の旅行に適した機内持ち込みサイズ。新幹線・電車等で移動する国内旅行や短期の出張にもおすすめです。ファスナー引手に備えられた磁石により、ロック時に引手がばらつかずスマートにまとまります。 ※スピナー55にはエキスパンダブル(拡張)機能はございません。  <ミンターについて> 洗練されたフォルムと機能性を融合させたトラベルコレクション「MINTER （ミンター）」。 フロントを囲むアルミニウムのロゴバーと、マットな質感のシェルの繊細な直線が描く、モダンで洗練された外観に加えて、旅をより快適にするための優れた機能性も備えています。 最新のAero-Trac™ II サスペンションホイールは、ノイズや振動を低減し、快適な操作性を実現することで、スムーズな移動をサポート。 ライニングに回収されたPETボトルを100％使用した再生素材RECYCLEX™が使われた内装は、複数のポケットを備えた機能的な両面ディバイダーを装備。右側のディバイダーは取り外し可能で、付属のフックにより旅先でそのまま掛けて使うことができます。 フロントには旅の合間にちょっとした荷物が掛けられるハンギングフック(※)のほか、荷物を整理するのに便利なパッキングキューブも付属するなど、さまざまな機能を備えています。 「ミンター」は、旅馴れたトラベラーにとっても理想的なコレクションです。  素材: ポリカーボネート サイズ: 55 x 38 x 22 cm 容量: 約 33L 重量: 約 3.3kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-45001.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-45001_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-45001_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-45001_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "405",
    brand: "Samsonite",
    sku: "HH5-41002",
    product_eng: "Samsonite Minter suitcase 69cm Navy",
    product_jpn: "Samsonite サムソナイト ミンター69cm ネイビー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥58,000",
    rrp_with_vat: "¥63,800",
    description_eng:
      "The Spinner 69 is sized for a 4-6 night trip. It is recommended for domestic travel as well as short-term international travel. The expandable function allows you to increase the storage capacity even if you have more luggage on your trip. The magnets on the zipper pulls prevent the pulls from coming apart when locked and keep them in place.  <About Minter> The MINTER travel collection combines sophisticated form and functionality. The aluminum logo bar around the front and the subtle straight lines of the matte-textured shell create a modern, sleek look that also offers superior functionality to make travel more comfortable. The latest Aero-Trac™ II suspension wheels support smooth travel by reducing noise and vibration and providing comfort and ease of operation. The interior, lined with RECYCLEX™, a recycled material made from 100% recovered PET bottles, features a functional double-sided divider with multiple pockets. The right side divider is removable and can be hung up on the road with the included hook. The front of the bag has a hanging hook (*) for hanging small items between trips, as well as a packing cube for organizing your belongings. The Minter collection is ideal for the seasoned traveler.  Material: Polycarbonate Dimensions: 69 x 49 x 29/33 cm Capacity: approx. 75/92 liters Weight: approx. 4.6 kg",
    description_jpn:
      "スピナー69は、4～6泊程度の旅行に適したサイズ。国内旅行はもちろん、短期の海外旅行にもおすすめです。 エキスパンダブル(拡張)機能搭載で、旅先で荷物が増えても収納容量をアップ可能です。ファスナー引手に備えられた磁石により、ロック時に引手がばらつかずスマートにまとまります。  <ミンターについて> 洗練されたフォルムと機能性を融合させたトラベルコレクション「MINTER （ミンター）」。 フロントを囲むアルミニウムのロゴバーと、マットな質感のシェルの繊細な直線が描く、モダンで洗練された外観に加えて、旅をより快適にするための優れた機能性も備えています。 最新のAero-Trac™ II サスペンションホイールは、ノイズや振動を低減し、快適な操作性を実現することで、スムーズな移動をサポート。 ライニングに回収されたPETボトルを100％使用した再生素材RECYCLEX™が使われた内装は、複数のポケットを備えた機能的な両面ディバイダーを装備。右側のディバイダーは取り外し可能で、付属のフックにより旅先でそのまま掛けて使うことができます。 フロントには旅の合間にちょっとした荷物が掛けられるハンギングフック(※)のほか、荷物を整理するのに便利なパッキングキューブも付属するなど、さまざまな機能を備えています。 「ミンター」は、旅馴れたトラベラーにとっても理想的なコレクションです。  素材: ポリカーボネート サイズ: 69 x 49 x 29/33 cm 容量: 約 75/92L 重量: 約 4.6kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-41002.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-41002_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-41002_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-41002_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "406",
    brand: "Samsonite",
    sku: "HH5-45002",
    product_eng: "Samsonite Minter suitcase 69cm Ivory",
    product_jpn: "Samsonite サムソナイト ミンター69cm アイボリー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥58,000",
    rrp_with_vat: "¥63,800",
    description_eng:
      "The Spinner 69 is sized for a 4-6 night trip. It is recommended for domestic travel as well as short-term international travel. The expandable function allows you to increase the storage capacity even if you have more luggage on your trip. The magnets on the zipper pulls prevent the pulls from coming apart when locked and keep them in place.  <About Minter> The MINTER travel collection combines sophisticated form and functionality. The aluminum logo bar around the front and the subtle straight lines of the matte-textured shell create a modern, sleek look that also offers superior functionality to make travel more comfortable. The latest Aero-Trac™ II suspension wheels support smooth travel by reducing noise and vibration and providing comfort and ease of operation. The interior, lined with RECYCLEX™, a recycled material made from 100% recovered PET bottles, features a functional double-sided divider with multiple pockets. The right side divider is removable and can be hung up on the road with the included hook. The front of the bag has a hanging hook (*) for hanging small items between trips, as well as a packing cube for organizing your belongings. The Minter collection is ideal for the seasoned traveler.  Material: Polycarbonate Dimensions: 69 x 49 x 29/33 cm Capacity: approx. 75/92 liters Weight: approx. 4.6 kg",
    description_jpn:
      "スピナー69は、4～6泊程度の旅行に適したサイズ。国内旅行はもちろん、短期の海外旅行にもおすすめです。 エキスパンダブル(拡張)機能搭載で、旅先で荷物が増えても収納容量をアップ可能です。ファスナー引手に備えられた磁石により、ロック時に引手がばらつかずスマートにまとまります。  <ミンターについて> 洗練されたフォルムと機能性を融合させたトラベルコレクション「MINTER （ミンター）」。 フロントを囲むアルミニウムのロゴバーと、マットな質感のシェルの繊細な直線が描く、モダンで洗練された外観に加えて、旅をより快適にするための優れた機能性も備えています。 最新のAero-Trac™ II サスペンションホイールは、ノイズや振動を低減し、快適な操作性を実現することで、スムーズな移動をサポート。 ライニングに回収されたPETボトルを100％使用した再生素材RECYCLEX™が使われた内装は、複数のポケットを備えた機能的な両面ディバイダーを装備。右側のディバイダーは取り外し可能で、付属のフックにより旅先でそのまま掛けて使うことができます。 フロントには旅の合間にちょっとした荷物が掛けられるハンギングフック(※)のほか、荷物を整理するのに便利なパッキングキューブも付属するなど、さまざまな機能を備えています。 「ミンター」は、旅馴れたトラベラーにとっても理想的なコレクションです。  素材: ポリカーボネート サイズ: 69 x 49 x 29/33 cm 容量: 約 75/92L 重量: 約 4.6kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-45002.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-45002_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-45002_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HH5-45002_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "407",
    brand: "Samsonite",
    sku: "HT7-09001",
    product_eng: "Samsonite sub-lim 2way bag Black Small",
    product_jpn: "Samsonite サムソナイ サブ-リム ツーウェイバッグSブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥37,000",
    rrp_with_vat: "¥40,700",
    description_eng:
      "<About Sub-lim> A business collection that won the Good Design Award 2021 for its balance of design, light weight, and functionality to meet the changing working styles regardless of where you work.  The 2Way Bag is designed as a backpack and is equipped with a side handle so that it can be carried as a briefcase type bag for business situations. The interior and exterior zipper pockets have an L-shaped structure that can be used either vertically or horizontally for ease of use. The front panel of the main body is made of a scratch-resistant material with a reinforced polyurethane coating, while the sides are made of water-repellent polyester. The interior fabric is made of recycled material from 100% recycled PET bottles with an antimicrobial finish. The bag features a PC pocket accessible from both the interior and exterior, as well as pockets throughout for efficient storage of tools.  Color: Black Materials: polyester, leather Dimensions: 39 x 27 x 10 cm Weight: approx. 0.7 kg PC compartment: up to 14 (reference size 31 x 23 x 2 cm)",
    description_jpn:
      "<サブ-リムについて> 働く場所にとらわれないワーキングスタイルの変化に合わせた、デザイン性と軽量性、機能性のバランスを重視した『グッドデザイン賞2021』受賞のビジネスコレクション。  2Way Bagはバックパックとして設計しており、ビジネスシーンに合わせてブリーフケースタイプでも持てるようにサイドハンドルを装備。 内装および外装のファスナーポケットはタテ、ヨコどちらの使用時にも対応できるL字構造で使いやすさを考慮しました。 本体フロントパネルには、表面にキズが付きにくい強化ポリウレタンコーティングを施した素材を、サイドには撥水ポリエステル素材を採用。 内装生地には抗菌加工されたリサイクルPETボトルを100%原料とする再生素材が使われています。 内装・外装両方からアクセス可能なPCポケットのほか、ツールを効率的に収納できるポケットを各所に装備しています。  カラー: ブラック 素材: ポリエステル、レザー サイズ: 39 x 27 x 10 cm 重量: 約 0.7kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-09001.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-09001_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-09001_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-09001_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "408",
    brand: "Samsonite",
    sku: "HT7-41001",
    product_eng: "Samsonite sub-lim 2way bag Navy Small",
    product_jpn: "Samsonite サムソナイ サブ-リム ツーウェイバッグSネイビー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥37,000",
    rrp_with_vat: "¥40,700",
    description_eng:
      "<About Sub-lim> A business collection that won the Good Design Award 2021 for its balance of design, light weight, and functionality to meet the changing working styles regardless of where you work.  The 2Way Bag is designed as a backpack and is equipped with a side handle so that it can be carried as a briefcase type bag for business situations. The interior and exterior zipper pockets have an L-shaped structure that can be used either vertically or horizontally for ease of use. The front panel of the main body is made of a scratch-resistant material with a reinforced polyurethane coating, while the sides are made of water-repellent polyester. The interior fabric is made of recycled material from 100% recycled PET bottles with an antimicrobial finish. The bag features a PC pocket accessible from both the interior and exterior, as well as pockets throughout for efficient storage of tools.  Color: Black Materials: polyester, leather Dimensions: 39 x 27 x 10 cm Weight: approx. 0.7 kg PC compartment: up to 14 (reference size 31 x 23 x 2 cm)",
    description_jpn:
      "<サブ-リムについて> 働く場所にとらわれないワーキングスタイルの変化に合わせた、デザイン性と軽量性、機能性のバランスを重視した『グッドデザイン賞2021』受賞のビジネスコレクション。  2Way Bagはバックパックとして設計しており、ビジネスシーンに合わせてブリーフケースタイプでも持てるようにサイドハンドルを装備。 内装および外装のファスナーポケットはタテ、ヨコどちらの使用時にも対応できるL字構造で使いやすさを考慮しました。 本体フロントパネルには、表面にキズが付きにくい強化ポリウレタンコーティングを施した素材を、サイドには撥水ポリエステル素材を採用。 内装生地には抗菌加工されたリサイクルPETボトルを100%原料とする再生素材が使われています。 内装・外装両方からアクセス可能なPCポケットのほか、ツールを効率的に収納できるポケットを各所に装備しています。  カラー: ブラック 素材: ポリエステル、レザー サイズ: 39 x 27 x 10 cm 重量: 約 0.7kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-41001.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-41001_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-41001_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-41001_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "409",
    brand: "Samsonite",
    sku: "HT7-09002",
    product_eng: "Samsonite sub-lim 2way bag Black Medium",
    product_jpn: "Samsonite サムソナイ サブ-リム ツーウェイバッグMブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥39,000",
    rrp_with_vat: "¥42,900",
    description_eng:
      "<About Sub-lim> A business collection that won the Good Design Award 2021 for its balance of design, light weight, and functionality to meet the changing working styles regardless of where you work.  The 2Way Bag is designed as a backpack and is equipped with a side handle so that it can be carried as a briefcase type bag for business situations. The interior and exterior zipper pockets have an L-shaped structure that can be used either vertically or horizontally for ease of use. The front panel of the main body is made of a scratch-resistant material with a reinforced polyurethane coating, while the sides are made of water-repellent polyester. The interior fabric is made of recycled material from 100% recycled PET bottles with an antimicrobial finish. The bag features a PC pocket accessible from both the interior and exterior, as well as pockets throughout for efficient storage of tools.  Color: Black Materials: polyester, leather Size: 41 x 28 x 13 cm Weight: approx. 0.8 kg PC compartment: up to 14 (reference size 31 x 23 x 2 cm)",
    description_jpn:
      "<サブ-リムについて> 働く場所にとらわれないワーキングスタイルの変化に合わせた、デザイン性と軽量性、機能性のバランスを重視した『グッドデザイン賞2021』受賞のビジネスコレクション。  2Way Bagはバックパックとして設計しており、ビジネスシーンに合わせてブリーフケースタイプでも持てるようにサイドハンドルを装備。 内装および外装のファスナーポケットはタテ、ヨコどちらの使用時にも対応できるL字構造で使いやすさを考慮しました。 本体フロントパネルには、表面にキズが付きにくい強化ポリウレタンコーティングを施した素材を、サイドには撥水ポリエステル素材を採用。 内装生地には抗菌加工されたリサイクルPETボトルを100%原料とする再生素材が使われています。 内装・外装両方からアクセス可能なPCポケットのほか、ツールを効率的に収納できるポケットを各所に装備しています。  カラー: ブラック 素材: ポリエステル、レザー サイズ: 41 x 28 x 13 cm 重量: 約 0.8kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-09003.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-09003_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-09003_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-09003_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "410",
    brand: "Samsonite",
    sku: "HT7-41002",
    product_eng: "Samsonite sub-lim 2way bag Navy Medium",
    product_jpn: "Samsonite サムソナイ サブ-リム ツーウェイバッグMネイビー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥39,000",
    rrp_with_vat: "¥42,900",
    description_eng:
      "<About Sub-lim> A business collection that won the Good Design Award 2021 for its balance of design, light weight, and functionality to meet the changing working styles regardless of where you work.  The 2Way Bag is designed as a backpack and is equipped with a side handle so that it can be carried as a briefcase type bag for business situations. The interior and exterior zipper pockets have an L-shaped structure that can be used either vertically or horizontally for ease of use. The front panel of the main body is made of a scratch-resistant material with a reinforced polyurethane coating, while the sides are made of water-repellent polyester. The interior fabric is made of recycled material from 100% recycled PET bottles with an antimicrobial finish. The bag features a PC pocket accessible from both the interior and exterior, as well as pockets throughout for efficient storage of tools.  Color: Black Materials: polyester, leather Size: 41 x 28 x 13 cm Weight: approx. 0.8 kg PC compartment: up to 14 (reference size 31 x 23 x 2 cm)",
    description_jpn:
      "<サブ-リムについて> 働く場所にとらわれないワーキングスタイルの変化に合わせた、デザイン性と軽量性、機能性のバランスを重視した『グッドデザイン賞2021』受賞のビジネスコレクション。  2Way Bagはバックパックとして設計しており、ビジネスシーンに合わせてブリーフケースタイプでも持てるようにサイドハンドルを装備。 内装および外装のファスナーポケットはタテ、ヨコどちらの使用時にも対応できるL字構造で使いやすさを考慮しました。 本体フロントパネルには、表面にキズが付きにくい強化ポリウレタンコーティングを施した素材を、サイドには撥水ポリエステル素材を採用。 内装生地には抗菌加工されたリサイクルPETボトルを100%原料とする再生素材が使われています。 内装・外装両方からアクセス可能なPCポケットのほか、ツールを効率的に収納できるポケットを各所に装備しています。  カラー: ブラック 素材: ポリエステル、レザー サイズ: 41 x 28 x 13 cm 重量: 約 0.8kg PC収納: 14インチまで（参考サイズ 31 x 23 x 2 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/samsonite/Samsonite_HT7-41002.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/samsonite.png",
  },
  {
    id: "411",
    brand: "Seiko",
    sku: "SARY155",
    product_eng: "Seiko Presage-CM-SARY155",
    product_jpn: "SEIKO セイコー プレサージュ CM-SARY155 ペアウォッチ男性用",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥55,000",
    rrp_with_vat: "¥60,500",
    description_eng:
      "A mechanical watch practical and graceful. A beautiful dial inspired by a Japanese garden. MADE IN JAPAN  Strap: Calf Crystal: Box-shaped Hardlex See-through back Case (Hardlex) No luminous Dial: Blue Water Resistance: 5 ATM Diameter: 40.5 mm (without the crown) Thickness: 11.8 mm Weight: 70g This watch can also be paired with SRRY035.",
    description_jpn:
      "100年を超える腕時計づくりの伝統を継承し、 世界に向けて日本の美意識を発信するウオッチブランド。 日本庭園をイメージした美しいダイヤルシリーズ。 こちらは品番：SRRY035とペアウォッチとしてお使いいただけます。こちらは男性用時計になります。 駆動方式 メカニカル 自動巻（手巻つき） 精度 日差＋45秒～－35秒 駆動期間 最大巻上時約41時間持続 ケース材質 ステンレス 裏ぶた：ステンレスとガラス ガラス材質 ボックス型ハードレックス バンド材質 皮革（カーフ） 中留 ワンプッシュ三つ折れ方式 防水 日常生活用強化防水（5気圧） 耐磁 あり ケースサイズ 厚さ: 11.8 ㎜ 横: 40.5 ㎜ 縦: 47.5 ㎜ 重さ 70.0 g 腕周り長さ（最長） 195 ㎜ その他仕様 シースルーバック スクリューバック (製造上の理由により、裏ぶたの向きには個体差があります) 簡易着脱レバー式バンド",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/seiko/Seiko_SARY155.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/seiko.png",
  },
  {
    id: "416",
    brand: "Seiko",
    sku: "SWFH090",
    product_eng: "Seiko Selection Silver/Pink Gold Ladies Watch",
    product_jpn:
      "SEIKO セイコーセレクション レディース腕時計 （シルバー/ピンクゴールド）",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥40,000",
    rrp_with_vat: "¥44,000",
    description_eng:
      "A watch that pursues basic functions and design. Drive system Solar radio correction accuracy Average monthly difference when not receiving ± 15 seconds Drive period Approximately 6 months when fully charged Approximately 1.5 years when power is saved Exterior Case material Stainless steel (partially pink gold plated) Back lid: Stainless steel Glass material Hard Rex Nakadome One-push three-fold method Other specifications waterproof Enhanced waterproof for daily life (10 bar) Magnetic resistance Yes Case size Thickness: 7.6 mm Horizontal: 25.2 mm Vertical: 31.4 mm Weight: 42.0 g Arm circumference (longest) 178 mm Other features Power save function Immediate start function Reception result display function Forced reception function Time difference correction function Automatic reception function Overcharge prevention function Needle position automatic correction function Radio wave correction function (receives standard radio waves from Japan, China, the United States, and Germany) Easy adjustment method",
    description_jpn:
      "セイコーの考える基本機能とデザイン性を追求したウオッチ。 駆動方式 ソーラー電波修正 精度 非受信時平均月差±15秒 駆動期間 フル充電時約6ヶ月間 パワーセーブ時約1.5年 外装 ケース材質 ステンレス（一部ピンクゴールド色めっき） 裏ぶた：ステンレス ガラス材質 ハードレックス 中留 ワンプッシュ三つ折れ方式 その他仕様 防水 日常生活用強化防水（10気圧） 耐磁 あり ケースサイズ 厚さ: 7.6 ㎜ 横: 25.2 ㎜ 縦: 31.4 ㎜ 重さ:42.0 g 腕周り長さ（最長） 178 ㎜ その他特徴 パワーセーブ機能 即スタート機能 受信結果表示機能 強制受信機能 時差修正機能 自動受信機能 過充電防止機能 針位置自動修正機能 電波修正機能（日本・中国・アメリカ・ドイツの標準電波を受信） らくらくアジャスト方式",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/seiko/Seiko_SWFH090.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/seiko.png",
  },
  {
    id: "417",
    brand: "Seiko",
    sku: "SWFH089",
    product_eng: "Seiko Selection Silver Ladies Watch",
    product_jpn: "SEIKO セイコーセレクション レディース腕時計 （シルバー）",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥38,000",
    rrp_with_vat: "¥41,800",
    description_eng:
      "A watch that pursues basic functions and design. Drive system Solar radio correction accuracy Average monthly difference when not receiving ± 15 seconds Drive period Approximately 6 months when fully charged Approximately 1.5 years when power is saved Exterior Case material stainless Glass material Hard Rex Nakadome One-push three-fold method Other specifications waterproof Enhanced waterproof for daily life (10 bar) Magnetic resistance Yes Case size Thickness: 7.6 mm Horizontal: 25.2 mm Vertical: 31.4 mm Weight: 42.0 g Arm circumference (longest) 178 mm Other features Power save function Immediate start function Reception result display function Forced reception function Time difference correction function Automatic reception function Overcharge prevention function Needle position automatic correction function Radio wave correction function (receives standard radio waves from Japan, China, the United States, and Germany) Easy adjustment method",
    description_jpn:
      "セイコーの考える基本機能とデザイン性を追求したウオッチ。 駆動方式 ソーラー電波修正 精度 非受信時平均月差±15秒 駆動期間 フル充電時約6ヶ月間 パワーセーブ時約1.5年 外装 ケース材質 ステンレス ガラス材質 ハードレックス 中留 ワンプッシュ三つ折れ方式 その他仕様 防水 日常生活用強化防水（10気圧） 耐磁 あり ケースサイズ 厚さ: 7.6 ㎜ 横: 25.2 ㎜ 縦: 31.4 ㎜ 重さ:42.0 g 腕周り長さ（最長） 178 ㎜ その他特徴 パワーセーブ機能 即スタート機能 受信結果表示機能 強制受信機能 時差修正機能 自動受信機能 過充電防止機能 針位置自動修正機能 電波修正機能（日本・中国・アメリカ・ドイツの標準電波を受信） らくらくアジャスト方式",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/seiko/Seiko_SWFH089.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/seiko.png",
  },
  {
    id: "420",
    brand: "Seiko",
    sku: "SSVR139",
    product_eng: "Seiko Lukia Silver Round Watch ",
    product_jpn: "SEIKO セイコー ルキア ラウンドウォッチ (シルバー)",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥47,000",
    rrp_with_vat: "¥51,700",
    description_eng:
      "It blends in with any style or occasion to create a feminine hand.  <Movement> Caliber No.: V117 Driving System:Solar Accuracy: ±15 seconds per month on average Duration: Approx. 6 months on full charge Functions:Overcharge prevention function  <Case and band> Case Material: Stainless Steel Case coating: Platinum diamond shield Case Size:Thickness:6.5mm / Width:23.5mm / Height:28.5mm  Glass material: Sapphire Glass coating: Super clear coating Clasp: One-push three-fold closure Wrist circumference (maximum): 167.0mm   <Watch Specifications> Water resistance: 10 atmospheres Magnetic resistance: Yes Weight: 44.0g",
    description_jpn:
      "どんなスタイルやシーンにもなじんで女性らしい手元を演出する。  <ムーブメント> キャリバーNo:V117 駆動方式:ソーラー 精度:平均月差±15秒 駆動期間:フル充電時約６ヶ月間 機能:過充電防止機能  <ケース・バンド> ケース材質:ステンレス ケースコーティング:プラチナダイヤシールド ケースサイズ:厚さ:6.5mm/横:23.5mm/縦:28.5mm  ガラス材質:サファイア ガラスコーティング:スーパークリア コーティング 中留:ワンプッシュ三つ折れ方式 腕周り長さ（最長）:167.0mm   <時計仕様> 防水:日常生活用強化防水（10気圧） 耐磁:あり 重さ:44.0g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/seiko/Seiko_SSVR139.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/seiko.png",
  },
  {
    id: "421",
    brand: "Seiko",
    sku: "SSVR140",
    product_eng: "Seiko Lukia Silver/Pink Gold Round Watch",
    product_jpn:
      "SEIKO セイコー ルキア ラウンドウォッチ (シルバー/ピンクゴールド)",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥47,000",
    rrp_with_vat: "¥51,700",
    description_eng:
      "It blends in with any style or occasion to create a feminine hand.  <Movement> Caliber No.: V117 Driving System:Solar Accuracy: ±15 seconds per month on average Duration: Approx. 6 months on full charge Functions:Overcharge prevention function  <Case and band> Case Material: Stainless Steel Case coating: Platinum diamond shield Case Size:Thickness:6.5mm / Width:23.5mm / Height:28.5mm  Glass material: Sapphire Glass coating: Super clear coating Clasp: One-push three-fold closure Wrist circumference (maximum): 167.0mm   <Watch Specifications> Water resistance: 10 atmospheres Magnetic resistance: Yes Weight: 44.0g",
    description_jpn:
      "どんなスタイルやシーンにもなじんで女性らしい手元を演出する。  <ムーブメント> キャリバーNo:V117 駆動方式:ソーラー 精度:平均月差±15秒 駆動期間:フル充電時約６ヶ月間 機能:過充電防止機能  <ケース・バンド> ケース材質:ステンレス ケースコーティング:プラチナダイヤシールド ケースサイズ:厚さ:6.5mm/横:23.5mm/縦:28.5mm  ガラス材質:サファイア ガラスコーティング:スーパークリア コーティング 中留:ワンプッシュ三つ折れ方式 腕周り長さ（最長）:167.0mm   <時計仕様> 防水:日常生活用強化防水（10気圧） 耐磁:あり 重さ:44.0g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/seiko/Seiko_SSVR140.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/seiko.png",
  },
  {
    id: "422",
    brand: "Seiko",
    sku: "SSVR141",
    product_eng: "Seiko Lukia Black Round Watch",
    product_jpn: "SEIKO セイコー ルキア ラウンドウォッチ (ブラック)",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥47,000",
    rrp_with_vat: "¥51,700",
    description_eng:
      "It blends in with any style or occasion to create a feminine hand.  <Movement> Caliber No.: V117 Driving System:Solar Accuracy: ±15 seconds per month on average Duration: Approx. 6 months on full charge Functions:Overcharge prevention function  <Case and band> Case material: Stainless steel Case size: Thickness: 6.5mm / Width: 23.5mm / Height: 28.5mm  Glass material: Sapphire Glass coating: Super clear coating Clasp: One-push three-fold closure Wrist circumference (maximum): 167.0mm   <Watch Specifications> Water resistance: 10 atmospheres Magnetic resistance: Yes Weight: 44.0g",
    description_jpn:
      "どんなスタイルやシーンにもなじんで女性らしい手元を演出する。  <ムーブメント> キャリバーNo:V117 駆動方式:ソーラー 精度:平均月差±15秒 駆動期間:フル充電時約６ヶ月間 機能:過充電防止機能  <ケース・バンド> ケース材質:ステンレス ケースサイズ:厚さ:6.5mm/横:23.5mm/縦:28.5mm  ガラス材質:サファイア ガラスコーティング:スーパークリア コーティング 中留:ワンプッシュ三つ折れ方式 腕周り長さ（最長）:167.0mm   <時計仕様> 防水:日常生活用強化防水（10気圧） 耐磁:あり 重さ:44.0g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/seiko/Seiko_SSVR141.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/seiko.png",
  },
  {
    id: "424",
    brand: "ZMI",
    sku: "QB810B",
    product_eng: "ZMI Mobile battery 10000mAh Black",
    product_jpn: "ZMI ズーミー モバイルバッテリー10000mAh ブラック",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥2,363",
    rrp_with_vat: "¥2,599",
    description_eng:
      "The PowerPack 10000mAh is the thinnest and lightest battery pack on the market.  2 port input support (USB-C & MicroUSB)  High efficiency proprietary chip improves power exchange efficiency as well as safety.  ＊Since 2014, more than 110 million chargers/mobile batteries have been sold worldwide under the Mi and ZMI brands.  Dimensions: 5 × 2.71 × 0.5 in (127 × 69 × 12.7 mm) Weight: 6.24 oz (177 g)",
    description_jpn:
      "小型・軽量薄型、バックにもスマートに収納な大容量10000mAhモバイルバッテリー バッテリーの容量を確保し、重量を10%削減し、美しいフォルムと携帯性の両面が向上。 2ポート入力対応（USB-C & MicroUSB）  高効率独自開発チップ搭載により、安全性だけでなく、電力交換効率を向上します。 ※ 2014年以来、世界中で1億1000万台以上のチャージャー／モバイルバッテリーを「Mi」及び「ZMI」ブランドで販売しています。  サイズ \t127 × 69 × 12.7 mm 商品重量 \t177 グラム",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/zmi/ZMI_QB810B.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Zmi.png",
  },
  {
    id: "425",
    brand: "ZMI",
    sku: "QB810W",
    product_eng: "ZMI Mobile battery 10000mAh White",
    product_jpn: "ZMI ズーミー モバイルバッテリー10000mAh ホワイト",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥2,363",
    rrp_with_vat: "¥2,599",
    description_eng:
      "The PowerPack 10000mAh is the thinnest and lightest battery pack on the market.  2 port input support (USB-C & MicroUSB)  High efficiency proprietary chip improves power exchange efficiency as well as safety.  ＊Since 2014, more than 110 million chargers/mobile batteries have been sold worldwide under the Mi and ZMI brands.  Dimensions: 5 × 2.71 × 0.5 in (127 × 69 × 12.7 mm) Weight: 6.24 oz (177 g)",
    description_jpn:
      "小型・軽量薄型、バックにもスマートに収納な大容量10000mAhモバイルバッテリー バッテリーの容量を確保し、重量を10%削減し、美しいフォルムと携帯性の両面が向上。 2ポート入力対応（USB-C & MicroUSB）  高効率独自開発チップ搭載により、安全性だけでなく、電力交換効率を向上します。 ※ 2014年以来、世界中で1億1000万台以上のチャージャー／モバイルバッテリーを「Mi」及び「ZMI」ブランドで販売しています。  サイズ \t127 × 69 × 12.7 mm 商品重量 \t177 グラム",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/zmi/ZMI_QB810W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Zmi.png",
  },
  {
    id: "427",
    brand: "Victorinox",
    sku: "7743323G",
    product_eng: "Victorinox Grand Maitre Bread Knife",
    product_jpn: "Victorinox ビクトリノックス グランメートル ブレッドナイフ",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥18,000",
    rrp_with_vat: "¥19,800",
    description_eng:
      "The forged blade bread knife can be used as a highly reliable kitchen tool. No matter how thick the crust or how hard the skin is, this knife will cut it well. The wave blade and perfect balance ensure sharp sharpness. And its quality stays stable for a very long time. size height \t25 mm net weight \t306 g Blade length \t23 cm Handle material \tSynthetic material (POM)  Edge type \tWave blade  Whether to use a dishwasher / dryer \tYes",
    description_jpn:
      "鍛造ブレードのブレッドナイフは、高い信頼性を備えたキッチンツールとしてお使いいただけます。どんなに厚いパンの耳でも、どんなに堅いパンの皮でも、このナイフなら良く切れます。波刃と完璧なバランスにより、鋭い切れ味を約束します。そして、その品質は非常に長く安定感を保ちます。 重量：389g ブレードの長さ：23㎝",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_7743323G.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "428",
    brand: "Victorinox",
    sku: "06228WL",
    product_eng: "Victorinox Swiss Lite",
    product_jpn: "Victorinox ビクトリノックス スイスライト",
    category_1: "Leisure",
    category_2: "",
    rrp_ex_vat: "4,000",
    rrp_with_vat: "¥3,850",
    description_eng:
      "Small Pocket Knife with LED Light Thanks to its powerful LED light, this pocket knife lets you cut through the dark with style, so you can keep exploring in any condition. Travel light and fully equipped with seven functions including a screwdriver and scissors. As elegant as it is practical, the Swiss Lite encapsulates all the Victorinox spirit in a slick and iconic design. Tools 1.toothpick 2. small blade 3.scissors 4.nail file  5.screwdriver 2.5 mm 6.key ring  7.tweezers  8.LED Dimensions Height \t11 mm Net weight \t24 g scale material \tABS / Cellidor  Size \t58 mm",
    description_jpn:
      "スモール・マルチツール（LEDライト付き） パワフルなLEDライトを搭載したこのスタイリッシュなマルチツールがあれば、暗闇でも安心。洞窟を探検するにも、誰も起こさずに冷蔵庫から牛乳を取り出すにも、あらゆる場面でこのライトが行く手を照らしてくれます。マイナスドライバーやはさみなど、7機能を装備したトラベルライトです。 ツール 1.つまようじ  2.スモールブレード  3.はさみ  4.つめやすり 5.マイナスドライバー 2.5mm  6.キーリング  7.ピンセット 8.LEDライト サイズ 高さ\t11 mm 正味重量\t24 g スケール素材：ABS樹脂またはセリドール樹脂  サイズ\t58 mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_06228WL.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "429",
    brand: "Victorinox",
    sku: "6385",
    product_eng: "Victorinox Mini Champ",
    product_jpn: "Victorinox ビクトリノックス ミニチャンプ",
    category_1: "Leisure",
    category_2: "",
    rrp_ex_vat: "¥6,000",
    rrp_with_vat: "¥6,050",
    description_eng:
      "Small Pocket Knife with 18 Functions It's a little knife with big ambitions. With no less than 18 functions packed into a slim profile that easily slips into your pocket, the MiniChamp pocket knife is the champion among small knives. Keep it with you all day long and you won't even notice it's there. That is until duty calls, and then the MiniChamp is at your service. Pull it out and win the day. 1.toothpick  2.key ring  3.tweezers     4.pressurized ballpoint pen 5.small blade   6.blade  7.orange peeler  8.scraper 9.cuticle pusher  10.bottle opener 11. screwdriver 0/1, magnetic 12.wire stripper 13.nail file 14.nail cleaner 15.screwdriver 2.5 mm 16.ruler (cm) 17.ruler (inches) 18.scissors Dimensions Height \t15 mm Net weight \t45 g scale material \tABS / Cellidor  Size \t58 mm",
    description_jpn:
      "18機能を搭載したスモールマルチツール 大志を抱く小型ナイフ。「ミニチャンプ」の名のとおり、18機能を備えたスリムな逸品。簡単にポケットにも収まります。一日中持っていてもコンパクトで気になりません。必要なときにきちんと役割を果たします。いざという時に役立ててください。 1.つまようじ 2.キーリング 3.ピンセット 4.加圧ボールペン 5.スモールブレード 6.レターオープナー（ブレード） 7.オレンジピーラー 8.スクレーパー 9.甘皮押し 10.せん抜き 11.プラスドライバー（フィリップス型0/1） 12.ワイヤーストリッパー 13.つめやすり 14.つめそうじ 15.マイナスドライバー 2.5mm 16.スケール（cm） 17.スケール（inch） 18.はさみ サイズ 高さ\t15 mm 正味重量\t45 g 商品紹介 スケール素材\tABS樹脂またはセリドール樹脂  サイズ\t58 mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_6385.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "430",
    brand: "Victorinox",
    sku: "16795",
    product_eng: "Victrionox Swiss Champ",
    product_jpn: "Victorinox ビクトリノックス スイスチャンプ",
    category_1: "Leisure",
    category_2: "",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥11,000",
    description_eng:
      "The ultimate companion to strip wire, scale fish or saw metal for your indoor and outdoor life Swiss made pocket knife with 33 functions Includes pliers, scissors and a magnifying glass Height \t33 mm Length \t91 mm Weight \t185 g",
    description_jpn:
      "ミディアム・マルチツール（33機能） マルチツールと聞くと、伝説的なオフィサーナイフをイメージするかもしれません。その伝統は、「スイスチャンプ」にも引き継がれています。究極のマルチツールとして、無数の可能性を秘めた33の機能が一ヵ所に収められています。 サイズ 高さ\t33 mm 正味重量\t185 g 商品紹介 スケール素材\tABS樹脂またはセリドール樹脂  サイズ\t91 mm",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_16795.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "431",
    brand: "Victorinox",
    sku: "0.956163",
    product_eng: "Victorinox Ranger Wood 55",
    product_jpn: "Victorinox ビクトリノックス レンジャーウッド 55",
    category_1: "Leisure",
    category_2: "",
    rrp_ex_vat: "¥12,000",
    rrp_with_vat: "¥13,200",
    description_eng:
      "Swiss made pocket knife with 10 functions and elegant wood scales Includes a large lock blade and wood saw  Height \t22.5 mm Length \t130 mm Weight \t163 g",
    description_jpn:
      "ラージ・マルチツール（エレガントな木材を使用したハンドル） 実用性の高い「レンジャーウッド 55」なら、一日を通じて多くの作業に役立ちます。木材を切ることを考えてデザインされたのこぎりは、オークやマツ、ビーチウッドの枝を簡単に切れるので、キャンプファイヤーの焚き付けを準備するのに便利です。エレガントなウォールナットのハンドルは、周囲の自然とよく調和します。 ツール 1.キーリング 2.カン切り 3.マイナスドライバー 3mm 4.ラージブレード 5.せん抜き 6.マイナスドライバー 5mm 7.ワイヤーストリッパー 8.のこぎりサイズ\t130 mm 9.リーマー（穴あけ）、千枚通し 10.コルクせん抜き サイズ 高さ\t22.5 mm 長さ   130 mm 正味重量\t163 g スケール素材:ウォールナットウッド",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_956163.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "432",
    brand: "Victorinox",
    sku: "2416821",
    product_eng: "Victorinox I.N.O.X",
    product_jpn: "Victorinox ビクトリノックス I.N.O.X",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥78,000",
    rrp_with_vat: "¥85,800",
    description_eng:
      "We created the I.N.O.X. Watch to endure a life as adventurous as yours. It can handle a ten metre drop, being driven over by a 64-ton tank, a dive down to 200 metres below sea level and two hours in a washing machine at 90 degrees.  Net weight  133 g Details Movement  quartz  Shape of case  round  Diameter  43 mm Dial Colour  black  Bracelet material  genuine rubber  Bracelet colour  black  Lug width  21 mm Watch features  end-of-life-indicator  screw-down crown  scratch-resistant, triple-coated anti-reflective sapphire crystal  military time  date  Water resistance \t20 ATM/200 M/660 FT",
    description_jpn:
      "I.N.O.X.ウォッチは、冒険に満ちた人生を生き抜くためにつくられました。高さ10メートルから落下しても、総重量64トンの戦車の下敷きになっても耐える強度。耐水深度は200メートル。90℃のお湯をつかった洗濯機に投入して2時間作動しても機能に支障をきたさない耐久性。 正味重量 \t133 g ムーブメント  クォーツ  ケースの形状  ラウンド  直径  43 mm ダイヤルカラー \tブラック  ブレスレット素材  天然ラバーストラップ  ブレスレットカラー  ブラック  ラグ幅 \t21 mm 機能 \tEOL表示（電池切れ表示）  ねじ込み式リューズ  耐傷性サファイアクリスタル、無反射トリプルコーティング  ミリタリータイム  日付  防水 \t20気圧（200m）防水",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_2416821.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "433",
    brand: "Victorinox",
    sku: "241835",
    product_eng: "Victorinox I.N.O.X. Mechanical",
    product_jpn: "Victorinox ビクトリノックス I.N.O.X. Mechanical",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥120,000",
    rrp_with_vat: "¥132,000",
    description_eng:
      "Meet our I.N.O.X. timepiece in its freshest guise: the I.N.O.X. Mechanical. This addition switches quartz for, just as its name suggests, mechanical movement in an expertly engineered delicate mechanism. The intricate guilloche pattern on the dial is not only a standout, timeless detail, it's designed to mimic a Swiss Army Knife handle.  Dimensions Height \t75 mm Net weight 201 g Movement mechanical automatic  Shape of case stainless steel  Diameter  43 mm Dial Colour  blue  Bracelet material stainless steel  Bracelet colour  silver Lug width  21 mm Watch features \tscratch-resistant, triple-coated anti-reflective sapphire crystal  military time  screw-in caseback  screw-down crown  date  see-through caseback  Water resistance \t20 ATM/200 M/660 FT",
    description_jpn:
      "フレッシュな装いのI.N.O.X.タイムピース、I.N.O.X. Mechanicalをご紹介します。この新モデルはその名の通り、クォーツ式ではなく、高度な技術を活かし繊細なメカニズムを備えたメカニカル・ムーブメントを採用しています。ダイヤルの精緻なギョーシェ柄は、個性的でありながら流行に左右されず、マルチツールのハンドルを思わせるデザインです。 正味重量 \t201 g ムーブメント \tメカニカル自動巻き  ケースの形状 \tステンレススチール  直径 \t43 mm ダイヤルカラー \tブルー  ブレスレット素材 \tステンレススチール  ブレスレットカラー \tブラウン  ラグ幅 \t21 mm 機能 \t耐傷性サファイアクリスタル、無反射トリプルコーティング  ミリタリータイム  ねじ込み式スクリューケースバック  ねじ込み式リューズ  日付  シースルーケースバック  防水 \t20気圧（200m）防水",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_241835.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "434",
    brand: "Victorinox",
    sku: "241848",
    product_eng: "Victorinox FIELDFORCE",
    product_jpn: "Victorinox ビクトリノックス FIELDFORCE",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥46,000",
    rrp_with_vat: "¥50,600",
    description_eng:
      "Sporty, serious and masculine timepiece that thrives in any situation With Day-Date function Generously sized hands and numerals featuring Super-LumiNova® for easy day and night readability Dimensions Height \t11.3 mm Net weight \t64.7 g Details Movement \tquartz  Shape of case \tround  Diameter \t42 mm Dial Colour \tblue  Bracelet material \tleather  Bracelet colour \tbrown  Lug width \t21 mm Watch features \tdate  day of the week  scratch-resistant, triple-coated anti-reflective sapphire crystal  screw-in caseback  Water resistance \t10 ATM/100 M/330 FT  Dimensions Height \t11.3 mm Net weight \t64.7 g",
    description_jpn:
      "先端にあり続けるために 「Fieldforce」は、常に先端を行くために不可欠な存在。鮮明なレッドの秒針、マルチツールをイメージしたカウンターウェイト、ダイヤルにレッドのクロス＆シールドを備えています。スーパールミノバを採用した明瞭なディスプレイは昼夜を問わず優れた視認性を誇り、頑健でダイナミックなデザインがモダンな中にビクトリノックスのルーツを感じさせます。 正味重量\t64.7 g 商品紹介 ムーブメント クォーツ  ケースの形状 ラウンド  直径 42 mm ダイヤルカラー\tブルー  ブレスレット素材 レザー  ブレスレットカラー  ブラウン  ラグ幅\t21 mm 機能\t日付  曜日  耐傷性サファイアクリスタル、無反射トリプルコーティング  ねじ込み式スクリューケースバック  防水\t10気圧（100m）防水",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_241848.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "435",
    brand: "Victorinox",
    sku: "611475",
    product_eng: "Victorinox CORDURA® Deluxe Backpack ",
    product_jpn:
      "Victorinox ビクトリノックス CORDURA® デラックス バックパック ",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥28,000",
    rrp_with_vat: "¥30,800",
    description_eng:
      "Crafted from extra durable, water-repellent CORDURA® fabric Designed to bring maximum comfort and convenience to working life With trolley pass-thru sleeve and accessory roll Size \t20 x 35 x 45 cm Weight \t1.4 kg",
    description_jpn:
      "耐久性抜群で撥水性を備えたCORDURA®ファブリック製 ワーキングライフに最大限の快適性と利便性をもたらすデザイン パススルー式トロリースリーブとアクセサリーロール搭載 サイズ\t20 x 35 x 45 cm 重量\t1.4 kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611475.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "437",
    brand: "Victorinox",
    sku: "611759",
    product_eng: "Victorinox Spectra 3.0 Expandable Medium Case Black",
    product_jpn:
      "Victorinox ビクトリノックス スペクトラ 3.0 エキスパンダブル ミディアム ケース ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥70,000",
    rrp_with_vat: "¥77,000",
    description_eng:
      "8-Wheel Expandable Travel Case  Made with SORPLAS™, a high performance recycled polycarbonate,  the Spectra 3.0 Expandable Medium Case is designed with sustainability in mind.  It also features improved handle stability, a restyled interior with two large mesh pockets, and elastic X-straps for flexible packing.  Need more space? Just unzip the self-expanding compartment for up to 40% extra capacity. When was travel this easy?  <Dimensions> Height:27.2 in Length:11.8 in Width :18.1 in <Details> Material:Polycarbonate  Handle :Dual-tube Telescopic Handle  Wheels :4 wheel dual caster (spinner)  Capacity :81 l Expandable capacity :113 l",
    description_jpn:
      "8ホイール エキスパンダブル トラベルケース  高性能な再生プラスチックSORPLAS™を使用したスペクトラ 3.0 エキスパンダブル ミディアム ケースは、サステナビリティを考慮したデザインです。 また、ハンドルの安定性が向上し、大きなメッシュポケット2つ、フレキシブルなパッキングを可能にするX字型の伸縮性ストラップが付属し、内部のデザインも新しくなっています。 荷物が増えたときは、自動エキスパンダブル コンパートメントのジッパーを開けて最大40%まで容量を増やせます。さらなる快適な旅を実現。  <サイズ> 高さ:69 cm 長さ:30 cm 幅:46 cm <商品紹介> 素材 :ポリカーボネート ハンドル :二重管式テレスコピックハンドル  ホイール :4輪デュアルキャスター（スピナー）  容量 \t81 l 拡張可能な容量 \t113 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611759.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611759_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611759_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611759_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "438",
    brand: "Victorinox",
    sku: "611760",
    product_eng: "Victorinox Spectra 3.0 Expandable Medium Case Red",
    product_jpn:
      "Victorinox ビクトリノックス スペクトラ 3.0 エキスパンダブル ミディアム ケース レッド",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥70,000",
    rrp_with_vat: "¥77,000",
    description_eng:
      "8-Wheel Expandable Travel Case  Made with SORPLAS™, a high performance recycled polycarbonate,  the Spectra 3.0 Expandable Medium Case is designed with sustainability in mind.  It also features improved handle stability, a restyled interior with two large mesh pockets, and elastic X-straps for flexible packing.  Need more space? Just unzip the self-expanding compartment for up to 40% extra capacity. When was travel this easy?  <Dimensions> Height:27.2 in Length:11.8 in Width :18.1 in <Details> Material:Polycarbonate  Handle :Dual-tube Telescopic Handle  Wheels :4 wheel dual caster (spinner)  Capacity :81 l Expandable capacity :113 l",
    description_jpn:
      "8ホイール エキスパンダブル トラベルケース  高性能な再生プラスチックSORPLAS™を使用したスペクトラ 3.0 エキスパンダブル ミディアム ケースは、サステナビリティを考慮したデザインです。 また、ハンドルの安定性が向上し、大きなメッシュポケット2つ、フレキシブルなパッキングを可能にするX字型の伸縮性ストラップが付属し、内部のデザインも新しくなっています。 荷物が増えたときは、自動エキスパンダブル コンパートメントのジッパーを開けて最大40%まで容量を増やせます。さらなる快適な旅を実現。  <サイズ> 高さ:69 cm 長さ:30 cm 幅:46 cm <商品紹介> 素材 :ポリカーボネート ハンドル :二重管式テレスコピックハンドル  ホイール :4輪デュアルキャスター（スピナー）  容量 \t81 l 拡張可能な容量 \t113 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611760.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611760_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611760_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611760_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "439",
    brand: "Victorinox",
    sku: "611761",
    product_eng: "Victorinox Spectra 3.0 Expandable Large Case Black",
    product_jpn:
      "Victorinox ビクトリノックス スペクトラ 3.0 エキスパンダブル ラージ ケース ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥77,000",
    rrp_with_vat: "¥84,700",
    description_eng:
      "8-Wheel Expandable Travel Case  Made with SORPLAS™, a high performance recycled polycarbonate, our Spectra 3.0 Expandable Large Case is designed with sustainability in mind.  It also features improved handle stability, a restyled interior with two large mesh pockets, and elastic X-straps for flexible packing. Need more space? Just unzip the self-expanding compartment for up to 40% extra capacity. When was travel this easy?  <Dimensions> Height: 29.5 in Length: 12.6 in Width: 20.1 in <Details> Material:Polycarbonate  Handle:Dual-tube Telescopic Handle  Wheels:4 wheel dual caster (spinner)  Capacity :103 l Expandable capacity: 143 l",
    description_jpn:
      "高性能な再生プラスチックSORPLAS™を使用したスペクトラ 3.0 エキスパンダブル ラージ ケースは、サステナビリティを考慮したデザインです。 また、ハンドルの安定性が向上し、大きなメッシュポケット2つ、フレキシブルなパッキングを可能にするX字型の伸縮性ストラップが付属し、内部のデザインも新しくなっています。 荷物が増えたときは、自動エキスパンダブル コンパートメントのジッパーを開けて最大40%まで容量を増やせます。さらなる快適な旅を実現。  <サイズ> 高さ: 75 cm 長さ: 32 cm 幅 :  51 cm <商品紹介> 素材:ポリカーボネート ハンドル:二重管式テレスコピックハンドル  ホイール:4輪デュアルキャスター（スピナー） 容量: 103 l 拡張可能な容量: 143 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611761.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611761_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611761_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611761_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "440",
    brand: "Victorinox",
    sku: "611762",
    product_eng: "Victorinox Spectra 3.0 Expandable Large Case Red",
    product_jpn:
      "Victorinox ビクトリノックス スペクトラ 3.0 エキスパンダブル ラージ ケース レッド",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥77,000",
    rrp_with_vat: "¥84,700",
    description_eng:
      "8-Wheel Expandable Travel Case  Made with SORPLAS™, a high performance recycled polycarbonate, our Spectra 3.0 Expandable Large Case is designed with sustainability in mind.  It also features improved handle stability, a restyled interior with two large mesh pockets, and elastic X-straps for flexible packing. Need more space? Just unzip the self-expanding compartment for up to 40% extra capacity. When was travel this easy?  <Dimensions> Height: 29.5 in Length: 12.6 in Width: 20.1 in <Details> Material:Polycarbonate  Handle:Dual-tube Telescopic Handle  Wheels:4 wheel dual caster (spinner)  Capacity :103 l Expandable capacity: 143 l",
    description_jpn:
      "高性能な再生プラスチックSORPLAS™を使用したスペクトラ 3.0 エキスパンダブル ラージ ケースは、サステナビリティを考慮したデザインです。 また、ハンドルの安定性が向上し、大きなメッシュポケット2つ、フレキシブルなパッキングを可能にするX字型の伸縮性ストラップが付属し、内部のデザインも新しくなっています。 荷物が増えたときは、自動エキスパンダブル コンパートメントのジッパーを開けて最大40%まで容量を増やせます。さらなる快適な旅を実現。  <サイズ> 高さ: 75 cm 長さ: 32 cm 幅 :  51 cm <商品紹介> 素材:ポリカーボネート ハンドル:二重管式テレスコピックハンドル  ホイール:4輪デュアルキャスター（スピナー） 容量: 103 l 拡張可能な容量: 143 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611762.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611762_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611762_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611762_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "441",
    brand: "Victorinox",
    sku: "611753",
    product_eng: "Victorinox Spectra 3.0 Expandable Global Carry-On Black",
    product_jpn:
      "Victorinox ビクトリノックス スペクトラ 3.0 エキスパンダブル グローバル キャリーオン ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥58,000",
    rrp_with_vat: "¥63,800",
    description_eng:
      "8-Wheel Expandable Cabin Case  Made from SORPLAS™, a high-performance recycled plastic, the Spectra 3.0 Expandable Global Carry-On was built with the earth and performance first in mind. Durable, stylish, and versatile storage options make this case a comfortable way to travel. Expansion system expands capacity by up to 20%. Compartments open in the front for quick access to your stored business essentials. You will truly feel free to travel.  <Size> Height: 55 cm Length: 20 cm Width: 40 cm <Product Description> Material: Sorplas™ polycarbonate Handle: Dual tube telescopic handle  Wheels: 4-wheel dual casters (spinner) Capacity: 39 l Expandable capacity: 47 l",
    description_jpn:
      "8ホイール エキスパンダブル キャビンケース  高性能な再生プラスチックSORPLAS™を使用したスペクトラ 3.0 エキスパンダブル グローバル キャリーオンは、地球と性能を第一に考えてつくられました。 耐久性抜群でスタイリッシュ、多用途な収納オプションを備えたケースで、快適な旅が実現します。 エキスパンションシステムで容量が最大20%拡張可能。コンパートメントはフロントオープンで、収納したビジネスの必需品にクイックアクセス。まさに自由な旅を実感できます。  <サイズ> 高さ: 55 cm 長さ: 20 cm 幅  : 40 cm <商品紹介> 素材: Sorplas™ ポリカーボネート ハンドル: 二重管式テレスコピックハンドル  ホイール: 4輪デュアルキャスター（スピナー） 容量:  39 l 拡張可能な容量: 47 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611753.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611753_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611753_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611753_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "442",
    brand: "Victorinox",
    sku: "602101",
    product_eng: "Victorinox Lexicon Frequent Flyer Black",
    product_jpn:
      "Victorinox ビクトリノックス レキシコン フリークエントフライヤー ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥52,000",
    rrp_with_vat: "¥57,200",
    description_eng:
      "Super-recessed wheels and haul handles to maximise carry-on dimensions X-shaped compression straps and two zippered mesh accessories pockets Integrated multi-tool (pen, sim card replacement tool, ID tag) with USB port Practical interior pocket for a portable power pack connecting to the USB adapter Size \t23 x 35 x 55 cm Capacity \t34 l Weight \t3.1 kg",
    description_jpn:
      "深く埋め込まれたホイールとハンドルでキャリーオンの収納スペースを最大化 X字型コンプレッション・ストラップとジッパー式のメッシュのアクセサリーポケット2つ サイズ23 x 35 x 55 cm 正味重量 3.1 kg 商品紹介 ホイール\tデュアル・キャスター  素材\tポリカーボネイト  容量\t34 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_602101.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_602101_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_602101_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "443",
    brand: "Victorinox",
    sku: "602102",
    product_eng: "Victorinox Lexicon Frequent Flyer Titanium",
    product_jpn:
      "Victorinox ビクトリノックス レキシコン フリークエントフライヤー チタン",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥52,000",
    rrp_with_vat: "¥57,200",
    description_eng:
      "Super-recessed wheels and haul handles to maximise carry-on dimensions X-shaped compression straps and two zippered mesh accessories pockets Integrated multi-tool (pen, sim card replacement tool, ID tag) with USB port Practical interior pocket for a portable power pack connecting to the USB adapter Size \t23 x 35 x 55 cm Capacity \t34 l Weight \t3.1 kg",
    description_jpn:
      "深く埋め込まれたホイールとハンドルでキャリーオンの収納スペースを最大化 X字型コンプレッション・ストラップとジッパー式のメッシュのアクセサリーポケット2つ サイズ23 x 35 x 55 cm 正味重量 3.1 kg 商品紹介 ホイール\tデュアル・キャスター  素材\tポリカーボネイト  容量\t34 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_602102.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_602102_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_602102_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "444",
    brand: "Victorinox",
    sku: "612497",
    product_eng: "Victorinox AIROX Global Hardside Carry-on Black",
    product_jpn:
      "Victorinox ビクトリノックス エアロックス グローバルハードサイド キャリーオン ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      "<Ultralight Carry-On> The lightweight yet strong luggage that many travelers have been looking for is here. Now, it's time to embark on an adventure. The Aerox Global Hardside Carry-On is the lightest Victorinox travel case ever, weighing in at just 2.3kg. Made of tough 100% genuine polycarbonate, it has been rigorously tested for its outstanding durability. The smart butterfly opening/closing system makes packing easy. Large 60mm dual caster wheels with 360-degree maneuverability make it virtually weightless on the move.  Size  Height 55 cm Length 40 cm Width 20 cm Weight 2.3 kg Product Introduction Material Polycarbonate  Handle Mono-tube Telescopic Handle  Wheels 4 wheel dual caster (spinner)  Capacity 33 l",
    description_jpn:
      "＜超軽量キャリーオン＞ 多くの旅行者が求めていた、軽量でありながら強靭なラゲッジがついに登場。 さあ、冒険に旅立ちましょう。 「エアロックス グローバル ハードサイド キャリーオン」は、ビクトリノックスのトラベルケースでも最軽量の重量2.3kgを実現した、画期的なモデルです。 強靭な100%純正ポリカーボネート製で、その卓越した耐久性は厳しいテストによって実証済みです。スマートなバタフライ開閉システムでパッキングも楽々。 360度の操作性を備えた大型の60mmデュアル・キャスター・ホイールで、移動の際もほとんど重さを感じさせません。   サイズ  高さ \t55 cm 長さ \t40 cm 幅 \t20 cm 重さ \t2.3 kg 商品紹介 素材 \tPolycarbonate  ハンドル \tMono-tube Telescopic Handle  ホイール \t4 wheel dual caster (spinner)  容量 \t33 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612497.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612497_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612497_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "445",
    brand: "Victorinox",
    sku: "612498",
    product_eng: "Victorinox AIROX Global Hardside Carry-on Red",
    product_jpn:
      "Victorinox ビクトリノックス エアロックス グローバルハードサイド キャリーオン レッド",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      "<Ultralight Carry-On> The lightweight yet strong luggage that many travelers have been looking for is here. Now, it's time to embark on an adventure. The Aerox Global Hardside Carry-On is the lightest Victorinox travel case ever, weighing in at just 2.3kg. Made of tough 100% genuine polycarbonate, it has been rigorously tested for its outstanding durability. The smart butterfly opening/closing system makes packing easy. Large 60mm dual caster wheels with 360-degree maneuverability make it virtually weightless on the move.  Size  Height 55 cm Length 40 cm Width 20 cm Weight 2.3 kg Product Introduction Material Polycarbonate  Handle Mono-tube Telescopic Handle  Wheels 4 wheel dual caster (spinner)  Capacity 33 l",
    description_jpn:
      "＜超軽量キャリーオン＞ 多くの旅行者が求めていた、軽量でありながら強靭なラゲッジがついに登場。 さあ、冒険に旅立ちましょう。 「エアロックス グローバル ハードサイド キャリーオン」は、ビクトリノックスのトラベルケースでも最軽量の重量2.3kgを実現した、画期的なモデルです。 強靭な100%純正ポリカーボネート製で、その卓越した耐久性は厳しいテストによって実証済みです。スマートなバタフライ開閉システムでパッキングも楽々。 360度の操作性を備えた大型の60mmデュアル・キャスター・ホイールで、移動の際もほとんど重さを感じさせません。   サイズ  高さ \t55 cm 長さ \t40 cm 幅 \t20 cm 重さ \t2.3 kg 商品紹介 素材 \tPolycarbonate  ハンドル \tMono-tube Telescopic Handle  ホイール \t4 wheel dual caster (spinner)  容量 \t33 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612498.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612498_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612498_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "446",
    brand: "Victorinox",
    sku: "612499",
    product_eng: "Victorinox AIROX Global Hardside Carry-on Silver",
    product_jpn:
      "Victorinox ビクトリノックス エアロックス グローバルハードサイド キャリーオン シルバー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      "<Ultralight Carry-On> The lightweight yet strong luggage that many travelers have been looking for is here. Now, it's time to embark on an adventure. The Aerox Global Hardside Carry-On is the lightest Victorinox travel case ever, weighing in at just 2.3kg. Made of tough 100% genuine polycarbonate, it has been rigorously tested for its outstanding durability. The smart butterfly opening/closing system makes packing easy. Large 60mm dual caster wheels with 360-degree maneuverability make it virtually weightless on the move.  Size  Height 55 cm Length 40 cm Width 20 cm Weight 2.3 kg Product Introduction Material Polycarbonate  Handle Mono-tube Telescopic Handle  Wheels 4 wheel dual caster (spinner)  Capacity 33 l",
    description_jpn:
      "＜超軽量キャリーオン＞ 多くの旅行者が求めていた、軽量でありながら強靭なラゲッジがついに登場。 さあ、冒険に旅立ちましょう。 「エアロックス グローバル ハードサイド キャリーオン」は、ビクトリノックスのトラベルケースでも最軽量の重量2.3kgを実現した、画期的なモデルです。 強靭な100%純正ポリカーボネート製で、その卓越した耐久性は厳しいテストによって実証済みです。スマートなバタフライ開閉システムでパッキングも楽々。 360度の操作性を備えた大型の60mmデュアル・キャスター・ホイールで、移動の際もほとんど重さを感じさせません。   サイズ  高さ \t55 cm 長さ \t40 cm 幅 \t20 cm 重さ \t2.3 kg 商品紹介 素材 \tPolycarbonate  ハンドル \tMono-tube Telescopic Handle  ホイール \t4 wheel dual caster (spinner)  容量 \t33 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612499.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612499_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612499_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "447",
    brand: "Victorinox",
    sku: "612509",
    product_eng: "Victorinox AIROX Large Hardside Black",
    product_jpn:
      "Victorinox ビクトリノックス エアロックス ラージハードサイド ブラック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥60,000",
    rrp_with_vat: "¥66,000",
    description_eng:
      "<Ultralightweight travel case> The Aerox Large Hardside is the very embodiment of Victorinox innovation. First, it is among the lightest luggage on the market today. Second, it is made of 100% genuine polycarbonate, a material that puts exceptional durability front and center. Third, it weighs almost nothing, thanks to dual 60mm caster wheels that provide 360-degree maneuverability. In addition, the use of HINOMOTO wheels with silent Lisof tires reaches the ultimate in Swiss manufacturing excellence.  Size  Height 75 cm Length 50 cm Width 32 cm Weight 4.1 kg Product Introduction Material Polycarbonate  Handle Mono-tube Telescopic Handle  Wheels 4 wheel dual caster (spinner)  Capacity 98 l",
    description_jpn:
      "＜超軽量トラベルケース＞ 「エアロックス ラージ ハードサイド」はまさにビクトリノックスの革新性を体現。 第一に、現在市販されているラゲッジでは世界最軽量クラスです。 第二に、卓越した耐久性を前面に出した素材、100%純正ポリカーボネートを採用しています。 第三に、360度の操作性を実現する60mmデュアル・キャスター・ホイールにより、ほとんど重さを感じさせません。加えて、静音性に優れたLisofタイヤを採用したHINOMOTO社製ホイールを用いることで、スイスが誇る優れた製造技術の極致に到達。  サイズ  高さ \t75 cm 長さ \t50 cm 幅 \t32 cm 重さ \t4.1 kg 商品紹介 素材 \tPolycarbonate  ハンドル \tMono-tube Telescopic Handle  ホイール \t4 wheel dual caster (spinner)  容量 \t98 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612509.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612509_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612509_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "448",
    brand: "Victorinox",
    sku: "612510",
    product_eng: "Victorinox AIROX Large Hardside Red",
    product_jpn:
      "Victorinox ビクトリノックス エアロックス ラージハードサイド レッド",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥60,000",
    rrp_with_vat: "¥66,000",
    description_eng:
      "<Ultralightweight travel case> The Aerox Large Hardside is the very embodiment of Victorinox innovation. First, it is among the lightest luggage on the market today. Second, it is made of 100% genuine polycarbonate, a material that puts exceptional durability front and center. Third, it weighs almost nothing, thanks to dual 60mm caster wheels that provide 360-degree maneuverability. In addition, the use of HINOMOTO wheels with silent Lisof tires reaches the ultimate in Swiss manufacturing excellence.  Size  Height 75 cm Length 50 cm Width 32 cm Weight 4.1 kg Product Introduction Material Polycarbonate  Handle Mono-tube Telescopic Handle  Wheels 4 wheel dual caster (spinner)  Capacity 98 l",
    description_jpn:
      "＜超軽量トラベルケース＞ 「エアロックス ラージ ハードサイド」はまさにビクトリノックスの革新性を体現。 第一に、現在市販されているラゲッジでは世界最軽量クラスです。 第二に、卓越した耐久性を前面に出した素材、100%純正ポリカーボネートを採用しています。 第三に、360度の操作性を実現する60mmデュアル・キャスター・ホイールにより、ほとんど重さを感じさせません。加えて、静音性に優れたLisofタイヤを採用したHINOMOTO社製ホイールを用いることで、スイスが誇る優れた製造技術の極致に到達。  サイズ  高さ \t75 cm 長さ \t50 cm 幅 \t32 cm 重さ \t4.1 kg 商品紹介 素材 \tPolycarbonate  ハンドル \tMono-tube Telescopic Handle  ホイール \t4 wheel dual caster (spinner)  容量 \t98 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612510.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612510_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612510_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "449",
    brand: "Victorinox",
    sku: "612511",
    product_eng: "Victorinox AIROX Large Hardside Silver",
    product_jpn:
      "Victorinox ビクトリノックス エアロックス ラージハードサイド シルバー",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥60,000",
    rrp_with_vat: "¥66,000",
    description_eng:
      "<Ultralightweight travel case> The Aerox Large Hardside is the very embodiment of Victorinox innovation. First, it is among the lightest luggage on the market today. Second, it is made of 100% genuine polycarbonate, a material that puts exceptional durability front and center. Third, it weighs almost nothing, thanks to dual 60mm caster wheels that provide 360-degree maneuverability. In addition, the use of HINOMOTO wheels with silent Lisof tires reaches the ultimate in Swiss manufacturing excellence.  Size  Height 75 cm Length 50 cm Width 32 cm Weight 4.1 kg Product Introduction Material Polycarbonate  Handle Mono-tube Telescopic Handle  Wheels 4 wheel dual caster (spinner)  Capacity 98 l",
    description_jpn:
      "＜超軽量トラベルケース＞ 「エアロックス ラージ ハードサイド」はまさにビクトリノックスの革新性を体現。 第一に、現在市販されているラゲッジでは世界最軽量クラスです。 第二に、卓越した耐久性を前面に出した素材、100%純正ポリカーボネートを採用しています。 第三に、360度の操作性を実現する60mmデュアル・キャスター・ホイールにより、ほとんど重さを感じさせません。加えて、静音性に優れたLisofタイヤを採用したHINOMOTO社製ホイールを用いることで、スイスが誇る優れた製造技術の極致に到達。  サイズ  高さ \t75 cm 長さ \t50 cm 幅 \t32 cm 重さ \t4.1 kg 商品紹介 素材 \tPolycarbonate  ハンドル \tMono-tube Telescopic Handle  ホイール \t4 wheel dual caster (spinner)  容量 \t98 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612511.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612511_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612511_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "450",
    brand: "Victorinox",
    sku: "611804",
    product_eng: "Victorinox ALOX NERO",
    product_jpn: "Victorinox ビクトリノックス  アロックスネロ バックパック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥31,000",
    rrp_with_vat: "¥34,100",
    description_eng:
      "Sophisticated backpack with double pocket for cell phone The ALOX Nero Backpack combines cutting-edge style with smart business credibility. Designed to maximize space while minimizing bulk. Inside, the pockets hold a 15.6 laptop and a 10 tablet. With a holder for a bottle or folding umbrella, a double pocket for a cell phone, and a hidden security pouch, you'll be ready for your busy schedule.  Size  Height 42 cm Length 19 cm Width 31 cm Weight 1.1 kg  Material Nylon/leather  Capacity 17 l",
    description_jpn:
      "携帯電話用ダブルポケット装備の洗練されたバックパック アロックス ネロ バックパックは、最先端のスタイルとスマートなビジネスの信頼性が融合したバッグです。 スペースを最大限に活かしつつ、かさばらないデザイン。 中は15.6インチのラップトップと10インチのタブレットをポケットに収納できます。 ボトルや折り畳み傘のためのホルダー、携帯電話用ダブルポケット、隠しセキュリティ・ポーチを備え、多忙なスケジュールへの準備は万端です。  サイズ  高さ\t42 cm 長さ\t19 cm 幅\t31 cm 重さ\t1.1 kg  素材\tナイロン／レザー  容量\t17 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611804.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611804_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611804_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "451",
    brand: "Victorinox",
    sku: "611955",
    product_eng: "Victorinox ARCHITECTURE URBAN 2.0 City Back Pack",
    product_jpn:
      "Victorinox ビクトリノックス  アーキテクチャーアーバン2.0 シティバックパック",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥30,000",
    rrp_with_vat: "¥33,000",
    description_eng:
      "City backpack with pockets for laptop and tablet Functional items for every commute, so you're ready to move around the city. The Architecture Urban 2 City Backpack is built to lead the front lines. It offers a level of functionality and elastic fabric to protect all your electronic devices from all directions. It features a number of design details, including maximized storage space and a special anti-microbial lining.  Size  Height 42 cm Length 19 cm Width 30 cm Weight 1.1 kg  Material Polyester   Capacity 17 l",
    description_jpn:
      "ラップトップとタブレット用ポケットを備えたシティ バックパック あらゆる通勤に役立つ機能的なアイテムで、都会の移動は万全。 アーキテクチャー アーバン2 シティ バックパックは、最前線をリードするためにつくられています。 レベルアップした機能を備え、伸縮性のあるファブリックであらゆる電子デバイスを全方向から保護します。 最大限に活かされた収納スペース、特別な抗菌裏地をはじめ、デザインの細部に数々の工夫を凝らしています。  サイズ  高さ\t42 cm 長さ\t19 cm 幅\t30 cm 重さ\t1.1 kg  素材\tポリエステル   容量\t17 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611955.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611955_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_611955_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "452",
    brand: "Victorinox",
    sku: "611956",
    product_eng: "Victorinox ARCHITECTURE URBAN 2.1 Briefcase",
    product_jpn:
      "Victorinox ビクトリノックス  アーキテクチャーアーバン2.1 ブリーフケース",
    category_1: "Travel",
    category_2: "",
    rrp_ex_vat: "¥32,000",
    rrp_with_vat: "¥35,200",
    description_eng:
      "Premium Briefcase with Sound Pocket The briefcase reborn for the current era. An innovative and functional commuting partner. With exceptional functionality, the Architecture Urban 2 Briefcase is a business-focused bag. Its special antimicrobial lining makes daily commuting a breeze. With all-around protection for all your electronic devices, maximum storage space, and a dedicated sound pocket, this is the coolest commuter bag.  Size   Height 31 cm Length 13 cm Width 42 cm Weight 0.8 kg  Material Polyester Capacity 16 l",
    description_jpn:
      "サウンドポケット付きのプレミアム ブリーフケース 今の時代に合わせて生まれ変わったブリーフケース。革新的で機能的な通勤のパートナーです。 卓越した機能性を備えたアーキテクチャー アーバン2 ブリーフケースは、ビジネスに特化したバッグです。 特別な抗菌裏地を採用し、日々の通勤を快適にこなします。 あらゆる電子デバイスを全方向から保護し、最大限の収納スペース、専用のサウンドポケットを備えた、クールな通勤用バッグです。  サイズ  高さ\t31 cm 長さ\t13 cm 幅\t42 cm 重さ\t0.8 kg  素材\tポリエステル 容量\t16 l",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612498.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612498_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/victorinox/Victorinox_612498_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/victorinox.png",
  },
  {
    id: "453",
    brand: "Nintendo",
    sku: "464004",
    product_eng: "Nintendo THE LEGEND OF ZELDA",
    product_jpn: "Nintendo ゼルダの伝説 ブレス オブ ザ ワイルド 通常版",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥6,980",
    rrp_with_vat: "¥7,678",
    description_eng:
      "STEP INTO A WORLD OF ADVENTURE Forget everything you know about The Legend of Zelda games. Step into a world of discovery, exploration, and adventure in The Legend of Zelda: Breath of the Wild, a boundary-breaking new game in the acclaimed series. ",
    description_jpn:
      "広大な世界を舞台に、どこに行くのも、何をするのも、冒険のすべてがあなた次第。 駆ける、活きる、護る。果てなき冒険を思いのままに。 ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_464004.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "454",
    brand: "Nintendo",
    sku: "464012",
    product_eng: "Nintendo MARIOKART DELUXE",
    product_jpn: "Nintendo マリオカート８デラックス",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "Race and battle your friends in the definitive version of Mario Kart 8.",
    description_jpn:
      "あらゆる場所がサーキット。レース、バトル、すべてがデラックス。今までにないキャラクター、コース、マシンが加わり、『マリオカート8』がデラックスに。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_464012.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "455",
    brand: "Nintendo",
    sku: "464111",
    product_eng: "Nintendo MINE CRAFT",
    product_jpn: "Nintendo マインクラフト",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥3,600",
    rrp_with_vat: "¥3,960",
    description_eng:
      "Minecraft is a game about placing blocks and going on adventures. Explore randomly generated worlds and build amazing things from the simplest of homes to the grandest of castles.",
    description_jpn:
      "Minecraftがより大きく、より優れたものになりました!  モバイル、PC、ゲーム機など、デバイスをまたいで友達と一緒に遊ぼう。同じ画面で4人まで遊べる画面分割にも対応。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_464111.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "456",
    brand: "Nintendo",
    sku: "464186",
    product_eng: "Nintendo SUPER MARIO PARTY",
    product_jpn: "Nintendo スーパーマリオパーティ",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng: "Super-charged fun for everyone!",
    description_jpn: "いつでも、どこでも、スーパーなマリオパーティ。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_464186.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "457",
    brand: "Nintendo",
    sku: "464236",
    product_eng: "Nintendo SUPER SMASH BROS SPECIAL",
    product_jpn: "Nintendo 大乱闘スマッシュブラザーズ ＳＰＥＣＩＡＬ",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥7,200",
    rrp_with_vat: "¥7,920",
    description_eng:
      "New characters and stages join the entire legacy roster! Gaming icons clash in the ultimate brawl you can play anytime, anywhere! ",
    description_jpn:
      "ファイター数:75体 100以上のステージ ポケモン、アシストフィギュアもボリュームアップ 800曲以上のサウンド",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_464236.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "458",
    brand: "Nintendo",
    sku: "464262",
    product_eng: "Nintendo NEW SUPER MARIO BROTHERS U DELUXE",
    product_jpn: "Nintendo New スーパーマリオブラザーズ Ｕ デラックス",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng: "Two Super Mario Bros. games in one, for double the fun!",
    description_jpn:
      "おなじみの横スクロールマリオがNintendo Switchでデラックスに。 ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_464262.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "459",
    brand: "Nintendo",
    sku: "464370",
    product_eng: "Nintendo SUPER MARIO MAKER 2",
    product_jpn: "Nintendo スーパーマリオメーカー ２ 通常版",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "Make it Your Way, Play it Your Way. Mario fans of the world, unite! Now you can play, create, and share* the side-scrolling Super Mario™ courses of your dreams in the Super Mario Maker™ 2 game, available exclusively on the Nintendo Switch™ system!",
    description_jpn:
      " つくれ、あそべ、みんなでマリオ。 「スーパーマリオ」のコースを自由に作って遊ぶことができる『スーパーマリオメーカー』シリーズ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_464370.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "462",
    brand: "Nintendo",
    sku: "464585",
    product_eng: "Nintendo ANIMAL CROSSING: NEW HORIZONS",
    product_jpn: "Nintendo あつまれ どうぶつの森",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "2020 Award Winner - Best Family Escape to Your Personal Island Paradise!",
    description_jpn:
      " 無人島ではじまる、新生活。 現実と同じ時間が流れる世界で、自由気ままな毎日を過ごす「どうぶつの森」シリーズ。 ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_464585.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "463",
    brand: "Nintendo",
    sku: "464629",
    product_eng: "Nintendo CLUBHOUSE GAMES: 51 Worldwide Classics",
    product_jpn: "Nintendo 世界のアソビ大全５１",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥3,980",
    rrp_with_vat: "¥4,378",
    description_eng:
      "Discover and play 51 tabletop games from around the world",
    description_jpn:
      "Nintendo Switchをゲーム盤に見立てて遊べる定番ゲームなど、世界のゲーム51種類をギッシリ収録！",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_464629.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "466",
    brand: "Nintendo",
    sku: "465105",
    product_eng: "Nintendo Mario Party™ Superstars",
    product_jpn: "Nintendo マリオパーティー スーパースターズ",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "Play 100 classic minigames from the Nintendo 64 and Nintendo GameCube™ games and more in Mt. Minigames!",
    description_jpn:
      "歴代シリーズから、懐かしの「スゴロク」と、厳選した「ミニゲーム」をつめこんだ「マリオパーティ」。歴代「マリオパーティ」から、NINTENDO 64の「スゴロク」と、厳選した「ミニゲーム」をギュギュっとつめこんだ「マリオパーティ」です。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_465105.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "467",
    brand: "Nintendo",
    sku: "464761",
    product_eng: "KONAMI Momotaro Dentetsu-Shouwa Heisei Reiwa Mo Teiban! ",
    product_jpn: "KONAMI 桃太郎電鉄 昭和 平成 令和も定番!",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥6,300",
    rrp_with_vat: "¥6,930",
    description_eng:
      "Momotaro Dentetsu is a game in which you become the president of a railway company and aim to become the best in Japan in terms of total assets while acquiring properties all over the country. In Momotaro Dentetsu: Showa Heisei Reiwa mo Seikei! ～In Momotaro Dentetsu: Showa Heisei, many new stations and properties will be introduced.",
    description_jpn:
      "鉄道会社の社長になって、全国の物件を手に入れながら、総資産日本一を目指す「桃太郎電鉄」。 『桃太郎電鉄 ～昭和 平成 令和も定番！～』では、新たな駅や物件が多数登場します。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/KONAMI_464761.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "468",
    brand: "Nintendo",
    sku: "465252",
    product_eng: "Nintendo Kirby™ and the Forgotten Land",
    product_jpn: "Nintendo 星のカービィ ディスカバリー",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "Join Kirby on an unforgettable journey  Float off on an all-new adventure as the powerful puffball, Kirby. Explore 3D stages as you discover a mysterious world, save the kidnapped Waddle Dees, and defeat the ferocious Beast Pack. Hope you’re hungry for an unforgettable adventure!",
    description_jpn:
      "「星のカービィ」初の3Dアクション 「星のカービィ」シリーズ最新作の舞台は、文明と自然が融合した未知なる「新世界」。すって、はいて、飛んで、コピーして。奥行きのある3Dのステージを、カービィおなじみのアクションで自由に動き回って冒険します。  ◆ワドルディの救出を目指す 謎の敵「ビースト軍団」にさらわれたワドルディたちを助けるため、カービィの冒険が始まります。各ステージでは、ビースト軍団と戦ったり、仕掛けを解いたりしながら、ゴール地点にとらわれているワドルディたちの救出を目指します。  ◆進化する多彩なコピー能力 おなじみのコピー能力が3Dに生まれ変わるのはもちろん、新しいコピー能力「ドリル」「レンジャー」が登場。さらにコピー能力は「進化」することによって、“見た目”も“わざ”もパワーアップ。攻撃の手数が増えたり、攻撃範囲が広がったり、より多彩なアクションを楽しめます。  ◆新アクション「ほおばりヘンケイ」 新世界に散らばる車や自販機などをほおばることで特別なアクションができる「ほおばりヘンケイ」。ほおばるアイテムによって様々な姿に変化し、ステージの探索やワドルディの救出に大活躍します。  ◆カービィとバンダナワドルディで2人協力プレイ Joy-Conをおすそわけすれば、カービィとバンダナワドルディの2人で新世界を冒険することができます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_465252.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "469",
    brand: "Nintendo",
    sku: "465467",
    product_eng: "Nintendo Ace Angler: Fishing Spirits",
    product_jpn: "Nintendo 釣りスピリッツ 釣って遊べる水族館 通常版",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "Shake and spin the Joy-Con™, and feel like you're out on the ocean waves! The latest Ace Angler title is set in an aquarium-themed amusement park! Play the park's various attractions by yourself or with friends to collect Medals, which you can then use to upgrade your aquarium!  As well as the core fishing game Ace Angler, the title has many more features, including online competitions and a story mode in which the seas of the world must be rescued from toxic pollution. With a fun party mode featuring a range of aquatic animals and a medal pusher game to scoop huge riches, there is more to enjoy than ever before.  Learn fascinating facts about marine life in the aquarium, housing over 250 species!",
    description_jpn:
      "さぁ、夢が泳ぐ水族館テーマパークへ！ 一人でもみんなでも楽しい 「釣って遊べる水族館」に行こう！ Joy-Con™をふってまわして釣り体験が楽しめる、釣りスピリッツの舞台は「水族館テーマパーク」！ 1人でもみんなでも楽しめる「釣って・遊べるアトラクション」でメダルを集め、オオモノ達が泳ぐ水族館を大きくしましょう！  魚釣り体験ゲーム「釣りスピリッツ」はもちろん、オンラインで釣り人の頂点を目指すオンライン対戦や、毒の海から世界を救うストーリーモードを搭載。 更に、水の生き物達が登場するパーティーモードや、一攫千金を目指すメダル落としゲームなど、更に幅広い遊びの要素を楽しむことができます。  250種以上の生き物たちがいる水族館では、魚の知識も盛りだくさん！",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_465467.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "470",
    brand: "Nintendo",
    sku: "465411",
    product_eng: "Nintendo Splatoon™ 3",
    product_jpn: "Nintendo スプラトゥーン 3",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "Enter 4-on-4* ink-slinging battles in this colorful action shooter packed with style and attitude. As a squid-like Inkling, quickly cover your surroundings (and opponents) in ink with wild weaponry and swim through your own color to sneak and splat. Dive into the fresh fun with family and friends and make waves as a team. Get splatted by an opponent? No sweat! The goal in Turf War is to cover the most ground, so respawn and jump back into the inky action.",
    description_jpn:
      "大自然で！大都会で！ さらに広がるナワバリバトル！ ヒトの姿に変身する不思議なイカたちによる、アクションシューティングがパワーアップして登場！ 4対4のチームに分かれて、地面を塗った面積で勝敗を決める基本的なルールはそのままに、新たなブキやスペシャルウェポン、バトルアクションが追加。 オンラインでフレンドや見知らぬ人と対戦できることはもちろん、本体を持ち寄って仲間と顔を合わせての対戦も可能。 よりダイナミックになったナワバリバトルで、存分にインクを塗りたくれ！",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_465411.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "471",
    brand: "Nintendo",
    sku: "465423",
    product_eng: "Nintendo Taiko no Tatsujin: Rhythm Festival",
    product_jpn: "Nintendo 太鼓の達人 ドンダフルフェスティバル",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "Online Music Not Rated by the ESRB  Welcome to Omiko City, the stage for Taiko no Tatsujin: Rhythm Festival! A city full of everyone’s favorite Taiko elements is gathered into one town! Together with DON-Chan, meet your new friend, Kumo-kyun and aim to become a Taiko Master!  76 songs including Gurenge, Feel Special, and Into the Night are available in the game! As well as Improvement Support that helps you with upping your drumming skills!  Participate in Online Ranked Matches and battle against with players from around the world! There are other modes to enjoy with everyone, like DON-chan Band, where Players work as a group of 4 to perform successful concerts! Also Great Drum Toy War, where Players make a deck of toys for Taiko battles!  Have fun playing Taiko solo, or together with friends!",
    description_jpn:
      "ひとりでも！みんなでも！太鼓でトコトン アソビつくそう！ 今回の舞台は太鼓の世界がギュッと詰まった街、オミコシティ！ 相棒のどんちゃんとオミコシティで出会ったくもきゅんと一緒に太鼓マスターを目指そう！ 収録曲は「紅蓮華」「Feel Special」「夜に駆ける」など76曲を収録！ 苦手な部分は「上達サポート」で繰り返し練習してスキルアップ！ 「オンラインランクマッチ」では世界中のプレイヤーと演奏バトルを楽しめる！ 他にも、4人でライブの成功を目指す「どんちゃんバンド」やおもちゃでデッキを組んで演奏バトルを楽しむ「ドンカツおもちゃ大戦」などみんなで遊べる新モードも搭載！ ひとりでも！みんなでも！太鼓でトコトン アソビつくそう！",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_465423.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "472",
    brand: "Nintendo",
    sku: "465487",
    product_eng: "SEGA Puyo Puyo Tetris 2 Special Price",
    product_jpn: "SEGA ぷよぷよテトリス2 スペシャルプライス",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥3,500",
    rrp_with_vat: "¥3,850",
    description_eng:
      "Puyopuyo™ Tetris® 2 is now available at an affordable price!  The newest title in the PuyoPuyo™ Tetris® series, featuring the world-famous action puzzle game PuyoPuyo™ and Tetris®, is now available at an affordable price! PuyoPuyo™ Tetris® 2, the latest in the series, is now available at an affordable price! In addition to the well-known classic rules, many new rules, characters, and stories are included. Up to four players can play Puyo Puyo and Tetris together, both offline and online. A lesson mode for beginners is also included.",
    description_jpn:
      "国民的、世界的アクションパズルゲーム「ぷよぷよ」と「テトリス」が楽しめる シリーズ最新作『ぷよぷよ テトリス２』がお求めやすい価格になって登場！ おなじみの定番ルールに加えて、新たなルール、キャラクター、ストーリーなど多数の新要素を収録。 オフラインでもオンラインでも、最大4人でみんなでワイワイ「ぷよぷよ」と「テトリス」をプレイできる。 初心者でも安心のレッスンモードも搭載。  1.定番ルール＆新ルール「スキルバトル」を収録 新ルール「スキルバトル」では、チームを組んだキャラクター固有のスキルを使って攻撃や防御、一発逆転を狙う新しい遊び方が可能。 定番ルールの「VS」「スワップ」「ビッグバン」「パーティー」「ぷよテトミックス」も収録。 一人で遊べる「とことん」モードはオンラインランキングに対応。 「ぷよぷよ」と「テトリス」をすみずみまで遊びつくすことができます。  2.新キャラクターが登場する「アドベンチャー」モード 「アドベンチャー」モードでは、本作初登場のキャラクターと、これまでのシリーズに登場したキャラクターたちが掛け合うおなじみの「まんざいデモ」による新ストーリーが楽しめます。 ストーリークリア後も繰り返しプレイできるアイテム収集要素や、ミッションが用意されており、一人でもとことん遊べるやりこみ要素が充実しています。  3.初心者安心のレッスンや、充実のオンライン要素 初心者でも安心の、「ぷよぷよ」と「テトリス」をイチから学べる「レッスン」モードを収録。 「インターネット」モードでは、世界中のプレイヤーと最大4人までの対戦が楽しめます。 さらに、「全世界パズルリーグ」では、「ぷよぷよ」や「テトリス」のオンラインランキングでゲームの腕を競えます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_465487.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "474",
    brand: "Nintendo",
    sku: "695265",
    product_eng: "Nintendo Switch - Neon Blue + Neon Red Joy-Con",
    product_jpn: "Nintendo Switch 本体 (L)/(R) ネオンブルー/ネオンレッド",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥29,980",
    rrp_with_vat: "¥32,978",
    description_eng:
      "Changing Forms, Everywhere. The Nintendo Switch is a game console that changes form to suit different play scenarios. Anytime, anywhere, at will. You can enjoy games with your own style of play.  ＜Three modes of play＞ -TV Mode Enjoy games on a large-screen TV. Connect to a TV and enjoy games on a large, powerful screen, or gather in the living room for a home party with family and friends to enjoy games. -Table Mode Sharing the screen brings you closer together. By setting up the stand on the back of the console, you can share the controller and the screen to enjoy competitive or cooperative play even when you are away from home or in other places where there is no TV. -Portable Mode Take the large, beautiful display with you. You can easily play games anytime and anywhere, even while commuting to work or school. You can also get together with like-minded friends and enjoy playing games together via local communication.  <Set Contents> Nintendo Switch x 1 unit Nintendo Switch dock x 1 Joy-Con (L) Neon Blue x 1, Joy-Con (R) Neon Red x 1 Joy-Con Strap Black x 2 Joy-Con Grip x 1 HDMI cable (1.5m) x 1 Nintendo Switch AC Adapter x 1 pc Safety Guide x 1 pc",
    description_jpn:
      "カタチを変えて、どこへでも。 「Nintendo Switch」は、さまざまなプレイシーンにあわせてカタチを変えるゲーム機。 いつでも、どこでも、気の向くままに。自由なプレイスタイルでゲームを楽しむことができます。  ＜3つのプレイモード＞ ・TVモード 大画面テレビでゲームを楽しむ。 テレビにつなぎ、迫力の大画面でじっくりゲームを楽しんだり、家族や友達同士のホームパーティなど、リビングに集まってゲームを楽しんだりすることができます。 ・テーブルモード 画面をシェアすれば、距離も縮まる。 本体の背面のスタンドを立てれば、外出先などテレビのない場所でも、コントローラーを分け合い、画面をシェアして、対戦や協力プレイを楽しむことができます。 ・携帯モード 大きく美しいディスプレイを持ち歩く。 通勤や通学の移動中など、場所を選ぶことなく、いつでも、気軽にゲームをプレイすることができます。 気の合う仲間と集まって、ローカル通信でゲームを一緒に楽しむこともできます。  【セット内容】 Nintendo Switch本体×1台 Nintendo Switchドック×1個 Joy-Con（L）ネオンブルー×1本、Joy-Con（R）ネオンレッド×1本 Joy-Conストラップ ブラック×2個 Joy-Conグリップ×1個 HDMIケーブル（1.5m）×1本 Nintendo Switch ACアダプター×1個 セーフティガイド×1枚",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_695246.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "475",
    brand: "Nintendo",
    sku: "877591",
    product_eng: "Nintendo Joy-Con Charging Grip",
    product_jpn: "Nintendo Joy-con 充電グリップ",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥2,480",
    rrp_with_vat: "¥2,728",
    description_eng:
      "Combine the left and right Joy‑Con™ into one larger controller with this handy grip.",
    description_jpn:
      "「Joy-Con(L)」と「Joy-Con(R)」を取り付けて、グリップ型のコントローラーとして使用できます。Nintendo Switch本体セットに付属している「Joy-Conグリップ」とは異なり、付属のUSB充電ケーブルまたはNintendo Switch ACアダプターを使ってプレイ中に「Joy-Con」の充電もできるので、バッテリー切れの心配がありません。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/nintendo/Nintendo_877591.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "1050",
    brand: "Nintendo",
    sku: "465290",
    product_eng: "Nintendo Switch Sports",
    product_jpn: "Nintendo Switch スポーツ レッグバンド同梱版",
    category_1: "Electronics",
    category_2: "Gaming",
    rrp_ex_vat: "¥4,980",
    rrp_with_vat: "¥5,478",
    description_eng:
      "・Swing, kick, spike, and bowl your way to victory in a sports collection that will get the whole family moving ・Play online and face opponents near and far to earn in-game rewards or aim for the Pro League ・Play with friends and family in the same room or across the world ・This physical version of the Nintendo Switch Sports game includes the Leg Strap accessory to use in Soccer.  *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "「Wii Sports」シリーズの最新作『Nintendo Switch Sports』がNintendo Switchに登場。 本作は、Joy-Conを使った直感的な操作で、どなたでもお楽しみいただけます。  シリーズで人気の高かったボウリング、チャンバラ、テニス、ゴルフ（※）のほかに、新しくバレーボール、バドミントン、サッカーが加わりました。 サッカーでは、レッグバンドを使ってキック操作ができます（※）。  家族や友達と集まって遊ぶのはもちろん、すべての種目で遠く離れた友達や世界中の人とオンライン対戦ができます。 オンライン対戦で集めたアイテムでキャラクターを自分好みにカスタマイズしたり、各競技でランク上位を目指す「プロリーグ」で腕前を競ったり、さまざまな楽しみ方で遊べます。  ※「ゴルフ」、およびレッグバンドを使ってサッカーの全てのモードを楽しむには、ソフトのアップデートが必要です。 ※レッグバンドはパッケージ版に付属しています。 ※『リングフィット アドベンチャー』に付属するレッグバンドもご使用いただけます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/nintendo/Nintendo_465290.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "1051",
    brand: "Nintendo",
    sku: "465491",
    product_eng: "Nintendo Pokémon™ Scarlet",
    product_jpn: "Nintendo ポケットモンスター スカーレット",
    category_1: "Electronics",
    category_2: "Gaming",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "Welcome to the wide-open world of the Paldea region Catch, battle, and train Pokémon in the Paldea Region, a vast land filled with lakes, towering peaks, wastelands, small towns, and sprawling cities. Explore a wide-open world at your own pace and traverse land, water, and air by riding on a form-shifting Legendary Pokémon—Koraidon in the Pokémon Scarlet game and Miraidon in the Pokémon Violet game. Choose either Sprigatito, Fuecoco, or Quaxly, to be your first partner Pokémon before setting off on your journey through Paldea. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      '『ポケットモンスター』シリーズはオープンワールドへ。 ポケモンを捕まえたり、交換したり、育ててバトルに挑んだり。『ポケットモンスター』シリーズならではの遊びを、"オープンワールド"の世界で楽しめます。 大自然や街には、至る所にポケモンたちが息づいており、境目なく広がるフィールドを自由に冒険することができます。  １、最初のパートナー あなたは、くさタイプの「ニャオハ」、ほのおタイプの「ホゲータ」、みずタイプの「クワッス」の3匹の中から1匹を選び冒険に出ることになります。はたして、どのように出会い、どのような物語を繰り広げるのでしょうか。  ２、伝説のポケモン「コライドン」 他のポケモンたちをはるかに凌駕する力を持つといわれていますが、その生態は謎に包まれています。「コライドン」の背に乗ることで、陸を走ったり、水上を泳いだり、滑空したり、崖を登ったりすることができ、さらに冒険の幅が広がります。  ３、「テラスタル」 パルデア地方特有の現象で、この地で暮らすすべてのポケモンが「テラスタル」をすることができます。 ポケモンごとにそれぞれ「テラスタイプ」を持っており、「テラスタル」することで、「テラスタイプ」に変化します。ほとんどのポケモンは、元のタイプと同じ「テラスタイプ」を持っていますが、中には元のタイプと異なるタイプを持つポケモンもいるようです。 パルデア地方でのポケモンバトルでは、この「テラスタル」が、勝負のカギを握ります。  ４、通信でつながる 本作は最大で4人同時のマルチプレイが可能。ポケモン交換や対戦などの通信プレイはもちろん、他のプレイヤーと同じフィールドを駆け巡りながら、一緒に冒険することもできます。 また、野生のテラスタルしたポケモンに出会える「テラレイドバトル」にも他のプレイヤーと一緒に挑むことができます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。',
    product_image_1:
      "https://products.naganorewards.com/images/nintendo/Nintendo_465491.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "1052",
    brand: "Nintendo",
    sku: "465492",
    product_eng: "Nintendo Pokémon™ Violet",
    product_jpn: "Nintendo ポケットモンスター バイオレット",
    category_1: "Electronics",
    category_2: "Gaming",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      'Welcome to the wide-open world of the Paldea region Catch Pokemon, trade them, raise them, and challenge them to battle. You can enjoy the play unique to the "Pokemon" series in an "open world" world. Pokémon live everywhere in nature and cities, and you can freely explore fields that spread out without boundaries.  1. First Partner You will go on an adventure by choosing one of three animals: the grass type “Nyaoha”, the fire type “Hogeta”, and the water type “Kwassu”. How will they meet and what kind of story will unfold?  2. Legendary Pokemon "Miraidon" It is said to have a power that far exceeds that of other Pokemon, but its ecology is shrouded in mystery. By riding on Miraidon\'s back, you can run on land, swim on water, glide, and climb cliffs, further expanding your adventures.  3. ``Terrastal\'\' A phenomenon unique to the Paldea region, all Pokemon living in this area can perform ``Terrastal\'\'. Each Pokemon has a "Terrace Type", and by "Terrastal" it changes to a "Terrace Type". Most Pokemon have the same "terrace type" as their original type, but some Pokemon seem to have a different type from their original type. In Pokemon battles in the Paldea region, this "Terustal" holds the key to victory.  4. This game is connected via communication, allowing up to four players to play multiplayer at the same time. In addition to online play such as Pokemon exchange and battles, you can also run around the same field as other players and go on adventures together. You can also join other players in ``Terra Raid Battles,\'\' where you can encounter wild Terra Star Pokémon. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.',
    description_jpn:
      '『ポケットモンスター』シリーズはオープンワールドへ。 ポケモンを捕まえたり、交換したり、育ててバトルに挑んだり。『ポケットモンスター』シリーズならではの遊びを、"オープンワールド"の世界で楽しめます。 大自然や街には、至る所にポケモンたちが息づいており、境目なく広がるフィールドを自由に冒険することができます。  １、最初のパートナー あなたは、くさタイプの「ニャオハ」、ほのおタイプの「ホゲータ」、みずタイプの「クワッス」の3匹の中から1匹を選び冒険に出ることになります。はたして、どのように出会い、どのような物語を繰り広げるのでしょうか。  ２、伝説のポケモン「ミライドン」 他のポケモンたちをはるかに凌駕する力を持つといわれていますが、その生態は謎に包まれています。「ミライドン」の背に乗ることで、陸を走ったり、水上を泳いだり、滑空したり、崖を登ったりすることができ、さらに冒険の幅が広がります。  ３、「テラスタル」 パルデア地方特有の現象で、この地で暮らすすべてのポケモンが「テラスタル」をすることができます。 ポケモンごとにそれぞれ「テラスタイプ」を持っており、「テラスタル」することで、「テラスタイプ」に変化します。ほとんどのポケモンは、元のタイプと同じ「テラスタイプ」を持っていますが、中には元のタイプと異なるタイプを持つポケモンもいるようです。 パルデア地方でのポケモンバトルでは、この「テラスタル」が、勝負のカギを握ります。  ４、通信でつながる 本作は最大で4人同時のマルチプレイが可能。ポケモン交換や対戦などの通信プレイはもちろん、他のプレイヤーと同じフィールドを駆け巡りながら、一緒に冒険することもできます。 また、野生のテラスタルしたポケモンに出会える「テラレイドバトル」にも他のプレイヤーと一緒に挑むことができます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。',
    product_image_1:
      "https://products.naganorewards.com/images/nintendo/Nintendo_465492.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "1053",
    brand: "Nintendo",
    sku: "465862",
    product_eng: "Nintendo Game of Life for Nintendo Switch",
    product_jpn: "Nintendo 人生ゲーム for Nintendo Switch",
    category_1: "Electronics",
    category_2: "Gaming",
    rrp_ex_vat: "¥6,000",
    rrp_with_vat: "¥6,600",
    description_eng:
      "The popular board game is finally available on Nintendo Switch™! You can live to work. It's okay to live in love. Aim to become a millionaire with your own life! It retains the fun of the board game \"Game of Life\" where you spin the roulette wheel and move the pieces forward, but it also has many elements unique to Nintendo Switch! Create your own avatar, refine its parameters and grow yourself! The jobs you can get will change depending on the parameters! There are various occupations, such as office workers and doctors, which automatically rank up if you meet certain conditions, and baseball players and idols, which rank up by successfully playing roulette. There are many events for each occupation, so let's experience various occupations and have fun! You can live for work, or you can live for love. Spin the roulette wheel and live your own life.  Save data from childhood can be carried over to adulthood. Local battles can be played using the Nintendo Switch console, and online multiplayer with up to four players is also supported. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "あの大人気ボードゲームがNintendo Switch™に遂に登場！ 仕事に生きるもよし。恋愛に生きるもよし。 自分なりの人生で、目指せ億万長者！ ルーレットを回してコマを進めていくボードゲームの「人生ゲーム」の楽しさはそのままに、Nintendo Switchならではの要素が盛りだくさん！ 自分だけのアバターを創って、パラメータを磨いて自分を成長させよう！パラメータによって就職できる職業が変わってくるぞ！ 職業には会社員や医者など条件を満たせば自動でランクアップする職業や、野球選手やアイドルなどルーレットを成功させてランクアップする職業など様々。 職業ごとのイベントもたくさんあるので色々な職業を体験して楽しもう！ 仕事に生きるもよし、恋愛に生きるもよし。ルーレットを回して自分なりの人生を歩んでいこう。  子ども時代のセーブデータは大人時代に持ち越すことが可能。 Nintendo Switch本体を持ちよって遊ぶローカル対戦、フレンドと最大4人でのオンラインマルチプレイにも対応。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/nintendo/Nintendo_465862.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "1054",
    brand: "Nintendo",
    sku: "465871",
    product_eng: "Nintendo Super Mario Bros.™ Wonder",
    product_jpn: "Nintendo スーパーマリオブラザーズ ワンダー",
    category_1: "Electronics",
    category_2: "Gaming",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      'Enter a world of wonder with Mario and friends In order to save the Flower Kingdom, which has been taken over by Bowser, Mario and his friends run toward the goal pole while overcoming enemies and devices.  ◆Mysterious changes "Wonder" By touching the newly introduced item "Wonder Flower", the play of the course will change dramatically. Clay pipes start to move, hordes of enemies appear, transform into different forms, etc. Each course offers different surprises and excitement.  ◆Adventure with your favorite characters You can control 12 different characters, the most in the series, including Mario, Luigi, Toad, as well as Peach, Daisy, and Toad. Yoshi and Totten do not take damage, so even those who are not good at action games can feel at ease.  ◆Mario and friends transform into elephants The new power-up "Elephant Mario" runs around the course with actions that take advantage of his large body and long nose. In addition, "Our Mario" and "Drill Mario" are newly introduced. Mario and friends come alive in various forms with special abilities.  ◆Various actions expanded with badges "Badges" that can be obtained as you progress through the adventure have special effects that can change your performance and actions. You can customize your abilities to suit the characteristics of the course and your own preferences, such as using a hat to glide or shooting vines to stick to walls.  ◆Play together Up to 4 people can play by sharing the Joy-Cons. You can enjoy adventures with various combinations. If you connect online, players who are adventuring somewhere in the world at the same time will appear on the course or world map with a faint appearance. Even though you are in different worlds, you can help each other and go on adventures by greeting each other, saving people who have made mistakes, and sharing items. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.',
    description_jpn:
      "マリオと仲間でワンダーな世界へ クッパに乗っ取られた「フラワー王国」を救うため、マリオと仲間たちは敵や仕掛けを突破しながら、ゴールポールを目指して駆け抜けます。  ◆不思議な変化「ワンダー」 新登場のアイテム「ワンダーフラワー」に触れることで、コースの遊びが大きく変化。土管が動き出したり、敵の大群が出現したり、別の姿に変身したり…。コースごとに異なる驚きやワクワクが待っています。  ◆好きなキャラクターで冒険 マリオやルイージ、キノピオはもちろん、ピーチやデイジー、キノピコなどシリーズ最多の12種類のキャラクターが操作可能。ヨッシーとトッテンはダメージを受けないので、アクションゲームが得意でない方でも安心です。  ◆マリオたちがゾウに大変身 新たなパワーアップ「ゾウマリオ」は、大きな体と長い鼻を活かしたアクションでコース中を駆け回ります。他にも「アワマリオ」や「ドリルマリオ」が新登場。マリオたちは特別な能力を持ったいろんな姿で躍動します。  ◆バッジで広がる多彩なアクション 冒険を進めると入手できる「バッジ」は、性能やアクションを変更できる特殊な効果を持っています。帽子を使って滑空したり、つるを発射してカベにはりついたり、コースの特性や自分の好みにあわせて能力をカスタマイズできます。  ◆みんなで一緒にプレイ Joy-Conをおすそわけすれば、最大4人プレイが可能。さまざまな組み合わせで冒険を楽しめます。オンラインに接続すれば、同じ時間に世界のどこかで冒険しているプレイヤーが、コースやワールドマップにうすい見た目で出現。別の世界にいながらも、挨拶したり、ミスした相手を救ったり、アイテムを分け合うなど、お互いに助け合いながら一緒に冒険できます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/nintendo/Nintendo_465871.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "1055",
    brand: "Nintendo",
    sku: "466021",
    product_eng: "Nintendo Mario vs. Donkey Kong™",
    product_jpn: "Nintendo マリオvsドンキーコング",
    category_1: "Electronics",
    category_2: "Gaming",
    rrp_ex_vat: "¥4,980",
    rrp_with_vat: "¥5,478",
    description_eng:
      'Compare your wits wiDonkey Kong has stolen all the Mini-Mario toys from the factory, and it’s up to Mario to get them back! Run, jump, and backflip your way to retrieving them across over 130 levels in this puzzle-style twist on classic platforming action.  The rivalry that originally heated up on the Game Boy™ Advance system returns on the Nintendo Switch™ system with newly added co-op play, brand-new worlds, updated music and visuals, and other new ways to play.  ◆Difficulty level selectable In addition to the "Classic Mode", which has the same difficulty as the original, you can also choose the "Casual Mode", which can be easily enjoyed even by those who are not familiar with the game. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.',
    description_jpn:
      "ひらめきとアクションで、ドンキーコングと知恵比べ！ ゲームボーイアドバンスで繰りひろげられた因縁の対決が、Nintendo Switchで復活。 新しくなったグラフィックで、さまざまな仕掛けを解きながら、盗まれたおもちゃのミニマリオを取り返していきます。  ◆ドンキーコングから、ミニマリオを取り戻せ！ 人気のおもちゃ「ミニマリオ」が欲しいドンキーコングでしたが、既にミニマリオは売り切れ。そこでドンキーコングは工場に押し入り、全てのミニマリオを奪い去ります。マリオはミニマリオを取り戻すため、ドンキーコングを追いかけることに。  ◆攻略のコツは、ひらめきとアクション マリオを待ち受けているのは、仕掛けがいっぱいのステージ。カギを持って扉を開け、ミニマリオの所までたどり着けばクリアです。新しい道を作り出す“ひらめき”と、シビアな場面も乗り越える“アクション”で、全てのミニマリオを取り戻しましょう。  ◆2人で協力プレイ 今作では、Joy-Conをおすそわけすることで、2人で協力しながら進めることができます。1人ではクリアできなかったステージも、2人で役割を分担すれば、新しい道筋が見つかるかもしれません。  ◆2つの新ワールドが追加 原作に登場したワールドに加えて、新たに2つのワールドが追加。130以上のステージがマリオを待ち受けています。  ◆難易度を選択可能 原作と同じ難易度の「クラシックモード」に加えて、ゲームに慣れていない方でも気軽にお楽しみいただける「カジュアルモード」を選ぶことができます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/nintendo/Nintendo_466021.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "1056",
    brand: "Nintendo",
    sku: "466062",
    product_eng: "Nintendo Princess Peach™: Showtime!",
    product_jpn: "Nintendoプリンセスピーチ ショータイム！",
    category_1: "Electronics",
    category_2: "Gaming",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "Help Peach save the Sparkle Theater from the wicked Grape and the Sour Bunch, who have set the stage for the ultimate tragedy. Joined by Stella, the theater’s guardian, Peach is ready to save the day! *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "ピーチが主役のShowが幕を開ける たくさんの舞台が上演されている「キラメキ劇場」にやってきたピーチ姫御一行。そこに突如現れた「グレープ劇団」により、劇場が乗っ取られてしまいます。悲劇と化した舞台を救うため、ピーチはグレープ劇団に立ち向かいます。  ◆「ステラ」との協力 劇場を見守る妖精「ステラ」からもらったリボンの力で、舞台上で困っている人たちを助けたり、行く手を阻むグレープ劇団の手下と戦ったりします。  ◆ピーチが大変身 舞台の特別な場所に行くと、ピーチが変身。その舞台に合った衣装を身にまとったピーチは能力も変化します。華麗な剣さばきで敵を迎え撃つ剣士、証拠を集めて犯人を捜す探偵。ほかにもパティシエやカンフーの達人、忍者やカウガールなど、ピーチが変身できる衣装はさまざま。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/nintendo/Nintendo_466062.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "1057",
    brand: "Nintendo",
    sku: "695260",
    product_eng: "Nintendo Switch (Organic EL model) white",
    product_jpn: "Nintendo Switch本体 有機EL ホワイト",
    category_1: "Electronics",
    category_2: "Gaming",
    rrp_ex_vat: "¥34,527",
    rrp_with_vat: "¥37,980",
    description_eng:
      '"Nintendo Switch (organic EL model)" has been added as a new member of the Nintendo Switch family. You can enjoy games anytime, anywhere, and with anyone on the brightly colored screen that only an organic EL model can provide. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.',
    description_jpn:
      "Nintendo Switchファミリーの新しい仲間として「Nintendo Switch(有機ELモデル)」が加わりました。いつでも、どこでも、誰とでも、有機ELモデルならではの色鮮やかな画面でゲームを楽しむことができます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/nintendo/Nintendo_695260.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "1058",
    brand: "Nintendo",
    sku: "877592",
    product_eng: "Nintendo Switch Pro Controller",
    product_jpn: "Nintendo Switch Proコントローラー",
    category_1: "Electronics",
    category_2: "Gaming",
    rrp_ex_vat: "¥6,980",
    rrp_with_vat: "¥7,678",
    description_eng:
      "Wireless Controller with Grip Design for Comfortable Gaming  Ideal for long gaming sessions, supports TV mode and table mode for comfortable gameplay.  ※ Includes USB charging cable *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "長時間でも持ちやすく、TVモードやテーブルモードのゲームが快適にプレイできるグリップ型のワイヤレスコントローラーです。  ※USB充電ケーブル付属 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/nintendo/Nintendo_877592.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nintendo.png",
  },
  {
    id: "476",
    brand: "Bodum",
    sku: "1923-16",
    product_eng: "Bodum CHAMBORD 0.35L french press coffee maker",
    product_jpn: "Bodum ボダム  CHAMBORD 0.35L フレンチプレスコーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "Discover the art of the perfect brew with the CHAMBORD French press coffee maker. The French press system is beloved by coffee aficionados worldwide for its simplicity of brewing and purity of taste. And the CHAMBORD is the original and best French press coffee maker. Capacity 0.35 L Width (cm) 11.1 Height (cm) 16.8 Depth (cm) 8.0",
    description_jpn:
      "耐熱ガラスと金属フレームのコンビネーションは、まさにフレンチプレスの原型ともいえるデザイン。 黒いハンドルは握りやすさだけはなく、クラシックで上品な印象を与えています。 フレンチプレスは、最もコーヒー豆の成分を抽出するのに適した92℃～96℃のお湯の温度を目安に、ゆっくりと豆の膨らみを確かめるようにお湯を注ぐことで、コーヒー豆の旨みや香り、おいしさに必要な豆の油分（コーヒーオイル）を余すことなく抽出します。 コーヒー豆本来の味が最大限に引き出された豊かな味わいのコーヒーをお楽しみください。 容量 0.350 L 幅 (cm) 11.1  高さ (cm) 16.8  奥行き (cm) 8.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum%EF%BC%BF1923-16.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "477",
    brand: "Bodum",
    sku: "1924-16",
    product_eng: "Bodum CHAMBORD 0.5L french press coffee maker",
    product_jpn: "Bodum ボダム  CHAMBORD 0.5L フレンチプレスコーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,500",
    description_eng:
      "Discover the art of the perfect brew with the CHAMBORD French press coffee maker. The French press system is beloved by coffee aficionados worldwide for its simplicity of brewing and purity of taste. And the CHAMBORD is the original and best French press coffee maker. Capacity 0.5 L Width (cm) 16.6 Height (cm) 19.0 Depth (cm) 10.5",
    description_jpn:
      "耐熱ガラスと金属フレームのコンビネーションは、まさにフレンチプレスの原型ともいえるデザイン。 黒いハンドルは握りやすさだけはなく、クラシックで上品な印象を与えています。 フレンチプレスは、最もコーヒー豆の成分を抽出するのに適した92℃～96℃のお湯の温度を目安に、ゆっくりと豆の膨らみを確かめるようにお湯を注ぐことで、コーヒー豆の旨みや香り、おいしさに必要な豆の油分（コーヒーオイル）を余すことなく抽出します。 コーヒー豆本来の味が最大限に引き出された豊かな味わいのコーヒーをお楽しみください。 容量 0.5 L  幅 (cm) 16.6  高さ (cm) 19.0  奥行き (cm) 10.5",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_1924-16.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "478",
    brand: "Bodum",
    sku: "10682-01",
    product_eng: "Bodum KENYA 0.35L french press coffee maker",
    product_jpn: "Bodum ボダム  KENYA 0.35L フレンチプレスコーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,300",
    description_eng:
      "The BODUM coffee press KENYA is a crossroads between traditional and modern.For those of you who prefer chrome plated steel, the tested coffee press KENYA offers the best way of enjoying a cup of coffee. Capacity 0.35 L Width (cm) 11.0 Height (cm) 15.0 Depth (cm) 7.0",
    description_jpn:
      "モダンクラシックなデザインのKENYA。  フレンチプレスは、最もコーヒー豆の成分を抽出するのに適した92℃～96℃のお湯の温度を目安に、ゆっくりと豆の膨らみを確かめるようにお湯を注ぐことで、コーヒー豆の旨みや香り、おいしさに必要な豆の油分（コーヒーオイル）を余すことなく抽出します。 コーヒー豆本来の味が最大限に引き出された豊かな味わいのコーヒーをお楽しみください。 容量 0.350 L  幅 (cm) 11.0  高さ (cm) 15.0  奥行き (cm) 7.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10682-01.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "479",
    brand: "Bodum",
    sku: "10683-01",
    product_eng: "Bodum KENYA 0.5L french press coffee maker",
    product_jpn: "Bodum ボダム  KENYA 0.5L フレンチプレスコーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,500",
    rrp_with_vat: "¥3,850",
    description_eng:
      "The BODUM coffee press KENYA is a crossroads between traditional and modern.For those of you who prefer chrome plated steel, the tested coffee press KENYA offers the best way of enjoying a cup of coffee.  Capacity 0.5 L Width (cm) 14.5 Height (cm) 15.0 Depth (cm) 11.0",
    description_jpn:
      "モダンクラシックなデザインのKENYA。  フレンチプレスは、最もコーヒー豆の成分を抽出するのに適した92℃～96℃のお湯の温度を目安に、ゆっくりと豆の膨らみを確かめるようにお湯を注ぐことで、コーヒー豆の旨みや香り、おいしさに必要な豆の油分（コーヒーオイル）を余すことなく抽出します。 コーヒー豆本来の味が最大限に引き出された豊かな味わいのコーヒーをお楽しみください。 容量 0.5 L  幅 (cm) 14.5  高さ (cm) 15.0  奥行き (cm) 11.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10683-01.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10683-01_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10683-01_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "480",
    brand: "Bodum",
    sku: "10685-01",
    product_eng: "Bodum KENYA 1L french press coffee maker",
    product_jpn: "Bodum ボダム  KENYA 1L フレンチプレスコーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      "The BODUM coffee press KENYA is a crossroads between traditional and modern.For those of you who prefer chrome plated steel, the tested coffee press KENYA offers the best way of enjoying a cup of coffee.  Capacity 1.0 L Width (cm) 15.1 Height (cm) 21.0 Depth (cm) 10.4",
    description_jpn:
      "モダンクラシックなデザインのKENYA。  フレンチプレスは、最もコーヒー豆の成分を抽出するのに適した92℃～96℃のお湯の温度を目安に、ゆっくりと豆の膨らみを確かめるようにお湯を注ぐことで、コーヒー豆の旨みや香り、おいしさに必要な豆の油分（コーヒーオイル）を余すことなく抽出します。 コーヒー豆本来の味が最大限に引き出された豊かな味わいのコーヒーをお楽しみください。 容量 1.0 L  幅 (cm) 15.1  高さ (cm) 21.0  奥行き (cm) 10.4",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10685-01.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10685-01_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "481",
    brand: "Bodum",
    sku: "11592-109GB",
    product_eng: "Bodum POUR OVER 0.5L coffee maker",
    product_jpn: "Bodum ボダム  POUR OVER 0.5L コーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,500",
    description_eng:
      "The Pour Over Coffee Maker from Bodum is one the best ways to brew coffee. Made from heat safe borosilicate glass; a permanent steel filter is included. Dishwasher safe and BPA free. Quick and easy to use. Capacity 0.5 L Width (cm) 11.5 Height (cm) 15.4 Depth (cm) 13.8",
    description_jpn:
      "プアオーバーは、最もコーヒー豆の成分を抽出するのに適した92℃～96℃のお湯の温度を目安に、ゆっくりと豆の膨らみを確かめるようにお湯を注ぐことで、コーヒー豆の旨みや香り、おいしさに必要な豆の油分（コーヒーオイル）を余すことなく抽出します。 コーヒー豆本来の味が最大限に引き出された豊かな味わいのコーヒーをお楽しみください。 容量 0.5 L  幅 (cm) 11.5  高さ (cm) 15.4  奥行き (cm) 13.8",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11592-109GB.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "482",
    brand: "Bodum",
    sku: "11571-109GB",
    product_eng: "Bodum POUR OVER 1L coffee maker",
    product_jpn: "Bodum ボダム  POUR OVER 1L コーヒーメーカー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥8,000",
    rrp_with_vat: "¥8,800",
    description_eng:
      "The Pour Over Coffee Maker from Bodum is one the best ways to brew coffee. Made from heat safe borosilicate glass; a permanent steel filter is included. Dishwasher safe and BPA free. Quick and easy to use. Capacity 1.0 L Width (cm) 16.3 Height (cm) 20.2 Depth (cm) 14.0",
    description_jpn:
      "プアオーバーは、最もコーヒー豆の成分を抽出するのに適した92℃～96℃のお湯の温度を目安に、ゆっくりと豆の膨らみを確かめるようにお湯を注ぐことで、コーヒー豆の旨みや香り、おいしさに必要な豆の油分（コーヒーオイル）を余すことなく抽出します。 コーヒー豆本来の味が最大限に引き出された豊かな味わいのコーヒーをお楽しみください。 容量 1.0 L  幅 (cm) 16.3  高さ (cm) 20.2  奥行き (cm) 14.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11571-109GB.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11571-109GB_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11571-109GB_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "483",
    brand: "Bodum",
    sku: "K11067-01",
    product_eng: "Bodum TRAVEL PRESS SET(black)",
    product_jpn: "Bodum ボダム トラベルプレスセット ブラック",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      "Bodum has combined the coffee maker with a travel mug into this travel press set which contains a travel mug and two lids; a coffee press lid and a plain lid for other drinks. Made from stainless steel for maximum heat retention. Non-skid rubber base and comfortable ergonomic grip with silicone band Caution: For safety reasons, please keep the mug upright. The mug is not leakproof because of possible over pressure. Capacity 0.350 L Width (cm) 8.0 Height (cm) 18.5 Depth (cm) 9.0",
    description_jpn:
      "・オフィスや出張先、アウトドアでも、自分だけのこだわりのコーヒーを簡単に淹れて直接飲むことができる。 ・付属のリッドに交換すれば、ミネラルウォーターやジュースを入れるタンブラーとしても使用可能。 ・本体は二重構造で保温性、保冷性抜群。 ※飲み口の部分は完全密封ではありません。 容量 0.350 L  幅 (cm) 8.0  高さ (cm) 18.5  奥行き (cm) 9.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_K11067-01.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_K11067-01_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_K11067-01_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "484",
    brand: "Bodum",
    sku: "K11067-913",
    product_eng: "Bodum TRAVEL PRESS SET(white)",
    product_jpn: "Bodum ボダム トラベルプレスセット ホワイト",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      "Bodum has combined the coffee maker with a travel mug into this travel press set which contains a travel mug and two lids; a coffee press lid and a plain lid for other drinks. Made from stainless steel for maximum heat retention. Non-skid rubber base and comfortable ergonomic grip with silicone band Caution: For safety reasons, please keep the mug upright. The mug is not leakproof because of possible over pressure. Capacity 0.350 L Width (cm) 8.0 Height (cm) 18.5 Depth (cm) 9.0",
    description_jpn:
      "・オフィスや出張先、アウトドアでも、自分だけのこだわりのコーヒーを簡単に淹れて直接飲むことができる。 ・付属のリッドに交換すれば、ミネラルウォーターやジュースを入れるタンブラーとしても使用可能。 ・本体は二重構造で保温性、保冷性抜群。 ※飲み口の部分は完全密封ではありません。 容量 0.350 L  幅 (cm) 8.0  高さ (cm) 18.5  奥行き (cm) 9.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_K11067-913.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "485",
    brand: "Bodum",
    sku: "1807-16",
    product_eng: "Bodum ASSAM 0.5L stainless steel tea press",
    product_jpn: "Bodum ボダム  ASSAM 0.5L ステンレスティープレス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥6,500",
    rrp_with_vat: "¥7,150",
    description_eng:
      "Material:  Handle: Heat resistant glass;  Tea leaf holder: Polypropylene; Infuser/Lid/Rod: Stainless steel; Gasket: Silicone rubber  Capacity 0.5 L Width (cm) 16.6 Height (cm) 12.0 Depth (cm) 12.0",
    description_jpn:
      "1991年、紅茶を淹れる基本を考え直し、フレンチプレスコーヒーメーカーの機能を紅茶にも生かして、英国紅茶協会のためにデザインされたティーポット。 容量 0.5 L  幅 (cm) 16.6  高さ (cm) 12.0  奥行き (cm) 12.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_1807-16.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_1807-16_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_1807-16_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "486",
    brand: "Bodum",
    sku: "1801-16",
    product_eng: "Bodum ASSAM 1L stainless steel tea press",
    product_jpn: "Bodum ボダム  ASSAM 1L ステンレスティープレス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥7,500",
    rrp_with_vat: "¥8,250",
    description_eng:
      "Material:  Handle: Heat resistant glass;  Tea leaf holder: Polypropylene; Infuser/Lid/Rod: Stainless steel; Gasket: Silicone rubber  Capacity 1.0 L Width (cm) 19.0 Height (cm) 15.8 Depth (cm) 14.0",
    description_jpn:
      "1991年、紅茶を淹れる基本を考え直し、フレンチプレスコーヒーメーカーの機能を紅茶にも生かして、英国紅茶協会のためにデザインされたティーポット。 容量 1.0 L  幅 (cm) 19.0  高さ (cm) 15.8  奥行き (cm) 14.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_1801-16.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_1801-16_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_1801-16_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "487",
    brand: "Bodum",
    sku: "1844-01",
    product_eng: "Bodum ASSAM 1L tea press black",
    product_jpn: "Bodum ボダム  ASSAM 1L ティープレス ブラック",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,500",
    rrp_with_vat: "¥3,850",
    description_eng:
      "Materials: Heat resistant glass/tea strainer/leaf support/lid/handle: polypropylene/rod: stainless steel steel/gasket: silicone rubber  Capacity 1.0 L Width (cm) 19.4 Height (cm) 15.5 Depth (cm) 14.8",
    description_jpn:
      "1991年、紅茶を淹れる基本を考え直し、フレンチプレスコーヒーメーカーの機能を紅茶にも生かして、英国紅茶協会のためにデザインされたティーポット。 容量 1.0 L  幅 (cm) 19.4  高さ (cm) 15.5  奥行き (cm) 14.8",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_1844-01.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "488",
    brand: "Bodum",
    sku: "4558-10",
    product_eng: "Bodum PAVINA 0.25L double wall glass",
    product_jpn: "Bodum ボダム  PAVINA 0.25L ダブルウォールグラス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,314",
    rrp_with_vat: "¥3,645",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.25 L Width (cm) 8.9 Height (cm) 9.2 Depth (cm) 8.9",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.25 L  幅 (cm) 8.9  高さ (cm) 9.2 奥行き (cm) 8.9",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_4558-10.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_4558-10_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_4558-10__3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "489",
    brand: "Bodum",
    sku: "4559-10",
    product_eng: "Bodum PAVINA 0.35L double wall glass",
    product_jpn: "Bodum ボダム  PAVINA 0.35L ダブルウォールグラス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,790",
    rrp_with_vat: "¥4,169",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.35L Width (cm) 8.8 Height (cm) 11.6 Depth (cm) 8.8",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.35L  幅 (cm) 8.8  高さ (cm) 11.6  奥行き (cm) 8.8",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_4559-10.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_4559-10_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_4559-10__3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "490",
    brand: "Bodum",
    sku: "4560-10",
    product_eng: "Bodum PAVINA 0.45L double wall glass",
    product_jpn: "Bodum ボダム  PAVINA 0.45L ダブルウォールグラス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,743",
    rrp_with_vat: "¥5,217",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.45 L Width (cm) 8.8 Height (cm) 14.8 Depth (cm) 8.8",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.45 L  幅 (cm) 8.8  高さ (cm) 14.8  奥行き (cm) 8.8",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_4560-10.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_4560-10_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_4560-10_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "491",
    brand: "Bodum",
    sku: "10109-10",
    product_eng: "Bodum CANTEEN 0.2L double wall glass",
    product_jpn: "Bodum ボダム  CANTEEN 0.2L ダブルウォールグラス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,314",
    rrp_with_vat: "¥3,645",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.2 L Width (cm) 8.3 Height (cm) 10.2 Depth (cm) 8.3",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.2 L  幅 (cm) 8.3  高さ (cm) 10.2  奥行き (cm) 8.3",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10109-10.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10109-10_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10109-10_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "492",
    brand: "Bodum",
    sku: "10110-10",
    product_eng: "Bodum CANTEEN 0.4L double wall glass",
    product_jpn: "Bodum ボダム  CANTEEN 0.4L ダブルウォールグラス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,743",
    rrp_with_vat: "¥5,217",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.4 L Width (cm) 10.0 Height (cm) 14.1 Depth (cm) 9.5",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.4 L  幅 (cm) 10.0  高さ (cm) 14.1  奥行き (cm) 9.5",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10110-10.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10110-10_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10110-10_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "493",
    brand: "Bodum",
    sku: "10484-10",
    product_eng: "Bodum PILATUS 0.25L double wall glass",
    product_jpn: "Bodum ボダム  PILATUS 0.25L ダブルウォールグラス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,314",
    rrp_with_vat: "¥3,645",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.25 L Width (cm) 8.9 Height (cm) 9.2 Depth (cm) 8.9",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.25 L  幅 (cm) 8.0  高さ (cm) 10.2  奥行き (cm) 8.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10484-10.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10484-10_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10484-10_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "494",
    brand: "Bodum",
    sku: "10485-10",
    product_eng: "Bodum PILATUS 0.35L double wall glass",
    product_jpn: "Bodum ボダム  PILATUS 0.35L ダブルウォールグラス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,790",
    rrp_with_vat: "¥4,169",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.35 L  Width (cm) 8.5  Height (cm) 12.5 Depth (cm) 8.5",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.350 L  幅 (cm) 8.5 高さ (cm) 12.5  奥行き (cm) 8.5",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10485-10.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10485-10_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10485-10_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "495",
    brand: "Bodum",
    sku: "10482-10",
    product_eng: "Bodum TITLIS 0.35L double wall glass",
    product_jpn: "Bodum ボダム  TITLIS 0.35L ダブルウォールグラス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,790",
    rrp_with_vat: "¥4,169",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.35 L Width (cm) 8.5  Height (cm) 12.5 Depth (cm) 8.5",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.35 L  幅 (cm) 8.5  高さ (cm) 12.5  奥行き (cm) 8.5",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10482-10.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "496",
    brand: "Bodum",
    sku: "10483-10",
    product_eng: "Bodum TITLIS 0.45L double wall glass",
    product_jpn: "Bodum ボダム  TITLIS 0.45L ダブルウォールグラス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,743",
    rrp_with_vat: "¥5,217",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.45 L Width (cm) 8.8 Height (cm) 15.1 Depth (cm) 8.8",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.45 L  幅 (cm) 8.8  高さ (cm) 15.1  奥行き (cm) 8.8",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10483-10.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "497",
    brand: "Bodum",
    sku: "10594-10",
    product_eng: "Bodum SKAL 0.35L double wall glass",
    product_jpn: "Bodum ボダム  SKAL 0.35L ダブルウォールグラス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,500",
    rrp_with_vat: "¥3,850",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.35 L Width (cm) 8.3 Height (cm) 16.3 Depth (cm) 8.3",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.35 L  幅 (cm) 8.3  高さ (cm) 16.3  奥行き (cm) 8.3",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10594-10.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10594-10_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10594-10_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "498",
    brand: "Bodum",
    sku: "10604-10",
    product_eng: "Bodum BISTRO 0.3L double wall mug",
    product_jpn: "Bodum ボダム  BISTRO 0.3L ダブルウォールマグ",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥5,695",
    rrp_with_vat: "¥6,265",
    description_eng:
      "2 pcs glass Innovative double wall construction that keeps hot drinks hot and cold drinks cold. Also perfect for serving soup or cold desserts. Made of mouth-blown, heat-resistant borosilicate glass. Hydrophobic silicone vent that equalizes the air pressure between the two layers of glass.     Dishwasher, microwave and oven safe (up to 350ºF/176ºC). Capacity 0.3 L Width (cm) 9.3 Height (cm) 10.8 Depth (cm) 12.4",
    description_jpn:
      "2個セット ❝おいしい”が続くグラス❞ 熟練された職人による吹きガラス製法で、ひとつずつ作られたボダム ダブルウォールグラスは、耐熱ガラスの二重構造で、温かい飲みものは温かく、冷たい飲みものは冷たいまま、飲みもののおいしさを持続させる、保温性、保冷性に優れたグラスです。 ・電子レンジ使用可能 ・オーブン使用可能 ・食器洗い乾燥機使用可能 ・冷凍庫使用可能 容量 0.3 L  幅 (cm) 9.3  高さ (cm) 10.8  奥行き (cm) 12.4",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10604-10.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_10604-10_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "499",
    brand: "Bodum",
    sku: "11659-01JP",
    product_eng: "Bodum BISTRO water kettle  Black",
    product_jpn: "Bodum ボダム  BISTRO ケトル ブラック",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥12,000",
    rrp_with_vat: "¥13,200",
    description_eng:
      "Stylish double glass kettle with temperature control. Five temperature settings for different types of tea: 60ºC/140ºF, 70ºC/158ºF, 80ºC/176ºF, 90ºC/194ºF, and 100ºC/212ºF. 1.1 litre / 37 ounce capacity. Transparent body with water level marked in litres, ounces and cups, so you only boil what you need. Innovative double wall construction. The inner wall is made from BPA-free borosilicate glass, while the outer wall is transparent plastic, which protects and insulates the glass while preventing you from burning your fingers. Warming function to keep water at your chosen temperature for up to 30 minutes. Manual on/off switch, with a temperature sensor for automatic shut-off. Removable filter in the spout to prevent limescale from entering your cup. width (cm) 23.0  height (cm) 26.5  depth (cm) 19.5",
    description_jpn:
      "温度調節と保温機能が付いたBISTRO ダブルウォールウォーターケトルは特にお茶好きの方には最適です。 温度調節は加熱中ダイヤルを回すだけでいつでも温度を高く変更することができます。  電源ボタンは設定された温度に達するまで点滅し、ピーという音とともに止まります。 30分の保温機能が付いていて、保温ボタンを押すと保温が開始。再度、保温ボタンを押すかポットが電源ベースから離れるまで保温されます。  容量 1.1 L  幅 (cm) 23.0  高さ (cm) 26.5  奥行き (cm) 19.5 EAN",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11659-01JP.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11659-01JP_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11659-01JP_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "500",
    brand: "Bodum",
    sku: "11659-913JP",
    product_eng: "Bodum BISTRO water kettle White",
    product_jpn: "Bodum ボダム  BISTRO ケトル ホワイト",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥12,000",
    rrp_with_vat: "¥13,200",
    description_eng:
      "Stylish double glass kettle with temperature control. Five temperature settings for different types of tea: 60ºC/140ºF, 70ºC/158ºF, 80ºC/176ºF, 90ºC/194ºF, and 100ºC/212ºF. 1.1 litre / 37 ounce capacity. Transparent body with water level marked in litres, ounces and cups, so you only boil what you need. Innovative double wall construction. The inner wall is made from BPA-free borosilicate glass, while the outer wall is transparent plastic, which protects and insulates the glass while preventing you from burning your fingers. Warming function to keep water at your chosen temperature for up to 30 minutes. Manual on/off switch, with a temperature sensor for automatic shut-off. Removable filter in the spout to prevent limescale from entering your cup. width (cm) 23.0  height (cm) 26.5  depth (cm) 19.5",
    description_jpn:
      "温度調節と保温機能が付いたBISTRO ダブルウォールウォーターケトルは特にお茶好きの方には最適です。 温度調節は加熱中ダイヤルを回すだけでいつでも温度を高く変更することができます。  電源ボタンは設定された温度に達するまで点滅し、ピーという音とともに止まります。 30分の保温機能が付いていて、保温ボタンを押すと保温が開始。再度、保温ボタンを押すかポットが電源ベースから離れるまで保温されます。  容量 1.1 L  幅 (cm) 23.0  高さ (cm) 26.5  奥行き (cm) 19.5 EAN",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11659-913JP.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11659-913JP_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11659-913JP_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "501",
    brand: "Bodum",
    sku: "11883-259JP",
    product_eng: "Bodum MELIOR water kettle",
    product_jpn: "Bodum ボダム  MELIOR ケトル",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥11,000",
    description_eng:
      "Take your coffee brewing to the next level with the ePEBO siphon coffee maker. Part art, part science with a dash of gravity-defying magic, this electric vacuum coffee maker brings a theatrical air to the brewing process. And the results are truly extraordinary. The capacity is 0.8 l / 27 oz. Width (cm) 31.0 Height (cm) 21.0 Depth (cm) 15.5",
    description_jpn:
      "・ボダムのPOUR OVERドリップコーヒーメーカーに最適。 ・人間工学に基づいた洗練されたデザインにより、コーヒーの抽出に最適なお湯の量と速度を簡単にコントロールすることができます。 ・スタイリッシュで耐久性のあるステンレス鋼と天然コルクでできた北欧らしいデザイン。 ・滑り止めの効果もあるコルクでできたハンドルと蓋のつまみは、火傷防止にも。 ・スイッチを押すだけの簡単操作。マニュアルでのON（作動中はランプが点灯）/OFFスイッチ機能に加え、沸騰すると自動的に電源が切れる温度センサーが付きで安全。  容量は、便利な0.8 l / 27 oz。 幅 (cm) 31.0  高さ (cm) 21.0  奥行き (cm) 15.5",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11883-259JP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "502",
    brand: "Bodum",
    sku: "11160-01JP-3",
    product_eng: "Bodum BISTRO coffee grinder",
    product_jpn: "Bodum ボダム  BISTRO コーヒーグラインダー ブラック",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "Coffee lovers may differ over their preferred method of brewing, but they all agree on one thing: the best tasting coffee comes from freshly ground beans. For a robust, aromatic cup of joe that’s bursting with flavor, make the BISTRO blade grinder part of your at-home coffee routine. Width (cm) 9.5 Height (cm) 16.8 Depth (cm) 8.7",
    description_jpn:
      "必要なときに必要な分だけ、いつでも手軽に挽き立てのコーヒー豆を。 ブレード刃により、細挽きから粗挽きまで素早く効率的にコーヒー豆を挽くことができます。コンパクトなのでキッチンカウンターに置いても場所を取りません。 幅 (cm) 9.5  高さ (cm) 16.8 奥行き (cm) 8.7",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11160-01JP-3.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11160-01JP-3_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11160-01JP-3_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "503",
    brand: "Bodum",
    sku: "11160-913JP-3",
    product_eng: "Bodum BISTRO coffee grinder",
    product_jpn: "Bodum ボダム  BISTRO コーヒーグラインダー ホワイト",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "Coffee lovers may differ over their preferred method of brewing, but they all agree on one thing: the best tasting coffee comes from freshly ground beans. For a robust, aromatic cup of joe that’s bursting with flavor, make the BISTRO blade grinder part of your at-home coffee routine. Width (cm) 9.5 Height (cm) 16.8 Depth (cm) 8.7",
    description_jpn:
      "必要なときに必要な分だけ、いつでも手軽に挽き立てのコーヒー豆を。 ブレード刃により、細挽きから粗挽きまで素早く効率的にコーヒー豆を挽くことができます。コンパクトなのでキッチンカウンターに置いても場所を取りません。 幅 (cm) 9.5  高さ (cm) 16.8 奥行き (cm) 8.7",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11160-913JP-3.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11160-913JP-3_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_11160-913JP-3_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "504",
    brand: "Bodum",
    sku: "12041-01JP",
    product_eng: "Bodum BISTRO blade coffee grinder",
    product_jpn: "Bodum ボダム  BISTRO ブレード コーヒーグラインダー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥9,000",
    rrp_with_vat: "¥9,900",
    description_eng:
      "・Compact blade-blade coffee grinder with adjustable coarseness and volume of coffee beans (maximum capacity 84g) ・Durable stainless steel blades that operate at precise rpm ・Five levels of coarseness adjustment from fine to coarse grind ・Cup selection slider allows you to specify the number of cups (3 to 12 cups) ・Easy-to-operate automatic grinder for consistent grinding. ・Hopper with measuring guide ・Metal container is removable for easy cleaning. ・Power cord is stored in the main body. ・Stainless steel, plastic, rubber, and silicone materials are used. <Size> Width (cm) 11.7 Height (cm) 19.8 Depth (cm) 11.8",
    description_jpn:
      "・コーヒー豆の粗さと量が調整できるコンパクトなブレード刃コーヒーグラインダー（最大容量84g） ・正確な回転数で動作する耐久性ステンレス製ブレード ・細挽きから粗挽きまで5段階の粗さ調整が可能 ・カップ選択スライダーでカップ数を指定（3杯～12杯） ・簡単操作の自動挽きで、安定した挽きあがり ・計量ガイド付きホッパー ・メタルコンテイナーは取り外し可能でお手入れ簡単 ・電源コードは本体に収納 ・ステンレス、プラスチック、ゴム、シリコンを使用 <サイズ> 幅（cm）11.7 高さ（cm）19.8 奥行き（cm）11.8",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_12041-01JP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "505",
    brand: "Bodum",
    sku: "12132-10",
    product_eng: "Bodum DOURO Sake bottle(tokkuri) 360ml",
    product_jpn: "Bodum ボダム  DOURO トックリカラフェ 360ml",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,200",
    description_eng:
      "・Elegant glass carafe in the traditional Japanese sake drinking style. ・suitable for both heated and chilled sake. ・Made of heat-resistant borosilicate glass that does not alter or degrade the flavor of the drink. ・Matching glasses (ochoko) are also available. ・Easy to use and clean. ・Dishwasher/dryer safe. <Size> Width (cm) 7.0 Height (cm) 16.1 Depth (cm) 7.0",
    description_jpn:
      "・日本の伝統的な酒器スタイルのエレガントなガラス製カラフェ。 ・燗酒にも冷酒にも。 ・吹きガラス製法、飲みものの風味を変化・劣化させない耐熱性ホウケイ酸ガラスを使用。 ・お揃いのグラス（おちょこ）も購入可能です。 ・使いやすく、お手入れも簡単。 ・食器洗浄機／乾燥機使用可能。 <サイズ> 幅（cm）7.0 高さ（cm）16.1 奥行き（cm）7.0",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_12132-10.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "506",
    brand: "Bodum",
    sku: "12129-10",
    product_eng: "Bodum DOURO Sake double wall glass(Set of 3)",
    product_jpn: "Bodum ボダム  DOURO ダブルウォール おちょこ3個セット 360ml",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,300",
    description_eng:
      "・This elegant set of sake glasses is based on the design of traditional Japanese sake cups. ・The unique DOURO series is inspired by the magical Douro Valley in Portugal. ・The innovative double-wall construction keeps both hot and cold drinks at the ideal temperature for an extended period of time. ・Ideal for small amounts of soups and desserts. ・Made of heat-resistant borosilicate glass that does not alter or degrade the flavor of the drink. ・Hydrophobic silicone vent to maintain even air pressure between the two glass layers. ・Dishwasher/dryer, microwave, and oven safe. （Dishwasher/dryer safe (up to 176°C). ・Matching carafe available. <Size> Width (cm) 6.1 Height (cm) 6.8 Depth (cm) 6.1",
    description_jpn:
      "・日本の伝統的な酒器のデザインを基にした、エレガントな日本酒グラスセット。 ・ポルトガルの幻想的なドゥーロ渓谷にインスピレーションを得たユニークなDOURO シリーズ。 ・温かい飲みものも冷たい飲みものも理想的な温度に長時間保つ、画期的なダブルウォール二重構造。 ・燗酒にも冷酒にも。 ・少量のスープやデザートにも最適。 ・吹きガラス製法、飲みものの風味を変化・劣化させない耐熱性ホウケイ酸ガラスを使用。 ・2枚のガラス層の間の空気圧を均等に保つ疎水性シリコンベント。 ・食器洗浄機／乾燥機、電子レンジ、オーブン使用可能。（176℃まで） ・お揃いのカラフェあり。 <サイズ> 幅（cm）6.1 高さ（cm）6.8 奥行き（cm）6.1",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bodum/Bodum_12129-10.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bodum.png",
  },
  {
    id: "508",
    brand: "Bose",
    sku: "SLink Flex WHT",
    product_eng: "BOSE SoundLink Flex Bluetooth® speaker White Smoke",
    product_jpn: "BOSE SoundLink Flex Bluetooth® speaker ホワイトスモーク",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥18,000",
    rrp_with_vat: "¥19,800",
    description_eng:
      "Enjoy deep, clear, lifelike audio at home or on the go Clear sound - Bose's exclusive PositionIQ technology automatically detects speaker position and optimizes sound quality based on orientation and environment Waterproof wireless speaker for outdoor activities - SoundLink Flex has been rigorously tested and is IP67 rated for waterproof performance Sealed design with waterproof material - ideal for outdoor activities Portable Bluetooth speaker - Resistant to water, dust, and debris, and resistant to drops and rust, you can take it anywhere. Easy to carry and store, designed to resist corrosion and UV rays Rechargeable via USB-C cable (included). The lithium-ion battery provides up to 12 hours of use on a single charge.",
    description_jpn:
      "自宅でも、外出先でも、深みのある、クリアで臨場感あふれるオーディオを楽しむことができます クリアなサウンド – ボーズ独自のPositionIQテクノロジーが、スピーカーのポジションを自動的に検出し、方向や環境に応じて音質を最適化 アウトドアに最適な防水仕様のワイヤレススピーカー – SoundLink Flexは、厳密なテストをクリアし、IP67に準拠した高い防水性能を備えています防水素材による密閉設計 – アウトドアでのアクティビティに最適 ポータブルBluetoothスピーカー – 水、ほこり、ごみが入りにくく、落下や錆に対する耐性に優れているため、さまざまな場所に持ち出すことができます。持ち運びも収納も簡単で、腐食や紫外線に強い設計です 充電式ワイヤレススピーカーバッテリー – USB-Cケーブル (付属) で充電可能。リチウムイオンバッテリーにより、1回の充電で最大12時間使用できます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bose/Bose_SLink+Flex+WHT.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bose.png",
  },
  {
    id: "509",
    brand: "Bose",
    sku: "SLink Flex BLU",
    product_eng: "BOSE SoundLink Flex Bluetooth® speaker Stone Blue",
    product_jpn: "BOSE SoundLink Flex Bluetooth® speaker ストーンブルー",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥18,000",
    rrp_with_vat: "¥19,800",
    description_eng:
      "Enjoy deep, clear, lifelike audio at home or on the go Clear sound - Bose's exclusive PositionIQ technology automatically detects speaker position and optimizes sound quality based on orientation and environment Waterproof wireless speaker for outdoor activities - SoundLink Flex has been rigorously tested and is IP67 rated for waterproof performance Sealed design with waterproof material - ideal for outdoor activities Portable Bluetooth speaker - Resistant to water, dust, and debris, and resistant to drops and rust, you can take it anywhere. Easy to carry and store, designed to resist corrosion and UV rays Rechargeable via USB-C cable (included). The lithium-ion battery provides up to 12 hours of use on a single charge.",
    description_jpn:
      "自宅でも、外出先でも、深みのある、クリアで臨場感あふれるオーディオを楽しむことができます クリアなサウンド – ボーズ独自のPositionIQテクノロジーが、スピーカーのポジションを自動的に検出し、方向や環境に応じて音質を最適化 アウトドアに最適な防水仕様のワイヤレススピーカー – SoundLink Flexは、厳密なテストをクリアし、IP67に準拠した高い防水性能を備えています防水素材による密閉設計 – アウトドアでのアクティビティに最適 ポータブルBluetoothスピーカー – 水、ほこり、ごみが入りにくく、落下や錆に対する耐性に優れているため、さまざまな場所に持ち出すことができます。持ち運びも収納も簡単で、腐食や紫外線に強い設計です 充電式ワイヤレススピーカーバッテリー – USB-Cケーブル (付属) で充電可能。リチウムイオンバッテリーにより、1回の充電で最大12時間使用できます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bose/Bose_SLink+Flex+BLU.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bose.png",
  },
  {
    id: "512",
    brand: "Bose",
    sku: "SLink REV PLUS BLK Ⅱ",
    product_eng: "BOSE SoundLink Revolve+ II Bluetooth® speaker Triple Black",
    product_jpn:
      "BOSE SoundLink Revolve+ II Bluetooth® speaker トリプルブラック",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥38,500",
    rrp_with_vat: "¥42,350",
    description_eng:
      "SoundLink Revolve+ II, Bose's premier portable Bluetooth speaker  Deep, powerful, intoxicating sound. With 360° of natural sound, SoundLink Revolve+ II is Bose's most advanced portable Bluetooth® speaker. Place it in the center of a room to share the same sound with everyone, or against a wall to create a sound so expansive with reflections you'll feel like you're in your favorite concert venue. With its easy-to-carry handle, you can take your music wherever you go. ●SoundLink Revolve+ II is dustproof and splashproof, so you can use it by the pool or in the kitchen without worrying. ●SoundLink Revolve+ II is also shock-resistant. The speaker body is made of soft material, so it is safe even if it receives a slight shock. ●The meticulously detailed speaker grille has not a single seam. This is due to the latest one-piece molding process. ●Portable Bluetooth speakers are required to have a long playback time. The rechargeable lithium-ion battery, which provides approximately 17 hours of continuous playback on a full charge, allows for all-day enjoyment. ●Included in the box USB power adapter USB cable (micro-B-USB A) Power adapter plug ●Dimensions 105 mm W x 184 mm H x 105 mm D (0.91 kg)",
    description_jpn:
      "ボーズ最高峰のポータブルBluetoothスピーカー、SoundLink Revolve+ II  深く、パワフル。夢中にさせるサウンドを実現。360°自然なサウンドが拡がるSoundLink Revolve+ IIはボーズ最高峰のポータブルBluetooth®スピーカー。部屋の中央に置いて皆で同じサウンドを共有したり、壁際に置けば反射音によって拡がりのあるサウンドで、まるでお気に入りのコンサート会場にいるかのような感覚に。持ち運びしやすいハンドル付きだから、音楽をどこへでも連れていけます。  ●SoundLink Revolve+ IIは防塵・防滴仕様なので、プールサイドやキッチンでも、気にせず使用できます。 ●衝撃にも強い。スピーカーのボディには柔らかい素材が使われているので、多少の衝撃を受けても安心です。 ●細部までこだわったスピーカーグリルには、継ぎ目が1つもありません。これは最新の一体成形プロセスによるものです。 ●ポータブルBluetoothスピーカーには、再生時間の長さが求められます。満充電で約17時間連続再生可能な充電式リチウムイオンバッテリーを搭載し、1日中楽しめます。 ● 同梱物 USB電源アダプター USBケーブル（micro-B-USB A） 電源アダプタープラグ ●サイズ 105 mm W x 184 mm H x 105 mm D (0.91 kg)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bose/Bose_SLinkREVPLUSBLK%E2%85%A1.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bose/Bose_SLinkREVPLUSBLK%E2%85%A1_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bose.png",
  },
  {
    id: "513",
    brand: "Bose",
    sku: "SLink REV PLUS SLV Ⅱ",
    product_eng: "BOSE SoundLink Revolve+ II Bluetooth® speaker Luxe Silver",
    product_jpn:
      "BOSE SoundLink Revolve+ II Bluetooth® speaker ラックスシルバー",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥38,500",
    rrp_with_vat: "¥42,350",
    description_eng:
      "SoundLink Revolve+ II, Bose's premier portable Bluetooth speaker  Deep, powerful, intoxicating sound. With 360° of natural sound, SoundLink Revolve+ II is Bose's most advanced portable Bluetooth® speaker. Place it in the center of a room to share the same sound with everyone, or against a wall to create a sound so expansive with reflections you'll feel like you're in your favorite concert venue. With its easy-to-carry handle, you can take your music wherever you go. ●SoundLink Revolve+ II is dustproof and splashproof, so you can use it by the pool or in the kitchen without worrying. ●SoundLink Revolve+ II is also shock-resistant. The speaker body is made of soft material, so it is safe even if it receives a slight shock. ●The meticulously detailed speaker grille has not a single seam. This is due to the latest one-piece molding process. ●Portable Bluetooth speakers are required to have a long playback time. The rechargeable lithium-ion battery, which provides approximately 17 hours of continuous playback on a full charge, allows for all-day enjoyment. ●Included in the box USB power adapter USB cable (micro-B-USB A) Power adapter plug ●Dimensions 105 mm W x 184 mm H x 105 mm D (0.91 kg)",
    description_jpn:
      "ボーズ最高峰のポータブルBluetoothスピーカー、SoundLink Revolve+ II  深く、パワフル。夢中にさせるサウンドを実現。360°自然なサウンドが拡がるSoundLink Revolve+ IIはボーズ最高峰のポータブルBluetooth®スピーカー。部屋の中央に置いて皆で同じサウンドを共有したり、壁際に置けば反射音によって拡がりのあるサウンドで、まるでお気に入りのコンサート会場にいるかのような感覚に。持ち運びしやすいハンドル付きだから、音楽をどこへでも連れていけます。  ●SoundLink Revolve+ IIは防塵・防滴仕様なので、プールサイドやキッチンでも、気にせず使用できます。 ●衝撃にも強い。スピーカーのボディには柔らかい素材が使われているので、多少の衝撃を受けても安心です。 ●細部までこだわったスピーカーグリルには、継ぎ目が1つもありません。これは最新の一体成形プロセスによるものです。 ●ポータブルBluetoothスピーカーには、再生時間の長さが求められます。満充電で約17時間連続再生可能な充電式リチウムイオンバッテリーを搭載し、1日中楽しめます。 ● 同梱物 USB電源アダプター USBケーブル（micro-B-USB A） 電源アダプタープラグ ●サイズ 105 mm W x 184 mm H x 105 mm D (0.91 kg)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bose/Bose_SLinkREVPLUSSLV%E2%85%A1.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bose/Bose_SLinkREVPLUSSLV%E2%85%A1_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bose.png",
  },
  {
    id: "516",
    brand: "Hyperice",
    sku: "34000 001-00",
    product_eng: "Hyperice Hypersphere Mini",
    product_jpn: "Hyperice ハイパースフィア ミニ",
    category_1: "Health & Beauty",
    category_2: "",
    rrp_ex_vat: "¥14,364",
    rrp_with_vat: "¥15,800",
    description_eng:
      "Perfect for travel, the TSA carry-on approved Hypersphere Mini targets your tightest areas with precision to help you move better wherever you roam. Size: approx. 9 cm in diameter Weight: approx. 340g Number of vibrations: Level 1: 42㎐ Level 2: 52㎐ Level 3: 62㎐ Accessories: USB charger, tabletop holder, one-year warranty in Japan",
    description_jpn:
      "セラピーボールなども筋肉をはじめとする腱や靭帯、筋膜などのサポートに効果的ですが、 HYPERSPHEREは振動を加えることで更なる効果が期待できます。コンパクトなボディサポートボールです。旅行など持ち運びに最適で、いつどこでも使うことができて、これまで以上に自由に動きやすい体を実現させます。 サイズ：直径約9cm 重量：約340g 振動数：レベル1:42㎐ レベル2:52㎐ レベル3:62㎐ 付属品：USBチャージャー・卓上ホルダー・国内一年保証 ※日本使用正規品です",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/hyperice/Hyperice_34000 001-00.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/hyperice.png",
  },
  {
    id: "517",
    brand: "Hyperice",
    sku: "31100-008-00",
    product_eng: "Hyperice Vyper 3.0",
    product_jpn: "Hyperice バイパー 3.0",
    category_1: "Health & Beauty",
    category_2: "",
    rrp_ex_vat: "¥31,636",
    rrp_with_vat: "¥34,800",
    description_eng:
      "The world's first vibrating foam roller, Vyper, has been enhanced and refined with the latest technology to become the most powerful vibrating foam roller in the world. Vyper is the world's first vibrating foam roller. ・It can be paired with the Hyperice App (Android / iOS), which enables automatic speed adjustment via Bluetooth®.  Size Approx. 13cm x 33cm Weight 1.24kg Number of vibrations Level 1: 48㎐ Level 2: 60㎐ Level 3: 72㎐ Accessories Battery charger (with PSE mark), One year warranty in Japan",
    description_jpn:
      "世界初で開発された振動付きフォームローラーVyperが、最新技術によってより強く洗練され、世界で最も力強い振動式フォームローラーへと進化しました。研究された振動数と身体への振動伝達率が、通常のフォームローラーと比べてより深い部位の筋肉へアプローチします。 ・Bluetooth®で自動スピード調整等を可能にするHyperice App(Android / iOS)とペアリングできます。  サイズ\t約13cm×33cm 重量\t1.24kg 振動数\tレベル1:48㎐ レベル2:60㎐ レベル3:72㎐ 付属品\t充電器(PSEマーク付き)・国内一年保証",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/hyperice/Hyperice_31100-008-00.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/hyperice.png",
  },
  {
    id: "518",
    brand: "Hyperice",
    sku: "53200-008-00",
    product_eng: "Hyperice Hypervolt 2.0",
    product_jpn: "Hyperice Hypervolt ハイパーボルト2.0",
    category_1: "Health & Beauty",
    category_2: "",
    rrp_ex_vat: "¥29,818",
    rrp_with_vat: "¥32,800",
    description_eng:
      "The Hypervolt 2 is an ideal item for total support of the body before and after training with its 3 levels of powerful vibration. The Hypervolt 2 is lightweight and cordless, weighing only 820g, and can be used with one hand anywhere. ・It can be paired with the Hyperice App (Android / iOS), which enables automatic speed adjustment via Bluetooth®. ・The patented Quiet Glide technology creates powerful vibrations, yet operates quietly. ・It has five attachments that can be customized according to your needs, and the vibration can be adjusted in three stages (from about 2,000 to 2,700 vibrations per minute). ・It is cordless, portable and can be used anywhere. It is powered by a lithium-ion battery that can last up to 3 hours on a single full charge. ・It is equipped with a pressure sensor that detects the amount of pressure being applied and provides a 3-step LED light. The pressure sensor detects how much pressure is being applied and provides a 3-stage LED light to help provide visual feedback.  Power:           Brushless motor / 60W Vibrations:      Level 1: 30㎐ / Level 2: 40㎐ / Level 3: 53㎐ Rotation speed:  Level 1: 2000 / Level 2: 2350 / Level 3: 2700 Size: Main unit: 17cm (W) x 24cm (H) x 6cm (W) Packing:         31cm (W) x 22cm (H) x 12cm (W) Weight:          0.82kg Charging:        3 hours continuous use when fully charged Accessories:     Charger (with PSE mark), 5 types of head attachments, one year warranty in Japan",
    description_jpn:
      "Hypervolt 2は、3段階の強力な振動によって、トレーニング前後の身体のトータルサポートに最適なアイテムです。 片手で使える約820gの軽量コードレス式で使用する場所を選びません。 ・Bluetooth®で自動スピード調整等を可能にするHyperice App(Android / iOS)とペアリングできます(アプリの提供言語は、英語版のみで日本語版リリースにはしばらくお待ちいただくことになります、日本語版リリース時期がわかり次第、お知らせさせていただきます)。 ・強力な振動を生み出しながらも特許取得済みのQuiet Glideテクノロジーにより静かな音で作動します。 ・5種類のアタッチメントを目的に応じてカスタマイズでき、振動は3段階(毎分約2,000回〜2,700回まで)に調整することができます。 ・使用する場所を選ばない、持ち運びにも便利なコードレス式で、1回の満充電で最大3時間まで連続使用できるリチウムイオンバッテリーを搭載しています。 ・どれくらいの圧力で当てているか圧力を感知して3段階のLEDライトで確認できる圧力センサーを搭載しています。視覚的なフィードバックとしてお役立てください。  パワー\tブラシレスモーター / 60W 振動数\tレベル1:30㎐ / レベル2:40㎐ / レベル3:53㎐ 回転数\tレベル1:2000 / レベル2:2350 / レベル3:2700 サイズ\t本体:横17cm x 縦24cm x 幅6cm 梱包:横31cm x 縦22cm x 幅12cm 重量\t0.82kg 充電\t満充電時約3時間連続使用可能 付属品\t充電器(PSEマーク付き)・5種類のヘッドアタッチメント・国内一年保証",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/hyperice/Hyperice_53200-008-00.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/hyperice.png",
  },
  {
    id: "519",
    brand: "Hyperice",
    sku: "55200 008-00",
    product_eng: "Hyperice Hypervolt GO 2",
    product_jpn: "Hyperice Hypervolt GO ハイパーボルト ゴー2",
    category_1: "Health & Beauty",
    category_2: "",
    rrp_ex_vat: "¥18,909",
    rrp_with_vat: "¥20,800",
    description_eng:
      "The Hypervolt Go2 has a compact and lightweight design that can be easily handled with one hand, even by women. It fits easily into a bag. It is recommended not only at home, but also at the workplace, gym, or on the go.  With patented QuietGlide® technology for ultra-quiet sessions, the Hypervolt Go 2 Provides a satisfying massage experience that balances power and portability Lightweight, compact design weighing only 680 grams and offering approximately 3 hours of continuous use (when fully charged). Arctic gray finish, the first color in the series.   ＜Size Approx. 17 x 18 x 5.5 cm (including attachments) <Accessories Battery charger, battery charger conversion plug (4 types) Main body charger and charging adapter for cross-country use 2 types of head attachments (flat, bullet) Interchangeable attachments to suit your preference",
    description_jpn:
      "Hypervolt Go2は、女性の方でも片手で簡単に扱える小型・軽量設計。バッグにもすっぽり収まります。 自宅はもちろん、職場やジム、外出先でもお勧めです。  特許取得のQuietGlide®テクノロジーで超静音セッションが可能なHypervolt Go 2は、 パワーと携帯性のバランスがとれた、満足度の高いマッサージを提供します わずか680gの軽量コンパクト設計で約３時間の連続使用が可能(満充電時)。 シリーズ初カラーのアークティックグレー仕上げ。   ＜Size＞ 約17×18×5.5cm (アタッチメント含む) ＜付属品＞ 充電器・充電変換プラグ(4種) 本体充電器と国を跨いでの使用が可能な充電アダプター ヘッドアタッチメント 2種(flat, bullet) お好みに合わせて交換可能なアタッチメント",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/hyperice/Hyperice_55200 008-00.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/hyperice/Hyperice_55200 008-00_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/hyperice/Hyperice_55200 008-00_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/hyperice.png",
  },
  {
    id: "520",
    brand: "BRUNO",
    sku: "BOE021-RD",
    product_eng: "BRUNO Compact Hotplate Red",
    product_jpn: "BRUNO コンパクトホットプレート レッド",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥11,000",
    rrp_with_vat: "¥12,100",
    description_eng:
      "A new standard of tableware that adds color to the daily dining table The cast-iron enamel design, which has never been seen on a hot plate before, adds color to the dining table like tableware. With a size just right for 2-3 people, you can enjoy cooking at your table, from daily cooking to parties at home.  Size: W375 x H140 x D235 mm / approx. 2.3 kg\t Material: Main body: Steel/phenolic resin, Plate: Aluminum alloy (fluorocarbon resin coated inner surface)     Power source: AC100V Cord: 1.8m Functions: Temperature control: 65°C to 250°C Safety devices: thermostat/thermal fuse    Power consumption: 1200W Accessories: flat plate, takoyaki plate, lid, wooden spatula",
    description_jpn:
      "毎日の食卓を彩るテーブルウェアの新定番 今までのホットプレートにはなかった鋳物ホーローをイメージしたデザインは、テーブルウェアのように食卓を彩ります。 2～3人に丁度良いサイズで、毎日のお料理からおうちパーティまで食卓で‘調理’を愉しめます。  サイズ：W375×H140×D235mm/約2.3kg\t 材質：本体：スチール/フェノール樹脂、プレート：アルミニウム合金（内面ふっ素樹脂塗膜加工）     電源：AC100V コード：1.8ｍ 機能：温度調節：65℃～250℃ 安全装置：サーモスタット/温度ヒューズ    消費電力:1200W 付属品：平プレート、たこ焼きプレート、フタ、木べら",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE021-RD.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE021-RD_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE021-RD_3.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE021-RD_4.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "521",
    brand: "BRUNO",
    sku: "BOE021-WH",
    product_eng: "BRUNO Compact Hotplate White",
    product_jpn: "BRUNO コンパクトホットプレート ホワイト",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥11,000",
    rrp_with_vat: "¥12,100",
    description_eng:
      "A new standard of tableware that adds color to the daily dining table The cast-iron enamel design, which has never been seen on a hot plate before, adds color to the dining table like tableware. With a size just right for 2-3 people, you can enjoy cooking at your table, from daily cooking to parties at home.  Size: W375 x H140 x D235 mm / approx. 2.3 kg\t Material: Main body: Steel/phenolic resin, Plate: Aluminum alloy (fluorocarbon resin coated inner surface)     Power source: AC100V Cord: 1.8m Functions: Temperature control: 65°C to 250°C Safety devices: thermostat/thermal fuse    Power consumption: 1200W Accessories: flat plate, takoyaki plate, lid, wooden spatula",
    description_jpn:
      "毎日の食卓を彩るテーブルウェアの新定番 今までのホットプレートにはなかった鋳物ホーローをイメージしたデザインは、テーブルウェアのように食卓を彩ります。 2～3人に丁度良いサイズで、毎日のお料理からおうちパーティまで食卓で‘調理’を愉しめます。  サイズ：W375×H140×D235mm/約2.3kg\t 材質：本体：スチール/フェノール樹脂、プレート：アルミニウム合金（内面ふっ素樹脂塗膜加工）     電源：AC100V コード：1.8ｍ 機能：温度調節：65℃～250℃ 安全装置：サーモスタット/温度ヒューズ    消費電力:1200W 付属品：平プレート、たこ焼きプレート、フタ、木べら",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE021-WH.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE021-WH_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE021-WH_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "522",
    brand: "BRUNO",
    sku: "BOE026-RD",
    product_eng: "BRUNO Hotplate Grande size Red",
    product_jpn: "BRUNO ホットプレート グランデサイズ レッド",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥17,000",
    rrp_with_vat: "¥18,700",
    description_eng:
      "Hot plate like a larger tableware that brings smiles and enjoyment to the dining table The compact hot plate is designed in the image of an enameled cast iron pot. The perfect size for 4 to 5 people. It is very useful for a variety of occasions, from everyday dining to special parties at home!  ・Size: W480 x H155 x D280 [mm] 3.2 Kg  ・Material: Main body: Steel/phenolic resin, Plate: Aluminum alloy (fluorocarbon resin coating on inner surface) ・Power source: AC100V, Cord: 1.8m ・Functions: temperature control: 65°C to 250°C, safety device: thermostat/thermal fuse, power consumption: 1200W ・Accessories: flat plate, takoyaki plate, magnetic detachable power cord",
    description_jpn:
      "食卓に笑顔が集まる、愉しさ広がる 大きくなったテーブルウェアのようなホットプレート 鋳物ホーローのお鍋をイメージしたコンパクトホットプレートに 4～5人にぴったりなサイズが仲間入り。 毎日の食卓～ちょっと特別なおうちパーティと、さまざまなシーンで大活躍！ サイズ： W480×H155×D280[mm]       3.2 Kg  材質：本体：スチール/フェノール樹脂、プレート：アルミニウム合金(内面ふっ素樹脂塗膜加工) 電源：AC100V、コード：1.8ｍ 機能：温度調節：65℃～250℃ 安全装置：サーモスタット/温度ヒューズ、消費電力:1200W 付属品：平プレート、たこ焼きプレート、マグネット式脱着電源コード",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE026-RD.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE026-RD_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "523",
    brand: "BRUNO",
    sku: "BOE026-WH",
    product_eng: "BRUNO Hotplate Grande size White",
    product_jpn: "BRUNO ホットプレート グランデサイズ ホワイト",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥17,000",
    rrp_with_vat: "¥18,700",
    description_eng:
      "Hot plate like a larger tableware that brings smiles and enjoyment to the dining table The compact hot plate is designed in the image of an enameled cast iron pot. The perfect size for 4 to 5 people. It is very useful for a variety of occasions, from everyday dining to special parties at home!  ・Size: W480 x H155 x D280 [mm] 3.2 Kg  ・Material: Main body: Steel/phenolic resin, Plate: Aluminum alloy (fluorocarbon resin coating on inner surface) ・Power source: AC100V, Cord: 1.8m ・Functions: temperature control: 65°C to 250°C, safety device: thermostat/thermal fuse, power consumption: 1200W ・Accessories: flat plate, takoyaki plate, magnetic detachable power cord",
    description_jpn:
      "食卓に笑顔が集まる、愉しさ広がる 大きくなったテーブルウェアのようなホットプレート 鋳物ホーローのお鍋をイメージしたコンパクトホットプレートに 4～5人にぴったりなサイズが仲間入り。 毎日の食卓～ちょっと特別なおうちパーティと、さまざまなシーンで大活躍！ サイズ： W480×H155×D280[mm]       3.2 Kg  材質：本体：スチール/フェノール樹脂、プレート：アルミニウム合金(内面ふっ素樹脂塗膜加工) 電源：AC100V、コード：1.8ｍ 機能：温度調節：65℃～250℃ 安全装置：サーモスタット/温度ヒューズ、消費電力:1200W 付属品：平プレート、たこ焼きプレート、マグネット式脱着電源コード",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE026-WH.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE026-WH_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "524",
    brand: "BRUNO",
    sku: "BOE034-IV",
    product_eng: "BRUNO Multi-stick Blender Ivory",
    product_jpn: "BRUNO マルチスティックブレンダー アイボリー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥6,500",
    rrp_with_vat: "¥7,150",
    description_eng:
      "For everyday cooking! Multi blender with 5 functions in 1 machine. Crush, mix, chop, crush, and whisk all in one machine! Easy one-handed cooking by changing attachments. It supports daily cooking from food preparation to drinks and baby food preparation. Includes an exclusive recipe leaf with 6 recipes.  Product size: W63 x H365 x D68 [mm] (with blender stick) Main unit + blender stick: 570g Main body + chopper bottle: 770 g Main body + whipper: 540g Power source: AC100V Material: Body: Polypropylene, Blender stick: Polypropylene / Stainless steel, Whipper: ABS resin / Stainless steel, Chopper: ABS resin / Stainless steel (titanium coating), Chopper bottle / Blender cup: AS resin Specs: Power consumption: 200 W (when blender and chopper are used) Functions: Blender (mashing, blending), Chopper (chopping, crushing), Whipper (whisking) Accessories: whipper, chopper bottle, lid for bottle, special cutter for chopper bottle, blender cup (500ml), cleaning brush, special recipe leaf Cord length: approx. 1.5m",
    description_jpn:
      "毎日のお料理に！ １台５役のマルチなブレンダー つぶす・混ぜる・刻む・砕く・泡立てるがこれ1台で！アタッチメントを付け替えて、片手で簡単調理。 下ごしらえからドリンク、離乳食づくりまで毎日のお料理をサポートします。 6つのレシピが掲載された専用レシピリーフ付き。  商品サイズ:W63×H365×D68[mm]（ブレンダースティック使用時） 本体＋ブレンダースティック：570g 本体＋チョッパーボトル：770g 本体＋ホイッパー：540g 電源:AC100V 材質:本体：ポリプロピレン、ブレンダースティック：ポリプロピレン／ステンレス鋼、ホイッパー：ABS樹脂／ステンレス鋼、チョッパー：ABS樹脂／ステンレス鋼（チタニウムコーティング）、チョッパーボトル・ブレンダーカップ：AS樹脂 スペック:消費電力：200W（ブレンダー・チョッパー使用時） 機能:ブレンダー（つぶす、混ぜる）、チョッパー（刻む、砕く）、ホイッパー（泡立てる） 付属品:ホイッパー、チョッパーボトル、ボトル用フタ、チョッパーボトル専用カッター、ブレンダーカップ（500ml）、お手入れブラシ、専用レシピリーフ コード長:約1.5m",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE034-IV.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE034-IV_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "525",
    brand: "BRUNO",
    sku: "BOE034-GR",
    product_eng: "BRUNO Multi-stick Blender Green",
    product_jpn: "BRUNO マルチスティックブレンダー グリーン",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥6,500",
    rrp_with_vat: "¥7,150",
    description_eng:
      "For everyday cooking! Multi blender with 5 functions in 1 machine. Crush, mix, chop, crush, and whisk all in one machine! Easy one-handed cooking by changing attachments. It supports daily cooking from food preparation to drinks and baby food preparation. Includes an exclusive recipe leaf with 6 recipes.  Product size: W63 x H365 x D68 [mm] (with blender stick) Main unit + blender stick: 570g Main body + chopper bottle: 770 g Main body + whipper: 540g Power source: AC100V Material: Body: Polypropylene, Blender stick: Polypropylene / Stainless steel, Whipper: ABS resin / Stainless steel, Chopper: ABS resin / Stainless steel (titanium coating), Chopper bottle / Blender cup: AS resin Specs: Power consumption: 200 W (when blender and chopper are used) Functions: Blender (mashing, blending), Chopper (chopping, crushing), Whipper (whisking) Accessories: whipper, chopper bottle, lid for bottle, special cutter for chopper bottle, blender cup (500ml), cleaning brush, special recipe leaf Cord length: approx. 1.5m",
    description_jpn:
      "毎日のお料理に！ １台５役のマルチなブレンダー つぶす・混ぜる・刻む・砕く・泡立てるがこれ1台で！アタッチメントを付け替えて、片手で簡単調理。 下ごしらえからドリンク、離乳食づくりまで毎日のお料理をサポートします。 6つのレシピが掲載された専用レシピリーフ付き。  商品サイズ:W63×H365×D68[mm]（ブレンダースティック使用時） 本体＋ブレンダースティック：570g 本体＋チョッパーボトル：770g 本体＋ホイッパー：540g 電源:AC100V 材質:本体：ポリプロピレン、ブレンダースティック：ポリプロピレン／ステンレス鋼、ホイッパー：ABS樹脂／ステンレス鋼、チョッパー：ABS樹脂／ステンレス鋼（チタニウムコーティング）、チョッパーボトル・ブレンダーカップ：AS樹脂 スペック:消費電力：200W（ブレンダー・チョッパー使用時） 機能:ブレンダー（つぶす、混ぜる）、チョッパー（刻む、砕く）、ホイッパー（泡立てる） 付属品:ホイッパー、チョッパーボトル、ボトル用フタ、チョッパーボトル専用カッター、ブレンダーカップ（500ml）、お手入れブラシ、専用レシピリーフ コード長:約1.5m",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE034-GR.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "526",
    brand: "BRUNO",
    sku: "BOE083-RD",
    product_eng: "BRUNO Grilled Sand Maker Single Red",
    product_jpn: "BRUNO グリルサンドメーカー シングル レッド",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥8,000",
    rrp_with_vat: "¥8,800",
    description_eng:
      "From hot sandwiches to authentic cooking, enjoy grilled sandwiches with greed A grilled sandwich maker that can be enjoyed morning, noon, and night. Simply insert the sandwiches and grill to quickly prepare hot sandwiches. The removable plate is easy to clean. The grilled surface, inspired by European baked sweets, will add color to your dining table.  Size: W165 x H145 x D240 mm Weight: approx. 2 kg Material: Body: Phenolic resin/steel/aluminum alloy, Plate: Aluminum alloy (fluoroplastic coating on inner surface) Power source: AC100V Rated power consumption: 550W Cord length: approx. 1.3 m Functions: timer, removable plate",
    description_jpn:
      "ホットサンドから本格料理まで、欲張りに愉しむグリルサンドメーカー 朝も昼も晩も、とことん愉しめるグリルサンドメーカー。 ギュッと挟んで焼くだけで、ホットサンドが手早く完成します。 プレートは取り外し式でお手入れも簡単。 ヨーロッパの焼き菓子をモチーフにした焼き目が食卓を華やかに彩ります。  サイズ：W165×H145×D240mm 重量：約2kg 材質：本体：フェノール樹脂/スチール/アルミニウム合金、プレート：アルミニウム合金( 内面ふっ素樹脂塗膜加工) 電源：AC100V 定格消費電力：550W コード長：約1.3m 機能：タイマー付き、プレート取りはずし可",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE083-RD.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE083-RD_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE083-RD_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "527",
    brand: "BRUNO",
    sku: "BOE083-GRG",
    product_eng: "BRUNO Grilled Sand Maker Single Greige",
    product_jpn: "BRUNO グリルサンドメーカー シングル グレージュ",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥8,000",
    rrp_with_vat: "¥8,800",
    description_eng:
      "From hot sandwiches to authentic cooking, enjoy grilled sandwiches with greed A grilled sandwich maker that can be enjoyed morning, noon, and night. Simply insert the sandwiches and grill to quickly prepare hot sandwiches. The removable plate is easy to clean. The grilled surface, inspired by European baked sweets, will add color to your dining table.  Size: W165 x H145 x D240 mm Weight: approx. 2 kg Material: Body: Phenolic resin/steel/aluminum alloy, Plate: Aluminum alloy (fluoroplastic coating on inner surface) Power source: AC100V Rated power consumption: 550W Cord length: approx. 1.3 m Functions: timer, removable plate",
    description_jpn:
      "ホットサンドから本格料理まで、欲張りに愉しむグリルサンドメーカー 朝も昼も晩も、とことん愉しめるグリルサンドメーカー。 ギュッと挟んで焼くだけで、ホットサンドが手早く完成します。 プレートは取り外し式でお手入れも簡単。 ヨーロッパの焼き菓子をモチーフにした焼き目が食卓を華やかに彩ります。  サイズ：W165×H145×D240mm 重量：約2kg 材質：本体：フェノール樹脂/スチール/アルミニウム合金、プレート：アルミニウム合金( 内面ふっ素樹脂塗膜加工) 電源：AC100V 定格消費電力：550W コード長：約1.3m 機能：タイマー付き、プレート取りはずし可",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE083-GRG.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE083-GRG_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "528",
    brand: "BRUNO",
    sku: "BOE084-RD",
    product_eng: "BRUNO Grilled Sand Maker Double Red",
    product_jpn: "BRUNO グリルサンドメーカー ダブル レッド",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥12,000",
    rrp_with_vat: "¥13,200",
    description_eng:
      "From hot sandwiches to authentic cooking, enjoy grilled sandwiches with greed Grilled sandwich maker for breakfast, lunch, and dinner. Just insert the sandwich and grill to quickly prepare hot sandwiches and paninis, or use the included double-size plate to grill meat and other authentic dishes. The plates are removable for easy cleaning. The baking motif of European baked goods adds color to your dining table.  Size: W285 x H145 x D240 mm Weight: approx. 3 kg Material: Main body: Phenolic resin/steel/aluminum alloy, Plate Aluminum alloy (fluorocarbon resin coated inner surface) Power source: AC100V Rated power consumption: 900W Cord length: approx. 1.3 m Functions: timer, removable plates, temperature control, oil tray Accessories: grill plate",
    description_jpn:
      "ホットサンドから本格料理まで、欲張りに愉しむグリルサンドメーカー 朝も昼も晩も、とことん愉しめるグリルサンドメーカー。 ギュッと挟んで焼くだけで、ホットサンドやパニーニが手早く完成するほか、ダブルサイズは付属プレートでお肉グリルなど本格料理が愉しめます。 プレートは取り外し式でお手入れも簡単。ヨーロッパの焼き菓子をモチーフにした焼き目が食卓を華やかに彩ります。  サイズ：W285×H145×D240mm 重量：約3kg 材質：本体：フェノール樹脂/スチール/アルミニウム合金、プレー ト：アルミニウム合金( 内面ふっ素樹脂塗膜加工) 電源：AC100V 定格消費電力：900W コード長：約1.3m 機能：タイマー付き、プレート取りはずし可、温度調節、油受けトレイ 付属品：グリルプレート",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE084-RD.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE084-RD_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "529",
    brand: "BRUNO",
    sku: "BOE084-GRG",
    product_eng: "BRUNO Grilled Sand Maker Double Greige",
    product_jpn: "BRUNO グリルサンドメーカー ダブル グレージュ",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥12,000",
    rrp_with_vat: "¥13,200",
    description_eng:
      "From hot sandwiches to authentic cooking, enjoy grilled sandwiches with greed Grilled sandwich maker for breakfast, lunch, and dinner. Just insert the sandwich and grill to quickly prepare hot sandwiches and paninis, or use the included double-size plate to grill meat and other authentic dishes. The plates are removable for easy cleaning. The baking motif of European baked goods adds color to your dining table.  Size: W285 x H145 x D240 mm Weight: approx. 3 kg Material: Main body: Phenolic resin/steel/aluminum alloy, Plate Aluminum alloy (fluorocarbon resin coated inner surface) Power source: AC100V Rated power consumption: 900W Cord length: approx. 1.3 m Functions: timer, removable plates, temperature control, oil tray Accessories: grill plate",
    description_jpn:
      "ホットサンドから本格料理まで、欲張りに愉しむグリルサンドメーカー 朝も昼も晩も、とことん愉しめるグリルサンドメーカー。 ギュッと挟んで焼くだけで、ホットサンドやパニーニが手早く完成するほか、ダブルサイズは付属プレートでお肉グリルなど本格料理が愉しめます。 プレートは取り外し式でお手入れも簡単。ヨーロッパの焼き菓子をモチーフにした焼き目が食卓を華やかに彩ります。  サイズ：W285×H145×D240mm 重量：約3kg 材質：本体：フェノール樹脂/スチール/アルミニウム合金、プレー ト：アルミニウム合金( 内面ふっ素樹脂塗膜加工) 電源：AC100V 定格消費電力：900W コード長：約1.3m 機能：タイマー付き、プレート取りはずし可、温度調節、油受けトレイ 付属品：グリルプレート",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE084-GRG.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE084-GRG_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "530",
    brand: "BRUNO",
    sku: "BOE076-GRG",
    product_eng: "BRUNO Styling Handy Steamer Greige",
    product_jpn: "BRUNO スタイリングハンディスチーマー  グレージュ",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥7,500",
    rrp_with_vat: "¥8,250",
    description_eng:
      "On busy mornings before going out, it takes only about 25 seconds to get up and ready. Powerful steam quickly removes wrinkles while the clothes are still on the hanger. The lightweight and compact design allows even women to work with one hand, while the large-capacity tank eliminates the need to refill with water. It also sterilizes curtains and sofas that are difficult to wash, removes allergens such as pollen, and deodorizes tobacco and pet odors. It can be used for a wide range of purposes, from clothing care during busy weekdays to interior care on holidays. It will help you to straighten out the wrinkles in your clothes and refresh your mind. It will make your daily life easier and hassle-free.  Size: W93 x H217 x D110 mm Weight: approx. 750g Material: Nylon, Polycarbonate, Stainless steel Power source: AC100V Cord length: approx. 3 m Specifications: Rated power consumption: 1,000W; Maximum continuous steam usage time: approx. 8 minutes; Steam volume: Lo mode: approx. 10ml/min, Hi mode: approx. 18ml/min; Tank capacity: approx. 130ml Function: Automatic heater OFF function Accessories: water filling cup, head cover, brush",
    description_jpn:
      "お出かけ前の忙しい朝も、立ち上がり約25秒でスピーディに準備完了。 ハンガーにかけたまま、パワフルなスチームで気になるシワをサッと伸ばします。 女性でも片手で作業できる軽量コンパクトながら、大容量タンクで水を入れ直す手間を省きます。 丸洗いしにくいカーテンやソファの除菌、花粉などのアレルゲンの除去、タバコ臭やペット臭などの消臭もでき、 忙しい平日の衣類ケアから休日のインテリアのケアまで幅広く使用できます。 衣類のシワをピンと伸ばして心もすっきり。毎日の暮らしを手間なく整えます。  サイズ：W93×H217×D110mm 重量：約750g 材質：ナイロン、ポリカーボネート、ステンレススチール 電源：AC100V コード長：約3m スペック：定格消費電力：1,000W、スチーム連続使用可能時間：最大約8分、スチーム量：Lo モード：約10ml/分、Hi モード：約18ml/分、タンク容量：約130ml 機能：自動ヒーターOFF機能 付属品：注水カップ、ヘッドカバー、ブラシ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE076-GRG.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE076-GRG_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE076-GRG_3.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE076-GRG_4.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "531",
    brand: "BRUNO",
    sku: "BOE076-BGY",
    product_eng: "BRUNO Styling Handy Steamer Blue Grey",
    product_jpn: "BRUNO スタイリングハンディスチーマー  ブルーグレー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥7,500",
    rrp_with_vat: "¥8,250",
    description_eng:
      "On busy mornings before going out, it takes only about 25 seconds to get up and ready. Powerful steam quickly removes wrinkles while the clothes are still on the hanger. The lightweight and compact design allows even women to work with one hand, while the large-capacity tank eliminates the need to refill with water. It also sterilizes curtains and sofas that are difficult to wash, removes allergens such as pollen, and deodorizes tobacco and pet odors. It can be used for a wide range of purposes, from clothing care during busy weekdays to interior care on holidays. It will help you to straighten out the wrinkles in your clothes and refresh your mind. It will make your daily life easier and hassle-free.  Size: W93 x H217 x D110 mm Weight: approx. 750g Material: Nylon, Polycarbonate, Stainless steel Power source: AC100V Cord length: approx. 3 m Specifications: Rated power consumption: 1,000W; Maximum continuous steam usage time: approx. 8 minutes; Steam volume: Lo mode: approx. 10ml/min, Hi mode: approx. 18ml/min; Tank capacity: approx. 130ml Function: Automatic heater OFF function Accessories: water filling cup, head cover, brush",
    description_jpn:
      "お出かけ前の忙しい朝も、立ち上がり約25秒でスピーディに準備完了。 ハンガーにかけたまま、パワフルなスチームで気になるシワをサッと伸ばします。 女性でも片手で作業できる軽量コンパクトながら、大容量タンクで水を入れ直す手間を省きます。 丸洗いしにくいカーテンやソファの除菌、花粉などのアレルゲンの除去、タバコ臭やペット臭などの消臭もでき、 忙しい平日の衣類ケアから休日のインテリアのケアまで幅広く使用できます。 衣類のシワをピンと伸ばして心もすっきり。毎日の暮らしを手間なく整えます。  サイズ：W93×H217×D110mm 重量：約750g 材質：ナイロン、ポリカーボネート、ステンレススチール 電源：AC100V コード長：約3m スペック：定格消費電力：1,000W、スチーム連続使用可能時間：最大約8分、スチーム量：Lo モード：約10ml/分、Hi モード：約18ml/分、タンク容量：約130ml 機能：自動ヒーターOFF機能 付属品：注水カップ、ヘッドカバー、ブラシ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE076-BGY.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE076-BGY_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE076-BGY_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "532",
    brand: "BRUNO",
    sku: "BOE047-IV",
    product_eng: "BRUNO Multi-Futon Dryer Ivory ",
    product_jpn: "BRUNO マルチふとんドライヤー アイボリー ",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥14,000",
    rrp_with_vat: "¥15,400",
    description_eng:
      "No mat is required. Just insert the telescopic nozzle into the futon to warm the futon from corner to corner. It can also be used for clothes drying, shoe drying (special attachment included), and heating, in addition to futon warming and tick prevention. The compact body and wood-grain handle are designed to fit in with any interior.  Size: W360xH225xD115 [mm] 1.4 kg Material：Polypropylene/ABS resin Power source: AC100V Power consumption: 500W Specs: Safety devices (thermostat to prevent over-temperature rise, thermal fuse) Warm air temperature near outlet: max. approx. 75°C Functions: Comforter drying: 60 min (winter)/120 min (summer) *Single size only; Dust mite control: 120 min; Clothes drying: 90 min; Shoe drying: 30 min Accessories: Shoe drying attachment Remarks: Cord length: approx. 2 m",
    description_jpn:
      "マット不要、ふとんに伸縮式のノズルを入れるだけでふとんを隅々まで温めます。ふとんの温めやダニ対策以外にも、衣類乾燥やくつ乾燥(専用アタッチメント付属)、暖房としての使用もOK。縦置きで収納できるので、省スペース。 コンパクトボディに木目調のハンドルで、インテリアにも馴染むデザインです。  サイズ：W360xH225xD115［mm］  1.4㎏ 材 質：ポリプロピレン/ABS樹脂 電 源：AC100V 消費電力：500Ｗ スペック：安全装置（温度過昇防止用サーモスタット、温度ヒューズ） 吹き出し口付近の温風温度：最高約75℃ 機能：・ふとん乾燥：60 分（冬）/120 分（夏）※シングルサイズ専用・ダニ対策：120 分・衣類乾燥：90 分・くつ乾燥：30 分 付属品：くつ乾燥アタッチメント 備考：コード長：約2m",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/bruno_boe047-iv.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE047-IV_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE047-IV_3.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE047-IV_4.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "533",
    brand: "BRUNO",
    sku: "BOE053-GRG",
    product_eng: "BRUNO crassy+ Oval Hotplate Greige",
    product_jpn: "BRUNO crassy+ オーバルホットプレート グレージュ",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥17,000",
    rrp_with_vat: "¥18,700",
    description_eng:
      "The set includes a full range of plates: flat, takoyaki, and deep pan. The included handles make it easy to change plates. The host can also enjoy cooking with guests as they can cook one after another at the table. A waste tray is included for easy cleaning. The design makes you want to use it every day.  Product size: W390 x H150 x D260[mm], approx. 2.8 kg (with flat plate and lid, including power cord) Power source: AC100V Material: Main body: Steel/phenolic resin, flat plate           Takoyaki plate: Aluminum alloy (fluoroplastic coated inner surface)           Deep pan: Aluminum alloy (inner surface ceramic coated, outer surface fluorocarbon resin coated)           Scrap tray: steel           Plate replacement handle: stainless steel Specifications: Rated power consumption: 1,200W Functions: Plate replaceable, Temperature control, Scrap tray Accessories: Flat plate (W315 x D235 x H33mm), Takoyaki plate, Deep pan (W385 x D249 x H63mm), Plate replacement handles x 2, Silicon mat, Magnetic detachable power cord Cord length: approx. 1.8m",
    description_jpn:
      "平面、たこ焼き、深鍋と充実のプレートがセットに。付属のハンドルを使えば、プレートの取り替えも楽々。 テーブルで次々と調理できるので、ホストもゲストと一緒にたのしめます。くず受けトレイ付きでお手入れも簡単。 毎日使いたくなるデザインです。  商品サイズ:W390×H150×D260[mm] 約2.8kg（平面プレート・フタ使用時、電源コード含む） 電源:AC100V 材質:本体：スチール/フェノール樹脂、平面プレート      たこ焼きプレート：アルミニウム合金(内面ふっ素樹脂塗膜加工)      深鍋：アルミニウム合金(内面セラミックコート、外面ふっ素樹脂塗膜加工)      くず受けトレイ：スチール      プレート取り替え用ハンドル：ステンレス鋼 スペック:定格消費電力：1,200W 機能:プレート取り替え式、温度調節、くず受けトレイ 付属品:平面プレート(W315×D235×H33mm）、たこ焼きプレート、深鍋（W385×D249×H63mm）、プレート取り替え用ハンドル×2、シリコンマット、マグネット式脱着電源コード コード長:約1.8ｍ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE053-GRG.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE053-GRG_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "534",
    brand: "BRUNO",
    sku: "BOE053-BK",
    product_eng: "BRUNO crassy+ Oval Hotplate Black",
    product_jpn: "BRUNO crassy+ オーバルホットプレート ブラック",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥17,000",
    rrp_with_vat: "¥18,700",
    description_eng:
      "The set includes a full range of plates: flat, takoyaki, and deep pan. The included handles make it easy to change plates. The host can also enjoy cooking with guests as they can cook one after another at the table. A waste tray is included for easy cleaning. The design makes you want to use it every day.  Product size: W390 x H150 x D260[mm], approx. 2.8 kg (with flat plate and lid, including power cord) Power source: AC100V Material: Main body: Steel/phenolic resin, flat plate           Takoyaki plate: Aluminum alloy (fluoroplastic coated inner surface)           Deep pan: Aluminum alloy (inner surface ceramic coated, outer surface fluorocarbon resin coated)           Scrap tray: steel           Plate replacement handle: stainless steel Specifications: Rated power consumption: 1,200W Functions: Plate replaceable, Temperature control, Scrap tray Accessories: Flat plate (W315 x D235 x H33mm), Takoyaki plate, Deep pan (W385 x D249 x H63mm), Plate replacement handles x 2, Silicon mat, Magnetic detachable power cord Cord length: approx. 1.8m",
    description_jpn:
      "平面、たこ焼き、深鍋と充実のプレートがセットに。付属のハンドルを使えば、プレートの取り替えも楽々。 テーブルで次々と調理できるので、ホストもゲストと一緒にたのしめます。くず受けトレイ付きでお手入れも簡単。 毎日使いたくなるデザインです。  商品サイズ:W390×H150×D260[mm] 約2.8kg（平面プレート・フタ使用時、電源コード含む） 電源:AC100V 材質:本体：スチール/フェノール樹脂、平面プレート      たこ焼きプレート：アルミニウム合金(内面ふっ素樹脂塗膜加工)      深鍋：アルミニウム合金(内面セラミックコート、外面ふっ素樹脂塗膜加工)      くず受けトレイ：スチール      プレート取り替え用ハンドル：ステンレス鋼 スペック:定格消費電力：1,200W 機能:プレート取り替え式、温度調節、くず受けトレイ 付属品:平面プレート(W315×D235×H33mm）、たこ焼きプレート、深鍋（W385×D249×H63mm）、プレート取り替え用ハンドル×2、シリコンマット、マグネット式脱着電源コード コード長:約1.8ｍ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE053-BK.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE053-BK_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE053-BK_3.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE053-BK_4.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "535",
    brand: "BRUNO",
    sku: "BOE067-GRG",
    product_eng: "BRUNO crassy+ Steam and Bake toaster Greige",
    product_jpn: "BRUNO crassy+ スチーム＆ベイクトースター グレージュ",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥15,000",
    rrp_with_vat: "¥16,500",
    description_eng:
      "This toaster makes your morning toast taste like new and makes your  cooking quick and tasty.  Prepared foods taste freshly prepared just by reheating them.  On weekends, you can bake a whole cake or a toast in the spacious oven that can bake 4 slices of bread at a time. Bake a pizza and share the delicious taste and time together. Stylish design and easy to clean. This is the toaster for you that fulfills your desires.  Product size: W350 x H225 x D370[mm], 4.8 kg  (inside cabinet size: W280 x H80 x D260[mm])  Power source: AC100V Material: Body: Galvalume steel sheet, Door: Glass, Grill net: Stainless steel, Tray: Aluminum plated steel sheet Rated power consumption: 1,350W Functions: bakes 4 cubes of bread, heating modes (steam, convection, normal), temperature control, timer 30 min. Accessories: water cup, baking tray, net for baking tray, bread crumb tray, recipe leaflet  Cord length: approx. 1.2 m",
    description_jpn:
      "いつもの朝のトーストが見違えるほどの味に、そして毎晩の料理が手早くおいしく仕上がるトースター。  お惣菜は温めなおすだけで出来立ての味に。休日は、食パン４枚が一度に焼ける広い庫内でホールケーキや ピザを焼いて、おいしさと時間をみんなでシェア。スタイリッシュなデザインで、お手入れも簡単。 “わがまま” をかなえる、あなたのためのトースターです。  商品サイズ：W350×H225×D370[mm]、4.8kg（庫内サイズ：W280×H80×D260[mm]) 電源：AC100V 材質：本体: ガルバリウム鋼板、ドア: ガラス、焼き網：ステンレス、トレイ：アルミメッキ鋼板 スペック：定格消費電力：1,350W 機能：角食パン4 枚焼き、加熱モード（スチーム、コンベクション、ノーマル）、温度調節、タイマー30 分 付属品：給水カップ、ベイキングトレイ、ベイキングトレイ用網、パンくずトレー、レシピリーフレット  コード長：約1.2ｍ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE067-GRG.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE067-GRG_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE067-GRG_3.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE067-GRG_4.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "536",
    brand: "BRUNO",
    sku: "BOE067-BK",
    product_eng: "BRUNO crassy+ Steam and Bake toaster Black",
    product_jpn: "BRUNO crassy+ スチーム＆ベイクトースター ブラック",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥15,000",
    rrp_with_vat: "¥16,500",
    description_eng:
      "This toaster makes your morning toast taste like new and makes your  cooking quick and tasty.  Prepared foods taste freshly prepared just by reheating them.  On weekends, you can bake a whole cake or a toast in the spacious oven that can bake 4 slices of bread at a time. Bake a pizza and share the delicious taste and time together. Stylish design and easy to clean. This is the toaster for you that fulfills your desires.  Product size: W350 x H225 x D370[mm], 4.8 kg  (inside cabinet size: W280 x H80 x D260[mm])  Power source: AC100V Material: Body: Galvalume steel sheet, Door: Glass, Grill net: Stainless steel, Tray: Aluminum plated steel sheet Rated power consumption: 1,350W Functions: bakes 4 cubes of bread, heating modes (steam, convection, normal), temperature control, timer 30 min. Accessories: water cup, baking tray, net for baking tray, bread crumb tray, recipe leaflet  Cord length: approx. 1.2 m",
    description_jpn:
      "いつもの朝のトーストが見違えるほどの味に、そして毎晩の料理が手早くおいしく仕上がるトースター。  お惣菜は温めなおすだけで出来立ての味に。休日は、食パン４枚が一度に焼ける広い庫内でホールケーキや ピザを焼いて、おいしさと時間をみんなでシェア。スタイリッシュなデザインで、お手入れも簡単。 “わがまま” をかなえる、あなたのためのトースターです。  商品サイズ：W350×H225×D370[mm]、4.8kg（庫内サイズ：W280×H80×D260[mm]) 電源：AC100V 材質：本体: ガルバリウム鋼板、ドア: ガラス、焼き網：ステンレス、トレイ：アルミメッキ鋼板 スペック：定格消費電力：1,350W 機能：角食パン4 枚焼き、加熱モード（スチーム、コンベクション、ノーマル）、温度調節、タイマー30 分 付属品：給水カップ、ベイキングトレイ、ベイキングトレイ用網、パンくずトレー、レシピリーフレット  コード長：約1.2ｍ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE067-BK.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE067-BK_2.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "537",
    brand: "BRUNO",
    sku: "BOE058-IV",
    product_eng: "BRUNO crassy+ Pressure Cooker Ivory",
    product_jpn: "BRUNO crassy+ マルチ圧力クッカー アイボリー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥16,000",
    rrp_with_vat: "¥17,600",
    description_eng:
      "All you have to do is prepare the food and press the button. From the usual side dishes to time-consuming stewed dishes Automatic cooking is ready. You don't have to be at the pot all the time.  Size: W253xH280xD268 [mm], approx. 3.2 kg (excluding power cord) Material: Body: Polypropylene/steel plate, Lid: Polypropylene, stainless steel, Inner pot: Aluminum alloy (with fluorine coating on the inside) Capacity: Cooking capacity: approx. 1.5L/ Nominal capacity (full water capacity): approx. 2.5L, Rated power consumption: 700W, Maximum operating pressure: 70kPa gauge pressure Rated power consumption: 700W  Power source: AC100V Functions: One-touch menu mode (5 menus), manual mode, keep warm function (max. 12 hours), slow cooking mode (max. 12 hours), warming mode □Remarks: Cord length: approx. 1.8 m Accessories: measuring cup, dedicated power cord, dedicated recipe leaflet",
    description_jpn:
      "下準備をしてボタンを押すだけ。いつものおかずから手間のかかる煮込み料理まで、 自動調理でできあがります。鍋につきっきりにならないので、時間のない 平日などもゆとりが生まれます。  サイズ：W253xH280xD268［mm］ 約3.2kg（電源コード除く） 材質：本体：ポリプロピレン/鋼板、ふた：ポリプロピレン、ステンレス鋼、内なべ：アルミニウム合金(内側ふっ素塗膜加工) 容量：調理容量：約1.5L/ 呼び容量(満水容量)：約2.5L、定格消費電力：700W、使用最高圧力：70kPaゲージ圧 定格消費電力：700W  電源：AC100V 機能：ワンタッチメニューモード(5メニュー)、マニュアルモード、保温機能( 最大12 時間)、スロー調理モード( 最大12 時間）、あたためモード    □備考：コード長：約1.8m 付属品：計量カップ、専用電源コード、専用レシピリーフレット",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE058-IV.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "538",
    brand: "BRUNO",
    sku: "BOE058-BR",
    product_eng: "BRUNO crassy+ Pressure Cooker Brown",
    product_jpn: "BRUNO crassy+ マルチ圧力クッカー ブラウン",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥16,000",
    rrp_with_vat: "¥17,600",
    description_eng:
      "All you have to do is prepare the food and press the button. From the usual side dishes to time-consuming stewed dishes Automatic cooking is ready. You don't have to be at the pot all the time.  Size: W253xH280xD268 [mm], approx. 3.2 kg (excluding power cord) Material: Body: Polypropylene/steel plate, Lid: Polypropylene, stainless steel, Inner pot: Aluminum alloy (with fluorine coating on the inside) Capacity: Cooking capacity: approx. 1.5L/ Nominal capacity (full water capacity): approx. 2.5L, Rated power consumption: 700W, Maximum operating pressure: 70kPa gauge pressure Rated power consumption: 700W  Power source: AC100V Functions: One-touch menu mode (5 menus), manual mode, keep warm function (max. 12 hours), slow cooking mode (max. 12 hours), warming mode □Remarks: Cord length: approx. 1.8 m Accessories: measuring cup, dedicated power cord, dedicated recipe leaflet",
    description_jpn:
      "下準備をしてボタンを押すだけ。いつものおかずから手間のかかる煮込み料理まで、 自動調理でできあがります。鍋につきっきりにならないので、時間のない 平日などもゆとりが生まれます。  サイズ：W253xH280xD268［mm］ 約3.2kg（電源コード除く） 材質：本体：ポリプロピレン/鋼板、ふた：ポリプロピレン、ステンレス鋼、内なべ：アルミニウム合金(内側ふっ素塗膜加工) 容量：調理容量：約1.5L/ 呼び容量(満水容量)：約2.5L、定格消費電力：700W、使用最高圧力：70kPaゲージ圧 定格消費電力：700W  電源：AC100V 機能：ワンタッチメニューモード(5メニュー)、マニュアルモード、保温機能( 最大12 時間)、スロー調理モード( 最大12 時間）、あたためモード    □備考：コード長：約1.8m 付属品：計量カップ、専用電源コード、専用レシピリーフレット",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE058-BR.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE058-BR_2.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bruno/BRUNO_BOE058-BR_3.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bruno.png",
  },
  {
    id: "539",
    brand: "Dyson",
    sku: "TP07 WS",
    product_eng: "Dyson Purifier Cool™ White/Silver",
    product_jpn:
      "Dyson ダイソンPurifier Cool™空気清浄ファン ホワイト／シルバー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥72,500",
    rrp_with_vat: "¥79,750",
    description_eng:
      "Air purification for the entire room while delivering cool air.  Purifies the air of the entire room in two stages: a highly sealed filter system and a powerful circulation system. The entire product as well as the filter reliably purifies the air by trapping 99.95% of PM0.1. -Double function as an air purifier and fan. -Diffused mode changes the direction of the airflow and directs it through an opening in the rear of the unit, purifying the air without sending cool air during cold weather. -LCD display shows air quality. -350° swivel function to circulate air throughout the room. -High-performance HEPA filter. -No periodic maintenance required. Simply replace the filter. -Dyson Link app integration.  <Product Specifications> Main unit weight: 4.99 kg Height: 1050mm Depth: 220mm Width: 220mm *Width and depth to fit in an A4-size printer, so it can be placed anywhere. Min / Max Power Consumption Air purification mode 6 / 40 Min / Max Operating Noise - Fan Mode Air purification mode 26.3 / 47.0 Air cleaning capacity Applicable floor area 12 tatami*II (30 min) / 35 tatami*III (60 min) (Approx. 22 min*II to purify 8 tatami mats)",
    description_jpn:
      "涼風を送り出しながら、部屋全体の空気清浄。  密閉性の高いフィルターシステムとパワフルな循環システムの2段階で、部屋全体の空気を浄化します。 フィルターだけでなく製品全体でもPM0.1を99.95％閉じ込めることで、確実に空気を浄化します。 -空気清浄機、扇風機の1台2役 -ディフューズドモードは風の向きを変えて 本体後方の開口部から 送り出し、寒い時期には 涼しい風を送らずに 空気を浄化します。 -LCDディスプレイに空気の状態を表示。 -350°首振り機能で、部屋全体に空気を循環。 -高性能HEPAフィルター搭載。 -定期的なお手入れ不要。フィルターを交換するだけです。 -Dyson Linkアプリ連携。  <製品仕様> 本体質量:4.99kg 高さ:1050mm 奥行き:220mm 幅:220mm ＊A4サイズに収まる幅・奥行で置き場所を選びません。 最小 / 最大消費電力 空気清浄モード 6 / 40 最小 / 最大運転音 - ファンモード 空気清浄モード 26.3 / 47.0 空気清浄能力 適用床面積 12畳*II(30分) / 35畳*III(60分) (8畳を浄化する目安 22分*II)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_TP07+WS.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_TP07+WS_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_TP07+WS_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "540",
    brand: "Dyson",
    sku: "TP07 SB",
    product_eng: "Dyson Purifier Cool™ Silver/Blue",
    product_jpn: "Dysonダイソン Purifier Cool™空気清浄ファン シルバー／ブルー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥72,500",
    rrp_with_vat: "¥79,750",
    description_eng:
      "Air purification for the entire room while delivering cool air.  Purifies the air of the entire room in two stages: a highly sealed filter system and a powerful circulation system. The entire product as well as the filter reliably purifies the air by trapping 99.95% of PM0.1. -Double function as an air purifier and fan. -Diffused mode changes the direction of the airflow and directs it through an opening in the rear of the unit, purifying the air without sending cool air during cold weather. -LCD display shows air quality. -350° swivel function to circulate air throughout the room. -High-performance HEPA filter. -No periodic maintenance required. Simply replace the filter. -Dyson Link app integration.  <Product Specifications> Main unit weight: 4.99 kg Height: 1050mm Depth: 220mm Width: 220mm *Width and depth to fit in an A4-size printer, so it can be placed anywhere. Min / Max Power Consumption Air purification mode 6 / 40 Min / Max Operating Noise - Fan Mode Air purification mode 26.3 / 47.0 Air cleaning capacity Applicable floor area 12 tatami*II (30 min) / 35 tatami*III (60 min) (Approx. 22 min*II to purify 8 tatami mats)",
    description_jpn:
      "涼風を送り出しながら、部屋全体の空気清浄。  密閉性の高いフィルターシステムとパワフルな循環システムの2段階で、部屋全体の空気を浄化します。 フィルターだけでなく製品全体でもPM0.1を99.95％閉じ込めることで、確実に空気を浄化します。 -空気清浄機、扇風機の1台2役 -ディフューズドモードは風の向きを変えて 本体後方の開口部から 送り出し、寒い時期には 涼しい風を送らずに 空気を浄化します。 -LCDディスプレイに空気の状態を表示。 -350°首振り機能で、部屋全体に空気を循環。 -高性能HEPAフィルター搭載。 -定期的なお手入れ不要。フィルターを交換するだけです。 -Dyson Linkアプリ連携。  <製品仕様> 本体質量:4.99kg 高さ:1050mm 奥行き:220mm 幅:220mm ＊A4サイズに収まる幅・奥行で置き場所を選びません。 最小 / 最大消費電力 空気清浄モード 6 / 40 最小 / 最大運転音 - ファンモード 空気清浄モード 26.3 / 47.0 空気清浄能力 適用床面積 12畳*II(30分) / 35畳*III(60分) (8畳を浄化する目安 22分*II)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_TP07+SB.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_TP07+SB_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_TP07+SB_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "541",
    brand: "Dyson",
    sku: "PH03 WS N",
    product_eng: "Dyson Purifier Humidify+Cool™ White/Silver",
    product_jpn:
      "Dysonダイソン Purifier Humidify+Cool™ 加湿空気清浄機 ホワイト／シルバー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥98,000",
    rrp_with_vat: "¥107,800",
    description_eng:
      "Powerful circulation of cool air for comfort.  Unmatched Air Multiplier™ technology circulates purified and humidified air throughout the room. -Up to 36 hours of humidification. Efficient humidification control and 5 liter tank capacity allow continuous operation without the need for periodic water refills. -As an air purifying fan in summer. On hot days, it can also be used as a fan to cool the air with purified breeze. -No periodic maintenance required. -The air purification filter does not need to be washed with water or cleaned. Simply remove the old filter and install a new one. -Humidification Care Function Dyson's humidification care function is activated at the touch of a button and shows simple instructions on the LCD display. -Diffused mode The airflow is redirected through an opening in the back of the unit to purify and humidify the air without sending cool air during cold weather. -Breathe mode A unique algorithm changes the direction of the airflow to deliver a refreshingly cool breeze. -Jet Axis Control Two airflow direction adjusters are used to adjust the direction of airflow. The direction of the airflow can be adjusted by turning the direction of the two regulators in the same direction or in different directions.  <Product Specifications> Main unit weight: 8.1 kg Height: 923mm Depth: 312mm Width: 312mm Minimum/maximum power consumption (w)*I Air cleaning mode 7 / 41 Humidification mode 9 / 43 Min. / Max. operating noise (dB)*I Air cleaning mode 24.3 / 47.9 Humidification mode 24.4 / 47.8 Humidification capacity Applicable floor area (tatami)*IV 10 tatami / 6 tatami (350mL/h)",
    description_jpn:
      "涼しい風をパワフルに循環し快適に。  他にはないAir Multiplier™テクノロジーにより、浄化・加湿された空気を部屋全体に循環させます。 -最大36時間の加湿。効率的な加湿制御機能と5リットルのタンク容量により、定期的に水を補充する必要がなく、連続運転が可能です。 -夏は空気清浄ファンとして。暑い日には扇風機にもなり、浄化された風で涼しくします。 -定期的なお手入れ不要 -空気清浄フィルターは水洗いや掃除などの面倒なお手入れは必要ありません。古いフィルターを外して新しいフィルターを装着するだけで簡単です。 -加湿お手入れ機能 ダイソンの加湿お手入れ機能は、ボタンひとつで作動し、簡単な手順をLCDディスプレイに表示します。 -ディフューズドモード 風の向きを変えて本体後方の開口部から送り出し、寒い時期には涼しい風を送らずに空気を浄化・加湿します。 -ブリーズモード 独自のアルゴリズムにより風向きを変化させて、さわやかな涼風を送り出します。 -ジェットアクシスコントロール 2つの風向調整器により送風方向を調整します。風向調整器の向きを同じ方向にしたり別方向にすることにより送風を調整することができます。  <製品仕様> 本体質量:8.1kg 高さ:923mm 奥行き:312mm 幅:312mm 最小 / 最大消費電力(w)*I 空気清浄モード 7 / 41 加湿モード 9 / 43 最小 / 最大運転音(dB)*I 空気清浄モード 24.3 / 47.9 加湿モード 24.4 / 47.8 加湿能力 適用床面積(畳)*Ⅳ 10畳 / 6畳 (350ｍL/h)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_PH03+WS+N.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_PH03 WS+N_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "544",
    brand: "T-fal",
    sku: "DV7530J0",
    product_eng: "T-fal Clothes Steamer shu-shu Cordless",
    product_jpn: "T-fal ティファール スチーム シュシュ コードレス",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥12,800",
    rrp_with_vat: "¥14,080",
    description_eng:
      "Cordless, so you can reach anywhere without wrinkles! 2-way type clothes steamer that can also be used as an iron.  <Cordless or corded can be selected according to the usage scenario.> One touch of a lever allows you to switch between cordless and corded. You can use it as a cordless iron when you need to care for multiple pieces of clothing, and as a corded iron when you need to care for multiple pieces of clothing. Depending on the condition and quantity of clothes, you can use the steamer and iron, or cordless and corded, in the best combination.  <Powerful steam of up to 14g/min(*1)> A large amount of steam penetrates deep into the fibers and loosens the cause of wrinkles. *1. When the machine is used vertically. Varies depending on usage conditions.  <Automatic shut-off safety device> Even if you forget to turn off the switch, the power will automatically turn off after about 13 minutes of inactivity.  <Convenient temperature control for ironing> Three temperature settings (high, medium, and low) can be adjusted to suit the material and application when ironing.    Product Size (Dimensions)   Width (mm):83 Depth (mm):172 Height (mm):145 Weight (g):830 Cord length (m):2.6 Capacity (ml):100    Performance (ratings and specifications)   Power consumption: 1200W Frequency: 50-60Hz Thermal fuse: 240°C",
    description_jpn:
      "コードレスだから、どこでも届いてシワなしに! アイロンとしても使える2WAYタイプ衣類スチーマー。 【使用シーンに応じて選べるコードレスとコード付】 レバー1つでワンタッチにコードレス/コード付きの切り替えが可能。 お出かけ前に気になる所は、コードレスでスチームをあててサッとシワ伸ばし、何枚も衣類のお手入れをするときはコード付アイロンとして。 衣類の状態や量に応じて、スチーマーとアイロン、そしてコードレスとコード付と最適な組み合わせでお使いいただけます。  【最大14g/分(※1)のパワフルスチーム】 大量のスチームが繊維の奥に浸透し、シワの原因をほぐします。 ※1.本体垂直使用時の場合。使用条件などによっても異なります。  【自動停止安全装置】 スイッチを消し忘れても、約13分間操作がないと自動的に電源がオフになるから、万が一の際にも安心。  【アイロン時も便利な温度調節】 アイロン時には素材や用途に合わせて高・中・低の3段階の温度調節が可能です。    製品サイズ（寸法）   幅 (mm):83 奥行き (mm):172 高さ (mm):145 重量 (g):830 コードの長さ (m):2.6 容量 (ml):100    性能（定格、製品仕様）   消費電力:1200W 周波数:50-60Hz 温度ﾋｭｰｽﾞ:240℃",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_DV7530J0.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_DV7530J0_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_DV7530J0_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "545",
    brand: "T-fal",
    sku: "HB65GDJP",
    product_eng: "T-fal Hand Blender Baby Light Gray",
    product_jpn: "T-fal ティファール ハンドブレンダー ベビー ライトグレー",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥10,800",
    rrp_with_vat: "¥11,880",
    description_eng:
      "A three-in-one hand blender capable of making baby food and mashing and mixing is now available!  With the baby food blender, even a small amount (about 50ml) of baby food in the early stages of weaning can be stirred evenly and smoothly. The baby food blender makes it possible to prepare baby food according to the baby's age, from the early stages of weaning to the complete stage of weaning. Accessories] Blender, blender for baby food, cooking cup, cup for baby food, recipe book     Product Size (Dimensions)   Width (mm):70 Depth (mm):70 Height (mm):400 Weight (g):820 Cord length (m):1.4    Performance (ratings and product specifications)   Voltage: 100V Power consumption: 400W Frequency: 50-60Hz",
    description_jpn:
      "「離乳食作り」、「つぶす・混ぜる」が可能な、1台3役のハンドブレンダー登場！  離乳食ブレンダーを使えば、離乳食初期の少量（50ml程度）でも均一に、なめらかに攪拌できます。 離乳食初期～完了期まで、月齢に合わせた離乳食づくりが可能です。 【付属品】ブレンダー、離乳食用ブレンダー、クッキングカップ、離乳食用カップ、レシピブック     製品サイズ（寸法）   幅（mm）:70 奥行き（mm）:70 高さ（mm）:400 重量（g）:820 コードの長さ (m):1.4    性能（定格、製品仕様）   電圧:100V 消費電力:400W 周波数:50-60Hz",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_HB65GDJP.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_HB65GDJP_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_HB65GDJP_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "547",
    brand: "T-fal",
    sku: "KO8001JP",
    product_eng: "T-fal Washable Kettle 0.8L",
    product_jpn: "T-falティファール ウォッシャブル 0.8L",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥9,880",
    rrp_with_vat: "¥10,868",
    description_eng:
      "Safe to wash the whole thing! Electric kettle that can be both rinsed and left to soak.ddd<Always clean! Ag+ (silver ions) antibacterial power>ddMicroban(R), an antibacterial material containing Ag+, is used.ddThe plastic surface is kept clean.ddd<Easy-to-use functions>dd・Automatically turns off when the water boils. Sound and light notifications.dd・Spout cover to prevent dust from entering.dd・Removable and easily washable filter.dd・A window that allows you to check the capacity at a glance.dd・Automatic power off.ddd  Product Size (Dimensions) d dWidth (mm):2d20dDepth (mm):1d55dHeight (mm):2d05dWeight (g):1,1d00dCord length (m):1.3ddCapacity (mL):8d00dd  Performance (ratings and specifications) d dVoltage: 1d00VdPower consumption: 1d250WdFrequency: 50-60Hz",
    description_jpn:
      "丸d洗いしても安心！洗い流しもつけ置き洗いも可能な電気ケトル。dd【いつでも清潔！“Ag+（d銀イオン）”の抗菌力】dAg+配合の抗菌素材「マイクロバン(R)」dを使用。dプラスチック表面を清潔に保ちます。dd【使いやすい機能】d・お湯が沸くと自動的に電源オフ。音と光でお知らせ。d・ほこりが入るのを防ぐ注ぎ口カバー。d・取り外しができ簡単に洗えるフィルター。d・ひと目で容量を確認できる窓。d・自動電源オフ。d・空だき防止。 ddd  製品サイズ（寸法）  d幅 (mm):2d20d奥行き (mm):1d55d高さ (mm):2d05d重量 (g):1,1d00dコードの長さ (m):1.3dd容量 (mL):8d00dd  性能（定格、製品仕様）  d電圧:1d00Vd消費電力:1d250Wd周波数:50-60Hz",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_KO8001JP.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_KO8001JP_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_KO8001JP_2.jpg",
    product_image_4:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_KO8001JP_3.jpg",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "548",
    brand: "T-fal",
    sku: "P4705132",
    product_eng: "T-fal ClipsoMinut Duo rouge 5.2L",
    product_jpn: "T-falティファール クリプソ ミニット デュオ ルージュ 5.2L",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥17,500",
    rrp_with_vat: "¥19,250",
    description_eng:
      "Quick and even heat conduction for even shorter cooking time!ddFrom daily meals to a small feast, you can easily become a good cook with this one pot!dddWith a simple turn of the selector, it can be used as both a pressure cooker and a pot.ddWhether you want to simmer, stir-fry, or pressure cook to save time, you can do it all with this one!ddPressure cooking takes about 1/3 of the cooking time of an ordinary pot, and produces slow-cooked results.ddTIFFAL's unique titanium coating prevents sticking and is easy to clean.ddThe TIFFAL original titanium coating prevents sticking and is easy to clean.ddd  Product Size (Dimensions)  d dWidth (mm):3d90dDepth (mm):2d80dHeight (mm):181.5 (body + lid)ddWeight (g):2d900dBody inner diameter (mm):2d40dFull water capacity (L):5.2dd  Materials  dBody】 Aluminum adlloydBottom】Stainless steel SUS430 (Stainless steel 16-0)ddHandle】Phenolic rdesindLid】 Stainless steel SUS304 (Stainless steel 18-8)ddLid handle, panel】 PBT (polybutylene terephthalate) rdesindSelector (Weight)】 NdylondPacking】 Silicone rdubberd  Country of origin  d dFrance",
    description_jpn:
      "すdばやく均一な熱伝導で、調理時間がさらに短縮！d毎日のごはんから、ちょっとしたごちそうまで、これ1つで簡単に料理上手！ddセレクターを回すだけで、圧力鍋としても、鍋としても使えます。dコトコト煮こみも炒め物も、時短になる圧力調理もこれひとつでOK！d圧力調理なら、普通の鍋に比べて約1/3dの調理時間で、じっくり煮込んだ仕上がりに。dまたティファール独自のチタンコーティングで、こびりつきにくく、お手入れもカンタン。d使いやすさにもこだわり、毎日の料理が快適になります。dd  製品サイズ（寸法）  d幅 (mm):3d90d奥行き (mm):2d80d高さ (mm):181.5 (本体+ふた)dd重量 (g):2d900d本体内径 (mm):2d40d満水容量 (L):5.2dd  素材  d【本体】アルミニウム合金d【底】ステンレスSUS430(ステンレス鋼16-0)dd【取っ手】フェノール樹脂d【ふた】ステンレスSUS304(ステンレス鋼18-8)dd【ふたハンドル・パネル】PBT（ポリブチレンテレフタレート）樹脂d【セレクター（おもり）】ナイロンd【パッキング】シリコーンゴムd  原産国  dフランス",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_P4705132.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "549",
    brand: "T-fal",
    sku: "P4704231",
    product_eng: "T-fal ClipsoMinut Duo rouge 4.2L",
    product_jpn: "T-falティファール クリプソ ミニット デュオ ルージュ 4.2L",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥16,500",
    rrp_with_vat: "¥18,150",
    description_eng:
      "Quick and even heat conduction further reduces cooking time!ddPressure cooker and pot in one, 2 in 1 pot.dd＜Included＞ Recipe book (18 recipes) ddd  Product Size (Dimensions)  d dWidth (mm):3d70dDepth (mm):2d50dHeight (mm):171 (body + lid)ddWeight (g):2d440dBody inner diameter (mm):2d15dFull water capacity (L):4.2ddMaterialdBody] Aluminum adlloydBottom】Stainless steel SUS430 (Stainless steel 16-0)ddHandle】Phenol rdesindLid】 Stainless steel SUS304 (Stainless steel 18-8)ddLid handle, panel] PBT (polybutylene terephthalate) rdesindSelector (Weight)] NdylondPacking] Silicone rdubberd  Country of origin  d dFrance",
    description_jpn:
      "すdばやく均一な熱伝導で、調理時間がさらに短縮！d圧力鍋と鍋が1つになった、2 in 1 なdべ。d【付属品】レシピブック (18種) ddd  製品サイズ（寸法）  d幅 (mm):3d70d奥行き (mm):2d50d高さ (mm):171 (本体+ふた)dd重量 (g):2d440d本体内径 (mm):2d15d満水容量 (L):4.2dd  素材  d【本体】アルミニウム合金d【底】ステンレスSUS430(ステンレス鋼16-0)dd【取っ手】フェノール樹脂d【ふた】ステンレスSUS304(ステンレス鋼18-8)dd【ふたハンドル・パネル】PBT（ポリブチレンテレフタレート）樹脂d【セレクター（おもり）】ナイロンd【パッキング】シリコーンゴムd  原産国  dフランス",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_P4704231.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "550",
    brand: "T-fal",
    sku: "FV6110J0",
    product_eng: "T-fal Freemove Mini 6110",
    product_jpn: "T-falティファール フリームーブミニ 6110",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥7,000",
    rrp_with_vat: "¥7,700",
    description_eng:
      "Powerful steam for a beautiful finish despite its compact sdized<Jet Steam up to 70g/min(*1)>ddThe lightest weight in the series at 860g(*2), TIFFAL's unique steam power is still realized in a compact mini size.ddThe large amount of jet steam (max. 70 g/min.) penetrates deep into fibers and quickly loosens the cause of stubborn wrinkles.dd*1Varies depending on usage conditions, etc. dd*2: Weight of main unit only.dd<Lightweight and compact>ddWeighing only about 860g(*2), this compact, palm-sized machine is also cordless, making it light and easy to use.ddThe cordless design makes it light and comfortable to use.dd<Slide-type temperature setting that can be operated with one hand.>ddThe temperature can be easily switched with a single thumb, allowing the temperature to be set according to the material.dd<Easy water supply>ddThe removable water tank makes it easy to supply and drain water from a washbasin or sink.dd<Water Leakage Prevention>ddWater leakage from the steam hole is prevented even at low temperatures.dd<Slim tip>ddEasily finishes even the smallest of details, such as around the collar and buttons.dd<Other Features>ddHigh power 1d200WdAutomatic cord reel: Quickly stores the cord without any hassle.ddFluoropolymer surface for excellent sliding performance. dd  Product Size (Dimensions) d dWidth (mm):1d06dLength (mm):2d10dHeight (mm):1d34dWeight (g):8d60dCord length (m):1.4d5dWater tank capacity (ml):1d00d  Country of odrigin  dChinadPerformance (ratings and specifications)ddVoltage:1d00VdPower consumption:1d200WdFrequency: 50-6d0HzdThermal fuse: 240°C",
    description_jpn:
      "コdンパクトサイズなのにパワフルスチームで綺麗な仕上がりd【ジェットスチーム 最大70g/分(※1)】ddシリーズ最軽量の860g(※2)、dコンパクトなミニサイズでもティファールならではのスチームパワーはそのまま実現。d最大70g/分dの大量ジェットスチームで繊維の奥深くまで浸透し、頑固なシワの原因をサッとほぐします。d※1. 使d用条件等によって異なります。d※2. 本体のみの重量。 dd【軽量・コンパクト】dわずか約860g(※2)とdいう軽さと、コンパクトな手の平サイズ。dさらにコードレスで、軽やかなかけ心地を実現。d【片手で操作可能なスライド式温度設定】d温度は親指一本で簡単に切り替えでき、素材に合わせて温度設定が可能です。d【簡単給水】d着脱可能な水タンクで洗面台やシンクでの給排水が簡単。d【水漏れ防止】d低温時でも、スチーム孔からの水漏れを防止します。d【スリムな先端】d襟元やボタン周りなどの細かい部分の仕上げもラクラク。d【その他の特長】d・ハイパワーの1200Wd・自動巻取りコードリール：コードを手間なくスピーディーに収納できます。d・ふっ素樹脂かけ面で、抜群のすべり ddd  製品サイズ（寸法）  d幅 (mm):1d06d長さ (mm):2d10d高さ (mm):1d34d重量 (g):8d60dコードの長さ (m):1.4d5d水タンク容量(ml):1d00d  原産国  d中国d  性能（定格、製品仕様）  d電圧:1d00Vd消費電力:1d200Wd周波数:50-6d0Hzd温度ﾋｭｰｽﾞ:240℃",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_FV6110J0.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_FV6110J0_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_FV6110J0_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "551",
    brand: "T-fal",
    sku: "IH2025JP",
    product_eng: "T-fal Fullflat IH Legal Red",
    product_jpn: "T-falティファール フルフラットIH リーガルレッド",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥11,000",
    description_eng:
      "Full-flat ceramic glass panel for beautiful, fun, and convenient tabletop cooking!ddAfter meals, the full-flat panel can be quickly wiped clean, making cleanup easy and delightful.ddThis is a convenient tabletop IH cooker that realizes enjoyable family time.ddd<Full-flat ceramic glass panel with excellent practicality.>ddStylish thin flat compact design. The strong ceramic glass panel is easy to clean.dd<Automatic temperature control with 6 cooking programs>ddSix cooking programs that are frequently used on a daily basis make it easy to cook a variety of dishes.ddThe optimal temperature for each cooking is automatically controlled.dd<Easy cooking program selection via touch panel>ddEasy-to-read touch panel with LED display and easy-to-operate screen.dd<The cooking mode, timer, and heat power can be easily operated.ddThe design of the fan is designed to minimize operating noise, which encourages family conversation.>ddThe fan speed is automatically adjusted in 3 stages according to the temperature.dd<Timer setting for worry-free cooking.>ddThe off timer can be set from 1 minute to 6 hours.dd<Five safety features>dd(1) Pot detection function: Automatically detects which pots and pans can be used.dd(2) Power off function: Automatically turns off the power after up to 1 hour from the start of cooking.dd(3) HOT indicator: The word HOT lights up while the top plate is hot even after the power is turned off.dd(4) Anti-slip function: Two anti-slip pads on the back of the legs of the main unit.dd(5)Magnetic plug (detachable): Easy to detach magnetic plug.ddd  Product Size (Dimensions) d dWidth (mm):2d80dDepth (mm):3d42dHeight (mm):5d3dWeight (g):2d600dCord length (m):2.5dd  Country of odrigin  dChinad  Performance (ratings and specifications) d dVoltage: 1d00VdPower consumption: 1d400WdFrequency: 50/60Hz",
    description_jpn:
      "フdルフラットのセラミックガラスパネルで美しく楽しく便利に卓上調理！dお食事後も、フルフラットなのでサッと拭き取れ、お手入れが簡単で嬉しい。d楽しい家族時間を実現する、便利な卓上IH調理器です。dd【実用性に優れたフルフラットのセラミックガラスパネル】dスタイリッシュな薄型フラットコンパクト設計。強度のあるセラミックガラスパネルでお手入れもしやすいです。d【6つの調理プログラムで自動温度管理】d日常的によく使う6つの調理プログラムで、様々な料理に対応し、調理がしやすいです。dそれぞれの調理に最適な温度を自動でコントロールします。d【タッチパネルで簡単に調理プログラムを選択】dLED表示で画面が見やすく、操作しやすいタッチパネル。d調理モード、タイマー、火力を簡単に操作できます。d【運転音が気になりにくい設計で家族の会話が弾む】d温度に合わせてファンの回転速度を3段階で自動調整します。d【タイマー設定で安心調理】d1分から6時間で切タイマーをセットできます。d【5つの安全機能】d①なべ検知機能：使用可能なべを自動的に判別。d②電源オフ機能：調理開始から最大1時間経過後に自動的に電源オフ。d③HOT表示機能：電源オフ後もトッププレートが熱い間は「HOT」の文字が点灯。d④スリップ防止：本体の脚の裏面に2箇所のすべり止め。d⑤マグネット式プラグ（着脱式）：取り外し簡単なマグネット式プラグ。dd  製品サイズ（寸法）  d幅 (mm):2d80d奥行き (mm):3d42d高さ (mm):5d3d重量 (g):2d600dコードの長さ (m):2.5dd  原産国  d中国d  性能（定格、製品仕様）  d電圧:1d00Vd消費電力:1d400Wd周波数:50/60Hz",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_DV7530J0.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_DV7530J0.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_DV7530J0.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "552",
    brand: "T-fal",
    sku: "DT9531J0",
    product_eng: "T-fal Access steam Pure",
    product_jpn: "T-falティファール アクセススチーム ピュア",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥13,800",
    rrp_with_vat: "¥15,180",
    description_eng:
      "Powerful continuous steam averaging 22g/min(*1) can be used for wrinkle stretching, virus removal and sterilization in the room.dd<Three types of multi-pads are included for a wide range of uses.>ddThe pads can be changed according to your needs, from dust removal to your favorite fragrance.dd・Velvet pad: Smoothly glides over fabrics for comfortable wrinkle removal.dd・Clean pad (reversible): removes dust on the front side, removes fine dust on the back sdided・Steam hood: Protects delicate fabrics from heat.ddIn addition, the included scenting tablet can be used to add your favorite fragrance.dd・Scenting tablet: Apply 2-3 pushes of your favorite fragrance spray to the water drop mark, insert it into the steam hood, and quickly apply steam to enjoy your favorite fragrance spreading with the steam to give your clothes and fabrics a subtle scent.dd<TIFFAL Clothes Steamer 5 Basic Comfort Effects (*2)>ddSince water is the only ingredient of steam, you can safely and securely clean fabrics in the room.dd・Virus removal and sdterilizationd・Pollen cdontrold・Deodorizationd・Mite killing edffectd・Allergen cdontrold<Quick and easy wrinkle stretching. Powerful steam averages 22g/min>.ddPowerful continuous steam averaging 22g/min(*1) penetrates deep into fibers and loosens the cause of wrinkles, so that wrinkles can be stretched out beautifully. It also effectively removes viruses and sterilization.dd<Equipped with 3 times more powerful steam. (*3)>ddPress and hold the turbo button for about 3 seconds to spray 3 times the amount of jet steam. Use it to target especially stubborn wrinkles and bothersome smells.dd<Rise time: 25 seconds!>ddQuickly starts up in 25 seconds.ddIt takes only 25 seconds to start up, so you can take care of your hair quickly in the morning or before you go out.dd<Power up wattage!>dd1400W for powerful wrinkle removal.dd<Auto shut-off safety device.>ddEven if you forget to turn off the switch, the power will automatically turn off after about 5 minutes of inactivity, so you don't have to worry in case of an emergency.dd<No need for an ironing board.>ddNo need for an ironing board since the ironing board can be used while clothes are on hangers.dd*1Varies depending on usage conditions, etc.dd*2Effectiveness depends on the time of steam application, type of fiber, environment at the time of use, and type of odor. Depends on the method of use in which the surface is placed against the fabric while the steam is being applied.dd*3When using again, wait at least 20 seconds and press and hold the turbo button again.ddd  Product Size (Dimensions)ddWidth (mm):1d70dDepth (mm):1d30dHeight (mm):2d80dWeight (g):1d100dCord length (m):3ddWater tank capacity (ml):2d00d  Country of odrigindChinadPerformance (ratings and specifications)ddVoltage: 100V tdodPower consumption: 1d400WdFrequency: 50-6d0HzdThermal fuse: 216°C",
    description_jpn:
      "平均22g/分(※1)のdパワフル連続スチームでシワ伸ばしも、部屋中のウイルス除去・除菌もできます。d【使い方広がる3種類のマルチパッド付き】d用途に合わせてパッドを付け替え、ホコリ・チリ取りからお好みの香りづけまで。d●ベルベットパッド：生地の上をスムーズに滑らせ快適なシワ伸ばしd●クリーンパッド［リバーシブル仕様］：表面／ホコリ取り、裏面／細かいチリ取りd●スチームボンネット：デリケートな素材を熱から守ります。dさらに、付属の「香り付けタブレット」を使えば、お好みの香りで香りづけd●香りづけタブレット：水滴マーク部分にお好みのフレグランススプレーを2～3プッシュし、「スチームボンネット」に差し込んでさっとスチームをかけると、お好きな香りがスチームと共に広がり衣類や布製品にほのかな香りがつき、楽しめます。dd【ティファール衣類スチーマー 5つの基本快適効果(※2)】ddスチームの成分は水だけの為、安心安全に部屋中の布製品のお手入れができます。d・ウイルス除去・除菌d・花粉対策d・脱臭d・殺ダニ効果d・アレル物質対策d【ササっと楽にシワ伸ばし。パワフルスチーム平均22g/分d】d平均22g/分(※1)のdパワフル連続スチームが繊維の奥まで浸透し、シワの原因をしっかりほぐすので、シワをキレイに伸ばせます。またウイルス除去・除菌も、効果的に行えます。d【3倍パワフルスチーム搭載。(※3)】ddターボボタンを長押しで、約3秒間、約3倍の量のジェットスチームが噴射されます。特に頑固なシワや、気になるニオイめがけて使用します。d【立ち上がり時間25秒！】d素早く25秒で立ち上がります。d忙しい朝やお出かけ前にサッとケアができます。d【ワット数がパワーアップ】d1400Wでパワフルにシワ伸ばし。d【自動停止安全装置】dスイッチを消し忘れても、約5分間操作がないと自動的に電源がオフになるから、万が一の際にも安心。d【アイロン台いらず】d衣類をハンガーにかけたまま使うことができるのでアイロン台が不要。d※1.使d用条件等によって異なります。d※2.効d果はスチームを当てる時間、繊維の種類、使用時の環境、ニオイなどの種類によって異なります。スチームを出しながらかけ面を生地に当てた使用方法によります。d※3.再d度使用する時は、20秒以上待ってから再度ターボボタンを長押ししてください。dd  製品サイズ（寸法）  d幅 (mm):1d70d奥行き (mm):1d30d高さ (mm):2d80d重量 (g):1d100dコードの長さ (m):3dd水タンク容量 (ml):2d00d  原産国  d中国d  性能（定格、製品仕様）  d電圧:1d00V～d消費電力:1d400Wd周波数:50-6d0Hzd温度ﾋｭｰｽﾞ:216℃",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_DT9531J0.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_DT9531J0_1.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_DT9531J0_2.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "556",
    brand: "T-fal",
    sku: "DT8261J0",
    product_eng: "T-fal Access steam Force",
    product_jpn: "T-falティファール アクセススチーム フォース",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥12,727",
    rrp_with_vat: "¥14,000",
    description_eng:
      "<No.1 Powerful Continuous Steam for Quick, Clean, Satisfying Results While on a Hanger> The key to wrinkle removal is the amount of steam. Powerful continuous steam with an average rate of 23 g/min(*1) penetrates deep into the fibers, loosens the cause of wrinkles (dry fibers that have become entangled in the fabric), and removes them beautifully. The instantaneous 3x powerful steam intensively treats especially stubborn wrinkles and odors. Pressing the turbo button for a long time delivers approximately 3 times the amount of steam for approximately 2 seconds. (*2) *1 According to our own research in 2021. 1 According to our own research in 2021. Varies depending on usage conditions. 2 When using again, press and hold the turbo button again after 20 seconds or more. <Large heating plate made of ceramic material> The heated heating plate is placed on the garment while stretching out wrinkles, resulting in a more beautiful finish. <Ergonomically designed to minimize arm and finger fatigue.> The ergonomic design keeps the center of gravity close to your hand, so your arm will not get tired. <Comfortable effects other than wrinkle stretching (*3)> The steam power of water and heat alone can safely and securely clean fabrics in the room.  1. viruses and bacteria: 99.9% or more removal 2. pollen matter: 98.9% or more reduction 3. deodorizing effect: cigarettes / insect repellents / perspiration / aging / fresh smell / pets / grilled meat 4. mite killing: 100% dead mites Allergen control: 98% or more reduction (from mites/feces) 3 Effectiveness depends on the time of steam application, type of fiber, environment at the time of use, and type of odor. 3 Effectiveness depends on the time of steam application, type of fabric, environment at the time of use, and type of odor, etc. <Other features> The machine starts up quickly in 25 seconds, making it convenient for quick care on busy mornings or before going out. Even if you forget to turn off the switch, the power automatically shuts off after about 5 minutes of inactivity, so you don't have to worry in case of emergency. A large 185mL water tank eliminates the need for frequent water supply. The water tank can be removed for easy removal. The water tank can be removed for easy water supply and drainage.    Product Size (Dimensions)   Width (mm):130 Depth (mm):141 Height (mm):283 Weight (g):1160 Cord length (m):3 Water tank capacity (ml):185   Country of origin   China   Performance (ratings and specifications)   Voltage: 100V to Power consumption: 1,400W Frequency: 50-60Hz Thermal fuse: 216°C",
    description_jpn:
      "【No.1 パワフル 連続 スチームで、ハンガーにかけたままサッとキレイに、満足の仕上がり】 ・シワ伸ばしの決め手はスチーム量。平均 23 g/ 分（※ 1）のパワフル 連続 スチームが 繊維の奥まで浸透し、 シワの原因（からみついた状態で乾燥した繊維）をしっかりほぐし、シワが きれいに伸ばせます。 ・瞬間3倍パワフルスチームで、特に頑固なシワやニオイを集中ケア。ターボボタン長押しで約 3倍量のスチームが約2秒間続きます。（※ 2）。 ※1 2021 年自社調べ。使用条件によって異なります 。 ※2 再度使用する場合は、 20 秒以上たってから再度ターボボタンを長押しください。 【セラミック素材の大型ヒーティングプレート】 ・熱くなったヒーティングプレートを衣類にあてながらシワを伸ばすことで、さらにキレイな仕上がりになります。 【腕や指が疲れにくい設計】 ・人間工学に基づいた設計で、重心が手元に来るため 腕が疲れにくくなっています。 ・スチームトリガーをロックすれば、トリガーを引かなくてもスチームが出続けるので、連続使用しても指が疲れません。 【シワ伸ばし以外の快適効果 （※ 3）】 ・水と熱だけの蒸気の力で、安心安全に部屋中の布製品のお手入れができます。  1．ウイルス・菌：99.9％以上除去 2．花粉物質： 98.9％以上低減 3. 脱臭効果：タバコ／防虫剤／汗／加齢臭／生乾き臭／ペット／焼肉 4．殺ダニ：死ダニ率100％ 5．アレル物質対策：98％以上低減（コナヒョウヒダニ／排泄物由来） ※3 効果はスチームを当てる時間、繊維の種類、使用時の環境、ニオイなどの種類によって異なります。スチームを出しながら、かけ面を生地に当てた使用方法によります。 【その他の機能】 ・素早く 25 秒で立ち上がり、忙しい朝やお出かけ前にサッとケアができて便利。 ・スイッチを消し忘れても、約5分間操作がないと自動的に電源が切れるので、万が一の際にも安心。 ・頻繁な給水が不要な、185mLの大容量水タンク。一度の給水でたっぷり使えます。また水タンクを取り外せるので給排水もカンタン    製品サイズ（寸法）   幅 (mm):130 奥行き (mm):141 高さ (mm):283 重量 (g):1160 コードの長さ (m):3 水タンク容量 (ml):185   原産国   中国   性能（定格、製品仕様）   電圧:100V～ 消費電力:1,400W 周波数:50-60Hz 温度ヒューズ:216℃",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_DT8261J0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "557",
    brand: "T-fal",
    sku: "CM4905JP",
    product_eng: "T-fal Coffee Maker Maison Wine Red",
    product_jpn: "T-fal コーヒーメーカー メゾン ワインレッド",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥6,500",
    rrp_with_vat: "¥7,150",
    description_eng:
      "A cup of aromatic coffee for your special taste. A drip coffee maker that makes it easy to enjoy mellow coffee at the touch of a button.  <Stainless steel material> The refined stainless steel material makes your kitchen more gorgeous. <Large shower head for less uneven extraction> Hot water showers down from the 13 holes of the large shower head (45 mm in diameter) to ensure even extraction of coffee. <Aroma mode> Aroma button is equipped. The hot water is intermittently poured out to steam the coffee slowly, resulting in more aromatic coffee. <Paperless filter> The paperless filter extracts the aroma of the coffee. <Automatic power off for peace of mind> The power turns off about 30 minutes after coffee brewing is complete. <Family-friendly 0.6L capacity> The brewer can brew up to 5 cups of coffee. This product assumes that one cup of coffee is approximately 120ml. <Easy water supply> Easy water supply from the pot without moving the main unit. <Leakage prevention function> Dripping water is prevented from leaking even when the pot is removed, preventing the heat-retaining plate from becoming dirty.   Product Size (Dimensions) Width (mm):175 Depth (mm):210 Height (mm):270 Weight (g):1180 Cord length (m):1.5 Water tank capacity (ml):600   Performance (ratings and specifications) Voltage: 100V Power consumption: 600W Frequency: 50-60Hz",
    description_jpn:
      "華やかに香る、こだわりの一杯を 芳醇なコーヒーをボタンひとつで簡単に楽しめるドリップ式コーヒーメーカー。  【ステンレス素材】 洗練のステンレス素材でキッチンをより華やかに。 【抽出ムラの少ない大きなシャワーヘッド】 直径45mmの大きなシャワーヘッドの13穴からお湯がシャワー状に降り注ぐことで、コーヒーをまんべんなく抽出可能。 【アロマモード】 アロマボタンを搭載。お湯が断続的に出ることでじっくり蒸らしながら抽出し、より香り高いコーヒーに。 【ペーパーレスフィルター】 コーヒーのアロマをしっかり抽出する、ペーパーレスフィルター。 【安心の自動電源オフ】 コーヒー抽出完了後、約30分で電源OFFなので安心。 【家族で楽しめる0.6Lの容量】 最大5杯分まで抽出可能。 ※本製品では、コーヒーカップ1杯を 約120mlとしています。 【給水ラクラク】 本体を移動させることなく、ポットから簡単に給水可能。 【しずくもれ防止機能】 ポットを外してもしずくが漏れにくいので、保温プレートが汚れるのを防ぎます。   製品サイズ（寸法）   幅 (mm):175 奥行 (mm):210 高さ (mm):270 重量 (g):1180 コードの長さ (m):1.5 水タンク容量 (ml):600   性能（定格、製品仕様）   電圧:100V 消費電力:600W 周波数:50-60Hz",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_CM4905JP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "558",
    brand: "T-fal",
    sku: "TT3425JP",
    product_eng: "T-fal Pop-Up Toaster Maison Wine Red",
    product_jpn: "T-fal ポップアップトースター メゾン ワインレッド",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥6,500",
    rrp_with_vat: "¥7,150",
    description_eng:
      "Ah! A pop-up toaster that makes it easy to enjoy crispy, fluffy toast in the blink of an eye.  <Stainless steel material> The sophisticated stainless steel material makes the kitchen more colorful. <Browning adjustment dial> Adjustable from 1 to 7 levels of browning. <Two wide slots> Two wide slots for baking from 10 to 4 slices. <Defrost and reheat buttons> The Defrost and Reheat buttons make it easy to defrost frozen breads and reheat them at the touch of a button. <Cancel button> The baking process can be stopped at any time during baking. <Lift-up function> Bread can be easily removed from the pan with the lift-up function. <Bread crumb tray> Bread crumb tray can be cleaned as soon as it is pulled out. <Dustproof lid> The cover can be covered when not in use to prevent dust from entering the slots.    Product Size (Dimensions)   Width (mm):278 Depth (mm):165 Height (mm):187 Weight (g):1303 Cord length (m):1.45   Performance (ratings and specifications)   Voltage: 100V Power consumption: 850W Frequency: 50-60Hz",
    description_jpn:
      "あっ！という間にサクふわなトーストが簡単に味わえる、ポップアップトースター。  【ステンレス素材】 洗練のステンレス素材でキッチンをより華やかに。 【焼き色調整ダイヤル】 1～7段階までお好みの焼き加減に調整可能。 【ワイドな2つのスロット】 10～4枚切りまで焼ける、ワイドな2つのスロット。 【解凍ボタン、温めなおしボタン】 冷凍パンの解凍も、あたためが足りないときの追加焼きも、ボタン1つで簡単に。 【取り消しボタン】 パン焼きを好きな時に途中停止できる。 【リフトアップ機能】 パンが取り出しやすい、リフトアップ機能付き。 【パンくずトレイ】 引き出してすぐお手入れができるパンくずトレイ。 【ほこり除けのふた付き】 使用しないときにはカバーを被せておけば、スロットにほこりが入るのを防げます。   製品サイズ（寸法）   幅 (mm):278 奥行 (mm):165 高さ (mm):187 重量 (g):1303 コードの長さ (m):1.45   性能（定格、製品仕様）   電圧:100V 消費電力:850W 周波数:50-60Hz",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_TT3425JP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "559",
    brand: "T-fal",
    sku: "G26202",
    product_eng: "T-fal Rouge Unlimited Frying Pan 20cm",
    product_jpn: "T-fal IHルージュ・アンリミテッド フライパン 20cm",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥3,780",
    rrp_with_vat: "¥4,158",
    description_eng:
      "The highest sticking resistance and durability in T-fal's history! Popular standard color with a luxurious feel. <Titanium Unlimited Coating> T-fal's most durable coating, Titanium Unlimited Coating, provides long-lasting durability and resistance to sticking at the beginning of use. <Wider IH Disc> The IH disc on the bottom is larger than the previous model to ensure more efficient and uniform heat transfer. <New Notification Mark>. The new design of the notification mark that indicates the best time to add food has been redesigned to make it even easier to recognize when to add food. The new design makes it even easier to understand.   Product Size (Dimensions)   Width (mm):374 Depth (mm):218 Height (mm):71 Weight (g):696 Body depth (mm):45 Body inner diameter (mm):200   Materials   Body: Aluminum alloy Bottom:Aluminum alloy + Stainless steel Handle:Phenol resin T-fal is PFOA-, lead- and cadmium-free. You can use it with peace of mind.   Heat source    Gas Electric plate coil Ceramic heater Halogen heater Electromagnetic cooker (IH) 100V-200V compatible   Features (special specifications/functions/remarks)   Can be used with any heat source, including IH (induction cooker) and gas fire. A metal spatula can also be used. (Please use one with rounded corners.)",
    description_jpn:
      "ティファール史上最高峰のこびりつきにくさと耐久性！ 高級感のある人気の定番カラー。 【チタン・アンリミテッドコーティング】 ティファール史上最高峰の耐久性を実現した「チタン・アンリミテッドコーティング」で、使い始めのこびりつきにくさが長く続きます。 【広くなったIHディスク】 底面のIHディスクが従来品より大きくなり、より効率的に、均一に熱が伝わります。 【新しくなった「お知らせマーク」】 食材を入れるベストなタイミングが分かる「お知らせマーク」が新デザインに。さらに分かりやすくなりました。   製品サイズ（寸法）   幅 （mm）:374 奥行き (mm):218 高さ (mm):71 重量 (g):696 本体の深さ (mm):45 本体内径 (mm):200   素材   【本体】アルミニウム合金 【底】アルミニウム合金＋ステンレス鋼 【取っ手】フェノール樹脂 ティファールはPFOA・鉛・カドミウム不使用。 安心してご使用いただけます。   熱源   ガス 電気プレートコイル セラミックヒーター ハロゲンヒーター 電磁調理器（IH） 100V-200V対応   特徴（特別仕様・機能／備考）   ・IH(電磁調理器)・ガス火を含む、いずれの熱源にも使えます。 ・金属へらも使えます。(角の丸いものをお使いください)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_G26202.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "560",
    brand: "T-fal",
    sku: "G26205",
    product_eng: "T-fal Rouge Unlimited Frying Pan 26cm",
    product_jpn: "T-fal IHルージュ・アンリミテッド フライパン 26cm",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥4,680",
    rrp_with_vat: "¥5,148",
    description_eng:
      "The highest sticking resistance and durability in T-fal's history! Popular standard color with a luxurious feel. <Titanium Unlimited Coating> T-fal's most durable coating, Titanium Unlimited Coating, provides long-lasting durability and resistance to sticking at the beginning of use. <Wider IH Disc> The IH disc on the bottom is larger than the previous model to ensure more efficient and uniform heat transfer. <New Notification Mark>. The new design of the notification mark that indicates the best time to add food has been redesigned to make it even easier to recognize when to add food. The new design makes it even easier to understand.   Product Size (Dimensions)   Width (mm):453 Depth (mm):277 Height (mm):88 Weight (g):1159 Body depth (mm):57 Body inner diameter (mm):260   Materials   Body: Aluminum alloy Bottom:Aluminum alloy + Stainless steel Handle:Phenol resin T-fal is PFOA-, lead- and cadmium-free. You can use it with peace of mind.   Heat source    Gas Electric plate coil Ceramic heater Halogen heater Electromagnetic cooker (IH) 100V-200V compatible   Features (special specifications/functions/remarks)   Can be used with any heat source, including IH (induction cooker) and gas fire. A metal spatula can also be used. (Please use one with rounded corners.)",
    description_jpn:
      "ティファール史上最高峰のこびりつきにくさと耐久性！ 高級感のある人気の定番カラー。 【チタン・アンリミテッドコーティング】 ティファール史上最高峰の耐久性を実現した「チタン・アンリミテッドコーティング」で、使い始めのこびりつきにくさが長く続きます。 【広くなったIHディスク】 底面のIHディスクが従来品より大きくなり、より効率的に、均一に熱が伝わります。 【新しくなった「お知らせマーク」】 食材を入れるベストなタイミングが分かる「お知らせマーク」が新デザインに。さらに分かりやすくなりました。   製品サイズ（寸法）   幅 （mm）:453 奥行き (mm):277 高さ (mm):88 重量 (g):1159 本体の深さ (mm):57 本体内径 (mm):260   素材   【本体】アルミニウム合金 【底】アルミニウム合金＋ステンレス鋼 【取っ手】フェノール樹脂 ティファールはPFOA・鉛・カドミウム不使用。 安心してご使用いただけます。   熱源   ガス 電気プレートコイル セラミックヒーター ハロゲンヒーター 電磁調理器（IH） 100V-200V対応   特徴（特別仕様・機能／備考）   ・IH(電磁調理器)・ガス火を含む、いずれの熱源にも使えます。 ・金属へらも使えます。(角の丸いものをお使いください)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_G26205.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "561",
    brand: "T-fal",
    sku: "G26219",
    product_eng: "T-fal Rouge Unlimited Wok Pan 28cm",
    product_jpn: "T-fal IH ルージュ・アンリミテッド ウォックパン 28cm",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥5,380",
    rrp_with_vat: "¥5,918",
    description_eng:
      "The highest sticking resistance and durability in T-fal's history! Popular standard color with a luxurious feel. <Titanium Unlimited Coating> T-fal's most durable coating, Titanium Unlimited Coating, provides long-lasting durability and resistance to sticking at the beginning of use. <Wider IH Disc> The IH disc on the bottom is larger than the previous model to ensure more efficient and uniform heat transfer. <New Notification Mark>. The new design of the notification mark that indicates the best time to add food has been redesigned to make it even easier to recognize when to add food. The new design makes it even easier to understand.   Product Size (Dimensions)   Width (mm):467 Depth (mm):286 Height (mm):109 Weight (g):1163 Body depth (mm):74 Body inner diameter (mm):280   Materials   Body: Aluminum alloy Bottom:Aluminum alloy + Stainless steel Handle:Phenol resin T-fal is PFOA-, lead- and cadmium-free. You can use it with peace of mind.   Heat source    Gas Electric plate coil Ceramic heater Halogen heater Electromagnetic cooker (IH) 100V-200V compatible   Features (special specifications/functions/remarks)   Can be used with any heat source, including IH (induction cooker) and gas fire. A metal spatula can also be used. (Please use one with rounded corners.)",
    description_jpn:
      "ティファール史上最高峰のこびりつきにくさと耐久性！ 高級感のある人気の定番カラー。 【チタン・アンリミテッドコーティング】 ティファール史上最高峰の耐久性を実現した「チタン・アンリミテッドコーティング」で、使い始めのこびりつきにくさが長く続きます。 【広くなったIHディスク】 底面のIHディスクが従来品より大きくなり、より効率的に、均一に熱が伝わります。 【新しくなった「お知らせマーク」】 食材を入れるベストなタイミングが分かる「お知らせマーク」が新デザインに。さらに分かりやすくなりました。   製品サイズ（寸法）   幅 （mm）:467 奥行き (mm):286 高さ (mm):109 重量 (g):1163 本体の深さ (mm):74 本体内径 (mm):280   素材   【本体】アルミニウム合金 【底】アルミニウム合金＋ステンレス鋼 【取っ手】フェノール樹脂 ティファールはPFOA・鉛・カドミウム不使用。 安心してご使用いただけます。   熱源   ガス 電気プレートコイル セラミックヒーター ハロゲンヒーター 電磁調理器（IH） 100V-200V対応   特徴（特別仕様・機能／備考）   ・IH(電磁調理器)・ガス火を含む、いずれの熱源にも使えます。 ・金属へらも使えます。(角の丸いものをお使いください)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_G26219.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "564",
    brand: "T-fal",
    sku: "CY353AJP",
    product_eng: "T-fal Lakula Electric Pressure Cooker",
    product_jpn: "T-fal ラクラ・クッカー プラス コンパクト電気圧力鍋 ",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥25,455",
    rrp_with_vat: "¥28,001",
    description_eng:
      "Ferment & bake, even bake bread! 16 functions in one machine that can easily perform a wide range of cooking from short cooking time to authentic cooking. With the addition of a steam cleaning function, cooking and cleaning are a breeze! <Accessories> Recipe book (105 recipes), rice cooking cup, steaming stand  16 cooking modes for both short cooking and full-fledged cooking. 8 cooking modes with a wide variety of variations  (1) Pressure cooking: Short cooking time at high temperature of 100°C or higher (114°C, max. 30 minutes)  (2) Steaming: Easy steaming cooking on a steaming table (114°C, max. 30 min.)  (3) Simmering: Finishing cooking such as stewing (approx. 95°C, max. 3 hours)  (4) Stir-fry: Stir-fry cooking with the lid open (max. 150°C, max. 59 min.)  (5) Low-temperature cooking: Slow cooking at low temperatures of 60-90°C (60-90°C, max. 22 hours)  (6)Waterless cooking : Keeps nutrients and flavor of ingredients (114°C, max. 30 min.)  (7) Fermentation: For fermentation of bread, cream cheese, etc. (22°C-59°C, max. 22 hours)  (8)Bake: Bread(*) and cakes easily! (130°C to 150°C, max. 2 hours)  *Bread can be made into dough and baked by utilizing the fermentation mode. ●Four recipe modes for popular Japanese dishes and stewed dishes are also easy to use.  (1) Curry (2) Kakuni (stewed cubes) (3) Beans (4) Hot pot ●Four cooking modes that can cook rice cakes and porridge in addition to white and brown rice  (1) White rice (2) Brown rice (3) Rice cakes (4) Rice porridge <Omakase cooking> Just add the ingredients, press the button, and the dish is ready in no time. <Pressure cooking allows for short cooking times (up to 1/3 the time of a regular pot).> The cooking temperature is 100℃ or higher, so the cooking time can be shortened by up to 1/3 compared to an ordinary pot. <T-fal's unique spherical simmering pot ensures even heat circulation.> The spherical stewing pot with two 62° golden angles provides excellent heat circulation. <Steam cleaning function for easy cleaning> Steam washing using steam easily removes dirt and odors from the pot. <Other features> ・The compact size of 3L (for 2-4 persons) fits perfectly in Japanese kitchens.  The cooker can cook up to 4 servings of food and cook up to 4 cups of rice. ・High power 700W for speedy cooking up to pressurized cooking. ・Up to 12 hours of reserved cooking time is possible. ＊Cannot be used for boiling, frying, low temperature, fermentation, baking, or keeping warm. ・Automatic warming for up to 24 hours after cooking and reheating (3 minutes) is possible. ・Cannot be used for simmering, sauteing, low temperature, fermentation, or baking. ・Detachable power cord. ・Stainless steel inner lid for easy cleaning. ・Comes with an original recipe book for all modes (105 recipes). ・Electricity is used without gas flame, so it is safe and secure for the elderly and children.   Product Size (Dimensions)   Width (mm):260 Depth (mm):285 Height (mm):283 Weight (g):4,180 Cord length (m):1.5 Capacity (L):3   Performance (ratings and specifications)   Voltage: 100V Power consumption: 700W Frequency: 50/60Hz Thermal fuse: 216",
    description_jpn:
      "発酵＆ベイクでパンまで焼ける！ 時短料理から本格料理まで幅広い料理が簡単にできる1台16役。 「スチーム洗浄」機能が加わり、調理もお手入れもラクラク！ 【付属品】レシピブック（105レシピ）、炊飯用カップ、蒸し台  【16種類の調理モードで時短・本格調理も全ておまかせ】 ●バリエーション豊富な8つの調理モード  ①圧力調理 ： 100℃以上の高温で時短調理（114℃・最大30分）  ②蒸す ： 蒸し台でお手軽に蒸し料理（114℃・最大30分）  ③煮る ： 煮物などの仕上げ調理（約95℃・最大3時間）  ④炒める ： 蓋を開けたままの炒め調理（最大150℃・最大59分）  ⑤低温調理 ： 60℃～90℃の低温でじっくり調理（60-90℃・最大22時間）  ⑥無水調理：食材の栄養・旨みを逃さない（114℃・最大30分）  ⑦発酵：パンの発酵やクリームチーズなどの発酵調理に（22℃～59℃・最大22時間）  ⑧ベイク：パン(※)やケーキを簡単に！（130℃～150℃・最大2時間）  ※パンは発酵モードから活用することで、生地を作って焼くことができます。 ●人気の和食や煮込み料理も簡単な4つのレシピモード  ①カレー ②角煮 ③豆類 ④なべ ●白米・玄米に加えて餅米、お粥も炊ける4つの調理モード  ①白米 ②玄米 ③餅米 ④お粥 【おまかせ調理】 食材を入れて、ボタンを押すだけであっという間に料理が完成。 【圧力調理なので、時短料理が可能（普通の鍋の最大1/3まで短縮）】 100℃以上の高温で調理するので、普通の鍋と比較して、最大1/3まで時短可能。 【T-fal独自の球状の煮込み鍋が均一な熱循環を実現】 62°のゴールデンアングルを2箇所に施した球状の煮込み鍋は優れた熱循環を実現し、 鍋の中で均一に熱が広がり、熱ムラなく炊飯のごはんも、おいしく仕上がります。 【スチーム洗浄機能搭載でお手入れラクラク】 蒸気を用いたスチーム洗浄で、鍋の汚れや匂いをカンタンに除去。 【その他の機能】 ・3L(2～4人分）のコンパクトサイズで、日本のキッチンにもピッタリフィット。  お料理は4人分まで、炊飯は4合まで作れます。 ・ハイパワーの700W。加圧調理までをスピーディーに。 ・最大12時間までの予約調理が可能。 ※煮る・炒め・低温・発酵・ベイク・保温には使用できません。 ・調理後は最大24時間の自動保温、再加熱（3分）も可能。 ※煮る・炒め・低温・発酵・ベイクには使用できません。 ・着脱式の電源コード。 ・ステンレス製の内蓋でお手入れ簡単。 ・すべてのモードに対応したオリジナルレシピブック付き（105レシピ） ・ガス火を使わない電気なのでご高齢の方やお子様にも安心安全！   製品サイズ（寸法）   幅 (mm):260 奥行き (mm):285 高さ (mm):283 重量 (g):4,180 コードの長さ (m):1.5 容量 (L):3   性能（定格、製品仕様）   電圧:100V 消費電力:700W 周波数:50/60Hz 温度ヒューズ:216",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_CY353AJP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "565",
    brand: "T-fal",
    sku: "FV6828J0",
    product_eng: "T-fal Ultimate 6828",
    product_jpn: "T-fal アルティメット 6828",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥16,364",
    rrp_with_vat: "¥18,000",
    description_eng:
      "T-fal's No.1 ever high volume steam, professional grade finish. Corded iron that maintains high temperature for powerful results.  <Powerful Jet Steam up to approx. 140g/min> The large amount of powerful steam penetrates deep into the fibers and quickly loosens even the most stubborn wrinkles from the root. <Air Glide ironing surface for the best sliding and finishing results in T-fal's history*> T-fal's unique Air Glide ironing surface is a technology developed by T-fal's through years of research and improvement. The Air Glide ironing surface, which allows for quick and smooth ironing, realizes efficient wrinkle removal through optimum steam diffusion, and is highly durable and scratch-resistant, making it possible to iron zippers and other areas that are prone to scratches. *According to our own research. Compared with other T-fal steam iron products. <Scratch-resistant auto-clean finish> The Auto Clean Process removes transfer debris from the ironing surface to keep it clean. <Vertical Steam> Powerful steam is sprayed even when the iron is in an upright position. The iron can be easily cleaned while the clothes are on hangers. <Water Leakage Prevention Function> Prevents water leakage from the steam hole even at low temperatures. <Automatic shut-off safety device> The power automatically shuts off if the machine is left unused for 30 to 35 seconds when placed horizontally, and for 8 to 9 minutes and 30 seconds when placed vertically.   Product Size (Dimensions)   Width (mm):145 Depth (mm):310 Height (mm):155 Weight (g):1,375 Cord length (m):2.1 Water tank capacity (ml):265   Performance (ratings and specifications)   Voltage: 100V Power consumption: 1,400W Frequency: 50-60Hz Thermal fuse: 257°C",
    description_jpn:
      "【キズが付きにくいオートクリーン加工】 かけ面に付着した遷移くずを取り除くことで、キレイな状態を保ちます。 【バーチカルスチーム】 アイロンを立てた状態でもパワフルスチームを噴射。衣類をハンガーにかけたままでのお手入れもラクラク。 【水漏れ防止機能】 低温時でも、スチーム孔からの水漏れを防止します。 【自動停止安全装置】 横置き約30～35秒、縦置き約8分～9分30秒間使わずに放置すると自動的に電源が切れるので、万が一の際にも安心です。   製品サイズ（寸法）   幅 (mm):145 奥行き (mm):310 高さ (mm):155 重量 (g):1,375 コードの長さ (m):2.1 水タンク容量 (ml):265   性能（定格、製品仕様）   電圧:100V 消費電力:1,400W 周波数:50-60Hz 温度ヒューズ:257℃",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/t-fal/Tfal_FV6828J0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/T-fal.png",
  },
  {
    id: "568",
    brand: "RUHAKU",
    sku: "RUHAKU CLEANSING",
    product_eng: "RUHAKU GETTOU Cleansing Oil",
    product_jpn: "RUHAKU 月桃 リセットクレンジングオイル",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥3,800",
    rrp_with_vat: "¥4,180",
    description_eng:
      "RUHAKU is an organic skincare brand created in Japan in 2012. All products are certified as Ecocert Organic or Cosmos Organic We make use of the blessings of nature in Okinawa, an island of longevity, to create products that are gentle on both the skin and the environment. (We do not test on animals.)  Gekko, a traditional Okinawan herb, is the main ingredient. It is an attractive herb with excellent anti-inflammatory and anti-oxidant properties that simultaneously prevents rough skin and cares for aging skin. The slightly sweet and refreshing scent of shell ginger relaxes the tired mind. It is also used as an amenity in resort hotels and is popular in Paris, France, a leading organic country.  <RUHAKU GETTOU Cleansing Oil> Organic cleansing oil of 100% natural origin that easily removes even firm makeup. It is ideal for deep cleansing when you are concerned about roughness and pores on your skin, not to mention when you are wearing heavy makeup. Cleansing is the basis of skin care. It is not hard on the skin and leaves it clean and refreshed, making it easier to care for afterwards.",
    description_jpn:
      "RUHAKU（ルハク）は、2012年に日本で誕生したオーガニックスキンケアブランドです。 全商品が「エコサートオーガニック」または「コスモスオーガニック」の認証を受けています。 長寿の島・沖縄の大自然の恵みを活かし、肌にも環境にもやさしい商品づくりをしています。 （動物実験は行っておりません。）  沖縄の伝統ハーブ「月桃」が主原料。優れた抗炎症作用と抗酸化作用とを持ち、「肌荒れ防止」と「エイジングケア」を同時に実現する魅力的なハーブです。 月桃の、ほのかに甘く爽やかな香りは、疲れた心をリラックスさせます。 リゾートホテルのアメニティでもあり、またオーガニック先進国フランス・パリで人気を博しています。  <RUHAKU 月桃 リセットクレンジングオイル> しっかりメイクもするっと落ちる 100%天然由来のオーガニッククレンジング オイル。しっかりメイクの時はもちろん、ノーメイクでも肌のざらつきや毛穴が気になる時のディープクレンジングに。 スキンケアの基本である「洗浄」。肌に負担なく、後のお手入れが見違える、まっさらな肌へ整えます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/ruhaku/RUHAKU_RUHAKU+CLEANSING.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/RUHAKU.png",
  },
  {
    id: "569",
    brand: "RUHAKU",
    sku: "RUHAKU SOAP",
    product_eng: "RUHAKU GETTOU Clear Soap",
    product_jpn: "RUHAKU 月桃 クリアソープ",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥2,200",
    rrp_with_vat: "¥2,420",
    description_eng:
      "RUHAKU is an organic skincare brand created in Japan in 2012. All products are certified as Ecocert Organic or Cosmos Organic We make use of the blessings of nature in Okinawa, an island of longevity, to create products that are gentle on both the skin and the environment. (We do not test on animals.)  Gekko, a traditional Okinawan herb, is the main ingredient. It is an attractive herb with excellent anti-inflammatory and anti-oxidant properties that simultaneously prevents rough skin and cares for aging skin. The slightly sweet and refreshing scent of shell ginger relaxes the tired mind. It is also used as an amenity in resort hotels and is popular in Paris, France, a leading organic country.  <RUHAKU GETTOU Clear Soap> This is a rare soap made by the frame kneading method, which is capable of richly blending moisturizing and skin beautifying ingredients. Kucha (sea silt), an Okinawan clay with high dirt adsorbing power, shell ginger, which is effective in preventing rough skin and anti-aging care (age-appropriate care), and Okinawan deep sea water, which is also used in SPA as thalassotherapy, were used for about 90 days to create a jewel-like clear solid soap.",
    description_jpn:
      "RUHAKU（ルハク）は、2012年に日本で誕生したオーガニックスキンケアブランドです。 全商品が「エコサートオーガニック」または「コスモスオーガニック」の認証を受けています。 長寿の島・沖縄の大自然の恵みを活かし、肌にも環境にもやさしい商品づくりをしています。 （動物実験は行っておりません。）  沖縄の伝統ハーブ「月桃」が主原料。優れた抗炎症作用と抗酸化作用とを持ち、「肌荒れ防止」と「エイジングケア」を同時に実現する魅力的なハーブです。 月桃の、ほのかに甘く爽やかな香りは、疲れた心をリラックスさせます。 リゾートホテルのアメニティでもあり、またオーガニック先進国フランス・パリで人気を博しています。  <RUHAKU 月桃 クリアソープ> 保湿や美肌成分を豊富に配合できる枠練り製法でつくられた希少な石けん。 汚れを吸着する力が高い沖縄のクレイ「クチャ（海シルト）」をはじめ、肌荒れ予防やエイジングケア（年齢に応じたお手入れ）効果の高い月桃や、タラソテラピーとしてSPAにも用いられるような沖縄海洋深層水などを約 90 日かけて宝石のような澄んだ固形石けんに。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/ruhaku/RUHAKU_RUHAKU+SOAP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/RUHAKU.png",
  },
  {
    id: "570",
    brand: "RUHAKU",
    sku: "RUHAKU LOTION",
    product_eng: "RUHAKU GETTOU Lotion",
    product_jpn: "RUHAKU 月桃 バランスローション",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥3,800",
    rrp_with_vat: "¥4,180",
    description_eng:
      "RUHAKU is an organic skincare brand created in Japan in 2012. All products are certified as Ecocert Organic or Cosmos Organic We make use of the blessings of nature in Okinawa, an island of longevity, to create products that are gentle on both the skin and the environment. (We do not test on animals.)  Gekko, a traditional Okinawan herb, is the main ingredient. It is an attractive herb with excellent anti-inflammatory and anti-oxidant properties that simultaneously prevents rough skin and cares for aging skin. The slightly sweet and refreshing scent of shell ginger relaxes the tired mind. It is also used as an amenity in resort hotels and is popular in Paris, France, a leading organic country.  <RUHAKU GETTOU Lotion> A thick lotion containing the dense blessings of nature from Okinawa. It contains umi budou (sea grapes), deep seawater from Okinawa, shell ginger, which is effective in preventing rough skin and aging care (age-appropriate care), and Milotamnus flabellifolia, called the tree of revival, to prevent rough skin and maintain the best skin balance while firmly moisturizing fragile skin.",
    description_jpn:
      "RUHAKU（ルハク）は、2012年に日本で誕生したオーガニックスキンケアブランドです。 全商品が「エコサートオーガニック」または「コスモスオーガニック」の認証を受けています。 長寿の島・沖縄の大自然の恵みを活かし、肌にも環境にもやさしい商品づくりをしています。 （動物実験は行っておりません。）  沖縄の伝統ハーブ「月桃」が主原料。優れた抗炎症作用と抗酸化作用とを持ち、「肌荒れ防止」と「エイジングケア」を同時に実現する魅力的なハーブです。 月桃の、ほのかに甘く爽やかな香りは、疲れた心をリラックスさせます。 リゾートホテルのアメニティでもあり、またオーガニック先進国フランス・パリで人気を博しています。  <RUHAKU 月桃 バランスローション> 沖縄の自然の恵みを濃密に含んだとろみ化粧水。 海ぶどう（クビレヅタ）や沖縄の海洋深層水・肌荒れ予防やエイジングケア（年齢に応じたお手入れ）効果の高い月桃、「復活の木」と呼ばれるミロタムヌスフラベリフォリアでゆらぎやすい肌をしっかり保湿しながら肌荒れを防ぎ、ベストバランスが続く肌へ。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/ruhaku/RUHAKU_RUHAKU+LOTION.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/RUHAKU.png",
  },
  {
    id: "571",
    brand: "RUHAKU",
    sku: "RUHAKU OIL",
    product_eng: "RUHAKU GETTOU Night Repair Oil",
    product_jpn: "RUHAKU 月桃 ナイトリペアオイル",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥3,800",
    rrp_with_vat: "¥4,180",
    description_eng:
      "RUHAKU is an organic skincare brand created in Japan in 2012. All products are certified as Ecocert Organic or Cosmos Organic We make use of the blessings of nature in Okinawa, an island of longevity, to create products that are gentle on both the skin and the environment. (We do not test on animals.)  Gekko, a traditional Okinawan herb, is the main ingredient. It is an attractive herb with excellent anti-inflammatory and anti-oxidant properties that simultaneously prevents rough skin and cares for aging skin. The slightly sweet and refreshing scent of shell ginger relaxes the tired mind. It is also used as an amenity in resort hotels and is popular in Paris, France, a leading organic country.  <RUHAKU GETTOU Night Repair Oil> Based on rosehip and jojoba, which are said to be vitamin bombs, and tamanu (terihaboku seed oil), which grows wild in Okinawa and is called a spirit tree in the Pacific islands, the blend also contains evening primrose, which is good for sensitive skin, and pomegranate, calendula, and sesame, which are ideal for anti-aging care*. and other 9 kinds of botanical oils. Use a little bit each day or a generous amount for face massage to prevent rough skin and leads to firm and glowing skin.",
    description_jpn:
      "RUHAKU（ルハク）は、2012年に日本で誕生したオーガニックスキンケアブランドです。 全商品が「エコサートオーガニック」または「コスモスオーガニック」の認証を受けています。 長寿の島・沖縄の大自然の恵みを活かし、肌にも環境にもやさしい商品づくりをしています。 （動物実験は行っておりません。）  沖縄の伝統ハーブ「月桃」が主原料。優れた抗炎症作用と抗酸化作用とを持ち、「肌荒れ防止」と「エイジングケア」を同時に実現する魅力的なハーブです。 月桃の、ほのかに甘く爽やかな香りは、疲れた心をリラックスさせます。 リゾートホテルのアメニティでもあり、またオーガニック先進国フランス・パリで人気を博しています。  <RUHAKU 月桃 ナイトリペアオイル> ビタミンの爆弾と言われる「ローズヒップ」や「ホホバ」、太平洋の島々で精霊の木と呼ばれ重宝され沖縄にも自生する「タマヌ（テリハボク種子油）」などをベースに、センシティブな肌に嬉しい「月見草」やエイジングケア*に最適な「ザクロ」「カレンデュラ」「セサミ」など9種類の植物オイルを贅沢にブレンド。 毎日のお手入れで少しづつお使いいただいたり、フェイスマッサージ用にたっぷりお使いいただくことで、肌荒れを防ぎ ハリつや肌に導きます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/ruhaku/RUHAKU_RUHAKU+OIL.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/RUHAKU.png",
  },
  {
    id: "572",
    brand: "RUHAKU",
    sku: "RUHAKU CREAM",
    product_eng: "RUHAKU GETTOU Moist Cream",
    product_jpn: "RUHAKU 月桃 モイストクリーム",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥3,800",
    rrp_with_vat: "¥4,180",
    description_eng:
      "RUHAKU is an organic skincare brand created in Japan in 2012. All products are certified as Ecocert Organic or Cosmos Organic We make use of the blessings of nature in Okinawa, an island of longevity, to create products that are gentle on both the skin and the environment. (We do not test on animals.)  Gekko, a traditional Okinawan herb, is the main ingredient. It is an attractive herb with excellent anti-inflammatory and anti-oxidant properties that simultaneously prevents rough skin and cares for aging skin. The slightly sweet and refreshing scent of shell ginger relaxes the tired mind. It is also used as an amenity in resort hotels and is popular in Paris, France, a leading organic country.  <RUHAKU GETTOU Moist Cream> Organic Moisturizing Cream for Skin and Moisturizing A blend of six plant-derived oils that are highly effective in beautifying and moisturizing the skin and blend well with the skin. It helps modern women's skin, which is prone to many skin stresses such as air conditioning, seasonal changes, and environmental changes, to become healthy and balanced in moisture and oil.",
    description_jpn:
      "RUHAKU（ルハク）は、2012年に日本で誕生したオーガニックスキンケアブランドです。 全商品が「エコサートオーガニック」または「コスモスオーガニック」の認証を受けています。 長寿の島・沖縄の大自然の恵みを活かし、肌にも環境にもやさしい商品づくりをしています。 （動物実験は行っておりません。）  沖縄の伝統ハーブ「月桃」が主原料。優れた抗炎症作用と抗酸化作用とを持ち、「肌荒れ防止」と「エイジングケア」を同時に実現する魅力的なハーブです。 月桃の、ほのかに甘く爽やかな香りは、疲れた心をリラックスさせます。 リゾートホテルのアメニティでもあり、またオーガニック先進国フランス・パリで人気を博しています。  <RUHAKU 月桃 モイストクリーム> 素肌と潤いをつつみこむ オーガニック保湿クリーム 美肌効果や保湿効果が高く、肌なじみのよい6 種の植物由来オイルをブレンド。 エアコンの風や季節の変わり目、環境の変化など、肌ストレスが多く乱れやすい現代女性のお肌を、水分と油分のバランスが整った健やかな肌に導きます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/ruhaku/RUHAKU_RUHAKU+CREAM.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/RUHAKU.png",
  },
  {
    id: "573",
    brand: "RUHAKU",
    sku: "ZZRR022000",
    product_eng: "RUHAKU GETTOU Enriched Creamy sheet mask 5pc",
    product_jpn: "RUHAKU 月桃エンリッチシートマスク",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥4,200",
    rrp_with_vat: "¥4,620",
    description_eng:
      "RUHAKU is an organic skincare brand created in Japan in 2012. All products are certified as Ecocert Organic or Cosmos Organic. We make use of the blessings of nature in Okinawa, an island of longevity, to create products that are gentle on both the skin and the environment. (We do not test on animals.)  Gekko, a traditional Okinawan herb, is the main ingredient. It is an attractive herb with excellent anti-inflammatory and anti-oxidant properties that simultaneously prevents rough skin and cares for aging skin. The slightly sweet and refreshing scent of shell ginger relaxes the tired mind. It is also used as an amenity in resort hotels and is popular in Paris, France, a leading organic country.  ＜RUHAKU Gekko Enrich Sheet Mask>  20 minutes of blissful time to moisturize your skin and mind with the blessings of the Ryukyu Islands. This emulsion sheet mask is designed to moisturize dry skin and mind caused by various skin stresses and aging.  Contains a concentrated blend of Okinawa's vital natural blessings such as shell ginger, sea grape, and noni. Use it as a weekend treat or the day before a special occasion, while taking the time to treat yourself.  It is also recommended as a gift to show your appreciation to your loved ones. This is the first sheet mask in Japan to be certified by Cosmos Ecocert.  The mask is made of 100% unbleached organic cotton (certified by Organic Content Standard), which is soft and fluffy to the touch.  It is also made of 100% natural ingredients, making it an environmentally friendly sheet mask as well as a skin-friendly product.  In addition, we received the 2022 Green Trend Leader Award in the AA Environment Possibility Award.",
    description_jpn:
      "RUHAKU（ルハク）は、2012年に日本で誕生したオーガニックスキンケアブランドです。 全商品が「エコサートオーガニック」または「コスモスオーガニック」の認証を受けています。 長寿の島・沖縄の大自然の恵みを活かし、肌にも環境にもやさしい商品づくりをしています。 （動物実験は行っておりません。）  沖縄の伝統ハーブ「月桃」が主原料。優れた抗炎症作用と抗酸化作用とを持ち、「肌荒れ防止」と「エイジングケア」を同時に実現する魅力的なハーブです。 月桃の、ほのかに甘く爽やかな香りは、疲れた心をリラックスさせます。 リゾートホテルのアメニティでもあり、またオーガニック先進国フランス・パリで人気を博しています。  ＜RUHAKU 月桃エンリッチシートマスク＞  琉球の恵みで肌とこころにうるおい満ちる至福の20 分 様々な肌ストレスやエイジングで乾いたお肌や心ををうるおいで満たす美容乳液シートマスク。月桃・海ぶどう・ノニといった生命力あふれる沖縄の自然の恵みを濃密に配合。 週末のご褒美スキンケアや特別な日の前日などにじっくりご自身を慈しみながらお使いください。大切な人へ感謝の心を伝えるギフトにもおすすめです。 シートマスクにおいて、日本で初めて「コスモスエコサート認証」を取得。 マスク素材は無漂白オーガニックコットン100%（Organic Content Standard認証を取得）で、ふわっとやわらかな肌触り。天然由来成分も100%で、肌だけでなく環境にもやさしいシートマスクです。 さらに、AA Environment Possibility Awardにおいて、2022年グリーントレンドリーダー賞をいただきました。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/ruhaku/RUHAKU_ZZRR022000.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/RUHAKU.png",
  },
  {
    id: "574",
    brand: "RUHAKU",
    sku: "ZZSS006000",
    product_eng: "RUHAKU GETTOU Trial Set",
    product_jpn: "RUHAKUトライアルセット",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥2,400",
    rrp_with_vat: "¥2,640",
    description_eng:
      "RUHAKU is an organic skincare brand created in Japan in 2012. All products are certified as Ecocert Organic or Cosmos Organic. We make use of the blessings of nature in Okinawa, an island of longevity, to create products that are gentle on both the skin and the environment. (We do not test on animals.)  Gekko, a traditional Okinawan herb, is the main ingredient. It is an attractive herb with excellent anti-inflammatory and anti-oxidant properties that simultaneously prevents rough skin and cares for aging skin. The slightly sweet and refreshing scent of shell ginger relaxes the tired mind. It is also used as an amenity in resort hotels and is popular in Paris, France, a leading organic country.  This 4-piece mini-size set of cleansing oil, soap, lotion, and cream is easy to take along on trips or to the gym. It gives moisture to dry skin, leaving it moist and soft. It also prevents rough skin. Also suitable for those who are new to Ryuhaku skincare.  <Set contents> Shell ginger reset cleansing oil S 12mL x 1 Shell ginger clear soap S 13g x 1 Gekko Balance Lotion S 20mL x 1 Gekko Day Moist Cream S 6g x 1",
    description_jpn:
      "RUHAKU（ルハク）は、2012年に日本で誕生したオーガニックスキンケアブランドです。 全商品が「エコサートオーガニック」または「コスモスオーガニック」の認証を受けています。 長寿の島・沖縄の大自然の恵みを活かし、肌にも環境にもやさしい商品づくりをしています。 （動物実験は行っておりません。）  沖縄の伝統ハーブ「月桃」が主原料。優れた抗炎症作用と抗酸化作用とを持ち、「肌荒れ防止」と「エイジングケア」を同時に実現する魅力的なハーブです。 月桃の、ほのかに甘く爽やかな香りは、疲れた心をリラックスさせます。 リゾートホテルのアメニティでもあり、またオーガニック先進国フランス・パリで人気を博しています。  旅行やジムなどに持って行きやすい、クレンジングオイル・石けん・化粧水・クリームのミニサイズ4点セット。乾燥した肌にうるおいを与え、しっとり柔らかな肌に。肌荒れも防ぎます。琉白のスキンケアが初めての方にも。  ＜セット内容＞ ・月桃リセットクレンジングオイルS 12mL×1 ・月桃クリアソープS 13g×1 ・月桃バランスローションS 20mL×1 ・月桃デイモイストクリームS 6g×1",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/ruhaku/RUHAKU_ZZSS006000.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/RUHAKU.png",
  },
  {
    id: "575",
    brand: "RUHAKU",
    sku: "RUHAKU Skincare1",
    product_eng: "RUHAKU GETTOU Skincare Set 1",
    product_jpn: "RUHAKU 月桃 スキンケアセット1",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥13,600",
    rrp_with_vat: "¥14,960",
    description_eng:
      "RUHAKU is an organic skincare brand created in Japan in 2012. All products are certified as Ecocert Organic or Cosmos Organic. We make use of the blessings of nature in Okinawa, an island of longevity, to create products that are gentle on both the skin and the environment. (We do not test on animals.)  Gekko, a traditional Okinawan herb, is the main ingredient. It is an attractive herb with excellent anti-inflammatory and anti-oxidant properties that simultaneously prevents rough skin and cares for aging skin. The slightly sweet and refreshing scent of shell ginger relaxes the tired mind. It is also used as an amenity in resort hotels and is popular in Paris, France, a leading organic country.  <Set Contents> ●Gekko Reset Cleansing Oil S Organic cleansing oil of 100% natural origin that easily removes even firm makeup. Capacity: 150mL  ●Gekko Clear Soap S Facial cleansing soap containing Okinawan clay (kucha). Capacity: 80g  ●Shell ginger balance lotion S Highly moisturizing lotion of 100% natural origin. Capacity: 120 mL  ●Gekko Night Repair Oil S A nighttime beauty oil with 100% naturally derived ingredients. Capacity: 17mL.",
    description_jpn:
      "RUHAKU（ルハク）は、2012年に日本で誕生したオーガニックスキンケアブランドです。 全商品が「エコサートオーガニック」または「コスモスオーガニック」の認証を受けています。 長寿の島・沖縄の大自然の恵みを活かし、肌にも環境にもやさしい商品づくりをしています。 （動物実験は行っておりません。）  沖縄の伝統ハーブ「月桃」が主原料。優れた抗炎症作用と抗酸化作用とを持ち、「肌荒れ防止」と「エイジングケア」を同時に実現する魅力的なハーブです。 月桃の、ほのかに甘く爽やかな香りは、疲れた心をリラックスさせます。 リゾートホテルのアメニティでもあり、またオーガニック先進国フランス・パリで人気を博しています。  <セット内容> ●月桃リセットクレンジングオイル S しっかりメイクもするっと落ちる 100%天然由来のオーガニッククレンジング オイル。容量：150mL  ●月桃クリアソープ S 沖縄のクレイ（クチャ）配合の洗顔石けん。容量：80g  ●月桃バランスローション S 100％天然由来の高保湿化粧水。容量：120mL  ●月桃ナイトリペアオイル S 100％天然由来成分の夜の美容オイル。容量：17mL",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/ruhaku/RUHAKU_Skincare1.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/RUHAKU.png",
  },
  {
    id: "576",
    brand: "RUHAKU",
    sku: "RUHAKU Skincare2",
    product_eng: "RUHAKU GETTOU Skincare Set 2",
    product_jpn: "RUHAKU 月桃 スキンケアセット2",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥14,000",
    rrp_with_vat: "¥15,400",
    description_eng:
      "RUHAKU is an organic skincare brand created in Japan in 2012. All products are certified as Ecocert Organic or Cosmos Organic. We make use of the blessings of nature in Okinawa, an island of longevity, to create products that are gentle on both the skin and the environment. (We do not test on animals.)  Gekko, a traditional Okinawan herb, is the main ingredient. It is an attractive herb with excellent anti-inflammatory and anti-oxidant properties that simultaneously prevents rough skin and cares for aging skin. The slightly sweet and refreshing scent of shell ginger relaxes the tired mind. It is also used as an amenity in resort hotels and is popular in Paris, France, a leading organic country.  <Set Contents> ●Gekko Clear Soap S Facial cleansing soap containing Okinawan clay (kucha). Capacity: 80 g  ●Shell ginger balance lotion S Highly moisturizing lotion of 100% natural origin. Capacity: 120 mL  ●Gekko Moist Cream S Moist and fresh organic moisturizing cream. Capacity: 30g  ●Gekko Enrich Creamy Sheet Mask (5 sheets per box) A beauty emulsion sheet mask that moisturizes dry skin and mind due to various skin stresses and aging. Capacity: 23 mL x 5 sheets.",
    description_jpn:
      "RUHAKU（ルハク）は、2012年に日本で誕生したオーガニックスキンケアブランドです。 全商品が「エコサートオーガニック」または「コスモスオーガニック」の認証を受けています。 長寿の島・沖縄の大自然の恵みを活かし、肌にも環境にもやさしい商品づくりをしています。 （動物実験は行っておりません。）  沖縄の伝統ハーブ「月桃」が主原料。優れた抗炎症作用と抗酸化作用とを持ち、「肌荒れ防止」と「エイジングケア」を同時に実現する魅力的なハーブです。 月桃の、ほのかに甘く爽やかな香りは、疲れた心をリラックスさせます。 リゾートホテルのアメニティでもあり、またオーガニック先進国フランス・パリで人気を博しています。  <セット内容> ●月桃クリアソープ S 沖縄のクレイ（クチャ）配合の洗顔石けん。容量：80g  ●月桃バランスローション S 100％天然由来の高保湿化粧水。容量：120mL  ●月桃モイストクリーム S しっとり瑞々しいオーガニック保湿クリーム。容量：30g  ●月桃エンリッチクリーミーシートマスク1箱5枚入り 様々な肌ストレスやエイジングで乾いたお肌や心ををうるおいで満たす美容乳液シートマスク。容量：23mL×5枚",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/ruhaku/RUHAKU_Skincare2.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/RUHAKU.png",
  },
  {
    id: "577",
    brand: "RUHAKU",
    sku: "RUHAKU Moisture",
    product_eng: "RUHAKU GETTOU Moisturizing Skincare Set",
    product_jpn: "RUHAKU 月桃 保湿スキンケアセット",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥11,800",
    rrp_with_vat: "¥12,980",
    description_eng:
      "RUHAKU is an organic skincare brand created in Japan in 2012. All products are certified as Ecocert Organic or Cosmos Organic. We make use of the blessings of nature in Okinawa, an island of longevity, to create products that are gentle on both the skin and the environment. (We do not test on animals.)  Gekko, a traditional Okinawan herb, is the main ingredient. It is an attractive herb with excellent anti-inflammatory and anti-oxidant properties that simultaneously prevents rough skin and cares for aging skin. The slightly sweet and refreshing scent of shell ginger relaxes the tired mind. It is also used as an amenity in resort hotels and is popular in Paris, France, a leading organic country.  <Set Contents> ●Gekko Balancing Lotion S Highly moisturizing lotion of 100% natural origin. Capacity: 120 mL  ●Gekko Night Repair Oil S A nighttime beauty oil with 100% naturally derived ingredients. Capacity: 17 mL  ●Gekko Enrich Creamy Sheet Mask (5 sheets per box) A beauty emulsion sheet mask that moisturizes dry skin and mind due to various skin stresses and aging. Capacity: 23mL x 5 sheets",
    description_jpn:
      "RUHAKU（ルハク）は、2012年に日本で誕生したオーガニックスキンケアブランドです。 全商品が「エコサートオーガニック」または「コスモスオーガニック」の認証を受けています。 長寿の島・沖縄の大自然の恵みを活かし、肌にも環境にもやさしい商品づくりをしています。 （動物実験は行っておりません。）  沖縄の伝統ハーブ「月桃」が主原料。優れた抗炎症作用と抗酸化作用とを持ち、「肌荒れ防止」と「エイジングケア」を同時に実現する魅力的なハーブです。 月桃の、ほのかに甘く爽やかな香りは、疲れた心をリラックスさせます。 リゾートホテルのアメニティでもあり、またオーガニック先進国フランス・パリで人気を博しています。  <セット内容> ●月桃バランスローション S 100％天然由来の高保湿化粧水。容量：120mL  ●月桃ナイトリペアオイル S 100％天然由来成分の夜の美容オイル。容量：17mL  ●月桃エンリッチクリーミーシートマスク1箱5枚入り 様々な肌ストレスやエイジングで乾いたお肌や心ををうるおいで満たす美容乳液シートマスク。容量：23mL×5枚",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/ruhaku/RUHAKU_Moisture.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/RUHAKU.png",
  },
  {
    id: "579",
    brand: "KITAO",
    sku: "KM Cleansing C",
    product_eng: "KITAO MATCHA Cleansing Cream",
    product_jpn: "KITAO MATCHA クレンジングクリーム",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥2,100",
    rrp_with_vat: "¥2,310",
    description_eng:
      "KITAO MATCHA is one of Japan's leading clean beauty cosmetics brands. Clean beauty products are produced with carefully selected ingredients that are gentle to the skin and respectful of the environment, society and our planet.  All of KITAO MATCHA's products are made with certified organic matcha. Matcha contains many beauty benefits. Let’supply your skin with three superfoods(chia seed, quinoa and acai)that are also healthy for your body. All products are made in Japan.  Facial cleansing cream gently removes makeup and sebum while moisturizing. It is a mild and rich cream that can also be used as a massage cream.",
    description_jpn:
      "KITAO MATCHAは、日本を代表する「クリーンビューティー」化粧品ブランドです。 クリーンビューティー製品は、肌に優しく、環境や社会、地球に配慮した厳選された成分で作られています。 KITAO MATCHAの製品は、すべてオーガニック認定の抹茶を使用しています。抹茶には多くの美容効果があります。 体に良いスーパーフード3種類(チアシード、キヌア、アサイー)を肌にも補給しましょう。 すべての製品は日本で製造されています。  洗顔クリームは潤いを与えながらメイクと皮脂を優しくオフ。まろやかでコクのあるクリーム状なのでマッサージクリームとしても使えます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/kitao/KITAO_KM Cleansing C.jpg.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/kitao.png",
  },
  {
    id: "580",
    brand: "KITAO",
    sku: "KM Lotion",
    product_eng: "KITAO MATCHA Lotion",
    product_jpn: "KITAO MATCHA ローション",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥2,200",
    rrp_with_vat: "¥2,420",
    description_eng:
      "KITAO MATCHA is one of Japan's leading clean beauty cosmetics brands. Clean beauty products are produced with carefully selected ingredients that are gentle to the skin and respectful of the environment, society and our planet.  All of KITAO MATCHA's products are made with certified organic matcha. Matcha contains many beauty benefits. Let’supply your skin with three superfoods(chia seed, quinoa and acai)that are also healthy for your body. All products are made in Japan.  The lotion is absorbed into the skin as soon as it is applied and moisturizes skin that tends to be dry and stiff. It leaves the skin fine and moisturized.",
    description_jpn:
      "KITAO MATCHAは、日本を代表する「クリーンビューティー」化粧品ブランドです。 クリーンビューティー製品は、肌に優しく、環境や社会、地球に配慮した厳選された成分で作られています。 KITAO MATCHAの製品は、すべてオーガニック認定の抹茶を使用しています。抹茶には多くの美容効果があります。 体に良いスーパーフード3種類(チアシード、キヌア、アサイー)を肌にも補給しましょう。 すべての製品は日本で製造されています。  化粧水はお肌にのせた瞬間にすーっと馴染み、乾燥でこわばりがちな肌にしっとりとうるおいを与えます。キメ細かいうるおいに満ちた肌に整えます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/kitao/KITAO_KM Lotion.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KITAO.png",
  },
  {
    id: "581",
    brand: "KITAO",
    sku: "KM Cream",
    product_eng: "KITAO MATCHA Cream",
    product_jpn: "KITAO MATCHA クリーム",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥2,400",
    rrp_with_vat: "¥2,640",
    description_eng:
      "KITAO MATCHA is one of Japan's leading clean beauty cosmetics brands. Clean beauty products are produced with carefully selected ingredients that are gentle to the skin and respectful of the environment, society and our planet.  All of KITAO MATCHA's products are made with certified organic matcha. Matcha contains many beauty benefits. Let’supply your skin with three superfoods(chia seed, quinoa and acai)that are also healthy for your body. All products are made in Japan.  The cream's rich moisture adheres tightly to the skin, leaving it glowing. It is non-sticky, so makeup can be applied afterwards.",
    description_jpn:
      "KITAO MATCHAは、日本を代表する「クリーンビューティー」化粧品ブランドです。 クリーンビューティー製品は、肌に優しく、環境や社会、地球に配慮した厳選された成分で作られています。 KITAO MATCHAの製品は、すべてオーガニック認定の抹茶を使用しています。抹茶には多くの美容効果があります。 体に良いスーパーフード3種類(チアシード、キヌア、アサイー)を肌にも補給しましょう。 すべての製品は日本で製造されています。  クリームはこっくりとしたうるおいが肌にピタッと密着し、もちもちとしたお肌に整えます。ベタ付きにくいので、その後にメイクをすることが可能です。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/kitao/KITAO_KM Cream.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KITAO.png",
  },
  {
    id: "582",
    brand: "KITAO",
    sku: "KM Sleeping Mask",
    product_eng: "KITAO MATCHA Sleeping Mask",
    product_jpn: "KITAO MATCHA スリーピングマスク",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥2,500",
    rrp_with_vat: "¥2,750",
    description_eng:
      "KITAO MATCHA is one of Japan's leading clean beauty cosmetics brands. Clean beauty products are produced with carefully selected ingredients that are gentle to the skin and respectful of the environment, society and our planet.  All of KITAO MATCHA's products are made with certified organic matcha. Matcha contains many beauty benefits. Let’supply your skin with three superfoods(chia seed, quinoa and acai)that are also healthy for your body. All products are made in Japan.  Sleeping Mask is a night time pack that you simply apply at the end of a busy day and go to sleep. It is an intensive moisturizing mask that moisturizes and hydrates dry skin and does not require rinsing off.  Apply it to your skin before bed and sleep, and it will leave your skin moist and lustrous.",
    description_jpn:
      "KITAO MATCHAは、日本を代表する「クリーンビューティー」化粧品ブランドです。 クリーンビューティー製品は、肌に優しく、環境や社会、地球に配慮した厳選された成分で作られています。 KITAO MATCHAの製品は、すべてオーガニック認定の抹茶を使用しています。抹茶には多くの美容効果があります。 体に良いスーパーフード3種類(チアシード、キヌア、アサイー)を肌にも補給しましょう。 すべての製品は日本で製造されています。  スリーピングマスクは忙しい１日の終りに塗って眠るだけの夜用パック。 洗い流し不要の集中保湿マスク。乾燥が気になる肌にしっとりと潤いを与える集中保湿マスクです。寝る前にお肌に塗布し、眠っていただくと、しっとり艷やかなお肌に整えます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/kitao/KITAO_KM Sleeping+Mask.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KITAO.png",
  },
  {
    id: "584",
    brand: "KITAO",
    sku: "KM Moisture",
    product_eng: "KITAO MATCHA Moisturizing Skincare Set",
    product_jpn: "KITAO MATCHA 保湿スキンケアセット",
    category_1: "Cosmetics & Beauty",
    category_2: "",
    rrp_ex_vat: "¥7,100",
    rrp_with_vat: "¥7,810",
    description_eng:
      "KITAO MATCHA is one of Japan's leading clean beautycosmetics brands. Clean beauty products are produced with carefully selected ingredients that are gentle to the skin and respectful of the environment, society and our planet.  All of KITAO MATCHA's products are made with certified organic matcha. Matcha contains many beauty benefits. Let’supply your skin with three superfoods(chia seed, quinoa and acai)that are also healthy for your body. All products are made in Japan.  KITAO MATCHA Skincare Basic Set   <Lotion> he lotion is absorbed into the skin as soon as it is applied and moisturizes skin that tends to be dry and stiff. It leaves the skin fine and moisturized. <Cream> The cream's rich moisture adheres tightly to the skin, leaving it glowing. It is non-sticky, so makeup can be applied afterwards. <Sleeping Mask> Sleeping Mask is a night time pack that you simply apply at the end of a busy day and go to sleep. It is an intensive moisturizing mask that moisturizes and hydrates dry skin and does not require rinsing off.  Apply it to your skin before bed and sleep, and it will leave your skin moist and lustrous.",
    description_jpn:
      "KITAO MATCHAは、日本を代表する「クリーンビューティー」化粧品ブランドです。 クリーンビューティー製品は、肌に優しく、環境や社会、地球に配慮した厳選された成分で作られています。 KITAO MATCHAの製品は、すべてオーガニック認定の抹茶を使用しています。抹茶には多くの美容効果があります。 体に良いスーパーフード3種類(チアシード、キヌア、アサイー)を肌にも補給しましょう。 すべての製品は日本で製造されています。  KITAO MATCHAの保湿スキンケアセットです。 ＜ローション＞ 化粧水はお肌にのせた瞬間にすーっと馴染み、乾燥でこわばりがちな肌にしっとりとうるおいを与えます。キメ細かいうるおいに満ちた肌に整えます。 ＜クリーム＞ クリームはこっくりとしたうるおいが肌にピタッと密着し、もちもちとしたお肌に整えます。ベタ付きにくいので、その後にメイクをすることが可能です。 ＜スリーピングマスク＞ スリーピングマスクは忙しい１日の終りに塗って眠るだけの夜用パック。 洗い流し不要の集中保湿マスク。乾燥が気になる肌にしっとりと潤いを与える集中保湿マスクです。寝る前にお肌に塗布し、眠っていただくと、しっとり艷やかなお肌に整えます。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/kitao/KITAO_KM+Moisture.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KITAO.png",
  },
  {
    id: "586",
    brand: "IMABARI KINSEI",
    sku: "GK71150",
    product_eng: "IMABARI KINSEI Superior Towels Set -2 Bath Towels",
    product_jpn: "今治謹製 極上タオル superior バスタオル2枚セット",
    category_1: "Gift",
    category_2: "",
    rrp_ex_vat: "¥11,500",
    rrp_with_vat: "¥12,650",
    description_eng:
      "This IMABARI towel gift includes two bath towels packed in a luxurious wooden box with the Imabari logo engraved in gold foil. The clean white and gray shades can be used by anyone, whether you like it or not. The bath towel is a little bit larger than the other towels, with a comfortable texture that will wrap your body tightly.  What is the superior towel? Imabari, Ehime Prefecture, is a town with a long history of towel production,with weaving techniques built up since the Nara Period and famous water from the Sosha River. Imabari is proud to present IMABARI KINSEI Superior Towel, which is woven by Imabari in earnest. The more you continue to use it, the more and more its IMABARI ability. Rigid yet soft. Strict and delicate. It is a gem that is a condensation of the maker's sense of beauty. Set Contents: 2 bath towels approx. 60 x 130 cm Box size: 30 x 40 x 10 cm Material: 100% cotton Country of origin: Made in Japan (Imabari)",
    description_jpn:
      "金の箔で今治謹製ロゴが刻印された、高級感のある木箱にバスタオル2枚をお詰めした今治タオルのタオルギフトです。 清潔感のあるホワイトとグレーの色合いはどなたでも好き嫌いなくお使いいただけます。 バスタオルは心地良い風合いで身体をしっかり包み込んでくれる少し大きめのバスタオルです。  「極上タオルとは」 歴史あるタオルの町、愛媛県「今治」。奈良時代から築き上げた織の技と、蒼社川の名水。 その「今治」が本気を出して織り上げた「今治謹製 極上タオル」です。 使い続けるほどに、ますますその「今治」の実力。 剛にして柔。厳然として繊細。作りての美意識が凝縮された逸品です。 今治謹製シリーズのタオルは全て今治産地で生産されています。  セット内容： バスタオル 2枚 約60×130㎝ 箱サイズ：30×40×10㎝ 素材：綿100％ 原産国：日本製（今治）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_GK71150.jpg.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_GK71150_1.jpg.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/imabari-kinsei.png",
  },
  {
    id: "587",
    brand: "IMABARI KINSEI",
    sku: "GK71550",
    product_eng:
      "IMABARI KINSEI Superior Towels Set -2Bath Towels and 2 Face Towels",
    product_jpn:
      "今治謹製 極上タオル superior バスタオル2枚・フェイスタオル2枚セット",
    category_1: "Gift",
    category_2: "",
    rrp_ex_vat: "¥15,500",
    rrp_with_vat: "¥17,050",
    description_eng:
      "This IMABARI towel gift includes two bath towels packed in a luxurious wooden box with the Imabari logo engraved in gold foil. The clean white and gray shades can be used by anyone, whether you like it or not. The bath towel is a little bit larger than the other towels, with a comfortable texture that will wrap your body tightly.  What is the superior towel? Imabari, Ehime Prefecture, is a town with a long history of towel production,with weaving techniques built up since the Nara Period and famous water from the Sosha River. Imabari is proud to present IMABARI KINSEI Superior Towel, which is woven by Imabari in earnest. The more you continue to use it, the more and more its IMABARI ability. Rigid yet soft. Strict and delicate. It is a gem that is a condensation of the maker's sense of beauty. Set Contents: 2 bath towels, approx. 60 x 130 cm 2 face towels: approx. 34 x 85 cm Box size: 30 x 40 x 10 cm Material: 100% cotton Country of origin: Made in Japan (Imabari)",
    description_jpn:
      "金の箔で今治謹製ロゴが刻印された、高級感のある木箱にバスタオルとフェイスタオルを各2枚をお詰めした今治タオルのタオルギフトです。 清潔感のあるホワイトとグレーの色合いはどなたでも好き嫌いなくお使いいただけます。 バスタオルは心地良い風合いで身体をしっかり包み込んでくれる少し大きめのバスタオルです。  「極上タオルとは」 歴史あるタオルの町、愛媛県「今治」。奈良時代から築き上げた織の技と、蒼社川の名水。 その「今治」が本気を出して織り上げた「今治謹製 極上タオル」です。 使い続けるほどに、ますますその「今治」の実力。 剛にして柔。厳然として繊細。作りての美意識が凝縮された逸品です。 今治謹製シリーズのタオルは全て今治産地で生産されています。  セット内容： バスタオル 2枚 約60×130㎝ フェイスタオル 2枚 約34×85㎝ 箱サイズ：30×40×10㎝ 素材：綿100％ 原産国：日本製（今治）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_GK71550.jpg.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_GK71550_1.jpg.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/imabari-kinsei.png",
  },
  {
    id: "588",
    brand: "IMABARI KINSEI",
    sku: "SH55040",
    product_eng:
      "IMABARI KINSEI SHIFUKU Towel Set -2 Face Towel and 1 Wash Towel",
    product_jpn:
      "今治謹製 至福タオル フェイスタオル２枚・ウォッシュタオル１枚セット",
    category_1: "Gift",
    category_2: "",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "A face towel and a wash towel are gently packed in a luxurious and beautiful wooden box. The towels are soft, fluffy, and smooth to the touch. The design is based on the name SHIFUKU＝Bliss and incorporates gold and silver for good luck. The lid of the wooden box is stamped with gold foil, and the label is made of pearl paper and gold string to create a dainty design that shines elegantly. The package is designed with attention to detail. The bell, which is believed to bring good luck because it is said to bring happiness, is also used to express the wish that many people will be happy.  The name Bliss Towel is especially suitable for celebrations and congratulatory events. It is especially appreciated as a wedding gift for newlyweds, wedding gifts, wedding gifts for bridal occasions, and as a gift for the birth of a newborn baby.  Set includes: 2 face towels, approx. 33 x 75 cm 1 wash towel, approx. 33 x 31 cm Box size: 20.5 x 30 x 7 cm Material: 100% cotton Country of origin: Made in Japan (Imabari)",
    description_jpn:
      "フェイスタオルとウォッシュタオルを高級感のある美しい木箱にやさしくそっと詰めたタオルギフト。 ふんわりやわらかく、なめらかな肌ざわり。 「至福」という名前にこだわって、縁起の良い金や銀をデザインに取り入れました。 木箱のフタには金の箔押しを、ラベルにはパール紙や金の紐を用い、上品に輝く可憐なデザインに仕上げています。 ディテールまでこだわり抜いたパッケージです。また、“幸せを呼ぶ”ということから縁起が良いとされている鈴には、“たくさんの人が幸せになりますように”という想いが込められています。  特に至福タオルという名前からお祝い事・慶事に最適です。 新婚のお二人への結婚祝い・結婚引き出物・結婚内祝い等ブライダルシーンや赤ちゃんが生まれた際の出産内祝い・出産祝いでは特に喜ばれています。  セット内容： フェイスタオル 2枚 約33×75㎝ ウオッシュタオル 1枚 約33×31㎝ 箱サイズ：20.5×30×７㎝ 素材：綿100％ 原産国：日本製（今治）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_SH55040.jpg.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_SH55040_1.jpg.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/imabari-kinsei.png",
  },
  {
    id: "589",
    brand: "IMABARI KINSEI",
    sku: "SH55100",
    product_eng:
      "IMABARI KINSEI SHIFUKU Towel Set -2 Bath Towel and 2 Face Towel",
    product_jpn: "今治謹製 至福タオル バスタオル２枚・フェイスタオル２枚セット",
    category_1: "Gift",
    category_2: "",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥11,000",
    description_eng:
      "Bath towel and face towel are gently packed in a luxurious and beautiful wooden box. The towels are soft, fluffy, and smooth to the touch. The design is based on the name SHIFUKU＝Bliss and incorporates gold and silver for good luck. The lid of the wooden box is stamped with gold foil, and the label is made of pearl paper and gold string to create a dainty design that shines elegantly. The package is designed with attention to detail. The bell, which is believed to bring good luck because it is said to bring happiness, is also used to express the wish that many people will be happy.  The name Bliss Towel is especially suitable for celebrations and congratulatory events. It is especially appreciated as a wedding gift for newlyweds, wedding gifts, wedding gifts for bridal occasions, and as a gift for the birth of a newborn baby.  Set includes: 2 bath towels approx. 60 x 110 cm 2 face towels: approx. 33 x 75 cm Box size: 30 x 40 x 10 cm Material: 100% cotton Country of origin: Made in Japan (Imabari)",
    description_jpn:
      "バスタオルとフェイスタオルを高級感のある美しい木箱にやさしくそっと詰めたタオルギフト。 ふんわりやわらかく、なめらかな肌ざわり。 「至福」という名前にこだわって、縁起の良い金や銀をデザインに取り入れました。 木箱のフタには金の箔押しを、ラベルにはパール紙や金の紐を用い、上品に輝く可憐なデザインに仕上げています。 ディテールまでこだわり抜いたパッケージです。また、“幸せを呼ぶ”ということから縁起が良いとされている鈴には、“たくさんの人が幸せになりますように”という想いが込められています。  特に至福タオルという名前からお祝い事・慶事に最適です。 新婚のお二人への結婚祝い・結婚引き出物・結婚内祝い等ブライダルシーンや赤ちゃんが生まれた際の出産内祝い・出産祝いでは特に喜ばれています。  セット内容： バスタオル 2枚 約60×110㎝ フェイスタオル 2枚 約33×75㎝ 箱サイズ：30×40×10㎝ 素材：綿100％ 原産国：日本製（今治）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_SH55100.jpg.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_SH55100_1.jpg.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_SH55100_2.jpg.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/imabari-kinsei.png",
  },
  {
    id: "590",
    brand: "IMABARI KINSEI",
    sku: "FS7713 P",
    product_eng: "IMABARI KINSEI Baby Gift in Wooden Box - Pink",
    product_jpn: "今治謹製 First towel 木箱入 ベビーギフト ピンク",
    category_1: "Gift",
    category_2: "",
    rrp_ex_vat: "¥13,000",
    rrp_with_vat: "¥14,300",
    description_eng:
      "The towels are woven into a comfortable towel for babies. It comes in a wooden and paper box with a pure and innocent image. The soft gauze fabric on the surface is gentle to babies' delicate skin. The pile fabric on the reverse side is highly absorbent and refreshing to wipe away sweat and saliva. Please present this carefully crafted, reliable quality product to your loved ones.  Set includes: 1 hooded bath poncho, approx. 60 x 100 cm Material: 100% cotton 2 face towels, approx. 34 x 80 cm Material: 100% cotton 1 Sty approx. 20 x 23 cm (neck circumference: approx. 26-28 cm) Material: 100% cotton Nigi-Nigigi (with bell) approx. 9 x 13 cm Material: Outer fabric/100% cotton, inner cotton/100% polyester Box size: 30 x 40 x 10 cm Material: 100% cotton Country of origin: Made in Japan (Imabari)",
    description_jpn:
      "赤ちゃんにとって使い心地の良いタオルに織り上げました。 木箱と紙箱を組み合わせたピュアで無垢なイメージの箱に入っています。 表面の柔らかなガーゼ生地は、繊細な赤ちゃんの肌にもやさしい風合い。 裏面のパイル生地は、汗や唾液をしっかりふき取り吸水性が高くさわやかな使い心地。 一枚一枚丁寧に作られた確かな品質を、大切な方へお贈りください。  セット内容： フード付きバスポンチョ 1枚 約60×100㎝ 素材：綿100％ フェイスタオル 2枚 約34×80㎝ 素材：綿100％ スタイ 1枚 約20×23㎝(首回り:約26～28㎝) 素材：綿100％ にぎにぎ（鈴入り）約9×13㎝ 素材:表地/綿100％、中綿/ポリエステル100％ 箱サイズ：30×40×10㎝ 素材：綿100％ 原産国：日本製（今治）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_FS7713 P.jpg.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_FS7713 P_1.jpg.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_GK71150.jpg.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/imabari-kinsei.png",
  },
  {
    id: "591",
    brand: "IMABARI KINSEI",
    sku: "FS7713 G",
    product_eng: "IMABARI KINSEI Baby Gift in Wooden Box - Gray",
    product_jpn: "今治謹製 First towel 木箱入 ベビーギフト グレー",
    category_1: "Gift",
    category_2: "",
    rrp_ex_vat: "¥13,000",
    rrp_with_vat: "¥14,300",
    description_eng:
      "The towels are woven into a comfortable towel for babies. It comes in a wooden and paper box with a pure and innocent image. The soft gauze fabric on the surface is gentle to babies' delicate skin. The pile fabric on the reverse side is highly absorbent and refreshing to wipe away sweat and saliva. Please present this carefully crafted, reliable quality product to your loved ones.  Set includes: 1 hooded bath poncho, approx. 60 x 100 cm Material: 100% cotton 2 face towels, approx. 34 x 80 cm Material: 100% cotton 1 Sty approx. 20 x 23 cm (neck circumference: approx. 26-28 cm) Material: 100% cotton Nigi-Nigigi (with bell) approx. 9 x 13 cm Material: Outer fabric/100% cotton, inner cotton/100% polyester Box size: 30 x 40 x 10 cm Material: 100% cotton Country of origin: Made in Japan (Imabari)",
    description_jpn:
      "赤ちゃんにとって使い心地の良いタオルに織り上げました。 木箱と紙箱を組み合わせたピュアで無垢なイメージの箱に入っています。 表面の柔らかなガーゼ生地は、繊細な赤ちゃんの肌にもやさしい風合い。 裏面のパイル生地は、汗や唾液をしっかりふき取り吸水性が高くさわやかな使い心地。 一枚一枚丁寧に作られた確かな品質を、大切な方へお贈りください。  セット内容： フード付きバスポンチョ 1枚 約60×100㎝ 素材：綿100％ フェイスタオル 2枚 約34×80㎝ 素材：綿100％ スタイ 1枚 約20×23㎝(首回り:約26～28㎝) 素材：綿100％ にぎにぎ（鈴入り）約9×13㎝ 素材:表地/綿100％、中綿/ポリエステル100％ 箱サイズ：30×40×10㎝ 素材：綿100％ 原産国：日本製（今治）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_FS7713 G.jpg.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_FS7713 G_1.jpg.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/imabari_kinsei/IMABARI_FS7713 G_2.jpg.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/imabari-kinsei.png",
  },
  {
    id: "592",
    brand: "evercook",
    sku: "EAFP13RD",
    product_eng: "evercookα  Rolled egg making pan 13×18 cm",
    product_jpn: "evercookα  エバークックα 玉子焼き13×18 cm",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥3,980",
    rrp_with_vat: "¥4,378",
    description_eng:
      "You will want to use evercook all the time. It does not stick easily and cleans off stains smoothly. Recommended for those who love to cook and want to use it tough every day!   Alpha diamond particles are contained in the fluorine coating, and the fluorine coating is strong.  Cleared the 2 million times abrasion resistance test and the 200 hours corrosion resistance test.  Unique anchor structure. Even if the fluorine coating peels off, the anodized aluminum coating, which is resistant to heat, salt, and friction, guards firmly.  2-year warranty (*Warranty covers peeling of the fluoropolymer on the inner surface.)  Size (approx.): W368mm x D143mm x H67mm (H35mm *Frying pan only)  Material: [Body] aluminum alloy, stainless steel, fluorine coating [Handle] phenol resin  Weight (approx.): 413g  Compatible with IH/GAS all heat sources.",
    description_jpn:
      "ずっと使いたくなるevercook。 こびりつきづらく汚れ落ちもスムーズ。 お料理好きの方、毎日タフに使いたい方にオススメ!   フッ素コーティングの中にαダイヤ粒子が入り、フッ素コーティングが強い。  200万回耐摩耗性試験クリア。200時間耐食性試験クリア。  独自のアンカー構造。もしフッ素が剥がれても熱・塩分・摩擦に強いアルマイトコーティングでしっかりガード。  自信があるから2年保証（※保証は内面ふっ素樹脂のはがれが対象です。)  サイズ（約）：W368mm×D143mm×H67mm（H35mm※フライパンのみ）  素材：[本体]アルミニウム合金、ステンレス鋼、ふっ素コーティング [取っ手]フェノール樹脂  質量（約）：413ｇ  IH/GASオール熱源対応",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/evercook/evercook_EAFP13RD.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/evercook.png",
  },
  {
    id: "593",
    brand: "evercook",
    sku: "EAFP22RD",
    product_eng: "evercookα  Fry Pan 22 cm",
    product_jpn: "evercookα  エバークックαフライパン22 cm",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥4,480",
    rrp_with_vat: "¥4,928",
    description_eng:
      "You will want to use evercook all the time. It does not stick easily and cleans off stains smoothly. Recommended for those who love to cook and want to use it tough every day!   Alpha diamond particles are contained in the fluorine coating, and the fluorine coating is strong.  Cleared the 2 million times abrasion resistance test and the 200 hours corrosion resistance test.  Unique anchor structure. Even if the fluorine coating peels off, the anodized aluminum coating, which is resistant to heat, salt, and friction, guards firmly.  2-year warranty (*Warranty covers peeling of the fluoropolymer on the inner surface.)  Size (approx.): W401mm x D235mm x H112mm (H60mm* frying pan only)  Material: [Body] aluminum alloy, stainless steel, fluorine coating [Handle] phenol resin  Weight (approx.): 597g  Compatible with all IH/GAS heat sources",
    description_jpn:
      "ずっと使いたくなるevercook。 こびりつきづらく汚れ落ちもスムーズ。 お料理好きの方、毎日タフに使いたい方にオススメ!   フッ素コーティングの中にαダイヤ粒子が入り、フッ素コーティングが強い。  200万回耐摩耗性試験クリア。200時間耐食性試験クリア。  独自のアンカー構造。もしフッ素が剥がれても熱・塩分・摩擦に強いアルマイトコーティングでしっかりガード。  自信があるから2年保証（※保証は内面ふっ素樹脂のはがれが対象です。）  サイズ（約）：W401mm×D235mm×H112mm（H60mm※フライパンのみ）  素材：[本体]アルミニウム合金、ステンレス鋼、ふっ素コーティング [取っ手]フェノール樹脂  質量（約）：597ｇ  IH/GASオール熱源対応",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/evercook/evercook_EAFP22RD.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/evercook.png",
  },
  {
    id: "594",
    brand: "evercook",
    sku: "EAFP26RD",
    product_eng: "evercookα  Fry Pan 26 cm",
    product_jpn: "evercookα  エバークックαフライパン26 cm",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥4,980",
    rrp_with_vat: "¥5,478",
    description_eng:
      "You will want to use evercook all the time. It does not stick easily and cleans off stains smoothly. Recommended for those who love to cook and want to use it tough every day!   Alpha diamond particles are contained in the fluorine coating, and the fluorine coating is strong.  Cleared the 2 million times abrasion resistance test and the 200 hours corrosion resistance test.  Unique anchor structure. Even if the fluorine coating peels off, the anodized aluminum coating, which is resistant to heat, salt, and friction, guards firmly.  2-year warranty (*Warranty covers peeling of the fluoropolymer on the inner surface.)  Size (approx.): W485mm x D275mm x H110mm (H60mm* frying pan only)  Material: [Body] aluminum alloy, stainless steel, fluorine coating [Handle] phenol resin  Weight (approx.): 674 g  Compatible with all IH/GAS heat sources",
    description_jpn:
      "ずっと使いたくなるevercook。 こびりつきづらく汚れ落ちもスムーズ。 お料理好きの方、毎日タフに使いたい方にオススメ!   フッ素コーティングの中にαダイヤ粒子が入り、フッ素コーティングが強い。  200万回耐摩耗性試験クリア。200時間耐食性試験クリア。  独自のアンカー構造。もしフッ素が剥がれても熱・塩分・摩擦に強いアルマイトコーティングでしっかりガード。  自信があるから2年保証（※保証は内面ふっ素樹脂のはがれが対象です。）  サイズ（約）：W485mm×D275mm×H110mm（H60mm※フライパンのみ）  素材：[本体]アルミニウム合金、ステンレス鋼、ふっ素コーティング [取っ手]フェノール樹脂  質量（約）：674ｇ  IH/GASオール熱源対応",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/evercook/evercook_EAFP26RD.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/evercook.png",
  },
  {
    id: "595",
    brand: "evercook",
    sku: "EAFP28RD",
    product_eng: "evercookα  Fry Pan 28 cm",
    product_jpn: "evercookα  エバークックαフライパン28 cm",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥5,480",
    rrp_with_vat: "¥6,028",
    description_eng:
      "You will want to use evercook all the time. It does not stick easily and cleans off stains smoothly. Recommended for those who love to cook and want to use it tough every day!   Alpha diamond particles are contained in the fluorine coating, and the fluorine coating is strong.  Cleared the 2 million times abrasion resistance test and the 200 hours corrosion resistance test.  Unique anchor structure. Even if the fluorine coating peels off, the anodized aluminum coating, which is resistant to heat, salt, and friction, guards firmly.  2-year warranty (*Warranty covers peeling of the fluoropolymer on the inner surface.)  Size (approx.): W505mm x D295mm x H109mm (H65mm* frying pan only)  Material: [Body] aluminum alloy, stainless steel, fluorine coating [Handle] phenol resin  Weight (approx.): 780ｇ  Compatible with all IH/GAS heat sources",
    description_jpn:
      "ずっと使いたくなるevercook。 こびりつきづらく汚れ落ちもスムーズ。 お料理好きの方、毎日タフに使いたい方にオススメ!   フッ素コーティングの中にαダイヤ粒子が入り、フッ素コーティングが強い。  200万回耐摩耗性試験クリア。200時間耐食性試験クリア。  独自のアンカー構造。もしフッ素が剥がれても熱・塩分・摩擦に強いアルマイトコーティングでしっかりガード。  自信があるから2年保証（※保証は内面ふっ素樹脂のはがれが対象です。）  サイズ（約）：W505mm×D295mm×H109mm（H65mm※フライパンのみ）  素材：[本体]アルミニウム合金、ステンレス鋼、ふっ素コーティング [取っ手]フェノール樹脂  質量（約）：780ｇ  IH/GASオール熱源対応",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/evercook/evercook_EAFP28RD.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/evercook.png",
  },
  {
    id: "596",
    brand: "evercook",
    sku: "EAFP26DRD",
    product_eng: "evercookα  Deep Fry Pan 26 cm",
    product_jpn: "evercookα  エバークックα深型 26 cm",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥5,480",
    rrp_with_vat: "¥6,028",
    description_eng:
      "You will want to use evercook all the time. It does not stick easily and cleans off stains smoothly. Recommended for those who love to cook and want to use it tough every day!   Alpha diamond particles are contained in the fluorine coating, and the fluorine coating is strong.  Cleared the 2 million times abrasion resistance test and the 200 hours corrosion resistance test.  Unique anchor structure. Even if the fluorine coating peels off, the anodized aluminum coating, which is resistant to heat, salt, and friction, guards firmly.  2-year warranty (*Warranty covers peeling of the fluoropolymer on the inner surface.)  Size (approx.): W485mm x D275mm x H135mm (H75mm* frying pan only)  Material: [Body] aluminum alloy, stainless steel, fluorine coating [Handle] phenol resin  Weight (approx.): 720ｇ  Compatible with all IH/GAS heat sources    サイズ（約）：W485mm×D275mm×H135mm（H75mm※フライパンのみ）  質量（約）：720ｇ",
    description_jpn:
      "ずっと使いたくなるevercook。 こびりつきづらく汚れ落ちもスムーズ。 お料理好きの方、毎日タフに使いたい方にオススメ!   フッ素コーティングの中にαダイヤ粒子が入り、フッ素コーティングが強い。  200万回耐摩耗性試験クリア。200時間耐食性試験クリア。  独自のアンカー構造。もしフッ素が剥がれても熱・塩分・摩擦に強いアルマイトコーティングでしっかりガード。  自信があるから2年保証（※保証は内面ふっ素樹脂のはがれが対象です。）  サイズ（約）：W485mm×D275mm×H135mm（H75mm※フライパンのみ）  素材：[本体]アルミニウム合金、ステンレス鋼、ふっ素コーティング [取っ手]フェノール樹脂  質量（約）：720ｇ  IH/GASオール熱源対応",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/evercook/evercook_EAFP26DRD.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/evercook.png",
  },
  {
    id: "597",
    brand: "evercook",
    sku: "EAFP28DRD",
    product_eng: "evercookα  Deep Fry Pan 28 cm",
    product_jpn: "evercookα  エバークックα深型 28 cm",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥5,980",
    rrp_with_vat: "¥6,578",
    description_eng:
      "You will want to use evercook all the time. It does not stick easily and cleans off stains smoothly. Recommended for those who love to cook and want to use it tough every day!   Alpha diamond particles are contained in the fluorine coating, and the fluorine coating is strong.  Cleared the 2 million times abrasion resistance test and the 200 hours corrosion resistance test.  Unique anchor structure. Even if the fluorine coating peels off, the anodized aluminum coating, which is resistant to heat, salt, and friction, guards firmly.  2-year warranty (*Warranty covers peeling of the fluoropolymer on the inner surface.)  Size (approx.): W497mm x D290mm x H160mm (H80mm* frying pan only)  Material: [Body] aluminum alloy, stainless steel, fluorine coating [Handle] phenol resin  Weight (approx.): 793ｇ  Compatible with all IH/GAS heat sources",
    description_jpn:
      "ずっと使いたくなるevercook。 こびりつきづらく汚れ落ちもスムーズ。 お料理好きの方、毎日タフに使いたい方にオススメ!   フッ素コーティングの中にαダイヤ粒子が入り、フッ素コーティングが強い。  200万回耐摩耗性試験クリア。200時間耐食性試験クリア。  独自のアンカー構造。もしフッ素が剥がれても熱・塩分・摩擦に強いアルマイトコーティングでしっかりガード。  自信があるから2年保証（※保証は内面ふっ素樹脂のはがれが対象です。）  サイズ（約）：W497mm×D290mm×H160mm（H80mm※フライパンのみ）  素材：[本体]アルミニウム合金、ステンレス鋼、ふっ素コーティング [取っ手]フェノール樹脂  質量（約）：793ｇ  IH/GASオール熱源対応",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/evercook/evercook_EAFP28DRD.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/evercook.png",
  },
  {
    id: "598",
    brand: "evercook",
    sku: "EIST8RD",
    product_eng: "evercook 8-piece pot and pan set",
    product_jpn: "evercook  エバークック ポット＆フライパン 8点セット",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥17,800",
    rrp_with_vat: "¥19,580",
    description_eng:
      "The evercook you will want to use all the time. The concept of evercook is The joy of cooking, the joy of eating, and the blissful time that is created. It is a kitchen brand that you will want to use forever.   Pot & pan 8-piece set (1) 18 pot (2) 13 x 19 egg (3) 22cm frying pan (4) 26cm frying pan (5) 18cm glass lid with silicone ring (6) 18cm seal lid (7) 20-26cm dual-use cover (8) New removable handle MINI  Stackable for neat storage  Oven-safe at 220℃ or lower.  1-year warranty (*Warranty covers peeling of the fluoroplastic on the inner surface.)  Compatible with all heat sources (IH/GAS)",
    description_jpn:
      "ずっと使いたくなるevercook。 evercook（エバークック）のコンセプトは『作る楽しさ、食べる喜び、そこに生まれる至福の時間。』 ずっと使いたくなるキッチンブランドです。   ポット＆フライパン8点セット ①18ポット ②13×19玉子 ③22cmフライパン ④26cmフライパン ⑤シリコーンリングつきガラスふた18cm ⑥18cmシールリッド ⑦20∼26㎝兼用カバー ⑧新着脱ハンドルMINI  スタッキングが可能ですっきり収納  設定220℃以下でオーブン使用可能  1年保証（※保証は内面ふっ素樹脂のはがれが対象です。）  IH/GASオール熱源対応",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/evercook/evercook_EIST8RD.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/evercook.png",
  },
  {
    id: "599",
    brand: "sutto",
    sku: "SIEFP4SBK",
    product_eng: "sutto 4-piece frying pan set",
    product_jpn: "sutto スット 選べるフライパン４点セット",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥4,480",
    rrp_with_vat: "¥4,928",
    description_eng:
      "Square frying pan/pot available from Sutto.IH/GAS compatible.  ●The detachable handle on the corner of the frying pan makes it easy to pour soup. ●The square shape can be used for temporary storage in the refrigerator. ●The square shape is very convenient for temporary storage in the refrigerator. ●The pan has a larger baking area than round pans, allowing you to cook a large number of dishes at once. ●Materials  Body: Aluminum alloy Laminated bottom: Stainless steel (16% chrome), bottom thickness 2.5 mm (including laminated bottom)  Surface finish: Fluoroplastic coating on the inside, baked coating on the outside ●4-piece frying pan set -Deep frying pan S size (14cm deep) -Frying pan L size (18 cm) -Detachable handle -Plastic lid S size (14cm)",
    description_jpn:
      "スッとたつ スッととるsuttoから選べる四角いフライパン・ポット。IH/GAS対応  ●フライパンの角に着脱ハンドルを付けることで、スープが注ぎやすい。 ●自立収納やスタッキング収納などそれぞれのキッチンに合わせて収納可能。 ●スクエア型を活かした冷蔵庫の一時保存がとっても便利。 ●丸型に比べ焼き面積が広いので、一度にたくさんの調理が可能。 ●素材  本体：アルミニウム合金製 貼り底：ステンレス鋼（クロム16％）・底厚2.5mm(貼り底含む)  表面加工： 内面 ふっ素樹脂塗膜加工 外面 焼付塗装 ●選べるフライパン4点セット ・深型フライパンSサイズ（14㎝深型） ・フライパンLサイズ（18㎝） ・着脱ハンドル ・プラスチックふたSサイズ（14㎝）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/sutto/sutto_SIEFP4SBK.jpg.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/sutto/sutto_SIEFP4SBK_1.jpg.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/sutto/sutto_SIEFP4SBK_2.jpg.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/sutto.png",
  },
  {
    id: "600",
    brand: "sutto",
    sku: "SIEFP8SBK",
    product_eng: "sutto 8-piece frying pan set",
    product_jpn: "sutto スット 選べるフライパン８点セット",
    category_1: "Home & Garden",
    category_2: "Kitchen",
    rrp_ex_vat: "¥9,980",
    rrp_with_vat: "¥10,978",
    description_eng:
      "Square frying pan/pot available from Sutto.IH/GAS compatible.  ●The detachable handle on the corner of the frying pan makes it easy to pour soup. ●The square shape can be used for temporary storage in the refrigerator. ●The square shape is very convenient for temporary storage in the refrigerator. ●The pan has a larger baking area than round pans, allowing you to cook a large number of dishes at once. ●Materials  Body: Aluminum alloy Laminated bottom: Stainless steel (16% chrome), bottom thickness 2.5 mm (including laminated bottom)  Surface finish: Fluoroplastic coating on the inside, baked coating on the outside ●8-piece set of frying pans -Deep frying pan S size (14cm deep) -Deep frying pan L size (18cm deep) -Frying pan M size (16cm) -Frying pan LL size (20 cm) -Frying pan M size (16 cm)  -Frying pan LL size (20 cm) -Detachable handle -Plastic lid S size (14cm) -Plastic lid L size (18cm)",
    description_jpn:
      "スッとたつ スッととるsuttoから選べる四角いフライパン・ポット。IH/GAS対応  ●フライパンの角に着脱ハンドルを付けることで、スープが注ぎやすい。 ●自立収納やスタッキング収納などそれぞれのキッチンに合わせて収納可能。 ●スクエア型を活かした冷蔵庫の一時保存がとっても便利。 ●丸型に比べ焼き面積が広いので、一度にたくさんの調理が可能。 ●素材  本体：アルミニウム合金製 貼り底：ステンレス鋼（クロム16％）・底厚2.5mm(貼り底含む)  表面加工： 内面 ふっ素樹脂塗膜加工 外面 焼付塗装 ●選べるフライパン8点セット ・深型フライパンSサイズ（14㎝深型） ・深型フライパンLサイズ（18㎝深型） ・フライパンMサイズ（16㎝） ・フライパンLLサイズ（20㎝） ・M～LLサイズアルミ兼用カバー 16～20㎝ ・着脱ハンドル ・プラスチックふたSサイズ 14㎝ ・プラスチックふたLサイズ 18㎝",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/sutto/sutto_SIEFP8SBK.jpg.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/sutto/sutto_SIEFP8SBK_1.jpg.jpg",
    product_image_3:
      "https://s3.amazonaws.com/products.naganorewards.com/images/doshisha/sutto/sutto_SIEFP8SBK_2.jpg.jpg",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/sutto.png",
  },
  {
    id: "601",
    brand: "EMEET",
    sku: "Office Core M0 PLUS",
    product_eng: "EMEET WEB Conference Speakerphones Office Core M0 PLUS",
    product_jpn: "EMEET WEB会議用スピーカーフォン Office Core M0 PLUS",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥6,908",
    rrp_with_vat: "¥7,599",
    description_eng:
      "Ideal speakerphone for telework and small meetings Conversation-oriented call quality enables good voice reproduction and comfortable remote conferencing.   Product Description ・Four omni-directional microphones ・USB connection/wireless connection (BT5.0) ・Built-in VoiceIA's proprietary technology ・Built-in battery. Built-in battery. Up to 10 hours of use. ・Two units can be connected together. ・No screwdriver required. No screwdriver required. Just plug it in and it is ready to use. ・Noise canceling function   Specifications Size: approx. 116 mm * 116 mm * 40 mm (main unit) Weight: 255g",
    description_jpn:
      "テレワーク、少人数の会議に最適なスピーカーフォン 会話に特化した通話品質のため、声をよくひろい、快適なリモート会議を実現します。   商品説明 ・4つ全方向マイク搭載 ・USB接続/ワイヤレス接続（BT5.0） ・VoiceIA自社独自技術搭載 ・バッテリー内蔵。最長10時間使用 ・2台の連結使用可能 ・ドライバー不要。接続すればすぐに使える ・ノイズキャンセリング機能   仕様 サイズ:約116㎜＊116㎜＊40㎜（本体） 重量：約255g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/emeet/EMEET_Office+Core+M0+PLUS.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/emeet.png",
  },
  {
    id: "603",
    brand: "NECESPOW",
    sku: "NECESPOW N800",
    product_eng: "NECESPOW Portable Power Station N800",
    product_jpn: "NECESPOWポータブル電源N800",
    category_1: "Electronics",
    category_2: "Battery Station",
    rrp_ex_vat: "¥63,635",
    rrp_with_vat: "¥69,999",
    description_eng:
      "This portable power supply has a large capacity of 806 WH/25200 mAh, making it safe for the whole family to use outdoors or in an emergency. There are three AC outlets for small appliances, two QC3.0 ports for fast charging, two PD fast charging ports for laptops and tablets, two DC output ports, and one cigarette lighter socket. Up to 4 devices can be charged at the same time, and the output power of each port does not drop even when simultaneously charging & powering multiple devices. Use in case of disasters, earthquakes, home emergency situations, etc.  Lithium iron phosphate batteries are safer and last longer than regular lithium-ion power supplies This battery is ➀Highly safe, no risk of abnormal overheating or ignition. ➁High charge/discharge efficiency, fast charge/high current discharge possible. ➂No memory effect, no self-discharge.   Lifespan of more than 10 years (2000 charge/discharge cycles)  Equipped with LED light, can be used as a lantern. Brightness adjustable.  Bi-directional charging & 5 charging methods  Charges at twice the speed by using both AC outlet and PD charging.  Five charging methods: cigarette socket, solar panel (sold separately), AC adapter, PD65W charging, AC + PD charging  12-month warranty and temperature monitoring function  The temperature inside the battery is displayed on the LCD screen during charging and discharging.  Size: 29 x 19.5 x 30 cm  Weight: approx. 10.5Kg  Battery capacity: 100.800Ah Battery power: 322Wh  Output   AC output: 3 units     USB output: 4 (USB 3.0 x 2, USB-PD x 2)  USB PD max 100W + USB PD 18W  Example of charging capacity: iPhone13 - approx. 55 charges / Notebook PC - approx. 14 charges / Electric fan - approx. 23 hours / Electric blanket - approx. 12 hours  Included in the box  User's manual  Car charger outlet  Cigar adapter  AC adapter",
    description_jpn:
      "このポータブル電源は806WH/25200mAhの大容量で、アウトドアや非常時に家族全員で使える安心。小型家電用のACコンセントは3つ、急速充電のQC3.0ポートは2つ、ノートパソコンやタブレット用のPD急速充電ポートは２つ、DC出力ポートは２つ、シガーソケットは１つです。最大4台デバイス同時に充電可能で、複数デバイスに同時充電＆給電しても各ポートの出力が落ちず、同時使用しても安心してご利用いただけます。災害時、地震、家庭の緊急状況などの場合で使用します。  リン酸鉄リチウム電池は、通常のリチウムイオン電源より安全で長寿命 この電池は➀安全性が高い、異常過熱や発火の心配なし。②充電/放電効率が良い、高速充電/大電流放電可能。③メモリー効果なし、自己放電しない。   10年以上の寿命(2000回の充放電サイクル)  LEDライト搭載でランタンとして使用可能。明るさ調整可能  双方向充電＆５つの充電方式  ・ACコンセントとPD充電を併用で２倍のスピードで充電  ・５つの充電方式:シガーソケット、ソーラーパネル（別売）、ACアダプター、PD65W充電、AC＋PD充電  12か月安心保証＆温度監視機能  ・充放電中、バッテリー内の温度を液晶画面に表示します。  サイズ：29×19.5×30cm  重量：約10.5Kg  バッテリー容量：100.800Ah   バッテリー電力:322Wh  出力   ・AC出力：3口     ・USB出力：4口(USB3.0×2、USB-PD×2)  ・USB PD最大100W+USB PD 18W  充電可能例 iPhone13-約55回充電/ノートPC-約14回/扇風機-約23時間/電気毛布-約12時間  同梱物  ・取扱説明書  ・車載充電器コンセント  ・シガーアダプター  ・ACアダプター",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/necespow/NECESPOW_NECESPOW N800.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/necespow.png",
  },
  {
    id: "605",
    brand: "NECESPOW",
    sku: "LL-YT120W",
    product_eng: "NECESPOW 120W Solar Panel",
    product_jpn: "NECESPOW 120Wソーラーパネル",
    category_1: "Electronics",
    category_2: "Battery Station",
    rrp_ex_vat: "¥26,363",
    rrp_with_vat: "¥28,999",
    description_eng:
      "The 21% higher replacement rate solar panel can charge the NECESPOW portable power supply even when there is no power supply outdoors or during emergencies or disasters. *Power cannot be supplied from the panel alone; it must be used together with the NECESPOW Portable Power Supply.   Use of DTFF material Material with excellent low abrasion, heat resistance, weather resistance, and insulation properties. Highly dustproof and waterproof, less susceptible to ultraviolet rays and other harmful elements, and can be used for a long period of time.  Size Stored size: 505 x 423 x 25 mm Expanded size: 1548 x 505 x 4 mm Weight: Approx. 6.5 kg  Included in the box MC4 to Anderson conversion cable Storage bag  Japanese user's manual",
    description_jpn:
      "電源がない屋外や非常時、災害時にも、21%高い交換率のソーラーパネルはNECESPOWポータブル電源へ充電することが可能です。 ※パネル単体からの電力供給はできません。NECESPOWポータブル電源と一緒にお使いください。   DTFF素材使用 低摩耗性、耐熱性、対候性、絶縁性に優れた素材。防塵と防水性が高く、紫外線などの影響を受けることが少なく、長期間にわたって利用可能。  サイズ ・収納サイズ：505 x 423 x 25 mm ・展開サイズ：1548 x 505 x 4 mm ・重量：約 6.5Kg  同梱物 ・MC4 to Anderson変換ケーブル ・収納バッグ  ・日本語取扱説明書",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/necespow/NECESPOW_LL-YT120W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/necespow.png",
  },
  {
    id: "608",
    brand: "iRobot",
    sku: "m613360",
    product_eng: "irobot Robot Mop Braava jet® m6 Graphite",
    product_jpn: "床拭きロボット ブラーバ ジェット m6 (グラファイト)",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥63,455",
    rrp_with_vat: "¥69,801",
    description_eng:
      "Wipes clean a variety of stains with a jet spray. This high-spec model learns and remembers room conditions.  Jet spray lifts up dirt and sticky residue and wipes clean. The water volume can be adjusted.  When the remaining charge is low, it recharges automatically.   Rooms to be cleaned, cleaning mode, and time can be specified.  Rooms can also be set for specific rooms, pinpoint cleaning, or areas that are off-limits (off-limits areas).  Child/pet lock function. The child/pet lock function can be set to disable button operation of the main unit, allowing operation only from the app or voice assistant.  Bundled products Main unit of Braava/Home base/Drip tray/Battery (built-in)/Wet pad x 2/Dry pad x 1/Washable wet pad/Washable dry pad x 1 each/Floor cleaner (2 times)/Power cord Rechargeable lithium-ion battery (charging time: approx. 3 hours) Power source AC100V 50/60Hz Dimensions (max. W x H) 25.2 cm x 27.0 cm x 9.0 cm Main unit weight (including battery) Approx. 2.2 kg",
    description_jpn:
      "さまざまな汚れをジェットスプレーでスッキリ拭き掃除。 部屋の状況を学習して記憶する、拭き掃除のハイスペックモデル。  ジェットスプレーが汚れやベタつきを浮き上がらせて、キレイに拭き取ります。水量の調整も可能です。  充電残量が少なくなると、自動で充電。残りの清掃範囲に必要な分だけ充電し再開。充電切れの心配不要。  清掃したい部屋や清掃モード、時間を指定可能  特定の部屋やピンポイントのお掃除、入ってほしくない場所（進入禁止エリア）の設定も可能  チャイルド/ペットロック機能を搭載。本体のボタン操作を無効にして、アプリや音声アシスタントからのみ操作するように設定できます  同梱商品 ブラーバ本体/ホームベース/ドリップトレイ/バッテリー（内蔵）/ウェットパッド×2/ドライパッド×1/洗濯可能ウェットパッド/洗濯可能ドライパッド×各1/床用洗剤（2回分）/電源コード  電源方式・充電時間 \t充電式リチウムイオン電池（充電時間:約3時間）  電源 \tAC100V 50/60Hz  本体寸法（最大幅×高さ） \t25.2cm×27.0cm×9.0cm  本体重量（バッテリー含む） \t約2.2kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/irobot/irobot_m613360.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/irobot.png",
  },
  {
    id: "609",
    brand: "iRobot",
    sku: "m613860",
    product_eng: "irobot Robot Mop Braava jet® m6 White",
    product_jpn: "床拭きロボット ブラーバ ジェット m6 (ホワイト)",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥63,455",
    rrp_with_vat: "¥69,801",
    description_eng:
      "Wipes clean a variety of stains with a jet spray. This high-spec model learns and remembers room conditions.  Jet spray lifts up dirt and sticky residue and wipes clean. The water volume can be adjusted.  When the remaining charge is low, it recharges automatically.   Rooms to be cleaned, cleaning mode, and time can be specified.  Rooms can also be set for specific rooms, pinpoint cleaning, or areas that are off-limits (off-limits areas).  Child/pet lock function. The child/pet lock function can be set to disable button operation of the main unit, allowing operation only from the app or voice assistant.  Bundled products Main unit of Braava/Home base/Drip tray/Battery (built-in)/Wet pad x 2/Dry pad x 1/Washable wet pad/Washable dry pad x 1 each/Floor cleaner (2 times)/Power cord Rechargeable lithium-ion battery (charging time: approx. 3 hours) Power source AC100V 50/60Hz Dimensions (max. W x H) 25.2 cm x 27.0 cm x 9.0 cm Main unit weight (including battery) Approx. 2.2 kg",
    description_jpn:
      "さまざまな汚れをジェットスプレーでスッキリ拭き掃除。 部屋の状況を学習して記憶する、拭き掃除のハイスペックモデル。  ジェットスプレーが汚れやベタつきを浮き上がらせて、キレイに拭き取ります。水量の調整も可能です。  充電残量が少なくなると、自動で充電。残りの清掃範囲に必要な分だけ充電し再開。充電切れの心配不要。  清掃したい部屋や清掃モード、時間を指定可能  特定の部屋やピンポイントのお掃除、入ってほしくない場所（進入禁止エリア）の設定も可能  チャイルド/ペットロック機能を搭載。本体のボタン操作を無効にして、アプリや音声アシスタントからのみ操作するように設定できます  同梱商品 ブラーバ本体/ホームベース/ドリップトレイ/バッテリー（内蔵）/ウェットパッド×2/ドライパッド×1/洗濯可能ウェットパッド/洗濯可能ドライパッド×各1/床用洗剤（2回分）/電源コード  電源方式・充電時間 \t充電式リチウムイオン電池（充電時間:約3時間）  電源 \tAC100V 50/60Hz  本体寸法（最大幅×高さ） \t25.2cm×27.0cm×9.0cm  本体重量（バッテリー含む） \t約2.2kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/irobot/irobot_m613860.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/irobot.png",
  },
  {
    id: "1080",
    brand: "iRobot",
    sku: "Y011260",
    product_eng: "irobot Roomba Combo® Essential robot White",
    product_jpn:
      "irobot 掃除機＆床拭きロボット ルンバ コンボ Essential robot ホワイト",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥35,727",
    rrp_with_vat: "¥39,300",
    description_eng:
      "Selected Features and Affordable Price  A stylish entry model that can also mop with the touch of a button.  Easy Operation & Selected Features for More Convenient Cleaning  Easily switch to mopping mode by attaching the pad plate.  Clean the Entire Room with the Touch of a Button  Cleans efficiently with no wasted movement.  Three Levels of Suction Power and Water Amount Selectable with the iRobot Home App  Clean according to the floor condition.  Capable of Wide-Area Cleaning  Operates for about 120 minutes on a single charge. *Varies based on room shape, floor condition, and battery status.  Automatically Recharges When Cleaning is Complete or Battery Runs Low  Prepares for the next cleaning session.  Specifications:  Included Accessories: Roomba unit & built-in battery, charging station, power adapter, pad plate & mop pad Supported Rooms: 3 to 4 rooms Switching Between Vacuuming/Mopping: Attach/detach the pad plate Suction Power: Standard (3 levels) Main Brush: Single V-shaped action brush with bristles and rubber Edge and Corner Cleaning: Yes Automatic Charging & Resumption: Automatic charging only Product Dimensions: Unit: Width 33 x Height 8 (cm) Product Weight: Robot unit: Approx. 2.8kg (including battery) Charging Time: Approx. 4 hours Wireless Communication: Wi-Fi 2.4GHz band Manufacturer Warranty: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "●厳選された機能とお手頃価格。 ボタンひとつで拭き掃除までできる、スタイリッシュなエントリーモデル。 ●かんたん操作＆厳選された機能でお掃除がもっと手軽に。 パッドプレートを取り付けるだけで水拭き対応にかんたん切り替え ●ボタンひとつで部屋全体をキレイに。 無駄のない動きで掃除。 ●iRobot Homeアプリを使用で選べる3段階の吸引力と水分量。 床の状態に合わせて掃除できる。 ●広範囲のお掃除が可能 1回の充電で約120分間稼働 ※部屋の形状や床の状態、バッテリーの状態によって異なります。 ●掃除完了または充電がなくなると自動で再充電。 次の掃除に備える。  【仕様】 付属品：ルンバ本体＆バッテリー（内蔵）、充電ステーション、電源アダプター、パッドプレート＆モップパッド 対応できる部屋数：3～4部屋 掃除機がけ/水拭きの切り替え：パットプレート付け外し 吸引力：スタンダード（3段階） メインブラシ：毛とゴム製のV字型シングルアクションブラシ 壁際、隅の掃除：〇 自動充電＆自動再開：自動充電のみ 製品寸法：本体：幅33×高さ8（cm） 本体重量：ロボット本体：約2.8kg（バッテリー含む） 充電時間：充電時間：約4時間 無線通信：Wi-Fi 2.4GHz帯 メーカー保証 1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/irobot/Y011260.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/irobot.png",
  },
  {
    id: "1081",
    brand: "iRobot",
    sku: "Y011060",
    product_eng: "irobot Roomba Combo® Essential robot Black",
    product_jpn:
      "irobot 掃除機＆床拭きロボット ルンバ コンボ Essential robot ブラック",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥35,727",
    rrp_with_vat: "¥39,300",
    description_eng:
      "Selected Features and Affordable Price  A stylish entry model that can also mop with the touch of a button.  Easy Operation & Selected Features for More Convenient Cleaning  Easily switch to mopping mode by attaching the pad plate.  Clean the Entire Room with the Touch of a Button  Cleans efficiently with no wasted movement.  Three Levels of Suction Power and Water Amount Selectable with the iRobot Home App  Clean according to the floor condition.  Capable of Wide-Area Cleaning  Operates for about 120 minutes on a single charge. *Varies based on room shape, floor condition, and battery status.  Automatically Recharges When Cleaning is Complete or Battery Runs Low  Prepares for the next cleaning session.  Specifications:  Included Accessories: Roomba unit & built-in battery, charging station, power adapter, pad plate & mop pad Supported Rooms: 3 to 4 rooms Switching Between Vacuuming/Mopping: Attach/detach the pad plate Suction Power: Standard (3 levels) Main Brush: Single V-shaped action brush with bristles and rubber Edge and Corner Cleaning: Yes Automatic Charging & Resumption: Automatic charging only Product Dimensions: Unit: Width 33 x Height 8 (cm) Product Weight: Robot unit: Approx. 2.8kg (including battery) Charging Time: Approx. 4 hours Wireless Communication: Wi-Fi 2.4GHz band Manufacturer Warranty: 1 year  *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "●厳選された機能とお手頃価格。 ボタンひとつで拭き掃除までできる、スタイリッシュなエントリーモデル。 ●かんたん操作＆厳選された機能でお掃除がもっと手軽に。 パッドプレートを取り付けるだけで水拭き対応にかんたん切り替え ●ボタンひとつで部屋全体をキレイに。 無駄のない動きで掃除。 ●iRobot Homeアプリを使用で選べる3段階の吸引力と水分量。 床の状態に合わせて掃除できる。 ●広範囲のお掃除が可能 1回の充電で約120分間稼働 ※部屋の形状や床の状態、バッテリーの状態によって異なります。 ●掃除完了または充電がなくなると自動で再充電。 次の掃除に備える。  【仕様】 付属品：ルンバ本体＆バッテリー（内蔵）、充電ステーション、電源アダプター、パッドプレート＆モップパッド 対応できる部屋数：3～4部屋 掃除機がけ/水拭きの切り替え：パットプレート付け外し 吸引力：スタンダード（3段階） メインブラシ：毛とゴム製のV字型シングルアクションブラシ 壁際、隅の掃除：〇 自動充電＆自動再開：自動充電のみ 製品寸法：本体：幅33×高さ8（cm） 本体重量：ロボット本体：約2.8kg（バッテリー含む） 充電時間：充電時間：約4時間 無線通信：Wi-Fi 2.4GHz帯 メーカー保証 1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/irobot/Y011060.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/irobot.png",
  },
  {
    id: "1082",
    brand: "iRobot",
    sku: "i557860",
    product_eng: "irobot Roomba Combo® i5+",
    product_jpn: "irobot 掃除機＆床拭きロボット ルンバ コンボ i5+",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥71,818",
    rrp_with_vat: "¥79,000",
    description_eng:
      "Simultaneously Vacuum and Mop by Simply Switching the Dust Container  Choose the cleaning method freely according to the dirt on the floor. It vacuums while mopping, thoroughly removing dirt, footprints, and dust. Specify the room to be cleaned, and it will automatically clean and empty the dust, making it a standard model.  iRobot's 4-Stage Cleaning System  The edge-cleaning brush, dual rubber brushes, powerful suction, and mopping pad work together. On hard floors, it vacuums and mops in one go.  High-Performance Mop Pad for Smooth Mopping  The special microfiber pad maximizes surface area with looped fibers twisted into double spirals. The mop pad is washable in the washing machine and can be reused.  Automatic Dust Disposal for Up to 1 Year  Collects up to a year's worth of dust, so you don’t need to worry about replacing dust bags or seeing dust. Calculated from the cleaning results of Clean Base users in Japan. Only when the dust container for vacuuming is attached.  Completes Cleaning Without Running Out of Charge  Automatically returns to the Clean Base to charge. Then resumes cleaning from where it left off. Charges efficiently by estimating the remaining cleaning area.  Specifications:  Included Accessories: Roomba unit & built-in battery, Clean Base, dust container for vacuuming & mopping, power cord for Clean Base, 1 replacement dust bag, 1 replacement filter, 1 microfiber mop pad Supported Rooms: 3 to 4 rooms Switching Between Vacuuming/Mopping: Dust container exchange Suction Power: Standard (1 level) Main Brushes: Dual rubber brushes Edge and Corner Cleaning: Yes Automatic Charging & Resumption: Smart charging & resumption Product Dimensions: Unit: Width 34.2 x Height 9.2 (cm) / Clean Base: Depth 40 x Width 32 x Height 34 (cm) Product Weight: Robot unit: Approx. 3.2kg (including battery) / Clean Base: Approx. 4.4kg Charging Time: Approx. 3 hours Wireless Communication: Wi-Fi 2.4GHz band Manufacturer Warranty: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "ダスト容器を付け替えるだけで掃除機がけと拭き掃除を同時に実行 床の汚れに合わせて、掃除方法を自由に選べます。ゴミを吸収しながら水拭きを行い、ゴミ、足跡、ホコリを一掃。 掃除する部屋を指定できゴミ捨てまで全自動のスタンダードモデル。  ●アイロボットの4段階クリーニングシステム エッジクリーニングブラシ、2本のゴム製のデュアルアクションブラシ、パワフルな吸引力、モップパッドによる水拭き掃除が連動。フローリングでは、ゴミの吸引と拭き掃除を一度に行えます。 ●高性能モップパッドでスムーズな水拭きを実現 マイクロファイバー製の特殊なパッドは、ループ状の繊維をさらに二重らせん状にねじることで表面積を最大化。モップパッドは洗濯機で洗うことができ、繰り返し使えます。 ●最大1年間※1ゴミ捨てまで全自動※2 最大1年分のゴミを収集できるので、紙パックの交換を気にかける必要もなくホコリを目にすることも、手を汚すこともありません。※1：日本のクリーンベースユーザーの掃除結果より算出。※2：掃除機専用ダスト容器を装着時のみ。 ●充電切れずに最後までやり遂げる。 自動でクリーンベースに戻り充電。その後、中断したところから清掃を再開。充電時に残りの清掃範囲を想定して必要な分だけ効率的に充電します。  【仕様】 付属品：ルンバ本体＆バッテリー（内蔵）、クリーンベース、掃除機＆床拭き対応ダスト容器、クリーンベース用 電源コード、交換用紙パック×1、交換用フィルター×1、マイクロファイバーモップパッド×1 対応できる部屋数：3～4部屋 掃除機がけ/水拭きの切り替え：ダスト容器交換 吸引力：スタンダード（1段階） メインブラシ：2本のゴム製デュアルアクションブラシ 壁際、隅の掃除：〇 自動充電＆自動再開：スマート充電＆再開 製品寸法：本体：幅34.2×高さ9.2（cm）/クリーンベース：奥行40×幅32×高さ34（cm） 本体重量：ロボット本体：約3.2kg（バッテリー含む）/クリーンベース：約4.4kg 充電時間：充電時間：約3時間 無線通信：Wi-Fi 2.4GHz帯 メーカー保証 1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/irobot/i557860.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/irobot.png",
  },
  {
    id: "1083",
    brand: "iRobot",
    sku: "j557860",
    product_eng: "irobot Roomba Combo® j5+",
    product_jpn: "irobot 掃除機＆床拭きロボット ルンバ コンボ j5+",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥98,818",
    rrp_with_vat: "¥108,700",
    description_eng:
      "Premium Model That Cleans and Empties Automatically, Recognizing and Avoiding Obstacles in Cluttered Rooms  Avoid Mopping Restricted Areas to Keep Rugs Dry  By setting up mop-restricted areas in the iRobot Home app, it avoids rugs and carpets during mopping, ensuring they stay dry and safe.  Switch Dust Containers to Simultaneously Vacuum and Mop  Choose the cleaning method according to the floor's condition. It vacuums and mops simultaneously, removing dirt, footprints, and dust.  iRobot's 4-Stage Cleaning System  The edge-cleaning brush, dual rubber brushes, powerful suction, and mopping pad work together. On hard floors, it vacuums and mops in one go.  High-Performance Mop Pad for Smooth Mopping  The special microfiber pad maximizes surface area with looped fibers twisted into double spirals. The mop pad is washable in the washing machine and can be reused.  Automatic Emptying for Up to 1 Year  Collects up to a year's worth of dust, so you don’t need to worry about replacing dust bags or seeing dust. Calculated from the cleaning results of Clean Base users in Japan. Only when the dust container for vacuuming is attached.  Specifications:  Included Accessories: Roomba unit & built-in battery, Clean Base, dust container for vacuuming & mopping, power cord for Clean Base, 1 replacement dust bag, 1 replacement filter, 1 replacement edge cleaning brush, 1 microfiber mop pad Supported Rooms: 5 rooms or more Switching Between Vacuuming/Mopping: Dust container exchange Suction Power: Standard (1 level) Main Brushes: Dual rubber brushes Edge and Corner Cleaning: Yes Automatic Charging & Resumption: Smart charging & resumption Product Dimensions: Unit: Width 33.9 x Height 8.7 (cm) / Clean Base: Depth 40 x Width 31 x Height 34 (cm) Product Weight: Robot unit: Approx. 3.4kg (including battery) / Clean Base: Approx. 4.0kg Charging Time: Approx. 3 hours Wireless Communication: Wi-Fi 2.4GHz band / 5GHz Manufacturer Warranty: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "●散らかったままの部屋も障害物を認識して回避しながら確実に掃除する、ゴミ捨てまで全自動のプレミアムモデル。  ●ラグを濡らさないように拭き掃除禁止エリアの設定ができる。 iRbot Homeアプリで拭き掃除禁止エリアを設定すれば、ラグやカーペットを避けて拭き掃除するので濡れることなく安心。  ●ダスト容器を付け替えるだけで掃除機がけと拭き掃除を同時に実行 床の汚れに合わせて、掃除方法を自由に選べます。ゴミを吸収しながら水拭きを行い、ゴミ、足跡、ホコリを一掃。  ●アイロボットの4段階クリーニングシステム エッジクリーニングブラシ、2本のゴム製のデュアルアクションブラシ、パワフルな吸引力、モップパッドによる水拭き掃除が連動。フローリングでは、ゴミの吸引と拭き掃除を一度に行えます。  ●高性能モップパッドでスムーズな水拭きを実現 マイクロファイバー製の特殊なパッドは、ループ状の繊維をさらに二重らせん状にねじることで表面積を最大化。モップパッドは洗濯機で洗うことができ、繰り返し使えます。  ●最大1年間※1ゴミ捨てまで全自動※2 最大1年分のゴミを収集できるので、紙パックの交換を気にかける必要もなくホコリを目にすることも、手を汚すこともありません。※1：日本のクリーンベースユーザーの掃除結果より算出。※2：掃除機専用ダスト容器を装着時のみ。  【仕様】 付属品：ルンバ本体＆バッテリー（内蔵）、クリーンベース、掃除機＆床拭き対応ダスト容器、クリーンベース用 電源コード、交換用紙パック×1、交換用フィルター×1、交換用エッジクリーニングブラシ×1、マイクロファイバーモップパッド×1 対応できる部屋数：5部屋以上 掃除機がけ/水拭きの切り替え：ダスト容器交換 吸引力：スタンダード（1段階） メインブラシ：2本のゴム製デュアルアクションブラシ 壁際、隅の掃除：〇 自動充電＆自動再開：スマート充電＆再開 製品寸法：本体：幅33.9×高さ8.7（cm）/クリーンベース：奥行40×幅31×高さ34（cm） 本体重量：ロボット本体：約3.4kg（バッテリー含む）/クリーンベース：約4.0kg 充電時間：充電時間：約3時間 無線通信：Wi-Fi 2.4GHz帯 / 5GHz メーカー保証 1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/irobot/j557860.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/irobot.png",
  },

  {
    id: "610",
    brand: "Dyson",
    sku: "HP07 WS",
    product_eng:
      "Dyson Purifier Hot+Cool™Air purifying fan heater White/Silver",
    product_jpn:
      "Dysonダイソン Purifier Hot+Cool™空気清浄ファンヒーター ホワイト／シルバー",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥85,000",
    rrp_with_vat: "¥93,500",
    description_eng:
      "Three functions in one (air cleaner/heater/fan) Removes up to 99.95% of PM0.1, which is the same size as viruses1 *Effectiveness varies depending on usage conditions and usage.  HEPA filter captures house dust, pollen, and viruses3 Activated carbon filter removes harmful gases and odors.  Powerful circulation. Air purification for the entire room.  Detects and alerts you to minute particles at the 0.3 µm level and to noxious gases and odors.  As an air purifying fan in summer Delivers powerful, smooth, cool air throughout the room.  Diffused mode The direction of the airflow is changed and the airflow is sent out through an opening at the rear of the unit to purify the air without sending cool air during cold weather.  Operating noise reduced by up to 20% Improved design has reduced operating noise by up to 20% compared to the previous model.  No need for periodic cleaning The air purifying filter does not need to be washed or cleaned with water. Simply remove the old filter and install a new one.  Swivel function of up to 350°. The angle-adjustable swivel function delivers purified air to the entire room, no matter where the air conditioner is located. The slim design allows you to place it wherever you want.  Smart air purification with the MyDyson™ app Connect to the MyDyson™ app to monitor and control the air quality in your home from anywhere with your device6.  Size/Mass Height: 1050mm Depth: 220mm Width: 220mm Main unit weight: 4.99 kg",
    description_jpn:
      "1台3役 (空気清浄機/ヒーター/扇風機) ウイルスと同じサイズのPM0.1まで99.95%除去1 *ご使用状況や使い方によって効果は異なります。   HEPAフィルターがハウスダストや花粉、ウイルスを捕らえます3 活性炭フィルターが有害なガスやニオイを除去します。  パワフルな循環力。部屋全体の空気清浄。  最小0.3µmレベルの微細な粒子や、有害ガス・ニオイを検知して、お知らせ  夏は空気清浄ファンとして パワフルでスムーズな涼しい風を部屋中に送り届けます。  ディフューズドモード 風の向きを変えて 本体後方の開口部から 送り出し、寒い時期には 涼しい風を送らずに 空気を浄化します。  運転音を最大20%低減 設計改良により、前モデルと比べ、運転音が最大20％低減しました。  定期的なお手入れ不要 空気清浄フィルターは水洗いや掃除などの面倒なお手入れは必要ありません。古いフィルターを外して新しいフィルターを装着するだけで簡単です。  最大350°の首振り機能 角度を調節できる首振り機能により、どこにおいても浄化された風を部屋全体に送り届けます。スリムで置き場所を選びません。  MyDyson™アプリでスマートに空気清浄 MyDyson™アプリと接続することで、ご自宅の空気の状態をどこからでも、お手持ちのデバイスでモニターし、コントロールできます6。  サイズ/質量 高さ:1050mm 奥行き:220mm 幅:220mm 本体質量：4.99kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_HP07+WS.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "611",
    brand: "Dyson",
    sku: "HP07 SB",
    product_eng: "Dyson Purifier Hot+Cool™Air purifying fan heater Silver/Blue",
    product_jpn:
      "Dysonダイソン Purifier Hot+Cool™空気清浄ファンヒーター シルバー／ブルー",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥85,000",
    rrp_with_vat: "¥93,500",
    description_eng:
      "Three functions in one (air cleaner/heater/fan) Removes up to 99.95% of PM0.1, which is the same size as viruses1 *Effectiveness varies depending on usage conditions and usage.  HEPA filter captures house dust, pollen, and viruses3 Activated carbon filter removes harmful gases and odors.  Powerful circulation. Air purification for the entire room.  Detects and alerts you to minute particles at the 0.3 µm level and to noxious gases and odors.  As an air purifying fan in summer Delivers powerful, smooth, cool air throughout the room.  Diffused mode The direction of the airflow is changed and the airflow is sent out through an opening at the rear of the unit to purify the air without sending cool air during cold weather.  Operating noise reduced by up to 20% Improved design has reduced operating noise by up to 20% compared to the previous model.  No need for periodic cleaning The air purifying filter does not need to be washed or cleaned with water. Simply remove the old filter and install a new one.  Swivel function of up to 350°. The angle-adjustable swivel function delivers purified air to the entire room, no matter where the air conditioner is located. The slim design allows you to place it wherever you want.  Smart air purification with the MyDyson™ app Connect to the MyDyson™ app to monitor and control the air quality in your home from anywhere with your device6.  Size/Mass Height: 1050mm Depth: 220mm Width: 220mm Main unit weight: 4.99 kg",
    description_jpn:
      "1台3役 (空気清浄機/ヒーター/扇風機) ウイルスと同じサイズのPM0.1まで99.95%除去1 *ご使用状況や使い方によって効果は異なります。   HEPAフィルターがハウスダストや花粉、ウイルスを捕らえます3 活性炭フィルターが有害なガスやニオイを除去します。  パワフルな循環力。部屋全体の空気清浄。  最小0.3µmレベルの微細な粒子や、有害ガス・ニオイを検知して、お知らせ  夏は空気清浄ファンとして パワフルでスムーズな涼しい風を部屋中に送り届けます。  ディフューズドモード 風の向きを変えて 本体後方の開口部から 送り出し、寒い時期には 涼しい風を送らずに 空気を浄化します。  運転音を最大20%低減 設計改良により、前モデルと比べ、運転音が最大20％低減しました。  定期的なお手入れ不要 空気清浄フィルターは水洗いや掃除などの面倒なお手入れは必要ありません。古いフィルターを外して新しいフィルターを装着するだけで簡単です。  最大350°の首振り機能 角度を調節できる首振り機能により、どこにおいても浄化された風を部屋全体に送り届けます。スリムで置き場所を選びません。  MyDyson™アプリでスマートに空気清浄 MyDyson™アプリと接続することで、ご自宅の空気の状態をどこからでも、お手持ちのデバイスでモニターし、コントロールできます6。  サイズ/質量 高さ:1050mm 奥行き:220mm 幅:220mm 本体質量：4.99kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_HP07+SB.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "613",
    brand: "Dyson",
    sku: "SV46 SU",
    product_eng: "Dyson V12s Detect Slim Submarine",
    product_jpn: "Dysonダイソン V12s Detect Slim Submarine",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥110,000",
    rrp_with_vat: "¥121,000",
    description_eng:
      "One machine, one cleaning stress. Powerful cleaning, even water wiping from now on.  Submarine Wet Roller Head   The Submarine Wet Roller Head wipes away dirt and grime as it rotates to wipe the floor with water.  Fluffy Optic Cleaner Head   Lifts even the tiniest dust contours from the floor to avoid missing them. *   *Effectiveness depends on the light in the operating environment, the type of dust, and the type of floor.  Hair Entanglement Prevention Screw Tool   Prevents hair and pet hair entanglement. Quickly rolls up and sucks up hair.  Four functions in one machine   In addition to being a stick, futon, and handheld cleaner, this four-in-one unit can also be used for wiping with water.  LCD display Real-time display for efficient cleaning   Displays current suction mode and remaining operating time in seconds for efficient cleaning. Optimal performance   Not only informs you when it is time to maintain the filter to maintain optimal performance, but also informs you of problems such as foreign matter clogging.  Floor Storage Method   The special freestanding charging dock allows for constant charging while storing the unit and tools, eliminating the need to fix the unit to the wall.  Included Products  Submarine Wet Roller Head / Fluffy Optic Cleaner Head / Crevice Nozzle / Combination Nozzle / Tool Clip / Anti Hair Entanglement Screw Tool / Floor Dok Multi-Tool Holder  Size Height: 253mm Depth:1129mm Width:257mm Main unit weight:3.20kg *With Submarine™ wet roller head *Water weight is not included With Fluffy Optic™ cleaner head Main unit weight: 2.20 kg",
    description_jpn:
      "一台で、掃除ストレスを一掃。 パワフルな掃除を、これからは水拭きまで。  Submarineウェットローラーヘッド   ウェットローラーが回転するたびに床を水拭きしながら、汚れをかき取ります。  Fluffy Opticクリーナーヘッド   微細なホコリの輪郭まで床から浮かび上がらせて、見逃しを防ぎます。*   *有効性は、使用環境の光やゴミの種類、床のタイプによって異なります。  毛絡み防止スクリューツール   髪の毛やペットの毛絡みを防止。すばやく毛を巻き取って吸い取ります。  1台4役   スティック・布団・ハンディクリーナーに加え、水拭きも可能な1台4役。  液晶ディスプレイ リアルタイムな表示で、効率的に掃除   現在の吸引モードや秒単位の残り運転時間を表示し、効率的な掃除を可能にします。最適なパフォーマンスを   維持するためにフィルターのメンテナンス時期をお知らせするだけでなく、異物の詰まりなどのトラブルもお知らせします。  床置き収納方法   自立式の専用充電ドックなら、本体やツールを収納しながら常時充電でき、壁に固定する必要がありません。  同梱商品  Submarineウェットローラーヘッド/Fluffy Opticクリーナーヘッド/隙間ノズル/コンビネーションノズル/ツールクリップ/毛絡み防止スクリューツール/Floor Dokマルチツールホルダー  サイズ 高さ:253mm 奥行き:1129mm 幅:257mm 本体質量:3.20kg  *Submarine™ウェットローラーヘッド装着時 *水の質量は含みません Fluffy Optic™クリーナーヘッド装着時 本体質量:2.20 kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_SV46+SU.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "614",
    brand: "Dyson",
    sku: "SV33 FF PL",
    product_eng: "Dyson Micro Plus",
    product_jpn: "Dysonダイソン Micro Plus",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥71,700",
    rrp_with_vat: "¥78,870",
    description_eng:
      "The only lightweight cordless product that delivers the same suction power while trapping 99.99% of microscopic particles   Product design with high collection power Other lightweight cordless cleaners can leak microscopic particles from the exhaust. Dyson captures 99.99% of particles as fine as 0.3 microns to purify the air and clean exhaust air. * * Test results by SGS-IBR (U.S.) and Dyson Corporation based on ASTM F1977-04 (conducted from 2020-2023). Compared to top-of-the-line lightweight cordless stick cleaners from the top six domestic sales companies excluding Dyson (based on data from an independent research firm from May-October 2022). Tests were conducted using particles of 0.3 µm or greater and in high mode. Lightweight cordless cleaners are defined by the company as having a mass of less than 2 kg when used as a stick, based on an awareness survey in which approximately 90% of respondents answered that the mass of the main unit was less than 2 kg, which they consider lightweight (June 2019 Internet survey of employees at electronics retail stores, n=6636). Radial Root Cyclone Technology Dyson's innovative cyclone technology (8 cyclones) creates centrifugal forces of up to 96,000G to remove fine dust particles from the airflow and deliver unchanging suction power. * *Tests of change in suction power conducted by SGS-IBR (U.K.) and in-house (in 2020) at the point of use from new to the first full load of dust in high mode in accordance with IEC (International Electrotechnical Commission) standard 62885-2 5.8, 5.9.   Powerful Dyson Hyperdymium motor The small, lightweight motor rotates at up to 104,000 revolutions per minute, producing powerful suction power.  Three functions in one machine Switch tools to use it as a futon cleaner or a handy cleaner for cleaning the inside of your car. Fluffy Optic cleaner head Raises even the smallest dust contours off the floor to prevent them from being missed. *Effectiveness depends on the light in the operating environment, the type of dust, and the type of floor.  Hair Entanglement Prevention Screw Tool Prevents hair and pet hair entanglement. Quickly rolls up and sucks up hair.  Easy cleaning The clear bin, filter, and brush bar can be easily removed and washed with water. * Please refer to the product instruction manual on the official Dyson website.  Included items Fluffy Optic Cleaner Head / Anti Hair Entanglement Screw Tool / Combination Crevice Nozzle / Tabletop Tool / Dedicated Charging Dock  Size Height: 222mm Depth: 1,091mm Width:250mm Main unit weight:1.54kg",
    description_jpn:
      "軽量コードレスで唯一、微細な粒子を99.99％閉じ込めながら変わらない吸引力を実現   捕集力の高い製品設計 他の軽量コードレスクリーナーでは、排気から漏れていることがある微細な粒子。ダイソンは、0.3ミクロンもの微細な粒子を99.99％捕らえて、空気を浄化し排気をきれいに。* * ASTM F1977-04に基づくSGS-IBR（米国）およびダイソン社による試験結果（2020-2023年に実施）。ダイソンを除く国内の売上上位6社の最上位軽量コードレススティッククリーナー（2022年5月-10月の独立調査会社のデータに基づく）との比較。試験は0.3μm以上の粒子を使用し、強モードで実施。 軽量コードレスクリーナーとは、意識調査により、軽量と感じる本体質量として2kg未満という回答が約90％であったことから、スティック時の質量が2kg未満と自社にて定義したもの（2019年6月 家電量販店社員に対するインターネット調査 n=6636）  Radial Root Cyclone（ラジアルルートサイクロン）テクノロジー ダイソンの革新的なサイクロンテクノロジー（8個のサイクロン）により、最大96,000Gの遠心力を生み出し、微細なホコリを気流から取り除き、変わらない吸引力を実現します。* *IEC（国際電気標準会議）規格62885-2 5.8, 5.9に準拠した、強モードで新品から1回目のゴミ満量まで使用した時点での、SGS-IBR（英国）および自社による吸引力の変化の試験（2020年に実施）。  パワフルなDyson Hyperdymiumモーター 小型で軽量のモーターが毎分最大104,000回転し、パワフルな吸引力を生み出します。  1台3役 ツールを切り替えて、布団クリーナー、車の中の掃除に便利なハンディクリーナーとしても使用できます。  Fluffy Optic（フラフィ オプティック）クリーナーヘッド 微細なホコリの輪郭まで床から浮かび上がらせて、見逃しを防ぎます。 *有効性は、使用環境の光やゴミの種類、床のタイプによって異なります。  毛絡み防止スクリューツール 髪の毛やペットの毛絡みを防止。すばやく毛を巻き取って吸い取ります。  簡単なお手入れ クリアビンやフィルター、ブラシバーは簡単に取り外せて、水洗いが可能です。 * ダイソン公式ウェブサイト上に掲載されている、製品の取扱説明書を参照してください。  同梱商品 Fluffy Opticクリーナーヘッド/毛絡み防止スクリュー 軽量コードレスで唯一、微細な粒子を99.99％閉じ込めながら変わらない吸引力を実現   捕集力の高い製品設計 他の軽量コードレスクリーナーでは、排気から漏れていることがある微細な粒子。ダイソンは、0.3ミクロンもの微細な粒子を99.99％捕らえて、空気を浄化し排気をきれいに。* * ASTM F1977-04に基づくSGS-IBR（米国）およびダイソン社による試験結果（2020-2023年に実施）。ダイソンを除く国内の売上上位6社の最上位軽量コードレススティッククリーナー（2022年5月-10月の独立調査会社のデータに基づく）との比較。試験は0.3μm以上の粒子を使用し、強モードで実施。 軽量コードレスクリーナーとは、意識調査により、軽量と感じる本体質量として2kg未満という回答が約90％であったことから、スティック時の質量が2kg未満と自社にて定義したもの（2019年6月 家電量販店社員に対するインターネット調査 n=6636）  Radial Root Cyclone（ラジアルルートサイクロン）テクノロジー ダイソンの革新的なサイクロンテクノロジー（8個のサイクロン）により、最大96,000Gの遠心力を生み出し、微細なホコリを気流から取り除き、変わらない吸引力を実現します。* *IEC（国際電気標準会議）規格62885-2 5.8, 5.9に準拠した、強モードで新品から1回目のゴミ満量まで使用した時点での、SGS-IBR（英国）および自社による吸引力の変化の試験（2020年に実施）。  パワフルなDyson Hyperdymiumモーター 小型で軽量のモーターが毎分最大104,000回転し、パワフルな吸引力を生み出します。  1台3役 ツールを切り替えて、布団クリーナー、車の中の掃除に便利なハンディクリーナーとしても使用できます。  Fluffy Optic（フラフィ オプティック）クリーナーヘッド 微細なホコリの輪郭まで床から浮かび上がらせて、見逃しを防ぎます。 *有効性は、使用環境の光やゴミの種類、床のタイプによって異なります。  毛絡み防止スクリューツール 髪の毛やペットの毛絡みを防止。すばやく毛を巻き取って吸い取ります。  簡単なお手入れ クリアビンやフィルター、ブラシバーは簡単に取り外せて、水洗いが可能です。 * ダイソン公式ウェブサイト上に掲載されている、製品の取扱説明書を参照してください。  同梱商品 Fluffy Opticクリーナーヘッド/毛絡み防止スクリューツール/コンビネーション隙間ノズル/卓上ツール/専用充電ドック  サイズ 高さ:222mm 奥行き:1,091mm 幅:250mm 本体質量:1.54kgツール/コンビネーション隙間ノズル/卓上ツール/専用充電ドック  サイズ 高さ:222mm 奥行き:1,091mm 幅:250mm 本体質量:1.54kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_SV33_FF_PL.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "615",
    brand: "Dyson",
    sku: "RB03 BN",
    product_eng: "Dyson 360 Vis Nav",
    product_jpn: "Dysonダイソン 360 Vis Nav",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥172,000",
    rrp_with_vat: "¥189,200",
    description_eng:
      "Powerful Robot Vacuum Cleaner Equipped with 360°vision Suction reaches walls and corners without missing anything   Reaches to the edges of walls and corners   When the robot detects the edge of furniture or walls, the edge nozzle automatically activates to suck up dust around the edges.  360° Vision System   Equipped with 26 sensors and a 360° panoramic vision system.   The system learns the indoor environment and automatically sets the most efficient cleaning path. The optimal cleaning method is determined.  Smart operation with the MyDyson App   The MyDyson App allows you to control, customize and schedule your cleaning from anywhere.  Powerful suction on a variety of floor surfaces   Equipped with Dyson's first triple-action brush bar.   The machine's wide brush bar, which combines three types of brushes, provides powerful suction for flooring and carpets.   The brush bar is also designed with a large diameter to prevent hair from getting tangled.  Easy maintenance   The clear bin, filter, and brush bar can be easily removed for cleaning.   They are also hygienic and easy to dispose of.  Quiet mode   Reduces operating noise for quieter operation and longer operating time.  Automatic adjustment of suction power   Piezo sensor measures the amount and size of suctioned dust. The suction power is intelligently adjusted according to the amount of dust.  *The suction power is automatically increased only when it detects an increase in dust concentration as determined by in-house testing while using the auto mode.  HEPA Filter   Captures 99.99% of particles as fine as 0.1 micron and discharges purified air. *  * Test results by SGS-IBR (USA) based on ASTM F3150 (conducted in 2022). Tests were conducted in high mode.   Overcoming bumps and cleaning low areas   Dual-link suspension enables the machine to overcome bumps of up to 21 mm without stopping. The low-profile design also makes it suitable for cleaning under furniture.  Accessories: Charging dock, battery charger  Size Height:97mm Depth:345mm Width:330mm Main unit mass:4.5kg",
    description_jpn:
      "パワフルなロボット掃除機 360°ビジョンを搭載 壁際や隅まで逃さず吸引   壁際や隅まで届いて吸引   家具や壁のきわを検知すると、端のゴミを吸引するエッジノズルが自動的に作動し、すみずみのホコリまで吸い取ります。  360°ビジョンシステム   26個のセンサーと、360°パノラマビジョンシステムを搭載。   室内環境を学習し、効率良く掃除できる経路を自動的に設定。最適な掃除方法を判断します。  MyDysonアプリでスマートに操作   MyDysonアプリで、どこからでも操作や掃除のカスタマイズ、スケジュールの設定が可能です  さまざまな床面で、パワフルに吸い取る   ダイソン初のトリプルアクションブラシバーを搭載。   3種類のブラシの組み合わせた機体幅のブラシバーが、フローリング、カーペットもパワフルに吸引。   また、ブラシバーの直径が大きく、髪の毛が絡まりにくい設計です。  簡単なお手入れ   クリアビンやフィルター、ブラシバーは簡単に取り外せ、お手入れが可能です。   また、衛生的で簡単にごみ捨てができます。  静音モード   運転音を低減し、静音性と長い運転時間を実現します。  吸引力を自動調整   ピエゾセンサーが吸引したゴミの量とサイズを計測。ゴミの量に応じて、吸引力をインテリジェントに調整します。  *オートモード使用中に自社試験で定めたホコリの濃度の増加を検知した時のみ、自動で吸引力が強まります。  HEPAフィルター   0.1ミクロンもの微細な粒子まで99.99％捕らえ、浄化された空気を排出。*  * ASTM F3150に基づくSGS-IBR（米国）による試験結果（2022年に実施）。試験は強モードで実施。  段差を乗り越え、低い場所の掃除にも   デュアルリンクサスペンションで最大21mmの段差を止まることなく乗り越えます。薄型設計で、家具の下の掃除にも対応しています。  付属品：充電ドック、バッテリー充電器  サイズ 高さ:97mm 奥行き:345mm 幅:330mm 本体質量4.5kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_RB03+BN.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "616",
    brand: "Dyson",
    sku: "HD15 ULF BNBC",
    product_eng: "Dyson Supersonic Shine hair dryer Nickel/Copper",
    product_jpn:
      "Dysonダイソン Supersonic Shine ヘアドライヤー ニッケル／コッパー",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥44,364",
    rrp_with_vat: "¥48,800",
    description_eng:
      "For salon-finished shiny hair. Protects against heat damage and adds shine with a new shine-enhancing tool. Two different modes lead to smoother, shinier hair with less floating and wavy hair.   Included Shine tool / Low temperature tool / Smooth tool   Size Height: 288 mm Depth: 98 mm Width: 77 mm Weight: 720 g",
    description_jpn:
      "サロンで仕上げたようなツヤめく髪に。 熱ダメージから守り、新しいツヤ出しツールで輝きを。 2つの異なるモードで、浮き毛やうねりの少ない、なめらかでツヤのある髪へ導きます。   同梱品 ツヤ出しツール/低温ツール/なめらかツール   サイズ 高さ：288 mm 奥行き：98 mm 幅：77 mm 重量：720g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_HD15_ULF_BNBC.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "617",
    brand: "Dyson",
    sku: "HD15 ULF IIF",
    product_eng: "Dyson Supersonic Shine hair dryer Iron/Fuchsia",
    product_jpn:
      "Dysonダイソン Supersonic Shine ヘアドライヤ アイアン／フューシャー",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥44,364",
    rrp_with_vat: "¥48,800",
    description_eng:
      "For salon-finished shiny hair. Protects against heat damage and adds shine with a new shine-enhancing tool. Two different modes lead to smoother, shinier hair with less floating and wavy hair.   Included Shine tool / Low temperature tool / Smooth tool   Size Height: 288 mm Depth: 98 mm Width: 77 mm Weight: 720 g",
    description_jpn:
      "サロンで仕上げたようなツヤめく髪に。 熱ダメージから守り、新しいツヤ出しツールで輝きを。 2つの異なるモードで、浮き毛やうねりの少ない、なめらかでツヤのある髪へ導きます。   同梱品 ツヤ出しツール/低温ツール/なめらかツール   サイズ 高さ：288 mm 奥行き：98 mm 幅：77 mm 重量：720g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_HD15_ULF_IIF.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "618",
    brand: "Dyson",
    sku: "HS05 COMP LG BNBC",
    product_eng:
      "Dyson Airwrap™multi-styler Complete Long Nickel/Copper with storage box",
    product_jpn:
      "Dysonダイソン Airwrap™マルチスタイラー Complete Long 収納ボックス付きニッケル／コッパー",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥57,500",
    rrp_with_vat: "¥63,250",
    description_eng:
      "Easier styling with coanda effect while drying hair. *1 Prevents excessive heat damage, leaving hair smooth and shiny. Airy curls, blow-drying, drying, and control of floating hairs all in one machine. *2 *1Comparison with conventional Dyson AirwrapTM styler. *2Floating hair control is when using the floating hair control mode on dry, straight hair.  Prevents excessive heat damage for easier styling. *1Airy curls, blow-drying, and floating hair control all in one machine. *2  *1Comparison with conventional Dyson Airwrap styler.   *2Floating hair control is when using the floating hair control mode on dry, straight hair.  Prevent excessive heat damage   Styling hair requires cutting and recombining hydrogen bonds. The Dyson Airlap dries wet hair to cut and re-fix hydrogen bonds, so it does not rely on excessive heat.  Easy styling with wind   High-speed, high-pressure airflow from the unique Dyson Digital Motor V11 creates a coanda effect, automatically attracting and wrapping hair with wind.  Smoother, shinier hair!   Newly redesigned attachments utilize the coanda effect to reduce flyaway hair, resulting in smoother, shinier hair.  Short styling time while drying   The new attachment is suitable for family use as it reduces hair care time and can be used for hair of various lengths.  Included 30mm Airwrap long curler/40mm Airwrap long curler/smoothing brush (soft)/smoothing brush (hard)/round volume brush/smoothing dryer/filter cleaning brush/storage box  Size Height: 448mm Depth: 47mm Width: 41mm Weight: 661g *including cable and plug",
    description_jpn:
      "髪を乾かしながら、コアンダ効果でより簡単にスタイリング。*1 過度な熱ダメージを防ぎ、なめらかでツヤのある髪へ。エアリーカール、ブロー、ドライ、浮き毛抑制も1台で。*2 *1従来のDyson AirwrapTMスタイラーとの比較。 *2浮き毛抑制は、乾いたストレートヘアに浮き毛抑制モードを使用した場合。   過度な熱ダメージを防ぎ、より簡単にスタイリング。*1エアリーカール、ブロー、ドライ、浮き毛抑制も1台で。*2  *1従来のDyson Airwrap スタイラーとの比較。   *2浮き毛抑制は、乾いたストレートヘアに浮き毛抑制モードを使用した場合。  過度な熱ダメージを防ぐ   髪のスタイリングには、水素結合を切って再結合させることが必要です。ダイソン エアラップは濡れた髪を乾かすことで、水素結合を切り再び固定させるので、過度な熱に頼りません。  風で簡単スタイリング   独自のダイソン デジタルモーター V11による高速・高圧の風がコアンダ効果を発生させ、風で髪を自動的に引き寄せ、巻き付けます。  よりなめらかでツヤのある髪へ   再設計された新しいアタッチメントは、コアンダ効果を利用し浮き毛を抑え、よりなめらかでツヤのある髪へ導きます。  乾かしながら時短スタイリング   ヘアケア時間を短縮でき、さらにさまざまな髪の長さに対応できるので家族での使用にも適しています。  同梱品 30mm Airwrap ロングカーラー/40mm Airwrap ロングカーラー/スムージングブラシ（ソフト）/スムージングブラシ（ハード）/ラウンドボリュームブラシ/スムージングドライヤー/フィルタークリーニングブラシ/収納ボックス  サイズ 高さ：448mm 奥行き：47mm 幅：41mm 重量：661ｇ ※ケーブルとプラグを含む",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/dyson/Dyson_HS05_COMP_LG_BNBC.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },

  {
    id: "1061",
    brand: "Dyson",
    sku: "HP10 WW",
    product_eng:
      "Dyson Purifier Hot+Cool™ Gen1 Air purifying fan heater White/White",
    product_jpn:
      "Dyson Purifier Hot+Cool™ Gen1 空気清浄ファンヒーター ホワイト／ホワイト",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥54,500",
    rrp_with_vat: "¥59,950",
    description_eng:
      "A Simple Model with Triple Functions (Air Purifier/Fan/Heater)  Enjoy comfortable temperature and air quality all year round with Dyson’s all-in-one device. This air purifier fan heater cleans the air in your room while providing both cool and warm air. It has a high air purification capacity, capturing 99.95% of house dust and pollen. The oscillation function up to 350° circulates the air throughout the room. Use it year-round without the need for storage space, as it seamlessly blends into your interior.  Features:  No Regular Maintenance Required: No need for frequent washing or cleaning. Simply replace the old filter with a new one. Night Mode: Switches to quiet operation and dims the display while continuing to monitor and respond to air quality. Ensures a comfortable sleep environment by delivering purified air without disturbing noise. Specifications:  Size (Approx.): Width 24.8cm x Depth 24.8cm x Height 76.4cm Weight (Approx.): 5.29kg Power Supply / Power Consumption: AC100V 50/60Hz Cool Mode: Min 2W / Max 50W Heat Mode: 1,400W Heating Capacity: 10 tatami mats / 5 tatami mats (Concrete housing) 6 tatami mats / 4 tatami mats (Wooden housing) Applicable Floor Area for Air Purification: 8 tatami mats (30 minutes) / 25 tatami mats (60 minutes) (Estimated time to purify 8 tatami mats: 28 minutes) Accessories: Remote control, test coin battery (CR 2032L x 1) Manufacturer Warranty: 2 years *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "1台3役（空気清浄機/扇風機/ヒーター）のシンプルモデルです。一年中快適な温度と空気をダイソンなら、1台で。部屋の空気をきれいにしながら、涼風も、温風も届けられる空気清浄ファンヒーターです。ハウスダストや花粉を99.95％捕らえる高い空気清浄能力を搭載。最大350°の首振り機能で、部屋中の空気を循環させます。一年中使えるため収納スペースは不要、インテリアに馴染む佇まいです。  ●定期的なお手入れ不要 水洗いや掃除などの面倒なお手入れは必要ありません。古いフィルターを外して新しいフィルターを装着するだけで簡単です。 ●ナイトモード 静音運転に切り替わり、ディスプレイを減光。引き続き空気の状態をモニターし、反応します。耳障りな運転音もなく、浄化された空気だけを送り出し、睡眠環境を快適にします。  【仕様】 ・サイズ（約） 縦24.8×横24.8×高さ76.4cm ・重さ（約） 5.29kg ・電源/消費電力 AC100V 50/60Hz 【涼風モード】最小2W / 最大50W 【温風モード】1,400W ・暖房能力：10畳 / 5畳 (コンクリート住宅) 6畳 / 4畳 (木造住宅) ・空気清浄適用床面積：8畳 (30分) / 25畳 (60分) (8畳を清浄する目安 28分) ・付属品：リモコン、テスト用コイン電池（CR 2032L×1）  ・メーカー保証２年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/dyson/HP10_WW.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "1062",
    brand: "Dyson",
    sku: "TP10 WW",
    product_eng: "Dyson Purifier Cool™ Gen1 Air purifying fan White/White",
    product_jpn: "Dyson Purifier Cool™ Gen1 空気清浄ファン ホワイト／ホワイト",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥45,400",
    rrp_with_vat: "¥49,940",
    description_eng:
      "A Simple Model with Dual Functions (Air Purifier/Fan)  With Dyson, one device does it all. This air purifier fan cleans the air in your room while keeping you cool and comfortable. It has a high air purification capacity, capturing 99.95% of house dust and pollen. The oscillation function up to 350° circulates the air throughout the room.  Features:  Powerful Circulation for Whole-Room Air Purification: Air Multiplier technology amplifies airflow, pulling in even distant air pollutants, and purifies the air throughout the entire room. Automatic Detection of Fine Particles and Notification: The built-in sensor continuously monitors air quality, automatically detecting fine particles like pollen. The air quality over the past 12 seconds is displayed in real-time on the LCD display. No Regular Maintenance Required: No need for frequent washing or cleaning. Simply replace the old filter with a new one. Night Mode: Switches to quiet operation and dims the display while continuing to monitor and respond to air quality. Ensures a comfortable sleep environment by delivering purified air without disturbing noise. Specifications:  Main Unit Size (Height x Width x Depth, mm): 1050 x 220 x 220 Main Unit Weight: 4.73kg Motor Type: Brushless DC Motor Vertical Angle Adjustment: 45° / 90° / 180° / 350° Cord Length (m): 1.8 Manufacturer Warranty: 2 years *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "1台2役（空気清浄機/扇風機）のシンプルモデルです。ダイソンなら、1台で。部屋の空気をきれいにしながら、涼しく快適にする空気清浄ファンです。ハウスダストや花粉を99.95％捕らえる高い空気清浄能力を搭載。最大350°の首振り機能で、部屋中の空気を循環させます。  ●パワフルな循環力。部屋全体の空気清浄。 Air Multiplier テクノロジーにより気流を増幅させ、遠くにある空気の汚れまでも引き寄せる循環力で、部屋全体の空気を浄化します。  ●自動で微細な粒子を検知して、お知らせ 本体に搭載されたセンサーが常に空気の状態をモニター。花粉などの目に見えない微細な粒子を自動で検知。直近12秒間の空気質をLCDディスプレイにリアルタイムに表示します。  ●定期的なお手入れ不要 水洗いや掃除などの面倒なお手入れは必要ありません。古いフィルターを外して新しいフィルターを装着するだけで簡単です。  ●ナイトモード 静音運転に切り替わり、ディスプレイを減光。引き続き空気の状態をモニターし、反応します。耳障りな運転音もなく、浄化された空気だけを送り出し、睡眠環境を快適にします。  【仕様】 ・本体サイズ（高さ×幅×奥行き、mm）：1050x220x220 ・本体重量：4.73kg ・モーター種類：ブラシレスDCモーター ・上下角度調節：45° / 90° / 180° / 350° ・コードの長さ（m）：1.8 ・メーカー保証２年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/dyson/TP10_WW.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "1063",
    brand: "Dyson",
    sku: "HD17 VLP",
    product_eng: "Dyson Supersonic r™hair dryer Ceramic Pink",
    product_jpn: "Dyson Supersonic r™ヘアドライヤー セラミックピンク",
    category_1: "Home & Garden",
    category_2: "Personal Care",
    rrp_ex_vat: "¥53,636",
    rrp_with_vat: "¥59,000",
    description_eng:
      "Japan Limited Color, Ceramic Pink. Dyson's Lightest Hair Dryer Approved by Professionals  Deliver air freely for salon-like silky touch hair.  Features:  Newly Developed Streamlined Heater: A small, lightweight, and high-power-density heater designed to heat airflow more evenly as it passes through curves. Achieves high precision and quick drying compared to the Dyson Supersonic™ hair dryer. Auto-Setting Attachments: Instantly recognizes attached attachments and automatically adjusts to pre-set recommended wind speed and temperature. Can also be adjusted to your preferred settings. Small but Quick Drying: Quick drying reduces the time your hair is exposed to heat, protecting against heat damage to the scalp and hair. Additionally, negative ions suppress static electricity in the hair. Controlled Air Temperature: Intelligent heat control ensures the temperature remains consistent without continuously increasing, preventing excessive heat damage. Temperature and Air Speed Settings: Each attachment can be used with three temperature settings (low, medium, high) with precisely controlled temperature. Airspeed can be selected from three levels and can be adjusted from the default settings to your preferred settings. Cold Shot: A fourth temperature setting. Press and hold for cold air. After styling with warm air, use cold air to finish and make the style last longer. Specifications:  Main Unit Size: Height 285mm × Width 108mm × Depth 55mm (including quick-dry tool) Cord Length: 2m Temperature Settings: 3 levels + cold air Power Consumption: 1200W Accessories: Smoothing tool, low-temperature tool, quick-dry tool Manufacturer Warranty: 2 years *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "日本限定カラー、セラミックピンク。プロも認める、ダイソン最軽量ドライヤー。 自由自在に風を届けて、サロン帰りのシルキータッチな髪へ。  ■新開発の流線形ヒーター 小型で軽量、かつ電力密度の高いヒーター。曲線を通過する気流をより均等に熱する設計。高精度かつ速乾を実現。* * Dyson Supersonic(TM)ヘアドライヤーとの比較。 ■オート設定アタッチメント 取り付けられたアタッチメントを瞬時に認識し、あらかじめ設定された推奨風速・風温に自動で調節。お好みの設定にも変更できます。 ■小さくても速乾 速乾により、髪に熱を当てる時間が短くなるので、熱による頭皮や髪へのダメージや、* 乾かしすぎから守ります。さらに、マイナスイオンが髪の静電気を抑制。 * 過度な熱によるダメージ。 ■風温をコントロール* インテリジェント・ヒートコントロールにより、温度が上がり続けることなく、一定に保てるように設計されています。 * 低温ツールを装着した本製品および検証用にインテリジェント・ヒートコントロール機能を切ったもので比較。使用場所の状況や使い方などで効果は異なることがあります。 ■風温および風速設定 各アタッチメントは、温度が正確にコントロールされた３つの設定(低温、中温、高温)から使用できます。風速は3段階から選択でき、それぞれの初期設定からお好みの設定にも変更できます。 ■コールドショット 4つ目の風温設定。長押しすると冷風になります。温風で髪を整えた後、仕上げに冷風を使用することで、セットが長持ちします。  本体サイズ 高さ285×幅108×奥行き55mm（速乾ツールを含む） コード長さ 2m 風温切替 3段階＋冷風 消費電力 1200W 付属品 なめらかツール、低温ツール、速乾ツール メーカー保証年数 ：2年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/dyson/HD17_VLP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "1064",
    brand: "Dyson",
    sku: "HD17 CPATO",
    product_eng: "Dyson Supersonic r™hair dryer Ceramic patina/Topaz",
    product_jpn:
      "Dyson Supersonic r™ヘアドライヤー セラミックパティーナ／トパーズ",
    category_1: "Home & Garden",
    category_2: "Personal Care",
    rrp_ex_vat: "¥53,636",
    rrp_with_vat: "¥59,000",
    description_eng:
      "Dyson's Lightest Hair Dryer, Approved by Professionals  Deliver air freely for salon-like silky touch hair.  Features:  Newly Developed Streamlined Heater: A small, lightweight, and high-power-density heater designed to heat airflow more evenly as it passes through curves. Achieves high precision and quick drying compared to the Dyson Supersonic™ hair dryer. Auto-Setting Attachments: Instantly recognizes attached attachments and automatically adjusts to pre-set recommended wind speed and temperature. Can also be adjusted to your preferred settings. Small but Quick Drying: Quick drying reduces the time your hair is exposed to heat, protecting against heat damage to the scalp and hair. Additionally, negative ions suppress static electricity in the hair. Controlled Air Temperature: Intelligent heat control ensures the temperature remains consistent without continuously increasing, preventing excessive heat damage. Temperature and Air Speed Settings: Each attachment can be used with three temperature settings (low, medium, high) with precisely controlled temperature. Airspeed can be selected from three levels and can be adjusted from the default settings to your preferred settings. Cold Shot: A fourth temperature setting. Press and hold for cold air. After styling with warm air, use cold air to finish and make the style last longer. Specifications:  Main Unit Size: Height 285mm × Width 108mm × Depth 55mm (including quick-dry tool) Cord Length: 2m Temperature Settings: 3 levels + cold air Power Consumption: 1200W Accessories: Smoothing tool, low-temperature tool, quick-dry tool *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "プロも認める、ダイソン最軽量ドライヤー。 自由自在に風を届けて、サロン帰りのシルキータッチな髪へ。  ■新開発の流線形ヒーター 小型で軽量、かつ電力密度の高いヒーター。曲線を通過する気流をより均等に熱する設計。高精度かつ速乾を実現。* * Dyson Supersonic(TM)ヘアドライヤーとの比較。 ■オート設定アタッチメント 取り付けられたアタッチメントを瞬時に認識し、あらかじめ設定された推奨風速・風温に自動で調節。お好みの設定にも変更できます。 ■小さくても速乾 速乾により、髪に熱を当てる時間が短くなるので、熱による頭皮や髪へのダメージや、* 乾かしすぎから守ります。さらに、マイナスイオンが髪の静電気を抑制。 * 過度な熱によるダメージ。 ■風温をコントロール* インテリジェント・ヒートコントロールにより、温度が上がり続けることなく、一定に保てるように設計されています。 * 低温ツールを装着した本製品および検証用にインテリジェント・ヒートコントロール機能を切ったもので比較。使用場所の状況や使い方などで効果は異なることがあります。 ■風温および風速設定 各アタッチメントは、温度が正確にコントロールされた３つの設定(低温、中温、高温)から使用できます。風速は3段階から選択でき、それぞれの初期設定からお好みの設定にも変更できます。 ■コールドショット 4つ目の風温設定。長押しすると冷風になります。温風で髪を整えた後、仕上げに冷風を使用することで、セットが長持ちします。  本体サイズ 高さ285×幅108×奥行き55mm（速乾ツールを含む） コード長さ 2m 風温切替 3段階＋冷風 消費電力 1200W 付属品 なめらかツール、低温ツール、速乾ツール メーカー保証年数 ：2年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/dyson/HD17_CPATO.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "1065",
    brand: "Dyson",
    sku: "BP02 WS",
    product_eng: "Dyson Purifier Big+Quiet Air purifier White/Silver",
    product_jpn: "Dyson Purifier Big+Quiet 空気清浄機 ホワイト／シルバー",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥98,000",
    rrp_with_vat: "¥107,800",
    description_eng:
      "Dyson Air Purifier  Features:  Circulates Air Up to 10 Meters: Dyson air purifiers circulate air up to 10 meters away, purifying every corner of the room. Powerful and Quiet: The high-speed, low-pressure system delivers air with the lowest operating noise of any Dyson air purifier, even at maximum airflow. Automatic Detection and Notification: Detects and analyzes airborne particulate matter, harmful gases, and odors automatically, notifying you in real-time. European Standard HEPA H13 Level Sealing: The highly sealed filter design ensures that captured pollutants are not released. Wind Direction Control: Adjust the angle to 0 degrees, 25 degrees, or 50 degrees, or set it to breeze mode for gentle airflow. Easy Filter Replacement: No need for complicated filter maintenance. The filter can be easily replaced with a one-touch mechanism. Night Mode: Switches to quiet operation and dims the LCD display. Safety and Easy Maintenance: No hard-to-clean covers or blades. Casters for Easy Movement: Easily move the unit around the room. Suitable for hard floors with a discreet design. Specifications:  Rated Power Consumption (Min/Max): 20W/50W Standby Power: 0.5W Airflow Adjustment: 10 levels Applicable Floor Area for Air Purification: 27 tatami mats (30 minutes) / 79 tatami mats (60 minutes) Vertical Angle Adjustment (Angle): 0°/25°/50°/Breeze Mode Timer: (Using App) 15, 30, 45 minutes, 1~9 hours. (Using Remote) 30 minutes, 1 hour, 2 hours, 4 hours, 8 hours. Main Unit Size (Height x Width x Depth): 830mm × 415mm × 434mm Main Unit Weight: 11.8kg Cable Length: 1.8m Manufacturer Warranty: 2 years *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "●ダイソンなら10m先まで空気を循環し、部屋のすみずみまで浄化。 ●パワフルで静か 高速低圧システムを通して空気が送り出されるため、最大風量時でも、ダイソンの空気清浄機で最も低減された運転音です。 ●検知してお知らせ 空気中に浮遊する粒子状物質や有害なガスやニオイを自動で検知・分析し、リアルタイムでお知らせします。 ●欧州規格HEPA H13レベルの密閉性 密閉性の高いフィルター設計で、捕らえた汚染物質を逃がしません。 ●風向コントロール 角度を0度、25度、50度に調整したり、そよ風のような動きに設定できます。 ●簡単なフィルター交換 面倒なフィルターのお手入れ不要。ワンタッチで簡単にフィルターを交換できます。 ●ナイトモード 静音運転に切り替え、LCDディスプレイを減光します。 ●安全への配慮。お手入れも簡単 お手入れが大変なカバーや羽根がありません ●キャスター搭載 部屋の中を簡単に 移動することができます。ハードフロアに適しており、目立たない設計です。  【仕様】 定格消費電力(最小 /最大）：20W/50W 待機電力：0.5W 風量調整：10段階 空気清浄適用床面積：27畳(30分) / 79畳(60分) 上下角度調節（角度）：0°/25°/50°/ブリーズモード タイマー：(アプリ使用時）15, 30, 45分, 1~9 時間。（リモコン使用時）30分、1時間、2時間、4時間、8時間。 本体サイズ(高さ×幅×奥行き)：830mm × 415mm × 434mm 本体重量：11.8kg ケーブルコードの長さ：1.8m メーカー保証年数 ：2年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/dyson/BP02_WS.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },
  {
    id: "1066",
    brand: "Dyson",
    sku: "BP03 NB",
    product_eng:
      "Dyson Purifier Big+Quiet Air Formaldehyde Air purifier Nickel/Blue",
    product_jpn:
      "Dyson Purifier Big+Quiet Formaldehyde 空気清浄機 ニッケル／ブルー",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥115,000",
    rrp_with_vat: "¥126,500",
    description_eng:
      "Dyson Air Purifier  Features:  Air Circulation and Purification Up to 10 Meters: Dyson air purifiers circulate and purify air up to 10 meters away, reaching every corner of the room, and even decomposing formaldehyde. Powerful and Quiet: The high-speed, low-pressure system delivers air with the lowest operating noise of any Dyson air purifier, even at maximum airflow. Formaldehyde Decomposition with Oxidation Catalyst Filter: This filter decomposes formaldehyde and measures and displays its indoor concentration. No maintenance or replacement is required. Automatic Detection and Notification: Detects and analyzes airborne particulate matter, harmful gases, and odors automatically, notifying you in real-time. European Standard HEPA H13 Level Sealing: The highly sealed filter design ensures that captured pollutants are not released. Wind Direction Control: Adjust the angle to 0 degrees, 25 degrees, or 50 degrees, or set it to breeze mode for gentle airflow. Easy Filter Replacement: No need for complicated filter maintenance. The filter can be easily replaced with a one-touch mechanism. Night Mode: Switches to quiet operation and dims the LCD display. Safety and Easy Maintenance: No hard-to-clean covers or blades. Casters for Easy Movement: Easily move the unit around the room. Suitable for hard floors with a discreet design. Specifications:  Rated Power Consumption (Min/Max): 20W/50W Standby Power: 0.5W Airflow Adjustment: 10 levels Applicable Floor Area for Air Purification: 27 tatami mats (30 minutes) / 79 tatami mats (60 minutes) Vertical Angle Adjustment (Angle): 0°/25°/50°/Breeze Mode Timer: (Using App) 15, 30, 45 minutes, 1~9 hours. (Using Remote) 30 minutes, 1 hour, 2 hours, 4 hours, 8 hours. Main Unit Size (Height x Width x Depth): 830mm × 415mm × 434mm Main Unit Weight: 11.8kg Cable Length: 1.8m *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "●ダイソンなら10m先まで空気を循環し、部屋のすみずみまで浄化*。さらにホルムアルデヒドまでも分解。 ●パワフルで静か 高速低圧システムを通して空気が送り出されるため、最大風量時でも、ダイソンの空気清浄機で最も低減された運転音です。 ●酸化触媒フィルターが、ホルムアルデヒドを分解します。ホルムアルデヒド室内での検知量を測定かつ表示します。メンテナンスも交換も不要です。 ●検知してお知らせ 空気中に浮遊する粒子状物質や有害なガスやニオイを自動で検知・分析し、リアルタイムでお知らせします。 ●欧州規格HEPA H13レベルの密閉性 密閉性の高いフィルター設計で、捕らえた汚染物質を逃がしません。 ●風向コントロール 角度を0度、25度、50度に調整したり、そよ風のような動きに設定できます。 ●簡単なフィルター交換 面倒なフィルターのお手入れ不要。ワンタッチで簡単にフィルターを交換できます。 ●ナイトモード 静音運転に切り替え、LCDディスプレイを減光します。 ●安全への配慮。お手入れも簡単 お手入れが大変なカバーや羽根がありません。 ●キャスター搭載 部屋の中を簡単に 移動することができます。ハードフロアに適しており、目立たない設計です。  【仕様】 定格消費電力(最小 /最大）：20W/50W 待機電力：0.5W 風量調整：10段階 空気清浄適用床面積：27畳(30分) / 79畳(60分) 上下角度調節（角度）：0°/25°/50°/ブリーズモード タイマー：(アプリ使用時）15, 30, 45分, 1~9 時間。（リモコン使用時）30分、1時間、2時間、4時間、8時間。 本体サイズ(高さ×幅×奥行き)：830mm × 415mm × 434mm 本体重量：11.8kg ケーブルコードの長さ：1.8m  【仕様】 定格消費電力(最小 /最大）：20W/50W 待機電力：0.5W 風量調整：10段階 空気清浄適用床面積：27畳(30分) / 79畳(60分) 上下角度調節（角度）：0°/25°/50°/ブリーズモード タイマー：(アプリ使用時）15, 30, 45分, 1~9 時間。（リモコン使用時）30分、1時間、2時間、4時間、8時間。 本体サイズ(高さ×幅×奥行き)：830mm × 415mm × 434mm 本体重量：11.8kg ケーブルコードの長さ：1.8m ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/dyson/BP03_NB.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
  },

  {
    id: "620",
    brand: "Philips",
    sku: "HX6421/12",
    product_eng: " Sonicare ProtectiveClean<Plus>White",
    product_jpn:
      " フィリップス ソニッケアー プロテクトクリーン＜プラス＞ ホワイト",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥13,600",
    rrp_with_vat: "¥14,960",
    description_eng:
      "Clears tooth stains that bother you. Natural white teeth.   Promotes healthy gums  Dense, high-quality bristles remove plaque from the gingival margin and promote healthy gums. Curved bristles reach back teeth easily.  You can choose how you want to brush.  The clean mode removes plaque thoroughly, while the white mode is ideal for removing stains on the tooth surface.  Gentle brushing  The sonic water flow is also suitable for orthodontic appliances and dental prosthetics (fillings, crowns, laminate veneers) and gently brushes them.  Overpressure prevention sensor function  Sensors pressure on teeth and gums. Vibration is transmitted to the handle for gentle brushing of teeth and gums.  Brush head replacement reminder function  The brush head records the brushing time and pressure each time, and when it is time to replace the brush head, a notification light at the bottom of the handle glows to let you know when it is time to replace the brush head. (When using the brush head with built-in RFID)  Cadpacer function notifies you at regular intervals.  Brush time is notified by timer. Brushes evenly over 4 sections of teeth and gums: top, bottom, front, back, and bottom.  Sonic Water Flow The combination of high-speed vibrations of approximately 31,000 times per minute and a wide range of amplitudes generates a sonic water flow. The water flow is gentle enough to brush the interdental spaces and gingival margins.  Start Function  The power is gradually increased from the first to the fourteenth use so that users can gradually become accustomed to brushing with Philips Sonicare. ●Dimensions (H x W x D): approx. 252 x 31 x 28 (mm) (with White Plus brush head attached) ●Weight: approx. 133 g (with WhitePlus brush head attached)",
    description_jpn:
      "気になる歯の着色をクリア。自然な白い歯へ。   歯ぐきの健康を推進  密集した高品質の毛先が歯肉縁の歯垢を除去し、歯ぐきの健康を推進。また、湾曲した毛先は奥歯にも簡単に届きます。  お好みの磨き方が選べる  クリーンモードなら歯垢をしっかり除去し、ホワイトモードは歯の表面のステイン（着色汚れ）の除去に最適です。  やさしくブラッシング  音波水流は、矯正器具、歯科補綴物（詰め物、クラウン、ラミネートベニアー）にも適しており、やさしく磨きます。  過圧防止センサー機能  歯と歯ぐきへの圧力を感知。ハンドルに振動で伝えて、歯と歯ぐきをやさしくブラッシングできます。  ブラシヘッド交換お知らせ機能  ブラシヘッドには毎回のブラッシング時間とブラシ圧が記録され、交換時期になるとハンドル下部にあるお知らせランプが光り、ブラシヘッド交換のタイミングをお知らせします。（RFID内蔵ブラシヘッドを使用した場合）  一定の間隔でお知らせするカドペーサー機能  磨き時間をタイマーでお知らせ。歯と歯ぐきの上下・表裏の4つのセクションを均等にブラッシングできます。  音波水流  1分間に約31000回の高速振動と幅広い振幅の組み合わせにより音波水流を発生。歯間と歯肉縁もしっかりとやさしく磨きます。  イージースタート機能  フィリップス ソニッケアーでの歯磨きに徐々に慣れていただけるよう、使いはじめから14回目にかけて徐々にパワーを上げていきます。 ●本体寸法（H×W×D）：約252×31×28（mm）（ホワイトプラスブラシヘッド装着時） ●質量：約133g（ホワイトプラスブラシヘッド装着時）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/phillips/Phillips_HX642112.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/philips.png",
  },
  {
    id: "621",
    brand: "Philips",
    sku: "HX6421/14",
    product_eng: " Sonicare ProtectiveClean<Plus>Black",
    product_jpn:
      " フィリップス ソニッケアー プロテクトクリーン＜プラス＞ ブラック",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥14,900",
    rrp_with_vat: "¥16,390",
    description_eng:
      "Clears tooth stains that bother you. Natural white teeth.   Promotes healthy gums  Dense, high-quality bristles remove plaque from the gingival margin and promote healthy gums. Curved bristles reach back teeth easily.  You can choose how you want to brush.  The clean mode removes plaque thoroughly, while the white mode is ideal for removing stains on the tooth surface.  Gentle brushing  The sonic water flow is also suitable for orthodontic appliances and dental prosthetics (fillings, crowns, laminate veneers) and gently brushes them.  Overpressure prevention sensor function  Sensors pressure on teeth and gums. Vibration is transmitted to the handle for gentle brushing of teeth and gums.  Brush head replacement reminder function  The brush head records the brushing time and pressure each time, and when it is time to replace the brush head, a notification light at the bottom of the handle glows to let you know when it is time to replace the brush head. (When using the brush head with built-in RFID)  Cadpacer function notifies you at regular intervals.  Brush time is notified by timer. Brushes evenly over 4 sections of teeth and gums: top, bottom, front, back, and bottom.  Sonic Water Flow The combination of high-speed vibrations of approximately 31,000 times per minute and a wide range of amplitudes generates a sonic water flow. The water flow is gentle enough to brush the interdental spaces and gingival margins.  Start Function  The power is gradually increased from the first to the fourteenth use so that users can gradually become accustomed to brushing with Philips Sonicare. ●Dimensions (H x W x D): approx. 252 x 31 x 28 (mm) (with White Plus brush head attached) ●Weight: approx. 133 g (with WhitePlus brush head attached)",
    description_jpn:
      "気になる歯の着色をクリア。自然な白い歯へ。   歯ぐきの健康を推進  密集した高品質の毛先が歯肉縁の歯垢を除去し、歯ぐきの健康を推進。また、湾曲した毛先は奥歯にも簡単に届きます。  お好みの磨き方が選べる  クリーンモードなら歯垢をしっかり除去し、ホワイトモードは歯の表面のステイン（着色汚れ）の除去に最適です。  やさしくブラッシング  音波水流は、矯正器具、歯科補綴物（詰め物、クラウン、ラミネートベニアー）にも適しており、やさしく磨きます。  過圧防止センサー機能  歯と歯ぐきへの圧力を感知。ハンドルに振動で伝えて、歯と歯ぐきをやさしくブラッシングできます。  ブラシヘッド交換お知らせ機能  ブラシヘッドには毎回のブラッシング時間とブラシ圧が記録され、交換時期になるとハンドル下部にあるお知らせランプが光り、ブラシヘッド交換のタイミングをお知らせします。（RFID内蔵ブラシヘッドを使用した場合）  一定の間隔でお知らせするカドペーサー機能  磨き時間をタイマーでお知らせ。歯と歯ぐきの上下・表裏の4つのセクションを均等にブラッシングできます。  音波水流  1分間に約31000回の高速振動と幅広い振幅の組み合わせにより音波水流を発生。歯間と歯肉縁もしっかりとやさしく磨きます。  イージースタート機能  フィリップス ソニッケアーでの歯磨きに徐々に慣れていただけるよう、使いはじめから14回目にかけて徐々にパワーを上げていきます。 ●本体寸法（H×W×D）：約252×31×28（mm）（ホワイトプラスブラシヘッド装着時） ●質量：約133g（ホワイトプラスブラシヘッド装着時）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/phillips/Phillips_HX642114.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/philips.png",
  },
  {
    id: "622",
    brand: "Philips",
    sku: "HX6870/56",
    product_eng: " Sonicare ProtectiveClean<Premium>Black",
    product_jpn:
      " フィリップス ソニッケアー プロテクトクリーン <プレミアム> ブラック",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥24,800",
    rrp_with_vat: "¥27,280",
    description_eng:
      " Gently and effectively removes plaque by generating sonic water flow (saliva flow in the mouth). Suitable for orthodontic appliances and dental prosthetics.   The brush head vibrates at a high speed of approximately 31,000 times per minute to knock away plaque, and the wide swing of the brush head removes the floating plaque.   At the same time, these movements generate a sonic current, a flow of saliva in the mouth, which gently and effectively scrubs away plaque.   The sonic current is also suitable for orthodontic appliances and dental prosthetics (fillings, crowns, laminate veneers) and gently polishes them.  Naturally white teeth in about 1 week   The dense central stain-removing brush removes stains and leads to naturally white teeth in about 1 week*1.   1 When using the WhitePlus brush head / Based on a study by Colgan et al. in 2010 (individual differences may occur).  Promotes healthy gums   Dense bristles remove plaque from the gingival margin and promote healthy gums. Also, the curved bristle tips easily reach back teeth.  Three modes and three strength settings allow you to choose your preferred brushing style.  Over-pressure prevention sensor function for gentle brushing of teeth and gums   When the overpressure prevention sensor detects excessive pressure being applied to the brush, it emits a pulsing sound to remind you to brush with less pressure.  Easy-to-understand lamps indicate when it is time to replace the brush head.  Brush head recognition function automatically sets the optimal mode and strength.   A microchip with RFID function built into the brush head is linked to the handle to automatically set the optimal mode and strength level by simply attaching the brush head to the handle (mode and strength can be changed as desired)Easy-to-understand lamps indicate when it is time to replace the brush head.  Cadpacer function (beeps to notify you when time is up)  Tongue polishing brush head removes tongue stains   More than 200 micro bumps are designed to remove dirt from the surface of the tongue. The micro bumps gently penetrate into the grooves of the tongue to remove dirt accumulated on the tongue. The compact shape comfortably cleans the entire tongue.  The No. 1 electric toothbrush brand used by dentists and dental hygienists in Japan for 14 consecutive years   Sonicare is trusted by dentists and dental hygienists and has been used for a long time.  ●Dimensions (H x W x D): approx. 252 x 31 x 28 (mm) (with White Plus Brush Head attached) ●Weight: approx. 133 g (with White Plus Brush Head attached)",
    description_jpn:
      " 音波水流（口の中の唾液の流れ）の発生で、やさしく効果的に歯垢を除去。矯正器具、歯科補綴物にも適します。   毎分約31,000回の高速振動で歯垢をたたき浮かせ、ブラシヘッドの幅広い振れ幅で浮かせた歯垢をはらい落とします。   同時にそれらの動きが口の中の唾液の流れ「音波水流」を発生させ、やさしく効果的に歯垢をかき出します。   音波水流は、矯正器具、歯科補綴物（詰め物、クラウン、ラミネートベニアー）にも適しており、やさしく磨きます。  約1週間で自然な白い歯へ   密集した中央のステイン除去ブラシが、約1週間※1でステインを落として歯本来の自然な白い歯に導きます。   ※1 ホワイトプラスブラシヘッド使用時/2010年Colgan氏らの調査に基づく（個人差があります。）  歯ぐきの健康を推進   密集した毛先が歯肉縁の歯垢を除去し、歯ぐきの健康を推進。また、湾曲した毛先は奥歯にも簡単に届きます。  3つのモードと3段階の強さ設定で、お好みの磨き方が選べる  過圧防止センサー機能で、歯と歯ぐきにやさしくブラッシング   過圧防止センサーが、ブラシにかけられた圧力が強いと感知した場合は、パルス音を発し、ブラシ圧を弱めてブラッシングするよう促してくれます。  ブラシヘッド交換時期をわかりやすく、ランプでお知らせ  ブラシヘッド認識機能で最適なモードと強さを自動設定   ブラシヘッドに内蔵されたRFID機能搭載のマイクロチップがハンドルと連携して、ブラシヘッドをハンドルに取り付けるだけで最適なモードと強さレベルを自動で設定（モード・強さはお好みで変更可能）  カドペーサー機能（時間の区切りをビープ音でお知らせする機能）  舌磨きブラシヘッドで舌の汚れを除去   200個以上のミクロの凹凸は、舌の表面の汚れを除去するために設計されています。ミクロの凹凸が舌の溝にやさしく入り込み、舌にたまった汚れを除去します。コンパクトな形状で舌全体を快適にクリーニングします。  日本の歯科医・歯科衛生士の使用率14年連続No.1の電動歯ブラシブランド   約30年にわたる研究と開発によって、進化し続けるソニッケアーブランドは、歯科医・歯科衛生士のみなさんに信頼され、長く使い続けられています。 ●本体寸法（H×W×D）：約252×31×28（mm）（ホワイトプラスブラシヘッド装着時） ●質量：約133g（ホワイトプラスブラシヘッド装着時）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/phillips/Phillips_HX687056.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/philips.png",
  },
  {
    id: "623",
    brand: "Philips",
    sku: "HX6877/56",
    product_eng: " Sonicare ProtectiveClean<Premium>White",
    product_jpn:
      " フィリップス ソニッケアー プロテクトクリーン <プレミアム> ホワイト",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥24,800",
    rrp_with_vat: "¥27,280",
    description_eng:
      " Gently and effectively removes plaque by generating sonic water flow (saliva flow in the mouth). Suitable for orthodontic appliances and dental prosthetics.   The brush head vibrates at a high speed of approximately 31,000 times per minute to knock away plaque, and the wide swing of the brush head removes the floating plaque.   At the same time, these movements generate a sonic current, a flow of saliva in the mouth, which gently and effectively scrubs away plaque.   The sonic current is also suitable for orthodontic appliances and dental prosthetics (fillings, crowns, laminate veneers) and gently polishes them.  Naturally white teeth in about 1 week   The dense central stain-removing brush removes stains and leads to naturally white teeth in about 1 week*1.   1 When using the WhitePlus brush head / Based on a study by Colgan et al. in 2010 (individual differences may occur).  Promotes healthy gums   Dense bristles remove plaque from the gingival margin and promote healthy gums. Also, the curved bristle tips easily reach back teeth.  Three modes and three strength settings allow you to choose your preferred brushing style.  Over-pressure prevention sensor function for gentle brushing of teeth and gums   When the overpressure prevention sensor detects excessive pressure being applied to the brush, it emits a pulsing sound to remind you to brush with less pressure.  Easy-to-understand lamps indicate when it is time to replace the brush head.  Brush head recognition function automatically sets the optimal mode and strength.   A microchip with RFID function built into the brush head is linked to the handle to automatically set the optimal mode and strength level by simply attaching the brush head to the handle (mode and strength can be changed as desired)Easy-to-understand lamps indicate when it is time to replace the brush head.  Cadpacer function (beeps to notify you when time is up)  Tongue polishing brush head removes tongue stains   More than 200 micro bumps are designed to remove dirt from the surface of the tongue. The micro bumps gently penetrate into the grooves of the tongue to remove dirt accumulated on the tongue. The compact shape comfortably cleans the entire tongue.  The No. 1 electric toothbrush brand used by dentists and dental hygienists in Japan for 14 consecutive years   Sonicare is trusted by dentists and dental hygienists and has been used for a long time.  ●Dimensions (H x W x D): approx. 252 x 31 x 28 (mm) (with White Plus Brush Head attached) ●Weight: approx. 133 g (with White Plus Brush Head attached)",
    description_jpn:
      " 音波水流（口の中の唾液の流れ）の発生で、やさしく効果的に歯垢を除去。矯正器具、歯科補綴物にも適します。   毎分約31,000回の高速振動で歯垢をたたき浮かせ、ブラシヘッドの幅広い振れ幅で浮かせた歯垢をはらい落とします。   同時にそれらの動きが口の中の唾液の流れ「音波水流」を発生させ、やさしく効果的に歯垢をかき出します。   音波水流は、矯正器具、歯科補綴物（詰め物、クラウン、ラミネートベニアー）にも適しており、やさしく磨きます。  約1週間で自然な白い歯へ   密集した中央のステイン除去ブラシが、約1週間※1でステインを落として歯本来の自然な白い歯に導きます。   ※1 ホワイトプラスブラシヘッド使用時/2010年Colgan氏らの調査に基づく（個人差があります。）  歯ぐきの健康を推進   密集した毛先が歯肉縁の歯垢を除去し、歯ぐきの健康を推進。また、湾曲した毛先は奥歯にも簡単に届きます。  3つのモードと3段階の強さ設定で、お好みの磨き方が選べる  過圧防止センサー機能で、歯と歯ぐきにやさしくブラッシング   過圧防止センサーが、ブラシにかけられた圧力が強いと感知した場合は、パルス音を発し、ブラシ圧を弱めてブラッシングするよう促してくれます。  ブラシヘッド交換時期をわかりやすく、ランプでお知らせ  ブラシヘッド認識機能で最適なモードと強さを自動設定   ブラシヘッドに内蔵されたRFID機能搭載のマイクロチップがハンドルと連携して、ブラシヘッドをハンドルに取り付けるだけで最適なモードと強さレベルを自動で設定（モード・強さはお好みで変更可能）  カドペーサー機能（時間の区切りをビープ音でお知らせする機能）  舌磨きブラシヘッドで舌の汚れを除去   200個以上のミクロの凹凸は、舌の表面の汚れを除去するために設計されています。ミクロの凹凸が舌の溝にやさしく入り込み、舌にたまった汚れを除去します。コンパクトな形状で舌全体を快適にクリーニングします。  日本の歯科医・歯科衛生士の使用率14年連続No.1の電動歯ブラシブランド   約30年にわたる研究と開発によって、進化し続けるソニッケアーブランドは、歯科医・歯科衛生士のみなさんに信頼され、長く使い続けられています。 ●本体寸法（H×W×D）：約252×31×28（mm）（ホワイトプラスブラシヘッド装着時） ●質量：約133g（ホワイトプラスブラシヘッド装着時）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/phillips/Phillips_HX687756.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/philips.png",
  },
  {
    id: "624",
    brand: "Philips",
    sku: "HX9911/57",
    product_eng: "Sonicare DiamondClean 9000 White",
    product_jpn: "フィリップス ダイヤモンドクリーン9000 ホワイト",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥39,900",
    rrp_with_vat: "¥43,890",
    description_eng:
      " Approaches all aspects of plaque, stains, and gum health. Plaque removal power up to 20 times greater than manual brushing.   Sonicare's sonic technology with high-speed vibration x amplitude x sonic water flow and premium all-in-one brush head provide a clean finish. The angled bristle tips remove up to 20 times more plaque than manual brushing, even in hard-to-reach areas*1, and the triangular cut tips remove up to twice as much stain in two days*2, leaving your teeth naturally white. The long bristles also clean the border between teeth and gums to promote gum health in 2 weeks*3.  *1 Compared to manual brushing / When premium all-in-one brush head is used / Philips research  *2 Comparison by brushing with a premium all-in-one brush head and a manual brush with artificial stain on a plastic plate / using commercial toothpaste in clean mode / researched by Philips / may differ in actual oral conditions   *3 Comparison with manual brushing when using clean mode / Philips study / may differ from actual in-mouth use  Sonicare App Progress Report supports brushing habits   The handle and the app are paired via Bluetooth(R)5 to record your daily brushing. You can check the number of times you brush, the time, and the strength of your brushing on the screen of your smartphone, supporting you to brush better. There is no need to take your smartphone with you when you brush your teeth. Just open the application when you have time, and the contents recorded by the handle will be reflected in the application.  4 modes and 3 strength settings to meet diverse brushing needs   The Diamond Clean 9000 is equipped with the following modes: Clean (basic brushing mode), White Plus (removes stains and polishes up), Gum Health (removes plaque and gently stimulates gums), and Deep Clean Plus (removes plaque thoroughly with comfortable vibration), The brush is designed to meet a variety of brushing needs. The brusher also offers three brushing intensity settings to choose from: low, medium, and high.  Glass Charging & Travel Case Charging for Your Benefit   You can charge the battery using the included charger with glass. The travel case can be charged from a computer via USB connection, making it convenient for brushing teeth while traveling or at the office.  Over-pressure prevention sensor function for gentle brushing of teeth and gums.  Brush head recognition function automatically sets the optimal mode and strength   Microchip with RFID function built into the brush head works with the handle to automatically set the optimal mode and strength level by simply attaching the brush head to the handle (mode and strength can be changed as desired).  Easy-to-understand lamps indicate when it is time to replace the brush head  The No.1 electric toothbrush brand used by dentists and dental hygienists in Japan for 14 consecutive years   The Sonicare brand, which has been evolving through 30 years of research and development, is trusted by dentists and dental hygienists, who continue to use it for a long time. ●Included: Premium All-in-One Brush White (1), Premium Gum Care Brush Head White (1), Charger Glass (1), Charger Stand (1), USB Charging Travel Case White (1) ●Dimensions (H x W x D): approx. 252 x 31 x 28 mm (with Premium All-in-One Brush Head attached) ●Weight: approx. 134 g (with Premium All-in-One Brush Head)",
    description_jpn:
      " 歯垢、ステイン、歯ぐきの健康すべてにアプローチ。歯垢除去力は手磨きの最大20倍   ソニッケアーの高速振動×振幅×音波水流による音波テクノロジーとプレミアムオールインワンブラシヘッドで、きれいな仕上がりを実現します。角度のついたアングル毛先は、届きにくい場所でも手磨きの最大20倍の歯垢を除去できます※1。先端はトライアングルカットで、2日間で最大2倍のステイン（着色汚れ）を除去し※2、歯本来の自然な白さに導きます。また、長めの毛先は歯と歯ぐきの境い目を洗浄し、2週間で歯ぐきの健康を推進します※3。  ※1 手磨きと比べ/プレミアムオールインワンブラシヘッド使用時/フィリップス調べ  ※2 プラスチック板に人工ステインを塗り、プレミアムオールインワンブラシヘッドと手磨きブラシでのブラッシングによる比較/クリーンモードで市販の歯磨き粉を使用/フィリップス調べ/実際の口内では異なる場合があります   ※3 クリーンモード使用時/手磨きと比べ/フィリップス調べ  ソニッケアーアプリ・プログレスレポートで歯磨き習慣をサポート   ハンドルとアプリがBluetooth（R）5でペアリングし、毎日の歯磨きを記録します。磨いた回数や時間、ブラッシングの強さなどをスマートフォンの画面で確認でき、より良いブラッシングへとサポートします。歯磨きする際にスマホを持っていく必要はなく、時間があるときにアプリを開けばハンドルで記録した内容がアプリに反映されます。  4つのモード、3段階の強さ設定で多様なブラッシングニーズに対応     ダイヤモンドクリーン 9000 には、クリーン（基本のブラッシングモード）、ホワイトプラス（ステインを落とし磨き上げる）、ガムヘルス（歯垢を落とし、歯ぐきにやさしい刺激を）、ディープクリーンプラス（心地よい振動で歯垢をしっかり除去）のモードが搭載されており、さまざまなブラッシングのニーズに対応します。ブラッシングの強さ設定も弱、中、強の3段階からお選びいただけます。  グラス充電＆トラベルケース充電で利   付属のグラス付充電器を使って充電ができます。トラベルケースはUSB接続でパソコンから充電でき旅行先やオフィスでの歯磨きにも便利です  過圧防止センサー機能で、歯と歯ぐきにやさしくブラッシング  ブラシヘッド認識機能で最適なモードと強さを自動設定   ブラシヘッドに内蔵されたRFID機能搭載のマイクロチップがハンドルと連携して、ブラシヘッドをハンドルに取り付けるだけで最適なモードと強さレベルを自動で設定（モード・強さはお好みで変更可能）  ブラシヘッド交換時期をわかりやすくランプでお知らせ  日本の歯科医・歯科衛生士の使用率14年連続No.1の電動歯ブラシブランド   約30年にわたる研究と開発によって、進化し続けるソニッケアーブランドは、歯科医・歯科衛生士のみなさんに信頼され、長く使い続けられています。 ●同梱物：プレミアムオールインワンブラシ ホワイト 1本、プレミアムガムケアブラシヘッド ホワイト 1本、充電器用グラス 1個、充電器台 1個、USB充電トラベルケース ホワイト 1個 ●本体寸法（H×W×D）：約252×31×28 mm（プレミアムオールインワンブラシヘッド装着時） ●質量：約134g（プレミアムオールインワンブラシヘッド装着時）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/phillips/Phillips_HX991157.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/philips.png",
  },
  {
    id: "625",
    brand: "Philips",
    sku: "HX9911/58",
    product_eng: "Sonicare DiamondClean 9000 Pink",
    product_jpn: "フィリップス ダイヤモンドクリーン9000 ピンク",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥39,900",
    rrp_with_vat: "¥43,890",
    description_eng:
      " Approaches all aspects of plaque, stains, and gum health. Plaque removal power up to 20 times greater than manual brushing.   Sonicare's sonic technology with high-speed vibration x amplitude x sonic water flow and premium all-in-one brush head provide a clean finish. The angled bristle tips remove up to 20 times more plaque than manual brushing, even in hard-to-reach areas*1, and the triangular cut tips remove up to twice as much stain in two days*2, leaving your teeth naturally white. The long bristles also clean the border between teeth and gums to promote gum health in 2 weeks*3.  *1 Compared to manual brushing / When premium all-in-one brush head is used / Philips research  *2 Comparison by brushing with a premium all-in-one brush head and a manual brush with artificial stain on a plastic plate / using commercial toothpaste in clean mode / researched by Philips / may differ in actual oral conditions   *3 Comparison with manual brushing when using clean mode / Philips study / may differ from actual in-mouth use  Sonicare App Progress Report supports brushing habits   The handle and the app are paired via Bluetooth(R)5 to record your daily brushing. You can check the number of times you brush, the time, and the strength of your brushing on the screen of your smartphone, supporting you to brush better. There is no need to take your smartphone with you when you brush your teeth. Just open the application when you have time, and the contents recorded by the handle will be reflected in the application.  4 modes and 3 strength settings to meet diverse brushing needs   The Diamond Clean 9000 is equipped with the following modes: Clean (basic brushing mode), White Plus (removes stains and polishes up), Gum Health (removes plaque and gently stimulates gums), and Deep Clean Plus (removes plaque thoroughly with comfortable vibration), The brush is designed to meet a variety of brushing needs. The brusher also offers three brushing intensity settings to choose from: low, medium, and high.  Glass Charging & Travel Case Charging for Your Benefit   You can charge the battery using the included charger with glass. The travel case can be charged from a computer via USB connection, making it convenient for brushing teeth while traveling or at the office.  Over-pressure prevention sensor function for gentle brushing of teeth and gums.  Brush head recognition function automatically sets the optimal mode and strength   Microchip with RFID function built into the brush head works with the handle to automatically set the optimal mode and strength level by simply attaching the brush head to the handle (mode and strength can be changed as desired).  Easy-to-understand lamps indicate when it is time to replace the brush head  The No.1 electric toothbrush brand used by dentists and dental hygienists in Japan for 14 consecutive years   The Sonicare brand, which has been evolving through 30 years of research and development, is trusted by dentists and dental hygienists, who continue to use it for a long time. ●Included: Premium All-in-One Brush White (1), Premium Gum Care Brush Head White (1), Charger Glass (1), Charger Stand (1), USB Charging Travel Case White (1) ●Dimensions (H x W x D): approx. 252 x 31 x 28 mm (with Premium All-in-One Brush Head attached) ●Weight: approx. 134 g (with Premium All-in-One Brush Head)",
    description_jpn:
      " 歯垢、ステイン、歯ぐきの健康すべてにアプローチ。歯垢除去力は手磨きの最大20倍   ソニッケアーの高速振動×振幅×音波水流による音波テクノロジーとプレミアムオールインワンブラシヘッドで、きれいな仕上がりを実現します。角度のついたアングル毛先は、届きにくい場所でも手磨きの最大20倍の歯垢を除去できます※1。先端はトライアングルカットで、2日間で最大2倍のステイン（着色汚れ）を除去し※2、歯本来の自然な白さに導きます。また、長めの毛先は歯と歯ぐきの境い目を洗浄し、2週間で歯ぐきの健康を推進します※3。  ※1 手磨きと比べ/プレミアムオールインワンブラシヘッド使用時/フィリップス調べ  ※2 プラスチック板に人工ステインを塗り、プレミアムオールインワンブラシヘッドと手磨きブラシでのブラッシングによる比較/クリーンモードで市販の歯磨き粉を使用/フィリップス調べ/実際の口内では異なる場合があります   ※3 クリーンモード使用時/手磨きと比べ/フィリップス調べ  ソニッケアーアプリ・プログレスレポートで歯磨き習慣をサポート   ハンドルとアプリがBluetooth（R）5でペアリングし、毎日の歯磨きを記録します。磨いた回数や時間、ブラッシングの強さなどをスマートフォンの画面で確認でき、より良いブラッシングへとサポートします。歯磨きする際にスマホを持っていく必要はなく、時間があるときにアプリを開けばハンドルで記録した内容がアプリに反映されます。  4つのモード、3段階の強さ設定で多様なブラッシングニーズに対応     ダイヤモンドクリーン 9000 には、クリーン（基本のブラッシングモード）、ホワイトプラス（ステインを落とし磨き上げる）、ガムヘルス（歯垢を落とし、歯ぐきにやさしい刺激を）、ディープクリーンプラス（心地よい振動で歯垢をしっかり除去）のモードが搭載されており、さまざまなブラッシングのニーズに対応します。ブラッシングの強さ設定も弱、中、強の3段階からお選びいただけます。  グラス充電＆トラベルケース充電で利   付属のグラス付充電器を使って充電ができます。トラベルケースはUSB接続でパソコンから充電でき旅行先やオフィスでの歯磨きにも便利です  過圧防止センサー機能で、歯と歯ぐきにやさしくブラッシング  ブラシヘッド認識機能で最適なモードと強さを自動設定   ブラシヘッドに内蔵されたRFID機能搭載のマイクロチップがハンドルと連携して、ブラシヘッドをハンドルに取り付けるだけで最適なモードと強さレベルを自動で設定（モード・強さはお好みで変更可能）  ブラシヘッド交換時期をわかりやすくランプでお知らせ  日本の歯科医・歯科衛生士の使用率14年連続No.1の電動歯ブラシブランド   約30年にわたる研究と開発によって、進化し続けるソニッケアーブランドは、歯科医・歯科衛生士のみなさんに信頼され、長く使い続けられています。 ●同梱物：プレミアムオールインワンブラシ ホワイト 1本、プレミアムガムケアブラシヘッド ホワイト 1本、充電器用グラス 1個、充電器台 1個、USB充電トラベルケース ホワイト 1個 ●本体寸法（H×W×D）：約252×31×28 mm（プレミアムオールインワンブラシヘッド装着時） ●質量：約134g（プレミアムオールインワンブラシヘッド装着時）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/phillips/Phillips_HX991158.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/philips.png",
  },
  {
    id: "626",
    brand: "SHARP",
    sku: "KC-40TH7-W",
    product_eng: "SHARP Humidified Air Purifiers KC-40TH7",
    product_jpn: "SHARP シャープ 加湿空気清浄機 KC-40TH7",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥19,800",
    rrp_with_vat: "¥21,780",
    description_eng:
      "Air purification, deodorization, and static elimination. Equipped with Plasmacluster 7000.  ●Maximum humidification 400mL/h ●Speed circulation airflow and wide suction at the back of the unit ●Integrated filter for dust collection and deodorization ●Quiet and comfortable with sleep operation ●Ag+ ion cartridge ●Captures 99% of particles between 0.1 and 2.5 micrometers in size with PM2.5 compatibility. Tank capacity: approx. 2.5L Plasmacluster applicable floor area: Approx. 11 mats Applicable floor area for air purification: up to 18 mats Applicable floor area for humidification：Wooden: up to 7 mats, Prefabricated Western-style rooms: up to 11 mats Product size: (approx.) W 39.9 x D 23 x H 61.3 cm Product weight: approx. 7.5 kg",
    description_jpn:
      "空気浄化・消臭・除電。 プラズマクラスター7000搭載。  ●最大加湿量400mL/h ●スピード循環気流＆背面ワイド吸引 ●集じん・脱臭一体型フィルター ●おやすみ運転で静かに快適 ●Ag+イオンカートリッジ ●PM2.5対応で0.1～2.5マイクロメートルの粒子を99%キャッチ タンク容量：約2.5L プラズマクラスター適用床面積：約11畳 空気清浄適用床面積：～18畳 加湿適用床面積：木造 ～7畳、プレハブ洋室 ～11畳 商品サイズ：（約）幅39.9×奥行23×高さ61.3cm 商品重量：約7.5kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/sharp/SHARP_KC-40TH7-W.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/sharp.png",
  },
  {
    id: "627",
    brand: "SHARP",
    sku: "KCM511-W",
    product_eng: "SHARP Humidified Air Purifiers KCM511-W",
    product_jpn: "SHARP シャープ 加湿空気清浄機 KCM511-W",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥32,000",
    rrp_with_vat: "¥35,200",
    description_eng:
      "Slim and space-saving. Standard humidifying air purifier model suitable for various scenes  ・Front suction and top blowout for wall-sitting installation and a power cord that can be pulled out from the bottom  ・Equipped with a high-performance filter that captures odors and dust.  ・Simple display for easy operation  ・Plasmacluster 7000, Sharp's unique air purification technology, is installed.  Plasmacluster applicable floor area: approx. 21m² (approx. 13 tatami mats) Applicable floor area for air purification：～38m² (23 tatami mats) Humidification applicable floor area：Prefabricated Western-style room: ~23m² (14 tatami mats) / Wooden Japanese-style room: ~14m² (8.5 tatami mats) Tank capacity: Approx. 2.5L External dimensions: 400 mm (W) x 220 mm (D) x 600 mm (H) Weight: approx. 8.4 kg",
    description_jpn:
      "スリムで省スペース。様々なシーンに適した加湿空気清浄機スタンダードモデル  ・前吸い込みと上吹き出しによる壁ピタ設置・底面引き出し電源コード採用  ・ニオイやホコリをしっかりキャッチする高性能フィルター搭載  ・簡単に操作できるシンプル表示  ・シャープ独自の空気浄化技術、プラズマクラスター7000を搭載しています。  プラズマクラスター適用床面積：約21m²（約13畳） 空気清浄適用床面積：～38m²（23畳） 加湿適用床面積：プレハブ洋室 〜23m²（14畳）/ 木造和室〜14m²（8.5畳） タンク容量：約2.5L 外形寸法：幅400×奥行220×高さ600mm 質量：約8.4kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/sharp/SHARP_KCM511-W.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/sharp.png",
  },
  {
    id: "628",
    brand: "SHARP",
    sku: "KCM511-B",
    product_eng: "SHARP Humidified Air Purifiers KCM511-B",
    product_jpn: "SHARP シャープ 加湿空気清浄機 KCM511-B",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥32,000",
    rrp_with_vat: "¥35,200",
    description_eng:
      "Slim and space-saving. Standard humidifying air purifier model suitable for various scenes  ・Front suction and top blowout for wall-sitting installation and a power cord that can be pulled out from the bottom  ・Equipped with a high-performance filter that captures odors and dust.  ・Simple display for easy operation  ・Plasmacluster 7000, Sharp's unique air purification technology, is installed.  Plasmacluster applicable floor area: approx. 21m² (approx. 13 tatami mats) Applicable floor area for air purification：～38m² (23 tatami mats) Humidification applicable floor area：Prefabricated Western-style room: ~23m² (14 tatami mats) / Wooden Japanese-style room: ~14m² (8.5 tatami mats) Tank capacity: Approx. 2.5L External dimensions: 400 mm (W) x 220 mm (D) x 600 mm (H) Weight: approx. 8.4 kg",
    description_jpn:
      "スリムで省スペース。様々なシーンに適した加湿空気清浄機スタンダードモデル  ・前吸い込みと上吹き出しによる壁ピタ設置・底面引き出し電源コード採用  ・ニオイやホコリをしっかりキャッチする高性能フィルター搭載  ・簡単に操作できるシンプル表示  ・シャープ独自の空気浄化技術、プラズマクラスター7000を搭載しています。  プラズマクラスター適用床面積：約21m²（約13畳） 空気清浄適用床面積：～38m²（23畳） 加湿適用床面積：プレハブ洋室 〜23m²（14畳）/ 木造和室〜14m²（8.5畳） タンク容量：約2.5L 外形寸法：幅400×奥行220×高さ600mm 質量：約8.4kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/sharp/SHARP_KCM511-B.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/sharp.png",
  },
  {
    id: "629",
    brand: "audio-technica",
    sku: "ATH-TWX9",
    product_eng: "audio-technica Wireless Earbuds",
    product_jpn: "audio-technica オーディオテクニカ 完全ワイヤレスイヤホン",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥33,000",
    rrp_with_vat: "¥36,300",
    description_eng:
      "Innovative sound that connects people to their hearts. Noise canceling to create a special silence.   Concentration of meticulously designed acoustic technology in earphones. Maximize the experience level of uncompromising sound quality and noise-canceling effect. In a quiet space, you can experience extended high frequencies and grainy, delicate sound.  Two noise canceling systems for your own personal space Two small MEMS noise-canceling microphones, one for each earphone, pick up ambient noise and transmit it to a high-precision noise-canceling processor. This maximizes noise cancellation performance and cancels out unwanted noise. Five preset noise canceling modes to choose from based on the situation.  Cavity-fit design for a natural fit in the ear that makes you forget you are wearing them. A total of 12 types of earpieces with three different conduit lengths are included. Special fit as if tailored for each individual.  Reliable communication performance that conveys every nuance in business situations Compact, high-performance MEMS microphones are placed in two locations on the earphone housing. Sidetone function for easier speaking. Ambience control (function/hear-through function/off switch) during calls, depending on the situation. Microphone mute function to avoid picking up unwanted sounds during a call.  Hear-Through: Listen, Talk, and Hear Hear-through function allows you to enjoy music while letting outside sounds in naturally. Occlusion canceling function that allows you to speak without muffling your voice. A quick hear-through function allows you to lower the volume during playback and listen to your voice right away.  A charging case with a deep UV sterilization system that refreshes you every time you finish using the device. Deep ultraviolet LEDs that sterilize bacteria and viruses are irradiated to automatically sterilize the surface of the earpieces.  Convenient functions for more seamless use Supports multi-point connection to two Bluetooth devices at the same time. Qi wireless charging is supported. QualcommTrueWireless Mirroring for independent left/right transmission. low latency mode to minimize the gap between sound and imHear-Through: Listen, Talk, and Hear  Charging time Earphones: approx. 2.5 hours / Charging case: approx. 3.5 hours (USB charging), approx. 5.0 hours (wireless charging) Usable time Continuous communication (during music playback): Max. 6.0 hours (earphone), Max. 18.5 hours (with charging case) Weight Earphone: approx. 5.4g (L side), approx. 5.4g (R side) / Charging case: approx. 55.9g Drip-proof specification IPX4 (main body of earphone only)",
    description_jpn:
      "人と心をつなぐ、革新のサウンド。特別な静寂を仕立てるノイズキャンセリング。   緻密に練り上げた音響テクノロジーをイヤホンに凝縮 妥協のない音質とノイズキャンセリング効果の体感レベルを最大限に高めること。静寂空間の中で、伸びやかな高域や粒立ちの良い繊細な音の鳴りを体験できます。  ２つのノイズキャンセリングシステムで、あなただけの空間へ 左右のイヤホンに、それぞれ2基ずつ用意されたノイズキャンセリング用小型MEMSマイクが周りの環境ノイズを拾い、高精度ノイズキャンセリングプロセッサーに伝送。ノイズキャンセル性能を最大限に高め、不要な雑音を打ち消します。シチュエーションから選べる５種のプリセットノイズキャンセリングモード。  着けているのを忘れる、耳に自然なキャビティフィット設計 導管の長さが異なる３種類のイヤピースを計12種類付属。一人ひとりに仕立てられたような特別な装着感  ビジネスシーンでニュアンスまで伝わる、確かなコミュニケーション性能 イヤホン筐体の２箇所に、小型の高性能MEMSマイクを配置。話しやすくなるサイドトーン機能。状況に応じて、通話中もアンビエンスコントロール(機能／ヒアスルー機能／OFFの切り替え)。通話中に不要な音を拾わないマイクミュート機能  聴ける、話せる、ヒアスルー 外の音を自然に取り込みながら、音楽が楽しめるヒアスルー機能。自分の発する声がこもらずに話せるオクルージョン（こもり）キャンセリング搭載。再生中の音量を下げ、今すぐ声が聴けるクイックヒアスルー機能。  使い終えるたびリフレッシュ、深紫外線除菌システムを搭載した充電ケース 細菌やウイルスを除菌する深紫外線LEDが照射され、イヤピースの表面除菌を自動的に行います。  よりシームレスに使える便利機能 2台のBluetooth機器へ同時接続できるマルチポイントに対応。使用頻度や利き手に合わせて操作をパーソナライズ。Qi規格のワイヤレス充電に対応。左右独立伝送に対応する QualcommTrueWireless Mirroring。音と映像のずれを抑える低遅延モード  充電時間   イヤホン：約2.5時間/充電ケース：約3.5時間(USB充電時)、約5.0時間(ワイヤレス充電時) 使用可能時間 連続通信(音楽再生時)：最大約6.0時間(イヤホン)、最大約18.5時間(充電ケース併用時) 質量  イヤホン：約5.4g(L側)、約5.4g(R側)/充電ケース：約55.9g 防滴仕様  IPX4(イヤホン本体のみ)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/audio_technica/audiotechnica_ATH-TWX9.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/audio-technica.png",
  },
  {
    id: "632",
    brand: "audio-technica",
    sku: "ATH-CKR100",
    product_eng: "audio-technica inner-ear headphones",
    product_jpn: "audio-technica オーディオテクニカ インナーイヤーヘッドホン",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥39,880",
    rrp_with_vat: "¥43,868",
    description_eng:
      " High-resolution reproduction of high-resolution sound sources to the utmost limit with two φ13mm drivers employing a pure iron yoke that efficiently transmits magnetism.  Aluminum stabilizer that improves front-to-back linear motion for highly responsive and faithful sound reproduction.  Highly rigid titanium housing with excellent acoustic characteristics thoroughly eliminates unwanted resonance.  Independent L/R channels with star-cad stranded wires for noise-free signal transmission  Audio-dedicated detachable connector (A2DC*) designed for superior noise immunity and ease of maintenance  Weight (excluding cord): Approx. 14g  Accessories:  Cord (detachable): 1.2m (φ3.5mm gold-plated stereo mini plug, L-type)  Case, earpieces (XS, S, M, L)",
    description_jpn:
      " 効率良く磁気を伝達する純鉄ヨーク採用のφ13mmドライバー×2によりハイレゾ音源を極致まで描く高解像度再生  前後直進運動を向上させるアルミニウムスタビライザーで高レスポンスかつ忠実な音を再現  優れた音響特性の高剛性チタニウムハウジングにより不要共振を徹底排除  L/Rch独立のスターカッド撚り線でノイズの少ない信号伝送を実現  ノイズへの耐性とメンテナンス性に優れたオーディオ専用設計の着脱式コネクター（A2DC*）を採用  質量（コード除く）：約14g  付属品：  コード(着脱式)：1.2m(φ3.5mm金メッキステレオミニプラグ L型)  ケース、イヤピース(XS，S，M，L)",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/audio_technica/audiotechnica_ATH-CKR100.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/audio-technica.png",
  },
  {
    id: "633",
    brand: "audio-technica",
    sku: "ATH-A2000Z",
    product_eng: "audio-technica Art Monitor® headphones",
    product_jpn: "audio-technica オーディオテクニカ アートモニターヘッドホン",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥79,880",
    rrp_with_vat: "¥87,868",
    description_eng:
      "The purest sound spun by the intrepid titanium body and magnesium baffle   Newly developed φ53mm driver that spins Audio-Technica's traditional sound  Highly rigid magnesium baffle with high internal loss effectively suppresses unwanted vibrations  Dual-layer housing with D.A.D.S. structure (PAT.) for enhanced air damping effect to reproduce extended bass.  New 3D-type wing support that maintains a comfortable fit with excellent head balance and a good sealed feeling.  Cord specification with left-right and right-right independent grounding wire (4-core) structure for thorough pursuit of sound quality  3D sewn earpads made of low-resilience material to minimize fatigue even after long hours of listening.  Main body weight 294g",
    description_jpn:
      "精悍なチタニウムボディとマグネシウム製バッフルが紡ぎ出す至純のサウンド   オーディオテクニカ伝統の音を紡ぐ新開発φ53mmドライバー  剛性に優れ、内部損失の高いマグネシウム製バッフルで不要振動を効果的に抑制  二重構造ハウジングで空気のダンピング効果を高めるD.A.D.S.構造(PAT.)により伸びやかな低音を再現  優れたヘッドバランスとほどよい密閉感で快適な装着感をキープする新3D方式ウイングサポート  音質を徹底追求した左右両出しの左右独立アース線(4芯)構造のコード仕様  長時間リスニングでも疲れにくい低反発素材の立体縫製イヤパッド  本体重量  294ｇ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/audio_technica/audiotechnica_ATH-A2000Z.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/audio-technica.png",
  },
  {
    id: "634",
    brand: "audio-technica",
    sku: "ATH-AD2000X",
    product_eng: "audio-technica Air Dynamic Headphones ",
    product_jpn:
      "audio-technica オーディオテクニカ エアーダイナミックヘッドホン",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥64,880",
    rrp_with_vat: "¥71,368",
    description_eng:
      "Once again, the peak of open-air sound. The AD2000X is a supreme sound system that lets you experience the vastness of the soundstage.   φ53mm driver exclusively designed for AD2000X with Permendur magnetic circuit + OFC7N voice coil for accurate expression of even the most detailed sounds.   The AD2000X is equipped with a specially designed driver that uses the Permendur magnetic material with excellent acoustic characteristics and an OFC7N voice coil made of oxygen-free copper with a purity of 99.99999%. Newly designed diffuser to diffuse the air inside the housing for a more expansive sound.  Input cord with left-right and right-right independent grounding wire (4-core) structure for high sound quality   High sound quality is made possible by a 4-core structure that eliminates transmission loss between the left and right sides and pursues a balanced sound.  Adoption of ultra-lightweight design joint and frame made of magnesium alloy   Lightweight and rigid magnesium is used for the joint and frame, realizing a weight of 265g.  3D wing support for a light wearing comfort. Total ear fit design with reduced pressure sensation.   The shape has been changed from the surface contact used in the AD series to a line contact. The new design allows users to enjoy wearing the earbuds for extended periods of time with comfort.  High-quality fit with low-resilience earpads made of durable and comfortable suede material   In contrast to the wing support, the earpads have been changed from line contact to surface contact. This prevents the low-frequency range from becoming dull and reproduces powerful bass sound.",
    description_jpn:
      "今ふたたび、オープンエアーの頂(ピーク)をきわめる。広大な音場を実体感できる至高のサウンド。   パーメンジュール磁気回路＋OFC7Nボイスコイル採用のAD2000X専用設計φ53mmドライバーで緻密な音まで正確に表現   音響特性に優れた磁気素材 パーメンジュール と純度99.99999％の無酸素銅を OFC7Nボイスコイル を採用した専用設計ドライバーを搭載。ハウジング内部の空気を拡散する新設計ディフューザーを搭載し音の広がりを追求。  音質を重視した左右両出し左右独立アース線(4芯)構造の入力コード   左右の伝送ロスをなくし、バランスの取れた音を追求した4芯構造で高音質を可能にしました。  マグネシウム合金の超軽量設計ジョイント&フレームを採用   ジョイントとフレームに軽量かつ剛性の高いマグネシウムを採用し、重量265gを実現しました。  3Dウイングサポートで軽快な装着感を追求。圧迫感を抑えたトータルイヤフィット設計   これまでADシリーズで採用していた「面」接触から「線」接触に形状を変更。長時間でも快適な着け心地でお楽しみいただけます。  耐久性があり、肌触りも良いスウェード素材の低反発イヤパッドで上質なフィット感   ウイングサポートとは逆に、イヤパッドはこれまでの「線」接触から「面」接触に変更。低域のヌケを防ぎ迫力の低音を再生します。",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/audio_technica/audiotechnica_ATH-AD2000X.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/audio-technica.png",
  },
  {
    id: "635",
    brand: "Swarovski",
    sku: "5636717",
    product_eng:
      "Swarovski Constella drop earrings Round cut, White, Rhodium plated ",
    product_jpn:
      "Swarovski スワロフスキー Constella ドロップピアス ラウンドカット, ホワイト, ロジウム・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Earring",
    rrp_ex_vat: "¥18,000",
    rrp_with_vat: "¥19,800",
    description_eng:
      "These mesmerizing drop earrings from the Constella family have wear-forever power. Striking the balance between dramatic and refined, dazzling centre stones are enhanced with pavé on the gallery and hoops, which are set with rhodium plating. Wear them with your hair tucked to really let them shine.  ・Collection:  Constella ・Colour:  White ・Length: 1.8 cm ・Width: 0.7 cm ・Material:  Crystals, Rhodium plated, Zirconia ・Weight (individual piece):  1.3 g",
    description_jpn:
      "Constellaシリーズの魅惑的なドロップピアスには、毎日身につけられるパワーがみなぎっています。まばゆい輝きのセンターストーンに、パヴェを施したフープをロジウム・コーティングで仕上げました。ドラマチックと洗練さがバランスしています。まとめた髪につけると、より一層の輝きを放ちます。  ・コレクション:  Constella ・色:  ホワイト ・長さ: 1.8 cm ・幅: 0.7 cm ・素材:  クリスタル, ロジウム・コーティング, ジルコニア ・重さ（片方）:  1.3 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5636717.jpeg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5636717_1.jpeg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "636",
    brand: "Swarovski",
    sku: "5638802",
    product_eng:
      "Swarovski Constella drop earrings Round cut, White, Gold-tone plated ",
    product_jpn:
      "Swarovski スワロフスキー Constella ドロップピアスラウンドカット, ホワイト, ゴールドトーン・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Earring",
    rrp_ex_vat: "¥18,000",
    rrp_with_vat: "¥19,800",
    description_eng:
      "These mesmerizing drop earrings from the Constella family have wear-forever power. Striking the balance between dramatic and refined, dazzling centre stones are enhanced with pavé on the gallery and hoops, which are set with gold-tone plating. Wear them with your hair tucked to really let them shine.  ・Collection:  Constella ・Colour:  White ・Length: 1.8 cm ・Width: 0.7 cm ・Material:  Crystals, Gold-tone plated, Zirconia ・Weight (individual piece):  1.3 g",
    description_jpn:
      "Constellaシリーズの魅惑的なドロップピアスには、毎日身につけられるパワーがみなぎっています。まばゆい輝きのセンターストーンに、パヴェを施したフープをゴールドトーン・コーティングで仕上げました。ドラマチックと洗練さがバランスしています。まとめた髪につけると、より一層の輝きを放ちます。  ・コレクション:  Constella ・色:  ホワイト ・長さ: 1.8 cm ・幅: 0.7 cm ・素材:  クリスタル, ゴールドトーン・プレーティング, ジルコニア ・重さ（片方）:  1.3 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5638802.jpeg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5638802_1.jpeg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "637",
    brand: "Swarovski",
    sku: "5662919",
    product_eng:
      "Swarovski Stilla drop earrings, Square cut, White, Rhodium plated",
    product_jpn:
      "Swarovski スワロフスキー Stilla ドロップピアス スクエア・カット, ホワイト, ロジウム・プレーティング ",
    category_1: "Jewelry & Watches",
    category_2: "Earring",
    rrp_ex_vat: "¥16,000",
    rrp_with_vat: "¥17,600",
    description_eng:
      "These radiant Stilla earrings are a perfect example of simple sophistication. Each rhodium plated piece features a clear faceted Swarovski Zirconia surrounded by clear sq Find out more  ・Collection:  Stilla ・Colour:  White ・Size: 2 x 0.8 cm ・Material:  Crystals, Rhodium plated, Zirconia ・Weight (individual piece):  1.9 g",
    description_jpn:
      "この光り輝くStillaピアスは、シンプルな洗練を見事に表現しています。ロジウム・コーティングを施したピアスは、ミニフープからゆれ動く、クリアなスクエア・クリスタルに囲まれたクリアなファセットカットのSwarovskiジルコニアが魅力です。自然体のエレガンス。  ・コレクション:  Stilla ・色:  ホワイト ・サイズ: 2 x 0.8 cm ・素材:  クリスタル, ロジウム・コーティング, ジルコニア ・重さ（片方）:  1.9 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5662919.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "638",
    brand: "Swarovski",
    sku: "5636269",
    product_eng:
      "Swarovski Constella stud earrings Round cut, Pavé, White, Rhodium plated ",
    product_jpn:
      "Swarovski スワロフスキー Constella スタッドピアス ラウンドカット, パヴェ, ホワイト, ロジウム・プレーティング ",
    category_1: "Jewelry & Watches",
    category_2: "Earring",
    rrp_ex_vat: "¥16,000",
    rrp_with_vat: "¥17,600",
    description_eng:
      "Get ready to shine in these mesmerizing stud earrings from the Constella family. Showcasing clear stones that are illuminated with Swarovski's exquisite pavé technique, this effortless pair is finished with a rhodium plated setting. Instant wonder for every day.  ・Collection:  Constella ・Colour:  White ・Length: 0.9 cm ・Width: 0.9 cm ・Material:  Rhodium plated, Zirconia ・Weight (individual piece):  1.3 g",
    description_jpn:
      "Constellaシリーズの魅惑的なスタッドピアスで、輝きを放ちましょう。スワロフスキーの精緻なパヴェ技法を施したクリアストーンが輝くエフォートレスなピアスは、ロジウム・コーティングのセッティングで仕上げました。日常で感動を体験しましょう。  ・コレクション:  Constella ・色:  ホワイト ・長さ: 0.9 cm ・幅: 0.9 cm ・素材:  ロジウム・コーティング, ジルコニア ・重さ（片方）:  1.3 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5636269.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "639",
    brand: "Swarovski",
    sku: "5636275",
    product_eng:
      "Swarovski Constella stud earrings Round cut, Pavé, White, Rose gold-tone plated ",
    product_jpn:
      "Swarovski スワロフスキー Constella スタッドピアス ラウンドカット, パヴェ, ホワイト, ローズゴールドトーン・プレーティング ",
    category_1: "Jewelry & Watches",
    category_2: "Earring",
    rrp_ex_vat: "¥16,000",
    rrp_with_vat: "¥17,600",
    description_eng:
      "Get ready to shine in these mesmerizing stud earrings from the Constella family. Showcasing clear stones that are illuminated with Swarovski's exquisite pavé technique, this effortless pair is finished with a rose gold-tone plated setting. Instant wonder for every day.  ・Collection:  Constella ・Colour:  White ・Length: 0.9 cm ・Width: 0.9 cm ・Material:  Rose gold-tone plated, Zirconia ・Weight (individual piece):  1.3 g",
    description_jpn:
      "Constellaシリーズの魅惑的なスタッドピアスで、輝きを放ちましょう。スワロフスキーの精緻なパヴェ技法を施したクリアストーンが輝くエフォートレスなピアスは、ローズゴールドトーン・プレーティングのセッティングで仕上げました。日常で感動を体験しましょう。  ・コレクション:  Constella ・色:  ホワイト ・長さ: 0.9 cm ・幅: 0.9 cm ・素材:  ローズゴールドトーン・プレーティング, ジルコニア ・重さ（片方）:  1.3 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5636275.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "640",
    brand: "Swarovski",
    sku: "5505470",
    product_eng:
      "Swarovski Angelic stud earrings Round cut, White, Gold-tone plated ",
    product_jpn:
      "Swarovski スワロフスキー Angelic スタッドピアス ラウンドカット, ホワイト, ゴールドトーン・プレーティング ",
    category_1: "Jewelry & Watches",
    category_2: "Earring",
    rrp_ex_vat: "¥14,000",
    rrp_with_vat: "¥15,400",
    description_eng:
      "This classic pair of pierced earrings will enhance any outfit with their timeless and elegant design. The gold-tone plated design displays a single clear crystal framed in pavé for beautiful sparkle. Pair with the matching bracelet and necklace to complete the look. Perfect for gift giving.  ・Collection:  Angelic ・Colour:  White ・Length: 1 cm ・Width: 1 cm ・Material:  Crystals, Gold-tone plated ・Weight (individual piece):  1.6 g",
    description_jpn:
      "どんなスタイルも引き立てるタイムレスでエレガントなデザインのクラシックなピアス。一粒のクリア・クリスタルをパヴェで囲み、ゴールドカラーコーティングを組み合わせた美しいきらめきが特徴です。おそろいのブレスレットやネックレスを合わせれば、統一感のあるルックを楽しめます。ギフトにも最適。  ・コレクション:  Angelic ・色:  ホワイト ・長さ: 1 cm ・幅: 1 cm ・素材:  クリスタル, ゴールドトーン・プレーティング ・重さ（片方）:  1.6 g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5505470.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "641",
    brand: "Swarovski",
    sku: "5286137",
    product_eng:
      "Swarovski Sparkling Dance necklace Round cut, White, Rhodium plated ",
    product_jpn:
      "Swarovski スワロフスキー Sparkling Dance ネックレス ラウンドカット, ホワイト, ロジウム・プレーティング ",
    category_1: "Jewelry & Watches",
    category_2: "Necklace",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng:
      "Inspired by the idea of a ‘dancing crystal’, this necklace showcases a round stone that floats inside a metal cage embellished with crystal pavé. An essential addition to any Jewelry box, it will give your daytime style a playful sparkle. The necklace is rhodium-plated.  ・Colour:  White ・Length: 38 cm ・Material:  Crystals, Rhodium plated, Zirconia ・Collection:  Swarovski Sparkling Dance ・Clasp type:  Lobster",
    description_jpn:
      "「ダンシングクリスタル」のアイデアからインスピレーションを得たネックレス。 クリスタル・パヴェをあしらったメタルで囲んだラウンドストーンが浮かぶように揺れ動きます。 どなたにも似合うマストアイテムとして、昼間のスタイルに遊び心のあるきらめきを添えてくれます。 ロジウムコーティングを施しました。  ・色:  ホワイト ・長さ: 38 cm ・素材:  クリスタル, ロジウム・コーティング, ジルコニア ・コレクション:  Swarovski Sparkling Dance ・クラスプタイプ:  ロブスター",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5286137.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "642",
    brand: "Swarovski",
    sku: "5272364",
    product_eng:
      "Swarovski Sparkling Dance necklace Round cut, White, Rose gold-tone plated ",
    product_jpn:
      "Swarovski スワロフスキー Sparkling Dance ネックレス ラウンドカット, ホワイト, ローズゴールドトーン・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Necklace",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng:
      "Featuring a new ‘dancing crystal’ design concept, this rose gold-plated necklace showcases a round stone that floats inside a 3D cage in crystal pavé. An essential addition to any Jewelry box, it will give your daytime style a playful sparkle.  ・Colour:  White ・Length: 38 cm ・Material:  Crystals, Rose gold-tone plated, Zirconia ・Collection:  Swarovski Sparkling Dance ・Clasp type:  Lobster",
    description_jpn:
      "新たな「ダンシングクリスタル」のデザインコンセプトが特徴のローズゴールド・コーティングを施したネックレス。 クリスタル・パヴェで立体的に囲んだラウンドストーンが浮かぶように揺れ動きます。 どなたにも似合うマストアイテムとして、昼間のスタイルに遊び心のあるきらめきを添えてくれます。  ・色:  ホワイト ・長さ: 38 cm ・素材:  クリスタル, ローズゴールドトーン・プレーティング, ジルコニア ・コレクション:  Swarovski Sparkling Dance ・クラスプタイプ:  ロブスター",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5272364.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "643",
    brand: "Swarovski",
    sku: "5599177",
    product_eng:
      "Swarovski Millenia pendant Octagon cut, White, Rhodium plated ",
    product_jpn:
      "Swarovski スワロフスキーMillenia ペンダント オクタゴンカット, ホワイト, ロジウム・プレーティング ",
    category_1: "Jewelry & Watches",
    category_2: "Necklace",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng:
      "Designed to form a striking octagon shape, this pendant necklace will become one of the hardest working pieces in your wardrobe. A delicate rhodium plated chain holds a clear step cut stone at its centre, which moves as you wear it, and is framed by smaller brilliant cut stones. Endlessly versatile, wear it with a white T-shirt for a subtle statement, or layered with other necklaces for a more dramatic look. This necklace is part of the Millenia family, designed by Creative Director Giovanna Engelbert for Collection I.  ・Collection:  Millenia ・Colour:  White ・Minimum length: 38 cm ・Maximum length: 43 cm ・Width: 0.9 cm ・Material:  Rhodium plated, Zirconia ・Clasp type:  Lobster",
    description_jpn:
      "印象的なオクタゴンの形にデザインされたこのペンダントネックレスは、ワードローブの中で最も大活躍するアイテムになることは間違いありません。ロジウムプレーティングが施された繊細なチェーンには、クリアステップカット・ストーンを中央にあしらわれ、つけるたびに動きを見せてくれます。センターストーンの周りには、小さなブリリアントカット・ストーンが周りに施されています。小さな白のTシャツに合わせてさりげないステートメントを作ったり、あるいは他のネックレスと重ねづけしてドラマティックに演出したりと、さまざまな使い方がお楽しみいただけます。 このネックレスは、Collection I を手掛けたクリエイティブディレクターのジョバンナ・エンゲルバートがデザインしたMilleniaシリーズの一つです。 ・コレクション:  Millenia ・色:  ホワイト ・最小幅: 38 cm ・最大幅: 43 cm ・幅: 0.9 cm ・素材:  ロジウム・コーティング, ジルコニア ・クラスプタイプ:  ロブスター",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5599177.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "644",
    brand: "Swarovski",
    sku: "5614933",
    product_eng:
      "Swarovski Millenia necklace Octagon cut, Pink, Rose gold-tone plated ",
    product_jpn:
      "Swarovski スワロフスキー Millenia ネックレス オクタゴンカット, ピンク, ローズゴールドトーン・プレーティング ",
    category_1: "Jewelry & Watches",
    category_2: "Necklace",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng:
      "Dynamic engineering and timeless elegance collide in this beautiful pendant. A true centrepiece to any look, its pink, octagon-cut stone is framed by smaller crystals and suspended from a delicate, rose gold-tone plated chain. Wear yours to lend a feminine flourish to both casual and more formal ensembles. This pendant is part of the Millenia family, designed by Creative Director Giovanna Engelbert for Collection II.  ・Collection:  Millenia ・Colour:  Pink ・Minimum length: 38 cm ・Maximum length: 43 cm ・Width: 0.9 cm ・Material:  Rose gold-tone plated, Zirconia ・Clasp type:  Lobster",
    description_jpn:
      "ダイナミックな技術とタイムレスなエレガンスが融合した美しいペンダント。ピンクのオクタゴンカットストーンを小さなクリスタルで囲み、ローズゴールド・プレーティングのチェーンで吊るした、どんな装いにも合うコーディネートのセンターピースともいうべきアイテムです。カジュアルな装いにもフォーマルな装いにも、フェミニンな輝きを与えてくれます。 このペンダントは、Collection II を手掛けるクリエイティブディレクターのジョバンナ・エンゲルバートがデザインした Millenia シリーズの一つです。  ・コレクション:  Millenia ・色:  ピンク ・最小幅: 38 cm ・最大幅: 43 cm ・幅: 0.9 cm ・素材:  ローズゴールドトーン・プレーティング, ジルコニア ・クラスプタイプ:  ロブスター",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5614933.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "645",
    brand: "Swarovski",
    sku: "5465384",
    product_eng:
      "Swarovski Subtle Trilogy bracelet Round cut, White, Rhodium plated ",
    product_jpn:
      "Swarovski スワロフスキー Subtle Trilogy ブレスレット ラウンドカット, ホワイト, ロジウム・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Bracelet",
    rrp_ex_vat: "¥16,000",
    rrp_with_vat: "¥17,600",
    description_eng:
      "Infused with subtle elegance and timeless sparkle, this delicate cupchain bracelet would make a lovely Mother's Day gift. The design combines white stones and rhodium plating, finished with an adjustable sliding closure to fit any wrist size. The perfect partner for everyday outfits, it stacks easily with other bracelets and would be a welcome addition to any Jewelry box.  ・Colour:  White ・Minimum length: 11 cm ・Maximum length: 22 cm ・Material:  Crystals, Rhodium plated ・Collection:  Subtle",
    description_jpn:
      "さりげないエレガンスとタイムレスなきらめきがあふれるカップチェーンの繊細なブレスレットは母の日の素敵なギフトに最適です。ホワイトのカットストーンとロジウムコーティングを組み合わせ、調節可能なスライド式クロージャーでほどよくフィットするデザインに仕上げています。普段のスタイルにふさわしく、お手持ちのブレスレットと気軽に重ねづけられるおすすめのジュエリーです。  ・色:  ホワイト ・最小幅: 11 cm ・最大幅: 22 cm ・素材:  クリスタル, ロジウム・コーティング ・コレクション:  Subtle",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/swarovski/Swarovski_5465384.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1035",
    brand: "Swarovski",
    sku: "5683445",
    product_eng: "Swarovski Meteora set, White, Rhodium plated",
    product_jpn:
      "Swarovski スワロフスキー Meteora セット ホワイト, ロジウム・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "set",
    rrp_ex_vat: "¥32,000",
    rrp_with_vat: "¥35,200",
    description_eng:
      "Starry sky inspiration and Swarovski's savoir-faire shine in this rhodium-plated jewelry set. The pendant is designed with a delicate chain and lobster clasp, featuring a dome-shaped meteorite motif set with round-cut clear crystals of various sizes in a snow pavé setting. A similar motif is used on the stud earrings, which come with shiny ball closures. Recommended as a gift full of mysterious charm for a loved one, or as a styling item full of your own radiance.  ・Color: White ・Necklace length: 40 - 47 cm ・Earrings: 1 x 1 cm ・Material: Crystal, Rhodium plating ・Collection: Meteora *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "星空のインスピレーションとSwarovskiのsavoir-faire（サヴォアフェール）が見事に優等したロジウム・プレーティングのジュエリーセット。ペンダントは繊細なチェーンとロブスタークラスプが付いたデザインで、ドーム形の隕石のモチーフには様々なサイズのラウンドカットのクリア・クリスタルがスノーパヴェ・セッティングされています。スタッドピアスにも同様のモチーフが使われており、光沢のあるボールクロージャーが付いています。大切な方への不思議な魅力に満ちたギフトにも、ご自分の輝きに満ちたスタイリングにもおすすめです。  ・色: ホワイト ・ネックレスの長さ: 40 - 47 cm ・イヤリング: 1 x 1 cm ・素材: クリスタル, ロジウム・コーティング ・コレクション: Meteora ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5683445.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1036",
    brand: "Swarovski",
    sku: "5683451",
    product_eng: "Swarovski Meteora set, White, Rose gold-tone plated",
    product_jpn:
      "Swarovski スワロフスキー Meteora セットホワイト, ローズゴールドトーン・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "set",
    rrp_ex_vat: "¥31,000",
    rrp_with_vat: "¥34,100",
    description_eng:
      "This rose gold-tone plated jewelry set combines starry inspiration with Swarovski's savoir-faire. The pendant is designed with a delicate chain and lobster clasp, featuring a dome-shaped meteorite motif set with round-cut clear crystals of various sizes in a snow pavé setting. The same motif is also used in the double chain earrings. Recommended as a gift for a loved one or for your own dazzling style.  ・Color: White ・Necklace length: 40 - 47 cm ・Earrings: 7 x 1 cm ・Materials: Crystal, rose gold-tone plating ・Collection: Meteora *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "星のインスピレーションとSwarovskiのsavoir-faire（サヴォアフェール）を融合したローズゴールドトーン・プレーティングのジュエリーセット。ペンダントは繊細なチェーンとロブスタークラスプが付いたデザインで、ドーム形の隕石のモチーフには様々なサイズのラウンドカットのクリア・クリスタルがスノーパヴェ・セッティングされています。ダブルチェーンのピアスにも同じモチーフが使われています。大切な方へのギフトにもご自分のまばゆいスタイルにもおすすめです。  ・色: ホワイト ・ネックレスの長さ: 40 - 47 cm ・イヤリング: 7 x 1 cm ・素材: クリスタル, ローズゴールドトーン・プレーティング ・コレクション: Meteora ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5683451.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1037",
    brand: "Swarovski",
    sku: "5683449",
    product_eng: "Swarovski Meteora pendant, White, Rose gold-tone plated",
    product_jpn:
      "Swarovski スワロフスキー Meteora ペンダントホワイト, ローズゴールドトーン・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Necklace",
    rrp_ex_vat: "¥26,000",
    rrp_with_vat: "¥28,600",
    description_eng:
      "A dazzling layered pendant for a sparkling look. A rose gold-tone plated design with two chains, each featuring a dome-shaped meteorite motif set with round-cut clear crystals of various sizes in a snow pavé setting. . The pendant is reversible, with the back of the larger one featuring a crystal-encrusted design, and the back of the smaller one with a single sparkling crystal in the center. Perfect as a treat for yourself or as a gift for a loved one.  ・Color: White ・Length (min - max): 38 - 45 cm ・Motif size: 2.2 x 1.6 cm ・Materials: Crystal, rose gold-tone plating ・Collection: Meteora *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "輝きに満ちた装いのためのまばゆいレイヤードペンダント。2本のチェーンが付いたローズゴールドトーン・プレーティングのデザインで、それぞれのチェーンに付けられたドーム形の隕石のモチーフには様々なサイズのラウンドカットのクリア・クリスタルがスノーパヴェ・セッティングされています。ペンダントはリバーシブルになっており、大きい方の裏面はクリスタルが散りばめられたデザイン、小さい方の裏面は中央にクリスタルが1個輝きます。ご自分へのご褒美や大切な方へのギフトにどうぞ。  ・色: ホワイト ・長さ (最短 - 最長): 38 - 45 cm ・モチーフのサイズ: 2.2 x 1.6 cm ・素材: クリスタル, ローズゴールドトーン・プレーティング ・コレクション: Meteora ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5683449.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1038",
    brand: "Swarovski",
    sku: "5684244",
    product_eng: "Swarovski Meteora pendant, White, Rhodium plated",
    product_jpn:
      "Swarovski スワロフスキー Meteora ペンダント ホワイト, ロジウム・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Necklace",
    rrp_ex_vat: "¥26,000",
    rrp_with_vat: "¥28,600",
    description_eng:
      "A dazzling layered pendant for a sparkling look. A rhodium-plated design with two chains, each featuring a dome-shaped meteorite motif set in snow pavé with round-cut clear crystals of various sizes. The pendant is reversible, with the back of the larger one featuring a crystal-encrusted design, and the back of the smaller one with a single sparkling crystal in the center. Perfect as a treat for yourself or as a gift for a loved one.  ・Color: White ・Length (min - max): 38 - 45 cm ・Motif size: 2.2 x 1.6 cm ・Material: Crystal, Rhodium plating ・Collection: Meteora *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "輝きに満ちた装いのためのまばゆいレイヤードペンダント。2本のチェーンが付いたロジウム・プレーティングのデザインで、それぞれのチェーンに付けられたドーム形の隕石のモチーフには様々なサイズのラウンドカットのクリア・クリスタルがスノーパヴェ・セッティングされています。ペンダントはリバーシブルになっており、大きい方の裏面はクリスタルが散りばめられたデザイン、小さい方の裏面は中央にクリスタルが1個輝きます。ご自分へのご褒美や大切な方へのギフトにどうぞ。  ・色: ホワイト ・長さ (最短 - 最長): 38 - 45 cm ・モチーフのサイズ: 2.2 x 1.6 cm ・素材: クリスタル, ロジウム・コーティング ・コレクション: Meteora ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5684244.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1039",
    brand: "Swarovski",
    sku: "5683452",
    product_eng: "Swarovski Meteora bangle, White, Rose gold-tone plated",
    product_jpn:
      "Swarovski スワロフスキー Meteora バングル ホワイト, ローズゴールドトーン・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Bracelet",
    rrp_ex_vat: "¥18,000",
    rrp_with_vat: "¥19,800",
    description_eng:
      "This bangle is reminiscent of space and the starry sky, and it's fun just to watch it capture the light beautifully. A rose gold-tone plated design combines a hard bracelet with a delicate chain. The dome-shaped meteorite motif at the center of the chain is set with round-cut clear crystals of various sizes in a snow pavé setting. Elevate your look by pairing it with the matching pendant.  ・Color: White ・Length: 17cm ・Inner circumference: 5.9 x 4 cm ・Motif size: 1 x 1 cm ・Opening width: 4.5 cm ・Materials: Crystal, rose gold-tone plating ・Collection: Meteora *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "宇宙と星空を思わせるバングルで、美しく光を捉える様子は見ているだけで楽しくなります。ハードブレスレットと繊細なチェーンを組み合わせたローズゴールドトーン・プレーティングのデザイン。チェーンの中央にあるドーム形の隕石のモチーフには様々なサイズのラウンドカットのクリア・クリスタルがスノーパヴェ・セッティングされています。揃いのペンダントと合わせて装いをランクアップしましょう。  ・色: ホワイト ・長さ: 17 cm ・内周: 5.9 x 4 cm ・モチーフのサイズ: 1 x 1 cm ・開口部の幅: 4.5 cm ・素材: クリスタル, ローズゴールドトーン・プレーティング ・コレクション: Meteora ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5683452.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1040",
    brand: "Swarovski",
    sku: "5683447",
    product_eng: "Swarovski Meteora bangle, White, Rhodium plated",
    product_jpn:
      "Swarovski スワロフスキー Meteora バングル ホワイト, ロジウム・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Bracelet",
    rrp_ex_vat: "¥18,000",
    rrp_with_vat: "¥19,800",
    description_eng:
      "This bangle is reminiscent of space and the starry sky, and it's fun just to watch it capture the light beautifully. A rhodium-plated design combines a hard bracelet with a delicate chain. The dome-shaped meteorite motif at the center of the chain is set with round-cut clear crystals of various sizes in a snow pavé setting. Elevate your look by pairing it with the matching pendant.  ・Color: White ・Length: 17cm ・Inner circumference: 5.9 x 4 cm ・Motif size: 1 x 1 cm ・Opening width: 4.5 cm ・Material: Crystal, Rhodium plating ・Collection: Meteora *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "宇宙と星空を思わせるバングルで、美しく光を捉える様子は見ているだけで楽しくなります。ハードブレスレットと繊細なチェーンを組み合わせたロジウム・プレーティングのデザイン。チェーンの中央にあるドーム形の隕石のモチーフには様々なサイズのラウンドカットのクリア・クリスタルがスノーパヴェ・セッティングされています。揃いのペンダントと合わせて装いをランクアップしましょう。  ・色: ホワイト ・長さ: 17 cm ・内周: 5.9 x 4 cm ・モチーフのサイズ: 1 x 1 cm ・開口部の幅: 4.5 cm ・素材: クリスタル, ロジウム・コーティング ・コレクション: Meteora ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5683447.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1041",
    brand: "Swarovski",
    sku: "5414999",
    product_eng:
      "Swarovski Stone necklace Interlocking circles, White, Rose gold-tone plated",
    product_jpn:
      "Swarovski スワロフスキー Stone ネックレスインターロッキングサークル, ホワイト, ローズゴールドトーン・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Necklace",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng:
      "This necklace features a crossed circle motif that brings a touch of luxury to any style. It's crafted from rose gold-plated metal with shimmering crystal pavé contrasting with gold tones. A delicate accessory that can be worn throughout the day to create a seamless look. Perfect for layering in a bohemian style. You can easily combine it with your existing Stone series items to enjoy a more classic beauty.  ・Color: White ・Minimum width: 38 cm ・Maximum width: 42 cm ・Width: 1.9cm ・Materials: Crystal, rose gold-tone plating ・Collection: Stone *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "どんなスタイルにもラグジュアリーな雰囲気をもたらしてくれる交差させた円のモチーフが特徴のネックレス。ローズゴールド・コーティングのメタルに、ゴールドトーンとクリアでコントラストをつけたきらめくクリスタルのパヴェを施しています。1日を通して身につけられシームレスなルックを作り上げてくれる繊細なアクセサリーです。ボヘミアン調の重ねづけに最適。お手持ちのStone シリーズのアイテムとも気軽に組み合わせられ、よりクラシックな美しさを楽しむこともできます。  ・色: ホワイト ・最小幅: 38 cm ・最大幅: 42 cm ・幅: 1.9 cm ・素材: クリスタル, ローズゴールドトーン・プレーティング ・コレクション: Stone ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5414999.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1042",
    brand: "Swarovski",
    sku: "5389432",
    product_eng:
      "Swarovski Stone hoop earrings, Pave, Large, White, Rhodium plated",
    product_jpn:
      "Swarovski スワロフスキー Stone フープピアスパヴェ, 大, ホワイト, ロジウム・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Earring",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng:
      "These timeless hoop earrings are recommended as gifts for various occasions, including Mother's Day. Crystal pavé gives it a special sparkle. The delicate rhodium-plated design is easy to match with any style throughout the day.  ・Color: White ・Length: 3.5cm ・Material: Crystal, Rhodium plating ・Weight (one side): 2.8 g ・Collection: Stone *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "母の日をはじめとするさまざまなシーンでのギフトにおすすめのタイムレスなフープタイプのピアス。クリスタルのパヴェが特別なきらめきを放ちます。ロジウムコーティングを施した繊細なデザインは一日を通してどんなスタイルにも簡単に合わせられます。  ・色: ホワイト ・長さ: 3.5 cm ・素材: クリスタル, ロジウム・コーティング ・重さ（片方）: 2.8 g ・コレクション: Stone ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5389432.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1043",
    brand: "Swarovski",
    sku: "5383938",
    product_eng:
      "Swarovski Stone hoop earrings, Pave, Large, White, Rose gold-tone plated",
    product_jpn:
      "Swarovski スワロフスキー Stone フープピアスパヴェ, 大, ホワイト, ローズゴールドトーン・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Earring",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng:
      "These timeless hoop earrings are recommended as gifts for various occasions, including Mother's Day. Crystal pavé gives it a special sparkle. The delicate rose gold-plated design is easy to match with any outfit throughout the day.  ・Color: White ・Length: 3.5cm ・Materials: Crystal, rose gold-tone plating ・Weight (one side): 2.8 g ・Collection: Stone *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "母の日をはじめとするさまざまなシーンでのギフトにおすすめのタイムレスなフープタイプのピアス。クリスタルのパヴェが特別なきらめきを放ちます。ローズゴールド・コーティングを施した繊細なデザインは一日を通してどんな装いにも簡単に合わせられます。  ・色: ホワイト ・長さ: 3.5 cm ・素材: クリスタル, ローズゴールドトーン・プレーティング ・重さ（片方）: 2.8 g ・コレクション: Stone ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5383938.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1044",
    brand: "Swarovski",
    sku: "5682595",
    product_eng:
      "Swarovski Imber Tennis necklace Round cut, White, Rhodium plated",
    product_jpn:
      "Swarovski スワロフスキー Imber Tennis ネックレスラウンドカット, ホワイト, ロジウム・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Necklace",
    rrp_ex_vat: "¥36,000",
    rrp_with_vat: "¥39,600",
    description_eng:
      "The Imber Tennis necklace is recommended for everyday wear with a subtle mix of different colors. The all-around style features a rhodium-plated design with round-cut crystals set in a rounded bezel setting. This jewelry is useful when you want to add volume to your shine.  ・Color: White ・Length (min - max): 38 - 45 cm ・Width: 0.7cm ・Material: Crystal, Rhodium plating ・Collection: Imber *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "微妙に異なるカラーをさりげなくミックスした毎日づかいにおすすめのImber Tennisネックレス。ロジウム・プレーティングのデザインで、丸みのあるベゼル・セッティングを施したラウンドカット・クリスタルを連ねたオールアラウンドスタイルです。輝きをボリュームアップしたいときに活躍するジュエリーです。  ・色: ホワイト ・長さ (最短 - 最長): 38 - 45 cm ・幅: 0.7 cm ・素材: クリスタル, ロジウム・コーティング ・コレクション: Imber ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5682595.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1045",
    brand: "Swarovski",
    sku: "5682666",
    product_eng:
      "Swarovski Imber Tennis bracelet Round cut, White, Rhodium plated",
    product_jpn:
      "Swarovski スワロフスキー Imber Tennis ブレスレットラウンドカット, ホワイト, ロジウム・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Bracelet",
    rrp_ex_vat: "¥24,000",
    rrp_with_vat: "¥26,400",
    description_eng:
      "The Imber Tennis bracelet is a subtle mix of hues. It has a timeless and sophisticated feel. It features a rhodium-plated design with strands of round-cut crystal puffy-bezel-set elements and a lobster clasp. It can be used for a wide range of purposes, from casual styling to evening dressing.  ・Color: White ・Length (min - max): 15.5 - 20 cm ・Width: 0.7cm ・Material: Crystal, Rhodium plating ・Collection: Imber *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "微妙な色合いをさりげなくミックスしたImber Tennisブレスレット。タイムレスで洗練された雰囲気が漂います。ラウンドカットのクリスタルをパフィーベゼル・セッティングしたエレメントをストランドに連ねたロジウム・プレーティングのデザインで、ロブスタークラスプが付いています。カジュアルなスタイリングから夜のドレスアップまで広く活躍します。  ・色: ホワイト ・長さ (最短 - 最長): 15.5 - 20 cm ・幅: 0.7 cm ・素材: クリスタル, ロジウム・コーティング ・コレクション: Imber ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5682666.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1046",
    brand: "Swarovski",
    sku: "5554983",
    product_eng:
      "Swarovski Crystalline ballpoint pen, Flower, Pink, Pink lacquer, Rose gold-tone plating",
    product_jpn:
      "Swarovski スワロフスキー Crystalline ボールペン, フラワー, ピンク, ピンクラッカー、ローズゴールドトーン・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Pen",
    rrp_ex_vat: "¥7,200",
    rrp_with_vat: "¥7,920",
    description_eng:
      "A Swarovski ballpoint pen with a charming yet powerful design. The combination of rose-colored lacquered metal and rose gold-tone plating exudes elegance. A dazzling design filled with numerous Swarovski crystals. A small charm with a cherry blossom motif is decorated with beautiful pink crystals. Ink cartridges are replaceable. Recommended as a gift for someone special.   ・Color: Pink ・Size: 14.3x1 cm ・Materials: Crystal, pink lacquered, rose gold-tone plating ・Collection: Crystalline *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "チャーミングな中にパワーが感じられるデザインのSwarovskiのボールペン。ローズカラーのラッカー加工メタルとローズゴールドトーン・プレーティングの組み合わせにエレガンスが漂います。多数のSwarovski・クリスタルを充填したまばゆい輝きのデザイン。桜のモチーフの小さなチャームには美しいピンクのクリスタルをあしらいました。インクカートリッジは交換可能です。  ・色: ピンク ・サイズ: 14.3x1 cm ・素材: クリスタル, ピンクのラッカー仕上げ, ローズゴールドトーン・プレーティング ・コレクション: Crystalline ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5554983.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1047",
    brand: "Swarovski",
    sku: "5678183",
    product_eng:
      "Swarovski Crystal Shimmer ballpoint pen, White lacquer, Chrome plating",
    product_jpn:
      "Swarovski スワロフスキー Crystal Shimmer ボールペン,ホワイトラッカー、クローム・プレーティング",
    category_1: "Jewelry & Watches",
    category_2: "Pen",
    rrp_ex_vat: "¥6,000",
    rrp_with_vat: "¥6,600",
    description_eng:
      "An elegant ballpoint pen that combines urban elegance with a modern, simple design. Let your creativity shine. The unique white lacquer design with its octagonal shaft and rounded tip is a striking balance between form and functionality. Embellished with an ultra-fine crystal rock technique, each letter catches the light and shines beautifully as you write. Easy-to-use twist mechanism opens and closes. This is a higher-grade pen that also comes with a clip. Recommended as a memorable gift for special occasions and events.   ・Color: White ・Ink color: black ・Collection: Crystal Shimmer ・Size: 14.5 x 0.9 cm ・Material: Crystal, white lacquered *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "都会的なエレガンスとモダンでシンプルなデザインが出会った優美なボールペン。クリエイティビティが輝きます。八角形の胴軸と丸みのある先端が目を惹くホワイトラッカーのユニークなデザインで、フォルムと機能性のバランスが見事です。ウルトラファイン・クリスタル・ロック技法の装飾が施されており、字を書くたびに光を捉えて美しく輝きます。開閉は使いやすいツイストメカニズム。クリップも付いたワンランク上のペンです。特別なシーンやイベントの思い出に残るギフトにおすすめです。  ・色: ホワイト ・インクカラー: ブラック ・コレクション: Crystal Shimmer ・サイズ: 14.5 x 0.9 cm ・素材: クリスタル, ホワイトラッカー仕上げ ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5678183.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1048",
    brand: "Swarovski",
    sku: "5671205",
    product_eng:
      "Swarovski Illumina watch, Swiss made, Metal bracelet, Silver-tone, Stainless steel",
    product_jpn:
      "Swarovski スワロフスキー Illumina ウォッチ, スイス製, メタルブレスレット, シルバー系, ステンレス鋼",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥48,000",
    rrp_with_vat: "¥52,800",
    description_eng:
      "Illumina watches bring impressive beauty to your fingertips. This stainless steel model has a case diameter of 27 mm and an adjustable bracelet set with 210 clear crystals set with perfect precision. The watch glass is mineral glass. The sunray-patterned dial features the Swan logo at 12 o'clock and is illuminated by three square crystal indexes. The crown also has one crystal. This Swiss-made watch is water resistant to 5 ATM and will tell the time with a dazzling glow in any situation, from day to night.  ・Color: Silver ・Case size: 27mm x 27mm ・Watch strap length: 16 cm ・Material: Crystal, Stainless steel ・Strap material: crystal ・Country of manufacture: Switzerland ・Watch mechanism: Quartz ・Collection: Illumina *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "手元に感動的な美しさをもたらすIlluminaウォッチ。ケース直径27mmのステンレススチールのモデルで、サイズ調節可能なブレスレットには210個のクリア・クリスタルが完璧な精度でセッティングされています。ウォッチガラスはミネラルガラス。サンレイ模様の文字盤には12時の位置にスワン・ロゴがあしらわれ、3個のスクエア・クリスタルのインデックスが輝きます。リューズにもクリスタルが1個付いています。5気圧防水のスイス製ウォッチで、昼から夜までシーンを問わずまばゆい輝きとともに時を告げます。  ・色: シルバー系 ・ケースサイズ: 27 mm x 27 mm ・ウォッチのストラップの長さ: 16 cm ・素材: クリスタル, ステンレス ・ストラップ素材: クリスタル ・製造国: スイス ・ウォッチメカニズム: クオーツ ・コレクション: Illumina ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5671205.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "1049",
    brand: "Swarovski",
    sku: "5671202",
    product_eng:
      "Swarovski Illumina watch, Swiss Made, Metal Bracelet, Rose Gold Color, Rose Gold Tone Finish",
    product_jpn:
      "Swarovski スワロフスキー Illumina ウォッチ, スイス製, メタルブレスレット, ローズゴールドカラー, ローズゴールドトーン仕上げ",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥54,000",
    rrp_with_vat: "¥59,400",
    description_eng:
      "Illumina watches bring impressive beauty to your fingertips. This rose gold-tone model has a case diameter of 27 mm and an adjustable bracelet set with 210 clear crystals set with perfect precision. The watch glass is mineral glass. The sunray-patterned dial features the Swan logo at 12 o'clock and is illuminated by three square crystal indexes. The crown also has one crystal. This Swiss-made watch is water resistant to 5 ATM and will tell the time with a dazzling glow in any situation, from day to night.  ・Color: rose gold color ・Case size: 27mm x 27mm ・Watch strap length: 16 cm ・Material: Crystal, Rose Gold Tone PVD ・Strap material: crystal ・Country of manufacture: Switzerland ・Watch mechanism: Quartz ・Collection: Illumina *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "手元に感動的な美しさをもたらすIlluminaウォッチ。ケース直径27mmのローズゴールドトーン仕上げのモデルで、サイズ調節可能なブレスレットには210個のクリア・クリスタルが完璧な精度でセッティングされています。ウォッチガラスはミネラルガラス。サンレイ模様の文字盤には12時の位置にスワン・ロゴがあしらわれ、3個のスクエア・クリスタルのインデックスが輝きます。リューズにもクリスタルが1個付いています。5気圧防水のスイス製ウォッチで、昼から夜までシーンを問わずまばゆい輝きとともに時を告げます。  ・色: ローズゴールドカラー ・ケースサイズ: 27 mm x 27 mm ・ウォッチのストラップの長さ: 16 cm ・素材: クリスタル, ローズゴールドトーンPVD ・ストラップ素材: クリスタル ・製造国: スイス ・ウォッチメカニズム: クオーツ ・コレクション: Illumina ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/swarovski/Swarovski_5671202.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/swarovski.png",
  },
  {
    id: "646",
    brand: "RHYTHM",
    sku: "4RH797SR01",
    product_eng: "RHYTHM Bellows Cuckoo Clock Red",
    product_jpn: "RHYTHM ふいごカッコー アカ",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥11,000",
    description_eng:
      "This cuckoo clock announces the time with a gentle ho-ho-ho tone every hour, using a mechanism that creates wind and a whistle with a Japanese paper blowpipe, which cannot be reproduced with electronic sounds.  Gentle sound of the whistle. The Japanese paper bellows mechanism works on the same principle as a musical accordion, compressing the bellows to send air to sound the whistle.  Its compact size allows it to be placed anywhere, and it can be used for both hanging and installation. The sound of a cuckoo that makes you smile may give you a little peace of mind in your busy day-to-day life.  ♦Movement Quartz (Rhythm's own manufacture) ♦Size and weight H135 x W146 x D107mm / 480g ♦Material Plastic frame ♦Function ON (automatic alarm stop sensor)/OFF switch ♦Cuckoo appears and chirps every hour on the hour. ♦Can be used for both hanging and placing ♦Operates on 1 alkaline AA battery.",
    description_jpn:
      "電子音では再現できない、和紙製のふいごで風を起こし笛を鳴らす機構で、毎正時「ホッホー」と やさしい音色で時をお知らせするカッコー時計です。  “やさしいふいごのねいろ” 和紙製蛇腹式ふいご機構は、楽器のアコーディオンと同じ原理で、蛇腹を圧縮させて空気を送り笛を鳴らします。  コンパクトなサイズは置く場所を選ばず、掛置兼用でお使い頂けます。 思わず微笑んでしまうカッコーの鳴き声は、忙しい毎日に少し安らぎを与えてくれるかも。   ムーブメント\tクオーツ（リズム自社製）  サイズ・重さ\tH135×W146×D107mm / 480g  材質\tプラスチック枠  機能\tON（自動鳴り止めセンサー）/OFFスイッチ  毎正時にカッコーが顔を出して鳴き声で報時します  掛置兼用  アルカリ単3x1本で稼働",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_4RH797SR01.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "647",
    brand: "RHYTHM",
    sku: "4MN513RH23",
    product_eng: "RHYTHM Radio-controlled clock:Small World Noel M",
    product_jpn: "RHYTHM 電波からくり時計:スモールワールドノエルM",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥35,000",
    rrp_with_vat: "¥38,500",
    description_eng:
      "Karakuri clocks provide a heartwarming moment in daily life with the delightful effects of a karakuri mechanism accompanied by a melody. The clock is especially well received overseas and loved by people all over the world.  At each hour of the hour, after the opening melody, the dial gradually begins to rotate, the rotating ornaments on the top rotate, and the LED lamps blink randomly.  The melody is composed of high quality aurora sand, which is made up of sounds from musical instruments, and a total of 30 songs have been recorded. The melody can be switched between (A: 12 Western songs, B: 12 classical songs, C: 6 Christmas songs) by a switch according to your preference.  ♦Movement Radio-controlled clock ♦Size and weight H499 x W389 x D108 mm / approx. 3.3 kg ♦Material Plastic frame/Glass ♦Function Radio-controlled clock ♦Aurora sound melody (total 30 songs) at every hour ♦Step second hand (second hand to sleep at night) ♦ON (automatic ring stop light/dark sensor)/OFF switch ♦Volume control volume ♦Operates on 2 x alkaline AAA batteries",
    description_jpn:
      "メロディに乗せてからくり仕掛けの楽しい演出が、日常に心温まるひと時を与えてくれるからくり時計。特に海外からの評価が高く、世界中の人々に愛されています。  毎正時になると、オープニングメロディの後、文字板が徐々に回転しはじめ、上部の回転飾りなどもそれぞれ回転しLEDランプがランダムに点滅します。  メロディは、楽器から音を取り込んで構成された高音質のオーロラサンドを使用し、全30曲を収録しました。 (A:洋楽12曲、B:クラシック12曲、C:クリスマス6曲)をお好みにあわせスイッチで切替できます。  ムーブメント\t電波時計 サイズ・重さ\tH499×W389×D108mm/約3.3kg 材質\tプラスチック枠/ガラス 機能\t電波時計 毎正時になると、オーロラサウンドメロディ（全30曲） ステップ秒針（夜眠る秒針） ON（自動鳴り止め明暗センサー）/OFFスイッチ 音量調節ボリューム アルカリ単1型×2本で稼働",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_4MN513RH23.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "648",
    brand: "RHYTHM",
    sku: "8MY564SR03",
    product_eng: "RHYTHM FITWAVE564 White",
    product_jpn: "RHYTHM フィットウェーブ564 ホワイト",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥6,000",
    rrp_with_vat: "¥6,600",
    description_eng:
      "The clean design makes it easy to match with any room. Visibility is ensured by a thinner front frame and a larger dial. The design is meticulous in every detail. Radio-controlled clock.  ♦Size and weightφ320×45mm/740g ♦Material/wind shield plastic frame/glass.",
    description_jpn:
      "すっきりとしたデザインでどんな部屋にも合わせやすい。前枠を細くし、文字板のサイズを大きくすることで視認性を確保しました。細部にまでこだわったデザインです。電波時計。 サイズ・重さφ320×45mm/740g 材質/風防プラスチック枠/ガラス",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8MY564SR03.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8MY564SR03_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "649",
    brand: "RHYTHM",
    sku: "8MY564SR06",
    product_eng: "RHYTHM FITWAVE564 Brown",
    product_jpn: "RHYTHM フィットウェーブ564 ブラウン",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥6,000",
    rrp_with_vat: "¥6,600",
    description_eng:
      "The clean design makes it easy to match with any room. Visibility is ensured by a thinner front frame and a larger dial. The design is meticulous in every detail. Radio-controlled clock.  ♦Size and weightφ320×45mm/740g ♦Material/wind shield plastic frame/glass.",
    description_jpn:
      "すっきりとしたデザインでどんな部屋にも合わせやすい。前枠を細くし、文字板のサイズを大きくすることで視認性を確保しました。細部にまでこだわったデザインです。電波時計。 サイズ・重さφ320×45mm/740g 材質/風防プラスチック枠/ガラス",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8MY564SR06.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8MY564SR06_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "650",
    brand: "RHYTHM",
    sku: "8MY557SR06",
    product_eng: "RHYTHM A Series・A4 Clock Natural",
    product_jpn: "RHYTHM A Series・A4クロック Natural",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥12,000",
    rrp_with_vat: "¥13,200",
    description_eng:
      "The A4 size body makes the time easy to read and stable when placed on a shelf. Wooden frame radio-controlled clock with stand. Radio-controlled clock. Continuous second hand. Battery replacement reminder function.  Size and weight 210 x 297 x 51.7 mm (with stand) / approx. 850 g Material/Windshield wooden frame/Glass",
    description_jpn:
      "A4サイズの本体で、時刻が見やすく、シェルフに置いても安定して使えます。 スタンド付の掛置兼用木枠電波時計です。 電波時計。連続秒針。電池交換お知らせ機能。  サイズ・重さ210×297×51.7mm（スタンド収納時）/約850g 材質/風防木枠/ガラス",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8MY557SR06.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8MY557SR06_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "651",
    brand: "RHYTHM",
    sku: "8MG815SR03",
    product_eng: "RHYTHM A Series・A4 Clock White",
    product_jpn: "RHYTHM A Series・A4クロック White",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥7,000",
    rrp_with_vat: "¥7,700",
    description_eng:
      "The A 4 size body makes the time easy to read and stable when placed on a shelf. This quartz clock can be used for both hanging and placing with a stand. Comes with a stand for placing.  Size and weight 210 x 297 x 47.5 mm (with stand) / 730 g Material/wind shield plastic frame/glass Quartz clock (continuous second hand)",
    description_jpn:
      "A 4サイズの本体で、時刻が見やすく、シェルフに置いても安定して使えます。 スタンド付の掛置兼用クオーツ時計です。置用スタンド付属。  サイズ・重さ210×297×47.5mm（スタンド収納時）/730g 材質/風防プラスチック枠/ガラス クオーツ時計（連続秒針）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8MG815SR03.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "652",
    brand: "RHYTHM",
    sku: "8RZ161SR07",
    product_eng: "RHYTHM FITWAVE D161 White",
    product_jpn: "RHYTHM フィットウェーブD161ホワイト",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "Recommended as a gift, wood grain style digital radio-controlled clock. Radio-controlled alarm clock Features: Electronic sound alarm (changes in 4 stages) Afterglow light Calendar display (displayable until December 31, 2099) Six-day display (displayable until December 31, 2030) Temperature display (-9.9 to 50°C) Humidity display (20 to 95%) Size: Weight 89 x 135 x 44 mm/190 g Material: windshield plastic frame",
    description_jpn:
      "ギフトにおすすめ、木目風デジタル電波時計。 電波めざまし時計 機能： 電子音アラーム（４段階に変化） 残照機能ライト付 カレンダー表示（2099年12月31日まで表示可能） 六曜表示（2030年12月31日まで表示可能） 温度表示（-9.9～50℃） 湿度表示（20～95％） サイズ：重さ89×135×44mm/190g 材質：風防プラスチック枠",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8MG815SR03_1.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8RZ161SR07_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "653",
    brand: "RHYTHM",
    sku: "8RZ161SR06",
    product_eng: "RHYTHM FITWAVE D161 Silver",
    product_jpn: "RHYTHM フィットウェーブD161シルバー",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "Recommended as a gift, wood grain style digital radio-controlled clock. Radio-controlled alarm clock Features: Electronic sound alarm (changes in 4 stages) Afterglow light Calendar display (displayable until December 31, 2099) Six-day display (displayable until December 31, 2030) Temperature display (-9.9 to 50°C) Humidity display (20 to 95%) Size: Weight 89 x 135 x 44 mm/190 g Material: windshield plastic frame",
    description_jpn:
      "ギフトにおすすめ、木目風デジタル電波時計。 電波めざまし時計 機能： 電子音アラーム（４段階に変化） 残照機能ライト付 カレンダー表示（2099年12月31日まで表示可能） 六曜表示（2030年12月31日まで表示可能） 温度表示（-9.9～50℃） 湿度表示（20～95％） サイズ：重さ89×135×44mm/190g 材質：風防プラスチック枠",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8RZ161SR06.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8RZ161SR06_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "654",
    brand: "RHYTHM",
    sku: "8RDA72SR03",
    product_eng: "RHYTHM Digital clock with drip-proof and timer",
    product_jpn: "RHYTHM タイマー付き防滴クロック",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥4,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      "JIS IPX4 class splash protection makes it ideal for bathrooms, kitchens, and other water areas. It comes with a timer convenient for half-bathing and cooking. It can also be placed on a study desk and used as a study timer.  Features: Calendar / Temperature display / Timer function: decrement/accumulation timer (counts up/counts down) / Pause function Battery: CR2032 x 1 Size and weight: 60 x 105 x 25 mm / 90 g Material: windshield plastic frame.",
    description_jpn:
      "ＪＩＳ ＩＰＸ4級の防飛沫性能なのでバスルームやキッチン等の水回りに最適です。 半身浴やクッキングに便利なタイマー付です。 勉強机に置いて、学習タイマーとしてもお使いいただけます。  機能： カレンダー付 / 温度表示 / タイマー機能：減算・積算計時可能（カウントアップ・カウントダウン）/ 一時停止機能付 電池：CR2032×1 サイズ・重さ：60×105×25mm/90g 材質：風防プラスチック枠",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8RDA72SR03.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "655",
    brand: "RHYTHM",
    sku: "9YYA22RH 03",
    product_eng: "RHYTHM Aroma Diffuser AROMAFUN Pearl",
    product_jpn: "RHYTHM アロマディフューザーAROMAFUN 真珠色",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥3,182",
    rrp_with_vat: "¥3,500",
    description_eng:
      "This fan-type aroma diffuser allows you to easily enjoy the aroma of aromatic oils. Just open the lid and pour essential oil to enjoy a real aroma space.   Scent your personal space. Deliver fragrance to the place where you are. Wherever you are, there is a special fragrant space just for you.   Enjoy the fragrance The form of the four small feet is reminiscent of a traditional incense burner, The shape is reminiscent of a traditional incense burner.   Ease of use The power is automatically turned on by simply opening the lid, eliminating the need for troublesome operations. The fan diffuses the fragrance without using fire or water, You can easily enjoy essential oils in their natural fragrance.   Contents of the set Aroma Fan (main unit), oil pads (3), oil pad holder (1 included), USB cable TYPE-C-A (1)    Dimensions\t Height 62 x Width 74 x Depth 74mm Weight approx. 100g (excluding cable and battery)   Specifications Power supply USB DC5.0V ・3 AAA batteries (sold separately) Operation mode Auto OFF in approx. 20 min. when using dry cell batteries. Auto OFF in approx. 20 min. when using dry cell batteries, Auto OFF in approx. 2 hrs. when using USB power supply Battery life Approx. 10 hours (20 minutes x 30 times)",
    description_jpn:
      "手軽にアロマオイルの香りを楽しめるファン式のアロマディフューザー。 蓋を開け、エッセンシャルオイルを垂らすだけで本格的なアロマ空間をお楽しみいただけます。   パーソナル空間に香る あなたがいる場所へ香りを届けます。 どこにいてもそこは、私だけの特別な香りの空間   香りを楽しむ佇まい 4つの小さな足が特長のフォルムは、 伝統的な香炉を想起する香りを楽しむための佇まいです。   使いやすさ ふたを開けるだけるだけで自動で電源が入るため面倒な操作の必要がありません。 火や水を使わずファンの風で拡散させるため、 エッセンシャルオイルをありのままの香りでお手軽にお楽しみいただけます   セット内容 アロマファン(本体)、オイルパッド(3枚)、オイルパッドホルダー(1個付属)、USBケーブルTYPE-C-A(1本)    本体サイズ\t 高さ62×幅74×奥行74mm 質量\t約 100g（ケーブル・電池含まず）   仕様 電源\tUSB DC5.0V ・単４乾電池３本使用（別売） 運転モード\t乾電池使用時約20分で自動OFF・ USB電源使用時は約2時間で自動OFF 電池寿命\t約10時間（20分×30回）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_9YYA22RH_03.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_9YYA22RH_03_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "656",
    brand: "RHYTHM",
    sku: "9YYA22RH 13",
    product_eng: "RHYTHM Aroma Diffuser AROMAFUN gray cherry color",
    product_jpn: "RHYTHM アロマディフューザーAROMAFUN 灰桜色",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥3,182",
    rrp_with_vat: "¥3,500",
    description_eng:
      "This fan-type aroma diffuser allows you to easily enjoy the aroma of aromatic oils. Just open the lid and pour essential oil to enjoy a real aroma space.   Scent your personal space. Deliver fragrance to the place where you are. Wherever you are, there is a special fragrant space just for you.   Enjoy the fragrance The form of the four small feet is reminiscent of a traditional incense burner, The shape is reminiscent of a traditional incense burner.   Ease of use The power is automatically turned on by simply opening the lid, eliminating the need for troublesome operations. The fan diffuses the fragrance without using fire or water, You can easily enjoy essential oils in their natural fragrance.   Contents of the set Aroma Fan (main unit), oil pads (3), oil pad holder (1 included), USB cable TYPE-C-A (1)    Dimensions\t Height 62 x Width 74 x Depth 74mm Weight approx. 100g (excluding cable and battery)   Specifications Power supply USB DC5.0V ・3 AAA batteries (sold separately) Operation mode Auto OFF in approx. 20 min. when using dry cell batteries. Auto OFF in approx. 20 min. when using dry cell batteries, Auto OFF in approx. 2 hrs. when using USB power supply Battery life Approx. 10 hours (20 minutes x 30 times)",
    description_jpn:
      "手軽にアロマオイルの香りを楽しめるファン式のアロマディフューザー。 蓋を開け、エッセンシャルオイルを垂らすだけで本格的なアロマ空間をお楽しみいただけます。   パーソナル空間に香る あなたがいる場所へ香りを届けます。 どこにいてもそこは、私だけの特別な香りの空間   香りを楽しむ佇まい 4つの小さな足が特長のフォルムは、 伝統的な香炉を想起する香りを楽しむための佇まいです。   使いやすさ ふたを開けるだけるだけで自動で電源が入るため面倒な操作の必要がありません。 火や水を使わずファンの風で拡散させるため、 エッセンシャルオイルをありのままの香りでお手軽にお楽しみいただけます   セット内容 アロマファン(本体)、オイルパッド(3枚)、オイルパッドホルダー(1個付属)、USBケーブルTYPE-C-A(1本)    本体サイズ\t 高さ62×幅74×奥行74mm 質量\t約 100g（ケーブル・電池含まず）   仕様 電源\tUSB DC5.0V ・単４乾電池３本使用（別売） 運転モード\t乾電池使用時約20分で自動OFF・ USB電源使用時は約2時間で自動OFF 電池寿命\t約10時間（20分×30回）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_9YYA22RH_13.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_9YYA22RH_13_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "657",
    brand: "RHYTHM",
    sku: "9YY020RH03",
    product_eng: "RHYTHM MIST Mini ",
    product_jpn: "RHYTHM MIST Mini ",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,981",
    description_eng:
      "This ultrasonic compact humidifier for personal use allows you to enjoy a clean mist, flickering light, and aroma during the dry season.  Water turns into a mist to cleanly humidify your personal space, and a candle-like light flickers inside the tank.  Dripping oil into the aroma pocket will spread the aroma of aroma.  Enjoy a relaxing time with the MIST Mini, which humidifies your personal space cleanly.  <Main functions and features> Humidification method: Ultrasonic vibration humidification Operation mode: 2 types (Rhythm/Continuous) Rhythmic operation repeats humidification at regular intervals Humidification volume: Rhythm: approx. 50 ml/h / Continuous: approx. 100 ml/h Continuous humidification time: Rhythm: approx. 8 hours, Continuous: approx. 4 hours Applicable floor area: Wooden Japanese-style room 2.7 m2 (1.7 tatami mats), Prefabricated Western-style room 4.5 m2 (2.8 tatami mats) Tank capacity: Approx. 400 ml Power source: Dedicated AC adapter (included) Input: AC100V 50/60Hz Output: DC12V 1.0A Illumination: LED (with OFF function (turn OFF by holding down the power button for about 2 seconds)) Power Consumption: Rhythm: Approx. 6W, Continuous: Approx. 8.4W Electricity bill: Rhythm: approx. 0.16 yen/hr, Continuous: approx. 0.22 yen/hr Power cord length: approx. 1.5 m Size and weight: 197 x 90 x 90 mm / approx. 400 g (not including AC power adapter)",
    description_jpn:
      "乾燥する季節に清潔なミストとゆらぐあかり、アロマの香りを楽しむパーソナル用超音波式コンパクト加湿器です。  水がミスト（霧）となりパーソナル空間を清潔に加湿し、キャンドルのようなあかりがタンクの中でゆらぎます。  アロマポケットにオイルを垂らせばアロマの香りが広がります。  パーソナル空間を清潔に加湿する「MIST Mini」でくつろぎの時間をお楽しみください。  主な機能・特徴： 加湿 方式：超音波振動加湿方式 運転モード：2種類(リズム/連続) ※リズム運転は一定間隔で加湿を繰り返します 加 湿 量：リズム：約50ml/h ・ 連続：約100 ml/h 連続加湿時間：リズム：約8h ・ 連続：約4h 適用床面積：木造和室 2.7㎡（1.7畳）、プレハブ洋室 4.5㎡（2.8畳） タンク容量：約400ml 電   源：専用ACアダプター(付属) 入力：AC100V 50/60Hz 出力：DC12V 1.0A 照   明：LED（OFF付 ※電源ボタン約2秒長押しで消灯） 消費 電力：リズム：約6W・連続：約8.4W 電 気 代：1時間当たり リズム：約0.16円・連続：約0.22円 電源コード長:約1.5m サイズ・重さ197×90×90mm/約400g（AC電源アダプター含まず）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_9YY020RH03.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "658",
    brand: "RHYTHM",
    sku: "9YYA28RH03",
    product_eng: "RHYTHM AROMAFUN hour",
    product_jpn: "RHYTHM AROMAFUN hour",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥6,345",
    rrp_with_vat: "¥6,980",
    description_eng:
      "This aroma diffuser allows you to enjoy the passage of time and fragrance. AROMAFUN hour releases fragrance once an hour, so you can enjoy that moment of fragrance again and again. Enjoy the moment of relaxation with the aroma of the light.  Main functions and features Power source: USB DC5.0V Operation mode: Aromatherapy once an hour (select from 1, 3, or 10 minutes) 1 = Repeat operation for 1 minute every hour (1 minute ON ⇒ 59 minutes OFF ⇒ 1 minute ON ⇒) 3 = Repeat operation for 3 minutes per hour (3 minutes ON ⇒ 57 minutes OFF ⇒ 3 minutes ON ⇒) 10=Repeat operation for 10 minutes per hour. (10 minutes ON ⇒ 50 minutes OFF ⇒ 10 minutes ON ⇒) Automatic power off function after 30 days Aroma method: Fan type Effective fragrance range: Up to approx. 16 tatami mats Effective fragrance area varies depending on the type of oil and fragrance time. Oil used: Essential oil only Illumination: Lights up during fragrance (Fluctuation/light on/light off) Mode changeover by long-pressing the switch (Fluctuation => Lit => Off => ) Memory function: previous setting is memorized. Power consumption: 1: approx. 0.07W, 3: approx. 0.09W, 10: approx. 0.16W Electricity bill: 1: Approx. 0.05 yen, 3: Approx. 0.07 yen, 10: Approx. 0.12 yen per day Power cord length: Approx. 1.8m Accessories: 3 oil pads, 1 dropper opener, 1 USB cable TYPE C-A Warranty Period ： 1 year Optional Accessories ：Oil pad holder set/Replacement oil pad Size and weight: approx. 100 mm dia. x 125 mm / approx. 200 g",
    description_jpn:
      "時の経過と香りを、楽しむことができるアロマディフューザーです。 AROMAFUN hourは、1時間に1度、香りを放出するため、 「ふと香るあの瞬間」を何度でも味わえます。 あかりとともに香るアロマで、くつろぎの時間をお楽しみください。  主な機能・特徴： 電源：USB DC5.0V 運 転 モード ：1時間に1度芳香（1・3・10分から選択） 1=1時間に1分運転を繰り返す （1分ON⇒59分OFF⇒1分ON⇒） 3=1時間に3分運転を繰り返す （3分ON⇒57分OFF⇒3分ON⇒） 10=1時間に10分運転を繰り返す （10分ON⇒50分OFF⇒10分ON⇒） ※30日後自動電源OFF機能 芳 香 方 式 ：ファン式 有効芳香範囲：～約16畳 ※有効芳香空間はオイルの種類や芳香時間により異なる。 使用 オイル：エッセンシャルオイル（精油）のみ 照   明：芳香時に点灯 （ゆらぎ/点灯/消灯） スイッチ長押しでモード切替 （ゆらぎ⇒点灯⇒消灯⇒） ※メモリ機能付で前回の設定を記憶します 消 費 電 力 ：1：約0.07W・3：約0.09W・10：約0.16W 電 気 代 :1：約0.05円・3：約0.07円・ 10 :約0.12円 ※1日あたり 電源コード長 :約1.8ｍ 付 属 品 ：オイルパッド３枚・ドロッパーオープナー１個・USBケーブル TYPE C-A１本 保 証 期 間 ：1年間 別 売 品 ：オイルパッドホルダーセット/取替用オイルパッド サイズ・重さ約Φ100×125mm/約200g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_9YYA28RH03.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_9YYA28RH03_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "659",
    brand: "RHYTHM",
    sku: "8RZ230SR02",
    product_eng: "RHYTHM Battle 230 BLACK",
    product_jpn: "RHYTHM フィットウェーブバトル230 BLACK",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,500",
    description_eng:
      "This is a loud radio-controlled digital alarm clock with the largest volume in the history of Rhythm. It is equipped with 30 types of new alarm sounds. The leave it to us mode, which randomly picks up three types of alarm sounds, prevents the user from becoming accustomed to hearing them. (About 2 years and 9 months, 1000 combinations of different alarm sounds are possible each time.)  Main functions and features: *Loud electronic alarm *Snooze & alarm auto stop *Alarm monitor *Volume control (volume type) *30 selectable alarm sounds (the last song played on the monitor is set as the alarm sound) *Omakase mode *12 (AM/PM) and 24-hour display switching *Afterglow light *Calendar display (displayable until December 31, 2099) *Temperature display *Manganese dry cell batteries included for trial use  Size and weight: 85 x 184 x 58 mm/2 85 x 184 x 58 mm/270 g",
    description_jpn:
      "リズム史上最大の音量を実現した大音量電波デジタルめざまし時計です。 新作のこだわりアラーム音を３０種類搭載。 ランダムで3 種類ピックアップするおまかせモードで耳慣れを防ぎます。 （ 約2 年９か月毎回違うアラーム音の組み合わせで、1000パターンの組み合わせが可能）  主な機能・特徴： *大音量電子音アラーム *スヌーズ＆アラームオートストップ *アラームモニター *音量調節(ボリューム式) *アラーム音30種類選択式（モニターで最後に流れた曲がアラーム音として設定されます） *おまかせモード *12(AM・PM)・24時間表示切替 *残照機能ライト付 *カレンダー表示（2099年12月31日まで表示可能） *温度表示 *お試し用マンガン乾電池同梱  サイズ・重さ: 85×184×58mm/270g",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8RZ230SR02.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "661",
    brand: "RHYTHM",
    sku: "8RDA46RH03",
    product_eng: "RHYTHM Kero Clock 2",
    product_jpn: "RHYTHM ケロクロック2",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥8,000",
    rrp_with_vat: "¥8,800",
    description_eng:
      "Quartz action alarm clock. When the alarm time arrives, Frog Chorus, Quiet Lakeside, and an electronic sound-like Kerokero Alarm play, and the two frogs sing and move their limbs rhythmically. With the random voice function, the frogs speak when the clock is lifted and at irregular intervals. There are more than 10 types of random voices. The frogs also speak when the alarm is switched on or off. Main functions and features 12-hour display (a.m. and p.m.) Calendar (displayable until December 31, 2099) Size/weight: 106 x 82 x 60 mm / 210 g Material/wind shield: Plastic frame",
    description_jpn:
      "クオーツアクション目覚し時計。 アラーム時刻になると「かえるの合唱」、「静かな湖畔」、電子音風の「ケロケロアラーム」が流れ、2匹のカエルが歌いながらリズミカルに手足を動かします。 ランダム音声機能で時計を持ち上げた時と不定期にかえるがしゃべります。ランダム音声は10種類以上。アラームをon/offに切り替えた時もしゃべります。 主な機能・特徴： １２時間（午前・午後）表示 カレンダー付（２０９９年１２月３１日まで表示可能） サイズ・重さ： 106×82×60mm/210g 材質・風防： プラスチック枠",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/RHYTHM_8RDA46RH03.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rhythm.png",
  },
  {
    id: "662",
    brand: "Citizen",
    sku: "DIT-50",
    product_eng: "CITIZEN Tournament Clock",
    product_jpn: "CITIZEN ザ・名人戦",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥15,000",
    rrp_with_vat: "¥16,500",
    description_eng:
      "A game clock for many Shogi and Go fans to experience tournament games!  ◆Compatible with a variety of board game rules from around the world   Shogi, Igo/Renshu, Chess, Xiangqi (Chinese chess), and Reversi ◆Tense and exciting games!   With the addition of a time consideration function, you can recreate the same tournament games as on TV. ◆7 game modes   7 different game modes: Snapping, SECONDS, CONSIDERATION TIME, FISCHER, CANADIAN STYLE, Chess, SHANJI, and the much-requested CONSIDERATION TIME, FISCHER rules, which are now being used in Shogi tournaments, are also supported. ◆Voice reading out function   Voice can be switched between Japanese, English and buzzer sound, and counts when the countdown starts. ◆Simple operation ◆Lightweight and compact design Dimensions: H98mm × W170mm × D62mm Mass: Approx. 400g (including batteries) Voice: Japanese, English, buzzer sound",
    description_jpn:
      "多くの将棋・囲碁ファンに向けた、トーナメント戦を体験できる対局時計！  ◆世界各国のボードゲームの様々なルールに対応   将棋、囲碁・連珠、チェス、象棋（シャンチー）、リバーシ ◆緊張感ある対局を   考慮時間の機能が加わり、テレビと同じトーナメント戦を再現できます。 ◆7種類のゲームモード   切れ負け、秒読み、考慮時間、フィッシャー、カナダ式、チェス、シャンチー、要望の多かった考慮時間、将棋トーナメントで使われ始めたフィッシャールールにも対応します。 ◆音声による読み上げ機能   日本語、英語、ブザー音の音声切り替えが可能で秒読みに入るとカウントを行います。 ◆操作がシンプル ◆軽量コンパクト設計 寸   法 ：H98mm × W170mm × D62mm 質   量 ：約 400g(電池含む) 音   声 ：日本語、英語、ブザー音",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/CITIZEN_DIT-50.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "663",
    brand: "Citizen",
    sku: "8RZ232-003",
    product_eng: "CITIZEN Digital thermo-hygrometer",
    product_jpn: "CITIZEN デジタル温湿度計",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,500",
    description_eng:
      "High accuracy digital temperature/hygrometer with environmental reference.  Main Features/Features: With clock Temperature display (-9.9 to 50°C) Humidity display (20 to 95%) Environmental guideline display (Heat stroke, Influenza, and Comfort display types) Minimum/ maximum value (temperature and humidity) display function within 24 to 25 hours Calendar display (displayable until December 31, 2099)  Size/weight: 132 x 186 x 53 mm / 290 g Material/wind shield: Plastic frame",
    description_jpn:
      "環境目安付き高精度デジタル温湿度計です。  主な機能・特徴： 時計付 温度表示（-9.9～50℃） 湿度表示（20～95%） 環境目安表示（「熱中症」「インフルエンザ」「快適」表示タイプ） 24～25時間以内の最低/最高値（温度・湿度）表示機能 カレンダー表示(2099年12月31日まで表示可能)  サイズ・重さ： 132×186×53mm/290g 材質/風防： プラスチック枠",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/CITIZEN_8RZ232-003.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "664",
    brand: "Citizen",
    sku: "8MY529-006",
    product_eng: "CITIZEN Wooden frame Octagonal Wall Clock",
    product_jpn: "CITIZEN 木枠８角形 壁掛け時計",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng:
      "Simple, modern octagonal, wood-framed wall clock. Quiet with continuous second hand.  Size and weight：320 x 320 x 51.7 mm/860 g. Material/wind shield wooden frame/glass",
    description_jpn:
      "シンプルモダンな八角形、木枠掛け時計。 連続秒針で静か。 サイズ・重さ320×320×51.7mm/860g 材質・風防木枠/ガラス",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/CITIZEN_8MY529-006.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/CITIZEN_8MY529-006_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "665",
    brand: "Citizen",
    sku: "8MY535-006",
    product_eng: "CITIZEN Wooden frame Round Wall Clock",
    product_jpn: "CITIZEN 木枠円形 壁掛け時計",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥15,000",
    rrp_with_vat: "¥16,500",
    description_eng:
      "This wall clock is easy to match with your interior design and is also recommended as a gift. This wall clock has a slender and sharp wooden frame. Round type, easy to match with your room. Continuous second hand.  Size and weightφ320×53.6mm/860g Material/Wind shield wooden frame/glass",
    description_jpn:
      "ギフトにもおすすめのインテリアに合わせやすい掛時計です。 細身でシャープな木枠の掛時計です。お部屋に合わせやすい丸型のタイプです。 連続秒針。 サイズ・重さφ320×53.6mm/860g 材質・風防木枠/ガラス",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/CITIZEN_8MY535-006.jpg",
    product_image_2:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/CITIZEN_8MY535-006_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "666",
    brand: "Citizen",
    sku: "8RZ202-003",
    product_eng: "CITIZEN Large-screen digital radio-controlled clock",
    product_jpn: "CITIZEN 大画面デジタル電波時計",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,500",
    description_eng:
      "This is an automatically lit digital radio-controlled clock with a large screen that is easy to read day and night. The light from the bottom of the clock body can be used as a night light by your bedside. Features: Automatic light on in dark place (with ON/OFF switch) Press the light button to make the light brighter. Radio wave alarm clock Electronic sound alarm (changes in 4 stages) Calendar display (displayable until December 31, 2099) Temperature display (-9.9 to 50°C) Humidity display (20 to 95%) Angle adjustment function  Size and weight 88 x 209 x 65mm/350g Material/wind shield plastic frame",
    description_jpn:
      "昼夜見やすい大画面の自動点灯デジタル電波時計です。 時計体下部からの光が、枕元の常夜灯としてもお使いいただけます。 機能： 暗所自動ライト点灯（ON/OFFスイッチ付） ライトボタンを押すとさらに明るくなります。 電波目覚まし時計 電子音アラーム（4段階に変化） カレンダー表示（2099年12月31日まで表示可能） 温度表示（-9.9～50℃） 湿度表示（20～95％） 角度調節機能付  サイズ・重さ 88×209×65mm/350g 材質・風防プラスチック枠",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/rhythm/CITIZEN_8RZ202-003.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "668",
    brand: "Citizen",
    sku: "BL5495-72E",
    product_eng: "Citizen Collection BL5495-72E",
    product_jpn: "Citizen シチズンコレクション BL5495-72E",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥50,000",
    rrp_with_vat: "¥55,000",
    description_eng:
      "Sporty chronograph model for adults.  Power Photovoltaic Eco-Drive No need for regular battery replacement Photo-power generation Eco-Drive is Citizen's proprietary technology that converts sunlight or a small amount of indoor light into electricity to keep the watch running. Once fully charged, the watch continues to run for a long time even in the absence of light, eliminating the need for periodic battery replacement.  Accuracy ±15 seconds/month  Duration 2 years (with power saving function)  Weight 133g  Thickness 11.1mm  Case size 39.5mm in width  Case material Stainless steel  Case surface treatment Plating (gray and brown)  Band material/type Stainless steel Three-fold push type  Band width 20.0mm  Adjustable band size 150-194mm  Glass Spherical crystal glass  Water resistance 10 atmospheric pressure waterproofing  Design features Luminescence (hands + indexes)  Functions Charging warning function Overcharge prevention function Power saving function Time setting notification function Approx. 2 years on full charge (with power saving function) Perpetual calendar Date display Date correction function 24-hour time display 1/20 second chronograph (60-minute counter) Local time function Alarm",
    description_jpn:
      "大人のためのスポーティーなクロノグラフモデル。  動力 光発電エコ・ドライブ 定期的な電池交換は不要 光発電『エコ・ドライブ』は、太陽光や室内のわずかな光を電気に換え、時計を動かしつづけるシチズン独自の技術です。一度フル充電すれば、光のないところでも長時間動き続けるので、定期的な電池交換は必要ありません。  精度 ±15秒／月  持続時間 光発電2年(パワーセーブ作動時)  重量 133g  厚み 11.1mm  ケースサイズ 横 39.5mm  ケース素材 ステンレス  ケース表面処理 めっき(グレー色・ブラウン色)  バンド素材・タイプ ステンレス 三ツ折れプッシュタイプ  バンド幅 20.0mm  バンド調整可能サイズ 150～194mm  ガラス 球面クリスタルガラス  防水性能 10気圧防水  デザイン特徴 夜光(針＋インデックス)  機能 充電警告機能 過充電防止機能 パワーセーブ機能 時刻合わせ告知機能 フル充電時約2年可動(パワーセーブ作動時) パーペチュアルカレンダー 日付表示 日付早修正機能 24時間表示 1/20秒クロノグラフ(60分計) ローカルタイム機能 アラーム",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_BL5495-72E.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "669",
    brand: "Citizen",
    sku: "BL5496-96L",
    product_eng: "Citizen Collection BL5496-96L",
    product_jpn: "Citizen シチズンコレクション BL5496-96L",
    category_1: "Jewelry & Watches",
    category_2: "",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      "Eco-Drive chronograph/perpetual calendar series with metal face.  Power Photovoltaic Eco-Drive No need for periodic battery replacement Photo-power generation Eco-Drive is Citizen's proprietary technology that converts sunlight or a small amount of indoor light into electricity to keep the watch running. Once fully charged, the watch continues to run for a long time even in the absence of light, eliminating the need for periodic battery replacement.  Accuracy ±15 seconds/month  Duration 2 years (when power-save is activated)  Weight 133g  Thickness 11.1mm  Case size 39.5mm in width  Case material Stainless steel  Case surface treatment Partially plated (Jet Black color)  Band material/type Stainless steel Three-fold push type  Band width 20.0mm  Adjustable band size 150-194mm  Glass Spherical crystal glass  Water resistance 10 atmospheric pressure waterproofing  Design features Luminescence (hands + indexes)  Functions Charging warning function Overcharge prevention function Power saving function Time setting notification function Approx. 2 years on full charge (with power saving function) Perpetual calendar Date display Date correction function 24-hour time display 1/20 second chronograph (60-minute counter) Local time function Alarm Country of origin Made in Japan",
    description_jpn:
      "メタルフェイスを採用した、エコ・ドライブ クロノグラフ／パーペチュアルカレンダーシリーズ。  動力 光発電エコ・ドライブ ※定期的な電池交換は不要 光発電『エコ・ドライブ』は、太陽光や室内のわずかな光を電気に換え、時計を動かしつづけるシチズン独自の技術です。 一度フル充電すれば、光のないところでも長時間動き続けるので、定期的な電池交換は必要ありません。  精度 ±15秒／月  持続時間 光発電2年(パワーセーブ作動時)  重量 133g  厚み 11.1mm  ケースサイズ 横 39.5mm  ケース素材 ステンレス  ケース表面処理 一部めっき(ジェットブラック色)  バンド素材・タイプ ステンレス 三ツ折れプッシュタイプ  バンド幅 20.0mm  バンド調整可能サイズ 150～194mm  ガラス 球面クリスタルガラス  防水性能 10気圧防水  デザイン特徴 夜光(針＋インデックス)  機能 充電警告機能 過充電防止機能 パワーセーブ機能 時刻合わせ告知機能 フル充電時約2年可動(パワーセーブ作動時) パーペチュアルカレンダー 日付表示 日付早修正機能 24時間表示 1/20秒クロノグラフ(60分計) ローカルタイム機能 アラーム 原産国 日本製",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/citizen/Citizen_BL5496-96L.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/citizen.png",
  },
  {
    id: "670",
    brand: "De'Longhi",
    sku: "RHJ21F1015-LG",
    product_eng: "De'Longhi Verti Cardo Electric Oil-Filled Heater",
    product_jpn: "De'Longhi デロンギ ヴェルティカルド オイルヒーター",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥29,818",
    rrp_with_vat: "¥32,800",
    description_eng:
      "Modern design and easy to use. The combination of white and light gray harmonizes with your interior, and the vertical lines of this model are distinctive.  For rooms up to 10-13 mats 1500W type ideal for living rooms and other spacious rooms  Safe design with a temperature of approx. 80°C to prevent burns.  24 hours a day, as you wish. Convenient timer setting.  Thermostat to maintain the proper temperature to cut down on excess electricity costs.  Power level (heating intensity) can be adjusted with the operation switch dial.  De'Longhi's unique safety plug Safety plug activates in the event of abnormal overheating (approx. 80°C or higher) and turns off the heater.  Foldable casters with no assembly required. No need to refill or replace fuel at all.  Warms the entire room even without airflow. Dimensions (mm): 260 (W) x 520 (D) x 650 (H) Main unit weight (kg): 15 Color: White + light gray Power cord length (m): 2.4 Voltage/frequency: AC100V/50-60Hz Power consumption (W): 1500 Power switching (W): High: 1500 / Medium: 900 / Low: 600 Standby power (W): 0.1 Fin shape: Thermal cut fins Number of fins: 10 Timer: 24-hour ON/OFF electronic timer (30-minute increments) Approximate floor space (tatami): 10-13 Average surface temperature (°C): 80",
    description_jpn:
      "モダンなデザインで使いやすい。 ホワイトとライトグレーの組み合わせがインテリアに調和する、縦のラインが特徴的なモデル。  10〜13畳までのお部屋に リビングなど広めのお部屋に最適な1500Ｗタイプ  約80℃、やけどしにくい安全設計  24時間思いのままに。便利なタイマー設定  適温を保つサーモスタットで、余分な電気代をカット  運転切り替えダイヤルで、電力レベル（暖房の強さ）を調整可能  デロンギ独自の安全プラグ 安全プラグが異常過熱（約80℃以上）したときに作動し、ヒーターの電源を切ります。  組み立て不要の折りたたみ式キャスター付き。燃料の補充や交換も一切不要  風が出なくても部屋全体が暖かい  肌も喉も乾燥しにくい 外形寸法（mm）:\t幅260×奥行520×高さ650 本体質量（kg）:\t15 色:\tホワイト＋ライトグレー 電源コードの長さ（m）:\t2.4 電圧/周波数:\tAC100V／50-60Hz 消費電力（W）:\t1500 電力切替（W）:\t強:1500 / 中:900 / 弱:600 待機電力（W）:\t0.1 フィン形状:\tサーマルカットフィン フィン枚数:\t10 タイマー:\t24時間ON/OFF電子タイマー（30分刻み） 広さの目安（畳）:\t10～13 平均表面温度（℃）:\t80",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/DeLonghi_RHJ21F1015-LG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "671",
    brand: "De'Longhi",
    sku: "HXJ60L12-WH",
    product_eng: "De'Longhi Convector Heater",
    product_jpn: "De'Longhi デロンギ コンベクターヒーター",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥29,800",
    rrp_with_vat: "¥32,780",
    description_eng:
      "Convector heater that speedily warms the entire room. Slim and wide design to prevent cold drafts from windows.  For rooms up to 8-10 mats.  Outstanding quick heating  Shuts out cold air by placing it near a window.  Equipped with ECO mode that saves about 20% of electricity.  Easy-to-operate digital interface  Low risk of burns and fires. Average surface temperature 70°C  Simple and stylish Italian design Dimensions (mm): W 825 x D 310 x H 565 (including casters) Main unit weight (kg): 7.5 Color: gray Power cord length (m): 1.9 Voltage/frequency: AC100V/50/60Hz Power consumption (W): 1200 Power switching (W): High: 1200 / Medium: 800 / Low: 500 Standby power (W): 1.0 Timer: Digital timer (ON or OFF) Approximate size: 8 to 10 Average surface temperature (°C): 70",
    description_jpn:
      "スピーディに部屋全体を暖めるコンベクターヒーター。 窓からのコールドドラフトを防ぐスリム＆ワイドデザイン。  ８～１０畳までのお部屋に  抜群の速暖暖房  窓際に置くことで冷気をシャットアウト  約20％節電できるＥＣＯモード搭載。  操作しやすいデジタルインターフェース  やけどや火事の心配が少ない。平均表面温度70℃  シンプルでスタイリッシュなイタリアンデザイン 外形寸法（mm）:\t幅825×奥行310×高さ565（キャスター含む） 本体質量（kg）:\t7.5 色:\tグレー 電源コードの長さ（m）:\t1.9 電圧/周波数:\tAC100V／50/60Hz 消費電力（W）:\t1200 電力切替（W）:\t強:1200 / 中：800 / 弱:500 待機電力（W）:\t1.0 タイマー:\tデジタルタイマー（ONまたはOFF) 広さの目安:\t8～10 平均表面温度（℃）:\t70",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/DeLonghi_HXJ60L12-WH.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "672",
    brand: "De'Longhi",
    sku: "HFX30C11-IW",
    product_eng: "De'Longhi CAPSULA Ceramic Fan Heater Ivory",
    product_jpn:
      "De'Longhi デロンギ カプスーラ セラミックファンヒーター アイボリーホワイト",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥8,909",
    rrp_with_vat: "¥9,800",
    description_eng:
      "Compact but quickly warms up with high power of 1150W. Ceramic fan heater with a distinctive rounded design.  Stylish design  Lightweight and compact, yet high-power  Two heating power options: low and high, and selectable airflow.  High warmth and safety.  Compact design for easy portability and use Dimensions (mm): W195 x D150 x H275 Main unit weight (kg): 1.35 Power cord length (m): 1.9 Voltage/frequency: 100V/50-60Hz Power consumption (W): 1150 Power switching (W): High 1150/weak 750 (airflow: 6)",
    description_jpn:
      "コンパクトだけど1150Wのハイパワーで素早く暖める。 丸みを帯びたデザインが特徴的なセラミックファンヒーター。  スタイリッシュなデザイン  軽量でコンパクトなのにハイパワー  弱・強の２つの暖房パワー切替及び送風の選択可能  高い速暖性と安全性を両立  持ち運びと使いやすさに優れたコンパクトデザイン 外形寸法（mm）:\t幅195×奥行150×高さ275 本体質量（kg）:\t1.35 電源コードの長さ（m）:\t1.9 電圧/周波数:\t100V/50-60Hz 消費電力（W）:\t1150 電力切替（W）:\t強1150//弱750（送風：６）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/DeLonghi_HFX30C11-IW.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "673",
    brand: "De'Longhi",
    sku: "HFX30C11-AG",
    product_eng: "De'Longhi CAPSULA Ceramic Fan Heater Asphalt",
    product_jpn:
      "De'Longhi デロンギ カプスーラ セラミックファンヒーター アスファルトブラック",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥8,909",
    rrp_with_vat: "¥9,800",
    description_eng:
      "Compact but quickly warms up with high power of 1150W. Ceramic fan heater with a distinctive rounded design.  Stylish design  Lightweight and compact, yet high-power  Two heating power options: low and high, and selectable airflow.  High warmth and safety.  Compact design for easy portability and use Dimensions (mm): W195 x D150 x H275 Main unit weight (kg): 1.35 Power cord length (m): 1.9 Voltage/frequency: 100V/50-60Hz Power consumption (W): 1150 Power switching (W): High 1150/weak 750 (airflow: 6)",
    description_jpn:
      "コンパクトだけど1150Wのハイパワーで素早く暖める。 丸みを帯びたデザインが特徴的なセラミックファンヒーター。  スタイリッシュなデザイン  軽量でコンパクトなのにハイパワー  弱・強の２つの暖房パワー切替及び送風の選択可能  高い速暖性と安全性を両立  持ち運びと使いやすさに優れたコンパクトデザイン 外形寸法（mm）:\t幅195×奥行150×高さ275 本体質量（kg）:\t1.35 電源コードの長さ（m）:\t1.9 電圧/周波数:\t100V/50-60Hz 消費電力（W）:\t1150 電力切替（W）:\t強1150//弱750（送風：６）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/delonghi/DeLonghi_HFX30C11-AG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },

  {
    id: "1071",
    brand: "De'Longhi",
    sku: "KBS1200J-W",
    product_eng: "De'Longhi Seta Electric Kettle White",
    product_jpn: "De'Longhi デロンギ セタ 電気ケトル ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥6,345",
    rrp_with_vat: "¥6,980",
    description_eng:
      "Elegant and Smooth Design Like Silk Drapes, Enhancing Your Kitchen. A Lightweight and Compact 0.8L Electric Kettle.  Features:  One-Touch Opening Lid Easy-to-Read Water Level Indicator Automatic Power Off and Boil-Dry Protection Power Cord Holder Specifications:  Capacity: 0.8L Dimensions (Height x Width x Depth) (Body + Base): 220 x 165 x 185mm Weight (Body + Base): 0.9kg Power Consumption: 1200W Cord Length: 1.2m Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "シルクのドレープのように優雅でなめらかなデザインでキッチンを彩ります。軽くてコンパクトな0.8L容量の電気ケトルです。  ●ワンプッシュで開くふた ●見やすい水量計 ●自動電源オフ、空だき防止機能付き ●電源コードホルダー  【仕様】 容量：0.8L サイズ（高さ×幅×奥行） (本体＋ベース）：220×165×185mm 本体重量 (本体＋ベース）：0.9kg 消費電力 ：1200W コード長：1.2m メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/delonghi/KBS1200J-W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "1072",
    brand: "De'Longhi",
    sku: "KBS1200J-BK",
    product_eng: "De'Longhi Seta Electric Kettle Black",
    product_jpn: "De'Longhi デロンギ セタ 電気ケトル ブラック",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥6,345",
    rrp_with_vat: "¥6,980",
    description_eng:
      "Elegant and Smooth Design Like Silk Drapes, Enhancing Your Kitchen. A Lightweight and Compact 0.8L Electric Kettle.  Features:  One-Touch Opening Lid Easy-to-Read Water Level Indicator Automatic Power Off and Boil-Dry Protection Power Cord Holder Specifications:  Capacity: 0.8L Dimensions (Height x Width x Depth) (Body + Base): 220 x 165 x 185mm Weight (Body + Base): 0.9kg Power Consumption: 1200W Cord Length: 1.2m Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "シルクのドレープのように優雅でなめらかなデザインでキッチンを彩ります。軽くてコンパクトな0.8L容量の電気ケトルです。  ●ワンプッシュで開くふた ●見やすい水量計 ●自動電源オフ、空だき防止機能付き ●電源コードホルダー  【仕様】 容量：0.8L サイズ（高さ×幅×奥行） (本体＋ベース）：220×165×185mm 本体重量 (本体＋ベース）：0.9kg 消費電力 ：1200W コード長：1.2m メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/delonghi/KBS1200J-BK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "1073",
    brand: "De'Longhi",
    sku: "KBS1200J-BG",
    product_eng: "De'Longhi Seta Electric Kettle Beige",
    product_jpn: "De'Longhi デロンギ セタ 電気ケトル ベージュ",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥6,345",
    rrp_with_vat: "¥6,980",
    description_eng:
      "Elegant and Smooth Design, Enhancing Your Kitchen Like a Silk Drape. A Lightweight and Compact 0.8L Electric Kettle.  Features:  One-Touch Opening Lid Easy-to-Read Water Level Indicator Automatic Power Off and Boil-Dry Protection Power Cord Holder Specifications:  Capacity: 0.8L Dimensions (Height x Width x Depth) (Body + Base): 220 x 165 x 185mm Weight (Body + Base): 0.9kg Power Consumption: 1200W Cord Length: 1.2m Manufacturer Warranty Period: 1 year  *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "シルクのドレープのように優雅でなめらかなデザインでキッチンを彩ります。軽くてコンパクトな0.8L容量の電気ケトルです。  ●ワンプッシュで開くふた ●見やすい水量計 ●自動電源オフ、空だき防止機能付き ●電源コードホルダー  【仕様】 容量：0.8L サイズ（高さ×幅×奥行） (本体＋ベース）：220×165×185mm 本体重量 (本体＋ベース）：0.9kg 消費電力 ：1200W コード長：1.2m メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/delonghi/KBS1200J-BG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "1074",
    brand: "De'Longhi",
    sku: "EO12562J-WN",
    product_eng: "De'Longhi SFORNATUTTO Concection Oven",
    product_jpn: "De'Longhi デロンギ スフォルナトゥット コンベクションオーブン",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥30,727",
    rrp_with_vat: "¥33,800",
    description_eng:
      "Family-Sized Convection Oven  A convection oven that circulates gentle heat, thoroughly cooking food by enveloping it. It is versatile enough for everything from toasting to baking cakes and bread, and even roasting beef.  Features:  Even and Delicious Baking: With 1400W high power and U-shaped heaters, it ensures even and delicious baking. Quick Startup: As a dedicated oven, it heats up quickly without needing to consider preheating time, so you can start cooking immediately. Crispy Pizza with Included Pizza Stone: The 30cm round pizza stone absorbs moisture and oil from the ingredients, resulting in a crispy crust. Original Recipe Book Included Specifications:  Oven Capacity: 14L Power Consumption: 1400W Power Cord Length: 2.1m Main Unit Weight: 6.8kg Main Unit Dimensions (approx.): Width 490mm × Depth 365mm × Height 240mm Temperature Settings: 100–220℃ Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "ファミリーサイズのコンベクションオーブン  やわらかい熱を対流させて、食材を包み込むようにじっくり火を通すコンベクションオーブン。トーストからケーキやパン、ローストビーフなどの本格オーブン調理まで幅広く活躍します。 ●ムラ無く美味しく焼き上げる 1400Wのハイパワーとロの字型シーズヒーター採用で、ムラ無く美味しく焼き上げる ●オーブン専用機だがら立ち上がりが早い 余熱時間を考慮せずに、思い立ったらすぐに使える ●パリッと焼きあがるピザストーン付属 30ｃｍの丸型ピザストーンが食材から出る水分や油を程よく吸収して、パリッと焼き上げる ●オリジナルレシピブック付属 【仕様】 庫内容量：14L 消費電力：1400W 電源コード長：2.1ｍ 本体質量：6.8ｋｇ 本体寸法(約)：幅490×奥行365×高さ240mm 設定温度：100～220℃ メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/delonghi/EO12562J-WN.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "1075",
    brand: "De'Longhi",
    sku: "TCX752J-RD",
    product_eng: "De'Longhi K-mix pop-up toaster Red",
    product_jpn:
      "De'Longhi デロンギ ケーミックス ポップアップトースター レッド",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥12,545",
    rrp_with_vat: "¥13,800",
    description_eng:
      "Timeless, Simple Functional Beauty. The New kMix Pop-Up Toaster with a Metal Plate Accented by a Large Logo  Delicious Bread with Perfect Browning  The pop-up style toaster produces delicious toast that is crispy on the outside and fluffy on the inside. The browning can be adjusted to your preference with five settings. The slots can accommodate slices as thick as five slices.  Suitable for Bagels and English Muffins  Equipped with a one-sided toasting function, convenient for toasting only one side of halved bagels or English muffins, as well as defrosting and reheating functions.  Easy to Clean with a Pull-Out Crumb Tray  Specifications:  Dimensions: Width 165mm × Depth 275mm × Height 210mm Main Unit Weight: 2.1kg Power Consumption: 900W Voltage/Frequency: 100V/50-60Hz Power Cord Length: 1.5m Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "いつの時代も変わらない、シンプルな機能美。メタル素材にロゴを大きくあしらったプレートがアクセントの新しいケーミックスのポップアップトースター  ●焼き目までこだわったおいしいパンを食卓に ポップアップ式で外はこんがり、中はふわふわの美味しいトーストが焼けます。焼き目調整はお好みに合わせて5段階で設定が可能です。スロットは厚めの5枚切りまで対応。 ●ベーグルやイングリッシュマフィンにも 半分に切ったベーグルやイングリッシュマフィンの片面だけを焼くのに便利な片面焼き機能や、回答・温めなおし機能を搭載しています。 ●掃除がしやすく清潔に保て引き出し式くず受け 【仕様】 外形寸法 幅165mm × 奥行275mm × 高さ210mm 本体質量 2.1kg 消費電力 900W 電圧／周波数 100V/50-60Hz 電源コードの長さ 1.5m 外形寸法 幅165mm × 奥行275mm × 高さ210mm 本体質量 2.1kg 消費電力 900W 電圧／周波数 100V/50-60Hz 電源コードの長さ 1.5m メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/delonghi/TCX752J-RD.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "1076",
    brand: "De'Longhi",
    sku: "TCX752J-WH",
    product_eng: "De'Longhi K-mix pop-up toaster White",
    product_jpn:
      "De'Longhi デロンギ ケーミックス ポップアップトースター ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥12,545",
    rrp_with_vat: "¥13,800",
    description_eng:
      "Timeless, Simple Functional Beauty. The New kMix Pop-Up Toaster with a Metal Plate Accented by a Large Logo  Delicious Bread with Perfect Browning  The pop-up style toaster produces delicious toast that is crispy on the outside and fluffy on the inside. The browning can be adjusted to your preference with five settings. The slots can accommodate slices as thick as five slices.  Suitable for Bagels and English Muffins  Equipped with a one-sided toasting function convenient for toasting only one side of halved bagels or English muffins, as well as defrosting and reheating functions.  Easy to Clean with a Pull-Out Crumb Tray  Specifications:  Dimensions: Width 165mm × Depth 275mm × Height 210mm Main Unit Weight: 2.1kg Power Consumption: 900W Voltage/Frequency: 100V/50-60Hz Power Cord Length: 1.5m Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "いつの時代も変わらない、シンプルな機能美。メタル素材にロゴを大きくあしらったプレートがアクセントの新しいケーミックスのポップアップトースター  ●焼き目までこだわったおいしいパンを食卓に ポップアップ式で外はこんがり、中はふわふわの美味しいトーストが焼けます。焼き目調整はお好みに合わせて5段階で設定が可能です。スロットは厚めの5枚切りまで対応。 ●ベーグルやイングリッシュマフィンにも 半分に切ったベーグルやイングリッシュマフィンの片面だけを焼くのに便利な片面焼き機能や、回答・温めなおし機能を搭載しています。 ●掃除がしやすく清潔に保て引き出し式くず受け 【仕様】 外形寸法 幅165mm × 奥行275mm × 高さ210mm 本体質量 2.1kg 消費電力 900W 電圧／周波数 100V/50-60Hz 電源コードの長さ 1.5m 外形寸法 幅165mm × 奥行275mm × 高さ210mm 本体質量 2.1kg 消費電力 900W 電圧／周波数 100V/50-60Hz 電源コードの長さ 1.5m メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/delonghi/TCX752J-WH.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "1077",
    brand: "De'Longhi",
    sku: "TCX752J-BK",
    product_eng: "De'Longhi K-mix pop-up toaster Black",
    product_jpn:
      "De'Longhi デロンギ ケーミックス ポップアップトースター ブラック",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥12,545",
    rrp_with_vat: "¥13,800",
    description_eng:
      "Timeless, Simple Functional Beauty. The New kMix Pop-Up Toaster with a Metal Plate Accented by a Large Logo  Delicious Toast with Perfect Browning  The pop-up style toaster produces delicious toast that is crispy on the outside and fluffy on the inside. The browning can be adjusted to your preference with five settings. The slots can accommodate slices as thick as five slices.  Suitable for Bagels and English Muffins  Equipped with a one-sided toasting function convenient for toasting only one side of halved bagels or English muffins, as well as defrosting and reheating functions.  Easy to Clean with a Pull-Out Crumb Tray  Specifications:  Dimensions: Width 165mm × Depth 275mm × Height 210mm Main Unit Weight: 2.1kg Power Consumption: 900W Voltage/Frequency: 100V/50-60Hz Power Cord Length: 1.5m Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "いつの時代も変わらない、シンプルな機能美。メタル素材にロゴを大きくあしらったプレートがアクセントの新しいケーミックスのポップアップトースター  ●焼き目までこだわったおいしいパンを食卓に ポップアップ式で外はこんがり、中はふわふわの美味しいトーストが焼けます。焼き目調整はお好みに合わせて5段階で設定が可能です。スロットは厚めの5枚切りまで対応。 ●ベーグルやイングリッシュマフィンにも 半分に切ったベーグルやイングリッシュマフィンの片面だけを焼くのに便利な片面焼き機能や、回答・温めなおし機能を搭載しています。 ●掃除がしやすく清潔に保て引き出し式くず受け 【仕様】 外形寸法 幅165mm × 奥行275mm × 高さ210mm 本体質量 2.1kg 消費電力 900W 電圧／周波数 100V/50-60Hz 電源コードの長さ 1.5m 外形寸法 幅165mm × 奥行275mm × 高さ210mm 本体質量 2.1kg 消費電力 900W 電圧／周波数 100V/50-60Hz 電源コードの長さ 1.5m メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/delonghi/TCX752J-BK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "1078",
    brand: "De'Longhi",
    sku: "EC9155J-B",
    product_eng:
      "De'Longhi La Specialista ARTE Espresso and cappuccino makers Black",
    product_jpn:
      "De'Longhi デロンギ ラ・スペシャリスタ・アルテ エスプレッソ・カプチーノメーカー ブラック",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥116,364",
    rrp_with_vat: "¥128,000",
    description_eng:
      "Espresso and Cappuccino Maker with Built-in Coffee Grinder  Experience the joy of brewing freshly ground espresso beans at home with this espresso and cappuccino maker with a built-in grinder. From grinding beans to tamping and steaming milk, you can adjust it like a barista to create not just espresso but also cappuccinos and latte art to your preference.  Features:  8-Stage Conical Grinder: The conical grinder grinds coffee beans evenly at low speed, reducing friction heat to preserve the beans' original aroma and flavor. Adjustable from Grinding to Extraction: The built-in grinder allows you to manually adjust from grinding to leveling (the process of smoothing the coffee grounds) and tamping, enjoying the process like a barista. The adjustment reflects directly on the extraction results, enhancing the pleasure of pursuing the perfect brew. Pre-infusion time can also be adjusted in three stages. Steam for Ideal Milk Foam Suitable for Latte Art Double-Layered Steam Wand: The outer layer stays cool, making it easy to handle and clean. Stable Extraction Temperature Control: The temperature control system ensures stable water temperature during coffee extraction, achieving the ideal brewing temperature. Customizable Extraction Volume (Quantitative Setting): Adjust the extraction volume by long-pressing the extraction button and releasing it at your desired amount. Comprehensive Barista Tools: Includes tamper, milk jug, tamping mat, tamping guide, and other tools for a complete barista experience. Easy Maintenance: Removable parts such as the cup tray, drip tray, and water tank make cleaning easy. Specifications:  Voltage / Frequency: 100V (50/60Hz) Power Consumption: 1450W Dimensions / Weight: Width: 285mm, Depth: 370mm, Height: 400mm, Main Unit Weight: 8.8kg Power Cord Length: 2.0m Included Accessories: Filter holder, single shot filter, double shot filter, tamping guide, tamper, tamping mat, milk jug, espresso cup tray, cleaning brush, frother cleaning pin, water hardness checker, descaler for coffee machines Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "コーヒーグラインダー搭載で豆から挽きたてのエスプレッソを自分の手で淹れることができる、グラインダー付きのエスプレッソ・カプチーノメーカー。豆挽きからタンピング、ミルクのスチームまでバリスタさながらに調整しエスプレッソだけでなく、カプチーノやラテアートもお好みの一杯を追求する愉しみをご自宅で体験いただけます。  ●8段階のコーン式グラインダー搭載 低速回転で摩擦熱を抑えながら均一にコーヒー豆を挽くコーン式グラインダーを採用し、揮発性のアロマを損なわずコーヒー豆本来の風味を生かします。 ●豆挽きから抽出まで自分好みにこれ一台で調整可能 グラインダー搭載で豆挽きからレベリング（コーヒー粉を均す工程）やタンピングまでバリスタさながらに所作を愉しみながら手動で調整いただけます。 抽出までの調整具合が抽出結果にそのまま表れるため、抽出工程を追求する愉しみを味わえます。また、蒸らしの時間設定も3段階で調整が可能です。 ●ラテアートにも適した理想的なフォームミルクをつくり出すスチーム ●二重構造のスチーム管 外装が高温になりにくく、お手入れも簡単。 ●安定した抽出温度制御 温度制御システムにより、コーヒー抽出時に安定した湯温を確保し、理想的な抽出温度を実現します。 ●抽出量のカスタマイズ（定量設定） 抽出ボタンを長押しして抽出し、お好みの量でボタンを放すだけで調整が出来ます。 ●充実のバリスタツール タンパーやミルクジャグに加えて、タンピングマットやタンピングガイドなど抽出前の工程で使用できるバリスタツールが充実しており、本格的なバリスタ体験の追求をサポートします。 ●簡単お手入れ カップ受けやトレイ、水タンクなどの各種パーツは取り外して清掃することができます。  電圧／周波数 100V(50/60Hz) 消費電力 1450W 外形寸法／重量 幅：285mm 奥行：370mm 高さ：400mm 本体重量：8.8Kg 電源コードの長さ：2.0m 付属品 フィルターホルダー、1杯用フィルター、2杯用フィルター、タンピングガイド、タンパー、タンピングマット、ミルクジャグ、エスプレッソカップ受け、クリーニングブラシ、フロッサークリーニングピン、水硬度チェッカー、コーヒーマシン用除石灰剤 メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/delonghi/EC9155J-B.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },
  {
    id: "1079",
    brand: "De'Longhi",
    sku: "EC9155J-W",
    product_eng:
      "De'Longhi La Specialista ARTE Espresso and cappuccino makers White",
    product_jpn:
      "De'Longhi デロンギ ラ・スペシャリスタ・アルテ エスプレッソ・カプチーノメーカー ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥116,364",
    rrp_with_vat: "¥128,000",
    description_eng:
      "Espresso and Cappuccino Maker with Built-in Coffee Grinder  Experience the joy of brewing freshly ground espresso beans at home with this espresso and cappuccino maker with a built-in grinder. From grinding beans to tamping and steaming milk, you can adjust it like a barista to create not just espresso but also cappuccinos and latte art to your preference.  Features:  8-Stage Conical Grinder: The conical grinder grinds coffee beans evenly at low speed, reducing friction heat to preserve the beans' original aroma and flavor. Adjustable from Grinding to Extraction: The built-in grinder allows you to manually adjust from grinding to leveling and tamping, enjoying the process like a barista. The adjustments reflect directly on the extraction results, enhancing the pleasure of pursuing the perfect brew. Pre-infusion time can also be adjusted in three stages. Ideal Steam for Latte Art: Produces perfect milk foam suitable for latte art. Double-Layered Steam Wand: The outer layer stays cool, making it easy to handle and clean. Stable Extraction Temperature Control: The temperature control system ensures stable water temperature during coffee extraction, achieving the ideal brewing temperature. Customizable Extraction Volume: Adjust the extraction volume by long-pressing the extraction button and releasing it at your desired amount. Comprehensive Barista Tools: Includes tamper, milk jug, tamping mat, tamping guide, and other tools for a complete barista experience. Easy Maintenance: Removable parts such as the cup tray, drip tray, and water tank make cleaning easy. Specifications:  Voltage / Frequency: 100V (50/60Hz) Power Consumption: 1450W Dimensions / Weight: Width: 285mm, Depth: 370mm, Height: 400mm, Main Unit Weight: 8.8kg Power Cord Length: 2.0m Included Accessories: Filter holder, single shot filter, double shot filter, tamping guide, tamper, tamping mat, milk jug, espresso cup tray, cleaning brush, frother cleaning pin, water hardness checker, descaler for coffee machines Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "コーヒーグラインダー搭載で豆から挽きたてのエスプレッソを自分の手で淹れることができる、グラインダー付きのエスプレッソ・カプチーノメーカー。豆挽きからタンピング、ミルクのスチームまでバリスタさながらに調整しエスプレッソだけでなく、カプチーノやラテアートもお好みの一杯を追求する愉しみをご自宅で体験いただけます。  ●8段階のコーン式グラインダー搭載 低速回転で摩擦熱を抑えながら均一にコーヒー豆を挽くコーン式グラインダーを採用し、揮発性のアロマを損なわずコーヒー豆本来の風味を生かします。 ●豆挽きから抽出まで自分好みにこれ一台で調整可能 グラインダー搭載で豆挽きからレベリング（コーヒー粉を均す工程）やタンピングまでバリスタさながらに所作を愉しみながら手動で調整いただけます。 抽出までの調整具合が抽出結果にそのまま表れるため、抽出工程を追求する愉しみを味わえます。また、蒸らしの時間設定も3段階で調整が可能です。 ●ラテアートにも適した理想的なフォームミルクをつくり出すスチーム ●二重構造のスチーム管 外装が高温になりにくく、お手入れも簡単。 ●安定した抽出温度制御 温度制御システムにより、コーヒー抽出時に安定した湯温を確保し、理想的な抽出温度を実現します。 ●抽出量のカスタマイズ（定量設定） 抽出ボタンを長押しして抽出し、お好みの量でボタンを放すだけで調整が出来ます。 ●充実のバリスタツール タンパーやミルクジャグに加えて、タンピングマットやタンピングガイドなど抽出前の工程で使用できるバリスタツールが充実しており、本格的なバリスタ体験の追求をサポートします。 ●簡単お手入れ カップ受けやトレイ、水タンクなどの各種パーツは取り外して清掃することができます。  電圧／周波数 100V(50/60Hz) 消費電力 1450W 外形寸法／重量 幅：285mm 奥行：370mm 高さ：400mm 本体重量：8.8Kg 電源コードの長さ：2.0m 付属品 フィルターホルダー、1杯用フィルター、2杯用フィルター、タンピングガイド、タンパー、タンピングマット、ミルクジャグ、エスプレッソカップ受け、クリーニングブラシ、フロッサークリーニングピン、水硬度チェッカー、コーヒーマシン用除石灰剤 メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/delonghi/EC9155J-W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/delonghi.png",
  },

  {
    id: "674",
    brand: "Philips",
    sku: "S5889/60",
    product_eng: "Philips shaver 5000 Series S5889/60",
    product_jpn: "Philips  フィリップス shaver 5000シリーズ S5889/60",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥21,000",
    rrp_with_vat: "¥23,100",
    description_eng:
      "For skin that inspires confidence. The decisive factor is the powerful cutting performance. The Philips S5000 series is equipped with SkinIQ technology that guides the shaver to the optimal shave according to the thickness of the beard and facial contours. It automatically adjusts the power according to the thickness of the beard for a perfect shave.  SkinIQ Technology This Philips technology detects the thickness of the beard and facial contours to guide and optimize shaving according to each individual's personality. Powerful Sharpness and Gentleness  The 45 blades cut 90,000 times per minute to efficiently capture beard growth in various directions for a deep shave.  The first lift blade lifts up the beard and the second cutting blade cuts for a deep shave.  Beard density sensing system for a clean deep shave.  The power is automatically adjusted according to the density of the beard by sensing the density of the beard 250 times per second. Automatically adjusts power according to beard density to shave even the thickest areas.  360-D flex-head for less shaving residue.  Accessories Care: Cleaning brush Quick clean pod: Yes 1 cartridge included Integrated pop-up trimmer: Yes Soft pouch for carrying and storage Protective cap USB-A cable included: Power adapter not included  Power supply Charging: Approx. 1 hour with 5-minute quick charge mode Battery type: Lithium-ion Supported voltage: 5 V Operating time: approx. 60 min. Standby power: 0.04 W Maximum power consumption: 5 W Supported voltage: 5 V",
    description_jpn:
      "自信がわく肌へ。決め手はパワフルな切れ味 フィリップス S5000シリーズは、ヒゲの濃さや顔の輪郭に合わせて、最適なシェービングへとガイドするSkinIQテクノロジーを搭載。 ヒゲの濃さに合わせて自動でパワーを調節するので、しっかり剃ることができます。  SkinIQテクノロジー ヒゲの濃さや顔の輪郭を感知し、一人ひとりの個性に合わせたシェービングへガイド・最適化するフィリップスのテクノロジー。 パワフルな切れ味とやさしさの両立  毎分90,000回カットする45枚刃で色々な方向に生えているヒゲを効率的に取り込み、しっかり深剃り。  1枚目のリフト刃がヒゲを引き上げ、2枚目のカット刃が深剃りカット。  ヒゲ密度感知システムできれいに深剃り  毎秒250回ヒゲの密度を感知し、ヒゲの濃さに合わせて自動でパワーを調節。濃い箇所もなんなく剃りきる。  360-D フレックスヘッドで剃り残しを低減  アクセサリー お手入れ：クリーニングブラシ クイッククリーンポッド：有 カートリッジ 1 個付属 一体型ポップアップトリマー：有 携帯・収納：ソフトポーチ 保護キャップ USB-A ケーブル付属：電源アダプターは付属していません  電源 充電：約 1 時間・５分間の急速充電モード付 バッテリーの種類：リチウムイオン 対応電圧：5 V 使用時間：約 60 分 待機電力：0.04  W 最大消費電力：5  W 対応電圧：5 V",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/phillips/Philips_S588960.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/philips.png",
  },
  {
    id: "675",
    brand: "Philips",
    sku: "S7886/50",
    product_eng: "Philips shaver 7000 Series S7886/50",
    product_jpn: "Philips  フィリップス shaver 7000シリーズ S7886/50",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥28,600",
    rrp_with_vat: "¥31,460",
    description_eng:
      "For skin that inspires confidence. The deciding factors are sharpness and gentleness. The Philips S7000 series has a microbead coating on the head to reduce the burden on the skin by 30%*¹. The S7000 series is equipped with SkinIQ technology that guides the shaver to the optimal shave according to the thickness of the beard and the contours of the face, enabling a shave that is gentle on the skin and gives a good shave.  SkinIQ Technology Philips technology that detects beard density and facial contours to guide and optimize shaving according to each individual's personality.  App Linked Creates a shaving plan optimized for you.  Powerful yet gentle The 45 blades cut 90,000 times per minute to efficiently capture beard growth in various directions for a deep shave.  The first lift blade lifts up the beard and the second cutting blade cuts for a deep shave.  The 360-D flex-head reduces the possibility of leaving a residue.  Skin Protection Technology Microbead coating on shaver head reduces stress on skin by 30%*. *Comparison with uncoated material  Accessories Quick clean pod: Yes 1 cartridge included Integrated pop-up trimmer: Yes Carrying and storage: Storage case USB-A cable included Power adapter not included  Charging Approx. 1 hour with 5-minute quick charge mode Battery type: Lithium-ion Supported voltage: 5 V Operating time: approx. 60 min. Standby power: 0.04 W Maximum power consumption: 9 W",
    description_jpn:
      "自信がわく肌へ。 決め手は、切れ味、そして、やさしさ。 フィリップス S7000シリーズは、ヘッド部分にマイクロビーズコーティングを施し、肌への負担を30％*¹低減。ヒゲの濃さや顔の輪郭に合わせて、最適なシェービングへとガイドするSkinIQテクノロジーを搭載、「肌にやさしく、よく剃れる」シェービングを可能にします。  SkinIQテクノロジー ヒゲの濃さや顔の輪郭を感知し、一人ひとりの個性に合わせたシェービングへガイド・最適化するフィリップスのテクノロジー。  アプリ連動 あなたに最適なシェービングプランを作成  パワフルな切れ味とやさしさの両立 毎分90,000回カットする45枚刃で色々な方向に生えているヒゲを効率的に取り込み、しっかり深剃り。  1枚目のリフト刃がヒゲを引き上げ、2枚目のカット刃が深剃りカット。  360-D フレックスヘッドで剃り残しを低減  顔の凹凸に密着し、剃り残しを低減  スキンプロテクションテクノロジー シェーバーヘッドに施されたマイクロビーズコーティングで30％*肌への負担を低減。 *非コーティング素材との比較  アクセサリー クイッククリーンポッド：有 カートリッジ 1 個付属 一体型ポップアップトリマー：有 携帯・収納：収納ケース USB-A ケーブル付属 電源アダプターは付属していません  充電 約 1 時間・５分間の急速充電モード付 バッテリーの種類：リチウムイオン 対応電圧：5 V 使用時間：約 60 分 待機電力：0.04  W 最大消費電力：9  W",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/phillips/Philips_S788650.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/philips.png",
  },
  {
    id: "676",
    brand: "Philips",
    sku: "S9985/30",
    product_eng: "Philips shaver 9000 Series S9985/30",
    product_jpn: "Philips  フィリップス shaver 9000シリーズ S9985/30",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      "Go ahead with your ideal skin. Personalized shaving for each individual No one's beard density or facial contours are the same as a fingerprint. The Philips S9000 Series features the Three Cyclone Head and SkinIQ technology. It adapts to your beard density and shaves closely to the contours of your face. It even guides your shave to give you a gentle, clean, deep shave. ◆Dual steel precision blades with automatic sharpening system for a consistently sharp shave. ◆World's first* overpressure prevention sensor ◆The sensor on the shaver detects the pressure on the skin 30 times per second and changes color and notifies you in real time so that you can adjust the pressure to the optimum level immediately. *World's first shaver equipped with an overpressure prevention sensor (available in February 2022) ◆Skin Protection Technology Microbead coating on the shaver head reduces the burden on the skin. ◆Shaving motion detection sensor Shaving motion sensing sensor tracks your shaving motion and guides you to shave with minimum number of strokes. ◆Beard density sensing system 500 times per second, it senses beard density and automatically adjusts power to match the density of your beard. ◆360-D Flex Head Flexible head rotates 360° and follows facial contours. ◆Pop-up trimmer (integrated type) ◆Fine-tune your mustache and shave your shins. ◆About 60 minutes of shaving on a 1-hour charge When the battery runs out, a 5-minute quick charge provides one time use. ◆Recharge Approx. 1 hour/5 minutes with quick charge mode ◆Battery type Lithium-ion ◆Supported voltage AC 100 - 240 V (for overseas use) ◆Usage time Approx. 60 min. ◆Maximum power consumption 9 W",
    description_jpn:
      "理想の肌で、進め。一人ひとりにパーソナルフィット・シェービング ヒゲの濃さ、顔の輪郭は、指紋のように誰一人として同じではありません。 フィリップス S9000シリーズは、スリーサイクロンヘッドとSkinIQテクノロジーを搭載。 あなたのヒゲの濃さに合わせ、顔の輪郭に密着してシェービング。さらにシェービングのガイドまで行うことで、やさしく、きれいな深剃りを実現します。 ◆自動研磨システム搭載のデュアルスティールプレシジョン刃 常にシャープな切れ味が続きます。 ◆世界初※過圧防止センサー搭載 シェーバーに搭載されたセンサーが、毎秒30回肌への圧力を感知し、リアルタイムで色が変化・お知らせするので、すぐに最適な圧力に調整が可能です。 ※世界初 過圧防止センサー搭載シェーバー（2022年2月発売） ◆スキンプロテクションテクノロジー シェーバーヘッドに施されたマイクロビーズコーティングが肌の負担を低減。 ◆シェービング動作検知センサー シェービング動作感知センサーが、シェービング動作を追跡し、最小限のストローク数で剃れるように、あなたをガイドします。 ◆ヒゲ密度感知システム 毎秒500回、ヒゲの密度を感知し、ヒゲの濃さに合わせて自動でパワーを調節。 ◆360-D フレックスヘッド 柔軟性に優れたヘッドが 360°回転し、顔の輪郭に沿って動きます。 ◆ポップアップトリマー（一体型） 口ヒゲやもみあげを細かく整えることができます。 ◆1時間の充電で約60分間シェービング 電池切れの際には5分の急速充電で1回分の使用ができます。 ◆充電 約 1 時間/５分間の急速充電モード付 ◆バッテリーの種類 リチウムイオン ◆対応電圧 AC 100 - 240 V（海外使用対応） ◆使用時間 約 60 分 ◆最大消費電力 9  W",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/phillips/Philips_S998530.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/philips.png",
  },
  {
    id: "677",
    brand: "Philips",
    sku: "HX3826/31",
    product_eng: "Sonicare Power Flosser3000",
    product_jpn: "Philips ソニッケアー コードレスパワー フロッサー3000",
    category_1: "Personal Care",
    category_2: "",
    rrp_ex_vat: "¥15,800",
    rrp_with_vat: "¥17,380",
    description_eng:
      "The X-shaped water flow refreshes food debris and stains between teeth! Cordless model for easy use and maintenance.   X-shaped water flow removes a wide range of interdental stains.  movement guide makes it easy to know when to move from interdental space to interdental space.  You can choose from two modes: clean mode (standard water pressure for 1 minute) or deep clean mode (water pressure with regular intervals and interdental movement guide for 1.5 minutes) You can choose your desired strength from three levels.  Tank part can be removed for easy filling & keeping clean after use.  Can also be used in the bath.  Two nozzles are included to choose your favorite feeling. Cad stream nozzle: Recommended for thorough cleaning of the entire mouth, the nozzle has a wide 4-way water flow to remove plaque and is designed with soft rubber to be gentle on gums. Standard nozzle: Jet stream of water removes food debris and plaque.  Removes plaque and stains from hard-to-reach areas and orthodontic appliances.  360 degree rotating nozzle for easy access to hard-to-reach places.  Voltage 100-240V (overseas voltage compatible)  Included in the box Sonicare Cordless Power Flosser 3000 Storage case USB cable Standard nozzle Cad stream nozzle",
    description_jpn:
      "Ｘ（エックス）型水流で歯間の食べかす・汚れもスッキリ爽快！手軽に使えてお手入れしやすいコードレスモデル。   X型の水流で広範囲の歯間の汚れを除去  歯間移動ガイドで、歯間から歯間に移るタイミングがわかりやすい  クリーンモード（1分間の標準水圧）とディープクリーンモード（1分半で一定間隔で強弱をつけた水圧・歯間移動ガイドあり）の2つからモードを選べます。3段階からお好みの強さを選べます。  タンク部分を取り外して、簡単に注水＆使用後にも清潔に保てる 約250mlの水タンクには60秒の洗浄に十分な水が入ります。水はタンクを取り外して注水するか、サイドの注水口から補充可能です。タンク内も洗えるため、衛生的に保つことができます。  お風呂でも使える  ノズル2本付でお好みの使用感が選べる ・カドストリームノズル：口内全体の徹底的な洗浄におすすめ。4方向にワイドに広がる水流で歯垢しっかり取り除くことができる、歯ぐきにやさしいソフトラバー仕様のノズルです。 ・スタンダードノズル：ジェット水流で食べかすや歯垢を取り除きます。  磨きにくい部分や矯正器具の歯垢や汚れも除去  360度回転するノズルで届きにくい場所にも使いやすい  対応電圧 100-240V (海外電圧対応)  同梱物 ソニッケアー コードレスパワーフロッサー3000 収納ケース USB ケーブル 標準ノズル カドストリームノズル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/phillips/Philips_HX382631.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/philips.png",
  },
  {
    id: "679",
    brand: "iRobot",
    sku: "j955860",
    product_eng: "irobot Robot Vacuum Roomba® j9+",
    product_jpn: "irobot ロボット掃除機 ルンバ j9+",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Recognizes obstacles*1 and avoids them*3 while reliably cleaning rooms that are still cluttered. High-spec model with up to twice the suction power*4 and fully automatic trash disposal.  *1 Objects to be avoided: cords, cables, pet waste *2 Objects to avoid: shoes, slippers, socks, fabrics, clothes, backpacks, pet dishes, cat toilets, pet toys (balls, ropes, etc.), dogs and cats, etc. Subjects to be avoided will be updated on a rolling basis. Only solid dog or cat droppings (hairballs, vomit, and liquids are not eligible). 3The device must be connected to the iRobot Home app and be used with obstacle detection set to automatic (recommended). If the front camera sensor is physically covered or in an extremely dark room, the detection of objects to be avoided may not work properly. The obstacle detection and avoidance function will not operate during the training/mapping run, so please ensure that the floor is free of obstacles such as cords or pet waste. *4Comparison with Roomba i series. Using iRobot Home app.   Fully automatic, even for garbage disposal. No more hassle of cleaning. The quietest clean base ever from iRobot. When cleaning is complete, it automatically discharges the dust from the dust container into the AllergenLock paper pack inside the clean base. It can hold up to one year* worth of dust, so you don't have to worry about cleaning for a while. *: Calculated based on the cleaning results of Clean Base users in Japan. The duration is not guaranteed in all home environments. If you notice any malfunction or unusual odor before the replacement lamp comes on, it is recommended to replace it.  They take up little space and blend in with the interior design.  Learns the floor plan in one run*. Suggests cleaning methods that suit your lifestyle*. Learns each time it cleans and suggests the optimal cleaning method. It also suggests more frequent cleaning during high pollen counts or when pets are shedding their hair. * Using the IRobot Home app. iRobot Home app requires the robot to be connected to a Wi-Fi network. Please check the AppStore or Google Play for the latest supported devices and requirements for the app.  Voice assistant support. Start cleaning right away, even when your hands are busy. Charging time 3 hours Width (main unit) 339mm Height (main unit) 87mm Depth (main unit) 339mm Width (charger) 310mm *Clean base Height (charger) 340mm *Clean base Depth (charger) 400mm *Clean base Weight (main unit) 3.4kg *Including battery",
    description_jpn:
      "散らかったままの部屋も障害物※1を認識して回避※3しながら確実に清掃。 吸引力最大2倍※4、ゴミ捨てまで全自動のハイスペックモデル。  ※1回避する対象：コードやケーブル、ペットの排せつ物 ※2靴やスリッパ、靴下、ファブリック、衣服、リュックサック、ペットの食器、猫用トイレ、ペットのおもちゃ（ボールやロープなど）、犬・猫など。回避する対象は順次アップデートされます。 犬または猫の固形の糞のみ（毛玉や吐しゃ物、液体は対象外になります）。 ※3iRobot Home アプリに接続し、障害物検知が自動（推奨）の状態でご使用いただく必要があります。前面カメラセンサーが物理的に覆われている場合や極端に暗い部屋では、回避する対象の検出が正常に作動しない可能性があります。トレーニング/マッピング走行中は障害物を検出して回避する機能が作動しないので、床にコードやペットの排せつ物などの障害物がない状態で行ってください。 ※4ルンバ i シリーズとの比較。 iRobot Home アプリを使用。   ゴミ捨てまで全自動。面倒な掃除の手間から解放。 アイロボット史上最も静かなクリーンベース。掃除が完了すると、自動で本体のダスト容器のゴミをクリーンベース内のAllergenLock紙パックへ排出。最大1年分*のゴミを収納できるので、しばらくは掃除のことを気にかける必要はありません。 ※：日本のクリーンベースユーザーの清掃結果より算出。全ての家庭環境において、期間を保証するものではありません。交換用ランプが点灯する前に誤動作や異臭に気づいた場合は、交換することをお勧めします。  場所を取らず、インテリアに溶け込む。  一度の走行で間取り学習*。  暮らしに合った掃除方法を提案*。 掃除するたびに学習して最適な清掃方法を提案。花粉の多い時季やペットの換毛期には、清掃回数を増やす提案もします。 * IRobot Home アプリを使用。iRobot Home アプリを使用するには、ロボットがWi-Fiネットワークに接続している必要があります。アプリの最新の対応端末や要件はAppStoreまたはGoogle Playからご確認ください。  音声アシスタント対応。手がふさがっていてもすぐに掃除を開始できます。 充電時間 \t3時間 幅（本体） \t339mm 高さ（本体） \t87mm 奥行（本体） \t339mm 幅（充電器） \t310mm ※クリーンベース 高さ（充電器） \t340mm ※クリーンベース 奥行（充電器） \t400mm ※クリーンベース 重量（本体） \t3.4kg ※バッテリー含む",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/irobot/irobot_j955860.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/irobot.png",
  },
  {
    id: "680",
    brand: "iRobot",
    sku: "c975860",
    product_eng: "irobot Roomba Combo® j9+",
    product_jpn: "irobot 掃除機＆床拭きロボット ルンバ コンボ j9+",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥181,637",
    rrp_with_vat: "¥199,801",
    description_eng:
      "Water supply, waste disposal, and charging are fully automatic*1 . The highest suction power in the history of the Roomba Combo and the most careful wiping with water as a person would do. An advanced 2-in-1 model that completes vacuuming and wiping in a single operation. Automatic water supply and automatic waste disposal eliminate the need for daily cleaning*2. The wood-grained top surface can also be used as a side table*3. *1 No need to dispose of waste for several months. Calculated based on the results of an iRobot experiment. *2 After cleaning, please wash the pad and discard water in the robot's dust container. *3 Do not place fragile items such as ceramics, liquids (potted plants, vases, drinks, etc.), or fire (incense, candles, etc.) on top.  Power supply method and charging time Rechargeable lithium-ion battery (charging time: approx. 3 hours) Power source AC100V 50/60Hz Dimensions (maximum width x height) Roomba main unit: 33.9 cm x 8.7 cm Clean base: 41.7 cm (depth) X 40.1 cm (width) X 41.5 cm (height) Main unit weight (including battery): approx. 4.1 kg",
    description_jpn:
      "給水、ゴミ捨て、充電が全自動。 ルンバ コンボ史上最高の吸引力と、人がするような丁寧な水拭きを実現。 掃除機がけと水拭きが一度で完了する進化した2in1モデル。 自動給水、自動ゴミ捨てで毎日のお手入れ※2は不要。 インテリアにも馴染むデザインで、木目調の天面はサイドテーブル※3としても役立ちます。 ※1。数ヵ月間ゴミ捨て不要。アイロボット実験結果より算出 ※2清掃後はパッドの洗浄やロボットのダスト容器内の水捨てを行ってください。 ※3陶器等壊れやすいもの、液体（鉢植え、花瓶、飲み物など）、火気（お香、キャンドルなど）は上に置かないでください。  電源方式・充電時間\t充電式リチウムイオン電池（充電時間：約3時間） 電源\tAC100V 50/60Hz 本体寸法（最大幅×高さ）\tルンバ本体：33.9cm×8.7cm クリーンベース：奥行き41.7cm×幅40.1cm×高さ41.5cm 本体重量（バッテリー含む）\t約4.1kg",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/irobot/irobot_c975860.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/irobot.png",
  },
  {
    id: "681",
    brand: "iRobot",
    sku: "P111860",
    product_eng: "irobot Air purifier Klaara p7 Pro",
    product_jpn: "irobot 空気清浄機 Klaara p7 Pro",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Unique sealed structure that keeps dirty air out. For those of you who want to do something about viruses and pollen, we offer unparalleled cleaning power to the air.   Original sealed structure that raises the performance to the bottom Delivering clean air without compromise We focused on the weak point of conventional air purifiers, leakage of dirty air. We fundamentally reviewed the structure and realized a unique sealed structure with closed capture technology and a sealed body with no joints. We have succeeded in preventing the leakage of dirty air. Removes 99.98%*1 of pollen, viruses, mold, and other contaminants Three filters remove contaminants from the air. (1) Pre-filter: Removes pet dander, hair, and dust (2) Carbon filter: VOCs, odors (3) HEPA filter: Viruses, smoke, pollen, smog, mold, dust  *1: Test results conducted under the conditions of ISO 29463 in the H13 class according to EN1822. Collection efficiency of 99.98% for particles 0.1μm or larger at maximum airflow. Varies depending on the operating environment.  Works with Roomba*1*2 Automatically powers up the motor fan while cleaning.  Child and pet lock*2  martphone app*2 A wide variety of functions are available. Makes operation much more convenient.  Voice assistant*2*3 Control by simply speaking. *1: Works with Roomba s9+/j9/j7/i7/i5/i3 series and Roomba Combo. *2: Uses iRobot Home app. iRobot Home app requires Klaara to be connected to a Wi-Fi network. Please check the App Store or Google Play for the latest supported devices and requirements for the app. *3: Compatible with Google Assistant and Amazon Alexa.  Product Specifications Minimum/maximum power consumption: 169W Dimensions: Depth 38.6cm x Width 36.8cm x Height 59.9cm Main unit weight 16kg Cord length: approx. 1.5m",
    description_jpn:
      "汚れた空気を逃さない、独自の密閉構造。 ウイルス・花粉をどうにかしたいあなたへ、圧倒的な清掃力を空気中にも。   性能を底上げする独自の密閉構造 妥協なしのキレイな空気を届ける 従来の空気清浄機の弱点「汚れた空気の漏れ」に注目。構造を根本から見直し、クローズド・キャプチャ技術とつなぎ目のない密閉型ボディによる、独自の密閉構造を実現。汚れた空気の漏れを防ぐことに成功しました。 花粉、ウイルス、カビなどの汚染物質を99.98％*1除去 3つのフィルターで汚染物質を空気中から除去します。 （1）プレフィルター：ペットのフケや毛、ちり （2）カーボンフィルター：VOC、ニオイ （3）HEPAフィルター：ウイルス、煙、花粉、スモッグ、カビ、ホコリ  *1：EN1822によるH13クラスで、ISO 29463の条件に従い、実施した試験結果。最大風量で0.1μm以上の粒子に対し99.98％の捕集効率。使用環境により異なります。  ルンバ※1と連携※2 掃除中はモーターのファンを自動的にパワーアップ。  チャイルド・ペットロック※2  スマホアプリ※2 豊富な機能を搭載。操作がぐっと便利に。  音声アシスタント※2※3 話しかけるだけでコントロール。 ※1：ルンバ s9＋/j9/j7/i7/i5/i3 シリーズ、ルンバ コンボと連携。 ※2： iRobot Home アプリを使用。iRobot Home アプリを使用するには、Klaara がWi-Fiネットワークに接続している必要があります。アプリの最新の対応端末や要件はApp StoreまたはGoogle Playからご確認ください。 ※3：Google アシスタント、Amazon Alexaに対応。  製品仕様 最小/最大消費電力:169W 本体寸法\t奥行き38.6cm×幅36.8cm×高さ59.9cm 本体重量\t16kg コードの長さ\t約1.5m",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/irobot/irobot_P111860.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/irobot.png",
  },
  {
    id: "682",
    brand: "Bose",
    sku: "QC ULTRA EARBUDS BLK",
    product_eng: "Bose QuietComfort Ultra Earbuds Black",
    product_jpn: "Bose QuietComfort Ultra Earbuds ブラック",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥36,000",
    rrp_with_vat: "¥39,600",
    description_eng:
      "Making music more real than ever before. Groundbreaking Bose Immersive Audio delivers more immersive sound regardless of content or source.  World-class noise cancellation and customized sound performance. And we've made sure it feels great. The sound is so immersive, you'll instantly feel its appeal.  Sound and silence that's just right for you  Up to 6 hours of continuous playback  Simple touch operation  Included accessories 3 types of ear tips (S, M, L) and 3 types of stability bands (S, M, L), charging case, USB-C (A to C) cable",
    description_jpn:
      "音楽をかつてないほどリアルに。画期的なBose イマーシブオーディオが、コンテンツや音源を問わずより臨場感のあるサウンドを実現。世界最高クラスのノイズキャンセリングとカスタマイズされたサウンドパフォーマンス。 さらに装着感にもこだわりました。このサウンドを聴けば、その魅力をすぐにご体感いただけるはずです。  世界クラスのノイズキャンセリング  あなたに合ったサウンドと静けさを演出  最大6時間の連続再生  シンプルなタッチ操作  付属品 3種類のイヤーチップ (S、M、L) および3種類のスタビリティバンド (S、M、L) 、充電ケース、USB-C (A to C) ケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bose/Bose_QC_ULTRA_EARBUDS_BLK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bose.png",
  },
  {
    id: "683",
    brand: "Bose",
    sku: "QC ULTRA EARBUDS WHT",
    product_eng: "Bose QuietComfort Ultra Earbuds White Smoke",
    product_jpn: "Bose QuietComfort Ultra Earbuds ホワイトスモーク",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥36,000",
    rrp_with_vat: "¥39,600",
    description_eng:
      "Making music more real than ever before. Groundbreaking Bose Immersive Audio delivers more immersive sound regardless of content or source.  World-class noise cancellation and customized sound performance. And we've made sure it feels great. The sound is so immersive, you'll instantly feel its appeal.  Sound and silence that's just right for you  Up to 6 hours of continuous playback  Simple touch operation  Included accessories 3 types of ear tips (S, M, L) and 3 types of stability bands (S, M, L), charging case, USB-C (A to C) cable",
    description_jpn:
      "音楽をかつてないほどリアルに。画期的なBose イマーシブオーディオが、コンテンツや音源を問わずより臨場感のあるサウンドを実現。世界最高クラスのノイズキャンセリングとカスタマイズされたサウンドパフォーマンス。 さらに装着感にもこだわりました。このサウンドを聴けば、その魅力をすぐにご体感いただけるはずです。  世界クラスのノイズキャンセリング  あなたに合ったサウンドと静けさを演出  最大6時間の連続再生  シンプルなタッチ操作  付属品 3種類のイヤーチップ (S、M、L) および3種類のスタビリティバンド (S、M、L) 、充電ケース、USB-C (A to C) ケーブル",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bose/Bose_QC_ULTRA_EARBUDS_WHT.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bose.png",
  },
  {
    id: "684",
    brand: "Bose",
    sku: "QC ULTRA HP BLK",
    product_eng: "Bose QuietComfort Ultra Headphones Black",
    product_jpn: "Bose QuietComfort Ultra Headphones ブラック",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥54,000",
    rrp_with_vat: "¥59,400",
    description_eng:
      "Take your listening experience to an unprecedented level. World-class noise-cancellation for unprecedented silence. Groundbreaking Bose Immersive Audio for more lifelike sound. Sophisticated design and luxurious materials for the ultimate in comfort. Take the excitement of music to an unprecedented level.   Dimensions Headphones: 19.5 (H) x 13.9 (W) x 5.08 (D) cm (0.25 kg) Carrying case: 21.1 (H) x 15.7 (W) x 6.1 (D) cm (0.2 kg)  Included in the box Bose QuietComfort Ultra Headphones Carrying case Audio cable (3.5 mm to 2.5 mm) USB-C® (A to C) cable (30 cm)",
    description_jpn:
      "リスニング体験をかつてないレベルへ さらに進化した世界最高クラスのノイズキャンセリングで、かつてない静けさを。 画期的なBoseイマーシブオーディオが、より臨場感のあるサウンドを実現。 洗練されたデザインと贅沢な素材で、極上の快適さをご体験ください。音楽がもたらす感動を今までにないレベルへ。   寸法 ヘッドホン:19.5 (H) x 13.9 (W) x 5.08 (D) cm (0.25 kg) キャリーケース:21.1 (H) x 15.7 (W) x 6.1 (D) cm (0.2 kg)  同梱物 Bose QuietComfort Ultra Headphones キャリーケース オーディオケーブル (3.5 mm - 2.5 mm) USB-C® (A → C) ケーブル (30 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bose/Bose_QC_ULTRA_HP_BLK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bose.png",
  },
  {
    id: "685",
    brand: "Bose",
    sku: "QC ULTRA HP WHT",
    product_eng: "Bose QuietComfort Ultra Headphones White Smoke",
    product_jpn: "Bose QuietComfort Ultra Headphones ホワイトスモーク",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥54,000",
    rrp_with_vat: "¥59,400",
    description_eng:
      "Take your listening experience to an unprecedented level. World-class noise-cancellation for unprecedented silence. Groundbreaking Bose Immersive Audio for more lifelike sound. Sophisticated design and luxurious materials for the ultimate in comfort. Take the excitement of music to an unprecedented level.   Dimensions Headphones: 19.5 (H) x 13.9 (W) x 5.08 (D) cm (0.25 kg) Carrying case: 21.1 (H) x 15.7 (W) x 6.1 (D) cm (0.2 kg)  Included in the box Bose QuietComfort Ultra Headphones Carrying case Audio cable (3.5 mm to 2.5 mm) USB-C® (A to C) cable (30 cm)",
    description_jpn:
      "リスニング体験をかつてないレベルへ さらに進化した世界最高クラスのノイズキャンセリングで、かつてない静けさを。 画期的なBoseイマーシブオーディオが、より臨場感のあるサウンドを実現。 洗練されたデザインと贅沢な素材で、極上の快適さをご体験ください。音楽がもたらす感動を今までにないレベルへ。   寸法 ヘッドホン:19.5 (H) x 13.9 (W) x 5.08 (D) cm (0.25 kg) キャリーケース:21.1 (H) x 15.7 (W) x 6.1 (D) cm (0.2 kg)  同梱物 Bose QuietComfort Ultra Headphones キャリーケース オーディオケーブル (3.5 mm - 2.5 mm) USB-C® (A → C) ケーブル (30 cm）",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/bose/Bose_QC_ULTRA_HP_WHT.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bose.png",
  },
  {
    id: "1059",
    brand: "Bose",
    sku: "ULTRA OPEN EB BLK",
    product_eng: "Bose Ultra Open Earbuds Black",
    product_jpn: "Bose Ultra Open Earbuds ブラック",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥36,000",
    rrp_with_vat: "¥39,600",
    description_eng:
      "Bose Ultra Open Earbuds  Features:  Stay Aware of Your Surroundings: Enjoy rich spatial audio while maintaining connection with your surroundings for an immersive listening experience. Enjoy Music Anywhere: Combines comfortable wear and stylish design to provide a more realistic listening experience that feels like being enveloped in sound. Comfortable and Secure Fit: The flexible and ultra-lightweight design of the Bose Ultra Open Earbuds ensures a comfortable fit. Simply place these comfortable earbuds on your ears to enjoy music while staying connected with your surroundings. IPX4 Water Resistance: Resistant to splashes, sweat, and rain. Long Battery Life: Up to 7.5 hours of continuous playback (up to 4.5 hours with immersive audio settings on) and up to 48 hours standby. Using the included charging case, you can get an additional 19.5 hours of playback. Simple Button Controls: The built-in microphone and button controls make it easy to switch between stereo mode and immersion mode, play/pause music, and answer calls with just a press of a button. Specifications:  Earbuds: 1.9 cm (H) x 1.7 cm (W) x 2.7 cm (D) Charging Case: 4.2 cm (H) x 6.5 cm (W) x 2.6 cm (D) USB Cable: 30.5 cm Included Items:  2 x Bose Ultra Open Earbuds Charging Case USB-C® (A → C) Cable (30 cm) Quick Start Guide Safety Sheet Manufacturer Warranty: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "■外の世界にも耳を澄ませる: 豊かな空間オーディオを楽しみながら、周囲との繋がりも保つリスニング体験。 ■どこででも、音楽を満喫: 快適な着け心地とスタイリッシュなデザインを両立しながら、サウンドに包まれているようなよりリアルなリスニング体験を実現します。 ■心地よく、しっかりフィット: Bose Ultra Open Earbudsのジョイント部分は柔軟かつ超軽量設計。この快適なイヤホンを耳にさっとかけるだけで、周りとの繋がりを保ちながら音楽も楽しむことができます。 ■IPX4防滴規格に準拠: 多少の水しぶきや汗、雨なら ご心配なく。 ■長時間再生バッテリー: 最長7.5時間の連続再生時間 (イマーシブオーディオ設定がオンの場合は最長4.5時間)*と、最長48時間スタンバイ***の長時間バッテリー。付属の充電ケース**を使用すると、さらに19.5時間再生可能。 ■マイク内蔵イヤホンのボタン操作はとてもシンプル。ステレオモードやイマージョンモードの切り替え、音楽の再生 / 一時停止、着信への応答など、ボタンを押すだけで素早く簡単に操作できます。  イヤホン:1.9 cm (H) x 1.7 cm (W) x 2.7 cm (D) 充電ケース:4.2 cm (H) x 6.5 cm (W) x 2.6 cm (D) USBケーブル:30.5 cm <同梱物> 2 x Bose Ultra Open Earbuds 充電ケース USB-C® (A → C) ケーブル (30 cm） クイックスタートガイド セーフティシート  メーカー保証１年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/bose/ULTRA_OPEN_EB_BLK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bose.png",
  },
  {
    id: "1060",
    brand: "Bose",
    sku: "ULTRA OPEN EB WHT",
    product_eng: "Bose Ultra Open Earbuds White Smoke",
    product_jpn: "Bose Ultra Open Earbuds ホワイトスモーク",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥36,000",
    rrp_with_vat: "¥39,600",
    description_eng:
      "Bose Ultra Open Earbuds  Features:  Stay Aware of Your Surroundings: Enjoy rich spatial audio while maintaining connection with your surroundings for an immersive listening experience. Enjoy Music Anywhere: Combines comfortable wear and stylish design to provide a more realistic listening experience that feels like being enveloped in sound. Comfortable and Secure Fit: The flexible and ultra-lightweight design of the Bose Ultra Open Earbuds ensures a comfortable fit. Simply place these comfortable earbuds on your ears to enjoy music while staying connected with your surroundings. IPX4 Water Resistance: Resistant to splashes, sweat, and rain. Long Battery Life: Up to 7.5 hours of continuous playback (up to 4.5 hours with immersive audio settings on) and up to 48 hours standby. Using the included charging case, you can get an additional 19.5 hours of playback. Simple Button Controls: The built-in microphone and button controls make it easy to switch between stereo mode and immersion mode, play/pause music, and answer calls with just a press of a button. Specifications:  Earbuds: 1.9 cm (H) x 1.7 cm (W) x 2.7 cm (D) Charging Case: 4.2 cm (H) x 6.5 cm (W) x 2.6 cm (D) USB Cable: 30.5 cm Included Items:  2 x Bose Ultra Open Earbuds Charging Case USB-C® (A → C) Cable (30 cm) Quick Start Guide Safety Sheet Manufacturer Warranty: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "■外の世界にも耳を澄ませる: 豊かな空間オーディオを楽しみながら、周囲との繋がりも保つリスニング体験。 ■どこででも、音楽を満喫: 快適な着け心地とスタイリッシュなデザインを両立しながら、サウンドに包まれているようなよりリアルなリスニング体験を実現します。 ■心地よく、しっかりフィット: Bose Ultra Open Earbudsのジョイント部分は柔軟かつ超軽量設計。この快適なイヤホンを耳にさっとかけるだけで、周りとの繋がりを保ちながら音楽も楽しむことができます。 ■IPX4防滴規格に準拠: 多少の水しぶきや汗、雨なら ご心配なく。 ■長時間再生バッテリー: 最長7.5時間の連続再生時間 (イマーシブオーディオ設定がオンの場合は最長4.5時間)*と、最長48時間スタンバイ***の長時間バッテリー。付属の充電ケース**を使用すると、さらに19.5時間再生可能。 ■マイク内蔵イヤホンのボタン操作はとてもシンプル。ステレオモードやイマージョンモードの切り替え、音楽の再生 / 一時停止、着信への応答など、ボタンを押すだけで素早く簡単に操作できます。  イヤホン:1.9 cm (H) x 1.7 cm (W) x 2.7 cm (D) 充電ケース:4.2 cm (H) x 6.5 cm (W) x 2.6 cm (D) USBケーブル:30.5 cm <同梱物> 2 x Bose Ultra Open Earbuds 充電ケース USB-C® (A → C) ケーブル (30 cm） クイックスタートガイド セーフティシート  メーカー保証１年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/bose/ULTRA_OPEN_EB_WHT.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/bose.png",
  },
  {
    id: "686",
    brand: "Amazon",
    sku: "AMA500",
    product_eng: "Amazon Gift Card 500 yen",
    product_jpn: "Amazon ギフトカード 500円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥500",
    rrp_with_vat: "¥500",
    description_eng:
      "Amazon Gift Card can be used to purchase your favorite products from Amazon.co.jp. 【Notes】  Gift Certificates are non-refundable and cannot be exchanged for cash. The Company and its affiliates are not responsible for any loss or theft of Gift Certificates.  This program is provided by NAGANO REWARDS Corporation. Amazon does not accept any inquiries regarding the issuance of Gift Cards. NAGANO REWARDS KK Customer Service mail:customerservice@naganorewards.com.  *Amazon, Amazon.co.jp and their logos are trademarks of Amazon.com, Inc. or its affiliates.",
    description_jpn:
      "Amazon ギフト券で、オンラインストア Amazon.co.jp にてお好きな商品をお買い求めいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/amazon.png",
  },
  {
    id: "687",
    brand: "Amazon",
    sku: "AMA1000",
    product_eng: "Amazon Gift Card 1,000 yen",
    product_jpn: "Amazon ギフトカード 1,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥1,000",
    description_eng:
      "Amazon Gift Card can be used to purchase your favorite products from Amazon.co.jp. 【Notes】  Gift Certificates are non-refundable and cannot be exchanged for cash. The Company and its affiliates are not responsible for any loss or theft of Gift Certificates.  This program is provided by NAGANO REWARDS Corporation. Amazon does not accept any inquiries regarding the issuance of Gift Cards. NAGANO REWARDS KK Customer Service mail:customerservice@naganorewards.com.  *Amazon, Amazon.co.jp and their logos are trademarks of Amazon.com, Inc. or its affiliates.",
    description_jpn:
      "Amazon ギフト券で、オンラインストア Amazon.co.jp にてお好きな商品をお買い求めいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/amazon.png",
  },
  {
    id: "688",
    brand: "Amazon",
    sku: "AMA2000",
    product_eng: "Amazon Gift Card 2,000 yen",
    product_jpn: "Amazon ギフトカード 2,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,000",
    description_eng:
      "Amazon Gift Card can be used to purchase your favorite products from Amazon.co.jp. 【Notes】  Gift Certificates are non-refundable and cannot be exchanged for cash. The Company and its affiliates are not responsible for any loss or theft of Gift Certificates.  This program is provided by NAGANO REWARDS Corporation. Amazon does not accept any inquiries regarding the issuance of Gift Cards. NAGANO REWARDS KK Customer Service mail:customerservice@naganorewards.com.  *Amazon, Amazon.co.jp and their logos are trademarks of Amazon.com, Inc. or its affiliates.",
    description_jpn:
      "Amazon ギフト券で、オンラインストア Amazon.co.jp にてお好きな商品をお買い求めいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/amazon.png",
  },
  {
    id: "689",
    brand: "Amazon",
    sku: "AMA3000",
    product_eng: "Amazon Gift Card 3,000 yen",
    product_jpn: "Amazon ギフトカード 3,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,000",
    description_eng:
      "Amazon Gift Card can be used to purchase your favorite products from Amazon.co.jp. 【Notes】  Gift Certificates are non-refundable and cannot be exchanged for cash. The Company and its affiliates are not responsible for any loss or theft of Gift Certificates.  This program is provided by NAGANO REWARDS Corporation. Amazon does not accept any inquiries regarding the issuance of Gift Cards. NAGANO REWARDS KK Customer Service mail:customerservice@naganorewards.com.  *Amazon, Amazon.co.jp and their logos are trademarks of Amazon.com, Inc. or its affiliates.",
    description_jpn:
      "Amazon ギフト券で、オンラインストア Amazon.co.jp にてお好きな商品をお買い求めいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/amazon.png",
  },
  {
    id: "690",
    brand: "Amazon",
    sku: "AMA5000",
    product_eng: "Amazon Gift Card 5,000 yen",
    product_jpn: "Amazon ギフトカード 5,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,000",
    description_eng:
      "Amazon Gift Card can be used to purchase your favorite products from Amazon.co.jp. 【Notes】  Gift Certificates are non-refundable and cannot be exchanged for cash. The Company and its affiliates are not responsible for any loss or theft of Gift Certificates.  This program is provided by NAGANO REWARDS Corporation. Amazon does not accept any inquiries regarding the issuance of Gift Cards. NAGANO REWARDS KK Customer Service mail:customerservice@naganorewards.com.  *Amazon, Amazon.co.jp and their logos are trademarks of Amazon.com, Inc. or its affiliates.",
    description_jpn:
      "Amazon ギフト券で、オンラインストア Amazon.co.jp にてお好きな商品をお買い求めいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/amazon.png",
  },
  {
    id: "691",
    brand: "Amazon",
    sku: "AMA10000",
    product_eng: "Amazon Gift Card 10,000 yen",
    product_jpn: "Amazon ギフトカード 10,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥10,000",
    description_eng:
      "Amazon Gift Card can be used to purchase your favorite products from Amazon.co.jp. 【Notes】  Gift Certificates are non-refundable and cannot be exchanged for cash. The Company and its affiliates are not responsible for any loss or theft of Gift Certificates.  This program is provided by NAGANO REWARDS Corporation. Amazon does not accept any inquiries regarding the issuance of Gift Cards. NAGANO REWARDS KK Customer Service mail:customerservice@naganorewards.com.  *Amazon, Amazon.co.jp and their logos are trademarks of Amazon.com, Inc. or its affiliates.",
    description_jpn:
      "Amazon ギフト券で、オンラインストア Amazon.co.jp にてお好きな商品をお買い求めいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/amazon.png",
  },
  {
    id: "692",
    brand: "Amazon",
    sku: "AMA20000",
    product_eng: "Amazon Gift Card 20,000 yen",
    product_jpn: "Amazon ギフトカード 20,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥20,000",
    description_eng:
      "Amazon Gift Card can be used to purchase your favorite products from Amazon.co.jp. 【Notes】  Gift Certificates are non-refundable and cannot be exchanged for cash. The Company and its affiliates are not responsible for any loss or theft of Gift Certificates.  This program is provided by NAGANO REWARDS Corporation. Amazon does not accept any inquiries regarding the issuance of Gift Cards. NAGANO REWARDS KK Customer Service mail:customerservice@naganorewards.com.  *Amazon, Amazon.co.jp and their logos are trademarks of Amazon.com, Inc. or its affiliates.",
    description_jpn:
      "Amazon ギフト券で、オンラインストア Amazon.co.jp にてお好きな商品をお買い求めいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/amazon.png",
  },
  {
    id: "693",
    brand: "Amazon",
    sku: "AMA30000",
    product_eng: "Amazon Gift Card 30,000 yen",
    product_jpn: "Amazon ギフトカード 30,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥30,000",
    rrp_with_vat: "¥30,000",
    description_eng:
      "Amazon Gift Card can be used to purchase your favorite products from Amazon.co.jp. 【Notes】  Gift Certificates are non-refundable and cannot be exchanged for cash. The Company and its affiliates are not responsible for any loss or theft of Gift Certificates.  This program is provided by NAGANO REWARDS Corporation. Amazon does not accept any inquiries regarding the issuance of Gift Cards. NAGANO REWARDS KK Customer Service mail:customerservice@naganorewards.com.  *Amazon, Amazon.co.jp and their logos are trademarks of Amazon.com, Inc. or its affiliates.",
    description_jpn:
      "Amazon ギフト券で、オンラインストア Amazon.co.jp にてお好きな商品をお買い求めいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/amazon.png",
  },
  {
    id: "694",
    brand: "Amazon",
    sku: "AMA50000",
    product_eng: "Amazon Gift Card 50,000 yen",
    product_jpn: "Amazon ギフトカード 50,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥50,000",
    rrp_with_vat: "¥50,000",
    description_eng:
      "Amazon Gift Card can be used to purchase your favorite products from Amazon.co.jp. 【Notes】  Gift Certificates are non-refundable and cannot be exchanged for cash. The Company and its affiliates are not responsible for any loss or theft of Gift Certificates.  This program is provided by NAGANO REWARDS Corporation. Amazon does not accept any inquiries regarding the issuance of Gift Cards. NAGANO REWARDS KK Customer Service mail:customerservice@naganorewards.com.  *Amazon, Amazon.co.jp and their logos are trademarks of Amazon.com, Inc. or its affiliates.",
    description_jpn:
      "Amazon ギフト券で、オンラインストア Amazon.co.jp にてお好きな商品をお買い求めいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/amazon.png",
  },
  {
    id: "695",
    brand: "Amazon",
    sku: "AMA100000",
    product_eng: "Amazon Gift Card 100,000 yen",
    product_jpn: "Amazon ギフトカード 100,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥100,000",
    rrp_with_vat: "¥100,000",
    description_eng:
      "Amazon Gift Card can be used to purchase your favorite products from Amazon.co.jp. 【Notes】  Gift Certificates are non-refundable and cannot be exchanged for cash. The Company and its affiliates are not responsible for any loss or theft of Gift Certificates.  This program is provided by NAGANO REWARDS Corporation. Amazon does not accept any inquiries regarding the issuance of Gift Cards. NAGANO REWARDS KK Customer Service mail:customerservice@naganorewards.com.  *Amazon, Amazon.co.jp and their logos are trademarks of Amazon.com, Inc. or its affiliates.",
    description_jpn:
      "Amazon ギフト券で、オンラインストア Amazon.co.jp にてお好きな商品をお買い求めいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/amazon.png",
  },
  {
    id: "696",
    brand: "Apple",
    sku: "AGC500",
    product_eng: "Apple Gift Card 500 yen",
    product_jpn: "Apple Gift Card 500 円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥500",
    rrp_with_vat: "¥500",
    description_eng:
      "・You can use it to purchase all Apple products, including iPads, AirPods, Apple Watch, iPhones, MacBooks, iCloud storage, and accessories. ・It can also be used to pay for App Store and subscriptions, as well as to purchase Apps, games, music, movies, TV shows, and more. ・It's the perfect gift for a birthday or as a token of appreciation or congratulations. ・The gift card will be sent to you via email. ・The gift card is valid for purchases at all Apple Retail Stores in Japan, as well as Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, Apple One, and other Apple services. Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, and Apple One. ・Please bring your unused gift card to an Apple Retail Store when making a purchase. ・To redeem for online purchases in your Apple Account, go to apple.com/redeem and charge the card amount to your balance. ・The card cannot be used for any other payment. ・Apple Gift Cards are non-returnable and non-refundable. Terms and conditions apply.",
    description_jpn:
      "・iPad、AirPods、Apple Watch、iPhone、MacBook、iCloudのストレージ、アクセサリなど、すべてのApple製品の購入に使えます。 ・App Storeやサブスクリプションの支払い、さらにAppやゲーム、音楽、映画、テレビ番組などの購入にも使えます。 ・誕生日プレゼントにも、感謝やお祝いのしるしにもふさわしいギフトです。 ・ギフトカードはEメールで届きます。 ・日本国内のすべてのApple Storeでの購入のほか、Apple Store App、apple.com、App Store、iTunes Store、Apple Music、Apple TV+、Apple Books、Apple Arcade、iCloud、Apple OneなどのAppleのサービスで利用できます。 ・Apple Storeで購入の際には、未使用のギフトカードをApple Storeにお持ちください。 ・Appleアカウントでのオンライン購入に利用するには、apple.com/redeemにアクセスして、カードの金額を残高にチャージしてください。 ・そのほかのお支払いには利用できません。 ・Apple Gift Cardの返品や払い戻しはできません。諸条件が適用されます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_giftcard.png",
  },
  {
    id: "697",
    brand: "Apple",
    sku: "AGC1000",
    product_eng: "Apple Gift Card 1,000 yen",
    product_jpn: "Apple Gift Card 1,000 円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥1,000",
    description_eng:
      "・You can use it to purchase all Apple products, including iPads, AirPods, Apple Watch, iPhones, MacBooks, iCloud storage, and accessories. ・It can also be used to pay for App Store and subscriptions, as well as to purchase Apps, games, music, movies, TV shows, and more. ・It's the perfect gift for a birthday or as a token of appreciation or congratulations. ・The gift card will be sent to you via email. ・The gift card is valid for purchases at all Apple Retail Stores in Japan, as well as Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, Apple One, and other Apple services. Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, and Apple One. ・Please bring your unused gift card to an Apple Retail Store when making a purchase. ・To redeem for online purchases in your Apple Account, go to apple.com/redeem and charge the card amount to your balance. ・The card cannot be used for any other payment. ・Apple Gift Cards are non-returnable and non-refundable. Terms and conditions apply.",
    description_jpn:
      "・iPad、AirPods、Apple Watch、iPhone、MacBook、iCloudのストレージ、アクセサリなど、すべてのApple製品の購入に使えます。 ・App Storeやサブスクリプションの支払い、さらにAppやゲーム、音楽、映画、テレビ番組などの購入にも使えます。 ・誕生日プレゼントにも、感謝やお祝いのしるしにもふさわしいギフトです。 ・ギフトカードはEメールで届きます。 ・日本国内のすべてのApple Storeでの購入のほか、Apple Store App、apple.com、App Store、iTunes Store、Apple Music、Apple TV+、Apple Books、Apple Arcade、iCloud、Apple OneなどのAppleのサービスで利用できます。 ・Apple Storeで購入の際には、未使用のギフトカードをApple Storeにお持ちください。 ・Appleアカウントでのオンライン購入に利用するには、apple.com/redeemにアクセスして、カードの金額を残高にチャージしてください。 ・そのほかのお支払いには利用できません。 ・Apple Gift Cardの返品や払い戻しはできません。諸条件が適用されます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_giftcard.png",
  },
  {
    id: "698",
    brand: "Apple",
    sku: "AGC2000",
    product_eng: "Apple Gift Card 2,000 yen",
    product_jpn: "Apple Gift Card 2,000 円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,000",
    description_eng:
      "・You can use it to purchase all Apple products, including iPads, AirPods, Apple Watch, iPhones, MacBooks, iCloud storage, and accessories. ・It can also be used to pay for App Store and subscriptions, as well as to purchase Apps, games, music, movies, TV shows, and more. ・It's the perfect gift for a birthday or as a token of appreciation or congratulations. ・The gift card will be sent to you via email. ・The gift card is valid for purchases at all Apple Retail Stores in Japan, as well as Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, Apple One, and other Apple services. Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, and Apple One. ・Please bring your unused gift card to an Apple Retail Store when making a purchase. ・To redeem for online purchases in your Apple Account, go to apple.com/redeem and charge the card amount to your balance. ・The card cannot be used for any other payment. ・Apple Gift Cards are non-returnable and non-refundable. Terms and conditions apply.",
    description_jpn:
      "・iPad、AirPods、Apple Watch、iPhone、MacBook、iCloudのストレージ、アクセサリなど、すべてのApple製品の購入に使えます。 ・App Storeやサブスクリプションの支払い、さらにAppやゲーム、音楽、映画、テレビ番組などの購入にも使えます。 ・誕生日プレゼントにも、感謝やお祝いのしるしにもふさわしいギフトです。 ・ギフトカードはEメールで届きます。 ・日本国内のすべてのApple Storeでの購入のほか、Apple Store App、apple.com、App Store、iTunes Store、Apple Music、Apple TV+、Apple Books、Apple Arcade、iCloud、Apple OneなどのAppleのサービスで利用できます。 ・Apple Storeで購入の際には、未使用のギフトカードをApple Storeにお持ちください。 ・Appleアカウントでのオンライン購入に利用するには、apple.com/redeemにアクセスして、カードの金額を残高にチャージしてください。 ・そのほかのお支払いには利用できません。 ・Apple Gift Cardの返品や払い戻しはできません。諸条件が適用されます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_giftcard.png",
  },
  {
    id: "699",
    brand: "Apple",
    sku: "AGC2500",
    product_eng: "Apple Gift Card 2,500 yen",
    product_jpn: "Apple Gift Card 2,500 円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥2,500",
    rrp_with_vat: "¥2,500",
    description_eng:
      "・You can use it to purchase all Apple products, including iPads, AirPods, Apple Watch, iPhones, MacBooks, iCloud storage, and accessories. ・It can also be used to pay for App Store and subscriptions, as well as to purchase Apps, games, music, movies, TV shows, and more. ・It's the perfect gift for a birthday or as a token of appreciation or congratulations. ・The gift card will be sent to you via email. ・The gift card is valid for purchases at all Apple Retail Stores in Japan, as well as Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, Apple One, and other Apple services. Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, and Apple One. ・Please bring your unused gift card to an Apple Retail Store when making a purchase. ・To redeem for online purchases in your Apple Account, go to apple.com/redeem and charge the card amount to your balance. ・The card cannot be used for any other payment. ・Apple Gift Cards are non-returnable and non-refundable. Terms and conditions apply.",
    description_jpn:
      "・iPad、AirPods、Apple Watch、iPhone、MacBook、iCloudのストレージ、アクセサリなど、すべてのApple製品の購入に使えます。 ・App Storeやサブスクリプションの支払い、さらにAppやゲーム、音楽、映画、テレビ番組などの購入にも使えます。 ・誕生日プレゼントにも、感謝やお祝いのしるしにもふさわしいギフトです。 ・ギフトカードはEメールで届きます。 ・日本国内のすべてのApple Storeでの購入のほか、Apple Store App、apple.com、App Store、iTunes Store、Apple Music、Apple TV+、Apple Books、Apple Arcade、iCloud、Apple OneなどのAppleのサービスで利用できます。 ・Apple Storeで購入の際には、未使用のギフトカードをApple Storeにお持ちください。 ・Appleアカウントでのオンライン購入に利用するには、apple.com/redeemにアクセスして、カードの金額を残高にチャージしてください。 ・そのほかのお支払いには利用できません。 ・Apple Gift Cardの返品や払い戻しはできません。諸条件が適用されます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_giftcard.png",
  },
  {
    id: "700",
    brand: "Apple",
    sku: "AGC3000",
    product_eng: "Apple Gift Card 3,000 yen",
    product_jpn: "Apple Gift Card 3,000 円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,000",
    description_eng:
      "・You can use it to purchase all Apple products, including iPads, AirPods, Apple Watch, iPhones, MacBooks, iCloud storage, and accessories. ・It can also be used to pay for App Store and subscriptions, as well as to purchase Apps, games, music, movies, TV shows, and more. ・It's the perfect gift for a birthday or as a token of appreciation or congratulations. ・The gift card will be sent to you via email. ・The gift card is valid for purchases at all Apple Retail Stores in Japan, as well as Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, Apple One, and other Apple services. Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, and Apple One. ・Please bring your unused gift card to an Apple Retail Store when making a purchase. ・To redeem for online purchases in your Apple Account, go to apple.com/redeem and charge the card amount to your balance. ・The card cannot be used for any other payment. ・Apple Gift Cards are non-returnable and non-refundable. Terms and conditions apply.",
    description_jpn:
      "・iPad、AirPods、Apple Watch、iPhone、MacBook、iCloudのストレージ、アクセサリなど、すべてのApple製品の購入に使えます。 ・App Storeやサブスクリプションの支払い、さらにAppやゲーム、音楽、映画、テレビ番組などの購入にも使えます。 ・誕生日プレゼントにも、感謝やお祝いのしるしにもふさわしいギフトです。 ・ギフトカードはEメールで届きます。 ・日本国内のすべてのApple Storeでの購入のほか、Apple Store App、apple.com、App Store、iTunes Store、Apple Music、Apple TV+、Apple Books、Apple Arcade、iCloud、Apple OneなどのAppleのサービスで利用できます。 ・Apple Storeで購入の際には、未使用のギフトカードをApple Storeにお持ちください。 ・Appleアカウントでのオンライン購入に利用するには、apple.com/redeemにアクセスして、カードの金額を残高にチャージしてください。 ・そのほかのお支払いには利用できません。 ・Apple Gift Cardの返品や払い戻しはできません。諸条件が適用されます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_giftcard.png",
  },
  {
    id: "701",
    brand: "Apple",
    sku: "AGC5000",
    product_eng: "Apple Gift Card 5,000 yen",
    product_jpn: "Apple Gift Card 5,000 円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,000",
    description_eng:
      "・You can use it to purchase all Apple products, including iPads, AirPods, Apple Watch, iPhones, MacBooks, iCloud storage, and accessories. ・It can also be used to pay for App Store and subscriptions, as well as to purchase Apps, games, music, movies, TV shows, and more. ・It's the perfect gift for a birthday or as a token of appreciation or congratulations. ・The gift card will be sent to you via email. ・The gift card is valid for purchases at all Apple Retail Stores in Japan, as well as Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, Apple One, and other Apple services. Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, and Apple One. ・Please bring your unused gift card to an Apple Retail Store when making a purchase. ・To redeem for online purchases in your Apple Account, go to apple.com/redeem and charge the card amount to your balance. ・The card cannot be used for any other payment. ・Apple Gift Cards are non-returnable and non-refundable. Terms and conditions apply.",
    description_jpn:
      "・iPad、AirPods、Apple Watch、iPhone、MacBook、iCloudのストレージ、アクセサリなど、すべてのApple製品の購入に使えます。 ・App Storeやサブスクリプションの支払い、さらにAppやゲーム、音楽、映画、テレビ番組などの購入にも使えます。 ・誕生日プレゼントにも、感謝やお祝いのしるしにもふさわしいギフトです。 ・ギフトカードはEメールで届きます。 ・日本国内のすべてのApple Storeでの購入のほか、Apple Store App、apple.com、App Store、iTunes Store、Apple Music、Apple TV+、Apple Books、Apple Arcade、iCloud、Apple OneなどのAppleのサービスで利用できます。 ・Apple Storeで購入の際には、未使用のギフトカードをApple Storeにお持ちください。 ・Appleアカウントでのオンライン購入に利用するには、apple.com/redeemにアクセスして、カードの金額を残高にチャージしてください。 ・そのほかのお支払いには利用できません。 ・Apple Gift Cardの返品や払い戻しはできません。諸条件が適用されます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_giftcard.png",
  },
  {
    id: "702",
    brand: "Apple",
    sku: "AGC10000",
    product_eng: "Apple Gift Card 10,000 yen",
    product_jpn: "Apple Gift Card 10,000 円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥10,000",
    description_eng:
      "・You can use it to purchase all Apple products, including iPads, AirPods, Apple Watch, iPhones, MacBooks, iCloud storage, and accessories. ・It can also be used to pay for App Store and subscriptions, as well as to purchase Apps, games, music, movies, TV shows, and more. ・It's the perfect gift for a birthday or as a token of appreciation or congratulations. ・The gift card will be sent to you via email. ・The gift card is valid for purchases at all Apple Retail Stores in Japan, as well as Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, Apple One, and other Apple services. Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, and Apple One. ・Please bring your unused gift card to an Apple Retail Store when making a purchase. ・To redeem for online purchases in your Apple Account, go to apple.com/redeem and charge the card amount to your balance. ・The card cannot be used for any other payment. ・Apple Gift Cards are non-returnable and non-refundable. Terms and conditions apply.",
    description_jpn:
      "・iPad、AirPods、Apple Watch、iPhone、MacBook、iCloudのストレージ、アクセサリなど、すべてのApple製品の購入に使えます。 ・App Storeやサブスクリプションの支払い、さらにAppやゲーム、音楽、映画、テレビ番組などの購入にも使えます。 ・誕生日プレゼントにも、感謝やお祝いのしるしにもふさわしいギフトです。 ・ギフトカードはEメールで届きます。 ・日本国内のすべてのApple Storeでの購入のほか、Apple Store App、apple.com、App Store、iTunes Store、Apple Music、Apple TV+、Apple Books、Apple Arcade、iCloud、Apple OneなどのAppleのサービスで利用できます。 ・Apple Storeで購入の際には、未使用のギフトカードをApple Storeにお持ちください。 ・Appleアカウントでのオンライン購入に利用するには、apple.com/redeemにアクセスして、カードの金額を残高にチャージしてください。 ・そのほかのお支払いには利用できません。 ・Apple Gift Cardの返品や払い戻しはできません。諸条件が適用されます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_giftcard.png",
  },
  {
    id: "703",
    brand: "Apple",
    sku: "AGC30000",
    product_eng: "Apple Gift Card 30,000 yen",
    product_jpn: "Apple Gift Card 30,000 円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥30,000",
    rrp_with_vat: "¥30,000",
    description_eng:
      "・You can use it to purchase all Apple products, including iPads, AirPods, Apple Watch, iPhones, MacBooks, iCloud storage, and accessories. ・It can also be used to pay for App Store and subscriptions, as well as to purchase Apps, games, music, movies, TV shows, and more. ・It's the perfect gift for a birthday or as a token of appreciation or congratulations. ・The gift card will be sent to you via email. ・The gift card is valid for purchases at all Apple Retail Stores in Japan, as well as Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, Apple One, and other Apple services. Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, and Apple One. ・Please bring your unused gift card to an Apple Retail Store when making a purchase. ・To redeem for online purchases in your Apple Account, go to apple.com/redeem and charge the card amount to your balance. ・The card cannot be used for any other payment. ・Apple Gift Cards are non-returnable and non-refundable. Terms and conditions apply.",
    description_jpn:
      "・iPad、AirPods、Apple Watch、iPhone、MacBook、iCloudのストレージ、アクセサリなど、すべてのApple製品の購入に使えます。 ・App Storeやサブスクリプションの支払い、さらにAppやゲーム、音楽、映画、テレビ番組などの購入にも使えます。 ・誕生日プレゼントにも、感謝やお祝いのしるしにもふさわしいギフトです。 ・ギフトカードはEメールで届きます。 ・日本国内のすべてのApple Storeでの購入のほか、Apple Store App、apple.com、App Store、iTunes Store、Apple Music、Apple TV+、Apple Books、Apple Arcade、iCloud、Apple OneなどのAppleのサービスで利用できます。 ・Apple Storeで購入の際には、未使用のギフトカードをApple Storeにお持ちください。 ・Appleアカウントでのオンライン購入に利用するには、apple.com/redeemにアクセスして、カードの金額を残高にチャージしてください。 ・そのほかのお支払いには利用できません。 ・Apple Gift Cardの返品や払い戻しはできません。諸条件が適用されます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_giftcard.png",
  },
  {
    id: "704",
    brand: "Apple",
    sku: "AGC50000",
    product_eng: "Apple Gift Card 50,000 yen",
    product_jpn: "Apple Gift Card 50,000 円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥50,000",
    rrp_with_vat: "¥50,000",
    description_eng:
      "・You can use it to purchase all Apple products, including iPads, AirPods, Apple Watch, iPhones, MacBooks, iCloud storage, and accessories. ・It can also be used to pay for App Store and subscriptions, as well as to purchase Apps, games, music, movies, TV shows, and more. ・It's the perfect gift for a birthday or as a token of appreciation or congratulations. ・The gift card will be sent to you via email. ・The gift card is valid for purchases at all Apple Retail Stores in Japan, as well as Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, Apple One, and other Apple services. Apple Store App, apple.com, App Store, iTunes Store, Apple Music, Apple TV+, Apple Books, Apple Arcade, iCloud, and Apple One. ・Please bring your unused gift card to an Apple Retail Store when making a purchase. ・To redeem for online purchases in your Apple Account, go to apple.com/redeem and charge the card amount to your balance. ・The card cannot be used for any other payment. ・Apple Gift Cards are non-returnable and non-refundable. Terms and conditions apply.",
    description_jpn:
      "・iPad、AirPods、Apple Watch、iPhone、MacBook、iCloudのストレージ、アクセサリなど、すべてのApple製品の購入に使えます。 ・App Storeやサブスクリプションの支払い、さらにAppやゲーム、音楽、映画、テレビ番組などの購入にも使えます。 ・誕生日プレゼントにも、感謝やお祝いのしるしにもふさわしいギフトです。 ・ギフトカードはEメールで届きます。 ・日本国内のすべてのApple Storeでの購入のほか、Apple Store App、apple.com、App Store、iTunes Store、Apple Music、Apple TV+、Apple Books、Apple Arcade、iCloud、Apple OneなどのAppleのサービスで利用できます。 ・Apple Storeで購入の際には、未使用のギフトカードをApple Storeにお持ちください。 ・Appleアカウントでのオンライン購入に利用するには、apple.com/redeemにアクセスして、カードの金額を残高にチャージしてください。 ・そのほかのお支払いには利用できません。 ・Apple Gift Cardの返品や払い戻しはできません。諸条件が適用されます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_giftcard.png",
  },
  {
    id: "705",
    brand: "Visa Gift vanilla",
    sku: "VISA1000",
    product_eng: "Visa eGift vanilla 1000yen",
    product_jpn: "Visa eギフト バニラ 1000円",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥985",
    description_eng:
      "It can be used at online Visa merchants worldwide. It is a code type gift that delivers a Visa card number” For more information, please visit https://www.vvgift.jp/egift/use",
    description_jpn:
      "世界のオンラインVisa加盟店で使えます。 「Visaのカード番号」をお届けするコードタイプギフトです。 詳細は以下をご覧ください。 https://www.vvgift.jp/egift/use",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/visa.png",
  },
  {
    id: "706",
    brand: "Visa Gift vanilla",
    sku: "VISA3000",
    product_eng: "Visa eGift vanilla 3000yen",
    product_jpn: "Visa eギフト バニラ 3000円",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥2,955",
    description_eng:
      "It can be used at online Visa merchants worldwide. It is a code type gift that delivers a Visa card number” For more information, please visit https://www.vvgift.jp/egift/use",
    description_jpn:
      "世界のオンラインVisa加盟店で使えます。 「Visaのカード番号」をお届けするコードタイプギフトです。 詳細は以下をご覧ください。 https://www.vvgift.jp/egift/use",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/visa.png",
  },
  {
    id: "707",
    brand: "Visa Gift vanilla",
    sku: "VISA5000",
    product_eng: "Visa eGift vanilla 5000yen",
    product_jpn: "Visa eギフト バニラ 5000円",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥4,925",
    description_eng:
      "It can be used at online Visa merchants worldwide. It is a code type gift that delivers a Visa card number” For more information, please visit https://www.vvgift.jp/egift/use",
    description_jpn:
      "世界のオンラインVisa加盟店で使えます。 「Visaのカード番号」をお届けするコードタイプギフトです。 詳細は以下をご覧ください。 https://www.vvgift.jp/egift/use",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/visa.png",
  },
  {
    id: "708",
    brand: "Visa Gift vanilla",
    sku: "VISA10000",
    product_eng: "Visa eGift vanilla 10.000yen",
    product_jpn: "Visa eギフト バニラ 10.000円",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥9,850",
    description_eng:
      "It can be used at online Visa merchants worldwide. It is a code type gift that delivers a Visa card number” For more information, please visit https://www.vvgift.jp/egift/use",
    description_jpn:
      "世界のオンラインVisa加盟店で使えます。 「Visaのカード番号」をお届けするコードタイプギフトです。 詳細は以下をご覧ください。 https://www.vvgift.jp/egift/use",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/visa.png",
  },
  {
    id: "709",
    brand: "Visa Gift vanilla",
    sku: "VISA30000",
    product_eng: "Visa eGift vanilla 30.000yen",
    product_jpn: "Visa eギフト バニラ 30.000円",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥30,000",
    rrp_with_vat: "¥29,550",
    description_eng:
      "It can be used at online Visa merchants worldwide. It is a code type gift that delivers a Visa card number” For more information, please visit https://www.vvgift.jp/egift/use",
    description_jpn:
      "世界のオンラインVisa加盟店で使えます。 「Visaのカード番号」をお届けするコードタイプギフトです。 詳細は以下をご覧ください。 https://www.vvgift.jp/egift/use",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/visa.png",
  },
  {
    id: "710",
    brand: "Visa Gift vanilla",
    sku: "VISA50000",
    product_eng: "Visa eGift vanilla 50.000yen",
    product_jpn: "Visa eギフト バニラ 50.000円",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥50,000",
    rrp_with_vat: "¥49,250",
    description_eng:
      "It can be used at online Visa merchants worldwide. It is a code type gift that delivers a Visa card number For more information, please visit https://www.vvgift.jp/egift/use",
    description_jpn:
      "世界のオンラインVisa加盟店で使えます。 「Visaのカード番号」をお届けするコードタイプギフトです。 詳細は以下をご覧ください。 https://www.vvgift.jp/egift/use",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/visa.png",
  },
  {
    id: "711",
    brand: "Book e-gift",
    sku: "BOO1000",
    product_eng: "Book e-gift card 1,000 yen",
    product_jpn: "図書カードネットギフト 1,000円",
    category_1: "Gift Card",
    category_2: "Books",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥1,000",
    description_eng:
      "You can purchase books and magazines of your choice at participating bookstores nationwide",
    description_jpn:
      "図書カードネットギフトは全国の加盟書店やネット書店でお好きな本や雑誌がご購入いただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/tosho.png",
  },
  {
    id: "712",
    brand: "Book e-gift",
    sku: "BOO3000",
    product_eng: "Book e-gift card 3,000 yen",
    product_jpn: "図書カードネットギフト 3,000円",
    category_1: "Gift Card",
    category_2: "Books",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,000",
    description_eng:
      "You can purchase books and magazines of your choice at participating bookstores nationwide",
    description_jpn:
      "図書カードネットギフトは全国の加盟書店やネット書店でお好きな本や雑誌がご購入いただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/tosho.png",
  },
  {
    id: "713",
    brand: "Book e-gift",
    sku: "BOO5000",
    product_eng: "Book e-gift card 5,000 yen",
    product_jpn: "図書カードネットギフト 5,000円",
    category_1: "Gift Card",
    category_2: "Books",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,000",
    description_eng:
      "You can purchase books and magazines of your choice at participating bookstores nationwide",
    description_jpn:
      "図書カードネットギフトは全国の加盟書店やネット書店でお好きな本や雑誌がご購入いただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/tosho.png",
  },
  {
    id: "714",
    brand: "JCB PREMO",
    sku: "JCB1000",
    product_eng: "JCB PREMO DIGITAL 1,000 yen",
    product_jpn: "JCBプレモデジタル(1,000円分)",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥1,000",
    description_eng:
      "JCB PREMO DIGITAL is a digital gift that can be used at online shopping and websites of JCB PREMO member stores, and can be used at more than 700,000 stores nationwide including convenience stores and department stores by transferring the value to JCB PREMO Card. Click here for details on JCB PREMO DIGITAL  https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    description_jpn:
      "JCBプレモデジタルは、JCB PREMO加盟店のオンラインショッピング・ウェブサイトで利用できるデジタルギフトです。JCBプレモカードへのバリュー移行により、コンビニエンスストアや百貨店など全国70万店以上のお店でも利用できます。 JCBプレモデジタルの詳細はこちら https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/jcb_premo.png",
  },
  {
    id: "715",
    brand: "JCB PREMO",
    sku: "JCB2000",
    product_eng: "JCB PREMO DIGITAL 2,000 yen",
    product_jpn: "JCBプレモデジタル(2,000円分)",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,000",
    description_eng:
      "JCB PREMO DIGITAL is a digital gift that can be used at online shopping and websites of JCB PREMO member stores, and can be used at more than 700,000 stores nationwide including convenience stores and department stores by transferring the value to JCB PREMO Card. Click here for details on JCB PREMO DIGITAL  https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    description_jpn:
      "JCBプレモデジタルは、JCB PREMO加盟店のオンラインショッピング・ウェブサイトで利用できるデジタルギフトです。JCBプレモカードへのバリュー移行により、コンビニエンスストアや百貨店など全国70万店以上のお店でも利用できます。 JCBプレモデジタルの詳細はこちら https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/jcb_premo.png",
  },
  {
    id: "716",
    brand: "JCB PREMO",
    sku: "JCB3000",
    product_eng: "JCB PREMO DIGITAL 3,000 yen",
    product_jpn: "JCBプレモデジタル(3,000円分)",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,000",
    description_eng:
      "JCB PREMO DIGITAL is a digital gift that can be used at online shopping and websites of JCB PREMO member stores, and can be used at more than 700,000 stores nationwide including convenience stores and department stores by transferring the value to JCB PREMO Card. Click here for details on JCB PREMO DIGITAL  https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    description_jpn:
      "JCBプレモデジタルは、JCB PREMO加盟店のオンラインショッピング・ウェブサイトで利用できるデジタルギフトです。JCBプレモカードへのバリュー移行により、コンビニエンスストアや百貨店など全国70万店以上のお店でも利用できます。 JCBプレモデジタルの詳細はこちら https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/jcb_premo.png",
  },
  {
    id: "717",
    brand: "JCB PREMO",
    sku: "JCB5000",
    product_eng: "JCB PREMO DIGITAL 5,000 yen",
    product_jpn: "JCBプレモデジタル(5,000円分)",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,000",
    description_eng:
      "JCB PREMO DIGITAL is a digital gift that can be used at online shopping and websites of JCB PREMO member stores, and can be used at more than 700,000 stores nationwide including convenience stores and department stores by transferring the value to JCB PREMO Card. Click here for details on JCB PREMO DIGITAL  https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    description_jpn:
      "JCBプレモデジタルは、JCB PREMO加盟店のオンラインショッピング・ウェブサイトで利用できるデジタルギフトです。JCBプレモカードへのバリュー移行により、コンビニエンスストアや百貨店など全国70万店以上のお店でも利用できます。 JCBプレモデジタルの詳細はこちら https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/jcb_premo.png",
  },
  {
    id: "718",
    brand: "JCB PREMO",
    sku: "JCB10000",
    product_eng: "JCB PREMO DIGITAL 10,000 yen",
    product_jpn: "JCBプレモデジタル(10,000円分)",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥10,000",
    description_eng:
      "JCB PREMO DIGITAL is a digital gift that can be used at online shopping and websites of JCB PREMO member stores, and can be used at more than 700,000 stores nationwide including convenience stores and department stores by transferring the value to JCB PREMO Card. Click here for details on JCB PREMO DIGITAL  https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    description_jpn:
      "JCBプレモデジタルは、JCB PREMO加盟店のオンラインショッピング・ウェブサイトで利用できるデジタルギフトです。JCBプレモカードへのバリュー移行により、コンビニエンスストアや百貨店など全国70万店以上のお店でも利用できます。 JCBプレモデジタルの詳細はこちら https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/jcb_premo.png",
  },
  {
    id: "719",
    brand: "JCB PREMO",
    sku: "JCB20000",
    product_eng: "JCB PREMO DIGITAL 20,000 yen",
    product_jpn: "JCBプレモデジタル(20,000円分)",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥20,000",
    description_eng:
      "JCB PREMO DIGITAL is a digital gift that can be used at online shopping and websites of JCB PREMO member stores, and can be used at more than 700,000 stores nationwide including convenience stores and department stores by transferring the value to JCB PREMO Card. Click here for details on JCB PREMO DIGITAL  https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    description_jpn:
      "JCBプレモデジタルは、JCB PREMO加盟店のオンラインショッピング・ウェブサイトで利用できるデジタルギフトです。JCBプレモカードへのバリュー移行により、コンビニエンスストアや百貨店など全国70万店以上のお店でも利用できます。 JCBプレモデジタルの詳細はこちら https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/jcb_premo.png",
  },
  {
    id: "720",
    brand: "JCB PREMO",
    sku: "JCB30000",
    product_eng: "JCB PREMO DIGITAL 30,000 yen",
    product_jpn: "JCBプレモデジタル(30,000円分)",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥30,000",
    rrp_with_vat: "¥30,000",
    description_eng:
      "JCB PREMO DIGITAL is a digital gift that can be used at online shopping and websites of JCB PREMO member stores, and can be used at more than 700,000 stores nationwide including convenience stores and department stores by transferring the value to JCB PREMO Card. Click here for details on JCB PREMO DIGITAL  https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    description_jpn:
      "JCBプレモデジタルは、JCB PREMO加盟店のオンラインショッピング・ウェブサイトで利用できるデジタルギフトです。JCBプレモカードへのバリュー移行により、コンビニエンスストアや百貨店など全国70万店以上のお店でも利用できます。 JCBプレモデジタルの詳細はこちら https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/jcb_premo.png",
  },
  {
    id: "721",
    brand: "JCB PREMO",
    sku: "JCB50000",
    product_eng: "JCB PREMO DIGITAL 50,000 yen",
    product_jpn: "JCBプレモデジタル(50,000円分)",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥50,000",
    rrp_with_vat: "¥50,000",
    description_eng:
      "JCB PREMO DIGITAL is a digital gift that can be used at online shopping and websites of JCB PREMO member stores, and can be used at more than 700,000 stores nationwide including convenience stores and department stores by transferring the value to JCB PREMO Card. Click here for details on JCB PREMO DIGITAL  https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    description_jpn:
      "JCBプレモデジタルは、JCB PREMO加盟店のオンラインショッピング・ウェブサイトで利用できるデジタルギフトです。JCBプレモカードへのバリュー移行により、コンビニエンスストアや百貨店など全国70万店以上のお店でも利用できます。 JCBプレモデジタルの詳細はこちら https://www.jcb.co.jp/card/voucher/premo/pop/premo_digital.html",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/jcb_premo.png",
  },
  {
    id: "722",
    brand: "QUO",
    sku: "QUO1000",
    product_eng: "QUO CARD Pay 1,000 yen",
    product_jpn: "QUOカードPay 1,000円分",
    category_1: "Gift Card",
    category_2: "Stores",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥1,040",
    description_eng:
      "QUO CARD Pay is easy! Safe and secure! No app or membership required!  Just have your phone screen scanned at the store and you're good to go!",
    description_jpn:
      "QUOカードPayは、 簡単！安心・安全！  登録やアプリなしでお使いいただけるので安心です。 スマホ画面をお店で読み取ってもらうだけでお支払完了。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/quo.png",
  },
  {
    id: "723",
    brand: "QUO",
    sku: "QUO3000",
    product_eng: "QUO CARD Pay 3,000 yen",
    product_jpn: "QUOカードPay 3,000円分",
    category_1: "Gift Card",
    category_2: "Stores",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,120",
    description_eng:
      "QUO CARD Pay is easy! Safe and secure! No app or membership required!  Just have your phone screen scanned at the store and you're good to go!",
    description_jpn:
      "QUOカードPayは、 簡単！安心・安全！  登録やアプリなしでお使いいただけるので安心です。 スマホ画面をお店で読み取ってもらうだけでお支払完了。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/quo.png",
  },
  {
    id: "724",
    brand: "QUO",
    sku: "QUO5000",
    product_eng: "QUO CARD Pay 5,000 yen",
    product_jpn: "QUOカードPay 5,000円分",
    category_1: "Gift Card",
    category_2: "Stores",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,200",
    description_eng:
      "QUO CARD Pay is easy! Safe and secure! No app or membership required!  Just have your phone screen scanned at the store and you're good to go!",
    description_jpn:
      "QUOカードPayは、 簡単！安心・安全！  登録やアプリなしでお使いいただけるので安心です。 スマホ画面をお店で読み取ってもらうだけでお支払完了。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/quo.png",
  },
  {
    id: "725",
    brand: "QUO",
    sku: "QUO10000",
    product_eng: "QUO CARD Pay 10,000 yen",
    product_jpn: "QUOカードPay 10,000円分",
    category_1: "Gift Card",
    category_2: "Stores",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥10,400",
    description_eng:
      "QUO CARD Pay is easy! Safe and secure! No app or membership required!  Just have your phone screen scanned at the store and you're good to go!",
    description_jpn:
      "QUOカードPayは、 簡単！安心・安全！  登録やアプリなしでお使いいただけるので安心です。 スマホ画面をお店で読み取ってもらうだけでお支払完了。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/quo.png",
  },
  {
    id: "726",
    brand: "Google",
    sku: "GOO300",
    product_eng: "GooglePlay Gift Code 300 yen",
    product_jpn: "Goole Play  ギフトコード 300円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥300",
    rrp_with_vat: "¥294",
    description_eng:
      "With millions of apps, games, and more, you're sure to find what you're looking for on Google Play, so grab a Google Play Gift Code and explore a world of endless fun. With no fees, no expiration date, and no credit card required, you can easily get popular games and everyday essential apps as gifts for your loved ones. Or, of course, treat yourself.",
    description_jpn:
      "アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。人気のゲームや毎日の生活に欠かせないアプリを、手数料なし、有効期限なし、クレジット カードなしで気軽に手に入れることができ、大切な人へのギフトとして最適です。もちろん、自分へのご褒美としても。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/google-play.png",
  },
  {
    id: "727",
    brand: "Google",
    sku: "GOO500",
    product_eng: "GooglePlay Gift Code 500 yen",
    product_jpn: "Goole Play  ギフトコード 500円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥500",
    rrp_with_vat: "¥490",
    description_eng:
      "With millions of apps, games, and more, you're sure to find what you're looking for on Google Play, so grab a Google Play Gift Code and explore a world of endless fun. With no fees, no expiration date, and no credit card required, you can easily get popular games and everyday essential apps as gifts for your loved ones. Or, of course, treat yourself.",
    description_jpn:
      "アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。人気のゲームや毎日の生活に欠かせないアプリを、手数料なし、有効期限なし、クレジット カードなしで気軽に手に入れることができ、大切な人へのギフトとして最適です。もちろん、自分へのご褒美としても。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/google-play.png",
  },
  {
    id: "728",
    brand: "Google",
    sku: "GOO1000",
    product_eng: "GooglePlay Gift Code 1,000 yen",
    product_jpn: "Goole Play  ギフトコード 1,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥980",
    description_eng:
      "With millions of apps, games, and more, you're sure to find what you're looking for on Google Play, so grab a Google Play Gift Code and explore a world of endless fun. With no fees, no expiration date, and no credit card required, you can easily get popular games and everyday essential apps as gifts for your loved ones. Or, of course, treat yourself.",
    description_jpn:
      "アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。人気のゲームや毎日の生活に欠かせないアプリを、手数料なし、有効期限なし、クレジット カードなしで気軽に手に入れることができ、大切な人へのギフトとして最適です。もちろん、自分へのご褒美としても。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/google-play.png",
  },
  {
    id: "729",
    brand: "Google",
    sku: "GOO2000",
    product_eng: "GooglePlay Gift Code 2,000 yen",
    product_jpn: "Goole Play  ギフトコード 2,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥1,960",
    description_eng:
      "With millions of apps, games, and more, you're sure to find what you're looking for on Google Play, so grab a Google Play Gift Code and explore a world of endless fun. With no fees, no expiration date, and no credit card required, you can easily get popular games and everyday essential apps as gifts for your loved ones. Or, of course, treat yourself.",
    description_jpn:
      "アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。人気のゲームや毎日の生活に欠かせないアプリを、手数料なし、有効期限なし、クレジット カードなしで気軽に手に入れることができ、大切な人へのギフトとして最適です。もちろん、自分へのご褒美としても。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/google-play.png",
  },
  {
    id: "730",
    brand: "Google",
    sku: "GOO3000",
    product_eng: "GooglePlay Gift Code 3,000 yen",
    product_jpn: "Goole Play  ギフトコード 3,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥2,940",
    description_eng:
      "With millions of apps, games, and more, you're sure to find what you're looking for on Google Play, so grab a Google Play Gift Code and explore a world of endless fun. With no fees, no expiration date, and no credit card required, you can easily get popular games and everyday essential apps as gifts for your loved ones. Or, of course, treat yourself.",
    description_jpn:
      "アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。人気のゲームや毎日の生活に欠かせないアプリを、手数料なし、有効期限なし、クレジット カードなしで気軽に手に入れることができ、大切な人へのギフトとして最適です。もちろん、自分へのご褒美としても。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/google-play.png",
  },
  {
    id: "731",
    brand: "Google",
    sku: "GOO5000",
    product_eng: "GooglePlay Gift Code 5,000 yen",
    product_jpn: "Goole Play  ギフトコード 5,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥4,900",
    description_eng:
      "With millions of apps, games, and more, you're sure to find what you're looking for on Google Play, so grab a Google Play Gift Code and explore a world of endless fun. With no fees, no expiration date, and no credit card required, you can easily get popular games and everyday essential apps as gifts for your loved ones. Or, of course, treat yourself.",
    description_jpn:
      "アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。人気のゲームや毎日の生活に欠かせないアプリを、手数料なし、有効期限なし、クレジット カードなしで気軽に手に入れることができ、大切な人へのギフトとして最適です。もちろん、自分へのご褒美としても。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/google-play.png",
  },
  {
    id: "732",
    brand: "Google",
    sku: "GOO10000",
    product_eng: "GooglePlay Gift Code 10,000 yen",
    product_jpn: "Goole Play  ギフトコード 10,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥9,800",
    description_eng:
      "With millions of apps, games, and more, you're sure to find what you're looking for on Google Play, so grab a Google Play Gift Code and explore a world of endless fun. With no fees, no expiration date, and no credit card required, you can easily get popular games and everyday essential apps as gifts for your loved ones. Or, of course, treat yourself.",
    description_jpn:
      "アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。人気のゲームや毎日の生活に欠かせないアプリを、手数料なし、有効期限なし、クレジット カードなしで気軽に手に入れることができ、大切な人へのギフトとして最適です。もちろん、自分へのご褒美としても。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/google-play.png",
  },
  {
    id: "733",
    brand: "Google",
    sku: "GOO30000",
    product_eng: "GooglePlay Gift Code 30,000 yen",
    product_jpn: "Goole Play  ギフトコード 30,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥30,000",
    rrp_with_vat: "¥29,400",
    description_eng:
      "With millions of apps, games, and more, you're sure to find what you're looking for on Google Play, so grab a Google Play Gift Code and explore a world of endless fun. With no fees, no expiration date, and no credit card required, you can easily get popular games and everyday essential apps as gifts for your loved ones. Or, of course, treat yourself.",
    description_jpn:
      "アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。人気のゲームや毎日の生活に欠かせないアプリを、手数料なし、有効期限なし、クレジット カードなしで気軽に手に入れることができ、大切な人へのギフトとして最適です。もちろん、自分へのご褒美としても。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/google-play.png",
  },
  {
    id: "734",
    brand: "Google",
    sku: "GOO50000",
    product_eng: "GooglePlay Gift Code 50,000 yen",
    product_jpn: "Goole Play  ギフトコード 50,000円分",
    category_1: "Gift Card",
    category_2: "Online stores",
    rrp_ex_vat: "¥50,000",
    rrp_with_vat: "¥49,000",
    description_eng:
      "With millions of apps, games, and more, you're sure to find what you're looking for on Google Play, so grab a Google Play Gift Code and explore a world of endless fun. With no fees, no expiration date, and no credit card required, you can easily get popular games and everyday essential apps as gifts for your loved ones. Or, of course, treat yourself.",
    description_jpn:
      "アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。人気のゲームや毎日の生活に欠かせないアプリを、手数料なし、有効期限なし、クレジット カードなしで気軽に手に入れることができ、大切な人へのギフトとして最適です。もちろん、自分へのご褒美としても。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/google-play.png",
  },
  {
    id: "735",
    brand: "nanaco",
    sku: "NAN200",
    product_eng: "nanaco Gift Card 200 yen",
    product_jpn: "nanacoギフト 200円分",
    category_1: "Gift Card",
    category_2: "Stores",
    rrp_ex_vat: "¥200",
    rrp_with_vat: "¥200",
    description_eng:
      "This is a service where you can register your nanaco card or nanaco mobile phone to receive the money as electronic money nanaco. You can also use nanaco Gift directly as payment at sites that support nanaco Gift, such as Omni7. An Internet environment is required to use this service. For more information, please visit the website (https://atgift.jp/user/item/nanacogift/). To charge nanaco Gift to nanaco you will need a nanaco card or nanaco mobile. If you do not have one, please visit (https://www.nanaco-net.jp/introduction/) For more information about nanaco services and how to use it, please visit the nanaco website (https://www.nanaco-net.jp/) *nanaco and nanaco Gift are registered trademarks of Seven Card Service Co. *Nanaco Gift is an electronic money gift service issued by NTT Card Solutions Corporation under a license agreement with Seven Card Service Co.",
    description_jpn:
      "お手持ちのnanacoカードやnanacoモバイルに登録することで、電子マネー「nanaco」として受け取ることができるサービスです。 オムニ７をはじめnanacoギフト対応サイトでは、nanacoギフトを直接お支払にご利用いただく事も可能です。 ご利用にはインターネット環境が必要となります。 詳細はホームページ（https://atgift.jp/user/item/nanacogift/）をご覧ください。 nanacoギフトを「nanaco」にチャージするには、nanacoカードもしくはnanacoモバイルが必要です。 お持ちでない方は、こちら（https://www.nanaco-net.jp/introduction/）をご覧ください。 「nanaco」のサービス内容やご利用方法は、nanacoのホームページ（https://www.nanaco-net.jp/ ）をご覧ください。 ※「nanaco(ナナコ)」と「nanacoギフト」は株式会社セブン・カードサービスの登録商標です。 ※「nanacoギフト」は、株式会社セブン・カードサービスとの発行許諾契約により、株式会社NTTカードソリューションが発行する電子マネーギフトサービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nanaco.png",
  },
  {
    id: "736",
    brand: "nanaco",
    sku: "NAN500",
    product_eng: "nanaco Gift Card 500 yen",
    product_jpn: "nanacoギフト 500円分",
    category_1: "Gift Card",
    category_2: "Stores",
    rrp_ex_vat: "¥500",
    rrp_with_vat: "¥500",
    description_eng:
      "This is a service where you can register your nanaco card or nanaco mobile phone to receive the money as electronic money nanaco. You can also use nanaco Gift directly as payment at sites that support nanaco Gift, such as Omni7. An Internet environment is required to use this service. For more information, please visit the website (https://atgift.jp/user/item/nanacogift/). To charge nanaco Gift to nanaco you will need a nanaco card or nanaco mobile. If you do not have one, please visit (https://www.nanaco-net.jp/introduction/) For more information about nanaco services and how to use it, please visit the nanaco website (https://www.nanaco-net.jp/) *nanaco and nanaco Gift are registered trademarks of Seven Card Service Co. *Nanaco Gift is an electronic money gift service issued by NTT Card Solutions Corporation under a license agreement with Seven Card Service Co.",
    description_jpn:
      "お手持ちのnanacoカードやnanacoモバイルに登録することで、電子マネー「nanaco」として受け取ることができるサービスです。 オムニ７をはじめnanacoギフト対応サイトでは、nanacoギフトを直接お支払にご利用いただく事も可能です。 ご利用にはインターネット環境が必要となります。 詳細はホームページ（https://atgift.jp/user/item/nanacogift/）をご覧ください。 nanacoギフトを「nanaco」にチャージするには、nanacoカードもしくはnanacoモバイルが必要です。 お持ちでない方は、こちら（https://www.nanaco-net.jp/introduction/）をご覧ください。 「nanaco」のサービス内容やご利用方法は、nanacoのホームページ（https://www.nanaco-net.jp/ ）をご覧ください。 ※「nanaco(ナナコ)」と「nanacoギフト」は株式会社セブン・カードサービスの登録商標です。 ※「nanacoギフト」は、株式会社セブン・カードサービスとの発行許諾契約により、株式会社NTTカードソリューションが発行する電子マネーギフトサービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nanaco.png",
  },
  {
    id: "737",
    brand: "nanaco",
    sku: "NAN1000",
    product_eng: "nanaco Gift Card 1,000 yen",
    product_jpn: "nanacoギフト 1,000円分",
    category_1: "Gift Card",
    category_2: "Stores",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥1,000",
    description_eng:
      "This is a service where you can register your nanaco card or nanaco mobile phone to receive the money as electronic money nanaco. You can also use nanaco Gift directly as payment at sites that support nanaco Gift, such as Omni7. An Internet environment is required to use this service. For more information, please visit the website (https://atgift.jp/user/item/nanacogift/). To charge nanaco Gift to nanaco you will need a nanaco card or nanaco mobile. If you do not have one, please visit (https://www.nanaco-net.jp/introduction/) For more information about nanaco services and how to use it, please visit the nanaco website (https://www.nanaco-net.jp/) *nanaco and nanaco Gift are registered trademarks of Seven Card Service Co. *Nanaco Gift is an electronic money gift service issued by NTT Card Solutions Corporation under a license agreement with Seven Card Service Co.",
    description_jpn:
      "お手持ちのnanacoカードやnanacoモバイルに登録することで、電子マネー「nanaco」として受け取ることができるサービスです。 オムニ７をはじめnanacoギフト対応サイトでは、nanacoギフトを直接お支払にご利用いただく事も可能です。 ご利用にはインターネット環境が必要となります。 詳細はホームページ（https://atgift.jp/user/item/nanacogift/）をご覧ください。 nanacoギフトを「nanaco」にチャージするには、nanacoカードもしくはnanacoモバイルが必要です。 お持ちでない方は、こちら（https://www.nanaco-net.jp/introduction/）をご覧ください。 「nanaco」のサービス内容やご利用方法は、nanacoのホームページ（https://www.nanaco-net.jp/ ）をご覧ください。 ※「nanaco(ナナコ)」と「nanacoギフト」は株式会社セブン・カードサービスの登録商標です。 ※「nanacoギフト」は、株式会社セブン・カードサービスとの発行許諾契約により、株式会社NTTカードソリューションが発行する電子マネーギフトサービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nanaco.png",
  },
  {
    id: "738",
    brand: "nanaco",
    sku: "NAN2000",
    product_eng: "nanaco Gift Card 2,000 yen",
    product_jpn: "nanacoギフト 2,000円分",
    category_1: "Gift Card",
    category_2: "Stores",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,000",
    description_eng:
      "This is a service where you can register your nanaco card or nanaco mobile phone to receive the money as electronic money nanaco. You can also use nanaco Gift directly as payment at sites that support nanaco Gift, such as Omni7. An Internet environment is required to use this service. For more information, please visit the website (https://atgift.jp/user/item/nanacogift/). To charge nanaco Gift to nanaco you will need a nanaco card or nanaco mobile. If you do not have one, please visit (https://www.nanaco-net.jp/introduction/) For more information about nanaco services and how to use it, please visit the nanaco website (https://www.nanaco-net.jp/) *nanaco and nanaco Gift are registered trademarks of Seven Card Service Co. *Nanaco Gift is an electronic money gift service issued by NTT Card Solutions Corporation under a license agreement with Seven Card Service Co.",
    description_jpn:
      "お手持ちのnanacoカードやnanacoモバイルに登録することで、電子マネー「nanaco」として受け取ることができるサービスです。 オムニ７をはじめnanacoギフト対応サイトでは、nanacoギフトを直接お支払にご利用いただく事も可能です。 ご利用にはインターネット環境が必要となります。 詳細はホームページ（https://atgift.jp/user/item/nanacogift/）をご覧ください。 nanacoギフトを「nanaco」にチャージするには、nanacoカードもしくはnanacoモバイルが必要です。 お持ちでない方は、こちら（https://www.nanaco-net.jp/introduction/）をご覧ください。 「nanaco」のサービス内容やご利用方法は、nanacoのホームページ（https://www.nanaco-net.jp/ ）をご覧ください。 ※「nanaco(ナナコ)」と「nanacoギフト」は株式会社セブン・カードサービスの登録商標です。 ※「nanacoギフト」は、株式会社セブン・カードサービスとの発行許諾契約により、株式会社NTTカードソリューションが発行する電子マネーギフトサービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nanaco.png",
  },
  {
    id: "739",
    brand: "nanaco",
    sku: "NAN5000",
    product_eng: "nanaco Gift Card 5,000 yen",
    product_jpn: "nanacoギフト 5,000円分",
    category_1: "Gift Card",
    category_2: "Stores",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,000",
    description_eng:
      "This is a service where you can register your nanaco card or nanaco mobile phone to receive the money as electronic money nanaco. You can also use nanaco Gift directly as payment at sites that support nanaco Gift, such as Omni7. An Internet environment is required to use this service. For more information, please visit the website (https://atgift.jp/user/item/nanacogift/). To charge nanaco Gift to nanaco you will need a nanaco card or nanaco mobile. If you do not have one, please visit (https://www.nanaco-net.jp/introduction/) For more information about nanaco services and how to use it, please visit the nanaco website (https://www.nanaco-net.jp/) *nanaco and nanaco Gift are registered trademarks of Seven Card Service Co. *Nanaco Gift is an electronic money gift service issued by NTT Card Solutions Corporation under a license agreement with Seven Card Service Co.",
    description_jpn:
      "お手持ちのnanacoカードやnanacoモバイルに登録することで、電子マネー「nanaco」として受け取ることができるサービスです。 オムニ７をはじめnanacoギフト対応サイトでは、nanacoギフトを直接お支払にご利用いただく事も可能です。 ご利用にはインターネット環境が必要となります。 詳細はホームページ（https://atgift.jp/user/item/nanacogift/）をご覧ください。 nanacoギフトを「nanaco」にチャージするには、nanacoカードもしくはnanacoモバイルが必要です。 お持ちでない方は、こちら（https://www.nanaco-net.jp/introduction/）をご覧ください。 「nanaco」のサービス内容やご利用方法は、nanacoのホームページ（https://www.nanaco-net.jp/ ）をご覧ください。 ※「nanaco(ナナコ)」と「nanacoギフト」は株式会社セブン・カードサービスの登録商標です。 ※「nanacoギフト」は、株式会社セブン・カードサービスとの発行許諾契約により、株式会社NTTカードソリューションが発行する電子マネーギフトサービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/nanaco.png",
  },
  {
    id: "740",
    brand: "Ponta",
    sku: "POP500",
    product_eng: "Ponta Gift Point Code 500points",
    product_jpn: "Pontaポイント コード 500ポイント分",
    category_1: "Gift Card",
    category_2: "points exchange",
    rrp_ex_vat: "¥500",
    rrp_with_vat: "¥500",
    description_eng:
      "You can add Ponta points to your Ponta member ID. For more information on the Ponta Point Code, please visit https://atgift.jp/user/item/pontapointcode/.",
    description_jpn:
      "Ponta会員IDにPontaポイントを加算できるサービスです。 Pontaポイント コードの詳細はこちら（https://atgift.jp/user/item/pontapointcode/）をご覧ください。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Ponta.png",
  },
  {
    id: "741",
    brand: "Ponta",
    sku: "POP1000",
    product_eng: "Ponta Gift Point Code 1,000points",
    product_jpn: "Pontaポイント コード 1000ポイント分",
    category_1: "Gift Card",
    category_2: "points exchange",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥1,000",
    description_eng:
      "You can add Ponta points to your Ponta member ID. For more information on the Ponta Point Code, please visit https://atgift.jp/user/item/pontapointcode/.",
    description_jpn:
      "Ponta会員IDにPontaポイントを加算できるサービスです。 Pontaポイント コードの詳細はこちら（https://atgift.jp/user/item/pontapointcode/）をご覧ください。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Ponta.png",
  },
  {
    id: "742",
    brand: "Ponta",
    sku: "POP2000",
    product_eng: "Ponta Gift Point Code 2,000 points",
    product_jpn: "Pontaポイント コード 2000ポイント分",
    category_1: "Gift Card",
    category_2: "points exchange",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,000",
    description_eng:
      "You can add Ponta points to your Ponta member ID. For more information on the Ponta Point Code, please visit https://atgift.jp/user/item/pontapointcode/.",
    description_jpn:
      "Ponta会員IDにPontaポイントを加算できるサービスです。 Pontaポイント コードの詳細はこちら（https://atgift.jp/user/item/pontapointcode/）をご覧ください。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Ponta.png",
  },
  {
    id: "743",
    brand: "Ponta",
    sku: "POP3000",
    product_eng: "Ponta Gift Point Code 3,000 points",
    product_jpn: "Pontaポイント コード 3000ポイント分",
    category_1: "Gift Card",
    category_2: "points exchange",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,000",
    description_eng:
      "You can add Ponta points to your Ponta member ID. For more information on the Ponta Point Code, please visit https://atgift.jp/user/item/pontapointcode/.",
    description_jpn:
      "Ponta会員IDにPontaポイントを加算できるサービスです。 Pontaポイント コードの詳細はこちら（https://atgift.jp/user/item/pontapointcode/）をご覧ください。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Ponta.png",
  },
  {
    id: "744",
    brand: "Ponta",
    sku: "POP5000",
    product_eng: "Ponta Gift Point Code 5,000 points",
    product_jpn: "Pontaポイント コード 5000ポイント分",
    category_1: "Gift Card",
    category_2: "points exchange",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,000",
    description_eng:
      "You can add Ponta points to your Ponta member ID. For more information on the Ponta Point Code, please visit https://atgift.jp/user/item/pontapointcode/.",
    description_jpn:
      "Ponta会員IDにPontaポイントを加算できるサービスです。 Pontaポイント コードの詳細はこちら（https://atgift.jp/user/item/pontapointcode/）をご覧ください。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Ponta.png",
  },
  {
    id: "745",
    brand: "Ponta",
    sku: "POP10000",
    product_eng: "Ponta Gift Point Code 10,000 points",
    product_jpn: "Pontaポイント コード 10000ポイント分",
    category_1: "Gift Card",
    category_2: "points exchange",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥10,000",
    description_eng:
      "You can add Ponta points to your Ponta member ID. For more information on the Ponta Point Code, please visit https://atgift.jp/user/item/pontapointcode/.",
    description_jpn:
      "Ponta会員IDにPontaポイントを加算できるサービスです。 Pontaポイント コードの詳細はこちら（https://atgift.jp/user/item/pontapointcode/）をご覧ください。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Ponta.png",
  },
  {
    id: "746",
    brand: "ASAHIBEER",
    sku: "ASH5000",
    product_eng: "ASAHIBEER Gift Card SUPERDRYFreshness",
    product_jpn: "アサヒスーパードライ  鮮度  デジタルギフト",
    category_1: "Gift Card",
    category_2: "Food/Drink",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥4,500",
    description_eng:
      "This card can be exchanged for Asahi Beer's Freshness Gift. You can experience the freshness of Super Dry.This freshness gift is a gift system that delivers Asahi Super Dry, shipped from the factory within three days of production, on the designated date by cool delivery. You can experience the freshness of Super Dry.",
    description_jpn:
      "アサヒビールの鮮度ギフトと交換ができるカードです。スーパードライの「鮮度」を実感していただけます。できたてのスーパードライをあなたへ。 “鮮度がいい”特別なビールをお届けするギフトセットです。 鮮度は、うまさ。「できたてのビール」をお客さまへ。この鮮度ギフトは、製造後３日以内に工場から出荷した「アサヒスーパードライ」をクール便でご指定日にお届けするギフトシステムです。スーパードライの「鮮度」を実感していただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/asahi.png",
  },
  {
    id: "747",
    brand: "ENOTECA",
    sku: "ENT5000",
    product_eng: "ENOTECA Digital Gift - Wine selection",
    product_jpn: "エノテカ  デジタルギフト",
    category_1: "Gift Card",
    category_2: "Food/Drink",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥4,500",
    description_eng:
      "A card that allows you to exchange recommended wines from the wine specialty store Enoteca.About 20 items are listed, including a set of 3 or 4 bottles for you to enjoy drinking comparison, special Bordeaux wines, sparkling wines, etc.",
    description_jpn:
      "ワイン専門ショップエノテカのおすすめワインを交換できるカード。飲み比べをお楽しみ頂ける3～4本セットやこだわりのボルドーワイン、スパークリングワインなど約20アイテムを掲載。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Enoteca.png",
  },
  {
    id: "748",
    brand: "GINZASENBIKIYA",
    sku: "SNB5500",
    product_eng: "GINZASENBIKIYA Digital Gift",
    product_jpn: "銀座千疋屋  デジタルギフト",
    category_1: "Gift Card",
    category_2: "Dessert",
    rrp_ex_vat: "¥5,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      "You can choose from a variety of processed fruit products from Ginza Sembikiya, the first fruit parlor in Japan and the birthplace of fruit punch, which has proposed new ways to enjoy fruit while preserving tradition.",
    description_jpn:
      "日本初めての「フルーツパーラー」を開業、フルーツポンチを誕生させるなど、伝統を守りながら果物の新しい楽しみ方を提案してきた銀座千疋屋のフルーツ加工品が選べるカードです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/ginza_sembikiya.png",
  },
  {
    id: "749",
    brand: "Itochu",
    sku: "SFD5000",
    product_eng: "Itochu Digital Gift - Grmet Digital Gift",
    product_jpn: "選べる海鮮グルメ  デジタルギフト ",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥4,500",
    description_eng:
      "You can  choose from a variety of gourmet seafood products such as salmon roe, crab, tuna, dried fish, delicacies, hot pot sets, and other processed products.",
    description_jpn:
      "イクラ、カニ、マグロなどの海鮮をはじめ、干物、珍味、鍋セットなど加工品など様々な海の幸のグルメからお好きなものを選べるギフトカードです。 ",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Itochu.png",
  },
  {
    id: "750",
    brand: "Itochu",
    sku: "FLW5000",
    product_eng: "Itochu Digital Gift - Choice of Flowers Digital Gift",
    product_jpn: "選べる花  デジタルギフト ",
    category_1: "Gift Card",
    category_2: "Flower",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥4,500",
    description_eng:
      "This gift card offers a wide variety of flowers to choose from seasonal flowers , houseplants and the trendy preserved flowers.",
    description_jpn:
      "季節を楽しめる四季折々のお花から観葉植物、流行りのプリザーブドフラワーまで、様々な種類から選べるギフトカードです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Itochu.png",
  },
  {
    id: "751",
    brand: "Itochu",
    sku: "SWT3500",
    product_eng: "Itochu Digital Gift - Sweets from all over Japan Digital Gift ",
    product_jpn: "全国お取り寄せスイーツ  デジタルギフト ",
    category_1: "Gift Card",
    category_2: "Dessert",
    rrp_ex_vat: "¥3,500",
    rrp_with_vat: "¥3,150",
    description_eng:
      "This card can be exchanged for famous sweets from all over Japan. Puddings, rolls, ice cream, waffles, cream puffs, as well as Japanese sweets. Contains about 50 items.",
    description_jpn:
      "全国の有名スイーツと交換できるカード。プリン、ロールケーキ、アイス、ワッフル、シュークリームのほか、和菓子なども。約50アイテムを掲載。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Itochu.png",
  },
  {
    id: "752",
    brand: "Itochu",
    sku: "OTY3675",
    product_eng: "Itochu Digital Gift - Gourmet Digital Gift 36",
    product_jpn: "お取り寄せグルメ  デジタルギフト 36",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥3,675",
    rrp_with_vat: "¥3,308",
    description_eng:
      "This card can be exchanged for delicious gourmet foods from all over Japan. More than 60 items such as meat, fish, regional specialties, and famous store products are available for customers to choose from.",
    description_jpn:
      "全国のおいしいグルメと交換できるカード。お肉やお魚、地域特産品や名店商品など約60アイテム以上を掲載お客様のお好みに合わせてお選びいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Itochu.png",
  },
  {
    id: "753",
    brand: "Itochu",
    sku: "OTY5250",
    product_eng: "Itochu Digital Gift - Gourmet Digital Gift 52",
    product_jpn: "お取り寄せグルメ  デジタルギフト 52",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥5,250",
    rrp_with_vat: "¥4,725",
    description_eng:
      "This card can be exchanged for delicious gourmet foods from all over Japan. More than 60 items such as meat, fish, regional specialties, and famous store products are available for customers to choose from.",
    description_jpn:
      "全国のおいしいグルメと交換できるカード。お肉やお魚、地域特産品や名店商品など約60アイテム以上を掲載お客様のお好みに合わせてお選びいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Itochu.png",
  },
  {
    id: "754",
    brand: "Itochu",
    sku: "YOO3000",
    product_eng: "Itochu Digital Gift - Choice of Delicious Rice Digital Gift",
    product_jpn: "選べる美味しいお米  デジタルギフト",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥2,700",
    description_eng:
      "We have carefully selected products from the most famous rice-producing regions in Japan. You can exchange them for a variety of rice such as Koshihikari from Niigata Prefecture and Tsuyahime from Yamagata Prefecture.",
    description_jpn:
      "全国の米どころから商品を厳選しました。新潟県産こしひかりや山形県産つや姫など様々な米と交換できます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Itochu.png",
  },
  {
    id: "755",
    brand: "Itochu",
    sku: "FRT5500",
    product_eng: "Itochu Digital Gift - Choice of Fruits Digital Gift 55",
    product_jpn: "選べるフルーツ  デジタルギフト55",
    category_1: "Gift Card",
    category_2: "Food/Drink",
    rrp_ex_vat: "¥5,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      "You can choose from a variety of fruits grown in Japan's famous production areas. Melons, watermelons, cherries, peaches, and other fruits from all over Japan will be delivered to you during the delicious harvest season.",
    description_jpn:
      "愛情たっぷりに育てられたとっておきのフルーツをお好みで選んで頂けます。 メロン、スイカ、さくらんぼ、桃など、日本全国各地のフルーツをおいしい収穫の時期にお届け致します。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Itochu.png",
  },
  {
    id: "756",
    brand: "Itochu",
    sku: "FRT11000",
    product_eng: "Itochu Digital Gift - Choice of Fruits Digital Gift 110",
    product_jpn: "選べるフルーツ  デジタルギフト110",
    category_1: "Gift Card",
    category_2: "Food/Drink",
    rrp_ex_vat: "¥11,000",
    rrp_with_vat: "¥9,900",
    description_eng:
      "You can choose from a variety of fruits grown in Japan's famous production areas. Melons, watermelons, cherries, peaches, and other fruits from all over Japan will be delivered to you during the delicious harvest season.",
    description_jpn:
      "愛情たっぷりに育てられたとっておきのフルーツをお好みで選んで頂けます。 メロン、スイカ、さくらんぼ、桃など、日本全国各地のフルーツをおいしい収穫の時期にお届け致します。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Itochu.png",
  },
  {
    id: "757",
    brand: "Ringbell",
    sku: "RIN5800",
    product_eng: "Ringbell Web Catalog - Presentage web catalog gift-VIOLA",
    product_jpn: "リンベル webカタログギフト プレゼンテージ ビオラ",
    category_1: "Gift Card",
    category_2: "Online catalogue gift",
    rrp_ex_vat: "¥6,380",
    rrp_with_vat: "¥6,193",
    description_eng:
      "Presentage catalog gifts offer a diverse lineup of general merchandise and gourmet foods in one catalog. We will send you an e-mail with a URL and ID to view the web catalog. You can also place your order online.",
    description_jpn:
      "雑貨とグルメを1冊にまとめた、多彩なラインナップを誇る「プレゼンテージ」webカタログギフト。 こちらはメールにてwebカタログを見られるURLとIDをお送り致します。ご発注もweb上にて承ります。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/ringbell.png",
  },
  {
    id: "758",
    brand: "Ringbell",
    sku: "RIN8800",
    product_eng: "Ringbell Web Catalog - Presentage web catalog gift-SYMPHONY",
    product_jpn: "リンベル webカタログギフトプレゼンテージ シンフォニー",
    category_1: "Gift Card",
    category_2: "Online catalogue gift",
    rrp_ex_vat: "¥9,680",
    rrp_with_vat: "¥8,998",
    description_eng:
      "Presentage catalog gifts offer a diverse lineup of general merchandise and gourmet foods in one catalog. We will send you an e-mail with a URL and ID to view the web catalog. You can also place your order online.",
    description_jpn:
      "雑貨とグルメを1冊にまとめた、多彩なラインナップを誇る「プレゼンテージ」webカタログギフト。 こちらはメールにてwebカタログを見られるURLとIDをお送り致します。ご発注もweb上にて承ります。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/ringbell.png",
  },
  {
    id: "759",
    brand: "Ringbell",
    sku: "RIN5000",
    product_eng: "Ringbell Web Catalog - Domestic Beef web catalog gift-Kensho",
    product_jpn: "リンベル webカタログギフト 選べる国産和牛 健勝",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥5,500",
    rrp_with_vat: "¥4,675",
    description_eng:
      "This is a web catalog gift dedicated to Japanese Wagyu beef that lists Matsusaka beef, Yonezawa beef, and other famous brands of beef recommended by Ringbell according to how they are eaten, such as sukiyaki, shabu-shabu, yakiniku, and steak. You will receive a URL and ID to view the web catalog by e-mail. You can also place your order on the web.",
    description_jpn:
      "〈松阪牛〉〈米沢牛〉をはじめとするリンベルお奨めの名だたる銘柄牛を、「すきやき」「しゃぶしゃぶ」「焼肉」「ステーキ」といった食べ方別に掲載した国産和牛専用webカタログギフト。 こちらはメールにてwebカタログを見られるURLとIDをお送り致します。ご発注もweb上にて承ります。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/ringbell.png",
  },
  {
    id: "760",
    brand: "Ringbell",
    sku: "RIN10000",
    product_eng: "Ringbell Web Catalog - Domestic Beef web catalog gift-Hatsuratsu",
    product_jpn: "リンベル webカタログギフト 選べる国産和牛 溌剌",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥11,000",
    rrp_with_vat: "¥9,350",
    description_eng:
      "This is a web catalog gift dedicated to Japanese Wagyu beef that lists Matsusaka beef, Yonezawa beef, and other famous brands of beef recommended by Ringbell according to how they are eaten, such as sukiyaki, shabu-shabu, yakiniku, and steak. You will receive a URL and ID to view the web catalog by e-mail. You can also place your order on the web.",
    description_jpn:
      "〈松阪牛〉〈米沢牛〉をはじめとするリンベルお奨めの名だたる銘柄牛を、「すきやき」「しゃぶしゃぶ」「焼肉」「ステーキ」といった食べ方別に掲載した国産和牛専用webカタログギフト。 こちらはメールにてwebカタログを見られるURLとIDをお送り致します。ご発注もweb上にて承ります。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/ringbell.png",
  },
  {
    id: "761",
    brand: "Ringbell",
    sku: "RIN20000",
    product_eng: "Ringbell Web Catalog - Domestic Beef web catalog gift-Enjyu",
    product_jpn: "リンベル webカタログギフト 選べる国産和牛 延壽",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥22,000",
    rrp_with_vat: "¥18,700",
    description_eng:
      "This is a web catalog gift dedicated to Japanese Wagyu beef that lists Matsusaka beef, Yonezawa beef, and other famous brands of beef recommended by Ringbell according to how they are eaten, such as sukiyaki, shabu-shabu, yakiniku, and steak. You will receive a URL and ID to view the web catalog by e-mail. You can also place your order on the web.",
    description_jpn:
      "〈松阪牛〉〈米沢牛〉をはじめとするリンベルお奨めの名だたる銘柄牛を、「すきやき」「しゃぶしゃぶ」「焼肉」「ステーキ」といった食べ方別に掲載した国産和牛専用webカタログギフト。 こちらはメールにてwebカタログを見られるURLとIDをお送り致します。ご発注もweb上にて承ります。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/ringbell.png",
  },
  {
    id: "762",
    brand: "Ringbell",
    sku: "RIN30000",
    product_eng: "Ringbell Web Catalog - Domestic Beef web catalog gift-Fukuroku",
    product_jpn: "リンベル webカタログギフト 選べる国産和牛 福禄",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥33,000",
    rrp_with_vat: "¥28,050",
    description_eng:
      "This is a web catalog gift dedicated to Japanese Wagyu beef that lists Matsusaka beef, Yonezawa beef, and other famous brands of beef recommended by Ringbell according to how they are eaten, such as sukiyaki, shabu-shabu, yakiniku, and steak. You will receive a URL and ID to view the web catalog by e-mail. You can also place your order on the web.",
    description_jpn:
      "〈松阪牛〉〈米沢牛〉をはじめとするリンベルお奨めの名だたる銘柄牛を、「すきやき」「しゃぶしゃぶ」「焼肉」「ステーキ」といった食べ方別に掲載した国産和牛専用webカタログギフト。 こちらはメールにてwebカタログを見られるURLとIDをお送り致します。ご発注もweb上にて承ります。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/ringbell.png",
  },
  {
    id: "763",
    brand: "Ringbell",
    sku: "RINC3500",
    product_eng: "Ringbell Web Catalog - 47CLUB web catalog-Mori",
    product_jpn: "リンベル webグルメカタログギフト 47CLUB 森",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥3,850",
    rrp_with_vat: "¥3,273",
    description_eng:
      "Local newspapers in 47 prefectures recommend really delicious local food! We will send you an e-mail with a URL and ID to view the web catalog. You can also place your order online.",
    description_jpn:
      "47都道府県の地方新聞社がお薦めする“地元”の本当においしいものをお届け！ こちらはメールにてwebカタログを見られるURLとIDをお送り致します。ご発注もweb上にて承ります。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/ringbell.png",
  },
  {
    id: "764",
    brand: "Ringbell",
    sku: "RINC5000",
    product_eng: "Ringbell Web Catalog - 47CLUB web catalog-Michi",
    product_jpn: "リンベル webグルメカタログギフト 47CLUB 路",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥5,500",
    rrp_with_vat: "¥4,675",
    description_eng:
      "Local newspapers in 47 prefectures recommend really delicious local food! We will send you an e-mail with a URL and ID to view the web catalog. You can also place your order online.",
    description_jpn:
      "47都道府県の地方新聞社がお薦めする“地元”の本当においしいものをお届け！ こちらはメールにてwebカタログを見られるURLとIDをお送り致します。ご発注もweb上にて承ります。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/ringbell.png",
  },
  {
    id: "765",
    brand: "Ringbell",
    sku: "RINC10000",
    product_eng: "Ringbell Web Catalog - 47CLUB web catalog-Sato",
    product_jpn: "リンベル webグルメカタログギフト 47CLUB 郷",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥11,000",
    rrp_with_vat: "¥9,350",
    description_eng:
      "Local newspapers in 47 prefectures recommend really delicious local food! We will send you an e-mail with a URL and ID to view the web catalog. You can also place your order online.",
    description_jpn:
      "47都道府県の地方新聞社がお薦めする“地元”の本当においしいものをお届け！ こちらはメールにてwebカタログを見られるURLとIDをお送り致します。ご発注もweb上にて承ります。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/ringbell.png",
  },
  {
    id: "766",
    brand: "Uber Eats",
    sku: "UE500",
    product_eng: "Uber Eats Gift Code 500 yen",
    product_jpn: "Uber Eats ギフトカード 500円分",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥500",
    rrp_with_vat: "¥490",
    description_eng: "A gift card redeemable on the Uber Eats app or website.",
    description_jpn:
      "Uber Eats のアプリまたはウェブサイト上で使用可能なギフトカードです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-eats.png",
  },
  {
    id: "767",
    brand: "Uber Eats",
    sku: "UE1000",
    product_eng: "Uber Eats Gift Code 1000 yen",
    product_jpn: "Uber Eats ギフトカード 1000円分",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥980",
    description_eng: "A gift card redeemable on the Uber Eats app or website.",
    description_jpn:
      "Uber Eats のアプリまたはウェブサイト上で使用可能なギフトカードです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-eats.png",
  },
  {
    id: "768",
    brand: "Uber Eats",
    sku: "UE2000",
    product_eng: "Uber Eats Gift Code 2000 yen",
    product_jpn: "Uber Eats ギフトカード 2000円分",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥1,960",
    description_eng: "A gift card redeemable on the Uber Eats app or website.",
    description_jpn:
      "Uber Eats のアプリまたはウェブサイト上で使用可能なギフトカードです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-eats.png",
  },
  {
    id: "769",
    brand: "Uber Eats",
    sku: "UE3000",
    product_eng: "Uber Eats Gift Code 3000 yen",
    product_jpn: "Uber Eats ギフトカード 3000円分",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥2,940",
    description_eng: "A gift card redeemable on the Uber Eats app or website.",
    description_jpn:
      "Uber Eats のアプリまたはウェブサイト上で使用可能なギフトカードです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-eats.png",
  },
  {
    id: "770",
    brand: "Uber Eats",
    sku: "UE5000",
    product_eng: "Uber Eats Gift Code 5000 yen",
    product_jpn: "Uber Eats ギフトカード 5000円分",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥4,900",
    description_eng: "A gift card redeemable on the Uber Eats app or website.",
    description_jpn:
      "Uber Eats のアプリまたはウェブサイト上で使用可能なギフトカードです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-eats.png",
  },
  {
    id: "771",
    brand: "Uber Eats",
    sku: "UE10000",
    product_eng: "Uber Eats Gift Code 10000 yen",
    product_jpn: "Uber Eats ギフトカード 10000円分",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥9,800",
    description_eng: "A gift card redeemable on the Uber Eats app or website.",
    description_jpn:
      "Uber Eats のアプリまたはウェブサイト上で使用可能なギフトカードです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-eats.png",
  },
  {
    id: "772",
    brand: "Uber Eats",
    sku: "UE30000",
    product_eng: "Uber Eats Gift Code 30000 yen",
    product_jpn: "Uber Eats ギフトカード 30000円分",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥30,000",
    rrp_with_vat: "¥29,400",
    description_eng: "A gift card redeemable on the Uber Eats app or website.",
    description_jpn:
      "Uber Eats のアプリまたはウェブサイト上で使用可能なギフトカードです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-eats.png",
  },
  {
    id: "773",
    brand: "Uber Taxi",
    sku: "UT500",
    product_eng: "Uber Taxi Gift Code 500yen",
    product_jpn: "Uber Taxi ギフトカード 500円分",
    category_1: "Gift Card",
    category_2: "Taxi",
    rrp_ex_vat: "¥500",
    rrp_with_vat: "¥490",
    description_eng:
      "This gift card is  recharged to the Uber app. The Uber app is a dispatch service that allows you to easily call an Uber Taxi (cab), Uber Black (premium), or Black VAN (premium minivan).",
    description_jpn:
      "Uberアプリにチャージできるギフトカードです。 Uberアプリは、簡単にUber Taxi（タクシー）、Uber Black（プレミアム）、Black VAN（プレミアムミニバン）を呼べる配車サービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-rides.png",
  },
  {
    id: "774",
    brand: "Uber Taxi",
    sku: "UT1000",
    product_eng: "Uber Taxi Gift Code 1000yen",
    product_jpn: "Uber Taxi ギフトカード 1000円分",
    category_1: "Gift Card",
    category_2: "Taxi",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥980",
    description_eng:
      "This gift card is  recharged to the Uber app. The Uber app is a dispatch service that allows you to easily call an Uber Taxi (cab), Uber Black (premium), or Black VAN (premium minivan).",
    description_jpn:
      "Uberアプリにチャージできるギフトカードです。 Uberアプリは、簡単にUber Taxi（タクシー）、Uber Black（プレミアム）、Black VAN（プレミアムミニバン）を呼べる配車サービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-rides.png",
  },
  {
    id: "775",
    brand: "Uber Taxi",
    sku: "UT2000",
    product_eng: "Uber Taxi Gift Code 2000yen",
    product_jpn: "Uber Taxi ギフトカード 2000円分",
    category_1: "Gift Card",
    category_2: "Taxi",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥1,960",
    description_eng:
      "This gift card is  recharged to the Uber app. The Uber app is a dispatch service that allows you to easily call an Uber Taxi (cab), Uber Black (premium), or Black VAN (premium minivan).",
    description_jpn:
      "Uberアプリにチャージできるギフトカードです。 Uberアプリは、簡単にUber Taxi（タクシー）、Uber Black（プレミアム）、Black VAN（プレミアムミニバン）を呼べる配車サービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-rides.png",
  },
  {
    id: "776",
    brand: "Uber Taxi",
    sku: "UT3000",
    product_eng: "Uber Taxi Gift Code 3000yen",
    product_jpn: "Uber Taxi ギフトカード 3000円分",
    category_1: "Gift Card",
    category_2: "Taxi",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥2,940",
    description_eng:
      "This gift card is  recharged to the Uber app. The Uber app is a dispatch service that allows you to easily call an Uber Taxi (cab), Uber Black (premium), or Black VAN (premium minivan).",
    description_jpn:
      "Uberアプリにチャージできるギフトカードです。 Uberアプリは、簡単にUber Taxi（タクシー）、Uber Black（プレミアム）、Black VAN（プレミアムミニバン）を呼べる配車サービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-rides.png",
  },
  {
    id: "777",
    brand: "Uber Taxi",
    sku: "UT5000",
    product_eng: "Uber Taxi Gift Code 5000yen",
    product_jpn: "Uber Taxi ギフトカード 5000円分",
    category_1: "Gift Card",
    category_2: "Taxi",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥4,900",
    description_eng:
      "This gift card is  recharged to the Uber app. The Uber app is a dispatch service that allows you to easily call an Uber Taxi (cab), Uber Black (premium), or Black VAN (premium minivan).",
    description_jpn:
      "Uberアプリにチャージできるギフトカードです。 Uberアプリは、簡単にUber Taxi（タクシー）、Uber Black（プレミアム）、Black VAN（プレミアムミニバン）を呼べる配車サービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-rides.png",
  },
  {
    id: "778",
    brand: "Uber Taxi",
    sku: "UT10000",
    product_eng: "Uber Taxi Gift Code 10000yen",
    product_jpn: "Uber Taxi ギフトカード 10000円分",
    category_1: "Gift Card",
    category_2: "Taxi",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥9,800",
    description_eng:
      "This gift card is  recharged to the Uber app. The Uber app is a dispatch service that allows you to easily call an Uber Taxi (cab), Uber Black (premium), or Black VAN (premium minivan).",
    description_jpn:
      "Uberアプリにチャージできるギフトカードです。 Uberアプリは、簡単にUber Taxi（タクシー）、Uber Black（プレミアム）、Black VAN（プレミアムミニバン）を呼べる配車サービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-rides.png",
  },
  {
    id: "779",
    brand: "Uber Taxi",
    sku: "UT30000",
    product_eng: "Uber Taxi Gift Code 30000yen",
    product_jpn: "Uber Taxi ギフトカード 30000円分",
    category_1: "Gift Card",
    category_2: "Taxi",
    rrp_ex_vat: "¥30,000",
    rrp_with_vat: "¥29,400",
    description_eng:
      "This gift card is  recharged to the Uber app. The Uber app is a dispatch service that allows you to easily call an Uber Taxi (cab), Uber Black (premium), or Black VAN (premium minivan).",
    description_jpn:
      "Uberアプリにチャージできるギフトカードです。 Uberアプリは、簡単にUber Taxi（タクシー）、Uber Black（プレミアム）、Black VAN（プレミアムミニバン）を呼べる配車サービスです。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/uber-rides.png",
  },
  {
    id: "780",
    brand: "Disney+",
    sku: "DN990",
    product_eng: "Disney+ Gift Card (1 month ticket)",
    product_jpn: "ディズニープラス デジタルギフトカード (1か月券)",
    category_1: "Gift Card",
    category_2: "Subscription",
    rrp_ex_vat: "¥990",
    rrp_with_vat: "¥960",
    description_eng:
      "This gift code can be used when signing up for a new Disney Plus membership. Once you complete your registration, you will be able to enjoy your Disney Plus subscription for the monthly subscription purchased.",
    description_jpn:
      "ディズニープラスの新規会員登録時にご使用をいただけるギフトコードです。 ご登録を完了いただくと、ご購入いただいた月額分のディズニープラスのサブスクリプションをお楽しみいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/disney.png",
  },
  {
    id: "781",
    brand: "Disney+",
    sku: "DN2970",
    product_eng: "Disney+ Gift Card (3 month ticket)",
    product_jpn: "ディズニープラス デジタルギフトカード (3か月券)",
    category_1: "Gift Card",
    category_2: "Subscription",
    rrp_ex_vat: "¥2,970",
    rrp_with_vat: "¥2,881",
    description_eng:
      "This gift code can be used when signing up for a new Disney Plus membership. Once you complete your registration, you will be able to enjoy your Disney Plus subscription for the monthly subscription purchased.",
    description_jpn:
      "ディズニープラスの新規会員登録時にご使用をいただけるギフトコードです。 ご登録を完了いただくと、ご購入いただいた月額分のディズニープラスのサブスクリプションをお楽しみいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/disney.png",
  },
  {
    id: "782",
    brand: "Disney+",
    sku: "DN5940",
    product_eng: "Disney+ Gift Card (6 month ticket)",
    product_jpn: "ディズニープラス デジタルギフトカード (6か月券)",
    category_1: "Gift Card",
    category_2: "Subscription",
    rrp_ex_vat: "¥5,940",
    rrp_with_vat: "¥5,762",
    description_eng:
      "This gift code can be used when signing up for a new Disney Plus membership. Once you complete your registration, you will be able to enjoy your Disney Plus subscription for the monthly subscription purchased.",
    description_jpn:
      "ディズニープラスの新規会員登録時にご使用をいただけるギフトコードです。 ご登録を完了いただくと、ご購入いただいた月額分のディズニープラスのサブスクリプションをお楽しみいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/disney.png",
  },
  {
    id: "783",
    brand: "Disney+",
    sku: "DN9900",
    product_eng: "Disney+ Gift Card (12 month ticket)",
    product_jpn: "ディズニープラス デジタルギフトカード (12か月券)",
    category_1: "Gift Card",
    category_2: "Subscription",
    rrp_ex_vat: "¥9,900",
    rrp_with_vat: "¥9,603",
    description_eng:
      "This gift code can be used when signing up for a new Disney Plus membership. Once you complete your registration, you will be able to enjoy your Disney Plus subscription for the monthly subscription purchased.",
    description_jpn:
      "ディズニープラスの新規会員登録時にご使用をいただけるギフトコードです。 ご登録を完了いただくと、ご購入いただいた月額分のディズニープラスのサブスクリプションをお楽しみいただけます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/disney.png",
  },
  {
    id: "784",
    brand: "Rakuten",
    sku: "RT500",
    product_eng: "Rakuten Gift Point Code 500 points",
    product_jpn: "楽天ポイントギフトコード 500ポイント",
    category_1: "Gift Card",
    category_2: "points exchange",
    rrp_ex_vat: "¥500",
    rrp_with_vat: "¥775",
    description_eng:
      "You can use it to make payments at Rakuten Ichiba and Rakuten Pay App merchants.",
    description_jpn:
      "楽天市場や楽天ペイアプリ加盟店でのお支払いなどでご利用いただけ ます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rakuten.png",
  },
  {
    id: "785",
    brand: "Rakuten",
    sku: "RT1000",
    product_eng: "Rakuten Gift Point Code 1000 points",
    product_jpn: "楽天ポイントギフトコード 1,000ポイント",
    category_1: "Gift Card",
    category_2: "points exchange",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥1,550",
    description_eng:
      "You can use it to make payments at Rakuten Ichiba and Rakuten Pay App merchants.",
    description_jpn:
      "楽天市場や楽天ペイアプリ加盟店でのお支払いなどでご利用いただけ ます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rakuten.png",
  },
  {
    id: "786",
    brand: "Rakuten",
    sku: "RT3000",
    product_eng: "Rakuten Gift Point Code 3000 points",
    product_jpn: "楽天ポイント ギフトコード3,000ポイント",
    category_1: "Gift Card",
    category_2: "points exchange",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥4,650",
    description_eng:
      "You can use it to make payments at Rakuten Ichiba and Rakuten Pay App merchants.",
    description_jpn:
      "楽天市場や楽天ペイアプリ加盟店でのお支払いなどでご利用いただけ ます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rakuten.png",
  },
  {
    id: "787",
    brand: "Rakuten",
    sku: "RT5000",
    product_eng: "Rakuten Gift Point Code 5000 points",
    product_jpn: "楽天ポイント ギフトコード5,000ポイント",
    category_1: "Gift Card",
    category_2: "points exchange",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥7,750",
    description_eng:
      "You can use it to make payments at Rakuten Ichiba and Rakuten Pay App merchants.",
    description_jpn:
      "楽天市場や楽天ペイアプリ加盟店でのお支払いなどでご利用いただけ ます。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/rakuten.png",
  },
  {
    id: "788",
    brand: "Demaekan",
    sku: "DK100",
    product_eng: "Demaecan Digital Coupon (100Yen)",
    product_jpn: "出前館クーポン（100円）",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥100",
    rrp_with_vat: "¥98",
    description_eng:
      "One of the largest food delivery sites in Japan, Delivery Kan. We offer a wide range of products from meals to daily necessities from over 100,000 stores",
    description_jpn:
      "国内最大級のフードデリバリーサイト「出前館」 約100,000店舗以上の店舗からお食事から日用品まで幅広く取り揃えております。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Demaecan.png",
  },
  {
    id: "789",
    brand: "Demaekan",
    sku: "DK500",
    product_eng: "Demaecan Digital Coupon (500Yen)",
    product_jpn: "出前館クーポン（500円）",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥500",
    rrp_with_vat: "¥490",
    description_eng:
      "One of the largest food delivery sites in Japan, Delivery Kan. We offer a wide range of products from meals to daily necessities from over 100,000 stores",
    description_jpn:
      "国内最大級のフードデリバリーサイト「出前館」 約100,000店舗以上の店舗からお食事から日用品まで幅広く取り揃えております。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Demaecan.png",
  },
  {
    id: "790",
    brand: "Demaekan",
    sku: "DK1000",
    product_eng: "Demaecan Digital Coupon (1000Yen)",
    product_jpn: "出前館クーポン（1000円）",
    category_1: "Gift Card",
    category_2: "Gourmet ",
    rrp_ex_vat: "¥1,000",
    rrp_with_vat: "¥980",
    description_eng:
      "One of the largest food delivery sites in Japan, Delivery Kan. We offer a wide range of products from meals to daily necessities from over 100,000 stores",
    description_jpn:
      "国内最大級のフードデリバリーサイト「出前館」 約100,000店舗以上の店舗からお食事から日用品まで幅広く取り揃えております。",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Demaecan.png",
  },
  {
    id: "791",
    brand: "Yogibo",
    sku: "MAX-DG",
    product_eng: "Yogibo Max Dark Gray",
    product_jpn: "Yogibo Max(ヨギボー マックス) ダークグレー",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥29,900",
    rrp_with_vat: "¥32,890",
    description_eng:
      "Not only a sofa, but also a chair or a bed. The No. 1 sofa that fulfills all your needs. A mysterious beaded sofa that fits perfectly to your body; it can also be used as a 3-seater sofa.  <Product Information> Cover 89% cotton / 11% polyurethane Inner cover 87% polyester, 13% polyurethane Filler EPS (Expanded polystyrene) beads Removable cover Height approx. 170cm Width approx. 65 cm Depth approx. 55 cm Weight approx. 8.5 kg Volume: approx. 415L Dimensions are approximate and subject to individual variations. Measurements are taken with the product lying on the floor.  <Caution> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2.Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "ソファはもちろん椅子やベッドにも。あなたの要望を全て叶えるNo.1ソファ。 完全に体にフィットする不思議なビーズソファ。3人掛けのソファにもなります。 <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填剤  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約170cm 幅  約65cm 奥行き  約55cm 重量  約8.5kg 体積  約415L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_MAX-DG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "792",
    brand: "Yogibo",
    sku: "MAX-LG",
    product_eng: "Yogibo Max Light Gray",
    product_jpn: "Yogibo Max(ヨギボー マックス) ライトグレー",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥29,900",
    rrp_with_vat: "¥32,890",
    description_eng:
      "Not only a sofa, but also a chair or a bed. The No. 1 sofa that fulfills all your needs. A mysterious beaded sofa that fits perfectly to your body; it can also be used as a 3-seater sofa.  <Product Information> Cover 89% cotton / 11% polyurethane Inner cover 87% polyester, 13% polyurethane Filler EPS (Expanded polystyrene) beads Removable cover Height approx. 170cm Width approx. 65 cm Depth approx. 55 cm Weight approx. 8.5 kg Volume: approx. 415L Dimensions are approximate and subject to individual variations. Measurements are taken with the product lying on the floor.  <Caution> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2.Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "ソファはもちろん椅子やベッドにも。あなたの要望を全て叶えるNo.1ソファ。 完全に体にフィットする不思議なビーズソファ。3人掛けのソファにもなります。 <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填剤  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約170cm 幅  約65cm 奥行き  約55cm 重量  約8.5kg 体積  約415L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_MAX-LG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "793",
    brand: "Yogibo",
    sku: "MAX-GR",
    product_eng: "Yogibo Max Lime Green",
    product_jpn: "Yogibo Max(ヨギボー マックス) ライムグリーン",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥29,900",
    rrp_with_vat: "¥32,890",
    description_eng:
      "Not only a sofa, but also a chair or a bed. The No. 1 sofa that fulfills all your needs. A mysterious beaded sofa that fits perfectly to your body; it can also be used as a 3-seater sofa.  <Product Information> Cover 89% cotton / 11% polyurethane Inner cover 87% polyester, 13% polyurethane Filler EPS (Expanded polystyrene) beads Removable cover Height approx. 170cm Width approx. 65 cm Depth approx. 55 cm Weight approx. 8.5 kg Volume: approx. 415L Dimensions are approximate and subject to individual variations. Measurements are taken with the product lying on the floor.  <Caution> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2.Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "ソファはもちろん椅子やベッドにも。あなたの要望を全て叶えるNo.1ソファ。 完全に体にフィットする不思議なビーズソファ。3人掛けのソファにもなります。 <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填剤  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約170cm 幅  約65cm 奥行き  約55cm 重量  約8.5kg 体積  約415L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_MAX-GR.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "794",
    brand: "Yogibo",
    sku: "MAX-CB",
    product_eng: "Yogibo Max Chocolate Brown ",
    product_jpn: "Yogibo Max(ヨギボー マックス) チョコレートブラウン ",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥29,900",
    rrp_with_vat: "¥32,890",
    description_eng:
      "Not only a sofa, but also a chair or a bed. The No. 1 sofa that fulfills all your needs. A mysterious beaded sofa that fits perfectly to your body; it can also be used as a 3-seater sofa.  <Product Information> Cover 89% cotton / 11% polyurethane Inner cover 87% polyester, 13% polyurethane Filler EPS (Expanded polystyrene) beads Removable cover Height approx. 170cm Width approx. 65 cm Depth approx. 55 cm Weight approx. 8.5 kg Volume: approx. 415L Dimensions are approximate and subject to individual variations. Measurements are taken with the product lying on the floor.  <Caution> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2.Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "ソファはもちろん椅子やベッドにも。あなたの要望を全て叶えるNo.1ソファ。 完全に体にフィットする不思議なビーズソファ。3人掛けのソファにもなります。 <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填剤  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約170cm 幅  約65cm 奥行き  約55cm 重量  約8.5kg 体積  約415L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_MAX-CB.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "795",
    brand: "Yogibo",
    sku: "MAX-OG",
    product_eng: "Yogibo Max Orange",
    product_jpn: "Yogibo Max(ヨギボー マックス) オレンジ",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥29,900",
    rrp_with_vat: "¥32,890",
    description_eng:
      "Not only a sofa, but also a chair or a bed. The No. 1 sofa that fulfills all your needs. A mysterious beaded sofa that fits perfectly to your body; it can also be used as a 3-seater sofa.  <Product Information> Cover 89% cotton / 11% polyurethane Inner cover 87% polyester, 13% polyurethane Filler EPS (Expanded polystyrene) beads Removable cover Height approx. 170cm Width approx. 65 cm Depth approx. 55 cm Weight approx. 8.5 kg Volume: approx. 415L Dimensions are approximate and subject to individual variations. Measurements are taken with the product lying on the floor.  <Caution> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2.Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "ソファはもちろん椅子やベッドにも。あなたの要望を全て叶えるNo.1ソファ。 完全に体にフィットする不思議なビーズソファ。3人掛けのソファにもなります。 <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填剤  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約170cm 幅  約65cm 奥行き  約55cm 重量  約8.5kg 体積  約415L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_MAX-OG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "801",
    brand: "Yogibo",
    sku: "MIN-DG",
    product_eng: "Yogibo Mini Dark Gray",
    product_jpn: "Yogibo Mini(ヨギボー ミニ) ダークグレー",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥29,900",
    rrp_with_vat: "¥32,890",
    description_eng:
      "Relax with a personal-sized Yogibo  Yogibo Mini is a a beaded sofa that can be a one-person chair or sofa. Welcome Yogibo into your child's room or into your one-person home! When combined with Yogibo support (sold separately), it becomes a sofa with backrest and armrests!  <Product Information> Cover 89% cotton, 11% polyurethane Inner cover 87% polyester, 13% polyurethane Filling material: EPS (Expanded polystyrene foam) beads Removable cover Height approx. 95cm Width approx. 65cm Depth approx. 55cm Weight approx. 4.4 kg Volume: approx. 212L Dimensions are approximate and subject to individual variation. Measurements are taken with the product lying on the floor.  <Caution> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2. Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "パーソナルサイズのYogiboでリラックス  Yogibo Mini（ヨギボーミニ）は 一人用のチェアやソファになるビーズソファ。 子供部屋や、一人暮らしの家にもYogiboを迎えましょう！ Yogibo support(別売)と組み合わせると、背もたれや肘置き付きのソファに！  <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填材  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約95cm 幅  約65cm 奥行き  約55cm 重さ  約4.4kg 体積  約212L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_MIN-DG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "802",
    brand: "Yogibo",
    sku: "MIN-LG",
    product_eng: "Yogibo Mini Light Gray",
    product_jpn: "Yogibo Mini(ヨギボー ミニ) ライトグレー",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥29,900",
    rrp_with_vat: "¥32,890",
    description_eng:
      "Relax with a personal-sized Yogibo  Yogibo Mini is a a beaded sofa that can be a one-person chair or sofa. Welcome Yogibo into your child's room or into your one-person home! When combined with Yogibo support (sold separately), it becomes a sofa with backrest and armrests!  <Product Information> Cover 89% cotton, 11% polyurethane Inner cover 87% polyester, 13% polyurethane Filling material: EPS (Expanded polystyrene foam) beads Removable cover Height approx. 95cm Width approx. 65cm Depth approx. 55cm Weight approx. 4.4 kg Volume: approx. 212L Dimensions are approximate and subject to individual variation. Measurements are taken with the product lying on the floor.  <Caution> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2. Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "パーソナルサイズのYogiboでリラックス  Yogibo Mini（ヨギボーミニ）は 一人用のチェアやソファになるビーズソファ。 子供部屋や、一人暮らしの家にもYogiboを迎えましょう！ Yogibo support(別売)と組み合わせると、背もたれや肘置き付きのソファに！  <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填材  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約95cm 幅  約65cm 奥行き  約55cm 重さ  約4.4kg 体積  約212L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_MIN-LG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "803",
    brand: "Yogibo",
    sku: "MIN-GR",
    product_eng: "Yogibo Mini Lime Green",
    product_jpn: "Yogibo Mini(ヨギボー ミニ) ライムグリーン",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥29,900",
    rrp_with_vat: "¥32,890",
    description_eng:
      "Relax with a personal-sized Yogibo  Yogibo Mini is a a beaded sofa that can be a one-person chair or sofa. Welcome Yogibo into your child's room or into your one-person home! When combined with Yogibo support (sold separately), it becomes a sofa with backrest and armrests!  <Product Information> Cover 89% cotton, 11% polyurethane Inner cover 87% polyester, 13% polyurethane Filling material: EPS (Expanded polystyrene foam) beads Removable cover Height approx. 95cm Width approx. 65cm Depth approx. 55cm Weight approx. 4.4 kg Volume: approx. 212L Dimensions are approximate and subject to individual variation. Measurements are taken with the product lying on the floor.  <Caution> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2. Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "パーソナルサイズのYogiboでリラックス  Yogibo Mini（ヨギボーミニ）は 一人用のチェアやソファになるビーズソファ。 子供部屋や、一人暮らしの家にもYogiboを迎えましょう！ Yogibo support(別売)と組み合わせると、背もたれや肘置き付きのソファに！  <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填材  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約95cm 幅  約65cm 奥行き  約55cm 重さ  約4.4kg 体積  約212L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_MIN-GR.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "804",
    brand: "Yogibo",
    sku: "MIN-CB",
    product_eng: "Yogibo Mini Chocolate Brown ",
    product_jpn: "Yogibo Mini(ヨギボー ミニ) チョコレートブラウン ",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥29,900",
    rrp_with_vat: "¥32,890",
    description_eng:
      "Relax with a personal-sized Yogibo  Yogibo Mini is a a beaded sofa that can be a one-person chair or sofa. Welcome Yogibo into your child's room or into your one-person home! When combined with Yogibo support (sold separately), it becomes a sofa with backrest and armrests!  <Product Information> Cover 89% cotton, 11% polyurethane Inner cover 87% polyester, 13% polyurethane Filling material: EPS (Expanded polystyrene foam) beads Removable cover Height approx. 95cm Width approx. 65cm Depth approx. 55cm Weight approx. 4.4 kg Volume: approx. 212L Dimensions are approximate and subject to individual variation. Measurements are taken with the product lying on the floor.  <Caution> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2. Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "パーソナルサイズのYogiboでリラックス  Yogibo Mini（ヨギボーミニ）は 一人用のチェアやソファになるビーズソファ。 子供部屋や、一人暮らしの家にもYogiboを迎えましょう！ Yogibo support(別売)と組み合わせると、背もたれや肘置き付きのソファに！  <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填材  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約95cm 幅  約65cm 奥行き  約55cm 重さ  約4.4kg 体積  約212L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_MIN-CB.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "805",
    brand: "Yogibo",
    sku: "MIN-OG",
    product_eng: "Yogibo Mini Orange",
    product_jpn: "Yogibo Mini(ヨギボー ミニ) オレンジ",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥29,900",
    rrp_with_vat: "¥32,890",
    description_eng:
      "Relax with a personal-sized Yogibo  Yogibo Mini is a a beaded sofa that can be a one-person chair or sofa. Welcome Yogibo into your child's room or into your one-person home! When combined with Yogibo support (sold separately), it becomes a sofa with backrest and armrests!  <Product Information> Cover 89% cotton, 11% polyurethane Inner cover 87% polyester, 13% polyurethane Filling material: EPS (Expanded polystyrene foam) beads Removable cover Height approx. 95cm Width approx. 65cm Depth approx. 55cm Weight approx. 4.4 kg Volume: approx. 212L Dimensions are approximate and subject to individual variation. Measurements are taken with the product lying on the floor.  <Caution> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2. Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "パーソナルサイズのYogiboでリラックス  Yogibo Mini（ヨギボーミニ）は 一人用のチェアやソファになるビーズソファ。 子供部屋や、一人暮らしの家にもYogiboを迎えましょう！ Yogibo support(別売)と組み合わせると、背もたれや肘置き付きのソファに！  <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填材  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約95cm 幅  約65cm 奥行き  約55cm 重さ  約4.4kg 体積  約212L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_MIN-OG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "806",
    brand: "Yogibo",
    sku: "SUP-DG",
    product_eng: "Yogibo Support Dark Gray",
    product_jpn: "Yogibo Support(ヨギボー サポート)ダークグレー",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥15,900",
    rrp_with_vat: "¥17,490",
    description_eng:
      "When used with the body-fitting beaded sofa, it becomes a backrest and armrest. u-shaped cushion. The U-shaped cushion is the perfect size for reading or watching TV. It fits your body more comfortably and relaxes you more than the beaded sofa alone. <Product Information> Cover: 89% cotton, 11% polyurethane Inner cover: 87% polyester, 13% polyurethane Filling material: EPS (Expanded polystyrene) beads Removable cover Height approx. 90cm Width approx. 70cm Depth approx. 30cm Weight approx. 2.5 kg Volume: approx. 96L Dimensions are approximate and subject to individual variations.  <Cautions> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2.Please be careful not to let the garment come in contact with light-colored items. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "体にフィットするビーズソファと使えば背もたれとアームレストに。U字型のクッションです。 読書をするときやテレビを見るときに最適な大きさに作られています。 ビーズソファのみのときより、さらに体にフィットしリラックスできます。 <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填材  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約90cm 幅  約70cm 奥行き  約30cm 重さ  約2.5kg 体積  約96L ※寸法は目安となり、個体差があります。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_SUP-DG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "807",
    brand: "Yogibo",
    sku: "SUP-LG",
    product_eng: "Yogibo Support Light Gray",
    product_jpn: "Yogibo Support(ヨギボー サポート)ライトグレー",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥15,900",
    rrp_with_vat: "¥17,490",
    description_eng:
      "When used with the body-fitting beaded sofa, it becomes a backrest and armrest. u-shaped cushion. The U-shaped cushion is the perfect size for reading or watching TV. It fits your body more comfortably and relaxes you more than the beaded sofa alone. <Product Information> Cover: 89% cotton, 11% polyurethane Inner cover: 87% polyester, 13% polyurethane Filling material: EPS (Expanded polystyrene) beads Removable cover Height approx. 90cm Width approx. 70cm Depth approx. 30cm Weight approx. 2.5 kg Volume: approx. 96L Dimensions are approximate and subject to individual variations.  <Cautions> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2.Please be careful not to let the garment come in contact with light-colored items. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "体にフィットするビーズソファと使えば背もたれとアームレストに。U字型のクッションです。 読書をするときやテレビを見るときに最適な大きさに作られています。 ビーズソファのみのときより、さらに体にフィットしリラックスできます。 <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填材  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約90cm 幅  約70cm 奥行き  約30cm 重さ  約2.5kg 体積  約96L ※寸法は目安となり、個体差があります。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_SUP-LG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "808",
    brand: "Yogibo",
    sku: "SUP-GR",
    product_eng: "Yogibo Support Lime Green",
    product_jpn: "Yogibo Support(ヨギボー サポート)ライムグリーン",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥15,900",
    rrp_with_vat: "¥17,490",
    description_eng:
      "When used with the body-fitting beaded sofa, it becomes a backrest and armrest. u-shaped cushion. The U-shaped cushion is the perfect size for reading or watching TV. It fits your body more comfortably and relaxes you more than the beaded sofa alone. <Product Information> Cover: 89% cotton, 11% polyurethane Inner cover: 87% polyester, 13% polyurethane Filling material: EPS (Expanded polystyrene) beads Removable cover Height approx. 90cm Width approx. 70cm Depth approx. 30cm Weight approx. 2.5 kg Volume: approx. 96L Dimensions are approximate and subject to individual variations.  <Cautions> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2.Please be careful not to let the garment come in contact with light-colored items. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "体にフィットするビーズソファと使えば背もたれとアームレストに。U字型のクッションです。 読書をするときやテレビを見るときに最適な大きさに作られています。 ビーズソファのみのときより、さらに体にフィットしリラックスできます。 <製品情報> カバー  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填材  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約90cm 幅  約70cm 奥行き  約30cm 重さ  約2.5kg 体積  約96L ※寸法は目安となり、個体差があります。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_SUP-GR.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "809",
    brand: "Yogibo",
    sku: "WLNAP-GR",
    product_eng: "Yogibo Neck Pillow Logo Lime Green",
    product_jpn:
      "Yogibo Neck Pillow Logo(ヨギボー ネックピロー ロゴ)ライムグリーン",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥3,590",
    rrp_with_vat: "¥3,949",
    description_eng:
      "Neck Pillow is a neck pillow that brings you a comfortable sleep on airplanes and trains.  *Stretchable fabric fits your neck/shoulders securely. *Convenient to carry. Two snap buttons at the strap and neck allow you to hook it to your backpack or carry-on case. Convenient and easy to carry without squeezing your luggage. *Machine washable and always clean The cover can be removed by opening the zipper, so it is safe even if it accidentally gets dirty. It can be easily washed in a washing machine.  <Product Information> Cover material: 89% cotton, 11% polyurethane Cover can be removed Inner cover material: 92% polyester, 8% polyurethane Filling material EPS (Expanded polystyrene) beads 80％ / Polyester fiber 20 Polyester fiber 20 Length approx. 32cm Width approx. 38cm Thickness approx. 11cm Weight: approx. 250 g Dimensions are approximate and subject to individual variation.  <Cautions> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2. Please be careful when the item comes in contact with light-colored items. 3. 3.Due to the characteristics of the material, some of the fibers may fall out.",
    description_jpn:
      "Neck Pillow は、飛行機や電車であなたに快適な眠りを届けるネックピローです。 *伸縮性のある生地で、あなたの首・肩にしっかりフィット。 *持ち運びが便利。 ストラップと首元の2箇所にスナップボタンが付いているため、リュックサックやキャリーケースに引っ掛けることができます。荷物も圧迫せず手軽に持ち運べて便利。 *洗濯機で洗えて、いつでも清潔に ジッパーを開ければカバーを取り外せるので、うっかり汚れてしまっても大丈夫。洗濯機で気軽に洗えます。 <製品情報> カバー材料  コットン 89％ / ポリウレタン 11％ カバーの取り外し  できます インナーカバー材料  ポリエステル 92％ / ポリウレタン 8％ 充填材  EPS(発泡スチロール)ビーズ 80％ / ポリエステル繊維 20％ 長さ  約32cm 幅  約38cm 厚み  約11cm 重さ  約250g ※寸法は目安となり、個体差があります  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_WLNAP-GR.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "810",
    brand: "Yogibo",
    sku: "WLNAP-BL",
    product_eng: "Yogibo Neck Pillow Logo Navy Blue",
    product_jpn:
      "Yogibo Neck Pillow Logo(ヨギボー ネックピロー ロゴ)ネイビーブルー",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥3,590",
    rrp_with_vat: "¥3,949",
    description_eng:
      "Neck Pillow is a neck pillow that brings you a comfortable sleep on airplanes and trains.  *Stretchable fabric fits your neck/shoulders securely. *Convenient to carry. Two snap buttons at the strap and neck allow you to hook it to your backpack or carry-on case. Convenient and easy to carry without squeezing your luggage. *Machine washable and always clean The cover can be removed by opening the zipper, so it is safe even if it accidentally gets dirty. It can be easily washed in a washing machine.  <Product Information> Cover material: 89% cotton, 11% polyurethane Cover can be removed Inner cover material: 92% polyester, 8% polyurethane Filling material EPS (Expanded polystyrene) beads 80％ / Polyester fiber 20 Polyester fiber 20 Length approx. 32cm Width approx. 38cm Thickness approx. 11cm Weight: approx. 250 g Dimensions are approximate and subject to individual variation.  <Cautions> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2. Please be careful when the item comes in contact with light-colored items. 3. 3.Due to the characteristics of the material, some of the fibers may fall out.",
    description_jpn:
      "Neck Pillow は、飛行機や電車であなたに快適な眠りを届けるネックピローです。 *伸縮性のある生地で、あなたの首・肩にしっかりフィット。 *持ち運びが便利。 ストラップと首元の2箇所にスナップボタンが付いているため、リュックサックやキャリーケースに引っ掛けることができます。荷物も圧迫せず手軽に持ち運べて便利。 *洗濯機で洗えて、いつでも清潔に ジッパーを開ければカバーを取り外せるので、うっかり汚れてしまっても大丈夫。洗濯機で気軽に洗えます。 <製品情報> カバー材料  コットン 89％ / ポリウレタン 11％ カバーの取り外し  できます インナーカバー材料  ポリエステル 92％ / ポリウレタン 8％ 充填材  EPS(発泡スチロール)ビーズ 80％ / ポリエステル繊維 20％ 長さ  約32cm 幅  約38cm 厚み  約11cm 重さ  約250g ※寸法は目安となり、個体差があります  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_WLNAP-BL.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "811",
    brand: "Yogibo",
    sku: "WLNAP-LG",
    product_eng: "Yogibo Neck Pillow Logo Light Gray",
    product_jpn:
      "Yogibo Neck Pillow Logo(ヨギボー ネックピロー ロゴ)ライトグレー",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥3,590",
    rrp_with_vat: "¥3,949",
    description_eng:
      "Neck Pillow is a neck pillow that brings you a comfortable sleep on airplanes and trains.  *Stretchable fabric fits your neck/shoulders securely. *Convenient to carry. Two snap buttons at the strap and neck allow you to hook it to your backpack or carry-on case. Convenient and easy to carry without squeezing your luggage. *Machine washable and always clean The cover can be removed by opening the zipper, so it is safe even if it accidentally gets dirty. It can be easily washed in a washing machine.  <Product Information> Cover material: 89% cotton, 11% polyurethane Cover can be removed Inner cover material: 92% polyester, 8% polyurethane Filling material EPS (Expanded polystyrene) beads 80％ / Polyester fiber 20 Polyester fiber 20 Length approx. 32cm Width approx. 38cm Thickness approx. 11cm Weight: approx. 250 g Dimensions are approximate and subject to individual variation.  <Cautions> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2. Please be careful when the item comes in contact with light-colored items. 3. 3.Due to the characteristics of the material, some of the fibers may fall out.",
    description_jpn:
      "Neck Pillow は、飛行機や電車であなたに快適な眠りを届けるネックピローです。 *伸縮性のある生地で、あなたの首・肩にしっかりフィット。 *持ち運びが便利。 ストラップと首元の2箇所にスナップボタンが付いているため、リュックサックやキャリーケースに引っ掛けることができます。荷物も圧迫せず手軽に持ち運べて便利。 *洗濯機で洗えて、いつでも清潔に ジッパーを開ければカバーを取り外せるので、うっかり汚れてしまっても大丈夫。洗濯機で気軽に洗えます。 <製品情報> カバー材料  コットン 89％ / ポリウレタン 11％ カバーの取り外し  できます インナーカバー材料  ポリエステル 92％ / ポリウレタン 8％ 充填材  EPS(発泡スチロール)ビーズ 80％ / ポリエステル繊維 20％ 長さ  約32cm 幅  約38cm 厚み  約11cm 重さ  約250g ※寸法は目安となり、個体差があります  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_WLNAP-LG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "812",
    brand: "Yogibo",
    sku: "CTP-NT",
    product_eng: "Yogibo Caterpillar Roll Long Natural",
    product_jpn:
      "Yogibo Caterpillar Roll Long（ヨギボー キャタピラー ロール ロング）ナチュラル",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥16,900",
    rrp_with_vat: "¥18,590",
    description_eng:
      "The long cushions have unlimited uses! Combine with Yogibo beaded sofa for more versatility. Choose a color that matches the theme of your room.  <Product Information> Cover material: 89% cotton, 11% polyurethane Inner cover: 87% polyester, 13% polyurethane Filling material: EPS (Expanded polystyrene foam) beads Removable cover Height approx. 165cm Width approx. 25cm Depth approx. 25cm Weight approx. 2.5 kg Volume: approx. 105L Dimensions are approximate and subject to individual variation. Measurements are taken with the product lying on the floor.  <Cautions> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2. Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "長ーいクッションは使い方無限大！ Yogiboのビーズソファと組み合わせてもっと多機能に。 あなたのお部屋のテーマに合わせたカラーをお選びください。  <製品情報> カバー材質  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填材  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約165cm 幅  約25cm 奥行き  約25cm 重さ  約2.5kg 体積  約105L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_CTP-NT.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "813",
    brand: "Yogibo",
    sku: "CTP-BR",
    product_eng: "Yogibo Caterpillar Roll Long Bright",
    product_jpn:
      "Yogibo Caterpillar Roll Long（ヨギボー キャタピラー ロール ロング）ブライト",
    category_1: "Home & Garden",
    category_2: "Furniture",
    rrp_ex_vat: "¥16,900",
    rrp_with_vat: "¥18,590",
    description_eng:
      "The long cushions have unlimited uses! Combine with Yogibo beaded sofa for more versatility. Choose a color that matches the theme of your room.  <Product Information> Cover material: 89% cotton, 11% polyurethane Inner cover: 87% polyester, 13% polyurethane Filling material: EPS (Expanded polystyrene foam) beads Removable cover Height approx. 165cm Width approx. 25cm Depth approx. 25cm Weight approx. 2.5 kg Volume: approx. 105L Dimensions are approximate and subject to individual variation. Measurements are taken with the product lying on the floor.  <Cautions> 1.Due to the nature of the material, colors may fade or migrate due to perspiration, water, friction, etc. 2. Please be careful not to come in contact with light-colored items. 3. 3.Due to the nature of the material, some of the fibers may come loose.  <Notice about the product> Color differences due to differences in the country of origin There is a slight difference in the color of the product due to differences in the country of origin. Please be assured that there is no problem with the quality. Please note that you cannot choose the country of origin of the product when you place an order. Therefore, you may receive a product with a different color than you requested. We apologize for the inconvenience and thank you in advance for your understanding.",
    description_jpn:
      "長ーいクッションは使い方無限大！ Yogiboのビーズソファと組み合わせてもっと多機能に。 あなたのお部屋のテーマに合わせたカラーをお選びください。  <製品情報> カバー材質  コットン 89% / ポリウレタン 11％ インナーカバー  ポリエステル 87% / ポリウレタン 13％ 充填材  EPS(発泡スチロール)ビーズ カバー取り外し  可能 高さ  約165cm 幅  約25cm 奥行き  約25cm 重さ  約2.5kg 体積  約105L ※寸法は目安となり、個体差があります。 ※床に倒して置いた状態で計測しています。  <ご注意> 1.素材の特性上、汗、水、摩擦等により色落ち、色移りする場合があります。 2.淡色のものとの接触には十分ご注意ください。 3.素材の特性上、繊維の一部が抜ける事があります。  <製品についてのお知らせ> 製品の原産国の違いによる色味の差について 原産国の違いにより、製品の色味に多少の差がございます。品質には問題ございませんのでご安心ください。 なおご注文の際に製品の原産国をお選びいただくことはできません。そのためご希望と違う色味の製品が届くことがございます。 ご不便をおかけいたしますが、予めご了承くださいませ。",
    product_image_1:
      "https://products.naganorewards.com/images/yogibo/Yogibo_CTP-BR.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/YOGIBO.png",
  },
  {
    id: "814",
    brand: "KAERCHER",
    sku: "1.603-540.0",
    product_eng:
      "KAERCHER Electric Pressure Washer K 5 premium silent (for East Japan/50HZ region)",
    product_jpn:
      "KAERCHER ケルヒャー 高圧洗浄機 K 5 プレミアム サイレント（東日本/50HZ地域用）",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥79,800",
    rrp_with_vat: "¥87,780",
    description_eng:
      'The Kärcher high-pressure cleaner series "Water-cooled Silent" is the pinnacle of high-pressure cleaners. The K 5 Premium Silent is a high-pressure cleaner with a water-cooled motor that is quiet and reliable.  With original cleaning accessories exclusively designed for the K 5, this high-pressure cleaner is versatile enough to be used in a variety of locations.  <Water-cooled motor, silent technology> The water-cooled motor, which achieves high-performance cleaning, cools the motor with water drawn in from the water supply port to generate stable torque, and provides an even supply of pressure to remove dirt and the volume of water essential for cleaning, resulting in effective cleaning performance without waste. The housing design suppresses motor vibration and noise, reducing drive noise by 10db compared to air-cooled models and cutting noise by 50% on a feel level.  <Special original cleaning accessories> The "5 in 1 Multi Jet Nozzle" provides 5 different water streams such as Cyclon Jet, Vario, and Direct Jet with a single nozzle, making the K 5 Premium Silent ideal for all cleaning situations. The "Terrace Cleaner T 7 Plus" is equipped with three cleaning modes, including a terrace cleaner function with a rotating flat jet nozzle that minimizes water splashing, making it more convenient for cleaning terraces, parking lots, walls, and other large surfaces.  *Please select a water-cooled motor product that is compatible with the power supply frequency of your region. *Please note that "60Hz models" cannot be used in "50Hz areas (East Japan)" and "50Hz models" cannot be used in "60Hz areas (West Japan)". *Water hose is not included. *To use the product, the main unit must be assembled after purchase. Estimated assembly time requires approximately 20 minutes.  ■Product Specifications Power supply (V/Hz) 100 / 50 Max. allowable pressure (MPa) Max. 12 Water discharge (L/h) max. 430 Water supply temperature (°C) max. 40 Motor output (kW) 1.4 Weight (without accessories) (kg) 13.7 Packing weight (kg) 18.6 Dimensions (L x W x H) (mm) 417 x 306 x 584 ■Accessories and Included Items Terrace cleaner: T 7 Plus Trigger gun: G 180 Q Multi-power jet nozzle High pressure hose: 12 m, Premium Flex high pressure hose Coupling on main unit side ■Product Features Hose reel for high-pressure hose Quick connect connection (main unit) Cleaning agent spraying: detergent suction function Telescopic handle Water-cooled motor Water inlet filter (already installed inside the main unit) The Kärcher high-pressure cleaner series "Water-cooled Silent" is the pinnacle of high-pressure cleaners. The K 5 Premium Silent is a high-pressure cleaner with a water-cooled motor that is quiet and reliable.  With original cleaning accessories exclusively designed for the K 5, this high-pressure cleaner is versatile enough to be used in a variety of locations.',
    description_jpn:
      "ケルヒャー高圧洗浄機の最高峰「水冷サイレント」シリーズ。 K 5 プレミアム サイレントは、静音と信頼の証「水冷式モーター」を採用した高圧洗浄機です。  K 5 専用のオリジナル洗浄アクセサリで、様々な場所で多彩に活躍する高圧洗浄機です。  ＜水冷式モーター、サイレント技術＞ ハイパフォーマンスな洗浄効果を実現する水冷式モーターは、給水口から取り込んだ水でモーターを冷やして安定したトルクを生み出し、汚れを落とす圧力と洗浄に欠かせない水量を均一供給することで無駄のない効果的な洗浄性能を生み出します。 モーター振動やノイズを抑えるハウジング設計を採用し、空冷式モデルと比べて駆動音を10db削減、体感レベルでノイズを50％カット。 高圧洗浄機の騒音を気にせずに清掃作業に集中することができます。  ＜特別なオリジナル洗浄アクセサリー＞ K 5 プレミアム サイレント専用のアクセサリー「5 in 1 マルチジェットノズル」と「テラスクリナー T 7 Plus」を標準装備。 「5 in 1 マルチジェットノズル」は、サイクロンジェット、バリオ、直噴など、一本のノズルで5種類の水流を自在に利用可能で、あらゆるシーンの洗浄に対応しています。 「テラスクリナー T 7 Plus」は、水ハネを抑えた回転フラットジェットノズルを採用したテラスクリーナー機能を含めた3種類の洗浄モードを搭載し、テラス、駐車場、壁面など広範囲面の洗浄をより便利に行うことが出来ます。  ※水冷式モーター製品は、お住まいの地域の電源周波数に合わせた製品をお選びください。  「50Hz地域（東日本）」で「60Hzモデル」を、また「60Hz地域（西日本）」で「50Hzモデル」を使用することはできませんのでご注意ください。 ※水道ホースは付属しておりません。 ※製品をご使用いただくには、購入後に本体を組み立てる必要があります。 組立時間の目安は、約20分程度を要します。  ■製品スペック 電源 (V/Hz) 100 / 50 最大許容圧力 (MPa) 最大 12 吐出水量 (L/h) 最大 430 給水温度 (°C) 最大 40 モーター出力 (kW) 1.4 質量（アクセサリーを含まない） (kg) 13.7 梱包質量 (kg) 18.6 寸法（長さ×幅×高さ） (mm) 417 x 306 x 584 ■付属品・同梱品 テラスクリーナー: T 7 Plus トリガーガン: G 180 Q マルチパワージェットノズル 高圧ホース: 12 m, プレミアムフレックス高圧ホース 本体側カップリング ■製品機能 ホースリール（高圧ホース用） クイックコネクト接続（本体） 洗浄剤散布: 洗剤吸引機能 伸縮ハンドル 水冷式モーター 給水口フィルター（本体内部取り付け済）",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/KAERCHER_1.603-540.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "815",
    brand: "KAERCHER",
    sku: "1.603-541.0",
    product_eng:
      "KAERCHER Electric Pressure Washer K 5 premium silent (for West Japan/60HZ region)",
    product_jpn:
      "KAERCHER ケルヒャー 高圧洗浄機 K 5 プレミアム サイレント（西日本/60HZ地域用）",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥79,800",
    rrp_with_vat: "¥87,780",
    description_eng:
      'The Kärcher high-pressure cleaner series "Water-cooled Silent" is the pinnacle of high-pressure cleaners. The K 5 Premium Silent is a high-pressure cleaner with a water-cooled motor that is quiet and reliable.  With original cleaning accessories exclusively designed for the K 5, this high-pressure cleaner is versatile enough to be used in a variety of locations.  <Water-cooled motor, silent technology> The water-cooled motor, which achieves high-performance cleaning, cools the motor with water drawn in from the water supply port to generate stable torque, and provides an even supply of pressure to remove dirt and the volume of water essential for cleaning, resulting in effective cleaning performance without waste. The housing design suppresses motor vibration and noise, reducing drive noise by 10db compared to air-cooled models and cutting noise by 50% on a feel level.  <Special original cleaning accessories> The "5 in 1 Multi Jet Nozzle" provides 5 different water streams such as Cyclon Jet, Vario, and Direct Jet with a single nozzle, making the K 5 Premium Silent ideal for all cleaning situations. The "Terrace Cleaner T 7 Plus" is equipped with three cleaning modes, including a terrace cleaner function with a rotating flat jet nozzle that minimizes water splashing, making it more convenient for cleaning terraces, parking lots, walls, and other large surfaces.  *Please select a water-cooled motor product that is compatible with the power supply frequency of your region. *Please note that "60Hz models" cannot be used in "50Hz areas (East Japan)" and "50Hz models" cannot be used in "60Hz areas (West Japan)". *Water hose is not included. *To use the product, the main unit must be assembled after purchase. Estimated assembly time requires approximately 20 minutes.  ■Product Specifications Power supply (V/Hz) 100 / 50 Max. allowable pressure (MPa) Max. 12 Water discharge (L/h) max. 430 Water supply temperature (°C) max. 40 Motor output (kW) 1.4 Weight (without accessories) (kg) 13.7 Packing weight (kg) 18.6 Dimensions (L x W x H) (mm) 417 x 306 x 584 ■Accessories and Included Items Terrace cleaner: T 7 Plus Trigger gun: G 180 Q Multi-power jet nozzle High pressure hose: 12 m, Premium Flex high pressure hose Coupling on main unit side ■Product Features Hose reel for high-pressure hose Quick connect connection (main unit) Cleaning agent spraying: detergent suction function Telescopic handle Water-cooled motor Water inlet filter (already installed inside the main unit) The Kärcher high-pressure cleaner series "Water-cooled Silent" is the pinnacle of high-pressure cleaners. The K 5 Premium Silent is a high-pressure cleaner with a water-cooled motor that is quiet and reliable.  With original cleaning accessories exclusively designed for the K 5, this high-pressure cleaner is versatile enough to be used in a variety of locations.',
    description_jpn:
      "ケルヒャー高圧洗浄機の最高峰「水冷サイレント」シリーズ。 K 5 プレミアム サイレントは、静音と信頼の証「水冷式モーター」を採用した高圧洗浄機です。  K 5 専用のオリジナル洗浄アクセサリで、様々な場所で多彩に活躍する高圧洗浄機です。  ＜水冷式モーター、サイレント技術＞ ハイパフォーマンスな洗浄効果を実現する水冷式モーターは、給水口から取り込んだ水でモーターを冷やして安定したトルクを生み出し、汚れを落とす圧力と洗浄に欠かせない水量を均一供給することで無駄のない効果的な洗浄性能を生み出します。 モーター振動やノイズを抑えるハウジング設計を採用し、空冷式モデルと比べて駆動音を10db削減、体感レベルでノイズを50％カット。 高圧洗浄機の騒音を気にせずに清掃作業に集中することができます。  ＜特別なオリジナル洗浄アクセサリー＞ K 5 プレミアム サイレント専用のアクセサリー「5 in 1 マルチジェットノズル」と「テラスクリナー T 7 Plus」を標準装備。 「5 in 1 マルチジェットノズル」は、サイクロンジェット、バリオ、直噴など、一本のノズルで5種類の水流を自在に利用可能で、あらゆるシーンの洗浄に対応しています。 「テラスクリナー T 7 Plus」は、水ハネを抑えた回転フラットジェットノズルを採用したテラスクリーナー機能を含めた3種類の洗浄モードを搭載し、テラス、駐車場、壁面など広範囲面の洗浄をより便利に行うことが出来ます。  ※水冷式モーター製品は、お住まいの地域の電源周波数に合わせた製品をお選びください。  「50Hz地域（東日本）」で「60Hzモデル」を、また「60Hz地域（西日本）」で「50Hzモデル」を使用することはできませんのでご注意ください。 ※水道ホースは付属しておりません。 ※製品をご使用いただくには、購入後に本体を組み立てる必要があります。 組立時間の目安は、約20分程度を要します。  ■製品スペック 電源 (V/Hz) 100 / 50 最大許容圧力 (MPa) 最大 12 吐出水量 (L/h) 最大 430 給水温度 (°C) 最大 40 モーター出力 (kW) 1.4 質量（アクセサリーを含まない） (kg) 13.7 梱包質量 (kg) 18.6 寸法（長さ×幅×高さ） (mm) 417 x 306 x 584 ■付属品・同梱品 テラスクリーナー: T 7 Plus トリガーガン: G 180 Q マルチパワージェットノズル 高圧ホース: 12 m, プレミアムフレックス高圧ホース 本体側カップリング ■製品機能 ホースリール（高圧ホース用） クイックコネクト接続（本体） 洗浄剤散布: 洗剤吸引機能 伸縮ハンドル 水冷式モーター 給水口フィルター（本体内部取り付け済）",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/KAERCHER_1.603-541.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "816",
    brand: "KAERCHER",
    sku: "1.603-202.0",
    product_eng:
      "KAERCHER Electric Pressure Washer K 3 Silent Plus for balcony (for East Japan/50HZ region)",
    product_jpn:
      "KAERCHER ケルヒャー 高圧洗浄機 K 3 サイレント プラス ベランダ（東日本/50HZ地域用）",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥39,800",
    rrp_with_vat: "¥43,780",
    description_eng:
      'The highest peak of Kärcher high-pressure cleaners, the "Water-cooled Silent" series. The K 3 Silent Plus Veranda is a high-pressure cleaner with a water-cooled motor that is quiet and reliable. With the cleaning accessory "Deck Cleaner PS 20" included, this high-pressure cleaner is versatile enough to be used in various places.  <Water-cooled motor and silent technology> The water-cooled motor, which achieves high-performance cleaning, cools the motor with water drawn in from the water supply port to generate stable torque, and provides an even supply of pressure to remove dirt and the volume of water essential for cleaning, resulting in effective cleaning performance without waste.The housing design suppresses motor vibration and noise, reducing drive noise by 10dB compared to air-cooled models and cutting noise by 50% at the hands-on level.   <High-pressure hose and cleaning accessories A 10m high pressure hose is included for wide area cleaning, and the high pressure hose can be stored on a hook on the back of the machine. The cleaning accessory "Deck Cleaner PS 20" reduces water splashing and spray noise, making it comfortable for cleaning balconies, bathrooms, and entrance areas of apartment complexes. The brush head rotates 90 degrees, making it convenient for cleaning in tight spaces. It can comfortably clean all areas of the home.  *Please select a water-cooled motor product that is compatible with the power supply frequency of your region. *Please note that "60Hz models" cannot be used in "50Hz areas (East Japan)" and "50Hz models" cannot be used in "60Hz areas (West Japan)". *Water hose is not included. *To use the product, the main unit must be assembled after purchase. Estimated assembly time requires approximately 20 minutes.  ■Product Specifications Power supply (V/Hz) 100 / 50 Max. allowable pressure (MPa) Max. 10 Water discharge (L/h) max. 360 Water supply temperature (°C) max. 40 Motor output (kW) 1.3 Weight (without accessories) (kg) 12.7 Packing weight (kg) 17.7 Dimensions (L x W x H) (mm) 394 x 289 x 542 ■Accessories Deck cleaner Self-priming hose Trigger gun: G 120 Q Vario spray lance Cyclone jet nozzle High pressure hose: 10 m Coupling on main unit side ■Product Features Quick connect connection (main unit) Cleaning agent spraying: Cleaning agent tank Telescopic handle Water-cooled motor Water inlet filter (already installed inside the main unit)',
    description_jpn:
      "ケルヒャー高圧洗浄機の最高峰「水冷サイレント」シリーズ。 K 3 サイレント プラス ベランダは、静音と信頼の証「水冷式モーター」を採用した高圧洗浄機です。 洗浄アクセサリ「デッキクリーナー PS 20」が付属し、様々な場所で多彩に活躍する高圧洗浄機です。  ＜水冷式モーター、サイレント技術＞ ハイパフォーマンスな洗浄効果を実現する水冷式モーターは、給水口から取り込んだ水でモーターを冷やして安定したトルクを生み出し、汚れを落とす圧力と洗浄に欠かせない水量を均一供給することで無駄のない効果的な洗浄性能を生み出します。 モーター振動やノイズを抑えるハウジング設計を採用し、空冷式モデルと比べて駆動音を10dB削減、体感レベルでノイズを50％カット。高圧洗浄機の騒音を気にせずに清掃作業に集中することができます。  ＜高圧ホースと洗浄アクセサリー＞ 広範囲の洗浄に便利な10m高圧ホースが付属、高圧ホースはマシン背面のフックに収納可能。 洗浄アクセサリー「デッキクリーナー PS 20」は、水の飛び跳ねが少なく噴射音が低減できるので、集合住宅のベランダや、浴室、玄関回りなどの洗浄を快適に行うことが出来ます。またブラシヘッドが90度回転するので、狭い場所での掃除にも便利です。ご家庭のあらゆる場所の洗浄を快適に行うことが出来ます。  ※水冷式モーター製品は、お住まいの地域の電源周波数に合わせた製品をお選びください。  「50Hz地域（東日本）」で「60Hzモデル」を、また「60Hz地域（西日本）」で「50Hzモデル」を使用することはできませんのでご注意ください。 ※水道ホースは付属しておりません。 ※製品をご使用いただくには、購入後に本体を組み立てる必要があります。 組立時間の目安は、約20分程度を要します。  ■製品スペック 電源 (V/Hz) 100 / 50 最大許容圧力 (MPa) 最大 10 吐出水量 (L/h) 最大 360 給水温度 (°C) 最大 40 モーター出力 (kW) 1.3 質量（アクセサリーを含まない） (kg) 12.7 梱包質量 (kg) 17.7 寸法（長さ×幅×高さ） (mm) 394 x 289 x 542 付属品・同梱品  ■デッキクリーナー 自吸用ホース トリガーガン: G 120 Q バリオスプレーランス サイクロンジェットノズル 高圧ホース: 10 m 本体側カップリング  ■製品機能 クイックコネクト接続（本体） 洗浄剤散布: 洗浄剤タンク 伸縮ハンドル 水冷式モーター 給水口フィルター（本体内部取り付け済）",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/KAERCHER_1.603-202.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "817",
    brand: "KAERCHER",
    sku: "1.603-203.0",
    product_eng:
      "KAERCHER Electric Pressure Washer K 3 Silent Plus for balcony (for West Japan/60HZ region)",
    product_jpn:
      "KAERCHER ケルヒャー 高圧洗浄機 K 3 サイレント プラス ベランダ（西日本/60HZ地域用）",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥39,800",
    rrp_with_vat: "¥43,780",
    description_eng:
      'The highest peak of Kärcher high-pressure cleaners, the "Water-cooled Silent" series. The K 3 Silent Plus Veranda is a high-pressure cleaner with a water-cooled motor that is quiet and reliable. With the cleaning accessory "Deck Cleaner PS 20" included, this high-pressure cleaner is versatile enough to be used in various places.  <Water-cooled motor and silent technology> The water-cooled motor, which achieves high-performance cleaning, cools the motor with water drawn in from the water supply port to generate stable torque, and provides an even supply of pressure to remove dirt and the volume of water essential for cleaning, resulting in effective cleaning performance without waste.The housing design suppresses motor vibration and noise, reducing drive noise by 10dB compared to air-cooled models and cutting noise by 50% at the hands-on level.   <High-pressure hose and cleaning accessories A 10m high pressure hose is included for wide area cleaning, and the high pressure hose can be stored on a hook on the back of the machine. The cleaning accessory "Deck Cleaner PS 20" reduces water splashing and spray noise, making it comfortable for cleaning balconies, bathrooms, and entrance areas of apartment complexes. The brush head rotates 90 degrees, making it convenient for cleaning in tight spaces. It can comfortably clean all areas of the home.  *Please select a water-cooled motor product that is compatible with the power supply frequency of your region. *Please note that "60Hz models" cannot be used in "50Hz areas (East Japan)" and "50Hz models" cannot be used in "60Hz areas (West Japan)". *Water hose is not included. *To use the product, the main unit must be assembled after purchase. Estimated assembly time requires approximately 20 minutes.  ■Product Specifications Power supply (V/Hz) 100 / 50 Max. allowable pressure (MPa) Max. 10 Water discharge (L/h) max. 360 Water supply temperature (°C) max. 40 Motor output (kW) 1.3 Weight (without accessories) (kg) 12.7 Packing weight (kg) 17.7 Dimensions (L x W x H) (mm) 394 x 289 x 542 ■Accessories Deck cleaner Self-priming hose Trigger gun: G 120 Q Vario spray lance Cyclone jet nozzle High pressure hose: 10 m Coupling on main unit side ■Product Features Quick connect connection (main unit) Cleaning agent spraying: Cleaning agent tank Telescopic handle Water-cooled motor Water inlet filter (already installed inside the main unit)',
    description_jpn:
      "ケルヒャー高圧洗浄機の最高峰「水冷サイレント」シリーズ。 K 3 サイレント プラス ベランダは、静音と信頼の証「水冷式モーター」を採用した高圧洗浄機です。 洗浄アクセサリ「デッキクリーナー PS 20」が付属し、様々な場所で多彩に活躍する高圧洗浄機です。  ＜水冷式モーター、サイレント技術＞ ハイパフォーマンスな洗浄効果を実現する水冷式モーターは、給水口から取り込んだ水でモーターを冷やして安定したトルクを生み出し、汚れを落とす圧力と洗浄に欠かせない水量を均一供給することで無駄のない効果的な洗浄性能を生み出します。 モーター振動やノイズを抑えるハウジング設計を採用し、空冷式モデルと比べて駆動音を10dB削減、体感レベルでノイズを50％カット。高圧洗浄機の騒音を気にせずに清掃作業に集中することができます。  ＜高圧ホースと洗浄アクセサリー＞ 広範囲の洗浄に便利な10m高圧ホースが付属、高圧ホースはマシン背面のフックに収納可能。 洗浄アクセサリー「デッキクリーナー PS 20」は、水の飛び跳ねが少なく噴射音が低減できるので、集合住宅のベランダや、浴室、玄関回りなどの洗浄を快適に行うことが出来ます。またブラシヘッドが90度回転するので、狭い場所での掃除にも便利です。ご家庭のあらゆる場所の洗浄を快適に行うことが出来ます。  ※水冷式モーター製品は、お住まいの地域の電源周波数に合わせた製品をお選びください。  「50Hz地域（東日本）」で「60Hzモデル」を、また「60Hz地域（西日本）」で「50Hzモデル」を使用することはできませんのでご注意ください。 ※水道ホースは付属しておりません。 ※製品をご使用いただくには、購入後に本体を組み立てる必要があります。 組立時間の目安は、約20分程度を要します。  ■製品スペック 電源 (V/Hz) 100 / 50 最大許容圧力 (MPa) 最大 10 吐出水量 (L/h) 最大 360 給水温度 (°C) 最大 40 モーター出力 (kW) 1.3 質量（アクセサリーを含まない） (kg) 12.7 梱包質量 (kg) 17.7 寸法（長さ×幅×高さ） (mm) 394 x 289 x 542 付属品・同梱品  ■デッキクリーナー 自吸用ホース トリガーガン: G 120 Q バリオスプレーランス サイクロンジェットノズル 高圧ホース: 10 m 本体側カップリング  ■製品機能 クイックコネクト接続（本体） 洗浄剤散布: 洗浄剤タンク 伸縮ハンドル 水冷式モーター 給水口フィルター（本体内部取り付け済）",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/KAERCHER_1.603-203.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "818",
    brand: "KAERCHER",
    sku: "1.117-223.0",
    product_eng: "KAERCHER K 2 Battery Set",
    product_jpn: "KAERCHER ケルヒャー K 2 バッテリーセット",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥58,600",
    rrp_with_vat: "¥64,460",
    description_eng:
      "The cordless high-pressure cleaner K 2 battery set requires no power source. It is ideal for cleaning in places where it is difficult to secure a power source, cleaning motorcycles and cars, and cleaning around the house. The nozzle comes with a 1-jet nozzle in standard mode and a cyclone jet nozzle in boost mode, allowing for approximately 14 minutes of continuous use (standard mode). The trigger gun is equipped with a water pressure indicator to check the cleaning mode in use, and a 36V 5.0Ah battery power is also included.  ■Product Specifications Battery Power Devices  Battery Platform 36 V Battery Platform Max. allowable pressure (MPa) Max. 11 Water discharge (L/h) 340 Water supply temperature (°C) max. 40 Battery type Lithium-ion battery Voltage (V) 36 Capacity (Ah) 5 Operating time (per charge) (min) 14 (5.0 Ah) Charging time (standard charging adapter) (h) 9 Weight (without accessories) (kg) 4.5 Packing weight (kg) 8 Dimensions (L x W x H) (mm) 245 x 303 x 629 ■Accessories and bundled items Variant: Includes battery and charger Trigger gun: with water pressure indicator 1 jet nozzle Cyclone jet nozzle High pressure hose: 4 m Coupling on the main unit side ■Product Features Quick connect connection (main unit) Cleaning agent spraying: detergent suction function Water inlet filter (already installed inside the main unit)",
    description_jpn:
      "コードレスタイプの高圧洗浄機K 2 バッテリーセットは、電源が必要ありません。 電源が確保しづらい場所での洗浄、バイクや車の洗浄、家まわりのお掃除などに最適です。 ノズルは、標準モードの1ジェットノズル、ブーストモードのサイクロンジェットノズル付属で、連続使用時間は約14分（標準モード）可能です。 トリガーガンは使用中の洗浄モードが確認できる水圧インジケーターが搭載されており、バッテリーパワー36V5.0Ahも付属しています。   ■製品仕様 製品スペック バッテリー パワー デバイス  バッテリープラットフォーム 36 V バッテリープラットフォーム 最大許容圧力 (MPa) 最大 11 吐出水量 (L/h) 340 給水温度 (°C) 最大 40 バッテリータイプ リチウムイオンバッテリー 電圧 (V) 36 容量 (Ah) 5 使用時間（一回の充電） (分) 14 （5.0 Ah） 充電時間（標準充電アダプター） (h) 9 質量（アクセサリーを含まない） (kg) 4.5 梱包質量 (kg) 8 寸法（長さ×幅×高さ） (mm) 245 x 303 x 629 ■付属品・同梱品 バリアント: バッテリーと充電器を含む トリガーガン: 水圧インジゲーター搭載 1ジェットノズル サイクロンジェットノズル 高圧ホース: 4 m 本体側カップリング ■製品機能 クイックコネクト接続（本体） 洗浄剤散布: 洗剤吸引機能 給水口フィルター（本体内部取り付け済）",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/KAERCHER_1.117-223.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "819",
    brand: "KAERCHER",
    sku: "1.600-920.0",
    product_eng: "KAERCHER Electric Pressure Washer K2 Silent",
    product_jpn: "KAERCHER ケルヒャー 高圧洗浄機 K 2 サイレント",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥28,700",
    rrp_with_vat: "¥31,570",
    description_eng:
      "K 2 The first quiet model with the highest cleaning power in the series. It is a powerful, yet light and quiet high-pressure cleaner.  <Silent yet lightweight>. By employing sound-absorbing materials and air flow, the sound you feel is reduced by approximately 50% compared to the previous K 2 model. The main unit weighs only 5.8 kg, the lightest of the quiet models (excluding the model for specific corporate use only), making it easy to carry with one hand.  <Smart Storage> Trigger gun, nozzle, high-pressure hose, and other accessories can be stored together on the back of the main unit for easy cleanup and storage. This makes it easy to carry with one hand and also helps prevent loss.  <Easy connection> The main unit and hoses can be connected with one-touch operation, making preparation and cleanup easy. Anyone can easily use it whenever they want.  ■Product Specifications Power source (V/Hz) 100 / 50 - 60 Maximum allowable pressure (MPa) Maximum 10 Water discharge (L/h) max. 360 Water supply temperature (°C) max. 40 Motor output (kW) 1.25 Weight (without accessories) (kg) 5.8 Packing weight (kg) 8.4 Dimensions (L x W x H) (mm) 538 x 293 x 303 ■Accessories Foam jet: 0.3 L Trigger gun: G 120 Q Vario spray lance Cyclone jet nozzle High pressure hose: 8 m Coupling on main unit side ■Product Features Quick connect connection (main unit) Water inlet filter (already installed inside the main unit)",
    description_jpn:
      "K 2 シリーズ最高の洗浄力で初めての静音モデル。パワフルなのに軽くて静かな高圧洗浄機です。  ＜静音なのに軽い＞ 吸音材の採用や空気の流れを工夫することで、体感音を従来のK 2 モデルよりも約50％カット。本体質量は静音モデル最軽量（特定法人専用モデルを除く）のわずか5.8kgだから片手でラクに持ち運びできます。  ＜スマート収納＞ トリガーガンやノズル、高圧ホースなどの付属品は本体背面にまとめて収納できるので、後片付けや収納がスムーズです。片手で持ち運びができるうえ、紛失の予防にもなります。  ＜接続が簡単＞ 本体とホース類の接続はワンタッチでできるので、準備も片付けも簡単です。誰でも手軽に、使いたいときにすぐ使えます。  ■製品スペック 電源 (V/Hz) 100 / 50 - 60 最大許容圧力 (MPa) 最大 10 吐出水量 (L/h) 最大 360 給水温度 (°C) 最大 40 モーター出力 (kW) 1.25 質量（アクセサリーを含まない） (kg) 5.8 梱包質量 (kg) 8.4 寸法（長さ×幅×高さ） (mm) 538 x 293 x 303 ■付属品・同梱品 フォームジェット: 0.3 L トリガーガン: G 120 Q バリオスプレーランス サイクロンジェットノズル 高圧ホース: 8 m 本体側カップリング ■製品機能 クイックコネクト接続（本体） 給水口フィルター（本体内部取り付け済）",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/KAERCHER_1.600-920.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "820",
    brand: "KAERCHER",
    sku: "1.600-050.0",
    product_eng: "KAERCHER Electric Pressure Washer K MINI",
    product_jpn: "KAERCHER ケルヒャー 高圧洗浄機 K MINI",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥24,400",
    rrp_with_vat: "¥26,840",
    description_eng:
      "The K MINI is Kärcher's most compact high-pressure cleaner ever, with two features together: compactness and ease of handling. The accessory storage case is on the back of the machine, the power cord is at the foot of the machine, and all included accessories are integrated into the body of the machine for easy storage. The gun and nozzle are divided into three parts: a short trigger gun, a short extension lance, and a short vario spray lance, so they can fit in a compact storage case. The gun and nozzle are also shortened, making it easier to clean in tight spaces. The high-pressure hose is made of a thinner, more flexible premium flex material, resulting in a more compact storage size and easier handling.  ■Product Specifications Maximum allowable pressure (MPa) 2 - 9 Water discharge (L/h) max. 330 Water supply temperature (°C) max. 40 Motor output (kW) 1 Power cord (m) 5 Weight (without accessories) (kg) 3.9 Packing weight (kg) 5.8 Dimensions (L x W x H) (mm) 280 x 233 x 295 ■Accessories Extension lance Trigger gun: Short (G 110 Q) Vario Spray Lance High pressure hose: 5 m, premium flex high pressure hose Coupling on main unit side ■Product Features Quick connect connection (main unit) Water inlet filter (already installed inside the main unit) Power cord tucked under foot",
    description_jpn:
      "K MINIはコンパクトさと扱いやすさという2つの機能の一緒に持つケルヒャー史上最もコンパクトな高圧洗浄機です。 アクセサリー収納ケースをマシンの背中に、電源コードは足元に、と同梱品はすべて本体に収納される収納一体型なので、収納場所に困りません。 ショートトリガーガン、ショート延長ランス、ショートバリオスプレーランスとガンとノズルが3分割されるので、コンパクトな収納ケースにも収まります。 またガンとノズルが短くなり、狭い場所での洗浄が楽になりました。高圧ホースには、しなやかさをもつプレミアムフレックスをさらに細くし、よりコンパクトな収納サイズと、扱いやすさを実現しました。  ■製品仕様 製品スペック 最大許容圧力 (MPa) 2 - 最大 9 吐出水量 (L/h) 最大 330 給水温度 (°C) 最大 40 モーター出力 (kW) 1 電源コード (m) 5 質量（アクセサリーを含まない） (kg) 3.9 梱包質量 (kg) 5.8 寸法（長さ×幅×高さ） (mm) 280 x 233 x 295 ■付属品・同梱品 延長ランス トリガーガン: ショート（G 110 Q） バリオスプレーランス 高圧ホース: 5 m, プレミアムフレックス高圧ホース 本体側カップリング ■製品機能 クイックコネクト接続（本体） 給水口フィルター（本体内部取り付け済） 電源コードを足元に収納",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/KAERCHER_1.600-050.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "821",
    brand: "KAERCHER",
    sku: "1.328-113.0",
    product_eng: "KAERCHER Mobile Electric Pressure Washer  KHB 6 Battery Set",
    product_jpn:
      "KAERCHER ケルヒャー モバイル高圧洗浄機 KHB 6 バッテリーセット",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥31,900",
    rrp_with_vat: "¥35,090",
    description_eng:
      "This lightweight, compact mobile cleaner can be easily held in one hand. Since it is cordless, there is no need to worry about where the power source is located, and it can be started simply by connecting a water hose. It is ideal for daily use because it is hassle-free and can be used quickly when dirt is bothering you. If you use the optional KHB dedicated self-priming hose (2.644-124.0), you can use water stored in a bucket or other container for cleaning. Since no power source is required, this machine is ideal not only for cleaning around the house, but also for cleaning balconies, outdoor scenes, and graves where it is difficult to secure a power source. Battery power 18 V 2.5 Ah included  ■Product Specifications Battery Power Device  Battery Platform 18 V Battery Platform Max. allowable pressure (MPa) Max. 2.4 Discharge pressure Medium pressure Discharge volume (L/h) max. 200 Battery type Lithium-ion battery Voltage (V) 18 Capacity (Ah) 2.5 Operating time (per charge) (min) 12 (2.5 Ah) Power supply for charger (V/Hz) 100 - 240 / 50 - 60 Weight (without accessories) (kg) 1.3 Packing weight (kg) 2.8 Dimensions (L x W x H) (mm) 302 x 89 x 265 ■Accessories and Included Items Variant: Includes battery and charger Battery: Battery Power 18 V 2.5 Ah (1 pc.) Charger: 18 V dedicated charging adapter Coupling on the main unit side ■Product Features Flat jet nozzle Water inlet filter (already installed inside the main unit)",
    description_jpn:
      "片手で簡単に持てる軽量、コンパクトなモバイル洗浄機です。コードレスなので、電源の場所を気にせず、水道ホースを接続するだけで使用開始でき準備の手間がありません。 手間なく使えるから、汚れが気になったときにさっと使え、日常使いに最適です。 別売りのKHB専用自吸用ホース（2.644-124.0）を使用すれば、バケツなどにためた水を使用して洗浄できます。 電源が不要なので、家まわりの洗浄はもちろん、電源が確保しづらいベランダ、アウトドアシーンやお墓の洗浄にも最適な洗浄機です。 バッテリーパワー18 V 2.5 Ah付属  ■製品スペック バッテリー パワー デバイス  バッテリープラットフォーム 18 Vバッテリープラットフォーム 最大許容圧力 (MPa) 最大 2.4 吐出圧力 中圧 吐出水量 (L/h) 最大 200 バッテリータイプ リチウムイオンバッテリー 電圧 (V) 18 容量 (Ah) 2.5 使用時間（一回の充電） (分) 12 （2.5 Ah） 充電器用電源 (V/Hz) 100 - 240 / 50 - 60 質量（アクセサリーを含まない） (kg) 1.3 梱包質量 (kg) 2.8 寸法（長さ×幅×高さ） (mm) 302 x 89 x 265 ■付属品・同梱品 バリアント: バッテリーと充電器を含む バッテリー: バッテリーパワー 18 V 2.5 Ah （1個） 充電器: 18 V 専用充電アダプター 本体側カップリング ■製品機能 フラットジェットノズル 給水口フィルター（本体内部取り付け済）",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/KAERCHER_1.328-113.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "822",
    brand: "Makita",
    sku: "CL286FDRFW",
    product_eng: "Makita Rechargeable Vacuum Cleaner CL286FDRFW",
    product_jpn: "Makita マキタ 充電式クリーナ CL286FDRFW",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥51,700",
    rrp_with_vat: "¥56,870",
    description_eng:
      'New 18V specification "integrated cyclone type", quiet and powerful suction power  ■Features ・Optimization of motor control has realized the same suction power as the 40Vmax specification. ・Dust collection capacity 250mL ・Weight 1.7kg (including battery / excluding nozzle and pipe)   ・Light / Trigger switch (ON/OFF when you want to use) / 4 speeds     ・Cyclone unit integrated with the main unit. ・Noise of the cyclone unit is reduced by the new 3-layer structure. ・Filter cleaning frequency is reduced to 1/6*. ・Filter is less prone to clogging, so suction power lasts longer. ・Compared to our conventional cyclone-free model. ・Easy to reach even in narrow spaces. The cyclone unit is placed at the top of the machine for efficient cleaning in tight spaces such as under seats. ・The center of the nozzle\'s movable part is positioned on the rear tire axis. ・Easy-to-use one-touch switch ・One-touch switch for ease of use ・Pipe can be securely fixed and removed with a push of a button. ・Filter can be fixed by simply inserting the filter. ・Tip shape for easy cleaning without a slant-cut pipe or T-shape nozzle.  ■Functions ・Continuous use time Powerful: approx. 8 min/High: approx. 15 min/Standard: approx. 21 min/Eco: approx. 38 min *The values are for reference only. ・Current 18V ・Dimensions (mm) (L x W x H) 1,106 x 113 x 177 (with pipe and nozzle) ・Weight (kg) (including battery) 1.7 * Excluding nozzle and pipe.',
    description_jpn:
      "18V仕様｢サイクロン一体式｣新登場､静かでパワフルな吸引力  ■特徴 ・モータ制御の最適化により40Vmax仕様と同等の吸引力を実現 ・集じん容量250mL ・質量1.7kg（バッテリ含む / ノズル・パイプ除く）   ・ライト付/トリガスイッチ（使いたい時にON/OFF）/4スピード     ・サイクロンユニットを本機と一体化｡ ・新･3層構造でサイクロン部の騒音低減 ・フィルタ清掃頻度は約1/6※ フィルタが目詰まりしにくいので､吸引力が長続き｡ ※当社サイクロン無し比較｡ ・狭い場所でもラクラク届く。サイクロンユニットを本機の上部に配置することで､座席下等の狭い場所も効率よく清掃｡ ・滑るような操作性 ノズル可動部の中心を後タイヤ軸上に配置｡ ・使いやすくなったワンタッチスイッチ ・前回OFFにしたモードから再開できるモードメモリ付｡ ・パイプを確実に固定でき､取り外しもボタンを押すだけ｡ ・フィルタ固定は挿し込むだけ｡ ・斜めカットパイプ/T字型ノズル無しでも掃除しやすい先端形状｡  ■機能 ・連続使用時間 パワフル：約8分/強：約15分/標準：約21分/エコ：約38分 ※数値は参考値です ・電流 18V ・本機寸法（mm）（長さ×幅×高さ）1,106×113×177（パイプ、ノズル付） ・質量（kg）（バッテリ含む） 1.7  ＊ノズル・パイプ除く。",
    product_image_1:
      "https://products.naganorewards.com/images/makita/Makita_CL286FDRFW.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "823",
    brand: "Makita",
    sku: "CL108FDSHW",
    product_eng: "Makita Rechargeable Vacuum Cleaner CL108FDSHW",
    product_jpn: "Makita マキタ 充電式クリーナ CL108FDSHW",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥21,000",
    rrp_with_vat: "¥23,100",
    description_eng:
      'Powerful suction" for cleaning up even the dirt that gets into crevices, this rechargeable cleaner can be quickly recharged in about 22 minutes per charge. One-touch switch for continuous operation allows for easy cleaning of high and narrow places. The cleaner is equipped with a high-luminance LED light with an "out-of-battery" function. The dust capsule can be easily removed by simply twisting and removing the capsule. A "dust stopper" prevents dust from spilling out.  ■Functions ・Continuous use time: Powerful: approx. 10 min/High: approx. 12 min/Standard: approx. 25 min ＊These figures are for reference only. The values are for reference only and may vary depending on the state of battery charge and working conditions. ・Dimensions (mm) (L x W x H) 956 x 110 x 150 (with pipe and nozzle) ・Dust collection capacity (mL) 600 ・Pre-filter, filter, straight pipe, nozzle, and sash nozzle.',
    description_jpn:
      "隙間に入り込んだゴミもしっかりと吸引する「パワフル吸引」を備えた、充電式クリーナー。1回約22分の急速充電が可能。 連続運転が可能な「ワンタッチスイッチ」を採用し、高い所や狭い所などの掃除が快適。「バッテリ切れお知らせ」機能付の高輝度LEDライトを備える。 ゴミ捨ては、カプセル部をひねって外すだけの簡単なカプセル式を採用。ゴミのこぼれ落ちを防止する「ゴミストッパ」を搭載。  ■機能 ・連続使用時間 パワフル：約10分/強：約12分/標準：約25分 ※ 数値は参考値です。バッテリの充電状態や作業条件により異なります。 ・本機寸法(mm)(長さx幅x高さ)  956×110×150（パイプ、ノズル付） ・集じん容量（mL）600 ・標準付属品 プレフィルタ・フィルタ・ストレートパイプ・ノズル・サッシ（すきま）ノズル",
    product_image_1:
      "https://products.naganorewards.com/images/makita/Makita_CL108FDSHW.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "824",
    brand: "Makita",
    sku: "CK1012",
    product_eng: "Makita Disaster Prevention Combo Kits CK1012",
    product_jpn: "Makita マキタ 防災用コンボキットCK1012",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥107,100",
    rrp_with_vat: "¥117,810",
    description_eng:
      "Makita's Combo Kit for Disaster Prevention Now Includes a TV! 18V battery specification, for everyday, leisure, and emergency use.  ・Rechargeable TV100 with radio Compatible with terrestrial digital and one-segment broadcasting. Can be used with Makita batteries for viewing in various locations. Enjoy radio and music Music from smartphones and other devices can be played via Bluetooth connection. Includes a retractable screen cover to protect the screen during transportation. USB device rechargeable Usage time per charge: TV approx. 11 hours / Radio approx. 14 hours ・Foldable stand ・Foldable stand ・ Wireless remote control ・Elastomer to protect the unit (around the monitor) ・Rechargeable LED Work Light ML807 18V battery, 360° LED light, USB device can be recharged. ・Battery BL1860B [6.0Ah] Usage time per charge: TV: approx. 11 hours / Radio: approx. 14 hours *The figures are for reference only. ・Battery charger DC18RF ・Tool bag  Convenient for carrying and storage. All set items can be stored and transported.",
    description_jpn:
      "マキタの防災用コンボキットにテレビ付コンボキット登場 18Vバッテリ仕様で、日常・レジャーから、もしもの時にも  ・充電式ラジオ付テレビ TV100 地上波デジタル・ワンセグ放送対応。 マキタバッテリを使って様々な場所で視聴可能。 ラジオや音楽も楽しめる Bluetooth接続でスマートフォン等の音楽を再生可能。 運搬時は画面を保護する開閉式画面カバー付。 USB機器充電可能 1充電あたりの使用時間 テレビ 約11時間/ラジオ 約14時間 ※数値は参考値です。 ・ 折りたたみ式スタンド ・ ワイヤレスリモコン付 ・ 本機（モニター周り）を保護するエラストマ付 ・充電式LEDワークライト ML807 18Vバッテリ採用、360°LEDライトで照射。USB機器が充電可能。 ・バッテリ BL1860B ［6.0Ah］ 1充電あたりの使用時間 テレビ 約11時間/ラジオ 約14時間 ※数値は参考値です。 ・充電器 DC18RF ・ツールバッグ  持ち運びや収納に便利。 セット品を全て収納&運搬可能",
    product_image_1:
      "https://products.naganorewards.com/images/makita/Makita_CK1012.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "825",
    brand: "Philips Hue",
    sku: "929003555501 ",
    product_eng: "Philips Hue Floor Light",
    product_jpn: "Philips Hue フロアライト",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥44,800",
    rrp_with_vat: "¥49,280",
    description_eng:
      "Equipped with a gradation function that elevates the space Indirect lighting that regulates the rhythm of daily life Indirect lighting ideal for waking and sleeping First floor light with video and music synchronization function (requires purchase of Philips Play HDMI Sync Box)  -Create a personalized space with colorful smart lights -Seamlessly blend colors A single light produces rich colors that blend smoothly. Enjoy unique lighting effects where the colors of the lights naturally blend together. -Control up to 10 lights via Bluetooth app (requires purchase of optional Hue bridge)  Net weight 2.275 kg Cable length 2 m Height 145.8 cm Length 11.1 cm Width 11.1 cm",
    description_jpn:
      "空間を格上げするグラデーション機能搭載 1日の生活リズムを整える間接照明 目覚め・眠りに最適な間接照明 フロアライト初、映像・音楽とのシンクロ機能搭載(Philips Play HDMI Sync Boxの購入が必要になります）  -カラフルなスマート ライトでパーソナライズされた空間を構築する -シームレスに色をブレンド 1 つのライトで、なめらかに混ざりあう豊かな色彩を演出します。ライトの色が自然に溶け合う、独特の照明効果を楽しむことができます。 -Bluetooth アプリで最大 10 個の照明を制御 (別売 Hueブリッジを購入する必要があります)  正味重 2.275 kg ケーブル長さ 2 m 高さ     145.8 cm 長さ    11.1 cm 幅    11.1 cm",
    product_image_1:
      "https://products.naganorewards.com/images/philips-hue/Philips-Hue_929003555501.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "826",
    brand: "Philips Hue",
    sku: "929002275804 ",
    product_eng: "Philips Play HDMI Sync Box",
    product_jpn: "Philips Play HDMI Sync Box",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥34,800",
    rrp_with_vat: "¥38,280",
    description_eng:
      "Connect your media device to the Hue setup using the four HDMI ports, and the Hue lights will synchronize with the video and music projected on the TV monitor you are watching. Full-color LED lighting in 16 million colors enhances the effects of video and music for a more immersive experience.  Synchronize lighting with home theater Connects to up to 4 HDMI devices Customizable via app Requires Hue bridge and Hue full-color lighting  Product Dimensions and Weight Net weight 0.455 kg Height 2.3 cm Length 9.9 cm",
    description_jpn:
      "4 つの HDMI ポートを使用して、メディアデバイスを Hue 設定に接続し、視聴しているTVモニターに映し出された映像・音楽とHue ライトの明かりがシンクロします。 1600万色のフルカラーLED照明が、映像や音楽の効果を高めより没入感のある空間を体験できます。ホームシアターと照明をシンクロ HDMI デバイス最大 4 台に接続 アプリを使ってカスタマイズ可能 ※Hue ブリッジ と Hue フルカラー照明が必要です  製品寸法・重量 正味重量 0.455 kg 高さ 2.3 cm 長さ 9.9 cm 幅  18.2 cm",
    product_image_1:
      "https://products.naganorewards.com/images/philips-hue/Philips-Hue_929002275804.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "827",
    brand: "Philips Hue",
    sku: "929003555601 ",
    product_eng: "Philips Hue Table Lump",
    product_jpn: "Philips Hue テーブルランプ",
    category_1: "Home & Garden",
    category_2: "Home appliances",
    rrp_ex_vat: "¥29,800",
    rrp_with_vat: "¥32,780",
    description_eng:
      "Equipped with a gradation function that elevates the space Indirect lighting that regulates the rhythm of daily life Indirect lighting ideal for waking and sleeping First floor light with video and music synchronization function (requires purchase of Philips Play HDMI Sync Box)  -Create a personalized space with colorful smart lights -Seamlessly blend colors A single light produces rich colors that blend smoothly. Enjoy unique lighting effects where the colors of the lights naturally blend together. -Control up to 10 lights via Bluetooth app (requires purchase of optional Hue bridge)  Net weight 0.72 kg Cable length 2 m Height 55.3 cm Length 11.1 cm Width 11.1 cm",
    description_jpn:
      "空間を格上げするグラデーション機能搭載 1日の生活リズムを整える間接照明 目覚め・眠りに最適な間接照明 フロアライト初、映像・音楽とのシンクロ機能搭載(Philips Play HDMI Sync Boxの購入が必要になります）  -カラフルなスマート ライトでパーソナライズされた空間を構築する -シームレスに色をブレンド 1 つのライトで、なめらかに混ざりあう豊かな色彩を演出します。ライトの色が自然に溶け合う、独特の照明効果を楽しむことができます。 -Bluetooth アプリで最大 10 個の照明を制御 (別売 Hueブリッジを購入する必要があります) 正味重量 0.72 kg ケーブル長さ 2 m 高さ 55.3 cm 長さ 11.1 cm 幅  11.1 cm",
    product_image_1:
      "https://products.naganorewards.com/images/philips-hue/Philips-Hue_929003555601.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "1084",
    brand: "KAERCHER",
    sku: "1.633-658.0",
    product_eng: "KAERCHER Water Vacuum Cleaner WV 2 BLACK EDITION",
    product_jpn:
      "KAERCHER ケルヒャー ウォーターバキュームクリーナー WV 2 BLACK EDITION",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥12,800",
    rrp_with_vat: "¥14,080",
    description_eng:
      'Water Vacuum Cleaner  The water vacuum cleaner can quickly suck up "water" from around the house. The WV 2 Black Edition has a cleaning width that is 3cm longer than the WV 1 White, making it ideal for cleaning large windows and removing water droplets from bathroom walls and floors. It is also perfect for cleaning mirrors, glass surfaces, removing water droplets from the bathroom, dealing with winter condensation, and wiping windows after car washing.  Features:  Two Types of Wiper Heads for Adjustable Cleaning Widths: The 280mm width is convenient for large surfaces like windows, while the 170mm width is useful for small windows and door glass. Vacuum Function: Effectively sucks up dirt without leaving water drips or wipe marks. Spray Bottle with Wipe Pad: Spray the cleaning solution on the surface and spread it with the wipe pad to lift dirt. Easy-to-Replace Wipe Pads: One-touch replacement with Velcro. The attached tag prevents your hands from getting dirty. Rechargeable and Cordless: Can be used anywhere without the need for a power cord. Specifications:  Cleaning Width (mm): 280 Cleaning Width (Small Wiper Head) (mm): 170 Dirty Water Tank Capacity (ml): 100 Battery Operating Time (minutes): 35 Battery Charging Time (minutes): 230 Maximum Cleaning Area: Approx. 105㎡ (equivalent to 35 windows) Power Supply (V/Hz): 100 - 240 / 50 - 60 Main Unit Weight (kg): 0.6 Weight (excluding accessories) (kg): 0.6 Packaged Weight (kg): 1.2 Dimensions (L x W x H) (mm): 120 x 280 x 320 Manufacturer Warranty: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.',
    description_jpn:
      "ウォーターバキュームクリーナーは、家中の「水」をサッと吸い取る*ことができるクリーナーです。WV 2 Black Editionは清掃幅がWV 1 Whiteより3cm長いので、面積の広い窓掃除や浴室の壁・床の水滴取りに最適です。鏡やガラス面の掃除、お風呂の水滴取りや冬場の結露取り、洗車後の窓の拭き上げにも最適です。  ●2種類のワイパーヘッドで清掃幅が選べます。 280mm幅は窓ガラスなどの広い面を、170mm幅は小さな出窓やドアガラスの掃除に便利です。 ●バキューム機能で水ダレや拭き跡を残さず、汚れをしっかり吸引します。 ●ワイプパッド付きスプレーボトル 洗浄剤を清掃面に吹きかけてワイプパッドで塗り広げ、汚れを浮き立たせます。 ●交換しやすいワイプパッド 面ファスナーでワンタッチ交換。タグが付いているので手を汚しません。 ●充電式 コードレスなので、場所を選ばず使用することができます。 【仕様】 清掃幅 (mm) 280 清掃幅（ワイパーヘッド小） (mm) 170 汚水タンク容量 (ml) 100 バッテリー稼働時間 (分) 35 バッテリー充電時間 (分) 230 最大清掃可能面積 約105㎡＝窓35枚分 電源 (V/Hz) 100 - 240 / 50 - 60 本体質量 (kg) 0.6 質量（アクセサリーを含まない） (kg) 0.6 梱包質量 (kg) 1.2 寸法（長さ×幅×高さ） (mm) 120 x 280 x 320 メーカー保証 1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/1.633-658.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "1085",
    brand: "KAERCHER",
    sku: "1.600-931.0",
    product_eng: "KAERCHER K 2 Electric Pressure Washer LITTLE PREMIUM",
    product_jpn: "KAERCHER ケルヒャー 高圧洗浄機 K 2 LITTLE PREMIUM",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥16,800",
    rrp_with_vat: "¥18,480",
    description_eng:
      "Ultra-Compact K 2 Little Premium  The K 2 Little Premium is ultra-compact and doesn't take up much storage space, making it perfect for quickly removing dirt from both small areas and large outdoor surfaces like exterior walls. It comes with a wide-angle one-jet nozzle for light dirt and a powerful cyclone jet nozzle for stubborn dirt that has been left for years. You can choose the appropriate nozzle based on the type of dirt you are dealing with.  Its lightweight design and integrated handle make it easy and convenient to move around. Additionally, the longer high-pressure hose reduces the need to move the main unit, and the quick connect system allows for simple and easy operation. The gun, nozzle, power cable, and other components, including the high-pressure hose, can be stored on the main unit, making storage smarter and more organized. It is easy to carry with one hand.  Specifications:  Power Supply (V/Hz): 100 / 50 - 60 Maximum Allowable Pressure (MPa): Max 8 Water Discharge Volume (L/h): Max 330 Water Supply Temperature (°C): Max 40 Motor Output (W): 1000 Weight (excluding accessories) (kg): 3.7 Packaged Weight (kg): 5.4 Dimensions (L x W x H) (mm): 380 x 197 x 264 Accessories / Included Items:  Trigger Gun: G 120 Q One-Jet Nozzle Cyclone Jet Nozzle High-Pressure Hose: 6 m Main Unit Coupling Manufacturer Warranty: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "超コンパクトで収納場所を取らないK 2 Little Premiumは、狭い範囲から外壁など広い範囲まで車や屋外の汚れをあっという間に除去します。 広角の水がでるワンジェットノズルの他に、長年放置された頑固な汚れも一気に落とす強力サイクロンジェットノズルが付属され、落ちやすい汚れから落ちにくい汚れまで、汚れに合わせてノズルを選んで洗浄することができます。 また、軽量で一体型ハンドルのおかげで、移動も簡単便利。 さらにより長い高圧ホースで本体を移動させる手間を軽減し、クイックコネクトシステムであっという間のシンプル簡単操作も実現。 ガンやノズル、電源ケーブル、その他はんざつになりやすい高圧ホースも本体に収納でき、よりスマートに保管ができます。片手でラクに持ち運びできます。  【仕様】 電源 (V/Hz) 100 / 50 - 60 最大許容圧力 (MPa) 最大 8 吐出水量 (L/h) 最大 330 給水温度 (°C) 最大 40 モーター出力 (W) 1000 質量（アクセサリーを含まない） (kg) 3.7 梱包質量 (kg) 5.4 寸法（長さ×幅×高さ） (mm) 380 x 197 x 264 <付属品・同梱品> トリガーガン: G 120 Q 1ジェットノズル サイクロンジェットノズル 高圧ホース: 6 m 本体側カップリング メーカー保証 1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/1.600-931.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "1086",
    brand: "KAERCHER",
    sku: "1.516-451.0",
    product_eng: "KAERCHER Steam Cleaner SC 1 MINI",
    product_jpn: "KAERCHER ケルヒャー スチームクリーナー SC 1 MINI",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥11,800",
    rrp_with_vat: "¥12,980",
    description_eng:
      "Steam Cleaner That Cleans with the Power of Steam  This is the most compact and lightweight model among Kärcher's steam cleaners, but it maintains powerful steam. Recommended for those who want to quickly take it out and use it, and those with limited storage space.  99.99% Disinfection with Just Water*  Safe for children and pets. It disinfects 99.99%* of invisible bacteria and viruses with just water, without using detergents or alcohol. Ideal for disinfecting areas frequently touched by family members or areas where you do not want to use chemical products.  Quick and Easy Daily Use  Heats up in about 3 minutes, continuous spray for about 6 minutes. Perfect for everyday quick cleaning.  Compact Yet Powerful High-Temperature Steam (about 100°C)  Lifts and removes stubborn dirt effectively. It serves dual purposes of disinfection and cleaning!  Specifications:  Cleaning Area (with a full water tank) (m²): 20 Heating Output (W): 1200 Maximum Steam Output Pressure (MPa): Max 0.3 Power Cord (m): 4 Heat-up Time (minutes): 3 Boiler Capacity (L): 0.2 Power Supply (V/Hz): 100 / 50 - 60 Weight (excluding accessories) (kg): 1.6 Packaged Weight (kg): 2.2 Dimensions (L x W x H) (mm): 321 x 127 x 186 Accessories / Included Items:  Microfiber Cover for Hand Brush: 2 pieces Hand Brush Manufacturer Warranty: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "蒸気の力で汚れを落とす、スチームクリーナー。ケルヒャーのスチームクリーナの中で、一番コンパクトで軽いモデルです。でもパワフルスチームはキープ。すぐにサッと取り出して使いたい方、収納・保管場所が限られている方におススメです。 ●水だけで99.99%*除菌 お子様もペットも安心。洗剤やアルコールを使わずに水だけで、目に見えないバクテリアやウイルスを99.99％*除菌できます。ご家族がよく触れる場所や、化学製品を使いたくない場所の除菌に最適です。 ●毎日サッと使える ヒートアップは約3分、連続噴射は約6分。毎日のちょっとしたお掃除にピッタリです。 ●コンパクトなのに安定した高温（約100℃）のパワフルスチームで、頑固な汚れもしっかり浮かせて落とします。除菌＆清掃の1台2役！ 【仕様】 清掃面積（給水タンク満水で清掃できる面積） (m²) 20 加熱出力 (W) 1200 最大スチーム吐出圧力 (MPa) 最大 0.3 電源コード (m) 4 ヒートアップタイム (分) 3 ボイラー容量 (L) 0.2 電源 (V/Hz) 100 / 50 - 60 質量（アクセサリーを含まない） (kg) 1.6 梱包質量 (kg) 2.2 寸法（長さ×幅×高さ） (mm) 321 x 127 x 186 <付属品・同梱品> ハンドブラシ用マイクロファイバーカバー: 2 個 ハンドブラシ メーカー保証 1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/1.516-451.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "1087",
    brand: "KAERCHER",
    sku: "1.513-655.0",
    product_eng: "KAERCHER Steam Cleaner SC 3 EasyFix W",
    product_jpn: "KAERCHER ケルヒャー スチームクリーナー SC 3 EasyFix W",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥33,800",
    rrp_with_vat: "¥37,180",
    description_eng:
      "Heat-up Time: Approximately 35 Seconds, Refill the Water Tank for Extended Use  Recommended for busy individuals, those who frequently use steam cleaners, those with long cleaning sessions, and those who do not need the high-end features of the SC 4 Deluxe model.  Easy Operation  No cap needed—just fill with water, switch it on, and it is ready to use in 35 seconds.  Cleaning and Disinfecting Without Detergent  High-temperature steam effectively wipes away dirt, disinfects, and removes mold and viruses. Achieves a clean finish similar to using detergent with just water. Eco-friendly and safe for children and pets.  Versatile Cleaning  Clean various places easily with the included accessories. Examples of cleaning areas: dirt on the floors of living rooms and kitchens, mold in bathrooms, and grease around the kitchen.  User-Friendly Accessories  Easy to attach and remove accessories that can be reused, reducing the stress of cleaning.  Cost-Effective Steam Cleaner  Cleans various areas and disinfects with one unit. Suitable for carpets and fabric sofas that cannot be washed. Also, no need to purchase detergents or alcohol, making it very cost-effective.  Specifications:  Cleaning Area (with a full water tank) (m²): 75 Heating Output (W): 1500 Maximum Steam Output Pressure (MPa): Max 0.35 Power Cord (m): 4 Heat-up Time (seconds): 35 Boiler Capacity: 1 Tank Capacity (L): 1 Power Supply (Ph/V/Hz): 1 / 100 / 50 - 60 Weight (excluding accessories) (kg): 3.1 Packaged Weight (kg): 4.7 Dimensions (L x W x H) (mm): 360 x 236 x 253 Included Items:  Microfiber Cloth for Easy Fix: 1 piece Microfiber Cover for Hand Brush: 1 piece Descaling Cartridge Nozzle Head Hand Brush Brush (Black): 1 piece Brush (Yellow): 1 piece Floor Nozzle: Easy Fix Extension Pipe (0.5m) x2 Manufacturer Warranty: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "ヒートアップ（待ち時間）約 35 秒、スチームがなくなったら給水タンクに水を入れて続けて長く使えます。 忙しい方、頻繁にスチームクリーナーを使う方、 1 回の掃除時間が長い方、 SC 4 Deluxe （ハイエンドモデル）ほどの機能を求めない方におススメです。  ＜かんたん操作＞ キャップが無いので水を入れてスイッチを入れるだけ、その後 35 秒で使用できます。  ＜洗剤不要で掃除と除菌＞ 高温スチームで汚れをしっかり拭き取り、除菌、カビ菌やウイルスの除去もできます。 水だけで洗剤を使ったときのような仕上がりに。エコで環境に優しく、こどもやペットに安心です。  ＜いろいろな場所のお掃除に＞ 付属のアクセサリーを使って、いろいろな場所を簡単に掃除できます。 清掃場所の一例：リビングやキッチンの床の汚れ、浴室のカビ、キッチンまわりの油汚れ  ＜使いやすいアクセサリー＞ 取り付け・外しが簡単で使いまわしの良いアクセサリー、掃除のストレスが軽減します。  ＜実はコスパ最高のスチームクリーナー＞ 1 台でいろいろな場所の掃除ができる上に、除菌もできます。 洗濯ができないカーペットや布製ソファにも使えます。 また洗剤やアルコールを買う必要がないので、コストパフォーマンスは最高です。  【仕様】 清掃面積（給水タンク満水で清掃できる面積） (m²) 75 加熱出力 (W) 1500 最大スチーム吐出圧力 (MPa) 最大 0.35 電源コード (m) 4 ヒートアップタイム (秒) 35 ボイラー容量 1 タンク容量 (L) 1 電源 (Ph/V/Hz) 1 / 100 / 50 - 60 質量（アクセサリーを含まない） (kg) 3.1 梱包質量 (kg) 4.7 寸法（長さ×幅×高さ） (mm) 360 x 236 x 253 <同梱品> イージーフィックス用マイクロファイバークロス: 1 個 ハンドブラシ用マイクロファイバーカバー: 1 個 スケール除去剤カートリッジ ノズルヘッド ハンドブラシ ブラシ（黒）: 1 個 ブラシ（黄）: 1 個 フロアノズル: イージーフィックス 延長パイプ（0.5m）2本 メーカー保証 1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/1.513-655.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "1088",
    brand: "KAERCHER",
    sku: "1.513-503.0",
    product_eng: "KAERCHER Steam Mop SC 2 UPRIGHT",
    product_jpn: "KAERCHER ケルヒャー スチームモップ SC 2 UPRIGHT",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥22,800",
    rrp_with_vat: "¥25,080",
    description_eng:
      'Steam Mop that Cleans with the Power of Steam  Lightweight and compact, it is ready to use in just 40 seconds after turning on the switch. It effectively wipes off dirt without using detergent, making it eco-friendly and safe. Ideal for those who clean frequently, and homes with babies or pets.  Compact Floor Nozzle  The nozzle fits into narrow gaps, such as those in the toilet, ensuring thorough cleaning.  Cleans Under Furniture Up to 6cm  By twisting the main unit to the left or right, the floor nozzle can reach under furniture up to approximately 6cm, making it easy to clean under beds and sofas.  One-Touch Cloth Replacement  Velcro allows for easy one-touch replacement. By pulling the "tag" attached to the cloth, it can be replaced without getting your hands dirty.  Refillable for Long Use  When the steam runs out, simply refill the water tank and continue using it for a long time.  Design and Construction That Can Stand Upright  The design blends seamlessly into the room, allowing you to quickly grab it and use it whenever needed. The handle is equipped with rubber to prevent it from falling over easily.  Specifications:  Cleaning Area (with a full water tank) (m²): 50 Heating Output (W): 1500 Power Cord (m): 5 Heat-up Time (seconds): 40 Tank Capacity (L): 0.4 Power Supply (Ph/V/Hz): 1 / 100 - 240 / 50 - 60 Weight (excluding accessories) (kg): 2.5 Packaged Weight (kg): 3.5 Dimensions (L x W x H) (mm): 243 x 168 x 1185 Accessories / Included Items:  Microfiber Cloth for Easy Fix: 1 piece Descaling Cartridge Floor Nozzle: Easy Fix Manufacturer Warranty: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.',
    description_jpn:
      "蒸気の力で汚れを落とす、スチームモップ。軽くてコンパクト、スイッチを入れてたった40秒で使用可能です。洗剤を使わず汚れをしっかり拭き取るので、エコで安心。床掃除を頻繁にする方、赤ちゃんやペットがいるご家庭に最適です。  ＜コンパクトなフロアノズル＞ トイレなどの狭い隙間にもノズルが入り、しっかりキレイに。  ＜家具下6cmまで清掃可能＞ 本体を左右にどちらかにひねると、フロアノズルが約6cmの家具下まで入り込み、ベッドやソファの下も掃除が簡単。  ＜ワンタッチで交換できるクロス＞ 面ファスナーで、交換もワンタッチ。 クロスに付いている「タグ」を引っ張れば、手を汚さず交換できます。  ＜給水して長く使える＞ スチームがなくなったら、給水タンクに水を入れて続けて長く使えます。  ＜立てかけられるデザイン・設計＞ 部屋に立てかけておいても溶け込むデザインで、気になった時にサッと取りだして使えます。 ハンドル部分についてるゴムで、倒れにくい設計です。  【仕様】 清掃面積（給水タンク満水で清掃できる面積） (m²) 50 加熱出力 (W) 1500 電源コード (m) 5 ヒートアップタイム (秒) 40 タンク容量 (L) 0.4 電源 (Ph/V/Hz) 1 / 100 - 240 / 50 - 60 質量（アクセサリーを含まない） (kg) 2.5 梱包質量 (kg) 3.5 寸法（長さ×幅×高さ） (mm) 243 x 168 x 1185 <付属品・同梱品> イージーフィックス用マイクロファイバークロス: 1 個 スケール除去剤カートリッジ フロアノズル: イージーフィックス メーカー保証 1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/kaercher/1.513-503.0.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/KAERCHER.png",
  },
  {
    id: "834",
    brand: "SORI YANAGI",
    sku: "121506011225",
    product_eng: "SORI YANAGI Stainless Steel Bowl 16cm",
    product_jpn: "柳宗理 ステンレスボール 16cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,200",
    description_eng:
      "・Durable and clean stainless steel bowl made of 18-8 stainless steel ・Simple design that would not look out of place on a dining table. ・Designed after years of research based on the opinions of cooking experts and many housewives. ・Matte finish on the surface to prevent stains and scratches from showing. ・The surface has a matte finish that does not attract stains or scratches.  φ158 x H65 0.7L",
    description_jpn:
      "・18-8ステンレスを使用した丈夫で清潔なステンレスボール ・そのまま食卓にあっても違和感のないシンプルなデザイン ・料理の専門家や多くの家庭主婦の意見に基づき、長年の研究を重ねてデザイン ・表面は汚れやキズが目立たないつや消し仕上げ ・収納性と優れた安定感で、使いやすさと美しさの両立  φ158×H65 0.7L",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121506011225.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "835",
    brand: "SORI YANAGI",
    sku: "121506011226",
    product_eng: "SORI YANAGI Stainless Steel Bowl 19cm",
    product_jpn: "柳宗理 ステンレスボール 19cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,500",
    rrp_with_vat: "¥2,750",
    description_eng:
      "・Durable and clean stainless steel bowl made of 18-8 stainless steel ・Simple design that would not look out of place on a dining table. ・Designed after years of research based on the opinions of cooking experts and many housewives. ・Matte finish on the surface to prevent stains and scratches from showing. ・The surface has a matte finish that does not attract stains or scratches.  φ185×H77 1.2L",
    description_jpn:
      "・18-8ステンレスを使用した丈夫で清潔なステンレスボール ・そのまま食卓にあっても違和感のないシンプルなデザイン ・料理の専門家や多くの家庭主婦の意見に基づき、長年の研究を重ねてデザイン ・表面は汚れやキズが目立たないつや消し仕上げ ・収納性と優れた安定感で、使いやすさと美しさの両立  φ185×H77 1.2L",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121506011226.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "836",
    brand: "SORI YANAGI",
    sku: "121506011227",
    product_eng: "SORI YANAGI Stainless Steel Bowl 23cm",
    product_jpn: "柳宗理 ステンレスボール 23cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,500",
    rrp_with_vat: "¥3,850",
    description_eng:
      "・Durable and clean stainless steel bowl made of 18-8 stainless steel ・Simple design that would not look out of place on a dining table. ・Designed after years of research based on the opinions of cooking experts and many housewives. ・Matte finish on the surface to prevent stains and scratches from showing. ・The surface has a matte finish that does not attract stains or scratches.   φ231×H119 3.4L",
    description_jpn:
      "・18-8ステンレスを使用した丈夫で清潔なステンレスボール ・そのまま食卓にあっても違和感のないシンプルなデザイン ・料理の専門家や多くの家庭主婦の意見に基づき、長年の研究を重ねてデザイン ・表面は汚れやキズが目立たないつや消し仕上げ ・収納性と優れた安定感で、使いやすさと美しさの両立  φ231×H119 3.4L",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121506011227.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "837",
    brand: "SORI YANAGI",
    sku: "121506011275",
    product_eng: "SORI YANAGI Punching Strainer 16cm",
    product_jpn: "柳宗理 パンチングストレーナー ざる 16cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,200",
    description_eng:
      "This perforated strainer was designed by product designer Sori Yanagi. The perforated strainer is formed by punching holes in a single stainless steel plate, so it is less likely to get clogged or stuck than a mesh strainer. Also, the center of the bottom is slightly concave, which reduces the ground contact surface, making it excellent for draining water. φ164×H63",
    description_jpn:
      "プロダクトデザイナーの柳宗理がデザインしたパンチングストレーナーです。一枚のステンレス板に穴をあけて成型しているため、網状のざるに比べ目詰まりを起こしにくく引っかかることがありません。また底の中央部分が少し凹んでおり、接地面が少ないので水切りのよさにすぐれます。 φ193×H69",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121506011275.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "838",
    brand: "SORI YANAGI",
    sku: "121506011267",
    product_eng: "SORI YANAGI Punching Strainer 19cm",
    product_jpn: "柳宗理 パンチングストレーナー ざる  19cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,500",
    rrp_with_vat: "¥2,750",
    description_eng:
      "This perforated strainer was designed by product designer Sori Yanagi. The perforated strainer is formed by punching holes in a single stainless steel plate, so it is less likely to get clogged or stuck than a mesh strainer. Also, the center of the bottom is slightly concave, which reduces the ground contact surface, making it excellent for draining water. φ193×H69",
    description_jpn:
      "プロダクトデザイナーの柳宗理がデザインしたパンチングストレーナーです。一枚のステンレス板に穴をあけて成型しているため、網状のざるに比べ目詰まりを起こしにくく引っかかることがありません。また底の中央部分が少し凹んでおり、接地面が少ないので水切りのよさにすぐれます。 φ238×H86",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121506011267.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "839",
    brand: "SORI YANAGI",
    sku: "121506011268",
    product_eng: "SORI YANAGI Punching Strainer 23cm",
    product_jpn: "柳宗理 パンチングストレーナー ざる  23cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,500",
    rrp_with_vat: "¥3,850",
    description_eng:
      "This perforated strainer was designed by product designer Sori Yanagi. The perforated strainer is formed by punching holes in a single stainless steel plate, so it is less likely to get clogged or stuck than a mesh strainer. Also, the center of the bottom is slightly concave, which reduces the ground contact surface, making it excellent for draining water. φ238×H86",
    description_jpn:
      "プロダクトデザイナーの柳宗理がデザインしたパンチングストレーナーです。一枚のステンレス板に穴をあけて成型しているため、網状のざるに比べ目詰まりを起こしにくく引っかかることがありません。また底の中央部分が少し凹んでおり、接地面が少ないので水切りのよさにすぐれます。 φ238×H86",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121506011268.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "840",
    brand: "SORI YANAGI",
    sku: "121506011280",
    product_eng: "SORI YANAGI Punching Strainer with Handle 19cm",
    product_jpn: "柳宗理 手付きパンチングストレーナー  ざる  19cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,300",
    description_eng:
      "This perforated strainer was designed by product designer Sori Yanagi. The perforated strainer is formed by punching holes in a single stainless steel plate, so it is less likely to get clogged or stuck than a mesh strainer. The center of the bottom is slightly concave, which reduces the surface area of the strainer, making it excellent for draining water. The colander has a handle for easy draining and is hygienic since it does not come in direct contact with the hand. φ193 x 300 x 107",
    description_jpn:
      "プロダクトデザイナーの柳宗理がデザインしたパンチングストレーナーです。一枚のステンレス板に穴をあけて成型しているため、網状のざるに比べ目詰まりを起こしにくく引っかかることがありません。また底の中央部分が少し凹んでおり、接地面が少ないので水切りのよさにすぐれます。ザルに柄が付いているので水切がしやすく、直接手を触れることがないので衛生的です。 φ193×300×107",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121506011280.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "841",
    brand: "SORI YANAGI",
    sku: "121517010008",
    product_eng: "SORI YANAGI Teaspoon 5pcs",
    product_jpn: "柳宗理  ティースプーン5pcs",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,300",
    description_eng:
      "Cutlery by Sori Yanagi, the world recognized leader in Japanese industrial design. Material 18-8 stainless steel Teaspoon total length approx. 14 cm",
    description_jpn:
      "世界が認める日本工業デザインの第一人者、柳宗理のカトラリー。 素材 18-8ステンレス鋼 ティースプーン全長約14cm",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121517010008.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "842",
    brand: "SORI YANAGI",
    sku: "121517010009",
    product_eng: "SORI YANAGI Cake Fork 5pcs",
    product_jpn: "柳宗理  ケーキフォーク5pcs",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,300",
    description_eng:
      "Cutlery by Sori Yanagi, the world recognized leader in Japanese industrial design. Material 18-8 stainless steel. Cake fork total length approx. 15 cm",
    description_jpn:
      "世界が認める日本工業デザインの第一人者、柳宗理のカトラリー。 素材 18-8ステンレス鋼 ケーキフォーク全長約15cm",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121517010009.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "843",
    brand: "SORI YANAGI",
    sku: "121517010011",
    product_eng: "SORI YANAGI Teaspoon/Hime Fork 10pcs",
    product_jpn: "柳宗理  ティースプーン／ヒメフォーク 10pcs",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,500",
    description_eng:
      "Cutlery by Sori Yanagi, the world recognized leader in Japanese industrial design. Material 18-8 stainless steel Teaspoon, length approx. 14 cm Himefork, total length approx. 14 cm",
    description_jpn:
      "世界が認める日本工業デザインの第一人者、柳宗理のカトラリー。 素材 18-8ステンレス鋼 ティースプーン 全長約14cm ヒメフォーク  全長約14cm",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121517010011.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "844",
    brand: "SORI YANAGI",
    sku: "121506010028",
    product_eng: "SORI YANAGI Stainless Steel Tongue with hole",
    product_jpn: "柳宗理  ステンレストング 穴あき",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,200",
    description_eng:
      "The perforated type is useful for gripping boiled noodles and other items you want to drain off the liquid. The short handle allows for a firm grip with little effort. The simple form of the all-stainless steel design makes it beautiful even if it is used as a server for serving food on the dining table.  47 x 70 x 220",
    description_jpn:
      "穴あきタイプはゆでた麺類など汁気を切りたいものをつかむ時に便利です。 柄が短めなので少ない力でもしっかりつかむことができます。オールステンレスのシンプルなフォルムで、お料理の取り分け用サーバーとしてそのまま食卓に出しても美しいデザインです。  47×70×220",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121506010028.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "845",
    brand: "SORI YANAGI",
    sku: "121514090003",
    product_eng: "SORI YANAGI Kitchen Knife 18cm",
    product_jpn: "柳宗理  キッチンナイフ 18cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥10,000",
    rrp_with_vat: "¥11,000",
    description_eng:
      "Basic 18cm size for cutting various materials, both meat and vegetables. We use a three-layer rope made of special stainless steel with molybdenum-vanadium added for long-lasting sharpness, sandwiched in the center by tenacious 13-chrome stainless steel. This material is stainless steel for blades that combines sharpness, resistance to breakage, and resistance to rust, and each blade is carefully honed by skilled craftsmen and can be resharpened. Total length 305mm",
    description_jpn:
      "肉も野菜も、いろんな素材を切るための基本の18cmサイズ。 モリブデン・バナジウムを添加した切れ味が長続きする特殊ステンレス鋼を中心部に、粘り強い13クロームステンレスでサンドイッチした3層綱を使用しております。 この材料は鋭い切れ味と、折れにくさ、錆びにくさを併せ持つ刃物用のステンレスで、熟練の職人が一本一本丁寧に本刃付けを行っており、研ぎ直しが可能です。 全長305mm",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121514090003.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "846",
    brand: "SORI YANAGI",
    sku: "121514090002",
    product_eng: "SORI YANAGI Kitchen Knife 14cm",
    product_jpn: "柳宗理  キッチンナイフ 14cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥8,000",
    rrp_with_vat: "¥8,800",
    description_eng:
      "Easy-to-use small size 14cm We use a three-layer rope made of special stainless steel with molybdenum and vanadium added for long-lasting sharpness, sandwiched between tenacious 13 chrome stainless steel in the center. This material is stainless steel for blades that combines sharpness, resistance to breakage, and resistance to rust, and each blade is carefully honed by skilled craftsmen and can be resharpened. Total length 270 mm",
    description_jpn:
      "使いやすい小ぶりサイズ１４cm モリブデン・バナジウムを添加した切れ味が長続きする特殊ステンレス鋼を中心部に、粘り強い13クロームステンレスでサンドイッチした3層綱を使用しております。 この材料は鋭い切れ味と、折れにくさ、錆びにくさを併せ持つ刃物用のステンレスで、熟練の職人が一本一本丁寧に本刃付けを行っており、研ぎ直しが可能です。 全長 270mm",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121514090002.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "847",
    brand: "SORI YANAGI",
    sku: "121514090001",
    product_eng: "SORI YANAGI Kitchen Knife 10cm",
    product_jpn: "柳宗理  キッチンナイフ 10cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥7,000",
    rrp_with_vat: "¥7,700",
    description_eng:
      "Small vegetable and fruit knife 14 cm size. We use a three-layer rope made of special stainless steel with molybdenum-vanadium added for long-lasting sharpness, sandwiched in the center with tenacious 13 chrome stainless steel. This material is stainless steel for blades that combines sharpness, resistance to breakage, and resistance to rust, and each blade is carefully honed by skilled craftsmen and can be resharpened. Total length 216mm.",
    description_jpn:
      "小さな野菜や果物ナイフ 14cmサイズ。 モリブデン・バナジウムを添加した切れ味が長続きする特殊ステンレス鋼を中心部に、粘り強い13クロームステンレスでサンドイッチした3層綱を使用しております。 この材料は鋭い切れ味と、折れにくさ、錆びにくさを併せ持つ刃物用のステンレスで、熟練の職人が一本一本丁寧に本刃付けを行っており、研ぎ直しが可能です。 全長216mmmm",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121514090001.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "848",
    brand: "SORI YANAGI",
    sku: "121517010016",
    product_eng: "SORI YANAGI Iron Frying Pan Magma Plate 18cm",
    product_jpn: "柳宗理  鉄フライパン マグマプレート 18cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥4,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      'Magma plate processing is a special processing in which Nambu ironware-like unevenness is raised on both the front and back surfaces of the blue tempered material, a black oxide coating is applied to protect the surface, and a silicon resin coating is applied to the surface of the surface. The surface is coated with silicon resin to protect the surface. The surface makes contact with the food at random points, and oil is easily absorbed, thus preventing scorching and sticking. The increased surface area also allows it to receive more heat and heat food quickly. The durability of iron allows for hard use, such as cooking over high heat or using metal tools.  The double-fiber nitriding process is applied to both sides of the pan by floating fibrous bumps and applying a "nitriding process" that hardens the surface of the iron with nitrogen.  Nitriding is a surface treatment technology that has been used to prevent rust on aircraft and automobile parts. By hardening the surface of iron with nitrogen, high corrosion and wear resistance is achieved. Nitrogen soaks into the iron, making it difficult to peel off and resistant to abrasion, thus ensuring a long life.  The uneven surface of the steel comes in contact with food at random points, and the more it is used, the more it becomes non-stick and rust resistant, since it also blends well with oil. Since no fluorine or other coating is required, the pan has the durability that only an iron frying pan can offer, and can be enjoyed even when used hard, such as for cooking over high heat.  18cm ／W338×D218×H72',
    description_jpn:
      "マグマプレート加工はブルーテンパ材の表裏両面に南部鉄器風の凹凸を浮き立たせ、表面保護のための黒色酸化皮膜、さらにその表面にはシリコン樹脂塗装を施した特殊加工です。食材とランダムな点で接触し、油なじみも良いのでこげつきやこびりつきを抑えます。また表面積が増えたことで、より多くの熱を受け、素早く食材を加熱します。鉄ならではの耐久性があり、強火調理や金属製ツールの使用などハードな使い方も可能です。  ダブルファイバー窒化加工はフライパンの両面に繊維状の凸凹を浮き立たせ、鉄の表面を窒素で硬化させる「窒化加工」を施して施しています。  「窒化加工」は航空機や自動車部品のサビ防止に用いられてきた表面加工技術です。鉄の表面を窒素で硬化させることで、高い耐腐食性と耐摩耗性を持たせています。窒素は鉄に浸み込んでおり、はがれにくく、摩耗しにくいので長持ちします。  表面の凹凸は、食材とランダムな点で接し、油なじみもよいので使っていくほどに焦げ付きにくく、さびにくくなります。フッ素などのコーティングが必要ないため、鉄フライパンならではの耐久性があり、強火料理などのハードな使用もお楽しみいただけます。  18cm ／W338×D218×H72",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121517010016.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "849",
    brand: "SORI YANAGI",
    sku: "121517010017",
    product_eng: "SORI YANAGI Iron Frying Pan Magma Plate 22cm",
    product_jpn: "柳宗理  鉄フライパン マグマプレート 22cm",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥5,800",
    rrp_with_vat: "¥6,380",
    description_eng:
      'Magma plate processing is a special processing in which Nambu ironware-like unevenness is raised on both the front and back surfaces of the blue tempered material, a black oxide coating is applied to protect the surface, and a silicon resin coating is applied to the surface of the surface. The surface is coated with silicon resin to protect the surface. The surface makes contact with the food at random points, and oil is easily absorbed, thus preventing scorching and sticking. The increased surface area also allows it to receive more heat and heat food quickly. The durability of iron allows for hard use, such as cooking over high heat or using metal tools.  The double-fiber nitriding process is applied to both sides of the pan by floating fibrous bumps and applying a "nitriding process" that hardens the surface of the iron with nitrogen.  Nitriding is a surface treatment technology that has been used to prevent rust on aircraft and automobile parts. By hardening the surface of iron with nitrogen, high corrosion and wear resistance is achieved. Nitrogen soaks into the iron, making it difficult to peel off and resistant to abrasion, thus ensuring a long life.  The uneven surface of the steel comes in contact with food at random points, and the more it is used, the more it becomes non-stick and rust resistant, since it also blends well with oil. Since no fluorine or other coating is required, the pan has the durability that only an iron frying pan can offer, and can be enjoyed even when used hard, such as for cooking over high heat.  22cm ／W400×D260×H100',
    description_jpn:
      "マグマプレート加工はブルーテンパ材の表裏両面に南部鉄器風の凹凸を浮き立たせ、表面保護のための黒色酸化皮膜、さらにその表面にはシリコン樹脂塗装を施した特殊加工です。食材とランダムな点で接触し、油なじみも良いのでこげつきやこびりつきを抑えます。また表面積が増えたことで、より多くの熱を受け、素早く食材を加熱します。鉄ならではの耐久性があり、強火調理や金属製ツールの使用などハードな使い方も可能です。  ダブルファイバー窒化加工はフライパンの両面に繊維状の凸凹を浮き立たせ、鉄の表面を窒素で硬化させる「窒化加工」を施して施しています。  「窒化加工」は航空機や自動車部品のサビ防止に用いられてきた表面加工技術です。鉄の表面を窒素で硬化させることで、高い耐腐食性と耐摩耗性を持たせています。窒素は鉄に浸み込んでおり、はがれにくく、摩耗しにくいので長持ちします。  表面の凹凸は、食材とランダムな点で接し、油なじみもよいので使っていくほどに焦げ付きにくく、さびにくくなります。フッ素などのコーティングが必要ないため、鉄フライパンならではの耐久性があり、強火料理などのハードな使用もお楽しみいただけます。  22cm ／W400×D260×H100",
    product_image_1:
      "https://products.naganorewards.com/images/sori-yanagi/SORI-YANAGI_121517010017.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/Sori-Yanagi.png",
  },
  {
    id: "850",
    brand: "DANSK",
    sku: "121509030104",
    product_eng: "DANSK BISTRO Mug",
    product_jpn: "DANSK BISTRO マグ",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥1,800",
    rrp_with_vat: "¥1,980",
    description_eng:
      "The blue lines on the white background are reminiscent of the sea and old Denmark. This work was designed from hotel kitchen tiles while based on the traditional Danish country style.  Product size: approx. φ76 x H107 (mm) Capacity: Approx. 300 ml Material: Porcelain Country of origin: Thailand Microwave and dishwasher: OK",
    description_jpn:
      "白地に映える青のラインは海と古きデンマークをイメージ。 デンマークの伝統的なカントリースタイルに基づきながらホテルのキッチンタイルよりデザインされた作品です。  ■商品サイズ：約φ76×H107（mm） ■容量：約300ml ■材質：磁器 ■原産国：タイ ■電子レンジ・食洗機：OK",
    product_image_1:
      "https://products.naganorewards.com/images/dansk/DANSK_121509030104.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/DANSK.png",
  },
  {
    id: "851",
    brand: "DANSK",
    sku: "121509030115",
    product_eng: "DANSK BISTRO Pasta Bowl",
    product_jpn: "DANSK BISTRO パスタボウル",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,800",
    rrp_with_vat: "¥3,080",
    description_eng:
      "The blue lines on the white background are reminiscent of the sea and old Denmark. This work was designed from hotel kitchen tiles while based on the traditional Danish country style.  Product size: approx. 205 x H57mm Capacity: approx. 1070ml Material: Porcelain Country of origin: Thailand Microwave and dishwasher: OK",
    description_jpn:
      "白地に映える青のラインは海と古きデンマークをイメージ。 デンマークの伝統的なカントリースタイルに基づきながらホテルのキッチンタイルよりデザインされた作品です。  ■商品サイズ：約205×H57mm ■容量：約1070ml ■材質：磁器 ■原産国：タイ ■電子レンジ・食洗機：OK",
    product_image_1:
      "https://products.naganorewards.com/images/dansk/DANSK_121509030115.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/DANSK.png",
  },
  {
    id: "852",
    brand: "DANSK",
    sku: "121509030112",
    product_eng: "DANSK BISTRO Cereal Bowl",
    product_jpn: "DANSK BISTRO シリアルボウル",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥1,800",
    rrp_with_vat: "¥1,980",
    description_eng:
      "The blue lines on the white background are reminiscent of the sea and old Denmark. This work was designed from hotel kitchen tiles while based on the traditional Danish country style.  Product size: 130 x H58mm approx. Capacity: approx. 450 ml Material: Porcelain Country of origin: Thailand Microwave and dishwasher: OK",
    description_jpn:
      "白地に映える青のラインは海と古きデンマークをイメージ。 デンマークの伝統的なカントリースタイルに基づきながらホテルのキッチンタイルよりデザインされた作品です。  ■商品サイズ：約130×H58mm ■容量：約450ml ■材質：磁器 ■原産国：タイ ■電子レンジ・食洗機：OK",
    product_image_1:
      "https://products.naganorewards.com/images/dansk/DANSK_121509030112.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/DANSK.png",
  },
  {
    id: "853",
    brand: "DANSK",
    sku: "121509030100",
    product_eng: "DANSK BISTRO Dinner Plate",
    product_jpn: "DANSK BISTRO ディナープレート",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,800",
    rrp_with_vat: "¥3,080",
    description_eng:
      "The blue lines on the white background are reminiscent of the sea and old Denmark. This work was designed from hotel kitchen tiles while based on the traditional Danish country style.  Product size: approx. 26.5 x height 2.4 cm  Weight: approx. 0.8 kg  Material: Porcelain Country of origin: Thailand Microwave and dishwasher: OK",
    description_jpn:
      "白地に映える青のラインは海と古きデンマークをイメージ。 デンマークの伝統的なカントリースタイルに基づきながらホテルのキッチンタイルよりデザインされた作品です。  ■商品サイズ：約26.5×高さ2.4cm  ■本体重量:約0.8kg  ■材質：磁器 ■原産国：タイ ■電子レンジ・食洗機：OK",
    product_image_1:
      "https://products.naganorewards.com/images/dansk/DANSK_121509030100.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/DANSK.png",
  },
  {
    id: "854",
    brand: "DANSK",
    sku: "121509030101",
    product_eng: "DANSK BISTRO Salada Plate",
    product_jpn: "DANSK BISTRO サラダプレート",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,000",
    rrp_with_vat: "¥2,200",
    description_eng:
      "The blue lines on the white background are reminiscent of the sea and old Denmark. This work was designed from hotel kitchen tiles while based on the traditional Danish country style.  Product size: approx. 225 x H23 mm Material: Porcelain Country of origin: Thailand Microwave and dishwasher: OK",
    description_jpn:
      "白地に映える青のラインは海と古きデンマークをイメージ。 デンマークの伝統的なカントリースタイルに基づきながらホテルのキッチンタイルよりデザインされた作品です。  ■商品サイズ：約225×H23mm ■材質：磁器 ■原産国：タイ ■電子レンジ・食洗機：OK",
    product_image_1:
      "https://products.naganorewards.com/images/dansk/DANSK_121509030101.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/DANSK.png",
  },
  {
    id: "855",
    brand: "DANSK",
    sku: "121509030102",
    product_eng: "DANSK BISTRO Bread Plate",
    product_jpn: "DANSK BISTRO パンプレート",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥1,500",
    rrp_with_vat: "¥1,650",
    description_eng:
      "The blue lines on the white background are reminiscent of the sea and old Denmark. This work was designed from hotel kitchen tiles while based on the traditional Danish country style.  Product size: about 183 x H20mm Material: Porcelain Country of origin: Thailand Microwave and dishwasher: OK",
    description_jpn:
      "白地に映える青のラインは海と古きデンマークをイメージ。 デンマークの伝統的なカントリースタイルに基づきながらホテルのキッチンタイルよりデザインされた作品です。  ■商品サイズ：約183×H20mm ■材質：磁器 ■原産国：タイ ■電子レンジ・食洗機：OK",
    product_image_1:
      "https://products.naganorewards.com/images/dansk/DANSK_121509030102.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/DANSK.png",
  },
  {
    id: "856",
    brand: "DANSK",
    sku: "121509100013",
    product_eng: "DANSK ARABESQUE Mug",
    product_jpn: "DANSK ARABESQUE マグ",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,500",
    rrp_with_vat: "¥2,750",
    description_eng:
      "The Arabesque series is one of DANSK's most popular. The Arabesque series is hand painted by skilled craftsmen, brush by brush. The bold and spontaneous brush strokes and the vivid cobalt blue coloring on the white background remind us of the tropical sea.  8 cm (diameter) X 11 cm (height)  Material: Porcelain Country of origin: Sri Lanka Capacity: 320cc  Microwave and dishwasher safe: OK",
    description_jpn:
      "ＤＡＮＳＫの中でひときわ人気の高いアラベスクシリーズ。熟練の職人たちによってひと筆ひと筆描かれたハンドペイントです。大胆でのびやかな筆遣いと白地を彩る鮮やかなコバルトブルーが、南国の海を連想させます。  ■口径8×高さ11㎝  ■材質：磁器 ■原産国：スリランカ ■容量:320cc  ■電子レンジ・食洗機：OK",
    product_image_1:
      "https://products.naganorewards.com/images/dansk/DANSK_121509100013.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/DANSK.png",
  },
  {
    id: "857",
    brand: "DANSK",
    sku: "121509100005",
    product_eng: "DANSK ARABESQUE Luncheon Plate",
    product_jpn: "DANSK ARABESQUE ランチョンプレート",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥4,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      "The Arabesque series is one of DANSK's most popular. The Arabesque series is hand painted by skilled craftsmen, brush by brush. The bold and spontaneous brush strokes and the vivid cobalt blue coloring on the white background remind us of the tropical sea.  24 cm (width) X 24 cm (depth) X 2.7 cm (height) Material: Porcelain Country of origin: Sri Lanka Weight: 735g   Microwave and dishwasher safe: OK",
    description_jpn:
      "ＤＡＮＳＫの中でひときわ人気の高いアラベスクシリーズ。熟練の職人たちによってひと筆ひと筆描かれたハンドペイントです。大胆でのびやかな筆遣いと白地を彩る鮮やかなコバルトブルーが、南国の海を連想させます。  ■幅24×奥行24×高さ2.7cm ■材質：磁器 ■原産国：スリランカ ■本体重量:735g   ■電子レンジ・食洗機：OK",
    product_image_1:
      "https://products.naganorewards.com/images/dansk/DANSK_121509100005.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/DANSK.png",
  },
  {
    id: "864",
    brand: "GARMIN",
    sku: "010-02784-41",
    product_eng: "GARMIN Venu 3 Regular size Black/Slate",
    product_jpn: "GARMIN Venu 3 レギュラーサイズ Black/Slate",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥55,273",
    rrp_with_vat: "¥60,800",
    description_eng:
      'Garmin is a pioneering GPS company founded in the United States in 1989. Leveraging technology cultivated in products for the aviation, marine, and automotive industries, which demand high reliability, Garmin develops high-quality products for the outdoor fitness field as well. It features dependable hardware with a long-life battery & tough construction.  A popular GPS smartwatch with a wealth of health monitoring and fitness functions, as well as notifications and payment functions to make your life smarter Venu 3 is a smartwatch with health monitoring and fitness features. It helps you achieve your health and fitness goals by getting to know yourself thoroughly. It also supports useful features for everyday life, such as Suica, notifications, and calls on the watch.  ■Long battery life The watch runs for about 14 days in smartwatch mode and about 26 hours in GPS mode. ■Sleep monitoring with sleep coach ■Automatically measures not only nighttime sleep, but also naps. ■Body Battery, a unique Garmin feature, measures how much physical energy is left in your body, or "body battery life. ■More than 30 sports apps are built in. Over 30 built-in sports apps allow you to challenge yourself in a variety of sports. ■Built-in speaker and microphone. ■Morning report. When you wake up in the morning, you can check information such as sleep, recovery, training summary, HRV status, and weather at a glance. ■Stress level score is calculated and displayed according to heart rate variability. ■Oxygen levels taken up into the blood can be measured on the wrist. ■HRV Status, based on technology developed by Firstbeat Analytics, gives you a deeper understanding of your health and training performance. ■Health Tracking for Women Track your menstrual cycle and pregnancy with the Garmin Connect app. ■Guided meditation activities to reduce stress, anxiety, and more. ■Do breathwork activities when you need to relax or focus. Track your stress and breath to better understand your breathing. ■Function to estimate your "body age" based on your actual age, physical activity, resting heart rate, height and weight, etc. ■Watch videos of workouts such as strength training, yoga, Pilates, cardio, and more while you train. ■Receive audio alerts from the watch during running/walking activities ■Track your daily workouts, weight transfer alerts, sports apps, wheelchair workouts, and more. ■Garmin Pay/Suica touch payment. You can also use Garmin Pay to make payments through partner providers. ■Store music on your watch ■Pair your watch with your smartphone to send a request for assistance or automatically send a location-based message when an accident is detected during an activity.  Case size 45x 45x 12mm Display size 1.4 inches (35.4 mm) in diameter Resolution 454 x 454 pixels Weight 30 g (47 g with standard accessory band) Waterproof rating 5 ATM',
    description_jpn:
      "Garmin（ガーミン）は1989年にアメリカで創業したGPSのパイオニア企業です。 高い信頼性が要求される航空・海洋・自動車産業向け製品で培った技術を生かし、アウトドア・フィットネスの分野でも高品質な製品をを開発しています。 長寿命バッテリー＆タフな構造の頼れるハードウェアが特徴です。  豊富なヘルスモニタリングやフィットネス機能に加え、生活をスマートにする通知機能や決済機能を搭載した人気のGPSスマートウォッチ Venu 3（ヴェニュー スリー） は、健康モニタリング機能やフィットネス機能を搭載したスマートウォッチです。 自分のことをとことん知ることで、健康やフィットネスの目標達成をサポート。 日常生活に役立つ、Suica、通知機能、ウォッチでの通話などの便利な機能にも対応しています。  ■長時間バッテリー スマートウォッチモードで約14日間、GPSモードで約26時間稼働します。 ■睡眠コーチ付きの睡眠モニタリング ■夜の眠りだけでなく、昼寝も自動的に計測。 ■Garmin独自の機能であるBody Batteryでは、身体的エネルギーの残量、つまり「カラダのバッテリー残量」を測定できます。 ■30以上のスポーツアプリを内蔵。いろいろなスポーツにチャレンジできます。 ■スピーカーとマイクを内蔵 ■モーニングレポート。朝起きたときに、睡眠、回復、トレーニングの概要、HRVステータス、天気などの情報を一目でチェックできます。 ■心拍変動によりストレスレベルのスコアを計算して表示します。 ■血液中に取り込まれた酸素のレベルを手首で測定することができます。 ■Firstbeat Analyticsが開発した技術に基づくHRVステータスによって、健康とトレーニングパフォーマンスについてより深く理解することができます。 ■女性のための健康トラッキング Garmin Connect アプリで、生理周期や妊娠をトラッキングしましょう。 ■ガイド付きの瞑想アクティビティを実践して、ストレスや不安などを軽減しましょう。 ■リラックスや集中したい時はブレスワークアクティビティを行いましょう。ストレスと呼吸をトラッキングすることで、自分の呼吸についてより良く理解できます。 ■実年齢や運動量、安静時の心拍数、身長・体重などから「身体の年齢」を推定する機能付き ■筋トレ、ヨガ、ピラティス、カーディオ（有酸素運動）やなどのワークアウトの動画をウォッチで確認しながらトレーニングできます。 ■ランニング/ウォーキングアクティビティ中にウォッチから音声アラートを受け取れます ■毎日の運動量を記録したり、体重移動アラート、スポーツアプリ、車いす向けのワークアウトなどを利用できます。 ■Garmin Pay/Suica タッチ決済。またGarmin Payで提携プロバイダを通した決済を行えます。 ■ウォッチに音楽を保存 ■ウォッチとスマートフォンをペアリングすれば、援助要請を送信したり、アクティビティ中の事故を検出した際に位置情報付きのメッセージを自動送信できます。  ケースサイズ 45x 45x 12mm ディスプレイサイズ 直径1.4インチ (35.4 mm) 解像度 454 x 454 ピクセル 重量 30 g (標準付属バンド込み：47 g) 防水等級 5 ATM",
    product_image_1:
      "https://products.naganorewards.com/images/garmin/GARMIN_010-02784-41.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/GARMIN.png",
  },
  {
    id: "865",
    brand: "GARMIN",
    sku: "010-02784-40",
    product_eng: "GARMIN Venu 3 Regular size Whitestone/Silver",
    product_jpn: "GARMIN Venu 3 レギュラーサイズ Whitestone/Silver",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥55,273",
    rrp_with_vat: "¥60,800",
    description_eng:
      'Garmin is a pioneering GPS company founded in the United States in 1989. Leveraging technology cultivated in products for the aviation, marine, and automotive industries, which demand high reliability, Garmin develops high-quality products for the outdoor fitness field as well. It features dependable hardware with a long-life battery & tough construction.  A popular GPS smartwatch with a wealth of health monitoring and fitness functions, as well as notifications and payment functions to make your life smarter Venu 3 is a smartwatch with health monitoring and fitness features. It helps you achieve your health and fitness goals by getting to know yourself thoroughly. It also supports useful features for everyday life, such as Suica, notifications, and calls on the watch.  ■Long battery life The watch runs for about 14 days in smartwatch mode and about 26 hours in GPS mode. ■Sleep monitoring with sleep coach ■Automatically measures not only nighttime sleep, but also naps. ■Body Battery, a unique Garmin feature, measures how much physical energy is left in your body, or "body battery life. ■More than 30 sports apps are built in. Over 30 built-in sports apps allow you to challenge yourself in a variety of sports. ■Built-in speaker and microphone. ■Morning report. When you wake up in the morning, you can check information such as sleep, recovery, training summary, HRV status, and weather at a glance. ■Stress level score is calculated and displayed according to heart rate variability. ■Oxygen levels taken up into the blood can be measured on the wrist. ■HRV Status, based on technology developed by Firstbeat Analytics, gives you a deeper understanding of your health and training performance. ■Health Tracking for Women Track your menstrual cycle and pregnancy with the Garmin Connect app. ■Guided meditation activities to reduce stress, anxiety, and more. ■Do breathwork activities when you need to relax or focus. Track your stress and breath to better understand your breathing. ■Function to estimate your "body age" based on your actual age, physical activity, resting heart rate, height and weight, etc. ■Watch videos of workouts such as strength training, yoga, Pilates, cardio, and more while you train. ■Receive audio alerts from the watch during running/walking activities ■Track your daily workouts, weight transfer alerts, sports apps, wheelchair workouts, and more. ■Garmin Pay/Suica touch payment. You can also use Garmin Pay to make payments through partner providers. ■Store music on your watch ■Pair your watch with your smartphone to send a request for assistance or automatically send a location-based message when an accident is detected during an activity.  Case size 45x 45x 12mm Display size 1.4 inches (35.4 mm) in diameter Resolution 454 x 454 pixels Weight 30 g (47 g with standard accessory band) Waterproof rating 5 ATM',
    description_jpn:
      "Garmin（ガーミン）は1989年にアメリカで創業したGPSのパイオニア企業です。 高い信頼性が要求される航空・海洋・自動車産業向け製品で培った技術を生かし、アウトドア・フィットネスの分野でも高品質な製品をを開発しています。 長寿命バッテリー＆タフな構造の頼れるハードウェアが特徴です。  豊富なヘルスモニタリングやフィットネス機能に加え、生活をスマートにする通知機能や決済機能を搭載した人気のGPSスマートウォッチ Venu 3（ヴェニュー スリー） は、健康モニタリング機能やフィットネス機能を搭載したスマートウォッチです。 自分のことをとことん知ることで、健康やフィットネスの目標達成をサポート。 日常生活に役立つ、Suica、通知機能、ウォッチでの通話などの便利な機能にも対応しています。  ■長時間バッテリー スマートウォッチモードで約14日間、GPSモードで約26時間稼働します。 ■睡眠コーチ付きの睡眠モニタリング ■夜の眠りだけでなく、昼寝も自動的に計測。 ■Garmin独自の機能であるBody Batteryでは、身体的エネルギーの残量、つまり「カラダのバッテリー残量」を測定できます。 ■30以上のスポーツアプリを内蔵。いろいろなスポーツにチャレンジできます。 ■スピーカーとマイクを内蔵 ■モーニングレポート。朝起きたときに、睡眠、回復、トレーニングの概要、HRVステータス、天気などの情報を一目でチェックできます。 ■心拍変動によりストレスレベルのスコアを計算して表示します。 ■血液中に取り込まれた酸素のレベルを手首で測定することができます。 ■Firstbeat Analyticsが開発した技術に基づくHRVステータスによって、健康とトレーニングパフォーマンスについてより深く理解することができます。 ■女性のための健康トラッキング Garmin Connect アプリで、生理周期や妊娠をトラッキングしましょう。 ■ガイド付きの瞑想アクティビティを実践して、ストレスや不安などを軽減しましょう。 ■リラックスや集中したい時はブレスワークアクティビティを行いましょう。ストレスと呼吸をトラッキングすることで、自分の呼吸についてより良く理解できます。 ■実年齢や運動量、安静時の心拍数、身長・体重などから「身体の年齢」を推定する機能付き ■筋トレ、ヨガ、ピラティス、カーディオ（有酸素運動）やなどのワークアウトの動画をウォッチで確認しながらトレーニングできます。 ■ランニング/ウォーキングアクティビティ中にウォッチから音声アラートを受け取れます ■毎日の運動量を記録したり、体重移動アラート、スポーツアプリ、車いす向けのワークアウトなどを利用できます。 ■Garmin Pay/Suica タッチ決済。またGarmin Payで提携プロバイダを通した決済を行えます。 ■ウォッチに音楽を保存 ■ウォッチとスマートフォンをペアリングすれば、援助要請を送信したり、アクティビティ中の事故を検出した際に位置情報付きのメッセージを自動送信できます。  ケースサイズ 45x 45x 12mm ディスプレイサイズ 直径1.4インチ (35.4 mm) 解像度 454 x 454 ピクセル 重量 30 g (標準付属バンド込み：47 g) 防水等級 5 ATM",
    product_image_1:
      "https://products.naganorewards.com/images/garmin/GARMIN_010-02784-40.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/GARMIN.png",
  },
  {
    id: "872",
    brand: "GARMIN",
    sku: "010-02809-60",
    product_eng: "GARMIN Forerunner 965 Black",
    product_jpn: "GARMIN Forerunner 965 ブラック",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      'Garmin is a pioneering GPS company founded in the United States in 1989. Leveraging technology cultivated in products for the aviation, marine, and automotive industries, which demand high reliability, Garmin develops high-quality products in the field of outdoor fitness as well. It features dependable hardware with a long-life battery & tough construction.  The FORERUNNER 965 is a GPS running smartwatch with a colorful AMOLED touch display and titanium bezel. It is equipped with functions for effective training and daily health management, as well as full-color maps, so you can train with peace of mind anywhere.  ■Japan DKG Map (Japan Detailed Topographic Map 2500/25000) Full-color detailed topographic map of Japan is included. ■Predict your finish time based on course data, weather forecast, and performance, and prepare for your next race with training tips and recommended workouts. ■Recommended workouts are suggested based on your training and recovery status and the races scheduled in the Garmin Connect Mobile app calendar. ■Wrist optical heart rate monitor measures how much power you are applying to the ground. ■PacePro function Guides you based on your target time, preferred pacing, and course data to help you keep pace. ■ClimbPro function Displays the gradient, distance, and amount of ascent for the current and upcoming ascending sections on the course in real time. ■Real-time monitoring of remaining stamina helps prevent running out of stamina in the second half of the race. ■In addition to analyzing your sleep stage, you can track your heart rate, blood oxygen level, and respiratory rate during sleep. ■Body Battery Energy Monitor A unique Garmin feature, Body Battery measures how much physical energy you have left in your body, or "body battery power," so ■you can determine if you\'ve had a calm day or a balanced day. ■Find out if you are having a calm, balanced, or stressful day.   Size 47.2 x 47.2 x 13.2 mm Display size 1.4 inches (35.4 mm) in diameter Resolution 454 x 454 pixels Weight 53 g Waterproof rating 5 ATM',
    description_jpn:
      "Garmin（ガーミン）は1989年にアメリカで創業したGPSのパイオニア企業です。 高い信頼性が要求される航空・海洋・自動車産業向け製品で培った技術を生かし、アウトドア・フィットネスの分野でも高品質な製品をを開発しています。 長寿命バッテリー＆タフな構造の頼れるハードウェアが特徴です。  FORERUNNER 965は、色鮮やかなAMOLEDタッチディスプレイとチタンベゼルを備えたGPSランニングスマートウォッチです。効果的なトレーニングや日頃の健康管理のための機能やフルカラーの地図が搭載されているため、どこでも安心してトレーニングが可能です。  ■Japan DKG Map（日本詳細地形図 2500/25000）フルカラーの日本詳細地形図が搭載 ■コースデータや天気予報、パフォーマンスに基づいて完走時間を予測し、トレーニングのヒントやおすすめワークアウトで次のレースに向けて準備できます。 ■トレーニングとリカバリーの状況やGarmin Connect Mobileアプリのカレンダーにスケジュールされたレースの予定を考慮しておすすめワークアウトが提案されます。 ■手首の光学式心拍計で地面にどれだけのパワーを加えているかを計測できます。 ■PacePro機能 目標タイムや好みのペース配分、コースデータに基づくガイドで、ペースを保つのに役立ちます。 ■ClimbPro機能 コース上の現在までとこれからの上昇区間の勾配や距離、上昇量をリアルタイムで表示します。 ■スタミナの残量をリアルタイムで把握することで、レース後半のスタミナ切れを防ぎます。 ■睡眠段階の分析に加えて、睡眠中の心拍数や血中酸素レベル、呼吸数をトラッキングすることができます。 ■Body Battery エネルギーモニター Garmin独自の機能であるBody Batteryでは、身体的エネルギーの残量、つまり「カラダのバッテリー残量」を測定できます。 ■落ち着いた1日なのか、バランスのとれた1日なのか、それともストレスの多い1日を過ごしているのかを確認します。   サイズ 47.2 x 47.2 x 13.2 mm ディスプレイサイズ 直径1.4インチ (35.4 mm) 解像度 454 x 454 ピクセル 重量 53 g 防水等級 5 ATM",
    product_image_1:
      "https://products.naganorewards.com/images/garmin/GARMIN_010-02809-60.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/GARMIN.png",
  },
  {
    id: "873",
    brand: "GARMIN",
    sku: "010-02809-61",
    product_eng: "GARMIN Forerunner 965 White",
    product_jpn: "GARMIN Forerunner 965 ホワイト",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      'Garmin is a pioneering GPS company founded in the United States in 1989. Leveraging technology cultivated in products for the aviation, marine, and automotive industries, which demand high reliability, Garmin develops high-quality products in the field of outdoor fitness as well. It features dependable hardware with a long-life battery & tough construction.  The FORERUNNER 965 is a GPS running smartwatch with a colorful AMOLED touch display and titanium bezel. It is equipped with functions for effective training and daily health management, as well as full-color maps, so you can train with peace of mind anywhere.  ■Japan DKG Map (Japan Detailed Topographic Map 2500/25000) Full-color detailed topographic map of Japan is included. ■Predict your finish time based on course data, weather forecast, and performance, and prepare for your next race with training tips and recommended workouts. ■Recommended workouts are suggested based on your training and recovery status and the races scheduled in the Garmin Connect Mobile app calendar. ■Wrist optical heart rate monitor measures how much power you are applying to the ground. ■PacePro function Guides you based on your target time, preferred pacing, and course data to help you keep pace. ■ClimbPro function Displays the gradient, distance, and amount of ascent for the current and upcoming ascending sections on the course in real time. ■Real-time monitoring of remaining stamina helps prevent running out of stamina in the second half of the race. ■In addition to analyzing your sleep stage, you can track your heart rate, blood oxygen level, and respiratory rate during sleep. ■Body Battery Energy Monitor A unique Garmin feature, Body Battery measures how much physical energy you have left in your body, or "body battery power," so ■you can determine if you\'ve had a calm day or a balanced day. ■Find out if you are having a calm, balanced, or stressful day.   Size 47.2 x 47.2 x 13.2 mm Display size 1.4 inches (35.4 mm) in diameter Resolution 454 x 454 pixels Weight 53 g Waterproof rating 5 ATM',
    description_jpn:
      "Garmin（ガーミン）は1989年にアメリカで創業したGPSのパイオニア企業です。 高い信頼性が要求される航空・海洋・自動車産業向け製品で培った技術を生かし、アウトドア・フィットネスの分野でも高品質な製品をを開発しています。 長寿命バッテリー＆タフな構造の頼れるハードウェアが特徴です。  FORERUNNER 965は、色鮮やかなAMOLEDタッチディスプレイとチタンベゼルを備えたGPSランニングスマートウォッチです。効果的なトレーニングや日頃の健康管理のための機能やフルカラーの地図が搭載されているため、どこでも安心してトレーニングが可能です。  ■Japan DKG Map（日本詳細地形図 2500/25000）フルカラーの日本詳細地形図が搭載 ■コースデータや天気予報、パフォーマンスに基づいて完走時間を予測し、トレーニングのヒントやおすすめワークアウトで次のレースに向けて準備できます。 ■トレーニングとリカバリーの状況やGarmin Connect Mobileアプリのカレンダーにスケジュールされたレースの予定を考慮しておすすめワークアウトが提案されます。 ■手首の光学式心拍計で地面にどれだけのパワーを加えているかを計測できます。 ■PacePro機能 目標タイムや好みのペース配分、コースデータに基づくガイドで、ペースを保つのに役立ちます。 ■ClimbPro機能 コース上の現在までとこれからの上昇区間の勾配や距離、上昇量をリアルタイムで表示します。 ■スタミナの残量をリアルタイムで把握することで、レース後半のスタミナ切れを防ぎます。 ■睡眠段階の分析に加えて、睡眠中の心拍数や血中酸素レベル、呼吸数をトラッキングすることができます。 ■Body Battery エネルギーモニター Garmin独自の機能であるBody Batteryでは、身体的エネルギーの残量、つまり「カラダのバッテリー残量」を測定できます。 ■落ち着いた1日なのか、バランスのとれた1日なのか、それともストレスの多い1日を過ごしているのかを確認します。   サイズ 47.2 x 47.2 x 13.2 mm ディスプレイサイズ 直径1.4インチ (35.4 mm) 解像度 454 x 454 ピクセル 重量 53 g 防水等級 5 ATM",
    product_image_1:
      "https://products.naganorewards.com/images/garmin/GARMIN_010-02809-61.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/GARMIN.png",
  },
  {
    id: "874",
    brand: "GARMIN",
    sku: "010-02562-40",
    product_eng: "GARMIN ForeAthlete 55 Black",
    product_jpn: "GARMIN ForeAthlete 55 ブラック",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥29,091",
    rrp_with_vat: "¥32,000",
    description_eng:
      "Garmin is a pioneering GPS company founded in the United States in 1989. Leveraging technology cultivated in products for the aviation, marine, and automotive industries, which demand high reliability, Garmin develops high-quality products in the field of outdoor fitness as well. It features dependable hardware with a long-life battery & tough construction.  Become a runner yourself with this Watch! ForeAthlete 55 is a GPS running watch that helps you achieve your fitness goals with training guidance and running features.  ■Built-in GPS - Track where you are running and get accurate statistics such as distance, pace, and intervals. ■Heart rate data1 -Get alerts when your heart rate stays high even when you are at rest  ■GARMIN COACH -A free app that provides you with advice and training plans from expert coaches to help you achieve your various goals. Training plans can be instantly transferred to your watch. ■PACEPRO - This feature guides your pace based on GPS for the selected course or distance. This allows you to make adjustments to meet your goals on your own. ■Simply set the distance and the estimated time of arrival is displayed on the screen. ■The recovery advisor tells you how long you need to rest before your next activity. ■Operating time Approximately 14 days of battery life in smartwatch mode and 20 hours in GPS mode. ■While you are out and about or training, ForeAthlete 55 tracks your steps, intensity, time, and more. ■Manage your daily stress with the watch. ■BODY BATTERY Energy Monitor tracks your body's energy levels so you know when it's best to do an activity or take a break. ■FITNESS AGE feature can estimate your body's age. ■Breath rate tracking feature tracks your breath rate throughout the day, breathing while sleeping, and breath work while doing yoga. ■Health Tracking for Women The Garmin Connect app tracks your menstrual cycle and pregnancy. ■Safety and Tracking Features If you feel in danger or the watch detects it as an accident, the Emergency and Incident Detection feature3 sends a message to your emergency contacts with your current location. ■Lightweight design weighing less than 40g ■Silicon band is made of silicone material, ideal for sports  Size 42 x 42 x 11.6 mm Display 1.04 inches (26.3 mm) in diameter Resolution 208 x 208 pixels Weight 37 g Water resistance rating 5 ATM",
    description_jpn:
      "Garmin（ガーミン）は1989年にアメリカで創業したGPSのパイオニア企業です。 高い信頼性が要求される航空・海洋・自動車産業向け製品で培った技術を生かし、アウトドア・フィットネスの分野でも高品質な製品をを開発しています。 長寿命バッテリー＆タフな構造の頼れるハードウェアが特徴です。  これを使ってあなたもランナーになろう！ ForeAthlete 55はトレーニングのガイド機能とランニング機能を備え、フィットネスの目標を達成を手助けしてくれるGPSランニングウォッチです。  ■GPS内蔵-走っている場所を追跡し、距離、ペース、インターバルなどの正確な統計データを得ることができます。 ■心拍数データ1を取得し、安静時に心拍数が高い状態が続いた場合は、アラートが送信されます ■GARMIN COACH-あなたの様々な目標に向けて専門のコーチからのアドバイスとトレーニングプランを提供する無料のアプリです。 トレーニングプランは瞬時にウォッチへ転送できます。 ■あなたのトレーニング履歴、フィットネスレベル、回復時間など様々ステータスから最適なワークアウトを提案します。 ■PACEPRO-この機能は選択されたコースまたは距離に対してGPSをもとにペースをガイドします。 これによって自身で目標に向かって調整することができます。 ■走行距離を設定するだけで画面に到着予測時間が表示されます。 ■リカバリーアドバイザー機能が次のアクティビティまで必要な休憩時間を伝えてくれます。 ■稼働時間 スマートウォッチモードでは約14日間、GPSモードで約20時間のバッテリー寿命。 ■外出中やトレーニングしている間も、ForeAthlete 55は歩数、強度、時間などを追跡しています。 ■あなたの日々のストレスをウォッチで管理。 ■BODY BATTERY エネルギーモニターは体のエネルギーレベルを追跡して、アクティビティを行ったり休憩したりするのにベストなタイミングがわかります。 ■フィットネス年齢機能は、あなたの身体の年齢を推定することができます。 ■呼吸数の追跡機能では、1日中の呼吸数や、睡眠中の呼吸、ヨガをしている最中のブレスワークを記録します。 ■女性のための健康トラッキング Garmin Connectアプリでは生理周期や妊娠の追跡が行えます。 ■セーフティ＆トラッキング機能 危険を感じたり、事故としてウォッチが感知した場合、救急および事件検出機能3によって、緊急連絡先に現在の位置情報を含むメッセージが送信されます。 ■40g以下の軽量設計 ■バンドはシリコン素材でスポーツに最適な素材  サイズ   42 x 42 x 11.6 mm ディスプレイ  直径1.04インチ（26.3 mm） 解像度  208 x 208 ピクセル 重量  37 g 防水等級  5 ATM",
    product_image_1:
      "https://products.naganorewards.com/images/garmin/GARMIN_010-02562-40.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/GARMIN.png",
  },
  {
    id: "875",
    brand: "GARMIN",
    sku: "010-02562-41",
    product_eng: "GARMIN ForeAthlete 55 White",
    product_jpn: "GARMIN ForeAthlete 55 ホワイト",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥29,091",
    rrp_with_vat: "¥32,000",
    description_eng:
      "Garmin is a pioneering GPS company founded in the United States in 1989. Leveraging technology cultivated in products for the aviation, marine, and automotive industries, which demand high reliability, Garmin develops high-quality products in the field of outdoor fitness as well. It features dependable hardware with a long-life battery & tough construction.  Become a runner yourself with this Watch! ForeAthlete 55 is a GPS running watch that helps you achieve your fitness goals with training guidance and running features.  ■Built-in GPS - Track where you are running and get accurate statistics such as distance, pace, and intervals. ■Heart rate data1 -Get alerts when your heart rate stays high even when you are at rest  ■GARMIN COACH -A free app that provides you with advice and training plans from expert coaches to help you achieve your various goals. Training plans can be instantly transferred to your watch. ■PACEPRO - This feature guides your pace based on GPS for the selected course or distance. This allows you to make adjustments to meet your goals on your own. ■Simply set the distance and the estimated time of arrival is displayed on the screen. ■The recovery advisor tells you how long you need to rest before your next activity. ■Operating time Approximately 14 days of battery life in smartwatch mode and 20 hours in GPS mode. ■While you are out and about or training, ForeAthlete 55 tracks your steps, intensity, time, and more. ■Manage your daily stress with the watch. ■BODY BATTERY Energy Monitor tracks your body's energy levels so you know when it's best to do an activity or take a break. ■FITNESS AGE feature can estimate your body's age. ■Breath rate tracking feature tracks your breath rate throughout the day, breathing while sleeping, and breath work while doing yoga. ■Health Tracking for Women The Garmin Connect app tracks your menstrual cycle and pregnancy. ■Safety and Tracking Features If you feel in danger or the watch detects it as an accident, the Emergency and Incident Detection feature3 sends a message to your emergency contacts with your current location. ■Lightweight design weighing less than 40g ■Silicon band is made of silicone material, ideal for sports  Size 42 x 42 x 11.6 mm Display 1.04 inches (26.3 mm) in diameter Resolution 208 x 208 pixels Weight 37 g Water resistance rating 5 ATM",
    description_jpn:
      "Garmin（ガーミン）は1989年にアメリカで創業したGPSのパイオニア企業です。 高い信頼性が要求される航空・海洋・自動車産業向け製品で培った技術を生かし、アウトドア・フィットネスの分野でも高品質な製品をを開発しています。 長寿命バッテリー＆タフな構造の頼れるハードウェアが特徴です。  これを使ってあなたもランナーになろう！ ForeAthlete 55はトレーニングのガイド機能とランニング機能を備え、フィットネスの目標を達成を手助けしてくれるGPSランニングウォッチです。  ■GPS内蔵-走っている場所を追跡し、距離、ペース、インターバルなどの正確な統計データを得ることができます。 ■心拍数データ1を取得し、安静時に心拍数が高い状態が続いた場合は、アラートが送信されます ■GARMIN COACH-あなたの様々な目標に向けて専門のコーチからのアドバイスとトレーニングプランを提供する無料のアプリです。 トレーニングプランは瞬時にウォッチへ転送できます。 ■あなたのトレーニング履歴、フィットネスレベル、回復時間など様々ステータスから最適なワークアウトを提案します。 ■PACEPRO-この機能は選択されたコースまたは距離に対してGPSをもとにペースをガイドします。 これによって自身で目標に向かって調整することができます。 ■走行距離を設定するだけで画面に到着予測時間が表示されます。 ■リカバリーアドバイザー機能が次のアクティビティまで必要な休憩時間を伝えてくれます。 ■稼働時間 スマートウォッチモードでは約14日間、GPSモードで約20時間のバッテリー寿命。 ■外出中やトレーニングしている間も、ForeAthlete 55は歩数、強度、時間などを追跡しています。 ■あなたの日々のストレスをウォッチで管理。 ■BODY BATTERY エネルギーモニターは体のエネルギーレベルを追跡して、アクティビティを行ったり休憩したりするのにベストなタイミングがわかります。 ■フィットネス年齢機能は、あなたの身体の年齢を推定することができます。 ■呼吸数の追跡機能では、1日中の呼吸数や、睡眠中の呼吸、ヨガをしている最中のブレスワークを記録します。 ■女性のための健康トラッキング Garmin Connectアプリでは生理周期や妊娠の追跡が行えます。 ■セーフティ＆トラッキング機能 危険を感じたり、事故としてウォッチが感知した場合、救急および事件検出機能3によって、緊急連絡先に現在の位置情報を含むメッセージが送信されます。 ■40g以下の軽量設計 ■バンドはシリコン素材でスポーツに最適な素材  サイズ   42 x 42 x 11.6 mm ディスプレイ  直径1.04インチ（26.3 mm） 解像度  208 x 208 ピクセル 重量  37 g 防水等級  5 ATM",
    product_image_1:
      "https://products.naganorewards.com/images/garmin/GARMIN_010-02562-41.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/GARMIN.png",
  },
  {
    id: "876",
    brand: "GARMIN",
    sku: "010-02645-60",
    product_eng: "GARMIN vívosmart 5 Black S/M ",
    product_jpn: "GARMIN vívosmart 5 Black S/Mサイズ",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥19,819",
    rrp_with_vat: "¥21,801",
    description_eng:
      'Garmin is a pioneering GPS company founded in the United States in 1989. Leveraging technology cultivated in products for the aviation, marine, and automotive industries, which demand high reliability, Garmin develops high-quality products in the field of outdoor fitness as well. It features dependable hardware with a long-life battery & tough construction.  Start your daily health management easily.  vivosmart 5 is a slim and lightweight activity tracker that is both comfortable to wear and fully functional. It visualizes your body condition by managing life logs such as heart rate, blood oxygen level, body battery, stress, and sleep. Health care functions for women include menstrual cycle and pregnancy tracking. In addition, it supports a wide variety of sports activities such as walking, running, and pool swim. Smart functions display notifications of incoming phone calls and messages. With approximately 7 days of battery operation, the watch is waterproof and can be used safely while swimming or showering. The silicone band is easily replaceable.  Size S/M: 19.5 x 10.7 x 217 mm Display size 0.41" x 0.73" (10.5 mm x 18.5 mm) Weight S/M size: 24.5 g Waterproof rating 50 m fully waterproof',
    description_jpn:
      "Garmin（ガーミン）は1989年にアメリカで創業したGPSのパイオニア企業です。 高い信頼性が要求される航空・海洋・自動車産業向け製品で培った技術を生かし、アウトドア・フィットネスの分野でも高品質な製品をを開発しています。 長寿命バッテリー＆タフな構造の頼れるハードウェアが特徴です。  毎日の健康管理を手軽にはじめよう。  vivosmart 5はスリム＆軽量で、快適な着け心地と充実した機能を両立させたアクティビティトラッカーです。 心拍数・血中酸素レベル・Body Battery・ストレス・睡眠など、ライフログを管理することで自分の体の状態を見える化します。 女性向けのヘルスケア機能として、生理周期・妊娠トラッキングも搭載。 さらに、ウォーキング・ランニング・プールスイムなどの豊富なスポーツアクティビティにも対応。 スマート機能では、電話の着信・メッセージの通知が表示されます。 約7日間のバッテリー稼働で、水泳やシャワー中も安心して使える防水性能。 シリコンバンドは簡単に付け替えが可能です。  S/Mサイズ: 19.5 x 10.7 x 217 mm ディスプレイサイズ  0.41インチ x 0.73インチ (10.5 mm x 18.5 mm) 重量 S/Mサイズ: 24.5 g 防水等級  50m完全防水",
    product_image_1:
      "https://products.naganorewards.com/images/garmin/GARMIN_010-02645-60.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/GARMIN.png",
  },
  {
    id: "877",
    brand: "GARMIN",
    sku: "010-02645-61",
    product_eng: "GARMIN vívosmart 5 White S/M",
    product_jpn: "GARMIN vívosmart 5 White S/Mサイズ",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥19,819",
    rrp_with_vat: "¥21,801",
    description_eng:
      'Garmin is a pioneering GPS company founded in the United States in 1989. Leveraging technology cultivated in products for the aviation, marine, and automotive industries, which demand high reliability, Garmin develops high-quality products in the field of outdoor fitness as well. It features dependable hardware with a long-life battery & tough construction.  Start your daily health management easily.  vivosmart 5 is a slim and lightweight activity tracker that is both comfortable to wear and fully functional. It visualizes your body condition by managing life logs such as heart rate, blood oxygen level, body battery, stress, and sleep. Health care functions for women include menstrual cycle and pregnancy tracking. In addition, it supports a wide variety of sports activities such as walking, running, and pool swim. Smart functions display notifications of incoming phone calls and messages. With approximately 7 days of battery operation, the watch is waterproof and can be used safely while swimming or showering. The silicone band is easily replaceable.  Size S/M: 19.5 x 10.7 x 217 mm Display size 0.41" x 0.73" (10.5 mm x 18.5 mm) Weight S/M size: 24.5 g Waterproof rating 50 m fully waterproof',
    description_jpn:
      "Garmin（ガーミン）は1989年にアメリカで創業したGPSのパイオニア企業です。 高い信頼性が要求される航空・海洋・自動車産業向け製品で培った技術を生かし、アウトドア・フィットネスの分野でも高品質な製品をを開発しています。 長寿命バッテリー＆タフな構造の頼れるハードウェアが特徴です。  毎日の健康管理を手軽にはじめよう。  vivosmart 5はスリム＆軽量で、快適な着け心地と充実した機能を両立させたアクティビティトラッカーです。 心拍数・血中酸素レベル・Body Battery・ストレス・睡眠など、ライフログを管理することで自分の体の状態を見える化します。 女性向けのヘルスケア機能として、生理周期・妊娠トラッキングも搭載。 さらに、ウォーキング・ランニング・プールスイムなどの豊富なスポーツアクティビティにも対応。 スマート機能では、電話の着信・メッセージの通知が表示されます。 約7日間のバッテリー稼働で、水泳やシャワー中も安心して使える防水性能。 シリコンバンドは簡単に付け替えが可能です。  S/Mサイズ: 19.5 x 10.7 x 217 mm ディスプレイサイズ  0.41インチ x 0.73インチ (10.5 mm x 18.5 mm) 重量 S/Mサイズ: 24.5 g 防水等級  50m完全防水",
    product_image_1:
      "https://products.naganorewards.com/images/garmin/GARMIN_010-02645-61.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/GARMIN.png",
  },
  {
    id: "878",
    brand: "VOICE CADDIE",
    sku: "100022764",
    product_eng: "VOICE CADDIE VC4 Aiming",
    product_jpn: "VOICE CADDIE VC4 Aiming",
    category_1: "Sports",
    category_2: "Golf",
    rrp_ex_vat: "¥16,500",
    rrp_with_vat: "¥18,150",
    description_eng:
      "■World's first Aiming function. VC4 Aiming displays accurate distances and assists golfers to accurately aim for the pin. ■Golf courses from all over the world are included. The world's most comprehensive collection of golf courses (some courses may not be included) is built in, and continuous data update service is provided free of charge. ■World's first smart battery management function When the battery power is low, the system automatically switches to energy-saving mode based on the number of holes remaining. The included dedicated USB cable (Type-C) enables rapid recharging.  Size: 48mm x 48mm x 13mm / 28.5g Color: Gray Supported languages: Japanese, English, Korean, Chinese",
    description_jpn:
      "■世界初のエイミング機能を搭載 VC4エイミングは正確な距離表示とゴルファーが正確にピンに向けるようにアシストします。 ■世界中のゴルフコースがこの中に 全世界のゴルフコース（一部収録されていないコースがあります）が内蔵されており、持続的なデータアップデートサービスを無償手提供します。 ■世界初、スマートバッテリー管理機能 フルタイム対応の大容量内蔵バッテリーにより約54ホールまで使用可能で、バッテリー残量が少ない時は、残りホール数を認識して自動的に省エネモードに切替ります。 また、付属の専用USBケーブル（Type-C）で、敏速な充電が可能です。  サイズ：48mm×48mm×13mm/28.5g カラー：グレー 対応言語：日本語、英語、韓国語、中国語",
    product_image_1:
      "https://products.naganorewards.com/images/voice-caddie/VOICE-CADDIE_100022764.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/VOICE-CADDIE.png",
  },
  {
    id: "879",
    brand: "VOICE CADDIE",
    sku: "100022769",
    product_eng: "VOICE CADDIE SL2",
    product_jpn: "VOICE CADDIE SL2",
    category_1: "Sports",
    category_2: "Golf",
    rrp_ex_vat: "¥80,000",
    rrp_with_vat: "¥88,000",
    description_eng:
      'Distance Measuring Instrument. ■Clear 2 Color OLED allows you to enjoy playing golf in both bright and dark environments (night rounds). You can accurately and precisely check the distance to be covered on any terrain. Voice Caddy has successfully developed its proprietary "V-Algorithm(TM)" technology through extensive research. Two modes are available: Slope Mode and Tournament Mode. Please select the measurement mode that best suits your situation. Slope mode provides corrected distances using the V-Algorithm, while Tournament mode provides uncorrected straight line distances. ■Powerful output, speedy measurement The "Pin Mode" for direct pin measurement and the "Normal Mode" for continuous target measurement provide even higher performance. Feel the high-level performance with the Speed Detecting Booster. ■Scanning function to stay one step ahead When you know the course, the game changes. Check the point of attack quickly. Normal mode measures distances continuously at high speed to help you successfully attack the course. Scan the points to be conquered with the power button pressed, and get a quick and easy grasp of the course. *Scan function is only available in Normal mode. ■Instantaneous measurement "One-touch pin mode One-touch pin seek function" for one-time accurate Check the exact distance immediately with the "One-touch Pin Seek Function" that eliminates the need to take a picture twice. Long Key (Long Key) Function" to capture the pin more reliably Guides you to a more accurate distance to the pin as the measurement time increases. When the measurement is complete, a vibration informs you of the exact distance. Farther and clearer ■6X wide view angle lens enables accurate measurement of even distant targets (up to 700Y).  Body weight/size: 143.7g/34×65×103mm Measuring range: 5 to 700yd Error range: within 1yd',
    description_jpn:
      "距離測定器 ■鮮明な2 Color OLEDにより、明るい環境はもちろん、暗い環境（夜間のラウンド）でもゴルフをお楽しみいただけます ■どんな地形でも正確に正確な攻略距離の確認できます。ボイスキャディでは数多くの研究を重ね、ボイスキャディ独自の「Vアルゴリズム（TM）」技術の開発に成功しました。スロープモードとトーナメントモード二つのモードが仕様できます。状況に適した測定モードを選択してください。スロープモードではV-アルゴリズムによる補正された距離を案内し、トーナメントモードでは補正されていない直線距離を案内するモードです。 ■パワフルな出力、スピーディーな測定 ダイレクトにピンを測定する「ピンモード」と、連続的に目標物を測定する「ノーマルモード」ではさらに高性能のパフォーマンスを発揮します。 スピード・ディテクティング・ブースターでハイレベルのパフォーマンスを感じてみてください。 ■一歩先を行くスキャン機能 コースが分かると、ゲームが変わります。攻略地点を素早く確認してみてください。 ノーマルモードは、高速で連続的に距離を測定してコース攻略を成功に導きます。 電源ボタンを押した状態で攻略対象地点をスキャンして、簡単に素早くコースを把握してください。※スキャン機能はノーマルモードのみ ■瞬時に測定「ワンタッチピンモード」 一度で正確な「ワンタッチピンシーク機能」 二度撮る必要のない、「ワンタッチピンシーク機能」で、正確な距離をすぐに確認してください。 より確実にピンをとらえる「ロングキー（Long Key）機能」測定時間が長くなると、より正確なピンまでの距離を案内します。 測定が完了すると、振動で正確な距離をお知らせします。より遠く、より鮮明に ■6Xの広視野角レンズで、遠くの目標物（最大700Y ）でも正確に測定できます。  本体重量/サイズ：143.7g/34×65×103mm 測定範囲：5～700yd 誤差範囲：1yd以内",
    product_image_1:
      "https://products.naganorewards.com/images/voice-caddie/VOICE-CADDIE_100022769.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/VOICE-CADDIE.png",
  },
  {
    id: "880",
    brand: "VOICE CADDIE",
    sku: "100025102",
    product_eng: "VOICE CADDIE T-Ultra",
    product_jpn: "VOICE CADDIE T-Ultra",
    category_1: "Sports",
    category_2: "Golf",
    rrp_ex_vat: "¥50,000",
    rrp_with_vat: "¥55,000",
    description_eng:
      '■"New Features" Larger 1.34-inch LCD. Green undulation in full color. ■"New Feature" Course view shot marking. Easy-to-see automatic or manual marking of shot locations on the course. ■"New Feature" Flashback function. Displays scores and round tracking if you have a record of previous rounds played. (Requires Bluetooth linkage with the My Voicecaddie app. ■Auto Shot & Auto Scoring. Automatically recognizes shots, registers locations and counts scores. ■Shot & Putt Tracking. Automatically recognizes shots and putts and counts them. *Caution Auto Shot/Tempo Measurement is not compatible with Lefty.  Other Functions ・New Weather Forecast ・New Feature GPS Accuracy Improvement ・Course Preview ・Four-step green zoom ・Putt view ・Course Layout ・Distance display between 3 points ・Tempo practice mode ・Bluetooth  Size: 48.2 mm x 48.2 mm x 15.1 mm / body only 35 g Screen: 1.34-inch full-color LCD / 1 button Waterproof function: IPX7 Usage time: Clock mode: approx. 2 days / Golf mode: approx. 10 hours Charging: Charging magnet type USB 2.0 charging Components: main unit, charging dock, instruction manual and warranty card',
    description_jpn:
      "ボイスキャディ Voice Caddie T-Ultra BK の 商品概要  ■「新機能」1.34インチに大きくなった液晶。フルカラーで魅せるグリーンアンジュレーション ■「新機能」コースビューショットマーキング。ショット地点（自動または手動）をコース上に見やすくマーキングします。 ■「新機能」フラッシュバック機能。過去のプレイ記録がある場合、スコアとラウンドトラッキングを表示します。アプリ「My Voicecaddie」とBluetoothでの連携が必要です ■ オートショット＆オートスコアリング。ショットを自動認識して地点登録やスコアカウントを行います。 ■ ショット＆パットトラッキング。ショットとパットを自動認識して、数を数えてくれます。 ご注意 ※オートショット/テンポ計測はレフティ非対応です。  その他機能 ・新機能 天気予報 ・新機能 GPS精度の向上 ・コースプレビュー ・4段階グリーンズーム ・パットビュー ・コースレイアウト ・3点間距離表示 ・テンポ練習モード ・Bluetooth  サイズ：48.2mm×48.2mm×15.1mm/ボディのみ35g 画面：1.34インチフルカラー液晶/ボタン1個 防水機能：IPX7 使用時間 時計モード：約2日/ゴルフモード：約10時間 充電：充電 マグネット式USB2.0充電 構成品：本体 充電ドック 取扱説明書兼保証書",
    product_image_1:
      "https://products.naganorewards.com/images/voice-caddie/VOICE-CADDIE_100025102.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/VOICE-CADDIE.png",
  },
  {
    id: "881",
    brand: "VOICE CADDIE",
    sku: "100025494",
    product_eng: "VOICE CADDIE SC4",
    product_jpn: "VOICE CADDIE SC4",
    category_1: "Sports",
    category_2: "Golf",
    rrp_ex_vat: "¥80,000",
    rrp_with_vat: "¥88,000",
    description_eng:
      '"SC4" is a further evolution of the portable ballistic measuring device!  The previous model displayed six data on the main unit (distance, swing speed, ball speed, launch angle, highest point reached, and meet rate * backspin is supported by the app), but the "SC4" also displays launch angle/direction and backspin amount on the main unit. The greatest feature of the "SC4" is that detailed data can be measured simply by placing the main unit behind the ball, without the need for an app or Internet connection! The Doppler radar sensor tracks the ball for up to 50 yards and calculates the distance based on the ball\'s initial velocity, swing speed and launch angle, launch direction, and club trajectory.  Charging time: approx. 6 hours Operating time: approx. 10 hoursMeasurement data details',
    description_jpn:
      "持ち運び可能な弾道測定器がさらに進化して「SC4」が登場！  旧モデルでは本体に表示されるデータは6つ（飛距離/スイングスピード/ボールスピード/打ち出し角/最高到達点/ミート率 ※バックスピンはアプリで対応）でしたが、「SC4」ではさらに打ち出し角度/方向とバックスピン量も本体に表示。 アプリやインターネットの接続も必要なく、本体をボールの後方に置くだけで細かなデータを測定できるのが最大の特徴！ ドップラーレーダーセンサーで最大約50y打球を追跡し、ボールの初速、スイングスピードと打ち出し角、打ち出し方向とクラブの弾道により飛距離を算出。  ●充電時間：約6時間 ●稼働時間：約10時間計測データ詳細",
    product_image_1:
      "https://products.naganorewards.com/images/voice-caddie/VOICE-CADDIE_100025494.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/VOICE-CADDIE.png",
  },
  {
    id: "882",
    brand: "FUJIHORO",
    sku: "TP-20K.W",
    product_eng:
      "FUJIHORO Rectangular Tempura pan (with Sunoko and Thermometer) White ",
    product_jpn:
      "FUJIHORO 富士ホーロー 角型天ぷら鍋 ホワイト(スノコ・温度計付き)",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥4,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      "■Compatible with various heat sources (gas stove/IH/oven sheath heater/halogen/enclosed heater/radiant heater/dishwasher OK (except thermometer)) ■Comes with a bat and a sunoko net, so you can work smoothly without worrying about where to put your fried food. ■With thermometer Detachable clip type. Removable clip type with thermometer. ■The corner of the pan can be used as a spout for transferring oil. ■Easy to clean The glassy surface is resistant to odors and stains, making it easy to clean. ■Compact storage The included bat and sunoko net can be stacked for space-saving storage.  Size: 250 x 145 x 90 mm Weight: 1050g Material: Surface treatment/enamel   <Features of enamel products> It has the advantages of both iron and glass, and compensates for their disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean because of its high thermal efficiency for IH as well as gas heat and its resistance to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. ※Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "■様々な熱源対応（ガスコンロ/IH/オーブンシーズヒーター/ハロゲン/エンクロヒーター/ラジエントヒーター/食洗器OK(温度計を除)) ■バットとスノコ網付きなので、揚げたものの置き場所に困らずスムーズに作業 ■温度計付き 着脱可能なクリップタイプ。丸洗い可能な防水型です。 ■油の移し替えは、鍋のコーナーが注ぎ口の代わりになります。 ■お手入れ簡単 表面がガラス質なので、匂いや汚れがつきにくく、お手入れしやすい。 ■コンパクト収納 付属のバットとスノコ網を重ねて省スペースに収納できます。  サイズ:250x145x90mm 本体重量:1050g 素材・材質:表面加工/ほうろう   <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_TP-20K.W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "883",
    brand: "FUJIHORO",
    sku: "TP-24.BK",
    product_eng: "FUJIHORO Tempura pan 24cm (with thermometer) Black",
    product_jpn: "FUJIHORO 富士ホーロー 天ぷら鍋 24cm(温度計付)ブラック",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥4,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      "Easy-to-use tempura pan. The enamel material retains the temperature of the oil to keep it crispy and deliciously fried. ■The color of fried food can be seen clearly. Since the inner surface is white, you can clearly see the color of the oil and how well the food is fried. Also, enameled products do not generate metal ions, so the flavor of the food is not damaged. ■Smoothly dispose of leftover oil The spout makes it easy to clean up oil. The pot's glassy surface resists odors and stains, making it easy to clean. ■Convenient thermometer The removable hood prevents oil from splashing around.  Size: 32 x 26.5 x 10.5 cm Weight: 1220g Materials and materials: Body and lid: Enameled steel plate for enameling   <Features of enamel products> It has the advantages of both iron and glass, and compensates for their disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean because of its high thermal efficiency for IH as well as gas heat and its resistance to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. ※Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "使い勝手の良い天ぷら鍋です。琺瑯素材の保温性により油の温度がキープされ、カラッとおいしく揚がります。 ■揚げ色がしっかり見える 内面が白いので、油の色や食材の揚がり具合がよくわかる。また、琺瑯製品は金属イオンが発生しないので、食材の風味を損なわない。 ■残った油処理もスムーズに 注ぎ口があるので、油の後片付けもスムーズ。鍋の表面はガラス質なので、匂いや汚れがつきにくく、お手入れもしやすい。 ■便利な温度計付き 取り外し可能なフードがついてまわりに油が飛び散るのを防ぐ。  サイズ:32×26.5×10.5cm 重量:1220g 素材・材質:本体・フタ:ホーロー用鋼板ホーロー加工   <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_TP-24.BK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "884",
    brand: "FUJIHORO",
    sku: "TP-24.W",
    product_eng: "FUJIHORO Tempura pan 24cm (with thermometer) White",
    product_jpn: "FUJIHORO 富士ホーロー 天ぷら鍋 24cm(温度計付)ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥4,500",
    rrp_with_vat: "¥4,950",
    description_eng:
      "Easy-to-use tempura pan. The enamel material retains the temperature of the oil to keep it crispy and deliciously fried. ■The color of fried food can be seen clearly. Since the inner surface is white, you can clearly see the color of the oil and how well the food is fried. Also, enameled products do not generate metal ions, so the flavor of the food is not damaged. ■Smoothly dispose of leftover oil The spout makes it easy to clean up oil. The pot's glassy surface resists odors and stains, making it easy to clean. ■Convenient thermometer The removable hood prevents oil from splashing around.  Size: 32 x 26.5 x 10.5 cm Weight: 1220g Materials and materials: Body and lid: Enameled steel plate for enameling   <Features of enamel products> It has the advantages of both iron and glass, and compensates for their disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean because of its high thermal efficiency for IH as well as gas heat and its resistance to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. ※Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "使い勝手の良い天ぷら鍋です。琺瑯素材の保温性により油の温度がキープされ、カラッとおいしく揚がります。 ■揚げ色がしっかり見える 内面が白いので、油の色や食材の揚がり具合がよくわかる。また、琺瑯製品は金属イオンが発生しないので、食材の風味を損なわない。 ■残った油処理もスムーズに 注ぎ口があるので、油の後片付けもスムーズ。鍋の表面はガラス質なので、匂いや汚れがつきにくく、お手入れもしやすい。 ■便利な温度計付き 取り外し可能なフードがついてまわりに油が飛び散るのを防ぐ。  サイズ:32×26.5×10.5cm 重量:1220g 素材・材質:本体・フタ:ホーロー用鋼板ホーロー加工   <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_TP-24.W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "885",
    brand: "FUJIHORO",
    sku: "OP-1.0L.LG",
    product_eng: "FUJIHORO  Filto 1.0L Oil Pot Light Gray",
    product_jpn: "FUJIHORO 富士ホーロー Filto 1.0L オイルポット ライトグレー",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,600",
    rrp_with_vat: "¥3,960",
    description_eng:
      'his is a slim and compact oil pot "Filt" that can be used easily. We have responded to the needs for something that takes up little space and is easy to maneuver. It is smooth, easy to clean, and easy to maintain. The white inner surface makes it easy to see the oil condition at a glance.  Size: approx. W150 x D110 x H170 mm Appropriate capacity: 1.0L Full water capacity: 1.23L Weight: 0.55 kg Material: Steel plate for enamel (body), stainless steel (strainer net)  <Features of enamel products> It has the advantages of both iron and glass, and compensates for their disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean because of its high thermal efficiency for IH as well as gas heat and its resistance to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. ※Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.',
    description_jpn:
      "手軽に使えるスリムでコンパクトなオイルポット「フィルト」です。 場所を取らず、取り回しが楽なものが欲しいというお声にお応えいたしました。 滑らかで汚れを落としやすく、お手入れが簡単です。 内面が白いため、油の状態が一目で分かります。  サイズ：約W150×D110×H170mm 適正容量：1.0L 満水容量：1.23L 重量：0.55kg 材質：ほうろう用鋼板(本体)、ステンレス(漉し網)  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_OP-1.0L.LG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "886",
    brand: "FUJIHORO",
    sku: "OP-1.0L.W",
    product_eng: "FUJIHORO  Filto 1.0L Oil Pot White",
    product_jpn: "FUJIHORO 富士ホーロー Filto 1.0L オイルポット ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,600",
    rrp_with_vat: "¥3,960",
    description_eng:
      'his is a slim and compact oil pot "Filt" that can be used easily. We have responded to the needs for something that takes up little space and is easy to maneuver. It is smooth, easy to clean, and easy to maintain. The white inner surface makes it easy to see the oil condition at a glance.  Size: approx. W150 x D110 x H170 mm Appropriate capacity: 1.0L Full water capacity: 1.23L Weight: 0.55 kg Material: Steel plate for enamel (body), stainless steel (strainer net)  <Features of enamel products> It has the advantages of both iron and glass, and compensates for their disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean because of its high thermal efficiency for IH as well as gas heat and its resistance to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. ※Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.',
    description_jpn:
      "手軽に使えるスリムでコンパクトなオイルポット「フィルト」です。 場所を取らず、取り回しが楽なものが欲しいというお声にお応えいたしました。 滑らかで汚れを落としやすく、お手入れが簡単です。 内面が白いため、油の状態が一目で分かります。  サイズ：約W150×D110×H170mm 適正容量：1.0L 満水容量：1.23L 重量：0.55kg 材質：ほうろう用鋼板(本体)、ステンレス(漉し網)  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_OP-1.0L.W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "887",
    brand: "FUJIHORO",
    sku: "CTN-14M.AP",
    product_eng: "FUJIHORO Cotton Series 14cm Milk Pan Ash Pink",
    product_jpn:
      "FUJIHORO 富士ホーロー コットンシリーズ 14cm ミルクパン アッシュピンク",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,700",
    rrp_with_vat: "¥2,970",
    description_eng:
      "It is just the right size for preparing hot milk, chai, soups and sweets. The enamel is hygienic and safe for making baby food. Can be used with gas stoves, induction cooktops, etc. Double spout type  Size: approx. W325 x D170 x H120 mm Capacity: 1.2L Weight: 0.75 kg Material: Steel plate for enamel (body), natural wood (knob/handle)  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "ホットミルク・チャイ・スープやスイーツの下ごしらえなどにちょうど良いサイズです。 ホーローは衛生的で、離乳食づくりにも安心です。 ガスコンロ・IH調理器などでご使用可能です。 ※注ぎ口「両口」タイプ  サイズ：約W325×D170×H120mm 容量：1.2L 重量：0.75kg 材質：ほうろう用鋼板(本体)、天然木(つまみ・持ち手)  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_CTN-14M.AP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "888",
    brand: "FUJIHORO",
    sku: "CTN-14M.LG",
    product_eng: "FUJIHORO Cotton Series 14cm Milk Pan Light Gray",
    product_jpn:
      "FUJIHORO 富士ホーロー コットンシリーズ 14cm ミルクパン ライトグレー",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,700",
    rrp_with_vat: "¥2,970",
    description_eng:
      "It is just the right size for preparing hot milk, chai, soups and sweets. The enamel is hygienic and safe for making baby food. Can be used with gas stoves, induction cooktops, etc. Double spout type  Size: approx. W325 x D170 x H120 mm Capacity: 1.2L Weight: 0.75 kg Material: Steel plate for enamel (body), natural wood (knob/handle)  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "ホットミルク・チャイ・スープやスイーツの下ごしらえなどにちょうど良いサイズです。 ホーローは衛生的で、離乳食づくりにも安心です。 ガスコンロ・IH調理器などでご使用可能です。 ※注ぎ口「両口」タイプ  サイズ：約W325×D170×H120mm 容量：1.2L 重量：0.75kg 材質：ほうろう用鋼板(本体)、天然木(つまみ・持ち手)  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_CTN-14M.LG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "889",
    brand: "FUJIHORO",
    sku: "CTN-14M.W",
    product_eng: "FUJIHORO Cotton Series 14cm Milk Pan White",
    product_jpn:
      "FUJIHORO 富士ホーロー コットンシリーズ 14cm ミルクパン ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,700",
    rrp_with_vat: "¥2,970",
    description_eng:
      "It is just the right size for preparing hot milk, chai, soups and sweets. The enamel is hygienic and safe for making baby food. Can be used with gas stoves, induction cooktops, etc. Double spout type  Size: approx. W325 x D170 x H120 mm Capacity: 1.2L Weight: 0.75 kg Material: Steel plate for enamel (body), natural wood (knob/handle)  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "ホットミルク・チャイ・スープやスイーツの下ごしらえなどにちょうど良いサイズです。 ホーローは衛生的で、離乳食づくりにも安心です。 ガスコンロ・IH調理器などでご使用可能です。 ※注ぎ口「両口」タイプ  サイズ：約W325×D170×H120mm 容量：1.2L 重量：0.75kg 材質：ほうろう用鋼板(本体)、天然木(つまみ・持ち手)  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_CTN-14M.W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "890",
    brand: "FUJIHORO",
    sku: "CTN-18W.AP",
    product_eng: "FUJIHORO Cotton Series 18cm Casseroles Ash Pink",
    product_jpn:
      "FUJIHORO 富士ホーロー コットンシリーズ 18cm キャセロール アッシュピンク",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,800",
    rrp_with_vat: "¥4,180",
    description_eng:
      "・This small casserole pot is ideal for stews, ratatouille, pot-au-feu, and other stewed dishes. ・It can be used with induction cooktops as well as gas cooktops. ・Enamel does not produce metallic ions and does not spoil the flavor of the food. ・The pot is economical because it can be used to cook food over low heat. ・The compact handle allows you to remove the lid and put the cooker in the oven.  Product size: Approx. 26.5 cm (width) X 21 cm (depth) X 13.5 cm (height)  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons. ",
    description_jpn:
      "・シチューやラタトゥイユ、ポトフなどの煮込み料理に活躍する、  小ぶりなキャセロール鍋。 ・ガス火はもちろん、・IH調理器でご使用いただけます。 ・ホーローは金気が出ず、金属イオンが発生しないので、食材の風味を損ねません。 ・弱い火力で煮込むことができるので経済的です。 ・コンパクトなハンドルなので、フタを外してオーブンにも入れられます。  商品サイズ:約幅26.5×奥行21×高さ13.5cm   品質表示:本体・フタ：ほうろう用鋼板  つまみ：天然木 満水容量:約2.3L 重量:約1090g   <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_CTN-18W.AP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "891",
    brand: "FUJIHORO",
    sku: "CTN-18W.LG",
    product_eng: "FUJIHORO Cotton Series 18cm Casseroles Light Gray",
    product_jpn:
      "FUJIHORO 富士ホーロー コットンシリーズ 18cm キャセロール ライトグレー",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,800",
    rrp_with_vat: "¥4,180",
    description_eng:
      "・This small casserole pot is ideal for stews, ratatouille, pot-au-feu, and other stewed dishes. ・It can be used with induction cooktops as well as gas cooktops. ・Enamel does not produce metallic ions and does not spoil the flavor of the food. ・The pot is economical because it can be used to cook food over low heat. ・The compact handle allows you to remove the lid and put the cooker in the oven.  Product size: Approx. 26.5 cm (width) X 21 cm (depth) X 13.5 cm (height)  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons. ",
    description_jpn:
      "・シチューやラタトゥイユ、ポトフなどの煮込み料理に活躍する、  小ぶりなキャセロール鍋。 ・ガス火はもちろん、・IH調理器でご使用いただけます。 ・ホーローは金気が出ず、金属イオンが発生しないので、食材の風味を損ねません。 ・弱い火力で煮込むことができるので経済的です。 ・コンパクトなハンドルなので、フタを外してオーブンにも入れられます。  商品サイズ:約幅26.5×奥行21×高さ13.5cm   品質表示:本体・フタ：ほうろう用鋼板  つまみ：天然木 満水容量:約2.3L 重量:約1090g   <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_CTN-18W.LG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "892",
    brand: "FUJIHORO",
    sku: "CTN-18W.W",
    product_eng: "FUJIHORO Cotton Series 18cm Casseroles White",
    product_jpn:
      "FUJIHORO 富士ホーロー コットンシリーズ 18cm キャセロール ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,800",
    rrp_with_vat: "¥4,180",
    description_eng:
      "・This small casserole pot is ideal for stews, ratatouille, pot-au-feu, and other stewed dishes. ・It can be used with induction cooktops as well as gas cooktops. ・Enamel does not produce metallic ions and does not spoil the flavor of the food. ・The pot is economical because it can be used to cook food over low heat. ・The compact handle allows you to remove the lid and put the cooker in the oven.  Product size: Approx. 26.5 cm (width) X 21 cm (depth) X 13.5 cm (height)  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons. ",
    description_jpn:
      "・シチューやラタトゥイユ、ポトフなどの煮込み料理に活躍する、  小ぶりなキャセロール鍋。 ・ガス火はもちろん、・IH調理器でご使用いただけます。 ・ホーローは金気が出ず、金属イオンが発生しないので、食材の風味を損ねません。 ・弱い火力で煮込むことができるので経済的です。 ・コンパクトなハンドルなので、フタを外してオーブンにも入れられます。  商品サイズ:約幅26.5×奥行21×高さ13.5cm   品質表示:本体・フタ：ほうろう用鋼板  つまみ：天然木 満水容量:約2.3L 重量:約1090g   <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_CTN-18W.W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "893",
    brand: "FUJIHORO",
    sku: "CTN-1.6WK.AP",
    product_eng: "FUJIHORO Cotton Series 1.6ＬWhistling Kettle Ash Pink",
    product_jpn:
      "FUJIHORO 富士ホーロー コットンシリーズ 1.6Ｌ笛吹きケトル アッシュピンク",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "This mini whistle kettle has a cute form that adds color to your living space. The handle has a spacious silhouette for easy grasping and viewing, and the surface has a non-slip matte finish. A whistle sounds to let you know when the water is ready to boil. *Do not use on a stove. *Not for use in microwave ovens.  Size: Approx. W225 x D170 x H205 mm Capacity: 1.6L Weight: 0.89 kg Material: Steel plate for enamel (body), resin (knob/handle) Heat source: Compatible with gas and IH  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons. ",
    description_jpn:
      "生活空間を彩るキュートなフォルムのミニ笛吹ケトル。 ハンドルはゆったりとしたシルエットでつか見やすく、表面は滑りにくいマット仕上げです。 沸き上がりを笛の音でお知らせします。 ※ストーブには使用しないでください。 ※電子レンジには使用できません。  サイズ：約W225×D170×H205mm 容量：1.6L 重量：0.89kg 材質：ほうろう用鋼板(本体)、樹脂(つまみ・持ち手) 熱源：ガス・IH対応  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_CTN-1.6WK.AP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "894",
    brand: "FUJIHORO",
    sku: "CTN-1.6WK.LG",
    product_eng: "FUJIHORO Cotton Series 1.6ＬWhistling Kettle Light Gray",
    product_jpn:
      "FUJIHORO 富士ホーロー コットンシリーズ 1.6Ｌ笛吹きケトル ライトグレー",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "This mini whistle kettle has a cute form that adds color to your living space. The handle has a spacious silhouette for easy grasping and viewing, and the surface has a non-slip matte finish. A whistle sounds to let you know when the water is ready to boil. *Do not use on a stove. *Not for use in microwave ovens.  Size: Approx. W225 x D170 x H205 mm Capacity: 1.6L Weight: 0.89 kg Material: Steel plate for enamel (body), resin (knob/handle) Heat source: Compatible with gas and IH  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons. ",
    description_jpn:
      "生活空間を彩るキュートなフォルムのミニ笛吹ケトル。 ハンドルはゆったりとしたシルエットでつか見やすく、表面は滑りにくいマット仕上げです。 沸き上がりを笛の音でお知らせします。 ※ストーブには使用しないでください。 ※電子レンジには使用できません。  サイズ：約W225×D170×H205mm 容量：1.6L 重量：0.89kg 材質：ほうろう用鋼板(本体)、樹脂(つまみ・持ち手) 熱源：ガス・IH対応  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_CTN-1.6WK.LG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "895",
    brand: "FUJIHORO",
    sku: "CTN-1.6WK.W",
    product_eng: "FUJIHORO Cotton Series 1.6ＬWhistling Kettle White",
    product_jpn:
      "FUJIHORO 富士ホーロー コットンシリーズ 1.6Ｌ笛吹きケトル ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "This mini whistle kettle has a cute form that adds color to your living space. The handle has a spacious silhouette for easy grasping and viewing, and the surface has a non-slip matte finish. A whistle sounds to let you know when the water is ready to boil. *Do not use on a stove. *Not for use in microwave ovens.  Size: Approx. W225 x D170 x H205 mm Capacity: 1.6L Weight: 0.89 kg Material: Steel plate for enamel (body), resin (knob/handle) Heat source: Compatible with gas and IH  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons. ",
    description_jpn:
      "生活空間を彩るキュートなフォルムのミニ笛吹ケトル。 ハンドルはゆったりとしたシルエットでつか見やすく、表面は滑りにくいマット仕上げです。 沸き上がりを笛の音でお知らせします。 ※ストーブには使用しないでください。 ※電子レンジには使用できません。  サイズ：約W225×D170×H205mm 容量：1.6L 重量：0.89kg 材質：ほうろう用鋼板(本体)、樹脂(つまみ・持ち手) 熱源：ガス・IH対応  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_CTN-1.6WK.W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "896",
    brand: "FUJIHORO",
    sku: "MFF-12Ｍ",
    product_eng: "FUJIHORO Miffy Face 12cm Milk Pan",
    product_jpn: "FUJIHORO 富士ホーローミッフィーフェイス 12cmミルクパン",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥2,700",
    rrp_with_vat: "¥2,970",
    description_eng:
      "The Miffy face series is popular for its simple design of just Miffy's face. Pure white enamel kitchenware that looks cute even when left out in the kitchen.  Size: approx. W255 x D140 x H80 mm Capacity: 0.8L Weight: 0.4 kg Material: Enameled steel plate (body), natural wood (handle)  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons. ",
    description_jpn:
      "ミッフィーのおかおだけのシンプルなデザインが人気のミッフィーフェイスシリーズ。 純白のホーロー製キッチンウェアで、出しっぱなしでも可愛い◎  サイズ：約W255×D140×H80mm 容量：0.8L 重量：0.4kg 材質：ほうろう用鋼板（本体）、天然木（持ち手） 熱源：ガス・IH対応  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO-MFF-12-%EF%BC%AD.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO-MFF-12%EF%BC%AD-1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "897",
    brand: "FUJIHORO",
    sku: "MFF-15W",
    product_eng: "FUJIHORO Miffy Face 15cm Casseroles",
    product_jpn: "FUJIHORO 富士ホーローミッフィーフェイス 15cmキャセロール",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,500",
    rrp_with_vat: "¥3,850",
    description_eng:
      "The Miffy Face Series is popular for its simple design with only Miffy's face. You can enjoy a different Miffy face on each side. This 15cm diameter mini casserole can be easily held by people living alone when making a pot-au-feu with a lot of ingredients or a small amount of stewed food. The casserole comes with a lid, so it is convenient for slow stewing and can also be used for oven cooking if the lid is removed. It also comes with a polyethylene lid for storing food in the refrigerator, so you can handle everything from cooking to storage in one casserole.  Size: 22 x 16.5 x 13 cm Capacity: 1.5 liters full water capacity Weight: Approx. 620g Material: Steel plate for enamel (body), natural wood (handle) Heat source: Compatible with gas and IH Storage lid PE  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons. ",
    description_jpn:
      "ミッフィーのおかおだけのシンプルなデザインが人気のミッフィーフェイスシリーズ。 両面それぞれ違うミッフィーのおかおが楽しめます。。 具だくさんのポトフや、少量の煮込み料理を作りたい時など一人暮らしでも気軽に持てる直径15cmのミニキャセロール。 蓋付なので、じっくりコトコト煮込みたい時にも便利で、蓋を外せば、オーブン調理にも対応しています。 さらに、作ったものをそのまま冷蔵庫で保存できるポリエチレン製の蓋も付いているので、調理から保存までひとつでまかなえます。  サイズ：22×16.5×13ｃｍ 容量：満水容量1.5リットル 重量：約620g 材質：ほうろう用鋼板（本体）、天然木（持ち手） 熱源：ガス・IH対応 保存用蓋 PE  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。 ",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-15W.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-15W_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "898",
    brand: "FUJIHORO",
    sku: "MFF-16MLP",
    product_eng: "FUJIHORO Miffy Face 16cm Multipot",
    product_jpn: "FUJIHORO 富士ホーローミッフィーフェイス 16㎝マルチポット",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥5,000",
    rrp_with_vat: "¥5,500",
    description_eng:
      "The Miffy Face Series is popular for its simple design with only Miffy's face. You can enjoy different Miffy faces on each side. Boils, boils, fries, cooks, simmers, dresses, and preserves food in 7 functions in a single unit. The large handle makes it easy to hold and maneuver in the kitchen.  Size : W250 x D170 x H150mm Capacity : 2.2L Weight ：1.25kg Material ：Steel plate for enamel (main body) Heat source: Compatible with gas and IH  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "ミッフィーのおかおだけのシンプルなデザインが人気のミッフィーフェイスシリーズ。 両面それぞれ違うミッフィーのおかおが楽しめます。 茹でる・沸かす・揚げる・炊く・煮る・和える・保存の一台7役。 大きな取っ手で持ちやすく、キッチンでの取り回しがとっても楽ちん。  サイズ：W250 x D170 x H150mm 容量 ： 2.2L 重量 ：1.25kg 材質：ほうろう用鋼板（本体） 熱源：ガス・IH対応  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-16MLP.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-16MLP_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "899",
    brand: "FUJIHORO",
    sku: "MFF-18W",
    product_eng: "FUJIHORO Miffy Face 18cm Two-handled pot",
    product_jpn: "FUJIHORO 富士ホーローミッフィーフェイス 18㎝両手鍋",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "The Miffy face series is popular for its simple design of just Miffy's face. The compact size is just right for cooking simmered dishes or soup for two.  Size: W260 x D190 x H145mm Capacity: 2.5L Weight: 1.2 kg Material: Steel plate for enamel (main body) Heat source: Compatible with gas and IH  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "ミッフィーのおかおだけのシンプルなデザインが人気のミッフィーフェイスシリーズ。 2人分の煮物やスープ作りにちょうどいいコンパクトサイズです。  サイズ：W260 x D190x H145mm 容量：2.5L 重量：1.2kg 材質：ほうろう用鋼板（本体） 熱源：ガス・IH対応  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-18W.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-18W_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "900",
    brand: "FUJIHORO",
    sku: "MFF-2.0K",
    product_eng: "FUJIHORO Miffy Face 2.0ＬKettle",
    product_jpn: "FUJIHORO 富士ホーローミッフィーフェイス 2.0Ｌケトル",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥4,000",
    rrp_with_vat: "¥4,400",
    description_eng:
      "The Miffy Face Series is popular for its simple design with only Miffy's face. You can enjoy a different Miffy face on each side. The product is processed to be strong and rust-resistant, resistant to acid and chalky water. The interior has a special enamel finish with a highly durable, dark blue, heat-resistant water-based glaze. *Not for use in microwave ovens. *Cannot be used on a stove.  Size : W225 x D160 x H205mm Capacity ：2.0L Weight ：1.0kg Material ：Steel plate for enamel (body), knob/handle: resin  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "ミッフィーのおかおだけのシンプルなデザインが人気のミッフィーフェイスシリーズ。 両面それぞれ違うミッフィーのおかおが楽しめます。 酸やカルキに強く、丈夫で錆びにくい加工を施しております。 内面は耐久性が高い、紺色の耐熱水性釉薬という特殊なホーロー仕上げ ※電子レンジには使用できません。 ※ストーブでのご使用はできません。  サイズ：W225 x D160 x H205mm 容量  ：2.0L 重量  ：1.0kg 材質：ほうろう用鋼板（本体）つまみ・ハンドル：樹脂  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-2.0K.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-2.0K_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "901",
    brand: "FUJIHORO",
    sku: "MFF-2SM",
    product_eng: "FUJIHORO Miffy Face Containers 2-Piece Set",
    product_jpn: "FUJIHORO 富士ホーローミッフィーフェイス 浅型角容器 2点セット",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,300",
    rrp_with_vat: "¥3,630",
    description_eng:
      "The Miffy Face Series is popular for its simple design with only Miffy's face. You can enjoy different Miffy faces on each side. The lid can also be removed for oven cooking. *Cannot be used in microwave ovens. *Please remove the lid when using it in the oven.  Size: S: W145 x D95 x H50mm 0.42L M：W175 x D115 x H55mm 0.74L  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "ミッフィーのおかおだけのシンプルなデザインが人気のミッフィーフェイスシリーズ。 両面それぞれ違うミッフィーのおかおが楽しめます。 フタを外せばオーブン調理にもご使用いただけます。 ※電子レンジには使用できません。 ※オーブンに使用する際は、フタを外してご使用ください。  サイズ： S：W145 x D95 x H50mm   0.42L M：W175 x D115 x H55mm  0.74L  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-2SM.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-2SM_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "902",
    brand: "FUJIHORO",
    sku: "MFF-3MB",
    product_eng: "FUJIHORO Miffy Face Mixing Ball 3-Piece Set",
    product_jpn:
      "FUJIHORO 富士ホーローミッフィーフェイス ミキシングボール3点セット",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,800",
    rrp_with_vat: "¥4,180",
    description_eng:
      "The Miffy face series is popular for its simple design of just Miffy's face. The set of three bowls S, M, and L each have a different design. When not in use, they can be nested together for compact storage. They are extremely durable and can be used for storing in the oven or freezer.  Sizes: 14cm: W150 x D150 x H75mm 0.8L 16cm: W170 x D170 x H85mm 1.2L 18cm: W190 x D190 x H95mm 1.8L Weight ：1kg   <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "ミッフィーのおかおだけのシンプルなデザインが人気のミッフィーフェイスシリーズ。 ボウル3点セット S・M・Lでそれぞれデザインが異なります。 使わないときは入れ子にできるので、コンパクトに収納できます。 耐久性抜群ですので、オーブンや冷凍庫の保存にも使えます。  サイズ： 14cm：W150 x D150 x H75mm  0.8L 16cm：W170 x D170 x H85mm  1.2L 18cm：W190 x D190 x H95mm  1.8L 重量  ：1kg  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-3MB.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "903",
    brand: "FUJIHORO",
    sku: "MFF-KP",
    product_eng: "FUJIHORO Miffy Face Square stock pot",
    product_jpn: "FUJIHORO 富士ホーローミッフィーフェイス 角型ストックポット",
    category_1: "Home & Garden",
    category_2: "Kitchenware",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,300",
    description_eng:
      "The Miffy Face Series is popular for its simple design with only Miffy's face. You can enjoy a different Miffy face on each side. This stockpot can hold an entire case of commercially available miso paste packets (750g). The large handle makes it easy to hold and maneuver in the kitchen. The airtight lid prevents drying and oxidation, making miso paste last longer. It can be used as a storage container for a wide range of items other than miso.  Size: W185 x D145 x H115mm Weight : 0.65kg Approximate capacity : 900g sugar, 1kg salt, 800g flour  <Features of enamel products> It has the advantages of both iron and glass, and compensates for the disadvantages. (Since the core material is iron, it is unbreakable. ) It is easy to clean as it has high thermal efficiency with IH as well as gas heat, and is resistant to stains and odors. Because it is resistant to acid and salt, it is also excellent for preservation. The main ingredient of enamel glaze is silicon, one of the components of the earth. It naturally returns to the soil even when discarded and buried. Iron used for the fabric also returns to the soil in the same way as iron oxide. Enameled products, which take advantage of the characteristics of iron and glass, are stain-resistant and hygienic, and their excellent thermal efficiency is effective in saving energy, and they are durable, long-lasting, and can be used for a long time. *Enamel products are glazed by hand, so there are slight individual differences. Black spots and uneven coating may be found on the body of the pot and the lid, but these are unavoidable due to the manufacturing process and can be used with confidence. Please note that we do not accept exchanges or returns for these reasons.",
    description_jpn:
      "ミッフィーのおかおだけのシンプルなデザインが人気のミッフィーフェイスシリーズ。 両面それぞれ違うミッフィーのおかおが楽しめます。 市販の味噌パック（750g）がケースごとぴったり入るストックポットです。 大きな取っ手で持ちやすく、キッチンでの取り回しがとっても楽ちん。 密閉蓋付きなので、乾燥・酸化を防ぎ、お味噌が長持ちします。 お味噌以外にも幅広く保存容器としてご利用ください。  サイズ：W185 x D145 x H115mm 重量  ：0.65kg 容量目安 :砂糖900g 塩1kg 小麦粉800g  <琺瑯製品の特長> 鉄とガラス両方の長所を活かし、短所を補う性質を持ちます。(芯材が鉄なので、割れない。ガラスの膜により錆びにくいなど)ガス火はもちろんIHでも熱効率が良く、汚れや匂いが付きにくくお手入れしやすい。酸や塩分に強い為、保存にも優れています。 琺瑯の釉薬の主成分は大地の成分の一つである珪素です。廃棄されて埋立てられた場合でも自然と土に還ります。生地に使われている鉄も同様に酸化鉄になって土に還ります。鉄とガラスの特性を活かした琺瑯製品は、汚れがつきにくく衛生的、且つ優れた熱効率は省エネに有効であり、丈夫で長持ちし、末永くご愛用いただける製品です。 ※ホーロー製品は手作業で釉薬をかけておりますので、多少の個体差がございます。鍋本体や蓋に黒点や塗りムラが見られる場合がありますが、製造工程上避けられないもので、安心してご使用頂けます。このような理由での交換・返品はお受けできかねますのでご了承ください。",
    product_image_1:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-KP.jpg",
    product_image_2:
      "https://products.naganorewards.com/images/fujihoro/FUJIHORO_MFF-KP_1.jpg",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/fujihoro.png",
  },
  {
    id: "918",
    brand: "Carson",
    sku: "CARSON-HU-10",
    product_eng: "Carson Kids BugView™ 5x Magnifier",
    product_jpn: "Carson カールソン バグビュー昆虫キャッチャー拡大鏡 5倍",
    category_1: "Leisure",
    category_2: "Outdoor",
    rrp_ex_vat: "¥2,700",
    rrp_with_vat: "¥2,970",
    description_eng:
      "Very popular throughout the United States! Bug catcher with loupe to catch and easily observe insects. Featured in the New York Times! Bug View is a loupe for children to catch and observe insects on their own. The 5x magnification acrylic lens captures ambient light and shows every detail of the object. The trap at the bottom of the loupe is sliding and can be easily operated with the thumb.  Size Length 5.6✕ Width 4.1✕ Height 26.7cm Product weight 113g Materials ABS, acrylic, iron Ages 6 years and up",
    description_jpn:
      "全米で大人気！虫を捕まえて簡単に観察できるルーペ付き虫取り。ニューヨークタイムズ紙でも紹介されました！バグビューは、お子様が自分で虫を捕まえ、観察するためのルーペです。倍率5倍のアクリル製レンズは、周囲の光を取り込み、対象物の細部まで映し出します。ルーペ下部のトラップはスライド式になっていて、親指で簡単に操作することができます。  サイズ 長さ5.6✕幅4.1✕高さ26.7cm 製品重量 113g 素材 ABS、アクリル、鉄 対象年齢 6歳以上",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/carson/Carson_CARSON-HU-10.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/carson.png",
  },
  {
    id: "919",
    brand: "Carson",
    sku: "CARSON-SG-12",
    product_eng: "Carson Hand Held 2x  Acrylic Magnifying Glass",
    product_jpn: "Carson カールソン 2倍アクリル製ハンディーマグニファイア",
    category_1: "Leisure",
    category_2: "Outdoor",
    rrp_ex_vat: "¥3,000",
    rrp_with_vat: "¥3,300",
    description_eng:
      "It has a high magnification 11.5x acrylic spot lens for close up. Ergonomic SureGrip™ handle for easy grip. A soft drawstring pouch is included. The SG-12, SureGrip™ Series Handheld Magnification 2X Acrylic Magnifying Glass, is our medium-sized handheld magnifying glass; its 2X clear acrylic lens makes it a lightweight alternative to traditional glass magnification lenses. The SG-12 is ideal for anyone who needs a lightweight, versatile magnifying lens. The 2x magnification main lens is a full 110mm and allows for easy observation of details. Magnification 2x/11.5x Lens diameter 100mm Product weight 205g Material Acrylic ",
    description_jpn:
      "近接用の11.5倍の高倍率アクリルスポットレンズを搭載しています。人間工学に基づいた SureGrip™ ハンドルにより、握りやすくなっています。ソフトな巾着ポーチが付属します。 SG-12、SureGrip™ シリーズ手持ち型倍率2倍アクリル虫眼鏡は、当社の中型手持ち型虫眼鏡です。2倍の透明なアクリルレンズにより、従来のガラス製拡大レンズに代わる軽量のレンズになります。 SG-12 は、軽量で多用途の拡大レンズを必要とする人に最適です。倍率2倍の主レンズはフル110mmで細部まで簡単に観察できます。 倍率 2倍/11.5倍 レンズ直径 100mm 製品重量 205g 素材 アクリル ",
    product_image_1:
      "https://s3.amazonaws.com/products.naganorewards.com/images/carson/Carson-CARSON-SG-12.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/carson.png",
  },
  {
    id: "1067",
    brand: "Braun",
    sku: "CG7040",
    product_eng: "Braun Multigrill 7",
    product_jpn: "Braun マルチグリル 7",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥39,800",
    rrp_with_vat: "¥43,780",
    description_eng:
      "Multi Grill 7 with Easy Operation  Simply press one button to power on, and then use the dial to set the temperature. The built-in heater plate heats up quickly, and with 1400W of high power, it can heat evenly and quickly. In the busy morning, you can cook toast, bacon, and fried eggs simultaneously. For lunch, cook buns and hamburgers at the same time for an easy and authentic hamburger. In the evening, just grill meat, fish, and vegetables to enjoy restaurant-quality flavors. It features a tray to drain excess fat, a timer function, and can be stored vertically when not in use, making it convenient for daily use.  Specifications:  Voltage / Frequency: 100V (50/60Hz) Power Consumption: 1400W Dimensions (mm): 370 x 320 x 170 (normal), 370 x 590 x 170 (BBQ) Weight: 5.5kg (including plates) Cord Length: 2.3m Set Contents: Main unit, 2 types of plates (flat/wavy, 1 each), original recipe book Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "電源はボタン1つ押すだけ、あとは温度をダイヤルで回すだけの簡単操作。 ヒーター内蔵型プレートで立ち上がりも早く、1400Ｗのハイパワーで素早く均一に加熱できるマルチグリル ７。 忙しい朝はトーストやベーコン、目玉焼きを同時調理、昼はバンズやハンバーグを同時調理し手軽に本格ハンバーガーを。夜は肉や魚、野菜をグリルするだけでお店顔負けの味わいが楽しめます。 余分な脂を落とすトレイや、タイマー機能、そして不使用時は縦置き収納できたりと、毎日の使い勝手も考えられたデザインです。  電圧／周波数 100V(50/60Hz) 消費電力 1400W サイズ (mm) 370 x 320 x 170（通常） 370 x 590 x 170（BBQ） 重量 5.5kg（プレートを含む） コード長 2.3m セット内容 本体,プレート2種（平型/波型、各1枚）,オリジナルレシピブック メーカー保証期間 １年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/braun/CG7040.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/braun.png",
  },
  {
    id: "1068",
    brand: "Braun",
    sku: "SM5038",
    product_eng: "Braun Snack Maker 5",
    product_jpn: "Braun スナックメーカー 5",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥17,800",
    rrp_with_vat: "¥19,580",
    description_eng:
      "Comes with 3 Types of Plates  Grill Plate: Convenient for daily cooking, including grilling meat, fish, and vegetables. The wavy plate allows for healthy cooking by draining excess fat from the ingredients. Hot Sandwich Plate: This plate presses the edges of the bread firmly, keeping ample ingredients and melted cheese securely inside the hot sandwich. The bread is cut in the middle, making it easy to share with family and friends. It can also be used to make pie sandwiches using pie crust or to bake cakes by pouring in cake batter. Waffle Plate: Create crispy waffles like those on a café menu. Suitable for making both sweet and savory waffles, ideal for snacks or meals. Features:  Luxurious Metal Design: The simple and stylish design integrates seamlessly into any kitchen. Easy Maintenance: The plates are removable and can be washed thoroughly, making them hygienic. They are also dishwasher-safe. Compact Storage: The main unit can stand on its own and can be stored vertically, saving space. The cord can be wrapped around the base of the unit. Specifications:  Voltage / Frequency: 100V (50/60Hz) Power Consumption: 800W Dimensions: 295 x 250 x 105 (mm) Weight: 2.9kg (including grill plates) Cord Length: 2.3m Set Contents: Main unit, 3 types of plates (grill/hot sandwich/waffle, 2 each), original recipe book Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "●3種類のプレートが付属 1. グリルプレート肉や魚、野菜のグリルまで、日々のお料理に便利なグリルプレート。波型のプレートで、食材から出た余分な脂を落としながらヘルシーに調理できます。 2. ホットサンドプレートパンのふちをしっかりプレスするので、たっぷりの具材や溶けたチーズもしっかりと閉じ込めたホットサンドが出来上がります。パンの真ん中に切れ目が入るので、家族や友人と分け合う場合にも便利です。パイ生地を使ったパイサンドや、ケーキ生地を流し込んでケーキ作りにも使えます。 3. ワッフルプレートカフェメニューのようなカリッとしたワッフルを作れるワッフルプレート。甘いワッフルだけでなくお食事ワッフルまで、おやつにもお食事にも便利です。 ●高級感のあるメタルデザイン シンプルでスタイリッシュなデザインは、キッチンに違和感なく溶け込みます。 ●簡単お手入れ プレートは取り外し可能で、丸洗いもできるから衛生的。 食器洗い機にも対応。 ●コンパクト収納 本体は自立可能で、縦置きで収納できるので場所を取りません。 コードは本体下部に巻き付け可能。  【仕様】 電圧／周波数 100V(50/60Hz) 消費電力 800W サイズ 295 x 250 x 105 (mm) 重量 2.9kg（グリルプレートを含む） コード長 2.3m セット内容 本体,プレート3種（グリル/ホットサンド/ワッフル、各2枚）,オリジナルレシピブック メーカー保証期間 １年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/braun/SM5038.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/braun.png",
  },
  {
    id: "1069",
    brand: "Braun",
    sku: "MQ9145XS",
    product_eng: "Braun Multiquick 9 hand blender",
    product_jpn: "Braun マルチクイック 9 ハンドブレンダー",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥26,800",
    rrp_with_vat: "¥29,480",
    description_eng:
      'Braun\'s Top-of-the-Line Hand Blender Series, the No.1 Hand Blender Brand  This model includes a big chopper and a whisk, offering five functions with the industry\'s highest power and unmatched ease of use.  Features:  Industry-Leading 500W Powerful Motor: This power can crush even avocado pits in no time. Smart Speed Technology: Allows free speed adjustment just by changing your grip strength. Additionally, the newly equipped iMode Technology offers three operating modes (high-speed, low-speed, pulse). Within the speed range corresponding to each mode, you can adjust the speed steplessly by varying your grip strength, making it easier to achieve your desired texture and finish. Large Capacity 1.25L Big Chopper: Capable of crushing ice. Along with the whisk, it allows you to perform "crushing," "mixing," "whipping," "chopping," and "crushing." Convenient Dedicated Stand: Comes with a dedicated stand for storing the hand blender upright during use and storage. Includes a cord holder to keep the power cord neatly stored. Recipe Book Included: Features the "Easy Dining Program" recipe book to make daily meal preparation easier. Specifications:  Main Unit Dimensions (mm) (with blender attached): Width 65 × Depth 70 × Height 410 Main Unit Weight (with blender attached): 1,030g Cord Length: 1.2m Voltage / Frequency: AC 100V 50/60Hz Power Consumption: 500W Manufacturer Warranty Period: 1 year *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.',
    description_jpn:
      "ハンドブレンダーNo.1ブランドのブラウンの最上位シリーズ。 業界最高クラスのパワー＆他にない使い勝手の良さを持った、ビッグチョッパーと泡立て器が付いた1台5役モデル！ ●業界最大級500Wパワフルモーター そのパワーはアボカドの種をもあっという間に砕きます。 ●握る力を変えるだけで自由自在にスピード調整が可能なスマートスピードテクノロジー搭載。さらに、新搭載のアイモードテクノロジーは3段階(高速/低速/パルス)の運転モードがあり、各モードに対応した回転速度の範囲で握る力の強さ/加減を変えることでスピードを無段階で調節可能、より簡便にお好みの食感や仕上がりが手に入ります。 ●ビッグチョッパーは氷も砕ける1.25L大容量 泡立て器も付いて、ハンドブレンダーの基本機能「つぶす」「混ぜる」に加え、「泡立てる」「きざむ」「砕く」が可能に。 ●便利な専用スタンド付き 調理中も収納時も、ハンドブレンダー本体を立てて収納できる専用スタンド付き。電源コードをすっきり収納するコードフォルダー付。 ●毎日のご飯づくりが楽になる、「らくらく食卓プログラム」レシピブック付き。 【仕様】 ・本体寸法 (mm)*ブレンダー装着時 幅65×奥行70×高410 ・本体重量 1,030g *ブレンダー装着時 ・コード長 1.2m ・電圧・周波数 AC 100V 50/60Hz ・消費電力 500W メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/braun/MQ9145XS.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/braun.png",
  },
  {
    id: "1070",
    brand: "Braun",
    sku: "MQ7030XG",
    product_eng: "Braun Multiquick 7 hand blender",
    product_jpn: "Braun マルチクイック 7 ハンドブレンダー",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥14,800",
    rrp_with_vat: "¥16,280",
    description_eng:
      "1 Device with 5 Functions! Equipped with a Grating Disc, Making It Easy to Grate Vegetables like Daikon Radish!  Features:  Industry-First Easy Smart Speed Technology for Ease of Use: This function allows speed control with your hand’s grip. The speed changes based on how firmly you press the large button, allowing you to adjust the speed freely according to the ingredients. This power control enables delicate cooking that was not possible with conventional products. World's First ActiveBlade Technology: The shaft features ActiveBlade Technology, which extends and retracts. The shaft moves up and down in sync with your hand movements, efficiently blending even hard ingredients. 400W Powerful Motor with Unique PowerBell Plus: Ensures efficient blending and chopping. Easy Maintenance! Ideal for Daily Use: Simply add detergent and lukewarm water to the dedicated measuring cup and run the device for 10-20 seconds to clean the container and around the blades. Additionally, except for the main unit, MC chopper connection part, and whisk connection part, all parts are dishwasher safe. Specifications:  Main Unit Dimensions (mm) (with blender attached): Width 70 x Depth 70 x Height 400 Main Unit Weight (with blender attached): 910g Cord Length: 1.2m Voltage / Frequency: AC 100V 50/60Hz Power Consumption: 400W *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "■1台5役！おろしディスク搭載で、大根おろし等の野菜をおろす作業も簡単に！ ■使い易さを追求した業界初イージースマートスピードテクノロジー 自分の手の感覚でスピードコントロールができる機能です。大きいボタンの握り具合によってスピードが変化し、食材に合わせてスピードを自由に変えられます。このパワーコントロールの実現により従来の製品にはできなかった繊細な調理が可能となりました。 ■世界初アクティブブレードテクノロジー搭載 *シャフトが上下に伸縮するアクティブブレードテクノロジーを搭載。シャフトが手の動きに合わせて上下に伸縮することで、固い食材も一機に撹拌します。 ■400Wパワフルモーターと独自のパワーベルプラス ■お手入れ簡単！だから毎日使いたくなる！ 専用計量カップに洗剤とぬるま湯を入れて10～20秒スイッチを入れるだけで容器と刃の周りのお手入れができる簡単お手入れです。また本体、MCチョッパー接続部、泡立て器接続部以外は食器洗い機で洗えます。  【仕様】 ●本体寸法 （mm）*ブレンダー装着時 幅70x奥行70x高400 ●本体重量 910g *ブレンダー装着時 ●コード長 1.2m ●電圧・周波数 AC 100V 50/60Hz ●消費電力 400W メーカー保証期間：1年 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/braun/MQ7030XG.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/braun.png",
  },
  {
    id: "1071",
    brand: "AIRMATE",
    sku: "HP20K49",
    product_eng: "AIRMATE heater",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$45.62",
    description_eng:
      "Brand: AIRMATE Rated voltage :220V Rated power :2000W Control mode: mechanical Heating method: ceramic heating Gear :3 Model :HP20-K49 Launch time :2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/AIRMATE/HP20K49.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1072",
    brand: "APM Monaco",
    sku: "PB4381XNAC",
    product_eng: "APM Monaco Pink Shell adjustable bracelet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$414.19",
    description_eng:
      "Brand: APM Monaco Color: Rose gold Material: 18K gold plated Size: Max. 16-24cm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/APMMonaco/PB4381XNAC.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1073",
    brand: "ASVEL",
    sku: "A7528",
    product_eng:
      "ASVEL kitchen rice box automatically produces off-white color",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$87.09",
    description_eng:
      "Brand: ASVEL Body: polypropylene (PP), sealing ring: silicone Size: 18.1*41.8*41.1cm Capacity: 12kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ASVEL/A7528.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1074",
    brand: "ASVEL",
    sku: "A7528R",
    product_eng: "ASVEL kitchen rice box automatically produces red rice",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$87.09",
    description_eng:
      "Brand: ASVEL Body: polypropylene (PP), sealing ring: silicone Size: 18.1*41.8*41.1cm Capacity: 12kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ASVEL/A7528R.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1075",
    brand: "ASVEL",
    sku: "A7528",
    product_eng:
      "ASVEL kitchen rice box automatically produces off-white color",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.38",
    description_eng:
      "Brand: ASVEL Body: polypropylene (PP), sealing ring: silicone Size: 18.1*41.8*41.1cm Capacity: 12kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/ASVEL/A7528.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1076",
    brand: "ASVEL",
    sku: "A7528R",
    product_eng: "ASVEL kitchen rice box automatically produces red rice",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.38",
    description_eng:
      "Brand: ASVEL Body: polypropylene (PP), sealing ring: silicone Size: 18.1*41.8*41.1cm Capacity: 12kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/ASVEL/A7528R.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1077",
    brand: "B&O",
    sku: "BeosoundExplore",
    product_eng: "B&O Beosound Explore portable wireless Bluetooth speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$278.36",
    description_eng:
      "Brand: B&O Battery: 2400mAh, 2 hours full, 27 hours at standard listening volume Frequency range: 56-22.700 Hz Sound output: 2 1.8-inch full frequency drive units Size: Approx. 81 W *124 H *81 D (mm) Wireless connection: Bluetooth 5.2 Dustproof and waterproof grade :IP67 dustproof and waterproof Weight: Approx. 631g (without buckle) 637g (with buckle) USB input/Output: USB-C is used for charging and music streaming",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/B&O/BeosoundExplore.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1078",
    brand: "B&O",
    sku: "BeoplayEQ",
    product_eng:
      "B&O Beoplay EQ Active noise cancelling true wireless Bluetooth headphones",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$373.32",
    description_eng:
      "Brand: B&O Driver: 6.8mm electric drive unit Frequency range: 20-20000Hz Bluetooth: Bluetooth 5.2 Microphones: 6 MEMS, omnidirectional Weight: Right side of earphone: about 8g, left side of earphone: about 8g, charging case: about 50g (without earplugs)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/B&O/BeoplayEQ.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1079",
    brand: "BABOLAT",
    sku: "B121221",
    product_eng: "BABOLAT beginner advanced tennis racket BOOST DRIVE",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$124.70",
    description_eng:
      "Brand: BABOLAT Material: Carbon fiber Racket weight: 260g Racket length: 27 inches Racket surface area: 105 square inches Threading mode: 16/19 Balance point: 345mm Handle size: 1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/BABOLAT/B121221.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1080",
    brand: "BABOLAT",
    sku: "B121230",
    product_eng: "BABOLAT beginner advanced tennis racket BOOST WIM",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$124.70",
    description_eng:
      "Brand: BABOLAT Material: Carbon fiber Racket weight: 260g Racket length: 27 inches Racket surface area: 105 square inches Threading mode: 16/19 Balance point: 345mm Handle size: 2",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/BABOLAT/B121230.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1081",
    brand: "BABOLAT",
    sku: "B121221",
    product_eng: "BABOLAT beginner advanced tennis racket BOOST DRIVE",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$128.99",
    description_eng:
      "Brand: BABOLAT Material: Carbon fiber Racket weight: 260g Racket length: 27 inches Racket surface area: 105 square inches Threading mode: 16/19 Balance point: 345mm Handle size: 1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/BABOLAT/B121221.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1082",
    brand: "BABOLAT",
    sku: "B121230",
    product_eng: "BABOLAT beginner advanced tennis racket BOOST WIM",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$128.99",
    description_eng:
      "Brand: BABOLAT Material: Carbon fiber Racket weight: 260g Racket length: 27 inches Racket surface area: 105 square inches Threading mode: 16/19 Balance point: 345mm Handle size: 2",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/BABOLAT/B121230.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1083",
    brand: "BAVAY",
    sku: "A1B25P1H4",
    product_eng: "BAVAY camping stroller beige",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$225.45",
    description_eng:
      "Brand: BAVAY Use: four-way folding cart Size: Expansion: 106*50*95cm, storage: 69*32*21cm Fabric: 600D Oxford Frame: Steel frame Weight: About 13kg Load capacity: approx. 150kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/BAVAY/A1B25P1H4.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1084",
    brand: "BAVAY",
    sku: "A1B25P1H1",
    product_eng: "BAVAY camping stroller black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$225.45",
    description_eng:
      "Brand: BAVAY Use: four-way folding cart Size: Expansion: 106*50*95cm, storage: 69*32*21cm Fabric: 600D Oxford Frame: Steel frame Weight: About 13kg Load capacity: approx. 150kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/BAVAY/A1B25P1H1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1085",
    brand: "BAVAY",
    sku: "A1B2Z8H25C17",
    product_eng: "BAVAY aluminum alloy table",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$70.87",
    description_eng:
      "Brand: BAVAY The table is made of aluminum alloy, which is light, strong load bearing and durable Net weight about 1.9kg Load-bearing capacity: 30kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/BAVAY/A1B2Z8H25C17.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1086",
    brand: "BAVAY",
    sku: "A1B14P1H4",
    product_eng: "BAVAY camping stroller beige",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.33",
    description_eng:
      "Brand: BAVAY Fabric: 600D Oxford Net weight approx. : 5kg Load capacity: 80kg Configuration: 8 EVA wheels Frame: plastic sprayed steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/BAVAY/A1B14P1H4.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1087",
    brand: "BAVAY",
    sku: "A1B14P1H1",
    product_eng: "BAVAY camping stroller black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.33",
    description_eng:
      "Brand: BAVAY Fabric: 600D Oxford Net weight approx. : 5kg Load capacity: 80kg Configuration: 8 EVA wheels Frame: plastic sprayed steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/BAVAY/A1B14P1H1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1088",
    brand: "BAVAY",
    sku: "A1B25P1H4",
    product_eng: "BAVAY camping stroller beige",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$229.74",
    description_eng:
      "Brand: BAVAY Use: four-way folding cart Size: Expansion: 106*50*95cm, storage: 69*32*21cm Fabric: 600D Oxford Frame: Steel frame Weight: About 13kg Load capacity: approx. 150kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/BAVAY/A1B25P1H4.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1089",
    brand: "BAVAY",
    sku: "A1B25P1H1",
    product_eng: "BAVAY camping stroller black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$229.74",
    description_eng:
      "Brand: BAVAY Use: four-way folding cart Size: Expansion: 106*50*95cm, storage: 69*32*21cm Fabric: 600D Oxford Frame: Steel frame Weight: About 13kg Load capacity: approx. 150kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/BAVAY/A1B25P1H1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1090",
    brand: "BAVAY",
    sku: "A1B2Z8H25C17",
    product_eng: "BAVAY aluminum alloy table",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$75.16",
    description_eng:
      "Brand: BAVAY The table is made of aluminum alloy, which is light, strong load bearing and durable Net weight about 1.9kg Load-bearing capacity: 30kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/BAVAY/A1B2Z8H25C17.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1091",
    brand: "BAVAY",
    sku: "A1B14P1H4",
    product_eng: "BAVAY camping stroller beige",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$106.62",
    description_eng:
      "Brand: BAVAY Fabric: 600D Oxford Net weight approx. : 5kg Load capacity: 80kg Configuration: 8 EVA wheels Frame: plastic sprayed steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/BAVAY/A1B14P1H4.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1092",
    brand: "BAVAY",
    sku: "A1B14P1H1",
    product_eng: "BAVAY camping stroller black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$106.62",
    description_eng:
      "Brand: BAVAY Fabric: 600D Oxford Net weight approx. : 5kg Load capacity: 80kg Configuration: 8 EVA wheels Frame: plastic sprayed steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/BAVAY/A1B14P1H1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1093",
    brand: "Bear",
    sku: "YLBD40Q1",
    product_eng: "Bear electric pressure cooker 4L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$98.10",
    description_eng:
      "Brand: Bear Display type: Digital display Model: YLB-D40Q1 Power cable length: 0.8m Rated power: 1000W Rated voltage: 220V Capacity: 4L Available: 2023-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Bear/YLBD40Q1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1094",
    brand: "Bear",
    sku: "YLBC25R5",
    product_eng: "Bear electric pressure cooker 2.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$76.02",
    description_eng:
      "Brand:Bear Model: YLB-C25R5 Display type: Digital display Power cable length: 0.8m Rated voltage: 220V Capacity: 2.5L Rated power: 600W Available: 2023-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Bear/YLBC25R5.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1095",
    brand: "Bear",
    sku: "ZDHH30G1",
    product_eng: "Bear electric hot water bottle 3L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$95.32",
    description_eng:
      "Brand: Bear Net weight: 1.6kg Product size: 252mm long; Width 216mm; The height is 283mm Rated power: 1350W Rated voltage: 220V Power cable length: 0.8m Model: ZDH-H30G1 Color: White Capacity: 3L Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Bear/ZDHH30G1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1096",
    brand: "Bear",
    sku: "JSQF40J1",
    product_eng: "Bear mist-free humidifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$85.91",
    description_eng:
      "Brand: Bear Rated humidification capacity: 350ml/h Noise: 21.7db Tank capacity: 4L Product size: 220mm long; Width 227mm; The height is 314mm Control mode: touch Style: Countertop Model: JSQ-F40J1 Available: 2023-07",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Bear/JSQF40J1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1097",
    brand: "Bear",
    sku: "QSJC01T1",
    product_eng: "Bear baby food maker 0.6+0.3L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$49.28",
    description_eng:
      "Brand: Bear Motor speed: 1100 RPM Rated frequency: 50Hz Rated power: 200W Rated voltage: 220V Model: QSJ-C01T1 Blade pages: 3 knives Product size: 122mm long; Width 122mm; Height 222mm Number of gears: 1 Available: 2023-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Bear/QSJC01T1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1098",
    brand: "Bear",
    sku: "DJJE02J1",
    product_eng: "Bear soy milk machine 600ml",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$56.37",
    description_eng:
      "Brand: bear Rated voltage: 220V Capacity: 0.6L Product size: 182mm long; Width 140mm; The height is 260mm Net weight: 1.3kg Rated power: 200W Cup body material: plastic outside and steel inside Model: DJJ-E02J1 Available: 2023-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Bear/DJJE02J1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1099",
    brand: "beneunder",
    sku: "B10001",
    product_eng: "beneunder pocket mini folding five-fold umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$46.96",
    description_eng:
      "Brand: beneunder Spread diameter: 94.5cm Opening height: 52cm Parachute height: 19cm Parachute width: 6cm Umbrella net weight: 262g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/beneunder/B10001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1100",
    brand: "beneunder",
    sku: "B10002",
    product_eng: "beneunder tri-fold sun umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$54.14",
    description_eng:
      "Brand: beneunder Spread diameter: 99cm Opening height: 63cm Parachute height: 29cm Parachute width: 7.5cm Umbrella net weight: 349g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/beneunder/B10002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1101",
    brand: "beneunder",
    sku: "B10005",
    product_eng: "beneunder tri-fold sun umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$54.14",
    description_eng:
      "Brand: beneunder Spread diameter: 99cm Opening height: 62cm Parachute height: 29cm Parachute width: 7cm Umbrella net weight: 386g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/beneunder/B10005.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1102",
    brand: "beneunder",
    sku: "B10006",
    product_eng: "beneunder children's umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$37.18",
    description_eng:
      "Brand: beneunder Spread diameter: 83cm Opening height: 71cm Parachute height: 71cm Parachute width: 4cm Umbrella net weight: 338.5g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/beneunder/B10006.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1103",
    brand: "beneunder",
    sku: "B10008",
    product_eng: "beneunder children's umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$37.18",
    description_eng:
      "Brand: beneunder Spread diameter: 83cm Opening height: 71cm Parachute height: 71cm Parachute width: 4cm Umbrella net weight: 338.5g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/beneunder/B10008.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1104",
    brand: "beneunder",
    sku: "B10009",
    product_eng: "beneunder children's umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$37.18",
    description_eng:
      "Brand: beneunder Spread diameter: 83cm Opening height: 71cm Parachute height: 71cm Parachute width: 4cm Umbrella net weight: 338.5g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/beneunder/B10009.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1105",
    brand: "beneunder",
    sku: "B10001",
    product_eng: "beneunder pocket mini folding five-fold umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$51.25",
    description_eng:
      "Brand: beneunder Spread diameter: 94.5cm Opening height: 52cm Parachute height: 19cm Parachute width: 6cm Umbrella net weight: 262g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/beneunder/B10001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1106",
    brand: "beneunder",
    sku: "B10002",
    product_eng: "beneunder tri-fold sun umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$58.43",
    description_eng:
      "Brand: beneunder Spread diameter: 99cm Opening height: 63cm Parachute height: 29cm Parachute width: 7.5cm Umbrella net weight: 349g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/beneunder/B10002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1107",
    brand: "beneunder",
    sku: "B10005",
    product_eng: "beneunder tri-fold sun umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$58.43",
    description_eng:
      "Brand: beneunder Spread diameter: 99cm Opening height: 62cm Parachute height: 29cm Parachute width: 7cm Umbrella net weight: 386g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/beneunder/B10005.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1108",
    brand: "beneunder",
    sku: "B10006",
    product_eng: "beneunder children's umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$41.47",
    description_eng:
      "Brand: beneunder Spread diameter: 83cm Opening height: 71cm Parachute height: 71cm Parachute width: 4cm Umbrella net weight: 338.5g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/beneunder/B10006.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1109",
    brand: "beneunder",
    sku: "B10008",
    product_eng: "beneunder children's umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$41.47",
    description_eng:
      "Brand: beneunder Spread diameter: 83cm Opening height: 71cm Parachute height: 71cm Parachute width: 4cm Umbrella net weight: 338.5g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/beneunder/B10008.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1110",
    brand: "beneunder",
    sku: "B10009",
    product_eng: "beneunder children's umbrella",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$41.47",
    description_eng:
      "Brand: beneunder Spread diameter: 83cm Opening height: 71cm Parachute height: 71cm Parachute width: 4cm Umbrella net weight: 338.5g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/beneunder/B10009.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1111",
    brand: "Bicoy",
    sku: "BY10017",
    product_eng: "Bicoy storage box set of two 66L*2",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$40.84",
    description_eng:
      "Brand: Bicoy Material: polyester cotton + inner PE film Capacity: 66L*2 Features: strong bearing, strong wear-resistant, washable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Bicoy/BY10017.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1112",
    brand: "Bicoy",
    sku: "BY10017",
    product_eng: "Bicoy storage box set of two 66L*2",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$45.13",
    description_eng:
      "Brand: Bicoy Material: polyester cotton + inner PE film Capacity: 66L*2 Features: strong bearing, strong wear-resistant, washable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Bicoy/BY10017.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1113",
    brand: "CAMEL",
    sku: "A9S3H8108",
    product_eng: "CAMEL outdoor tent automatic 3-4 people",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$109.54",
    description_eng:
      "Brand: CAMEL Material: 150D Oxford cloth + anti-mosquito net Material: 150D Oxford cloth Waterproof: PU2000 Tent nail material: iron nail Support material: 8.5mm glass fiber Tent structure: two doors and four Windows Outer size: 220*190*120cm Inner size: 200*180*115cm Storage size: 77*15*15cm Number of people: 3-4 Packing weight: 3.4kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/CAMEL/A9S3H8108.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1114",
    brand: "CAMEL",
    sku: "133CA6B033",
    product_eng: "CAMEL canopy tent",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$116.69",
    description_eng:
      "Brand: CAMEL Fabric: 150D vinyl Oxford PU2000mm UPF50+ Awning rod Y shape 4 through 2.4 meters high awning rod, 2.5cm diameter, 0.1cm wall thickness Curtain rod material: iron Floor nail: fluorescent iron floor nail Weight: About 7.05kg Accessories: Y-shaped 4-way 2.4m high pole *2, ground nail *12, wind rope *12",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/CAMEL/133CA6B033.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1115",
    brand: "CAMEL",
    sku: "A1S3NA111",
    product_eng: "CAMEL outdoor tent automatic 3-4 people",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$103.25",
    description_eng:
      "Brand: CAMEL Material: 210D PU3000mm Oxford cloth, UPF50+ coated silver sunscreen Inner tent material: 210D Oxford PU2000mm Account bottom material: 210D Oxford PU3000mm Tent nail material: iron nail Support material: 8.5mm glass fiber Tent structure: two doors and four Windows Outer diameter: 220*200*135cm Inner diameter: 200*180*115cm Number of people: 3-4 Storage size: 77*15*15cm Packing weight: 3.4kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/CAMEL/A1S3NA111.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1116",
    brand: "CAMEL",
    sku: "A9S3H8108",
    product_eng: "CAMEL outdoor tent automatic 3-4 people",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$113.83",
    description_eng:
      "Brand: CAMEL Material: 150D Oxford cloth + anti-mosquito net Material: 150D Oxford cloth Waterproof: PU2000 Tent nail material: iron nail Support material: 8.5mm glass fiber Tent structure: two doors and four Windows Outer size: 220*190*120cm Inner size: 200*180*115cm Storage size: 77*15*15cm Number of people: 3-4 Packing weight: 3.4kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/CAMEL/A9S3H8108.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1117",
    brand: "CAMEL",
    sku: "133CA6B033",
    product_eng: "CAMEL canopy tent",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$120.98",
    description_eng:
      "Brand: CAMEL Fabric: 150D vinyl Oxford PU2000mm UPF50+ Awning rod Y shape 4 through 2.4 meters high awning rod, 2.5cm diameter, 0.1cm wall thickness Curtain rod material: iron Floor nail: fluorescent iron floor nail Weight: About 7.05kg Accessories: Y-shaped 4-way 2.4m high pole *2, ground nail *12, wind rope *12",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/CAMEL/133CA6B033.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1118",
    brand: "CAMEL",
    sku: "A1S3NA111",
    product_eng: "CAMEL outdoor tent automatic 3-4 people",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$107.54",
    description_eng:
      "Brand: CAMEL Material: 210D PU3000mm Oxford cloth, UPF50+ coated silver sunscreen Inner tent material: 210D Oxford PU2000mm Account bottom material: 210D Oxford PU3000mm Tent nail material: iron nail Support material: 8.5mm glass fiber Tent structure: two doors and four Windows Outer diameter: 220*200*135cm Inner diameter: 200*180*115cm Number of people: 3-4 Storage size: 77*15*15cm Packing weight: 3.4kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/CAMEL/A1S3NA111.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1119",
    brand: "COACH",
    sku: "C0082IME74",
    product_eng: "COACH wallet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$199.54",
    description_eng:
      "Brand: COACH Color: Khaki Size: 13*1*9cm Material: PVC with leather",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/C0082IME74.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1120",
    brand: "COACH",
    sku: "CE551QBBK",
    product_eng: "COACH Men's Long Wallet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$275.42",
    description_eng:
      "Brand: COACH Color: Black Size: 19*2*10cm Material: Leather",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/CE551QBBK.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1121",
    brand: "COACH",
    sku: "F66551QBMI5",
    product_eng: "COACH Men's Short Wallet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$147.15",
    description_eng:
      "Brand: COACH Color: Black gray Size: 10*1*9cm Material: PVC",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/F66551QBMI5.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1122",
    brand: "COACH",
    sku: "F88208IME74",
    product_eng: "COACH women's card holder",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$101.62",
    description_eng:
      "Brand: COACH Color: Khaki brown Size: 11*1*8cm Material: artificial leather with leather",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/F88208IME74.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1123",
    brand: "COACH",
    sku: "91019IMAA8",
    product_eng: "COACH small women's shoulder bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$362.08",
    description_eng:
      "Brand: COACH Material: PVC with leather Size: 22*6*16cm Color: Black",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/91019IMAA8.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1124",
    brand: "COACH",
    sku: "CH167IMOT4",
    product_eng: "COACH small women's shoulder bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$336.91",
    description_eng:
      "Brand: COACH Material: PVC with leather Size: 20*4*10.5cm Color: Khaki",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/CH167IMOT4.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1125",
    brand: "COACH",
    sku: "C1563IMNOX",
    product_eng: "COACH medium women's shoulder bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$373.37",
    description_eng:
      "Brand: Coach Color: Light brown Material: PVC with leather Size: 24*7*18cm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/C1563IMNOX.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1126",
    brand: "COACH",
    sku: "CA148IMRFI",
    product_eng: "COACH small women's shoulder bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$404.18",
    description_eng:
      "Brand: Coach Material: PVC with leather Size: 22*7*16cm Color: White with brown",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/CA148IMRFI.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1127",
    brand: "COACH",
    sku: "4455IMDQC",
    product_eng: "COACH large women's shoulder bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$316.17",
    description_eng:
      "Brand: Coach Material: PVC Size: 38*29*10*24cm Color: Khaki white",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/4455IMDQC.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1128",
    brand: "COACH",
    sku: "CB898IMUOH",
    product_eng: "COACH small women's shoulder bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$376.66",
    description_eng:
      "Brand: Coach Material: PVC with cow leather Size: 24*7*17cm Color: Dark brown color",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/CB898IMUOH.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1129",
    brand: "COACH",
    sku: "5504IMRKY",
    product_eng: "COACH small women's shoulder bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$333.76",
    description_eng:
      "Brand: Coach Material: PVC with leather Size: 20*10*13cm Color: Light khaki",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/5504IMRKY.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1130",
    brand: "COACH",
    sku: "5693IMDJ8",
    product_eng: "COACH small women's shoulder bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$362.36",
    description_eng:
      "Brand: Coach Size: 17*8*17cm Material: PVC with leather Color: Khaki",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Coach/5693IMDJ8.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1131",
    brand: "COACH",
    sku: "C0082IME74",
    product_eng: "COACH wallet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$203.83",
    description_eng:
      "Brand: COACH Color: Khaki Size: 13*1*9cm Material: PVC with leather",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/COACH/C0082IME74.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1132",
    brand: "COACH",
    sku: "CE551QBBK",
    product_eng: "COACH Men's Long Wallet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$279.71",
    description_eng:
      "Brand: COACH Color: Black Size: 19*2*10cm Material: Leather",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/COACH/CE551QBBK.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1133",
    brand: "COACH",
    sku: "F66551QBMI5",
    product_eng: "COACH Men's Short Wallet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$151.44",
    description_eng:
      "Brand: COACH Color: Black gray Size: 10*1*9cm Material: PVC",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/COACH/F66551QBMI5.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1134",
    brand: "COACH",
    sku: "F88208IME74",
    product_eng: "COACH women's card holder",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$105.91",
    description_eng:
      "Brand: COACH Color: Khaki brown Size: 11*1*8cm Material: artificial leather with leather",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/COACH/F88208IME74.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1135",
    brand: "COACH",
    sku: "91019IMAA8",
    product_eng: "COACH small women's shoulder bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$366.37",
    description_eng:
      "Brand: COACH Material: PVC with leather Size: 22*6*16cm Color: Black",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/COACH/91019IMAA8.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1136",
    brand: "COACH",
    sku: "CH167IMOT4",
    product_eng: "COACH small women's shoulder bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$341.20",
    description_eng:
      "Brand: COACH Material: PVC with leather Size: 20*4*10.5cm Color: Khaki",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/COACH/CH167IMOT4.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1137",
    brand: "crocs",
    sku: "C207641",
    product_eng:
      "crocs lightweight wear-resistant casual canvas shoes 41/42 (260mm) light gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.81",
    description_eng: "Brand: crocs Upper material: canvas Size: 41/42(260mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C207641.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1138",
    brand: "crocs",
    sku: "C207643",
    product_eng:
      "crocs lightweight wear-resistant casual canvas shoes 43 (270mm) light gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.81",
    description_eng: "Brand: crocs Upper material: canvas Size: 43(270mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C207643.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1139",
    brand: "crocs",
    sku: "C207644",
    product_eng:
      "crocs lightweight wear-resistant casual canvas shoes 44 (280mm) light gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.81",
    description_eng: "Brand: crocs Upper material: canvas Size: 44(280mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C207644.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1140",
    brand: "crocs",
    sku: "C207640",
    product_eng:
      "crocs lightweight wear-resistant casual canvas shoes 40 (250mm) light gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.81",
    description_eng: "Brand: crocs Upper material: canvas Size: 40(250mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C207640.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1141",
    brand: "crocs",
    sku: "C207541",
    product_eng:
      "crocs lightweight wear-resistant casual canvas shoes 41/42 (260mm) dark blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.81",
    description_eng: "Brand: crocs Upper material: canvas Size: 41/42(260mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C207541.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1142",
    brand: "crocs",
    sku: "C207543",
    product_eng:
      "crocs lightweight wear-resistant casual canvas shoes 43 (270mm) dark blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.81",
    description_eng: "Brand: crocs Upper material: canvas Size: 43(270mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C207543.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1143",
    brand: "crocs",
    sku: "C207544",
    product_eng:
      "crocs lightweight wear-resistant casual canvas shoes 44 (280mm) dark blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.81",
    description_eng: "Brand: crocs Upper material: canvas Size: 44(280mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C207544.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1144",
    brand: "crocs",
    sku: "C207540",
    product_eng:
      "crocs lightweight wear-resistant casual canvas shoes 40 (250mm) dark blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.81",
    description_eng: "Brand: crocs Upper material: canvas Size: 40(250mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C207540.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1145",
    brand: "crocs",
    sku: "C206750",
    product_eng: "crocs shoes White 35(220mm)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.39",
    description_eng: "Brand: crocs Heel height: 41mm Size:35(220mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C206750.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1146",
    brand: "crocs",
    sku: "C206751",
    product_eng: "crocs shoes White 36/37(230mm)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.39",
    description_eng: "Brand: crocs Heel height: 41mm Size:36/37(230mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C206751.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1147",
    brand: "crocs",
    sku: "C206752",
    product_eng: "crocs shoes White 37/38(240mm)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.39",
    description_eng: "Brand: crocs Heel height: 41mm Size:37/38(240mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C206752.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1148",
    brand: "crocs",
    sku: "C206753",
    product_eng: "crocs shoes White 39(250mm)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.39",
    description_eng: "Brand: crocs Heel height: 41mm Size:39(250mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C206753.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1149",
    brand: "crocs",
    sku: "C206754",
    product_eng: "crocs shoes White 40(260mm)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.39",
    description_eng: "Brand: crocs Heel height: 41mm Size:40(260mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C206754.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1150",
    brand: "crocs",
    sku: "C206760",
    product_eng: "crocs shoes Black 35(220mm)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.39",
    description_eng: "Brand: crocs Heel height: 41mm Size:35(220mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C206760.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1151",
    brand: "crocs",
    sku: "C206761",
    product_eng: "crocs shoes Black 36/37(230mm)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.39",
    description_eng: "Brand: crocs Heel height: 41mm Size:36/37(230mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C206761.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1152",
    brand: "crocs",
    sku: "C206762",
    product_eng: "crocs shoes Black 37/38(240mm)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.39",
    description_eng: "Brand: crocs Heel height: 41mm Size:37/38(240mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C206762.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1153",
    brand: "crocs",
    sku: "C206763",
    product_eng: "crocs shoes Black 39(250mm)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.39",
    description_eng: "Brand: crocs Heel height: 41mm Size:39(250mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C206763.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1154",
    brand: "crocs",
    sku: "C206764",
    product_eng: "crocs shoes Black 40(260mm)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.39",
    description_eng: "Brand: crocs Heel height: 41mm Size:40(260mm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Crocs/C206764.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1155",
    brand: "DanielWellington",
    sku: "DW00100307",
    product_eng: "DanielWellington Couple Watches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$545.17",
    description_eng:
      "Brand: DanielWellington Case color: Rose gold/Silver Case diameter: 36/28mm Case thickness: 6mm Strap size: 190*16/190*12mm Literal color: Black/white Movement: Imported quartz movement Strap material: 316L stainless steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/DanielWellington/DW00100307.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1156",
    brand: "deli",
    sku: "GQ101",
    product_eng: "deli plastic sealing machine",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$83.63",
    description_eng:
      "Brand: deli Automatic film feeding Plasticized leveling High speed film, 330mm/ min Multi-speed adjustable Automatic film stripping Hot and cold double mounting",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/deli/GQ101.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1157",
    brand: "deli",
    sku: "LM887",
    product_eng: "deli vacuum packaging machine",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$54.17",
    description_eng:
      "Brand: deli 60kPa strong suction 1h continuous operation Nickel-chromium alloy heating wire Four modes lock fresh Wet items can be smoked 300mm extended heating wire",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/deli/LM887.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1158",
    brand: "DHS",
    sku: "H4",
    product_eng: "DHS four-star H4 horizontal and vertical table tennis racket",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$78.34",
    description_eng:
      "Brand: DHS Four-star ping-pong pairs Double reverse adhesive Light weight and high strength Speed offensive Seven-ply floor",
    description_jpn: "",
    product_image_1: "https://products.naganorewards.com/CN/images/DHS/H4.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1159",
    brand: "DHS",
    sku: "H9002",
    product_eng: "DHS nine-star table tennis racket horizontal shot",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$103.19",
    description_eng:
      "Brand: DHS Configuration: double-sided reverse adhesive Racket type: horizontal (long handle) Style of play: fast attack and circle Base plate: 5 wood +2 aryl carbon (Ebony + aryl carbon) Features: high elasticity and high viscosity, double-sided arc, strong bottom",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/DHS/H9002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1160",
    brand: "DHS",
    sku: "H9006",
    product_eng: "DHS nine-star table tennis racket straight shot",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$113.69",
    description_eng:
      "Brand: DHS Configuration: double-sided reverse adhesive Racket type: straight (short handle) Style of play: Circle and fast attack Base plate: 5 wood +2 aryl carbon (Ebony + aryl carbon) Features: high elasticity and high viscosity, double-sided arc, strong bottom",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/DHS/H9006.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1161",
    brand: "DHS",
    sku: "H4",
    product_eng: "DHS four-star H4 horizontal and vertical table tennis racket",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$82.63",
    description_eng:
      "Brand: DHS Four-star ping-pong pairs Double reverse adhesive Light weight and high strength Speed offensive Seven-ply floor",
    description_jpn: "",
    product_image_1: "https://products.naganorewards.com/HK/images/DHS/H4.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1162",
    brand: "DHS",
    sku: "H9002",
    product_eng: "DHS nine-star table tennis racket horizontal shot",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$107.48",
    description_eng:
      "Brand: DHS Configuration: double-sided reverse adhesive Racket type: horizontal (long handle) Style of play: fast attack and circle Base plate: 5 wood +2 aryl carbon (Ebony + aryl carbon) Features: high elasticity and high viscosity, double-sided arc, strong bottom",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/DHS/H9002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1163",
    brand: "DHS",
    sku: "H9006",
    product_eng: "DHS nine-star table tennis racket straight shot",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$117.98",
    description_eng:
      "Brand: DHS Configuration: double-sided reverse adhesive Racket type: straight (short handle) Style of play: Circle and fast attack Base plate: 5 wood +2 aryl carbon (Ebony + aryl carbon) Features: high elasticity and high viscosity, double-sided arc, strong bottom",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/DHS/H9006.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1164",
    brand: "Diplomat",
    sku: "DEF1551G",
    product_eng: "Diplomat suitcase 16 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$172.43",
    description_eng:
      "Brand: Diplomat Material: Polyester Inside: Polyester Roller: universal wheel Size: 16 inches Specification: 34.5*25*40cm Weight: 3.54kg boardable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Diplomat/DEF1551G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1165",
    brand: "Diplomat",
    sku: "TC26172",
    product_eng: "Diplomat suitcase 20 inches blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$285.43",
    description_eng:
      "Brand: Diplomat Main material: PC Inner material: fabric Roller: double row universal wheel Specification: 36*22*50cm boardable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Diplomat/TC26172.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1166",
    brand: "Diplomat",
    sku: "TC26172K",
    product_eng: "Diplomat Luggage 20 Inch Khaki",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$285.43",
    description_eng:
      "Brand: Diplomat Main material: PC Inner material: fabric Roller: double row universal wheel Specification: 36*22*50cm boardable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Diplomat/TC26172K.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1167",
    brand: "Diplomat",
    sku: "TC23253",
    product_eng: "Diploma trolley case 24 inches white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$211.21",
    description_eng:
      "Brand: Diplomat Material: Main fabric (ABS+PC), inner (fabric) Roller: 360° universal wheel Pull rod: Double rod Lock: TSA combination lock Size: 24 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Diplomat/TC23253.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1168",
    brand: "Diplomat",
    sku: "TC23252",
    product_eng: "Diploma trolley case 24 inches blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$211.21",
    description_eng:
      "Brand: Diplomat Material: Main fabric (ABS+PC), inner (fabric) Roller: 360° universal wheel Pull rod: Double rod Lock: TSA combination lock Size: 24 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Diplomat/TC23252.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1169",
    brand: "Diplomat",
    sku: "TC23251",
    product_eng: "Diploma trolley case 24 inches gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$211.21",
    description_eng:
      "Brand: Diplomat Material: Main fabric (ABS+PC), inner (fabric) Roller: 360° universal wheel Pull rod: Double rod Lock: TSA combination lock Size: 24 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Diplomat/TC23251.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1170",
    brand: "Diplomat",
    sku: "DEF1551G",
    product_eng: "Diplomat suitcase 16 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$176.72",
    description_eng:
      "Brand: Diplomat Material: Polyester Inside: Polyester Roller: universal wheel Size: 16 inches Specification: 34.5*25*40cm Weight: 3.54kg boardable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Diplomat/DEF1551G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1171",
    brand: "Diplomat",
    sku: "TC26172",
    product_eng: "Diplomat suitcase 20 inches blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$289.72",
    description_eng:
      "Brand: Diplomat Main material: PC Inner material: fabric Roller: double row universal wheel Specification: 36*22*50cm boardable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Diplomat/TC26172.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1172",
    brand: "Diplomat",
    sku: "TC26172K",
    product_eng: "Diplomat Luggage 20 Inch Khaki",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$289.72",
    description_eng:
      "Brand: Diplomat Main material: PC Inner material: fabric Roller: double row universal wheel Specification: 36*22*50cm boardable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Diplomat/TC26172K.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1173",
    brand: "Diplomat",
    sku: "TC23253",
    product_eng: "Diploma trolley case 24 inches white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$215.50",
    description_eng:
      "Brand: Diplomat Material: Main fabric (ABS+PC), inner (fabric) Roller: 360° universal wheel Pull rod: Double rod Lock: TSA combination lock Size: 24 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Diplomat/TC23253.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1174",
    brand: "Diplomat",
    sku: "TC23252",
    product_eng: "Diploma trolley case 24 inches blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$215.50",
    description_eng:
      "Brand: Diplomat Material: Main fabric (ABS+PC), inner (fabric) Roller: 360° universal wheel Pull rod: Double rod Lock: TSA combination lock Size: 24 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Diplomat/TC23252.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1175",
    brand: "Diplomat",
    sku: "TC23251",
    product_eng: "Diploma trolley case 24 inches gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$215.50",
    description_eng:
      "Brand: Diplomat Material: Main fabric (ABS+PC), inner (fabric) Roller: 360° universal wheel Pull rod: Double rod Lock: TSA combination lock Size: 24 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Diplomat/TC23251.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1176",
    brand: "DISNEY",
    sku: "SX210",
    product_eng: "DISNEY bag Bluetooth wireless earphones Minnie",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$51.17",
    description_eng:
      "Brand: DISNEY Model: SX-210 Dust resistance: IP5X Charging interface: Type-C Waterproof rating: IPX5 Wireless Bluetooth 5.3 HIFI sound quality Long endurance Hd call",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Disney/SX210.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1177",
    brand: "DISNEY",
    sku: "SX210W",
    product_eng: "DISNEY Bag Bluetooth Wireless Headphones Mickey",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$51.17",
    description_eng:
      "Brand: DISNEY Model: SX-210 Dust resistance: IP5X Charging interface: Type-C Waterproof rating: IPX5 Wireless Bluetooth 5.3 HIFI sound quality Long endurance Hd call",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Disney/SX210W.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1178",
    brand: "DISNEY",
    sku: "SX210R",
    product_eng: "DISNEY Bag Bluetooth Wireless Headphones Strawberry Bear",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$51.42",
    description_eng:
      "Brand: DISNEY Model: SX-210 Dust resistance: IP5X Charging interface: Type-C Waterproof rating: IPX5 Wireless Bluetooth 5.3 HIFI sound quality Long endurance Hd call",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Disney/SX210R.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1179",
    brand: "Disney",
    sku: "MK11334W",
    product_eng: "Disney Watch for Kids",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$42.70",
    description_eng:
      "Brand: Disney Case material: alloy Strap material: Leather Movement: Quartz movement Wear range: 14-18.2cm Waterproof level: 30m life waterproof",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Disney/MK11334W.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1180",
    brand: "Disney",
    sku: "MK11621B",
    product_eng: "Disney Watch for Kids",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$44.13",
    description_eng:
      "Brand: Disney Mirror material: HD glass Strap material: silicone strap Movement: Quartz movement Wear range: 140-180mm Waterproof level: 30m life waterproof Case diameter: 33.5mm Strap width: 16*16mm Case thickness: 9mm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Disney/MK11621B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1181",
    brand: "Disney",
    sku: "DC55065B",
    product_eng: "Disney Watch for Kids",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$42.70",
    description_eng:
      "Brand: Disney Movement: Electronic movement Strap material: silicone Case material: rubber Waterproof class: 50m",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Disney/DC55065B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1182",
    brand: "EDIFIER",
    sku: "W820NB",
    product_eng:
      "EDIFIER Head-mounted Active Noise Canceling Bluetooth Headphones White",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$93.09",
    description_eng:
      "Brand: EDIFIER Model: W820NB Charging interface: Type-C Zero pressure Hi-Res double gold label certification LDAC HD codec -43dB noise reduction depth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/W820NB.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1183",
    brand: "EDIFIER",
    sku: "W820NBG",
    product_eng:
      "EDIFIER Head-mounted Active Noise Canceling Bluetooth Headphones Gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$93.09",
    description_eng:
      "Brand: EDIFIER Model: W820NB Charging interface: Type-C Zero pressure Hi-Res double gold label certification LDAC HD codec -43dB noise reduction depth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/W820NBG.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1184",
    brand: "EDIFIER",
    sku: "W820NBO",
    product_eng:
      "EDIFIER Head-mounted Active Noise Canceling Bluetooth Headphones Orange",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$93.09",
    description_eng:
      "Brand: EDIFIER Model: W820NB Charging interface: Type-C Zero pressure Hi-Res double gold label certification LDAC HD codec -43dB noise reduction depth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/W820NBO.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1185",
    brand: "EDIFIER",
    sku: "W820NBGN",
    product_eng:
      "EDIFIER Head-mounted Active Noise Canceling Bluetooth Headphones Green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$93.09",
    description_eng:
      "Brand: EDIFIER Model: W820NB Charging interface: Type-C Zero pressure Hi-Res double gold label certification LDAC HD codec -43dB noise reduction depth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/W820NBGN.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1186",
    brand: "EDIFIER",
    sku: "W820NBBL",
    product_eng:
      "EDIFIER Head-mounted Active Noise Canceling Bluetooth Headphones Blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$93.09",
    description_eng:
      "Brand: EDIFIER Model: W820NB Charging interface: Type-C Zero pressure Hi-Res double gold label certification LDAC HD codec -43dB noise reduction depth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/W820NBBL.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1187",
    brand: "EDIFIER",
    sku: "RetroPro2",
    product_eng:
      "EDIFIER True Wireless Active Noise Canceling Bluetooth Headphones White",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$77.59",
    description_eng:
      "Brand: EDIFIER Model: Retro Pro 2 Dust resistance: IP5X Waterproof rating: IPX4 Charging interface: Type-C Bluetooth version: V5.3 Working hours: About 4h+12h (noise reduction on), about 6h+18h (noise reduction off)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/RetroPro2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1188",
    brand: "EDIFIER",
    sku: "RetroPro2BL",
    product_eng:
      "EDIFIER True Wireless Active Noise Canceling Bluetooth Headphones Blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$77.59",
    description_eng:
      "Brand: EDIFIER Model: Retro Pro 2 Dust resistance: IP5X Waterproof rating: IPX4 Charging interface: Type-C Bluetooth version: V5.3 Working hours: About 4h+12h (noise reduction on), about 6h+18h (noise reduction off)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/RetroPro2BL.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1189",
    brand: "EDIFIER",
    sku: "RetroPro2GN",
    product_eng:
      "EDIFIER True Wireless Active Noise Canceling Bluetooth Headphones Green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$76.99",
    description_eng:
      "Brand: EDIFIER Model: Retro Pro 2 Dust resistance: IP5X Waterproof rating: IPX4 Charging interface: Type-C Bluetooth version: V5.3 Working hours: About 4h+12h (noise reduction on), about 6h+18h (noise reduction off)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/RetroPro2GN.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1190",
    brand: "EDIFIER",
    sku: "M230",
    product_eng: "EDIFIER High Quality Retro Bluetooth Portable Speaker White",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$95.81",
    description_eng:
      "Brand: EDIFIER Wooden box Retro key Class D power amplifier Bluetooth 5.0 Long-life endurance Size: 162*85*108mm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/M230.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1191",
    brand: "EDIFIER",
    sku: "M230G",
    product_eng: "EDIFIER High Quality Retro Bluetooth Portable Speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$95.81",
    description_eng:
      "Brand: EDIFIER Wooden box Retro key Class D power amplifier Bluetooth 5.0 Long-life endurance Size: 162*85*108mm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/M230G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1192",
    brand: "EDIFIER",
    sku: "D12",
    product_eng: "EDIFIER all-in-one desktop stereo",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$107.94",
    description_eng:
      "Brand: EDIFIER Line length: 1.5-2m Bluetooth version: Bluetooth 5.0 Type: Active speaker Wireless connection: Bluetooth Power Supply type: Power supply 2.0 Acoustics Wooden box Multiple input Wireless remote control",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EDIFIER/D12.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1193",
    brand: "EETOYS",
    sku: "ETL1209",
    product_eng: "EETOYS Latex Sound Toy Ball Large Set of Four",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$31.26",
    description_eng:
      "Brand: EETOYS Material: Latex Product function: Grinding/interactive/floating",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EETOYS/ETL1209.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1194",
    brand: "EETOYS",
    sku: "ETL1209",
    product_eng: "EETOYS Latex Sound Toy Ball Large Set of Four",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$35.55",
    description_eng:
      "Brand: EETOYS Material: Latex Product function: Grinding/interactive/floating",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/EETOYS/ETL1209.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1195",
    brand: "EPSON",
    sku: "L3266",
    product_eng: "EPSON printer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$280.94",
    description_eng:
      "Brand: EPSON Model: L3266 Network printing: Supports wireless network printing Copy function Automatic double-sided copying: Automatic double-sided copying is not supported Single-sided support paper size: A4 Port: USB; WiFi port Product size: 375mm long; Width 347mm; Height 179mm Net weight: 4.1kg Photo printing: Supports photo printing Borderless printing: Supports borderless printing Best print resolution in black and white mode: 5760*1440dpi",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/EPSON/L3266.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1196",
    brand: "FUANNA",
    sku: "F1795959",
    product_eng: "FUANNA 4-piece bed set 203*229cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$156.44",
    description_eng:
      "Brand: FUANNA Product list: Bed sheet *1, duvet cover *1, pillowcase *2 Bed sheet :230*250cm bed cover :203*229cm pillowcase :74*48cm (suitable for 1.5m bed) Material description: Fabric: A polyester viscose jacquard +B version 40 twill Applicable season: spring, summer, autumn and winter",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/FUANNA/F1795959.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1197",
    brand: "FUANNA",
    sku: "F1795980",
    product_eng: "FUANNA 4-piece bed set 230*229cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$157.87",
    description_eng:
      "Brand: FUANNA Product list: Bed sheet *1, duvet cover *1, pillowcase *2 Bed sheet :260*250cm bed cover :230*229cm pillowcase :74*48cm (suitable for 1.8m bed) Material description: Fabric: A polyester viscose jacquard +B version 40 twill Applicable season: spring, summer, autumn and winter",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/FUANNA/F1795980.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1198",
    brand: "FUANNA",
    sku: "F2372593",
    product_eng: "FUANNA 4-piece bed set 203*229cm pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$169.60",
    description_eng:
      "Brand: FUANNA Product list: Bed sheet *1, duvet cover *1, pillowcase *2 Bed sheet :230*250cm bed cover :203*229cm pillowcase :74*48cm (suitable for 1.5m bed) Material description: Fabric: A cotton viscose jacquard +B cotton twill Applicable season: spring, summer, autumn and winter",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/FUANNA/F2372593.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1199",
    brand: "FUANNA",
    sku: "F2372601",
    product_eng: "FUANNA 4-piece bed set 230*229cm pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$171.03",
    description_eng:
      "Brand: FUANNA Product list: Bed sheet *1, duvet cover *1, pillowcase *2 Bed sheet :260*250cm bed cover :230*229cm pillowcase :74*48cm (for 1.8m bed) Material description: Fabric: A cotton viscose jacquard +B cotton twill Applicable season: spring, summer, autumn and winter",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/FUANNA/F2372601.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1200",
    brand: "FUANNA",
    sku: "F100056906426",
    product_eng: "FUANNA 100% mulberry silk quilt 203*229cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$288.00",
    description_eng:
      "Brand: FUANNA Filling: 100% mulberry silk Color: Light grey Size: 1.5m bed Size: 203*229cm Filling weight: 300g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/FUANNA/F100056906426.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1201",
    brand: "FUANNA",
    sku: "F100061729061",
    product_eng: "FUANNA 100% mulberry silk quilt 203*229cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$332.33",
    description_eng:
      "Brand: FUANNA Filling: 100% mulberry silk Color: Light grey Size: 1.8m bed Size: 230*229cm Filling weight: 350g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/FUANNA/F100061729061.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1202",
    brand: "FUANNA",
    sku: "F100034799552",
    product_eng: "FUANNA silk pillow core 70*45cm 1pcs",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$80.65",
    description_eng:
      "Brand: FUANNA Size: 70*45cm Filling weight: outer 100% tussah silk 150g, inner 100% polyester fiber 650g Applicable season: Spring, summer, autumn and winter",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/FUANNA/F100034799552.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1203",
    brand: "FUANNA",
    sku: "F1795959",
    product_eng: "FUANNA 4-piece bed set 203*229cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$160.73",
    description_eng:
      "Brand: FUANNA Product list: Bed sheet *1, duvet cover *1, pillowcase *2 Bed sheet :230*250cm bed cover :203*229cm pillowcase :74*48cm (suitable for 1.5m bed) Material description: Fabric: A polyester viscose jacquard +B version 40 twill Applicable season: spring, summer, autumn and winter",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/FUANNA/F1795959.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1204",
    brand: "FUANNA",
    sku: "F1795980",
    product_eng: "FUANNA 4-piece bed set 230*229cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$162.16",
    description_eng:
      "Brand: FUANNA Product list: Bed sheet *1, duvet cover *1, pillowcase *2 Bed sheet :260*250cm bed cover :230*229cm pillowcase :74*48cm (suitable for 1.8m bed) Material description: Fabric: A polyester viscose jacquard +B version 40 twill Applicable season: spring, summer, autumn and winter",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/FUANNA/F1795980.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1205",
    brand: "FUANNA",
    sku: "F2372593",
    product_eng: "FUANNA 4-piece bed set 203*229cm pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$173.89",
    description_eng:
      "Brand: FUANNA Product list: Bed sheet *1, duvet cover *1, pillowcase *2 Bed sheet :230*250cm bed cover :203*229cm pillowcase :74*48cm (suitable for 1.5m bed) Material description: Fabric: A cotton viscose jacquard +B cotton twill Applicable season: spring, summer, autumn and winter",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/FUANNA/F2372593.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1206",
    brand: "FUANNA",
    sku: "F2372601",
    product_eng: "FUANNA 4-piece bed set 230*229cm pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$175.32",
    description_eng:
      "Brand: FUANNA Product list: Bed sheet *1, duvet cover *1, pillowcase *2 Bed sheet :260*250cm bed cover :230*229cm pillowcase :74*48cm (for 1.8m bed) Material description: Fabric: A cotton viscose jacquard +B cotton twill Applicable season: spring, summer, autumn and winter",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/FUANNA/F2372601.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1207",
    brand: "FUANNA",
    sku: "F100056906426",
    product_eng: "FUANNA 100% mulberry silk quilt 203*229cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$292.29",
    description_eng:
      "Brand: FUANNA Filling: 100% mulberry silk Color: Light grey Size: 1.5m bed Size: 203*229cm Filling weight: 300g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/FUANNA/F100056906426.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1208",
    brand: "FUANNA",
    sku: "F100061729061",
    product_eng: "FUANNA 100% mulberry silk quilt 203*229cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$336.62",
    description_eng:
      "Brand: FUANNA Filling: 100% mulberry silk Color: Light grey Size: 1.8m bed Size: 230*229cm Filling weight: 350g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/FUANNA/F100061729061.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1209",
    brand: "FUANNA",
    sku: "F100034799552",
    product_eng: "FUANNA silk pillow core 70*45cm 1pcs",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$84.94",
    description_eng:
      "Brand: FUANNA Size: 70*45cm Filling weight: outer 100% tussah silk 150g, inner 100% polyester fiber 650g Applicable season: Spring, summer, autumn and winter",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/FUANNA/F100034799552.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1210",
    brand: "GARMIN",
    sku: "Active5",
    product_eng: "GARMIN Active5 Smart sports Watch",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$457.09",
    description_eng:
      "Brand: GARMIN Screen size: 42mm/1.2 inches Quick strap removal: 20mm Weight (with strap) : 36g Battery life: 21 days in power-saving mode, 11 days in smart mode, 21 hours in GPS motion mode",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/GARMIN/Active5.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1211",
    brand: "GREE",
    sku: "NSJ8",
    product_eng: "GREE small solar electric heater",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$39.98",
    description_eng:
      "Brand: GREE Control mode: mechanical Heating method: quartz tube heating Gear :2 Waterproof class :IPX0 Model :NSJ-8",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/GREE/NSJ8.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1212",
    brand: "GUCCI",
    sku: "GG0154SA001",
    product_eng: "GUCCI sunglasses",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$472.53",
    description_eng:
      "Brand: GUCCI Glasses weight: 28g Frame type: Full frame Frame material:Acetic acid sheet",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Gucci/GG0154SA001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1213",
    brand: "GUCCI",
    sku: "GG0154SA001",
    product_eng: "GUCCI sunglasses",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$476.82",
    description_eng:
      "Brand: GUCCI Glasses weight: 28g Frame type: Full frame Frame material:Acetic acid sheet",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Gucci/GG0154SA001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1214",
    brand: "HiVi",
    sku: "D300",
    product_eng: "HiVi active HIFI speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$479.97",
    description_eng:
      "Brand: HiVi Unit configuration: Professional 6.5-inch bass, equal-field band treble Frequency range: 38Hz-20kHz Audio source input: Bluetooth, fiber, coaxial, balanced input, line input Wireless connection: Bluetooth Bluetooth version: Bluetooth 5.0",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/HiVi/D300.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1215",
    brand: "Homerun",
    sku: "PD60",
    product_eng: "Homerun Pet Dryer Pro",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$281.14",
    description_eng:
      "Brand: Homerun Capacity: 62L Net weight: 9.2kg Material: ABS Rated input power: 350W Rated voltage: 220V-50Hz Working environment: 5℃-35℃ Wind speed: 4th gear Timing range: Drying mode 1-120min",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/homerun/PD60.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1216",
    brand: "Homerun",
    sku: "PF20",
    product_eng: "Homerun Real intelligent automatic feeder",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$90.66",
    description_eng:
      "Brand: Homerun Grain storage drum capacity: 4L(about 2kg) Product material: ABS Rated input: 5V-2A Wireless connection: WiFi 2.4G Dry battery type: No. 1 Alkaline battery (to be purchased) Suitable for pets: cats, small dogs",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/homerun/PF20.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1217",
    brand: "Homerun",
    sku: "BF10",
    product_eng: "Homerun pet wireless water dispenser",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$83.51",
    description_eng:
      "Brand: Homerun Main materials: ABS, silicone Product size: 189*187*162mm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/homerun/BF10.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1218",
    brand: "hoopet",
    sku: "22X3362GV0004",
    product_eng: "hoopet pet sleeping mat XL",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$63.49",
    description_eng:
      "Brand: hoopet Application: within 80 kg (XL),100*82*26CM Material: Polyester + sponge + cut velvet + technology cloth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/hoopet/22X3362GV0004.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1219",
    brand: "hoopet",
    sku: "22W0014GV0080",
    product_eng: "hoopet pet sleeping mat L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$56.34",
    description_eng:
      "Brand: hoopet Application: Within 60 kg (L),80*65*23CM Material: Polyester + sponge + cut velvet + technology cloth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/hoopet/22W0014GV0080.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1220",
    brand: "hoopet",
    sku: "22X3362GV0002",
    product_eng: "hoopet pet sleeping mat M",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$45.19",
    description_eng:
      "Brand: hoopet Application: Within 20 kg (M),65*50*20CM Material: Polyester + sponge + cut velvet + technology cloth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/hoopet/22X3362GV0002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1221",
    brand: "hoopet",
    sku: "22X3362GV0001",
    product_eng: "hoopet pet sleeping mat S",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$40.33",
    description_eng:
      "Brand: hoopet Application: Within 8 kg (S),47*35*17CM Material: Polyester + sponge + cut velvet + technology cloth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/hoopet/22X3362GV0001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1222",
    brand: "HUAWEI",
    sku: "WATCH4Pro",
    product_eng: "HUAWEI Smart Watch Jupiter Brown",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$594.68",
    description_eng:
      "Brand: HUAWEI System :HarmonyOS 3.1 Screen size :1.5 inches Mirror material: sapphire crystal glass Screen resolution :466*466 Dial size :48mm Speaker: Built-in speaker Temperature check: Supported Wi-Fi connection :2.4GHz Bluetooth version: Bluetooth 5.2 Net weight :65g Product size: length 47.6mm; Width 47.6mm; The height is 12.9mm Battery capacity :800mAh Maximum battery life :21 days Standard battery life :4.5 days Wrist circumference: 140-210mm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/HUAWEI/WATCH4Pro.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1223",
    brand: "HUAWEI",
    sku: "WATCH4ProF",
    product_eng: "HUAWEI Smart Watch Mars Titanium",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$679.62",
    description_eng:
      "Brand: HUAWEI System :HarmonyOS 3.1 Screen size :1.5 inches Mirror material: sapphire crystal glass Screen resolution :466*466 Dial size :48mm Speaker: Built-in speaker Temperature check: Supported Wi-Fi connection :2.4GHz Bluetooth version: Bluetooth 5.2 Net weight :65g Product size: length 47.6mm; Width 47.6mm; The height is 12.9mm Battery capacity :800mAh Maximum battery life :21 days Standard battery life :4.5 days Wrist circumference: 140-210mm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/HUAWEI/WATCH4ProF.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1224",
    brand: "HUAWEI",
    sku: "WATCH4ProE",
    product_eng: "HUAWEI Smart Watch Blue Earth",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$637.58",
    description_eng:
      "Brand: HUAWEI System :HarmonyOS 3.1 Screen size :1.5 inches Mirror material: sapphire crystal glass Screen resolution :466*466 Dial size :48mm Speaker: Built-in speaker Temperature check: Supported Wi-Fi connection :2.4GHz Bluetooth version: Bluetooth 5.2 Net weight :65g Product size: length 47.6mm; Width 47.6mm; The height is 12.9mm Battery capacity :800mAh Maximum battery life :21 days Standard battery life :4.5 days Wrist circumference: 140-210mm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/HUAWEI/WATCH4ProE.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1225",
    brand: "HYPERICE",
    sku: "Hypervolt2.0",
    product_eng: "HYPERICE Hypervolt 2.0 fascia gun",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$386.24",
    description_eng:
      "Brand: HYPERICE Physiotherapy head: 5 Product weight: 0.82kg Motor power: 60W Strike depth: 12mm Thrust: 25-30kg Strength gear: Three gear high frequency impact adjustable 1800/2400/3000rpm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/HYPERICE/Hypervolt2.0.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1226",
    brand: "JAGO",
    sku: "JAZH498A",
    product_eng: "JAGO lumbar cushion",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$65.35",
    description_eng:
      "Brand: JAGO Name: Cushion Size: Cushion: 46*43.5*13.5cm Inner core material: polyurethane Coat material: Cushion fabric: polyester fiber",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JAGO/JAZH498A.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1227",
    brand: "JAGO",
    sku: "JAZH500A",
    product_eng: "JAGO lumbar cushion",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$65.61",
    description_eng:
      "Brand: JAGO Name: Cushion Size: Cushion: 46*43.5*13.5cm Inner core material: polyurethane Coat material: Cushion fabric: polyester fiber",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JAGO/JAZH500A.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1228",
    brand: "JAGO",
    sku: "220603J0500MS9",
    product_eng: "JAGO massage waist pad",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$73.79",
    description_eng:
      "Brand: JAGO Product name: Massage waist pad Size: 39*20*8cm Net weight: 570g Material: polyurethane",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JAGO/220603J0500MS9.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1229",
    brand: "JAGO",
    sku: "JAZH498A",
    product_eng: "JAGO lumbar cushion",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$69.64",
    description_eng:
      "Brand: JAGO Name: Cushion Size: Cushion: 46*43.5*13.5cm Inner core material: polyurethane Coat material: Cushion fabric: polyester fiber",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/JAGO/JAZH498A.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1230",
    brand: "JAGO",
    sku: "JAZH500A",
    product_eng: "JAGO lumbar cushion",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$69.90",
    description_eng:
      "Brand: JAGO Name: Cushion Size: Cushion: 46*43.5*13.5cm Inner core material: polyurethane Coat material: Cushion fabric: polyester fiber",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/JAGO/JAZH500A.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1231",
    brand: "JAGO",
    sku: "220603J0500MS9",
    product_eng: "JAGO massage waist pad",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$78.08",
    description_eng:
      "Brand: JAGO Product name: Massage waist pad Size: 39*20*8cm Net weight: 570g Material: polyurethane",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/JAGO/220603J0500MS9.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1232",
    brand: "JBL",
    sku: "T280TWSX2",
    product_eng: "JBL True Wireless Bluetooth Headphones Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$71.07",
    description_eng:
      "Brand: JBL Model :T280TWS X2 Waterproof rating :IPX4 Charging interface :Type-C Bluetooth version: 5.3 Support: HFP,A2DP,AVRCP Charging time: less than 2 hours Charging case power support: 18 hours",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/T280TWSX2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1233",
    brand: "JBL",
    sku: "T280TWSX2W",
    product_eng: "JBL True Wireless Bluetooth Headphones White",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$71.07",
    description_eng:
      "Brand: JBL Model :T280TWS X2 Waterproof rating :IPX4 Charging interface :Type-C Bluetooth version: 5.3 Support: HFP,A2DP,AVRCP Charging time: less than 2 hours Charging case power support: 18 hours",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/T280TWSX2W.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1234",
    brand: "JBL",
    sku: "T280TWSX2P",
    product_eng: "JBL True Wireless Bluetooth Headphones Purple",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$71.07",
    description_eng:
      "Brand: JBL Model :T280TWS X2 Waterproof rating :IPX4 Charging interface :Type-C Bluetooth version: 5.3 Support: HFP,A2DP,AVRCP Charging time: less than 2 hours Charging case power support: 18 hours",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/T280TWSX2P.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1235",
    brand: "JBL",
    sku: "T280TWSX2PK",
    product_eng: "JBL True Wireless Bluetooth Headphones Pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$71.07",
    description_eng:
      "Brand: JBL Model :T280TWS X2 Waterproof rating :IPX4 Charging interface :Type-C Bluetooth version: 5.3 Support: HFP,A2DP,AVRCP Charging time: less than 2 hours Charging case power support: 18 hours",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/T280TWSX2PK.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1236",
    brand: "JBL",
    sku: "HORIZON2",
    product_eng:
      "JBL Second Generation Desktop Bluetooth Speaker Dual Alarm Clock + Night Light Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$229.09",
    description_eng:
      "Brand: JBL Line length: 1.5-2m Wireless connection: Bluetooth Bluetooth version: Bluetooth 4.2 Power Supply type: Power supply Size: 160*183*86MM",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/HORIZON2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1237",
    brand: "JBL",
    sku: "HORIZON2G",
    product_eng:
      "JBL Second Generation Desktop Bluetooth Speaker Dual Alarm Clock + Night Light Gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$229.09",
    description_eng:
      "Brand: JBL Line length: 1.5-2m Wireless connection: Bluetooth Bluetooth version: Bluetooth 4.2 Power Supply type: Power supply Size: 160*183*86MM",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/HORIZON2G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1238",
    brand: "JBL",
    sku: "TUNEFLEX",
    product_eng: "JBL true wireless Bluetooth headphones purple",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$108.54",
    description_eng:
      "Brand: JBL Model :TUNE FLEX Waterproof rating :IPX4 Charging interface :Type-C Charging time: less than 2 hours Music playback time: up to 8 hours with Bluetooth on but ANC(active noise reduction) off, up to 6 hours with Bluetooth and ANC(active noise reduction) on",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/TUNEFLEX.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1239",
    brand: "JBL",
    sku: "TUNEFLEXBK",
    product_eng: "JBL true wireless Bluetooth headphones black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$108.54",
    description_eng:
      "Brand: JBL Model :TUNE FLEX Waterproof rating :IPX4 Charging interface :Type-C Charging time: less than 2 hours Music playback time: up to 8 hours with Bluetooth on but ANC(active noise reduction) off, up to 6 hours with Bluetooth and ANC(active noise reduction) on",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/TUNEFLEXBK.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1240",
    brand: "JBL",
    sku: "TUNEFLEXW",
    product_eng: "JBL true wireless Bluetooth headphones white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$108.54",
    description_eng:
      "Brand: JBL Model :TUNE FLEX Waterproof rating :IPX4 Charging interface :Type-C Charging time: less than 2 hours Music playback time: up to 8 hours with Bluetooth on but ANC(active noise reduction) off, up to 6 hours with Bluetooth and ANC(active noise reduction) on",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/TUNEFLEXW.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1241",
    brand: "JBL",
    sku: "CLIP4",
    product_eng:
      "JBL CLIP4 wireless music box fourth generation Bluetooth portable speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$114.40",
    description_eng:
      "Brand: JBL Model :CLIP4 Bluetooth version: Bluetooth 5.1 Power supply type: Battery powered Wireless connection: Bluetooth Charging time: 3 hours (5V/500mA) Music playback time: about 10 hours Size: 86.3*134.5*46mm Weight: 239g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/CLIP4.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1242",
    brand: "JBL",
    sku: "CLIP4B",
    product_eng:
      "JBL CLIP4 Wireless Music Box 4th Generation Bluetooth Portable Speaker Blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$114.40",
    description_eng:
      "Brand: JBL Model :CLIP4 Bluetooth version: Bluetooth 5.1 Power supply type: Battery powered Wireless connection: Bluetooth Charging time: 3 hours (5V/500mA) Music playback time: about 10 hours Size: 86.3*134.5*46mm Weight: 239g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/CLIP4B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1243",
    brand: "JBL",
    sku: "AUTHENTICS500",
    product_eng: "JBL Music Family 500 Bluetooth Speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$968.68",
    description_eng:
      "Brand: JBL 7 unit controllable waveguide loudspeaker array Trichotomous hearing 270W RMS shock power Support Dolby Panorama WI-FI streaming lossless sound quality Bluetooth 5.3 Flash connection Intuitive control, simplify the complex",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/AUTHENTICS500.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1244",
    brand: "JBL",
    sku: "PEBBLESMiniBT2",
    product_eng: "JBL Little Snail Bluetooth 2nd Generation Speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$87.29",
    description_eng:
      "Brand:JBL Bluetooth version: V5.0 Frequency response: 80Hz-20KHz Output power: 1W*2 Connection cable: 3.5 audio cable Size: 141*124*80mm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/PEBBLESMiniBT2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1245",
    brand: "JBL",
    sku: "T280TWSNC2P",
    product_eng:
      "JBL active noise canceling in-ear wireless bluetooth headphones purple",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$111.40",
    description_eng:
      "Brand:JBL Charge time: less than 2 hours (from empty to full) Music playback time when Bluetooth is on and ANC is off: 10 hours Music playback time with Bluetooth and ANC on: 8 hours 10 minutes of charging = 2 hours of playback Charging port Type: type-c",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/T280TWSNC2P.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1246",
    brand: "JBL",
    sku: "T280TWSNC2",
    product_eng:
      "JBL Active Noise Cancellation In-Ear Wireless Bluetooth Headphones Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$111.40",
    description_eng:
      "Brand:JBL Charge time: less than 2 hours (from empty to full) Music playback time when Bluetooth is on and ANC is off: 10 hours Music playback time with Bluetooth and ANC on: 8 hours 10 minutes of charging = 2 hours of playback Charging port Type: type-c",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/T280TWSNC2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1247",
    brand: "JBL",
    sku: "T280TWSNC2S",
    product_eng:
      "JBL Active Noise Cancellation In-Ear Wireless Bluetooth Headphones Silver",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$111.40",
    description_eng:
      "Brand:JBL Charge time: less than 2 hours (from empty to full) Music playback time when Bluetooth is on and ANC is off: 10 hours Music playback time with Bluetooth and ANC on: 8 hours 10 minutes of charging = 2 hours of playback Charging port Type: type-c",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/T280TWSNC2S.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1248",
    brand: "JBL",
    sku: "Soundgearsense",
    product_eng: "JBL Open True Wireless Bluetooth Headphones Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$273.27",
    description_eng:
      "Brand:JBL Charge time: 2 hours (from empty to full) Bluetooth enabled music playback time: up to 6 hours Talk time: up to 3.5 hours Bluetooth version: 5.3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/Soundgearsense.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1249",
    brand: "JBL",
    sku: "SoundgearsenseW",
    product_eng: "JBL Open True Wireless Bluetooth Headphones White",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$273.27",
    description_eng:
      "Brand:JBL Charge time: 2 hours (from empty to full) Bluetooth enabled music playback time: up to 6 hours Talk time: up to 3.5 hours Bluetooth version: 5.3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/SoundgearsenseW.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1250",
    brand: "JBL",
    sku: "TOURPRO2",
    product_eng:
      "JBL True Wireless In-Ear Active Noise Canceling Bluetooth Headphones Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$373.37",
    description_eng:
      "Brand:JBL Power Supply: 5V-1A Charge time: 2 hours (from empty to full) Music playback time with Bluetooth on but active noise cancellation off: up to 10 hours Music playback time with Bluetooth on and active noise cancellation: up to 8 hours Music playback time with Bluetooth enabled and fully adaptive active noise reduction: up to 6 hours Talk time with active noise reduction turned off: up to 6 hours Talk time with active noise reduction enabled: up to 5.5 hours Frequency response range: 20Hz-20kHz Bluetooth version (headset) : 5.3 Bluetooth version (charging case) : 5.1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/TOURPRO2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1251",
    brand: "JBL",
    sku: "TOURPRO2G",
    product_eng:
      "JBL true wireless in-ear active noise reduction Bluetooth headphones champagne gold",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$373.37",
    description_eng:
      "Brand:JBL Power Supply: 5V-1A Charge time: 2 hours (from empty to full) Music playback time with Bluetooth on but active noise cancellation off: up to 10 hours Music playback time with Bluetooth on and active noise cancellation: up to 8 hours Music playback time with Bluetooth enabled and fully adaptive active noise reduction: up to 6 hours Talk time with active noise reduction turned off: up to 6 hours Talk time with active noise reduction enabled: up to 5.5 hours Frequency response range: 20Hz-20kHz Bluetooth version (headset) : 5.3 Bluetooth version (charging case) : 5.1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/JBL/TOURPRO2G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1252",
    brand: "Joyoung",
    sku: "JY30H25",
    product_eng: "Joyoung electric pressure cooker 3L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$85.69",
    description_eng:
      "Brand: Joyoung Model: Y-30H25 Display type: Digital display Capacity: 3L Rated power: 700W Rated voltage: 220V Length of power cable: 1m Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Joyoung/JY30H25.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1253",
    brand: "Joyoung",
    sku: "DJ12K3",
    product_eng: "Joyoung hands-free soy milk machine",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$204.78",
    description_eng:
      "Brand: Joyoung Rated voltage: 220V Net weight: 5.9kg Product size: 403mm long; Width 172mm; The height is 379mm Capacity: 1.2L Rated power: 1200W Model: DJ12-K3 Cup body material: plastic outside and steel inside Available: 2023-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Joyoung/DJ12K3.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1254",
    brand: "Joyoung",
    sku: "HG60G3",
    product_eng: "Joyoung electric hot pot 6L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$101.04",
    description_eng:
      "Brand: Joyoung Rated voltage: 220V Rated power: 2200W Length of power cable: 1m Gear: 3 Capacity: 6L Liner material: Aluminum alloy Model: HG60-G3 Food contact surface material: Teflon Color: Gold Pan diameter: 35cm Available: 2023-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Joyoung/HG60G3.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1255",
    brand: "Joyoung",
    sku: "KX13VA501",
    product_eng: "Joyoung air fryer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$86.09",
    description_eng:
      "Brand: Joyoung Pot body material: metal Model: KX13-VA501 Chassis type: flat chassis Capacity: 12L Door opening mode: front open Product size: 420mm long; Width 394mm; It is 443mm high Net weight: 6.6kg Rated voltage: 220V Rated power: 1800W Launch time: 2022-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Joyoung/KX13VA501.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1256",
    brand: "Joyoung",
    sku: "DJ12XD2136",
    product_eng: "Joyoung soy milk machine 1.2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$74.44",
    description_eng:
      "Brand: Joyoung Rated voltage: 220V Product size: Long 197mm; Width 151mm; Height 292mm Rated power: 400W Net weight: 2.5kg Capacity: 1.2L Body material: single glass Model: DJ12X-D2136 Available: 2023-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Joyoung/DJ12XD2136.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1257",
    brand: "Joyoung",
    sku: "DJ06XD525",
    product_eng: "Joyoung soy milk machine 600ml",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$92.81",
    description_eng:
      "Brand: Joyoung Rated voltage: 220V Capacity: 0.6L Rated power: 150W Net weight: 2.5kg Product size: 183mm long; Width 136mm; Height 177mm Cup body material: plastic outside and steel inside Model: DJ06X-D525 Available: 2023-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Joyoung/DJ06XD525.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1258",
    brand: "Joyoung",
    sku: "DJ12XD360",
    product_eng: "Joyoung wall breaking machine 1.2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$94.27",
    description_eng:
      "Brand: Joyoung Rated voltage: 220V Net weight: 2.6kg Capacity: 1.2L Product size: length 217mm; Width 156mm; The height is 313mm Rated power: 800W Body material: single glass Model: DJ12X-D360 Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Joyoung/DJ12XD360.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1259",
    brand: "Joyoung",
    sku: "DJ10XD650",
    product_eng: "Joyoung wall breaking machine 0.8-1L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$89.03",
    description_eng:
      "Brand: Joyoung Rated voltage: 220V Capacity: 1L Rated power: 1000W Product size: length 217mm; Width 162mm; The height is 283mm Net weight: 2.1kg Cup body material: plastic outside and steel inside Model: DJ10X-D650 Available: 2023-03",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Joyoung/DJ10XD650.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1260",
    brand: "Joyoung",
    sku: "KL65V573",
    product_eng: "Joyoung Air Fryer 6.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$97.53",
    description_eng:
      "Brand: Joyoung Door opening mode: pull type Body material: non-stick coating Model :KL65-V573 Chassis type: flat chassis Capacity :6.5L Rated voltage :220V Rated power :2100W Net weight :4.9kg Product size: 374mm long; Width 270mm; Height 332mm Launch time :2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Joyoung/KL65V573.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1261",
    brand: "LEGO",
    sku: "L31145",
    product_eng: "LEGO red dragon 6 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$43.47",
    description_eng:
      "Brand: LEGO Number of grains :149 pieces Suitable age: 6 + years old",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L31145.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1262",
    brand: "LEGO",
    sku: "L76964",
    product_eng: "LEGO Jurassic World T-Rex skull 9 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$90.66",
    description_eng:
      "Brand: LEGO Number of particles :577 pieces Suitable age: 9 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L76964.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1263",
    brand: "LEGO",
    sku: "L31147",
    product_eng: "LEGO Retro Camera 8 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$60.63",
    description_eng:
      "Brand: LEGO Number of particles :261 pieces Suitable age: 8 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L31147.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1264",
    brand: "LEGO",
    sku: "L31140",
    product_eng: "LEGO Magic Unicorn 7 years old+",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$43.24",
    description_eng:
      "Brand: LEGO Number of grains :145 pieces Suitable age: 7 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L31140.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1265",
    brand: "LEGO",
    sku: "L31058",
    product_eng: "LEGO Tyrannosaurus ferocity 7-12 years old",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$46.33",
    description_eng:
      "Brand: LEGO Number of grains :174 pieces Suitable age: 7-12 years old",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L31058.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1266",
    brand: "LEGO",
    sku: "L42134",
    product_eng: "LEGO Megalodon truck 7 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$54.63",
    description_eng:
      "Brand: LEGO Number of grains :260 pieces Suitable age: 7 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L42134.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1267",
    brand: "LEGO",
    sku: "L71469",
    product_eng: "LEGO Nightmare Shark Boat 10 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$166.45",
    description_eng:
      "Brand: LEGO Number of particles :1389 pieces Suitable age: 10 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L71469.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1268",
    brand: "LEGO",
    sku: "L31152",
    product_eng: "LEGO space astronaut 9 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.10",
    description_eng:
      "Brand: LEGO Number of grains :647 pieces Suitable age: 9 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L31152.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1269",
    brand: "LEGO",
    sku: "L31156",
    product_eng: "LEGO Tropical Ukulele 8 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$74.65",
    description_eng:
      "Brand: LEGO Number of particles :387 pieces Suitable age: 8 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L31156.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1270",
    brand: "LEGO",
    sku: "L10787",
    product_eng: "LEGO Elf Cat garden party 4 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$60.63",
    description_eng:
      "Brand: LEGO Number of particles :130 pieces Suitable age: 4 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L10787.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1271",
    brand: "LEGO",
    sku: "L10788",
    product_eng: "LEGO Gabe's dollhouse 4 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$114.69",
    description_eng:
      "Brand: LEGO Number of particles :498 pieces Suitable age: 4 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L10788.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1272",
    brand: "LEGO",
    sku: "L10280",
    product_eng: "LEGO bouquet 18 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$96.67",
    description_eng:
      "Brand: LEGO Number of grains :756 pieces Suitable age: 18 +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L10280.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1273",
    brand: "LEGO",
    sku: "L76226",
    product_eng: "LEGO superhero Spider-Man 8 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$60.63",
    description_eng:
      "Brand: LEGO Number of particles :258 pieces Suitable age: 8 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L76226.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1274",
    brand: "LEGO",
    sku: "L76258",
    product_eng: "LEGO superhero Captain America 8 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$68.64",
    description_eng:
      "Brand: LEGO Number of grains :310 pieces Suitable age: 8 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L76258.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1275",
    brand: "LEGO",
    sku: "L21332",
    product_eng: "LEGO globe 18 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$275.85",
    description_eng:
      "Brand: LEGO Number of particles :2585 pieces Suitable age: 18 +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LEGO/L21332.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1276",
    brand: "LEGO",
    sku: "L31145",
    product_eng: "LEGO red dragon 6 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$47.76",
    description_eng:
      "Brand: LEGO Number of grains :149 pieces Suitable age: 6 + years old",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L31145.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1277",
    brand: "LEGO",
    sku: "L76964",
    product_eng: "LEGO Jurassic World T-Rex skull 9 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$94.95",
    description_eng:
      "Brand: LEGO Number of particles :577 pieces Suitable age: 9 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L76964.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1278",
    brand: "LEGO",
    sku: "L31147",
    product_eng: "LEGO Retro Camera 8 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$64.92",
    description_eng:
      "Brand: LEGO Number of particles :261 pieces Suitable age: 8 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L31147.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1279",
    brand: "LEGO",
    sku: "L31140",
    product_eng: "LEGO Magic Unicorn 7 years old+",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$47.53",
    description_eng:
      "Brand: LEGO Number of grains :145 pieces Suitable age: 7 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L31140.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1280",
    brand: "LEGO",
    sku: "L31058",
    product_eng: "LEGO Tyrannosaurus ferocity 7-12 years old",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$50.62",
    description_eng:
      "Brand: LEGO Number of grains :174 pieces Suitable age: 7-12 years old",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L31058.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1281",
    brand: "LEGO",
    sku: "L42134",
    product_eng: "LEGO Megalodon truck 7 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$58.92",
    description_eng:
      "Brand: LEGO Number of grains :260 pieces Suitable age: 7 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L42134.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1282",
    brand: "LEGO",
    sku: "L71469",
    product_eng: "LEGO Nightmare Shark Boat 10 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$170.74",
    description_eng:
      "Brand: LEGO Number of particles :1389 pieces Suitable age: 10 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L71469.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1283",
    brand: "LEGO",
    sku: "L31152",
    product_eng: "LEGO space astronaut 9 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$106.39",
    description_eng:
      "Brand: LEGO Number of grains :647 pieces Suitable age: 9 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L31152.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1284",
    brand: "LEGO",
    sku: "L31156",
    product_eng: "LEGO Tropical Ukulele 8 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$78.94",
    description_eng:
      "Brand: LEGO Number of particles :387 pieces Suitable age: 8 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L31156.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1285",
    brand: "LEGO",
    sku: "L10787",
    product_eng: "LEGO Elf Cat garden party 4 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$64.92",
    description_eng:
      "Brand: LEGO Number of particles :130 pieces Suitable age: 4 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L10787.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1286",
    brand: "LEGO",
    sku: "L10788",
    product_eng: "LEGO Gabe's dollhouse 4 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$118.98",
    description_eng:
      "Brand: LEGO Number of particles :498 pieces Suitable age: 4 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L10788.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1287",
    brand: "LEGO",
    sku: "L10280",
    product_eng: "LEGO bouquet 18 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$100.96",
    description_eng:
      "Brand: LEGO Number of grains :756 pieces Suitable age: 18 +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L10280.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1288",
    brand: "LEGO",
    sku: "L76226",
    product_eng: "LEGO superhero Spider-Man 8 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$64.92",
    description_eng:
      "Brand: LEGO Number of particles :258 pieces Suitable age: 8 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L76226.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1289",
    brand: "LEGO",
    sku: "L76258",
    product_eng: "LEGO superhero Captain America 8 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$72.93",
    description_eng:
      "Brand: LEGO Number of grains :310 pieces Suitable age: 8 years old +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L76258.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1290",
    brand: "LEGO",
    sku: "L21332",
    product_eng: "LEGO globe 18 years old +",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$280.14",
    description_eng:
      "Brand: LEGO Number of particles :2585 pieces Suitable age: 18 +",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LEGO/L21332.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1291",
    brand: "Lenovo",
    sku: "PadPro",
    product_eng: "Lenovo PadPro 12.7-inch 8+256 tablet WIFI",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$375.52",
    description_eng:
      "Brand: Lenovo Network connection: WiFi/WLAN Processor speed: 3.2GHz Number of speakers: 4 Net weight: 0.62kg Product size: length 293.37mm; Width 190.76mm; Height 6.9mm Screen type: LCD Screen ratio: 16:10 Feature Multi-touch control; AI voice; Hall sensor; Gravity induction; Light sensing; Gyroscope; A compass; Split screen function Rear camera pixel :800W Front camera pixel :1300W",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Lenovo/PadPro.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1292",
    brand: "LOCK&LOCK",
    sku: "LLB5158GLF003OCH",
    product_eng: "LOCK&LOCK storage box three-piece set green 58L*3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$75.99",
    description_eng:
      "Brand: LOCK&LOCK Material: Waterproof Oxford cloth Size: 50*40*30cm Capacity: 58L*3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LOCK&LOCK/LLB5158GLF003OCH.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1293",
    brand: "LOCK&LOCK",
    sku: "LLB5158YLF003OCH",
    product_eng: "LOCK&LOCK storage box three-piece set yellow 58L*3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$75.22",
    description_eng:
      "Brand: LOCK&LOCK Material: Waterproof Oxford cloth Size: 50*40*30cm Capacity: 58L*3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LOCK&LOCK/LLB5158YLF003OCH.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1294",
    brand: "LOCK&LOCK",
    sku: "LLB5158BLF003OCH",
    product_eng: "LOCK&LOCK storage box three-piece set blue 58L*3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$75.22",
    description_eng:
      "Brand: LOCK&LOCK Material: Waterproof Oxford cloth Size: 50*40*30cm Capacity: 58L*3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LOCK&LOCK/LLB5158BLF003OCH.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1295",
    brand: "LOCK&LOCK",
    sku: "LLB780S601",
    product_eng: "LOCK&LOCK storage box five-piece set 66L*5",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$85.34",
    description_eng:
      "Brand: LOCK&LOCK Material: Oxford cloth; Chrome-plated iron frame Size: 54*37*33cm Capacity: 66L*5",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LOCK&LOCK/LLB780S601.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1296",
    brand: "LOCK&LOCK",
    sku: "LLB816DBSH604",
    product_eng: "LOCK&LOCK storage box four-piece set 66L*4",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$78.88",
    description_eng:
      "Brand: LOCK&LOCK Material: Polyester plastic cloth; Iron stand Capacity: 66L*4",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LOCK&LOCK/LLB816DBSH604.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1297",
    brand: "LOCK&LOCK",
    sku: "LLB5158GLF003OCH",
    product_eng: "LOCK&LOCK storage box three-piece set green 58L*3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$80.28",
    description_eng:
      "Brand: LOCK&LOCK Material: Waterproof Oxford cloth Size: 50*40*30cm Capacity: 58L*3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LOCK&LOCK/LLB5158GLF003OCH.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1298",
    brand: "LOCK&LOCK",
    sku: "LLB5158YLF003OCH",
    product_eng: "LOCK&LOCK storage box three-piece set yellow 58L*3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$79.51",
    description_eng:
      "Brand: LOCK&LOCK Material: Waterproof Oxford cloth Size: 50*40*30cm Capacity: 58L*3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LOCK&LOCK/LLB5158YLF003OCH.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1299",
    brand: "LOCK&LOCK",
    sku: "LLB5158BLF003OCH",
    product_eng: "LOCK&LOCK storage box three-piece set blue 58L*3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$79.51",
    description_eng:
      "Brand: LOCK&LOCK Material: Waterproof Oxford cloth Size: 50*40*30cm Capacity: 58L*3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LOCK&LOCK/LLB5158BLF003OCH.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1300",
    brand: "LOCK&LOCK",
    sku: "LLB780S601",
    product_eng: "LOCK&LOCK storage box five-piece set 66L*5",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$89.63",
    description_eng:
      "Brand: LOCK&LOCK Material: Oxford cloth; Chrome-plated iron frame Size: 54*37*33cm Capacity: 66L*5",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LOCK&LOCK/LLB780S601.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1301",
    brand: "LOCK&LOCK",
    sku: "LLB816DBSH604",
    product_eng: "LOCK&LOCK storage box four-piece set 66L*4",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$83.17",
    description_eng:
      "Brand: LOCK&LOCK Material: Polyester plastic cloth; Iron stand Capacity: 66L*4",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LOCK&LOCK/LLB816DBSH604.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1302",
    brand: "LOVEYOUPET",
    sku: "LT100064",
    product_eng: "LOVE YOU PET pet backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$49.62",
    description_eng:
      "Brand: LOVEYOUPET Size: 33.5*28*43cm Net weight: 1.65kg Material: ABS, soft sponge, pearl cotton Applicable object: cat within 15 kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/LOVEYOUPET/LT100064.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1303",
    brand: "LOVEYOUPET",
    sku: "LT100064",
    product_eng: "LOVE YOU PET pet backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$53.91",
    description_eng:
      "Brand: LOVEYOUPET Size: 33.5*28*43cm Net weight: 1.65kg Material: ABS, soft sponge, pearl cotton Applicable object: cat within 15 kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/LOVEYOUPET/LT100064.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1304",
    brand: "MARK RYDEN",
    sku: "MR9299",
    product_eng: "MARK RYDEN backpack 17.3 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$57.71",
    description_eng:
      "Brand: MARK RYDEN 5 Pockets with multiple layers Individual digital warehouse USB charging port Capacity can be expanded by 14L 180° box opening and closing It can fit a 17.3-inch laptop",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MARKRYDEN/MR9299.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1305",
    brand: "MARK RYDEN",
    sku: "MR9299",
    product_eng: "MARK RYDEN backpack 17.3 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$62.00",
    description_eng:
      "Brand: MARK RYDEN 5 Pockets with multiple layers Individual digital warehouse USB charging port Capacity can be expanded by 14L 180° box opening and closing It can fit a 17.3-inch laptop",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/MARKRYDEN/MR9299.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1306",
    brand: "MI",
    sku: "K03A",
    product_eng: "MI Xiaoai Speaker Children's Edition",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$73.79",
    description_eng:
      "Brand: MI Model: K03A Bluetooth version: Bluetooth 5.2 Wireless connection: Bluetooth; WIFI Power supply type: Battery powered 10 hours long battery life 32GB large storage",
    description_jpn: "",
    product_image_1: "https://products.naganorewards.com/CN/images/MI/K03A.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1307",
    brand: "MI",
    sku: "PRO",
    product_eng: "MI Xiaoai Speaker Pro Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$73.79",
    description_eng:
      "Brand: MI 750mL large cavity volume Combination stereo AUX IN supports wired connections Master crafty tuning Hi-Fi audio chip Support infrared remote control of traditional home appliances Bluetooth Mesh gateway",
    description_jpn: "",
    product_image_1: "https://products.naganorewards.com/CN/images/MI/PRO.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1308",
    brand: "MI",
    sku: "M1000046",
    product_eng: "MI Xiaoai touch screen speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$69.93",
    description_eng:
      "Brand: MI Model :LX04 Bluetooth version: Bluetooth 5.0 Wireless connection: Bluetooth; WIFI",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MI/M1000046.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1309",
    brand: "MI",
    sku: "M1000056",
    product_eng: "MI backpack blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$51.42",
    description_eng:
      "Brand: MI Light guest pressure relief material 23L mass storage Level 4 waterproof Relaxed-cool carrying system",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MI/M1000056.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1310",
    brand: "MI",
    sku: "RedmiK70",
    product_eng: "MI Redmi K70 16GB+512GB mobile phone black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$552.35",
    description_eng:
      "Brand: MI Model :Redmi K70 Available Date :2023-11-29 Body size: width 74.95mm; Length 160.86mm; The thickness is 8.21mm Body weight :209g Body memory :512GB Running memory :16GB Screen refresh rate :120Hz Screen features: High frequency PWM dimming Screen size :6.67 inches Battery capacity :5000mAh(typ) Charging power :120W Wireless charging: Not supported 5G network: Supports 5G 4G network :4G FDD-LTE; 4G TD-LTE SIM card type :Nano SIM Dual-card machine Type: Dual-card dual-standby Charging interface :Type-C Biometrics: screen fingerprint Front camera main pixel :16 million pixels Rear shot 2- ultra wide Angle pixels :8 million pixels Rear shot 3-tele pixel: None",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MI/RedmiK70.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1311",
    brand: "MI",
    sku: "RedmiK70W",
    product_eng: "MI Redmi K70 16GB+512GB mobile phone white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$552.35",
    description_eng:
      "Brand: MI Model :Redmi K70 Available Date :2023-11-29 Body size: width 74.95mm; Length 160.86mm; The thickness is 8.21mm Body weight :209g Body memory :512GB Running memory :16GB Screen refresh rate :120Hz Screen features: High frequency PWM dimming Screen size :6.67 inches Battery capacity :5000mAh(typ) Charging power :120W Wireless charging: Not supported 5G network: Supports 5G 4G network :4G FDD-LTE; 4G TD-LTE SIM card type :Nano SIM Dual-card machine Type: Dual-card dual-standby Charging interface :Type-C Biometrics: screen fingerprint Front camera main pixel :16 million pixels Rear shot 2- ultra wide Angle pixels :8 million pixels Rear shot 3-tele pixel: None",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MI/RedmiK70W.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1312",
    brand: "MI",
    sku: "RedmiK70B",
    product_eng: "MI Redmi K70 16GB+512GB mobile phone blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$552.35",
    description_eng:
      "Brand: MI Model :Redmi K70 Available Date :2023-11-29 Body size: width 74.95mm; Length 160.86mm; The thickness is 8.21mm Body weight :209g Body memory :512GB Running memory :16GB Screen refresh rate :120Hz Screen features: High frequency PWM dimming Screen size :6.67 inches Battery capacity :5000mAh(typ) Charging power :120W Wireless charging: Not supported 5G network: Supports 5G 4G network :4G FDD-LTE; 4G TD-LTE SIM card type :Nano SIM Dual-card machine Type: Dual-card dual-standby Charging interface :Type-C Biometrics: screen fingerprint Front camera main pixel :16 million pixels Rear shot 2- ultra wide Angle pixels :8 million pixels Rear shot 3-tele pixel: None",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MI/RedmiK70B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1313",
    brand: "MI",
    sku: "RedmiK70P",
    product_eng: "MI Redmi K70 16GB+512GB mobile phone purple",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$552.35",
    description_eng:
      "Brand: MI Model :Redmi K70 Available Date :2023-11-29 Body size: width 74.95mm; Length 160.86mm; The thickness is 8.21mm Body weight :209g Body memory :512GB Running memory :16GB Screen refresh rate :120Hz Screen features: High frequency PWM dimming Screen size :6.67 inches Battery capacity :5000mAh(typ) Charging power :120W Wireless charging: Not supported 5G network: Supports 5G 4G network :4G FDD-LTE; 4G TD-LTE SIM card type :Nano SIM Dual-card machine Type: Dual-card dual-standby Charging interface :Type-C Biometrics: screen fingerprint Front camera main pixel :16 million pixels Rear shot 2- ultra wide Angle pixels :8 million pixels Rear shot 3-tele pixel: None",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MI/RedmiK70P.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1314",
    brand: "MI",
    sku: "M1000056",
    product_eng: "MI backpack blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$55.71",
    description_eng:
      "Brand: MI Light guest pressure relief material 23L mass storage Level 4 waterproof Relaxed-cool carrying system",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/MI/M1000056.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1315",
    brand: "Midea",
    sku: "MYE6910",
    product_eng: "Midea electric pressure cooker 6L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$94.72",
    description_eng:
      "Brand: Midea Model: MY-E6910 Display type: 88 screens Liner material: non-stick coating Rated power: 1000W Rated voltage: 220V Length of power cable: 1m Capacity: 6L Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MYE6910.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1316",
    brand: "Midea",
    sku: "MYC5936G",
    product_eng: "Midea electric pressure cooker 5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.04",
    description_eng:
      "Brand: Midea Model: MY-C5936G Display type: LCD Capacity: 5L Rated voltage: 220V Length of power cable: 1m Rated power: 800W Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MYC5936G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1317",
    brand: "Midea",
    sku: "MYS5879K",
    product_eng: "Midea electric pressure cooker 5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$174.17",
    description_eng:
      "Brand: Midea Liner material: fine steel Display type: 88 screens Model: MY-S5879K Capacity: 5L Rated power: 1600W Rated voltage: 220V Length of power cable: 1m Available: 2023-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MYS5879K.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1318",
    brand: "Midea",
    sku: "SZ2M40",
    product_eng: "Midea mist-free humidifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.66",
    description_eng:
      "Brand: Midea Product size: length 247.2mm; Width 247.2mm; The height is 403.7mm Noise: 34db Rated humidification capacity: 350ml/h Tank capacity: 4L Humidifying gear: 4 and above Control mode: touch Humidification method: no fog Style: Countertop Model: SZ-2M40 Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/SZ2M40.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1319",
    brand: "Midea",
    sku: "HGS282813",
    product_eng: "Midea electric hot pot 5.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$93.09",
    description_eng:
      "Brand: Midea Rated power: 2000W Liner material: cast iron Color: White Capacity: 5.5L Food contact surface material: medical stone coating Pan diameter: 31.2cm Model: MC-HGS282813 Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/HGS282813.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1320",
    brand: "Midea",
    sku: "MBAFB4041RL",
    product_eng: "Midea rice cooker 4L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$73.62",
    description_eng:
      "Brand: Midea Rated power: 760W Rated voltage: 220V Net weight: 3.3kg Power cable length: 0.9m Liner material: Aluminum alloy Model: MB-AFB4041RL Energy efficiency level: Level 3 energy efficiency Coating material: Teflon coating Capacity: 4L Steamer material: PP(polypropylene) Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MBAFB4041RL.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1321",
    brand: "Midea",
    sku: "PT1010",
    product_eng: "Midea air fryer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$59.69",
    description_eng:
      "Brand: Midea Model: PT1010 Available: 2023-03 Rated voltage: 220V Rated power: 1000W Product size: length 278mm; Width 283mm; Height 285mm Capacity: 9L Heating tube material: metal Number of heating tubes: 4 Built-in lighting: No built-in lighting Temperature control mode: mechanical temperature control",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/PT1010.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1322",
    brand: "Midea",
    sku: "R03",
    product_eng: "Midea toaster",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$50.42",
    description_eng:
      "Brand: Midea Rated power: 800W Baking speed: 6 Certified model: R03",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/R03.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1323",
    brand: "Midea",
    sku: "ZGS352002",
    product_eng: "Midea electric steamer 14L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$210.21",
    description_eng:
      "Brand: Midea Rated power: 2000W Rated voltage: 220V Power cable length: 0.8m Gear: 4 Food contact surface material: stainless steel Color: Green Capacity: 14L Model: MZ-ZGS352002 Pan diameter: 30cm Liner material: stainless steel Launch date: 2022-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/ZGS352002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1324",
    brand: "Midea",
    sku: "MZZGC262388",
    product_eng: "Midea electric steamer 12.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$83.11",
    description_eng:
      "Brand: Midea Rated voltage: 220V Rated power: 1300W Power cable length: 0.8m Gear: 1 gear Pan diameter: 30.9cm Food contact surface material: stainless steel Color: White Liner material: stainless steel Capacity: 12.5L Launch time: 2023-06",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MZZGC262388.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1325",
    brand: "Midea",
    sku: "MYC566N",
    product_eng: "Midea electric pressure cooker 4.8L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$112.51",
    description_eng:
      "Brand: Midea Liner material: enamel Model: MY-C566N Rated power: 1000W Capacity: 4.8L Rated voltage: 220V Length of power cable: 1m Available: 2023-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MYC566N.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1326",
    brand: "Midea",
    sku: "MYC244",
    product_eng: "Midea electric pressure cooker 2.2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$78.02",
    description_eng:
      "Brand: Midea Model: MY-C244 Liner material: non-stick coating Rated power: 730W Rated voltage: 220V Length of power cable: 1m Capacity: 2.2L Available: 2023-07",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MYC244.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1327",
    brand: "Midea",
    sku: "MYC567N",
    product_eng: "Midea electric pressure cooker 5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$136.48",
    description_eng:
      "Brand: Midea Model: MY-C567N Liner material: fine steel Capacity: 5L Rated voltage: 220V Rated power: 1300W Length of power cable: 1m Available: 2023-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MYC567N.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1328",
    brand: "Midea",
    sku: "MYC561",
    product_eng: "Midea electric pressure cooker 5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$109.80",
    description_eng:
      "Brand: Midea Model: MY-C561 Rated power: 1000W Capacity: 5L Rated voltage: 220V Length of power cable: 1m Launch time: 2023-06",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MYC561.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1329",
    brand: "Midea",
    sku: "MYE5910",
    product_eng: "Midea electric pressure cooker 5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$86.00",
    description_eng:
      "Brand: Midea Model: MY-E5910 Liner material: non-stick coating Rated power: 1000W Capacity: 5L Rated voltage: 220V Length of power cable: 1m Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MYE5910.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1330",
    brand: "Midea",
    sku: "MBCFB4089H",
    product_eng: "Midea rice cooker 4L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$206.21",
    description_eng:
      "Brand: Midea Rated voltage: 220V Net weight: 5.5kg Rated power: 1300W Power cable length: 0.9m Capacity: 4L Coating material: prepared long carbon Liner material: steel and aluminum alloy Steamer material: stainless steel Model: MB-CFB4089H Energy efficiency rating: Level 1 energy efficiency Available: 2023-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MBCFB4089H.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1331",
    brand: "Midea",
    sku: "MBRC328",
    product_eng: "Midea double-gallon rice cooker 1.6L*2",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$119.09",
    description_eng:
      "Brand: Midea Rated power :350W Rated voltage :220V Net weight :3.5kg Power cable length :0.9m Liner material: Aluminum alloy Energy efficiency level: Level 3 energy efficiency Steamer material :PP(polypropylene) Model :MB-RC328 Launch time :2023-06",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MBRC328.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1332",
    brand: "Midea",
    sku: "MBHS433",
    product_eng: "Midea rice cooker 4L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$194.77",
    description_eng:
      "Brand: Midea Net weight: 5.1kg Rated voltage: 220V Rated power: 1300W Power cable length: 0.9m Capacity: 4L Model: MB-HS433 Liner material: steel and aluminum alloy Steamer material: stainless steel Energy efficiency rating: Level 1 energy efficiency Available: 2023-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MBHS433.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1333",
    brand: "Midea",
    sku: "MBHS415",
    product_eng: "Midea rice cooker 4L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$249.11",
    description_eng:
      "Brand: Midea Rated voltage: 220V Net weight: 6.3kg Rated power: 1300W Power cable length: 0.9m Energy efficiency level: Level 2 energy efficiency Capacity: 4L Liner material: titanium Model: MB-HS415 1300w Steamer material: stainless steel Available: 2023-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MBHS415.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1334",
    brand: "Midea",
    sku: "MCE22B31Z",
    product_eng: "Midea induction cooker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$142.71",
    description_eng:
      "Brand: Midea Energy efficiency level: Level 3 energy efficiency Fire gear: 8 Model: MC-E22B31Z Net weight: 1.95kg Rated power: 2200W Product size: length 380mm; Width 296mm; Height 47mm Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MCE22B31Z.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1335",
    brand: "Midea",
    sku: "C22MICCA711",
    product_eng: "Midea induction cooker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.47",
    description_eng:
      "Brand: Midea Energy efficiency level: Level 3 energy efficiency Model: C22-MICCA711 Fire gear: 9 Product size: length 380mm; Width 296mm; Height 45mm Rated voltage: 220V Net weight: 2.56kg Rated power: 2200W Available: 2023-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/C22MICCA711.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1336",
    brand: "Midea",
    sku: "SH51Q",
    product_eng: "Midea electric kettle 1.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$45.73",
    description_eng:
      "Brand: Midea Rated power: 1500W Net weight: 0.94kg Rated voltage: 220V Power cable length: 0.72m Model: MK-SH51-Q Color: beige Capacity: 1.5L Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/SH51Q.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1337",
    brand: "Midea",
    sku: "10FPro",
    product_eng: "Midea electric hot water bottle 5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$106.71",
    description_eng:
      "Brand: Midea Rated power :1500W Power cable length :0.9m Net weight :2.88kg Rated voltage :220V Model :MK-SP50E-10FPro Capacity :5L Available :2023-07",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/10FPro.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1338",
    brand: "Midea",
    sku: "MCHGS303015",
    product_eng: "Midea electric hot pot 6.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$77.42",
    description_eng:
      "Brand: Midea Rated power :2000W Power cable length :1.2m Rated voltage :220V Gear :2 Capacity :6.5L Liner material: Aluminum alloy Model :MC-HGS303015 Food contact surface material: Teflon Color: Gold Pan diameter :30cm Available :2023-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/MCHGS303015.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1339",
    brand: "Midea",
    sku: "XZE2017",
    product_eng: "Midea electric cooker 1.6L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$55.68",
    description_eng:
      "Brand: Midea Rated power: 700W Gear: 2 Model: MC-XZE2017 Capacity: 1.6L Pan diameter: 20cm Food contact surface material: Teflon Color: White Liner material: stainless steel Available: 2023-03",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/XZE2017.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1340",
    brand: "Midea",
    sku: "KZE538J5",
    product_eng: "Midea air fryer 5.3L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$89.00",
    description_eng:
      "Brand: Midea Door opening mode: pull type Body material: non-stick coating Model: MF-KZE538J5 Capacity: 5.3L Chassis type: no-tip chassis Rated power: 1550W Product size: 372mm long; Width 276.0mm; The height is 295.0mm Rated voltage: 220V Net weight: 4.2kg Available: 2023-12",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/KZE538J5.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1341",
    brand: "Midea",
    sku: "KZE1502KS1",
    product_eng: "Midea Air Fryer 1.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$85.80",
    description_eng:
      "Brand: Midea Door opening mode: pull type Body material: non-stick coating Chassis type: flat chassis Model :MF-KZE1502-KS1 Capacity :1.5L Rated power :900W Net weight :1.8kg Product size: 270mm long; Width 204mm; The height is 213mm Available :2023-07",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/KZE1502KS1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1342",
    brand: "Midea",
    sku: "KZC5504",
    product_eng: "Midea Air Fryer 5.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$101.53",
    description_eng:
      "Brand: Midea Door opening mode: pull type Body material: non-stick coating Capacity :5.5L Chassis type: no-tip chassis Model :MF-KZC5504 Product size: 268mm long; Width 377mm; The height is 319.0mm Rated power :2000W Rated voltage :220V Net weight :4.8kg Available :2023-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Midea/KZC5504.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1343",
    brand: "MiDeer",
    sku: "MD11621",
    product_eng: "MiDeer Archimedes Building Blocks 300 piece set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$99.84",
    description_eng: "Brand: MiDeer Age: 3+ Material: Bamboo powder, PP,PE",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MiDeer/MD11621.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1344",
    brand: "MiDeer",
    sku: "MD6395",
    product_eng: "MiDeer magnetic block",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$82.08",
    description_eng: "Brand: MiDeer Age: 3+ Material: Magnet +MABS",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MiDeer/MD6395.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1345",
    brand: "MiDeer",
    sku: "MD11621",
    product_eng: "MiDeer Archimedes Building Blocks 300 piece set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$104.13",
    description_eng: "Brand: MiDeer Age: 3+ Material: Bamboo powder, PP,PE",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/MiDeer/MD11621.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1346",
    brand: "MiDeer",
    sku: "MD6395",
    product_eng: "MiDeer magnetic block",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$86.37",
    description_eng: "Brand: MiDeer Age: 3+ Material: Magnet +MABS",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/MiDeer/MD6395.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1347",
    brand: "MIJIA",
    sku: "CJSJSQ01MX",
    product_eng: "MIJIA fog-free humidifier 3Pro",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$408.41",
    description_eng:
      "Brand: MIJIA Control mode: APP control Style: Floor to floor Model: CJSJSQ01MX Product size: length 280mm; Width 280mm; The height is 670mm Rated humidification capacity: 1500ml/h Noise: 57.2db Tank capacity: 15L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MIJIA/CJSJSQ01MX.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1348",
    brand: "MIJIA",
    sku: "CJSJSQ02XY",
    product_eng: "MIJIA fog-free humidifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$98.47",
    description_eng:
      "Brand: MIJIA Product size: 230mm long; Width 230mm; The height is 390mm Rated humidification capacity: 400ml/h Noise: 32db Tank capacity: 4L Humidification method: no fog Control mode: APP control Style: Floor to floor Model: CJSJSQ02XY Available: 2023-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MIJIA/CJSJSQ02XY.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1349",
    brand: "MOBIGARDEN",
    sku: "NX22665048",
    product_eng: "MOBIGARDEN outdoor folding chair",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$61.20",
    description_eng:
      "Brand: MOBIGARDEN Material: Fabric: 600D Oxford cloth, bracket: aluminum alloy Expansion size: W54*D55*H63CM Storage size: 55*9*57CM Sitting height: 28.5cm Net weight: about 2.3kg Static pressure load: 240 kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/MOBIGARDEN/NX22665048.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1350",
    brand: "MOBIGARDEN",
    sku: "NX22665048",
    product_eng: "MOBIGARDEN outdoor folding chair",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$65.49",
    description_eng:
      "Brand: MOBIGARDEN Material: Fabric: 600D Oxford cloth, bracket: aluminum alloy Expansion size: W54*D55*H63CM Storage size: 55*9*57CM Sitting height: 28.5cm Net weight: about 2.3kg Static pressure load: 240 kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/MOBIGARDEN/NX22665048.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1351",
    brand: "Morphyrichards",
    sku: "MR8300",
    product_eng: "Morphyrichards Folding Warming Board",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$84.46",
    description_eng:
      "Brand: Morphyrichards Applicable tableware material: ceramic; Metal; Glass; Enamel; Purple sand; High temperature resistant plastic Model: MR8300 Panel color: white Control mode: touch",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Morphyrichards/MR8300.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1352",
    brand: "Morphyrichards",
    sku: "MR9405",
    product_eng: "Morphyrichards multifunctional food processor",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$72.87",
    description_eng:
      "Brand: Morphyrichards Rated frequency: 50Hz Rated power: 180W Rated voltage: 220V Motor speed: 22000 RPM Capacity: 1L Model: MR9405 Blade pages: 4 knives Number of gears: 1 Product size: length 134mm; Width 134mm; The height is 283mm Available: 2023-03",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Morphyrichards/MR9405.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1353",
    brand: "Morphyrichards",
    sku: "MR6090",
    product_eng: "Morphyrichards Portable Travel Electric Kettle 400ml",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$50.51",
    description_eng:
      "Brand: Morphyrichards Rated power: 700W Net weight: 0.7kg Rated voltage: 220V Power cable length: 0.8m Application scenario: Travel Capacity: 0.4L Color: Blue Certified model: MR6090",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Morphyrichards/MR6090.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1354",
    brand: "Morphyrichards",
    sku: "MR8101",
    product_eng: "Morphyrichards Air Fryer 4L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$129.56",
    description_eng:
      "Brand: Morphyrichards Chassis type: flat chassis Body material: non-stick coating Door opening mode: pull type Capacity :4L Model :MR8101 Net weight :4.5kg Rated voltage :220V Product size: length 310mm; Width 252mm; Height 275mm Rated power :1500W Available :2023-03",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Morphyrichards/MR8101.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1355",
    brand: "OIWAS",
    sku: "OCN7065",
    product_eng: "OIWAS casual travel bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$59.43",
    description_eng:
      "Brand: OIWAS Size: 48.5*23*27.5cm Material: Fabric Weight: 0.77kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/OIWAS/OCN7065.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1356",
    brand: "OIWAS",
    sku: "OCN8001",
    product_eng: "OIWAS travel trolley bag black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$59.43",
    description_eng:
      "Brand: OIWAS Size: 57.5*26.5*36cm Material: Fabric Weight: 1.87kg Capacity: Approx. 55L(before expansion)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/OIWAS/OCN8001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1357",
    brand: "OIWAS",
    sku: "OCN8001R",
    product_eng: "OIWAS travel trolley bag red",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$59.43",
    description_eng:
      "Brand: OIWAS Size: 57.5*26.5*36cm Material: Fabric Weight: 1.87kg Capacity: Approx. 55L(before expansion)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/OIWAS/OCN8001R.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1358",
    brand: "OIWAS",
    sku: "OCN7065",
    product_eng: "OIWAS casual travel bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$63.72",
    description_eng:
      "Brand: OIWAS Size: 48.5*23*27.5cm Material: Fabric Weight: 0.77kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/OIWAS/OCN7065.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1359",
    brand: "OIWAS",
    sku: "OCN8001",
    product_eng: "OIWAS travel trolley bag black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$63.72",
    description_eng:
      "Brand: OIWAS Size: 57.5*26.5*36cm Material: Fabric Weight: 1.87kg Capacity: Approx. 55L(before expansion)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/OIWAS/OCN8001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1360",
    brand: "OIWAS",
    sku: "OCN8001R",
    product_eng: "OIWAS travel trolley bag red",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$63.72",
    description_eng:
      "Brand: OIWAS Size: 57.5*26.5*36cm Material: Fabric Weight: 1.87kg Capacity: Approx. 55L(before expansion)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/OIWAS/OCN8001R.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1361",
    brand: "Panasonic",
    sku: "SRDK101",
    product_eng: "Panasonic Rice Cooker 3.2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$109.85",
    description_eng:
      "Rated voltage: 220V Length of power cable: 1m Net weight: 3kg Rated power: 750W Liner material: Aluminum alloy Coating material: prepared long carbon Model: SR-DK101 Steamer material: PP(polypropylene) Capacity: 3.2L Main color: white Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/SRDK101.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1362",
    brand: "Panasonic",
    sku: "DS37",
    product_eng: "Panasonic Micro steaming/baking/frying machine 23L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$414.70",
    description_eng:
      "Rated voltage :220V Barbecue power :1350W Product size: length 483mm; Width 456mm; The height is 338mm Net weight :13.3kg Capacity :23L Rated frequency :50Hz Microwave power :1000W Model :NN-DS37PW Available :2023-07",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/DS37.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1363",
    brand: "Panasonic",
    sku: "LS9AX",
    product_eng: "Panasonic 9 series electric shaver",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$564.62",
    description_eng:
      "Brand: panasonics Net weight: 0.8kg Product size: length 164mm; Width 48mm; Height 70mm Battery life: 45 minutes Model: ES-LS9AX Launch time: 2022-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/LS9AX.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1364",
    brand: "Panasonic",
    sku: "NIGWF240",
    product_eng: "Panasonic hanging ironing machine",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$305.16",
    description_eng:
      "Brand: panasonics Tank capacity: 1.6L Rated voltage: 220V Rated power: 2200W Exhaust time: 60S or more Ironing brush panel material: ceramic Model: NI-GWF240 Color: Purple",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/NIGWF240.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1365",
    brand: "Panasonic",
    sku: "RRTK30",
    product_eng: "Panasonic Smart toilet seat",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$405.92",
    description_eng:
      "Brand: panasonics Quick drying Ultra-thin body Remote operation Thermostatic temperature Automatic deodorization Toilet ring heating",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/RRTK30.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1366",
    brand: "Panasonic",
    sku: "TKAD61C",
    product_eng: "Panasonic heating water purifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$350.64",
    description_eng:
      "Brand: panasonics Use: Drinking water; Straight drink Rated net water: 2000L Outlet temperature: normal temperature water; Hot water Filtration principle: reverse osmosis Filter level: 4 levels Installation mode: No installation Water efficiency grade: Level 3 Model: TK-AD61C",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/TKAD61C.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1367",
    brand: "Panasonic",
    sku: "DA80",
    product_eng: "Panasonic foot massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$231.15",
    description_eng:
      "Brand: panasonics Rated voltage: 220V Power cable length: 1.8m Net weight: 5.8kg Rated power: 45W Gear adjustment: three gear adjustment Model: EW-DA80PN492",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/DA80.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1368",
    brand: "Panasonic",
    sku: "DSPL2023CW",
    product_eng: "Panasonic heater",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$430.57",
    description_eng:
      "Brand: panasonics Rated voltage: 220V Rated power: 2000W Heating method: ceramic heating Number of heating tablets: 15 or more Waterproof rating: IPX4 Gear: 5 or more Operation mode: remote control Model: DS-PL2023CW",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/DSPL2023CW.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1369",
    brand: "Panasonic",
    sku: "EWRJ50",
    product_eng: "Panasonic knee massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$239.15",
    description_eng:
      "Brand: panasonics Model: EW-RJ50 Gear adjustment: three gear adjustment Product size: length 825mm; 385mm wide; Height 50mm Rated power: 110W Rated voltage: 220V Net weight: 0.7kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/EWRJ50.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1370",
    brand: "Panasonic",
    sku: "MCA21G",
    product_eng: "Panasonic A Series wireless handheld vacuum cleaner",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$302.30",
    description_eng:
      "Brand: panasonics Rated power: 450W Rated voltage: 220V Suction head type: cylinder dual suction nozzle Number of suction heads: 3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/MCA21G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1371",
    brand: "Panasonic",
    sku: "NA9K",
    product_eng: "Panasonic Hair Dryer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$155.01",
    description_eng:
      "Brand: panasonics Appearance design: straight tube type Main color: Red Model: EH-NA9K Cold air gear: first gear Support: No support Hot air gear: first gear Display: There is no display Operation mode: mechanical Handle is foldable: Not foldable Product size: length 141mm; Width 76mm; The height is 247mm Hair care module: There are hair care modules Rated power: 1500W Net weight: 0.6kg Power cable length: 1.7m Motor type: High speed",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/NA9K.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1372",
    brand: "Panasonic",
    sku: "NFPC401L",
    product_eng: "Panasonic 4L electric pressure cooker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$175.03",
    description_eng:
      "Brand: panasonics Display type: 88 screens Model: NF-PC401-L Rated voltage: 220V Rated power: 800W Capacity: 4L Power cable length: 0.9m",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/NFPC401L.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1373",
    brand: "Panasonic",
    sku: "EWDC70W",
    product_eng: "Panasonic electric toothbrush white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$172.17",
    description_eng:
      "Brand: panasonics Model: EW-DC2-W405 Brush head shape: Long head Product size: 247mm long; Width 35mm; Height 30mm Net weight: 160g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/EWDC70W.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1374",
    brand: "Panasonic",
    sku: "EWDC70A",
    product_eng: "Panasonic electric toothbrush blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$172.17",
    description_eng:
      "Brand: panasonics Model: EW-DC2-W405 Brush head shape: Long head Product size: 247mm long; Width 35mm; Height 30mm Net weight: 160g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/EWDC70A.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1375",
    brand: "Panasonic",
    sku: "EWDC70G",
    product_eng: "Panasonic electric toothbrush green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$172.17",
    description_eng:
      "Brand: panasonics Model: EW-DC2-W405 Brush head shape: Long head Product size: 247mm long; Width 35mm; Height 30mm Net weight: 160g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/EWDC70G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1376",
    brand: "Panasonic",
    sku: "EWDC70P",
    product_eng: "Panasonic electric toothbrush orange",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$172.17",
    description_eng:
      "Brand: panasonics Model: EW-DC2-W405 Brush head shape: Long head Product size: 247mm long; Width 35mm; Height 30mm Net weight: 160g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/EWDC70P.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1377",
    brand: "Panasonic",
    sku: "NIFS770G",
    product_eng: "Panasonic hand-held steam hanging press",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$115.69",
    description_eng:
      "Brand: panasonics Rated power: 950W Tank capacity: 0.15L Rated voltage: 220V Exhaust time: 16-25S Ironing brush panel material: ceramic Color: Green Model: NI-FS770-G",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/NIFS770G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1378",
    brand: "Panasonic",
    sku: "SRHTL155",
    product_eng: "Panasonic rice cooker 4.2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$289.43",
    description_eng:
      "Brand: panasonics Rated voltage: 220V Rated power: 1370W Net weight: 6.1kg Power cable length: 0.9m Number of IH segments: Multiple segments Model: SR-HTL155 Capacity: 4.2L Coating material: prepared long carbon Liner material: steel and aluminum alloy Steamer material: stainless steel Main color: white Energy efficiency rating: Level 1 energy efficiency",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/SRHTL155.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1379",
    brand: "Panasonic",
    sku: "NFHW200",
    product_eng: "Panasonic warming board",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$111.25",
    description_eng:
      "Brand: panasonics Applicable tableware material: ceramic; High temperature resistant plastic; Metal; Glass; Enamel; Purple sand Panel color: white Model: NF-HW200 Control mode: touch Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/NFHW200.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1380",
    brand: "Panasonic",
    sku: "LM34",
    product_eng: "Panasonic electric shaver",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$156.73",
    description_eng:
      "Brand: panasonics Net weight: 0.18kg Product size: length 168mm; Width 68mm; Height 45mm Battery life: 65 minutes",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/LM34.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1381",
    brand: "Panasonic",
    sku: "DSPF2226CH",
    product_eng: "Panasonic heater (High-end heating and cooling)",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$233.66",
    description_eng:
      "Brand: panasonics Rated power: 2200W Rated voltage: 220V Heating method: ceramic heating Number of heating sheets: No heating sheets Operation mode: remote control Model: DS-PF2226CH",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/DSPF2226CH.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1382",
    brand: "Panasonic",
    sku: "SRDB071K",
    product_eng: "Panasonic 2L microcomputer rice cooker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$85.66",
    description_eng:
      "Brand: panasonics Net weight: 2.64kg Rated voltage: 220V Rated power: 400W Power cable length: 0.9m Liner material: Aluminum alloy Energy efficiency level: Level 3 energy efficiency Steamer material: No steamer Capacity: 2L Model: SR-DB071-K",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/SRDB071K.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1383",
    brand: "Panasonic",
    sku: "JLM3C",
    product_eng: "Panasonic electric shaver",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$125.27",
    description_eng:
      "Brand: panasonics Net weight: 0.18kg Product size: length 168mm; Width 68mm; Height 45mm Battery life: 65 minutes Model: ES-JLM3CK405",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/JLM3C.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1384",
    brand: "Panasonic",
    sku: "LM35",
    product_eng: "Panasonic electric shaver",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$142.03",
    description_eng:
      "Brand: panasonics Net weight: 0.18kg Product size: length 168mm; Width 68mm; Height 45mm Battery life: 65 minutes Model: ES-LM35-V",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/LM35.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1385",
    brand: "Panasonic",
    sku: "NFHC600A",
    product_eng: "Panasonic 6L air fryer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$203.63",
    description_eng:
      "Brand: panasonics Chassis type: flat chassis Door opening mode: pull type Model: NF-HC600 Capacity: 6L Body material: non-stick coating Rated power: 1400W Net weight: 4.5kg Product size: length 360mm; Width 260mm; Height 350mm Rated voltage: 220V",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Panasonic/NFHC600A.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1386",
    brand: "petgugu",
    sku: "PF2",
    product_eng: "petgugu Smart pet feeder",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$319.46",
    description_eng:
      "Brand: petgugu Capacity: 3.5L Rated power: 10W Operating temperature: 0-50℃ Working humidity: 10%-90%RH Food basin material: handmade ceramic Power cable: 1.5m",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/petgugu/PF2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1387",
    brand: "PHILIPS",
    sku: "S7388",
    product_eng: "PHILIPS electric shaver 7 series",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$212.93",
    description_eng:
      "General voltage: 220V Product size: 92mm long; Width 162mm; Height 245mm Battery life: 60 minutes Model: S7388/07 Available: 2023-03 Packing list: Shaver travel protection case charging cable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/S7388.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1388",
    brand: "PHILIPS",
    sku: "S3203",
    product_eng: "PHILIPS electric shaver 3 series high-end version",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$76.62",
    description_eng:
      "Product size: 242mm long; Width 242mm; Height 82mm Battery life: 50 minutes Model: S3203/08 Available: 2023-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/S3203.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1389",
    brand: "PHILIPS",
    sku: "X5003",
    product_eng: "PHILIPS Electric Shaver Honeycomb X Glare Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$111.23",
    description_eng:
      "Product size: 70mm long; Width 100mm; Height 190mm Battery life: 50 minutes Model: X5003/00 Launch time: 2022-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/X5003.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1390",
    brand: "PHILIPS",
    sku: "X5009",
    product_eng:
      "PHILIPS electric shaver 5 series pro League of Legends IP model",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$133.91",
    description_eng:
      "Product size: 70mm long; Width 100mm; Height 190mm Battery life: 50 minutes Model: X5009/00 Launch time: 2022-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/X5009.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1391",
    brand: "PHILIPS",
    sku: "S9936",
    product_eng: "PHILIPS Electric Shaver Honeycomb 9 Series Pro+ Gift Box",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$413.13",
    description_eng:
      "Product size: length 344mm; Width 278mm; Height 272mm Battery life: 60 minutes Model: S9936/55BBP Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/S9936.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1392",
    brand: "PHILIPS",
    sku: "S9889",
    product_eng:
      "PHILIPS Electric Shaver Honeycomb 9 Series Year of the Dragon Limited Gift Box",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$596.88",
    description_eng:
      "Product size: 394mm long; Width 376mm; Height 245mm Battery life: 60 minutes Model: S9889/88BP Available: 2023-11",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/S9889.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1393",
    brand: "PHILIPS",
    sku: "PQ888",
    product_eng: "PHILIPS mini electric shaver",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$88.52",
    description_eng:
      "Product size: 110mm long; Width 145mm; Height 79mm Battery life: 60 minutes Model: PQ888/06 Launch date: 2022-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/PQ888.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1394",
    brand: "PHILIPS",
    sku: "HX2432",
    product_eng:
      "PHILIPS children's sonic vibration toothbrush, suitable for 4-6-12 years old, blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$72.53",
    description_eng:
      "Model: HX2432/01 Blue Net weight: 85g Product size: 86mm long; Width 59mm; The height is 189mm Launch date: 2022-06",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HX2432.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1395",
    brand: "PHILIPS",
    sku: "HX2432P",
    product_eng:
      "PHILIPS children's sonic vibration toothbrush, suitable for 4-6-12 years old, pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$72.53",
    description_eng:
      "Model: HX2432/01 Pink Net weight: 85g Product size: 86mm long; Width 59mm; The height is 189mm Launch date: 2022-06",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HX2432P.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1396",
    brand: "PHILIPS",
    sku: "HC9450",
    product_eng: "PHILIPS professional electric hair clipper",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$135.79",
    description_eng:
      "Product size: 245mm long; Width 182mm; Height 70mm Rated voltage: 220V Battery life: 120 minutes Charging time: 60 minutes Model: HC9450/15",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HC9450.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1397",
    brand: "PHILIPS",
    sku: "HC5690",
    product_eng: "PHILIPS electric hair clipper",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$68.78",
    description_eng:
      "Product size: 225mm long; Width 190mm; Height 70mm Rated voltage: 220V Charging time: 60 minutes Battery life: 90 minutes Certified model: HC5690/15",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HC5690.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1398",
    brand: "PHILIPS",
    sku: "QC5131",
    product_eng: "PHILIPS electric hair clipper",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$47.59",
    description_eng:
      "Product size: 222mm long; Width 140mm; Height 70mm Rated voltage: 220V Charging time: 480 minutes Battery life: 60 minutes Certified model: QC5131/15",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/QC5131.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1399",
    brand: "PHILIPS",
    sku: "BHD 538",
    product_eng: "PHILIPS hair dryer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$85.49",
    description_eng:
      "Certified model: BHD538/05 Cold air gear: first gear Handle is foldable: Foldable Hot air gear: second gear Operation mode: mechanical Net weight: 0.72kg Rated power: 2200W Power cable length: 1.8m Product size: 267mm long; Width 255mm; Height 110mm Launch time: 2022-07",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/BHD538.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1400",
    brand: "PHILIPS",
    sku: "BHD 737",
    product_eng: "PHILIPS high speed hair dryer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$244.10",
    description_eng:
      "Certified Model: BHD737 Cold air gear: first gear Bracket: There is a bracket Display: There is a display Hot air gear: 4th gear Operation mode: mechanical Handle is foldable: Not foldable Hair care module: There are hair care modules Power cable length: 1.8m Product size: length 316mm; Width 240mm; Height 109mm Rated power: 1400W Motor type: High speed Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/BHD737.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1401",
    brand: "PHILIPS",
    sku: "BHD 720",
    product_eng: "PHILIPS hair dryer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$126.58",
    description_eng:
      "Certified model: BHD720 Cold air gear: first gear Hot air gear: 4th gear Operation mode: mechanical Handle is foldable: Not foldable Rated power: 1800W Hair care module: There are hair care modules Power cable length: 1.8m Product size: length 330mm; Width 237mm; Height 115mm Motor type: High speed Net weight: 0.58kg Available: 2023-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/BHD720.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1402",
    brand: "PHILIPS",
    sku: "BRR 454",
    product_eng: "PHILIPS facial electric shaver",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$56.20",
    description_eng:
      "Rated voltage: 220V Rated power: 1W Power supply: dry battery Model: BRR454/00 Electric heating: Not supported Certified Model: BRR454/00 Launch time: 2023-06",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/BRR454.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1403",
    brand: "PHILIPS",
    sku: "BHB878",
    product_eng: "PHILIPS fully automatic electric curling iron",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$170.23",
    description_eng:
      "Net weight: 0.65kg Power supply mode: Power supply Rated voltage: 220V Length of power cord: 2m Rated power: 32W Product size: 350mm long; Width 150mm; The height is 108mm Preheating time: 30s Model: BHB878/15 Launch date: 2022-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/BHB878.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1404",
    brand: "PHILIPS",
    sku: "BHS510",
    product_eng: "PHILIPS Electric Curling Iron/Straight Clamp Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$80.51",
    description_eng:
      "Power supply mode: Power supply Net weight :0.48kg Power cable length :1.8m Rated voltage :220V Rated power :53W Product size: 370mm long; Width 121mm; Height 60mm Preheating time :30s Model :BHS510 Launch time :2022-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/BHS510.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1405",
    brand: "PHILIPS",
    sku: "BHS510W",
    product_eng: "PHILIPS Electric Curling Iron/Straight Clamp White",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$80.51",
    description_eng:
      "Power supply mode: Power supply Net weight :0.48kg Power cable length :1.8m Rated voltage :220V Rated power :53W Product size: 370mm long; Width 121mm; Height 60mm Preheating time :30s Model :BHS510 Launch time :2022-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/BHS510W.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1406",
    brand: "PHILIPS",
    sku: "HX2491",
    product_eng: "PHILIPS electric toothbrush white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$86.23",
    description_eng:
      "Model: HX2491/01 Product size: length 261mm; Width 167mm; The height is 61mm Net weight: 400g Available: 2023-03 Packing list: Brush head, handle, travel case, charger",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HX2491.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1407",
    brand: "PHILIPS",
    sku: "HX2491R",
    product_eng: "PHILIPS electric toothbrush red",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$86.23",
    description_eng:
      "Model: HX2491/01 Product size: length 261mm; Width 167mm; The height is 61mm Net weight: 400g Available: 2023-03 Packing list: Brush head, handle, travel case, charger",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HX2491R.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1408",
    brand: "PHILIPS",
    sku: "HX2411",
    product_eng: "PHILIPS electric toothbrush green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$82.11",
    description_eng:
      "Model: HX2411/03 Product size: 190mm long; Width 88mm; Height 60mm Net weight: 300g Launch time: 2023-06 Packing list: Brush handle *1, brush head *1, charging base *1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HX2411.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1409",
    brand: "PHILIPS",
    sku: "HX2411P",
    product_eng: "PHILIPS electric toothbrush purple",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$82.11",
    description_eng:
      "Model: HX2411/03 Product size: 190mm long; Width 88mm; Height 60mm Net weight: 300g Launch time: 2023-06 Packing list: Brush handle *1, brush head *1, charging base *1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HX2411P.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1410",
    brand: "PHILIPS",
    sku: "HX3792",
    product_eng: "PHILIPS Electric Toothbrush Diamond 7 Series Pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$172.32",
    description_eng:
      "Model: HX3792/02 Product size: 253mm long; Width 155mm; Height 65mm Net weight: 500g Available: 2023-07 Packing list: G3 brush head *2, handle *1, charging base *1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HX3792.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1411",
    brand: "PHILIPS",
    sku: "HX3792B",
    product_eng: "PHILIPS Electric Toothbrush Diamond 7 Series Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$172.32",
    description_eng:
      "Model: HX3792/02 Product size: 253mm long; Width 155mm; Height 65mm Net weight: 500g Available: 2023-07 Packing list: G3 brush head *2, handle *1, charging base *1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HX3792B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1412",
    brand: "PHILIPS",
    sku: "3303G",
    product_eng: "Philips mini fascia gun",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$56.11",
    description_eng:
      "Model: PPM3303G Gear adjustment: five gear adjustment Net weight: 0.24kg Rated power: 15W Rated voltage: 7.4V Launch time: 2022-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/3303G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1413",
    brand: "PHILIPS",
    sku: "5201L",
    product_eng: "PHILIPS knee massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$169.31",
    description_eng:
      "Model: PPM5201L Gear adjustment: three gear adjustment Available: 2023-01",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/5201L.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1414",
    brand: "PHILIPS",
    sku: "5302F",
    product_eng: "PHILIPS foot bath bucket",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$175.03",
    description_eng:
      "Product size: 382mm long; Width 382mm; It is 483mm high Net weight: 5.8kg Power cable length: 1.5m Heating power: 1000W Rated voltage: 220V Capacity: 18L Water level height: 21-25cm Maximum water temperature: 48℃ Heating method: DPS heating Model: PPM5302F Launch time: 2022-11",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/5302F.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1415",
    brand: "PHILIPS",
    sku: "SWR8106E",
    product_eng: "Philips HDMI Wireless Screen Projector 50 Meter Transmitter",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$154.30",
    description_eng:
      "Model: SWR8106E/93 Interface: HDMI interface, Type-C interface Packing list: Screen projector (receiving end) *1 Screen projector (transmitting section) *1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SWR8106E.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1416",
    brand: "PHILIPS",
    sku: "SWR8106",
    product_eng: "Philips 4K mobile phone wireless screen projector",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$55.48",
    description_eng:
      "Model: SWR8106 Interface: HDMI interface, Type-C interface Packing list: Wireless projector *1, HDMI cable *1, TYPE-C cable *1, manual *1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SWR8106.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1417",
    brand: "PHILIPS",
    sku: "AHR2244FD",
    product_eng: "PHILIPS heater",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$107.94",
    description_eng:
      "Rated voltage: 220V Rated power: 2000W Number of heating tablets: 1 Control mode: touch Gear: 2 Heating method: graphene heating Certified Model: AHR2244FD Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AHR2244FD.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1418",
    brand: "PHILIPS",
    sku: "3203F",
    product_eng: "PHILIPS foot bath bucket",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$110.31",
    description_eng:
      "Net weight: 5kg Power cable length: 1.5m Product size: 370mm long; Width 442mm; The height is 416mm Heating power: 850W Rated voltage: 220V Water level height: 21-25cm Maximum water temperature: 48℃ 35-48℃ temperature control Capacity: 15L Heating method: DPS heating Model: PPM3203F Color: White Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/3203F.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1419",
    brand: "PHILIPS",
    sku: "AHR3144ED",
    product_eng: "PHILIPS electric blanket double",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$188.02",
    description_eng:
      "Rated power: 190W Rated voltage: 220V Heating method: electric heating wire heating Control mode: touch Number of heating sheets: No heating sheets Certified model: AHR3144ED Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AHR3144ED.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1420",
    brand: "PHILIPS",
    sku: "ADD6815",
    product_eng: "PHILIPS heating water purifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$281.14",
    description_eng:
      "Rated net water: 2000L Filtration principle: reverse osmosis Filter level: 3 levels Usage: domestic water; Potable water Installation mode: No installation Water efficiency grade: Grade 1 Model: ADD6815 Launch date: 2022-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/ADD6815.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1421",
    brand: "PHILIPS",
    sku: "5401L",
    product_eng: "PHILIPS knee massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$135.79",
    description_eng:
      "Model: PPM5401L Gear adjustment: three gear adjustment Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/5401L.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1422",
    brand: "PHILIPS",
    sku: "SHP 9600",
    product_eng: "PHILIPS headphones",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$93.75",
    description_eng:
      "Line length: 3m Model: SHP9600 Line type: unilateral wire",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SHP9600.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1423",
    brand: "PHILIPS",
    sku: "DLP2202G",
    product_eng: "PHILIPS power bank 20000 mAh black gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$49.62",
    description_eng:
      "Battery capacity: 20000mAh Charging protocol: SCP Rated capacity: 12000mAh Type: Power bank Net weight: 360g Input voltage: 5V Output voltage: 12V Product size: length 93.5mm; Width 89mm; The height is 32.6mm Input method: Type-c Input Number of USB ports: 2",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/DLP2202G.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1424",
    brand: "PHILIPS",
    sku: "DLP2202GB",
    product_eng: "PHILIPS power bank 20000 mAh blue gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$49.62",
    description_eng:
      "Battery capacity: 20000mAh Charging protocol: SCP Rated capacity: 12000mAh Type: Power bank Net weight: 360g Input voltage: 5V Output voltage: 12V Product size: length 93.5mm; Width 89mm; The height is 32.6mm Input method: Type-c Input Number of USB ports: 2",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/DLP2202GB.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1425",
    brand: "PHILIPS",
    sku: "27M2N5510J",
    product_eng: "Philips 27-inch 2K native 180Hz FastIPS fast LCD 1ms",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$311.17",
    description_eng:
      "Color: Silver black Model: 27M2N5510J Screen size: 27 inches Brightness: 400cd/㎡ Point distance: 0.2331mm Wall mounting specifications: 100x100mm Power Supply type: Built-in power supply Support base: rotary lifting Built-in speaker: No built-in speaker",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/27M2N5510J.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1426",
    brand: "PHILIPS",
    sku: "3111B",
    product_eng: "Philips waist massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$115.06",
    description_eng:
      "Model: PPM3111B Gear adjustment: four-gear adjustment Net weight: 1.4kg Rated voltage: 11.6V Rated power: 24W",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/3111B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1427",
    brand: "PHILIPS",
    sku: "7202E",
    product_eng: "Philips eye massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$276.85",
    description_eng:
      "Brand: PHILIPS Charging voltage: 5V Charging current: 500mA Operating voltage: 3.7V Working power: 5W Battery capacity: 1000mAh Size: 223*116*75mm Net weight: 0.315kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/7202E.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1428",
    brand: "PHILIPS",
    sku: "HU4816",
    product_eng: "PHILIPS mist-free humidifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$116.49",
    description_eng:
      "Rated humidification capacity: 300ml/h Product size: 249mm long; Width 249mm; The height is 379mm Noise: 33db Tank capacity: 4L Control mode: push-button type Style: Countertop Humidifying gear: 2 Model: HU4816",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HU4816.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1429",
    brand: "PHILIPS",
    sku: "AIS8540",
    product_eng: "PHILIPS vertical high-definition garment steamer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$516.80",
    description_eng:
      "Rated voltage: 220V Tank capacity: 1.2L Rated power: 2200W Exhaust time: 60S or more Suitable material: hemp; Chemical fiber; Cotton; Woolen; Plush; Silk Certified model: AIS8540/80 Available: 2023-03",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AIS8540.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1430",
    brand: "PHILIPS",
    sku: "STE1050",
    product_eng: "PHILIPS powerful single-rod steamer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$101.62",
    description_eng:
      "Tank capacity: 1.8L Rated voltage: 220V Rated power: 1800W Color: White Ironing brush panel material: stainless steel Certified model: STE1050/10 Launch time: 2022-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/STE1050.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1431",
    brand: "PHILIPS",
    sku: "HD9455",
    product_eng: "PHILIPS air fryer 5L green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$130.42",
    description_eng:
      "Door opening mode: pull type Body material: non-stick coating Chassis type: no-tip chassis Certified model: HD9455 Capacity: 5L Rated power: 1700W Net weight: 4.7kg Product size: length 390mm; Width 275mm; Height 285mm Rated voltage: 220V Available: 2023-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HD9455.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1432",
    brand: "PHILIPS",
    sku: "HD9455B",
    product_eng: "PHILIPS air fryer 5L black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$130.42",
    description_eng:
      "Door opening mode: pull type Body material: non-stick coating Chassis type: no-tip chassis Certified model: HD9455 Capacity: 5L Rated power: 1700W Net weight: 4.7kg Product size: length 390mm; Width 275mm; Height 285mm Rated voltage: 220V Available: 2023-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HD9455B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1433",
    brand: "PHILIPS",
    sku: "EP3146",
    product_eng: "PHILIPS cloud coffee machine",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$628.34",
    description_eng:
      "Rated voltage: 220V Length of power cable: 1m Rated power: 1500W Grinding gear: 12 stops Pump pressure: 15Bar Features: Bean/powder dual use Color: Champagne gold Certified model: EP3146/72",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/EP3146.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1434",
    brand: "PHILIPS",
    sku: "FC9735",
    product_eng: "PHILIPS horizontal vacuum cleaner",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$217.67",
    description_eng:
      "Rated power: 1800W Rated voltage: 220V Suction head type: 2-in-1 wide flat suction Number of suction heads: 4 Launch date: 2022-01",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/FC9735.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1435",
    brand: "PHILIPS",
    sku: "S15",
    product_eng: "Philips Smartphone 8+128G White",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$134.99",
    description_eng:
      "Launch Date: 2023-09-13 Body size: width 75mm; Length 163.5mm; It is 7.95mm thick Body weight: 195g Memory card: MicroSD(TF) support Running memory: 8GB Body memory: 128GB Screen size: 6.5 inches Screen refresh rate: 60Hz Wireless charging: Not supported Battery capacity: 3900mAh(typ) Charging power: 10W Operating system: Android 5G network: Not supported 4G network: 4G FDD-LTE; 4G TD-LTE SIM card type: Nano SIM Dual-card machine Type: Dual-card dual-standby Number of SIM cards: 2 Charging interface: Type-C Mobile phone features Biometrics: face recognition; Lateral fingerprint Front camera main pixel: 5 million pixels",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/S15.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1436",
    brand: "PHILIPS",
    sku: "S15B",
    product_eng: "Philips Smartphone 8+128G Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$134.99",
    description_eng:
      "Launch Date: 2023-09-13 Body size: width 75mm; Length 163.5mm; It is 7.95mm thick Body weight: 195g Memory card: MicroSD(TF) support Running memory: 8GB Body memory: 128GB Screen size: 6.5 inches Screen refresh rate: 60Hz Wireless charging: Not supported Battery capacity: 3900mAh(typ) Charging power: 10W Operating system: Android 5G network: Not supported 4G network: 4G FDD-LTE; 4G TD-LTE SIM card type: Nano SIM Dual-card machine Type: Dual-card dual-standby Number of SIM cards: 2 Charging interface: Type-C Mobile phone features Biometrics: face recognition; Lateral fingerprint Front camera main pixel: 5 million pixels",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/S15B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1437",
    brand: "PHILIPS",
    sku: "5101B",
    product_eng: "Philips waist massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$190.19",
    description_eng:
      "Model: PPM5101B Gear adjustment: four-gear adjustment Launch date: 2022-01",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/5101B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1438",
    brand: "PHILIPS",
    sku: "AHR3124FX",
    product_eng: "PHILIPS heater",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$117.26",
    description_eng:
      "Gear: 3 Control mode: APP control Number of heating sheets: No heating sheets Waterproof class: IPX2 Heating method: ceramic heating Certified model: AHR3124FX Available: 2023-01",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AHR3124FX.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1439",
    brand: "PHILIPS",
    sku: "TAS2808WT",
    product_eng: "Philips microphone audio integrated microphone",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$65.78",
    description_eng:
      "Model: TAS2808 Color: White Main material: Plastic Type: Passive speaker Bluetooth version: Bluetooth 5.3 Power supply type: Battery powered Wireless connection: Bluetooth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAS2808WT.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1440",
    brand: "PHILIPS",
    sku: "SFL2189P",
    product_eng: "PHILIPS strong light flashlight",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$42.39",
    description_eng:
      "Brand: PHILIPS Lamp power: 21W(3W*7) Lumen: 1700LM Exposure range: 120㎡ flood light Battery capacity: 4000mAh Battery life: 900min (low light) Anti-fall height: 1m Protection class: IP55 Charging mode: Type-C Net weight: 200g Product size: Diameter 40* height 128mm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SFL2189P.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1441",
    brand: "PHILIPS",
    sku: "5301H",
    product_eng: "PHILIPS Scalp Smart Massage Comb",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$127.78",
    description_eng:
      "Model: PPM5301H Gear adjustment: second gear adjustment Available: 2023-12",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/5301H.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1442",
    brand: "PHILIPS",
    sku: "5101M",
    product_eng: "Philips multifunctional massage mattress",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$348.35",
    description_eng:
      "Model: PPM5101M Gear adjustment: three gear adjustment Available: 2023-07",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/5101M.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1443",
    brand: "PHILIPS",
    sku: "3305B",
    product_eng: "PHILIPS abdominal belt",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.67",
    description_eng:
      "Model: PPM3305B Gear adjustment: more than five Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/3305B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1444",
    brand: "PHILIPS",
    sku: "FC6730",
    product_eng: "PHILIPS Cordless Handheld Vacuum Cleaner",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$267.98",
    description_eng:
      "Rated voltage: 18V Rated power: 100W Number of suction heads: 2 Suction head type: 2-in-1 wide flat suction Launch date: 2022-01",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/FC6730.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1445",
    brand: "PHILIPS",
    sku: "5502F",
    product_eng: "Philips leg massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$241.67",
    description_eng:
      "Model: PPM5502F Gear adjustment: three gear adjustment Product size: 279mm long; Width 114mm; The height is 434mm Net weight: 1.3kg Rated power: 20W Rated voltage: 7.4V Available: 2023-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/5502F.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1446",
    brand: "PHILIPS",
    sku: "AWP2792WH",
    product_eng: "PHILIPS water boiling thermos cup white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$50.34",
    description_eng:
      "Brand: philips Capacity: 400ml Liner material: 316 stainless steel Quickly boil water on five sets",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AWP2792WH.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1447",
    brand: "PHILIPS",
    sku: "AWP2792WHG",
    product_eng: "PHILIPS water boiling thermos cup black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$50.34",
    description_eng:
      "Brand: philips Capacity: 400ml Liner material: 316 stainless steel Quickly boil water on five sets",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AWP2792WHG.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1448",
    brand: "PHILIPS",
    sku: "AWP2792WHP",
    product_eng: "PHILIPS water boiling thermos cup black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$50.34",
    description_eng:
      "Brand: philips Capacity: 400ml Liner material: 316 stainless steel Quickly boil water on five sets",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AWP2792WHP.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1449",
    brand: "PHILIPS",
    sku: "AWP2775WH",
    product_eng: "PHILIPS smart thermos cup white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$47.13",
    description_eng:
      "Brand: philips Capacity: 460ml Liner material: 316 stainless steel Intelligent temperature sensing, a touch of temperature Plug and charge, universal type-c port",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AWP2775WH.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1450",
    brand: "PHILIPS",
    sku: "AWP2775WHG",
    product_eng: "PHILIPS smart thermos cup gold",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$47.13",
    description_eng:
      "Brand: philips Capacity: 460ml Liner material: 316 stainless steel Intelligent temperature sensing, a touch of temperature Plug and charge, universal type-c port",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AWP2775WHG.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1451",
    brand: "PHILIPS",
    sku: "AWP2775WHB",
    product_eng: "PHILIPS smart thermos cup white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$47.13",
    description_eng:
      "Brand: philips Capacity: 460ml Liner material: 316 stainless steel Intelligent temperature sensing, a touch of temperature Plug and charge, universal type-c port",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AWP2775WHB.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1452",
    brand: "PHILIPS",
    sku: "AWP2775WHBL",
    product_eng: "PHILIPS smart thermos cup white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$47.13",
    description_eng:
      "Brand: philips Capacity: 460ml Liner material: 316 stainless steel Intelligent temperature sensing, a touch of temperature Plug and charge, universal type-c port",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AWP2775WHBL.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1453",
    brand: "PHILIPS",
    sku: "GCA2200",
    product_eng: "PHILIPS hair ball trimmer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$45.22",
    description_eng:
      "Rated voltage: 3.6V Charging time: 4H Duration: 5H Model: GCA2200/10 Launch time: 2022-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/GCA2200.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1454",
    brand: "PHILIPS",
    sku: "P66153",
    product_eng: "PHILIPS sensor night light",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$31.69",
    description_eng:
      "Brand: philips Induction light, people to automatically light up, people leave 15 seconds after the automatic turn off the light charging Very long endurance Easy to install Double shift brightness Light effect is soft, 3000K light, warm like candlelight",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/P66153.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1455",
    brand: "PHILIPS",
    sku: "DLP4107N",
    product_eng: "Philips Car Bluetooth Receiver",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$45.87",
    description_eng:
      "Brand: philips Fast charge: PD30W Android Super Fast charge Interface: A+A+C External audio: Support USB/Bluetooth connection Atmosphere light: Supported",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/DLP4107N.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1456",
    brand: "PHILIPS",
    sku: "TAH5705",
    product_eng: "PHILIPS headphones",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$53.97",
    description_eng:
      "Brand: philips Acoustic structure: enclosed Connection mode: type-c interface Frequency range: 10-20000Hz Impedance: 32 ohms Sensitivity (dB) :98dB(1KHz) Maximum power input: 100mW Data cable length: 142cm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAH5705.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1457",
    brand: "PHILIPS",
    sku: "5202N",
    product_eng: "Philips cervical massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$134.62",
    description_eng:
      "Brand: philips Model: PPM5202N Gear adjustment: second gear adjustment Available: 2023-07",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/5202N.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1458",
    brand: "PHILIPS",
    sku: "TAR3578",
    product_eng: "PHILIPS Bluetooth Clock Speaker Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$95.24",
    description_eng:
      "Brand: philips FM radio Bluetooth connection Clock + Alarm clock USB playback TF card playback LED large screen display Temperature display Built-in lithium battery Type-c charging port",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAR3578.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1459",
    brand: "PHILIPS",
    sku: "TAR3578W",
    product_eng: "PHILIPS Bluetooth Clock Speaker White",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$95.24",
    description_eng:
      "Brand: philips FM radio Bluetooth connection Clock + Alarm clock USB playback TF card playback LED large screen display Temperature display Built-in lithium battery Type-c charging port",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAR3578W.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1460",
    brand: "PHILIPS",
    sku: "GoSure3201",
    product_eng: "PHILIPS driving recorder",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$53.51",
    description_eng:
      "Brand: philips 1080P HD image quality Voice control Night vision enhancement 132° Wide Angle F2.0 Large aperture Mobile APP connection Tired driving warning Intelligent voice Parking monitoring",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/GoSure3201.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1461",
    brand: "PHILIPS",
    sku: "ACR5166TN",
    product_eng: "PHILIPS heater",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$399.83",
    description_eng:
      "Brand: philips Rated power: 3000W Rated voltage: 220V Heating method: ceramic heating Number of heating tablets: 1 Gear: 2 Control mode: APP control Certified model: ACR5166TN Available: 2023-03",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/ACR5166TN.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1462",
    brand: "PHILIPS",
    sku: "XB2023",
    product_eng: "PHILIPS horizontal vacuum cleaner",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.90",
    description_eng:
      "Brand: philips Rated voltage: 220V Rated power: 1500W Number of suction heads: 2 Suction head type: 2-in-1 wide flat suction Launch date: 2022-01",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/XB2023.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1463",
    brand: "PHILIPS",
    sku: "P66136",
    product_eng: "PHILIPS national AA grade eye protection desk lamp white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$135.56",
    description_eng:
      "Brand: philips Take a seat and turn on the light Intelligent automatic dimming Eye care pupil happy light High color reducibility Regular rest reminder Delay turning off the lights and sending them to sleep",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/P66136.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1464",
    brand: "PHILIPS",
    sku: "P66136B",
    product_eng: "PHILIPS national AA grade eye protection desk lamp black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$135.56",
    description_eng:
      "Brand: philips Take a seat and turn on the light Intelligent automatic dimming Eye care pupil happy light High color reducibility Regular rest reminder Delay turning off the lights and sending them to sleep",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/P66136B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1465",
    brand: "PHILIPS",
    sku: "AC3036",
    product_eng: "PHILIPS air purifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$388.10",
    description_eng:
      "Brand: philips Rated power: 55W Rated voltage: 220V Motor type: DC brushless motor Purification method: filter type Filter pollutant type: PM2.5; Allergens; bacteria Solid pollutant CADR: 450m³/h Particulate matter CCM: P4 Gaseous CADR: 300m³/h HEPA filter grade: H12 Gaseous pollutant CCM: F4 Model: AC3036/00",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AC3036.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1466",
    brand: "PHILIPS",
    sku: "HD9366",
    product_eng: "PHILIPS thermostatic electric kettle 1.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$45.73",
    description_eng:
      "Brand: philips Rated power: 1500W Net weight: 1kg Rated voltage: 220V Power cable length: 0.8m Color: White Capacity: 1.5L Certified model: HD9366 Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HD9366.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1467",
    brand: "PHILIPS",
    sku: "NT5600",
    product_eng: "PHILIPS electric nose hair trimmer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$62.69",
    description_eng:
      "Brand: philips Comfort trim Safe and comfortable High quality imported stainless steel cutter head Double efficiency Full body washing Lube free AA battery",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/NT5600.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1468",
    brand: "PHILIPS",
    sku: "HR2037",
    product_eng: "PHILIPS household wall breaking machine",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$98.58",
    description_eng:
      "Brand: philips Heating power: 600W Mixing power: 200W Maximum noise: 67 decibels Rated voltage: 220V Function: rice paste; Soybean Milk; Fruit and vegetable juice; Porridge; Corn juice; Complementary food; Milkshake making Main cup capacity: 0.6L Certified model: HR2037/50 Head type: serrated knife Available: 2023-03",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HR2037.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1469",
    brand: "PHILIPS",
    sku: "SA6116",
    product_eng: "PHILIPS 16G HIFI lossless music MP3 player",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$94.61",
    description_eng:
      "Brand: philips Screen touch: multi-touch Type: TFT screen Product size: length 39mm; Width 45mm; Height 12mm Net weight: 31g Storage type: Flash FM: Supports the FM function A-B rereading: A-B rereading is supported PPT format: PPT format is not supported Outgoing function: The outgoing function is not supported Recording: Recording is not supported Ebook reading: Not supported OTG function: Supports OTG function",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SA6116.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1470",
    brand: "PHILIPS",
    sku: "AWP2813GNT",
    product_eng: "PHILIPS water purification kettle 3.4L 7 cores in one pot",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$50.51",
    description_eng:
      "Brand: philips Rated net water: 100L Filtration principle: ion displacement Outlet temperature: normal temperature water Usage: domestic water; Potable water Filter level: 4 levels Installation mode: No installation Water efficiency grade: Grade 1 Model: AWP2813GNT (a pot of seven cores) Launch time: 2022-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AWP2813GNT.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1471",
    brand: "PHILIPS",
    sku: "A5",
    product_eng: "PHILIPS national AA grade eye protection desk lamp",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$396.97",
    description_eng:
      "Brand: philips The whole table protects the eyes No blue light hazard, no video flash Anti-glare auxiliary light source Automatic brightness control Take a seat and turn on the light 40 minute break reminder Chroma/brightness is adjustable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/A5.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1472",
    brand: "PHILIPS",
    sku: "7201B",
    product_eng: "PHILIPS waist massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$212.58",
    description_eng:
      "Brand: philips Model: PPM7201B Gear adjustment: four-gear adjustment Launch time: 2022-11",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/7201B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1473",
    brand: "PHILIPS",
    sku: "3302N",
    product_eng: "Philips cervical massager blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$54.97",
    description_eng:
      "Brand: philips Model: PPM3302N Gear adjustment: five gear adjustment Rated voltage: 3.7V Net weight: 0.1kg Rated power: 1W",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/3302N.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1474",
    brand: "PHILIPS",
    sku: "3302NW",
    product_eng: "Philips cervical massager white",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$54.97",
    description_eng:
      "Brand: philips Model: PPM3302N Gear adjustment: five gear adjustment Rated voltage: 3.7V Net weight: 0.1kg Rated power: 1W",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/3302NW.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1475",
    brand: "PHILIPS",
    sku: "DLK5303B",
    product_eng: "Philips bluetooth selfie stick",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$50.34",
    description_eng:
      "Brand: philips Multi-dimensional perspective ABS+ metal material Anti-shake head Cardan rotation Firm and steady Bluetooth remote control Wide compatibility",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/DLK5303B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1476",
    brand: "PHILIPS",
    sku: "P66143",
    product_eng: "PHILIPS Eye Protection Rechargeable Desk Lamp Magnetic",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$40.73",
    description_eng:
      "Brand: philips Variable scene Charge and plug Very long endurance Brightness color temperature is adjustable Anti-glare design Strobe free",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/P66143.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1477",
    brand: "PHILIPS",
    sku: "TAS2009",
    product_eng: "Philips computer speakers",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$43.67",
    description_eng:
      "Brand: philips Model: TAS2009 Bluetooth version: Bluetooth 5.3 Power supply type: Battery powered Wireless connection: Bluetooth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAS2009.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1478",
    brand: "PHILIPS",
    sku: "P66142",
    product_eng: "PHILIPS eye-protecting desk lamp rechargeable and plug-in",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$93.44",
    description_eng:
      "Brand: philips 30 seconds delay turn off the lights Constant bright system, the brightness is stable and does not weaken 5200mAh lithium battery, only charged once a week Crystal drill honeycomb filter, anti-halo anti-glare no glare Endless dimming, brightness as desired Three color temperature, multi-scene use",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/P66142.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1479",
    brand: "PHILIPS",
    sku: "GC626",
    product_eng: "PHILIPS vertical booster ironing machine",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$285.43",
    description_eng:
      "Brand: philips Tank capacity: 2L Rated voltage: 220V Rated power: 2200W Exhaust time: 60S or more Certified model: GC626/38 Ironing brush panel material: stainless steel Color: Purple Launch date: 2022-02",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/GC626.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1480",
    brand: "PHILIPS",
    sku: "7101N",
    product_eng: "PHILIPS cervical massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$190.76",
    description_eng:
      "Brand: philips Model: PPM7101N Gear adjustment: second gear adjustment Product size: length 308mm; Width 290mm; The height is 124mm Rated power: 10W Rated voltage: 3.7V Net weight: 1.33kg Available: 2023-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/7101N.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1481",
    brand: "PHILIPS",
    sku: "HD9880",
    product_eng: "PHILIPS new variable speed air fryer 8.3L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$401.26",
    description_eng:
      "Brand: philips Door opening mode: pull type Body material: non-stick coating Capacity: 8.3L Chassis type: no-tip chassis Certified model: HD9880 Rated power: 2000W Rated voltage: 220V Product size: long 443mm; 335mm wide; The height is 351mm Net weight: 9.5kg Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HD9880.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1482",
    brand: "PHILIPS",
    sku: "HD3063",
    product_eng: "PHILIPS 1.8L Mini Rice Cooker White",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$55.86",
    description_eng:
      "Brand: philips Rated voltage: 220V Rated power: 400W Net weight: 2.2kg Power cable length: 0.9m Liner material: Aluminum alloy Energy efficiency level: Level 3 energy efficiency Steamer material: No steamer Certified model: HD3063/20 Capacity: 1.8L Launch date: 2022-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HD3063.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1483",
    brand: "PHILIPS",
    sku: "HD3063B",
    product_eng: "PHILIPS 1.8L Mini Rice Cooker Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$55.86",
    description_eng:
      "Brand: philips Rated voltage: 220V Rated power: 400W Net weight: 2.2kg Power cable length: 0.9m Liner material: Aluminum alloy Energy efficiency level: Level 3 energy efficiency Steamer material: No steamer Certified model: HD3063/20 Capacity: 1.8L Launch date: 2022-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HD3063B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1484",
    brand: "PHILIPS",
    sku: "DST8041",
    product_eng: "PHILIPS steam iron",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$201.20",
    description_eng:
      "Brand: philips Rated voltage: 220V Tank capacity: 0.35L Rated power: 2200W Exhaust time: 10-15S Certified model: DST8041/88 Ironing brush panel material: stainless steel Color: Black Launch time: 2022-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/DST8041.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1485",
    brand: "PHILIPS",
    sku: "GP7101",
    product_eng: "PHILIPS car air purifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$151.55",
    description_eng:
      "Brand: philips Filtered toluene Filter total volatile organic compounds TVOC,CADR Filtered formaldehyde Filter vehicle exhaust PM2.5 CADR PM2.5 Energy efficiency rating: High efficiency TVOC Energy Efficiency Rating: High Efficiency",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/GP7101.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1486",
    brand: "PHILIPS",
    sku: "PPM3401FDB",
    product_eng: "PHILIPS foot massage machine",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$82.65",
    description_eng:
      "Brand: philips Model: PPM3401FDB/93 Gear adjustment: second gear adjustment Available: 2023-01",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/PPM3401FDB.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1487",
    brand: "PHILIPS",
    sku: "3106F",
    product_eng: "PHILIPS folding foot bucket",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$56.57",
    description_eng:
      "Brand: philips Water level height: 21-25cm Heating method: PTC heating Model: PPM3106F Color: White Launch time: 2022-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/3106F.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1488",
    brand: "PHILIPS",
    sku: "3501F",
    product_eng: "PHILIPS foot massage mat",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$94.47",
    description_eng:
      "Brand: philips Operating voltage: 3.7V Charging voltage: 5V Charging current: 300mA Battery capacity: 300mAh Working power: 1W",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/3501F.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1489",
    brand: "PHILIPS",
    sku: "CNB0303",
    product_eng: "PHILIPS atomizer children's model",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$168.88",
    description_eng:
      "Brand: philips Model: CN-B-0303 Structure and composition: It is composed of main engine, gas pipe, atomizing device, bite mouth and suction mask. Storage condition: normal temperature Name of medical device: Atomizer Medical device category: Class II 08 Medical device or not: Yes Whether the atomization volume is adjustable: not adjustable Noise: ≤65db",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/CNB0303.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1490",
    brand: "PHILIPS",
    sku: "SA3116",
    product_eng: "PHILIPS mp3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$103.65",
    description_eng:
      "Brand: philips Screen touch: multi-touch FM: Supports the FM function A-B rereading: A-B rereading is supported Headphone port :3.5mm Outgoing function: Supports outgoing function Fast forward and fast back: Support fast forward and fast back Ebook reading :txt format Recording: Supports recording OTG function: Supports OTG function",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SA3116.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1491",
    brand: "PHILIPS",
    sku: "TAJT60",
    product_eng: "PHILIPS true wireless Bluetooth headphones",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$347.63",
    description_eng:
      "Brand: philips Model :TAJT60/00 Dust resistance :IP5X Charging interface :Type-C",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAJT60.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1492",
    brand: "PHILIPS",
    sku: "TAA7607",
    product_eng: "PHILIPS bone conduction Bluetooth headphones",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$162.36",
    description_eng:
      "Brand: philips Model :TAA7607LC Color: Black Waterproof class :IPX6 Dustproof performance :IP6X Charging interface :Type-C",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAA7607.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1493",
    brand: "PHILIPS",
    sku: "TAA5608",
    product_eng: "PHILIPS bone conduction Bluetooth headphones",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$112.26",
    description_eng:
      "Brand: philips Model :TAA5608 Color: Black Charging interface :Type-C Waterproof rating :IPX5",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAA5608.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1494",
    brand: "PHILIPS",
    sku: "DB12",
    product_eng: "PHILIPS finger clip pulse oximeter",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$85.60",
    description_eng:
      "Brand: philips Model :DB12 Name of medical device: pulse oximeter Product size (cm) :5.5X3.5X3.4 Display mode :LCD digital Medical device category: Class II 08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/DB12.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1495",
    brand: "PHILIPS",
    sku: "TAUT102S",
    product_eng: "PHILIPS true wireless Bluetooth headphones green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$43.04",
    description_eng:
      "Brand: philips Color: Green Waterproof rating :IPX4 Charging interface :Type-C",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAUT102S.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1496",
    brand: "PHILIPS",
    sku: "TAUT102SR",
    product_eng: "PHILIPS true wireless Bluetooth headphones red",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$42.70",
    description_eng:
      "Brand: philips Color: Red Waterproof rating :IPX4 Charging interface :Type-C",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAUT102SR.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1497",
    brand: "PHILIPS",
    sku: "3201H",
    product_eng: "PHILIPS head massager",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$128.47",
    description_eng:
      "Brand: philips Model :PPM3201H Gear adjustment: three gear adjustment Net weight :0.45kg Rated voltage :5V Rated power :3.5W Product size: 191mm long; Width 78mm; Height 74mm Launch time :2022-08",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/3201H.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1498",
    brand: "PHILIPS",
    sku: "SHM1100",
    product_eng: "PHILIPS microphone",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$55.91",
    description_eng:
      "Brand: philips Heart-shaped pickup to filter out noise Folding storage to free up space High sensitivity microphone Built-in heavy iron, shock-proof design Adjustable Angle 90-160 degrees No drive required, plug and play Compatible computer USB A to C cable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SHM1100.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1499",
    brand: "PHILIPS",
    sku: "SA5016",
    product_eng: "Philips mp3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$110.71",
    description_eng:
      "Brand: philips 4.0-inch screen Lossless music playback 1100mAh large capacity battery Wireless Bluetooth 16GB large memory Continue listening for about 10 hours OTG convenient links Chinese-english dictionary",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SA5016.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1500",
    brand: "PHILIPS",
    sku: "ADD6800",
    product_eng: "PHILIPS heating water purifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$281.14",
    description_eng:
      "Brand: philips Filter level: 5 levels Filtration principle: reverse osmosis Usage: domestic water; Potable water Installation mode: No installation Model: ADD6800",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/ADD6800.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1501",
    brand: "PHILIPS",
    sku: "XW7110",
    product_eng: "PHILIPS wireless smart floor scrubber",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$373.37",
    description_eng:
      "Brand: philips Battery life: 20-30 minutes Sewage tank capacity: 0.6L Clean water tank capacity: 0.67L Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/XW7110.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1502",
    brand: "PHILIPS",
    sku: "5220YE",
    product_eng:
      "PHILIPS new national standard outdoor 16A high power socket 15 meters",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$72.70",
    description_eng:
      "Brand: PHILIPS Hole combination: 16A high power anti-fall extension cable Total length: 15m Rated current: 16A Rated voltage: 250V-50Hz Max power: 4000W",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/5220YE.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1503",
    brand: "PHILIPS",
    sku: "VTR9000Pro",
    product_eng: "PHILIPS AI smart recording pen 32G+64G",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$377.66",
    description_eng:
      "Brand: philips Model: VTR9000Pro Color: Grey Battery type: Lithium battery Product net weight (kg) : 0.105 Product size: 112mm long; Width 52mm; Height 11.5mm Microphone: Built-in microphone Recording format: WAV Speaker: Built-in speaker",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/VTR9000Pro.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1504",
    brand: "PHILIPS",
    sku: "EXP5608",
    product_eng: "philips CD player",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$155.76",
    description_eng:
      "Brand: philips Model: EXP5608 Color: Black Main material: Plastic Line length: Wireless Bluetooth version: Bluetooth 5.0 Power supply type: Battery powered",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/EXP5608.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1505",
    brand: "PHILIPS",
    sku: "TAS1108",
    product_eng: "Philips Luminous Bluetooth Speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$67.38",
    description_eng:
      "Brand: philips Model :TAS1108 Main material: Plastic Bluetooth version: Bluetooth 5.1 Power supply type: Battery powered Wireless connection: Bluetooth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAS1108.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1506",
    brand: "PHILIPS",
    sku: "DLP4303B",
    product_eng: "Philips Car Bluetooth Receiver",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$36.18",
    description_eng:
      "Brand: PHILIPS Working voltage: 12V-24V Power: 18W Input voltage: 12V-24V Transmission frequency: 87.5-108MHz Bluetooth version: Bluetooth V5.3 Bluetooth frequency: 2.4GHz Effective distance: about 10m Launching distance: ≤5m Support expansion: U disk /TF card",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/DLP4303B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1507",
    brand: "PHILIPS",
    sku: "STH7030",
    product_eng: "PHILIPS handheld garment steamer",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$129.33",
    description_eng:
      "Brand: philips Rated power: 1500W Rated voltage: 220V Tank capacity: 0.3L Exhaust time: 26-30S Ironing brush panel material: aluminum alloy Model: STH7030/18 Color: Champagne gold Launch date: 2022-03",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/STH7030.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1508",
    brand: "PHILIPS",
    sku: "TAVS300",
    product_eng: "PHILIPS Retro Portable Wireless Bluetooth Speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$97.18",
    description_eng:
      "Brand: philips Model: TAVS300 Main material: Plastic Line length: Wireless Bluetooth version: Bluetooth 5.0 Wireless connection: Bluetooth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAVS300.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1509",
    brand: "PHILIPS",
    sku: "TAVS700",
    product_eng: "PHILIPS Retro Wireless Bluetooth Speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$281.14",
    description_eng:
      "Brand: philips Model: TAVS700/93 Main material: Plastic Line length: 1.5-2m Bluetooth version: Bluetooth 5.0 Wireless connection: Bluetooth Power Supply type: Power supply",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAVS700.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1510",
    brand: "PHILIPS",
    sku: "3502N",
    product_eng: "PHILIPS neck massage pillow",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$124.78",
    description_eng:
      "Brand: philips Model: PPM3502N Gear adjustment: three gear adjustment Available: 2023-01",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/3502N.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1511",
    brand: "PHILIPS",
    sku: "TAPH805",
    product_eng: "PHILIPS active noise reduction headphones",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$111.74",
    description_eng:
      "Brand: PHILIPS Drive unit: 40mm Impedance: 16 ohms Sensitivity: 90dB Frequency range: 7-40kHz (noise reduction off) Noise reduction: ANC intelligent active noise reduction Bluetooth version: 5.0 Maximum transmission distance: 10 meters ANC on battery life: 10 hours Super fast charge: Charge 5 minutes, use 2 hours; Charge 15 minutes, use 6 hours",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAPH805.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1512",
    brand: "PHILIPS",
    sku: "L3",
    product_eng: "PHILIPS active noise reduction headphones",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$273.27",
    description_eng:
      "Brand: philips Model: Fidelio L3 Color: Black Charging interface: Type-C Dustproof performance: IP3X",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/L3.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1513",
    brand: "PHILIPS",
    sku: "TAH8506",
    product_eng: "PHILIPS active noise reduction headphones",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$134.85",
    description_eng:
      "Brand: philips Model: TAH8506 Color: Black Charging interface: Type-C Dustproof performance: IP3X",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAH8506.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1514",
    brand: "PHILIPS",
    sku: "HU2716",
    product_eng: "PHILIPS mist-free humidifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$140.14",
    description_eng:
      "Brand: philips Rated humidification capacity: 200ml/h Tank capacity: 2L Noise: 33db Product size: length 280mm; Width 280mm; Height 400mm Control mode: push-button type Style: Countertop Humidifying gear: 3 Model: HU2716/00",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HU2716.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1515",
    brand: "PHILIPS",
    sku: "HD2640",
    product_eng: "PHILIPS toaster",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$76.28",
    description_eng:
      "Brand: philips Rated power: 760W Model: HD2640 Baking speed: 7 Number of baking sheets: 1 Launch time: 2022-11",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HD2640.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1516",
    brand: "PHILIPS",
    sku: "GCA1000",
    product_eng: "PHILIPS electric shoe brush",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$53.34",
    description_eng:
      "Brand: philips Rated power: 12.2W Exhaust time: 10-15S Color: Black Certified model: GCA1000/60",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/GCA1000.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1517",
    brand: "PHILIPS",
    sku: "HX2462",
    product_eng: "PHILIPS electric toothbrush",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$113.17",
    description_eng:
      "Brand: philips Model: HX2462 Product size: 260mm long; Width 180mm; Height 50mm Net weight: 300g Launch time: 2022-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HX2462.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1518",
    brand: "PHILIPS",
    sku: "TAS2307",
    product_eng: "Philips Colorful Bluetooth Speaker",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$79.25",
    description_eng:
      "Brand: philips Color: Black Model: TAS2307 Main material: Plastic Line length: Wireless Bluetooth version: Bluetooth 5.3 Power supply type: Battery powered Wireless connection: Bluetooth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAS2307.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1519",
    brand: "PHILIPS",
    sku: "STH3000",
    product_eng: "PHILIPS handheld garment steamer blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$54.43",
    description_eng:
      "Brand: philips Rated voltage: 220V Rated power: 1000W Tank capacity: 0.1L Steam discharge time: 31-40S Model: STH3000/28 Color: Blue Ironing brush panel material: plastic",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/STH3000.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1520",
    brand: "PHILIPS",
    sku: "STH3010",
    product_eng: "PHILIPS handheld garment steamer green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$54.43",
    description_eng:
      "Brand: philips Rated voltage: 220V Rated power: 1000W Tank capacity: 0.1L Steam discharge time: 31-40S Model: STH3000/28 Color: Green Ironing brush panel material: plastic",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/STH3010.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1521",
    brand: "PHILIPS",
    sku: "TAG3207",
    product_eng: "philips true wireless bluetooth headphones",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$53.00",
    description_eng:
      "Brand: philips Color: Silver Model: TAG3207 Charging interface: Bluetooth Dust resistance: IP4X Waterproof rating: IPX4",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/TAG3207.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1522",
    brand: "PHILIPS",
    sku: "DCTG5501",
    product_eng: "PHILIPS cordless phone dark gray",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$85.40",
    description_eng:
      "Brand: philips Product size: 50mm long; Width 210mm; Height 70mm Luminous lighting: Backlight the screen and buttons Features: Caller ID; Ringtone selection Ringtone: Optional Certification model: HWDCD9889(49)TSD Launch time: 2022-11",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/DCTG5501.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1523",
    brand: "PHILIPS",
    sku: "DCTG5501R",
    product_eng: "PHILIPS cordless phone red",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$86.52",
    description_eng:
      "Brand: philips Product size: 50mm long; Width 210mm; Height 70mm Luminous lighting: Backlight the screen and buttons Features: Caller ID; Ringtone selection Ringtone: Optional Certification model: HWDCD9889(49)TSD Launch time: 2022-11",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/DCTG5501R.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1524",
    brand: "PHILIPS",
    sku: "GP5301",
    product_eng: "PHILIPS car air purifier",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$86.31",
    description_eng:
      "Brand: philips Filter out small particles such as viruses HESAMax technology removes harmful gases Efficient sterilization 99% Total protection removes 125 contaminants USB power supply is more convenient",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/GP5301.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1525",
    brand: "PHILIPS",
    sku: "P65016",
    product_eng: "Philips LED night light",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$36.38",
    description_eng:
      "Brand: philips Magnetic night light Soft light for the eyes Wake up with a touch Electroless dimming",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/P65016.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1526",
    brand: "PHILIPS",
    sku: "AHR3142NTD",
    product_eng: "PHILIPS electric heating blanket blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$167.02",
    description_eng:
      "Brand: philips Control mode: mechanical Gear: 3 Number of heating sheets: No heating sheets Heating method: far infrared heating Certified Model: AHR3142NTD Available: 2023-01",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AHR3142NTD.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1527",
    brand: "PHILIPS",
    sku: "AHR3142NTDG",
    product_eng: "PHILIPS electric heating blanket blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$167.02",
    description_eng:
      "Brand: philips Control mode: mechanical Gear: 3 Number of heating sheets: No heating sheets Heating method: far infrared heating Certified Model: AHR3142NTD Available: 2023-01",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/AHR3142NTDG.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1528",
    brand: "PHILIPS",
    sku: "HR3700",
    product_eng: "PHILIPS handheld egg beater",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$40.76",
    description_eng:
      "Brand: philips Motor speed: 1500 RPM Number of gears: 3 Model: HR370/07 Mixing rod storage device: no storage device Launch date: 2022-01 Rechargeable or not: Not rechargeable Rated power: 200W Rated voltage: 220V",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/HR3700.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1529",
    brand: "PHILIPS",
    sku: "SPS1004B",
    product_eng: "PHILIPS global communication converter",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$53.77",
    description_eng:
      "Brand: philips Rated current: 10A Number of USB ports: 4 x USB,1 x Type-C USB Power: 18W Fuse: 10A*2 Highlights: PC/QC double fast charge",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SPS1004B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1530",
    brand: "PHILIPS",
    sku: "SPS1003B",
    product_eng: "PHILIPS global communication converter",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$82.11",
    description_eng:
      "Brand: philips Rated current: 8A Number of USB ports: 2 x USB,1 x Type-C USB power: 65W Fuse: 8A*2 Highlights: Gallium nitride rechargeable laptop",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SPS1003B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1531",
    brand: "PHILIPS",
    sku: "P71667",
    product_eng: "PHILIPS LED floor lamp",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$209.07",
    description_eng:
      "Brand: philips Material: plastic lamp head, metal lamp arm Rated power: 11.2W Power cable length: 1.8m Number of lamp beads: 135 *0.06W Brightness adjustment: third gear Color temperature: 4000K Color rendering index: Ra98 Power cable length: 1.8m Product illumination: 1800Lux (distance 40cm) Product lumen: 900lm Product light efficiency: comfortable light formula, no blue light harm No video flash, glare suppression",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/P71667.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1532",
    brand: "PHILIPS",
    sku: "SPA620B",
    product_eng: "PHILIPS laptop stand audio",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$41.70",
    description_eng:
      "Brand: philips steady Hollow heat dissipation Hyperdynamic loudspeaker Bluetooth connection Anti-slip design Easy to carry",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/PHILIPS/SPA620B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1533",
    brand: "pidan",
    sku: "PD2601W1",
    product_eng: "pidan new style pet travel box",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$162.68",
    description_eng:
      "Brand: pidan Size: 490*360*520mm Net weight: 4.1kg Material: polycarbonate, polyester fiber",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/pidan/PD2601W1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1534",
    brand: "pidan",
    sku: "PD2651M1",
    product_eng: "pidan pet backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$80.34",
    description_eng:
      "Brand: pidan Expansion size: 370*290*490mm Storage size: 370*10*490mm Net weight: 1974g Material: PC, Oxford cloth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/pidan/PD2651M1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1535",
    brand: "pidan",
    sku: "PD2601W1",
    product_eng: "pidan new style pet travel box",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$166.97",
    description_eng:
      "Brand: pidan Size: 490*360*520mm Net weight: 4.1kg Material: polycarbonate, polyester fiber",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/pidan/PD2601W1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1536",
    brand: "pidan",
    sku: "PD2651M1",
    product_eng: "pidan pet backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$84.63",
    description_eng:
      "Brand: pidan Expansion size: 370*290*490mm Storage size: 370*10*490mm Net weight: 1974g Material: PC, Oxford cloth",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/pidan/PD2651M1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1537",
    brand: "Samsonite",
    sku: "TU790301",
    product_eng: "Samsonite school bag pink grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$278.28",
    description_eng:
      "Brand: Samsonite Main material: fabric + synthetic leather Inner material: fabric Net weight: 0.99kg Capacity: 19L Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TU790301.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1538",
    brand: "Samsonite",
    sku: "TU741301",
    product_eng: "Samsonite school bag blue grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$278.28",
    description_eng:
      "Brand: Samsonite Main material: fabric + synthetic leather Inner material: fabric Net weight: 0.99kg Capacity: 19L Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TU741301.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1539",
    brand: "Samsonite",
    sku: "TU690301",
    product_eng: "Samsonite school bag purple pink grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$217.65",
    description_eng:
      "Brand: Samsonite Size: 33*39.5*16cm Main material: fabric Inner material: fabric Net weight: 0.99kg Capacity: 18L Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TU690301.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1540",
    brand: "Samsonite",
    sku: "TU681013",
    product_eng: "Samsonite schoolbag purple/pink grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$139.85",
    description_eng:
      "Brand: Samsonite Size: 32*39*18cm Main material: fabric Inner material: fabric Net weight: 0.84kg Capacity: 17.5L Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TU681013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1541",
    brand: "Samsonite",
    sku: "TU60002",
    product_eng: "Samsonite school bag red grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$130.76",
    description_eng:
      "Brand: Samsonite Size: 27*38.5*13.5cm Main material: fabric Inner material: fabric Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TU60002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1542",
    brand: "Samsonite",
    sku: "TU601002",
    product_eng: "Samsonite school bag blue grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$130.76",
    description_eng:
      "Brand: Samsonite Size: 27*38.5*13.5cm Main material: fabric Inner material: fabric Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TU601002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1543",
    brand: "Samsonite",
    sku: "TU741304",
    product_eng: "Samsonite school bag blue grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$139.43",
    description_eng:
      "Brand: Samsonite Size: 34*38.5*16cm Main material: fabric Inner material: fabric Suitable for: Primary 1-3 Weight: 0.78kg Capacity: 17L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TU741304.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1544",
    brand: "Samsonite",
    sku: "TU700304",
    product_eng: "Samsonite school bag pink grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$139.43",
    description_eng:
      "Brand: Samsonite Size: 34*38.5*16cm Main material: fabric Inner material: fabric Suitable for: Primary 1-3 Weight: 0.78kg Capacity: 17L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TU700304.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1545",
    brand: "Samsonite",
    sku: "BC909101",
    product_eng: "Samsonite backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$414.19",
    description_eng:
      "Brand: Samsonite Material: Main material: fabric + cow leather + microfiber leather, inner material: fabric Size: 30*40*14cm Capacity: 16L Net weight: 1.3kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/BC909101.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1546",
    brand: "Samsonite",
    sku: "HO009018",
    product_eng: "Samsonite backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$542.89",
    description_eng:
      "Brand: Samsonite Material: Main material: fabric + leather, inner material: fabric Size: 35.5*44*17cm Capacity: 19.5L Net weight: 1.015kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/HO009018.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1547",
    brand: "Samsonite",
    sku: "BT509004",
    product_eng: "Samsonite backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$217.99",
    description_eng:
      "Brand: Samsonite Material: Main material: fabric + microfiber leather, inner material: fabric Size: 38*26*14cm Capacity: A 13-inch computer",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/BT509004.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1548",
    brand: "Samsonite",
    sku: "QK309001",
    product_eng: "Samsonite backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$246.59",
    description_eng:
      "Brand: Samsonite Material: Fabric Size: 31.5*44.5*12cm Capacity: 16.5L Weight: 0.86kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/QK309001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1549",
    brand: "Samsonite",
    sku: "TN509002",
    product_eng: "Samsonite business briefcase",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$246.59",
    description_eng:
      "Brand: Samsonite Material: Main fabric: fabric + microfiber leather + cow leather, inner: fabric Size: 38.5*29*7cm Capacity: 11.5L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TN509002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1550",
    brand: "Samsonite",
    sku: "BP009010",
    product_eng: "Samsonite Backpack 15.6 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$168.80",
    description_eng:
      "Brand: Samsonite Material: Fabric +PU leather Size: 31*15*42 Weight: 1.19kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/BP009010.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1551",
    brand: "Samsonite",
    sku: "S67401012",
    product_eng: "Samsonite travel amenity bag three-piece set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$83.08",
    description_eng:
      "Brand: Samsonite Material: Polyester Capacity: Large 5L (14*24.5*12.5cm), medium 5.5L (15*23.5*11cm), small 1.5L (12*21.5*4cm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/S67401012.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1552",
    brand: "Samsonite",
    sku: "BP580002",
    product_eng: "Samsonite computer bag handbag 14 inches pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$84.08",
    description_eng:
      "Brand: Samsonite Size: 36*26.5*4cm Material: waterproof fabric +PU splice Weight: 0.35kg Capacity: 13.3-inch computer",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/BP580002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1553",
    brand: "Samsonite",
    sku: "BP509002",
    product_eng: "Samsonite Computer Bag Handbag 14 Inch Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$84.08",
    description_eng:
      "Brand: Samsonite Size: 36*26.5*4cm Material: waterproof fabric +PU splice Weight: 0.35kg Capacity: 13.3-inch computer",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/BP509002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1554",
    brand: "Samsonite",
    sku: "TO009013",
    product_eng: "Samsonite casual travel bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$471.39",
    description_eng:
      "Brand: Samsonite Size: 50*22*30cm Material: Fabric + cow leather + microfiber leather Weight: 1.1kg Capacity: 30L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TO009013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1555",
    brand: "Samsonite",
    sku: "NO009002",
    product_eng: "Samsonite casual travel bag black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$232.29",
    description_eng:
      "Brand: Samsonite Size: 50*22*25cm Material: Fabric Weight: 1.01kg Capacity: 32L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/NO009002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1556",
    brand: "Samsonite",
    sku: "NO024002",
    product_eng: "Samsonite casual travel bag green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$232.29",
    description_eng:
      "Brand: Samsonite Size: 50*22*25cm Material: Fabric Weight: 1.01kg Capacity: 32L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/NO024002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1557",
    brand: "Samsonite",
    sku: "QU340003",
    product_eng: "Samsonite casual travel bag 19L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$330.10",
    description_eng:
      "Brand: Samsonite Size: 50*20*36cm Material: Fabric Weight: 0.84kg Capacity: 19L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/QU340003.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1558",
    brand: "Samsonite",
    sku: "NQ109023",
    product_eng: "Samsonite short wallet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.33",
    description_eng:
      "Brand: Samsonite Color: Black Size: 115*95*20mm Material: Main fabric: cow leather, inner: cow leather + fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/NQ109023.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1559",
    brand: "Samsonite",
    sku: "NQ109017",
    product_eng: "Samsonite long wallet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$160.27",
    description_eng:
      "Brand: Samsonite Color: Black Size: 200*100*25mm Material: Main fabric: cow leather, inner: cow leather + fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/NQ109017.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1560",
    brand: "Samsonite",
    sku: "TK209002",
    product_eng: "Samsonite Men's Belt",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$55.91",
    description_eng:
      "Brand: Samsonite Color: Black Size: 12mm (excluding lead) *4mm*35mm Material: Main material: cow split leather, inner: cow split leather",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TK209002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1561",
    brand: "Samsonite",
    sku: "AF905007",
    product_eng: "Samsonite trolley case 20 inches beige",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$253.40",
    description_eng:
      "Brand: Samsonite Size: 20 inches Size: 385*550*235mm Capacity (before expansion) : 35L Net weight: 2.95kg Can be boarded/checked in Main material: Plastic (ABS+PC) Inner material: fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/AF905007.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1562",
    brand: "Samsonite",
    sku: "AF909007",
    product_eng: "Samsonite trolley case 20 inches black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$253.40",
    description_eng:
      "Brand: Samsonite Size: 20 inches Size: 385*550*235mm Capacity (before expansion) : 35L Net weight: 2.95kg Can be boarded/checked in Main material: Plastic (ABS+PC) Inner material: fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/AF909007.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1563",
    brand: "Samsonite",
    sku: "AF909009",
    product_eng: "Samsonite trolley case 29 inches black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$366.94",
    description_eng:
      "Brand: Samsonite Size: 29 inches Size: 530*780*330mm Capacity (before expansion) : 106L Capacity (after expansion) : 119.5L Net weight: 5.32kg consignable Main material: Plastic (ABS+PC) Inner material: fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/AF909009.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1564",
    brand: "Samsonite",
    sku: "AF905009",
    product_eng: "Samsonite trolley case 29 inches beige",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$366.94",
    description_eng:
      "Brand: Samsonite Size: 29 inches Size: 530*780*330mm Capacity (before expansion) : 106L Capacity (after expansion) : 119.5L Net weight: 5.32kg consignable Main material: Plastic (ABS+PC) Inner material: fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/AF905009.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1565",
    brand: "Samsonite",
    sku: "41C25013",
    product_eng: "Samsonite trolley case silver 20 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$285.43",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inside: Fabric Size: 20 inches Size: 375*550*210mm Net weight: 2.7kg Capacity: 36.5L non-expandable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/41C25013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1566",
    brand: "Samsonite",
    sku: "41C39013",
    product_eng: "Samsonite trolley case black 20 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$285.43",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inside: Fabric Size: 20 inches Size: 375*550*210mm Net weight: 2.7kg Capacity: 36.5L non-expandable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/41C39013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1567",
    brand: "Samsonite",
    sku: "41C39014",
    product_eng: "Samsonite trolley case black 25 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$331.87",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inside: Fabric Size: 25 inches Size: 480*690*305mm Net weight: 4.2kg Capacity: 79.5L After expansion: 93L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/41C39014.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1568",
    brand: "Samsonite",
    sku: "41C25014",
    product_eng: "Samsonite trolley case silver 25 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$331.87",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inside: Fabric Size: 25 inches Size: 480*690*305mm Net weight: 4.2kg Capacity: 79.5L After expansion: 93L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/41C25014.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1569",
    brand: "Samsonite",
    sku: "U2290120",
    product_eng: "Samsonite children's suitcase pink bunny 16 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$161.02",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inner fabric: Fabric Link number: 3 Weight: 10kg Capacity: 26.5L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/U2290120.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1570",
    brand: "Samsonite",
    sku: "U2226122",
    product_eng: "Samsonite children's suitcase little yellow duck 16 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$161.02",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inner fabric: Fabric Link number: 3 Weight: 10kg Capacity: 26.5L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/U2226122.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1571",
    brand: "Samsonite",
    sku: "U2204119",
    product_eng: "Samsonite children's suitcase green dinosaur 16 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$161.02",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inner fabric: Fabric Link number: 3 Weight: 10kg Capacity: 26.5L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/U2204119.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1572",
    brand: "Samsonite",
    sku: "U2219121",
    product_eng: "Samsonite children's suitcase penguin 16 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$161.02",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inner fabric: Fabric Link number: 3 Weight: 10kg Capacity: 26.5L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/U2219121.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1573",
    brand: "Samsonite",
    sku: "HH541001",
    product_eng: "Samsonite trolley case dark blue 20 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$591.51",
    description_eng:
      "Brand: Samsonite External material: Polycarbonate (PC) Inside: Fabric Size: 20 inches Net weight: 3.225kg Capacity: 31.5L non-expandable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/HH541001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1574",
    brand: "Samsonite",
    sku: "HH500001",
    product_eng: "Samsonite trolley case red 20 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$591.51",
    description_eng:
      "Brand: Samsonite External material: Polycarbonate (PC) Inside: Fabric Size: 20 inches Net weight: 3.225kg Capacity: 31.5L non-expandable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/HH500001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1575",
    brand: "Samsonite",
    sku: "HH545001",
    product_eng: "Samsonite trolley case ivory 20 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$591.51",
    description_eng:
      "Brand: Samsonite External material: Polycarbonate (PC) Inside: Fabric Size: 20 inches Net weight: 3.225kg Capacity: 31.5L non-expandable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/HH545001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1576",
    brand: "Samsonite",
    sku: "TO009011",
    product_eng: "Samsonite backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$419.19",
    description_eng:
      "Brand: Samsonite Main material: cow leather + microfiber leather + fabric Inner fabric: Fabric Net weight: 1.425kg Color: Black Size: 410*280*140mm Can fit a 16-inch computer",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TO009011.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1577",
    brand: "Samsonite",
    sku: "QU309003",
    product_eng: "Samsonite women's travel bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$320.81",
    description_eng:
      "Brand: Samsonite Main material: fabric Inner material: fabric Net weight: 0.84kg Color: Black Size: 500*360*200mm Capacity: 19L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/QU309003.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1578",
    brand: "Samsonite",
    sku: "TO009013",
    product_eng: "Samsonite men's travel bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$455.00",
    description_eng:
      "Brand: Samsonite Main material: fabric + cow leather + microfiber leather Inner material: fabric Net weight: 1.1kg Color: Black Size: 500*300*220mm Capacity: 30L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Samsonite/TO009013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1579",
    brand: "Samsonite",
    sku: "TU790301",
    product_eng: "Samsonite school bag pink grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$282.57",
    description_eng:
      "Brand: Samsonite Main material: fabric + synthetic leather Inner material: fabric Net weight: 0.99kg Capacity: 19L Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TU790301.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1580",
    brand: "Samsonite",
    sku: "TU741301",
    product_eng: "Samsonite school bag blue grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$282.57",
    description_eng:
      "Brand: Samsonite Main material: fabric + synthetic leather Inner material: fabric Net weight: 0.99kg Capacity: 19L Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TU741301.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1581",
    brand: "Samsonite",
    sku: "TU690301",
    product_eng: "Samsonite school bag purple pink grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$221.94",
    description_eng:
      "Brand: Samsonite Size: 33*39.5*16cm Main material: fabric Inner material: fabric Net weight: 0.99kg Capacity: 18L Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TU690301.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1582",
    brand: "Samsonite",
    sku: "TU681013",
    product_eng: "Samsonite schoolbag purple/pink grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$144.14",
    description_eng:
      "Brand: Samsonite Size: 32*39*18cm Main material: fabric Inner material: fabric Net weight: 0.84kg Capacity: 17.5L Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TU681013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1583",
    brand: "Samsonite",
    sku: "TU60002",
    product_eng: "Samsonite school bag red grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$135.05",
    description_eng:
      "Brand: Samsonite Size: 27*38.5*13.5cm Main material: fabric Inner material: fabric Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TU60002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1584",
    brand: "Samsonite",
    sku: "TU601002",
    product_eng: "Samsonite school bag blue grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$135.05",
    description_eng:
      "Brand: Samsonite Size: 27*38.5*13.5cm Main material: fabric Inner material: fabric Suitable for: Primary 1-3",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TU601002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1585",
    brand: "Samsonite",
    sku: "TU741304",
    product_eng: "Samsonite school bag blue grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$143.72",
    description_eng:
      "Brand: Samsonite Size: 34*38.5*16cm Main material: fabric Inner material: fabric Suitable for: Primary 1-3 Weight: 0.78kg Capacity: 17L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TU741304.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1586",
    brand: "Samsonite",
    sku: "TU700304",
    product_eng: "Samsonite school bag pink grade 1-3",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$143.72",
    description_eng:
      "Brand: Samsonite Size: 34*38.5*16cm Main material: fabric Inner material: fabric Suitable for: Primary 1-3 Weight: 0.78kg Capacity: 17L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TU700304.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1587",
    brand: "Samsonite",
    sku: "BC909101",
    product_eng: "Samsonite backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$418.48",
    description_eng:
      "Brand: Samsonite Material: Main material: fabric + cow leather + microfiber leather, inner material: fabric Size: 30*40*14cm Capacity: 16L Net weight: 1.3kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/BC909101.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1588",
    brand: "Samsonite",
    sku: "HO009018",
    product_eng: "Samsonite backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$547.18",
    description_eng:
      "Brand: Samsonite Material: Main material: fabric + leather, inner material: fabric Size: 35.5*44*17cm Capacity: 19.5L Net weight: 1.015kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/HO009018.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1589",
    brand: "Samsonite",
    sku: "BT509004",
    product_eng: "Samsonite backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$222.28",
    description_eng:
      "Brand: Samsonite Material: Main material: fabric + microfiber leather, inner material: fabric Size: 38*26*14cm Capacity: A 13-inch computer",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/BT509004.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1590",
    brand: "Samsonite",
    sku: "QK309001",
    product_eng: "Samsonite backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$250.88",
    description_eng:
      "Brand: Samsonite Material: Fabric Size: 31.5*44.5*12cm Capacity: 16.5L Weight: 0.86kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/QK309001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1591",
    brand: "Samsonite",
    sku: "TN509002",
    product_eng: "Samsonite business briefcase",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$250.88",
    description_eng:
      "Brand: Samsonite Material: Main fabric: fabric + microfiber leather + cow leather, inner: fabric Size: 38.5*29*7cm Capacity: 11.5L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TN509002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1592",
    brand: "Samsonite",
    sku: "BP009010",
    product_eng: "Samsonite Backpack 15.6 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$173.09",
    description_eng:
      "Brand: Samsonite Material: Fabric +PU leather Size: 31*15*42 Weight: 1.19kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/BP009010.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1593",
    brand: "Samsonite",
    sku: "S67401012",
    product_eng: "Samsonite travel amenity bag three-piece set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$87.37",
    description_eng:
      "Brand: Samsonite Material: Polyester Capacity: Large 5L (14*24.5*12.5cm), medium 5.5L (15*23.5*11cm), small 1.5L (12*21.5*4cm)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/S67401012.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1594",
    brand: "Samsonite",
    sku: "BP580002",
    product_eng: "Samsonite computer bag handbag 14 inches pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$88.37",
    description_eng:
      "Brand: Samsonite Size: 36*26.5*4cm Material: waterproof fabric +PU splice Weight: 0.35kg Capacity: 13.3-inch computer",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/BP580002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1595",
    brand: "Samsonite",
    sku: "BP509002",
    product_eng: "Samsonite Computer Bag Handbag 14 Inch Black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$88.37",
    description_eng:
      "Brand: Samsonite Size: 36*26.5*4cm Material: waterproof fabric +PU splice Weight: 0.35kg Capacity: 13.3-inch computer",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/BP509002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1596",
    brand: "Samsonite",
    sku: "TO009013",
    product_eng: "Samsonite casual travel bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$475.68",
    description_eng:
      "Brand: Samsonite Size: 50*22*30cm Material: Fabric + cow leather + microfiber leather Weight: 1.1kg Capacity: 30L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TO009013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1597",
    brand: "Samsonite",
    sku: "NO009002",
    product_eng: "Samsonite casual travel bag black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$236.58",
    description_eng:
      "Brand: Samsonite Size: 50*22*25cm Material: Fabric Weight: 1.01kg Capacity: 32L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/NO009002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1598",
    brand: "Samsonite",
    sku: "NO024002",
    product_eng: "Samsonite casual travel bag green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$236.58",
    description_eng:
      "Brand: Samsonite Size: 50*22*25cm Material: Fabric Weight: 1.01kg Capacity: 32L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/NO024002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1599",
    brand: "Samsonite",
    sku: "QU340003",
    product_eng: "Samsonite casual travel bag 19L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$334.39",
    description_eng:
      "Brand: Samsonite Size: 50*20*36cm Material: Fabric Weight: 0.84kg Capacity: 19L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/QU340003.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1600",
    brand: "Samsonite",
    sku: "NQ109023",
    product_eng: "Samsonite short wallet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$106.62",
    description_eng:
      "Brand: Samsonite Color: Black Size: 115*95*20mm Material: Main fabric: cow leather, inner: cow leather + fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/NQ109023.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1601",
    brand: "Samsonite",
    sku: "NQ109017",
    product_eng: "Samsonite long wallet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$164.56",
    description_eng:
      "Brand: Samsonite Color: Black Size: 200*100*25mm Material: Main fabric: cow leather, inner: cow leather + fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/NQ109017.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1602",
    brand: "Samsonite",
    sku: "TK209002",
    product_eng: "Samsonite Men's Belt",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$60.20",
    description_eng:
      "Brand: Samsonite Color: Black Size: 12mm (excluding lead) *4mm*35mm Material: Main material: cow split leather, inner: cow split leather",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TK209002.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1603",
    brand: "Samsonite",
    sku: "AF905007",
    product_eng: "Samsonite trolley case 20 inches beige",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$257.69",
    description_eng:
      "Brand: Samsonite Size: 20 inches Size: 385*550*235mm Capacity (before expansion) : 35L Net weight: 2.95kg Can be boarded/checked in Main material: Plastic (ABS+PC) Inner material: fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/AF905007.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1604",
    brand: "Samsonite",
    sku: "AF909007",
    product_eng: "Samsonite trolley case 20 inches black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$257.69",
    description_eng:
      "Brand: Samsonite Size: 20 inches Size: 385*550*235mm Capacity (before expansion) : 35L Net weight: 2.95kg Can be boarded/checked in Main material: Plastic (ABS+PC) Inner material: fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/AF909007.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1605",
    brand: "Samsonite",
    sku: "AF909009",
    product_eng: "Samsonite trolley case 29 inches black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$371.23",
    description_eng:
      "Brand: Samsonite Size: 29 inches Size: 530*780*330mm Capacity (before expansion) : 106L Capacity (after expansion) : 119.5L Net weight: 5.32kg consignable Main material: Plastic (ABS+PC) Inner material: fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/AF909009.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1606",
    brand: "Samsonite",
    sku: "AF905009",
    product_eng: "Samsonite trolley case 29 inches beige",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$371.23",
    description_eng:
      "Brand: Samsonite Size: 29 inches Size: 530*780*330mm Capacity (before expansion) : 106L Capacity (after expansion) : 119.5L Net weight: 5.32kg consignable Main material: Plastic (ABS+PC) Inner material: fabric",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/AF905009.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1607",
    brand: "Samsonite",
    sku: "41C25013",
    product_eng: "Samsonite trolley case silver 20 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$289.72",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inside: Fabric Size: 20 inches Size: 375*550*210mm Net weight: 2.7kg Capacity: 36.5L non-expandable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/41C25013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1608",
    brand: "Samsonite",
    sku: "41C39013",
    product_eng: "Samsonite trolley case black 20 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$289.72",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inside: Fabric Size: 20 inches Size: 375*550*210mm Net weight: 2.7kg Capacity: 36.5L non-expandable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/41C39013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1609",
    brand: "Samsonite",
    sku: "41C39014",
    product_eng: "Samsonite trolley case black 25 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$336.16",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inside: Fabric Size: 25 inches Size: 480*690*305mm Net weight: 4.2kg Capacity: 79.5L After expansion: 93L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/41C39014.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1610",
    brand: "Samsonite",
    sku: "41C25014",
    product_eng: "Samsonite trolley case silver 25 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$336.16",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inside: Fabric Size: 25 inches Size: 480*690*305mm Net weight: 4.2kg Capacity: 79.5L After expansion: 93L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/41C25014.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1611",
    brand: "Samsonite",
    sku: "U2290120",
    product_eng: "Samsonite children's suitcase pink bunny 16 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$165.31",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inner fabric: Fabric Link number: 3 Weight: 10kg Capacity: 26.5L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/U2290120.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1612",
    brand: "Samsonite",
    sku: "U2226122",
    product_eng: "Samsonite children's suitcase little yellow duck 16 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$165.31",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inner fabric: Fabric Link number: 3 Weight: 10kg Capacity: 26.5L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/U2226122.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1613",
    brand: "Samsonite",
    sku: "U2204119",
    product_eng: "Samsonite children's suitcase green dinosaur 16 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$165.31",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inner fabric: Fabric Link number: 3 Weight: 10kg Capacity: 26.5L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/U2204119.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1614",
    brand: "Samsonite",
    sku: "U2219121",
    product_eng: "Samsonite children's suitcase penguin 16 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$165.31",
    description_eng:
      "Brand: Samsonite Main material: Plastic (ABS+PC) Inner fabric: Fabric Link number: 3 Weight: 10kg Capacity: 26.5L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/U2219121.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1615",
    brand: "Samsonite",
    sku: "HH541001",
    product_eng: "Samsonite trolley case dark blue 20 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$595.80",
    description_eng:
      "Brand: Samsonite External material: Polycarbonate (PC) Inside: Fabric Size: 20 inches Net weight: 3.225kg Capacity: 31.5L non-expandable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/HH541001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1616",
    brand: "Samsonite",
    sku: "HH500001",
    product_eng: "Samsonite trolley case red 20 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$595.80",
    description_eng:
      "Brand: Samsonite External material: Polycarbonate (PC) Inside: Fabric Size: 20 inches Net weight: 3.225kg Capacity: 31.5L non-expandable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/HH500001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1617",
    brand: "Samsonite",
    sku: "HH545001",
    product_eng: "Samsonite trolley case ivory 20 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$595.80",
    description_eng:
      "Brand: Samsonite External material: Polycarbonate (PC) Inside: Fabric Size: 20 inches Net weight: 3.225kg Capacity: 31.5L non-expandable",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/HH545001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1618",
    brand: "Samsonite",
    sku: "TO009011",
    product_eng: "Samsonite backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$423.48",
    description_eng:
      "Brand: Samsonite Main material: cow leather + microfiber leather + fabric Inner fabric: Fabric Net weight: 1.425kg Color: Black Size: 410*280*140mm Can fit a 16-inch computer",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TO009011.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1619",
    brand: "Samsonite",
    sku: "QU309003",
    product_eng: "Samsonite women's travel bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$325.10",
    description_eng:
      "Brand: Samsonite Main material: fabric Inner material: fabric Net weight: 0.84kg Color: Black Size: 500*360*200mm Capacity: 19L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/QU309003.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1620",
    brand: "Samsonite",
    sku: "TO009013",
    product_eng: "Samsonite men's travel bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$459.29",
    description_eng:
      "Brand: Samsonite Main material: fabric + cow leather + microfiber leather Inner material: fabric Net weight: 1.1kg Color: Black Size: 500*300*220mm Capacity: 30L",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Samsonite/TO009013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1621",
    brand: "SMEG",
    sku: "KLF04",
    product_eng: "SMEG electric kettle 1.7L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$372.94",
    description_eng:
      "Brand: SMEG Capacity: 1.7L Temperature control range: 50/60/70/80/90/95/100℃ Size: 275*226*171mm Weight: 1.8kg Power: 2400W Power cable length: 1m",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/SMEG/KLF04.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1622",
    brand: "SPALDING",
    sku: "76797Y",
    product_eng: "SPALDING Basketball No. 7",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$75.65",
    description_eng:
      "Brand: SPALDING Material: PU Specification: No. 7 Model: 76-797Y",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/SPALDING/76797Y.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1623",
    brand: "SPALDING",
    sku: "76797Y",
    product_eng: "SPALDING Basketball No. 7",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$79.94",
    description_eng:
      "Brand: SPALDING Material: PU Specification: No. 7 Model: 76-797Y",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/SPALDING/76797Y.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1624",
    brand: "Star",
    sku: "VB425",
    product_eng:
      "star high school entrance examination volleyball soft wear-resistant No. 5 volleyball",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$48.31",
    description_eng:
      "Brand: Star Weight: 260-280g Process: Manual bonding Specification: No. 5 volleyball Material: Imported advanced microfiber leather",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Star/ VB425.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1625",
    brand: "Star",
    sku: "SB235FTB",
    product_eng: "star FIFA certified match ball size 5 football",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$76.30",
    description_eng:
      "Brand: Star Material: polyurethane material Size: 5 Circumference: 67-70cm Weight: 405-450g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Star/SB235FTB.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1626",
    brand: "Star",
    sku: "VB425",
    product_eng:
      "star high school entrance examination volleyball soft wear-resistant No. 5 volleyball",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$52.60",
    description_eng:
      "Brand: Star Weight: 260-280g Process: Manual bonding Specification: No. 5 volleyball Material: Imported advanced microfiber leather",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Star/ VB425.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1627",
    brand: "Star",
    sku: "SB235FTB",
    product_eng: "star FIFA certified match ball size 5 football",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$80.59",
    description_eng:
      "Brand: Star Material: polyurethane material Size: 5 Circumference: 67-70cm Weight: 405-450g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Star/SB235FTB.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1628",
    brand: "staub",
    sku: "S1025321",
    product_eng: "staub enameled cast iron pot 22cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$363.65",
    description_eng:
      "Brand: staub Capacity: 2.6L Material: enamelled cast iron Diameter: 22cm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/staub/S1025321.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1629",
    brand: "Supor",
    sku: "SY50HC5021Q",
    product_eng: "SUPOR electric pressure cooker 5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$153.30",
    description_eng:
      "Brand: Supor Liner material: refined steel; Nonstick coating Display type: 88 screens Model: SY-50HC5021Q Capacity: 5L Rated voltage: 220V Rated power: 2200W Power cable length: 0.9m Available: 2023-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/SY50HC5021Q.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1630",
    brand: "Supor",
    sku: "SY35YZ8099",
    product_eng: "SUPOR electric pressure cooker 3.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$216.22",
    description_eng:
      "Brand: Supor Display type: 88 screens Model: SY-35YZ8099 Liner material: ceramic crystal Capacity: 3.5L Rated voltage: 220V Rated power: 2000W Power cable length: 0.9m Available: 2023-05",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/SY35YZ8099.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1631",
    brand: "Supor",
    sku: "SY50HC5003Q",
    product_eng: "SUPOR electric pressure cooker 5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$227.37",
    description_eng:
      "Brand: Supor Rated power: 2200W Rated voltage: 220V Net weight: 7.4kg Power cable length: 0.9m Capacity: 5L Energy efficiency level: Level 3 energy efficiency Model: SY-50HC5003Q Liner material: steel and aluminum alloy Steamer material: stainless steel Available: 2023-03",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/SY50HC5003Q.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1632",
    brand: "Supor",
    sku: "SW15J72L",
    product_eng: "SUPOR 316L stainless steel electric kettle 1.5L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$44.39",
    description_eng:
      "Brand: Supor Product size: length 206mm; Width 154mm; The height is 241mm Rated power: 1500W Power cord length: 0.7m Rated voltage: 220V Net weight: 0.98kg Capacity: 1.5L Model: SW-15J72L Available: 2023-02",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/SW15J72L.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1633",
    brand: "Supor",
    sku: "SW20J01P",
    product_eng: "SUPOR 316L stainless steel electric kettle 2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$49.62",
    description_eng:
      "Brand: Supor Power cord length: 0.7m Rated power: 1800W Net weight: 0.92kg Product size: 220mm long; Width 160mm; Height 240mm Rated voltage: 220V Capacity: 2L Model: SW-20J01P Available: 2023-04",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/SW20J01P.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1634",
    brand: "Supor",
    sku: "H3030FK851",
    product_eng: "SUPOR electric hot pot 6L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$77.82",
    description_eng:
      "Brand: Supor Power cable length: 0.9m Rated power: 1800W Rated voltage: 220V Gear: 3 Capacity: 6L Food contact surface material: Flon (PTFE fiber) Pan diameter: 30cm Color: Blue Model: H3030FK851 Liner material: Aluminum alloy Launch time: 2022-10",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/H3030FK851.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1635",
    brand: "SUPOR",
    sku: "ZN26FC836",
    product_eng: "SUPOR electric steamer 16L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$115.20",
    description_eng:
      "Brand: SUPOR Power cable length: 0.9m Rated power: 2100W Rated voltage: 220V Gear: 4 Capacity: 16L Food contact surface material: Flon (PTFE fiber) Pan diameter: 26cm Color: Blue Model: ZN26FC836 Liner material: Aluminum alloy Launch time: 2023-09",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/ZN26FC836.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1636",
    brand: "SUPOR",
    sku: "TP2302E",
    product_eng: "SUPOR pot set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$91.26",
    description_eng:
      "Brand: SUPOR Material: Aluminum Size: 30cm frying pan, 24cm frying pan, 16cm milk pan Applicable cookware: induction cooker, gas stove, gas stove, electric pottery stove, electric stove",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/TP2302E.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1637",
    brand: "Supor",
    sku: "TP2006E",
    product_eng: "SUPOR three-piece pot set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$107.62",
    description_eng:
      "Brand: Supor Material: Aluminum alloy Suitable for stove: induction cooker gas universal Specifications: 32cm wok +26cm frying pan +22cm stockpot",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/TP2006E.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1638",
    brand: "Supor",
    sku: "TP1627E",
    product_eng: "SUPOR three-piece pot set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$131.56",
    description_eng:
      "Brand: Supor Material: Aluminum alloy Suitable for stove: induction cooker gas universal Specifications: 30cm wok +26cm frying pan +20cm stockpot",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/TP1627E.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1639",
    brand: "Supor",
    sku: "TR2201E",
    product_eng: "SUPOR outdoor multifunctional pot set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$105.79",
    description_eng:
      "Brand: Supor Material: hard alumina Specifications: Stock pan 1.5L, milk pan 1.3L, frying pan 0.6L, gas stove Net weight: 1.03kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/TR2201E.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1640",
    brand: "SUPOR",
    sku: "EC32QLP01",
    product_eng: "SUPOR non-stick wok 32cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$85.51",
    description_eng:
      "Brand: SUPOR Material: Aluminum alloy imitation die casting process Size: 32CM",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/EC32QLP01.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1641",
    brand: "SUPOR",
    sku: "EC32JGC03",
    product_eng:
      "SUPOR Titanium 2 generation uncoated stainless steel wok 32cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$152.44",
    description_eng:
      "Brand: Supor Material: Stainless steel Size: 32cm Applicable number: 3-5 people",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/EC32JGC03.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1642",
    brand: "SUPOR",
    sku: "EC30JGC03",
    product_eng:
      "SUPOR Titanium 2 generation uncoated stainless steel wok 30cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$140.86",
    description_eng:
      "Brand: Supor Material: Stainless steel Size: 30cm Applicable number: 2-3 people",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Supor/EC30JGC03.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1643",
    brand: "SUPOR",
    sku: "TP2302E",
    product_eng: "SUPOR pot set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$95.55",
    description_eng:
      "Brand: SUPOR Material: Aluminum Size: 30cm frying pan, 24cm frying pan, 16cm milk pan Applicable cookware: induction cooker, gas stove, gas stove, electric pottery stove, electric stove",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/SUPOR/TP2302E.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1644",
    brand: "Supor",
    sku: "TP2006E",
    product_eng: "SUPOR three-piece pot set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$111.91",
    description_eng:
      "Brand: Supor Material: Aluminum alloy Suitable for stove: induction cooker gas universal Specifications: 32cm wok +26cm frying pan +22cm stockpot",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/SUPOR/TP2006E.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1645",
    brand: "Supor",
    sku: "TP1627E",
    product_eng: "SUPOR three-piece pot set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$135.85",
    description_eng:
      "Brand: Supor Material: Aluminum alloy Suitable for stove: induction cooker gas universal Specifications: 30cm wok +26cm frying pan +20cm stockpot",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/SUPOR/TP1627E.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1646",
    brand: "Supor",
    sku: "TR2201E",
    product_eng: "SUPOR outdoor multifunctional pot set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$110.08",
    description_eng:
      "Brand: Supor Material: hard alumina Specifications: Stock pan 1.5L, milk pan 1.3L, frying pan 0.6L, gas stove Net weight: 1.03kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/SUPOR/TR2201E.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1647",
    brand: "SUPOR",
    sku: "EC32QLP01",
    product_eng: "SUPOR non-stick wok 32cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$89.80",
    description_eng:
      "Brand: SUPOR Material: Aluminum alloy imitation die casting process Size: 32CM",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/SUPOR/EC32QLP01.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1648",
    brand: "SUPOR",
    sku: "EC32JGC03",
    product_eng:
      "SUPOR Titanium 2 generation uncoated stainless steel wok 32cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$156.73",
    description_eng:
      "Brand: Supor Material: Stainless steel Size: 32cm Applicable number: 3-5 people",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/SUPOR/EC32JGC03.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1649",
    brand: "SUPOR",
    sku: "EC30JGC03",
    product_eng:
      "SUPOR Titanium 2 generation uncoated stainless steel wok 30cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$145.15",
    description_eng:
      "Brand: Supor Material: Stainless steel Size: 30cm Applicable number: 2-3 people",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/SUPOR/EC30JGC03.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1650",
    brand: "TAFUCO",
    sku: "T5392",
    product_eng: "TAFUCO insulated lunch box four layers/microwaveable 2.2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$45.87",
    description_eng:
      "Brand: TAFUCO Capacity: 650ml*2+450ml*2 Material: Inner container -PP+316L stainless steel, container lid -PP, sealing ring - silicone rubber, spoon/chopsticks -304 stainless steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TAFUCO/T5392.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1651",
    brand: "TAFUCO",
    sku: "T6241",
    product_eng: "TAFUCO extra long insulated lunch box three layers 2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$90.66",
    description_eng:
      "Brand: TAFUCO Multi-layer independent packaging Cutlery set 6h long-term insulation denticle 316 stainless steel Thermal insulation design Capacity: 450ml+650ml*2 Material: 304 stainless steel bottle body /PP resin outer cover /316 stainless steel inner container/silicone sealing ring /304 stainless steel chopsticks spoon Insulation performance: 6H≥65℃",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TAFUCO/T6241.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1652",
    brand: "TAFUCO",
    sku: "T6251",
    product_eng: "TAFUCO extra long insulated lunch box four layers 2.3L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$99.21",
    description_eng:
      "Brand: TAFUCO Multi-layer independent packaging Cutlery set 6h long-term insulation denticle 316 stainless steel Thermal insulation design Capacity: 350ml*2+450ml+650ml Material: 304 stainless steel bottle body /PP resin outer cover /316 stainless steel inner container/silicone sealing ring /304 stainless steel chopsticks spoon Insulation performance: 6H≥68℃",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TAFUCO/T6251.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1653",
    brand: "TAFUCO",
    sku: "T5392",
    product_eng: "TAFUCO insulated lunch box four layers/microwaveable 2.2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$50.16",
    description_eng:
      "Brand: TAFUCO Capacity: 650ml*2+450ml*2 Material: Inner container -PP+316L stainless steel, container lid -PP, sealing ring - silicone rubber, spoon/chopsticks -304 stainless steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TAFUCO/T5392.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1654",
    brand: "TAFUCO",
    sku: "T6241",
    product_eng: "TAFUCO extra long insulated lunch box three layers 2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$94.95",
    description_eng:
      "Brand: TAFUCO Multi-layer independent packaging Cutlery set 6h long-term insulation denticle 316 stainless steel Thermal insulation design Capacity: 450ml+650ml*2 Material: 304 stainless steel bottle body /PP resin outer cover /316 stainless steel inner container/silicone sealing ring /304 stainless steel chopsticks spoon Insulation performance: 6H≥65℃",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TAFUCO/T6241.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1655",
    brand: "TAFUCO",
    sku: "T6251",
    product_eng: "TAFUCO extra long insulated lunch box four layers 2.3L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$103.50",
    description_eng:
      "Brand: TAFUCO Multi-layer independent packaging Cutlery set 6h long-term insulation denticle 316 stainless steel Thermal insulation design Capacity: 350ml*2+450ml+650ml Material: 304 stainless steel bottle body /PP resin outer cover /316 stainless steel inner container/silicone sealing ring /304 stainless steel chopsticks spoon Insulation performance: 6H≥68℃",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TAFUCO/T6251.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1656",
    brand: "THERAGUN",
    sku: "TG00039714A10",
    product_eng: "THERAGUN Sense triangle fascia gun",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$447.45",
    description_eng:
      "Brand: THERAGUN Power: 38W Battery life: 120 minutes (depending on mode selected) Weight: 725g Material: Body: plastic +TPU, massage head: PU foam, silicone Size: 210*160*65mm (excluding massage head)",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/THERAGUN/TG00039714A10.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1657",
    brand: "TILIVING",
    sku: "TB201",
    product_eng: "TILIVING pure titanium travel tea set, one pot and two cups",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$77.02",
    description_eng:
      "Brand: TILIVING 99% pure titanium to create no heavy metal precipitation Two cups in a pot",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TILIVING/TB201.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1658",
    brand: "TOMIC",
    sku: "TJ70020",
    product_eng: "TOMIC teapot 1L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$74.50",
    description_eng:
      "Brand: TOMIC Pure titanium tea bin Ceramic liner Keep warm and fresh Tea water separation",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TOMIC/TJ70020.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1659",
    brand: "tudao",
    sku: "TDRobotRM2",
    product_eng: "tudao programs world robotics advanced",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$97.96",
    description_eng:
      "Brand: tudao Packing list: Master *1, Sensor *1, Motor *2, Wheel hub *6, Tire *6, Rubber band *7, Instruction manual *1, Chain strap *100, Storage box *1",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/tubao/TDRobotRM2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1660",
    brand: "tudao",
    sku: "TDRobotRM2EDplus1",
    product_eng: "tudao Programming robot Master Advanced",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$155.73",
    description_eng:
      "Brand: tudao Packing list: Master *1, Sensor *2, Motor *2, Wheel hub *6, Tire *6, Rubber band *7, Block 500, Remover *1, Instruction manual *1, Tank track *100",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/tubao/TDRobotRM2EDplus1.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1661",
    brand: "TUMI",
    sku: "02603580D3",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$998.00",
    description_eng:
      "Brand: TUMI Size: 43*30.5*20.5cm Computer compartment: 40.5*25.5*3.75cm Main material: Nylon Weight: 1.5kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/02603580D3.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1662",
    brand: "TUMI",
    sku: "02603589D3",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,185.90",
    description_eng:
      "Brand: TUMI Size: 43*30.5*21cm Computer compartment: 40.5*26*2.5cm Main material: nylon Weight: 1.6kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/02603589D3.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1663",
    brand: "TUMI",
    sku: "02223388HKO",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$822.68",
    description_eng:
      "Brand: TUMI Size: 48.5*35.5*15cm Main material: Ballistic nylon Weight: 1.45kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/02223388HKO.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1664",
    brand: "TUMI",
    sku: "06602035GYCME",
    product_eng: "TUMI men's chest bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$707.05",
    description_eng:
      "Brand: TUMI Size: 30.5*18*5cm Main material: Polyester Weight: 0.5kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/06602035GYCME.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1665",
    brand: "TUMI",
    sku: "02603182D3",
    product_eng: "TUMI men's briefcase",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$897.33",
    description_eng:
      "Brand: TUMI Size: 29*40.5*9cm Computer compartment: 26.5*38*3.75cm Main material: Nylon Weight: 2kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/02603182D3.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1666",
    brand: "TUMI",
    sku: "0232799IRN",
    product_eng: "TUMI men's chest bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$613.90",
    description_eng:
      "Brand: TUMI Size: 15*30.5*10.25cm Main material: Nylon Weight: 0.5kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0232799IRN.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1667",
    brand: "TUMI",
    sku: "0196651DGM",
    product_eng: "TUMI women's backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$828.40",
    description_eng:
      "Brand: TUMI Size: 38*30*15cm Computer compartment: 30.5*26.5*2.5cm Main material: Nylon Weight: 0.78kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0196651DGM.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1668",
    brand: "TUMI",
    sku: "0196369MP",
    product_eng: "TUMI women's backpack pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$627.63",
    description_eng:
      "Brand: TUMI Size: 36*29*14cm Computer compartment: 27.5*25.5*1.25cm Main material: Nylon Weight: 0.6kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0196369MP.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1669",
    brand: "TUMI",
    sku: "0196369ZNC",
    product_eng: "TUMI women's backpack zinc color",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$627.63",
    description_eng:
      "Brand: TUMI Size: 36*29*14cm Computer compartment: 27.5*25.5*1.25cm Main material: Nylon Weight: 0.6kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0196369ZNC.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1670",
    brand: "TUMI",
    sku: "0196369BER",
    product_eng: "TUMI women's backpack berry red",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$627.63",
    description_eng:
      "Brand: TUMI Size: 36*29*14cm Main material: Nylon Weight: 0.7kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0196369BER.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1671",
    brand: "TUMI",
    sku: "0196460GLB",
    product_eng: "TUMI women's backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$627.63",
    description_eng:
      "Brand: TUMI Size: 34.5*25*13.25cm Main material: Nylon Weight: 0.6kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0196460GLB.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1672",
    brand: "TUMI",
    sku: "0196601DGM",
    product_eng: "TUMI women's backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$705.42",
    description_eng:
      "Brand: TUMI Size: 37*29*14cm Main material: Nylon Weight: 0.717kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0196601DGM.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1673",
    brand: "TUMI",
    sku: "0232793NVY",
    product_eng: "TUMI backpack navy blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$854.14",
    description_eng:
      "Brand: TUMI Size: 40.5*35.5*18.5cm Expansion size: 25.5cm Computer compartment: 38*25.5*2.25cm Main material: nylon Weight: 1.3kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0232793NVY.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1674",
    brand: "TUMI",
    sku: "0232759D",
    product_eng: "TUMI backpack black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$854.14",
    description_eng:
      "Brand: TUMI Size: 42*35*16cm Expansion size: 61cm Computer compartment: 38*29*2cm Main material: nylon Weight: 1.5kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0232759D.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1675",
    brand: "TUMI",
    sku: "0232759NVY",
    product_eng: "TUMI backpack navy blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$854.14",
    description_eng:
      "Brand: TUMI Size: 42*35*16cm Expansion size: 61cm Computer compartment: 38*29*2cm Main material: nylon Weight: 1.5kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0232759NVY.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1676",
    brand: "TUMI",
    sku: "0232657OBS",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$867.87",
    description_eng:
      "Brand: TUMI Size: 49*32*15cm Main material: polyurethane Weight: 1kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0232657OBS.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1677",
    brand: "TUMI",
    sku: "06602011GYCME",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$927.93",
    description_eng:
      "Brand: TUMI Size: 42*29*9cm Main material: Polyester Weight: 1.1kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/06602011GYCME.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1678",
    brand: "TUMI",
    sku: "06602021GYCME",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$971.40",
    description_eng:
      "Brand: TUMI Size: 44.5*31*12.75cm Main material: Polyester Weight: 1.2kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/06602021GYCME.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1679",
    brand: "TUMI",
    sku: "0232719MDK",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,243.10",
    description_eng: "Brand: TUMI Size: 52.5*32*19cm Main material: Nylon",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0232719MDK.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1680",
    brand: "TUMI",
    sku: "0232793MDK",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$854.14",
    description_eng:
      "Brand: TUMI Size: 40.5*35.5*18.5cm Main material: Nylon Weight: 2.236kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0232793MDK.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1681",
    brand: "TUMI",
    sku: "0232770OLVG",
    product_eng: "TUMI fashion waist bag chest bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$448.02",
    description_eng:
      "Brand: TUMI Size: 12*25.5*5cm Main material: nylon Weight: 0.3kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0232770OLVG.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1682",
    brand: "TUMI",
    sku: "0228774HG2",
    product_eng: "TUMI trolley case 29 inches green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,346.26",
    description_eng:
      "Brand: TUMI Size: 77.5*51*28cm Main material: PC Size: 29 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0228774HG2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1683",
    brand: "TUMI",
    sku: "0228771MST2",
    product_eng: "TUMI trolley case 20 inches green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$883.31",
    description_eng:
      "Brand: TUMI Size: 55*35.5*23cm Main material: polycarbonate Weight: 3.558kg Size: 20 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0228771MST2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1684",
    brand: "TUMI",
    sku: "0228771CRL2",
    product_eng: "TUMI trolley case 20 inches orange",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$883.31",
    description_eng:
      "Brand: TUMI Size: 55*35.5*23cm Main material: polycarbonate Weight: 3.558kg Size: 20 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0228771CRL2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1685",
    brand: "TUMI",
    sku: "0228773D2",
    product_eng: "TUMI trolley case 24 inches black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,215.21",
    description_eng:
      "Brand: TUMI Size: 66*44.5*25.5cm Main material: polycarbonate Weight: 4.08kg Size: 24 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0228773D2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1686",
    brand: "TUMI",
    sku: "0228774MST2",
    product_eng: "TUMI trolley case 29 inches green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,120.41",
    description_eng:
      "Brand: TUMI Size: 77.5*51*28cm Main material: polycarbonate Weight: 5.556kg Size: 29 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0228774MST2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1687",
    brand: "TUMI",
    sku: "0228774CRL2",
    product_eng: "TUMI trolley case 29 inches orange",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,120.41",
    description_eng:
      "Brand: TUMI Size: 77.5*51*28cm Main material: polycarbonate Weight: 5.556kg Size: 29 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0228774CRL2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1688",
    brand: "TUMI",
    sku: "0232793GRY",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$748.32",
    description_eng:
      "Brand: TUMI Size: 40.5*35.5*18.5cm Expansion size: 25.5cm Computer compartment: 38*25.5*2.25cm Main material: nylon Weight: 1.3kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/TUMI/0232793GRY.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1689",
    brand: "TUMI",
    sku: "02603580D3",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,002.29",
    description_eng:
      "Brand: TUMI Size: 43*30.5*20.5cm Computer compartment: 40.5*25.5*3.75cm Main material: Nylon Weight: 1.5kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/02603580D3.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1690",
    brand: "TUMI",
    sku: "02603589D3",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,190.19",
    description_eng:
      "Brand: TUMI Size: 43*30.5*21cm Computer compartment: 40.5*26*2.5cm Main material: nylon Weight: 1.6kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/02603589D3.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1691",
    brand: "TUMI",
    sku: "02223388HKO",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$826.97",
    description_eng:
      "Brand: TUMI Size: 48.5*35.5*15cm Main material: Ballistic nylon Weight: 1.45kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/02223388HKO.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1692",
    brand: "TUMI",
    sku: "06602035GYCME",
    product_eng: "TUMI men's chest bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$711.34",
    description_eng:
      "Brand: TUMI Size: 30.5*18*5cm Main material: Polyester Weight: 0.5kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/06602035GYCME.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1693",
    brand: "TUMI",
    sku: "02603182D3",
    product_eng: "TUMI men's briefcase",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$901.62",
    description_eng:
      "Brand: TUMI Size: 29*40.5*9cm Computer compartment: 26.5*38*3.75cm Main material: Nylon Weight: 2kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/02603182D3.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1694",
    brand: "TUMI",
    sku: "0232799IRN",
    product_eng: "TUMI men's chest bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$618.19",
    description_eng:
      "Brand: TUMI Size: 15*30.5*10.25cm Main material: Nylon Weight: 0.5kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0232799IRN.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1695",
    brand: "TUMI",
    sku: "0196651DGM",
    product_eng: "TUMI women's backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$832.69",
    description_eng:
      "Brand: TUMI Size: 38*30*15cm Computer compartment: 30.5*26.5*2.5cm Main material: Nylon Weight: 0.78kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0196651DGM.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1696",
    brand: "TUMI",
    sku: "0196369MP",
    product_eng: "TUMI women's backpack pink",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$631.92",
    description_eng:
      "Brand: TUMI Size: 36*29*14cm Computer compartment: 27.5*25.5*1.25cm Main material: Nylon Weight: 0.6kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0196369MP.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1697",
    brand: "TUMI",
    sku: "0196369ZNC",
    product_eng: "TUMI women's backpack zinc color",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$631.92",
    description_eng:
      "Brand: TUMI Size: 36*29*14cm Computer compartment: 27.5*25.5*1.25cm Main material: Nylon Weight: 0.6kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0196369ZNC.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1698",
    brand: "TUMI",
    sku: "0196369BER",
    product_eng: "TUMI women's backpack berry red",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$631.92",
    description_eng:
      "Brand: TUMI Size: 36*29*14cm Main material: Nylon Weight: 0.7kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0196369BER.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1699",
    brand: "TUMI",
    sku: "0196460GLB",
    product_eng: "TUMI women's backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$631.92",
    description_eng:
      "Brand: TUMI Size: 34.5*25*13.25cm Main material: Nylon Weight: 0.6kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0196460GLB.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1700",
    brand: "TUMI",
    sku: "0196601DGM",
    product_eng: "TUMI women's backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$709.71",
    description_eng:
      "Brand: TUMI Size: 37*29*14cm Main material: Nylon Weight: 0.717kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0196601DGM.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1701",
    brand: "TUMI",
    sku: "0232793NVY",
    product_eng: "TUMI backpack navy blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$858.43",
    description_eng:
      "Brand: TUMI Size: 40.5*35.5*18.5cm Expansion size: 25.5cm Computer compartment: 38*25.5*2.25cm Main material: nylon Weight: 1.3kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0232793NVY.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1702",
    brand: "TUMI",
    sku: "0232759D",
    product_eng: "TUMI backpack black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$858.43",
    description_eng:
      "Brand: TUMI Size: 42*35*16cm Expansion size: 61cm Computer compartment: 38*29*2cm Main material: nylon Weight: 1.5kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0232759D.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1703",
    brand: "TUMI",
    sku: "0232759NVY",
    product_eng: "TUMI backpack navy blue",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$858.43",
    description_eng:
      "Brand: TUMI Size: 42*35*16cm Expansion size: 61cm Computer compartment: 38*29*2cm Main material: nylon Weight: 1.5kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0232759NVY.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1704",
    brand: "TUMI",
    sku: "0232657OBS",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$872.16",
    description_eng:
      "Brand: TUMI Size: 49*32*15cm Main material: polyurethane Weight: 1kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0232657OBS.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1705",
    brand: "TUMI",
    sku: "06602011GYCME",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$932.22",
    description_eng:
      "Brand: TUMI Size: 42*29*9cm Main material: Polyester Weight: 1.1kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/06602011GYCME.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1706",
    brand: "TUMI",
    sku: "06602021GYCME",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$975.69",
    description_eng:
      "Brand: TUMI Size: 44.5*31*12.75cm Main material: Polyester Weight: 1.2kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/06602021GYCME.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1707",
    brand: "TUMI",
    sku: "0232719MDK",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,247.39",
    description_eng: "Brand: TUMI Size: 52.5*32*19cm Main material: Nylon",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0232719MDK.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1708",
    brand: "TUMI",
    sku: "0232793MDK",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$858.43",
    description_eng:
      "Brand: TUMI Size: 40.5*35.5*18.5cm Main material: Nylon Weight: 2.236kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0232793MDK.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1709",
    brand: "TUMI",
    sku: "0232770OLVG",
    product_eng: "TUMI fashion waist bag chest bag",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$452.31",
    description_eng:
      "Brand: TUMI Size: 12*25.5*5cm Main material: nylon Weight: 0.3kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0232770OLVG.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1710",
    brand: "TUMI",
    sku: "0228774HG2",
    product_eng: "TUMI trolley case 29 inches green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,350.55",
    description_eng:
      "Brand: TUMI Size: 77.5*51*28cm Main material: PC Size: 29 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0228774HG2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1711",
    brand: "TUMI",
    sku: "0228771MST2",
    product_eng: "TUMI trolley case 20 inches green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$887.60",
    description_eng:
      "Brand: TUMI Size: 55*35.5*23cm Main material: polycarbonate Weight: 3.558kg Size: 20 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0228771MST2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1712",
    brand: "TUMI",
    sku: "0228771CRL2",
    product_eng: "TUMI trolley case 20 inches orange",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$887.60",
    description_eng:
      "Brand: TUMI Size: 55*35.5*23cm Main material: polycarbonate Weight: 3.558kg Size: 20 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0228771CRL2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1713",
    brand: "TUMI",
    sku: "0228773D2",
    product_eng: "TUMI trolley case 24 inches black",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,219.50",
    description_eng:
      "Brand: TUMI Size: 66*44.5*25.5cm Main material: polycarbonate Weight: 4.08kg Size: 24 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0228773D2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1714",
    brand: "TUMI",
    sku: "0228774MST2",
    product_eng: "TUMI trolley case 29 inches green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,124.70",
    description_eng:
      "Brand: TUMI Size: 77.5*51*28cm Main material: polycarbonate Weight: 5.556kg Size: 29 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0228774MST2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1715",
    brand: "TUMI",
    sku: "0228774CRL2",
    product_eng: "TUMI trolley case 29 inches orange",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$1,124.70",
    description_eng:
      "Brand: TUMI Size: 77.5*51*28cm Main material: polycarbonate Weight: 5.556kg Size: 29 inches",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0228774CRL2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1716",
    brand: "TUMI",
    sku: "0232793GRY",
    product_eng: "TUMI backpack",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$752.61",
    description_eng:
      "Brand: TUMI Size: 40.5*35.5*18.5cm Expansion size: 25.5cm Computer compartment: 38*25.5*2.25cm Main material: nylon Weight: 1.3kg",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/TUMI/0232793GRY.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1717",
    brand: "VICTORIATOURIST",
    sku: "V9016",
    product_eng: "VICTORIATOURIST backpack 15.6 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$56.31",
    description_eng:
      "Brand: VICTORIATOURIST Size: 31*18*42cm Material: Oxford cloth Weight: 0.73kg Capacity: 15.6/16.1 inch computer",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/VICTORIATOURIST/V9016.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1718",
    brand: "VICTORIATOURIST",
    sku: "V9016",
    product_eng: "VICTORIATOURIST backpack 15.6 inches",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$60.60",
    description_eng:
      "Brand: VICTORIATOURIST Size: 31*18*42cm Material: Oxford cloth Weight: 0.73kg Capacity: 15.6/16.1 inch computer",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/VICTORIATOURIST/V9016.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1719",
    brand: "WANGYEJUN",
    sku: "CWW16B",
    product_eng: "WANGYEJUN pet nest for all seasons 60*55*63CM",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$37.12",
    description_eng:
      "Brand: WANGYEJUN Material: Polyester cloth + pine Size: 60*55*63cm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/WANGYEJUN/CWW16B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1720",
    brand: "WANGYEJUN",
    sku: "CWW16B",
    product_eng: "WANGYEJUN pet nest for all seasons 60*55*63CM",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$41.41",
    description_eng:
      "Brand: WANGYEJUN Material: Polyester cloth + pine Size: 60*55*63cm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/WANGYEJUN/CWW16B.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1721",
    brand: "Wilson",
    sku: "WR061610U2",
    product_eng: "Wilson aluminum alloy junior single tennis racket",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$72.19",
    description_eng:
      "Brand: Wilson Racket face: 113 square inches Cable weight: 275g Threading mode: 16 x 19 Handle: Number 2 Air beat balance point: 2 Nod gently",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Wilson/WR061610U2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1722",
    brand: "Wilson",
    sku: "WZ1003301CN7",
    product_eng:
      "Wilson NCAA EVO NXT Indoor Competition Microfiber Size 7 Basketball",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$137.85",
    description_eng:
      "Brand: Wilson Specification: No. 7 Circumference: 749-780mm Weight: 570-650g Material: microfiber PU",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Wilson/WZ1003301CN7.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1723",
    brand: "Wilson",
    sku: "WTB7505XB07",
    product_eng: "Wilson NBA Official Game Ball No. 7 Basketball",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$325.47",
    description_eng:
      "Brand: Wilson Specification: No. 7 Circumference: 749-780mm Weight: 570-650g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Wilson/WTB7505XB07.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1724",
    brand: "Wilson",
    sku: "WR125711U2",
    product_eng: "Wilson all-carbon professional tennis racquet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$423.28",
    description_eng:
      "Brand: Wilson Racket face: 97 square inches Air weight: 315g Threading mode: 16 x 19 Handle: Number 2 Air beat balance point: 10 nod gently",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/Wilson/WR125711U2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1725",
    brand: "Wilson",
    sku: "WR061610U2",
    product_eng: "Wilson aluminum alloy junior single tennis racket",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$76.48",
    description_eng:
      "Brand: Wilson Racket face: 113 square inches Cable weight: 275g Threading mode: 16 x 19 Handle: Number 2 Air beat balance point: 2 Nod gently",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Wilson/WR061610U2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1726",
    brand: "Wilson",
    sku: "WZ1003301CN7",
    product_eng:
      "Wilson NCAA EVO NXT Indoor Competition Microfiber Size 7 Basketball",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$142.14",
    description_eng:
      "Brand: Wilson Specification: No. 7 Circumference: 749-780mm Weight: 570-650g Material: microfiber PU",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Wilson/WZ1003301CN7.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1727",
    brand: "Wilson",
    sku: "WTB7505XB07",
    product_eng: "Wilson NBA Official Game Ball No. 7 Basketball",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$329.76",
    description_eng:
      "Brand: Wilson Specification: No. 7 Circumference: 749-780mm Weight: 570-650g",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Wilson/WTB7505XB07.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1728",
    brand: "Wilson",
    sku: "WR125711U2",
    product_eng: "Wilson all-carbon professional tennis racquet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$427.57",
    description_eng:
      "Brand: Wilson Racket face: 97 square inches Air weight: 315g Threading mode: 16 x 19 Handle: Number 2 Air beat balance point: 10 nod gently",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/Wilson/WR125711U2.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1729",
    brand: "YIHUTEA",
    sku: "Y46880",
    product_eng: "YI HU TEA teapot 1.2L",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$42.79",
    description_eng:
      "Brand: YI HU TEA Capacity: 1.2L Material: High borosilicate heat resistant glass + injection molding handle Size: 13*13.5*8.7cm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/YIHUTEA/Y46880.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1735",
    brand: "YONEX",
    sku: "ASTORXCS",
    product_eng: "YONEX badminton racket full carbon sky ax pair",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$133.85",
    description_eng:
      "Brand: YONEX Frame material: tungsten carbon Rod material: carbon nano mesh resin NEO Racket size: 5U5 Length: 10mm long Hitter's sense: medium Recommended pounds: 19-26LBS",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/YONEX/ASTORXCS.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1736",
    brand: "YONEX",
    sku: "NR7000I",
    product_eng: "YONEX badminton racket blue and pink pair",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$69.38",
    description_eng:
      "Brand: YONEX Threaded or not: Cables are routed Frame material: aluminum Rod material: carbon Connector: Built-in T-shaped connector Recommended weight: 16-20 pounds",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/YONEX/NR7000I.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1737",
    brand: "YONEX",
    sku: "AS05",
    product_eng: "YONEX badminton set of 12 pieces",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$47.19",
    description_eng:
      "Brand: YONEX Quantity: 12 PCS /1 barrel Individual weight: 4.7-5.5g Ball: Duck ball Material: Duck feather, composite cork",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/YONEX/AS05.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1738",
    brand: "YONEX",
    sku: "AXSVSE1H",
    product_eng: "YONEX badminton racket gift set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$284.34",
    description_eng:
      "Brand: YONEX Batsman feeling: hard Frame material: high elastic carbon; Nano-reticular resin NEO; tungsten Rod material: high elastic carbon; New dimension carbon Length: 10MM long Racket size: 4U5 Recommended weight: 4U 21-29 Color: Black/red Racket bag: Specification: 72*24cm, color: black Wrist guard: Specification: 7.5*8cm, color: black Hand glue: Specification: 25*1100*0.6mm, color: black",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/YONEX/AXSVSE1H.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1739",
    brand: "YONEX",
    sku: "NFFLSE1H",
    product_eng: "YONEX badminton racket gift set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$284.34",
    description_eng:
      "Brand: YONEX Hitter sensation: Medium Frame material: high elastic carbon; Nano-molecule NEO; EX- Highly elastic carbon Rod material: high elastic carbon Color: Silver/white Length: 10MM long Racket size: 4U5 Recommended weight: 4U 20-28 Racket bag: Size: 72*24cm, color: coral pink Wrist guard: Specification: 7.5*8cm, color: white Hand glue: Specification: 25*1100*0.6mm, color: white",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/YONEX/NFFLSE1H.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1740",
    brand: "ZEZE",
    sku: "ZEZEZ1B00039",
    product_eng: "ZEZE doghouse mat",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$36.04",
    description_eng:
      "Brand: ZEZE Application: within 20 kg Material: rush, cotton, foamed polypropylene Size: 68*48cm",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/zeze/ZEZEZ1B00039.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1741",
    brand: "ZEZE",
    sku: "ZEZEZ1B00111",
    product_eng: "ZEZE pet sofa",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$64.75",
    description_eng:
      "Brand: ZEZE Size: 68*53*37cm Material: plush fabric, polyester fiber, wood-based board",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/zeze/ZEZEZ1B00111.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1742",
    brand: "ZWILLING",
    sku: "Z100013",
    product_eng: "ZWILLING Knife Set 2 Piece Red",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$93.89",
    description_eng:
      "Brand: ZWILLING Medium blade knife *1, multi-purpose knife *1 Blade material: stainless steel Handle material: PP material",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z100013.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1743",
    brand: "ZWILLING",
    sku: "Z100008",
    product_eng: "ZWILLING Knife Set 2 Piece Green",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$93.89",
    description_eng:
      "Brand: ZWILLING Medium blade knife *1, multi-purpose knife *1 Blade material: stainless steel Handle material: PP material",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z100008.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1744",
    brand: "ZWILLING",
    sku: "Z100050",
    product_eng: "ZWILLING soup pot and steamer set of two pieces 28cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$160.70",
    description_eng:
      "Brand: ZWILLING 28cm stockpot *1, 28cm double-ear steamer *1, lid *1 Pot body quality: austenitic stainless steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z100050.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1745",
    brand: "ZWILLING",
    sku: "Z543500",
    product_eng: "ZWILLING Knife Set 7-Piece Set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$231.32",
    description_eng:
      "Brand: ZWILLING Medium blade knife *1, multi-purpose knife *1, multi-purpose scissors *1, vegetable knife *1, chopping knife *1, sharpener rod *1, knife holder *1 Blade material: stainless steel Handle material: PP material (cutter), PA material: (scissors) Tool rest material: rubber wood + birch",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z543500.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1746",
    brand: "ZWILLING",
    sku: "Z601403",
    product_eng: "ZWILLING sterilizing knife holder 26-piece set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$473.27",
    description_eng:
      "Brand: ZWILLING Tool material: Body: martensitic stainless steel Handle: Resin Tool rest material: Shell PP(polypropylene) Rated voltage: 220V Rated power: 50Hz Rated power: 80W Sterilizing drying knife holder Knife and scissors 7-piece set 2 pieces cutting board set 16-piece tableware set",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z601403.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1747",
    brand: "ZWILLING",
    sku: "Z1022215",
    product_eng: "ZWILLING non-stick pan 28cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$131.45",
    description_eng:
      "Brand: ZWILLING 28cm frying pan *1, lid *1, small silicone spatula *1 Material: Body body: aluminum alloy, lid body: glass",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z1022215.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1748",
    brand: "ZWILLING",
    sku: "Z1000008",
    product_eng: "ZWILLING Western tableware 8-piece set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$53.94",
    description_eng:
      "Brand: ZWILLING Main knife (22.8cm long) *2, main fork (22cm long) *2, main spoon (22cm long) *2, dessert spoon (14.2cm long) *2",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z1000008.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1749",
    brand: "ZWILLING",
    sku: "Z1000006",
    product_eng: "ZWILLING compact multi-purpose knife",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$41.38",
    description_eng:
      "Brand: ZWILLING Dimensions: Blade length 120mm, knife length 226mm, including the total length of 234mm Blade material: stainless steel Handle/sleeve material: Resin",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z1000006.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1750",
    brand: "ZWILLING",
    sku: "Z111361",
    product_eng: "ZWILLING enamel pot 24cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$176.20",
    description_eng:
      "Brand: ZWILLING Material: enamelled cast iron Dimensions: Diameter 24cm, depth 11cm Applicable stoves: gas stoves, induction stoves, ceramic stoves, halogen stoves, etc",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z111361.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1751",
    brand: "ZWILLING",
    sku: "Z10001",
    product_eng: "ZWILLING pot set 3 pieces + silicone spatula",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$283.37",
    description_eng:
      "Brand: ZWILLING Milk pan 18cm*1 Frying pan 24cm*1 Wok 30cm*1 Small silicone spatula Inner coating material: PTFE Pot body quality: aluminum alloy",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z10001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1752",
    brand: "ZWILLING",
    sku: "Z40127",
    product_eng: "ZWILLING stainless steel uncoated steak skillet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$102.10",
    description_eng:
      "Brand: ZWILLING Dimensions: Diameter 24cm, body 7.6cm Material: Austenitic stainless steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/CN/images/ZWILLING/Z40127.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1753",
    brand: "ZWILLING",
    sku: "Z100050",
    product_eng: "ZWILLING soup pot and steamer set of two pieces 28cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$164.99",
    description_eng:
      "Brand: ZWILLING 28cm stockpot *1, 28cm double-ear steamer *1, lid *1 Pot body quality: austenitic stainless steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/ZWILLING/Z100050.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1754",
    brand: "ZWILLING",
    sku: "Z1022215",
    product_eng: "ZWILLING non-stick pan 28cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$135.74",
    description_eng:
      "Brand: ZWILLING 28cm frying pan *1, lid *1, small silicone spatula *1 Material: Body body: aluminum alloy, lid body: glass",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/ZWILLING/Z1022215.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1755",
    brand: "ZWILLING",
    sku: "Z1000008",
    product_eng: "ZWILLING Western tableware 8-piece set",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$58.23",
    description_eng:
      "Brand: ZWILLING Main knife (22.8cm long) *2, main fork (22cm long) *2, main spoon (22cm long) *2, dessert spoon (14.2cm long) *2",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/ZWILLING/Z1000008.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1756",
    brand: "ZWILLING",
    sku: "Z111361",
    product_eng: "ZWILLING enamel pot 24cm",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$180.49",
    description_eng:
      "Brand: ZWILLING Material: enamelled cast iron Dimensions: Diameter 24cm, depth 11cm Applicable stoves: gas stoves, induction stoves, ceramic stoves, halogen stoves, etc",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/ZWILLING/Z111361.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1757",
    brand: "ZWILLING",
    sku: "Z10001",
    product_eng: "ZWILLING pot set 3 pieces + silicone spatula",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$287.66",
    description_eng:
      "Brand: ZWILLING Milk pan 18cm*1 Frying pan 24cm*1 Wok 30cm*1 Small silicone spatula Inner coating material: PTFE Pot body quality: aluminum alloy",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/ZWILLING/Z10001.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1758",
    brand: "ZWILLING",
    sku: "Z40127",
    product_eng: "ZWILLING stainless steel uncoated steak skillet",
    product_jpn: "",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "$106.39",
    description_eng:
      "Brand: ZWILLING Dimensions: Diameter 24cm, body 7.6cm Material: Austenitic stainless steel",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/HK/images/ZWILLING/Z40127.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1759",
    brand: "Dyson",
    sku: "CF06WS",
    product_eng: "Dyson Solarcycle Morph™floor lamp White/Silver",
    product_jpn: "Dyson Solarcycle Morph™フロアライト ホワイト/シルバー",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥89,000",
    rrp_with_vat: "¥97,900",
    description_eng:
      "The only lighting that keeps the quality of light for 60 years Calming light.  Four lighting modes in one unit that change shape to fit the space Intelligently tracks natural light in the current location using a unique GPS-based algorithm, adjusting color temperature and brightness every 60 seconds.  ■Main unit weight 6.1kg ■Height 1251mm ■Depth 302mm ■Width 465mm",
    description_jpn:
      "光の質を60年間保つ、ただひとつの照明 落ち着いた光を  空間に合わせて形を変える1台で4つの照明モード GPSに基づく独自のアルゴリズムにより、インテリジェントに現在地の自然光をトラッキング。60秒ごとに色温度と明るさを調整します。  ■本体質量 6.1kg ■高さ 1251mm ■奥行き 302mm ■幅 465mm",
    product_image_1:
      "https://products.naganorewards.com/images/dyson/Dyson_CD06WS.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
    "": "",
  },
  {
    id: "1760",
    brand: "Dyson",
    sku: "CD06WS",
    product_eng: "Dyson Solarcycle Morph™ Desk Light White/Silver",
    product_jpn: "Dyson Solarcycle Morph™デスクライトホワイト/シルバー",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥66,000",
    rrp_with_vat: "¥72,600",
    description_eng:
      "Shape-changing. Illuminates freely. Intelligently tracks natural light at your current location. By positioning the light perpendicular to where you are working, it illuminates the area with powerful, high-quality light. Can also be used as indirect lighting in a variety of situations. The head rotates 360°, allowing the light to softly reflect off walls and ceilings.  ●Product main unit size: 523 (H) x 414.4 (W) x 200.2 (D) mm ●Main unit weight: 3.50 kg",
    description_jpn:
      "形が変わる。自在に照らす。インテリジェントに現在地の自然光をトラッキング。 作業する場所に対してライトを垂直に配置することで、パワフルで高品質な光で明るく照らします。また間接照明として、さまざまな場面で利用可能。ヘッドが360°回転するため、壁や天井に光を当て柔らかく反射させます。  ●製品本体サイズ：高さ523×幅414.4×奥行200.2mm ●本体質量：3.50kg",
    product_image_1:
      "https://products.naganorewards.com/images/dyson/Dyson_CF06WS.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/dyson.png",
    "": "",
  },
  {
    id: "1761",
    brand: "BOSE",
    sku: "Smart Ultra SB BLK",
    product_eng: "Bose Smart Ultra Soundbar",
    product_jpn: "Bose Smart Ultra Soundbar",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥120,000",
    rrp_with_vat: "¥132,000",
    description_eng:
      "A soundbar that immerses you in your favorite content and delivers an extraordinary sense of presence. Realistic sound for any content  Sound that resonates from all directions  Easy setup and connection to your TV with the included optical digital audio cable or the included HDMI™ eARC cable.  Soundbar: 5.8 cm (H) x 104.5 cm (W) x 10.7 cm (D) (5.8 kg)",
    description_jpn:
      "お気に入りのコンテンツに没入できる,かってない臨場感をお届けするサウンドバー あらゆるコンテンツで臨場感のあるサウンドを  全方向から響くサウンド  付属の光デジタル音声ケーブルまたは、付属のHDMI™ eARCケーブル1本でテレビに簡単セットアップ接続。  サウンドバー:5.8 cm (H) x 104.5 cm (W) x 10.7 cm (D) (5.8 kg)",
    product_image_1:
      "https://products.naganorewards.com/images/bose/BOSE_Smart_Ultra-SB-BLK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1762",
    brand: "AVIOT",
    sku: "WA-V1-BK(BLACK)",
    product_eng: "AVIOT Wireless Headphone Black",
    product_jpn: "AVIOT ワイヤレスヘッドフォン ブラック",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥13,500",
    rrp_with_vat: "¥14,850",
    description_eng:
      "We give up nothing. Everything is included, setting a new standard for wireless headphones. Ultra-long stamina that enables up to 120 hours* of continuous playback, and high-resolution wireless  *Playback time may vary depending on the usage environment.  ■Advanced “Adaptive Hybrid Noise Cancellation” adjusts the level of noise suppression according to the situation.The “Adaptive Hybrid Noise Cancellation” technology significantly reduces ambient noise such as train and car noise, busy city streets, and people's voices. This function is ideal for enjoying music and movies, as well as for when you want to concentrate on work or study. ■Uncompromising structural design for both high sound quality and functionality ■LDAC compatibility for enjoying high-resolution sound sources wirelessly Even wirelessly, users can enjoy music while taking full advantage of the characteristics of high-resolution sound sources. ＊LDAC and the LDAC logo are trademarks of Sony Corporation. ■Compact design that can be folded for easy portability ■Comfortable fit for long hours of use ■Specifications High-resolution: Compatible External Sound Intake: Compatible Built-in microphone for calls: ECM microphone x 1 Maximum talk time: 70 hours Maximum continuous playback time: 120 hours Quick Charge: 10 minutes charge / up to 11 hours playback Charging port: USB Type-C  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "何もあきらめない。全てをそなえ、ワイヤレスヘッドホンの新基準へ 最大120時間*連続再生可能な超ロングスタミナを実現し、音質、機能、操作性、全てをそなえたハイレゾ対応ワイヤレスヘッドホン *再生時間は使用環境により変動する可能性があります。  ■進化した”アダプティブハイブリッドノイズキャンセリング”でシーンに応じて騒音抑制のレベルを調整 電車や車の走行音、街中の雑踏や人の話し声といった環境音を大幅に軽減。音楽や動画を楽しむ際にはもちろん、仕事や勉強に集中したい時にも最適な機能です。 ■高音質と機能性を両立した、妥協なき構造設計 癖の少ない自然な音響特性で、ハイレゾ音源が持つ情報を余すことなく再現します。 ■最適な音響バランスを実現するアコースティックダクト インナーバックチャンバー内の音響インピーダンスを最適化するため、ハウジング内に独自設計のアコースティックダクトを配置。低音の量感とクリアネスを両立し、のびやかな高音域とあわせ、バランスの良いサウンドを実現します。 ■ワイヤレスでハイレゾ音源を楽しめるLDAC対応 Bluetooth伝送方式には、AAC、SBCに加え、既存技術(SBC)と比べ約3倍のデータ量送信が可能なLDACを採用。 ワイヤレスでも、音場の広さ、情報量の多さ、細やかな表現など、ハイレゾ音源が持つ特性を最大限に生かしながら、音楽をお楽しみいただくことができます。 ※ LDACおよびLDACロゴは、ソニー株式会社の商標です。 ■持ち運びに便利な折りたたみできるコンパクト設計 ハイブリッドノイズキャンセリング搭載モデルながら、約267gに本体重量を抑えました。 ■長時間の使用でも疲れにくい快適な装着感  【仕様】 ハイレゾ：対応 外音取込：対応 通話用内蔵マイク：ECM マイク x 1 最大通話時間：70時間 最大連続再生時間：120時間 急速充電：10分充電/最大11時間再生 充電ポート：USB Type-C  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/aviot/WA-V1-BK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1763",
    brand: "AVIOT",
    sku: "WA-V1-WH(WHIE)",
    product_eng: "AVIOT Wireless Headphone White",
    product_jpn: "AVIOT ワイヤレスヘッドフォン ホワイト",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥13,500",
    rrp_with_vat: "¥14,850",
    description_eng:
      "We give up nothing. Everything is included, setting a new standard for wireless headphones. Ultra-long stamina that enables up to 120 hours* of continuous playback, and high-resolution wireless  *Playback time may vary depending on the usage environment.  ■Advanced “Adaptive Hybrid Noise Cancellation” adjusts the level of noise suppression according to the situation.The “Adaptive Hybrid Noise Cancellation” technology significantly reduces ambient noise such as train and car noise, busy city streets, and people's voices. This function is ideal for enjoying music and movies, as well as for when you want to concentrate on work or study. ■Uncompromising structural design for both high sound quality and functionality ■LDAC compatibility for enjoying high-resolution sound sources wirelessly Even wirelessly, users can enjoy music while taking full advantage of the characteristics of high-resolution sound sources. ＊LDAC and the LDAC logo are trademarks of Sony Corporation. ■Compact design that can be folded for easy portability ■Comfortable fit for long hours of use ■Specifications High-resolution: Compatible External Sound Intake: Compatible Built-in microphone for calls: ECM microphone x 1 Maximum talk time: 70 hours Maximum continuous playback time: 120 hours Quick Charge: 10 minutes charge / up to 11 hours playback Charging port: USB Type-C  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "何もあきらめない。全てをそなえ、ワイヤレスヘッドホンの新基準へ 最大120時間*連続再生可能な超ロングスタミナを実現し、音質、機能、操作性、全てをそなえたハイレゾ対応ワイヤレスヘッドホン *再生時間は使用環境により変動する可能性があります。  ■進化した”アダプティブハイブリッドノイズキャンセリング”でシーンに応じて騒音抑制のレベルを調整 電車や車の走行音、街中の雑踏や人の話し声といった環境音を大幅に軽減。音楽や動画を楽しむ際にはもちろん、仕事や勉強に集中したい時にも最適な機能です。 ■高音質と機能性を両立した、妥協なき構造設計 癖の少ない自然な音響特性で、ハイレゾ音源が持つ情報を余すことなく再現します。 ■最適な音響バランスを実現するアコースティックダクト インナーバックチャンバー内の音響インピーダンスを最適化するため、ハウジング内に独自設計のアコースティックダクトを配置。低音の量感とクリアネスを両立し、のびやかな高音域とあわせ、バランスの良いサウンドを実現します。 ■ワイヤレスでハイレゾ音源を楽しめるLDAC対応 Bluetooth伝送方式には、AAC、SBCに加え、既存技術(SBC)と比べ約3倍のデータ量送信が可能なLDACを採用。 ワイヤレスでも、音場の広さ、情報量の多さ、細やかな表現など、ハイレゾ音源が持つ特性を最大限に生かしながら、音楽をお楽しみいただくことができます。 ※ LDACおよびLDACロゴは、ソニー株式会社の商標です。 ■持ち運びに便利な折りたたみできるコンパクト設計 ハイブリッドノイズキャンセリング搭載モデルながら、約267gに本体重量を抑えました。 ■長時間の使用でも疲れにくい快適な装着感  【仕様】 ハイレゾ：対応 外音取込：対応 通話用内蔵マイク：ECM マイク x 1 最大通話時間：70時間 最大連続再生時間：120時間 急速充電：10分充電/最大11時間再生 充電ポート：USB Type-C  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/aviot/WA-V1-WH.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1764",
    brand: "CASIO",
    sku: "CTS200BK",
    product_eng: "CASIO Basic musical keyboard Black",
    product_jpn: "CASIO カシオ ベーシックキーボード ブラック",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥17,000",
    rrp_with_vat: "¥18,700",
    description_eng:
      "Slim & Stylish Portable Design In addition to its compact size (930 x 256 x 73 mm) so that you can enjoy your music wherever you want, it can run continuously for about 16 hours* on alkaline batteries. It is also lightweight at 3.3 kg and equipped with a grip on the top of the keyboard, making it easy to carry with one hand.  ・Easy-to-operate interface, even for beginners ・Sound that belies the compact size of the unit ・Dance music mode with voice to expand your playing pleasure ・Piano shaped keyboard for easy playability and realistic feel. ・The keyboard has a box-shaped keyboard.   <Specifications> Keyboard: 61 keys Number of simultaneous tones: Maximum 48 tones Tone function: Preset tones: 400 tones / Stereo piano tone: 1 Metronome function Song bank function Preset songs: 60 Dual power supply Battery: AA alkaline batteries or 6 AA rechargeable nickel-hydrogen batteries Continuous operating time: Approx. 16 hours (with alkaline batteries), Approx. 13 hours (with rechargeable nickel-hydrogen batteries)*. Continuous operating time may decrease depending on the type of batteries used, the method of performance, and the environment in which the product is used. AC adapter: AD-E95100L (JEITA standard, with unified polarity plug) Auto power off function: after approx. 30 minutes (cancelable) Speakers: 13cm x 6cm (oval) x 2 (output: 2.0W + 2.0W) Power consumption: 5.5W Accessories: music stand, AC adapter  *We do not accept order cancellations or changes due to customer reasons (different from what you expected, wrong order, etc.), nor do we accept returns of products delivered to you. Please be aware of this before placing your order. *Only in the case of initial defects, we will exchange the product if you contact us within 7 days of arrival.",
    description_jpn:
      "スリム＆スタイリッシュなポータブルデザイン 音楽を好きな場所で楽しめるよう、930×256×73mmのコンパクトサイズに仕上げたほか、アルカリ乾電池で約16時間の連続駆動※が可能です。 また、3.3kgと軽量で、キーボード上部にはグリップを備えているので、片手で楽に持ち運びができます。  ●初心者でも操作しやすいインターフェイス ●コンパクトな本体サイズを感じさせないサウンド ●演奏の楽しみ方を広げるダンスミュージックモード with ボイス ●ピアノ形状鍵盤 弾きやすさとリアルな演奏感にこだわった、ピアノ形状の鍵盤を採用しています。 ※箱型の形状をした鍵盤です。（白鍵のサイズ：長さ約136mm×幅約22mm） ●拡張性のためのUSBホスト端子 T-S200はUSB micro Bジャックが付属しているので、スマートデバイスやコンピュータと一緒に、音楽の制作を簡単に楽しむことができます。（市販のケーブルが必要です。）  【仕様】 鍵盤：61鍵 同時発音数：最大48音 音色機能：プリセット音色：400音色/ステレオピアノ音色：1 メトロノーム機能 ソングバンク機能 ・プリセットソング：60曲 電源 ・2電源方式 ・電池：単3形アルカリ乾電池又は単3形充電式ニッケル水素電池6本使用 ・連続動作時間：約16時間（アルカリ乾電池使用時）、約13時間（充電式ニッケル水素電池使用時）※ ・ご使用の電池の種類や演奏方法、使用環境によっては連続動作時間が短くなることがあります。 ※eneloop（エネループ）使用時の測定値 「eneloop」は、パナソニックの登録商標です。 ・ACアダプター：AD-E95100L（JEITA規格・極性統一形プラグ付き） ・オートパワーオフ機能：約30分後（キャンセル可能） スピーカー：13cm×6cm（楕円形）×2（出力：2.0W＋2.0W） 消費電力：5.5W 付属品：譜面立て、ACアダプター  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/casio/CTS200BK.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1765",
    brand: "CASIO",
    sku: "CTS200WE",
    product_eng: "CASIO Basic musical keyboard White",
    product_jpn: "CASIO カシオ ベーシックキーボード ホワイト",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥17,000",
    rrp_with_vat: "¥18,700",
    description_eng:
      "Slim & Stylish Portable Design In addition to its compact size (930 x 256 x 73 mm) so that you can enjoy your music wherever you want, it can run continuously for about 16 hours* on alkaline batteries. It is also lightweight at 3.3 kg and equipped with a grip on the top of the keyboard, making it easy to carry with one hand.  ・Easy-to-operate interface, even for beginners ・Sound that belies the compact size of the unit ・Dance music mode with voice to expand your playing pleasure ・Piano shaped keyboard for easy playability and realistic feel. ・The keyboard has a box-shaped keyboard.   <Specifications> Keyboard: 61 keys Number of simultaneous tones: Maximum 48 tones Tone function: Preset tones: 400 tones / Stereo piano tone: 1 Metronome function Song bank function Preset songs: 60 Dual power supply Battery: AA alkaline batteries or 6 AA rechargeable nickel-hydrogen batteries Continuous operating time: Approx. 16 hours (with alkaline batteries), Approx. 13 hours (with rechargeable nickel-hydrogen batteries)*. Continuous operating time may decrease depending on the type of batteries used, the method of performance, and the environment in which the product is used. AC adapter: AD-E95100L (JEITA standard, with unified polarity plug) Auto power off function: after approx. 30 minutes (cancelable) Speakers: 13cm x 6cm (oval) x 2 (output: 2.0W + 2.0W) Power consumption: 5.5W Accessories: music stand, AC adapter  *We do not accept order cancellations or changes due to customer reasons (different from what you expected, wrong order, etc.), nor do we accept returns of products delivered to you. Please be aware of this before placing your order. *Only in the case of initial defects, we will exchange the product if you contact us within 7 days of arrival.",
    description_jpn:
      "スリム＆スタイリッシュなポータブルデザイン 音楽を好きな場所で楽しめるよう、930×256×73mmのコンパクトサイズに仕上げたほか、アルカリ乾電池で約16時間の連続駆動※が可能です。 また、3.3kgと軽量で、キーボード上部にはグリップを備えているので、片手で楽に持ち運びができます。  ●初心者でも操作しやすいインターフェイス ●コンパクトな本体サイズを感じさせないサウンド ●演奏の楽しみ方を広げるダンスミュージックモード with ボイス ●ピアノ形状鍵盤 弾きやすさとリアルな演奏感にこだわった、ピアノ形状の鍵盤を採用しています。 ※箱型の形状をした鍵盤です。（白鍵のサイズ：長さ約136mm×幅約22mm） ●拡張性のためのUSBホスト端子 T-S200はUSB micro Bジャックが付属しているので、スマートデバイスやコンピュータと一緒に、音楽の制作を簡単に楽しむことができます。（市販のケーブルが必要です。）  【仕様】 鍵盤：61鍵 同時発音数：最大48音 音色機能：プリセット音色：400音色/ステレオピアノ音色：1 メトロノーム機能 ソングバンク機能 ・プリセットソング：60曲 電源 ・2電源方式 ・電池：単3形アルカリ乾電池又は単3形充電式ニッケル水素電池6本使用 ・連続動作時間：約16時間（アルカリ乾電池使用時）、約13時間（充電式ニッケル水素電池使用時）※ ・ご使用の電池の種類や演奏方法、使用環境によっては連続動作時間が短くなることがあります。 ※eneloop（エネループ）使用時の測定値 「eneloop」は、パナソニックの登録商標です。 ・ACアダプター：AD-E95100L（JEITA規格・極性統一形プラグ付き） ・オートパワーオフ機能：約30分後（キャンセル可能） スピーカー：13cm×6cm（楕円形）×2（出力：2.0W＋2.0W） 消費電力：5.5W 付属品：譜面立て、ACアダプター  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/casio/CTS200WE.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1766",
    brand: "ALINCO",
    sku: "AFBX5523",
    product_eng: "ALINCO Exercise cross Bike White",
    product_jpn: "ALINCO アルインコ クロスバイク ホワイト",
    category_1: "Health & Beauty",
    category_2: "",
    rrp_ex_vat: "¥18,182",
    rrp_with_vat: "¥20,000",
    description_eng:
      "●Lightweight bike that can be folded ●Equipped with a tray for exercise while riding ●Large saddle ●Includes a cover to prevent finger jamming when opening and closing the main unit. ●Position can be adjusted in detail to suit the body. ●Comfortable exercise can be done in a space-saving manner. ●Foldable for storage when not in use. ●8 levels of load can be adjusted with a single dial.  Specifications Saddle height: 7 levels adjustable Maximum weight limit for use: 90 kg Continuous use time: 30 minutes Suitable height: 160-180 cm Power source: 2 AA batteries Load: 8 levels of magnetic load  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "●折り畳みできる軽量なバイク ●ながら運動ができるトレー付 ●大型サドルを採用 ●本体開閉時の指詰めを防止するカバー付 ●身体に合わせて細かなポジション調節ができます ●省スペースで快適に運動ができます ●使わない時は折り畳み収納ができます ●８段階の負荷をダイヤルひとつで調節可能  【仕様】 サドル高さ：7段階調節可能 使用体重制限：90kg 連続使用時間：30分 適応身長：160～180㎝ 電源：単3乾電池2本 負荷：マグネット負荷方式8段階  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/alinco/AFBX5523.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1767",
    brand: "DOCTORAIR",
    sku: "ESB08(WH)",
    product_eng: "DOCTORAIR Vibration Exercise Machine White",
    product_jpn: "DOCTORAIR ドクターエアー 振動マシン ホワイト",
    category_1: "Health & Beauty",
    category_2: "",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      "Your days are so busy that you don't have time to exercise. With the 3D Superblade Smart 2, you can exercise easily and efficiently even if you don't have much time, You can exercise and stretch while you ride. It can train the muscles of the lower body, mainly the rectus femoris and gluteus maximus muscles.  ●Easy Exercise by Simply Riding on it All you have to do is get on and hold the posture. Recommended for those who want to exercise but have difficulty continuing and for those who want to exercise easily at home. ●Vibration Levels to Choose the “Perfect Fit” for You Each mode has 15 vibration levels. You can exercise at your own pace and with the vibration that best suits your needs. ●Space-saving both in use and in storage Compact size: 65 cm (width), 15.8 cm (height), and 36 cm (depth) ●Smart design that fits in with any interior ●Easy operation with band-type remote control  Specifications Power supply: Rated input: AC100 V50/60Hz Power consumption: 240W Vertical vibration frequency: Minimum 600 vibrations/minute, Maximum 770 vibrations/minute Timer: Initial setting 10 minutes, maximum 20 minutes at 1-minute intervals Maximum adaptable body weight: 120 kg Ambient temperature and humidity: +10°C to +40°C, 30-85% RH Main unit dimensions：W：650D：360H：158(mm) Main unit weight: Approx. 1,150g Included: Remote control (with button battery), power cord, floor mat, instruction manual (with warranty)  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "運動する時間が取れないほど忙しい日々。 3Dスーパーブレードスマート2なら、時間がなくても乗るだけで、楽に、効率的に、 “ながら運動” “ながらストレッチ” が可能。 「大腿直筋」「大殿筋」の下半身を中心とした筋肉を鍛えることができます。  ●乗るだけ簡単エクササイズ 乗って姿勢をキープするだけ。運動したいけどなかなか続かない方、自宅で手軽にエクササイズしたい方にオススメです。 ●「自分にぴったり」が選べる振動レベル それぞれのモードで15段階の振動レベルを搭載。自分のペースや負荷に合わせた振動でエクササイズが可能です。 ●使用時も収納時も省スペース 幅65㎝高さ15.8㎝奥行き36㎝のコンパクトサイズ ●インテリアに馴染むスマートなデザイン シンプルなフォルムと落ち着きのある質感でインテリアにマッチします。 ●バンド型リモコンでらくらく操作 腕につけるバンド型リモコンで、乗っている間の操作も簡単。  【仕様】 電源：定格入力：AC100 Ｖ50/60Hz 消費電力：240W 振動回数上下振動 ：最小600回/分最大770回/分 タイマー：初期設定10分、1分間隔で最大20分 最大適応体重：120㎏ 仕様環境温湿度：使用環境温湿度：+10℃～+40℃ 30～85％RH 本体寸法：W：650Ｄ：360Ｈ：158(mm) 本体質量：約1,150g 同梱資材：リモコン(ボタン電池付き)、電源コード、フロアマット、取扱説明書(保証書付き)  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/doctorair/ESB08(WH).jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1768",
    brand: "Vixen",
    sku: "ATREKII HR10X25WP",
    product_eng: "Vixen ATREKII 10x Binoculars",
    product_jpn: "Vixen ビクセン ATREKⅡ 10倍双眼鏡",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥26,000",
    rrp_with_vat: "¥28,600",
    description_eng:
      "Lightweight and compact body that fits neatly in a backpack Lightweight, but still authentic  ■PFM Coating PFM coating (Perfect Fourier Multi-coating) is used. The prism and the entire surface of the lens (objective and eyepiece) are coated with a multi-coat to provide extremely high contrast.  ■High Eyepoint Design High eyepoint design for less eye fatigue even after long hours of observation. A wide field of view can be seen even while wearing glasses.  ■Waterproof design The waterproof design prevents water from entering the optical tube even if it gets wet from rain or snow, making it suitable for outdoor use in changeable weather conditions.  ■Dach prism The roof (Dach) prism design enables the optical tube to be designed in a straight line. The smart form is attractive.   *We do not accept order cancellations, changes, or returns of delivered products due to customer's reasons (e.g., different product from what was expected, wrong order, etc.). Please understand this beforehand before placing an order. *Only in the case of initial defects, we will exchange the product if you contact us within 7 days of arrival.",
    description_jpn:
      "リュックにすっきり収まる軽量・コンパクトボディー 軽量でありがなら本格派  ●PFMコート PFMコート（パーフェクトフーリーマルチコート）採用。プリズムとレンズ全面（対物および接眼）にマルチコートが施され、極めて優れたコントラストが得られます。  ●ハイアイポイント設計 長時間の観察でも目が疲れにくい、ハイアイポイント設計です。メガネをかけたままでも広い視野を見ることができます。  ●防水設計 雨や雪などに濡れても鏡筒内に水が入らない設計なので、天候が変わりやすいアウトドア用として適しています。  ●ダハプリズム 屋根（＝ダハ／独語）型プリズム仕様により、鏡筒を直線状に設計することが可能に。スマートなフォルムが魅力です。   ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/vixen/ATREKII_HR10X25WP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1769",
    brand: "Vixen",
    sku: "Mobile PORTA A70LF",
    product_eng: "Vixen Mobile PORTA astronomical telescope",
    product_jpn: "Vixen ビクセン モバイルポルタ 天体望遠鏡",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥45,000",
    rrp_with_vat: "¥49,500",
    description_eng:
      "Entry-level 70mm aperture refractor optical tube set. For observing planets and the lunar surface!   ■Intuitive and comfortable operation Free-stop type The optical tube rotates on two axes horizontally and vertically by moving the optical tube, and stops quietly at the position when you release your hand. ■Dovetail type The optical tube is attached by a dovetail system, a world-standard dovetail system developed by Vixen. The optical tube can be easily exchanged with a separately sold optical tube* without the use of tools. Furthermore, it is possible to upgrade the mount and tripod without changing the optical tube. An optical tube weighing 3.5 kg or less can be mounted. ■Foldable and compact for easy storage ■Size and weight Length 860mm, OD 76mm, 2.5kg (main body 1.9kg) ■Finder 6x24mm, 5 degrees field of view ■Accessories Upright zenith prism, hexagonal wrench (4mm, 3mm), color star guidebook, star chart  *We do not accept order cancellations, changes, or returns of delivered products due to customer's reasons (e.g., different product from what was expected, wrong order, etc.). Please understand this beforehand before placing an order. *Only in the case of initial defects, we will exchange the product if you contact us within 7 days of arrival.",
    description_jpn:
      "エントリー向け口径70mmの屈折式鏡筒セット。惑星や月面の観測に！   ●直感的で快適な操作性 フリーストップ式 鏡筒を動かせば水平・垂直方向に2軸で回転し、手を離せばその位置で静かに止まるフリーストップ式。 ●アリミゾ式 鏡筒の取付け部はビクセンが生んだ世界標準のアリミゾ式（規格）。別売鏡筒※との交換も工具レスで簡単に行えます。さらに鏡筒をそのままに架台や三脚のグレードアップが可能です。※重さ3.5kg以下の鏡筒が装着できます。 ●折りたたみ式・コンパクト収納 ●サイズ・重さ 長さ860mm 外径76mm 2.5kg（本体1.9kg） ●ファインダー 6倍24mm 実視界5度 ●付属品 正立天頂プリズム、六角レンチ(4mm、3mm）、カラー星空ガイドブック、星座早見盤  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/vixen/61ZqTVJRl9S._AC_SL1500_.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1770",
    brand: "Vixen",
    sku: "PORTA 2R130SF",
    product_eng: "Vixen PORTA astronomical telescope",
    product_jpn: "Vixen ビクセン ポルタ 天体望遠鏡",
    category_1: "Home & Garden",
    category_2: "",
    rrp_ex_vat: "¥79,000",
    rrp_with_vat: "¥86,900",
    description_eng:
      "Wide and bright field of view, for observing faint objects such as nebulae and star clusters ■Free stop” system that holds the optical tube in place when you release your hand, making it easy to change the optical tube's direction. ■Equipped with a fine movement handle (vertical and azimuthal all-round fine movement) to search for and follow stars with fine movements. ■Dovetail system (standard), a world standard developed by Vixen, allows the optical tube to be replaced.  <The optical tube section> Objective lens (primary mirror) effective diameter ： 130mm / parabolic surface, multi-coated Focal length (aperture ratio F) ： 650mm (F5), wide field of view Resolution / Limiting magnitude ： 0.89 arcseconds, 12.3 magnitude Light gathering power ： 345 times that of the naked eye Size/Weight ： Length 575mm, Outer diameter 160mm, 5.3kg (Main body 4.0kg) Viewfinder ： 6x30mm, 7 degree field of view  <Other accessories> Accessories: Starry sky guidebook, star chart Solar Observation ： Not available Gross weight ： 11.0kg (excluding eyepiece)  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "広く明るい視界、星雲・星団など淡い天体の観測に ■手を離した位置で鏡筒がそのまま固定される「フリーストップ式」を採用、鏡筒の向きを大きく変える操作が簡単。 ■こまかい動きで星を探したり追ったりするための微動ハンドル（上下方位全周微動）を装備。 ■ビクセンが生んだ世界標準「アリミゾ式（規格）」を採用、鏡筒の載せかえが可能。 ■オプションパーツ（別売）併用で月面写真撮影もOK。 ■架台部と三脚の取付・取外しがハンドルネジ1本で可能。 【鏡筒部】 対物レンズ（主鏡）有効径 ： 130mm／放物面、マルチコート 焦点距離（口径比F） ： 650mm（F5）広視界 分解能・極限等級 ： 0.89秒・12.3等星 集光力 ： 肉眼の345倍 サイズ・重さ ： 長さ575mm 外径160mm 5.3kg（本体4.0kg） ファインダー ： 6倍30mm 実視界7度 【接眼部】 パーツ取付サイズ ： ネジ込み／42mmTリング用ネジ、差し込み／31.7mm 接眼レンズ(※)（31.7mm径） ： PL20mm（33倍、実視界89分）、PL6.3mm（103倍、実視界30分） ※倍率変換は、別売接眼レンズにより可能です。 【その他】 付属品 ： 星空ガイドブック、星座早見盤 太陽観察 ： 不可 総重量 ： 11.0kg（接眼レンズ別）  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/vixen/PORTA_2R130SF.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1771",
    brand: "Canon",
    sku: "PSV10BK(1)",
    product_eng: "Canon Vlog Camera PowerShot V10",
    product_jpn: "Canon キャノンVlogｶﾒﾗ PowerShot V10",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥54,500",
    rrp_with_vat: "¥59,950",
    description_eng:
      "●Compact vlog camera that is easy to handle even for first-time camera users.  ●High-performance and versatile video recording functions for personalized shooting Supports high-quality 4K/30P and Full HD/60P video recording.  ●Supports wireless live streaming and webcam for multiple uses with a single unit. By linking with “Camera Connect,” an application that can be used with smartphones and other devices, wireless live-streaming on “YouTube” and other sites and remote shooting from a smartphone can be performed in a simple flow.   <Specifications> Effective pixels during video recording: approx. 13.1 megapixels *Effective pixels during still image recording: approx. 15.2 megapixels Angle of view: 97.5° during movie recording, 100.2° during still image recording Aperture: F2.8-F8.0 Digital zoom: Off/1.5×/2.0×/3.0× Image stabilizer: Electronic Focus method: Contrast detection ND filter: 3 steps (ON/OFF/Auto) Imaging engine：DIGIC X Shooting distance：5cm~∞ LCD：2.0-inch, approx. 460,000 dots Size (W, H, D): approx. 63.4 x 90.0 x 34.3 mm Weight: 211g (including internal battery and memory card) Built-in stand: The camera can be positioned horizontally at an angle of ±30° (vertically) Built-in microphone: Noise canceling function Power supply: USB charging*Type-C 5V/1.5A or higher  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "●初めてカメラを使用するユーザーでも簡単に扱えるコンパクトなVlogカメラ 大きさ約63.4mm（幅）×34.3mm（奥行き）×90mm（高さ）のコンパクトボディーを実現しています。表示情報を最小限に抑えることで分かりやすく、シンプルなUI（ユーザーインターフェース）を採用し、初めてカメラを使用するユーザーでも簡単に本格的な動画撮影を楽しむことができます。さらに、手持ちでの撮影に加え、カメラアングルの調整ができる内蔵スタンドを搭載することで、様々な角度からの置き撮りが可能です。  ●自分好みの撮影を実現する高性能かつ多彩な動画撮影機能 高画質な4K／30P、フルHD／60P動画撮影に対応しています。  ●無線ライブ配信やウェブカメラに対応し1台でマルチに活用可能 スマホなどで使用可能なアプリケーション「Camera Connect」と連携することで、シンプルなフローで「YouTube」などでの無線ライブ配信や、スマホからのリモート撮影などを行うことが可能です。また、PCとUSBで接続することで高画質なウェブカメラとしても使用でき、1台でさまざまな用途に活用することが可能です。  【仕様】 動画撮影時有効画素数：約1310万画素※静止画撮影時の有効画素数は約1520万画素 センサーサイズ：1.0型高感度裏面照射CMOSセンサー 焦点距離(35mm判換算)：動画撮影時:約19mm相当、静止画撮影時:約18mm相当 画角：動画撮影時:97.5°、静止画撮影時:100.2° 絞り：F2.8-F8.0 デジタルズーム：切/1.5×/2.0×/3.0× 手ブレ補正機能：電子式 フォーカス方式：コントラスト検出方式 ISO感度(1/3段ステップ)：フルHD 125~6400、4K 125~3200 NDフィルター：3段(ON/OFF/オート) 映像エンジン：DIGIC X 撮影距離：5cm~∞ 液晶：2.0型 約46万ドット 大きさ(幅・高さ・奥行)：約63.4×90.0×34.3mm 質量：211g(内臓バッテリー、メモリーカードを含む) 内臓スタンド：水平±約30°(上下方向)の角度でカメラの設置が可能 内臓マイク：ノイズキャンセリング機能搭載 電源：USB充電※Type-C 5V/1.5A以上  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/canon/PSV10BK(1).jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1772",
    brand: "Instax360",
    sku: "INSTA360 CINSAAQ/B",
    product_eng: "Instax360 360° Action Camera",
    product_jpn: "Instax360 360度アクションカメラ",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥61,818",
    rrp_with_vat: "¥68,000",
    description_eng:
      "●A versatile tool that records the entire space of a place in a single shot. The Insta360 X3 is the ultimate pocket-sized camera with 360-degree shooting, action-ready hardware, and AI-driven software. ●The X3 captures crisp 5.7K 360-degree video so you won't miss a moment. With 360-degree video at your fingertips, the creative possibilities are endless. ●The X3's dual 1/2-inch 48-megapixel sensors deliver crisp, high-definition, high-quality images even in low-light conditions, such as in dark places. ●Reframing X3's dual 1/2” sensors capture the action in vivid 5.7K 360-degree video.  ●Capture 360-degree photos with the highest pixel count ever seen in a 360-degree action camera. ●Innovative new HDR mode delivers blur-free action videos. Even in harsh lighting conditions, Active HDR shows details in highlights and shadows that other action cameras cannot reproduce.  <Specifications> Aperture: F1.9 35mm film equivalent focal length: 6.7mm Photo Format：insp (exportable via mobile app or Studio) DNG RAW (PureShot, Studio required for editing) Video Format: - Single lens: mp4 - 360 degree: insv Weight: 180g Size：114.0 x 46.0 x 33.1 mm (W x H x D) Continuous recording time: 81 minutes Maximum video bit rate：120Mbps Gyroscope: 6-axis gyroscope Live streaming: 360-degree live, reframe live (the streamer determines the angle) Exposure value: ±4EV  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "●その場の空間を1ショットで、まるごと記録する万能ツール 「フレームで空間の一部を切り取る」のではなく、「撮影場所の空間をそのまま360度全方位を写真・映像に残す」アクションカメラです。360度撮影、アクションに耐えるハードウェア、AI駆動型ソフトウェアを備えたInsta360 X3は究極のポケットサイズのカメラです。  ●5.7K 360度撮影 X3は鮮明な5.7K 360度動画撮影でき、大切な瞬間を見逃しません。指先の操作で360度映像が撮影でき、クリエイティブな可能性が無限大です。  ●1/2インチ4800万画素センサー X3に搭載されるデュアル1/2インチ4800万画素センサーは、暗い場所などの、低照度下でも鮮明で高精細な高画質映像をもたらします。  ●リフレーミング X3のデュアル1/2インチセンサーは鮮やかな5.7K 360度映像でアクションを捉えます。簡単に操作できる、AI駆動のInsta360アプリのリフレームツールで、撮影後に好きなアングルを選択。360度撮影の無限の可能性を体験しよう。  ●7200万画素360度写真 360度アクションカメラ史上最高の画素数で、これまでにない高精細な360度写真を撮影しよう。  ●360度アクティブHDR 革新的な新しいHDRモードでブレのないアクション動画を実現。厳しい照明条件下でも、アクティブHDRは他のアクションカメラでは再現不可能なハイライト部分やシャドウ部分の細部までを映し出します。   【仕様】 絞り：F1.9 35mm判換算焦点距離：6.7mm 写真フォーマット：insp(モバイルアプリまたはStudioで書き出し可能)DNG RAW(PureShot、編集にはStudioが必要です) 動画フォーマット：●シングルレンズ:mp4●360度:insv 重量：180g サイズ：114.0×46.0×33.1mm(幅×高さ×奥行き) 連続録画時間：81分 最大動画ビットレート：120Mbps ジャイロスコープ：6軸ジャイロスコープ ライブ配信：360度ライブ、リフレームライブ(配信側がアングルを決めます) 露出値：±4EV  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/Instax360/INSTA360+CINSAAQB.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1773",
    brand: "GoPro",
    sku: "CHDHX121FW",
    product_eng: "GoPro HERO12 Action Camera black",
    product_jpn: "GoPro HERO12 アクションカメラ ブラック",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥57,091",
    rrp_with_vat: "¥62,800",
    description_eng:
      "●The new HERO12 Black delivers best-in-class 5.3K video and HDR (High Dynamic Range) for capturing the travel memories of a lifetime and the everyday moments of your life in even greater detail. ●Improved power management functionality doubles the continuous recording time (70 minutes) at 5.3K60. Durable, lightweight, and easy to mount for hands-free filming in all water and land environments. ● Advanced video stabilization ensures smooth footage at all times, even on rough terrain. When you are done recording, simply charge your GoPro. While it's charging, it automatically uploads the content you've captured to the cloud and sends it to your smartphone as a highlight video. Immerse yourself in the memories of your adventures and share your best moments.  Specifications Body size: Approx. 50.8 x 71.8 x 33.6 mm Body weight: Approx. 121g (excluding battery) Product Contents ：HERO12 Black camera, Enduro battery, adhesive base mount (curved), quick release buckle, thumb screw, USB-C cable  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "信じられないほどの高画質、さらに進化したHyperSmooth (ハイパースムーズ) ビデオブレ補正、大幅に向上したバッテリー駆動時間。そのすべてを実現するのが、GoPro史上最高の新しいHERO12 Blackです。  ●クラス最高レベルの5.3KビデオとHDR (ハイダイナミックレンジ) で、一生の思い出に残る旅や日常のとっておきの瞬間を更に細部まで記録可能。 ●電源管理機能の改良により、5.3K60での連続録画可能時間が2倍(70分) に。 耐久性に優れて軽量で、簡単にマウントしてハンズフリーで撮影できるため、水陸のあらゆるシーンで活躍します。 ●高度なビデオブレ補正を備えているため、悪路でも常にスムーズな映像を撮影できます。 録画が終わったら、GoProをチャージするだけ。 充電中、撮影したコンテンツをクラウドに自動アップロードし、ハイライトビデオとしてスマートフォンに送信。 冒険の思い出に浸り、最高の瞬間を共有できます。  【仕様】 本体サイズ：約50.8×71.8×33.6mm 本体重量 ：約121g（バッテリーを除く） 製品内容：HERO12 Black カメラ、Enduroバッテリー、粘着性ベースマウント（曲面）、クイックリリースバックル、サムスクリュー、USB-C ケーブル  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/gopro/CHDHX121FW.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1774",
    brand: "Levoit",
    sku: "LAPC302WJPR",
    product_eng: "Levoit Air cleaner for 20 tatami mats",
    product_jpn: "Levoit 空気清浄機 20畳用",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥13,200",
    rrp_with_vat: "¥14,520",
    description_eng:
      "●Powerful and quick cleaning! Can be used for 20 tatami mats. The patented VortexAir3.0 technology and 11 centrifugal fans increase the suction power and can purify 8 tatami mats in only 13 minutes when the air volume is maximized.   ●Five-layer filtration and two-layer sterilization relieve you from air quality worries! The integrated high-performance filter emphasizes removal of pollen, viruses, bacteria, dust, mold, allergens, PM2.5, cigarettes, pet odors, and hair loss. 0.1μm particles removal rate is up to 99.97%, and the sterilization rate climbs to another 99.99%. This helps to prevent pollen and allergens, relieving symptoms such as sneezing, runny nose, and itchy nose for a safer and more comfortable life.  ●Quiet, energy-saving, and can be left on all the time!  ●The timer and child lock function enhance the convenience of your daily life.  ●Small size and space-saving simple style the design blends in with both Japanese and Western styles. 360° absorbing design for interior decoration  <Specifications> Applicable area: 20 tatami mats (33 m2) Cleaning time: 8 tatami/13 minutes (CADR value: 260m3/h) Operating noise: 24dB~46dB Operation mode: sleep, low, medium, high Timer (h): 2-4-6-8 Power consumption: 14W~39W Body size (WDH): 22 x 22 x 36 cm Body weight: 3.5 kg Power cord length (m): 1.83  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "●強力ですばやく清浄に! 20畳対応可 特許のVortexAir3.0技術と11個の遠心ファンにより、吸引力がアップされ、風量を最大にすれば8畳をわずか13分で浄化できます。空気清浄能力は20畳まで対応しているため、6畳の寝室・ベビー室・一人暮らしなどの小スペースは勿論、オフィスやリビングのような広い空間でもご利用頂けます。  ●5層ろ過・2層除菌で、空気の悩みから解放! 花粉・ウイルス・菌・ホコリ・カビ・アレルゲン・PM2.5・たばこ・ペット臭・抜け毛除去を重視した、一体型高性能フィルターを採用しています。0.1μmの微粒子の除去率は99.97%まで、除菌率はさらに99.99%に登ります。花粉対策・アレルゲン対策に役立ち、くしゃみ、鼻水、鼻のかゆみなどの症状を緩和し、より安心で快適な毎日を過ごしていただけます。  ●静かで省エネ、つけっぱなしでも大丈夫! 静音の上におやすみモードの電気代は1時間たったの0.25円ですので、つけっぱなしにしても気になりません。  ●タイマーとチャイルドロック機能で、生活の利便性をアップ  ●小型で省スペースのシンプルスタイル iFデザインワード2020とレッドドット・デザインアワード2019を受賞したデザインで、和風にも洋風にもなじみます。インテリアとしては360°吸収の設計  【仕様】 適用面積：20畳(33㎡) 清浄時間：8畳/13分(CADR値:260m3/ｈ) 運転音：24dB~46dB 運転モード：おやすみ、低、中、高 タイマー(ｈ)：２－４－６－８ 消費電力：14W～39W 本体サイズ（WDH）：22 x 22 x 36 cm 本体重量：3.5kg 電源コードの長さ(m)：1.83  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/levoit/LAPC302WJPR.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1775",
    brand: "Levoit",
    sku: "LAPC401SWJP",
    product_eng: "Levoit Air cleaner for 32 tatami mats",
    product_jpn: "Levoit 空気清浄機 32畳用",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥23,864",
    rrp_with_vat: "¥26,250",
    description_eng:
      "●Visualizes air quality and automatically optimizes operation! Equipped with a high-precision laser sensor, the air conditioner detects air pollution in real time, and you can visually see how the air is becoming cleaner.  ●Compatible with smartphones and smart speakers for more convenience With the free dedicated VeSync app, you can easily turn the unit on and off, switch modes, and set timers and schedules without moving from the spot. It is also compatible with popular smart speakers such as Amazon alexa and google assistant. ●Compatible with 32 tatami mats,  The patented VortexAir3.0 technology and 360-degree omni-directional absorption design realize a high purification speed (CADR value: 442m3/h), purifying an 8-mat room in only 9 minutes. ●Double purification by fan type and ion type, sterilization rate of 99.99% or higher Plasma Pro” released into the air reaches the entire room and not only neutralizes airborne dirt but also cleans odors and bacteria adhering to walls and clothes.  ●Ultra-quiet and energy-saving at 24dB or less.  <Specifications> Applicable area: 32 tatami mats (53 m2) Cleaning time: 8 tatami/9 min (CADR value: 7.37 m3/min) Operating noise: 24dB~49dB Operation modes: sleep, low, medium, high, turbo, auto mode, pollen mode Timer (h): 2-4-6-8 Power consumption: Low 3W~24W Body size (WDH): 27.4 x 27.4 x 52 cm Body weight: 5 kg Power cord length (m): 1.83  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "●空気質を見える化・自動で運転を最適化！ 高精度レーザーセンサーを搭載しているので、空気の汚れをリアルタイム検知し、空気がキレイになっていく様子も目で見てわかります。また、自動モードの場合では、汚れの度合いに応じて風量を自動的に調整し、効率的に空気をキレイにします。  ●スマホとスマートスピーカー対応・もっと便利に 無料の専用アプリVeSyncで、電源オン/オフやモードの切り替え、タイマーやスケジュールの設定などがその場から動かずに簡単に操作できます。また、Amazon alexa、googleアシスタントなどの話題のスマートスピーカーにも対応しております。  ●32畳対応可能・素早く清浄できるタイプ 特許のVortexAir3.0技術と360度全方位吸収の設計により、高い浄化スピード(CADR値:442m3/h)を実現し、8畳の部屋をわずか9分で浄化します。  ●ファン式とイオン式のダブル浄化・99.99%以上の除菌率 空気中に放出した「プラズマプロ」はお部屋全体に行き届き、空気中に浮遊している汚れを無力化させるのみならず、壁や衣類に付着したニオイや菌もきれいにします。消臭専用のARC式活性炭フィルターにより、たばこや汗臭、ペット臭、部屋干し衣類の生乾き臭など、気になるニオイもすばやく分解します。  ●24dB以下超静音・省エネ性も高い  【仕様】 適用面積：32畳（53㎡） 清浄時間：8畳/9分(CADR値:7.37m3/分) 運転音：24dB~49dB 運転モード：おやすみ、低、中、高、ターボ、自動モード、花粉モード タイマー(ｈ)：２－４－６－８ 消費電力：弱3W～24W 本体サイズ（WDH）：27.4 x 27.4 x 52 cm 本体重量：5kg 電源コードの長さ(m)：1.83  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/levoit/LAPC401SWJP.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1776",
    brand: "COSORI",
    sku: "COLI38SAFGY",
    product_eng: "COSORI Smart Non-Fryer 3.8L",
    product_jpn: "COSORI ｽﾏｰﾄﾉﾝﾌﾗｲﾔｰ 3.8L",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥16,000",
    rrp_with_vat: "¥17,600",
    description_eng:
      "●Six functions in one unit! Grill, toaster, oven, microwave, electric fryer, frying pan  ●Great for a wide range of uses, from single person to family! The 3.8-liter large cooking basket and maximum temperature of 230°C can be stored in a compact body, even on a narrow counter or kitchen shelf.  ●Smartphone App Linkage Settings can be changed, operated, and monitored via smartphone (temperature and cooking time settings and time management are also possible) Recipes developed by professional chefs (more than 120 original recipes to be added as needed)  ●Easy to clean Dishwasher-safe and easy to clean (removable basket and plate are dishwasher-safe as they are) Non-stick coating (non-stick with our proprietary CrispFitTM technology)  ●Grilling skewer and rack included  <Specifications> Volume: 3.8 liters (for 1 to 4 persons) Dimensions: W 32.5 x D 27.5 x H 34.5 cm Weight: 4.4 kg Power source: AC 100V, 50/60Hz Power cord length: 1.5 m Rated power: 1230w Temperature setting range: 75°C to 230°C Time setting range: 1 to 60 min.  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "●1台6役！ 『グリル』『トースター』『オーブン』『電子レンジ』『電気フライヤー』『フライパン』  ●一人暮らしからファミリーまで幅広く大活躍！ 3.8リットルの大容量調理バスケットと最高温230℃をコンパクトなボディに収め、狭いカウンターやキッチン棚にも格納可能です  ●スマホアプリ連携 スマホで設定変更・操作・モニター（温度・調理時間の設定や時間管理も可能）プロのシェフが開発したレシピ（120以上のオリジナルレシピが随時追加予定）  ●簡単お手入れ 食洗機対応でかんたん（取り外せるバスケットとプレートをそのまま食洗機OK）焦げ付きにくい加工（独自開発のCrispFitTMテクノロジーで焦げ付きにくい）  ●焼き串＆ラック付属  【仕様】 容積：3.8リットル（1～4人分） 寸法：幅32.5 × 奥行27.5 × 高さ34.5 cm 重量：4.4㎏ 電源：AC 100V, 50/60Hz 電源コード長さ：1.5m 定格電力：1230ｗ 温度設定範囲：75℃～230℃ 時間設定範囲：1～60分  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/cosori/COLI38SAFGY.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1777",
    brand: "LEGO",
    sku: "10698(LEG)",
    product_eng: "LEGO JAPAN Yellow Idea Box",
    product_jpn: "LEGO ﾚｺﾞｼﾞｬﾊﾟﾝ 黄色のアイディアボックス",
    category_1: "Gift",
    category_2: "",
    rrp_ex_vat: "¥6,618",
    rrp_with_vat: "¥7,280",
    description_eng:
      "Build your own imaginary world with 33 basic LEGO(R) bricks in 33 colors!  Includes 8 different windows and doors, 2 green base plates, 6 tires and wheel rims.  Box size 37 x 18 x 26.2 cm; 1.59 kg  LEGO and the LEGO logo are trademarks of the LEGO Group.(C)2015 The LEGO Group. ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "33色の基本的なレゴ(R) ブロックで想像の世界を組み立てよう!  8種類の窓とドア、2つのグリーンベースプレート、6本のタイヤとホイールリムが含まれています。  ボックスサイズ 37 x 18 x 26.2 cm; 1.59 kg  LEGO and the LEGO logo are trademarks of the LEGO Group. (C)2015 The LEGO Group.  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/lego/10698(LEG).jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1778",
    brand: "LEGO",
    sku: "10914D(LEG)",
    product_eng: "LEGO Duplo Container Super Deluxe",
    product_jpn: "LEGO ﾚｺﾞｼﾞｬﾊﾟﾝ デュプロのコンテナ スーパーデラックス",
    category_1: "Gift",
    category_2: "",
    rrp_ex_vat: "¥6,618",
    rrp_with_vat: "¥7,280",
    description_eng:
      "Your child's mind will be thrilled by the LEGO DUPLO blocks and pieces, which are easy for even young children to handle. The creative possibilities for playing with their hands are endless. The set includes dolls, dogs, cars, roofs, windows, flowers, flags, slides, and blocks printed with numbers 1-5. This set makes it easy for children to play with blocks using their fingers and imagination. This set can be enjoyed as your child grows.  Box size 18 x 37 x 26.2 cm; 1.38 kg   ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "幼児でも扱いやすいレゴデュプロのブロックやピースにお子さまの心がわくわくします。手を使って遊ぶ創造の可能性は無限大。お人形や犬、車、屋根、窓、花、旗、滑り台、1～5の数字がプリントされたブロックなどが入っています。 指先を使い、想像力を働かせて遊ぶブロック遊びが手軽にできるセットです。 お子さまの成長に合わせてお楽しみいただけます。  ボックスサイズ 18 x 37 x 26.2 cm; 1.38 kg   ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/lego/10914D(LEG).jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1779",
    brand: "LEGO",
    sku: "60316(LEG)",
    product_eng: "LEGO Police Station",
    product_jpn: "LEGO ﾚｺﾞｼﾞｬﾊﾟﾝ ポリスステーション",
    category_1: "Gift",
    category_2: "",
    rrp_ex_vat: "¥7,982",
    rrp_with_vat: "¥8,780",
    description_eng:
      "LEGO City: Animated Series Playset. This set includes a three-story police station, a police car, a helicopter, an assembled model of a garbage truck, a police dog figure, and five minifigs. (Piece count: 668) Ages: 6 years old and up  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "レゴシティ アニメシリーズのプレイセット 3階建てのポリスステーション、パトカー、ヘリコプター、ゴミ収集車の組み立てモデル、警察犬のフィギュア1体、ミニフィグ5体が入ったセットです。（ピース数：668） 対象年齢:6才以上  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/lego/60316(LEG).jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1780",
    brand: "HP",
    sku: "HPMP250",
    product_eng: "HP Mobile Projector",
    product_jpn: "HP モバイルプロジェクター",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥48,109",
    rrp_with_vat: "¥52,920",
    description_eng:
      "●Projects the equivalent of 80 inches in power savings Capable of projecting 80-inch size from a distance of only 2.1m, with 250 LED lumens / 120 ANSI lumens resolution and energy-saving design with power consumption of 45W. ●Ultra compact and lightweight It can also be used outdoors or in places where there is no power supply by connecting to a mobile battery. ●Autofocus support Instantly and automatically adjusts the focus of the image.  ●Intuitive App Menu The App Center, screen mirroring, media player, screen projection, Bluetooth speaker, and Setup/Info menu buttons can be intuitively operated with the remote control for easy operation. ●Built-in Speakers Built-in 3W x2 speakers can be used as Bluetooth speakers and also support wireless audio output via Bluetooth.  <Specifications> Product size: Diameter 80 x 140mm Product weight: 587g Display: DLP/LED light source Light source life: Approx. 25,000 hours Brightness: 250 LED lumens / 120 ANSI lumens Interface: 1x HDMI, 1x USB Network and Wireless Function: WiFi 4 (802.11n), Bluetooth 4.0 Power input: 100-240V 2.31A 50~60Hz / 19.5V 2.31A Power consumption: 45W Trapezoidal distortion correction function: 4-point correction Audio: 2x 3W speakers, Bluetooth Screen Mirroring: Projection of iOS and Android devices on the same WiFi network (Eshare App is required on the device side) Accessories: Quick Start Guide, AC adapter and cable, remote control  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "●省電力で80インチ相当の投影が可能 わずか2.1mの距離から80インチサイズの投影が可能、250LEDルーメン / 120 ANSIルーメン解像度で消費電力が45Wと省エネ設計となっています。 ●超小型・軽量 直径80ｍｍ・高さ14cmの超小型と587gの軽量本体hはどこでも簡単に持ち運べるサイズ・重量です。モバイルバッテリー接続で電源のない場所や屋外でも使用可能です。 ●オートフォーカス対応 瞬時に画像のフォーカスを自動調整。レンズと投影面間の距離と角度を測定し、4点2軸台形補正でピント調整を自動で行います。隅から隅まで歪みのない鮮明な映像をお楽しみいただけます。 ●直観操作が可能なAppメニュー App Center、画面ミラーリング、メディアプレーヤー、スクリーン投影、Bluetoothスピーカー、セットアップ・Infoメニューボタンをリモコンで直観的に操作が可能、簡単操作でお使いいただけます。 ●スピーカー内蔵 3W x2のスピーカーを内蔵、Bluetoothスピーカーとしても使用できるほか、Bluetoothでのワイヤレス音声出力にも対応しています。  【仕様】 製品サイズ：直径80 x 140mm 製品重量：587g ディスプレイ：DLP・LED光源 光源寿命：約25000時間 明るさ：250 LEDルーメン / 120 ANSIルーメン インターフェース：1x HDMI、1x USB ネットワーク・ワイヤレス機能：WiFi 4(802.11n)、Bluetooth 4.0 電源入力：100-240V 2.31A 50~60Hz / 19.5V 2.31A 消費電力：45W 台形ゆがみ補正機能：4点補正 オーディオ：2x 3Wスピーカー、Bluetooth スクリーンミラーリング：同WiFiネットワーク上のiOS・Androidデバイスの投影 (Eshare Appがデバイス側に必要です) 付属品：クイックスタートガイド、ACアダプタ・ケーブル、リモコン  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1: "https://products.naganorewards.com/images/hp/HPMP250.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1781",
    brand: "FOODCYCLER",
    sku: "FC1001",
    product_eng: "FOODCYCLER Garbage Disposal Machines",
    product_jpn: "FOODCYCLER フードサイクラー生ごみ処理機",
    category_1: "Electronics",
    category_2: "",
    rrp_ex_vat: "¥70,909",
    rrp_with_vat: "¥78,000",
    description_eng:
      "The Food Cycler reduces food waste by up to 90% in just 3 hours and converts it into a mature fertilizer ideal for gardening. It is very easy to use! Simply place your daily food scraps into the bucket and flip the switch. No additional pellets, enzymes, or additives are required. The special bucket is easy to remove and can be washed in a dishwasher.  The food cycler is lightweight and odorless. Its compact design allows it to be used anywhere, and it also eliminates odors and bacteria from food scraps. Even when disposed of as burnable garbage, it does not attract rats, crows, and other insects because there is no odor. Basic food scraps and kitchen waste can be disposed of as is. High performance that can dispose of chicken bones as they are is a feature of the food cycler.   Reduction of food waste odors (methane gas) helps reduce greenhouse gases that cause global warming. Start your ecological activities easily with a food cycler that will make your garden and the earth more beautiful!  FoodCycler is a Canadian brand.  Main body (W x D x H): 280 x 320 x 360 mm Weight: 1000g  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "フードサイクラーは、わずか3時間で生ごみの量を最大90％削減し、ガーデニングに理想的な成熟した肥料に変換します。使い方はとても簡単！毎日の生ごみをただバケツの中に入れてスイッチを押すだけ。追加で投入するペレット、酵素、添加物は必要ありません。専用バケツは取り外しが簡単で、食洗器で洗えます。  フードサイクラーは軽量で無臭。コンパクトなデザインなので使う場所を選ばないほか、生ごみの悪臭・雑菌をなくします。 燃えるゴミとして処分した場合でも、ニオイがないのでネズミ・カラスなどを寄せ付けません。 基本的な食べ残しや生ごみはそのまま処理をすることが可能です。 鶏の骨をそのまま処理できる高性能なのがフードサイクラーの特長です。   食品廃棄物の悪臭（メタンガス）削減は、地球温暖化の原因である温室ガスの削減に役立ちます。 素敵なお庭と地球をより美しくするフードサイクラーで、気軽にエコロジー活動を始めましょう！  FoodCyclerはカナダのブランドです。  本体(W×D×H)：280×320×360mm 重量：10000g  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/foodcycler/FC1001.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1782",
    brand: "Panasonic",
    sku: "MJ-L600-H",
    product_eng: "Panasonic low-speed juicer",
    product_jpn: "Panasonic ﾊﾟﾅｿﾆｯｸ 低速ｼﾞｭｰｻｰ",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥27,900",
    rrp_with_vat: "¥30,690",
    description_eng:
      "●The screw is rotated slowly and carefully to compress and grind the ingredients to produce nutrient-rich cold-pressed juice.  ●Rough filter” for rich, thick juice The filter allows soft fruit pulp to pass through easily and prevents seeds from getting in, making it possible to produce thick, pulpy juice.  ●Dispersed compression structure” squeezes out even the hardest ingredients to the last. The dispersed compression structure has a wide food compression area and a narrow path for squeezed lees, allowing even tough foodstuffs such as carrots to be squeezed through to the end. When using the Sarasara Filter  Accessories: Sarasara Filter, Frozen Attachment, Juice Cup, Squeezed Lees Cup, Brush, Recipe Book Dimensions: 43.2cm*18.5cm*17.6cm (4kg) Height*Width*Depth (mass)  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "低速回転で、栄養豊富なコールドプレスジュースを作る「低速圧縮絞り方式」 スクリューをゆっくりていねいに回転させて、食材を圧縮しながらすりつぶすことで、栄養豊富なコールドプレスジュースが作れます。  濃厚なとろみのあるジュースを堪能できる「あらごしフィルター」 やわらかい果物の果肉が通りやすく、また種が入りにくいフィルターで、果肉感のあるとろりとしたあらごしジュースが作れます。  かたい食材も最後まで絞りきる「分散型圧縮構造」 食材圧縮部が広い、絞りかすの通り道が狭い分散型圧縮構造で、にんじんなどのかたい食材でも最後まで絞りきることができます。 さらさらフィルター使用時  付属品：あらごしフィルター、フローズンアタッチメント、ジュースカップ、 絞りかすカップ、ブラシ、 レシピブック 本体寸法：43.2cm＊18.5cm＊17.6cm（4kg） 高さ＊幅＊奥行き（質量）  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/panasonic/MJ-L600-H.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1783",
    brand: "Braun",
    sku: "IOG31A60IB",
    product_eng: "Braun Oral B Electric toothbrushes iO3",
    product_jpn: "Braun ﾌﾞﾗｳﾝ ｵｰﾗﾙB 電動歯ﾌﾞﾗｼ iO3",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥10,717",
    rrp_with_vat: "¥11,789",
    description_eng:
      "●Recommended by dentists around the world (*1) 99.7% more plaque removal power (*2) Reduces plaque buildup. Oral-B's unique round rotating brush brushes gently while micro-vibrating. For healthier teeth and gums. *1. According to P&G research. Based on an ongoing sample survey of dentists worldwide. 2. Based on comparison with manual toothbrush.  ●ON/OFF button & charge indicator The ON/OFF button notifies you when you need to recharge the battery. So you can brush comfortably without running out of charge while brushing your teeth.  ●Brushing mode switching & brush head replacement reminder Brushing mode can be switched at the touch of a button. The brush head replacement reminder indicates when it is time to replace the brush head with a yellow light to ensure that you always get the best brushing results.  ●Guides you to the right brush pressure Smart anti-push sensor guides brush pressure by color. It tells you if you are brushing too hard, too soft, or with the right amount of pressure, just like a signal.  ●3 smart modes All 3 modes (clean/soft clean/whitening) are equipped!  ●Includes 1 replacement brush (1 Ultimate Clean) and charger. ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "●世界の歯科医師推奨(※1)歯垢除去力99.7%UP(※2)歯垢の蓄積を抑える オーラルB独自の丸型回転ブラシがマイクロバイブレーションしながら優しくブラッシング。より健康的な歯と歯ぐきへ。 ※1.P&G調べ。世界の歯科医師を対象にした継続的サンプル調査に基づく。 ※2.手磨きブラシとの比較による  ●ON/OFFボタン&充電表示 充電が必要になると、ON/OFFボタンでお知らせ。だから、歯磨き中に充電が切れることなく快適にブラッシング。  ●ブラッシングモード切り替え& ブラシヘッド交換リマインダー ボタン一つで、ブラッシングモードを切り替え。さらに、いつでも最高の磨き上りを保つために、ブラシヘッド交換リマインダーが交換時期を黄色のライトでお知らせ。  ●適切なブラシ圧をガイド スマート押し付け防止センサーが、ブラシ圧を色でガイド 強すぎ、弱すぎ、そして適切な力加減を、信号のように教えてくれます。  ●3 スマートモード搭載 全3モード(クリーン/やわらかクリーン/ホワイトニング)搭載!  ●替えブラシ1本(アルティメイトクリーン1本)、充電器付き  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/braun/IOG31A60IB.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1784",
    brand: "Tiger",
    sku: "PCKA081(KM)",
    product_eng: "Tiger Steamless electric kettle 0.8L Black",
    product_jpn: "Tiger ﾀｲｶﾞｰ 蒸気ﾚｽ電気ｹﾄﾙ0.8L ﾌﾞﾗｯｸ",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥8,791",
    rrp_with_vat: "¥9,670",
    description_eng:
      "●Steamless” structure that keeps steam out Steam catcher structure is installed inside the lid. A new structure that instantly detects boiling has been developed to quickly detect steam at the time of boiling and reduce the amount of steam to a small amount, thereby preventing the generation of unnecessary amounts of steam.   ●Tipping over hot water leakage prevention structure” for peace of mind even in the unlikely event of a tipping over  ●Double-layered structure” that prevents the body from getting hot and keeps the water warm.  ●Automatic power off” when water boils over  ●Automatic “dry-boiling prevention” function detects empty water and automatically turns off the water heater.  ●Hot water lock button Prevents hot water from leaking from the spout in the event of a fall. When pouring, the button can be easily operated with one hand.  ●Fastest boiling speed in the industry Equipped with a printed heater, a cup of water (140 mL) boils in only about 45 seconds from the time the switch is turned on to the time the water automatically stops boiling.  <Specifications> Size (approx.) (cm) W x D x H: 15.9 x 25.0 x 22.0 Body weight (approx.): 1.1 kg Capacity: 0.8L Power consumption when heating water: 1300W Boiling time for 1 cup (140ml) (approx.): 45 seconds Boiling time when full of water (approx.): 4 minutes  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "●蒸気を外に出さない「蒸気レス」構造 ふた内部に蒸気キャッチャー構造を搭載しました。沸とうを瞬時に検知する新構造を開発し、沸とう時の蒸気をすばやく感知して、わずかな蒸気量に抑えて、無駄な量の蒸気を発生させません。そして、湯わかし時に発生した蒸気は蒸気取込口から入り、ふた内部に内蔵されている蒸気キャッチャーに受け止められ、蒸気キャッチャー内の冷却通路を通って冷却されます。蒸気孔から出る高温の蒸気にふれてやけどをするおそれがなく、安心してご使用頂けます。  ●万一倒れても安心「転倒お湯もれ防止構造」 万一傾いた場合でも、お湯もれを最小限に抑えます。  ●本体が熱くならず 保温効果も高い「本体二重構造」 二重構造で、本体が熱くなりにくく、沸かしたお湯も冷めにくい安全設計です。  ●沸とうすれば「通電自動オフ」 沸とうすればスイッチが自動的にオフして電源が切れます。  ●カラだきを検知して自動オフ「カラだき防止」機能 お湯がない状態でのカラだきを防ぎます。  ●給湯ロックボタン 万一倒れても注ぎ口からのお湯もれを防ぎます。注ぐときはボタンを押して片手でらくらく操作が可能です。  ●業界最速スピード沸とうを実現 プリントヒーター搭載し、スイッチを入れてから自動で沸とうがとまるまで、カップ1杯分（140mL）がたったの約45 秒のスピード沸とうします。  ●ドリップしやすいなめらかな注ぎが可能に 細くてきれいにでる水流で注ぎやすい設計です。  ●沸とう時間目盛り付 目安の沸とう時間がわかる水目盛りつき。  ●スマートハンドル 持ちやすく、注ぎやすいオープンハンドル。  【仕様】 サイズ(約)(cm) 幅×奥行×高さ：15.9×25.0×22.0 本体質量（約)：1.1kg 容量：0.8L 湯わかし時の消費電力：1300W カップ1杯（140ml）沸とう時間（約）：45秒 満水時沸とう時間（約）：4分  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/tiger/PCKA081(KM).jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1785",
    brand: "Tanita",
    sku: "BC771(WH)",
    product_eng: "Tanita Body Composition Scale White",
    product_jpn: "Tanitaﾀﾆﾀ 体組成計 ﾎﾜｲﾄ",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥7,000",
    rrp_with_vat: "¥7,700",
    description_eng:
      "Leg point” is a score to determine if you have enough leg muscle mass to support your body weight. Why don't you check your “leg points” and start building legs that can support your future? ●With “leg points” that show the muscle mass of each part of the body Check the muscle mass of your legs, which are easily affected by aging, and take early countermeasures against leg weakness. ● With “Ride Pita” that can be stored on a stand. ●Large, easy-to-read LCD display  <Specifications> Main unit (W x D x H): 280 x 280 x 27 mm Weight: 1.6kg  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "体重を支えるだけの脚の筋肉量があるかを「脚点」として点数化。あなたも「脚点」をチェックして、未来を支える脚づくりをはじめませんか？ ●部位筋肉量がわかる脚点付 加齢の影響を受けやすい脚の筋肉量をチェックして、脚力低下に早めの対策を。 ●立掛け収納可能な乗るピタ付 ●大きく見やすいLCD表示  【仕様】 本体(W×D×H)：280×280×27mm 重量：1.6kg  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/tanita/BC771(WH).jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/tanita.png",
    "": "",
  },
  {
    id: "1786",
    brand: "SHARP",
    sku: "EC-AR10",
    product_eng: "SHARP Lactive Air Cordless Stick Vacuum Cleaner",
    product_jpn: "SHARP コードレススティック掃除機 ラクティブエア ブラック系",
    category_1: "Home & Garden",
    category_2: "Home Appliances",
    rrp_ex_vat: "¥59,945",
    rrp_with_vat: "¥65,940",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/sharp/EC-AR10.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/sharp.png",
    "": "",
  },
  {
    id: "1787",
    brand: "SHARP",
    sku: "KNHW16H-W",
    product_eng: "SHARP Automatic cooking pot Hot Cook 1.6L White",
    product_jpn: "SHARP 自動調理鍋 ホットクック 1.6L ホワイト",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥54,495",
    rrp_with_vat: "¥59,945",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/sharp/KNHW16H-W.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/sharp.png",
    "": "",
  },
  {
    id: "1788",
    brand: "SHARP",
    sku: "KNHW16H-B",
    product_eng: "SHARP Automatic cooking pot Hot Cook 1.6L Black",
    product_jpn: "SHARP 自動調理鍋 ホットクック 1.6L ブラック",
    category_1: "Home & Garden",
    category_2: "Kitchen Appliances",
    rrp_ex_vat: "¥54,495",
    rrp_with_vat: "¥59,945",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/sharp/KNHW16H-B.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/sharp.png",
    "": "",
  },
  {
    id: "1789",
    brand: "Beats",
    sku: "MUW23PA/A",
    product_eng: "Beats Solo4 On-ear wireless headphones Matte Black",
    product_jpn:
      "Beats Solo4 オンイヤーワイヤレスヘッドフォン - マットブラック",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥29,818",
    rrp_with_vat: "¥32,800",
    description_eng:
      "Headphones for active people who love music, re-released with further evolution. Powerful sound that moves your body unintentionally.  ■A new standard. Headphones for active people who love music. ■Drivers that have evolved for the best sound. Acoustics with the ultimate balance. Improved frequency response. Uniquely designed 40mm transducers minimize noise, latency and distortion to deliver clear, expansive sound. ■The feeling of being surrounded by 64 speakers at the same time. Personalized spatial audio and dynamic head tracking utilize the built-in gyroscope and accelerometer. ■Powerful sound. Lightweight design. Ergonomic design for comfort. At only 217 grams, you'll forget you're wearing them. ■Softer than you think. UltraPlush ear cushions provide lightweight softness and durability for all-day wear. ■Best comfort and sound. Delicately balanced headband with flexible fit and size-adjustable slider. Beats Solo 4's comfortable, stable fit delivers optimized sound to your ears. ■Up to 50 hours of playback time. ■For both Apple and Android. ■Dimensions Height: 6.8 cm / Length: 17.7 cm / Width: 15.8 cm / Weight: 217 g ■Includes Beats Solo4 headphones / Carrying case / USB-C charging and audio cable / 3.5mm analog audio cable Quick start guide  Warranty Period : 1 year *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "音楽を愛するアクティブな人のためのヘッドフォン、さらなる進化を遂げて再登場。思わず体が動くパワフルなサウンド。  ■定番が、新しく。 音楽を愛するアクティブな人のためのヘッドフォン、さらなる進化を遂げて再登場。 ■最高のサウンドのために 進化を遂げたドライバ。 バランスを極めたアコースティック。改良された周波数レスポンス。独自に設計された40mmトランスデュー サーがノイズやレイテンシー、歪みを最小化し、クリアで広がりのある音を届けます。 ■同時に64台のスピーカーに囲まれているような感覚。 パーソナライズされた空間オーディオとダイナミックヘッドトラッキングは内蔵ジャイロスコープと加速度センサーを利用。 ■パワフルサウンド。軽量設計。 快適さを目指した人間工学に基づくデザイン。わずか217グラム、着けていることを忘れるほどの軽さです。 ■想像以上の柔らかさ。 UltraPlushイヤークッションにより、一日中装着しても軽くソフトな着け心地と耐久性を実現しました。 ■最高の着け心地とサウンド。 繊細なバランスで柔軟にフィットするヘッドバンドとサイズ調整が可能なスライダー。人間工学に基づく角度のイヤーカップ。Beats Solo 4の快適で安定した着け心地が、あなたの耳に最適化されたサウンドを届けます。 ■最大50時間の再生時間。 ■AppleとAndroid、どちらでも。 ■サイズ 高さ：6.8 cm/長さ：17.7 cm/幅：15.8 cm/重量：217 g ■同梱物 Beats Solo4 ヘッドフォン/キャリングケース/USB-C 充電・オーディオケーブル/3.5mmアナログオーディオケーブルクイックスタートガイド 保証期間 1年 ※Beats製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/beats/MUW23PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
    "": "",
  },
  {
    id: "1790",
    brand: "Beats",
    sku: "MUW33PA/A",
    product_eng: "Beats Solo4 On-ear wireless headphones Cloud Pink",
    product_jpn:
      "Beats Solo4 オンイヤーワイヤレスヘッドフォン - クラウドピンク",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥29,818",
    rrp_with_vat: "¥32,800",
    description_eng:
      "Headphones for active people who love music, re-released with further evolution. Powerful sound that moves your body unintentionally.  ■A new standard. Headphones for active people who love music. ■Drivers that have evolved for the best sound. Acoustics with the ultimate balance. Improved frequency response. Uniquely designed 40mm transducers minimize noise, latency and distortion to deliver clear, expansive sound. ■The feeling of being surrounded by 64 speakers at the same time. Personalized spatial audio and dynamic head tracking utilize the built-in gyroscope and accelerometer. ■Powerful sound. Lightweight design. Ergonomic design for comfort. At only 217 grams, you'll forget you're wearing them. ■Softer than you think. UltraPlush ear cushions provide lightweight softness and durability for all-day wear. ■Best comfort and sound. Delicately balanced headband with flexible fit and size-adjustable slider. Beats Solo 4's comfortable, stable fit delivers optimized sound to your ears. ■Up to 50 hours of playback time. ■For both Apple and Android. ■Dimensions Height: 6.8 cm / Length: 17.7 cm / Width: 15.8 cm / Weight: 217 g ■Includes Beats Solo4 headphones / Carrying case / USB-C charging and audio cable / 3.5mm analog audio cable Quick start guide  Warranty Period : 1 year *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "音楽を愛するアクティブな人のためのヘッドフォン、さらなる進化を遂げて再登場。思わず体が動くパワフルなサウンド。  ■定番が、新しく。 音楽を愛するアクティブな人のためのヘッドフォン、さらなる進化を遂げて再登場。 ■最高のサウンドのために 進化を遂げたドライバ。 バランスを極めたアコースティック。改良された周波数レスポンス。独自に設計された40mmトランスデュー サーがノイズやレイテンシー、歪みを最小化し、クリアで広がりのある音を届けます。 ■同時に64台のスピーカーに囲まれているような感覚。 パーソナライズされた空間オーディオとダイナミックヘッドトラッキングは内蔵ジャイロスコープと加速度センサーを利用。 ■パワフルサウンド。軽量設計。 快適さを目指した人間工学に基づくデザイン。わずか217グラム、着けていることを忘れるほどの軽さです。 ■想像以上の柔らかさ。 UltraPlushイヤークッションにより、一日中装着しても軽くソフトな着け心地と耐久性を実現しました。 ■最高の着け心地とサウンド。 繊細なバランスで柔軟にフィットするヘッドバンドとサイズ調整が可能なスライダー。人間工学に基づく角度のイヤーカップ。Beats Solo 4の快適で安定した着け心地が、あなたの耳に最適化されたサウンドを届けます。 ■最大50時間の再生時間。 ■AppleとAndroid、どちらでも。 ■サイズ 高さ：6.8 cm/長さ：17.7 cm/幅：15.8 cm/重量：217 g ■同梱物 Beats Solo4 ヘッドフォン/キャリングケース/USB-C 充電・オーディオケーブル/3.5mmアナログオーディオケーブルクイックスタートガイド 保証期間 1年 ※Beats製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/beats/MUW33PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
    "": "",
  },
  {
    id: "1791",
    brand: "Beats",
    sku: "MUW43PA/A",
    product_eng: "Beats Solo4 On-ear wireless headphones Slate Blue",
    product_jpn: "Beats Solo4 オンイヤーワイヤレスヘッドフォン - スレートBlue",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥29,818",
    rrp_with_vat: "¥32,800",
    description_eng:
      "Headphones for active people who love music, re-released with further evolution. Powerful sound that moves your body unintentionally.  ■A new standard. Headphones for active people who love music. ■Drivers that have evolved for the best sound. Acoustics with the ultimate balance. Improved frequency response. Uniquely designed 40mm transducers minimize noise, latency and distortion to deliver clear, expansive sound. ■The feeling of being surrounded by 64 speakers at the same time. Personalized spatial audio and dynamic head tracking utilize the built-in gyroscope and accelerometer. ■Powerful sound. Lightweight design. Ergonomic design for comfort. At only 217 grams, you'll forget you're wearing them. ■Softer than you think. UltraPlush ear cushions provide lightweight softness and durability for all-day wear. ■Best comfort and sound. Delicately balanced headband with flexible fit and size-adjustable slider. Beats Solo 4's comfortable, stable fit delivers optimized sound to your ears. ■Up to 50 hours of playback time. ■For both Apple and Android. ■Dimensions Height: 6.8 cm / Length: 17.7 cm / Width: 15.8 cm / Weight: 217 g ■Includes Beats Solo4 headphones / Carrying case / USB-C charging and audio cable / 3.5mm analog audio cable Quick start guide  Warranty Period : 1 year *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "音楽を愛するアクティブな人のためのヘッドフォン、さらなる進化を遂げて再登場。思わず体が動くパワフルなサウンド。  ■定番が、新しく。 音楽を愛するアクティブな人のためのヘッドフォン、さらなる進化を遂げて再登場。 ■最高のサウンドのために 進化を遂げたドライバ。 バランスを極めたアコースティック。改良された周波数レスポンス。独自に設計された40mmトランスデュー サーがノイズやレイテンシー、歪みを最小化し、クリアで広がりのある音を届けます。 ■同時に64台のスピーカーに囲まれているような感覚。 パーソナライズされた空間オーディオとダイナミックヘッドトラッキングは内蔵ジャイロスコープと加速度センサーを利用。 ■パワフルサウンド。軽量設計。 快適さを目指した人間工学に基づくデザイン。わずか217グラム、着けていることを忘れるほどの軽さです。 ■想像以上の柔らかさ。 UltraPlushイヤークッションにより、一日中装着しても軽くソフトな着け心地と耐久性を実現しました。 ■最高の着け心地とサウンド。 繊細なバランスで柔軟にフィットするヘッドバンドとサイズ調整が可能なスライダー。人間工学に基づく角度のイヤーカップ。Beats Solo 4の快適で安定した着け心地が、あなたの耳に最適化されたサウンドを届けます。 ■最大50時間の再生時間。 ■AppleとAndroid、どちらでも。 ■サイズ 高さ：6.8 cm/長さ：17.7 cm/幅：15.8 cm/重量：217 g ■同梱物 Beats Solo4 ヘッドフォン/キャリングケース/USB-C 充電・オーディオケーブル/3.5mmアナログオーディオケーブルクイックスタートガイド 保証期間 1年 ※Beats製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/beats/MUW43PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
    "": "",
  },
  {
    id: "1792",
    brand: "Beats",
    sku: "MUVW3PA/A",
    product_eng: "Beats Solo Buds Wireless earphone Matte Black",
    product_jpn: "Beats Solo Buds ワイヤレスイヤフォン - マットブラック",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥11,636",
    rrp_with_vat: "¥12,800",
    description_eng:
      "Looks small, sounds big.  ■All for the music Everything from the drivers to the vents to the intricate arrangement of internal parts was designed to faithfully reproduce music. That is why we are able to reproduce the full range of emotion in the music, just as the artist wants it to sound. ■Unique Sound System The dual-layer driver structure reduces minute sound distortion and delivers sound that is faithful to the original with uncompromising accuracy and warmth. ■Smallest case ever Beats Solo Buds come in the smallest case ever. Enjoy powerful earbuds on the go. ■Comfortable for any ear The ergonomically angled nozzles fit the true shape of the ear. For ultimate comfort and optimized passive noise isolation, Beats Solo Buds are available in XS, S, M, and L ear tips. ■Charge with your smartphone tablet, or even a wall outlet. When you need to charge, simply place the earbuds in the case connected to the USB-C cable.Even when you are in a hurry, you can play for another hour with a 5-minute charge by the Fast Fuel function. ■Up to 18 hours of playback time ■Compatible with iOS and Android ■Clear call quality ■Size  Height: (case) 2.4 cm (earbuds) 1.9 cm Length: (case) 6.6 cm (earbuds) 2.05 cm Width: (Case) 3.5 cm (Earbuds) 1.85 cm Weight: (Case) 22 g (Earbuds) 5.7 g (Total) 33.4 g Includes: Beats Solo Buds earbuds, carrying case, ear tips in four different sizes  Warranty Period : 1 year *Beats products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "小さく見えて、大きく響く。  ■すべては音楽のために ドライバからベント、入り組んだ内部パーツの配置に至るまで、そのすべては音楽を忠実に再現するためにデザインされました。 だからこそ、アーティストが届けたい音をそのままに、音楽に込められたエモーションをフルレンジで再現できるのです。 ■独自のサウンドシステム 2層構造のドライバが微細な音の歪みを低減、妥協を許さない正確さと温かさで原音に忠実なサウンドを届けます。 独自に設計されたドライバは、サウンドが耳にまっすぐ届くようにイヤーノズルに対して平行に配置しました。 ■これまで最も小さなケース Beats Solo Budsのケースはこれまでで最小サイズ。パワフルなイヤーバッドを外出先でも楽しめます。 ■エアフローを最適化 左右のイヤーバッドに設けられたレーザーカットのベントによって、特に低音のオーディオパフォーマンスが向上。圧力の軽減でさらに快適になりました。 ■どんな耳でも快適 人間工学に基づく最適な角度のノズルが、本来の耳の形にフィットします。 究極の快適さを実現し、パッシブノイズアイソレーションを最適化するために、Beats Solo Budsには、XS、S、M、Lの4種類のイヤーチップを用意しました。 ■スマートフォンで充電 タブレットでも、壁コンセントでも。充電が必要なときは、USB-Cケーブルに接続したケースにイヤーバッドを入れてください。 急いでいるときも、Fast Fuel機能による5分の充電でさらに1時間再生できます。 ■最大18時間の再生時間 ■iOSとAndroidに対応 ■クリアな通話品質 ■サイズ  高さ：（ケース）2.4 cm （イヤーバッド）1.9 cm 長さ：（ケース）6.6 cm （イヤーバッド）2.05 cm 幅：（ケース）3.5 cm （イヤーバッド）1.85 cm 重量：（ケース）22 g （イヤーバッド）5.7 g （合計）33.4 g ■同梱物 Beats Solo Buds イヤフォン/キャリングケース/4種類のサイズから選べるイヤーチップ  保証期間 1年 ※Beats製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/beats/MUVW3PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
    "": "",
  },
  {
    id: "1793",
    brand: "Beats",
    sku: "MUVX3PA/A",
    product_eng: "Beats Solo Buds Wireless earphone Arctic Purple",
    product_jpn:
      "Beats Solo Buds ワイヤレスイヤフォン - アークティックパープル",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥11,636",
    rrp_with_vat: "¥12,800",
    description_eng:
      "Looks small, sounds big.  ■All for the music Everything from the drivers to the vents to the intricate arrangement of internal parts was designed to faithfully reproduce music. That is why we are able to reproduce the full range of emotion in the music, just as the artist wants it to sound. ■Unique Sound System The dual-layer driver structure reduces minute sound distortion and delivers sound that is faithful to the original with uncompromising accuracy and warmth. ■Smallest case ever Beats Solo Buds come in the smallest case ever. Enjoy powerful earbuds on the go. ■Comfortable for any ear The ergonomically angled nozzles fit the true shape of the ear. For ultimate comfort and optimized passive noise isolation, Beats Solo Buds are available in XS, S, M, and L ear tips. ■Charge with your smartphone tablet, or even a wall outlet. When you need to charge, simply place the earbuds in the case connected to the USB-C cable.Even when you are in a hurry, you can play for another hour with a 5-minute charge by the Fast Fuel function. ■Up to 18 hours of playback time ■Compatible with iOS and Android ■Clear call quality ■Size  Height: (case) 2.4 cm (earbuds) 1.9 cm Length: (case) 6.6 cm (earbuds) 2.05 cm Width: (Case) 3.5 cm (Earbuds) 1.85 cm Weight: (Case) 22 g (Earbuds) 5.7 g (Total) 33.4 g Includes: Beats Solo Buds earbuds, carrying case, ear tips in four different sizes  Warranty Period : 1 year *Beats products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "小さく見えて、大きく響く。  ■すべては音楽のために ドライバからベント、入り組んだ内部パーツの配置に至るまで、そのすべては音楽を忠実に再現するためにデザインされました。 だからこそ、アーティストが届けたい音をそのままに、音楽に込められたエモーションをフルレンジで再現できるのです。 ■独自のサウンドシステム 2層構造のドライバが微細な音の歪みを低減、妥協を許さない正確さと温かさで原音に忠実なサウンドを届けます。 独自に設計されたドライバは、サウンドが耳にまっすぐ届くようにイヤーノズルに対して平行に配置しました。 ■これまで最も小さなケース Beats Solo Budsのケースはこれまでで最小サイズ。パワフルなイヤーバッドを外出先でも楽しめます。 ■エアフローを最適化 左右のイヤーバッドに設けられたレーザーカットのベントによって、特に低音のオーディオパフォーマンスが向上。圧力の軽減でさらに快適になりました。 ■どんな耳でも快適 人間工学に基づく最適な角度のノズルが、本来の耳の形にフィットします。 究極の快適さを実現し、パッシブノイズアイソレーションを最適化するために、Beats Solo Budsには、XS、S、M、Lの4種類のイヤーチップを用意しました。 ■スマートフォンで充電 タブレットでも、壁コンセントでも。充電が必要なときは、USB-Cケーブルに接続したケースにイヤーバッドを入れてください。 急いでいるときも、Fast Fuel機能による5分の充電でさらに1時間再生できます。 ■最大18時間の再生時間 ■iOSとAndroidに対応 ■クリアな通話品質 ■サイズ  高さ：（ケース）2.4 cm （イヤーバッド）1.9 cm 長さ：（ケース）6.6 cm （イヤーバッド）2.05 cm 幅：（ケース）3.5 cm （イヤーバッド）1.85 cm 重量：（ケース）22 g （イヤーバッド）5.7 g （合計）33.4 g ■同梱物 Beats Solo Buds イヤフォン/キャリングケース/4種類のサイズから選べるイヤーチップ  保証期間 1年 ※Beats製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/beats/MUVX3PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
    "": "",
  },
  {
    id: "1794",
    brand: "Beats",
    sku: "MUVY3PA/A",
    product_eng: "Beats Solo Buds Wireless earphone Storm Gray",
    product_jpn: "Beats Solo Buds ワイヤレスイヤフォン - ストームグレイ",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥11,636",
    rrp_with_vat: "¥12,800",
    description_eng:
      "Looks small, sounds big.  ■All for the music Everything from the drivers to the vents to the intricate arrangement of internal parts was designed to faithfully reproduce music. That is why we are able to reproduce the full range of emotion in the music, just as the artist wants it to sound. ■Unique Sound System The dual-layer driver structure reduces minute sound distortion and delivers sound that is faithful to the original with uncompromising accuracy and warmth. ■Smallest case ever Beats Solo Buds come in the smallest case ever. Enjoy powerful earbuds on the go. ■Comfortable for any ear The ergonomically angled nozzles fit the true shape of the ear. For ultimate comfort and optimized passive noise isolation, Beats Solo Buds are available in XS, S, M, and L ear tips. ■Charge with your smartphone tablet, or even a wall outlet. When you need to charge, simply place the earbuds in the case connected to the USB-C cable.Even when you are in a hurry, you can play for another hour with a 5-minute charge by the Fast Fuel function. ■Up to 18 hours of playback time ■Compatible with iOS and Android ■Clear call quality ■Size  Height: (case) 2.4 cm (earbuds) 1.9 cm Length: (case) 6.6 cm (earbuds) 2.05 cm Width: (Case) 3.5 cm (Earbuds) 1.85 cm Weight: (Case) 22 g (Earbuds) 5.7 g (Total) 33.4 g Includes: Beats Solo Buds earbuds, carrying case, ear tips in four different sizes  Warranty Period : 1 year *Beats products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "小さく見えて、大きく響く。  ■すべては音楽のために ドライバからベント、入り組んだ内部パーツの配置に至るまで、そのすべては音楽を忠実に再現するためにデザインされました。 だからこそ、アーティストが届けたい音をそのままに、音楽に込められたエモーションをフルレンジで再現できるのです。 ■独自のサウンドシステム 2層構造のドライバが微細な音の歪みを低減、妥協を許さない正確さと温かさで原音に忠実なサウンドを届けます。 独自に設計されたドライバは、サウンドが耳にまっすぐ届くようにイヤーノズルに対して平行に配置しました。 ■これまで最も小さなケース Beats Solo Budsのケースはこれまでで最小サイズ。パワフルなイヤーバッドを外出先でも楽しめます。 ■エアフローを最適化 左右のイヤーバッドに設けられたレーザーカットのベントによって、特に低音のオーディオパフォーマンスが向上。圧力の軽減でさらに快適になりました。 ■どんな耳でも快適 人間工学に基づく最適な角度のノズルが、本来の耳の形にフィットします。 究極の快適さを実現し、パッシブノイズアイソレーションを最適化するために、Beats Solo Budsには、XS、S、M、Lの4種類のイヤーチップを用意しました。 ■スマートフォンで充電 タブレットでも、壁コンセントでも。充電が必要なときは、USB-Cケーブルに接続したケースにイヤーバッドを入れてください。 急いでいるときも、Fast Fuel機能による5分の充電でさらに1時間再生できます。 ■最大18時間の再生時間 ■iOSとAndroidに対応 ■クリアな通話品質 ■サイズ  高さ：（ケース）2.4 cm （イヤーバッド）1.9 cm 長さ：（ケース）6.6 cm （イヤーバッド）2.05 cm 幅：（ケース）3.5 cm （イヤーバッド）1.85 cm 重量：（ケース）22 g （イヤーバッド）5.7 g （合計）33.4 g ■同梱物 Beats Solo Buds イヤフォン/キャリングケース/4種類のサイズから選べるイヤーチップ  保証期間 1年 ※Beats製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/beats/MUVY3PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
    "": "",
  },
  {
    id: "1795",
    brand: "Beats",
    sku: "MUW03PA/A",
    product_eng: "Beats Solo Buds Wireless earphone Transparent Red",
    product_jpn:
      "Beats Solo Buds ワイヤレスイヤフォン - トランスペアレントレッド",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥11,636",
    rrp_with_vat: "¥12,800",
    description_eng:
      "Looks small, sounds big.  ■All for the music Everything from the drivers to the vents to the intricate arrangement of internal parts was designed to faithfully reproduce music. That is why we are able to reproduce the full range of emotion in the music, just as the artist wants it to sound. ■Unique Sound System The dual-layer driver structure reduces minute sound distortion and delivers sound that is faithful to the original with uncompromising accuracy and warmth. ■Smallest case ever Beats Solo Buds come in the smallest case ever. Enjoy powerful earbuds on the go. ■Comfortable for any ear The ergonomically angled nozzles fit the true shape of the ear. For ultimate comfort and optimized passive noise isolation, Beats Solo Buds are available in XS, S, M, and L ear tips. ■Charge with your smartphone tablet, or even a wall outlet. When you need to charge, simply place the earbuds in the case connected to the USB-C cable.Even when you are in a hurry, you can play for another hour with a 5-minute charge by the Fast Fuel function. ■Up to 18 hours of playback time ■Compatible with iOS and Android ■Clear call quality ■Size  Height: (case) 2.4 cm (earbuds) 1.9 cm Length: (case) 6.6 cm (earbuds) 2.05 cm Width: (Case) 3.5 cm (Earbuds) 1.85 cm Weight: (Case) 22 g (Earbuds) 5.7 g (Total) 33.4 g Includes: Beats Solo Buds earbuds, carrying case, ear tips in four different sizes  Warranty Period : 1 year *Beats products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "小さく見えて、大きく響く。  ■すべては音楽のために ドライバからベント、入り組んだ内部パーツの配置に至るまで、そのすべては音楽を忠実に再現するためにデザインされました。 だからこそ、アーティストが届けたい音をそのままに、音楽に込められたエモーションをフルレンジで再現できるのです。 ■独自のサウンドシステム 2層構造のドライバが微細な音の歪みを低減、妥協を許さない正確さと温かさで原音に忠実なサウンドを届けます。 独自に設計されたドライバは、サウンドが耳にまっすぐ届くようにイヤーノズルに対して平行に配置しました。 ■これまで最も小さなケース Beats Solo Budsのケースはこれまでで最小サイズ。パワフルなイヤーバッドを外出先でも楽しめます。 ■エアフローを最適化 左右のイヤーバッドに設けられたレーザーカットのベントによって、特に低音のオーディオパフォーマンスが向上。圧力の軽減でさらに快適になりました。 ■どんな耳でも快適 人間工学に基づく最適な角度のノズルが、本来の耳の形にフィットします。 究極の快適さを実現し、パッシブノイズアイソレーションを最適化するために、Beats Solo Budsには、XS、S、M、Lの4種類のイヤーチップを用意しました。 ■スマートフォンで充電 タブレットでも、壁コンセントでも。充電が必要なときは、USB-Cケーブルに接続したケースにイヤーバッドを入れてください。 急いでいるときも、Fast Fuel機能による5分の充電でさらに1時間再生できます。 ■最大18時間の再生時間 ■iOSとAndroidに対応 ■クリアな通話品質 ■サイズ  高さ：（ケース）2.4 cm （イヤーバッド）1.9 cm 長さ：（ケース）6.6 cm （イヤーバッド）2.05 cm 幅：（ケース）3.5 cm （イヤーバッド）1.85 cm 重量：（ケース）22 g （イヤーバッド）5.7 g （合計）33.4 g ■同梱物 Beats Solo Buds イヤフォン/キャリングケース/4種類のサイズから選べるイヤーチップ  保証期間 1年 ※Beats製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/beats/MUW03PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
    "": "",
  },
  {
    id: "1796",
    brand: "Beats",
    sku: "MW443PA/A",
    product_eng: "Beats Pill Bluetooth Speaker Matte Black",
    product_jpn: "Beats Pill ワイヤレスBluetoothスピーカー マットブラック",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥22,545",
    rrp_with_vat: "¥24,800",
    description_eng:
      "Beats Pill has evolved even further.  ■Powerful. Precision. Low sound. Lighter, more powerful, and easy to carry. Enjoy it indoors or out. Powerful sound that fills the space, dynamic bass. ■Engaging bass. Beats Pill features a unique racetrack woofer that's larger in size. It delivers 90% more air to move and delivers powerful, deep, thick bass. ■Loud and Clear The materials and construction used in the woofer, especially its unique shape, minimize bass distortion even at high volumes. ■IP67 dust and water resistance Beats Pill is sealed to keep out dust, sand, and water. ■Sound is Upward Beats Pill's streamlined design keeps sound 20 degrees upward, away from obstructions and directly to your ears. ■Battery lasts up to 24 hours ■Also works as a speakerphone Paired Beats Pill can take calls and activate voice assistants. Industry-leading Class 1 Bluetooth® for greater range and fewer dropouts. ■Choice of playback modes When two Beats Pill speakers are connected in amplified mode, they each play the same music. For surround sound enjoyment, connect two Beats Pill speakers in stereo mode and one will play the left channel and the other the right channel. ■Specifications Height: 7.0 cm / Length: 21.9 cm / Width: 7.1 cm / Weight: 680 g  Warranty Period : 1 year *Beats products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Beats Pillがさらなる進化を遂げました。  ■パワフル。高精度。低音。 より軽くよりパワフルに、持ち運びも簡単。室内でも屋外でも楽しめます。空間を満たすパワフルサウンド、ダイナミックな低音。 ■魅力あふれる低音 Beats Pillはサイズアップした独自のレーストラックウーファーを搭載。動かせる空気量が90%増加、パワフルかつ深く厚みのある低音を届けます。 ■ラウドでクリア ウーファーに採用された素材と構造、とりわけそのユニークな形状が大音量でも低音域の歪みを最小化します。 ■強い磁石による駆動力 強化されたネオジム磁石により動かせる空気量が増加し、駆動力が28%向上。ダイナミックかつ再現性の高いサウンドを実現しました。 ■IP67等級の防塵・耐水性能 プールやビーチ、雨の中でも安心。Beats Pillは高い密封性により、ホコリや砂、水を寄せつけません。 ■サウンドは上向きに Beats Pillの流線型デザインは障害物を避けて音が直接耳へ届くように上方20度をキープ。 ■最大24時間持続するバッテリー ■スピーカーフォンとしても機能 ペアリングしたBeats Pillで通話や音声アシスタントの起動ができます。業界最高クラスのClass 1 Bluetooth®は通信範囲が広く、ドロップアウトも減少。 ■選べる再生モード 増幅モードで2台のBeats Pillスピーカーを接続すると、それぞれ同じ音楽を再生します。サラウンドで楽しむときは、ステレオモードで2台のBeats Pillスピーカーを接続すると、1台が左チャンネル、もう1台が右チャンネルを再生します。 ■仕様 高さ：7.0 cm/長さ：21.9 cm/幅：7.1 cm/重量：680 g  保証期間 1年 ※Beats製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/beats/MW443PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
    "": "",
  },
  {
    id: "1797",
    brand: "Beats",
    sku: "MW463PA/A",
    product_eng: "Beats Pill Bluetooth Speaker Champagne Gold",
    product_jpn: "Beats Pill ワイヤレスBluetoothスピーカー シャンパンゴールド",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥22,545",
    rrp_with_vat: "¥24,800",
    description_eng:
      "Beats Pill has evolved even further.  ■Powerful. Precision. Low sound. Lighter, more powerful, and easy to carry. Enjoy it indoors or out. Powerful sound that fills the space, dynamic bass. ■Engaging bass. Beats Pill features a unique racetrack woofer that's larger in size. It delivers 90% more air to move and delivers powerful, deep, thick bass. ■Loud and Clear The materials and construction used in the woofer, especially its unique shape, minimize bass distortion even at high volumes. ■IP67 dust and water resistance Beats Pill is sealed to keep out dust, sand, and water. ■Sound is Upward Beats Pill's streamlined design keeps sound 20 degrees upward, away from obstructions and directly to your ears. ■Battery lasts up to 24 hours ■Also works as a speakerphone Paired Beats Pill can take calls and activate voice assistants. Industry-leading Class 1 Bluetooth® for greater range and fewer dropouts. ■Choice of playback modes When two Beats Pill speakers are connected in amplified mode, they each play the same music. For surround sound enjoyment, connect two Beats Pill speakers in stereo mode and one will play the left channel and the other the right channel. ■Specifications Height: 7.0 cm / Length: 21.9 cm / Width: 7.1 cm / Weight: 680 g  Warranty Period : 1 year *Beats products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Beats Pillがさらなる進化を遂げました。  ■パワフル。高精度。低音。 より軽くよりパワフルに、持ち運びも簡単。室内でも屋外でも楽しめます。空間を満たすパワフルサウンド、ダイナミックな低音。 ■魅力あふれる低音 Beats Pillはサイズアップした独自のレーストラックウーファーを搭載。動かせる空気量が90%増加、パワフルかつ深く厚みのある低音を届けます。 ■ラウドでクリア ウーファーに採用された素材と構造、とりわけそのユニークな形状が大音量でも低音域の歪みを最小化します。 ■強い磁石による駆動力 強化されたネオジム磁石により動かせる空気量が増加し、駆動力が28%向上。ダイナミックかつ再現性の高いサウンドを実現しました。 ■IP67等級の防塵・耐水性能 プールやビーチ、雨の中でも安心。Beats Pillは高い密封性により、ホコリや砂、水を寄せつけません。 ■サウンドは上向きに Beats Pillの流線型デザインは障害物を避けて音が直接耳へ届くように上方20度をキープ。 ■最大24時間持続するバッテリー ■スピーカーフォンとしても機能 ペアリングしたBeats Pillで通話や音声アシスタントの起動ができます。業界最高クラスのClass 1 Bluetooth®は通信範囲が広く、ドロップアウトも減少。 ■選べる再生モード 増幅モードで2台のBeats Pillスピーカーを接続すると、それぞれ同じ音楽を再生します。サラウンドで楽しむときは、ステレオモードで2台のBeats Pillスピーカーを接続すると、1台が左チャンネル、もう1台が右チャンネルを再生します。 ■仕様 高さ：7.0 cm/長さ：21.9 cm/幅：7.1 cm/重量：680 g  保証期間 1年 ※Beats製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/beats/MW463PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
    "": "",
  },
  {
    id: "1798",
    brand: "Beats",
    sku: "MWQW3PA/A",
    product_eng: "Beats Pill Bluetooth Speaker Statement Red",
    product_jpn:
      "Beats Pill ワイヤレスBluetoothスピーカー ステートメントレッド",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥22,545",
    rrp_with_vat: "¥24,800",
    description_eng:
      "Beats Pill has evolved even further.  ■Powerful. Precision. Low sound. Lighter, more powerful, and easy to carry. Enjoy it indoors or out. Powerful sound that fills the space, dynamic bass. ■Engaging bass. Beats Pill features a unique racetrack woofer that's larger in size. It delivers 90% more air to move and delivers powerful, deep, thick bass. ■Loud and Clear The materials and construction used in the woofer, especially its unique shape, minimize bass distortion even at high volumes. ■IP67 dust and water resistance Beats Pill is sealed to keep out dust, sand, and water. ■Sound is Upward Beats Pill's streamlined design keeps sound 20 degrees upward, away from obstructions and directly to your ears. ■Battery lasts up to 24 hours ■Also works as a speakerphone Paired Beats Pill can take calls and activate voice assistants. Industry-leading Class 1 Bluetooth® for greater range and fewer dropouts. ■Choice of playback modes When two Beats Pill speakers are connected in amplified mode, they each play the same music. For surround sound enjoyment, connect two Beats Pill speakers in stereo mode and one will play the left channel and the other the right channel. ■Specifications Height: 7.0 cm / Length: 21.9 cm / Width: 7.1 cm / Weight: 680 g  Warranty Period : 1 year *Beats products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Beats Pillがさらなる進化を遂げました。  ■パワフル。高精度。低音。 より軽くよりパワフルに、持ち運びも簡単。室内でも屋外でも楽しめます。空間を満たすパワフルサウンド、ダイナミックな低音。 ■魅力あふれる低音 Beats Pillはサイズアップした独自のレーストラックウーファーを搭載。動かせる空気量が90%増加、パワフルかつ深く厚みのある低音を届けます。 ■ラウドでクリア ウーファーに採用された素材と構造、とりわけそのユニークな形状が大音量でも低音域の歪みを最小化します。 ■強い磁石による駆動力 強化されたネオジム磁石により動かせる空気量が増加し、駆動力が28%向上。ダイナミックかつ再現性の高いサウンドを実現しました。 ■IP67等級の防塵・耐水性能 プールやビーチ、雨の中でも安心。Beats Pillは高い密封性により、ホコリや砂、水を寄せつけません。 ■サウンドは上向きに Beats Pillの流線型デザインは障害物を避けて音が直接耳へ届くように上方20度をキープ。 ■最大24時間持続するバッテリー ■スピーカーフォンとしても機能 ペアリングしたBeats Pillで通話や音声アシスタントの起動ができます。業界最高クラスのClass 1 Bluetooth®は通信範囲が広く、ドロップアウトも減少。 ■選べる再生モード 増幅モードで2台のBeats Pillスピーカーを接続すると、それぞれ同じ音楽を再生します。サラウンドで楽しむときは、ステレオモードで2台のBeats Pillスピーカーを接続すると、1台が左チャンネル、もう1台が右チャンネルを再生します。 ■仕様 高さ：7.0 cm/長さ：21.9 cm/幅：7.1 cm/重量：680 g  保証期間 1年 ※Beats製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/beats/MWQW3PAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/beats.png",
    "": "",
  },
  {
    id: "1799",
    brand: "Apple",
    sku: "MTJT3J/A",
    product_eng: "Home Pod mini - Midnight",
    product_jpn: "Home Pod mini - ミッドナイト",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥13,455",
    rrp_with_vat: "¥14,801",
    description_eng:
      "The entire room will be enveloped in 360-degree sound. Place multiple HomePod mini's throughout your home to experience rich multi-room audio and use features like Intercom.  With Siri, HomePod mini turns into a smart assistant. With just your voice, you can check your calendar and weather, set alarms, and complete daily tasks. Warranty Period : 1 year *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "360度に広がるサウンドで部屋全体が包まれます。複数のHomePod miniを家中に置くと、豊かなマルチルームオーディオを体験したり、インターコムなどの機能を使えます。  Siriを使えば、HomePod miniが賢いアシスタントに変身。あなたの声だけで、カレンダーや天気を確認したり、アラームをセットしたり、毎日のタスクを完了できます。 保証期間 1年 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/MTJT3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1800",
    brand: "Citizen",
    sku: "AT8185-62E",
    product_eng: "Citizen ATTESA ACT Line AT8185-62E",
    product_jpn: "Citizen シチズン ATTESA ACT Line AT8185-62E",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥145,000",
    rrp_with_vat: "¥159,500",
    description_eng:
      "The “ACT Line” has a strong and light design that can be used for both suit and casual wear to match diversifying business styles.  ■No need for regular battery replacement Eco-Drive” is Citizen's proprietary technology that converts sunlight or a small amount of indoor light into electricity to keep the watch running.  ■Scratch-resistant, lightweight, and rust-resistant Super Titanium” is a material made with our original titanium processing technology and surface hardening technology (Duratect). ■Continuously accurate timekeeping The watch receives standard radio waves transmitted based on atomic clocks, which are said to have an error of 1 second in 100,000 years, and automatically corrects the time and calendar in four areas around the world: Japan, China, the U.S., and Europe. ■Reduced reflections for easy viewing of the dial Clarity Coating, a glass coating technology that allows approximately 99% of the light to pass through, reducing reflections and making the dial easier to read.  <Product Specifications> Water resistance 10 atmospheric pressure Band width 21.0mm Adjustable band size 148-200mm Weight 95g Thickness 10.8mm Case size: 42.0 mm (width)  Made in Japan 1-year manufacturer's warranty  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "ブラックボディに映えるオレンジのアクセントカラーが印象的な、「ACT Line」の人気モデル  多様化するビジネススタイルに合わせ、スーツスタイルとカジュアルの両方で使える、力強く軽快なデザインの「ACT Line」。 アクティブなデザインで存在感のあるケースと丸型のプッシュボタン。キラッと輝き高級感を演出するインデックス。マットな質感のケース・バンドの中で、ミラー仕上げのベゼルがエレガントな印象もプラス。スーツだけでなくTシャツなどのラフなスタイルにもマッチする1本です。   ■定期的な電池交換は不要 光発電『エコ・ドライブ』は、太陽光や室内のわずかな光を電気に換え、時計を動かしつづけるシチズン独自の技術です。一度フル充電すれば、光のないところでも長時間動き続けるので、定期的な電池交換は必要ありません。 ■キズに強く、軽く、サビにくい 独自のチタニウム加工技術と表面硬化技術（デュラテクト）を施した素材『スーパーチタニウム』。ステンレスに比べて40%軽く、5倍以上の表面硬度を実現しています。 ■いつでも正確な時刻を刻み続ける 10万年に1秒の誤差と言われる原子時計をもとに送信される標準電波を受信し、日本、中国、アメリカ、ヨーロッパの世界4エリアで自動的に時刻やカレンダーを修正します。 ■反射を抑えて、文字板を見やすく 光の約99％を透過させることで反射を抑え、文字板を見やすくするガラスのコーティング技術『クラリティ・コーティング』。 ■衝撃にも磁気にも強い、ズレない時計 「JIS1種耐磁」「衝撃検知機能」「針自動補正機能」、3つの機能を一体化させた独自技術『パーフェックス』が、磁気や衝撃によって腕時計の針がズレるのを防ぎます。  製品スペック ・防水性能 10気圧防水 ・バンド幅 21.0mm ・バンド調整可能サイズ 148～200mm ・重量 95g ・厚み 10.8mm ・ケースサイズ 横 42.0mm  ・原産国 日本製 ・1年間メーカー保証  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/citizen/AT8185-62E.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1801",
    brand: "Citizen",
    sku: "AT8189-61E",
    product_eng: "Citizen ATTESA ACT Line AT8189-61E",
    product_jpn: "Citizen シチズン ATTESA ACT Line AT8189-61E",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥130,000",
    rrp_with_vat: "¥143,000",
    description_eng:
      "The “ACT Line” has a strong and light design that can be used for both suit and casual wear to match diversifying business styles.  ■No need for regular battery replacement Eco-Drive” is Citizen's proprietary technology that converts sunlight or a small amount of indoor light into electricity to keep the watch running.  ■Scratch-resistant, lightweight, and rust-resistant Super Titanium” is a material made with our original titanium processing technology and surface hardening technology (Duratect). ■Continuously accurate timekeeping The watch receives standard radio waves transmitted based on atomic clocks, which are said to have an error of 1 second in 100,000 years, and automatically corrects the time and calendar in four areas around the world: Japan, China, the U.S., and Europe. ■Reduced reflections for easy viewing of the dial Clarity Coating, a glass coating technology that allows approximately 99% of the light to pass through, reducing reflections and making the dial easier to read.  <Product Specifications> Water resistance 10 atmospheric pressure Band width 21.0mm Adjustable band size 148-200mm Weight 95g Thickness 10.8mm Case size: 42.0 mm (width)  Made in Japan 1-year manufacturer's warranty  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "ブラックボディに映えるオレンジのアクセントカラーが印象的な、「ACT Line」の人気モデル  多様化するビジネススタイルに合わせ、スーツスタイルとカジュアルの両方で使える、力強く軽快なデザインの「ACT Line」。 アクティブなデザインで存在感のあるケースと丸型のプッシュボタン。キラッと輝き高級感を演出するインデックス。マットな質感のケース・バンドの中で、ミラー仕上げのベゼルがエレガントな印象もプラス。スーツだけでなくTシャツなどのラフなスタイルにもマッチする1本です。   ■定期的な電池交換は不要 光発電『エコ・ドライブ』は、太陽光や室内のわずかな光を電気に換え、時計を動かしつづけるシチズン独自の技術です。一度フル充電すれば、光のないところでも長時間動き続けるので、定期的な電池交換は必要ありません。 ■キズに強く、軽く、サビにくい 独自のチタニウム加工技術と表面硬化技術（デュラテクト）を施した素材『スーパーチタニウム』。ステンレスに比べて40%軽く、5倍以上の表面硬度を実現しています。 ■いつでも正確な時刻を刻み続ける 10万年に1秒の誤差と言われる原子時計をもとに送信される標準電波を受信し、日本、中国、アメリカ、ヨーロッパの世界4エリアで自動的に時刻やカレンダーを修正します。 ■反射を抑えて、文字板を見やすく 光の約99％を透過させることで反射を抑え、文字板を見やすくするガラスのコーティング技術『クラリティ・コーティング』。 ■衝撃にも磁気にも強い、ズレない時計 「JIS1種耐磁」「衝撃検知機能」「針自動補正機能」、3つの機能を一体化させた独自技術『パーフェックス』が、磁気や衝撃によって腕時計の針がズレるのを防ぎます。  製品スペック ・防水性能 10気圧防水 ・バンド幅 21.0mm ・バンド調整可能サイズ 148～200mm ・重量 95g ・厚み 10.8mm ・ケースサイズ 横 42.0mm  ・原産国 日本製 ・1年間メーカー保証  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/citizen/AT8189-61E.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1802",
    brand: "Citizen",
    sku: "BY1001-66E",
    product_eng: 'Citizen ATTESA Equipped with "Luna Program" BY1001-66E',
    product_jpn: "Citizen シチズン ATTESA ルナプログラム搭載 BY1001-66E",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥125,000",
    rrp_with_vat: "¥137,500",
    description_eng:
      "The world's first* analog photovoltaic wristwatch equipped with the “Lunar Program,” a function that automatically calculates the age of the moon The moon's age is automatically displayed in the moon phase at the 6 o'clock position. The moon's age can be displayed not only from the northern hemisphere, but also from the southern hemisphere. ■No need for periodic battery replacement The “Eco-Drive” photovoltaic power generation system is a unique Citizen technology that converts sunlight or a small amount of indoor light into electricity to keep the watch running.  ■Scratch-resistant, lightweight, and rust-resistant Super Titanium” is a material made with our original titanium processing technology and surface hardening technology (Duratect).  ■The watch receives standard radio waves transmitted based on atomic clocks, which are said to have an error of 1 second in 100,000 years, and automatically corrects the time and calendar in four areas around the world: Japan, China, the U.S., and Europe. ■Shock- and magnetism-resistant watch that never deviates from its original position  Product Specifications ・Water resistance 10 atmospheres ・Weight 89g ・Thickness 10.8mm ・Case size: 41.5 mm (width)  ・Band width: 21.0mm ・Adjustable band size: 126-192mm ・Made in Japan ・1-year manufacturer's warranty  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "アナログ式光発電腕時計で世界初*、月齢自動計算機能「ルナプログラム」搭載 電波受信した日付情報からムーブメント内部で独自の計算式を用いてその日の月齢を計算。6 時位置のムーンフェイズ部分に月齢を自動表示します。北半球からの月の形状だけでなく、南半球から眺める月の形状も表示可能な月齢表示切替機能「NS シフト」も搭載しています。 ■定期的な電池交換は不要 光発電『エコ・ドライブ』は、太陽光や室内のわずかな光を電気に換え、時計を動かしつづけるシチズン独自の技術です。一度フル充電すれば、光のないところでも長時間動き続けるので、定期的な電池交換は必要ありません。 ■キズに強く、軽く、サビにくい 独自のチタニウム加工技術と表面硬化技術（デュラテクト）を施した素材『スーパーチタニウム』。ステンレスに比べて40%軽く、5倍以上の表面硬度を実現しています。 ■いつでも正確な時刻を刻み続ける 10万年に1秒の誤差と言われる原子時計をもとに送信される標準電波を受信し、日本、中国、アメリカ、ヨーロッパの世界4エリアで自動的に時刻やカレンダーを修正します。 ■衝撃にも磁気にも強い、ズレない時計 「JIS1種耐磁」「衝撃検知機能」「針自動補正機能」、3つの機能を一体化させた独自技術『パーフェックス』が、磁気や衝撃によって腕時計の針がズレるのを防ぎます。  製品スペック ・防水性能 10気圧防水 ・重量 89g ・厚み10.8mm ・ケースサイズ 横 41.5mm  ・バンド幅 21.0mm ・バンド調整可能サイズ 126～192mm ・原産国 日本製 ・1年間メーカー保証  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/citizen/BY1001-66E.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1803",
    brand: "Citizen",
    sku: "BY1004-17X",
    product_eng: 'Citizen ATTESA Equipped with "Luna Program" BY1004-17X',
    product_jpn: "Citizen シチズン ATTESA ルナプログラム搭載 BY1004-17X",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥115,000",
    rrp_with_vat: "¥126,500",
    description_eng:
      "The world's first* analog photovoltaic wristwatch equipped with the “Lunar Program,” a function that automatically calculates the age of the moon The moon's age is automatically displayed in the moon phase at the 6 o'clock position. The moon's age can be displayed not only from the northern hemisphere, but also from the southern hemisphere. ■No need for periodic battery replacement The “Eco-Drive” photovoltaic power generation system is a unique Citizen technology that converts sunlight or a small amount of indoor light into electricity to keep the watch running.  ■Scratch-resistant, lightweight, and rust-resistant Super Titanium” is a material made with our original titanium processing technology and surface hardening technology (Duratect).  ■The watch receives standard radio waves transmitted based on atomic clocks, which are said to have an error of 1 second in 100,000 years, and automatically corrects the time and calendar in four areas around the world: Japan, China, the U.S., and Europe. ■Shock- and magnetism-resistant watch that never deviates from its original position  Product Specifications ・Water resistance 10 atmospheres ・Weight 59g ・Band material/type Calf leather ・Band width 21.0mm ・Adjustable band size: 150 to 220mm ・Made in Japan ・1-year manufacturer's warranty  ＊We do not accept orders cancelled or changed for reasons beyond our control (e.g., different product from what was expected, wrong order, etc.), nor do we accept returns of products that have been delivered to you. Please be aware of this before placing an order. ＊We will exchange the product only in the case of initial defects if you contact us within 7 days of arrival.",
    description_jpn:
      "アナログ式光発電腕時計で世界初*、月齢自動計算機能「ルナプログラム」搭載 電波受信した日付情報からムーブメント内部で独自の計算式を用いてその日の月齢を計算。6 時位置のムーンフェイズ部分に月齢を自動表示します。北半球からの月の形状だけでなく、南半球から眺める月の形状も表示可能な月齢表示切替機能「NS シフト」も搭載しています。 ■定期的な電池交換は不要 光発電『エコ・ドライブ』は、太陽光や室内のわずかな光を電気に換え、時計を動かしつづけるシチズン独自の技術です。一度フル充電すれば、光のないところでも長時間動き続けるので、定期的な電池交換は必要ありません。 ■キズに強く、軽く、サビにくい 独自のチタニウム加工技術と表面硬化技術（デュラテクト）を施した素材『スーパーチタニウム』。ステンレスに比べて40%軽く、5倍以上の表面硬度を実現しています。 ■いつでも正確な時刻を刻み続ける 10万年に1秒の誤差と言われる原子時計をもとに送信される標準電波を受信し、日本、中国、アメリカ、ヨーロッパの世界4エリアで自動的に時刻やカレンダーを修正します。 ■衝撃にも磁気にも強い、ズレない時計 「JIS1種耐磁」「衝撃検知機能」「針自動補正機能」、3つの機能を一体化させた独自技術『パーフェックス』が、磁気や衝撃によって腕時計の針がズレるのを防ぎます。  製品スペック ・防水性能 10気圧防水 ・重量 59g ・厚み10.8mm ・バンド素材・タイプ カーフ革 ・バンド幅 21.0mm ・バンド調整可能サイズ 150～220mm ・原産国 日本製 ・1年間メーカー保証  ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。 ※初期不良の場合のみ、到着から７日以内にご連絡を頂ければ商品の交換を致します。",
    product_image_1:
      "https://products.naganorewards.com/images/citizen/BY1004-17X.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1804",
    brand: "Citizen",
    sku: "AT6085-50E",
    product_eng: "Citizen PROMASTER LAND AT6085-50E",
    product_jpn: "Citizen シチズン PROMASTER LAND AT6085-50E",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥100,000",
    rrp_with_vat: "¥110,000",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/citizen/AT6085-50E.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1805",
    brand: "Citizen",
    sku: "AT6080-53L",
    product_eng: "Citizen PROMASTER LAND AT6080-53L",
    product_jpn: "Citizen シチズン PROMASTER LAND AT6080-53L",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥72,000",
    rrp_with_vat: "¥79,200",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/citizen/AT6080-53L.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1806",
    brand: "Citizen",
    sku: "CB5874-90E",
    product_eng: "Citizen CITIZEN COLLECTION CB5874-90E",
    product_jpn: "Citizen シチズン CITIZEN COLLECTION CB5874-90E",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥55,000",
    rrp_with_vat: "¥60,500",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/citizen/CB5874-90E.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1807",
    brand: "Citizen",
    sku: "NP1010-78E",
    product_eng: "Citizen CITIZEN COLLECTION NP1010-78E",
    product_jpn: "Citizen シチズン CITIZEN COLLECTION NP1010-78E",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥47,000",
    rrp_with_vat: "¥51,700",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/citizen/NP1010-78E.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1808",
    brand: "Citizen",
    sku: "NP1010-78L",
    product_eng: "Citizen CITIZEN COLLECTION NP1010-78L",
    product_jpn: "Citizen シチズン CITIZEN COLLECTION NP1010-78L",
    category_1: "Jewelry & Watches",
    category_2: "Watches",
    rrp_ex_vat: "¥47,000",
    rrp_with_vat: "¥51,700",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/citizen/NP1010-78L.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1809",
    brand: "Victorinox",
    sku: "602151",
    product_eng: "Victorinox Altmont Professional Compact Laptop Backpack",
    product_jpn:
      "Victorinox ビクトリノックス Altmont Professional コンパクト ラップトップバッグ",
    category_1: "Business",
    category_2: "Bags",
    rrp_ex_vat: "¥18,000",
    rrp_with_vat: "¥19,800",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/victorinox/602151.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1810",
    brand: "Victorinox",
    sku: "602154",
    product_eng: "Victorinox Altmont Professional Essential Laptop Bag",
    product_jpn:
      "Victorinox ビクトリノックス Altmont Professional エッセンシャル ラップトップバッグ",
    category_1: "Business",
    category_2: "Bags",
    rrp_ex_vat: "¥20,000",
    rrp_with_vat: "¥22,000",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/victorinox/602154.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1811",
    brand: "Victorinox",
    sku: "606796",
    product_eng: "Victorinox Altmont Professional Tablet Sling",
    product_jpn:
      "Victorinox ビクトリノックス Altmont Professional タブレットスリング",
    category_1: "Business",
    category_2: "Bags",
    rrp_ex_vat: "¥15,000",
    rrp_with_vat: "¥16,500",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/victorinox/606796.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1812",
    brand: "Victorinox",
    sku: "611954",
    product_eng: "Victorinox Architecture Urban2 Deluxe Backpack",
    product_jpn:
      "Victorinox ビクトリノックス アーキテクチャーアーバン2 デラックスバックパック",
    category_1: "Business",
    category_2: "Bags",
    rrp_ex_vat: "¥43,000",
    rrp_with_vat: "¥47,300",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/victorinox/611954.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1813",
    brand: "Victorinox",
    sku: "611806",
    product_eng: "Victorinox ALOX NERO 3WAY Bag",
    product_jpn: "Victorinox ビクトリノックス アロックスネロ 3WAYバッグ",
    category_1: "Business",
    category_2: "Bags",
    rrp_ex_vat: "¥34,000",
    rrp_with_vat: "¥37,400",
    description_eng: "",
    description_jpn: "",
    product_image_1:
      "https://products.naganorewards.com/images/victorinox/611806.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
    "": "",
  },
  {
    id: "1814",
    brand: "Apple",
    sku: "MYWJ3J/A",
    product_eng: "iPhone 16 Pro Max 256GB Desert Titanium",
    product_jpn: "iPhone 16 Pro Max 256GB デザートチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥172,545",
    rrp_with_vat: "¥189,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWJ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1815",
    brand: "Apple",
    sku: "MYWK3J/A",
    product_eng: "iPhone 16 Pro Max 256GB Natural Titanium",
    product_jpn: "iPhone 16 Pro Max 256GB ナチュラルチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥172,545",
    rrp_with_vat: "¥189,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWK3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1816",
    brand: "Apple",
    sku: "MYWH3J/A",
    product_eng: "iPhone 16 Pro Max 256GB White Titanium",
    product_jpn: "iPhone 16 Pro Max 256GB ホワイトチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥172,545",
    rrp_with_vat: "¥189,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWH3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1817",
    brand: "Apple",
    sku: "MYWG3J/A",
    product_eng: "iPhone 16 Pro Max 256GB Black Titanium",
    product_jpn: "iPhone 16 Pro Max 256GB ブラックチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥172,545",
    rrp_with_vat: "¥189,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWG3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1818",
    brand: "Apple",
    sku: "MYWN3J/A",
    product_eng: "iPhone 16 Pro Max 512GB Desert Titanium",
    product_jpn: "iPhone 16 Pro Max 512GB デザートチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥199,818",
    rrp_with_vat: "¥219,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWN3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1819",
    brand: "Apple",
    sku: "MYWP3J/A",
    product_eng: "iPhone 16 Pro Max 512GB Natural Titanium",
    product_jpn: "iPhone 16 Pro Max 512GB ナチュラルチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥199,818",
    rrp_with_vat: "¥219,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWP3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1820",
    brand: "Apple",
    sku: "MYWM3J/A",
    product_eng: "iPhone 16 Pro Max 512GB White Titanium",
    product_jpn: "iPhone 16 Pro Max 512GB ホワイトチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥199,818",
    rrp_with_vat: "¥219,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWM3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1821",
    brand: "Apple",
    sku: "MYWL3J/A",
    product_eng: "iPhone 16 Pro Max 512GB Black Titanium",
    product_jpn: "iPhone 16 Pro Max 512GB ブラックチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥199,818",
    rrp_with_vat: "¥219,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWL3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1822",
    brand: "Apple",
    sku: "MYWT3J/A",
    product_eng: "iPhone 16 Pro Max 1TB Desert Titanium",
    product_jpn: "iPhone 16 Pro Max 1TB デザートチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥227,091",
    rrp_with_vat: "¥249,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWT3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1823",
    brand: "Apple",
    sku: "MYWU3J/A",
    product_eng: "iPhone 16 Pro Max 1TB Natural Titanium",
    product_jpn: "iPhone 16 Pro Max 1TB ナチュラルチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥227,091",
    rrp_with_vat: "¥249,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWU3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1824",
    brand: "Apple",
    sku: "MYWR3J/A",
    product_eng: "iPhone 16 Pro Max 1TB White Titanium",
    product_jpn: "iPhone 16 Pro Max 1TB ホワイトチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥227,091",
    rrp_with_vat: "¥249,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWR3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1825",
    brand: "Apple",
    sku: "MYWQ3J/A",
    product_eng: "iPhone 16 Pro Max 1TB Black Titanium",
    product_jpn: "iPhone 16 Pro Max 1TB ブラックチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥227,091",
    rrp_with_vat: "¥249,800",
    description_eng:
      "Apple Intelligence. Big possibilities in your hands.  ・With a larger 6.9-inch display, the iPhone 16 Pro Max features the largest display ever on an iPhone. ・The iPhone 16 Pro is designed in grade 5 Titanium. The iPhone 16 Pro is designed in Grade 5 Titanium, a new microblasted, polished finish. From titanium, one of the metals with the highest strength-to-weight ratio, we have created a model that is both incredibly strong and impressively light. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. Camera Control. Easier and faster access to camera tools.  Width: 77.6 mm Height: 163 mm Thickness: 8.25 mm Weight: 227 g   arranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.9インチディスプレイ、iPhone 16 Pro Maxは、これまでのiPhoneの中で最も大きなディスプレイを搭載。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：77.6 mm 高さ：163 mm 厚さ：8.25 mm 重量：227 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_ProMax/MYWQ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1826",
    brand: "Apple",
    sku: "MYMX3J/A",
    product_eng: "iPhone 16 Pro 128GB Desert Titanium",
    product_jpn: "iPhone 16 Pro 128GB デザートチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥145,273",
    rrp_with_vat: "¥159,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYMX3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1827",
    brand: "Apple",
    sku: "MYMY3J/A",
    product_eng: "iPhone 16 Pro 128GB Natural Titanium",
    product_jpn: "iPhone 16 Pro 128GB ナチュラルチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥145,273",
    rrp_with_vat: "¥159,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYMY3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1828",
    brand: "Apple",
    sku: "MYMW3J/A",
    product_eng: "iPhone 16 Pro 128GB White Titanium",
    product_jpn: "iPhone 16 Pro 128GB ホワイトチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥145,273",
    rrp_with_vat: "¥159,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYMW3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1829",
    brand: "Apple",
    sku: "MYMV3J/A",
    product_eng: "iPhone 16 Pro 128GB Black Titanium",
    product_jpn: "iPhone 16 Pro 128GB ブラックチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥145,273",
    rrp_with_vat: "¥159,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYMV3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1830",
    brand: "Apple",
    sku: "MYN23J/A",
    product_eng: "iPhone 16 Pro 256GB Desert Titanium",
    product_jpn: "iPhone 16 Pro 256GB デザートチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥158,909",
    rrp_with_vat: "¥174,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYN23JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1831",
    brand: "Apple",
    sku: "MYN33J/A",
    product_eng: "iPhone 16 Pro 256GB Natural Titanium",
    product_jpn: "iPhone 16 Pro 256GB ナチュラルチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥158,909",
    rrp_with_vat: "¥174,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYN33JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1832",
    brand: "Apple",
    sku: "MYN13J/A",
    product_eng: "iPhone 16 Pro 256GB White Titanium",
    product_jpn: "iPhone 16 Pro 256GB ホワイトチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥158,909",
    rrp_with_vat: "¥174,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYN13JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1833",
    brand: "Apple",
    sku: "MYN03J/A",
    product_eng: "iPhone 16 Pro 256GB Black Titanium",
    product_jpn: "iPhone 16 Pro 256GB ブラックチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥158,909",
    rrp_with_vat: "¥174,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYN03JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1834",
    brand: "Apple",
    sku: "MYN63J/A",
    product_eng: "iPhone 16 Pro 512GB Desert Titanium",
    product_jpn: "iPhone 16 Pro 512GB デザートチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥186,182",
    rrp_with_vat: "¥204,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYN63JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1835",
    brand: "Apple",
    sku: "MYN73J/A",
    product_eng: "iPhone 16 Pro 512GB Natural Titanium",
    product_jpn: "iPhone 16 Pro 512GB ナチュラルチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥186,182",
    rrp_with_vat: "¥204,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYN73JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1836",
    brand: "Apple",
    sku: "MYN53J/A",
    product_eng: "iPhone 16 Pro 512GB White Titanium",
    product_jpn: "iPhone 16 Pro 512GB ホワイトチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥186,182",
    rrp_with_vat: "¥204,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYN53JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1837",
    brand: "Apple",
    sku: "MYN43J/A",
    product_eng: "iPhone 16 Pro 512GB Black Titanium",
    product_jpn: "iPhone 16 Pro 512GB ブラックチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥186,182",
    rrp_with_vat: "¥204,800",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYN43JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1838",
    brand: "Apple",
    sku: "MYNA3J/A",
    product_eng: "iPhone 16 Pro 1TB Desert Titanium",
    product_jpn: "iPhone 16 Pro 1TB デザートチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥213,455",
    rrp_with_vat: "¥234,801",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYNA3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1839",
    brand: "Apple",
    sku: "MYNC3J/A",
    product_eng: "iPhone 16 Pro 1TB Natural Titanium",
    product_jpn: "iPhone 16 Pro 1TB ナチュラルチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥213,455",
    rrp_with_vat: "¥234,801",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYNC3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1840",
    brand: "Apple",
    sku: "MYN93J/A",
    product_eng: "iPhone 16 Pro 1TB White Titanium",
    product_jpn: "iPhone 16 Pro 1TB ホワイトチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥213,455",
    rrp_with_vat: "¥234,801",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYN93JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1841",
    brand: "Apple",
    sku: "MYN83J/A",
    product_eng: "iPhone 16 Pro 1TB Black Titanium",
    product_jpn: "iPhone 16 Pro 1TB ブラックチタニウム",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥213,455",
    rrp_with_vat: "¥234,801",
    description_eng:
      "Apple Intelligence. Great possibilities in your hands.  ・The iPhone 16 Pro is a grade 5 titanium design with a larger 6.3-inch display, the latest generation Ceramic Shield, Action Button, and USB-C with USB 3 compatibility. ・The A18 Pro chip brings tremendous speed and power efficiency to the iPhone 16 Pro, allowing it to play AAA games with exceptional graphics. ・The A18 Pro chip incorporates an improved internal design, including a 100% recycled aluminum base for high thermal conductivity and optimized rear glass for heat dispersion, resulting in up to 20% longer performance compared to the iPhone 15 Pro. ・Apple Intelligence Built into iPhone is Apple Intelligence, a personal intelligence system that helps you write, express yourself, and complete tasks with ease. With its revolutionary privacy protection, your data cannot be accessed by anyone but you, not even Apple. ・Camera Control. Easier and faster access to camera tools.  Width: 71.5 mm Height: 149.6 mm Thickness: 8.25 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・一段と大きな6.3インチディスプレイ、最新世代のCeramic Shield、アクションボタン、USB 3に対応したUSB-Cを搭載したチタニウムのデザイン。 ・iPhone 16 Proはグレード5チタニウムのデザイン。マイクロブラスト加工で磨き上げた新しい仕上げです。強度重量比が最も高い金属の一つであるチタニウムから、圧倒的に強くて感動的に軽いモデルが誕生しました。 ・A18 Proチップ。iPhone 16 Proにとてつもないスピードと電力効率をもたらします。AAAゲームを並外れたグラフィックスでプレーできるのも、このチップのおかげです。 ・熱伝導率が高い100%再生アルミニウムの基盤を組み込み、さらに熱を拡散させるために背面ガラスを最適化するなど、内部設計を改良。iPhone 15 Proと比べて最大20%も長くパフォーマンスが持続します。 ・Apple Intelligence iPhoneに組み込まれたApple Intelligenceは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポートするパーソナルなインテリジェンスシステムです。画期的なプライバシー保護機能により、あなたのデータにはあなた以外の人はもちろん、Appleもアクセスできません。 ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス,瞬撮。 ・新しい48MP超広角カメラ。解像度革命。 ・4K 120fpsのドルビービジョン。4つのスタジオ品質のマイク。Proのレコーディングを手軽に。  幅：71.5 mm 高さ：149.6 mm 厚さ：8.25 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_pro/MYN83JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1842",
    brand: "Apple",
    sku: "MXVE3J/A",
    product_eng: "iPhone 16 Plus 128GB Ultramarine",
    product_jpn: "iPhone 16 Plus 128GB ウルトラマリン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVE3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1843",
    brand: "Apple",
    sku: "MXVF3J/A",
    product_eng: "iPhone 16 Plus 128GB Teal",
    product_jpn: "iPhone 16 Plus 128GB ティール",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVF3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1844",
    brand: "Apple",
    sku: "MXVD3J/A",
    product_eng: "iPhone 16 Plus 128GB Pink",
    product_jpn: "iPhone 16 Plus 128GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVD3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1845",
    brand: "Apple",
    sku: "MXVC3J/A",
    product_eng: "iPhone 16 Plus 128GB White",
    product_jpn: "iPhone 16 Plus 128GB ホワイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVC3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1846",
    brand: "Apple",
    sku: "MXVA3J/A",
    product_eng: "iPhone 16 Plus 128GB Black",
    product_jpn: "iPhone 16 Plus 128GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVA3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1847",
    brand: "Apple",
    sku: "MXVK3J/A",
    product_eng: "iPhone 16 Plus 256GB Ultramarine",
    product_jpn: "iPhone 16 Plus 256GB ウルトラマリン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVK3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1848",
    brand: "Apple",
    sku: "MXVL3J/A",
    product_eng: "iPhone 16 Plus 256GB Teal",
    product_jpn: "iPhone 16 Plus 256GB ティール",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVL3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1849",
    brand: "Apple",
    sku: "MXVJ3J/A",
    product_eng: "iPhone 16 Plus 256GB Pink",
    product_jpn: "iPhone 16 Plus 256GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVJ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1850",
    brand: "Apple",
    sku: "MXVH3J/A",
    product_eng: "iPhone 16 Plus 256GB White",
    product_jpn: "iPhone 16 Plus 256GB ホワイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVH3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1851",
    brand: "Apple",
    sku: "MXVG3J/A",
    product_eng: "iPhone 16 Plus 256GB Black",
    product_jpn: "iPhone 16 Plus 256GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥140,727",
    rrp_with_vat: "¥154,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVG3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1852",
    brand: "Apple",
    sku: "MXVR3J/A",
    product_eng: "iPhone 16 Plus 512GB Ultramarine",
    product_jpn: "iPhone 16 Plus 512GB ウルトラマリン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥168,000",
    rrp_with_vat: "¥184,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVR3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1853",
    brand: "Apple",
    sku: "MXVT3J/A",
    product_eng: "iPhone 16 Plus 512GB Teal",
    product_jpn: "iPhone 16 Plus 512GB ティール",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥168,000",
    rrp_with_vat: "¥184,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVT3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1854",
    brand: "Apple",
    sku: "MXVQ3J/A",
    product_eng: "iPhone 16 Plus 512GB Pink",
    product_jpn: "iPhone 16 Plus 512GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥168,000",
    rrp_with_vat: "¥184,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVQ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1855",
    brand: "Apple",
    sku: "MXVP3J/A",
    product_eng: "iPhone 16 Plus 512GB White",
    product_jpn: "iPhone 16 Plus 512GB ホワイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥168,000",
    rrp_with_vat: "¥184,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVP3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1856",
    brand: "Apple",
    sku: "MXVN3J/A",
    product_eng: "iPhone 16 Plus 512GB Black",
    product_jpn: "iPhone 16 Plus 512GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥168,000",
    rrp_with_vat: "¥184,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 77.8 mm Height: 160.9 mm Thickness: 7.80 mm Weight: 199 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：77.8 mm 高さ：160.9 mm 厚さ：7.80 mm 重量：199 g   保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16_plus/MXVN3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1857",
    brand: "Apple",
    sku: "MYDU3J/A",
    product_eng: "iPhone 16 128GB Ultramarine",
    product_jpn: "iPhone 16 128GB ウルトラマリン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,801",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYDU3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1858",
    brand: "Apple",
    sku: "MYDV3J/A",
    product_eng: "iPhone 16 128GB Teal",
    product_jpn: "iPhone 16 128GB ティール",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,801",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYDV3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1859",
    brand: "Apple",
    sku: "MYDT3J/A",
    product_eng: "iPhone 16 128GB Pink",
    product_jpn: "iPhone 16 128GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,801",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYDT3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1860",
    brand: "Apple",
    sku: "MYDR3J/A",
    product_eng: "iPhone 16 128GB White",
    product_jpn: "iPhone 16 128GB ホワイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,801",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYDR3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1861",
    brand: "Apple",
    sku: "MYDQ3J/A",
    product_eng: "iPhone 16 128GB Black",
    product_jpn: "iPhone 16 128GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥113,455",
    rrp_with_vat: "¥124,801",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYDQ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1862",
    brand: "Apple",
    sku: "MYE03J/A",
    product_eng: "iPhone 16 256GB Ultramarine",
    product_jpn: "iPhone 16 256GB ウルトラマリン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYE03JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1863",
    brand: "Apple",
    sku: "MYE13J/A",
    product_eng: "iPhone 16 256GB Teal",
    product_jpn: "iPhone 16 256GB ティール",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYE13JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1864",
    brand: "Apple",
    sku: "MYDY3J/A",
    product_eng: "iPhone 16 256GB Pink",
    product_jpn: "iPhone 16 256GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYDY3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1865",
    brand: "Apple",
    sku: "MYDX3J/A",
    product_eng: "iPhone 16 256GB White",
    product_jpn: "iPhone 16 256GB ホワイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYDX3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1866",
    brand: "Apple",
    sku: "MYDW3J/A",
    product_eng: "iPhone 16 256GB Black",
    product_jpn: "iPhone 16 256GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥127,091",
    rrp_with_vat: "¥139,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYDW3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1867",
    brand: "Apple",
    sku: "MYE53J/A",
    product_eng: "iPhone 16 512GB Ultramarine",
    product_jpn: "iPhone 16 512GB ウルトラマリン",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYE53JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1868",
    brand: "Apple",
    sku: "MYE63J/A",
    product_eng: "iPhone 16 512GB Teal",
    product_jpn: "iPhone 16 512GB ティール",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYE63JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1869",
    brand: "Apple",
    sku: "MYE43J/A",
    product_eng: "iPhone 16 512GB Pink",
    product_jpn: "iPhone 16 512GB ピンク",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYE43JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1870",
    brand: "Apple",
    sku: "MYE33J/A",
    product_eng: "iPhone 16 512GB White",
    product_jpn: "iPhone 16 512GB ホワイト",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYE33JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1871",
    brand: "Apple",
    sku: "MYE23J/A",
    product_eng: "iPhone 16 512GB Black",
    product_jpn: "iPhone 16 512GB ブラック",
    category_1: "Electronics",
    category_2: "Smartphone",
    rrp_ex_vat: "¥154,364",
    rrp_with_vat: "¥169,800",
    description_eng:
      "Apple Intelligence. Great Possibilities in its Hands.  The iPhone 16 is designed for Apple Intelligence. This personal intelligence system helps you write, express yourself, and complete tasks with ease. A18 Chip. The A18 chip powers the next generation of photo and video features and lets you play console-class games, while being exceptionally power efficient. A significantly improved battery. Up to 22 hours of video playback. Aerospace-grade aluminum 6.1” design, rugged new generation Ceramic Shield front, action buttons, USB-C, and a new, more powerful, and more powerful USB port. Camera Controls. Easier and quicker access to camera tools.  Width: 71.6 mm Height: 147.6 mm Thickness: 7.80 mm Weight: 170 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple Intelligence. その手に大きな可能性を。  ・iPhone 16は、Apple Intelligenceのために設計されています。このパーソナルなインテリジェンスシステムは、あなたが文章を書いたり、自分を表現したり、タスクを簡単にこなせるようにサポート。 ・A18チップ。並外れた電力効率を持ちながら、写真とビデオの次世代の機能をパワフルに動かし、コンソール級のゲームもプレイできるようにします。 ・大きく進化したバッテリー。最大22時間のビデオ再生。 ・航空宇宙産業レベルのアルミニウムを採用した6.1インチのデザイン、頑丈な最新世代のCeramic Shieldの前面、アクションボタン、USB-C ・カメラコントロール。カメラのツールに、より簡単にすばやくアクセス。  幅：71.6 mm 高さ：147.6 mm 厚さ：7.80 mm 重量：170 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone16/MYE23JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1872",
    brand: "Apple",
    sku: "MX4D3J/A",
    product_eng:
      "Apple Watch Ultra 2(GPS+Cellular)49mm Natural Titanium/Navy Ocean Band",
    product_jpn:
      "Apple Watch Ultra 2(GPS + Cellular)49mmナチュラルチタニウムケースとネイビーオーシャンバンド",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥117,091",
    rrp_with_vat: "¥128,800",
    description_eng:
      "The ultimate watch for sports and adventure. It supports you every day with communication and health and safety features. With GPS for greater accuracy than any sports watch, your workouts will never be the same.  ●The brightest display in Apple's history at 3,000 nits.  ●Complies with EN13319, the internationally recognized standard for diving accessories ●36 hours of maximum use. Up to 72 hours in low power mode. Up to 80% charge in approx. 1 hour Fast charging. ●Sensors  Electric heart rate sensor / 3rd generation optical heart rate sensor / Skin temperature sensor / Blood oxygen wellness sensor / Depth gauge (±1m accuracy) / Water temperature sensor / Compass / Constantly measuring altimeter / High gravity acceleration sensor / High dynamic range gyroscope / Ambient light sensor ●Health and Wellness Blood oxygen wellness app / ECG app / Cycle recording app to estimate past ovulation / Heart rate app / High and low heart rate notification / Irregular heart rhythm notification / Medication app / Mindfulness app / Noise app / Sleep app for sleep stages / Sleep apnea notification ●Size and weight Height: 49mm / Width: 44mm / Thickness: 14.4mm 410 x 502 pixels Display area: 1,185 square millimeters Weight: 61.4 g Fits wrists 130-210 mm  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "スポーツと冒険のための究極の腕時計です。 通信機能や健康と安全を守る機能で毎日をサポート。 どんなスポーツウォッチよりも高い精度を発揮するGPSで、あなたのトレーニングを進化させます。  ● 3,000ニト Apple史上、最も明るいディスプレイ  ●国際的に認められたダイビングアクセサリの規格であるEN13319に準拠 ●最大使用36時間。低電力モードで最大72時間。約1時間で最大80%充電高速充電。 ●センサー  電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/水深計（±1mの精度）/水温センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ●サイズと重量 ・縦：49mm/横：44mm/厚さ：14.4mm ・410 x 502ピクセル ・1,185平方ミリメートルの表示領域 ・重量：61.4 g ・130-210mmの手首にフィット  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchUltra2/MX4D3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1873",
    brand: "Apple",
    sku: "MX4F3J/A",
    product_eng:
      "Apple Watch Ultra 2(GPS+Cellular)49mm Natural Titanium/Tan Alpine Loop M",
    product_jpn:
      "Apple Watch Ultra 2(GPS + Cellular) 49mmナチュラルチタニウムケースとタンアルパインループ - M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥117,091",
    rrp_with_vat: "¥128,800",
    description_eng:
      "The ultimate watch for sports and adventure. It supports you every day with communication and health and safety features. With GPS for greater accuracy than any sports watch, your workouts will never be the same.  ●The brightest display in Apple's history at 3,000 nits.  ●Complies with EN13319, the internationally recognized standard for diving accessories ●36 hours of maximum use. Up to 72 hours in low power mode. Up to 80% charge in approx. 1 hour Fast charging. ●Sensors  Electric heart rate sensor / 3rd generation optical heart rate sensor / Skin temperature sensor / Blood oxygen wellness sensor / Depth gauge (±1m accuracy) / Water temperature sensor / Compass / Constantly measuring altimeter / High gravity acceleration sensor / High dynamic range gyroscope / Ambient light sensor ●Health and Wellness Blood oxygen wellness app / ECG app / Cycle recording app to estimate past ovulation / Heart rate app / High and low heart rate notification / Irregular heart rhythm notification / Medication app / Mindfulness app / Noise app / Sleep app for sleep stages / Sleep apnea notification ●Size and weight Height: 49mm / Width: 44mm / Thickness: 14.4mm 410 x 502 pixels Display area: 1,185 square millimeters Weight: 61.4 g Fits wrists 130-210 mm  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "スポーツと冒険のための究極の腕時計です。 通信機能や健康と安全を守る機能で毎日をサポート。 どんなスポーツウォッチよりも高い精度を発揮するGPSで、あなたのトレーニングを進化させます。  ● 3,000ニト Apple史上、最も明るいディスプレイ  ●国際的に認められたダイビングアクセサリの規格であるEN13319に準拠 ●最大使用36時間。低電力モードで最大72時間。約1時間で最大80%充電高速充電。 ●センサー  電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/水深計（±1mの精度）/水温センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ●サイズと重量 ・縦：49mm/横：44mm/厚さ：14.4mm ・410 x 502ピクセル ・1,185平方ミリメートルの表示領域 ・重量：61.4 g ・130-210mmの手首にフィット  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchUltra2/MX4F3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1874",
    brand: "Apple",
    sku: "MX4L3J/A",
    product_eng:
      "Apple Watch Ultra 2(GPS+Cellular)49mm Natural Titanium/Blue Trail Loop M/L",
    product_jpn:
      "Apple Watch Ultra 2(GPS + Cellular) 49mmナチュラルチタニウムケースとBlueトレイルループ - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥117,091",
    rrp_with_vat: "¥128,800",
    description_eng:
      "The ultimate watch for sports and adventure. It supports you every day with communication and health and safety features. With GPS for greater accuracy than any sports watch, your workouts will never be the same.  ●The brightest display in Apple's history at 3,000 nits.  ●Complies with EN13319, the internationally recognized standard for diving accessories ●36 hours of maximum use. Up to 72 hours in low power mode. Up to 80% charge in approx. 1 hour Fast charging. ●Sensors  Electric heart rate sensor / 3rd generation optical heart rate sensor / Skin temperature sensor / Blood oxygen wellness sensor / Depth gauge (±1m accuracy) / Water temperature sensor / Compass / Constantly measuring altimeter / High gravity acceleration sensor / High dynamic range gyroscope / Ambient light sensor ●Health and Wellness Blood oxygen wellness app / ECG app / Cycle recording app to estimate past ovulation / Heart rate app / High and low heart rate notification / Irregular heart rhythm notification / Medication app / Mindfulness app / Noise app / Sleep app for sleep stages / Sleep apnea notification ●Size and weight Height: 49mm / Width: 44mm / Thickness: 14.4mm 410 x 502 pixels Display area: 1,185 square millimeters Weight: 61.4 g Fits wrists 130-210 mm  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "スポーツと冒険のための究極の腕時計です。 通信機能や健康と安全を守る機能で毎日をサポート。 どんなスポーツウォッチよりも高い精度を発揮するGPSで、あなたのトレーニングを進化させます。  ● 3,000ニト Apple史上、最も明るいディスプレイ  ●国際的に認められたダイビングアクセサリの規格であるEN13319に準拠 ●最大使用36時間。低電力モードで最大72時間。約1時間で最大80%充電高速充電。 ●センサー  電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/水深計（±1mの精度）/水温センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ●サイズと重量 ・縦：49mm/横：44mm/厚さ：14.4mm ・410 x 502ピクセル ・1,185平方ミリメートルの表示領域 ・重量：61.4 g ・130-210mmの手首にフィット  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchUltra2/MX4L3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1875",
    brand: "Apple",
    sku: "MX5R3J/A",
    product_eng:
      "Apple Watch Ultra 2(GPS+Cellular)49mm Natural Titanium/Titanium Milanese Loop",
    product_jpn:
      "Apple Watch Ultra 2(GPS + Cellular) 49mmナチュラルチタニウムケースとナチュラルチタニウムミラネーゼループ - M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥131,636",
    rrp_with_vat: "¥144,800",
    description_eng:
      "The ultimate watch for sports and adventure. It supports you every day with communication and health and safety features. With GPS for greater accuracy than any sports watch, your workouts will never be the same.  ●The brightest display in Apple's history at 3,000 nits.  ●Complies with EN13319, the internationally recognized standard for diving accessories ●36 hours of maximum use. Up to 72 hours in low power mode. Up to 80% charge in approx. 1 hour Fast charging. ●Sensors  Electric heart rate sensor / 3rd generation optical heart rate sensor / Skin temperature sensor / Blood oxygen wellness sensor / Depth gauge (±1m accuracy) / Water temperature sensor / Compass / Constantly measuring altimeter / High gravity acceleration sensor / High dynamic range gyroscope / Ambient light sensor ●Health and Wellness Blood oxygen wellness app / ECG app / Cycle recording app to estimate past ovulation / Heart rate app / High and low heart rate notification / Irregular heart rhythm notification / Medication app / Mindfulness app / Noise app / Sleep app for sleep stages / Sleep apnea notification ●Size and weight Height: 49mm / Width: 44mm / Thickness: 14.4mm 410 x 502 pixels Display area: 1,185 square millimeters Weight: 61.4 g Fits wrists 130-210 mm  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "スポーツと冒険のための究極の腕時計です。 通信機能や健康と安全を守る機能で毎日をサポート。 どんなスポーツウォッチよりも高い精度を発揮するGPSで、あなたのトレーニングを進化させます。  ● 3,000ニト Apple史上、最も明るいディスプレイ  ●国際的に認められたダイビングアクセサリの規格であるEN13319に準拠 ●最大使用36時間。低電力モードで最大72時間。約1時間で最大80%充電高速充電。 ●センサー  電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/水深計（±1mの精度）/水温センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ●サイズと重量 ・縦：49mm/横：44mm/厚さ：14.4mm ・410 x 502ピクセル ・1,185平方ミリメートルの表示領域 ・重量：61.4 g ・155-185mmの手首にフィット  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchUltra2/MX5R3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1876",
    brand: "Apple",
    sku: "MX4P3J/A",
    product_eng:
      "Apple Watch Ultra 2(GPS + Cellular) 49mm Black Titanium/Black Ocean Band",
    product_jpn:
      "Apple Watch Ultra 2(GPS + Cellular) 49mmブラックチタニウムケースとブラックオーシャンバンド",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥117,091",
    rrp_with_vat: "¥128,800",
    description_eng:
      "The ultimate watch for sports and adventure. It supports you every day with communication and health and safety features. With GPS for greater accuracy than any sports watch, your workouts will never be the same.  ●The brightest display in Apple's history at 3,000 nits.  ●Complies with EN13319, the internationally recognized standard for diving accessories ●36 hours of maximum use. Up to 72 hours in low power mode. Up to 80% charge in approx. 1 hour Fast charging. ●Sensors  Electric heart rate sensor / 3rd generation optical heart rate sensor / Skin temperature sensor / Blood oxygen wellness sensor / Depth gauge (±1m accuracy) / Water temperature sensor / Compass / Constantly measuring altimeter / High gravity acceleration sensor / High dynamic range gyroscope / Ambient light sensor ●Health and Wellness Blood oxygen wellness app / ECG app / Cycle recording app to estimate past ovulation / Heart rate app / High and low heart rate notification / Irregular heart rhythm notification / Medication app / Mindfulness app / Noise app / Sleep app for sleep stages / Sleep apnea notification ●Size and weight Height: 49mm / Width: 44mm / Thickness: 14.4mm 410 x 502 pixels Display area: 1,185 square millimeters Weight: 61.8 g Fits wrists 130-210 mm  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "スポーツと冒険のための究極の腕時計です。 通信機能や健康と安全を守る機能で毎日をサポート。 どんなスポーツウォッチよりも高い精度を発揮するGPSで、あなたのトレーニングを進化させます。  ● 3,000ニト Apple史上、最も明るいディスプレイ  ●国際的に認められたダイビングアクセサリの規格であるEN13319に準拠 ●最大使用36時間。低電力モードで最大72時間。約1時間で最大80%充電高速充電。 ●センサー  電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/水深計（±1mの精度）/水温センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ●サイズと重量 ・縦：49mm/横：44mm/厚さ：14.4mm ・410 x 502ピクセル ・1,185平方ミリメートルの表示領域 ・重量：61.8 g ・130-210mmの手首にフィット  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchUltra2/MX4P3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1877",
    brand: "Apple",
    sku: "MX4R3J/A",
    product_eng:
      "Apple Watch Ultra 2(GPS + Cellular) 49mm Black Titanium/Dark Green Alpine Loop M",
    product_jpn:
      "Apple Watch Ultra 2(GPS + Cellular) 49mmブラックチタニウムケースとダークグリーンアルパインループ - M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥117,091",
    rrp_with_vat: "¥128,800",
    description_eng:
      "The ultimate watch for sports and adventure. It supports you every day with communication and health and safety features. With GPS for greater accuracy than any sports watch, your workouts will never be the same.  ●The brightest display in Apple's history at 3,000 nits.  ●Complies with EN13319, the internationally recognized standard for diving accessories ●36 hours of maximum use. Up to 72 hours in low power mode. Up to 80% charge in approx. 1 hour Fast charging. ●Sensors  Electric heart rate sensor / 3rd generation optical heart rate sensor / Skin temperature sensor / Blood oxygen wellness sensor / Depth gauge (±1m accuracy) / Water temperature sensor / Compass / Constantly measuring altimeter / High gravity acceleration sensor / High dynamic range gyroscope / Ambient light sensor ●Health and Wellness Blood oxygen wellness app / ECG app / Cycle recording app to estimate past ovulation / Heart rate app / High and low heart rate notification / Irregular heart rhythm notification / Medication app / Mindfulness app / Noise app / Sleep app for sleep stages / Sleep apnea notification ●Size and weight Height: 49mm / Width: 44mm / Thickness: 14.4mm 410 x 502 pixels Display area: 1,185 square millimeters Weight: 61.8 g Fits wrists 130-210 mm  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "スポーツと冒険のための究極の腕時計です。 通信機能や健康と安全を守る機能で毎日をサポート。 どんなスポーツウォッチよりも高い精度を発揮するGPSで、あなたのトレーニングを進化させます。  ● 3,000ニト Apple史上、最も明るいディスプレイ  ●国際的に認められたダイビングアクセサリの規格であるEN13319に準拠 ●最大使用36時間。低電力モードで最大72時間。約1時間で最大80%充電高速充電。 ●センサー  電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/水深計（±1mの精度）/水温センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ●サイズと重量 ・縦：49mm/横：44mm/厚さ：14.4mm ・410 x 502ピクセル ・1,185平方ミリメートルの表示領域 ・重量：61.8 g ・130-210mmの手首にフィット  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchUltra2/MX4R3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1878",
    brand: "Apple",
    sku: "MX4V3J/A",
    product_eng:
      "Apple Watch Ultra 2(GPS + Cellular) 49mm Black Titanium/Black Trail Loop M/L",
    product_jpn:
      "Apple Watch Ultra 2(GPS + Cellular) 49mmブラックチタニウムケースとブラックトレイルループ - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥117,091",
    rrp_with_vat: "¥128,800",
    description_eng:
      "The ultimate watch for sports and adventure. It supports you every day with communication and health and safety features. With GPS for greater accuracy than any sports watch, your workouts will never be the same.  ●The brightest display in Apple's history at 3,000 nits.  ●Complies with EN13319, the internationally recognized standard for diving accessories ●36 hours of maximum use. Up to 72 hours in low power mode. Up to 80% charge in approx. 1 hour Fast charging. ●Sensors  Electric heart rate sensor / 3rd generation optical heart rate sensor / Skin temperature sensor / Blood oxygen wellness sensor / Depth gauge (±1m accuracy) / Water temperature sensor / Compass / Constantly measuring altimeter / High gravity acceleration sensor / High dynamic range gyroscope / Ambient light sensor ●Health and Wellness Blood oxygen wellness app / ECG app / Cycle recording app to estimate past ovulation / Heart rate app / High and low heart rate notification / Irregular heart rhythm notification / Medication app / Mindfulness app / Noise app / Sleep app for sleep stages / Sleep apnea notification ●Size and weight Height: 49mm / Width: 44mm / Thickness: 14.4mm 410 x 502 pixels Display area: 1,185 square millimeters Weight: 61.8 g Fits wrists 130-210 mm  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "スポーツと冒険のための究極の腕時計です。 通信機能や健康と安全を守る機能で毎日をサポート。 どんなスポーツウォッチよりも高い精度を発揮するGPSで、あなたのトレーニングを進化させます。  ● 3,000ニト Apple史上、最も明るいディスプレイ  ●国際的に認められたダイビングアクセサリの規格であるEN13319に準拠 ●最大使用36時間。低電力モードで最大72時間。約1時間で最大80%充電高速充電。 ●センサー  電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/水深計（±1mの精度）/水温センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ●サイズと重量 ・縦：49mm/横：44mm/厚さ：14.4mm ・410 x 502ピクセル ・1,185平方ミリメートルの表示領域 ・重量：61.8 g ・130-210mmの手首にフィット  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchUltra2/MX4V3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1879",
    brand: "Apple",
    sku: "MX5U3J/A",
    product_eng:
      "Apple Watch Ultra 2(GPS + Cellular) 49mm Black Titanium/Black Titanium Milanese Loop M",
    product_jpn:
      "Apple Watch Ultra 2(GPS + Cellular) 49mmブラックチタニウムケースとブラックチタニウムミラネーゼループ - M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥131,636",
    rrp_with_vat: "¥144,800",
    description_eng:
      "The ultimate watch for sports and adventure. It supports you every day with communication and health and safety features. With GPS for greater accuracy than any sports watch, your workouts will never be the same.  ●The brightest display in Apple's history at 3,000 nits.  ●Complies with EN13319, the internationally recognized standard for diving accessories ●36 hours of maximum use. Up to 72 hours in low power mode. Up to 80% charge in approx. 1 hour Fast charging. ●Sensors  Electric heart rate sensor / 3rd generation optical heart rate sensor / Skin temperature sensor / Blood oxygen wellness sensor / Depth gauge (±1m accuracy) / Water temperature sensor / Compass / Constantly measuring altimeter / High gravity acceleration sensor / High dynamic range gyroscope / Ambient light sensor ●Health and Wellness Blood oxygen wellness app / ECG app / Cycle recording app to estimate past ovulation / Heart rate app / High and low heart rate notification / Irregular heart rhythm notification / Medication app / Mindfulness app / Noise app / Sleep app for sleep stages / Sleep apnea notification ●Size and weight Height: 49mm / Width: 44mm / Thickness: 14.4mm 410 x 502 pixels Display area: 1,185 square millimeters Weight: 61.8 g Fits wrists 155-185mm  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "スポーツと冒険のための究極の腕時計です。 通信機能や健康と安全を守る機能で毎日をサポート。 どんなスポーツウォッチよりも高い精度を発揮するGPSで、あなたのトレーニングを進化させます。  ● 3,000ニト Apple史上、最も明るいディスプレイ  ●国際的に認められたダイビングアクセサリの規格であるEN13319に準拠 ●最大使用36時間。低電力モードで最大72時間。約1時間で最大80%充電高速充電。 ●センサー  電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/水深計（±1mの精度）/水温センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ●サイズと重量 ・縦：49mm/横：44mm/厚さ：14.4mm ・410 x 502ピクセル ・1,185平方ミリメートルの表示領域 ・重量：61.8 g ・155-185mmの手首にフィット  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchUltra2/MX5U3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1880",
    brand: "Apple",
    sku: "MWX33J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 42mm Silver Aluminum Case/Denim Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 42mmシルバーアルミニウムケースとデニムスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥68,909",
    rrp_with_vat: "¥75,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS + Cellular model): 29.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）： 29.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWX33JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1881",
    brand: "Apple",
    sku: "MWX43J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 42mm Silver Aluminum Case/Denim Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 42mmシルバーアルミニウムケースとデニムスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥68,909",
    rrp_with_vat: "¥75,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS + Cellular model): 29.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）： 29.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWX43JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1882",
    brand: "Apple",
    sku: "MWX93J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 42mm Rose Gold Aluminum Case/Light Blush Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 42mmローズゴールドアルミニウムケースとライトブラッシュスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥68,909",
    rrp_with_vat: "¥75,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS + Cellular model): 29.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）： 29.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWX93JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1883",
    brand: "Apple",
    sku: "MWXA3J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 42mm Rose Gold Aluminum Case/Light Blush Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 42mmローズゴールドアルミニウムケースとライトブラッシュスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥68,909",
    rrp_with_vat: "¥75,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS + Cellular model): 29.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）： 29.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWXA3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1884",
    brand: "Apple",
    sku: "MWX63J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 42mm Jet Black Aluminum Case/Black Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 42mmジェットブラックアルミニウムケースとブラックスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥68,909",
    rrp_with_vat: "¥75,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS + Cellular model): 29.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）： 29.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWX63JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1885",
    brand: "Apple",
    sku: "MWX73J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 42mm Jet Black Aluminum Case/Black Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 42mmジェットブラックアルミニウムケースとブラックスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥68,909",
    rrp_with_vat: "¥75,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS + Cellular model): 29.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）： 29.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWX73JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1886",
    brand: "Apple",
    sku: "MWXD3J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 42mm Natural Titanium Case/Stone Gray Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 42mmナチュラルチタニウムケースとストーングレイスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥99,818",
    rrp_with_vat: "¥109,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (titanium): 34.4 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（チタニウム）：34.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWXD3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1887",
    brand: "Apple",
    sku: "MWXF3J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 42mm Natural Titanium Case/Natural Milanese Loop",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 42mmナチュラルチタニウムケースとナチュラルミラネーゼループ",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥107,091",
    rrp_with_vat: "¥117,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (titanium): 34.4 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（チタニウム）：34.4 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWXF3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1888",
    brand: "Apple",
    sku: "MX083J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 42mm Gold Titanium Case/Gold Milanese Loop",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 42mmゴールドチタニウムケースとゴールドミラネーゼループ",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥107,091",
    rrp_with_vat: "¥117,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (titanium): 34.4 g   Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（チタニウム）：34.4 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MX083JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1889",
    brand: "Apple",
    sku: "MWY03J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 46mm Silver Aluminum Case/Denim Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 46mmシルバーアルミニウムケースとデニムスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥73,455",
    rrp_with_vat: "¥80,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS + Cellular model): 35.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）：35.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWY03JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1890",
    brand: "Apple",
    sku: "MWY13J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 46mm Silver Aluminum Case/Denim Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 46mmシルバーアルミニウムケースとデニムスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥73,455",
    rrp_with_vat: "¥80,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS + Cellular model): 35.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）：35.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWY13JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1891",
    brand: "Apple",
    sku: "MWY63J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 46mm Rose Gold Aluminum Case/Light Blush Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 46mmローズゴールドアルミニウムケースとライトブラッシュスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥73,455",
    rrp_with_vat: "¥80,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS + Cellular model): 35.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）：35.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWY63JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1892",
    brand: "Apple",
    sku: "MWY73J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 46mm Rose Gold Aluminum Case/Light Blush Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 46mmローズゴールドアルミニウムケースとライトブラッシュスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥73,455",
    rrp_with_vat: "¥80,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS + Cellular model): 35.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）：35.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWY73JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1893",
    brand: "Apple",
    sku: "MWY33J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 46mm Jet Black Aluminum Case/Black Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 46mmジェットブラックアルミニウムケースとブラックスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥73,455",
    rrp_with_vat: "¥80,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS + Cellular model): 35.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）：35.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWY33JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1894",
    brand: "Apple",
    sku: "MWY43J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 46mm Jet Black Aluminum Case/Black Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 46mmジェットブラックアルミニウムケースとブラックスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥73,455",
    rrp_with_vat: "¥80,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS + Cellular model): 35.3 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPS + Cellularモデル）：35.3 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWY43JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1895",
    brand: "Apple",
    sku: "MWYA3J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 46mm Natural Titanium Case/Stone Gray Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 46mmナチュラルチタニウムケースとストーングレイスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥107,091",
    rrp_with_vat: "¥117,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (titanium): 41.7 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（チタニウム）：41.7 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWYA3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1896",
    brand: "Apple",
    sku: "MC7Q4J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 46mm Natural Titanium Case/Natural Milanese Loop",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 46mmナチュラルチタニウムケースとナチュラルミラネーゼループ",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥114,364",
    rrp_with_vat: "¥125,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (titanium): 41.7 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（チタニウム）：41.7 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MC7Q4JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1897",
    brand: "Apple",
    sku: "MC7R4J/A",
    product_eng:
      "Apple Watch Series 10(GPS + Cellular) 46mm Slate Titanium Case/Slate Milanese Loop",
    product_jpn:
      "Apple Watch Series 10(GPS + Cellular) 46mmスレートチタニウムケースとスレートミラネーゼループ",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥114,364",
    rrp_with_vat: "¥125,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (titanium): 41.7 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（チタニウム）：41.7 g  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MC7R4JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1898",
    brand: "Apple",
    sku: "MWWA3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 42mm Silver Aluminum Case/Denim Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10 GPS 42mmシルバーアルミニウムケースとデニムスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥54,364",
    rrp_with_vat: "¥59,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS model): 30 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWA3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1899",
    brand: "Apple",
    sku: "MWWC3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 42mm Silver Aluminum Case/Denim Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10 GPS 42mmシルバーアルミニウムケースとデニムスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥54,364",
    rrp_with_vat: "¥59,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS model): 30 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWC3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1900",
    brand: "Apple",
    sku: "MWWH3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 42mm Rose Gold Aluminum Case/Light Blush Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10 GPS 42mmローズゴールドアルミニウムケースとライトブラッシュスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥54,364",
    rrp_with_vat: "¥59,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS model): 30 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWH3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1901",
    brand: "Apple",
    sku: "MWWJ3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 42mm Rose Gold Aluminum Case/Light Blush Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10 GPS 42mmローズゴールドアルミニウムケースとライトブラッシュスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥54,364",
    rrp_with_vat: "¥59,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS model): 30 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWJ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1902",
    brand: "Apple",
    sku: "MWWE3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 42mm Jet Black Aluminum Case/Black Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10 GPS 42mmジェットブラックアルミニウムケースとブラックスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥54,364",
    rrp_with_vat: "¥59,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS model): 30 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWE3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1903",
    brand: "Apple",
    sku: "MWWF3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 42mm Jet Black Aluminum Case/Black Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10 GPS 42mmジェットブラックアルミニウムケースとブラックスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥54,364",
    rrp_with_vat: "¥59,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 42 mm Width: 36 mm Thickness: 9.7 mm 374 x 446 pixels 989 square millimeter display area Weight (aluminum, GPS model): 30 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：42mm 横：36mm 厚さ：9.7mm 374 x 446ピクセル 989平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWF3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1904",
    brand: "Apple",
    sku: "MWWL3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 46mm Silver Aluminum Case/Denim Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10 GPS 46mmシルバーアルミニウムケースとデニムスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥58,909",
    rrp_with_vat: "¥64,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS model): 36.4 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWL3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1905",
    brand: "Apple",
    sku: "MWWM3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 46mm Silver Aluminum Case/Denim Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10 GPS 46mmシルバーアルミニウムケースとデニムスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥58,909",
    rrp_with_vat: "¥64,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS model): 36.4 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWM3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1906",
    brand: "Apple",
    sku: "MWWT3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 46mm Rose Gold Aluminum Case/Light Blush Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10 GPS 46mmローズゴールドアルミニウムケースとライトブラッシュスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥58,909",
    rrp_with_vat: "¥64,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS model): 36.4 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWT3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1907",
    brand: "Apple",
    sku: "MWWU3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 46mm Rose Gold Aluminum Case/Light Blush Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10 GPS 46mmローズゴールドアルミニウムケースとライトブラッシュスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥58,909",
    rrp_with_vat: "¥64,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS model): 36.4 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWU3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1908",
    brand: "Apple",
    sku: "MWWP3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 46mm Jet Black Aluminum Case/Black Sport Band S/M",
    product_jpn:
      "Apple Watch Series 10 GPS 46mmジェットブラックアルミニウムケースとブラックスポーツバンド - S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥58,909",
    rrp_with_vat: "¥64,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS model): 36.4 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWP3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1909",
    brand: "Apple",
    sku: "MWWQ3J/A",
    product_eng:
      "Apple Watch Series 10 GPS 46mm Jet Black Aluminum Case/Black Sport Band M/L",
    product_jpn:
      "Apple Watch Series 10 GPS 46mmジェットブラックアルミニウムケースとブラックスポーツバンド - M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥58,909",
    rrp_with_vat: "¥64,800",
    description_eng:
      "Thinstant classic.  ●The thinnest Apple Watch with the largest display. ●Sensors Electric heart rate sensor / 3rd generation optical heart rate sensor / skin temperature sensor / blood oxygen wellness sensor / compass / constantly monitored altimeter / high gravity acceleration sensor / high dynamic range gyroscope / ambient light sensor / depth gauge / water temperature sensor ●Health and Wellness Blood oxygen wellness app / EKG app / Cycle recording app to estimate past ovulation / Heart rate app / Notification of high and low heart rate / Notification of irregular heart rhythm / Medication app / Mindfulness app to record state of mind / Noise app / Sleep app to support sleep stages / Sleep apnea Notification of sleep apnea ●All-day battery life. Up to 18 hours of normal use7 / Up to 36 hours in low power mode / Up to 80% charge in about 30 minutes / Up to 8 hours of normal use with a 15 minute charge / Up to 8 hours of sleep recording with an 8 minute charge ●Size and weight Height: 46mm Width: 39mm Thickness: 9.7mm 416 x 496 pixels Display area of 1,220 square millimeters Weight (aluminum, GPS model): 36.4 g ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order",
    description_jpn:
      "大いなる薄さ  ●最も薄いApple Watch。最も大きいディスプレイを搭載。 ●センサー 電気心拍センサー/第3世代の光学式心拍センサー/皮膚温センサー/血中酸素ウェルネスセンサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー/水深計/水温センサー ●健康とウェルネス 血中酸素ウェルネスアプリ/心電図アプリ/過去の排卵を推定できる周期記録アプリ/心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/心の状態を記録できるマインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ/睡眠時無呼吸の通知 ● 一日中駆動するバッテリー。 通常使用時で最大18時間7/低電力モードで最大36時間/約30分で最大80%充電/15分間の充電で最大8時間の通常使用/8分間の充電で最大8時間の睡眠記録 ●サイズと重量 縦：46mm 横：39mm 厚さ：9.7mm 416 x 496ピクセル 1,220平方ミリメートルの表示領域 重量（アルミニウム、GPSモデル）：36.4 g ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatch10/MWWQ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1910",
    brand: "Apple",
    sku: "MXGF3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 40mm Silver Aluminum Case/Denim Sport Band S/M",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 40mmシルバーアルミニウムケースとデニムスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥38,909",
    rrp_with_vat: "¥42,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGF3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1911",
    brand: "Apple",
    sku: "MXGG3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 40mm Silver Aluminum Case/Denim Sport Band M/L",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 40mmシルバーアルミニウムケースとデニムスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥38,909",
    rrp_with_vat: "¥42,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGG3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1912",
    brand: "Apple",
    sku: "MXGJ3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 40mm Starlight Aluminium Case/Starlight Sport Band S/M",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 40mmスターライトアルミニウムケースとスターライトスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥38,909",
    rrp_with_vat: "¥42,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGJ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1913",
    brand: "Apple",
    sku: "MXGK3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 40mm Starlight Aluminium Case/Starlight Sport Band M/L",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 40mmスターライトアルミニウムケースとスターライトスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥38,909",
    rrp_with_vat: "¥42,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGK3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1914",
    brand: "Apple",
    sku: "MXGC3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 40mm Midnight Aluminium Case/Midnight Sport Band S/M",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 40mmミッドナイトアルミニウムケースとミッドナイトスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥38,909",
    rrp_with_vat: "¥42,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGC3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1915",
    brand: "Apple",
    sku: "MXGD3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 40mm Midnight Aluminium Case/Midnight Sport Band M/L",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 40mmミッドナイトアルミニウムケースとミッドナイトスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥38,909",
    rrp_with_vat: "¥42,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGD3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1916",
    brand: "Apple",
    sku: "MXGP3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 44mm Silver Aluminum Case/Denim Sport Band S/M",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 44mmシルバーアルミニウムケースとデニムスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥43,455",
    rrp_with_vat: "¥47,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGP3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1917",
    brand: "Apple",
    sku: "MXGQ3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 44mm Silver Aluminum Case/Denim Sport Band M/L",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 44mmシルバーアルミニウムケースとデニムスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥43,455",
    rrp_with_vat: "¥47,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGQ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1918",
    brand: "Apple",
    sku: "MXGT3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 44mm Starlight Aluminium Case/Starlight Sport Band S/M",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 44mmスターライトアルミニウムケースとスターライトスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥43,455",
    rrp_with_vat: "¥47,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGT3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1919",
    brand: "Apple",
    sku: "MXGU3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 44mm Starlight Aluminium Case/Starlight Sport Band M/L",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 44mmスターライトアルミニウムケースとスターライトスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥43,455",
    rrp_with_vat: "¥47,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGU3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1920",
    brand: "Apple",
    sku: "MXGL3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 44mm Midnight Aluminium Case/Midnight Sport Band S/M",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 44mmミッドナイトアルミニウムケースとミッドナイトスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥43,455",
    rrp_with_vat: "¥47,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGL3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1921",
    brand: "Apple",
    sku: "MXGM3J/A",
    product_eng:
      "Apple Watch SE(GPS + Cellular) 44mm Midnight Aluminium Case/Midnight Sport Band M/L",
    product_jpn:
      "Apple Watch SE(GPS + Cellular) 44mmミッドナイトアルミニウムケースとミッドナイトスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥43,455",
    rrp_with_vat: "¥47,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXGM3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1922",
    brand: "Apple",
    sku: "MXEC3J/A",
    product_eng:
      "Apple Watch SE GPS 40mm Silver Aluminum Case/Denim Sport Band S/M",
    product_jpn:
      "Apple Watch SE GPS 40mmシルバーアルミニウムケースとデニムスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥31,636",
    rrp_with_vat: "¥34,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXEC3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1923",
    brand: "Apple",
    sku: "MXED3J/A",
    product_eng:
      "Apple Watch SE GPS 40mm Silver Aluminum Case/Denim Sport Band M/L",
    product_jpn:
      "Apple Watch SE GPS 40mmシルバーアルミニウムケースとデニムスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥31,636",
    rrp_with_vat: "¥34,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXED3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1924",
    brand: "Apple",
    sku: "MXEF3J/A",
    product_eng:
      "Apple Watch SE GPS 40mm Starlight Aluminium Case/Starlight Sport Band S/M",
    product_jpn:
      "Apple Watch SE GPS 40mmスターライトアルミニウムケースとスターライトスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥31,636",
    rrp_with_vat: "¥34,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXEF3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1925",
    brand: "Apple",
    sku: "MXEG3J/A",
    product_eng:
      "Apple Watch SE GPS 40mm Starlight Aluminium Case/Starlight Sport Band M/L",
    product_jpn:
      "Apple Watch SE GPS 40mmスターライトアルミニウムケースとスターライトスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥31,636",
    rrp_with_vat: "¥34,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXEG3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1926",
    brand: "Apple",
    sku: "MXE73J/A",
    product_eng:
      "Apple Watch SE GPS 40mm Midnight Aluminium Case/Midnight Sport Band S/M",
    product_jpn:
      "Apple Watch SE GPS 40mmミッドナイトアルミニウムケースとミッドナイトスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥31,636",
    rrp_with_vat: "¥34,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXE73JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1927",
    brand: "Apple",
    sku: "MXE93J/A",
    product_eng:
      "Apple Watch SE GPS 40mm Midnight Aluminium Case/Midnight Sport Band M/L",
    product_jpn:
      "Apple Watch SE GPS 40mmミッドナイトアルミニウムケースとミッドナイトスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥31,636",
    rrp_with_vat: "¥34,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 40 mm, width: 34 mm, thickness: 10.7 mm 324 x 394 pixels 759 sq. mm display area Weight (GPS model): 26.4 g Weight (GPS + Cellular model): 27.8 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：40mm 横：34mm 厚さ：10.7mm 324 x 394ピクセル 759平方ミリメートルの表示領域 重量（GPSモデル）：26.4 g 重量（GPS + Cellularモデル）：27.8 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXE93JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1928",
    brand: "Apple",
    sku: "MXEQ3J/A",
    product_eng:
      "Apple Watch SE GPS 44mm Silver Aluminum Case/Denim Sport Band S/M",
    product_jpn:
      "Apple Watch SE GPS 44mmシルバーアルミニウムケースとデニムスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥36,182",
    rrp_with_vat: "¥39,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXEQ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1929",
    brand: "Apple",
    sku: "MXER3J/A",
    product_eng:
      "Apple Watch SE GPS 44mm Silver Aluminum Case/Denim Sport Band M/L",
    product_jpn:
      "Apple Watch SE GPS 44mmシルバーアルミニウムケースとデニムスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥36,182",
    rrp_with_vat: "¥39,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXER3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1930",
    brand: "Apple",
    sku: "MXEU3J/A",
    product_eng:
      "Apple Watch SE GPS 44mm Starlight Aluminium Case/Starlight Sport Band S/M",
    product_jpn:
      "Apple Watch SE GPS 44mmスターライトアルミニウムケースとスターライトスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥36,182",
    rrp_with_vat: "¥39,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXEU3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1931",
    brand: "Apple",
    sku: "MXEV3J/A",
    product_eng:
      "Apple Watch SE GPS 44mm Starlight Aluminium Case/Starlight Sport Band M/L",
    product_jpn:
      "Apple Watch SE GPS 44mmスターライトアルミニウムケースとスターライトスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥36,182",
    rrp_with_vat: "¥39,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXEV3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1932",
    brand: "Apple",
    sku: "MXEJ3J/A",
    product_eng:
      "Apple Watch SE GPS 44mm Midnight Aluminium Case/Midnight Sport Band S/M",
    product_jpn:
      "Apple Watch SE GPS 44mmミッドナイトアルミニウムケースとミッドナイトスポーツバンド S/M",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥36,182",
    rrp_with_vat: "¥39,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXEJ3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1933",
    brand: "Apple",
    sku: "MXEK3J/A",
    product_eng:
      "Apple Watch SE GPS 44mm Midnight Aluminium Case/Midnight Sport Band M/L",
    product_jpn:
      "Apple Watch SE GPS 44mmミッドナイトアルミニウムケースとミッドナイトスポーツバンド M/L",
    category_1: "Electronics",
    category_2: "Watches",
    rrp_ex_vat: "¥36,182",
    rrp_with_vat: "¥39,800",
    description_eng:
      "A great deal to love.  Easy ways to stay connected. Motivating fitness metrics. Innovative health and safety features.Apple Watch SE is packed with features at a feel-good price.  ●Sensors Second-generation optical heart rate sensor/compass/always-on altimeter/high-gravity accelerometer/high dynamic range gyroscope/ambient light sensor  ●Health and Wellness Heart rate app / high and low heart rate notifications / irregular heart rhythm notifications / medication app / mindfulness app / noise app / sleep app with sleep stage support  ●Power and battery All-day battery. Up to 18 hours of normal use. Built-in rechargeable lithium-ion battery Recharges up to 80% in about 1.5 hours  ●Size and weight Height: 44 mm Width: 38 mm Thickness: 10.7 mm 368 x 448 pixels 977 sq. mm display area Weight (GPS model): 32.9 g Weight (GPS + Cellular model): 33 g  ●S/M band fits wrists 130-180 mm; M/L band fits wrists 150-200 mm.  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "こんなにできる。 こんなに手軽。  いつもつながるための簡単な方法。モチベーションをくれるフィットネスの測定値。健康と安全を守るイノベーション。新しいカラーのバンド。Apple Watch SEは、たくさんの機能を、手に入れやすいプライスで届けます。  ●センサー 第2世代の光学式心拍センサー/コンパス/常時計測の高度計/高重力加速度センサー/ハイダイナミックレンジジャイロスコープ/環境光センサー  ●健康とウェルネス 心拍数アプリ/高心拍数と低心拍数の通知/不規則な心拍リズムの通知/服薬アプリ/マインドフルネスアプリ/ノイズアプリ/睡眠ステージ対応の睡眠アプリ  ●電源とバッテリー 一日中駆動するバッテリー。通常使用時で最大18時間。 リチャージャブルリチウムイオンバッテリー内蔵 約1.5時間で最大80%充電  ●サイズと重量 縦：44mm 横：38mm 厚さ：10.7mm 368 x 448ピクセル 977平方ミリメートルの表示領域 重量（GPSモデル）：32.9 g 重量（GPS + Cellularモデル）：33 g  ●S/M バンドは手首が130–180mmの方にフィットします。M/Lバンドは手首が150–200mmの方にフィットします。  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AppleWatchSE/MXEK3JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1934",
    brand: "Apple",
    sku: "MXP63J/A",
    product_eng: "Apple AirPods 4",
    product_jpn: "Apple AirPods 4",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥19,818",
    rrp_with_vat: "¥21,800",
    description_eng:
      "AirPods 4, now available. Taking sound and comfort to the next level.  ■Theatre-like, immersive sound. Personalized spatial audio and dynamic head tracking put sound all around you2, bringing a 3D listening experience to music, TV shows, movies, games, and more. ■We even reworked the wearing comfort. AirPods 4 are exceptionally comfortable to wear. It's also more stable when you're on the move. ■IP54 dustproof and sweat-resistant. ■Size and weight Earphone Height: 30.2 mm, Width: 18.3 mm, Thickness: 18.1 mm, Weight: 4.3 g Case Height: 46.2 mm, Width: 50.1 mm, Thickness: 21.2 mm  Weight (AirPods 4): 32.3 g  ■Included in the box AirPods 4 / Charging case (USB-C) / Manual (USB-C charging cable sold separately)  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "AirPods 4、登場。 サウンドと快適性を、次のレベルへ。  ■シアターのような臨場感あふれるサウンド。 パーソナライズされた空間オーディオとダイナミックヘッドトラッキングが、あなたの周りに音を配置2。音楽、テレビ番組、映画、ゲームなどに3Dのリスニング体験をもたらします。 ■付け心地まで作り直しました AirPods 4の着け心地は格別。動いている時の安定感も向上しました。 ■IP54等級の防塵性能と耐汗耐水性能。 ■サイズと重量 ・イヤフォン 高さ：30.2 mm・幅：18.3 mm・厚さ：18.1 mm・重量：4.3 g ・ケース    高さ：46.2 mm 幅：50.1 mm 厚さ：21.2 mm  重量（AirPods 4）：32.3 g  ■同梱物 AirPods 4/充電ケース（USB-C）/マニュアル （USB-C充電ケーブルは別売りです）  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AirPods4/MXP63JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1935",
    brand: "Apple",
    sku: "MXP93J/A",
    product_eng: "Apple AirPods 4 with Active Noise Cancellation",
    product_jpn: "Apple AirPods 4アクティブノイズキャンセリング搭載",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥27,091",
    rrp_with_vat: "¥29,800",
    description_eng:
      "Iconic. Now supersonic. The next evolution of sound and comfort.  For the first time, AirPods 4 offers a choice of models with active noise cancellation in an open-ear design. Active noise cancellation takes advantage of the power of the H2 chip and an upgraded microphone. It helps reduce ambient low-frequency noise, such as airplane engines, heating and air conditioning systems, and traffic jams, before it reaches your ears. Calls are clearer with the “voice separation” feature, allowing you to answer Siri in a new hands-free way. You'll also love the IP54-rated dust and sweat-resistant performance, and USB-C charging for up to 30 hours of playback time. With active noise cancellation enabled, AirPods 4 offer up to 4 hours of playback time on a single charge. With noise control turned off, up to 5 hours of playback time on a single charge. Up to 4.5 hours of continuous talk time on a single charge.  ＜Size and Weight＞ Earphone Height: 30.2 mm, Width: 18.3 mm, Thickness: 18.1 mm, Weight: 4.3 g Case Height: 46.2 mm, Width: 50.1 mm, Thickness: 21.2 mm  Weight (AirPods 4 with active noise cancellation): 34.7 g   ＜What's included＞ AirPods 4 Charging case (USB-C) Manure (USB-C charging cable sold separately)  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "サウンドと快適性を、次のレベルへ。  AirPods 4では、オープンイヤーデザインで初めてアクティブノイズキャンセリングを搭載したモデルを選べるようになりました。アクティブノイズキャンセリングは、H2チップのパワーとアップグレードされたマイクを活用。飛行機のエンジン、冷暖房空調設備、交通渋滞など、周囲の低周波の雑音をあなたの耳に届く前に低減できるようにします。 「声を分離」機能で通話は一段とクリアになり、新しいハンズフリーの方法でSiriに応答できます。 パーソナライズされた空間オーディオとダイナミックヘッドトラッキングは、あなたの周りに音を配置。 IP54等級の防塵性能と耐汗耐水性能や、USB-C充電による最大30時間の再生時間も魅力です。 「探す」アプリで、AirPods 4の場所を簡単にチェックすることもできます。 アクティブノイズキャンセリングを有効にした場合、1回の充電で最大4時間の再生時間。 ノイズコントロールをオフにした場合、1回の充電で最大5時間の再生時間。 1回の充電で最大4.5時間の連続通話時間  ＜サイズと重量＞ ●イヤフォン 高さ：30.2 mm・幅：18.3 mm・厚さ：18.1 mm・重量：4.3 g ●ケース    高さ：46.2 mm 幅：50.1 mm 厚さ：21.2 mm  重量（アクティブノイズキャンセリング搭載AirPods 4）：34.7 g   ＜同梱物＞ AirPods 4 充電ケース（USB-C） マニュア （USB-C充電ケーブルは別売りです）  保証期間 1年 ※2024年9月20日発売商品です。発売からしばらくは２週間～1か月の納期がかかることもございます。 ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AirPods4/MXP93JA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1936",
    brand: "Apple",
    sku: "MWW43ZA/A",
    product_eng: "Apple AirPods Max Midnight",
    product_jpn: "Apple AirPods Max - ミッドナイト",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "Symphonic boom.  ■Bright and resonant. AirPods Max delivers an unprecedented listening experience by reproducing audio with amazing detail and fidelity to the original sound. Each part of the specially designed driver works together. Each part of the specially designed driver works together to produce sound with minimal distortion in all audible ranges. So every sound rushes into your ears with unprecedented brilliance. ■Professional-level active noise cancellation. Generates sound that is balanced by outside noise, eliminating up to twice as much noise. You control what sounds enter your ears and what doesn't, so you can be more engaged than ever with your music or podcasts and stay focused.  Press the noise control button to switch to the external sound capture mode, which brings in the sounds around you.  ■Battery Up to 20 hours of playback time on a single charge when pro-level active noise cancellation is enabled Approximately 1.5 hours of playback time on a 5-minute charge, charged via USB-C ■Size and Weight AirPods Max (including cushion): width 168.6 mm, thickness 83.4 mm, height 187.3 mm Weight: 386.2 g ■Included in the box AirPods Max (USB-C) / Smart Case / USB-C charging cable / Manual  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "色めき立つサウンド。  ■あざやかに響きわたる。 AirPods Maxは、原音に忠実なオーディオを驚くほど細部まで再現して、かつてないリスニング体験を届けます。専用に設計されたドライバの各パーツが連係。すべての可聴域で歪みを最小にとどめたサウンドを生み出します。だから、あらゆる音が今までにないあざやかさであなたの耳に飛び込みます。 ■プロレベルのアクティブノイズキャンセリング。 外部の音と釣り合う音を発生させて、最大2倍の雑音を消し去ります。あなたの耳に入る音と入らない音がコントロールされるので、これまで以上に音楽やポッドキャストに夢中になることも集中力をキープすることもできます。  ノイズコントロールボタンを押して外部音取り込みモードに切り替えると、周りの音を取り込みます。そのため、自然な感覚でそばにいる人と話したり、周囲の音を聞くことができます。  ■バッテリー プロレベルのアクティブノイズキャンセリングを有効にした場合、1回の充電で最大20時間の再生時間 5分間の充電時間で約1.5時間の再生時間。USB-C経由で充電 ■サイズと重量 AirPods Max（クッションを含む）横幅168.6 mm 厚み83.4 mm 縦幅187.3 mm 重量： 386.2 g ■同梱物 AirPods Max（USB-C）/Smart Case/USB-C充電ケーブル/マニュアル ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AirPodsMax/MWW43ZAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1937",
    brand: "Apple",
    sku: "MWW53ZA/A",
    product_eng: "Apple AirPods Max Starlight",
    product_jpn: "Apple AirPods Max - スターライト",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "Symphonic boom.  ■Bright and resonant. AirPods Max delivers an unprecedented listening experience by reproducing audio with amazing detail and fidelity to the original sound. Each part of the specially designed driver works together. Each part of the specially designed driver works together to produce sound with minimal distortion in all audible ranges. So every sound rushes into your ears with unprecedented brilliance. ■Professional-level active noise cancellation. Generates sound that is balanced by outside noise, eliminating up to twice as much noise. You control what sounds enter your ears and what doesn't, so you can be more engaged than ever with your music or podcasts and stay focused.  Press the noise control button to switch to the external sound capture mode, which brings in the sounds around you.  ■Battery Up to 20 hours of playback time on a single charge when pro-level active noise cancellation is enabled Approximately 1.5 hours of playback time on a 5-minute charge, charged via USB-C ■Size and Weight AirPods Max (including cushion): width 168.6 mm, thickness 83.4 mm, height 187.3 mm Weight: 386.2 g ■Included in the box AirPods Max (USB-C) / Smart Case / USB-C charging cable / Manual  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "色めき立つサウンド。  ■あざやかに響きわたる。 AirPods Maxは、原音に忠実なオーディオを驚くほど細部まで再現して、かつてないリスニング体験を届けます。専用に設計されたドライバの各パーツが連係。すべての可聴域で歪みを最小にとどめたサウンドを生み出します。だから、あらゆる音が今までにないあざやかさであなたの耳に飛び込みます。 ■プロレベルのアクティブノイズキャンセリング。 外部の音と釣り合う音を発生させて、最大2倍の雑音を消し去ります。あなたの耳に入る音と入らない音がコントロールされるので、これまで以上に音楽やポッドキャストに夢中になることも集中力をキープすることもできます。  ノイズコントロールボタンを押して外部音取り込みモードに切り替えると、周りの音を取り込みます。そのため、自然な感覚でそばにいる人と話したり、周囲の音を聞くことができます。  ■バッテリー プロレベルのアクティブノイズキャンセリングを有効にした場合、1回の充電で最大20時間の再生時間 5分間の充電時間で約1.5時間の再生時間。USB-C経由で充電 ■サイズと重量 AirPods Max（クッションを含む）横幅168.6 mm 厚み83.4 mm 縦幅187.3 mm 重量： 386.2 g ■同梱物 AirPods Max（USB-C）/Smart Case/USB-C充電ケーブル/マニュアル ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AirPodsMax/MWW53ZAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1938",
    brand: "Apple",
    sku: "MWW63ZA/A",
    product_eng: "Apple AirPods Max Blue",
    product_jpn: "Apple AirPods Max - Blue",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "Symphonic boom.  ■Bright and resonant. AirPods Max delivers an unprecedented listening experience by reproducing audio with amazing detail and fidelity to the original sound. Each part of the specially designed driver works together. Each part of the specially designed driver works together to produce sound with minimal distortion in all audible ranges. So every sound rushes into your ears with unprecedented brilliance. ■Professional-level active noise cancellation. Generates sound that is balanced by outside noise, eliminating up to twice as much noise. You control what sounds enter your ears and what doesn't, so you can be more engaged than ever with your music or podcasts and stay focused.  Press the noise control button to switch to the external sound capture mode, which brings in the sounds around you.  ■Battery Up to 20 hours of playback time on a single charge when pro-level active noise cancellation is enabled Approximately 1.5 hours of playback time on a 5-minute charge, charged via USB-C ■Size and Weight AirPods Max (including cushion): width 168.6 mm, thickness 83.4 mm, height 187.3 mm Weight: 386.2 g ■Included in the box AirPods Max (USB-C) / Smart Case / USB-C charging cable / Manual  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "色めき立つサウンド。  ■あざやかに響きわたる。 AirPods Maxは、原音に忠実なオーディオを驚くほど細部まで再現して、かつてないリスニング体験を届けます。専用に設計されたドライバの各パーツが連係。すべての可聴域で歪みを最小にとどめたサウンドを生み出します。だから、あらゆる音が今までにないあざやかさであなたの耳に飛び込みます。 ■プロレベルのアクティブノイズキャンセリング。 外部の音と釣り合う音を発生させて、最大2倍の雑音を消し去ります。あなたの耳に入る音と入らない音がコントロールされるので、これまで以上に音楽やポッドキャストに夢中になることも集中力をキープすることもできます。  ノイズコントロールボタンを押して外部音取り込みモードに切り替えると、周りの音を取り込みます。そのため、自然な感覚でそばにいる人と話したり、周囲の音を聞くことができます。  ■バッテリー プロレベルのアクティブノイズキャンセリングを有効にした場合、1回の充電で最大20時間の再生時間 5分間の充電時間で約1.5時間の再生時間。USB-C経由で充電 ■サイズと重量 AirPods Max（クッションを含む）横幅168.6 mm 厚み83.4 mm 縦幅187.3 mm 重量： 386.2 g ■同梱物 AirPods Max（USB-C）/Smart Case/USB-C充電ケーブル/マニュアル ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AirPodsMax/MWW63ZAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1939",
    brand: "Apple",
    sku: "MWW73ZA/A",
    product_eng: "Apple AirPods Max Orange",
    product_jpn: "Apple AirPods Max - オレンジ",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "Symphonic boom.  ■Bright and resonant. AirPods Max delivers an unprecedented listening experience by reproducing audio with amazing detail and fidelity to the original sound. Each part of the specially designed driver works together. Each part of the specially designed driver works together to produce sound with minimal distortion in all audible ranges. So every sound rushes into your ears with unprecedented brilliance. ■Professional-level active noise cancellation. Generates sound that is balanced by outside noise, eliminating up to twice as much noise. You control what sounds enter your ears and what doesn't, so you can be more engaged than ever with your music or podcasts and stay focused.  Press the noise control button to switch to the external sound capture mode, which brings in the sounds around you.  ■Battery Up to 20 hours of playback time on a single charge when pro-level active noise cancellation is enabled Approximately 1.5 hours of playback time on a 5-minute charge, charged via USB-C ■Size and Weight AirPods Max (including cushion): width 168.6 mm, thickness 83.4 mm, height 187.3 mm Weight: 386.2 g ■Included in the box AirPods Max (USB-C) / Smart Case / USB-C charging cable / Manual  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "色めき立つサウンド。  ■あざやかに響きわたる。 AirPods Maxは、原音に忠実なオーディオを驚くほど細部まで再現して、かつてないリスニング体験を届けます。専用に設計されたドライバの各パーツが連係。すべての可聴域で歪みを最小にとどめたサウンドを生み出します。だから、あらゆる音が今までにないあざやかさであなたの耳に飛び込みます。 ■プロレベルのアクティブノイズキャンセリング。 外部の音と釣り合う音を発生させて、最大2倍の雑音を消し去ります。あなたの耳に入る音と入らない音がコントロールされるので、これまで以上に音楽やポッドキャストに夢中になることも集中力をキープすることもできます。  ノイズコントロールボタンを押して外部音取り込みモードに切り替えると、周りの音を取り込みます。そのため、自然な感覚でそばにいる人と話したり、周囲の音を聞くことができます。  ■バッテリー プロレベルのアクティブノイズキャンセリングを有効にした場合、1回の充電で最大20時間の再生時間 5分間の充電時間で約1.5時間の再生時間。USB-C経由で充電 ■サイズと重量 AirPods Max（クッションを含む）横幅168.6 mm 厚み83.4 mm 縦幅187.3 mm 重量： 386.2 g ■同梱物 AirPods Max（USB-C）/Smart Case/USB-C充電ケーブル/マニュアル ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AirPodsMax/MWW73ZAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1940",
    brand: "Apple",
    sku: "MWW83ZA/A",
    product_eng: "Apple AirPods Max Purple",
    product_jpn: "Apple AirPods Max - パープル",
    category_1: "Electronics",
    category_2: "Sound & Vision",
    rrp_ex_vat: "¥77,091",
    rrp_with_vat: "¥84,800",
    description_eng:
      "Symphonic boom.  ■Bright and resonant. AirPods Max delivers an unprecedented listening experience by reproducing audio with amazing detail and fidelity to the original sound. Each part of the specially designed driver works together. Each part of the specially designed driver works together to produce sound with minimal distortion in all audible ranges. So every sound rushes into your ears with unprecedented brilliance. ■Professional-level active noise cancellation. Generates sound that is balanced by outside noise, eliminating up to twice as much noise. You control what sounds enter your ears and what doesn't, so you can be more engaged than ever with your music or podcasts and stay focused.  Press the noise control button to switch to the external sound capture mode, which brings in the sounds around you.  ■Battery Up to 20 hours of playback time on a single charge when pro-level active noise cancellation is enabled Approximately 1.5 hours of playback time on a 5-minute charge, charged via USB-C ■Size and Weight AirPods Max (including cushion): width 168.6 mm, thickness 83.4 mm, height 187.3 mm Weight: 386.2 g ■Included in the box AirPods Max (USB-C) / Smart Case / USB-C charging cable / Manual  Warranty Period : 1 year *This product will be released on September 20, 2024. It may take 2 weeks to 1 month for delivery for a while after the release. *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "色めき立つサウンド。  ■あざやかに響きわたる。 AirPods Maxは、原音に忠実なオーディオを驚くほど細部まで再現して、かつてないリスニング体験を届けます。専用に設計されたドライバの各パーツが連係。すべての可聴域で歪みを最小にとどめたサウンドを生み出します。だから、あらゆる音が今までにないあざやかさであなたの耳に飛び込みます。 ■プロレベルのアクティブノイズキャンセリング。 外部の音と釣り合う音を発生させて、最大2倍の雑音を消し去ります。あなたの耳に入る音と入らない音がコントロールされるので、これまで以上に音楽やポッドキャストに夢中になることも集中力をキープすることもできます。  ノイズコントロールボタンを押して外部音取り込みモードに切り替えると、周りの音を取り込みます。そのため、自然な感覚でそばにいる人と話したり、周囲の音を聞くことができます。  ■バッテリー プロレベルのアクティブノイズキャンセリングを有効にした場合、1回の充電で最大20時間の再生時間 5分間の充電時間で約1.5時間の再生時間。USB-C経由で充電 ■サイズと重量 AirPods Max（クッションを含む）横幅168.6 mm 厚み83.4 mm 縦幅187.3 mm 重量： 386.2 g ■同梱物 AirPods Max（USB-C）/Smart Case/USB-C充電ケーブル/マニュアル ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/AirPodsMax/MWW83ZAA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1941",
    brand: "Apple",
    sku: "MX6X3AM/A",
    product_eng: "Apple MagSafe Charger (1 m)",
    product_jpn: "Apple MagSafe充電器（1 m）",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥5,891",
    rrp_with_vat: "¥6,480",
    description_eng:
      "Wireless charging is even easier with the MagSafe charger, which magnetically attaches to iPhone 12 or later models in the perfect position. Combine the MagSafe charger with a 30W power adapter (sold separately) for even faster wireless charging up to 25W.  The MagSafe charger is Qi2 and Qi charging compatible and charges iPhone 8 or later models and AirPods models with wireless charging cases just like a Qi2 or Qi standard charger.  Included MagSafe charger Integrated USB-C cable (1 m)  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "MagSafe充電器なら、ワイヤレス充電がさらに簡単。iPhone 12以降のモデルの完璧な位置に磁力で装着します。 MagSafe充電器を30Wの電源アダプタ(別売)と組み合わせると、最大25Wのワイヤレス充電を一段とすばやく完了します。  MagSafe充電器はQi2およびQi充電に対応。Qi2またはQi規格の充電器と同じように、iPhone 8以降のモデルとワイヤレス充電ケースが付いたAirPodsのモデルを充電できます  同梱物 MagSafe充電器 一体型USB‑Cケーブル（1 m）  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MX6X3AMA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1942",
    brand: "Apple",
    sku: "MX6Y3AM/A",
    product_eng: "Apple MagSafe Charger (2 m)",
    product_jpn: "Apple MagSafe充電器（2 m）",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,709",
    rrp_with_vat: "¥8,480",
    description_eng:
      "Wireless charging is even easier with the MagSafe charger, which magnetically attaches to iPhone 12 or later models in the perfect position. Combine the MagSafe charger with a 30W power adapter (sold separately) for even faster wireless charging up to 25W.  The MagSafe charger is Qi2 and Qi charging compatible and charges iPhone 8 or later models and AirPods models with wireless charging cases just like a Qi2 or Qi standard charger.  Included MagSafe charger Integrated USB-C cable (2 m)  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "MagSafe充電器なら、ワイヤレス充電がさらに簡単。iPhone 12以降のモデルの完璧な位置に磁力で装着します。 MagSafe充電器を30Wの電源アダプタ(別売)と組み合わせると、最大25Wのワイヤレス充電を一段とすばやく完了します。  MagSafe充電器はQi2およびQi充電に対応。Qi2またはQi規格の充電器と同じように、iPhone 8以降のモデルとワイヤレス充電ケースが付いたAirPodsのモデルを充電できます  同梱物 MagSafe充電器 一体型USB‑Cケーブル（2 m）  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MX6Y3AMA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1943",
    brand: "Apple",
    sku: "MWVV3AM/A",
    product_eng: "Power Adapter 20W USB-C",
    product_jpn: "Apple 20W USB-C電源アダプタ",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥2,527",
    rrp_with_vat: "¥2,780",
    description_eng:
      "The Apple 20W USB-C Power Adapter provides fast and efficient charging at home, in the office, and on the go. While this power adapter is compatible with any USB-C enabled device, it provides the best charging performance when used with the 11“ iPad Pro or 12.9” iPad Pro (3rd generation). It is also compatible with iPhone 8 or later models for fast charging capabilities. Charging cable sold separately.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "Apple 20W USB-C電源アダプタを使えば、自宅、オフィス、外出先で、すばやく効率的に充電ができます。この電源アダプタはあらゆるUSB-C対応デバイスとの互換性がありますが、11インチiPad Proや12.9インチiPad Pro（第3世代）と組み合わせると最も優れた充電パフォーマンスを発揮します。また、iPhone 8以降のモデルとの組み合わせでも、高速充電機能に対応します。 充電ケーブルは別売りです。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MWVV3AMA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1944",
    brand: "Apple",
    sku: "MW2G3AM/A",
    product_eng: "Power Adapter 30W USB-C",
    product_jpn: "30W USB-C電源アダプタ",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥4,364",
    rrp_with_vat: "¥4,800",
    description_eng:
      "The 30W USB-C Power Adapter allows for quick and efficient charging at home, in the office, or on the go. While this power adapter is compatible with any USB-C device, it is recommended for use with the MacBook Air and Apple Vision Pro. It can also be used with select iPhone and iPad Pro models to take advantage of its fast charging capabilities. Charging cable sold separately.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "30W USB-C電源アダプタを使えば、自宅、オフィス、外出先などで、すばやく効率的に充電ができます。この電源アダプタはあらゆるUSB-Cデバイスとの互換性がありますが、MacBook AirおよびApple Vision Proと組み合わせて使うことをおすすめします。一部のiPhoneおよびiPad Proモデルとの組み合わせでも、高速充電機能を活かすことができます。 充電ケーブルは別売りです。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MW2G3AMA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1945",
    brand: "Apple",
    sku: "MA7F4FE/A",
    product_eng: "iPhone Case - Apple iPhone 16 Pro Max Clear Case with MagSafe",
    product_jpn: "Apple MagSafe対応iPhone 16 Pro Maxクリアケース",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "Thin, lightweight, and easy to hold, this Apple case is for those who want to protect their iPhone 16 even more securely while enjoying its colorful finish.  Designed with a combination of highly transparent polycarbonate and flexible materials, this case fits snugly over the iPhone's buttons for ease of use. This case works seamlessly with the camera controls. The sapphire cap with conductive layer senses finger movement on the case and transmits it to the camera controls.  The surfaces inside and out are coated with a scratch-resistant coating, and all materials and coatings are designed to prevent yellowing over long periods of use.  Installation is magically easy with the built-in magnet that perfectly matches the iPhone 16. Wireless charging is also faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "薄くて、軽くて、持ちやすいApple製ケース。iPhone 16 Pro Maxをさらにしっかりと守りながら、そのカラフルな仕上げを楽しみたい方におすすめです。  透明度の高いポリカーボネートと柔軟性がある素材を組み合わせた設計。iPhoneのボタンにぴったりフィットするので使いやすさも抜群です。このケースはカメラコントロールとシームレスに連係。導電層を備えたサファイアキャップがケース上の指の動きを感知して、カメラコントロールに伝えます。  内側も外側も表面には傷に強いコーティングが施されていて、すべての素材とコーティングは長期にわたって使用する際に黄ばみを防げるように考慮されています。  iPhone 16 Pro Maxに完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MA7F4FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1946",
    brand: "Apple",
    sku: "MA7U4FE/A",
    product_eng:
      "iPhone Case - iPhone 16 Pro Max Silicone Case with MagSafe - Star Fruit",
    product_jpn:
      "Apple MagSafe対応iPhone 16 Pro Maxシリコーンケース - スターフルーツ",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MA7U4FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1947",
    brand: "Apple",
    sku: "MYYT3FE/A",
    product_eng: "iPhone Case - iPhone 16 Pro Max Silicone Case with MagSafe - Black",
    product_jpn:
      "Apple MagSafe対応iPhone 16 Pro Maxシリコーンケース - ブラック",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYYT3FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1948",
    brand: "Apple",
    sku: "MYYU3FE/A",
    product_eng: "iPhone Case - iPhone 16 Pro Max Silicone Case with MagSafe - Denim",
    product_jpn: "Apple MagSafe対応iPhone 16 Pro Maxシリコーンケース - デニム",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYYU3FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1949",
    brand: "Apple",
    sku: "MYYY3FE/A",
    product_eng:
      "iPhone Case - iPhone 16 Pro Max Silicone Case with MagSafe - Ultramarine",
    product_jpn:
      "Apple MagSafe対応iPhone 16 Pro Maxシリコーンケース - ウルトラマリン",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYYY3FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1950",
    brand: "Apple",
    sku: "MA7E4FE/A",
    product_eng: "iPhone Case - iPhone 16 Pro Clear Case with MagSafe",
    product_jpn: "Apple MagSafe対応iPhone 16 Proクリアケース",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "Thin, lightweight, and easy to hold, this Apple case is for those who want to protect their iPhone 16 even more securely while enjoying its colorful finish.  Designed with a combination of highly transparent polycarbonate and flexible materials, this case fits snugly over the iPhone's buttons for ease of use. This case works seamlessly with the camera controls. The sapphire cap with conductive layer senses finger movement on the case and transmits it to the camera controls.  The surfaces inside and out are coated with a scratch-resistant coating, and all materials and coatings are designed to prevent yellowing over long periods of use.  Installation is magically easy with the built-in magnet that perfectly matches the iPhone 16. Wireless charging is also faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "薄くて、軽くて、持ちやすいApple製ケース。iPhone 16 Proをさらにしっかりと守りながら、そのカラフルな仕上げを楽しみたい方におすすめです。  透明度の高いポリカーボネートと柔軟性がある素材を組み合わせた設計。iPhoneのボタンにぴったりフィットするので使いやすさも抜群です。このケースはカメラコントロールとシームレスに連係。導電層を備えたサファイアキャップがケース上の指の動きを感知して、カメラコントロールに伝えます。  内側も外側も表面には傷に強いコーティングが施されていて、すべての素材とコーティングは長期にわたって使用する際に黄ばみを防げるように考慮されています。  iPhone 16 Proに完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MA7E4FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1951",
    brand: "Apple",
    sku: "MYYQ3FE/A",
    product_eng: "iPhone Case - iPhone 16 Pro Silicone Case with MagSafe - Star Fruit",
    product_jpn:
      "Apple MagSafe対応iPhone 16 Pro シリコーンケース - スターフルーツ",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYYQ3FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1952",
    brand: "Apple",
    sku: "MYYJ3FE/A",
    product_eng: "iPhone Case - iPhone 16 Pro Silicone Case with MagSafe - Black",
    product_jpn: "Apple MagSafe対応iPhone 16 Pro シリコーンケース - ブラック",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYYJ3FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1953",
    brand: "Apple",
    sku: "MYYK3FE/A",
    product_eng: "iPhone Case - iPhone 16 Pro Silicone Case with MagSafe - Denim",
    product_jpn: "Apple MagSafe対応iPhone 16 Pro シリコーンケース - デニム",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYYK3FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1954",
    brand: "Apple",
    sku: "MYYP3FE/A",
    product_eng: "iPhone Case - iPhone 16 Pro Silicone Case with MagSafe - Ultramarine",
    product_jpn:
      "Apple MagSafe対応iPhone 16 Pro シリコーンケース - ウルトラマリン",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYYP3FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1955",
    brand: "Apple",
    sku: "MA7D4FE/A",
    product_eng: "iPhone Case - iPhone 16 Plus Clear Case with MagSafe",
    product_jpn: "Apple MagSafe対応iPhone 16 Plusクリアケース",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "Thin, lightweight, and easy to hold, this Apple case is for those who want to protect their iPhone 16 even more securely while enjoying its colorful finish.  Designed with a combination of highly transparent polycarbonate and flexible materials, this case fits snugly over the iPhone's buttons for ease of use. This case works seamlessly with the camera controls. The sapphire cap with conductive layer senses finger movement on the case and transmits it to the camera controls.  The surfaces inside and out are coated with a scratch-resistant coating, and all materials and coatings are designed to prevent yellowing over long periods of use.  Installation is magically easy with the built-in magnet that perfectly matches the iPhone 16. Wireless charging is also faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "薄くて、軽くて、持ちやすいApple製ケース。iPhone 16 Plusをさらにしっかりと守りながら、そのカラフルな仕上げを楽しみたい方におすすめです。  透明度の高いポリカーボネートと柔軟性がある素材を組み合わせた設計。iPhoneのボタンにぴったりフィットするので使いやすさも抜群です。このケースはカメラコントロールとシームレスに連係。導電層を備えたサファイアキャップがケース上の指の動きを感知して、カメラコントロールに伝えます。  内側も外側も表面には傷に強いコーティングが施されていて、すべての素材とコーティングは長期にわたって使用する際に黄ばみを防げるように考慮されています。  iPhone 16 Plusに完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MA7D4FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1956",
    brand: "Apple",
    sku: "MYY93FE/A",
    product_eng: "iPhone Case - iPhone 16 Plus Silicone Case with MagSafe - Black",
    product_jpn: "Apple MagSafe対応iPhone 16 Plusシリコーンケース - ブラック",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYY93FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1957",
    brand: "Apple",
    sku: "MYYA3FE/A",
    product_eng: "iPhone Case - iPhone 16 Plus Silicone Case with MagSafe - Denim",
    product_jpn: "Apple MagSafe対応iPhone 16 Plusシリコーンケース - デニム",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYYA3FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1958",
    brand: "Apple",
    sku: "MYYF3FE/A",
    product_eng:
      "iPhone Case - iPhone 16 Plus Silicone Case with MagSafe - Ultramarine",
    product_jpn:
      "Apple MagSafe対応iPhone 16 Plusシリコーンケース - ウルトラマリン",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYYF3FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1959",
    brand: "Apple",
    sku: "MYYE3FE/A",
    product_eng: "iPhone Case - iPhone 16 Plus Silicone Case with MagSafe - Fuchsia",
    product_jpn: "Apple MagSafe対応iPhone 16 Plusシリコーンケース - フクシア",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYYE3FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1960",
    brand: "Apple",
    sku: "MA6A4FE/A",
    product_eng: "iPhone Case - iPhone 16 Clear Case with MagSafe",
    product_jpn: "Apple MagSafe対応iPhone 16 クリアケース",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "Thin, lightweight, and easy to hold, this Apple case is for those who want to protect their iPhone 16 even more securely while enjoying its colorful finish.  Designed with a combination of highly transparent polycarbonate and flexible materials, this case fits snugly over the iPhone's buttons for ease of use. This case works seamlessly with the camera controls. The sapphire cap with conductive layer senses finger movement on the case and transmits it to the camera controls.  The surfaces inside and out are coated with a scratch-resistant coating, and all materials and coatings are designed to prevent yellowing over long periods of use.  Installation is magically easy with the built-in magnet that perfectly matches the iPhone 16. Wireless charging is also faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "薄くて、軽くて、持ちやすいApple製ケース。iPhone 16をさらにしっかりと守りながら、そのカラフルな仕上げを楽しみたい方におすすめです。  透明度の高いポリカーボネートと柔軟性がある素材を組み合わせた設計。iPhoneのボタンにぴったりフィットするので使いやすさも抜群です。このケースはカメラコントロールとシームレスに連係。導電層を備えたサファイアキャップがケース上の指の動きを感知して、カメラコントロールに伝えます。  内側も外側も表面には傷に強いコーティングが施されていて、すべての素材とコーティングは長期にわたって使用する際に黄ばみを防げるように考慮されています。  iPhone 16 に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MA6A4FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1961",
    brand: "Apple",
    sku: "MYY13FE/A",
    product_eng: "iPhone Case - iPhone 16 Silicone Case with MagSafe - Black",
    product_jpn: "Apple MagSafe対応iPhone 16 シリコーンケース - ブラック",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYY13FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1962",
    brand: "Apple",
    sku: "MYY23FE/A",
    product_eng: "iPhone Case - iPhone 16 Silicone Case with MagSafe - Denim",
    product_jpn: "Apple MagSafe対応iPhone 16 シリコーンケース - デニム",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYY23FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1963",
    brand: "Apple",
    sku: "MYY63FE/A",
    product_eng: "iPhone Case - iPhone 16 Silicone Case with MagSafe - Ultramarine",
    product_jpn: "Apple MagSafe対応iPhone 16 シリコーンケース - ウルトラマリン",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYY63FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1964",
    brand: "Apple",
    sku: "MYY53FE/A",
    product_eng: "iPhone Case - iPhone 16 Silicone Case with MagSafe - Fuchsia",
    product_jpn: "Apple MagSafe対応iPhone 16 シリコーンケース - フクシア",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥7,255",
    rrp_with_vat: "¥7,980",
    description_eng:
      "MagSafe compatible silicone case designed by Apple for the iPhone 16. Your iPhone is well protected.  Made of 55% recycled silicone material, the outside is silky soft and comfortable in the hand. The inside is lined with soft microfiber for extra protection for your iPhone.  The case works seamlessly with the camera controls. The sapphire crystal layered with conductive layers transmits your finger movements to the camera controls.  Installation is magically easy with built-in magnets that are perfectly aligned with the iPhone 16. Wireless charging is faster than ever. To charge, simply use the MagSafe charger or place it on a Qi2 or Qi standard charger. Either way, you can leave your iPhone in the case.  Like all Apple cases, it has undergone thousands of hours of testing throughout the design and manufacturing process. So not only are they beautiful, they also keep your iPhone scratch-resistant and protected from the shock of being dropped.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "iPhone 16のためにAppleがデザインしたMagSafe対応シリコーンケース。あなたのiPhoneをしっかりと守ります。  55%再生シリコーン素材で作られ、外側は絹のように柔らかく仕上げてあるため、手に心地良く収まります。内側には、iPhoneを一段としっかり保護できるように柔らかなマイクロファイバーの裏地を採用しました。  このケースはカメラコントロールとシームレスに連係。導電層を重ねたサファイアクリスタルが、指の動きをカメラコントロールに伝えます。  iPhone 16に完璧に合ったマグネットを内蔵しているので、取りつけは魔法のように簡単。ワイヤレス充電もこれまで以上にすばやく完了します。充電する時は、MagSafe充電器を使うか、Qi2またはQi規格の充電器の上に置くだけ。どちらもiPhoneをケースに入れたままどうぞ。  ほかのすべてのApple製ケースと同様に、設計と製造の工程を通じて何千時間にもわたるテストを実施しました。だから美しいだけでなく、iPhoneを傷つきにくくし、落下時の衝撃からも守ります。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MYY53FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  {
    id: "1965",
    brand: "Apple",
    sku: "MA6W4FE/A",
    product_eng: "Apple iPhone FineWoven Wallet with MagSafe - Black",
    product_jpn: "Apple MagSafe対応iPhoneファインウーブンウォレット - ブラック",
    category_1: "Electronics",
    category_2: "Accessories",
    rrp_ex_vat: "¥9,073",
    rrp_with_vat: "¥9,980",
    description_eng:
      "The new MagSafe-enabled iPhone Fine Woven Wallet was designed to combine style and function. It is the perfect way to keep your identification and credit cards with you at all times. It supports the Find Me feature, so when the wallet leaves your iPhone, a notification will let you know where it was last seen.  This fine woven material is made of durable micro twill for a smooth, wrap-around feel. Made from 100% recycled materials recovered from consumers, it significantly reduces carbon emissions compared to leather.  The wallet features a strong built-in magnet that attaches snugly and easily to the back of your iPhone, and can also be attached to MagSafe compatible cases for a coordinated look that works for you. It holds up to three cards and is shielded so you can safely store your credit cards.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
    description_jpn:
      "新しいMagSafe対応iPhoneファインウーブンウォレットは、スタイルと機能を兼ね備えるように設計されました。身分証明書やクレジットカードをいつも手元に置くための完璧な方法です。「探す」機能に対応しているので、ウォレットがあなたのiPhoneから離れた時は、最後に確認された場所を通知でお知らせします。  このファインウーブン素材は耐久性に優れたマイクロツイル製で、なめらかに包み込むような感触です。消費者から回収した再生素材を100%使用することで、レザーに比べて炭素排出量を大幅に削減します。  このウォレットは強力なマグネットを内蔵しているので、iPhoneの背面にピタッと簡単に取りつけられます。MagSafe対応ケースにも装着できるため、あなたにぴったりのコーディネートを楽しむこともできます。最大3枚のカードが入り、シールド機能があるのでクレジットカードを入れても安心です。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
    product_image_1:
      "https://products.naganorewards.com/images/apple/iphone_accessories/MA6W4FEA.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image:
      "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
    "": "",
  },
  // {
  //   id: "1966",
  //   brand: "Apple",
  //   sku: "MA6X4FE/A",
  //   product_eng: "Apple iPhone FineWoven Wallet with MagSafe - Deep Blue",
  //   product_jpn:
  //     "Apple MagSafe対応iPhoneファインウーブンウォレット - ディープBlue",
  //   category_1: "Electronics",
  //   category_2: "Accessories",
  //   rrp_ex_vat: "¥9,073",
  //   rrp_with_vat: "¥9,980",
  //   description_eng:
  //     "The new MagSafe-enabled iPhone Fine Woven Wallet was designed to combine style and function. It is the perfect way to keep your identification and credit cards with you at all times. It supports the Find Me feature, so when the wallet leaves your iPhone, a notification will let you know where it was last seen.  This fine woven material is made of durable micro twill for a smooth, wrap-around feel. Made from 100% recycled materials recovered from consumers, it significantly reduces carbon emissions compared to leather.  The wallet features a strong built-in magnet that attaches snugly and easily to the back of your iPhone, and can also be attached to MagSafe compatible cases for a coordinated look that works for you. It holds up to three cards and is shielded so you can safely store your credit cards.  *Apple products will be returned or exchanged only if the product is deemed defective by Apple Japan, LLC. *We do not accept returns or exchanges due to a change of mind or personal reasons. Returns and exchanges are only accepted if the item is defective or damaged upon receipt. Please be mindful of this policy when placing your order.",
  //   description_jpn:
  //     "新しいMagSafe対応iPhoneファインウーブンウォレットは、スタイルと機能を兼ね備えるように設計されました。身分証明書やクレジットカードをいつも手元に置くための完璧な方法です。「探す」機能に対応しているので、ウォレットがあなたのiPhoneから離れた時は、最後に確認された場所を通知でお知らせします。  このファインウーブン素材は耐久性に優れたマイクロツイル製で、なめらかに包み込むような感触です。消費者から回収した再生素材を100%使用することで、レザーに比べて炭素排出量を大幅に削減します。  このウォレットは強力なマグネットを内蔵しているので、iPhoneの背面にピタッと簡単に取りつけられます。MagSafe対応ケースにも装着できるため、あなたにぴったりのコーディネートを楽しむこともできます。最大3枚のカードが入り、シールド機能があるのでクレジットカードを入れても安心です。  ※Apple製品はApple Japan 合同会社が初期不良と認めた場合のみ、返品交換をさせていただきます。 ※お客様都合（思ってたものと違う、間違って注文してしまった等）による注文キャンセルや変更、お届けした商品の返品はお受けしておりません。予めご了承の上、ご注文ください。",
  //   product_image_1:
  //     "https://products.naganorewards.com/images/apple/iphone_accessories/MA6X4FEA.jpg",
  //   product_image_2: "",
  //   product_image_3: "",
  //   product_image_4: "",
  //   logo_image:
  //     "https://s3.amazonaws.com/products.naganorewards.com/logos/apple_logo.png",
  //   "": "",
  // },
  {
    id: "1966",
    brand: "Samsonite",
    sku: "SAFASSAKR0001",
    product_eng: "Samsonite Passport wallet DC809002",
    product_jpn: "[샘소나이트] 여권지갑 DC809002",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "99,000",
    description_eng:
      "■ Product Features\nTeacher Sonite passport wallet\nscratch-resistant Saffiano cowhide passport wallet\nConveniently used as a variety of storage spaces\nA simple and sophisticated design with luxurious black color and the Samsonite gold logo\n\n■ Size - 9.5 × 14 × 1 (cm)\n■ Material - Natural leather (Cowhide)",
    description_jpn:
      "■제품특징\n쌤소나이트 여권지갑\n스크래치에 강한 사피아노 소가죽 소재의 여권지갑\n다양한 수납공간으로 편리하게 사용 가능\n고급스러운 블랙 컬러에 쌤소나이트 골드 로고가 더해진 심플하고 세련된 디자인\n\n■사이즈 - 9.5 x 14 x 1 (cm)\n■재 질 - 천연가죽(소가죽)",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/PassportWallet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1967",
    brand: "Samsonite",
    sku: "SAFASSAKR0002",
    product_eng: "Samsonite Belt DC809008",
    product_jpn: "[샘소나이트] 벨트 DC809008",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "95,000",
    description_eng:
      "■ Product Features\n- Size: 113.5×3.2×cm\n- Teacher Sonite Cowhide Belt\n- a scretch-resistant Saffiano embossed belt\ndomestic use of high-quality cowhide",
    description_jpn:
      "■제품특징\n- 사이즈 : 113.5X3.2X (cm)\n- 쌤소나이트 소가죽 벨트\n- 스크레치에 강한 사피아노 엠보 소재의 벨트\n국내 고급 소가죽 사용",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/Belt.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1968",
    brand: "Samsonite",
    sku: "SAFASSAKR0003",
    product_eng: "Samsonite DELAENO BACKPACK (BLACK)",
    product_jpn: "[샘소나이트] DELAENO BACKPACK(BLACK)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "148,000",
    description_eng:
      "■Red Label with the youthful sense of Samsonite\n■Backpack of a simple and stylish design made of light polyester material\n■Using a wide and stable shoulder strap with a comfortable fit and breathable mesh material\n■ Basic SHAPE that gives you stability and strong flooring\n■Size: 32×42×13 (cm)\n■ Material: Polyester",
    description_jpn:
      "■샘소나이트의 젊은 감각이 돋보이는 Red Label 제품\n■가벼운 폴리에스터 소재로 심플하면서 멋스러운 디자인의 백팩\n■폭이 넓고 안정감있는 어깨끈으로 편안한 착용감과 통기성이 좋은 메쉬소재 사용\n■안정감을 주는 기본 SHAPE과 튼튼한 바닥처리\n■사이즈 : 32 x 42 x 13 (cm)\n■재질 : 폴리에스터",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/Backpack.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1969",
    brand: "Samsonite",
    sku: "SAFASSAKR0004",
    product_eng: "Samsonite Red EUCLIDE Backpack HR009001",
    product_jpn: "[샘소나이트] 레드 EUCLIDE 백팩 HR009001",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "159,000",
    description_eng:
      "• Size: 31 x 11.5 x 46 (Cm)\n• Material: 100% Polyester\n\n\nProduct Features\n• A simple square-shape backpack that is good for matching various outfits.\n• It is accentuated with a wide front combination PU, and it is useful as two water bottles and zipper pockets.\n• 15 You can store your laptop.\n• The design goes well with both business and casual attire.",
    description_jpn:
      "•사이즈 : 31 x 11.5 x 46 ( Cm )\n•재 질 : 100% Polyester\n\n\n상품 특징\n• 다양한 착장에 매치하기 좋은 심플한 스퀘어 쉐입의 백팩.\n• 전면 넓은 콤비PU로 포인트를 주었으며 2개의 물통 및 지퍼포켓으로 활용성이 좋습니다.\n• 15 노트북의 수납이 가능합니다.\n• 비즈니스 및 캐주얼한 복장에 모두 잘 어울리는 디자인입니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/Backpack2.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1970",
    brand: "Amorepacific",
    sku: "AMCOSAMKR0005",
    product_eng: "Amore AP Happy No.1 set",
    product_jpn: "[아모레] AP 행복듬뿍 1호 세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "49,000",
    description_eng:
      "■ AP Happy No. 1 Set 16 pcs\nHappy Bath is a really moist body wash 400g 1p\nRyeo Hambit Extreme Damage & Nutrition Care Shampoo 400 ml 1p\nRyeoWoon Hair Muscle Enhancement & Volume Care Shampoo 400 ml 2pcs\n4 Median Dual Effect Toothbrushes\nMedian Tartar Original Toothpaste 90 g 4p\nIlliyoon Oil Smoothing Soap 80 g 4p",
    description_jpn:
      "■ AP 행복듬뿍 1호 세트 16pcs\n해피바스 정말 촉촉한 바디워시 400 g 1개\n려 함빛 극손상&영양케어 샴푸 400 ml 1개\n려 흑운 모근강화&볼륨케어 샴푸 400 ml 2개\n메디안 듀얼이펙션 칫솔 4 개\n메디안 치석오리지널 치약 90 g  4개\n일리윤 오일스무딩 비누 80 g  4개",
    product_image_1:
      "https://products.naganorewards.com/KR/Amorepacific/HappySet1.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1971",
    brand: "Amorepacific",
    sku: "AMCOSAMKR0006",
    product_eng: "Amore AP Happiness Premium A Set",
    product_jpn: "[아모레] AP 행복 프리미엄 A 세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "49,900",
    description_eng:
      "■ AP Happiness Premium A Set 18 pcs\nHappy Bath is a really moist body wash 400g 1p\nRyeo Hambit Extreme Damage & Nutrition Care Shampoo 400 ml 1p\nRyeoWoon Hair Muscle Enhancement & Volume Care Shampoo 400 ml 2pcs\n4 Median Dual Effect Toothbrushes\nMedian Tartar Original Toothpaste 90 g 4p\nIlliyoon Oil Smoothing Soap 80 g 4p\nHappy Bath Fairy Yogert Mild Foam 120 g 1p\nRyeoWoon Hair Muscle Reinforcement & Volume Care Shampoo 180 ml 1p",
    description_jpn:
      "■ AP 행복 프리미엄 A 세트 18pcs\n해피바스 정말 촉촉한 바디워시 400 g 1개\n려 함빛 극손상&영양케어 샴푸 400 ml 1개\n려 흑운 모근강화&볼륨케어 샴푸 400 ml 2개\n메디안 듀얼이펙션 칫솔 4 개\n메디안 치석오리지널 치약 90 g  4개\n일리윤 오일스무딩 비누 80 g  4개\n해피바스 훼이셜요거트 순한폼 120 g 1개 \n려 흑운 모근강화&볼륨케어 샴푸 180 ml 1개",
    product_image_1:
      "https://products.naganorewards.com/KR/Amorepacific/HappinessA.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1972",
    brand: "Amorepacific",
    sku: "AMCOSAMKR0007",
    product_eng: "Amore AP Happy No.2 set",
    product_jpn: "[아모레] AP 행복듬뿍 2호 세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "63,900",
    description_eng:
      "■ AP Happy No. 2 Set 23 pcs\nHappy Bath is a really moist body wash 400g 1p\nHappy Bath is a very gentle body wash 400g 1p\nRyeo Hambit Extreme Damage & Nutrition Care Shampoo 400 ml 2p\nRyeoWoon Hair Muscle Enhancement & Volume Care Shampoo 400 ml 1p\n8 Median Dual Effect Toothbrushes\nMedian Tartar Original Toothpaste 90g 6pcs\nHappy Bath Original Collection Soap Lavender Soap 90 g 2p\nHappy Bath Original Collection Olive Soap 90g 2pcs",
    description_jpn:
      "■ AP 행복듬뿍 2호 세트 23pcs\n해피바스 정말 촉촉한 바디워시 400 g 1개\n해피바스 정말 순한 바디워시 400 g 1개\n려 함빛 극손상&영양케어 샴푸 400 ml 2개\n려 흑운 모근강화&볼륨케어 샴푸 400 ml 1개\n메디안 듀얼이펙션 칫솔  8 개\n메디안 치석오리지널 치약 90 g 6개\n해피바스 오리지널 컬렉션 솝 라벤더비누 90 g 2개\n해피바스 오리지널 컬렉션 올리브 비누 90 g 2개",
    product_image_1:
      "https://products.naganorewards.com/KR/Amorepacific/HappySet2.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1973",
    brand: "Amorepacific",
    sku: "AMCOSAMKR0008",
    product_eng: "Amore AP Happiness Premium B Set",
    product_jpn: "[아모레] AP 행복 프리미엄 B 세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "63,900",
    description_eng:
      "■ AP Happiness Premium B Set of 26\nHappy Bath is a really moist body wash 400g 1p\nHappy Bath is a very gentle body wash 400g 1p\nRyeo Hambit Extreme Damage & Nutrition Care Shampoo 400 ml 2p\nRyeoWoon Hair Muscle Enhancement & Volume Care Shampoo 400 ml 1p\n8 Median Dual Effect Toothbrushes\nMedian Tartar Original Toothpaste 90g 6pcs\nHappy Bath Original Collection Soap Lavender Soap 90 g 2p\nHappy Bath Original Collection Olive Soap 90g 2pcs\nHappy Bath Fairy Yogert Mild Foam 120 g 1p\nIlliyoon Oil Smoothing Soap 80 g 2p",
    description_jpn:
      "■ AP 행복 프리미엄 B 세트 26종\n해피바스 정말 촉촉한 바디워시 400 g 1개\n해피바스 정말 순한 바디워시 400 g 1개\n려 함빛 극손상&영양케어 샴푸 400 ml 2개\n려 흑운 모근강화&볼륨케어 샴푸 400 ml 1개\n메디안 듀얼이펙션 칫솔  8 개\n메디안 치석오리지널 치약 90 g 6개\n해피바스 오리지널 컬렉션 솝 라벤더비누 90 g 2개\n해피바스 오리지널 컬렉션 올리브 비누 90 g 2개\n해피바스 훼이셜요거트 순한폼 120 g 1개\n일리윤 오일스무딩 비누 80 g 2개",
    product_image_1:
      "https://products.naganorewards.com/KR/Amorepacific/HappinessB.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1974",
    brand: "Amorepacific",
    sku: "AMCOSAMKR0009",
    product_eng: "Amore AP Happy 55",
    product_jpn: "[아모레] AP 행복가득 55호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "85,000",
    description_eng:
      "■ AP Happy No. 55 18 pcs\nRyeoHam's Light Dramatic Damage & Nutrition Care Shampoo 400ml 1p\nRyeoWoon Hair Muscle Reinforced Volume Care Shampoo 400ml 2pcs\nRyeo Cheong-ah Deep Cleansing Cooling Shampoo 400 ml 1p\nRyeoWook Hair Loss Specialized Care Shampoo 400ml 1p\nMedian Tartar Original Toothpaste 90g 4pcs\nMedian Flex Effect Toothbrush 3pcs\nHappy Bath Original Collection Body Wash 500g 1p\nHappy Bath Original Baby Powder Body Wash 500g 1p\nHappy Bath Original Collection Soap Lavender Soap 90g\nHappy Bath Original Collection Olive Soap 90g2p\nHappy Bath Rice Moisturizing Cleansing Foam 200g 1p",
    description_jpn:
      "■ AP 행복가득 55호 18pcs\n려 함빛극손상&영양케어 샴푸 400ml 1개 \n려 흑운 모근강화 볼륨케어 샴푸 400ml 2개\n려 청아 딥클렌징 쿨링샴푸 400ml 1개 \n려 자양 탈모전문케어 샴푸 400ml 1개 \n메디안 치석오리지널치약 90g 4개\n메디안 플렉스이펙션칫솔 3개 \n해피바스 오리지널컬렉션 바디워시 500g 1개\n해피바스 오리지널 베이비파우더 바디워시 500g 1개\n해피바스 오리지널컬렉션 솝라벤더 비누 90g\n해피바스 오리지널컬렉션 올리브비누 90g2개\n해피바스 라이스보습 클렌징폼 200g 1개",
    product_image_1:
      "https://products.naganorewards.com/KR/Amorepacific/Happy55.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1975",
    brand: "ATOCARE",
    sku: "ATHOUATKR0010",
    product_eng: "Atocare Wireless Vacuum Cleaner Simple EP-CVC-HC2005E",
    product_jpn: "[아토케어] 무선청소기 더 심플 EP-CVC-HC2005E",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "198,000",
    description_eng:
      "Type: Handystick type\nMotor : BLDC motor\nRelease year : 2024\nCleaning method: Inhalation only\nInhalation power: 120W suction power\nAdjustment: Step 2\nUsage time: 40 minutes\nCharging time: 4 hours\nCharging method: USB charging\nDust container: Detachable, one-touch, water washable\nFilter: H10 class HEPA filter Multiple filter: Double filter\nEffectiveness: Blocking fine dust\nAdditional functions: cradle\nBattery capacity: 2,500 mAh\nVoltage: 11.1 V\nMaximum output: 120 W",
    description_jpn:
      "형태 : 핸디스틱형\n모터 : BLDC모터\n출시년도 : 2024년\n청소방식 : 흡입전용\n흡입력 : 120W흡입력\n조절 : 2단계\n사용시간 : 40분\n충전시간 : 4시간\n충전방식 : USB충전\n먼지통 : 분리형, 원터치, 물세척가능\n필터 : H10급 헤파필터다중필터 : 2중필터필터\n효과 : 미세먼지차단\n부가기능 : 거치대\n배터리용량 : 2,500mAh\n전압 : 11.1V\n최대출력 : 120W",
    product_image_1:
      "https://products.naganorewards.com/KR/ATOCARE/Vacuum.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1976",
    brand: "BFL",
    sku: "BFFASBFKR0011",
    product_eng: "BFL BFL outdoor men's digital watch BFL-7007",
    product_jpn: "[BFL] 비에프엘 아웃도어 남성용 디지털 시계 BFL-7007",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "89,000",
    description_eng: "Main product, warranty, case",
    description_jpn: "본품,보증서,케이스",
    product_image_1: "https://products.naganorewards.com/KR/BFL/WatchMen.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1977",
    brand: "BFL",
    sku: "BFFASBFKR0012",
    product_eng:
      "BFL BFL outdoor couple digital clock BFL-7014 for both men and women",
    product_jpn: "[BFL] 비에프엘 아웃도어 커플 남녀공용 디지털 시계 BFL-7014",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "89,000",
    description_eng: "Main product, warranty, case",
    description_jpn: "본품,보증서,케이스",
    product_image_1:
      "https://products.naganorewards.com/KR/BFL/WatchCouple.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1978",
    brand: "BFL",
    sku: "BFFASBFKR0013",
    product_eng: "BFL BFL outdoor couple universal digital watch BFL-7017",
    product_jpn: "[BFL] 비에프엘 아웃도어 커플 남녀공용 디지털 시계 BFL-7017",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "99,000",
    description_eng: "Main product, warranty, case",
    description_jpn: "본품,보증서,케이스",
    product_image_1:
      "https://products.naganorewards.com/KR/BFL/WatchUniversal.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1979",
    brand: "BFL",
    sku: "BFFASBFKR0014",
    product_eng:
      "BFL BFL outdoor couple digital watch for both men and women BFL-7018",
    product_jpn: "[BFL] 비에프엘 아웃도어 커플 남녀공용 디지털 시계 BFL-7018",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "99,000",
    description_eng: "Main product, warranty, case",
    description_jpn: "본품,보증서,케이스",
    product_image_1:
      "https://products.naganorewards.com/KR/BFL/WatchCouple2.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1980",
    brand: "bokuk",
    sku: "BOHOUPRKR0015",
    product_eng:
      "Precious Premium Modern Cactus Washable Safe Washing Electricity Single",
    product_jpn: "[보국]프리미엄 모던선인장 워셔블 안심세탁 전기요 싱글",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "129,000",
    description_eng:
      "[Product characteristics]\n- It's a real washable electricity that can be used in a washing machine and dehydrated\n- Quality safety that can be trusted and used with EMF certification of electromagnetic wave safety\n- Obtain tick-free BAF certification\n- Eco-friendly product LOHAS certification\n- 4th Generation of Boguk Controllers\n- Fast heating/extreme heating/preventing extreme heating/five-fold safety devices\n- 15-hour timer function\n- Jumping quilting method / Using high-quality padding cotton\n- 100% free 2-year domestic manufacturing AS\n- Size: 100 × 180 cm / about 1.8 kg\n- Composition: Electric pole, regulator, storage bag, manual",
    description_jpn:
      "[상품특징]\n - 세탁기사용 및 탈수까지 가능한 진짜워셔블 전기요 \n - 전자파안심 EMF인증으로 믿고 사용 가능한 품질안전\n - 진드기 걱정없는 BAF 인증획득\n - 친환경제품 로하스인증\n - 보국 4세대 컨트롤러\n - 급속가열기능/극부과열방지/5중안전장치\n - 15시간 타이머기능\n - 점핑퀼딩방식 / 고급패팅솜사용\n - 100%국내제조 2년 무상AS\n - 크기 : 100 X 180cm / 약 1.8kg\n - 구성 : 전기요,조절기,보관가방,설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/bokuk/CactusSingle.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1981",
    brand: "bokuk",
    sku: "BOHOUTRKR0016",
    product_eng: "Treasure Sweet sleep, safe washing, electricity, single",
    product_jpn: "[보국]꿀잠안심세탁 전기요 싱글",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "149,000",
    description_eng:
      "[Product characteristics]\n- It's a real washable electricity that can be used in a washing machine and dehydrated\n- Quality safety that can be trusted and used with EMF certification of electromagnetic wave safety\n- Obtain tick-free BAF certification\n- Eco-friendly product LOHAS certification\n- 4th Generation of Boguk Controllers\n- Fast heating/extreme heating/preventing extreme heating/five-fold safety devices\n- 15-hour timer function\n- Jumping quilting method / Using high-quality padding cotton\n- 100% free 2-year domestic manufacturing AS\n- Size: 100 × 180 cm / about 1.8 kg\n- Composition: Electric pole, regulator, storage bag, manual",
    description_jpn:
      "[상품특징]\n - 세탁기사용 및 탈수까지 가능한 진짜워셔블 전기요 \n - 전자파안심 EMF인증으로 믿고 사용 가능한 품질안전\n - 진드기 걱정없는 BAF 인증획득\n - 친환경제품 로하스인증\n - 보국 4세대 컨트롤러\n - 급속가열기능/극부과열방지/5중안전장치\n - 15시간 타이머기능\n - 점핑퀼딩방식 / 고급패팅솜사용\n - 100%국내제조 2년 무상AS\n - 크기 : 100 X 180cm / 약 1.8kg\n - 구성 : 전기요,조절기,보관가방,설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/bokuk/SweetSingle.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1982",
    brand: "bokuk",
    sku: "BOHOUTRKR0017",
    product_eng: "Treasure Sweet sleep, safe washing, electricity, double",
    product_jpn: "[보국]꿀잠안심세탁 전기요 더블",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "159,000",
    description_eng:
      "[Product characteristics]\n- It's a real washable electricity that can be used in a washing machine and dehydrated\n- Quality safety that can be trusted and used with EMF certification of electromagnetic wave safety\n- Obtain tick-free BAF certification\n- Eco-friendly product LOHAS certification\n- 4th Generation of Boguk Controllers\n- Fast heating/extreme heating/preventing extreme heating/five-fold safety devices\n- 15-hour timer function\n- Jumping quilting method / Using high-quality padding cotton\n- 100% free 2-year domestic manufacturing AS\n- Size: 135 × 180 cm / about 2.2 kg\n- Composition: Electric pole, regulator, storage bag, manual",
    description_jpn:
      "[상품특징]\n - 세탁기사용 및 탈수까지 가능한 진짜워셔블 전기요 \n - 전자파안심 EMF인증으로 믿고 사용 가능한 품질안전\n - 진드기 걱정없는 BAF 인증획득\n - 친환경제품 로하스인증\n - 보국 4세대 컨트롤러\n - 급속가열기능/극부과열방지/5중안전장치\n - 15시간 타이머기능\n - 점핑퀼딩방식 / 고급패팅솜사용\n - 100%국내제조 2년 무상AS\n - 크기 : 135 X 180cm / 약 2.2kg\n - 구성 : 전기요,조절기,보관가방,설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/bokuk/SweetDouble.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1983",
    brand: "bokuk",
    sku: "BOHOUPRKR0018",
    product_eng:
      "Precious Premium Modern Cactus Washable Safe Washing Electricity Double",
    product_jpn: "[보국]프리미엄 모던선인장 워셔블 안심세탁 전기요 더블",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "159,000",
    description_eng:
      "[Product characteristics]\n- It's a real washable electricity that can be used in a washing machine and dehydrated\n- Quality safety that can be trusted and used with EMF certification of electromagnetic wave safety\n- Obtain tick-free BAF certification\n- Eco-friendly product LOHAS certification\n- 4th Generation of Boguk Controllers\n- Fast heating/extreme heating/preventing extreme heating/five-fold safety devices\n- 15-hour timer function\n- Jumping quilting method / Using high-quality padding cotton\n- 100% free 2-year domestic manufacturing AS\n- Size: 135 × 180 cm / about 2.2 kg\n- Composition: Electric pole, regulator, storage bag, manual",
    description_jpn:
      "[상품특징]\n - 세탁기사용 및 탈수까지 가능한 진짜워셔블 전기요 \n - 전자파안심 EMF인증으로 믿고 사용 가능한 품질안전\n - 진드기 걱정없는 BAF 인증획득\n - 친환경제품 로하스인증\n - 보국 4세대 컨트롤러\n - 급속가열기능/극부과열방지/5중안전장치\n - 15시간 타이머기능\n - 점핑퀼딩방식 / 고급패팅솜사용\n - 100%국내제조 2년 무상AS\n - 크기 : 135 X 180cm / 약 2.2kg\n - 구성 : 전기요,조절기,보관가방,설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/bokuk/CactusDouble.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1984",
    brand: "Calvin klein",
    sku: "CAFASCAKR0019",
    product_eng:
      "Calvin Klein Men's Casual Sports File Socks Three-Piece Set (Premium Line)",
    product_jpn:
      "[캘빈클라인] 남성 캐주얼 스포츠 파일 양말3족 세트(프리미엄라인)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "45,000",
    description_eng:
      "Calvin Klein's Premium Line \"Men's Sports & Casual Socks Set of 3\"\nHigh-end koma cotton knit soft to the touch and sweat-absorbing socks, laid on the floor in a two-dimensional file structure that relieves fatigue, especially when working out, and emblazoned with the Calvin Klein logo for high-end sports and casual socks that are good to walk or work for a long time.\n\n[Product Composition]\n> Men's Casual Sports File Socks Black Group 1 + White Group 2\n[Product specifications]\n> Material: Cotton, polyester, polyurethane\n> Color: Black 1 & White 2\n> Packaging: Calvin Klein Genuine Wrapper Packaging\n[Product Features]\n> Premium line products with high quality satisfaction\n> We used a cotton fabric that is highly elastic, not too tight, and has excellent absorption\n> Minimize foot fatigue from sports activities with double 3D file socks\n> Pure Calvin Klein logo for luxury\n> High-quality socks that can be used for various purposes such as sports, golf, leisure, casual, hiking, etc",
    description_jpn:
      "캘빈클라인의 프리미엄 라인 “남성 스포츠&캐주얼 양말 3족 세트”\n 본 양말은 고급 코마면으로 편직하여 느낌이 부드러우며 땀 흡수력이 뛰어난 제품으로 특히 바닥을 2중 입체 파일조직으로 편직하여 운동시에 피로감을 덜어주며, 오랫동안 걷거나 활동하기 좋은 스포츠 양말 및 캐주얼 양말로 Calvin Klein로고를 새겨 브랜드를 강조한 최고급 양말입니다.\n \n [제품구성]\n  > 남성 캐주얼 스포츠 파일양말 블랙1족 + 화이트2족\n [제품사양]\n  > 소재: 면, 폴리에스터, 폴리우레탄\n  > 색상: 블랙1 & 화이트2\n  > 포장: 캘빈클라인 정품포장지 포장\n [제품특징]\n  > 프리미엄 라인으로 품질에 대한 만족도가 우수한 상품\n  > 고신축 코마면 원단을 사용하여 신축성이 뛰어나 심한 조임이 없으며 흡수력이 뛰어남\n  > 2중 입체 파일조직의 두툼한 파일양말로 스포츠 활동으로 인한 발의 피로를 최소화함\n  > 캘빈클라인 정품 로고가 처리되어 고급스러움을 더함\n  > 스포츠, 골프, 레져, 캐주얼, 등산등 다용도로 사용 가능한 고급 양말",
    product_image_1:
      "https://products.naganorewards.com/KR/Calvin_Klein/SocksMen.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1985",
    brand: "Calvin klein",
    sku: "CAFASCAKR0020",
    product_eng:
      "Calvin Klein Women's Casual Sports File Socks Three-Piece Set (Premium Line)",
    product_jpn:
      "[캘빈클라인] 여성 캐주얼 스포츠 파일 양말3족 세트(프리미엄라인)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "45,000",
    description_eng:
      "Calvin Klein's Premium Line \"Women's Sports & Casual Socks Set of 3\"\nThese socks are knitted with high-end koma cotton, which feels soft and has excellent sweat absorption, especially with double-dimensional file structures on the floor to relieve fatigue when exercising, and are high-end sports socks and casual socks that are good to walk or work for a long time, with the Calvin Klein logo engraved on them.\n\n[Product composition]\n> Women's casual sports file socks Black Group 1 + White Group 2\n[Product specifications]\n> Material: Cotton, polyester, polyurethane\n> Color: Black 1, White 2\n> Packaging: Calvin Klein Genuine Wrapper Packaging\n[Product Features]\n> Premium line products with excellent satisfaction with quality\n> High-stretch Koma cotton fabric is used for excellent elasticity, no severe tightening, and excellent absorption\n> Double three-dimensional file socks minimize foot fatigue from sports activities\n> Genuine Calvin Klein logo for luxuriousness\n> High-quality socks that can be used for various purposes such as sports, golf, leisure, casual, hiking, etc",
    description_jpn:
      "캘빈클라인의 프리미엄 라인 “여성 스포츠&캐주얼 양말 3족 세트”\n 본 양말은 고급 코마면으로 편직하여 느낌이 부드러우며 땀 흡수력이 뛰어난 제품으로 특히 바닥을 2중 입체 파일조직으로 편직하여 운동시에 피로감을 덜어주며, 오랫동안 걷거나 활동하기 좋은 스포츠 양말 및 캐주얼 양말로 Calvin Klein로고를 새겨 브랜드를 강조한 최고급 양말입니다.\n \n [제품구성]\n  > 여성 캐주얼 스포츠 파일양말 블랙1족 + 화이트2족\n [제품사양]\n  > 소재: 면, 폴리에스터, 폴리우레탄\n  > 색상: 블랙1, 화이트2\n  > 포장: 캘빈클라인 정품포장지 포장 \n [제품특징]\n  > 프리미엄 라인으로 품질에 대한 만족도가 우수한 상품\n  > 고신축 코마면 원단을 사용하여 신축성이 뛰어나 심한 조임이 없으며 흡수력이 뛰어남\n  > 2중 입체 파일조직의 두툼한 파일양말로 스포츠 활동으로 인한 발의 피로를 최소화함\n  > 캘빈클라인 정품 로고가 처리되어 고급스러움을 더함\n  > 스포츠, 골프, 레져, 캐주얼, 등산등 다용도로 사용 가능한 고급 양말",
    product_image_1:
      "https://products.naganorewards.com/KR/Calvin_Klein/SocksWomen.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1986",
    brand: "Celltrion",
    sku: "CECOSCEKR0021",
    product_eng: "Celltrion Nourishing Ultra Hand and Nail Cream 50 ml",
    product_jpn: "[셀트리온] 너리싱울트라 핸드앤네일 크림 50ml",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "30,000",
    description_eng:
      "Hand wrinkles and nail care due to dry skin all at once!\nWrinkle improvement and hypoallergenic tested cosmetics\n\n* Ingredients and ingredients: purified water, shea butter, glycerin, cetylethylsecanoate, cetearyl alcohol, cetearylolivate, sorbitanolivate, hydrozenate vegetable oil, olive oil, etc\n\n* Product Features\n1. High-strength anti-aging that provides elasticity at once as if it has received professional skin care with Celltrion's patented ingredients\n2. Hand wrinkles, texture, elasticity improvement, and new hand care that have evolved to the next level\n3. Containing adenosine, a functional ingredient for improving wrinkles announced by the Ministry of Food and Drug Safety, intensive wrinkle care\n4. Bio-company Celltrion's technology is the only new material in the world, containing 'farming-peb'\n5. The most natural moisturizer from nature, containing shea butter\n6. Moisturizing and taking care of your hands and nails at the same time!",
    description_jpn:
      "건조한 피부로 인한 손주름과 손톱 관리를 한번에!\n주름개선 및 저자극 테스트 완료 화장품\n\n* 원료 및 성분 : 정제수, 시어버터, 글리세린, 세틸에틸섹사노에이트, 세테아릴알코올,세테아릴올리베이트,솔비탕로리베이트,하이드로제네이트식물성오일, 올리브오일 외\n\n* 상품특징\n1. 셀트리온의 특허성분으로 전문 피부관리를 받은듯 단번에, 탄력을 선사하는 고강도 안티에이징\n2. 세월의 흔적이 느껴지는 손 주름, 결,탄력개선, 한차원 진화된 새로운 핸드케어\n3. 식약처 고시 주름개선 기능성 성분 아데노신 함유, 집중주름케어\n4. 바이오 기업 셀트리온의 기술력으로 탄색한 독자 신물질 국제유일, '퍼밍-펩\" 함유\n5. 자연이 선사한 가장 자연적인 보습제, 시어버터 함유\n6. 손과 손톱의 보습과 관리를 동시에, 한번에!",
    product_image_1:
      "https://products.naganorewards.com/KR/celltrion/HandCream.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1987",
    brand: "Celltrion",
    sku: "CECOSCEKR0022",
    product_eng:
      "Celltrion Celineon Bio All-in-One Foreman 300 ml + 50 ml + 50 ml (with shopping bag)",
    product_jpn:
      "[셀트리온] 셀린온 바이오 올인원 포맨 300ml+50ml+50ml (쇼핑백포함)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "150,000",
    description_eng:
      "* Product characteristics\n\n1. Deep ocean water and 8 hyaluronic acid complexes boost moisture energy to the skin\n2. The power of skin science, which has become more powerful with global biotechnology company Celltrion's only patented active pep\n3. Hypoallergenic cooling calming care that is comfortable for damaged and stimulated skin due to external factors such as frequent shaving and stress\n4. It's an oil cut formulation that relieves dirty oil on the skin with PHA ingredients and takes care of clean skin\n5. Manic woody scent: A neutral scent that interprets the charisma of a modern and elegant man, and expresses warmth, sensuality, and delicacy with a manic woody scent",
    description_jpn:
      "* 상품특성\n\n1.해양심층수와 8종 히알루론산 콤플렉스가 피부에 수분활력 에너지 부스팅\n2. 글로벌 바이오기업 셀트리온의 국제 유일 특허성분 액티브펩을 담아 더욱 강력해진 피부과학의 힘\n3. 잦은면도와 스트레스등 외부요인으로 인해 손상자극된 피부에 피부가 편안한 저자극 쿨링 진정케어\n4. PHA성분이 피부에 겉도는 지저분한 유분을 덜어주어 깔끔한 피부로 케어해주는 오일컷 제형\n5. 매니시한 우디계열 향 : 모던하고 우아한 남성의 카리스마를 해석한 중성적인 향으로 따뜻함, 관능미, 섬세함을 매니시한 우디계열로 표현",
    product_image_1:
      "https://products.naganorewards.com/KR/celltrion/ForemanSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1988",
    brand: "Celltrion",
    sku: "CECOSCEKR0023",
    product_eng: "Celltrion Celineon Bio Extreme Lifting Skincare Set of 7",
    product_jpn: "[셀트리온]셀린온 바이오 익스트림 리프팅 스킨케어 7종세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "598,000",
    description_eng:
      "*Configuration\n150 ml Skin, 50 ml Serum, 30 ml Concentrate, 150 ml Emulsion, 30 ml Spot Concentrate, 50 ml Day Cream (Core Cream Classic), 50 ml Night Cream (Core Cream EX) 50 ml\n\n1. Extremely high lifting care\n2. Celltrion's Technology! Contains BIO-3RF (EGF, TRX, IGF-1)\n3. Celltrion's proprietary patent ingredient Active-Pep (registered in the U.S. ICID, published an SCI-class paper in the German Academy of Dermatology, won the Jang Young-sil Award, and won the Ji Seok Image)\n4. Contains 1,000 ppm of mesenchymal stem cell culture extract for human production\n5. Completion of clinical trials for non-(n) stimulation test for skin stability (PNK Skin Clinical Research Center)\n6. Whitening and wrinkle improvement functional cosmetics certification (Ministry of Food and Drug Safety)\n7. Manufactured by an excellent cosmetics manufacturing and quality control standards (CGMP) certified company\n8. International Standard Certification ISO 22716 International Standard Product Manufacturing Management",
    description_jpn:
      "*구성\n스킨 150ml,세럼 50ml,컨센트레이트 30ml,에멀전 150ml,스팟 컨센트레이트 30ml,데이크림(코어크림 클래식) 50ml,나이트크림(코어크림 이엑스) 50ml\n\n1. 극강고도의 리프팅 케어\n2. 셀트리온의 기술력! BIO-3RF (EGF, TRX, IGF-1)함유\n3. 셀트리온 독점 특허성분 액티브-펩 함유(미국 ICID 등록, 독일 피부과학회지 SCI급 논문 게재, 장영실상 수상, 지석영상 수상)\n4. 인체제대중간엽줄기세포배양액 추출물 1,000ppm 함유\n5. 피부안정성 비(무) 자극테스트 임상시험 완료(피엔케이 피부임상연구센터)\n6. 미백, 주름개선 기능성 화장품 인증(식품의약품안전처)\n7. 우수화장품 제조 및 품질관리기준(CGMP) 인증 기업에서 제조\n8. 국제표준기준 인증 ISO 22716 국제규격 제품제조 관리",
    product_image_1:
      "https://products.naganorewards.com/KR/celltrion/SkincareSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1989",
    brand: "Cheong Kwan Jang",
    sku: "CHHEADIKR0024",
    product_eng: "Director Jeong Red ginseng fingerprint (50ml × 30 bags)",
    product_jpn: "[정관장] 홍삼지감 (50ml*30포)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "44,000",
    description_eng:
      "■ Composition: 50ml*30 bags, shopping bag\n\n- Red ginseng concentrated solution 0.36% and mixed plant concentrated solution\n- The taste and aroma of red ginseng are gently put in so that the whole family can eat it.\n- It is a pouch-type product using 6-year-old ginseng contracted by the articles of association.",
    description_jpn:
      "■ 구성 : 50ml*30포, 쇼핑백\n\n- 홍삼농축액 0.36% ,  식물혼합농축액\n- 온 가족이 먹을 수 있도록 홍삼의 맛과 향을 부드럽게 담았습니다.\n- 정관장에서 직접 계약재배한 6년근 인삼을 사용한 파우치 타입의 제품입니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheong_Kwan_Jang/GinsengFingerprint.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1990",
    brand: "Cheong Kwan Jang",
    sku: "CHHEADIKR0025",
    product_eng: "Director Jeong Red ginseng supplement (50ml × 20 bags)",
    product_jpn: "[정관장] 홍삼보력 (50ml*20포)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "98,000",
    description_eng:
      "■ Composition: 50 ml × 20 bags, shopping bag\n\n- Red ginseng concentrate 0.8%, mixed plant concentrate\n- Six-year-old red ginseng was gently extracted to capture the taste and aroma of red ginseng.\n- The Korea Ginseng Research Institute conducts numerous stability tests more strictly and manages quality.",
    description_jpn:
      "■ 구성 : 50ml*20포, 쇼핑백\n\n- 홍삼농축액 0.8%, 식물혼합농축액\n- 6년근 홍삼을 부드럽게 추출하여 홍삼의 맛과 향을 담아냈습니다. \n- 한국인삼연구원에서 더욱 엄격하게 수많은 안정성 검사를 실시하며, 품질을 관리하고 있습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheong_Kwan_Jang/GinsengSupplement.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1991",
    brand: "Cheong Kwan Jang",
    sku: "CHHEADIKR0026",
    product_eng: "Director Jeong Red ginseng vitality (40ml × 30 bags)",
    product_jpn: "[정관장] 홍삼활력 (40ml*30포)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "99,000",
    description_eng:
      "■ Composition: 40ml*30 bags, shopping bag\n\n- Red ginseng concentrated solution 2%, antler extract\n- It is a red ginseng product made in Korea with six years of red ginseng.\n- It uses raw materials that have passed strict quality control such as peony, oak, earth sulfur, yellow flag, licorice, and dermis.",
    description_jpn:
      "■ 구성 : 40ml*30포, 쇼핑백\n\n- 홍삼농축액 2% ,  녹용추출액\n- 국내산 6년근 홍삼을 정성껏 달인 홍삼제품입니다. \n- 작약, 참당귀, 지황, 황기, 감초, 진피 등 엄격한 품질관리를 통과한 원료를 사용합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheong_Kwan_Jang/GinsengVitality.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1992",
    brand: "Cheong Kwan Jang",
    sku: "CHHEADIKR0027",
    product_eng: "Director Jeong Red Ginseng Garhwal (50ml × 30 bags)",
    product_jpn: "[정관장] 홍삼가활 (50ml*30포)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "67,000",
    description_eng:
      "■ Composition: 50ml*30 bags, shopping bag\n\n- Red ginseng concentrated solution 1.28% and Yeongji mushroom concentrated solution\n- It is a product that can be enjoyed healthier by adding Yeongji mushroom concentrate to red ginseng concentrate.\n- It is a pouch-type product using 6-year-old ginseng contracted by the articles of association.",
    description_jpn:
      "■ 구성 : 50ml*30포, 쇼핑백\n\n- 홍삼농축액 1.28%, 영지버섯 농축액\n- 홍삼농축액에 영지버섯 농축액을 더해 더욱 건강하게 즐기실 수 있는 제품입니다.\n- 정관장에서 직접 계약재배한 6년근 인삼을 사용한 파우치타입의 제품입니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheong_Kwan_Jang/GinsengGarhwal.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1993",
    brand: "Cheong Kwan Jang",
    sku: "CHHEADIKR0028",
    product_eng: "Director Jeong 250g of red ginseng",
    product_jpn: "[정관장] 홍삼대정 250g",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "70,000",
    description_eng:
      "■ Composition: Red Ginseng Daejeong 250 g + Case + Shopping Bag\n\n- Red ginseng concentrated solution 6.3%, fruit concentrated solution of oriental raisin tree (Daejeong)\n- Red ginseng concentrate 1% (Red ginseng candy)\n- Red ginseng concentrate (70mg/g of saponin) is added 6.3%.\n- It is a good gift with a red ginseng concentrate type product consisting of two 250g bottles and candy to soothe the bitterness of red ginseng.",
    description_jpn:
      "■ 구성 : 홍삼대정 250g+케이스+쇼핑백\n\n- 홍삼농축액 6.3%,  헛개나무열매농축액\n- 홍삼농축액 (사포닌70mg/g) 6.3%이 첨가되어있습니다.\n- 홍삼 농축액 타입의 제품과 정관장 전용 케이스로 선물용으로 좋습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheong_Kwan_Jang/Ginseng250g.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1994",
    brand: "Cheong Kwan Jang",
    sku: "CHHEADIKR0029",
    product_eng: "Director Jeong Red ginseng supplement (50ml*60 bags)",
    product_jpn: "[정관장] 홍삼보력 (50ml*60포)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "190,000",
    description_eng:
      "■ Composition: 50ml*60 bags, shopping bag\n\n- Red ginseng concentrate 0.8%, mixed plant concentrate\n- Six-year-old red ginseng was gently extracted to capture the taste and aroma of red ginseng.\n- The Korea Ginseng Research Institute conducts numerous stability tests more strictly and manages quality.",
    description_jpn:
      "■ 구성 : 50ml*60포, 쇼핑백\n\n- 홍삼농축액 0.8%, 식물혼합농축액\n- 6년근 홍삼을 부드럽게 추출하여 홍삼의 맛과 향을 담아냈습니다. \n- 한국인삼연구원에서 더욱 엄격하게 수많은 안정성 검사를 실시하며, 품질을 관리하고 있습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheong_Kwan_Jang/GinsengSupplement60.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1995",
    brand: "Cheong Kwan Jang",
    sku: "CHHEADIKR0030",
    product_eng:
      "Director Jeong Red ginseng large set (250g × 2 bottles + Red ginseng candy 120g)",
    product_jpn: "[정관장] 홍삼대정세트 (250g*2병+홍삼캔디 120g)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "130,000",
    description_eng:
      "■ Composition: Red Ginseng Daejeong 250 g + Case + Shopping Bag\n\n- Red ginseng concentrated solution 6.3%, fruit concentrated solution of oriental raisin tree (Daejeong)\n- Red ginseng concentrate 1% (Red ginseng candy)\n- Red ginseng concentrate (70mg/g of saponin) is added 6.3%.\n- It is a good gift with a red ginseng concentrate type product consisting of two 250g bottles and candy to soothe the bitterness of red ginseng.",
    description_jpn:
      "■ 구성 : 홍삼대정 250g+케이스+쇼핑백\n\n- 홍삼농축액 6.3%, 헛개나무열매농축액(대정)\n- 홍삼농축액 1% (홍삼캔디)\n-  홍삼농축액 (사포닌70mg/g) 6.3%이 첨가되어있습니다.\n- 250g 2병으로 구성된 홍삼 농축액 타입의 제품과 홍삼의 쓴맛을 달래 줄 캔디가 포함된 알찬 구성으로 선물용으로 좋습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheong_Kwan_Jang/GinsengLargeSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1996",
    brand: "Cheong Kwan Jang",
    sku: "CHHEADIKR0031",
    product_eng:
      "Director Jeong Red ginseng original set (250g × 2 bottles + Red ginseng candy 120g)",
    product_jpn: "[정관장] 홍삼본정세트 (250g*2병+홍삼캔디 120g)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "110,000",
    description_eng:
      "■ Composition: Red ginseng original 250 g × 2 bottles + Red ginseng caddy water 120 g\n\n- Including 5753% of red ginseng concentrated liquid, jujube, succulent, Bokryeong, Gooji, Cheongung, Danggui, etc\n- Red ginseng concentrate 1% and red ginseng powder 0.2% (red ginseng candy)\n- Red ginseng concentrate (70mg/g of saponin) is added 6.3%.\n- It is a good gift with a red ginseng concentrate type product consisting of two 250g bottles and candy to soothe the bitterness of red ginseng.",
    description_jpn:
      "■ 구성 : 홍삼본정 250g*2병 + 홍삼캐디수 120g\n\n- 홍삼농축액 5753%,대추, 숙지황, 복령, 구기자, 천궁, 당귀등 농협액 포함\n- 홍삼농축액 1%,홍삼분말 0.2% (홍삼수캔디)\n-  홍삼농축액 (사포닌70mg/g) 6.3%이 첨가되어있습니다.\n- 250g 2병으로 구성된 홍삼 농축액 타입의 제품과 홍삼의 쓴맛을 달래 줄 캔디가 포함된 알찬 구성으로 선물용으로 좋습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheong_Kwan_Jang/GinsengOriginal.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1997",
    brand: "Cheong Kwan Jang",
    sku: "CHHEADIKR0032",
    product_eng: "Director Jeong Red ginseng vitalizer (250 g × 2 bottles)",
    product_jpn: "[정관장] 홍삼활력보세트 (250g*2병)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "150,000",
    description_eng:
      "■ Composition: Red Ginseng Vitality Bo Set (250 g × 2 bottles)\n\n- Product characteristics: It is a health functional food that presents healthy vitality to the whole family, containing 10.2% of the 6-year-old red ginseng concentrate and traditional materials such as Sookji Hwang, Bokryeong, and Gooja.\n\n- Raw materials and contents: Red ginseng concentrate (6 years root, 64% solid content, 5.5mg/g of ginsenosite Rg1+Rb1+Rg3, domestic) 10.2%, plant-mixed concentrate (lobchu, ripe rhubarb, cornelian cherry, heavenly palace), natural flavoring (herb scent)",
    description_jpn:
      "■ 구성 :홍삼활력보세트 (250g*2병)\n\n- 제품특성 : 정관장 6년근 홍삼농축액 10.2%에, 숙지황, 복령, 구기자 등의 전통소재를 함유한 온 가족에게 건강한 활력을 선물해주는 건강기능식품입니다.                   \n\n- 원재료 및 함량 : 홍삼농축액(6년근,고형분64%,진세노사이트Rg1+Rb1+Rg3 5.5mg/g,국산)10.2%,식물혼합농축액(대추,숙지황,복령,구기자,당귀,천궁),천연착향료(허브향)",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheong_Kwan_Jang/GinsengVitalizer.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1998",
    brand: "Cheongsoom",
    sku: "CHHEAFRKR0033",
    product_eng: "Fresh breath Aronia undiluted solution gift set No. 1",
    product_jpn: "[청숨] 통째로 갈아만든 아로니아 원액 선물세트 1호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "30,000",
    description_eng: "500ml * 1 bottle",
    description_jpn: "500ml * 1병",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheongsoom/AroniaSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "1999",
    brand: "Cheongsoom",
    sku: "CHHEABRKR0034",
    product_eng: "Breathing The whole citron extract gift set No. 1",
    product_jpn: "[청숨] 통째로 갈아만든 유자 원액 선물세트 1호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "30,000",
    description_eng: "500ml * 1 bottle",
    description_jpn: "500ml * 1병",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheongsoom/CitronSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2000",
    brand: "Cheongsoom",
    sku: "CHHEABRKR0035",
    product_eng:
      "Breathing Green tangerine extract that was ground as a whole. No. 1 gift set",
    product_jpn: "[청숨] 통째로 갈아만든 청귤 원액 선물세트 1호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "30,000",
    description_eng: "500ml * 1 bottle",
    description_jpn: "500ml * 1병",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheongsoom/TangerineSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2001",
    brand: "Cheongsoom",
    sku: "CHHEABRKR0036",
    product_eng: "Breathing The whole ginger extract gift set No. 1",
    product_jpn: "[청숨] 통째로 갈아만든 생강 원액 선물세트 1호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "32,000",
    description_eng: "500ml * 1 bottle",
    description_jpn: "500ml * 1병",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheongsoom/GingerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2002",
    brand: "Cheongsoom",
    sku: "CHHEAFRKR0037",
    product_eng: "Fresh breath Green plum extract gift set No. 1",
    product_jpn: "[청숨] 통째로 갈아만든 매실 원액 선물세트 1호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "35,000",
    description_eng: "500ml * 1 bottle",
    description_jpn: "500ml * 1병",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheongsoom/PlumSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2003",
    brand: "Cheongsoom",
    sku: "CHHEABRKR0038",
    product_eng: "Breathing Omija undiluted solution gift set No. 1",
    product_jpn: "[청숨] 통째로 갈아만든 오미자 원액 선물세트 1호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "35,000",
    description_eng: "500ml * 1 bottle",
    description_jpn: "500ml * 1병",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheongsoom/OmijaSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2004",
    brand: "Cheongsoom",
    sku: "CHHEAFRKR0039",
    product_eng:
      "Fresh breath Fermented medicinal bellflower root concentrate No. 3 set",
    product_jpn: "[청숨] 발효 약도라지 농축액 3호세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "45,500",
    description_eng:
      "[10g stick x 30 bags of fermented bellflower root concentrate]",
    description_jpn: "[발효 약도라지 농축액 10g 스틱 X 30포]",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheongsoom/BellflowerSet3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2005",
    brand: "Cheongsoom",
    sku: "CHHEAFRKR0040",
    product_eng:
      "Fresh breath Fermented medicinal bellflower root concentrate No. 1 set",
    product_jpn: "[청숨] 발효 약도라지 농축액 1호세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "66,500",
    description_eng:
      "[10g stick x 20 bags of fermented bellflower root concentrate] +\n[Fertilized bellflower root concentrate 220g x 1 bottle]",
    description_jpn:
      "[발효 약도라지 농축액 10g 스틱 X 20포] + \n[발효 약도라지 농축액 220g X 1병]",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheongsoom/BellflowerSet1.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2006",
    brand: "Cheongsoom",
    sku: "CHHEAFRKR0041",
    product_eng:
      "Fresh breath Fermented medicinal bellflower root concentrate No. 5 set",
    product_jpn: "[청숨] 발효 약도라지 농축액 5호세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "112,000",
    description_eng:
      "[10g stick x 20 bags of fermented bellflower root concentrate] +\n[Fertilized bellflower root concentrate 220g x 2 bottles]",
    description_jpn:
      "[발효 약도라지 농축액 10g 스틱 X 20포] + \n[발효 약도라지 농축액 220g X 2병]",
    product_image_1:
      "https://products.naganorewards.com/KR/Cheongsoom/BellflowerSet5.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2007",
    brand: "CHUNHONCARE",
    sku: "CHHEACHKR0042",
    product_eng:
      "Cheonho Encare Daily Core 20g*15 bags of aloe in faraway regions",
    product_jpn: "[천호엔케어] 데일리코어 먼역엔 알로에뮨 20g*15포",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      '"Every day, I gather the most important points, and I\'ll say \'Daily Core Immunity Aloe Mune\'."\nFor more than 4,000 years, human health functional food, God\'s gift" "Aloe vera"\nAloe gel extracted from aloe vera is found to improve immunity, intestinal health, and skin health\n[Product composition]\n> Chunho 20g*15 sachets of aloe\n[Product Features]\n> 100% American aloe vera: High quality aloe vera containing immunopolysaccharide *International Association of Aloe Standards (IASC) certified raw material\n> Triple complex health functional food: Aloe gel, the only ingredient that satisfies immunity, intestinal health, and skin health at once\n> Immunopolysaccharide concentration with scientific manufacturing method: Processing starts within 2 hours after harvesting, and freeze-drying method minimizes loss of active ingredients\n> Main ingredient Aloe gel + carefully selected subsidiary ingredients: zinc, vitamin B1, B2, B6, niacin, biotin, green grapes, apples\n>1 immune jelly per day: 100% immune polysaccharide content recommended by the Ministry of Food and Drug Safety\n[Ingredients and contents]\n> Food type: Health functional food / Aloe gel: It can help improve immunity, skin health, and intestinal health\n> Raw material name: Aloe vera gel powder (American/aloe vera gel powder, maltodextrin), glucose solution, purified water, green grape concentrate (chileic acid), fructooligosaccharide, apple concentrate (apple: local), mixed product 1 (locust bean gum, fine detection gum, hydrous crystal glucose, agar, tamarind gum), mixed product 2 (propylene glycol, synthetic flavoring, acetic acid, glacial acetic acid, purified water, sugar syrup, alcohol, caramel pigment), citric acid, calcium lactate, enzyme-treated stevia, complex golden extract, zinc oxide, nicotinamide, mixed product 3 (calcium phosphate, biotin), vitamin B6 hydrochloride, vitamin B1 nitrate, vitamin B2"',
    description_jpn:
      '"매일, 가장 중요한 핵심만 모아서 ‘데일리코어 면역엔 알로에뮨‘\n4천년 이상 긴 시간 인류의 건강기능식품, 신의 선물 ""알로에베라""\n알로에베라에서 추출한 알로에겔은 면역력 증진, 장 건강, 피부 건강의 기능성이 밝혀짐\n[제품구성]\n > 천호 알로에뮨 20g*15포\n[제품특징]\n > 100% 미국산 알로에베라 : 면역다당체가 함유된 고품질 알로에베라 *국제 알로에 기준심의 협회(IASC) 인증 원료\n > 3중 복합 건강기능식품 : 면역력증진, 장건강, 피부건강을 한 번에 충족시키는 유일한 원료 알로에겔\n > 과학적 제조공법으로 면역다당체 농축 : 수확 후 2시간 이내 가공 시작, 동결건조공법으로 유효성분의 손실을 최소화\n > 주원료 알로에겔 + 엄선한 부원료 : 아연, 비타민B1, B2, B6, 나이아신, 비오틴, 청포도, 사과 \n > 1일 1면역젤리 : 식약처 권장 면역다당체 함유량 100% 충족\n[성분 및 함량]\n > 식품유형 : 건강기능식품 / 알로에겔 : 면역력증진, 피부건강, 장건강에 도움을 줄 수 있음\n > 원재료명 : 알로에베라겔파우더(미국산/알로에베라겔분말, 말토덱스트린), 포도당액, 정제수, 청포도농축액(칠레산), 프락토올리고당, 사과농축액(사과:국산), 혼합제제1(로커스트콩검, 잔탐검, 함수결정포도당, 한천, 타마린드검), 혼합제제2(프로필렌글리콜, 합성향료, 초산, 빙초산, 정제수, 슈가시럽, 주정, 카라멜색소), 구연산, 젖산칼슘, 효소처리스테비아, 복합황금추출물, 산화아연, 니코틴산아미드, 혼합제제3(제이인산칼슘, 비오틴), 비타민B6염산염, 비타민B1질산염, 비타민B2"',
    product_image_1:
      "https://products.naganorewards.com/KR/CHUNHONCARE/AloeSet.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2008",
    brand: "CHUNHONCARE",
    sku: "CHHEACAKR0043",
    product_eng: "Care for Cheonho Rusty red ginseng vigor 70ml*30 pack",
    product_jpn: "[천호엔케어] 녹용홍삼활력 70ml*30팩",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "70,000",
    description_eng:
      "\"Rolling Red Ginseng Vitality\" containing precious antlers and red ginseng\nClean Nature Red Ginseng, a six-year-old 'melon' grown in New Zealand and a six-year-old 'red ginseng' that has endured the harsh cold\n\"Renlyong Red Ginseng Vitality,\" which allows men and women of all ages to enjoy healthy and deep taste without burden\n\n[Product composition]\n> Cheonho Rusty Red Ginseng Vitality 70ml*30 packs *Shopping bag requested separately\n[Product Features]\n> Clean New Zealand deer antlers: Use whole batteries including deer antlers, deer antlers tips, and bone managed in accordance with the New Zealand government's strict food control law\n> 6-year-old red ginseng: Use 6-year-old red ginseng grown in high-quality Gangwon-do soil\n> Selected plant ingredients: Chamdanggui, jujube, cheongung, Sukjihwang, Sapju, Peony, Licorice, Sansuyu, Baekbokryeong, Hwanggi, cinnamon, Seokchangpo, Chaga mushroom, Injin mugwort\n> 4-layered cheer pack type product: Easy to open in the form of a spout pouch and eat neatly\n[Ingredients and contents]\n> Food type: Red ginseng beverage\n> Raw material name: Daebo extract [Cham Dangi (Domestic), Daechu (Domestic), Cheongung (Domestic), Sukji Hwang, Sapju, Peony, Gacho, Sansuyu, Baekbongryeong, Hwanggi, cinnamon, Seokchangpo, Chaga mushroom, Injin mugwort], Nokyong extract 8% [Solid content 0.1%; Nokyong (New Zealand)], Guitar fructose, unsweetened honey (Domestic)], 6-year root red ginseng concentrate 0.4% [Solid content 60%; Red ginseng ingredient 70mg/g; Raw material triplicate ratio: Red ginseng root 70%; Red rice ginseng 30%; Domestic), Guagum, Guja gum, Gooji extract",
    description_jpn:
      "귀한 녹용과 홍삼을 담은 ‘녹용홍삼활력’\n 청정 자연 뉴질랜드에서 자란 ‘녹용’과 혹독한 추위를 견뎌낸 6년근 ‘홍삼’\n 남녀노소 누구나 건강하고 깊은 맛을 부담없이 즐길 수 있는 ‘녹용홍삼활력’\n \n [제품구성]\n  > 천호 녹용홍삼활력 70ml*30팩 *쇼핑백 별도 요청\n [제품특징]\n  > 청정 뉴질랜드산 녹용 : 뉴질랜드 정부의 엄격한 식품관리법에 따라 관리된 녹용 사용, 녹용의 팁, 분골까지 포함된 전지를 통째로 사용\n  > 힘이 꽉 찬 6년근 홍삼 : 양질의 강원도 토양에서 자라 힘이 꽉 찬 6년근 홍삼을 사용\n  > 엄선된 다양한 식물성 원료 : 참당귀, 대추, 천궁, 숙지황, 삽주, 작약, 감초, 산수유, 백복령, 황기, 계피, 석창포, 차가버섯, 인진쑥\n  > 4중 치어팩형 제품 : 스파우트 파우치 형태로 간편하게 개봉하여 깔끔하게 섭취 가능\n [성분 및 함량]\n  > 식품유형 : 홍삼음료\n  > 원재료명 : 대보추출액[참당귀(국산),대추(국산),천궁(국산),숙지황,삽주,작약,감초,산수유,백봉령,황기,계피,석창포,차가버섯,인진쑥], 녹용추출액8%[고형분함량0.1%,녹용(뉴질랜드)], 기타과당, 사양벌꿀(국산), 6년근홍삼농축액0.4%[고형분함량60%,홍삼성분70mg/g,원료삼배합비율:홍삼근70%,홍미삼30%,국산), 구아검, 구기자추출물",
    product_image_1:
      "https://products.naganorewards.com/KR/CHUNHONCARE/GinsengVigor.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2009",
    brand: "CHUNHONCARE",
    sku: "CHHEACHKR0044",
    product_eng:
      "Cheonho's care cultivated wild ginseng The Black 60 ml × 30 bags",
    product_jpn: "[천호엔케어] 산삼배양근 더 블랙 60ml*30포",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "90,000",
    description_eng:
      '"cultivated wild ginseng the Black", which contains black foods such as frosted tae, black rice, black sesame, and succulent sulfur in cultivated wild ginseng\nCarefully select domestic cultivated wild ginseng, which is a precious ingredient\nDeep and Jinhang flavor through the combination of 20 precious ingredients, including black food\n\n[Product composition]\n> Cheonho cultivated wild ginseng The Black 60 ml × 30 bags *Shopping bag requested separately\n[Product Features]\n> 100% domestic cultivated wild ginseng carefully selected\n> 20 selected ingredients: cultivated wild ginseng + black food (black garlic, frosted tae, etc.) + subsidiary ingredients (Cheongung, Chaga mushroom, etc.) provide a deep and rich flavor\n> Deep and clean taste with Cheonho\'s know-how: 30kcal calories per pack, 0% saturated fat, trans fat, cholesterol\n> cultivated wild ginseng The Black made through strict quality control with hygienic and systematic manufacturing method and self-history management system\n[Ingredients and contents]\n> Food type: Liquid tea\n> Raw material name: purified water, vegetable mixed extract [lake, oak, heaven, palace, ripe yellow, licorice, peony, ginger, cinnamon, black garlic, indigo, charcuterium, black rice, black sesame, black barley, yellow flag, white peach], guitar fructose, maltodextrin, arrowroot concentrate (domestic), twin flower concentrate [crop (China), heaven (China), ripe yellow (China), yellow pepper, green pepper, cinnamon, green pepper, green pepper], wild ginseng root extract 0.47% (solid content 3.5%, domestic), cinnamon concentrate, mixture (propylene glycol, purified water, alcohol, glycerin, natural flavoring, synthetic flavoring), citric acid, enzyme-treated stevia',
    description_jpn:
      "산삼배양근에 서리태, 흑미, 흑임자, 숙지황 등의 블랙푸드를 담은 ‘산삼배양근 더 블랙‘\n 귀한 원료인 국산 산삼배양근을 엄선\n 블랙푸드를 비롯해 20가지의 귀한 원료 배합을 통해 깊고 진항 풍미\n \n [제품구성]\n  > 천호 산삼배양근 더 블랙 60ml*30포 *쇼핑백 별도 요청\n [제품특징]\n  > 100% 국산 산삼배양근을 엄선하여 담은 제품\n  > 20가지 엄선된 원료 배합 : 산삼배양근+블랙푸드(흑마늘, 서리태 등)+부원료(천궁, 차가버섯 등)의 배합으로 깊고 진한 풍미를 느낄 수 있음\n  > 천호의 노하우를 담은 깊고 깔끔한 맛 : 1포 열량 30kcal, 포화지방, 트랜스지방, 콜레스테롤 0%\n  > 위생적이고 체계적인 제조공법, 자체 이력관리시스템으로 깐깐한 품질관리를 통해 만들어진 산삼배양근 더 블랙\n [성분 및 함량]\n  > 식품유형 : 액상차\n  > 원재료명 : 정제수, 식물혼합추출액[대추,참당귀,천궁,숙지황,감초,작약,생강,계피,흑마늘,인진숙,서리태,차가버섯,흑미,흑임자,흑보리,황기,백복령], 기타과당, 말토덱스트린, 칡농축액(국산), 쌍화농축액[작약(중국),천궁(중국),숙지황(중국),황기,감초,당귀,계피,생강,대추], 산삼배양근추출물0.47%(고형분함량3.5%,국산), 계피농축액, 혼합제제(프로필렌글리콜,정제수,주정,글리세린,천연향료,합성향료), 구연산, 효소처리스테비아",
    product_image_1:
      "https://products.naganorewards.com/KR/CHUNHONCARE/GinsengWild.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2010",
    brand: "CJ",
    sku: "CJPROCJKR0045",
    product_eng: "CJ Spam #34",
    product_jpn: "[CJ] 스팸 34호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "75,000",
    description_eng:
      "[Product composition] Spam classic 120g 8 pieces\n[Regular] 346×229×40 mm\n\n■ Spam classic\n1st place pride spam made with carefully selected pork, loved for its best taste and unwavering quality",
    description_jpn:
      "[제품구성] 스팸클래식 120g 8개\n[ 규   격 ] 346*229*40mm\n\n■ 스팸클래식\n엄선된 돈육으로 만든, 최상의 맛과 변함없는 품질로 사랑받는 1등 자부심 스팸",
    product_image_1: "https://products.naganorewards.com/KR/CJ/Spam34.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2011",
    brand: "CUCKOO",
    sku: "CUKITCUKR0046",
    product_eng:
      "Cuckoo Blackstone Electric Pressure Rice Cooker for 6 people CRP-BR065FB",
    product_jpn: "[쿠쿠] 블랙스톤 6인용 전기압력밥솥 CRP-BR065FB",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "308,000",
    description_eng:
      "* Size and weight: 356×266×257 mm / Weight 5.5 kg\n* Rated voltage: 220 V/60 Hz\n* Power consumption: 890W\n* Composition: Main product, measuring cup, spatula, cleaning pin, instruction manual\n* Full-Stainless Detachable Cover\n* Double motion packing\n* automatic sterilization cleaning\n* a high-power function\n* Voice guidance\n* Soft Team Cap\n* 14 Heavy Safety Application",
    description_jpn:
      "* 사이즈 및 중량 : 356*266*257 mm / 중량 5.5kg\n* 정격전압 : 220V/60Hz\n* 소비전력 : 890W\n* 구성 : 본품, 계량컵, 주걱, 청소용 핀, 사용설명서\n* 풀스테인리스 분리형 커버\n* 이중모션패킹\n* 자동살균세척\n* 고화력기능\n* 음성안내\n* 소프트스팀캡\n* 14중 안전장치 적용",
    product_image_1:
      "https://products.naganorewards.com/KR/CUCKOO/RiceCooker6P.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2012",
    brand: "CUCKOO",
    sku: "CUKITCUKR0047",
    product_eng: "Cuckoo Twin Presser Rice Cooker CRP-RT069FG for 6 people",
    product_jpn: "[쿠쿠] 트윈프레셔 밥솥 6인용 CRP-RT069FG",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "348,000",
    description_eng:
      "* Capacity: For 6 people\n* Weight: 5.7 kg\n* Size: 356×266×264 (mm)\n* Composition: Main product, measuring cup, spatula, instruction manual\n* Energy efficiency rating: Grade 1\n■ Ultra-high pressure and no-scratch twin presser\n■ Easy-to-remove stainless steel removable cover\n■ X-WELL BLACK COATED INNER Cauldron",
    description_jpn:
      "* 용량 : 6인용\n * 중량 : 5.7kg\n * 크기 : 356×266×264(mm)\n * 구성 : 본품, 계량컵, 주걱, 사용설명서\n * 에너지 효율등급 : 1등급\n ■ 초고압과 무사취사 가능한 트윈프레셔\n ■ 간편하게 분리 세척 가능한 스테인리스 분리형 커버\n ■ 엑스웰 블랙 코팅 내솥",
    product_image_1:
      "https://products.naganorewards.com/KR/CUCKOO/TwinPresser6P.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2013",
    brand: "CUCKOO",
    sku: "CUKITCUKR0048",
    product_eng: "Cuckoo Twin Presser Rice Cooker for 6 people CRP-RT069FW",
    product_jpn: "[쿠쿠] 트윈프레셔 밥솥 6인용 CRP-RT069FW",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "348,000",
    description_eng:
      "* Capacity: For 6 people\n* Weight: 5.7 kg\n* Size: 356×266×264 (mm)\n* Composition: Main product, measuring cup, spatula, instruction manual\n* Energy efficiency rating: Grade 1\n■ Ultra-high pressure and no-scratch twin presser\n■ Easy-to-remove stainless steel removable cover\n■ X-WELL BLACK COATED INNER Cauldron",
    description_jpn:
      "* 용량 : 6인용\n * 중량 : 5.7kg\n * 크기 : 356×266×264(mm)\n * 구성 : 본품, 계량컵, 주걱, 사용설명서\n * 에너지 효율등급 : 1등급\n ■ 초고압과 무사취사 가능한 트윈프레셔\n ■ 간편하게 분리 세척 가능한 스테인리스 분리형 커버\n ■ 엑스웰 블랙 코팅 내솥",
    product_image_1:
      "https://products.naganorewards.com/KR/CUCKOO/TwinPresser6PWhite.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2014",
    brand: "CUCKOO",
    sku: "CUKITCUKR0049",
    product_eng:
      "Cuckoo Blackstone Electric Pressure Rice Pot for 10 People CRP-BR105FB",
    product_jpn: "[쿠쿠] 블랙스톤 10인용 전기압력밥솥 CRP-BR105FB",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "338,000",
    description_eng:
      "* Size and weight: 391×298×228 mm / Weight 6.9 kg\n* Rated voltage: 220 V/60 Hz\n* Power consumption: 1150W\n* Composition: Main product, measuring cup, spatula, cleaning pin, instruction manual\n* Full-Stainless Detachable Cover\n* Double motion packing\n* automatic sterilization cleaning\n* a high-power function\n* Voice guidance\n* Soft Team Cap\n* 14 Heavy Safety Application",
    description_jpn:
      "* 사이즈 및 중량 : 391*298*228 mm / 중량 6.9kg\n* 정격전압 : 220V/60Hz\n* 소비전력 : 1,150W\n* 구성 : 본품, 계량컵, 주걱, 청소용 핀, 사용설명서\n* 풀스테인리스 분리형 커버\n* 이중모션패킹\n* 자동살균세척\n* 고화력기능\n* 음성안내\n* 소프트스팀캡\n* 14중 안전장치 적용",
    product_image_1:
      "https://products.naganorewards.com/KR/CUCKOO/RiceCooker10P.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2015",
    brand: "CUCKOO",
    sku: "CUKITCUKR0050",
    product_eng: "Cuckoo Twin Presser Rice Cooker for 10 people CRP-RT109FG",
    product_jpn: "[쿠쿠] 트윈프레셔 밥솥 10인용 CRP-RT109FG",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "368,000",
    description_eng:
      "* Capacity: For 10 people\n* Weight: 7.0 kg\n* Size: 391×298×284 (mm)\n* Composition: Main product, measuring cup, spatula, instruction manual\n* Energy efficiency rating: Grade 1\n■ Ultra-high pressure and no-scratch twin presser\n■ Easy-to-remove stainless steel removable cover\n■ X-WELL BLACK COATED INNER Cauldron",
    description_jpn:
      "* 용량 : 10인용\n * 중량 : 7.0kg\n * 크기 : 391×298×284(mm)\n * 구성 : 본품, 계량컵, 주걱, 사용설명서\n * 에너지 효율등급 : 1등급\n ■ 초고압과 무사취사 가능한 트윈프레셔\n ■ 간편하게 분리 세척 가능한 스테인리스 분리형 커버\n ■ 엑스웰 블랙 코팅 내솥",
    product_image_1:
      "https://products.naganorewards.com/KR/CUCKOO/TwinPresser10P.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2016",
    brand: "CUCKOO",
    sku: "CUKITCUKR0051",
    product_eng: "Cuckoo Twin Presser Rice Cooker for 10 people CRP-RT109FW",
    product_jpn: "[쿠쿠] 트윈프레셔 밥솥 10인용 CRP-RT109FW",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "368,000",
    description_eng:
      "* Capacity: For 10 people\n* Weight: 7.0 kg\n* Size: 391×298×284 (mm)\n* Composition: Main product, measuring cup, spatula, instruction manual\n* Energy efficiency rating: Grade 1\n■ Ultra-high pressure and no-scratch twin presser\n■ Easy-to-remove stainless steel removable cover\n■ X-WELL BLACK COATED INNER Cauldron",
    description_jpn:
      "* 용량 : 10인용\n * 중량 : 7.0kg\n * 크기 : 391×298×284(mm)\n * 구성 : 본품, 계량컵, 주걱, 사용설명서\n * 에너지 효율등급 : 1등급\n ■ 초고압과 무사취사 가능한 트윈프레셔\n ■ 간편하게 분리 세척 가능한 스테인리스 분리형 커버\n ■ 엑스웰 블랙 코팅 내솥",
    product_image_1:
      "https://products.naganorewards.com/KR/CUCKOO/TwinPresser10PWhite.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2017",
    brand: "CUCKOO",
    sku: "CUKITCUKR0052",
    product_eng:
      "Cuckoo Tupper Steel Master IH Electric Pressure Rice Pot for 6 people CRP-BDHF065BD",
    product_jpn: "[쿠쿠] 타철명장 6인용 IH 전기압력밥솥 CRP-BDHF065BD",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "438,000",
    description_eng:
      "* Size and weight: 378×266×256 mm / weight 6.2 kg\n* Rated voltage: 220 V/60 Hz\n* Power consumption: 1,090W\n* Composition: Main product, measuring cup, spatula, cleaning pin, instruction manual\n* Premium Metallic Design\n* The iron master's pot\n* X-WELL BLACK COATING\n* Double motion packing\n* a smart algorithm\n* LED Display\n* Automatic Shal bacteria (steam) cleaning\n* an anti-sucking drainage channel\n* Double Soft Steam Cap",
    description_jpn:
      "* 사이즈 및 중량 : 378*266*256 mm / 중량 6.2kg\n* 정격전압 : 220V/60Hz\n* 소비전력 : 1,090W\n* 구성 : 본품, 계량컵, 주걱, 청소용 핀, 사용설명서\n* 프리미엄 메탈릭 디자인\n* 타철명장 내솥\n* 엑스웰 블랙 코팅\n* 2중 모션 패킹\n* 스마트 알고리즘\n* LED 디스플레이\n* 자동샬균(스팀)세척\n* 밥물고임 방지 배수로\n* 2중 소프트 스팀캡",
    product_image_1:
      "https://products.naganorewards.com/KR/CUCKOO/TupperCooker6P.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2018",
    brand: "CUCKOO",
    sku: "CUKITCUKR0053",
    product_eng:
      "Cuckoo Premium 10-person twin presser mortgage rice cooker CRP-KHLR1010FG",
    product_jpn: "[쿠쿠] 프리미엄 10인용 트윈프레셔 저당 밥솥 CRP-KHLR1010FG",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "698,000",
    description_eng:
      "* Size and weight: 419×303×290 mm / Weight 9 kg\n* Rated voltage: 220 V/60 Hz\n* Power consumption: 1,455W\n* Composition: Main product, measuring cup, spatula, cleaning pin, instruction manual\n* Strong ultra-high pressure to soft no-pressure twin presser low-sugar rice cooker\n* Twin pressers (ultra-high pressure / no pressure cooking)\n* Low-sugar low-sugar rice cooker\n* Full Stainless Detachable Cover\n* Eco stainless steel curved inner pot\n* X-WELL BLACK SHINE COATING\n* One-touch detachable cover\n* Stainless steel inner pot case\n* Double motion packing\n* Standby power cutoff switch\n* Direct Touch Features\n* Energy Eye Function\n* Automatic Shal bacteria (steam) cleaning\n* an antifouling drainage channel\n* Double Soft Steam Cap",
    description_jpn:
      "* 사이즈 및 중량 : 419*303*290 mm / 중량 9kg\n* 정격전압 : 220V/60Hz\n* 소비전력 : 1,455W\n* 구성 : 본품, 계량컵, 주걱, 청소용 핀, 사용설명서\n* 강력한 초고압에서 부드러운 무압까지 트윈 프레셔 저당밥솥\n* 트윈프레셔(초고압 / 무압 취사)\n* 당질 저감 저당밥솥\n* Full 스테인리스 분리형 커버\n* 에코 스테인리스 커브드 내솥\n* 엑스웰 블랙샤인 코팅\n* 원터치 분리형 커버\n* 스테인리스 내솥 케이스\n* 2중모션패킹\n* 대기전력 차단스위치\n* 다이렉트 터치 기능\n* 에너지아이 기능\n* 자동샬균(스팀) 세척\n* 밥물고임방지배수로\n* 2중 소프트 스팀캡",
    product_image_1:
      "https://products.naganorewards.com/KR/CUCKOO/TwinPresserPremium10P.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2019",
    brand: "Daeng Gi Meo Ri",
    sku: "DACOSPUKR0054",
    product_eng: "Puppy hair Coloring Black Speed Dye Shampoo 200 ml 2 bottles",
    product_jpn: "[댕기머리] 컬러링 블랙 스피드 염색샴푸 200ml 2병",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "49,800",
    description_eng: "2 bottles of 200ml shampoo",
    description_jpn: "샴푸 200ml 2병",
    product_image_1:
      "https://products.naganorewards.com/KR/Daen_Gi_Meo_Ri/DyeShampoo.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2020",
    brand: "Dermagen",
    sku: "DECOSDEKR0055",
    product_eng:
      "Dermagen Hypoallergenic multifunctional soothing white sunscreen 50g",
    product_jpn: "[더마겐] 저자극 다기능성 진정 화이트 선크림 50g",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "38,000",
    description_eng:
      "Dermagen recommended and sold by hospitals, such as dermatological plastic surgery\n\na sunscreen with one's own car\na mildly acidic sunscreen\nTriple functional sunscreen (whitening, wrinkle improvement, UV protection)\na smooth, non-gloss sunscreen\nContains Cica Ingredients\nContains glutathione ingredients\nIt's a texture that doesn't smudge on the mask",
    description_jpn:
      "피부과 성형와과 등 병의원에서 추천하고 판매되는 더마겐\n\n무기자차 선크림\n약산성 선크림\n3중기능성 선크림 (미백,주름개선,자외선차단)\n부드러운 사용감의 번들거림 없는 선크림\n시카 성분 함유 \n글루타티온 성분 함유\n마스크에 묻어나지 않는 제형",
    product_image_1:
      "https://products.naganorewards.com/KR/dermagen/Sunscreen.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2021",
    brand: "Dermagen",
    sku: "DECOSDEKR0056",
    product_eng: "Dermagen Urea Cream 180g Hospital Exfoliating Calluses",
    product_jpn: "[더마겐] 우레아 크림 180g 병원전용 각질 굳은살 제거",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "26,000",
    description_eng:
      "Product description\n180g capacity\nHighly concentrated urea cream with 100,000 ppm of urea with excellent moisturizing and skin softening properties\nBody cream that can work on a variety of gomin vu, including heels, elbows, knees, and peach bones\nContains four moisturizing ingredients such as panthenol",
    description_jpn:
      "상품설명\n180g 대용량\n뛰어난 보습 능력과 각질연화작용을 가진 우레아 100,000ppm 함유 고농축 우레아 크림\n발뒷꿈치,팔꿈치,무릎,복숭아뼈등 다양한 고민뷔에 작용 가능한 바디크림\n판테놀등 4중 보습 성분 함유",
    product_image_1:
      "https://products.naganorewards.com/KR/dermagen/UreaCream.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2022",
    brand: "DOBIDOS",
    sku: "DOHOUDOKR0057",
    product_eng:
      "Dobidos Darim Dobidos Body Dryer UV Lamp Sterilization Body Dryer (Foot Mat Presented)",
    product_jpn:
      "[도비도스]대림 도비도스 바디건조기 UV램프살균 바디드라이어 (발매트증정)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "399,000",
    description_eng:
      "- Based on the Dyson method, the introduced air is quickly circulated and amplified to form a high-pressure airflow\n- Designed with vent holes and discharge method for the most stable and comfortable users\n- The atmosphere of the house is modern and clean with a monotone-centered color that goes well with the interior\n1. Stage 3 Wind speed (strong, medium, weak) / Natural wind and warm air functions, depending on the situation\n2. Fourteen air holes create a rich air volume and dry 360 degrees\n3. There is a motion sensor, so the user has to enter the product to operate (automatically stop when not in use)\n4. A pleasant and clear wind with UVC-LED\n5. Built to minimize ambient damage with minimum noise of 60db\n6. Easy to use with a touch button that responds just by touching the tip of the toe\n7. Can be set up and stored so that unnecessary space is not used when not in use\n8. It has an overheat prevention sensor, so it's safe to use\n- Size: 580×580×160 mm Code length 2 m\n- Composition: Dobidos body dryer body + instruction manual + foot mat (free gift)",
    description_jpn:
      "- 다이슨 방식을 착안하여 유입된 공기를 빠르게 순환, 증폭시켜 고압의 기류를 형성\n - 사용자가 가장 안정적이고 편안함을 느낄 수 있는 벤트홀과 토출 방식으로 설계 \n - 실내 인테리어와 어울리는 모노톤 중심의 컬러로 집안의 분위기가 모던하고 깨끗\n 1. 3단계 풍속(강,중,약) / 자연풍,온풍 기능으로 상황에 따라 맞춰서 사용\n 2. 14개의 에어홀이 풍성한 풍량을 이루고 360도로 건조\n 3. 동작센서가 있어 사용자가 제품안에 들어가야 작동 (미사용시 자동으로 중지)\n 4. UVC-LED를 장착하여 쾌적하고 맑은 바람\n 5. 최저소음이 60db로 주변 피해를 최대한 줄이도록 제작\n 6. 발끝만 닿아도 반응하는 터치식 버튼으로 사용이 편리\n 7. 사용하지 않을 경우 불필요한 공간을 사용하지 않도록 세워서 보관이 가능\n 8.과열방지 센서가 있어 안전하게 사용\n - 크기 : 580×580×160 mm 코드길이2m\n - 구성 : 도비도스 바디드라이어 본체+사용설명서+발매트(사은품)",
    product_image_1:
      "https://products.naganorewards.com/KR/DOBIDOS/BodyDryer.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2023",
    brand: "Dongjin Pharmaceutical",
    sku: "DOHEADOKR0058",
    product_eng:
      "Dongjin Pharmaceutical Ho Kwan Won Arthton Gold (refined) 1000mg*120 tablets",
    product_jpn: "[동진제약] 호관원 관절튼튼 골드 (정제) 1000mg*120정",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "298,000",
    description_eng: "1000mg * 120 tablets",
    description_jpn: "1000mg * 120정",
    product_image_1:
      "https://products.naganorewards.com/KR/Dongjin_Pharmaceutical/ArthtonGold.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2024",
    brand: "Dongjin Pharmaceutical",
    sku: "DOHEADOKR0059",
    product_eng:
      "Dongjin Pharmaceutical Ho Kwan Won Arthletton Premium (stick) 15ml*30 bags",
    product_jpn: "[동진제약] 호관원 관절튼튼 프리미엄(스틱) 15ml*30포",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "300,000",
    description_eng: "15ml × 30 bags",
    description_jpn: "15ml * 30포",
    product_image_1:
      "https://products.naganorewards.com/KR/Dongjin_Pharmaceutical/ArthletonPremium.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2025",
    brand: "DongWon",
    sku: "DOPRODOKR0060",
    product_eng: "Dongwon Healthy tuna set No. 9",
    product_jpn: "[동원] 건강한참치세트9호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "40,000",
    description_eng:
      "■ Product composition\n* Dongwon tuna 100g (Omega 369) × 9 cans\n\n* Handle Paper Case",
    description_jpn:
      "■ 상품구성 \n* 동원참치100g(오메가369)×9캔\n\n* 손잡이 종이케이스",
    product_image_1:
      "https://products.naganorewards.com/KR/DongWon/TunaSet9.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2026",
    brand: "DongWon",
    sku: "DOPRODOKR0061",
    product_eng: "Dongwon Mix Set No. 8-4",
    product_jpn: "[동원] 혼합세트8-4호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "55,000",
    description_eng:
      "■ Product composition\n* Dongwon tuna 100g (Omega 369) × 8 cans\n* 120 g × 4 cans of LiCham\n\n* Handle Paper Case",
    description_jpn:
      "■ 상품구성 \n* 동원참치100g(오메가369)×8캔\n* 리챔120g×4캔\n\n* 손잡이 종이케이스",
    product_image_1:
      "https://products.naganorewards.com/KR/DongWon/MixSet8.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2027",
    brand: "DongWon",
    sku: "DOPROMOKR0062",
    product_eng: "Mobilized Tuna S12",
    product_jpn: "[동원] 참치 S12호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "48,000",
    description_eng:
      "■ Product composition\n* Light Standard Tuna 90 g x 12 cans",
    description_jpn: "■ 상품구성 \n * 라이트스탠다드참치 90g x 12캔",
    product_image_1:
      "https://products.naganorewards.com/KR/DongWon/TunaS12.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2028",
    brand: "DongWon",
    sku: "DOPROMOKR0063",
    product_eng: "Mobilized Tuna S14",
    product_jpn: "[동원] 참치 S14호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "64,000",
    description_eng:
      "■ Product composition\n* Light Standard Tuna 90 g x 10 cans\n* Dongwon red pepper tuna 90g x 4 cans",
    description_jpn:
      "■ 상품구성 \n * 라이트스탠다드참치 90g x 10캔\n * 동원 고추참치 90g x 4캔",
    product_image_1:
      "https://products.naganorewards.com/KR/DongWon/TunaS14.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2029",
    brand: "DongWon",
    sku: "DOPRODOKR0064",
    product_eng: "Dongwon Healthy tuna set No. 15",
    product_jpn: "[동원] 건강한참치세트15호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "67,000",
    description_eng:
      "■ Product composition\n* Dongwon tuna 100g (Omega 369) × 15 cans\n\n* Handle Paper Case",
    description_jpn:
      "■ 상품구성 \n* 동원참치100g(오메가369)×15캔\n\n* 손잡이 종이케이스",
    product_image_1:
      "https://products.naganorewards.com/KR/DongWon/TunaSet15.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2030",
    brand: "DongWon",
    sku: "DOPROMOKR0065",
    product_eng: "Mobilized Tuna S22",
    product_jpn: "[동원] 참치 S22호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "103,000",
    description_eng:
      "■ Product composition\n*Light Standard Tuna 90 g x 14 cans\n*Red pepper tuna 90g x 8 cans",
    description_jpn:
      "■ 상품구성\n*라이트 스탠다드참치 90g x 14캔\n*고추참치 90g x 8캔",
    product_image_1:
      "https://products.naganorewards.com/KR/DongWon/TunaS22.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2031",
    brand: "DongWon",
    sku: "DOPROMOKR0066",
    product_eng: "Mobilized Tuna S26",
    product_jpn: "[동원] 참치 S26호",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "122,000",
    description_eng:
      "■ Product composition\n*Light Standard Tuna 90 g x 12 cans\n*Red pepper tuna 90g x 6 cans\n*90 g x 4 cans of vegetable tuna\n*90g of tuna for kimchi stew x 4 cans",
    description_jpn:
      "■ 상품구성\n*라이트 스탠다드참치 90g x 12캔\n*고추참치 90g x 6캔\n*야채참치 90g x 4캔\n*김치찌개용 참치 90g x 4캔",
    product_image_1:
      "https://products.naganorewards.com/KR/DongWon/TunaS26.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2032",
    brand: "Dr.G",
    sku: "DRCOSDOKR0067",
    product_eng: "Doctor G MediUV Ultra Up Sunstick 25g SPF50+/PA++++",
    product_jpn: "[닥터지] 메디유브이 울트라업 선스틱 25g SPF50+/PA++++",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "38,000",
    description_eng:
      "▷ Expiration Date: 2027-03-03\n▷ 25g High Capacity! Popular Sunscreen is a new Sunstick!\nMedi UV Ultra-Up Sunstick to Strongly Protect Your Skin\nIt can be used without touching the hand, so it is essential for outdoor activities\n\nBarrier protection sunstick that keeps skin healthy from UV rays and external environment\nInorganic sunscreen containing provitamin D and panthenol\nA barrier-protecting sunstick that protects the skin from UV rays and applies smoothly without being excited\nFunctional products for whitening and wrinkle improvement of skin\nIt protects your skin from UV rays",
    description_jpn:
      "▷ 유통기한 : 2027-03-03\n▷ 25g 대용량! 인기 선크림이 선스틱으로 새롭게 출시!\n피부를 강력하게 보호하는 메디 UV 울트라 업 선스틱\n손에 뭍지 않고 사용할수 있어서 야외에서 외부활동시 필수품\n\n자외선과 외부환경으로부터 피부를 건강하게 지켜주는 장벽보호 선스틱\n프로비타민 D와 판테놀을 함유한 무기 자외선 차단제\n자외선으로부터 피부를 보호해주고 들뜸없이 부드럽게 발라지는 장벽 보호 선스틱\n피부의 미백과 주름개선 기능성 제품\n자외선으로부터 피부를 보호해줍니다",
    product_image_1: "https://products.naganorewards.com/KR/Dr.G/Sunstick.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2033",
    brand: "Dr.G",
    sku: "DRCOSDOKR0068",
    product_eng: "Doctor G Medi UV Ultra Up Sun Cushion SPF50+/PA++++",
    product_jpn: "[닥터지] 메디유브이 울트라업 선쿠션 SPF50+/PA++++",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "32,000",
    description_eng:
      "▷ Expiration date: 2027-03-06\n▷ Medi UV Ultra Up Sun Cushion Strongly Protects Skin\nIt can be used without touching the hand, so it is essential for outdoor activities\n\nBarrier protection sun cushion that keeps skin healthy from UV rays and external environment\nInorganic sunscreen containing provitamin D and panthenol\nA barrier-protecting sun cushion that protects the skin from UV rays and applies smoothly without being excited\n\nFunctional products for whitening and wrinkle improvement of skin\nIt protects your skin from UV rays",
    description_jpn:
      "▷ 유통기한 : 2027-03-06\n▷ 피부를 강력하게 보호하는 메디 UV 울트라 업 선쿠션\n손에 뭍지 않고 사용할수 있어서 야외에서 외부활동시 필수품\n\n자외선과 외부환경으로부터 피부를 건강하게 지켜주는 장벽보호 선쿠션\n프로비타민 D와 판테놀을 함유한 무기 자외선 차단제\n자외선으로부터 피부를 보호해주고 들뜸없이 부드럽게 발라지는 장벽 보호 선쿠션\n\n피부의 미백과 주름개선 기능성 제품\n자외선으로부터 피부를 보호해줍니다",
    product_image_1:
      "https://products.naganorewards.com/KR/Dr.G/SunCushion.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2034",
    brand: "ELBA",
    sku: "ELKITELKR0069",
    product_eng: "Elba Black mini wine cellar (8 bottles / 22 liters)",
    product_jpn: "[엘바] 블랙 미니와인셀러 (8병 / 22리터)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "259,000",
    description_eng:
      "*Capacity: 8 bottles (22 liters)\n*Temperature control range: 9-18℃\n*Power consumption: 50W\n*Size: 267×450×530 / mm\n*Weight: 10.1 kg",
    description_jpn:
      "*용량: 8병(22리터)\n*온도조절범위: 9~18℃\n*소비전력 : 50W\n*사이즈: 267×450×530/mm\n*무게: 10.1kg",
    product_image_1:
      "https://products.naganorewards.com/KR/ELBA/WineCellarMini.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2035",
    brand: "ELBA",
    sku: "ELKITELKR0070",
    product_eng: "Elba Pure White Mini Wine Cellar (8 bottles / 22 liters)",
    product_jpn: "[엘바] 퓨어화이트 미니 와인셀러 (8병 / 22리터)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "279,000",
    description_eng:
      "*Capacity: 8 bottles (22 liters)\n*Temperature control range: 9-18℃\n*Power consumption: 50W\n*Size: 267×450×530 / mm\n*Weight: 10.1 kg",
    description_jpn:
      "*용량: 8병(22리터)\n*온도조절범위: 9~18℃\n*소비전력 : 50W\n*사이즈: 267×450×530/mm\n*무게: 10.1kg",
    product_image_1:
      "https://products.naganorewards.com/KR/ELBA/WineCellarWhiteMini.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2036",
    brand: "ELBA",
    sku: "ELKITELKR0071",
    product_eng: "Elba Black wine cellar (12 bottles / 40 liters)",
    product_jpn: "[엘바] 블랙 와인셀러 (12병 / 40리터)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "279,000",
    description_eng:
      "*Capacity: 12 bottles (40 liters)\n*Temperature control range: 9-18℃\n*Power consumption: 70W\n*Size: 280×543×660 / mm\nWeight: 13.8 kg",
    description_jpn:
      "*용량: 12병(40리터)\n*온도조절범위: 9~18℃\n*소비전력 : 70W\n*사이즈: 280×543×660/mm\n무게: 13.8kg",
    product_image_1:
      "https://products.naganorewards.com/KR/ELBA/WineCellar12.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2037",
    brand: "ELBA",
    sku: "ELKITELKR0072",
    product_eng: "Elba Black slim wine cellar (18 bottles / 60 liters)",
    product_jpn: "[엘바] 블랙 슬림 와인셀러 (18병 / 60리터)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "469,000",
    description_eng:
      "*Capacity: 18 bottles (60 liters)\n*Temperature control range: 9-18℃\n*Power consumption: 140W\n*Size: 280×1030×530 / mm\nWeight: 21.2 kg",
    description_jpn:
      "*용량: 18병(60리터)\n*온도조절범위: 9~18℃\n*소비전력 : 140W\n*사이즈: 280×1030×530/mm\n무게: 21.2kg",
    product_image_1:
      "https://products.naganorewards.com/KR/ELBA/WineCellar18.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2038",
    brand: "ELBA",
    sku: "ELKITELKR0073",
    product_eng: "Elba Pure White Slim Wine Cellar (18 bottles/ 60 liters)",
    product_jpn: "[엘바] 퓨어화이트 슬림 와인셀러 (18병 / 60리터)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "549,000",
    description_eng:
      "*Capacity: 18 bottles (60 liters)\n*Temperature control range: 9-18℃\n*Power consumption: 140W\n*Size: 280×1030×530 / mm\nWeight: 21.2 kg",
    description_jpn:
      "*용량: 18병(60리터)\n*온도조절범위: 9~18℃\n*소비전력 : 140W\n*사이즈: 280×1030×530/mm\n무게: 21.2kg",
    product_image_1:
      "https://products.naganorewards.com/KR/ELBA/WineCellarWhite18.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2039",
    brand: "ELBA",
    sku: "ELKITELKR0074",
    product_eng: "Elba Pure white wide wine cellar (24 bottles / 65 liters)",
    product_jpn: "[엘바] 퓨어화이트 와이드 와인셀러 (24병 / 65리터)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "599,000",
    description_eng:
      "*Capacity: 24 bottles (65 liters)\n*Temperature control range: 9-18℃\n*Power consumption: 140W\n*Size: 410×725×525 / mm\n*Weight: 20.5 kg",
    description_jpn:
      "*용량: 24병(65리터)\n*온도조절범위: 9~18℃\n*소비전력 : 140W\n*사이즈: 410×725×525/mm \n*무게: 20.5kg",
    product_image_1:
      "https://products.naganorewards.com/KR/ELBA/WineCellarWhite24.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2040",
    brand: "ELCANTO",
    sku: "ELFASELKR0075",
    product_eng: "El Canto Modern Saffiano Cowhide Men's Automatic Belt",
    product_jpn: "[엘칸토] 모던 사피아노 소가죽 남성 자동벨트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "58,000",
    description_eng:
      "Elcanto Co., Ltd. has more than 200 branch networks nationwide and is agile in segmenting the market, including the launch of various new brands, technology alliances with famous foreign brands, and direct imports of globally loved luxury brands\nMen's and women's suits, hiking boots, casual shoes, golf shoes, handbags, miscellaneous goods, and more\n\n[Product composition]\n> Saffiano Cowhide Men's Automatic Belt 1 Type\n[Product specifications]\n> Size: Buckle (length 3.3 cm × 5.3 cm / belt length 110 cm)\n> Box Size: 180×135×40 mm\n> Material: Belt: Outer Fabric (Cowhide) / Inner Skin (Artificial Leather)\n[Product Features]\n> Wrapping paper wrapping\n>Men's belt of a style that exudes modernity and chicness\n> With a belt made of cowhide material, the brand logo is inserted into the buckle to reinforce a young and sophisticated image\n> It's a men's belt, easy to wear with a suit and suit\n> A/S: El Canto stores nationwide (department stores)",
    description_jpn:
      '"㈜엘칸토는 전국에 200여개의 지점망을 갖추고 있으며, 다양한 신규 브랜드 출시, 외국의 유명 브랜드와의 기술 제휴, 전 세계적으로 사랑받는 명품 브랜드의 직수입 등 시장 세분화에 민첩히 대응 \n남, 여 정장, 등산화, 캐쥬얼화, 골프화, 핸드백, 잡화까지 패션의 모든 것을 대표하는 회사로 성장\n\n[제품구성]\n > 사피아노 소가죽 남성 자동벨트 1종\n[제품사양]\n > 사이즈 : 버클(세로3.3cm * 5.3cm/벨트길이 110cm)\n > 박스사이즈 : 180*135*40mm\n > 소재 : 벨트 : 외피(소가죽) / 내피(인조가죽)\n[제품특징]\n > 포장지 포장\n > 모던함과 쉬크함이 묻어나는 스타일의 남성 벨트 \n > 소가죽 소재로 제작된 벨트로 버클에 브랜드 로고를 삽입하여 젊고 세련된 이미지 강저\n > 남성 스타일의 벨트로 정장수트 스타일에 착용 용이\n > A/S : 전국 엘칸토 매장(백화점)\n"',
    product_image_1:
      "https://products.naganorewards.com/KR/ELCANTO/BeltAutomatic.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2041",
    brand: "GIPFEL",
    sku: "GIKITGIKR0076",
    product_eng: "Gipfel Klein Automatic Wireless Chopping SN001",
    product_jpn: "[기펠]클라인 자동 무선 다지기 SN001",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "60,000",
    description_eng: "Body + 3-layered blade + manual",
    description_jpn: "본체+3중 칼날+설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/WirelessChopper.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2042",
    brand: "GIPFEL",
    sku: "GIKITGIKR0077",
    product_eng: "Gipfel Airlock 4-in-1 Wireless Vacuum Wrapper QW-21031",
    product_jpn: "[기펠]에어락 4in1 무선 진공포장기 QW-21031",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "90,000",
    description_eng:
      "body + charging cable + vacuum pack 5 sheets (22 cm 2 sheets + 28 cm 3 sheets) + sealing clip + air pump kit 2 types",
    description_jpn:
      "본체+충전케이블+진공팩 5매(22cm 2장+28cm 3장)+밀봉클립+에어 펌프 키트2종",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/VacuumWrapper.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2043",
    brand: "GIPFEL",
    sku: "GIKITGIKR0078",
    product_eng: "Gipfel Stein Induction Pot 6PC Stein",
    product_jpn: "[기펠]슈타인 인덕션 냄비 6PC Stein",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "120,000",
    description_eng:
      "16 cm single handle pot + 18 cm double handle pot + 24 cm hot pot + reinforced glass cover 3p",
    description_jpn: "16cm편수+18cm양수+24cm 전골냄비+강화유리 커버3p",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/InductionPot.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2044",
    brand: "GIPFEL",
    sku: "GIKITGIKR0079",
    product_eng: "Gipfel TASTEA 2-in-1 Insulation Teapot WK-5020",
    product_jpn: "[기펠]TASTEA 2in1 보온 티포트 WK-5020",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "180,000",
    description_eng: "Glass kettle body + stainless steel net + power base",
    description_jpn: "유리주전자 본체+스테인리스 티망+전원베이스\n",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/InsulationTeapot.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2045",
    brand: "GIPFEL",
    sku: "GIDAIGIKR0080",
    product_eng: "Gipfel Automatic vinyl adsorption trash can JCT002-A",
    product_jpn: "[기펠]자동 비닐 흡착 휴지통 JCT002-A",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "120,000",
    description_eng:
      "Body + plastic bag 30 sheets + instruction manual + 4 batteries",
    description_jpn: "본체+비닐백30매+사용설명서+건전지4개",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/TrashCan.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2046",
    brand: "GIPFEL",
    sku: "GIKITGIKR0081",
    product_eng: "Gipfel Pierre Casting Thermal Sensor Pan",
    product_jpn: "[기펠] 피에르 통주물 열센서팬",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "190,000",
    description_eng: "2 holes egg pan + 20 gambas pan + 28 cm frying pan",
    description_jpn: "2구 에그팬+20감바스팬+28cm후라이팬",
    product_image_1: "",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2047",
    brand: "GIPFEL",
    sku: "GIKITGIKR0082",
    product_eng:
      "Gipfel Plating Campo Tree Antibacterial Cutting Board 3p 4SEASON",
    product_jpn: "[기펠]플레이팅 캄포나무 항균도마 3p 4SEASON",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "200,000",
    description_eng:
      "camphor cutting board large + medium + exclusive stand + luxury shopping bag",
    description_jpn: "캄포도마 대+중+전용 거치대+고급 쇼핑백\n",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/CuttingBoard.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2048",
    brand: "GIPFEL",
    sku: "GIHOUGIKR0083",
    product_eng:
      "Gipfel UVC Wireless Toothbrush Sterilizer + Sterilization BCM-2020",
    product_jpn: "[기펠]UVC 무선 칫솔살균기+살균함 BCM-2020",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "200,000",
    description_eng:
      "Toothbrush sterilizer body, UV-C multi-sterilizer bar, holder, portable body, adhesive tape, manual",
    description_jpn:
      "칫솔 살균기 본체, UV-C멀티 살균바 ,거치대, 휴대용 본체, 접착 테이프, 설명서\n",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/ToothbrushSterilizer.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2049",
    brand: "GIPFEL",
    sku: "GIKITGIKR0084",
    product_eng: "Gipfel THE ONE electric griddle fan THE ONE",
    product_jpn: "[기펠] 더원 전기그리들 팬 THE ONE",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "250,000",
    description_eng:
      "This product + temperature controller + manual + glass lid + exclusive bag",
    description_jpn: "본체+온도조절기+설명서+유리뚜껑+전용 가방",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/ElectricGriddle.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2050",
    brand: "GIPFEL",
    sku: "GIKITGIKR0085",
    product_eng: "Gipfel Matrosica folding 3-layered pot 6 PCS EK2012SET6",
    product_jpn: "[기펠] 마트로시카  폴딩 3중냄비 6PCS EK2012SET6",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "270,000",
    description_eng:
      "16 cm double handle pot + 20 cm double handle pot + 24 cm double handle pot + folding handle reinforced glass cover 3p",
    description_jpn:
      "16cm 양수+20cm양수+24cm 양수냄비+폴딩 손잡이 강화유리 커버3p",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/FoldingPotSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2051",
    brand: "GIPFEL",
    sku: "GIHOUGIKR0086",
    product_eng: "Gipfel Anytime Wireless Thermal Massager EZ-01",
    product_jpn: "[기펠]애니타임 무선 온열 마사지기 EZ-01",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "290,000",
    description_eng: "Body + Charger + User's Manual",
    description_jpn: "본체+충전기+사용설명서\n",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/ThermalMassager.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2052",
    brand: "GIPFEL",
    sku: "GIKITGIKR0087",
    product_eng: "Gipfel Glass Air Fryer (4.5 L) GBA-045I",
    product_jpn: "[기펠] 글라스 에어프라이어(4.5L) GBA-045I",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "245,000",
    description_eng:
      "main product + reinforced glass basket + cooking tray + oven gloves + silicone pouch",
    description_jpn: "본체+강화 글라스 바스킷+조리 트레이+오븐장갑+실리콘 바침",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/AirFryer.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2053",
    brand: "GIPFEL",
    sku: "GIKITGIKR0088",
    product_eng: "Gipfel Air slim ultra-thin induction",
    product_jpn: "[기펠] 에어슬림 초박형 인덕션",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "350,000",
    description_eng:
      "21 mm Ultra-thin Induction Main Product + Charger + User's Manual",
    description_jpn: "21mm 초박형인덕션 본체+충전기+사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/SlimInduction.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2054",
    brand: "GIPFEL",
    sku: "GIHOUGIKR0089",
    product_eng: "Gipfel Built-in wireless BLDC 3D FANE-919",
    product_jpn: "[기펠]빌트인 무선 BLDC 3D FAN E-919",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "300,000",
    description_eng:
      "head + battery + medium rod + charging adapter + remote controller + storage pouch + user manual",
    description_jpn:
      "헤드+배터리+중간봉+충전 어댑터+리모컨+보관파우치+사용설명서\n",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/WirelessFan.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2055",
    brand: "GIPFEL",
    sku: "GIHOUGIKR0090",
    product_eng: "Gipfel Airbride Air Purifier BKJ-20G",
    product_jpn: "[기펠] 에어 브리드 공기청정기 BKJ-20G",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "400,000",
    description_eng: "This product + H13 triple filter + instruction manual",
    description_jpn: "본체+H13 3중 필터+사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/AirPurifier.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2056",
    brand: "GIPFEL",
    sku: "GIKITGIKR0091",
    product_eng: "Gipfel Plating IH frying pan 5 PCS(A) plating",
    product_jpn: "[기펠]바로 플레이팅 IH프라이팬 5PCS(A) Plating",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "400,000",
    description_eng:
      "27 cm Gambas Pan / 31 cm Pasta Pan / 31 cm Wok / 32 cm Square Grill Pan / Detachable Handle",
    description_jpn:
      "27cm감바스 팬/31cm파스타 팬/31cm궁중팬/32cm사각 그릴팬/탈착식 손잡이",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/FryingPanIH.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2057",
    brand: "GIPFEL",
    sku: "GIKITGIKR0092",
    product_eng: "Gipfel Belbetty Super High Speed Low Noise Blender PB8006",
    product_jpn: "[기펠]벨베티 초고속 저소음 블렌더 PB8006",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "400,000",
    description_eng:
      "Body + Tritan 1.3 L Mixer Cup + Noise Prevention Cover (attached to device) + User's Manual",
    description_jpn:
      "본체+트라이탄 1.3L 믹서컵+저소음 방지 커버(기기에 부착)+사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/SuperBlender.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2058",
    brand: "GIPFEL",
    sku: "GIKITGIKR0093",
    product_eng: "Gipfel Air curtain lead-free grill GFG-EL147",
    product_jpn: "[기펠]에어커튼 무연 그릴 GFG-EL147",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "470,000",
    description_eng:
      "Body + Grill Pan + Air Cotton + Storage Bag + User's Manual",
    description_jpn: "본체+그릴팬+에어커튼+보관가방+사용설명서\n",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/AirCurtainGrill.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2059",
    brand: "GIPFEL",
    sku: "GIKITGIKR0094",
    product_eng: "Gipfel Wide air curtain lead-free grill GFG-EL500",
    product_jpn: "[기펠] 와이드 에어커튼 무연 그릴 GFG-EL500",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "500,000",
    description_eng:
      "main product + grill pan + air curtain + storage bag + manual for use",
    description_jpn: "본체+그릴팬+에어커튼+보관가방+사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/WideAirCurtainGrill.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2060",
    brand: "GIPFEL",
    sku: "GIHOUGIKR0095",
    product_eng: "Gipfel ZET-10 Detect Complete SP003E",
    product_jpn: "[기펠] ZET-10  디텍트 컴플리트 SP003E",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "1,190,000",
    description_eng:
      "This product + aluminum tube + combination tool + gap nozzle + charging adapter + charging wall holder",
    description_jpn:
      "본체+알루미늄 튜브+콤비네이션툴+틈새노즐+충전어댑터+충전형 벽 거치대",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/ZET10Detect.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2061",
    brand: "GIPFEL",
    sku: "GIHOUGIKR0096",
    product_eng: "Gipfel Gyro Sensor Robot Vacuum Cleaner GFR-1121G",
    product_jpn: "[기펠]자이로센서 로봇청소기 GFR-1121G",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "350,000",
    description_eng:
      "Body + Automatic Charging Cradle + Remote Control + Brush 2P + Water Mop 1P + Adapter",
    description_jpn: "본체+자동 충전 거치대+리모컨+브러시2P+물걸레1P+어댑터",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/RobotVacuum.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2062",
    brand: "HAAN",
    sku: "HAHOUHAKR0097",
    product_eng: "HAN KYUNG HEE Mini dryer 5 kg (Ivory)",
    product_jpn: "[한경희] 미니건조기 5kg(아이보리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "499,000",
    description_eng:
      "Drying capacity: 5 kg\n. PTC heater\n. Triple dust filter (exhaust/inhaler filter)\n. Easy installation (power cord only)\n. sterilization/deodorization of UV lamps\n. KRW 313 for one-time electricity use\n. Energy Efficiency Grade 5\n. 1 year of free warranty",
    description_jpn:
      '". 건조용량 : 5KG\n. PTC 히터\n. 3중 먼지필터(배기/흡기 필터)\n. 간편설치(전원 코드만 연결)\n. UV램프 살균/탈취 \n. 1회 전기사용량 313원\n. 에너지 효율등급 5등급\n. 무상보증 1년"',
    product_image_1:
      "https://products.naganorewards.com/KR/HAAN/MiniDryer.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2063",
    brand: "HAAN",
    sku: "HAHOUHAKR0098",
    product_eng: "HAN KYUNG HEE Stand Steam Iron - White HESI-D1700WT",
    product_jpn: "[한경희] 스탠드 스팀다리미 - 화이트 HESI-D1700WT",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "149,000",
    description_eng:
      "*Steam master Han Kyung-hee's latest stand Steam Iron (released in November 2022)\n*35 second super fast preheating\n*40g/min of rich steam\n*The angle of the ironing board can be adjusted in three stages\n*Intuitive 3-speed steam control controlled by dial\n*Height-adjustable support in three stages\n*1.7L Detachable Large Water Bottle",
    description_jpn:
      "*스팀 명가 한경희의 최신 스탠드 스팀다리미 (2022년 11월 출시)\n*35초 초고속 예열\n*40g/min의 풍부한 스팀량\n*다리미판 각도를 3단으로 조절 가능\n*다이얼로 조절하는 직관적인 3단 스팀량 조절\n*3단으로 높이 조절이 가능한 지지대\n*1.7L의 분리형 대용량 물통",
    product_image_1:
      "https://products.naganorewards.com/KR/HAAN/SteamIron.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2064",
    brand: "HAAN",
    sku: "HAHOUHAKR0099",
    product_eng: "HAN KYUNG HEE Bedding cleaner HEBV-B100WT",
    product_jpn: "[한경희] 침구 청소기 HEBV-B100WT",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "149,000",
    description_eng:
      "*White & Gold Design for Bedroom, Living Room, Study, Anywhere in the House\n*To sterilize harmful bacteria and mites 99.9% with UV-C wavelength lamps\n*Ultra-lightweight 1.1kg based on body, wrist-free design\n*Washable triple filter for washing with water\n*UV sensors that work only when pressed on both sides make it safer\n*Power vibration pad with two-stage suction power adjustment\n*Intuitive UV-operated LED, dust bin, and battery notification LED\n*2-in-1 nozzle even cleans gaps\n*Easy charging with USB-C type terminals without requiring separate terminals or adapters\n*Product quality warranty period: 1 year",
    description_jpn:
      "*침실, 거실, 서재 등 집안 어디에서나 어울리는 화이트&골드 디자인\n*UV-C 파장 램프로 유해균, 진드기 99.9% 살균\n*본체 기준 1.1kg의 초경량으로 손목에 부담 없는 설계\n*물로 세척하여 사용하는 워셔블 3중 필터\n*양쪽이 눌려야 작동하는 UV 센서로 더 안전하게\n*흡입력 2단 조절이 가능한 파워 진동 패드\n*직관적인 UV 작동 LED와 먼지통, 배터리 알림 LED\n*2in1 노즐로 틈새 청소까지 가능\n*별도 단자, 어댑터 필요 없이 USB-C타입 단자로 간편 충전\n*제품 품질보증기간 : 1년",
    product_image_1:
      "https://products.naganorewards.com/KR/HAAN/BeddingCleaner.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2065",
    brand: "HAAN",
    sku: "HAHOUHAKR0100",
    product_eng: "HAN KYUNG HEE 2-in-1 steam cleaner EHSM-D2000WT",
    product_jpn: "[한경희] 2in1 스팀청소기 EHSM-D2000WT",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "149,000",
    description_eng:
      "*High temperature steam with super fast preheating for 20 seconds, 99% steam sterilization power\n*Step 3 steam injection and step-by-step LED display\n*1.96cm slim head allows you to clean under the bed and under the sofa freely\n*The swivel head is comfortable with the free-to-go swivel head\n*It is a detachable water bottle that is easy to attach and detach, and it is easy to remove remaining moisture after cleaning\n*Cleaning the floor with various brushes and nozzles, as well as kitchen hoods, induction, window cracks, and bathroom cleaning are okay\n*The cord length of 5M allows you to freely access every corner of the house\n*Eradicate thoroughly staining without scratches with a microfiber pad\n*After use, self-standing keeps it clean without a separate cradle\n*Product Quality Warranty Period: 1 Year",
    description_jpn:
      "*20초 초고속 예열로 강력한 고온 스팀, 99% 스팀 살균력\n*3단계 스팀 분사와 단계별 LED 표시\n*1.96cm의 슬림 헤드로 침대 밑, 소파 밑 청소도 자유롭게\n*자유자재로 돌아가는 스위블 헤드로 편안하게\n*탈부착이 용이한 분리형 물통으로 청소 후 남은 물기 제거도 간편해요\n*다양한 브러쉬와 노즐로 바닥 청소뿐만 아니라 주방 후드, 인덕션, 창틈 청소, 욕실청소도 OK\n*5M의 코드길이로 집안 구석구석 자유롭게\n*극세사 패드로 스크래치 없이 꼼꼼하게 찌든때 박멸\n*사용 후에는 셀프 스탠딩으로 별도의 거치대 없이 깔끔하게 보관\n*제품 품질보증기간 : 1년",
    product_image_1:
      "https://products.naganorewards.com/KR/HAAN/SteamCleaner2in1.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2066",
    brand: "HAAN",
    sku: "HAHOUHAKR0101",
    product_eng: "HAN KYUNG HEE Steam cleaner SI-3600WT",
    product_jpn: "[한경희] 스팀청소기 SI-3600WT",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "129,000",
    description_eng:
      "*I'll stand 1.9kg ultra-light to reduce the burden on my wrist.\"\n*30 seconds of preheating time allows for quick cleaning without having to wait for a long time\n*180 ︒ swivel head for every nook and cranny cleaning\n*1.95cm slim head allows clean cleaning of dark and invisible narrow spaces\n*Easy one-touch steam button\n*360 ︒ Anti-Collapse Cord Hanger\n*350 ml large capacity detachable water bottle\n*Product Quality Warranty Period: 1 Year",
    description_jpn:
      "*손목에 부담을 줄여주는 1.9kg 초경량 설게\n*예열시간 30초로 오랜시간 기다릴 필요없이 빠르기 청소 가능\n*180︒ 스위블헤드로 구석구석 청소 가능\n*1.95cm 슬림헤드로 어둡고 보이지 않는 좁은 공간까지 깨끗하게 청소 가능\n*원터치 간편한 스팀버튼\n*360︒꼬임 방지 코드걸이\n*350ml 대용량 분리형 물통\n*제품 품질보증기간 : 1년",
    product_image_1:
      "https://products.naganorewards.com/KR/HAAN/SteamCleaner.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2067",
    brand: "HAAN",
    sku: "HAHOUHAKR0102",
    product_eng: "HAN KYUNG HEE 2-in-1 vacuum cleaner EHVS-D2000",
    product_jpn: "[한경희] 2in1 진공청소기 EHVS-D2000",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "219,000",
    description_eng:
      "*Dual vacuum cleaner for both stick and handle\n*Lower center design with less wrist strain\n*Stage 4 Dust Filter\n*Step 2 Power Adjustment\n*2,200 mAh large capacity lithium battery\n*LED light\n*Self-standing\n*a folding handle\n*Product quality warranty period: 1 year",
    description_jpn:
      "*스틱/핸디 겸용 듀얼 진공청소기\n*손목 부담 적은 하부 중심 설계\n*4단계 먼지 필터\n*2단계 파워 조절\n*2,200mAh 대용량 리튬 배터리\n*LED 라이트\n*셀프 스탠딩\n*접이식 손잡이\n*제품 품질보증기간 : 1년",
    product_image_1:
      "https://products.naganorewards.com/KR/HAAN/VacuumCleaner2in1.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2068",
    brand: "HAAN",
    sku: "HAHOUHAKR0103",
    product_eng: "HAN KYUNG HEE Slim type steam cleaner HESM-D1100",
    product_jpn: "[한경희] 슬림형 스팀청소기 HESM-D1100",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "129,000",
    description_eng:
      "*15 second super fast preheating\n*100 degrees Celsius high-temperature steam\n*Step 3 Steam Control\n*30g/min strong steam\n*Swivel Head\n*320 ml Large Capacity Water Bottle (Integrated)\n*Self-standing\n*microfiber pad\n*Product quality warranty period: 1 year",
    description_jpn:
      "*15초 초고속 예열\n*100도씨 고온 스팀\n*3단계 스팀량 조절\n*30g/min 의 강력 스팀\n*스위블 헤드\n*320ml 대용량 물통 (일체형)\n*셀프 스탠딩\n*극세사 패드\n*제품 품질보증기간 : 1년",
    product_image_1:
      "https://products.naganorewards.com/KR/HAAN/SlimSteamCleaner.png",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2069",
    brand: "Hanil",
    sku: "HAHOUKOKR0104",
    product_eng: "Korea-Japan Nature Dream Comeli Carbon Mat (Single)",
    product_jpn: "[한일] 자연꿈 코멜리 탄소매트 (싱글)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "79,000",
    description_eng:
      "* far-infrared radiation\n* anti-tick fabric\n* Electromagnetic waves-free carbon mat\n* Automatic turn-off timer (15 hours)\n* Power consumption: 190W\n\nSpecifications: 100×180 cm\nComposition: Main product, temperature cutter, manual",
    description_jpn:
      "* 원적외선 방사\n* 진드기 방지용 원단\n* 전자파 걱정없는 탄소매트\n* 자동꺼짐 타이머(15시간)\n* 소비전력 : 190W\n\n규격 : 100*180cm\n구성 : 본품, 온도도절기, 설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Hanil/CarbonMatSingle.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2070",
    brand: "Hanil",
    sku: "HAHOUKOKR0105",
    product_eng: "Korea-Japan Nature Dream Comeli Carbon Mat (Double)",
    product_jpn: "[한일] 자연꿈 코멜리 탄소매트 (더블)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "89,000",
    description_eng:
      "* far-infrared radiation\n* anti-tick fabric\n* Electromagnetic waves-free carbon mat\n* Automatic turn-off timer (15 hours)\n* Power consumption: 190W\n\nSpecification: 135*180 cm\nComposition: Main product, temperature cutter, manual",
    description_jpn:
      "* 원적외선 방사\n* 진드기 방지용 원단\n* 전자파 걱정없는 탄소매트\n* 자동꺼짐 타이머(15시간)\n* 소비전력 : 190W\n\n규격 : 135*180cm\n구성 : 본품, 온도도절기, 설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Hanil/CarbonMatDouble.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2071",
    brand: "HANSSEM",
    sku: "HAHOUHAKR0106",
    product_eng: "Hanssem My Home Horn Ring Horn Home Toothbrush Sterilizer",
    product_jpn: "[한샘] 마이홈 뿔링뿔링 가정용 칫솔살균기",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "89,000",
    description_eng:
      "Sterilize 99.9% every day!\n□ 99.9% sterilization by PTC heater method sterilization\n□ 3 toothbrushes + razor rack / Toothpaste storage tray applied\n□ semi-permanent LED lamp\n□ Stand and wall type 2way available\n□ Equipped with an anti-slip pad, it can be used without shaking\n□ Size: 239×270×90 mm\n□ Material: ABS, PC, aluminum\n□ Composition: toothbrush sterilizer body, stand-type holder, toothbrush 5-piece holder, 3 toothbrushes, and razor holder",
    description_jpn:
      "매일 99.9% 살균하세요!\n□ PTC 히터방식 살균으로 99.9% 살균\n□ 칫솔 3개 + 면도기 걸이 거치가능 / 치약 보관 트레이 적용\n□ 반영구 LED램프\n□ 스탠드 및 벽걸이 타입으로 2way 사용 가능\n□ 미끄럼 방지 패드를 장착하여 흔들림 없이 사용 가능\n□ 사이즈: 239*270*90mm\n□ 재질: ABS, PC, 알류미늄\n□ 구성: 칫솔살균기 본체, 스탠드형 거치대, 칫솔5개입 거치대, 칫솔3개와 면도기 거치대",
    product_image_1:
      "https://products.naganorewards.com/KR/GIPFEL/ToothbrushSterilizer.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2072",
    brand: "HANSSEM",
    sku: "HAKITHAKR0107",
    product_eng: "Hanssem Daily snack maker",
    product_jpn: "[한샘] 데일리 간식메이커",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "69,000",
    description_eng:
      "□ a white-toned neat color and minimal design\n□ There's a 15-minute timer, so you don't have to watch the cooking process\nYou may not burn it.\n□ The double-sided coated plate does not stick to the dough, making it convenient to cook.\n□ You can check whether the snack maker is operating with the power indicator.\n□ Size: 13x23x10.3 cm",
    description_jpn:
      "□ 화이트톤의 깔끔한 컬러와 미니멀한 디자인\n□ 15분 타이머 기능이 있어서 조리과정을 지켜보지 않아도 음식을\n태우지 않을 수 있습니다.\n□ 양면코팅된 플레이트로 반죽이 눌어붙지 않아 조리가 편리합니다.\n□ 전원표시등으로 간식메이커의 작동여부 확인이 가능합니다.\n□ 사이즈 : 13 x 23 x 10.3cm",
    product_image_1:
      "https://products.naganorewards.com/KR/hanssem/SnackMaker.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2073",
    brand: "HANSSEM",
    sku: "HAHOUHAKR0108",
    product_eng: "Hanssem Olivia Danstand (with basic light bulb)",
    product_jpn: "[한샘] 올리비아 단스탠드(기본전구 포함)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "58,000",
    description_eng:
      "# Composition: Glass God, Body, Base\n# Size: 19.4 cm in diameter × 10 cm in diameter × 25.5 cm in height\n# Color: Gad-Milk Glass / Lamp Stand, Base-Gold Painting\n# Material: Glass, Steel\n# Power consumption: recommended 4W\n# KC certification: YU11100-21001G\n# Characteristics\n- French/Modern Style\n- Excellent as a gift because there are few likes and dislikes for men and women of all ages\n- a warm light consisting of round lights",
    description_jpn:
      "# 구성 : 유리갓, 바디, 베이스\n# 사이즈 : 갓 지름19.4cm * 베이스지름 10cm * 높이 25.5cm\n# 색상 : 갓-유백색 유리 / 램프 대, 베이스-골드도장\n# 소재 : 유리, 스틸\n# 소비전력 : 권장 4W\n# KC인증 : YU11100-21001G\n# 특징\n- 프렌치/ 모던 스타일\n- 남녀노소 호불호가 적어 선물용으로 탁월\n- 둥근 불빛으로 구성 된 따뜻한 분위기의 조명",
    product_image_1:
      "https://products.naganorewards.com/KR/hanssem/DanstandLamp.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2074",
    brand: "HANSSEM",
    sku: "HAHOUHAKR0109",
    product_eng: "Hanssem Olivia Mini-Table Lamp (with basic light bulb)",
    product_jpn: "[한샘] 올리비아 미니테이블램프(기본전구 포함)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "58,000",
    description_eng:
      "# Composition: Glass God, Body, Base\n# Size: 19.4 cm in diameter × 12 cm in diameter × 33.4 cm in height\n# Color: Gad-Milk Glass / Lamp Stand, Base-Gold Painting\n# Material: Glass, Steel\n# Power consumption: recommended 4W\n# KC certification: YU11100-21001G\n# Characteristics\n- French/Modern Style\n- Excellent as a gift because there are few likes and dislikes for men and women of all ages\n- Mini-sized interior design is possible even in a narrow window frame",
    description_jpn:
      "# 구성 : 유리갓, 바디, 베이스\n# 사이즈 : 갓 지름19.4cm * 베이스지름 12cm * 높이 33.4cm\n# 색상 :  갓-유백색 유리 / 램프 대, 베이스-골드도장\n# 소재 : 유리, 스틸\n# 소비전력 : 권장 4W\n# KC인증 : YU11100-21001G\n# 특징\n- 프렌치/ 모던 스타일\n- 남녀노소 호불호가 적어 선물용으로 탁월\n- 미니 사이즈로 좁은 창틀에도 인테리어 가능",
    product_image_1:
      "https://products.naganorewards.com/KR/hanssem/MiniTableLamp.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2075",
    brand: "HANSSEM",
    sku: "HAHOUHAKR0110",
    product_eng: "Hanssem Olivia table lamp (with basic light bulb)",
    product_jpn: "[한샘] 올리비아 테이블램프(기본전구 포함)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "60,000",
    description_eng:
      "# Composition: Glass God, Body, Base\n# Size: 25 cm in diameter × 18 cm in diameter × 44.5 cm in height\n# Color: Gad-Milk Glass / Lamp Stand, Base-Gold Painting\n# Material: Glass, Steel\n# Power consumption: Recommended 6W (up to 10W)\n# KC certification: YU11100-17001\n# Characteristics\n- French/Modern Style\n- Excellent as a gift because there are few likes and dislikes for men and women of all ages\n- a luxurious circular gat made by handcrafted work\n- Great for mini table size, such as narrow table",
    description_jpn:
      "# 구성 : 유리갓, 바디, 베이스\n# 사이즈 : 갓 지름25cm * 베이스지름 18cm * 높이 44.5cm\n# 색상 : 갓-유백색 유리 / 램프 대, 베이스-골드도장\n# 소재 : 유리, 스틸\n# 소비전력 : 권장 6W (최대10W이하)\n# KC인증 : YU11100-17001\n# 특징\n- 프렌치/ 모던 스타일\n- 남녀노소 호불호가 적어 선물용으로 탁월\n- 수공예 작업으로 만들어 진 고급스러운 원형 갓\n- 협탁 등 미니 테이블 사이즈에 연출하기 좋음",
    product_image_1:
      "https://products.naganorewards.com/KR/hanssem/TableLamp.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2076",
    brand: "HANSSEM",
    sku: "HAHOUHAKR0111",
    product_eng: "Hanssem Olivia floor lamp (with basic light bulb)",
    product_jpn: "[한샘] 올리비아 플로어램프(기본전구 포함)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "125,000",
    description_eng:
      "# Composition: Glass God, Body, Base\n# Size: Gad diameter 30 cm × Base diameter 28 cm × Height 145 cm\n# Color God-Glass Glass / Lamp Stand, Base-Gold Painting\n# Material: Glass, Steel\n# Power consumption: Recommended 6W (up to 10W)\n# KC certification: YU11100-17001\n# Characteristics\n- French/Modern Style\n- Excellent as a gift because there are few likes and dislikes for men and women of all ages\n- a luxurious circular gat made by handcrafted work\n- Subtle lighting interior design is possible with living room and bedroom, etc",
    description_jpn:
      "# 구성 : 유리갓, 바디, 베이스\n# 사이즈 : 갓 지름30cm * 베이스지름 28cm * 높이 145cm\n# 색상 갓-유백색 유리 / 램프 대, 베이스-골드도장\n# 소재 : 유리, 스틸\n# 소비전력 : 권장 6W (최대10W이하)\n# KC인증 : YU11100-17001\n# 특징\n- 프렌치/ 모던 스타일\n- 남녀노소 호불호가 적어 선물용으로 탁월\n- 수공예 작업으로 만들어 진 고급스러운 원형 갓\n- 거실 및 침실등 으로 은은한 조명 인테리어 연출 가능",
    product_image_1:
      "https://products.naganorewards.com/KR/hanssem/FloorLamp.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2077",
    brand: "HAPPYCALL",
    sku: "HAKITHAKR0112",
    product_eng: "Happy Call Grilled Egg Roll Pan IH Small 18 cm",
    product_jpn: "해피콜 그래핀 계란말이팬 IH 소형 18cm",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "48,000",
    description_eng:
      "■ Size: 16.1 × 39.8 × 5.2\n■ Material - Metal (aluminum), Wood, ABS\n■ Coating - Internal coating: Fluororesin coating (titanium spray) / External coating: Graphene and silica coating\n1. Internal coating: Fluororesin coating (titanium yarn)\n- Titanium, called platinum in the sea, was melted at an ultra-high temperature of more than 2,000 degrees Celsius to achieve amazing durability and non-stick through a fluororesin coating (titanium spraying).\n2. External coating: graphene\n- Graphene is in the spotlight as a dream material that can implement curved displays, high-efficiency solar cells, and ultra-fast semiconductors because its properties do not change even when it is bent or stretched. It is superior to other materials in terms of strength, thickness, conductivity, and thermal conductivity. Graphene exterior treatment lowers preheating and increases instantaneous heat conduction.\n3. External coating: high strength black silica\n- It is resistant to wear and tear, easy to clean without detergent, and resistant to fire by using silica inorganic components, so it can be used for a long time like the first time.\n- It is resistant to scratches and peeling and has excellent cleaning power, so it is easy to clean the seasoning and foreign substances while cooking, so it can be washed with less detergent and can be used hygienically.\n4. 20,000 oil spots\n- Happy Call More than 20,000 oil spots created through the latest CAVO EXTREAME PROCESS in history keep food ingredients floating without sticking directly to the bottom of the frying pan. With a small amount of oil, this CAVO XP can achieve innovative and overwhelming non-stick effects.\n5. Modern design and comfortable and stable handle\n- The simple and clean design and stable handle make it comfortable to use as it is with the modern feeling of the entire egg roll pan.\n6. Available for all heat sources including induction\n- It can be used not only for gas ranges, highlights, and hot plates, but also for IH induction, which boasts a high thermal efficiency of more than 90%, so it is very useful in various kitchen environments.\nspecial note",
    description_jpn:
      "■사이즈: 16.1 X 39.8 X 5.2\n■재질 - 금속제(알루미늄), 목재류, ABS\n■코팅 - 내장코팅 : 불소수지코팅(티타늄 용사) / 외장코팅 : 그래핀, 실리카코팅\n1. 내부코팅 : 불소수지코팅(티타늄용사)\n- 바다의 백금이라고 불리는 ‘티타늄’을 2천도 이상의 초고온에서 녹여 불소수지 코팅(티타늄 용사)으로 놀라운 내구성과 넌스틱을 실현했다.\n2. 외부코팅:그래핀\n- 그래핀은 휘거나 늘려도 특성이 변하지 않아 휘는 디스플레이, 고효율 태양전지, 초고속 반도체 등을 구현할 수 있는 꿈의 소재로 각광받고 있다. 강도, 두께, 전도율, 열전도율 면에서 다른 물질보다 뛰어나다. 그래핀 외장처리로 예열을 낮추고 순간열전도를 높인다.\n3. 외부코팅 : 고강도 블랙 실리카\n- 실리카 무기질 성분을 이용하여 블랙 포셀라인 외장 처리로 마모에 강하고 세제 없이도 세척이 간편하고 불에 강하여 변색이 적고 처음처럼 오래오래 사용할 수 있다.\n- 긁힘, 벗겨짐에 강하고 세척력이 우수하여 요리하다 묻은 양념, 이물질이 쉽게 닦여 적은 세제로 물세척이 가능하고 위생적으로 사용할 수 있다.\n4. 2만여 개 오일스팟\n- 해피콜 역대 최신의 CAVO EXTREAME PROCESS를 통해 탄생한 2만여 개 오일스팟을 통해 식재료가 프라이팬의 바닥면에 바로 붙지 않고 떠있게 해준다. 이 CAVO XP는 적은 양의 오일로 혁신적이고 압도적인 넌스틱 효과를 얻을 수 있다.\n5. 모던한 디자인과 편안하고 안정적인 핸들\n- 계란말이팬 전체의 모던한 느낌 그대로 심플하고 깔끔한 디자인과 안정적인 핸들로 사용 시 편안함을 준다.\n6. 인덕션을 포함한 모든 열원에 사용 가능\n- 가스레인지, 하이라이트, 핫플레이트 등은 물론이고, 90% 이상의 높은 열효율을 자랑하는 IH 인덕션에도 사용이 가능하여 다양한 주방 환경에서 그 활용성이 매우 뛰어나다.\n특이사항",
    product_image_1:
      "https://products.naganorewards.com/KR/HAPPYCALL/EggRollPan.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2078",
    brand: "HAPPYCALL",
    sku: "HAKITHAKR0113",
    product_eng: "Happy call New Waffle Pan CC",
    product_jpn: "해피콜 뉴와플팬CC",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "54,000",
    description_eng:
      "■ Material\n- Body: Aluminum castings, Dow Corning Co.'s special silicone (U.S. FDA approved)\n- Handle: thermosetting resin, stainless steel\n■ Coating\n- Internal Coating: Fluororesin Coating (ceratinium coating)\n- External Coating: Ceramic Coating\n■ Size - 250×335×30 mm\n1. serratinium triple coating\n- It is treated with a triple coating of serratinium baked at a high temperature of 450 degrees, so the coating power is very strong and hard, so there is little fear that food will stick to the pan floor, and the floor is smooth, making it easy to clean after cooking.\n2. overflow prevention groove\n- High cooking walls and wide edge grooves are applied to prevent the contents from overflowing and dirtying the pan surface during cooking, enabling clean cooking.\n3. Convenient lock handle\n- The Easy-Locking handle, which can be easily opened and closed with a soft operation, helps convenient cooking by closely attaching and fixing the upper and lower plates.",
    description_jpn:
      "■재질\n- 본체 : 알루미늄 통주물, 다우코닝사 특수 실리콘(미국 FDA승인)\n- 손잡이 : 열경화수지, 스테인레스 스틸\n■코팅\n- 내부코팅 : 불소수지코팅(세라티늄 코팅)\n- 외부코팅 : 세라믹코팅\n■사이즈 - 250*335*30mm\n1. 세라티늄 3중 코팅\n- 450도 고열에서 구운 세라티늄 3중 코팅으로 처리되어 코팅력이 매우 강하고 단단해 음식물이 팬바닥에 눌러붙을 염려가 적으며, 바닥이 매끄러워 조리 후 세척이 간편하다.\n2. 넘침방지 홈\n- 높은 조리벽과 넓은 가장자리 홈을 적용시켜 조리시 내용물이 넘쳐나와 팬 표면이 더러워지는 것을 방지해 주어 깔끔한 조리가 가능하다.\n3. 편리한 잠금 손잡이\n- 부드러운 조작감으로 손쉽게 열고 닫을 수 있는 Easy-Locking 손잡이는 상, 하판을 밀착, 고정시켜서 편리한 조리를 도와준다.",
    product_image_1:
      "https://products.naganorewards.com/KR/HAPPYCALL/WaffleFan.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2079",
    brand: "HuBDIC",
    sku: "HUHOUHUKR0114",
    product_eng:
      "Hubdic Handy wired steam iron HWS-3W (iron, sterilization, deodorization)",
    product_jpn: "[휴비딕] 핸디 유선 스팀다리미 HWS-3W(다리미, 살균, 탈취)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "34,900",
    description_eng:
      "Light as air but powerful Power Steam Hubidic Handy Steam Iron\n\n1. Fast preheating and rich steam products with 1000W of powerful steam\n2. Easy to use anywhere in size\n3. Powersteam is available with 40 seconds of preheating quickly\n4. Strong high-temperature steam for sterilization and deodorization at once\n5. Easy to use with just one ON/OFF one-touch button!\n6. Effective ironing of various types of fibers",
    description_jpn:
      "공기처럼 가볍지만 강력한 파워스팀 휴비딕 핸디 스팀다리미\n\n1. 1000W의 강력한 스팀으로 빠른 예열과 풍부한 스팀의 제품\n2. 부담없는 사이즈로 어디에서든 간편하게 사용가능\n3. 빠른 40초 예열으로 파워스팀 사용가능\n4. 강력한 고온스팀으로 살균 & 탈취까지 한번에 사용가능\n5. ON/OFF 원터치 버튼 하나로 간편하게 사용! \n6. 다양한 섬유 종류에 효과적으로 다림질 가능",
    product_image_1:
      "https://products.naganorewards.com/KR/HuBDIC/SteamIronWired.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2080",
    brand: "HuBDIC",
    sku: "HUDAIHUKR0115",
    product_eng: "Hubdic Automatic blood pressure gauge BPIC Pro",
    product_jpn: "[휴비딕] 자동 혈압계 비피첵 프로",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "60,000",
    description_eng:
      '*Components: main body, instruction manual, 4 AAA batteries, cuff, product box\n* Size: 140×130×4937 (mm) m, weight: 250 g (excluding batteries)\n\n1. The non-Pacek pro is an oscillometric measurement method that allows you to measure blood pressure, pulse rate, and arrhythmia at home easily and quickly.\n2. When measuring blood pressure, the blood pressure status according to the WHO blood pressure classification criteria is displayed with the "Display Bar" icon.\n3. Save 2 custom and 250 measurements\n4. Easy to use at home\n5. Principle of Operation - Method by Vibration (Ossilometric)\n6. Purpose of use - Electronic devices that use indirect (non-vascular) systolic (non-vascular) systolic (non-vascular) systolic, cuff automatically pressurizes and usually displays heart rate in addition to systolic and diastolic blood pressure.',
    description_jpn:
      '*구성품:본체, 사용설명서, AAA건전지 4개, 커프, 제품박스\n* 사이즈 : 140*130*4937(mm)m, 무게: 250g(배터리제외)\n\n1. 비파첵 프로는 오실로 메트릭 측정방법으로 쉽고 빠르게 가정에서 혈압, 맥박수, 부정맥 3가지를 한번에 측정 할 수 있습니다.\n2. 혈압을 측정시 WHO 혈압 분류기준에 따른 혈압 상태를 "표시바" 아이콘으로 표시 합니다.\n3. 2명의 사용자 지정 및 250개 측정치 저장\n4. 가정에서도 사용하기 쉬운 간편한 디자인\n5. 작동원리 - 진동법에 의한 방식(오실로메트릭)\n6. 사용목적 -  혈압의 간접적(비혈관적)측저엥 이용하는 전자식 기기, 커프는 자동적으로 가압하며 일반적으로 수축기 및 확장기 혈압에 더해 심박수를 표시한다.',
    product_image_1:
      "https://products.naganorewards.com/KR/HuBDIC/BloodPressureGauge.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2081",
    brand: "Hugo-Frosch",
    sku: "HUDAIHUKR0116",
    product_eng:
      "Hugo Prosch Insulation Water Pouch Hot Pack Classic Teddy Coat Type Giraffe Brown 1.8 L",
    product_jpn:
      "[휴고프로쉬] 보온물주머니 핫팩클래식 테디코트형 기린브라운 1.8L",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "34,500",
    description_eng:
      "*Patent Safety Cap (Monitoring Hazardous Substances for 2-Year Warranty T̈V Test for Leakage)\n*Ce Medical Device Guidelines 93/42 EEC Class 1 Compliance\n*Manufactured in accordance with British Standard BS 1970:2012\n*Size: 33×20 cm\n*Color: Brown\n*Material: Water Pouch PVC / Cover: 100% polyester\n*Composition: Water bag Hot pack + Cover\n*Manufacturer/Country of Origin: Hugo-Frosch/Germany\n*When you hold it, the warmth time is longer and it is less hot.",
    description_jpn:
      "*특허안전캡 (누설에 대 한 2 년 보증 TÜV 테스트를 유해 물질 모니터링 ) \n*Ce 의료 기기 지침 93/42 EEC 클래스 1 준수\n*영국 표준 BS 1970:2012에 따라 제조\n*크  기 : 33x 20 cm \n*색  상 : 브라운\n*재  질 : 물주머니 PVC / 커버: 폴리에스테르100%  \n*구  성 : 물주머니핫팩+커버  \n*제조원/원산지:Hugo-Frosch/독일                        \n*안고있을때 보온시간이 더 늘어나고 덜 뜨겁습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Hugo-Frosch/HotPackGiraffeBrown.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2082",
    brand: "Hugo-Frosch",
    sku: "HUDAIHUKR0117",
    product_eng:
      "Hugo Prosch Insulation Water Pouch Hot Pack Classic Teddy Coat Type Giraffe White 1.8 L",
    product_jpn:
      "[휴고프로쉬] 보온물주머니 핫팩클래식 테디코트형 기린화이트 1.8L",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "34,500",
    description_eng:
      "*Patent Safety Cap (Monitoring Hazardous Substances for 2-Year Warranty T̈V Test for Leakage)\n*Ce Medical Device Guidelines 93/42 EEC Class 1 Compliance\n*Manufactured in accordance with British Standard BS 1970:2012\n*Size: 33×20 cm\n*Color: White\n*Material: Water Pouch PVC / Cover: 100% polyester\n*Composition: Water bag Hot pack + Cover\n*Manufacturer/Country of Origin: Hugo-Frosch/Germany\n*When you hold it, the warmth time is longer and it is less hot.",
    description_jpn:
      "*특허안전캡 (누설에 대 한 2 년 보증 TÜV 테스트를 유해 물질 모니터링 ) \n*Ce 의료 기기 지침 93/42 EEC 클래스 1 준수\n*영국 표준 BS 1970:2012에 따라 제조\n*크  기 : 33x 20 cm \n*색  상 : 화이트\n*재  질 : 물주머니 PVC / 커버: 폴리에스테르100%  \n*구  성 : 물주머니핫팩+커버  \n*제조원/원산지:Hugo-Frosch/독일                        \n*안고있을때 보온시간이 더 늘어나고 덜 뜨겁습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Hugo-Frosch/HotPackGiraffeWhite.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2083",
    brand: "Inkel",
    sku: "INDAIINKR0118",
    product_eng: "Inkel High Speed Wireless Charging Clock INDEX",
    product_jpn: "[인켈] 고속무선충전 시계 INDEX",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "30,000",
    description_eng:
      "* Powerful 15W fast wireless charging support\n* Smart watch with 6 features\n* Equipped with thermometer to measure and display the temperature of the current space\n* 4-Step Brightness Adjustable LED Display\n\n* Components: Main body, Type C power USB charging cable, User's manual\n* Communication distance: 10M\n* Product specification: 160×75×65(mm) * Weight: 212 g",
    description_jpn:
      "* 강력한 15W 고속 무선충전 지원\n* 6가지 기능이 탑재된 스마트 시계\n* 현재 공간의 온도를 측정 및 표시하는 온도계 기능 탑재\n* 4단계 밝기 조절 가능한 LED 디스플레이\n\n* 구성품 : 본체, C타입 전원 USB 충전 케이블, 사용설명서\n* 통신거리 : 10M\n* 제품규격 : 160*75*65(mm)  * 무게 : 212g",
    product_image_1:
      "https://products.naganorewards.com/KR/inkel/WirelessChargingClock.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2084",
    brand: "Inkel",
    sku: "INDAIINKR0119",
    product_eng: "Inkel Easy Grip High-Performance Taste Gun IK-WAG1",
    product_jpn: "[인켈] 이지그립 고성능 맛사지건 IK-WAG1",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "59,000",
    description_eng:
      "* 250g ultra-lightweight weight makes it easy to use in everyday life\n* From 1st to 4th stages, you can adjust it to the desired strength\n* Provides four different types of functional headers\n\n* Components: Main product, 4 headers, C-type charging cable, user manual\n* Usage time: 3 to 5H\n* Product specification: 78×44.5×132 (mm) * Weight: 250 g",
    description_jpn:
      "* 250g 초경량 무게로 일상에서 부담없이 사용\n* 1단부터 4단까지 원하는 강도로 조절 가능\n* 4가지 타입의 다양한 기능성 헤더 제공\n\n* 구성품 : 본품, 헤더 4종, C타입충전전용케이블, 사용설명서\n* 사용시간 : 3~5H\n* 제품규격 : 78*44.5*132(mm)  * 무게 : 250g",
    product_image_1:
      "https://products.naganorewards.com/KR/inkel/TasteGun.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2085",
    brand: "Iriver",
    sku: "IRHOUIRKR0120",
    product_eng: "Iriver Mini kettle humidifier KH-A9",
    product_jpn: "[아이리버] 미니케틀 가습기 KH-A9",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "59,000",
    description_eng:
      "Components - Body, Type-C Cable (90 cm), User's Guide\nColor - White / Size - 181 x 115 x 152 mm / 368 g\nspecial note -\nPowerful ultrasonic humidifier - Micro mist humidification, application of technology that foams water particles by more than 30% smaller than existing products - Large capacity 350ml water tank - 90 degrees left/right rotation function for up to 12 hours continuously - Support automatic rotation mode, equipped with Staminer battery that allows wide humidification with left/right automatic rotation function for the first time in Korea - 2,000mAh lithium-ion battery Pure cotton filter - Hygienic cotton filter Automatic detection sensor for water shortage - Automatic turn-off in case of water shortage, preventing fire from burning or overheating filter Unique design of iRiver - Unique design reminiscent of coffee pot Easy cleaning - Can be cleaned in a barrel Type-C charging port support - Existing smartphone chargers or cables can be compatible and connected to auxiliary batteries to charge and use PCM dual safety circuits - It can prevent overcharging, overdischarging, overvoltage, and short (load)\nSafety certification number: XU101536-18001A / R-R-a2z-Mini-Kettle",
    description_jpn:
      "구성품 - 본체, Type-C 케이블(90cm), 사용설명서\n색상 - 화이트 / 사이즈 - 181 x 115 x 152mm / 368g\nspecial note - \n강력한 초음파 가습기 - 마이크로 미스트 가습, 기존 자사 제품 대비 물입자를 30% 이상 작게하여 발포하는 기술 적용                                                                                                                       대용량 350ml 수조 - 최대 12시간 연속 사용                                                                                                                         90도 좌/우 회전 기능 - 자동 회전모드 지원, 국내 최초 좌/우 자동 회전기능으로 폭 넓은 가습이 가능                                                                                                                           스태미너 배터리 탑재 - 2,000mAh 리튬이온 배터리                                                                                                                 순수 코튼필터 - 위생적인 면소재 필터 사용                                                                                                                                         물 부족 자동 감지센서 - 물 부족시 자동 꺼짐기능, 필터가 타거나 과열로 인한 화재를 예방                                                                                                                        아이리버만의 유니크한 디자인 - 커피포트를 연상시키는 유니크한 디자인                                                                                               간편한 세척 - 통 세척 가능                                                                                                                                               Type-C 충전포트 지원 - 기존 스마트폰 충전기나 케이블 호환 사용이 가능, 보조배터리에 연결하여 충전 및 사용이 가능                                      PCM 2중 안전 회로 탑재 - 과충전, 과방전, 과전압, 쇼트(부하)방지가 가능\n안전인증번호 : XU101536-18001A / R-R-a2z-MIni-Kettle",
    product_image_1:
      "https://products.naganorewards.com/KR/iriver/KettleHumidifier.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2086",
    brand: "Iriver",
    sku: "IRHOUIRKR0121",
    product_eng: "Iriver Calf EMS massager CE010",
    product_jpn: "[아이리버] 종아리 EMS 마사지기 CE010",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "40,000",
    description_eng:
      "* Configuration: main body, micro 5-pin cable, user manual\n* Color: White, Navy\n* Material: ABS, PP, etc\n\n' - Low frequency stimulation to the inner muscles\n- Step 5 Adjusting the Strength and Strength\n- Blood circulation thermal function\n- Weight-free 250g, easy to wear Velcro\n- a clean semi-permanent pad\n- a variety of 12 patterns\n- Smart 15-minute automatic timer",
    description_jpn:
      "* 구성 : 본체, Micro 5핀 케이블, 사용설명서\n * 색상 : 화이트,네이비\n * 재질 : ABS, PP 외\n\n' -속 근육까지 저주파 자극\n - 5단계 강약 조절\n - 혈액순환 온열기능\n - 부담없는 250g 무게, 간편한 벨크로 착용 방식\n - 청결한 반영구 패드\n - 다양한 12가지 패턴\n - 스마트 15분 자동 타이머",
    product_image_1:
      "https://products.naganorewards.com/KR/iriver/EMSMassager.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2087",
    brand: "Iriver",
    sku: "IRHOUIRKR0122",
    product_eng: "Iriver Massage your calf's feet",
    product_jpn: "[아이리버] 종아리발마사지기",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "69,000",
    description_eng:
      "* Configuration: Body, Power Adapter, User's Guide\n* Color: White\n* Material: ABS, PP, etc\n\n' - Chiropractic rolling, Chiropractic plate\n- Step 3 Customized Speed Adjustment\n- Different parts available\n- Adjustable forward and reverse use\n- Compact size, 1.2kg lightweight\n- Blood circulation thermal function\n- Smart 15-minute automatic timer",
    description_jpn:
      "* 구성 : 본체, 전원어댑터, 사용설명서\n * 색상 : 화이트\n * 재질 : ABS, PP 외\n\n' -지압롤링, 지압판\n - 3단계 맞춤형 속도 조절\n - 다양한 부위 사용 가능\n - 정방향 역방향 사용조절 가능\n -  컴팩트한 사이즈,1.2kg의 부담없는 무게\n - 혈액순환 온열기능\n - 스마트 15분 자동 타이머",
    product_image_1:
      "https://products.naganorewards.com/KR/iriver/CalfMassager.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2088",
    brand: "Kitchen-Art",
    sku: "KIKITKIKR0123",
    product_eng: "Kitchen art Air pop popcorn maker PK-219JT",
    product_jpn: "[키친아트] 에어팝 팝콘 메이커 PK-219JT",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "90,000",
    description_eng:
      "● It is good for health by making popcorn only with the ingredients of corn itself.\n● Easy to clean by simply removing the lid after use.\n● There is a warmer cup, so you can enjoy popcorn in any flavor you want, such as butter, cheese, chocolate, and caramel.",
    description_jpn:
      "● 옥수수자체의 성분으로만 팝콘을 만들어 건강에 좋습니다.\n● 사용 후 간단하게 뚜껑을 분리하여 손쉽게 세척할 수 있습니다.\n● 워머컵이 있어서 버터, 치즈, 초콜렛, 카라멜 등 원하는 맛으로 팝콘을 맛있게 즐기실 수 있습니다.\n특이사항",
    product_image_1:
      "https://products.naganorewards.com/KR/Kitchen-Art/PopcornMaker.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2089",
    brand: "Kitchen-Art",
    sku: "KIKITKIKR0124",
    product_eng: "Kitchen Art Electric Grill Large KP-3070",
    product_jpn: "[키친아트] 전기 그릴 대 KP-3070",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "125,000",
    description_eng:
      "■ Size: 660×300 mm\n■ Product Features\n1. Its practical area makes it easy to use.\n2. The heating wire is integrated with the grill pan, so it is convenient to use because the preheating time is short.\n3. It has an oil outlet so that the oil can be discharged without stagnation.\n4. It is convenient to use as an automatic temperature control function.\n5. There is an embossed grill pan for more delicious cooking when grilling steak or meat.",
    description_jpn:
      "■크기 : 660*300mm\n■상품특징\n1. 실용적인 면적으로 간편하게 사용할 수 있습니다.\n2. 열선이 그릴팬과 일체형이라서 예열시간이 짧아 사용하시기 편리합니다.\n3. 기름 배출구가 있어서 기름이 정체되지 않고 배출될수 있도록 하여 사용이 가능합니다.\n4. 자동온도조절기능으로 사용하시기 편리합니다.\n5. 엠보로 된 그릴팬이 있어 스테이크나 육류를 구울때 더욱 맛있게 조리가 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Kitchen-Art/ElectricGrill.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2090",
    brand: "LG H&H",
    sku: "LGCOSLGKR0125",
    product_eng: "LG Touching TPho (A3) of life",
    product_jpn: "[LG] 생활의 감동 TP호(A3)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "16,900",
    description_eng:
      "■ Touching life TPho -9 PCS\nES Damage Moisture Care 10×Shampoo 200 ML-1 ea\nES Damage Glossy Care 10X Condition 200 ML-1 ea\nOn) The Natural Body Wash Lavender Scent 190 ML-1p\nPerioCavity Total Red Purple_90G-2p\nOn) Botanic Mild Soap 80G-2p\nPerio Microfiber Slim Touch Black Pearl-2p",
    description_jpn:
      "■ 생활의 감동 TP호 -9PCS\nES데미지윤기케어10X샴푸 200ML-1개\nES데미지윤기케어10X컨디 200ML-1개\n온)더내추럴바디워시 라벤더향190ML-1개\n페리오캐비티토탈 레드퍼플_90G-2개\n온)보타닉마일드 비누 80G-2개\n페리오 초극세모 슬림터치 흑진주-2개",
    product_image_1:
      "https://products.naganorewards.com/KR/LG_H&H/TouchingLifeA3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2091",
    brand: "LG H&H",
    sku: "LGCOSLGKR0126",
    product_eng: "LG Touching Life No. 29 (A2)",
    product_jpn: "[LG] 생활의감동 29호(A2)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "29,900",
    description_eng:
      "■ Touching Life No. 29 (13pcs)\n*Dr. Groot Hair Shampoo 180 ml\n*Organist Cherry Blossom Shampoo 180 ml\n*Organist Cherry Blossom Conditioner 180 ml\n*Organist Peppermint Shampoo 180 ml\n*On the Body Avocado Body Wash 190 ml\n*Perio Cavity Toothpaste (6 pieces)\n*On the Body Botanic Soap 80 g (2)",
    description_jpn:
      "■ 생활의감동 29호(13pcs)\n*닥터그루트 모발용샴푸 180ml\n*오가니스트 체리블라썸 샴푸 180ml\n*오가니스트 체리블라썸 컨디셔너 180ml\n*오가니스트 페퍼민트 샴푸 180ml\n*온더바디 아보카도 바디워시 190ml\n*페리오 캐비티 치약(6개)\n*온더바디 보타닉비누 80g(2개)",
    product_image_1:
      "https://products.naganorewards.com/KR/LG_H&H/TouchingLifeA2.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2092",
    brand: "LG H&H",
    sku: "LGCOSLGKR0127",
    product_eng: "LG Masterpiece Special No. 48 (A3)",
    product_jpn: "[LG] 명작스페셜 48호(A3)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "48,900",
    description_eng:
      "■ Masterpiece Special No. 48 (A3) (15pcs)\nESO Heaping Scaling Shampoo 200 ml\nOn) Himalayan Pink Salt Body Wash 190 ml\nESO Cherry Moisture Shampoo 200 ml\nESO Cherry Moisture Conditioner 200ml\nOga Hipping Shampoo 380 ml\nPerio Cavity Total Blue Green_90G - 2 pieces\nPerio Cavity Total Red Purple_90G\nOn)The Natural Body Wash Lavender Scent 500G\nOn)Botanic Mild Soap 80G Red\nOn) Botanic Mild Soap 80G Purple\nPerio Microfiber Slim Touch Black Pearl-2p\nPerio Microfiber Slim Touch Bamboo - 2p",
    description_jpn:
      "■ 명작스페셜 48호(A3)(15pcs)\nES 오가 히핑 스케일링샴푸 200ML\n온)히말라야핑크솔트 바디워시190ML\nES 오가 체리 수분 샴푸 200ML\nES 오가 체리 수분 컨디 200ML\n오가 히핑 샴푸 380ML\n페리오 캐비티토탈 블루그린_90G -2개 \n페리오 캐비티토탈 레드퍼플_90G\n온)더내추럴바디워시 라벤더향500G\n온)보타닉마일드 비누 80G 레드\n온)보타닉마일드 비누 80G 퍼플\n페리오 초극세모 슬림터치 흑진주-2개 \n페리오 초극세모 슬림터치 대나무 -2개",
    product_image_1:
      "https://products.naganorewards.com/KR/LG_H&H/MasterpieceA3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2093",
    brand: "LG H&H",
    sku: "LGCOSLGKR0128",
    product_eng: "LG Classic No. 59 (A3)",
    product_jpn: "[LG] 명작클래식 59호(A3)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "59,900",
    description_eng:
      "■ Masterpiece Classic No. 59 (A3) (17 pcs)\nESO Cherry Moisture Shampoo 200 ml\nESO Cherry Moisture Conditioner 200ml\nOga Hipping Shampoo 380 ml\nPerio Cavity Total Blue Green_90G-2 ea\nPerio Cavity Total Red Purple_90G-2p\nOn) Himalayan Pink Salt Body Wash 380 ml\nOn)Botanic Mild Soap 80G Red\nOn) Botanic Mild Soap 80G Purple\nPerio Microfiber Slim Touch Black Pearl-3p\nTech Clean & 1KG (975ML) General/Drums\nHomestar application mold sprout 120ml\nSaffron Pink Container 1.0 L_Citric Acid\nNatural Pong Pine Leaf CAP 490 ml",
    description_jpn:
      "■ 명작클래식 59호(A3) (17pcs)\nES 오가 체리 수분 샴푸 200ML\nES 오가 체리 수분 컨디 200ML\n오가 히핑 샴푸 380ML\n페리오 캐비티토탈 블루그린_90G-2개 \n페리오 캐비티토탈 레드퍼플_90G-2개\n온)히말라야핑크솔트 바디워시380ML\n온)보타닉마일드 비누 80G 레드\n온)보타닉마일드 비누 80G 퍼플\n페리오 초극세모 슬림터치 흑진주-3개\n테크 클린앤 1KG(975ML) 일반/드럼 겸용\n홈스타 바르는 곰팡이 싹 120ML\n샤프란핑크용기1.0L_구연산\n자연퐁 솔잎 CAP 490ML",
    product_image_1:
      "https://products.naganorewards.com/KR/LG_H&H/ClassicA3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2094",
    brand: "LG H&H",
    sku: "LGCOSLGKR0129",
    product_eng: "LG Classic No. 72 (A3)",
    product_jpn: "[LG] 명작클래식 72호(A3)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "72,900",
    description_eng:
      "■ Classic No. 72 (19 pcs)\n*ESO Cherry Moisture Shampoo 200 ml\n*ESO Cherry Moisture Conditioner 200ml\n*Dr. Groot Powerless Shampoo AD 400ml\n*Oga Pink Salt Shampoo 380 ml\n*Dr. Groot Conditioner 180 ml\n*ESO Pink Salt Shampoo 200 ml\n*On) The Natural Lemon Bear Wash 500 ml\n*Perio Cavity Total Blue_90G (2)\n*Perio Cavity Total Red_90G (1)\n*Bamboo Salt Cheongshinwon Toothpaste 90G (2)\n*On)Botanic Mild Soap 80G (2)\n*Perrio S Microfiber Slim Touch Black Pearl (2)\n*FERIO S Ultra-Fibre Slim Touch Bamboo (2)",
    description_jpn:
      "■ 명작클래식 72호(19pcs)\n*ES 오가 체리 수분 샴푸 200ML\n*ES 오가 체리 수분 컨디 200ML\n*닥터그루트 힘없는샴푸AD 400ML\n*오가 핑크솔트 샴푸 380ML\n*닥터그루트 컨디셔너 180ML\n*ES 오가 핑크솔트 샴푸 200ML\n*온)더내추럴레몬버베워시500ML\n*페리오 캐비티토탈블루_90G(2개)\n*페리오 캐비티토탈레드_90G(1개)\n*죽염 청신원 치약 90G(2개)\n*온)보타닉마일드 비누 80G(2개)\n*페리오S 초극세모 슬림터치 흑진주(2개)\n*페리오S 초극세모 슬림터치 대나무(2개)",
    product_image_1:
      "https://products.naganorewards.com/KR/LG_H&H/ClassicA3_72.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2095",
    brand: "LG H&H",
    sku: "LGCOSLGKR0130",
    product_eng: "LG Masterpiece Special No. 93 (A3)",
    product_jpn: "[LG] 명작 스페셜 93호(A3)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "93,900",
    description_eng:
      "■ Masterpiece Special No. 93 (20 pcs)\nLien Royal Jelly Shampoo 400 ml\nLien Royal Jelly Conditioner 200 ml\nDr. Groot Conditioner 180 ml\nDr. Groot Powerless Shampoo AD 400ml\nESO Hipping Scaling Shampoo 200 ML-2p\nOn) The Natural Body Wash Lavender Scent 190 ml\nPerio Cavity Total Blue Green_90G-2 ea\nPerio Cavity Total Red Purple_90G\nBamboo Salt Blue Shinwon Toothpaste 90G-2p\nOga Hipping Shampoo 380 ml\nOn) Himalayan Pink Salt Body Wash 380 ml\nOn) Botanic Mild Soap 80G Purple-2p\nPerio Microfiber Slim Touch Black Pearl-2p\nPerio Microfiber Slim Touch Bamboo - 2p",
    description_jpn:
      "■ 명작 스페셜 93호 (20pcs)\n리엔 로열젤리 샴푸 400ML\n리엔 로열젤리 컨디 200ML\n닥터그루트 컨디셔너 180ML\n닥터그루트 힘없는샴푸AD 400ML\nES 오가 히핑 스케일링 샴푸 200ML-2개\n온)더내추럴바디워시 라벤더향190ML\n페리오 캐비티토탈 블루그린_90G-2개 \n페리오 캐비티토탈 레드퍼플_90G\n죽염 청신원 치약 90G-2개\n오가 히핑 샴푸 380ML\n온)히말라야핑크솔트 바디워시380ML\n온)보타닉마일드 비누 80G 퍼플-2개\n페리오 초극세모 슬림터치 흑진주-2개 \n페리오 초극세모 슬림터치 대나무 -2개",
    product_image_1:
      "https://products.naganorewards.com/KR/LG_H&H/MasterpieceA3_93.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2096",
    brand: "LOUIS QUATORZE",
    sku: "LOFASDEKR0131",
    product_eng:
      "Department Store Model Louis Cardinals 58 Embossed Pattern 3-Stage Manual Umbrella (Black)",
    product_jpn: "[백화점판매모델]루이까또즈 58엠보패턴 3단 수동우산(블랙)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      "A stylish embossed design, three-tier umbrella set\n\n[Product composition]\n> 3-tier manual umbrella 1EA\n[Product specifications]\n> Color: Black\n> Case: genuine paper case, packaging inquiries separately\n> Specification: 580 mm × 8 K (length of the umbrella × spray)\n> Fabric material: 100% polyester, medium rod: aluminum, rod: aluminum+FRP, nickel plated handle\n[Product Features]\n> 100% polyester Ponzi fabric waterproof (WP) and water repellent (WP) coating prevent rainwater from permeating and excellent gloss due to the use of the highest quality fabric\n> High-quality nickel-plated handle does not fade and is strong so it can be used for a long time\n> Simple, good grip and luxurious, and the medium rod and rod are rust-resistant by using the highest-quality electrodeposition coated rod\n\n* Warranty service is available at the department store / No exchange or return at the department store",
    description_jpn:
      "엠보패턴의 스타일리시한 디자인, 3단 우산 세트\n \n [제품구성]\n  > 3단 수동우산 1EA\n [제품사양]\n  > 색상 : 블랙\n  > 케이스 : 정품 종이케이스, 포장 별도 문의\n  > 규격 : 580mm * 8K(우산의길이X살수)\n  > 원단 재질: 폴리에스터100%, 중봉: 알루미늄, 살대: 알루미늄+FRP, 니켈도금손잡이\n [제품특징]\n  > 폴리에스터 100% 폰지원단방수(WP), 발수(WP)코팅을 하여 빗물이 스며들지 않으며 최고급원단 사용으로 광택이 우수\n  > 고급니켈도금 손잡이로 색이 바래지 않으며, 튼튼하여 오래 사용할 수 있음 \n  > 심플하고 그립감이 좋으며 고급스러우며, 중봉과 살대는 최고급 전착도장 살대를 사용하여 녹이슬지 않음\n \n * 백화점 A/S 가능 / 백화점 교환,반품 불가",
    product_image_1:
      "https://products.naganorewards.com/KR/LOUIS_QUATORZE/UmbrellaBlack.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2097",
    brand: "LOUIS QUATORZE",
    sku: "LOFASDEKR0132",
    product_eng:
      "Department Store Model Luikatoz 58 Embossed Pattern 2 and 3 Tier Umbrella Set (Black)",
    product_jpn: "[백화점판매모델]루이까또즈 58엠보패턴 2, 3단우산세트(블랙)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "50,000",
    description_eng:
      "Stylish design with an embossed pattern, 2-tier umbrella set, 2/3 tier umbrella set\n\n[Product composition]\n> 58 Embossed pattern 2-stage semi-automatic umbrella, 58 Embossed pattern 3-stage manual umbrella\n[Product specifications]\n> Color: Black\n> case: genuine paper set case *ask separately for packaging\n> Specification (length of upper flesh and number of upper flesh: 3-stage 550mm*8K, 2-stage 58mm*8K\n> Fabric: 3 layers) 100% polyester / Sal: FRP+aluminum / Large: electrodeposition painting + aluminum\n2nd stage) 100% polyester / Skin: electrodeposition painting / Large: electrodeposition painting\n[Product Features]\n> 100% polyester Ponzi fabric waterproof (WP) and water repellent (WP) coating prevent rainwater from permeating and excellent gloss due to the use of the highest quality fabric\n> High-quality nickel-plated handle does not fade and is strong so it can be used for a long time\n> Simple, good grip and luxurious, and the medium rod and rod are rust-resistant by using the highest-quality electrodeposition coated rod\n\n* Warranty service at department store / No exchange or return at department store",
    description_jpn:
      "엠보패턴의 스타일리시한 디자인, 2단 우산 세트, 2/3단 우산 세트\n \n [제품구성]\n  > 58엠보패턴 2단 반자동우산, 58엠보패턴 3단 수동우산\n [제품사양]\n  > 색상: 블랙\n  > 케이스: 정품 종이 세트케이스 *포장지 포장 별도 문의\n  > 규격(윗살 길이 및 윗살의 수: 3단 550mm*8K, 2단 58mm*8K\n  > 원단: 3단) 폴리에스터 100% / 살 : FRP+알루미늄 / 대 : 전착도장+알루미늄\n  2단) 폴리에스터 100% / 살 : 전착도장 / 대 : 전착도장\n [제품특징]\n  > 폴리에스터 100% 폰지원단방수(WP), 발수(WP)코팅을 하여 빗물이 스며들지 않으며 최고급원단 사용으로 광택이 우수\n  > 고급니켈도금 손잡이로 색이 바래지 않으며, 튼튼하여 오래 사용할 수 있음 \n  > 심플하고 그립감이 좋으며 고급스러우며, 중봉과 살대는 최고급 전착도장 살대를 사용하여 녹이슬지 않음\n \n * 백화점 AS 가능 / 백화점 교환 및 반품 불가",
    product_image_1:
      "https://products.naganorewards.com/KR/LOUIS_QUATORZE/UmbrellaSetBlack.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2098",
    brand: "MICHELANGELO",
    sku: "MIKITGEKR0133",
    product_eng: "German Michelangelo IH Essen ST Stainless Steel Pot 3 types",
    product_jpn: "독일 미켈란젤로 IH 에센 ST 스텐냄비 3종",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "210,000",
    description_eng:
      "▶ Product composition - 18 cm single handle pot, 20 cm double handle pot, 24 cm hot pot\n▶ Luxurious and beautiful Essen's all-stainless pot ▶ induction and a variety of heat sources.\n▶ Luxurious with a European-style pot design and the latest trend, satin treatment\n▶ The bottom stainless steel and aluminum are bonded in three layers by the brazing method, resulting in high thermal conductivity.\n▶ 5 mm Thick triple bottom: Stainless steel + aluminum + stainless steel\n▶ Pouring rim function: Corner part design to prevent it from flowing into the body when pouring soup from the pot. ▶Keep the balance of internal temperature and moisture appropriate when cooking through a smart steam hole.",
    description_jpn:
      "▶상품구성 - 편수냄비18cm, 양수냄비20cm, 전골냄비24cm\n▶ 고급 스럽고 아름다운 Essen의 올 스텐냄비 ▶ 인덕션 및 다양한 열원에서 사용이 가능한 제품.\n▶ 유럽풍 느낌의 냄비 디자인에 최신트렌드인 Satin(무광) 처리로 고급스러움\n▶ 브레이징 공법으로 바닥의 스테인리스와 알루미늄을 3중으로 접합하여 열전도율이 높음.\n▶ 5mm의 두꺼운 3중 바닥 : 스테인리스 스틸 + 알루미늄 + 스테인리스 스틸\n▶ 푸어링 림 기능 : 냄비에서 국물을 따를 때 몸체에 흐르지 않도록 모서리 부분 설계. ▶스마트한 스팀홀을 통해 요리시 내부온도 및 수분의 밸런스를 알맞게 유지.",
    product_image_1:
      "https://products.naganorewards.com/KR/MICHELANGELO/StainlessSteelPot.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2099",
    brand: "Novita",
    sku: "NOHOUNOKR0134",
    product_eng:
      "Novita Smart Plus Waterproof Bidet (including 1 filter)/ (self-installation, visit installation site 20,000 won)",
    product_jpn:
      "[노비타]스마트 플러스 방수비데 (필터1개포함)/ (자가설치,방문설치현장2만원)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "399,000",
    description_eng:
      "[Product characteristics]\n- Waterproof (IPX4) with Novita's own technology for daily waterproofing\n- Maximize convenience and comfort Ergonomic design\n- Continuous hot water heating - up to 38% power saving effect\n- Clean and hygienic FULL stainless steel nozzle: silver nanomaterials with antibacterial power of 99.9% or more\n- Novita Bidet's Hygienic Care System\n1. Natural mixed water is provided when washing with air bubbles\n2. Children's function\n3. Automatic cleaning function: It automatically dries at once\n4. Pleasure function: Strong cleaning water massages before defecation to induce defecation\n5. Automatic nozzle cleaning provides a hygienic use environment\n- Various Additional Features of Novita Bidet\n1. Ergonomic round design: Fish and water stain free design\n2. User-detected sensors\n3. Soft Gaffet to close smoothly\n- Size: (W)455 × (D)530 × (H)150 mm\n- Configuration: Main body, 1 filter, manual",
    description_jpn:
      "[상품특징]\n - 노비타만의 기술로 방수(IPX4)설계되어 생활방수 가능\n - 편리함과 편안함의 극대화 인체공학적 디자인\n - 연속온수 가열방식 - 최대 38%절전효과\n - 깨끗하고 위생적인 FULL 스테인리스노즐 : 99.9%이상의 향균력을 가진 은나노재질\n - 노비타 비데의 위생적인 케어 시스템\n   1. 자연혼입 방식의 공기방울로 세정시 더욱 혼입수류제공\n   2. 어린이 기능\n   3. 자동세정기능 : 자동으로 한번에 건조까지 \n   4. 쾌변기능 : 배변전 강력한 세정수가 마사지하여 배변유도\n   5. 자동 노즐세척으로 위생적인 사용환경 제공\n - 노비타 비데의 다양한 부가기능\n   1. 인체 공학적 라운드 디자인 : 물고임, 물얼룩 걱정없이 설계\n   2. 사용자 감지 센서 \n   3. 부드럽게 닫는 소프트 개페\n - 크기 : (W)455 X (D)530 X (H)150 mm\n - 구성 : 본체,필터1개,설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Novita/SmartPlusBidet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2100",
    brand: "Novita",
    sku: "NOHOUNOKR0135",
    product_eng:
      "Novita Spatherapy Waterproof Bidet (including 1 filter) / (self-installed, driver's visit site 20,000 won)",
    product_jpn:
      "[노비타] 스파테라피 방수비데 (필터1개포함) / (자가설치,기사방문현장2만원)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "319,000",
    description_eng:
      "[Product characteristics]\n- Popular Home Shopping Products\n- My own healing time, Novita Spatherapy Waterproof Bide\n- Various custom spa modes\n- Industry's first three different water streams\n- Ergonomic Design / Automatic Nozzle Cleaning Function\n- Water bottle-free direct water continuous hot water\n- Can be installed on various pottery\n- Pleasant drying function\n- It's a waterproof raincoat that can be cleaned with water\n- Size: 460 (width) × 526 (length) × 150 (height) mm\n- Configuration: Main body, 1 filter, manual",
    description_jpn:
      "[상품특징]\n - 홈쇼핑인기상품\n - 나만의힐링타임 노비타 스파테라피 방수비데\n - 다양한 맞춤 스파모드 \n - 업계최초 3가지 다양한 수류제공\n - 인체공학적 디자인 / 자동노즐세척기능\n - 물통없는 직수방식 연속온수\n - 다양한 도기에 설치가능\n - 쾌적한 건조기능\n - 물청소도 가능한 방수비데 \n - 크기 : 460(가로) × 526(세로) × 150(높이)mm\n - 구성 : 본체,필터1개,설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Novita/SpatherapyBidet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2101",
    brand: "Orthomol",
    sku: "ORHEAORKR0136",
    product_eng: "Orthomol for woman Vital F - Men's Multivitamin, 30-Day",
    product_jpn: "[오쏘몰] 포우먼 바이탈F(30일분)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "149,000",
    description_eng: "",
    description_jpn:
      "＊생동감 넘치는 여성을 위한 종합 건강기능식품\n＊영양성분의 특성을 반영한 제형 설계\n＊여성에게 더 필요한 특정 영양소 고함량 함유\n＊독일 마이스터 정신을 담은 건강기능식품\n＊원료 선정부터 제조까지 100% 독일 현지 생산",
    product_image_1:
      "https://products.naganorewards.com/KR/Orthomol/VitalF30Day.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2102",
    brand: "Orthomol",
    sku: "ORHEAORKR0137",
    product_eng: "Orthomol for woman Vital F - Men's Multivitamin, 7-Day",
    product_jpn: "[오쏘몰] 포우먼 바이탈F(7일분)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "44,000",
    description_eng: "",
    description_jpn:
      "＊생동감 넘치는 여성을 위한 종합 건강기능식품\n＊영양성분의 특성을 반영한 제형 설계\n＊여성에게 더 필요한 특정 영양소 고함량 함유\n＊독일 마이스터 정신을 담은 건강기능식품\n＊원료 선정부터 제조까지 100% 독일 현지 생산",
    product_image_1:
      "https://products.naganorewards.com/KR/Orthomol/VitalF7Day.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2103",
    brand: "Orthomol",
    sku: "ORHEAORKR0138",
    product_eng: "Orthomol for man Vital M - Men's Multivitamin, 30-Day",
    product_jpn: "[오쏘몰] 포맨 바이탈M(30일분)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "149,000",
    description_eng: "",
    description_jpn:
      "＊생동감 넘치는 남성을 위한 종합 건강기능식품\n＊영양성분의 특성을 반영한 제형 설계\n＊남성에게 더 필요한 특정 영양소 고함량 함유\n＊독일 마이스터 정신을 담은 건강기능식품\n＊원료 선정부터 제조까지 100% 독일 현지 생산",
    product_image_1:
      "https://products.naganorewards.com/KR/Orthomol/VitalM30Day.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2104",
    brand: "Orthomol",
    sku: "ORHEAORKR0139",
    product_eng: "Orthomol for man Vital M - Men's Multivitamin, 7-Day",
    product_jpn: "[오쏘몰] 포맨 바이탈M(7일분)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "44,000",
    description_eng: "",
    description_jpn:
      "＊생동감 넘치는 남성을 위한 종합 건강기능식품\n＊영양성분의 특성을 반영한 제형 설계\n＊남성에게 더 필요한 특정 영양소 고함량 함유\n＊독일 마이스터 정신을 담은 건강기능식품\n＊원료 선정부터 제조까지 100% 독일 현지 생산",
    product_image_1:
      "https://products.naganorewards.com/KR/Orthomol/VitalM7Day.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2105",
    brand: "Orthomol",
    sku: "ORHEAORKR0140",
    product_eng: "Orthomol IMMUN MULTI VITAMIN & MINERAL(30 DAYS)",
    product_jpn: "[동아제약] 오쏘몰 시그니처 종합비타민 이뮨 (30일분)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "129,000",
    description_eng:
      "*Orthomol Immun\n\nOrthomol Immun contains 25 important micronutrients in a combination of vitamins, phytonutrients and trace elements, and has been tried and trusted in medical practices for the past 30 years.\n\n\n\n*Vitamins, trace elements, phytonutrients\n\nOrthomol Immun is a food for special medical purposes. It is suitable for the dietary management of nutrition-related immune deficiencies (e.g. recurrent respiratory infections). Orthomol Immun contains important micronutrients for the immune system. The nutritional characteristics of vitamin C play a key role in the immune defences. For instance, some immunocompetent cells contain a vitamin C concentration that is about 10-100 times higher than the plasma levels.\n\nIn the interests of combatting doping, Orthomol Immun is included on the Kölner Liste® (Cologne List®) to achieve greater transparency and safety.\n\n\n\n*For the dietary management of...\n\nAs well as fulfilling your needs as our customers, we naturally also keep a close eye on the legal provisions in our industry. We adapt the claims for our dietary foods – Orthomol Immun, Orthomol arthroplus and Orthomol AMD extra – in line with the latest legal specifications.\n\nAnd this is where it gets more complicated, because these products are called foods for special medical purposes. Until recently, this category of products was governed by legislation such as EU Directive 1999/21/EC, which specifies how we as manufacturers must label the products: with the statement ‘For the dietary management of’, followed by the disease(s), disorder(s) or medical condition(s) for which the product is intended.",
    description_jpn:
      "＊영양성분의 특성을 반영한 제형 설계\n＊특정 필요 영양소 고함량 함유\n＊독일 마이스터 정신을 담은 건강기능식품\n＊원료 선정부터 제조까지 100% 독일 현지 생산",
    product_image_1:
      "https://products.naganorewards.com/KR/Orthomol/Immun30Day.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2106",
    brand: "Orthomol",
    sku: "ORHEAORKR0141",
    product_eng: "Orthomol IMMUN MULTI VITAMIN & MINERAL(7 DAYS)",
    product_jpn: "[동아제약] 오쏘몰 시그니처 종합비타민 이뮨 (7일분)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "38,000",
    description_eng:
      "*Orthomol Immun\n\nOrthomol Immun contains 25 important micronutrients in a combination of vitamins, phytonutrients and trace elements, and has been tried and trusted in medical practices for the past 30 years.\n\n\n\n*Vitamins, trace elements, phytonutrients\n\nOrthomol Immun is a food for special medical purposes. It is suitable for the dietary management of nutrition-related immune deficiencies (e.g. recurrent respiratory infections). Orthomol Immun contains important micronutrients for the immune system. The nutritional characteristics of vitamin C play a key role in the immune defences. For instance, some immunocompetent cells contain a vitamin C concentration that is about 10-100 times higher than the plasma levels.\n\nIn the interests of combatting doping, Orthomol Immun is included on the Kölner Liste® (Cologne List®) to achieve greater transparency and safety.\n\n\n\n*For the dietary management of...\n\nAs well as fulfilling your needs as our customers, we naturally also keep a close eye on the legal provisions in our industry. We adapt the claims for our dietary foods – Orthomol Immun, Orthomol arthroplus and Orthomol AMD extra – in line with the latest legal specifications.\n\nAnd this is where it gets more complicated, because these products are called foods for special medical purposes. Until recently, this category of products was governed by legislation such as EU Directive 1999/21/EC, which specifies how we as manufacturers must label the products: with the statement ‘For the dietary management of’, followed by the disease(s), disorder(s) or medical condition(s) for which the product is intended.",
    description_jpn:
      "＊영양성분의 특성을 반영한 제형 설계\n＊특정 필요 영양소 고함량 함유\n＊독일 마이스터 정신을 담은 건강기능식품\n＊원료 선정부터 제조까지 100% 독일 현지 생산",
    product_image_1:
      "https://products.naganorewards.com/KR/Orthomol/Immun7Day.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2107",
    brand: "PENSONIC",
    sku: "PEHOUPEKR0142",
    product_eng: "Pensonic Constellation Humidifier PSC-WA01",
    product_jpn: "[펜소닉] 별자리 가습기 PSC-WA01",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "99,000",
    description_eng:
      "[Product composition]\n> Product body, instruction manual, charging cable, extra filter 2pcs, film 2pcs\n[Product specifications]\n- Material: ABS, PP\n- Color: White\n- Power consumption: 4W - 4.5W\n- KC Electrical Safety Certification: XU101423-18002A\n[Product specification]\n> 202*122*119mm / 0.514kg\n[Product Features]\n- December 2021 Launch Idea Design Product\n- Constellations and sea creatures can be produced in various ways with two films\n- 'Moving LED' that automatically rotates constellation/sea biological film, effect of Milky Way/aura in the room\n- Rechargeable battery can be used for up to 4 hours, 2,000 mAh\n- Dual spray humidification function that is faithful to the basics to prevent dry weather colds\n- Enough humidification for sleep time with 90ml spray per hour in 1L capacity\"",
    description_jpn:
      '"[제품구성] \n> 제품 본체, 사용 설명서,  충전케이블, 여분 필터 2pcs, 필름 2pcs\n[제품사양]\n- 재질: ABS, PP 外\n- 색상: 화이트\n- 소비전력 : 4W - 4.5W\n- KC전기 안전인증 : XU101423-18002A\n[제품규격] \n> 202*122*119mm / 0.514kg\n[제품특징] \n- 2021년 12월 출시 아이디어 디자인 상품\n- 별자리, 바다 생물 두 가지 필름으로 다양한 프로젝터 방식 별자리 연출 가능\n- 별자리/바다생물 필름이 자동 회전 되는 ‘무빙 LED’로 방안에 은하수/오로라 효과 \n- 충전 배터리 사용시 최대 4시간 사용 가능, 2,000mAh\n- 건조한 날씨 감기 예방을 위한 기본에 충실한 듀얼 스프레이 가습 기능\n- 1L 용량에 시간당 90ml 스프레이로 수면 시간 동안 충분한 가습 기능"',
    product_image_1:
      "https://products.naganorewards.com/KR/PENSONIC/Humidifier.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2108",
    brand: "PENSONIC",
    sku: "PEHOUPEKR0143",
    product_eng:
      "Pensonic Bluetooth u15 grade air purifier/PDS-BZ01 produced in Korea",
    product_jpn: "[펜소닉] 국내생산 블루투스 u15등급 공기청정기/PDS-BZ01",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "128,000",
    description_eng:
      "[Product composition]\n> Product body, adapter, instruction manual, U15 grade filter\n[Product specifications]\n- Material: ABS back\n- Color: White\n- Power consumption: 125W\n- Adapter electromagnetic wave authentication: R-R-RY1-WT-AD1818A\n- Adapter Certification: HU10424-19016A\n- Electromagnetic wave authentication: R-C-Kek - KL-140\n[Product specification]\n> 170×170×300 mm / about 1.5k\n[Product Features]\n- Domestic Manufacturing Equipped with U15 Grade Top-rated Filter in Korea\n- Operating time adjustment (timer function): 4 hours / 8 hours / 12 hours\n- Bluetooth speaker function: Bluetooth connection with mobile device to perform speaker function\n- FM radio receiving function: FM output receiving\n- Automatic air volume control : Air volume control according to pollution level / Smart air check sensor\n- Actual available area approximately 16 m2\n- Small office space, office desk, kitchen, student room, bedroom, individual space cover\n- Modern white interior effect",
    description_jpn:
      "[제품구성] \n > 제품 본체, 아답터, 사용설명서, U15등급 필터\n [제품사양]\n - 재질: ABS 外\n - 색상: 화이트\n - 소비전력 : 125W\n - 어뎁터 전자파 인증 : R-R-RY1-WT-AD1818A\n - 어뎁터 인증 : HU10424-19016A\n - 전자파 인증 : R-C-Kek – KL-140\n [제품규격]\n > 170*170*300mm / 약 1.5k\n [제품특징] \n - 국내 제조, U15 등급 국내 출시 최고 등급 필터 장착\n - 작동 시간 조절 (타이머 기능) : 4시간 / 8시간 / 12시간 \n - 블루투스 스피커 기능 : 모바일 디바이스와 블루투스 연결하여 스피커 기능 수행\n - FM 라디오 수신 기능 : FM 출력 수신\n - 자동 풍량 조절 : 오염도에 따른 풍량 조절 / 스마트 공기 체크 센서\n - 실 가용 면적 약 16m2\n - 소규모 사무 공간, 사무실 책상 위, 주방, 학생 방, 침실, 개별 공간 커버\n - 모던한 화이트 색상으로 인테리어 효과",
    product_image_1:
      "https://products.naganorewards.com/KR/PENSONIC/BluetoothAirPurifier.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2109",
    brand: "PGATOUR",
    sku: "PGCOSPGKR0144",
    product_eng: "PGA TOUR Sunmon Lab Pitto Water Defense Spray 150 ml",
    product_jpn: "[PGA TOUR] 선몬랩 피토 워터 디펜스 스프레이 150ml",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "28,000",
    description_eng:
      "■ Effect: It does not dissolve easily in sweat and water, protecting the skin from ultraviolet rays.\n■ Raw material: bottle grass, ginkgo tree leaves, bamboo shoot bark\n■ Strong UV protection\n■ An untact line that doesn't get on your hand\n■ Contains our own Phytoscreen Complex\n■ Selection of PGA TOUR\n■ Forming a 'Water Defense Shield' that protects against water and sweat\n■ Cool down as soon as you spray it. Clear finish as if you didn't spray it\n■ Hoskale calp extract, kelp extract, and Tongtong body extract help moisture care, helping moisturize sweaty skin.\n■ Like body spray with aqua scent, the scent of the cool sea lasts a long time.",
    description_jpn:
      "■ 효과 : 땀과 물에 쉽게 녹지 않아 자외선으로 부터 피부를 보호해줍니다.\n■ 원재료 : 병풀, 은행나무잎,죽순껍질\n■ 강력한 자외선 차단\n■ 손에 묻지 않는 언택트 선\n■ 자사만의 Phytoscreen Complex 함유\n■ PGA TOUR의 선택\n■ 물과 땀을 방어하는 'Water Defense Shield' 형성\n■ 뿌리는 즉시 쿨링, 안 뿌린듯 투명한 마무리\n■ 호스케일캘프추출물, 다시마추출물, 퉁퉁바디추출물이 수분 케어에 도움을 주어, 땀 흘리고난 피부의 보습에 도움을 줍니다.\n■ 아쿠아향으로 바디 스프레이를 뿌린듯 시원한 바다의향이 오래 지속됩니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/PGATOUR/WaterDefenseSpray.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2110",
    brand: "PGATOUR",
    sku: "PGCOSPGKR0145",
    product_eng: "PGA TOUR Sunmon Lab Pro UV Balm",
    product_jpn: "[PGA TOUR] 선몬랩 프로 UV밤",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "30,000",
    description_eng:
      "■ Component: 1 main product\n■ Capacity and weight: 10 g / 0.35 oz.\n■ UV protection: PSF50+/PA++++\n\n■ Soft gliding sun stick that smooths and adheres smoothly to the skin\n■ The sebum adsorption powder helps control the sebum and provides a smooth finish without stickiness\n■ Add ingredients that moisturize and smooth the skin to give skin a skin care effect\n\n[How to use it]\n- In the last step of skincare, turn the dial at the bottom of the container to raise the contents for about 5mm, and apply it lightly from the inside of the face to the outside.\n- Apply sushi over all areas (face, body) that need to be blocked from ultraviolet rays while carrying around.",
    description_jpn:
      "■ 구성품 : 본품1개\n■ 용량 및 중량 : 10g / 0.35oz.\n■ 자외선 차단 : PSF50+ / PA++++\n\n■ 피부결을 매끈하게 정돈해주고 부드럽게 밀착되는 소프트 글라이딩 선스틱\n■ 피지흡착 파우더로 세범 컨트롤 효과에 도움을 주고 끈적임 없이 보송한 마무리감 선사\n■ 피부를 촉촉하고 매끈하게 관리해주는 성분을더해 피부의 스킨 케어 효과 부여\n\n[사용법]\n- 스킨케어 마지막 단계에서 용기 하단의 다이얼을 돌려 5mm정도 내용물을 올린 후 얼굴 안쪽에서 바깥쪽으로 가볍게 발라 줍니다.\n- 휴대하면서 자외산 차단이 필요한 모든 부위 (얼굴,바디)에 스시로 덧발라 줍니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/PGATOUR/UVBalm.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2111",
    brand: "PGATOUR",
    sku: "PGCOSPGKR0146",
    product_eng: "PGA TOUR Sunmon Wrap Warm Up Cream 50 ml",
    product_jpn: "[PGA TOUR] 선몬랩 워밍 업 크림 50ml",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,900",
    description_eng:
      "□ Option: Single item\n■ Package Size: 4.1x4.1x13.1 cm\n■ Component: 1 main product\n■ Capacity: 50 ml\n■ Type: Body-only skin flexible cream\n■ Expiration date: July 4, 25\n\n■ It revitalizes your tired body and quickly restores your body with a formulation that gives you warmth\n■ Energy boosting cream with relaxation and warm-up effect\n■ Moisturizing and calming effects\n■ It is lightly absorbed, non-stick, and moisturizes the skin.\n■ It helps increase skin flexibility before exercising.\n■ It can be used as a massage cream for the body.\n■ Roll it to the desired areas such as arms and legs to absorb it\n■ Be careful not to use it on your face and sensitive areas",
    description_jpn:
      "□ 옵션 : 단품\n■ 패키지 사이즈 : 4.1x4.1x13.1cm\n■ 구성품 : 본품1개\n■ 용량 : 50ml\n■ 종류 : 바디전용 피부 유연성 크림\n■ 유통기한 : 25년 7월 4일\n\n■ 지친 몸에 활력을 부여하고 온열감을 주는 제형으로 빠르게 몸을 회복시켜줌\n■ 긴장을 완화하고 웜업 효과를 통한 에너지 부스팅 크림\n■ 보습과 진정 효과\n■ 가볍게 흡수되어 끈적이지 않으며 피부를 촉촉하게 가꿔줍니다.\n■ 운동전 피부 유연성을 높이는데 도움을 줍니다.\n■ 바디용 마사지 크림으로 사용 가능합니다.\n■ 팔,다리 등 원하는 부위에 굴려가며 흡수 시켜 줍니다\n■ 얼굴과 예민한 부위에 사용하지 않도록 주의합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/PGATOUR/WarmUpCream.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2112",
    brand: "Philips",
    sku: "PHHOUPHKR0147",
    product_eng: "Philips 3000 Series Steam Iron DST3020/20",
    product_jpn: "[필립스] 3000시리즈 스팀 다리미 DST3020/20",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "109,000",
    description_eng:
      "• Up to 160g instantaneous steam boost\n• Up to 35g/min continuous steam for continuous performance\n• Quick heating to 2200W\n• smooth gliding ceramic plate\n• Drip-stop system prevents leakage\n• vertical steam for hanging cloth\n• Triple precision tips for optimal control and visibility\n• 300ml water tank that can be ironed at once\n• Calcium removal for long-lasting steam performance\nContinuous steam volume: 35g/min\nInstant Steam volume: 160g\nSteam preparation time: 35 seconds\nPower consumption: 2200 W\nSize: 121×143×29 mm\nLeakage prevention\nHot plate: ceramic\nCode length: 1.9 m\nWater tank capacity: 300 ml\nspecial note",
    description_jpn:
      "• 최대 160g의 순간 스팀 부스트\n• 지속적인 성능을 위한 최대 35g/min의 연속스팀\n• 2200W로 빠른 가열\n• 매끄러운 글라이딩 세라믹 열판\n• Drip-stop 시스템으로 누수 방지\n• 걸려있는 옷감을 위한 수직 스팀\n• 최적의 제어 및 가시성을 위한 3 중 정밀 팁\n• 한번에 다림질이 가능한 300ml 물탱크\n• 오래 지속되는 스팀 성능을 위한 석회질 제거\n연속 스팀량 : 35g/분\n순간 스팀량 : 160g\n스팀 준비 시간 : 35초\n소비전력 : 2200W\n사이즈 : 121x143x29mm\n누수방지\n열판 : 세라믹\n코드 길이 : 1.9m\n물탱크 용량 : 300ml\n특이사항",
    product_image_1:
      "https://products.naganorewards.com/KR/philips/SteamIron3000.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2113",
    brand: "Philips",
    sku: "PHKITPHKR0148",
    product_eng: "Philips Daily Collection Mini Blender HR2603/90",
    product_jpn: "[필립스] 데일리 콜렉션 미니블렌더 HR2603/90",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "79,000",
    description_eng:
      "• a smooth smooth smoothie that makes fast\n• Powerful 350W motor for smooth mixing\n• ice crushing\n• Two speed settings for fine mixing\n• Tumbler for convenient use on the go\n• Compact Design\n• Detachable blade for easy cleaning\n• Dishwasher Available Parts\n• Multi-hardening for grinding different materials\n• Number of speed settings: 2\n• Product Function: Dishwasher safe, non-slip\n• Body: Plastic\n• Power: 350W\n• RPM blender (max): 21080 - 28520 rpm\n• Container: 1 L (available capacity of 0.6 L)\n• Tumbler: 0.7 L (available capacity 0.6 L)\n• Multi-chopping: 150ml",
    description_jpn:
      "• 빠르게 만드는 부드러운 스무디\n• 부드러운 혼합을 위한 강력한 350W 모터\n• 얼음 분쇄\n• 미세 혼합을 위한 두 가지 속도 설정\n• 이동 중 편리한 사용을 위한 텀블러\n• 컴팩트 디자인\n• 간편한 세척을위한 분리형 칼날\n• 식기세척기 사용가능한 부품\n• 다양한 재료를 분쇄할 수 있는 멀티 다지기\n• 속도 설정 수: 2\n• 제품 기능: 식기세척기 사용가능, 미끄럼 방지\n• 본체: 플라스틱\n• 전력: 350W\n• RPM 블렌더(최대): 21080 - 28520rpm\n• 용기 : 1L (사용가능용량 0.6L)\n• 텀블러 : 0.7L (사용가능용량 0.6L)\n• 멀티 다지기: 150ml",
    product_image_1:
      "https://products.naganorewards.com/KR/philips/MiniBlender.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2114",
    brand: "Philips",
    sku: "PHHOUPHKR0149",
    product_eng: "Philips 1000 Series razor S1232/41",
    product_jpn: "[필립스] 1000 시리즈 면도기 S1232/41",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "119,000",
    description_eng:
      "• 27 self-polishing blades for consistent and clean shaving\n• 4D flex head that enables clean shaving along the contour of the face\n• Power-cut system designed for continuous clean shaving\n• Easy-to-clean one-touch open\n• Use it by wire or wirelessly\n• Level 1 battery indicator to keep the razor at its best\n• 40 minutes wireless shaving after 8 hours of charging\n• Ergonomic handle for convenient operation\n• Easy-to-clean IPX7 water resistance\n• Protective cap to keep shaving head clean when not shaving\n• trimming moustaches and sideburns\n\nShaving System: Power Cut System\nClose to face flexion: 4-way flex head\nDisplay: Level 1 battery indicator lamp\nDry: Dry shaving\nCleaning: One touch open, washable\nOperation: Use wired/wireless\nColor: Black Noir\nHandle: Ergonomic handle and grip, non-slip rubber handle\nBattery Type: Nickel Hydrogen\nOperating time: 40 minutes\nRecharge: 8 hours full charge\nAutomatic voltage: 100-240V",
    description_jpn:
      "• 일관되고 깔끔한 면도가 가능한 27개의 자가 연마날\n• 얼굴의 윤곽을 따라 깔끔한 면도를 가능하게 하는 4D 플렉스 헤드\n• 지속적인 깔끔한 면도를 위해 설계된 파워 컷 시스템\n• 세척이 간편한 원터치 오픈\n• 유선 또는 무선으로 사용하세요\n• 면도기를 최상의 상태로 유지하기 위한 1단계 배터리 표시등\n• 8시간 충전 후 40분 무선 면도 가능\n• 편리하게 조작할 수 있는 인체공학적 손잡이\n• 간편하게 세척 가능한 IPX7 방수 기능\n• 면도를 하지 않을 때 쉐이빙 헤드를 깨끗하게 유지해주는 보호 캡\n• 콧수염과 구레나룻까지 다듬기\n\n면도 시스템: 파워 컷 시스템\n얼굴 굴곡에 따라 밀착: 4방향 플렉스 헤드\n디스플레이: 1단계 배터리 표시등\n건식: 건식 면도\n세척: 원터치 오픈, 세척 가능\n작동: 유무선 사용\n색상: 블랙 느와르\n핸들: 인체공학적인 손잡이와 그립감, 미끄럼 방지 고무 손잡이\n배터리 유형: 니켈수소\n작동 시간: 40분\n충전: 8시간 완충\n자동 전압: 100-240V",
    product_image_1:
      "https://products.naganorewards.com/KR/philips/Razor1000.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2115",
    brand: "Philips",
    sku: "PHKITPHKR0150",
    product_eng: "Philips Compact air fryer 4.1L analog HD9200/90",
    product_jpn: "[필립스] 컴팩트 에어프라이어 4.1L 아날로그 HD9200/90",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "159,000",
    description_eng:
      "Design for everyday cooking\n• Adjustable time and temperature\n•12-in-1 cooking capabilities\n•Easy to use and clean NutriU app provides healthy eating ideas\n•Customized recipes to your liking\n•Delicious air fryer recipe for a healthy life\n•Easy Homemade. How to Make Fries Healthier\n•Fried dishes with up to 90% fat reduction\n•Over 10 years of experience in air fryers\n•Healthy fried dishes made with airstorm technology\n•Time and energy efficiency\n•Product specification (LxWxH): 360×264×295 mm\n• Weight: 4.5 kg\n•Pan (Liter*): 4.1 L\n• Capacity (number of persons): 4\n•Power consumption: 1400 W\n•Cord length: 0.8 m",
    description_jpn:
      "매일의 요리를 위한 설계\n•조절 가능한 시간 및 온도\n•12-in-1 조리 기능\n•간편한 사용 및 세척NutriU 앱은 건강한 식생활 아이디어를 제공\n•기호에 맞는 맞춤형 레시피\n•건강한 삶을 위한 맛있는 에어프라이어 레시피\n•쉬운 홈메이드.튀김을 더 건강하게 만드는 방법\n•최대 90%까지 지방을 줄인 튀김 요리\n•10년 이상 경력의 에어프라이어 전문가\n•에어스톰기술로 만드는 건강한 튀김 요리\n•시간 및 에너지 효율성\n•제품 규격(LxWxH): 360x264x295 mm\n•중량: 4.5 kg\n•팬(리터*): 4.1 L\n•용량(인원): 4\n•소비전력: 1400 W\n•코드 길이: 0.8 m",
    product_image_1:
      "https://products.naganorewards.com/KR/philips/AirFryer.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2116",
    brand: "Polaroid",
    sku: "POFASPOKR0151",
    product_eng: "Polaroid Mongle Ready Bag (Ivory)",
    product_jpn: "[폴라로이드] 몽글 레디백(아이보리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "38,900",
    description_eng:
      "■ 14-inch ready-back that can be used anywhere.\n■It has a three-dimensional design that can be used for various purposes such as camping, traveling, and picnics.\n■There are X-shaped fixing buckles on one side of the inside and detachable pockets and mesh pockets on the other, so it's good to store/organize a variety of items and don't let items flow down.\n■There is a fixed strap on the back of the ready bag, so it can be inserted into the carrier and used.\n■ External materials capable of light weight, excellent durability, and even waterproofing\n■This is a Mongle ready bag with details added.",
    description_jpn:
      "■어디에서나 활용 가능한 14인치 레디백.\n■몽글몽글한 입체적인 디자인으로 캠핑, 여행, 피크닉 등 다용도에 사용 가능합니다.\n■내부 한쪽은 X자 고정버클과 다른 한쪽은 분리형 포켓과 메쉬포켓이 있어 다양한 물건을 수납/정리하기 좋으며 물건이 흘러내리지 않습니다.\n■레디백 뒷면에는 고정스트랩이 있어 캐리어에 끼워서 사용 가능합니다.\n■가벼운 무게, 뛰어난 내구성, 생활방수까지 가능한 외부소재\n■디테일까지 더해진 몽글 레디백입니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Polaroid/ReadyBag.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2117",
    brand: "Polaroid",
    sku: "POFASPOKR0152",
    product_eng: "Polaroid Messenger convertible bag",
    product_jpn: "[폴라로이드] 메신져 컨버터블 백",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "95,000",
    description_eng:
      "■ Fabric: Outer Fabric-100% nylon / Lining-100% polyester\n■ Detachable shoulder strap\n■ Notebook storage\n■ Internal detachable slip pocket\n■Back hidden zipper pocket\n■Durable double webbing handle\n■Side slip pocket water bottle, umbrella storage space\n■ Size: 41 x 31 x 15 cm\n■ Safe storage with luxurious light reflection and daily waterproofing using high-quality nylon spark fabric\n■Storage of umbrellas, water bottles, etc. with left/right side pockets\n■ Easy to store documents with Velcro slip pockets on the back\n■Soft with high-density webbing, excellent durability using T-live\n■Composed of various storage slip pockets and zipper pockets\n■ Easy pocket on the back for easy and safe storage of cards and car keys, etc\n■ Excellent durability with battek treatment at the shoulder connection\n■Size to store 15-inch laptops and reinforce sponges on the bottom and outer surfaces",
    description_jpn:
      "■원단 : 겉감-나일론 100% / 안감-폴리에스테르 100%\n■탈 부착형 숄더 스트랩\n■노트북 수납가능\n■내부 분리형 슬립포켓\n■뒷면 히든 지퍼 포켓\n■내구성 좋은 이중 웨빙 손잡이\n■사이드 스립포켓 물병, 우산 수납공간\n■사이즈: 41 x 31 x 15cm\n■고급 나일론 스파크사 원단을 사용하여 고급스러운 빛반사와 생활방수로 안전한 수납\n■좌/우 사이드포켓으로 우산, 물병 등 수납\n■뒷면 벨크로 슬립포켓으로 서류 등 보관 용이\n■고급 고밀도 웨빙으로 부드러우며, T-rivet을 사용하여 우수한 내구성\n■내부 다양한 수납 슬립포켓과 지퍼 포켓으로 구성\n■뒷면 이지포켓으로 카드, 자동차키 등 쉽고 안전하게 수납\n■숄더 연결부위 바텍처리로 훌륭한 내구성\n■15인치 노트북 수납 가능한 사이즈로 바닥면과 외부 겉면에 스폰지 보강처리",
    product_image_1:
      "https://products.naganorewards.com/KR/Polaroid/ConvertibleBag.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2118",
    brand: "Polaroid",
    sku: "PODIGPOKR0153",
    product_eng: "Polaroid Go Instant Camera (Color: Black/Blue/Red/White)",
    product_jpn: "[폴라로이드] 고 즉석 카메라(Color: Black/Blue/Red/White)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "159,000",
    description_eng:
      "1. The Smallest and Smallest Instant Camera in the World\n2. Lightweight and simple operation, it can be used by men and women of all ages.\n- Autofocus, double exposure, and self-timer features are available.\n- Compatible Films: GO Films",
    description_jpn:
      "1. 세상에서 가장 작고 아담한 사이즈의 즉석 카메라\n2. 가벼운 무게와 간단한 작동법으로 남녀노소 사용 가능합니다.\n- 오토포커스, 이중노출, 셀프타이머 기능을 사용할 수 있습니다.\n- 호환 필름 : GO 필름\n\n크기 : 105 x 84 x 62mm / 재질: ABS, PC (30% recycled plastics)",
    product_image_1:
      "https://products.naganorewards.com/KR/Polaroid/InstantCameraGo.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2119",
    brand: "Polaroid",
    sku: "POFASPOKR0154",
    product_eng: "Polaroid Spread Carrier 20 Inches (White)",
    product_jpn: "[폴라로이드] 펄린 캐리어 20인치(화이트)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "189,000",
    description_eng:
      "■ It is 100% polycarbonate material that is resistant to shock absorption\n■ Installation of TSA LOCK locks\n■ Made of YKK triple zip, it is safe from theft because it cannot be opened easily.\nEquipped with a ■360-degree wide double wheel, it is soft and quiet.\n■The handle can be adjusted to four levels of height to suit the user's key.\n■ Waterproof function is added, so efficient storage is possible.",
    description_jpn:
      "■100% 폴리카보네이트 소재로 충격흡수에 강합니다\n■TSA LOCK 잠금장치 장착\n■YKK 3중지퍼로 제작되어 쉽게 열수없어 도난으로부터 안전합니다.\n■360도 광폭 더블휠을 장착하여, 부드럽고 조용합니다.\n■사용자 키에 맞게 4단계 높이로 핸들 조절이 가능합니다.\n■방수기능까지 더해져, 효율적인 수납이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Polaroid/Carrier20Inch.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2120",
    brand: "Polaroid",
    sku: "PODIGPOKR0155",
    product_eng:
      "Polaroid Now Instant Camera (Color: Black & White/Black/Blue/Red)",
    product_jpn:
      "[폴라로이드] 나우 즉석 카메라(Color: Black&White/Black/Blue/Red)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "199,000",
    description_eng:
      "1. Polaroid NOW can use the key features of the existing OneStep+ model without Bluetooth,\nThe improved internal structure allows you to print the output with clearer resolution.\n- You can use auto-focus, double exposure, and self-timer functions that fit the situation through double lens adjustment.\n- Compatible films: I-TYPE film, 600 film",
    description_jpn:
      "1. Polaroid NOW는 기존 OneStep+ 모델의 주요기능을 블루투스 없이도 사용가능하며, \n 개선된 내부 구조로 더 선명한 해상도를 갖춘 결과물을 출력물로 인쇄할 수 있습니다.\n - 2중 렌즈조절을 통한 상황에 맞는 오토포커스, 이중노출과 셀프타이머 기능을 사용 할 수 있습니다.\n - 호환 필름 : I-TYPE 필름, 600필름\n\n크기 : 150.2 x 112.2 x 94 mm / 재질: ABS, PC (40% recycled plastics)",
    product_image_1:
      "https://products.naganorewards.com/KR/Polaroid/InstantCameraNow.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2121",
    brand: "Polaroid",
    sku: "PODIGPOKR0156",
    product_eng:
      "Polaroid Now Plus Instant Camera (Color: Black/Forest green/White)",
    product_jpn:
      "[폴라로이드] 나우 플러스 즉석 카메라(Color: Black/Forest green/White)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "219,000",
    description_eng:
      "1. Polaroid Now, which allows you to shoot freely and in depth through Bluetooth+\n- Using Bluetooth, photos can be taken in a variety of ways, especially through manual mode,\nYou can take pictures of the style and color you want by adjusting the shutter speed, aperture, and brightness\nA variety of sophisticated modes are available.\n- Compatible films: I-TYPE film, 600 film",
    description_jpn:
      "1. 블루투스를 통해 자유롭고 심도있게 촬영을 할 수 있는 Polaroid Now+\n - 블루투스를 활용하여, 다양한 방식으로 사진을 촬영할 수 있으며 특히 매뉴얼 모드를 통하여, \n 셔터속도부터 조리개, 밝기까지 모두 조절하여 원하는 스타일, 색상의 사진을 촬영할 수 있고 \n 다양한 정교한 모드들을 사용할 수 있습니다.\n - 호환 필름 : I-TYPE 필름, 600필름\n\n크기 : 150.2 x 112.2 x 95.5 mm / 재질: ABS, PC (40% recycled plastics)",
    product_image_1:
      "https://products.naganorewards.com/KR/Polaroid/InstantCameraPlus.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2122",
    brand: "PUMA",
    sku: "PUFASPUKR0157",
    product_eng:
      "PUMA Men's Casual universal sportswear Lamb's Wool socks Set of 2 (Black+White)",
    product_jpn: "[퓨마] 남성 캐쥬얼 겸용 스포츠 중목양말 2족세트(블랙+화이트)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "12,500",
    description_eng:
      "It is knitted with high-quality cotton, so it feels soft and has excellent sweat absorption\nA set of mid-neck casual socks with the PUMA logo engraved on them to emphasize the brand\n\n[Product composition]\n> Men's black team and white team\n[Product specifications]\n> case size: 19×24×2.5 cm\n> Material: cotton, polyester, polyurethane\n[Product Features]\n> Using soft high quality cotton: Light and soft fit and excellent sweat absorption\n> Comfortable and sophisticated design: High elasticity using high-stretch base and highlighting the brand by engraving the PUMA logo\n> Ankle band to prevent falling down: Apply a high elastic band to prevent falling down, minimize stretching and deformation",
    description_jpn:
      '"고급 코마면으로 편직하여 느낌이 부드러우며 땀 흡수력이뛰어난 제품\n활동하기 좋은 캐쥬얼 양말로 PUMA 로고를 새겨 브랜드를 강조한 중목 캐쥬얼 양말 세트\n\n[제품구성]\n > 남성 블랙 1족, 화이트 1족\n[제품사양]\n > 케이스사이즈 : 19*24*2.5cm\n > 소재 : 면, 폴리에스터, 폴리우레탄\n[제품특징]\n > 부드러운 고품질 코튼 사용 : 가볍고 부드러운 착용감 및 우수한 땀 흡수력\n > 편안하면서 세련된 디자인 : 고신축원단을 사용하여 신축성이 뛰어나며, PUMA로고를 새겨 브랜드를 강조\n > 흘러내림을 방지하는 앵클밴드 : 고탄성 소재의 밴드를 적용하여 흘러내림을 방지하고, 늘어남과 변형 최소화"',
    product_image_1:
      "https://products.naganorewards.com/KR/PUMA/SportsSocksMen.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2123",
    brand: "PUMA",
    sku: "PUFASPUKR0158",
    product_eng:
      "Puma Women's Casual universal sportswear Lamb's Wool socks Set of 2 (Black+White)",
    product_jpn: "[퓨마] 여성 캐쥬얼 겸용 스포츠 중목양말 2족세트(블랙+화이트)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "12,500",
    description_eng:
      "It is knitted with high-quality cotton, so it feels soft and has excellent sweat absorption\nA set of mid-neck casual socks with the PUMA logo engraved on them to emphasize the brand\n\n[Product composition]\n> Women's black team, white team\n[Product specifications]\n> case size: 19×24×2.5 cm\n> Material: cotton, polyester, polyurethane\n[Product Features]\n> Using soft high quality cotton: Light and soft fit and excellent sweat absorption\n> Comfortable and sophisticated design: High elasticity using high-stretch base and highlighting the brand by engraving the PUMA logo\n> Ankle band to prevent falling down: Apply a high elastic band to prevent falling down, minimize stretching and deformation",
    description_jpn:
      '"고급 코마면으로 편직하여 느낌이 부드러우며 땀 흡수력이뛰어난 제품\n활동하기 좋은 캐쥬얼 양말로 PUMA 로고를 새겨 브랜드를 강조한 중목 캐쥬얼 양말 세트\n\n[제품구성]\n > 여성 블랙 1족, 화이트 1족\n[제품사양]\n > 케이스사이즈 : 19*24*2.5cm\n > 소재 : 면, 폴리에스터, 폴리우레탄\n[제품특징]\n > 부드러운 고품질 코튼 사용 : 가볍고 부드러운 착용감 및 우수한 땀 흡수력\n > 편안하면서 세련된 디자인 : 고신축원단을 사용하여 신축성이 뛰어나며, PUMA로고를 새겨 브랜드를 강조\n > 흘러내림을 방지하는 앵클밴드 : 고탄성 소재의 밴드를 적용하여 흘러내림을 방지하고, 늘어남과 변형 최소화"',
    product_image_1:
      "https://products.naganorewards.com/KR/PUMA/SportsSocksWomen.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2124",
    brand: "PURADAK",
    sku: "PUPROPUKR0159",
    product_eng: "Pura Dak Black Alio Pork Belly Sweet and Sour 500G",
    product_jpn: "[푸라닭] 블랙알리오순살강정 500G",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "10,900",
    description_eng:
      "Configuration: 500G\nExpiration Date: 2025-07-16\nStorage method: Freeze below -18 degrees\nExpiration date: Until the date of separate indication\n\nI only use boneless chicken\nSnacks, side dishes, and snacks are all popular\nHCCP Safety Certification",
    description_jpn:
      "구성 :  500G\n유통기한 : 2025-07-16\n보관 방법 : -18도 이하에서 냉동보관\n소비기한 : 별도 표시일까지\n\n닭다리 순살만 사용\n간식,반찬,안주 인기만점\nHCCP 안전 인증",
    product_image_1:
      "https://products.naganorewards.com/KR/PURADAK/PorkBelly500G.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2125",
    brand: "PURADAK",
    sku: "PUPROPUKR0160",
    product_eng: "Pura Dak Sweet and sour pork 500G",
    product_jpn: "[푸라닭] 달콤순살강정 500G",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "10,900",
    description_eng:
      "Configuration: 500G\nExpiration Date: 2025-04-14|\nStorage method: Freeze below -18 degrees\nExpiration date: Until the date of separate indication\n\nI only use boneless chicken\nSnacks, side dishes, and snacks are all popular\nHCCP Safety Certification",
    description_jpn:
      "구성 :  500G\n유통기한 : 2025-04-14|\n보관 방법 : -18도 이하에서 냉동보관\n소비기한 : 별도 표시일까지\n\n닭다리 순살만 사용\n간식,반찬,안주 인기만점\nHCCP 안전 인증",
    product_image_1:
      "https://products.naganorewards.com/KR/PURADAK/SweetPork500G.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2126",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0161",
    product_eng: "Roberta Ceramic Perfume Car Air freshener Refill 2P Set",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 리필 2P세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "12,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerRefill.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2127",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0162",
    product_eng:
      "Roberta Ceramic Perfume Air freshener for vehicle + refill 2P",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 본품+리필 2P",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "23,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nConfiguration: main body 1P, refill ceramic 11g x 2P, clip 2P (general 1P, long type 1P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 1P,리필 세라믹 11g x 2P,클립 2P(일반1P, 롱타입1P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2128",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0163",
    product_eng: "Roberta Aero Car Air freshener 60 ml Set of 2 NRB602",
    product_jpn: "[로베르타] 에어로 차량용 방향제 60ml 2종세트 NRB602",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "22,000",
    description_eng:
      "1. Venetian-inspired designs express freshness and passion\n2. It is an air freshener that can be used both for vehicles and indoors.\n3. Scent Description:\n1) Venetian red: a musk scent of romantic sweetness\n2) Citrus Blue: A cool ocean feel reminiscent of the blue waves and seas of the Mediterranean Sea\n3) Phtoncide Green: A deep, subtle scent of musk sandal, reminiscent of the forest\nConfiguration: 60 ml 2P + Gift Case\nFragrance composition: Venetian red, citrus blue",
    description_jpn:
      "1. 베네치아에서 영감을 얻은 디자인으로 싱그러움, 열정을 표현\n2. 차량용 및 실내용 모두 사용가능한 방향제 입니다.\n3. 향설명 : \n1) 베네치안레드: 로맨틱한 달콤함의 머스크향\n2) 시트러스블루: 지중해의 푸른파도와 바다를 연상시키는 시원한 바다느낌\n3) 프톤치드그린: 머스크 샌달의 깊고 은은한 잔향으로 숲속을 연상시키는 향\n구성 : 60ml 2P + 기프트케이스\n향구성 : 베네치안레드, 시트러스블루",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/AirFreshener60ml.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2129",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0164",
    product_eng: "Roberta Aero Car Air freshener 100 ml Set of 2 NRB1002",
    product_jpn: "[로베르타] 에어로 차량용 방향제 100ml 2종세트 NRB1002",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      "1. Venetian-inspired designs express freshness and passion\n2. It is an air freshener that can be used both for vehicles and indoors.\n3. Scent Description:\n1) Venetian red: a musk scent of romantic sweetness\n2) Citrus Blue: A cool ocean feel reminiscent of the blue waves and seas of the Mediterranean Sea\n3) Phtoncide Green: A deep, subtle scent of musk sandal, reminiscent of the forest\nConfiguration: 100 ml 2P + Gift Case\nFragrance composition: Venetian red, citrus blue",
    description_jpn:
      "1. 베네치아에서 영감을 얻은 디자인으로 싱그러움, 열정을 표현\n2. 차량용 및 실내용 모두 사용가능한 방향제 입니다.\n3. 향설명 : \n1) 베네치안레드: 로맨틱한 달콤함의 머스크향\n2) 시트러스블루: 지중해의 푸른파도와 바다를 연상시키는 시원한 바다느낌\n3) 프톤치드그린: 머스크 샌달의 깊고 은은한 잔향으로 숲속을 연상시키는 향\n구성 : 100ml 2P + 기프트케이스\n향구성 : 베네치안레드, 시트러스블루",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/AirFreshener100ml.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2130",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0165",
    product_eng: "Roberta Aero Car Chrome Air freshener Set of 2 NRB602",
    product_jpn: "[로베르타] 에어로 차량용 크롬 방향제 2종세트 NRB602",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      "1. Venetian-inspired designs express freshness and passion\n2. Chromium molding creates a luxurious atmosphere.\n3 Air fresheners that can be used both for vehicles and indoors.\n3. Scent Description:\n1) Venetian red: a musk scent of romantic sweetness\n2) Citrus Blue: A cool ocean feel reminiscent of the blue waves and seas of the Mediterranean Sea\n3) Phtoncide Green: A deep, subtle scent of musk sandal, reminiscent of the forest\nConfiguration: 60 ml 2P + Gift Case\nFragrance composition: Venetian red, citrus blue",
    description_jpn:
      "1. 베네치아에서 영감을 얻은 디자인으로 싱그러움, 열정을 표현\n2. 크롬 몰딩이 고급스러운 분위기를 연출해 줍니다.\n3 차량용 및 실내용 모두 사용가능한 방향제 입니다.\n3. 향설명 : \n1) 베네치안레드: 로맨틱한 달콤함의 머스크향\n2) 시트러스블루: 지중해의 푸른파도와 바다를 연상시키는 시원한 바다느낌\n3) 프톤치드그린: 머스크 샌달의 깊고 은은한 잔향으로 숲속을 연상시키는 향\n구성 : 60ml 2P + 기프트케이스\n향구성 : 베네치안레드, 시트러스블루",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/ChromeAirFreshener.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2131",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0166",
    product_eng:
      "Roberta Two-piece clip type air freshener set for Aero Vehicle",
    product_jpn: "[로베르타] 에어로 차량용 클립형 방향제 2종세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      "1. Its modern and slim design exudes fragrance with the wind of the vehicle's air outlet and makes you feel clear and refreshed when driving.\n2. Designed by world-renowned fashion designer Juliana Camerono, it is elegant and luxurious with a prestigious chrome metal container.\n3. Scent Description:\n1) Sweet Rose: It is a luxurious scent that feels warm and calm as if dawn is brightening, creates an arduous atmosphere, and combines sweet rose scent with orange blossom to create a unique feeling and a smooth finish.\n2) It is a scent that gives a cool and refreshing image by using lime, basil, and rosemary, and you can feel like you are in the middle of a cool sea in the hot summer. It is a scent steered with aroma effects in mind as well as a scent that embodies the image of the blue sea with waves.\n3) Little Forest: It offers a refreshing and fresh scent like the dew of a spring morning, and it is a scent that expresses an innocent, refreshing, subtle, fresh, and luscious scent.\nComposition: 7 ml fragrance bottle, chrome lid, clip + gift case",
    description_jpn:
      "1. 모던하고 슬림한 디자인으로 차량용 송풍구의 바람으로 향기를 뿜어내며 운전시 기분을 맑고 상쾌하게 만들어 줍니다.\n2. 세계적인 패션디자이너 줄리아나 까메리노가 디자인한 세련된 디자인으로 우아하며, 프레스티지한 크롬 메탈용기로 제작되어 고급스럽습니다. \n3. 향설명 : \n1) 스위트로즈 : 여명이 밝아오는듯한, 따뜻하면서 차분한 느낌이 전해지며, 애로틱한 분위기를 연출하며 달콤한 장미향과 오렌지 블러썸이 조화를 이루어 유니크한 느낌과 부드럽게 마무리 되는 고급스러운 향입니다.\n2) 라임, 바질, 로즈마리 등을 사용하여 시원하면서도 상쾌한 이미지를 부여한 향으로서, 무더운 여름에 시원한 바다의 가운데 있는듯한 착각을 느낄수 있습니다. 파도가 일렁이는 푸른바다의 이미지를 형상화한 향뿐아니라 아로마 효과를 염두에 두고 조향한 향입니다.\n3) 리틀포레스트 : 봄날같은 아침의 이슬과같은 싱그럽고 신선한 향취를 선사하고 있으며 청순하면서 상쾌한, 또한 은은하고 산뜻하면서 감미로운 향취를 표현한 향입니다.\n구성 : 향료병 7ml, 크롬뚜껑, 클립 + 기프트케이스",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/ClipFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2132",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0167",
    product_eng:
      "Roberta Ceramic Perfume Air freshener for vehicle 2P+refill 4P",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 2P+리필4P",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "46,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nComposition: Body 2P, Refill Ceramic 11g x 4P, Clip 4P (General 2P, Long Type 2P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 2P, 리필 세라믹 11g x 4P,클립 4P(일반2P, 롱타입2P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2133",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0168",
    product_eng: "Roberta Aero Perfume Diffuser 120 ml Set of 2 NPD1202",
    product_jpn: "[로베르타] 에어로 퍼퓸 디퓨져 120ml 2종세트 NPD1202",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "31,000",
    description_eng:
      "1. It is a safe and healthy product made with imported natural fragrances that are free of harmful substances.\n(Various Certification Tested Products)\n2. It contains beautiful Italian sensibilities that can be used anywhere other than bedrooms, study rooms, living rooms, bathrooms and dressing rooms.\n3. Scent Description\n1) Rose Garden: It's a romantic pinnacle with a blend of fragrant flowers, a warmth of beautiful, soft cotton wool, and an exquisite blend of furorals.\n2) Monaco Blue: It expresses the rich feeling of fresh nature and emphasizes the rich feeling of everyone's favorite furoral scent and fresh wind, and it is a luxurious scent that finishes off the subtle fruit scent.\n3) Pine tree: It symbolizes the dignity of the noble French aristocrat who expressed high-quality green furorals and vividly expresses the fascinating image of Cleopatra with long straight hair, embodies the flower rain of white petals flying over the blue grass, giving a romantic and bright feeling.\nComposition: 120 ml, stick 4P, gift case x 2 types",
    description_jpn:
      "1. 유해물질이 없는 수입 천연향료로 제작되어 안전하고 건강한 제품입니다.\n(각종 인증 테스트 완료 제품)\n2. 침실, 서재, 거실, 욕실, 드레스룸 외에 어디서나 사용할수 있는 미려한 이탈리안 감성을 담은 제품입니다.\n3. 향 설명\n1) 로즈가든 : 향기로운 꽃들의 조화로움과 아름답고 부드러운 목화솜의 따뜻함을 느낄수 있으며 후로랄이 절묘한 조화를 이루는 로맨틱한 꽂향이 입니다.\n2) 모나코블루 : 프래쉬한 자연의 풍성한 느낌을 표한하였고 누구나 좋아하는 후로랄계열의 향기와 싱그러운 바람의 풍성한 느낌을 강조해주며, 은은한 과일 향기가 마무리되는 고급스러운 향입니다.\n3) 파인트리 : 고품격 그린 후로랄을 표현한 고귀한 프랑스 귀족의 품위를 상징하고 있으며 긴 생머리를 휘날리는 매혹적인 클레오파트라의 이미지를 싱싱하게 표현, 푸른 초원위에서 흩날리는 하얀 꽃잎의 꽃비를 형상화, 로맨틱하고 화사한 느낌을 선사하는 향입니다.\n구성 : 본품 120ml, 스틱 4P, 기프트케이스 x 2종",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeDiffuser120ml.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2134",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0169",
    product_eng: "Roberta Aero Car Chrome Air freshener Set of 3 NRBG603",
    product_jpn: "[로베르타] 에어로 차량용 크롬 방향제 3종세트  NRBG603",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "31,000",
    description_eng:
      "1. Venetian-inspired designs express freshness and passion\n2. It is an air freshener that can be used both for vehicles and indoors.\n3. Scent Description:\n1) Venetian red: a musk scent of romantic sweetness\n2) Citrus Blue: A cool ocean feel reminiscent of the blue waves and seas of the Mediterranean Sea\n3) Phtoncide Green: A deep, subtle scent of musk sandal, reminiscent of the forest\nConfiguration: 60 ml 3P + Gift Case\nFlavor compositions: Venetian red, citrus blue, phytoncide green",
    description_jpn:
      "1. 베네치아에서 영감을 얻은 디자인으로 싱그러움, 열정을 표현\n2. 차량용 및 실내용 모두 사용가능한 방향제 입니다.\n3. 향설명 : \n1) 베네치안레드: 로맨틱한 달콤함의 머스크향\n2) 시트러스블루: 지중해의 푸른파도와 바다를 연상시키는 시원한 바다느낌\n3) 프톤치드그린: 머스크 샌달의 깊고 은은한 잔향으로 숲속을 연상시키는 향\n구성 : 60ml 3P + 기프트케이스\n향구성 : 베네치안레드, 시트러스블루, 피톤치드그린",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/ChromeFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2135",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0170",
    product_eng:
      "Roberta Three-piece clip type air freshener set for AeroVehicle NCLRBG703",
    product_jpn: "[로베르타] 에어로 차량용 클립형 방향제 3종세트 NCLRBG703",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "35,000",
    description_eng:
      "1. Its modern and slim design exudes fragrance with the wind of the vehicle's air outlet and makes you feel clear and refreshed when driving.\n2. Designed by world-renowned fashion designer Juliana Camerono, it is elegant and luxurious with a prestigious chrome metal container.\n3. Scent Description:\n1) Sweet Rose: It is a luxurious scent that feels warm and calm as if dawn is brightening, creates an arduous atmosphere, and combines sweet rose scent with orange blossom to create a unique feeling and a smooth finish.\n2) Aquafresh: It is a scent that gives a cool yet refreshing image by using lime, basil, rosemary, etc., and you can feel like you are in the middle of a cool sea in the hot summer. It is a scent that is steered with an aroma effect in mind as well as a scent that embodies the image of the blue sea with waves.\n3) Little Forest: It offers a refreshing and fresh scent like the dew of a spring morning, and it is a scent that expresses an innocent, refreshing, subtle, fresh, and luscious scent.\nComposition: 7 ml fragrance bottle, chrome lid, clip + gift case\nFragrance composition: Sweet Rose, Aquafresh, Little Forest",
    description_jpn:
      "1. 모던하고 슬림한 디자인으로 차량용 송풍구의 바람으로 향기를 뿜어내며 운전시 기분을 맑고 상쾌하게 만들어 줍니다.\n2. 세계적인 패션디자이너 줄리아나 까메리노가 디자인한 세련된 디자인으로 우아하며, 프레스티지한 크롬 메탈용기로 제작되어 고급스럽습니다. \n3. 향설명 : \n1) 스위트로즈 : 여명이 밝아오는듯한, 따뜻하면서 차분한 느낌이 전해지며, 애로틱한 분위기를 연출하며 달콤한 장미향과 오렌지 블러썸이 조화를 이루어 유니크한 느낌과 부드럽게 마무리 되는 고급스러운 향입니다.\n2) 아쿠아프레쉬 : 라임, 바질, 로즈마리 등을 사용하여 시원하면서도 상쾌한 이미지를 부여한 향으로서, 무더운 여름에 시원한 바다의 가운데 있는듯한 착각을 느낄수 있습니다. 파도가 일렁이는 푸른바다의 이미지를 형상화한 향뿐아니라 아로마 효과를 염두에 두고 조향한 향입니다.\n3) 리틀포레스트 : 봄날같은 아침의 이슬과같은 싱그럽고 신선한 향취를 선사하고 있으며 청순하면서 상쾌한, 또한 은은하고 산뜻하면서 감미로운 향취를 표현한 향입니다.\n구성 : 향료병 7ml, 크롬뚜껑, 클립 + 기프트케이스\n향구성 : 스위트로즈, 아쿠아프레쉬, 리틀포레스트",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/ClipFreshenerSet3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2136",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0171",
    product_eng: "Roberta Aero Perfume Diffuser 120 ml Set of 3 NPDRBG1203",
    product_jpn: "[로베르타] 에어로 퍼퓸 디퓨져 120ml 3종세트 NPDRBG1203",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "44,000",
    description_eng:
      "1. It is a safe and healthy product made with imported natural fragrances that are free of harmful substances.\n(Various Certification Tested Products)\n2. It contains beautiful Italian sensibilities that can be used anywhere other than bedrooms, study rooms, living rooms, bathrooms and dressing rooms.\n3. Scent Description\n1) Rose Garden: It's a romantic pinnacle with a blend of fragrant flowers, a warmth of beautiful, soft cotton wool, and an exquisite blend of furorals.\n2) Monaco Blue: It expresses the rich feeling of fresh nature and emphasizes the rich feeling of everyone's favorite furoral scent and fresh wind, and it is a luxurious scent that finishes off the subtle fruit scent.\n3) Pine tree: It symbolizes the dignity of the noble French aristocrat who expressed high-quality green furorals and vividly expresses the fascinating image of Cleopatra with long straight hair, embodies the flower rain of white petals flying over the blue grass, giving a romantic and bright feeling.\nConfiguration: 120 ml 1P, Stick 4P, Gift Case x 3 Types",
    description_jpn:
      "1. 유해물질이 없는 수입 천연향료로 제작되어 안전하고 건강한 제품입니다.\n(각종 인증 테스트 완료 제품)\n2. 침실, 서재, 거실, 욕실, 드레스룸 외에 어디서나 사용할수 있는 미려한 이탈리안 감성을 담은 제품입니다.\n3. 향 설명\n1) 로즈가든 : 향기로운 꽃들의 조화로움과 아름답고 부드러운 목화솜의 따뜻함을 느낄수 있으며 후로랄이 절묘한 조화를 이루는 로맨틱한 꽂향이 입니다.\n2) 모나코블루 : 프래쉬한 자연의 풍성한 느낌을 표한하였고 누구나 좋아하는 후로랄계열의 향기와 싱그러운 바람의 풍성한 느낌을 강조해주며, 은은한 과일 향기가 마무리되는 고급스러운 향입니다.\n3) 파인트리 : 고품격 그린 후로랄을 표현한 고귀한 프랑스 귀족의 품위를 상징하고 있으며 긴 생머리를 휘날리는 매혹적인 클레오파트라의 이미지를 싱싱하게 표현, 푸른 초원위에서 흩날리는 하얀 꽃잎의 꽃비를 형상화, 로맨틱하고 화사한 느낌을 선사하는 향입니다.\n구성 : 본품 120ml 1P, 스틱 4P, 기프트케이스  x 3종",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeDiffuserSet3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2137",
    brand: "Samsonite",
    sku: "SAFASTEKR0172",
    product_eng: "Teacher Sonite RED CADIAZ Sling Bag BLACK DN109002",
    product_jpn: "[쌤소나이트RED] CADIAZ 슬링백 BLACK DN109002",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "128,000",
    description_eng:
      "▷ Teacher Sonite RED sling bag *Color: Black ▷ Material: 100% polyester ▷ Size: 17.5×5.5×27 cm ▷ Sold in department stores",
    description_jpn:
      "▷ 쌤소나이트RED 슬링백                                    *색상: 블랙                                                          ▷ 재질: 100% 폴리에스테르                                ▷ 사이즈: 17.5*5.5*27cm                                         ▷ 백화점 판매상품",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/SlingBag.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2138",
    brand: "Samsonite",
    sku: "SAFASTEKR0173",
    product_eng: "Teacher Sonite RED JinTS Backpack_ HV609001",
    product_jpn: "[쌤소나이트 RED]  JINTS    백팩 _ HV609001",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "199,000",
    description_eng:
      "▷ Teacher Sonite RED Backpack JINTS Backpack BLACK HV609001\n▷ Color: black\n▷ Material: 100% Polyester\n▷ Size: 30×12×45.5 cm (notebook 15.6 in.)\n▷ Trendy business casual backpack with sporty details\n▷ Smart sleeve and various pockets for convenience in storage\n▷ Power Zipper Pocket - Side Pocket\n▷ Department Store Sales Products",
    description_jpn:
      "▷ 쌤소나이트RED 백팩   JINTS 백팩 BLACK    HV609001\n▷ 색상: black                              \n▷재질: 100% Polyester\n▷사이즈: 30*12*45.5cm (노트북 15.6인치)  \n▷스포티한 디테일이 가미된 트렌디한 스타일의 비즈니스 캐주얼 백팩\n▷ 스마트슬리브 및 다양한 포켓으로 수납편리\n▷ 전폄지퍼포켓 –사이드포켓\n▷백화점 판매상품",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/JinTSBackpack.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2139",
    brand: "Samsonite",
    sku: "SAFASTEKR0174",
    product_eng: "Teacher Sonite RED Slocan Backpack - Q1409001",
    product_jpn: "[쌤소나이트 RED]  슬로칸   백팩 _ Q1409001",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "199,000",
    description_eng:
      "▷ Teacher Sonite RED Backpack Slocan Backpack BLACK\n▷ Color: black\n▷ Material: 80% Polyester + 20% PU\n▷ Size: 30×12×45.5 cm (notebook 15.6 in.)\n▷ Power Zipper Pocket - Side Pocket\n▷ products sold at department stores\n▷ As the headquarters of Samseongnite and Samseongnite department store AS",
    description_jpn:
      "▷ 쌤소나이트RED 백팩   슬로칸 백팩 BLACK \n▷ 색상: black                               \n▷ 재질:  80% Polyester  + 20% PU\n▷ 사이즈: 30*12*45.5cm (노트북 15.6인치)  \n▷ 전폄지퍼포켓 –사이드포켓\n▷ 백화점 판매상품\n▷ 쌤소나이트 본사 및 쌤소나이트 백화점매장 AS",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/SlocanBackpack.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2140",
    brand: "Samsonite",
    sku: "SAFASTEKR0175",
    product_eng:
      "Team Sonite Camilliant WAIKI SPINNER 66 TSA 24 Inch Cargo Carrier",
    product_jpn:
      "[쌤소나이트] 카밀리안트 WAIKIKI SPINNER 66 TSA  24인치 화물용 캐리어",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "249,000",
    description_eng:
      "■ Product Features\n▷ Manufacturer: Samsonite\n▷ Material: HS ABS\n▷ 색상: DARK GREY / NAVY / PETRBLUE\n▷ Size (width×width×height (cm) / including wheel): 24 inches (45×28×66 cm) / 3.8 kg for 24 inches of cargo\n\n▶ Install the TSA lock, which is essential for traveling to North America\n\n▶ Stable handling of the main body using 360-degree urethane rotating wheels that are very fluid\n\n▶ Unique and three-dimensional design with exterior molding decorated with unique textures and patterns\n\n▶ Handle stick that can be operated to suit the user's body shape",
    description_jpn:
      "■ 제품 특징\n▷ 제조사:  샘소나이트\n▷ 재질:  HS ABS\n▷ 색상: DARK GREY / NAVY / PETRBLUE\n▷ 사이즈(가로*폭*높이(cm)/바퀴포함): 24인치(45*28*66cm) /3.8kg  24인치화물용\n\n▶북미 여행시 꼭 필요한  TSA 잠금장치  설치 \n\n▶유동성이 매우 좋은 360도 우레탄 회전바퀵의 사용으로 본체의 안정적인 핸들링\n\n▶유니크한 질감과 무늬로 장식된 외부몰딩으로 독특하고 입체적인 디자인\n\n▶사용자의 체형에 맞게 조작가능한 핸들스틱",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/Spinner66Carrier.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2141",
    brand: "Samsonite",
    sku: "SAFASTEKR0176",
    product_eng:
      "Team Sonite Camilliant WAIKI SPINNER 75 TSA 28 inches extra large cargo carrier",
    product_jpn:
      "[쌤소나이트] 카밀리안트 WAIKIKI SPINNER 75 TSA      28인치 특대화물용캐리어",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "299,000",
    description_eng:
      "■ Product Features\n▷ Manufacturer: Samsonite\n▷ Material: HS ABS\n▷ Colors: Navy, Black\n▷ Size (width×width×height (cm) / wheel included): 28 inches (55×32×75 cm) / 4.6 kg 28 inches freight carrier\n\n▶ Install the TSA lock, which is essential for traveling to North America\n\n▶ Stable handling of the main body using 360-degree urethane rotating wheels that are very fluid\n\n▶ Unique and three-dimensional design with exterior molding decorated with unique textures and patterns\n\n▶ Handle stick that can be operated to suit the user's body shape",
    description_jpn:
      "■ 제품 특징\n▷ 제조사:  샘소나이트\n▷ 재질:  HS ABS\n▷ 색상: 네이비,블랙\n▷ 사이즈(가로*폭*높이(cm)/바퀴포함): 28인치(55*32*75cm) /4.6kg   28인치 화물용캐리어\n\n▶북미 여행시 꼭 필요한  TSA 잠금장치  설치 \n\n▶유동성이 매우 좋은 360도 우레탄 회전바퀵의 사용으로 본체의 안정적인 핸들링\n\n▶유니크한 질감과 무늬로 장식된 외부몰딩으로 독특하고 입체적인 디자인\n\n▶사용자의 체형에 맞게 조작가능한 핸들스틱",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/Spinner75Carrier.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2142",
    brand: "Samsonite",
    sku: "SAFASTEKR0177",
    product_eng: "Teacher Sonite LAMIAL briefcase QT209001",
    product_jpn: "[쌤소나이트] LAMIAL 서류가방 QT209001",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "299,000",
    description_eng:
      "▷ Manufacturer: Samsonite\n▷ Material: 70% Polyester + 30% PU\n▷ Color: Black\n▷ Size: 40*10 × 29 cm ▷ Neat business briefcase ▷ Launched in May 2023",
    description_jpn:
      "▷ 제조사:  샘소나이트\n▷ 재질:  70% Polyester  + 30% PU\n▷ 색상:   블랙\n▷ 사이즈 : 40* 10 * 29cm                                            ▷깔끔한 비즈니스 서류가방                                               ▷2023년 05월 출시",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/Briefcase.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2143",
    brand: "Samsonite",
    sku: "SAFASTEKR0178",
    product_eng: "Teacher Sonite RED DOMANN Backpack Black_QK409001",
    product_jpn: "[쌤소나이트 RED] DOMANN 백팩   black _QK409001",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "219,000",
    description_eng:
      "▷ Teacher Sonite RED backpack\n▷ Color: black\n▷ Material: 100% Polyester\n▷ Size: 32×9×45 cm (notebook 15.6 in.)\n▷ Hold extension\n▷ products sold at department stores\n▷ As the headquarters of Samseongnite and Samseongnite department store AS",
    description_jpn:
      "▷ 쌤소나이트RED 백팩             \n▷  색상: black                               \n▷ 재질:  100% Polyester \n▷ 사이즈: 32*9*45cm (노트북 15.6인치)  \n▷ 확장기능보유\n▷ 백화점 판매상품\n▷ 쌤소나이트 본사 및 쌤소나이트 백화점매장 AS",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/DomannBackpack.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2144",
    brand: "Samsonite",
    sku: "SAFASTEKR0179",
    product_eng: "Team Sonite RED DOMANN Backpack Black/Orange_QK419001",
    product_jpn: "[쌤소나이트 RED] DOMANN 백팩   Black/Orange_QK419001",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "219,000",
    description_eng:
      "▷ Teacher Sonite RED backpack\n▷ colors: Black/Orange\n▷ Material: 100% Polyester\n▷ Size: 32×9×45 cm (notebook 15.6 in.)\n▷ Hold extension\n▷ products sold at department stores\n▷ As the headquarters of Samseongnite and Samseongnite department store AS",
    description_jpn:
      "▷ 쌤소나이트RED 백팩             \n▷  색상: Black/Orange                      \n▷ 재질:  100% Polyester \n▷ 사이즈: 32*9*45cm (노트북 15.6인치)   \n▷ 확장기능보유\n▷ 백화점 판매상품\n▷ 쌤소나이트 본사 및 쌤소나이트 백화점매장 AS",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/DomannBackpackOrange.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2145",
    brand: "Samsonite",
    sku: "SAFASTEKR0180",
    product_eng: "Team Sonite RED DOMANN Backpack Black/Tan_QK43991",
    product_jpn: "[쌤소나이트 RED] DOMANN 백팩   Black/Tan_QK439001",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "219,000",
    description_eng:
      "▷ Teacher Sonite RED backpack\n▷ colors:Black/Tan\n▷ Material: 100% Polyester\n▷ Size: 32×9×45 cm (notebook 15.6 in.)\n▷ Hold extension\n▷ products sold at department stores\n▷ As the headquarters of Samseongnite and Samseongnite department store AS",
    description_jpn:
      "▷ 쌤소나이트RED 백팩             \n▷  색상:Black/Tan                            \n▷ 재질: 100% Polyester \n▷ 사이즈: 32*9*45cm (노트북 15.6인치) \n▷ 확장기능보유\n▷ 백화점 판매상품\n▷ 쌤소나이트 본사 및 쌤소나이트 백화점매장 AS",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/DomannBackpackTan.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2146",
    brand: "Samsonite",
    sku: "SAFASTEKR0181",
    product_eng: "Teacher Sonite CEDRIC Backpack_QT409001",
    product_jpn: "[쌤소나이트] CEDRIC 백팩  _QT409001",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "299,000",
    description_eng:
      "▷ Teacher Sonite backpack\n▷ color:Black\n▷ Material: 100% PU\n▷ Size: 31×12×40 cm (notebook 15.6 in.)\n▷ May 2023 New Product\n▷ products sold at department stores\n▷ As the headquarters of Samseongnite and Samseongnite department store AS",
    description_jpn:
      "▷ 쌤소나이트 백팩             \n▷  색상:Black                        \n▷ 재질: 100% PU\n▷ 사이즈: 31*12*40cm (노트북 15.6인치)\n▷ 2023년 05월 신상품\n▷ 백화점 판매상품\n▷ 쌤소나이트 본사 및 쌤소나이트 백화점매장 AS",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/CedricBackpack.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2147",
    brand: "Samsonite",
    sku: "SAFASTEKR0182",
    product_eng: "Teacher Sonite RED HOLTE Backpack Black_HT209001",
    product_jpn: "[쌤소나이트RED] HOLTE 백팩 블랙_HT209001",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "348,000",
    description_eng:
      "▷ Teacher Sonite RED Premium Backpack\n▷ Manufacturer: Teacher Sonite\n▷ Color: Black\n▷ 재질: 60% NYLON+20%SPLIT+20%PU\n▷ Size: 31.5×12×44.5 cm (15.6 in. of laptop)\n▷ products sold at department stores\n▷ Lightweight with nylon material, securing various storage spaces\n▷ SamSonite headquarters and department store SamSonite store AS",
    description_jpn:
      "▷ 쌤소나이트RED  프리미엄  백팩 \n▷ 제조사 : 쌤소나이트                                                                                                       \n▷ 색상: 블랙                                                                                                              \n▷ 재질: 60% NYLON+20%SPLIT+20%PU                                                                \n▷  사이즈: 31.5*12*44.5cm (노트북 15.6인치)                                                                        \n▷ 백화점 판매상품\n▷  나이론 재질로 가볍고, 각종 수납공간 확보\n▷ 쌤소나이트 본사 및 백화점 쌤소나이트 매장 AS",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/HolteBackpack.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2148",
    brand: "Samsonite",
    sku: "SAFASTEKR0183",
    product_eng: "Team Sonite AZIO SPINNER 55/20 EXP 20 Inch Carrier",
    product_jpn: "[쌤소나이트] AZIO SPINNER 55/20 EXP 20인치 기내용 캐리어",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "398,000",
    description_eng:
      "▷ Manufacturer: Samsonite ▷ Material: 100% PC ▷ Color: MATT BLACK, GLOSSY BUILDING ▷ Size: 20 inches (36×24×55 cm) /3.1 kg 20 inches Freight Carrier ▶ Extended function: Storage space expandable ▶ Using the Samsonite Heel system - Soft and stable driving with double wheels ▶ Embedded TSA lock (Must-have product for travel in the U.S.) ▶ Department store Samsonite store AS and Samsonite headquarters AS ▶ Anti-theft zipper",
    description_jpn:
      "▷ 제조사:  쌤소나이트                                         ▷ 재   질:  100% PC                                             ▷ 색   상:  MATT BLACK,GLOSSY BURGUNDY       ▷ 사이즈:  20인치(36*24*55cm) /3.1kg     20인치 화물용캐리어                                      ▶ 확장기능보유  : 수납공간 확장가능                   ▶ 쌤소나이트 흴 시스템 사용 - 더블휠로 부드럽고 안정적인 주행가능                                      ▶ 스타일리쉬한 로고바                                   ▶ 매립형 TSA 락 (미국여행 필수제품)                    ▶ 백화점 쌤소나이트 매장 AS 및 쌤소나이트 본사AS                                                           ▶ 도난방지 지퍼",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/Spinner55Carrier.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2149",
    brand: "Samsonite",
    sku: "SAFASSAKR0184",
    product_eng: "Samsonite AZIO SPINNER 69/25 EXP 25 inch cargo carrier",
    product_jpn: "[쌤소나이트] AZIO SPINNER 69/25 EXP 25인치 화물용 캐리어",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "448,000",
    description_eng:
      "▷ Manufacturer: Samsonite ▷ Material: 100% PC ▷ Color: MATT BLACK, GLOSSY BUILDING ▷ Size: 25 inches (49×29×69 cm) / 4.4 kg 25 inches Freight Carrier ▶ Expanded function: Storage space expandable ▶ Using the Samsonite Heel system - Smooth and stable driving with double wheels ▶ Embedded TSA lock ▶ Department store Samsonite store AS and Samsonite headquarters AS ▶ Anti-theft zipper",
    description_jpn:
      "▷ 제조사:  쌤소나이트                                         ▷ 재   질:  100% PC                                             ▷ 색   상:  MATT BLACK,GLOSSY BURGUNDY       ▷ 사이즈:  25인치(49*29*69cm) /4.4kg     25인치 화물용캐리어                                      ▶ 확장기능보유  : 수납공간 확장가능                   ▶ 쌤소나이트 흴 시스템 사용 - 더블휠로 부드럽고 안정적인 주행가능                                      ▶ 스타일리쉬한 로고바                                   ▶ 매립형 TSA 락 (미국여행 필수제품)                    ▶ 백화점 쌤소나이트 매장 AS 및 쌤소나이트 본사AS                                                           ▶ 도난방지 지퍼",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/Spinner69Carrier.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2150",
    brand: "Samsonite",
    sku: "SAFASTEKR0185",
    product_eng: "Team Sonite NIAR 78/29 Extra Large Cargo 29 Inch Carrier",
    product_jpn: "[쌤소나이트]  NIAR 78/29 특대화물용 29인치 캐리어",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "498,000",
    description_eng:
      "▷ Teacher Sonite RED backpack\n▷ colors:Black/Tan\n▷ Material: 100% Polyester\n▷ Size: 32×9×45 cm (notebook 15.6 in.)\n▷ Hold extension\n▷ products sold at department stores\n▷ As the headquarters of Samseongnite and Samseongnite department store AS",
    description_jpn:
      "▷ 제조사 :   샘소나이트\n▷ 재    질 :   100% 폴리카보네이트\n▷ 색    상 :    MATT GRAPHITE, MATT SILVER\n▷ 사이즈(가로*폭*높이(cm)/바퀴포함): 29인치(53*34*78cm) /4.85kg   29인치 특대화물용캐리어\n▶ 화강기능 보유 : 늘림기능을 적용하여 약 5cm 확장가능\n▶ 유동성이 매우 좋은 360도 우레탄 회전바퀵의 사용으로 본체의 안정적인 핸들링\n▶ 면세점 베스트 판매1위  제품\n▶ 매립형 TSA락\n▶사용자의 체형에 맞게 조작가능한 핸들스틱",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/NiarCarrier.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2151",
    brand: "Samsonite",
    sku: "SAFASSAKR0186",
    product_eng:
      "Samsonite AZIO SPINNER 75/28 EXP 28 inches extra large cargo carrier",
    product_jpn: "[쌤소나이트] AZIO SPINNER 75/28 EXP 28인치 특대화물용 캐리어",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "498,000",
    description_eng:
      "▷ Manufacturer: Samsonite ▷ Material: 100% PC ▷ Color: MATT BLACK, GLOSSY BURGUNDY ▷ Size: 28 inches (51×32×75 cm) / 4.9 kg 28 inches Freight Carrier ▶ Extension Function: Storage space expandable ▶ Using the Samsonite Heel system - Soft and stable with double wheels ▶ Embedded TSA lock ▶ Department store Samsonite store AS and Samsonite headquarters AS ▶ Anti-theft zipper",
    description_jpn:
      "▷ 제조사:  쌤소나이트                                         ▷ 재   질:  100% PC                                             ▷ 색   상:  MATT BLACK,GLOSSY BURGUNDY       ▷ 사이즈: 28인치(51*32*75cm) /4.9kg     28인치 화물용캐리어                                                 ▶ 확장기능보유  : 수납공간 확장가능                   ▶ 쌤소나이트 흴 시스템 사용 - 더블휠로 부드럽고 안정적인 주행가능                                      ▶ 스타일리쉬한 로고바                                   ▶ 매립형 TSA 락 (미국여행 필수제품)                    ▶ 백화점 쌤소나이트 매장 AS 및 쌤소나이트 본사AS                                                           ▶ 도난방지 지퍼",
    product_image_1:
      "https://products.naganorewards.com/KR/Samsonite/Spinner75CarrierEXP.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2152",
    brand: "SHINIL",
    sku: "SHHOUSHKR0187",
    product_eng: "SHINIL Shinil Handy Wireless Vacuum Cleaner SVC-840WK",
    product_jpn: "[SHINIL] 신일 핸디형 무선청소기 SVC-840WK",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "113,000",
    description_eng:
      "■Composition: Main body, dust collection container, dust collection filter, cradle, extension stick, 2 types of nozzles, adapter, instruction manual\n■ Easy to use without inconvenience of power cord\n■ Easy to clean the gap (gap suction port/extension pipe)\n■Recruitment of powerful and superior high-performance motors\n■ Use a semi-permanent dust collection filter\n■ Easy to store because of a charging cradle",
    description_jpn:
      "■구성 : 본체, 먼지수집통, 집진필터, 거치대, 연장스틱, 노즐2종, 어댑터, 사용설명서\n■전원코드의 불편함 없이 간편하게 사용\n■틈새청소 용이(틈새 흡입구/연장파이프)\n■강력하고 우수한 고성능 모터채용\n■반영구적 집진필터 사용\n■충전거치대가 있어 보관이 용이",
    product_image_1:
      "https://products.naganorewards.com/KR/SHINIL/HandyVacuum.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2153",
    brand: "SHINIL",
    sku: "SHHOUSHKR0188",
    product_eng:
      "SHINIL Shinil BLDC Wireless Sweep Vacuum Cleaner+Charge Cradle Set SVC-JS330WK",
    product_jpn:
      "[SHINIL] 신일 BLDC 무선 싹쓸이 진공 청소기+충전 거치대 세트 SVC-JS330WK",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "398,000",
    description_eng:
      "■Composition: main body, charging holder, 3 types of brushes, manual for use\n■With BLDC turbo motor\n■ From small grains to dog hair, strong suction\n■ Smart automatic AUTO function minimizes battery usage\n■3 types of multipurpose brushes can be used as needed\n■A total of three operational stages\n■72db low-noise decibels\n■Stick and touch-type behavior\n■HEPA H13 and Steel Mesh Filter",
    description_jpn:
      "■구성 : 본체, 충전거치대,브러쉬3종,사용설명서\n■BLDC 터보 모터 탑재\n■작은 알갱이부터 애견털 머리카락까지 강력한 흡입\n■스마트한 자동 AUTO 기능으로 배터리 사용시간 최소화\n■3가지의 다용도 브러쉬로 필요에 따라 사용 가능\n■총 3단계의 동작 단계\n■72db의 저소음 데시벨\n■스틱 및 터치형 동작 방식\n■HEPA H13과 강철 메쉬 필터",
    product_image_1:
      "https://products.naganorewards.com/KR/SHINIL/WirelessVacuum.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2154",
    brand: "Shinsegae Food",
    sku: "SHPROSHKR0189",
    product_eng:
      "Shinsegae Food Hotel Collection Korean Beef Beef Bone Samgyetang 2 packs + 3 types of roasted boneless chicken (garlic soy sauce 1 + Cheongyang spicy 1 + herb salt 1)",
    product_jpn:
      "[신세계푸드] 호텔컬렉션 한우사골 삼계탕 2봉+순살 닭다리구이 3종(마늘간장1+청양매콤1+허브솔트1)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "75,000",
    description_eng:
      "2 bags of Korean beef bone samgyetang + 3 types of roasted boneless chicken (garlic soy sauce 1 + Cheongyang spicy 1 + herb salt 1)",
    description_jpn:
      "한우사골 삼계탕 2봉+순살 닭다리구이 3종(마늘간장1+청양매콤1+허브솔트1",
    product_image_1:
      "https://products.naganorewards.com/KR/Shinsegae_Food/BeefBoneSamgyetangSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2155",
    brand: "Shinsegae Food",
    sku: "SHPROSHKR0190",
    product_eng:
      "Shinsegae Food Hotel Collection Hanwoo Beef Bone Samgyetang 2 bags + Essential Homandum 210g 3 kinds (Champpong 1 + Mara 1 + Salted Egg 1)",
    product_jpn:
      "[신세계푸드] 호텔컬렉션 한우사골 삼계탕 2봉+에센셜 호만두 210g 3종(짬뽕1+마라1+명란1)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "75,000",
    description_eng:
      "2 bags of Korean beef bone samgyetang + essential steamed dumplings 210g 3 kinds (jjamppong 1 + mala 1 + pollack 1",
    description_jpn:
      "한우사골 삼계탕 2봉+에센셜 호만두 210g 3종(짬뽕1+마라1+명란1",
    product_image_1:
      "https://products.naganorewards.com/KR/Shinsegae_Food/BeefBoneEssentialSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2156",
    brand: "Shinsegae Food",
    sku: "SHPROSHKR0191",
    product_eng:
      "Shinsegae Food Hotel Collection Hanwoo Beef Bone Samgyetang 2 packs + Essential Uchadol Jjamppongtang 2 packs)",
    product_jpn:
      "[신세계푸드] 호텔컬렉션 한우사골 삼계탕 2봉+에센셜 우차돌짬뽕탕 2봉)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "78,000",
    description_eng:
      "2 bags of Korean beef bone samgyetang + 2 bags of essential uchadol jjamppongtang",
    description_jpn: "한우사골 삼계탕 2봉+에센셜 우차돌짬뽕탕 2봉",
    product_image_1:
      "https://products.naganorewards.com/KR/Shinsegae_Food/HanwooSamgyetang2.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2157",
    brand: "Shinsegae Food",
    sku: "SHPROSHKR0192",
    product_eng:
      "Shinsegae Food Hotel Collection Korean Beef Beef Bone Samgyetang 2 bags + Olban Pan Pizza 3 types (Bulgogi 1 + Pepperoni 1 + Combination 1)",
    product_jpn:
      "[신세계푸드] 호텔컬렉션 한우사골 삼계탕 2봉+올반 팬피자 3종(불고기1+페페로니1+콤비네이션1)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "85,000",
    description_eng:
      "2 bags of Korean beef bone samgyetang + 3 types of pan pizza (bulgogi 1 + pepperoni 1 + combination)",
    description_jpn:
      "한우사골 삼계탕 2봉+올반 팬피자 3종(불고기1+페페로니1+콤비네이션",
    product_image_1:
      "https://products.naganorewards.com/KR/Shinsegae_Food/HanwooPizza3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2158",
    brand: "Shinsegae Food",
    sku: "SHPROSHKR0193",
    product_eng:
      "Shinsegae Food Hotel Collection Hanwoo Beef Bone Samgyetang 2 bags + Olban Sous vide Chicken Chest 3 types (Original 2 + Herb 2 + Black Pepper 2)",
    product_jpn:
      "[신세계푸드] 호텔컬렉션 한우사골 삼계탕 2봉+올반 수비드 닭가슴살3종(오리지날2+허브2+블랙페퍼2)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "90,000",
    description_eng:
      "2 bags of Korean beef bone samgyetang + 3 types of Olban sous vide chicken breasts (Original 2 + Herb 2 + Black Pepper 2)",
    description_jpn:
      "한우사골 삼계탕 2봉+올반 수비드 닭가슴살3종(오리지날2+허브2+블랙페퍼2",
    product_image_1:
      "https://products.naganorewards.com/KR/Shinsegae_Food/HanwooChicken3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2159",
    brand: "Shinsegae Food",
    sku: "SHPROSHKR0194",
    product_eng:
      "Shinsegae Food Hotel Collection Hanwoo Beef Bone Samgyetang 2 bags + Essential Homandum 210g 3 types (Champpong 3 + Mara 3 + Salted Egg 3)",
    product_jpn:
      "[신세계푸드] 호텔컬렉션 한우사골 삼계탕 2봉+에센셜 호만두 210g 3종(짬뽕3+마라3+명란3)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "98,000",
    description_eng:
      "2 bags of Korean beef bone samgyetang + essential steamed dumplings 210g 3 types (jjamppong 3 + mala 3 + pollack 3",
    description_jpn:
      "한우사골 삼계탕 2봉+에센셜 호만두 210g 3종(짬뽕3+마라3+명란3",
    product_image_1:
      "https://products.naganorewards.com/KR/Shinsegae_Food/HanwooHomandum3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2160",
    brand: "Shinsegae Food",
    sku: "SHPROSHKR0195",
    product_eng:
      "Shinsegae Food Hotel Collection Hanwoo Beef Bone Samgyetang 4 bags + Olban Sous vide Chicken Chest 3 types (Original 2 + Herb 2 + Black Pepper 2)",
    product_jpn:
      "[신세계푸드] 호텔컬렉션 한우사골 삼계탕 4봉+올반 수비드 닭가슴살3종(오리지날2+허브2+블랙페퍼2)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "125,000",
    description_eng:
      "Korean beef bone samgyetang 4 bags + Olban sous vide chicken breast 3 types (Original 2 + Herb 2 + Black Pepper 2",
    description_jpn:
      "한우사골 삼계탕 4봉+올반 수비드 닭가슴살3종(오리지날2+허브2+블랙페퍼2",
    product_image_1:
      "https://products.naganorewards.com/KR/Shinsegae_Food/HanwooChicken4.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2161",
    brand: "SHUMAX",
    sku: "SHHOUSUKR0196",
    product_eng: "SU-Max Waffle maker",
    product_jpn: "[슈맥스] 와플메이커",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "40,000",
    description_eng:
      "▶ Product composition: body, waffle plate, sandwich plate, manual\n▶ Product Material: Aluminum, etc\n▶ Product size: 227×-139×127 mm\n▶ Product Color: Ivory, Pink, Mint\n\n1. 2-in-1 interchangeable plate (waffle plate, sandwich plate) 2. Simple design without unnecessity\n3. 3 sensuous pastel tone colors: ivory, pink, and mint\n4. Nonstick coating plates prevent coating from peeling off easily or food from sticking\n5. Cook quickly and evenly with double-sided heating wires\n6. One-touch detachable plate\n7. Convenient vertical storage\n8. Non-slip rubber pad fitted\n9. Timer adjustment function (up to 15 minutes)",
    description_jpn:
      "▶ 제품구성 : 본체, 와플 플레이트, 샌드위치 플레이트, 설명서        \n▶ 제품재질 : 알루미늄 외        \n▶ 제품크기 : 227*-139*127 mm        \n▶ 제품색상 : 아이보리, 핑크, 민트        \n\n1. 2in1 교체형 플레이트 (와플 플레이트, 샌드위치 플레이트)        2. 군더더기 없는 심플한 디자인        \n3. 아이보리, 핑크, 민트 3가지의 감각적인 파스텔톤 컬러        \n4. 논스틱 코팅 플레이트로 코팅이 쉽게 벗겨지거나, 음식물이 눌러붙지 않습니다        \n5. 상하 양면 열선 장착으로 빠르고 고르게 익혀줍니다        \n6. 원터치 분리형 플레이트        \n7. 편리한 수직 보관        \n8. 미끄럼 방지 고무패드 장착        \n9. 타이머 조절 기능 (최대 15분)",
    product_image_1:
      "https://products.naganorewards.com/KR/SHUMAX/WaffleMaker.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2162",
    brand: "SHUMAX",
    sku: "SHHOUSHKR0197",
    product_eng: "Shumax multi square electric cooker HU-EC207",
    product_jpn: "[슈맥스] 멀티 사각 전기쿠커 HU-EC207",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "88,000",
    description_eng:
      "1. Simple and modern design\n2. Easy operation lever and power lamp\n3. Two-function pan (pot, steamer)\n4. Wood Type Two-Stage Dial-Type Temperature Control\n(1-500W, 2-stage-1,000W)\n5. hygienic ceramic coating\n6. Safety-enhanced glass lid for checking the cooking process\n7. A wide range of dishes with a generous capacity of 2 liters\n8. an easy-to-go handle",
    description_jpn:
      "1. 심플하고 모던한 디자인\n2. 쉬운 조작 레버와 전원램프\n3. 2가지 기능의 팬 (냄비,찜기)\n4. 우드 타입 2단계 다이얼식 온도조절 \n   (1단-500W, 2단-1,000W)\n5. 위생적인 세라믹 코팅\n6. 조리 과정 확인이 가능한 안전 강화 유리뚜껑 \n7. 2리터의 넉넉한 용량으로 다양한 요리 가능\n8. 이동이 편리한 손잡이",
    product_image_1:
      "https://products.naganorewards.com/KR/SHUMAX/MultiCooker.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2163",
    brand: "SHUMAX",
    sku: "SHHOUSUKR0198",
    product_eng: "SU-Max Tumbler cordless vacuum cleaner",
    product_jpn: "[슈맥스] 텀블러 무선청소기",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "65,000",
    description_eng:
      "▶ Product composition: main body, USB charging cable, basic head, brush nozzle, gap nozzle, manual\n▶ Product Material: Aluminum alloy, ABS\n▶ Product size: 75×75×275 mm\n▶ Product Color: Dark Gray\n\n1. cordless vacuum cleaner\n2. Compact size for easy storage\n3. 4200PA Super Strong Inhalation Performance\n4. Strong suction power and low noise with stable wing structure\n5. Up to 10 minutes of continuous use with 2000 mah battery\n6. Dust collection filter + HEPA filter to remove fine dust",
    description_jpn:
      "▶ 제품구성 : 본체,USB충전케이블,기본헤드,브러쉬노즐,틈새노즐,설명서        \n▶ 제품재질 : 알루미늄합금,ABS        \n▶ 제품크기 : 75*75*275mm\n▶ 제품색상 : 다크그레이\n\n1. 코드없이 작동하는 무선청소기\n2. 컴팩트한 사이즈로 간편수납                              \n3. 4200PA 초강력 흡입 성능                              \n4. 안정적인 날개구조로 강한 흡입력과 저소음                \n5. 최대 10분 연속사용 2000mah배터리 장착          \n6. 집진필터+HEPA 필터로 미세먼지까지 제거",
    product_image_1:
      "https://products.naganorewards.com/KR/SHUMAX/CordlessVacuum.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2164",
    brand: "SIDIZ",
    sku: "SIFURDIKR0199",
    product_eng:
      "Display T50 SIDE T501FE Mesh Chair Black Shell TNA501FE\n(New brand name: Ible)",
    product_jpn:
      "[시디즈] T50 SIDE T501FE 메쉬 의자 블랙쉘 [TNA501FE]\n(신규브랜드 네임: 아이블)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "184,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 615×600×915 mm\n* Color: Indigo Blue, Dark Gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 1 Chair in Korea's Schools, Libraries, and Reading Rooms\n- Glide to help secure the back legs of the chair and the right weight that doesn't push easily\nMinimize movement to help perfect concentration.\n- The S-line back that ideally supports the spine and the thick yet fluffy stand provide the best comfort even if you sit for a long time",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 615*600*915 mm\n* 색상 : 인디고블루, 다크그레이\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 국내 학교, 도서관, 독서실 납품 1위 의자\n- 의자 뒷다리에 고정을 돕는 글라이드와 쉽게 밀리지 않는 적당한 무게감이\n움직임을 최소화해 완벽한 집중을 돕습니다.\n- 척추를 이상적으로 지지해주는 S라인 등판과 두툼하면서도 푹신한 좌판으로 오랜 시간 앉아도 최상의 편안함을 제공합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50BlackChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2165",
    brand: "SIDIZ",
    sku: "SIFURDIKR0200",
    product_eng:
      "Display T50 SIDE T501FE Mesh Chair White Shell TNB501FE\n(New brand name: Ible)",
    product_jpn:
      "[시디즈] T50 SIDE T501FE 메쉬 의자 화이트쉘 [TNB501FE]\n(신규브랜드 네임: 아이블)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "184,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 615×600×915 mm\n* Colors: Pebble Gray, Sand Beige\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 1 Chair in Korea's Schools, Libraries, and Reading Rooms\n- Glide to help secure the back legs of the chair and the right weight that doesn't push easily\nMinimize movement to help perfect concentration.\n- The S-line back that ideally supports the spine and the thick yet fluffy stand provide the best comfort even if you sit for a long time",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 615*600*915 mm\n* 색상 : 페블그레이, 샌드베이지\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n \n- 국내 학교, 도서관, 독서실 납품 1위 의자\n- 의자 뒷다리에 고정을 돕는 글라이드와 쉽게 밀리지 않는 적당한 무게감이\n움직임을 최소화해 완벽한 집중을 돕습니다.\n- 척추를 이상적으로 지지해주는 S라인 등판과 두툼하면서도 푹신한 좌판으로 오랜 시간 앉아도 최상의 편안함을 제공합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2166",
    brand: "SIDIZ",
    sku: "SIFURSIKR0201",
    product_eng: "SIDES T50 SIDE T503F Fabric Mesh Chair White Shell TNB503F",
    product_jpn: "[시디즈] T50 SIDE T503F 패브릭 메쉬 의자 화이트쉘 [TNB503F]",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "199,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 620x600x900–960 mm\n* Colors: Light Gray, Dark Gray, Indigo Blue, Dark Gray, Green\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 2 Chair in Library and Reading Room Delivery\n- We have revolutionized materials to design so that you don't feel uncomfortable even if you sit for a long time without complicated functions. The integrated design of various colored stalls, a clean white frame, and an S-line that flows along the back curve enhances your seating experience\n- With its diverse lineup, the T50 series perfectly supports users of different body types in a variety of postures. The compact T503F can be used comfortably when looking at simple businesses such as conference rooms or study rooms",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 620x600x900~960 mm\n* 색상 : 라이트그레이, 다크그레이, 인디고블루, 다크그레이, 그린\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 도서관, 독서실 납품 2위 의자\n- 복잡한 기능 없이도, 오래도록 앉아 있어도 불편함이 없도록 소재부터 설계까지 획기적으로 만들었습니다. 다양한 컬러 좌판에 깔끔한 화이트 프레임 그리고 등판곡선을 따라 흐르는 S라인의 일체형 디자인이 착석감을 높여드립니다\n- 다양한 라인업을 가진 T50시리즈는 각기 다른 체형을 가진 사용자들의 다양한 자세를 완벽하게 서포트해줍니다. 그 중 컴팩트하게 제작된 T503F는 회의공간이나 서재 등 간단한 용무를 보실 때 편안하게 사용하실 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T503WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2167",
    brand: "SIDIZ",
    sku: "SIFURDIKR0202",
    product_eng:
      "Display TX200HF Tab Plus Mesh Fabric Chair VTNB200HF (Self-assembly)",
    product_jpn:
      "[시디즈] TX200HF 탭 플러스 메쉬 패브릭 의자 [VTNB200HF] (셀프조립)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "214,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 64×60×113.5–128 cm\n* Colors: Dark Gray, Ocean Blue, Warm Sand\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The staff sink function is added to secure the backside with the backside tilted, so you can rest comfortably by leaning on the backside\n- Mesh materials are tightly composed of small holes like mesh, and they are pleasant because they are breathable, and they fit naturally in the shape of the body, which helps blood circulation. TAB PLUS has increased durability by applying more sturdy mesh materials, and you can feel comfortable for a long time\n- The simple and superfluous design and vivid color of Tab Plus go well with various spaces and allow for stylish interior design",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 64 * 60 * 113.5~128  cm  \n* 색상 : 다크그레이, 오션블루, 웜샌드\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 등판이 젖혀진 상태로 고정되는 스탭 싱크 기능이 추가되어, 등판에 기대어 편하게 휴식할 수 있습니다\n- 메쉬 소재는 그물망처럼 작은 구멍으로 촘촘하게 구성된 소재를 말하며, 통기성이 좋기 때문에 땀이 차지 않아 쾌적하며 몸의 형태에 자연스럽게 맞춰져서 혈액 순환에 도움이 됩니다. TAB PLUS는 더욱 견고해진 메쉬 소재를 적용하여 내구성을 높였으며, 오랜기간 쾌적함을 느낄 수 있습니다\n- 탭 플러스의 심플하고 군더더기 없는 디자인과 선명한 컬러는 다양한 공간에 잘 어울리며스타일리쉬한 인테리어 구성이 가능합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/TX200HFChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2168",
    brand: "SIDIZ",
    sku: "SIFURDIKR0203",
    product_eng:
      "Display Tab Square Basic White Shell Chair VTNB402HF (Self-assembled)",
    product_jpn:
      "[시디즈] 탭스퀘어 베이직 화이트쉘 의자 [VTNB402HF] (셀프조립)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "214,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 66.5×58.5×91.5 cm\n* Color: khaki gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The slim design and soft color go well with various environments.\n- The sitting part is designed to look fluffy and slim with a concave sitting frame.\nIn addition, the mesh back is flexible to fit your body shape, so you can feel comfortable.\n- You can adjust the tilting strength so that you can use it comfortably to fit your body. In addition, the multi-locking function, which holds the back while the back is tilted, allows you to do a variety of activities, such as studying and relaxing in a chair.",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 66.5 * 58.5 * 91.5  cm  \n* 색상 : 카키쉬그레이\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 슬림한 디자인과 부드러운 컬러는 다양한 환경과 잘 어울립니다.\n- 오목한 형태의 좌판프레임이 적용되어 앉는 부분은 푹신하며 슬림해보이도록 디자인되었습니다. \n또한, 메쉬 소재의 등판은 체형에 유연하게 맞춰져 편안함을 느낄 수 있습니다.\n- 틸팅 강도를 조절할 수 있어 내 몸에 맞춰 편안하게 사용할 수 있습니다. 또한, 등판이 젖혀진 상태에서 고정되는 멀티 락킹 기능을 사용하여 의자에 앉아 공부와 휴식 등 다양한 활동이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/TabWhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2169",
    brand: "SIDIZ",
    sku: "SIFURDIKR0204",
    product_eng: "Display T25 Mesh Rotating Chair White Shell TXNA250F",
    product_jpn: "[시디즈] T25 메쉬 회전형 의자 화이트쉘 [TXNA250F]",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "299,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 65 x 59.5 x 90.5 cm to 100.5 cm\n* Color: Ash Green, Beige, Gray\n* Material: Fabric, foamed sponge, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- It stretches the body through tilting and helps improve the child's concentration by relieving accumulated fatigue through long-term learning\n- T25's Weight Activated Tilt Weight Sensitive Tilt (WAT) detects the user's weight\nIt adjusts the strength of the backside properly without any separate manipulation\n- The T25's uphill and stall stream lines are designed to take into account the shape of the human body and the movement of the user. The uphill stream lines of different thicknesses and lengths provide better adhesion and ventilation, while at the same time providing more natural and stable support for the movement of the user. The stream lines inside the stall are\nIt effectively distributes the load on the stall, so it is comfortable even when sitting for a long time\n-Depending on the seating experience desired by the user, you can choose a breathable 'mesh lamp' and a 'flex lamp' that supports various postures. You can also purchase a separate fabric cover for the 'flex lamp' to add a soft touch",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 65 x 59.5 x 90.5 ~100.5 cm  \n* 색상 :애쉬그린, 베이지, 그레이\n* 소재 : 패브릭, 발포 스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 틸팅을 통해 몸을 스트레칭 하며, 장시간 학습으로 누적된 피로를 완화시켜줄 수 있어 아이의 집중력 향상에 도움을 줍니다\n- T25의 WAT (Weight Activated Tilt 체중감응형 틸트)는 사용자의 체중을 감지하여 \n별도의 조작 없이도 등판 젖히는 강도를 적절하게 조절해줍니다\n- T25의 등판과 좌판 스트림 라인은 인체의 형상과 사용자의 움직임을 고려하여 설계되었습니다. 서로 다른 굵기와 길이의 등판 스트림 라인은 밀착감과 통기성을 좋게 하고, 동시에 사용자의 움직임을 더욱 자연스럽고 안정감있게 지지해 줍니다. 좌판 내부의 스트림 라인은 \n좌판에 가해지는 하중을 효과적으로 분산시켜 장시간 착석시에도 편안합니다\n-사용자가 원하는 착석감에 따라 통기성이 우수한 '메쉬등판', 다양한 자세를 지지하는 '플렉스 등판'을 선택할 수 있습니다. 또한 '플렉스 등판'을 위한 패브릭 커버를 별도 구매하여, 부드러운 감촉을 더할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T25WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2170",
    brand: "SIDIZ",
    sku: "SIFURDIKR0205",
    product_eng: "Display T40 T400HLDA Mesh Chair Black Shell T400HLDA",
    product_jpn: "[시디즈] T40 T400HLDA 메쉬 의자 블랙쉘 [T400HLDA]",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "319,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.5×65.5×115–126 cm\n* Colors: Black, Navy, Yellow Green\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T40 is designed to be a very slim line with only the essential features considering various users and environments. The slim shape and soft color harmonize with various interiors such as the office or study.\n- The T40 is designed to make the sitting area look fluffy and slim with a concave sitting frame. In addition, the mesh back is flexible and comfortable to fit into the body, and the simple shape of Lumber Support is designed to take into account the pressure on the waist to comfortably support the back.\n- The T40's tilting intensity adjustment lever optimizes the number of lever turns, and the tilting angle adjustment lever can be easily adjusted to fit my body by applying a step-by-step dial type.",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.5x65.5x115~126 cm\n* 색상 : 블랙, 네이비, 옐로우그린\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다. \n\n- T40은 다양한 사용자와 환경을 고려하여 꼭 필요한 기능만 담아 매우 슬림한 라인으로 디자인되었습니다.슬림한 형태와 부드러운 컬러는 사무실이나 서재 등의 다양한 인테리어와 조화를 이룹니다.\n- T40은 오목한 형태의 좌판프레임이 적용되어앉는 부분은 푹신하며 슬림해보이도록 디자인되었습니다.또한, 메쉬 소재의 등판은 체형에 유연하게 맞춰져 편안함을 느낄 수 있으며, 간단한 형상의 럼버서포트는 허리가 받는 압력을 고려한 디자인으로 등을 편안하게 지지해줍니다.\n- T40의 틸팅 강도 조절 레버는 레버 회전 수를 최적화하고, 틸팅 각도 조절 레버는 단계별로 조절할 수 있는 다이얼식을 적용하여 간편하게 내 몸에 맞도록 조절이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T40BlackChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2171",
    brand: "SIDIZ",
    sku: "SIFURDIKR0206",
    product_eng: "Display T50 Series T500HLDA Mesh Chair (VTNE500HLDA)",
    product_jpn: "[시디즈] T50 시리즈 T500HLDA 메쉬 의자 (VTNE500HLDA)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "359,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67×64.5×108–122 cm\n* Colors: Gray, Dark Gray, Deep Green, Ivory\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T50 is the most ideal support for the waist from this ergonomic point of view, and at the same time the most\nIt was developed with an S-Curve motif to have a natural and beautiful appearance\n- Many of the scientifically designed T50's features not only support your vital neck and waist, but also help you optimally customize each part according to your height and body type\n-T50 chairs are applied with a variety of high-quality mesh materials, from high-quality polyester mesh to striped mesh to double lasel mesh, which are different from low-cost mesh chairs, providing both comfort and comfort\n- The T500HLDA is designed to make it easy to replace the seat at home, so you can always use the chair for a long time as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67x64.5x108~122 cm \n* 색상 :그레이 , 다크그레이 , 딥그린 , 아이보리\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- T50은 이러한 인간공학적인 관점에서 허리를가장 이상적으로 지지하며, 동시에 가장\n자연스럽고 아름다운 모습을 가지기 위해 S-Curve 형태를 모티브로 개발 되었습니다\n- 과학적으로 설계된 T50의 많은 기능은 당신의 중요한 목과 허리를 든든하게 지지할 뿐만 아니라 키와 체형에 따라 손쉽게 각부분을 최적으로 맞춤화하여 사용하도록 지원합니다\n-T50 의자는 저가 메쉬 의자들과는 차원이 다른 고품질 폴리에스테르 메쉬부터 스트라이프 메쉬, 더블 라셀 메쉬까지 다양한 고급 메쉬 소재를 적용하여 편안함과 쾌적함을 동시에 제공합니다\n- T500HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50MeshChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2172",
    brand: "SIDIZ",
    sku: "SIFURDIKR0207",
    product_eng: "Display T52 T500HLDA Air Mesh Chair Black Shell TXA520HLDA",
    product_jpn: "[시디즈] T52 T500HLDA 에어 메쉬 의자 블랙쉘 [TXA520HLDA]",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "389,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.0×52.5×108–122 cm\n* Colors: Gray, Black, Blue\n* Material: mesh, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- AirSkin Mesh uses Hytrel® raw materials from DuPont, the world's leading chemical company\nIt is made of strong elastic yarn, so it is very stretchable and elastic.\n- The T50 AIR stall is designed to be open-frame to keep thighs out of touch. The elasticity and elasticity of the air skin mesh meets the stall structure of the open-frame to evenly distribute body pressure\nYou can feel comfortable and comfortable in various positions, such as tilting forward or leaning against your back\n- Multi-sink is applied to the T50 AIR series to adjust the tilting strength in detailed steps tailored to the user, and adjust the lumber support, headrest, and armrest to fit the user's body\nYou can use it comfortably",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.0*52.5*108~122 cm  \n* 색상 : 그레이, 블랙, 블루\n* 소재 : 메쉬, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 에어스킨 메쉬는 세계 최고 화학 전문 기업인 미국 듀폰사의 Hytrel® 원료를 이용한 \n강력 탄성사로 구성되어, 신축성과 탄력성이 매우 뛰어납니다.\n- T50 AIR 좌판은 허벅지가 닿지 않도록 오픈 프레임으로 설계되었습니다. 신축성과 탄력성이 뛰어난 에어스킨 메쉬와 오픈프레임의 좌판 구조가 만나, 체압을 고르게 분산시켜주어 \n앞으로 기울이거나, 등에 기대는 등 다양한 자세에서 쾌적함과 편안함을 느낄 수 있습니다\n- T50 AIR 시리즈에는 멀티 싱크가 적용되어, 사용자에게 맞추어 세밀한 단계로 틸팅 강도 조절이 가능하며, 럼버서포트, 헤드레스트, 팔걸이등을 사용자의 몸에 맞도록 조절하여\n편안하게 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T52BlackChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2173",
    brand: "SIDIZ",
    sku: "SIFURDIKR0208",
    product_eng: "Display T50 T500HLDA White Shell Mesh Chair VTNF500HLDA",
    product_jpn: "[시디즈] T50 T500HLDA 화이트쉘 메쉬 의자 [VTNF500HLDA]",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "369,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67×64.5×108–122 cm\n* Colors: Gray, Ivory, Coral, Deep Green\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T50 is the most ideal support for the waist from this ergonomic point of view, and at the same time the most\nIt was developed with an S-Curve motif to have a natural and beautiful appearance\n- Many of the scientifically designed T50's features not only support your vital neck and waist, but also help you optimally customize each part according to your height and body type\n-T50 chairs are applied with a variety of high-quality mesh materials, from high-quality polyester mesh to striped mesh to double lasel mesh, which are different from low-cost mesh chairs, providing both comfort and comfort\n- The T500HLDA is designed to make it easy to replace the seat at home, so you can always use the chair for a long time as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67x64.5x108~122 cm\n* 색상 : 그레이 , 아이보리 , 코랄 , 딥그린\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- T50은 이러한 인간공학적인 관점에서 허리를가장 이상적으로 지지하며, 동시에 가장\n자연스럽고 아름다운 모습을 가지기 위해 S-Curve 형태를 모티브로 개발 되었습니다\n- 과학적으로 설계된 T50의 많은 기능은 당신의 중요한 목과 허리를 든든하게 지지할 뿐만 아니라 키와 체형에 따라 손쉽게 각부분을 최적으로 맞춤화하여 사용하도록 지원합니다\n-T50 의자는 저가 메쉬 의자들과는 차원이 다른 고품질 폴리에스테르 메쉬부터 스트라이프 메쉬, 더블 라셀 메쉬까지 다양한 고급 메쉬 소재를 적용하여 편안함과 쾌적함을 동시에 제공합니다\n- T500HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50WhiteMesh.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2174",
    brand: "SIDIZ",
    sku: "SIFURDIKR0209",
    product_eng: "Display T52 T500HLDA Air Mesh Chair White Shell TXB520HLDA",
    product_jpn: "[시디즈] T52 T500HLDA 에어 메쉬 의자 화이트쉘 [TXB520HLDA]",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "399,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.0×52.5×108–122 cm\n* Colors: Gray, Black, Blue\n* Material: mesh, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- AirSkin Mesh uses Hytrel® raw materials from DuPont, the world's leading chemical company\nIt is made of strong elastic yarn, so it is very stretchable and elastic.\n- The T50 AIR stall is designed to be open-frame to keep thighs out of touch. The elasticity and elasticity of the air skin mesh meets the stall structure of the open-frame to evenly distribute body pressure\nYou can feel comfortable and comfortable in various positions, such as tilting forward or leaning against your back\n- Multi-sink is applied to the T50 AIR series to adjust the tilting strength in detailed steps tailored to the user, and adjust the lumber support, headrest, and armrest to fit the user's body\nYou can use it comfortably",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.0*52.5*108~122 cm  \n* 색상 : 그레이, 블랙, 블루\n* 소재 : 메쉬, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 에어스킨 메쉬는 세계 최고 화학 전문 기업인 미국 듀폰사의 Hytrel® 원료를 이용한 \n강력 탄성사로 구성되어, 신축성과 탄력성이 매우 뛰어납니다.\n- T50 AIR 좌판은 허벅지가 닿지 않도록 오픈 프레임으로 설계되었습니다. 신축성과 탄력성이 뛰어난 에어스킨 메쉬와 오픈프레임의 좌판 구조가 만나, 체압을 고르게 분산시켜주어 \n앞으로 기울이거나, 등에 기대는 등 다양한 자세에서 쾌적함과 편안함을 느낄 수 있습니다\n- T50 AIR 시리즈에는 멀티 싱크가 적용되어, 사용자에게 맞추어 세밀한 단계로 틸팅 강도 조절이 가능하며, 럼버서포트, 헤드레스트, 팔걸이등을 사용자의 몸에 맞도록 조절하여\n편안하게 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T52WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2175",
    brand: "SIDIZ",
    sku: "SIFURDIKR0210",
    product_eng: "Display T55 series T550HLDA double lasel chair",
    product_jpn: "[시디즈] T55 시리즈 T550HLDA 더블라셀 의자",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "399,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 65.5×59.3×113.5 cm\n* Color: Double Racer-Red, Double Racer-Blue\n* Material: Double lacquer, foam sponge, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n-Synchronized tilt and ergonomically designed adjustable neckrests, armrests and stalls that respond to the user's posture and body type with delicate adjustments according to the back and weight change to shape and size just for you with simple manipulation\n- For the first time in the world, it is equipped with an automatic lumbar support that moves on its own depending on the user's posture and body shape and supports the waist in an S-shape.\n-Double lasel is one of the evolved mesh materials used in hiking clothes and marathon shoes. It is breathable, comfortable, and helps blood circulation, as well as being durable, providing a higher level of elasticity for a long time\n-The T550HLDA double lasel is designed to make it easy to replace the seat at home, so the chair can always be used as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 65.5*59.3*113.5 cm  \n* 색상 : 더블라셀-레드, 더블라셀-블루\n* 소재 : 더블라셀,발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n-사용자의 자세와 체형에 따라 스스로 반응하며 움직이는 등판과 몸무게에 따라 섬세한 조절이 가능한 싱크로나이즈드 틸트와 인체공학적으로 설계된 조절형 목받침과 팔걸이, 좌판은 간단한 조작만으로도 당신만을 위한 형태와 크기로 변화합니다\n- 세계 최초로 사용자의 자세와 체형에 따라 등판이 스스로 움직이며 허리를 S자 형태로 받쳐주는 오토매틱 요추지지대가 장착되어 있습니다.\n-더블라셀은 진화된 메쉬 소재 중 하나로 등산복, 마라톤화 등에 사용되는 고 기능성 소재 입니다. 통기성이 좋아 땀이 차지 않고 쾌적하며 혈액 순환에 도움이 되는 것은 물론, 내구성이 강화되어 더 높은 수준의 탄성을 오랫동안 변함없이 제공합니다\n-T550HLDA 더블라셀은 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T55DoubleChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2176",
    brand: "SIDIZ",
    sku: "SIFURDIKR0211",
    product_eng: "Display T80 Series T800HLDA Mesh Chair",
    product_jpn: "[시디즈] T80 시리즈 T800HLDA 메쉬의자",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "739,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 73.5×58.0×115.0 cm\n* Color: Gray, Golden Blue\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within up to D+10 days from the date of order by immediate production.\n\n- Refined design lines, luxurious materials that match them, and elaborate details add dignity to the time spent sitting down\n- The 'Ultimate Sync' mechanism, which fits the body from any angle, optimizes the movement of the chair so that it can maintain a tight fit from any angle when the backrest is tilted. The T80 is the only way to achieve the optimum level of comfort that has been proven through six years of research\n- For a more comfortable smart life, the T80 series of armrests are designed around the back\n- The longer you sit in the chair, the easier it is to become contaminated. The T800HLDA is designed to make it easy to replace stalls at home, so you can always use your chair for as long as it's new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 73.5 * 58.0 * 115.0cm\n* 색상 : 그레이, 골든블루\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 최대 D+10일 이내 출고됩니다. \n\n- 정제된 디자인 라인과 그에 어울리는 고급스러운 소재, 정교한 디테일로 앉아서 보내는 시간 위에 품격을 더합니다\n- 어느 각도에서도 몸에 꼭 맞는 'Ultimate Sync' 매커니즘은 등판을 뒤로 젖히는 어느 각도에서도 의자가 몸에 꼭 맞는 형상을 유지할 수 있도록 의자의 움직임을 신체동작에 최적화 하였습니다. 6년간의 연구를 통해 검증된 최적의 편안함은 오직 T80을 통해서만 경험하실 수 있습니다\n- 더 편안한 스마트 라이프를 즐길 수 있도록 T80 시리즈의 팔걸이는 등판을 중심으로 설계되었습니다\n- 의자에 오래 앉을수록 오염되기 쉽습니다. T800HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T80MeshChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2177",
    brand: "TANDY",
    sku: "TAFASTAKR0212",
    product_eng: "Tandy Women's Diamond Clock DIA-4044 RG-BK",
    product_jpn: "[탠디] 여성 다이아몬드 시계 DIA-4044 RG-BK",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "440,000",
    description_eng:
      "■ 12-way index real diamond\n■케이스: Stainless Steel Back\n■band: Metall Band\n■ Size: case 23 mm, band: 187 mm\n■ Weight: 17 g\n■Glass: Mineral Glass\n■Movement: Japan Movie't\n■Waterproof: 3 atmospheric pressure life waterproof\n■ Warranty, Diamond Warranty",
    description_jpn:
      "■12방향 인덱스 리얼다이아몬드\n■케이스: Stainless Steel Back\n■밴드: Metall Band\n■사이즈: 케이스 23mm, 밴드: 187mm\n■무게: 17g\n■글래스: 미네랄 글래스\n■무브먼트: Japan Mov’t\n■방수: 3기압 생활 방수\n■보증서, 다이아몬드 보증서",
    product_image_1:
      "https://products.naganorewards.com/KR/TANDY/Women_sDiamond4044.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2178",
    brand: "TANDY",
    sku: "TAFASTAKR0213",
    product_eng: "Tandy Women's Diamond Clock DIA-4043 WH",
    product_jpn: "[탠디] 여성 다이아몬드 시계 DIA-4043 WH",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "450,000",
    description_eng:
      "■ 12-way index real diamond\n■케이스: Stainless Steel Back\n■band: Metall Band\n■ Size: case 23 mm, band 177 mm\n■ Weight: 30 g\n■Glass: Mineral Glass\n■Movement: Japan Movie't\n■Waterproof: 3 atmospheric pressure life waterproof\n■ Warranty, Diamond Warranty",
    description_jpn:
      "■12방향 인덱스 리얼다이아몬드\n■케이스: Stainless Steel Back\n■밴드: Metall Band\n■사이즈: 케이스 23mm, 밴드 177mm\n■무게: 30g\n■글래스: 미네랄 글래스\n■무브먼트: Japan Mov’t\n■방수: 3기압 생활 방수\n■보증서, 다이아몬드 보증서",
    product_image_1:
      "https://products.naganorewards.com/KR/TANDY/Women_sDiamond4043.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2179",
    brand: "TANDY",
    sku: "TAFASTAKR0214",
    product_eng: "Tandy Men's Diamond Clock DIA-3925 BK",
    product_jpn: "[탠디] 남성 다이아몬드 시계 DIA-3925 BK",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "480,000",
    description_eng:
      "■ 12-way index real diamond\n■케이스: Stainless Steel Back\n■밴드: Stainless Steel Band\n■ Size: case 42 mm, band 188 mm\n■ Weight: 55 g\n■Glass: Mineral Glass\n■Movement: Japan Movie't\n■Waterproof: 3 atmospheric pressure life waterproof\n■ Warranty, Diamond Warranty",
    description_jpn:
      "■12방향 인덱스 리얼다이아몬드\n■케이스: Stainless Steel Back\n■밴드: Stainless Steel Band\n■사이즈: 케이스 42mm, 밴드 188mm\n■무게: 55g\n■글래스: 미네랄 글래스\n■무브먼트: Japan Mov’t\n■방수: 3기압 생활 방수\n■보증서, 다이아몬드 보증서\n특이사항",
    product_image_1:
      "https://products.naganorewards.com/KR/TANDY/Men_sDiamond3925.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2180",
    brand: "TANDY",
    sku: "TAFASTAKR0215",
    product_eng: "Tandy Men's Diamond Clock DIA-3924 WH",
    product_jpn: "[탠디] 남성 다이아몬드 시계 DIA-3924 WH",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "490,000",
    description_eng:
      "■ 12-way index real diamond\n■케이스: Stainless Steel Back\n■밴드: Stainless Steel Band\n■ Size: case 42 mm, band 168 mm\n■ Weight: 117 g\n■Glass: Mineral Glass\n■Movement: Japan Movie't\n■Waterproof: 3 atmospheric pressure life waterproof\n■ Warranty, Diamond Warranty",
    description_jpn:
      "■12방향 인덱스 리얼다이아몬드\n■케이스: Stainless Steel Back\n■밴드: Stainless Steel Band\n■사이즈: 케이스 42mm, 밴드 168mm\n■무게: 117g\n■글래스: 미네랄 글래스\n■무브먼트: Japan Mov’t\n■방수: 3기압 생활 방수\n■보증서, 다이아몬드 보증서",
    product_image_1:
      "https://products.naganorewards.com/KR/TANDY/Men_sDiamond3924.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2181",
    brand: "Tefal",
    sku: "TEKITTEKR0216",
    product_eng: "Tefal Vallied Cook titanium frying pan 20 cm",
    product_jpn: "[테팔] 밸리드쿡 티타늄 프라이팬 20cm",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "84,000",
    description_eng:
      "1. A non-stick coating that does not stick to the strong titanium coating\n2. New thermal sensors make cooking start timing easier and more precise and intuitive for perfect cooking - a more comprehensible design, distinct color contrast\n3. Cook food evenly with Tefal's floor technique for even heat conduction\n4. Tefal's promise, safe coating, safe material (PFOA, cadmium, lead not detected)\n5. Made in France, Reliable Quality - Made in France Quality / Headquarters Thorough Quality Control\n6. Chef design prints reminiscent of the home of gourmet France and red-colored bodies make the kitchen more stylish\n■Raw Material: Body: Aluminum / Inside – Titanium Nonstick Coating / Outside-Nonstick Coating",
    description_jpn:
      "1.강력한 티타늄 코팅으로 눌어붙지 않아 오래가는 논스틱 코팅\n2. 새로워진 열센서로 조리 시작 타이밍을 보다 쉽고 정확하게 직관적으로 알려주어 완벽한 요리 가능 - 더욱 이해하기 쉬운 디자인, 뚜렷한 색상 대비\n3.고른 열전도를 위한 테팔만의 바닥 기술로 음식을 고르게 익힘\n4. 테팔의 약속, 안심 코팅, 안심소재 (PFOA, 카드뮴, 납 불검출)\n5. Made in 프랑스, 믿을 수 있는 품질 - 믿을 수 있는 Made in 프랑스 품질/본사의 철저한 품질 관리\n6. 미식의 고장 프랑스를 연상시키는 쉐프 디자인 프린트와 레드컬러 바디로 주방을 더욱 느낌있게\n■원재료: 몸체: 알루미늄 / 내부– 티타늄 논스틱 코팅 / 외부-논스틱 코팅",
    product_image_1:
      "https://products.naganorewards.com/KR/Tefal/TefalFryingPan20cm.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2182",
    brand: "Tefal",
    sku: "TEKITTEKR0217",
    product_eng: "Tefal Dueto stainless steel frying pan 30 cm",
    product_jpn: "[테팔] 듀에또 스테인레스 프라이팬 30cm",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "122,000",
    description_eng:
      "The more convenient and smart functions you use!\nDo you know? Stainless steel is not all the same.\n\n1. All heating appliances including induction are available\n2. 두꺼운 HIBB(High Impact Bonded Base)로\neven heat conduction and delicious dishes\n3. Safe to use metal cookware for any cooking\n4. Excellent durability coating for increased durability\n5. Closer heat sensor: state-of-the-art with temperature sensing\nDouble-treating the coating material, and when the surface reaches the appropriate temperature\nIt turns completely red and tells you the temperature to start cooking.\nspecial note",
    description_jpn:
      "쓸수록 편리하고 똑똑한 기능들!\n알고계시나요? 스텐이라고 다 같은 스텐이 아닙니다.\n\n1. 인덕션을 포함한 모든 가열기구 사용가능\n2. 두꺼운 HIBB(High Impact Bonded Base)로\n고른 열전도와 맛있는 요리\n3. 어떤 요리도 가능하도록 금속 조리도구 사용에 안전\n4. 내구성 향상을 위한 뛰어난 내구성의 코팅\n5. 더욱 선명해진 열센서 : 온도 감지 기능이 있는 최첨단\n코팅 소재를 이중 처리하여, 표면이 적정 온도에 도달하면\n완전히 빨갛게 되어 요리를 시작할 온도를 알려줍니다.\n특이사항",
    product_image_1:
      "https://products.naganorewards.com/KR/Tefal/TefalPan30cm.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2183",
    brand: "Tender garden",
    sku: "TECOS(FKR0218",
    product_eng:
      "(For sale in department stores) Tender Garden Hydro Vitalizing Toner 200 ml",
    product_jpn: "(백화점판매용) [텐더가든] 하이드로 바이탈라이징 토너 200ml",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "35,000",
    description_eng:
      "[Product composition]\n> Tender Garden Hydro Vitalizing Toner 200 ml * 1 ea\n[Product specification]\n> 65*30*140mm\n[Product Features]\n> It can be used by both men and women and is a new concept oil, water texture that absorbs quickly into the skin without leaving any stickiness\n> Skin soothing Bergamot toner: Provides clear skin with excellent soothing and moisturizing effects with Bergamot ingredients\n> Patting toner to soothe skin: Containing active ingredients to soothe sensitive skin reduces skin burden\n> Moisturizing type: A sticky type of toner that increases moisture when applied 2 or 3 times\n> Contains tea tree extract: Quickly soothes and protects sensitive skin and balances oil and moisture\n> Contains papain: Helps exfoliate and helps soft and smooth skin\n> Containing ACZERO: 7 plant extracts, effective in inhibiting sebaceous cell activity, patented technology for acne skin treatment with antioxidant, anti-inflammatory, and antibacterial effects\n> NBP-Complex: Contains essential amino acids, which are effective for anti-aging, moisturizing, and elasticity by strengthening skin immunity\n> 20 harmful ingredients added/all ingredients EWG green grade\n\nPremium brands on sale at Hyundai Department Store, Geleria Luxury Hall, Lotte Department Store, and Shinsegae Department Store'\nA soothing line containing Bergamot ingredients with mysterious hertz, it provides clear and transparent skin like glass grains with glowing moisture protection all day long, soothes sensitive skin, hydrates dry skin, and quickly soothes irritated skin, contains tea tree, helps improve skin wrinkles",
    description_jpn:
      "[제품구성] \n  > 텐더가든 하이드로 바이탈라이징 토너 200ml * 1개\n [제품규격]\n  > 65*30*140mm\n [제품 특징]\n > 남성, 여성 모두 사용가능하며 신개념 오일인워터 텍스처로 끈적임이 남지않고 피부에 빠르게 흡수\n > 피부 진정 베르가못 토너 : 베르가못 성분이 탁월한 진정, 보습 효능으로 맑은 피부 선사\n > 피부를 달래주는 토닥 토너 : 민감한 피부를 달래주는 유효성분 함유로 피부 부담 감소\n > 쫀쫀 촉촉 제형 : 2~3번 덧 바르면 더 좋은 보습감을 높인 쫀쫀한 제형의 토너\n > 티트리추출물 함유 : 예민한 피부를 빠르게 진정,보호해주고 유수분 균형을 맞춤\n > 파파인 함유 : 각질 제거에 도움을 주어 부드럽고 매끄러운 피부에 도움을 줌\n > ACZERO 함유 : 7가지 식물 추출물로 이루어져 피지세포 활성 억제에 효과적이며 항산화 효과,항염,항균 효과로 여드름 피부 치료를 위한 특허받은 기술 성품\n > NB P-Complex : 필수 아미노산이 함유되어 피부면역강화로 항노화,보습,탄력에 효과적임 \n > 화해 20가지 유해성분 무첨가 / 전성분 EWG 그린 등급\n\n현대백화점, 겔러리아 명품관, 롯데백화점, 신세계백화점 판매중인 프리미엄 브랜드’\n 신비의 헤르티지를 가진 베르가못 성분을 함유한 진정라인으로 하루종일 빛나는 수분 방어로 유리알처럼 맑고 투명한 피부를 선사하며 민감한 피부를 달래주고 건조한 피부에 수분을 공급, 자극받은 피부를 빠르게 진정시커주는 베르가모트잎 추출물, 티트리 함유 / 피부 주름개선에 도움을 줌",
    product_image_1:
      "https://products.naganorewards.com/KR/Tender_garden/HydroToner200ml.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2184",
    brand: "Tender garden",
    sku: "TECOS(FKR0219",
    product_eng:
      "(For Sale at Department Store) Tender Garden Hydro Vitalizing Sun Protector (50 ml)",
    product_jpn:
      "(백화점판매용) [텐더가든] 하이드로 바이탈라이징 선 프로텍터(50ml)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "35,000",
    description_eng:
      "[Product composition]\n> Tender Garden Hydro Vitalizing Sun Protector (50ml)\n[Product specification]\n> 50*25*140mm\n[Product Features]\n> Functional sunscreen with seamless UV protection and whitening (SPF50+ PA++++), strong UVA/UVB protection\n> Contains Bergamot leaf extract to soothe skin: Bergamot ingredients help hydrate and soothe skin excellently\n> Sunscreen to soothe skin: Moisture to sensitive and dry skin\n> Blank tone-up: It is effective in creating clear and transparent skin, tone-up, and glossy with a natural tone-up effect\n> Soft and creamy high viscosity moisture cream texture: It protects the skin from UV rays and is not sticky\n> Contains tea tree extract: Quickly soothes and protects sensitive skin and balances oil and moisture to maintain healthy skin\n> Containing ACZERO: 7 plant extracts, effective in inhibiting sebaceous cell activity, patented technology ingredients for acne skin treatment with antioxidant, anti-inflammatory, and antibacterial effects\n> NBP-Complex: Rich in essential amino acids and vitamins, care for the skin barrier, and protect the skin from external stimuli\n> Hwahae 20 harmful ingredients added/all ingredients EWG green grade (excluding fragrance)\n\nPremium brands on sale at Hyundai Department Store, Geleria Luxury Hall, Lotte Department Store, and Shinsegae Department Store'\nA soothing line containing Bergamot ingredients with mysterious hertz, it provides clear and transparent skin like glass grains with radiant moisture protection all day long, soothes sensitive skin, hydrates dry skin, and quickly soothes irritated skin, a Bergamot leaf extract containing tea tree, and a functional sunscreen for UV protection and whitening",
    description_jpn:
      "[제품구성]\n  > 텐더가든 하이드로 바이탈라이징 선 프로텍터(50ml)\n [제품규격]\n  > 50*25*140mm\n [제품 특징]\n > 틈새없는 자외선 차단 및 미백 기능성 선크림 (SPF50+ PA++++), 강력한 UVA/UVB 방어\n > 피부 진정 베르가모트잎 추출물 함유 : 베르가모트 성분이 수분 공급과 탁월한 진정에 도움을 줌\n > 피부를 달래주는 선크림 : 민감하고 건조한 피부에 촉촉한 수분감을 전달\n > 백탁없는 톤업 : 백탁없는 자연스러운 톤업효과로 맑고 투명한 피부 연출, 톤 업, 윤광에도 효과적\n > 부드럽고 크림 질감의 고점도 수분크림 텍스처 : 자외선으로 부터 피부를 보호하고 끈적임이 없슴\n > 티트리추출물 함유 : 예민한 피부를 빠르게 진정,보호해주고 유수분 균형을 맞춰 건강한 피부 유지\n > ACZERO 함유 : 7가지 식물 추출물로 이루어져 피지세포 활성 억제에 효과적이며 항산화 효과,항염,항균 효과로 여드름 피부 치료를 위한 특허받은 기술 성분\n > NB P-Complex : 필수 아미노산과 비타민이 풍부하게 함유,피부장벽을 케어,외부자극에서 피부보호\n > 화해 20가지 유해성분 무첨가 / 전성분 EWG 그린 등급 (향료 제외)\n\n현대백화점, 겔러리아 명품관, 롯데백화점, 신세계백화점 판매중인 프리미엄 브랜드’\n 신비의 헤르티지를 가진 베르가못 성분을 함유한 진정라인으로 하루종일 빛나는 수분 방어로 유리알처럼 맑고 투명한 피부를 선사하며 민감한 피부를 달래주고 건조한 피부에 수분을 공급, 자극받은 피부를 빠르게 진정시커주는 베르가모트잎 추출물, 티트리 함유한 자외선차단 및 미백 기능성 선크림",
    product_image_1:
      "https://products.naganorewards.com/KR/Tender_garden/HydroSunProtector50ml.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2185",
    brand: "Tender garden",
    sku: "TECOS(FKR0220",
    product_eng:
      "(For sale in department stores) Tender Garden Hydro Vitalizing Serum 40 ml",
    product_jpn: "(백화점판매용) [텐더가든] 하이드로 바이탈라이징 세럼 40ml",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "35,000",
    description_eng:
      "[Product composition]\n> 1 Tender Garden Hydro Vitalizing Serum (40 ml)\n[Product Features]\n> It can be used by both men and women and strengthens the collapsed skin: It contains natural extracts to take care of the skin's foundation\n> Moisture explosion, skin calming, Bergamot Serum: Provides clear skin with excellent soothing and moisturizing effects with Bergamot ingredients\n> Soft green concentrated texture: It is applied smoothly like silk and absorbs and finishes smoothly as if it dissolves on the skin\n> Daffodil extract: Serum that provides clear and uniform care for skin tone with excellent moisturizing effect and skin soothing effect\n> NBP-Complex: Contains essential amino acids, which are effective for anti-aging, moisturizing, and elasticity by strengthening skin immunity\n> 20 harmful ingredients added/all ingredients EWG green grade\n> Contains ACZERO: Completion of clinical trials on acne skin care, reduction of sebum secretion, and suppression of skin secretion\n\nPremium brands on sale at Hyundai Department Store, Geleria Luxury Hall, Lotte Department Store, and Shinsegae Department Store'\nA soothing line containing Bergamot ingredients with mysterious hertz, it provides clear and transparent skin like glass grains with glowing moisture protection all day long, soothes sensitive skin, hydrates dry skin, and quickly soothes irritated skin, contains tea tree, helps improve skin wrinkles",
    description_jpn:
      "[제품구성] \n > 텐더가든 하이드로 바이탈라이징 세럼(40ml) 1개\n [제품 특징]\n > 남성, 여성 모두 사용가능하며 무너진 피부를 탄탄하게 : 자연유래 추출물 함유로 피부 근본을 케어\n > 수분 폭발, 피부 진정, 베르가못 세럼 : 베르가못 성분이 탁월한 진정, 보습 효능으로 맑은 피부 선사\n > 부드러운 그린 농축 텍스처 : 실크처럼 부드럽게 도포되어 피부가에 녹아들듯 흡수,매끄럽게 마무리\n > 수선화 추출물 : 뛰어난 보습효과와 피부 진정효과로 피부톤을 맑고 균일하게 케어해주는 세럼\n > NB P-Complex : 필수 아미노산이 함유되어 피부면역강화로 항노화,보습,탄력에 효과적임 \n > 화해 20가지 유해성분 무첨가 / 전성분 EWG 그린 등급\n > 아크제로(ACZERO) 함유 : 여드름 피부 관리, 피지 분비 감소, 피부 분비 억제 효과 임상시험 완료\n\n현대백화점, 겔러리아 명품관, 롯데백화점, 신세계백화점 판매중인 프리미엄 브랜드’\n 신비의 헤르티지를 가진 베르가못 성분을 함유한 진정라인으로 하루종일 빛나는 수분 방어로 유리알처럼 맑고 투명한 피부를 선사하며 민감한 피부를 달래주고 건조한 피부에 수분을 공급, 자극받은 피부를 빠르게 진정시커주는 베르가모트잎 추출물, 티트리 함유 / 피부 주름개선에 도움을 줌",
    product_image_1:
      "https://products.naganorewards.com/KR/Tender_garden/HydroSerum40ml.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2186",
    brand: "Tender garden",
    sku: "TECOS(FKR0221",
    product_eng:
      "(For sale in department stores) Tender Garden Hydro Vitalizing Cream 50 ml",
    product_jpn: "(백화점판매용) [텐더가든] 하이드로 바이탈라이징 크림 50ml",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "38,000",
    description_eng:
      "[Product composition]\n> Tender Garden Hydro Vitalizing Cream 50 ml * 1 ea\n[Product specification]\n> 60*60*50mm\n[Product Features]\nHigh moisturizing cream that can be used by both men and women and is soft on application\nSkin soothing Bergamot extract: Provides clear skin with excellent soothing and moisturizing effects with Bergamot ingredients\n> Contains tea tree extract: Quickly soothes and protects sensitive skin and balances oil and moisture to make healthy skin\n> Contains 7 types of hyaluronic acid: A collaboration of small molecules ensures deep moisture in the skin and moisturizes for a long time\nContaining ACZERO: 7 plant extracts, effective in inhibiting sebaceous cell activity, patented technology for acne skin treatment with antioxidant, anti-inflammatory, and antibacterial effects\n> NBP-Complex: Contains essential amino acids, which are effective for anti-aging, moisturizing, and elasticity by strengthening skin immunity\n> Hwahae 20 harmful ingredients added/all ingredients EWG green grade (excluding flavorings)\n\nPremium brands on sale at Hyundai Department Store, Geleria Luxury Hall, Lotte Department Store, and Shinsegae Department Store'\nA soothing line containing Bergamot ingredients with mysterious hertz, it provides clear and transparent skin like glass grains with glowing moisture protection all day long, soothes sensitive skin, hydrates dry skin, and quickly soothes irritated skin, contains tea tree, helps improve skin wrinkles",
    description_jpn:
      "[제품구성] \n  > 텐더가든 하이드로 바이탈라이징 크림 50ml * 1개\n [제품규격] \n  > 60*60*50mm\n [제품 특징]\n 남성, 여성 모두 사용 가능하며 발림성이 부드러운 고보습 크림 \n 피부 진정 베르가모트 추출액 : 베르가모트 성분이 탁월한 진정, 보습 효능으로 맑은 피부 선사\n > 티트리추출물 함유 : 예민한 피부를 빠르게 진정,보호해주고 유수분 균형을 맞춰 건강한 피부로\n > 7종 히알루론산 함유 : 소분자 대분자의 콜라보로 피부속 깊이 수분 보층, 보습효과 오래 지속\n ACZERO 함유 : 7가지 식물 추출물로 이루어져 피지세포 활성 억제에 효과적이며 항산화 효과,항염, 항균 효과로 여드름 피부 치료를 위한 특허받은 기술 성품\n > NB P-Complex : 필수 아미노산이 함유되어 피부면역강화로 항노화,보습,탄력에 효과적임 \n > 화해 20가지 유해성분 무첨가 / 전성분 EWG 그린 등급 (향료제외)\n\n현대백화점, 겔러리아 명품관, 롯데백화점, 신세계백화점 판매중인 프리미엄 브랜드’\n 신비의 헤르티지를 가진 베르가못 성분을 함유한 진정라인으로 하루종일 빛나는 수분 방어로 유리알처럼 맑고 투명한 피부를 선사하며 민감한 피부를 달래주고 건조한 피부에 수분을 공급, 자극받은 피부를 빠르게 진정시커주는 베르가모트잎 추출물, 티트리 함유 / 피부 주름개선에 도움을 줌",
    product_image_1:
      "https://products.naganorewards.com/KR/Tender_garden/HydroCream50ml.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2187",
    brand: "Tender garden",
    sku: "TECOS(FKR0222",
    product_eng:
      "(For sale in department stores) Tender Garden Hydro Vitalizing Toner, Serum Set of 2",
    product_jpn:
      "(백화점판매용) [텐더가든] 하이드로 바이탈라이징 토너,세럼 2종세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "67,000",
    description_eng:
      "[Product composition]\n>Tender Garden Hydro Vitalizing Toner (200ml) 1 + Serum (40ml) 1\n[Product specification]\n>160*30*195mm\n[Product Features]\n> It can be used by both men and women and is a new concept oil, water texture that absorbs quickly into the skin without leaving any stickiness\n> Skin soothing Bergamot toner: Excellent soothing and moisturizing properties of Bergamot to provide clear skin\n> Tight triple texture: A silky soft texture absorbs and smooths as if dissolved in the skin\n> Daffodil extract: Serum that provides clear and uniform care for skin tone with excellent moisturizing effect and skin soothing effect\n> Contains tea tree extract: It quickly soothes and protects sensitive skin and balances oil and moisture to make healthy skin\n> Contains papain: It helps exfoliate, so it has soft and smooth skin\n> Containing ACZERO: 7 plant extracts, effective in inhibiting sebaceous cell activity, patented technology for acne skin treatment with antioxidant, anti-inflammatory, and antibacterial effects\n> NBP-Complex: Contains essential amino acids, which are effective for anti-aging, moisturizing, and elasticity by strengthening skin immunity\n> 20 harmful ingredients added/all ingredients EWG green grade\n\nPremium brands on sale at Hyundai Department Store, Geleria Luxury Hall, Lotte Department Store, and Shinsegae Department Store'\nA soothing line containing Bergamot ingredients with mysterious hertz, it provides clear and transparent skin like glass grains with glowing moisture protection all day long, soothes sensitive skin, hydrates dry skin, and quickly soothes irritated skin, contains tea tree, helps improve skin wrinkles",
    description_jpn:
      "[제품구성] \n >텐더가든 하이드로 바이탈라이징 토너(200ml) 1개 + 세럼(40ml) 1개\n [제품규격] \n >160*30*195mm\n [제품 특징]\n > 남성, 여성 모두 사용가능하며 신개념 오일인워터 텍스처로 끈적임이 남지않고 피부에 빠르게 흡수\n > 피부 진정 베르가모트 토너 : 베르가모트 성분이 탁월한 진정, 보습 효능으로 맑은 피부 선사\n > 쫀쫀한 3중 텍스처:실크처럼 부드러운 텍스처가 피부가에 녹아들듯 흡수,매끄럽게 마무리되는 세럼\n > 수선화 추출물 : 뛰어난 보습효과와 피부 진정효과로 피부톤을 맑고 균일하게 케어해주는 세럼\n > 티트리추출물 함유 : 예민한 피부를 빠르게 진정,보호해주고 유수분 균형을 맞춰 건강한 피부로~\n > 파파인 함유 : 각질 제거에 도움을 주어 부드럽고 매끄러운 피부로 ~\n > ACZERO 함유 : 7가지 식물 추출물로 이루어져 피지세포 활성 억제에 효과적이며 항산화 효과,항염,항균 효과로 여드름 피부 치료를 위한 특허받은 기술 성품\n > NB P-Complex : 필수 아미노산이 함유되어 피부면역강화로 항노화,보습,탄력에 효과적임 \n > 화해 20가지 유해성분 무첨가 / 전성분 EWG 그린 등급\n\n현대백화점, 겔러리아 명품관, 롯데백화점, 신세계백화점 판매중인 프리미엄 브랜드’\n 신비의 헤르티지를 가진 베르가못 성분을 함유한 진정라인으로 하루종일 빛나는 수분 방어로 유리알처럼 맑고 투명한 피부를 선사하며 민감한 피부를 달래주고 건조한 피부에 수분을 공급, 자극받은 피부를 빠르게 진정시커주는 베르가모트잎 추출물, 티트리 함유 / 피부 주름개선에 도움을 줌",
    product_image_1:
      "https://products.naganorewards.com/KR/Tender_garden/HydroTonerSerum2Set.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2188",
    brand: "Tender garden",
    sku: "TECOS(FKR0223",
    product_eng:
      "(For sale in department stores) Tender Garden Hydro Vitalizing Toner, Serum, and Cream Set of 3",
    product_jpn:
      "(백화점판매용) [텐더가든] 하이드로 바이탈라이징 토너,세럼,크림 3종세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "103,000",
    description_eng:
      "[Product composition]\n>One toner (200ml), one serum (40ml), one cream (50ml), one luxury packaging box\n[Product Features]\n> Functional cosmetics set that can be used by both men and women\n> Contains Bergamot leaf extract to soothe skin: Bergamot ingredients help hydrate and soothe skin excellently\n> It's applied smoothly like silk for a clean finish\n> Contains tea tree extract: It quickly soothes and protects sensitive skin and balances oil and moisture to make healthy skin\n> Containing ACZERO: 7 plant extracts, effective in inhibiting sebaceous cell activity, antioxidant effect, anti-inflammatory,\nPatented technology for acne skin treatment with antibacterial effect (serum)\n> Soft green concentrated texture: It is applied smoothly like silk and absorbs and finishes smoothly as if it dissolves on the skin\n> NBP-Complex: Rich in essential amino acids and vitamins, care for the skin barrier, and protect the skin from external stimuli\n> Hwahae 20 harmful ingredients added/all ingredients EWG green grade (excluding fragrance)\n\nPremium brands on sale at Hyundai Department Store, Geleria Luxury Hall, Lotte Department Store, and Shinsegae Department Store'\nA soothing line containing Bergamot ingredients with mysterious hertz, it provides clear and transparent skin like glass grains with glowing moisture protection all day long, soothes sensitive skin, hydrates dry skin, and quickly soothes irritated skin, contains tea tree, helps improve skin wrinkles",
    description_jpn:
      "[제품구성] \n >토너(200ml) 1개, 세럼(40ml) 1개, 크림(50ml) 1개, 고급 포장박스\n [제품 특징]\n > 남성, 여성 모두 사용 가능한 기능성 화장품 세트\n > 피부 진정 베르가모트잎 추출물 함유 : 베르가모트 성분이 수분 공급과 탁월한 진정에 도움을 줌\n > 실크처럼 부드럽게 도포되어 깔끔한 마무리감\n > 티트리추출물 함유 : 예민한 피부를 빠르게 진정,보호해주고 유수분 균형을 맞춰 건강한 피부로~\n > ACZERO 함유 : 7가지 식물 추출물로 이루어져 피지세포 활성 억제에 효과적이며 항산화 효과,항염, \n  항균 효과로 여드름 피부 치료를 위한 특허받은 기술 성품 (세럼)\n > 부드러운 그린 농축 텍스처 : 실크처럼 부드럽게 도포되어 피부가에 녹아들듯 흡수,매끄럽게 마무리\n > NB P-Complex : 필수 아미노산과 비타민이 풍부하게 함유,피부장벽을 케어,외부자극에서 피부보호\n > 화해 20가지 유해성분 무첨가 / 전성분 EWG 그린 등급 (향료 제외)\n\n현대백화점, 겔러리아 명품관, 롯데백화점, 신세계백화점 판매중인 프리미엄 브랜드’\n 신비의 헤르티지를 가진 베르가못 성분을 함유한 진정라인으로 하루종일 빛나는 수분 방어로 유리알처럼 맑고 투명한 피부를 선사하며 민감한 피부를 달래주고 건조한 피부에 수분을 공급, 자극받은 피부를 빠르게 진정시커주는 베르가모트잎 추출물, 티트리 함유 / 피부 주름개선에 도움을 줌",
    product_image_1:
      "https://products.naganorewards.com/KR/Tender_garden/HydroTonerSerumCream3Set.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2189",
    brand: "Tender garden",
    sku: "TECOS(FKR0224",
    product_eng:
      "(For sale in department stores) Tender Garden Hydro Vitalizing Functional Skin Care Set of 4",
    product_jpn:
      "(백화점판매용)[텐더가든] 하이드로 바이탈라이징 기능성 스킨케어 4종세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "128,000",
    description_eng:
      "[Product composition]\n> 1 toner (200ml), 1 serum (40ml), 1 cream (50ml), 1 sun protector (50ml), 1 advanced packaging box\n[Product specification]\n> 140*70*180mm\n[Product Features]\n> Functional cosmetics set that can be used by both men and women\n> Contains Bergamot leaf extract to soothe skin: Bergamot ingredients help hydrate and soothe skin excellently\n> It's applied smoothly like silk for a clean finish\n> Contains tea tree extract: Healthy skin that quickly soothes and protects sensitive skin and balances oil and moisture\n> Containing ACZERO: 7 plant extracts, effective in inhibiting sebaceous cell activity, antioxidant effect, anti-inflammatory,\nPatented technology for acne skin treatment with antibacterial effects\n> NBP-Complex: Rich in essential amino acids and vitamins, care for the skin barrier, and protect the skin from external stimuli\n> Sun protector: Seamless UV protection SPF50+ PA++++, strong UVA/UVB protection and hydration and skin\nIt helps soothe and creates clear and transparent skin with a natural tone-up effect\n> Hwahae 20 harmful ingredients added/all ingredients EWG green grade (excluding fragrance)\n\nPremium brands on sale at Hyundai Department Store, Geleria Luxury Hall, Lotte Department Store, and Shinsegae Department Store'\nA soothing line containing Bergamot ingredients with mysterious hertz, it provides clear and transparent skin like glass grains with glowing moisture protection all day long, soothes sensitive skin, hydrates dry skin, and quickly soothes irritated skin, contains tea tree, helps improve skin wrinkles",
    description_jpn:
      "[제품구성]\n  > 토너(200ml) 1개, 세럼(40ml) 1개, 크림(50ml) 1개, 선프로텍터(50ml) 1개, 고급 포장박스\n [제품규격] \n  > 140*70*180mm\n [제품 특징]\n > 남성, 여성 모두 사용 가능한 기능성 화장품 세트\n > 피부 진정 베르가모트잎 추출물 함유 : 베르가모트 성분이 수분 공급과 탁월한 진정에 도움을 줌\n > 실크처럼 부드럽게 도포되어 깔끔한 마무리감\n > 티트리추출물 함유 : 예민한 피부를 빠르게 진정,보호해주고 유수분 균형을 맞춰 건강한 피부\n > ACZERO 함유 : 7가지 식물 추출물로 이루어져 피지세포 활성 억제에 효과적이며 항산화 효과,항염, \n  항균 효과로 여드름 피부 치료를 위한 특허받은 기술 성품\n > NB P-Complex : 필수 아미노산과 비타민이 풍부하게 함유,피부장벽을 케어,외부자극에서 피부보호\n > 선프로텍터 : 틈새없는 자외선 차단 SPF50+ PA++++ , 강력한 UVA/UVB 방어 및 수분 공급과 피부\n  진정에 도움을 주고 백탁없는 자연스러운 톤업 효과로 맑고 투명한 피부 연출\n > 화해 20가지 유해성분 무첨가 / 전성분 EWG 그린 등급 (향료 제외)\n\n현대백화점, 겔러리아 명품관, 롯데백화점, 신세계백화점 판매중인 프리미엄 브랜드’\n 신비의 헤르티지를 가진 베르가못 성분을 함유한 진정라인으로 하루종일 빛나는 수분 방어로 유리알처럼 맑고 투명한 피부를 선사하며 민감한 피부를 달래주고 건조한 피부에 수분을 공급, 자극받은 피부를 빠르게 진정시커주는 베르가모트잎 추출물, 티트리 함유 / 피부 주름개선에 도움을 줌",
    product_image_1:
      "https://products.naganorewards.com/KR/Tender_garden/HydroSkinCare4Set.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2190",
    brand: "TESEUMGOLF",
    sku: "TELEITEKR0225",
    product_eng: "TESEUM GOLF Metallic Ribbon Suncap Black TBWB22F02_bk",
    product_jpn: "[TESEUM GOLF] 메탈릭 리본 썬캡 블랙 TBWB22F02_bk",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "118,000",
    description_eng:
      "1. \"Tezium Golf\" is a character golf brand of Tezium, a teddy bear museum located in Aewol, Jeju Island, and it is a brand that wittily expresses teddy bears' loveliness with Tezium Golf's own sense.\n\n2. The classic and luxurious design of Tezium teddy bear character decoration and luxurious spangle material maximizes the quality of the product to preserve self-esteem on the field.\n\n3. This is a custom-designed suncap that matches any golf outfit style by using high-quality spangle materials to accentuate the entire look.\n\n4. The soft ribbon strap allows you to adjust the size of each body type.",
    description_jpn:
      "1. “테지움 골프”는 제주도 애월에 위치한 테디베어 박물관인 “테지움”의 캐릭터 골프 브랜드로 테디베어의 사랑스러움을 테지움 골프만의 감각으로 위트있게 표현하는 브랜드 입니다.\n\n2. 테지움 테디베어 캐릭터 장식과 고급스런 스팽글 소재의 클래식하고 럭셔리한 디자인으로 연출하여 상품의 품격을 극대화 시켜 필드에서의 자존감을 지켜드립니다.\n\n3. 고급 스팽글 소재를 사용하여 전체 룩에 포인트를 줌으로서 어떠한 골프 의상 스타일과도 어울리는 맞춤형 디자인 썬캡 입니다.\n\n4. 부드러운 소재의 리본 스트랩으로 체형별 사이즈 조절이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/TESEUMGOLF/RibbonSuncapBlack.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2191",
    brand: "TESEUMGOLF",
    sku: "TELEITEKR0226",
    product_eng: "TESEUM GOLF Mini Bear Spangle Bowl Case White TBWB22F07_wh",
    product_jpn: "[TESEUM GOLF] 미니베어 스팽글 볼케이스 화이트 TBWB22F07_wh",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "128,000",
    description_eng:
      "1. \"Tezium Golf\" is a character golf brand of Tezium, a teddy bear museum located in Aewol, Jeju Island, and it is a brand that wittily expresses teddy bears' loveliness with Tezium Golf's own sense.\n\n2. A teddy bear-shaped ball pouch with the Tezium Golf logo as a point on the back.\n\n3. It is a ball pouch that can be carried by putting a golf ball on the back of the mini bear during rounding.\n\n4. It can be worn on golf suit bottoms or bags with a hook that is easy to attach and detach.\n\n5. The spangle material is used to make it trickier than regular fabrics, and it can be a point of a sports look, making it a fashion accessory that stands out on the field.",
    description_jpn:
      "1. “테지움 골프”는 제주도 애월에 위치한 테디베어 박물관인 “테지움”의 캐릭터 골프 브랜드로 테디베어의 사랑스러움을 테지움 골프만의 감각으로 위트있게 표현하는 브랜드 입니다.\n\n2. 테디베어 모양의 볼 파우치로 테지움 골프 로고가 후면에 포인트로 들어갔습니다.\n\n3. 라운딩시에 미니 베어의 후면에 골프공을 넣어 휴대 할 수 있는 볼 파우치 입니다.\n\n4. 탈부착이 용이한 후크를 장착하여 골프복 하의나 가방 등에 착용 할 수 있습니다.\n\n5. 스팽글 소재를 사용하여 일반 원단보다 제작 방식이 까다로우며, 스포츠 룩의 포인트가 되어 필드에서 돋보이는 패션 소품으로 연출 할 수 있습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/TESEUMGOLF/BearBowlCaseWhite.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2192",
    brand: "TESEUMGOLF",
    sku: "TELEITEKR0227",
    product_eng: "TESEUM GOLF Mini Bear Spangle Bowl Case Black TBWB22F07_bk",
    product_jpn: "[TESEUM GOLF] 미니베어 스팽글 볼케이스 블랙 TBWB22F07_bk",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "128,000",
    description_eng:
      "1. \"Tezium Golf\" is a character golf brand of Tezium, a teddy bear museum located in Aewol, Jeju Island, and it is a brand that wittily expresses teddy bears' loveliness with Tezium Golf's own sense.\n\n2. A teddy bear-shaped ball pouch with the Tezium Golf logo as a point on the back.\n\n3. It is a ball pouch that can be carried by putting a golf ball on the back of the mini bear during rounding.\n\n4. It can be worn on golf suit bottoms or bags with a hook that is easy to attach and detach.\n\n5. The spangle material is used to make it trickier than regular fabrics, and it can be a point of a sports look, making it a fashion accessory that stands out on the field.",
    description_jpn:
      "1. “테지움 골프”는 제주도 애월에 위치한 테디베어 박물관인 “테지움”의 캐릭터 골프 브랜드로 테디베어의 사랑스러움을 테지움 골프만의 감각으로 위트있게 표현하는 브랜드 입니다.\n\n2. 테디베어 모양의 볼 파우치로 테지움 골프 로고가 후면에 포인트로 들어갔습니다.\n\n3. 라운딩시에 미니 베어의 후면에 골프공을 넣어 휴대 할 수 있는 볼 파우치 입니다.\n\n4. 탈부착이 용이한 후크를 장착하여 골프복 하의나 가방 등에 착용 할 수 있습니다.\n\n5. 스팽글 소재를 사용하여 일반 원단보다 제작 방식이 까다로우며, 스포츠 룩의 포인트가 되어 필드에서 돋보이는 패션 소품으로 연출 할 수 있습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Tender_garden/BearBowlCaseBlack.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2193",
    brand: "WMF",
    sku: "WMKITWMKR0228",
    product_eng: "WMF 1-hole induction range_WF1552",
    product_jpn: "[WMF] 1구 인덕션 레인지_WF1552",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "770,000",
    description_eng: "Main product, instruction manual",
    description_jpn: "본체, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/WMF/InductionRangeWF1552.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2194",
    brand: "Xiaomi",
    sku: "XIHOUXIKR0229",
    product_eng: "XIAOMI Nose hair remover HN3",
    product_jpn: "[샤오미] 코털제거기 HN3",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      "■ Product name: Nose hair remover\n□ Option: Single item\n■ Product size: 12.9×1.65 cm\n■ Package Size: 6x3.3x14.9 cm\n■ Color: White\n■ Component: main product, 1 AAA battery\n■ Rated voltage: 1.5V\n■ Head material: 420J2 Toyota imported steel\n■ Weight: 114 g",
    description_jpn:
      "■ 상품명 : 코털제거기\n□ 옵션 : 단품\n■ 상품 사이즈 : 12.9x1.65cm\n■ 패키지 사이즈 : 6x3.3x14.9cm\n■ 색상 : 화이트\n■ 구성품 : 본품,AAA건전지 1개\n■ 정격전압 : 1.5V\n■ 헤드재질 : 420J2 도요타 수입강재\n■ 무게 : 114g",
    product_image_1:
      "https://products.naganorewards.com/KR/Xiaomi/XiaomiNoseRemover.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2195",
    brand: "HAPPYCALL",
    sku: "HAHOUHAKR0230",
    product_eng: "HappyCall New Waffle Fan CC",
    product_jpn: "해피콜 뉴와플팬CC",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "54,000",
    description_eng:
      "■ Material\n- Body: Aluminum castings, Dow Corning Co.'s special silicone (U.S. FDA approved)\n- Handle: thermosetting resin, stainless steel\n■ Coating\n- Internal Coating: Fluororesin Coating (ceratinium coating)\n- External Coating: Ceramic Coating\n■ Size - 250×335×30 mm\n1. serratinium triple coating\n- It is treated with a triple coating of serratinium baked at a high temperature of 450 degrees, so the coating power is very strong and hard, so there is little fear that food will stick to the pan floor, and the floor is smooth, making it easy to clean after cooking.\n2. overflow prevention groove\n- High cooking walls and wide edge grooves are applied to prevent the contents from overflowing and dirtying the pan surface during cooking, enabling clean cooking.\n3. Convenient lock handle\n- The Easy-Locking handle, which can be easily opened and closed with a soft operation, helps convenient cooking by closely attaching and fixing the upper and lower plates.",
    description_jpn:
      "■재질\n- 본체 : 알루미늄 통주물, 다우코닝사 특수 실리콘(미국 FDA승인)\n- 손잡이 : 열경화수지, 스테인레스 스틸\n■코팅\n- 내부코팅 : 불소수지코팅(세라티늄 코팅)\n- 외부코팅 : 세라믹코팅\n■사이즈 - 250*335*30mm\n1. 세라티늄 3중 코팅\n- 450도 고열에서 구운 세라티늄 3중 코팅으로 처리되어 코팅력이 매우 강하고 단단해 음식물이 팬바닥에 눌러붙을 염려가 적으며, 바닥이 매끄러워 조리 후 세척이 간편하다.\n2. 넘침방지 홈\n- 높은 조리벽과 넓은 가장자리 홈을 적용시켜 조리시 내용물이 넘쳐나와 팬 표면이 더러워지는 것을 방지해 주어 깔끔한 조리가 가능하다.\n3. 편리한 잠금 손잡이\n- 부드러운 조작감으로 손쉽게 열고 닫을 수 있는 Easy-Locking 손잡이는 상, 하판을 밀착, 고정시켜서 편리한 조리를 도와준다.",
    product_image_1:
      "https://products.naganorewards.com/KR/HAPPYCALL/NewWaffleFanCC.jpg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2196",
    brand: "Starbucks",
    sku: "STKITSTKR0231",
    product_eng:
      "Starbucks SS Brown Debbie Tumbler 414 ml + Premium Coffee 10p",
    product_jpn: "[스타벅스] SS 브라운 데비 텀블러 414ml + 프리미엄 커피 10입",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "55,000",
    description_eng:
      "■It is made of stainless steel and vacuum-treated between the double wall structures for excellent thermal/cooling effects. ■It is easy to use because it has a non-slip pad finish and a lid together at the bottom.\n ■Powder type coffee using Arabica beans of the same quality as Starbucks coffee house",
    description_jpn:
      "■스테인레스 스틸 재질로 이중벽 구조 사이가 진공 처리되어 보온/보냉 효과가 우수합니다. ■하단에 미끄럼 방지 패드 마감, 리드가 함께 있어 사용이 편리합니다.\n■스타벅스 커피하우스와 동일한 품질의 아라비카 원두를 사용한 파우더 타입 커피",
    product_image_1:
      "https://products.naganorewards.com/KR/STARBUCKS/SSBrownDebbieTumbler_PremiumCoffee.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2197",
    brand: "Starbucks",
    sku: "STKITSTKR0232",
    product_eng: "Starbucks SS Dayage Navy Tumbler 444 ml + Premium Coffee 10p",
    product_jpn: "[스타벅스] SS데이지 네이비 텀블러 444ml + 프리미엄커피 10입",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "59,000",
    description_eng:
      "■Navy-colored stainless steel tumbler that can be used daily\n ■Powder type coffee with Arabica beans of the same quality as Starbucks coffee house",
    description_jpn:
      "■데일리하게 사용 가능한 네이비 색상의 스테인레스 텀블러\n■스타벅스 커피 하우스와 동일한 품질의 아라비카 원두를 사용한 파우더 타입 커피",
    product_image_1:
      "https://products.naganorewards.com/KR/STARBUCKS/SSDayageNavyTumbler_PremiumCoffee.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2198",
    brand: "Cookcell",
    sku: "COKITCOKR0233",
    product_eng:
      "Cookcell Cookcell 3-Layered Single Coated Black Edition IH Teflon Frying Pan 26 cm",
    product_jpn:
      "[Cookcell] 쿡셀 통3중 싱글 코팅 블랙에디션 IH 테프론 프라이팬 26cm",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "72,000",
    description_eng:
      "■ Composition: Frying pan 26 cm\n■ Black Cube's Cookcell fans are technology-patented fans in the U.S., South Korea and China as well as technology powerhouse Germany, introducing new technology that combines the advantages of stainless steel fans and coating fans to help with safer and more convenient cooking.\n■ Hexagonal dot embossing coating technology that improves cooking efficiency reduces sticking and peeling, and even lowers stain (barking) worries with a double coating.\n■ Faster and hotter thermal conductivity with triple-layer material\n■ Stainless steel haul handle that is not hot even while cooking\n■ From various stir-fried soup dishes to party dishes\n■ Various heat sources and dishwashers are available!",
    description_jpn:
      "■구성 : 프라이팬 26cm\n■블랙큐브의 Cookcell 팬은 기술 강국 독일 뿐만 아니라, 미국, 한국 및 중국에 기술 특허 등록한 팬으로 스테인리스 팬과 코팅 팬의 장점을 결합한 형식의 신기술을 도입하여 보다 안전하고 편리한 조리를 돕습니다.\n■요리 효율을 높이는 육각 도트 엠보 코팅 기술로 바닥을 눌어 붙음, 벗겨짐을 낮추고, 더블코팅으로 얼룩(갈변) 걱정까지 다운시켰습니다.\n■통3중 재질로 더 빠르고, 뜨껍게  뛰어난 열 전도율\n■조리중에도 뜨겁지 않은 스텐할로우 핸들\n■다양한 볶음 탕요리부터 파티 음식까지\n■다양한 열원 및 식기세척기 사용가능!",
    product_image_1:
      "https://products.naganorewards.com/KR/Cookcell/3-LayeredSingleCoatedBlackPan26.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2199",
    brand: "Cookcell",
    sku: "COKITCOKR0234",
    product_eng:
      "Cookcell Cookcell 3-layered double coating IH square multi-pan 32 cm",
    product_jpn: "[Cookcell] 쿡셀 통3중 더블코팅 IH 사각멀티팬 32cm",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "158,000",
    description_eng:
      "■Composition: Square Multi-Pan 32 cm\n■ Black Cube's Cookcell fans are technology-patented fans in the U.S., South Korea and China as well as technology powerhouse Germany, introducing new technology that combines the advantages of stainless steel fans and coating fans to help with safer and more convenient cooking.\n■ Hexagonal dot embossing coating technology that improves cooking efficiency reduces sticking and peeling, and even lowers stain (barking) worries with a double coating.\n■ Faster and hotter thermal conductivity with triple-layer material\n■ Stainless steel haul handle that is not hot even while cooking\n■ From various stir-fried soup dishes to party dishes\n■ Various heat sources and dishwashers are available!",
    description_jpn:
      "■구성 : 사각멀티팬 32cm\n■블랙큐브의 Cookcell 팬은 기술 강국 독일 뿐만 아니라, 미국, 한국 및 중국에 기술 특허 등록한 팬으로 스테인리스 팬과 코팅 팬의 장점을 결합한 형식의 신기술을 도입하여 보다 안전하고 편리한 조리를 돕습니다.\n■요리 효율을 높이는 육각 도트 엠보 코팅 기술로 바닥을 눌어 붙음, 벗겨짐을 낮추고, 더블코팅으로 얼룩(갈변) 걱정까지 다운시켰습니다.\n■통3중 재질로 더 빠르고, 뜨껍게  뛰어난 열 전도율\n■조리중에도 뜨겁지 않은 스텐할로우 핸들\n■다양한 볶음 탕요리부터 파티 음식까지\n■다양한 열원 및 식기세척기 사용가능!",
    product_image_1:
      "https://products.naganorewards.com/KR/Cookcell/3-layeredDoubleCoating.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2200",
    brand: "Cookcell",
    sku: "COKITCOKR0235",
    product_eng:
      "Cookcell Cookcell 3-layered single coated IH cauldron 16 cm black + glass lid",
    product_jpn:
      "[Cookcell] 쿡셀 통3중 싱글 코팅 IH 가마솥 16cm 블랙 + 유리뚜껑",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "169,000",
    description_eng:
      "■ Composition: Cauldron 16 cm\n■ Black Cube's Cookcell fans are technology-patented fans in the U.S., South Korea and China as well as technology powerhouse Germany, introducing new technology that combines the advantages of stainless steel fans and coating fans to help with safer and more convenient cooking.\n■ Hexagonal dot embossing coating technology that improves cooking efficiency reduces sticking and peeling, and even lowers stain (barking) worries with a double coating.\n■ Faster and hotter thermal conductivity with triple-layer material\n■ Stainless steel haul handle that is not hot even while cooking\n■ From various stir-fried soup dishes to party dishes\n■ Various heat sources and dishwashers are available!",
    description_jpn:
      "■구성 : 가마솥 16cm\n■블랙큐브의 Cookcell 팬은 기술 강국 독일 뿐만 아니라, 미국, 한국 및 중국에 기술 특허 등록한 팬으로 스테인리스 팬과 코팅 팬의 장점을 결합한 형식의 신기술을 도입하여 보다 안전하고 편리한 조리를 돕습니다.\n■요리 효율을 높이는 육각 도트 엠보 코팅 기술로 바닥을 눌어 붙음, 벗겨짐을 낮추고, 더블코팅으로 얼룩(갈변) 걱정까지 다운시켰습니다.\n■통3중 재질로 더 빠르고, 뜨껍게  뛰어난 열 전도율\n■조리중에도 뜨겁지 않은 스텐할로우 핸들\n■다양한 볶음 탕요리부터 파티 음식까지\n■다양한 열원 및 식기세척기 사용가능!",
    product_image_1:
      "https://products.naganorewards.com/KR/Cookcell/3-layeredSingleCoated.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2201",
    brand: "Cookcell",
    sku: "COKITCOKR0236",
    product_eng:
      "Cookcell Cookcell 3-layered stainless steel IH stock pot 28 cm",
    product_jpn: "[Cookcell] 쿡셀 통3중 스텐 IH 곰솥 28cm",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "140,000",
    description_eng:
      "■Composition: Stainless steel stock pot 28 cm (9 L) + Steamer 28 cm + complex lid 29 cm (dom type)\n■ Black Cube's Cookcell fans are technology-patented fans in the U.S., South Korea and China as well as technology powerhouse Germany, introducing new technology that combines the advantages of stainless steel fans and coating fans to help with safer and more convenient cooking.\n■ Hexagonal dot embossing coating technology that improves cooking efficiency reduces sticking and peeling, and even lowers stain (barking) worries with a double coating.\n■ Faster and hotter thermal conductivity with triple-layer material\n■ Stainless steel haul handle that is not hot even while cooking\n■ From various stir-fried soup dishes to party dishes\n■ Various heat sources and dishwashers are available!",
    description_jpn:
      "■구성 : 스텐 곰솥 28cm(9L) + 스티머 28cm + 복합뚜껑 29cm(돔형) \n■블랙큐브의 Cookcell 팬은 기술 강국 독일 뿐만 아니라, 미국, 한국 및 중국에 기술 특허 등록한 팬으로 스테인리스 팬과 코팅 팬의 장점을 결합한 형식의 신기술을 도입하여 보다 안전하고 편리한 조리를 돕습니다.\n■요리 효율을 높이는 육각 도트 엠보 코팅 기술로 바닥을 눌어 붙음, 벗겨짐을 낮추고, 더블코팅으로 얼룩(갈변) 걱정까지 다운시켰습니다.\n■통3중 재질로 더 빠르고, 뜨껍게  뛰어난 열 전도율\n■조리중에도 뜨겁지 않은 스텐할로우 핸들\n■다양한 볶음 탕요리부터 파티 음식까지\n■다양한 열원 및 식기세척기 사용가능!",
    product_image_1:
      "https://products.naganorewards.com/KR/Cookcell/3-layeredStainlessSteel.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2202",
    brand: "Cookcell",
    sku: "COKITCOKR0237",
    product_eng: "Cookcell Cookcell Kitchen Tool 6p Set (Scissors)",
    product_jpn: "[Cookcell] 쿡셀 키친툴 6종 세트(가위)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "198,000",
    description_eng:
      "■Composition: Multipurpose tongs 2P + Multipurpose scissors 1P + Stir-fried spoons 1P + ladle 1P + Square fritter tender 1P\n■ Handle with excellent grip\n- It provides an optimal grip to relieve wrist fatigue.\n■ Convenient storage\n- There is a hole at the end of the handle, so it is convenient to dry and store on foot when not in use.\n■ Hygienic management\n- It is made of stainless steel and is convenient to clean, and it is not rusty, so hygienic management is possible.",
    description_jpn:
      "■구성 : 다용도 집게 2P + 다용도 가위 1P + 볶음스푼 1P + 국자 1P + 사각뒤집게 1P\n■그립감이 뛰어난 손잡이 \n- 최적의 그립감을 제공해 손목의 피로감을 덜어줍니다.\n■편리한 보관 \n- 손잡이 끝에 hole이 있어 사용하지 않을 때 걸어서 건조 및 보관이 편리합니다.\n■위생적인 관리\n- 스테인리스 스틸 소재로 세척이 편리하며, 녹이 잘 슬지 않아 위생적인 관리가 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Cookcell/KitchenTool6pSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2203",
    brand: "Cookcell",
    sku: "COKITCOKR0238",
    product_eng: "Cookcell Cookcell Premium Damascus Cello Set of 4",
    product_jpn: "[Cookcell] 쿡셀 프리미엄 다마스커스 첼로 4종 칼세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "429,000",
    description_eng:
      '■Composition: Chef knife 20 cm + Sandoku knife 18 cm + fruit 12.7 cm + jam knife 10.5 cm\n■What is Damascus knife?\n- a legendary sword famous for "The Knife of Cutting."\n■67-layer Damascus\n■ Robust core steel with hardness of Hrc 60\n■ Sharp blade\n■Unique wavy pattern\n■ Pull structure handle',
    description_jpn:
      '■구성 : 셰프 나이프 20cm + 산도쿠 나이프 18cm + 과도 12.7cm + 잼 나이프 10.5cm\n■다마스커스 칼이란? \n- "칼을 자르는 칼" 로 유명한 전설의 칼\n■67겹 다마스커스\n■Hrc 60의 경도로 강력한 코어강\n■예리한 칼날\n■고유의 물결무늬\n■풀탱구조 손잡이',
    product_image_1:
      "https://products.naganorewards.com/KR/Cookcell/PremiumDamascusCelloSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2204",
    brand: "Cookcell",
    sku: "COKITCOKR0239",
    product_eng: "Cookcell Cookcell Teak End Grain Wood Mini Cutting Board",
    product_jpn: "[Cookcell] 쿡셀 티크 엔드그레인 원목미니 도마",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "99,000",
    description_eng:
      "■Composition: Main product\n■ Size: 20×30×3.2 cm\n■ Teak trees are rich in unique natural oils, making them more hygienic with natural waterproofing.\n■ The blade is also less damaged.\n■ Its unique rigidity and natural waterproofing function of teak trees help prevent the reproduction of harmful bacteria.",
    description_jpn:
      "■구성 : 본품\n■ 사이즈 : 20*30*3.2cm\n■ 티크나무에는 특유의 천연오일이 풍부하게 함유되어 자연스러운 방수 기능으로 더욱 위생적입니다.\n■ 칼날에도 손상이 적습니다.\n■ 티크나무 특유의 강성과 천연방수 기능으로 유해세균 번식 예방에 도움이 됩니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Cookcell/TeakEndGrainWoodMiniCuttingBoard.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2205",
    brand: "Cookcell",
    sku: "COKITCOKR0240",
    product_eng:
      "Cookcell Cookcell 3-layered double ceramic coated IH frying pan set of 7",
    product_jpn: "[Cookcell] 쿡셀 통3중 더블 세라믹 코팅 IH 프라이팬 7종 세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "398,000",
    description_eng:
      "■Composition: 24 cm frying pan, 28 cm frying pan, 24 cm sauté pan, 28 cm double wok (wok), 24 cm steamer, 24 cm glass lid, 28 cm glass lid\n■ Black Cube's Cookcell fans are technology-patented fans in the U.S., South Korea and China as well as technology powerhouse Germany, introducing new technology that combines the advantages of stainless steel fans and coating fans to help with safer and more convenient cooking.\n■ Hexagonal dot embossing coating technology that improves cooking efficiency reduces sticking and peeling, and even lowers stain (barking) worries with a double coating.\n■ Faster and hotter thermal conductivity with triple-layer material\n■ Stainless steel haul handle that is not hot even while cooking\n■ From various stir-fried soup dishes to party dishes\n■ Various heat sources and dishwashers are available!",
    description_jpn:
      "■구성 : 프라이팬24cm, 프라이팬28cm, 소테팬24cm, 더블웍(궁중팬)28cm, 찜기24cm, 유리뚜껑24cm, 유리뚜껑28cm\n■블랙큐브의 Cookcell 팬은 기술 강국 독일 뿐만 아니라, 미국, 한국 및 중국에 기술 특허 등록한 팬으로 스테인리스 팬과 코팅 팬의 장점을 결합한 형식의 신기술을 도입하여 보다 안전하고 편리한 조리를 돕습니다.\n■요리 효율을 높이는 육각 도트 엠보 코팅 기술로 바닥을 눌어 붙음, 벗겨짐을 낮추고, 더블코팅으로 얼룩(갈변) 걱정까지 다운시켰습니다.\n■통3중 재질로 더 빠르고, 뜨껍게 뛰어난 열 전도율\n■조리중에도 뜨겁지 않은 스텐할로우 핸들\n■다양한 볶음 탕요리부터 파티 음식까지\n■다양한 열원 및 식기세척기 사용가능!",
    product_image_1:
      "https://products.naganorewards.com/KR/Cookcell/3-layeredDoubleCeramicCoated.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2206",
    brand: "Cookcell",
    sku: "COKITCOKR0241",
    product_eng:
      "Cookcell Cookcell 3-Layered Single Coated Black Edition IH Party Wok 28 cm",
    product_jpn: "[Cookcell] 쿡셀 통3중 싱글 코팅 블랙에디션 IH 파티웍 28cm",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "180,000",
    description_eng:
      "■Composition: Partyer 28 cm + Glass lid\n■ Black Cube's Cookcell fans are technology-patented fans in the U.S., South Korea and China as well as technology powerhouse Germany, introducing new technology that combines the advantages of stainless steel fans and coating fans to help with safer and more convenient cooking.\n■ Hexagonal dot embossing coating technology that improves cooking efficiency reduces sticking and peeling, and even lowers stain (barking) worries with a double coating.\n■ Faster and hotter thermal conductivity with triple-layer material\n■ Stainless steel haul handle that is not hot even while cooking\n■ From various stir-fried soup dishes to party dishes\n■ Various heat sources and dishwashers are available!",
    description_jpn:
      "■구성 : 파티워 28cm + 유리뚜껑\n■블랙큐브의 Cookcell 팬은 기술 강국 독일 뿐만 아니라, 미국, 한국 및 중국에 기술 특허 등록한 팬으로 스테인리스 팬과 코팅 팬의 장점을 결합한 형식의 신기술을 도입하여 보다 안전하고 편리한 조리를 돕습니다.\n■요리 효율을 높이는 육각 도트 엠보 코팅 기술로 바닥을 눌어 붙음, 벗겨짐을 낮추고, 더블코팅으로 얼룩(갈변) 걱정까지 다운시켰습니다.\n■통3중 재질로 더 빠르고, 뜨껍게  뛰어난 열 전도율\n■조리중에도 뜨겁지 않은 스텐할로우 핸들\n■다양한 볶음 탕요리부터 파티 음식까지\n■다양한 열원 및 식기세척기 사용가능!",
    product_image_1:
      "https://products.naganorewards.com/KR/Cookcell/3-LayeredSingleCoatedBlackWok28.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2207",
    brand: "Cookcell",
    sku: "COKITCOKR0242",
    product_eng:
      "Cookcell Cookcell 3-layered single coated black edition IH single handle pot",
    product_jpn: "[Cookcell] 쿡셀 통3중 싱글 코팅 블랙에디션 IH 편수냄비",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "148,000",
    description_eng:
      "■Composition: Single single handle pot 18 cm + glass lid\n■ Black Cube's Cookcell fans are technology-patented fans in the U.S., South Korea and China as well as technology powerhouse Germany, introducing new technology that combines the advantages of stainless steel fans and coating fans to help with safer and more convenient cooking.\n■ Hexagonal dot embossing coating technology that improves cooking efficiency reduces sticking and peeling, and even lowers stain (barking) worries with a double coating.\n■ Faster and hotter thermal conductivity with triple-layer material\n■ Stainless steel haul handle that is not hot even while cooking\n■ From various stir-fried soup dishes to party dishes\n■ Various heat sources and dishwashers are available!",
    description_jpn:
      "■구성 : 싱글 편수 냄비 18cm + 유리뚜껑\n■블랙큐브의 Cookcell 팬은 기술 강국 독일 뿐만 아니라, 미국, 한국 및 중국에 기술 특허 등록한 팬으로 스테인리스 팬과 코팅 팬의 장점을 결합한 형식의 신기술을 도입하여 보다 안전하고 편리한 조리를 돕습니다.\n■요리 효율을 높이는 육각 도트 엠보 코팅 기술로 바닥을 눌어 붙음, 벗겨짐을 낮추고, 더블코팅으로 얼룩(갈변) 걱정까지 다운시켰습니다.\n■통3중 재질로 더 빠르고, 뜨껍게  뛰어난 열 전도율\n■조리중에도 뜨겁지 않은 스텐할로우 핸들\n■다양한 볶음 탕요리부터 파티 음식까지\n■다양한 열원 및 식기세척기 사용가능!",
    product_image_1:
      "https://products.naganorewards.com/KR/Cookcell/3-layeredSingleCoatedBlackPot.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2208",
    brand: "WMF",
    sku: "WMKITWMKR0243",
    product_eng: "WMF Safir 16 cm single handle pot",
    product_jpn: "[WMF] 사피르 16cm 편수냄비",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "130,000",
    description_eng:
      "■Composition: 16 pieces (diameter 16 cm, height 8 cm, capacity 1.4 L)\n■ Material: Chroma liver (stainless steel), glass\n■ Product Features\n- German luxury brand with 160 years of tradition and No. 1 brand in the world for kitchenware\n- Already in Europe, WMF means high-end kitchenware.\n- WMF is made of chromagan material, so it is durable and maintains a long-lasting subtle luster.\n- It is made of chromagan material, so it does not generate harmful ingredients.\n- By applying the 11mm thick triple bottom (chromagan-aluminum-chromium) transsum method, food can be cooked evenly by maximizing high thermal conductivity and heat retention, and food's unique taste and nutrition can be cooked in a short time.\n- It can be used on all cooking heat sources, including gas ranges, electric ranges, induction, and highlights.",
    description_jpn:
      "■구성 : 16편수(지름 16cm, 높이 8cm, 용량 1.4L)\n■재질 : 크로마간(스테인레스 스틸), 유리   \n■상품특징\n- 160년 전통의 독일 명품 브랜드 주방용품 세계판매 1위 브랜드\n- 이미 유럽에서는 WMF란 곧 최고급 주방용품을 의미합니다.\n- WMF는 크로마간소재로 만들어져 내구성이 강하고 은은한 광택이 오래 유지됩니다.\n- 크로마간소재로 만들어져  유해 성분이 발생하지 않습니다. \n- 11mm의 두꺼운 3중 바닥 (크로마간-알루미늄-크롬) 트랜스썸 공법을 적용하여, 높은 열전도율, 열보존률을 최대화하여 음식물을 골고루 익혀주며 빠른 시간내에 음식 고유의 맛과 영양이 살아 있는 요리가 가능합니다.\n- 가스레인지, 전기레인지, 인덕션, 하이라이트 등 모든 조리용 열원에서 사용이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/WMF/Safir16SinglePot.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2209",
    brand: "WMF",
    sku: "WMKITWMKR0244",
    product_eng:
      "WMF Safir Pot Set of 2 (16 single handle pot + 24 stock pot (H))",
    product_jpn: "[WMF] 사피르 냄비 2종 세트(16편수+24곰솥(H))",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "382,000",
    description_eng:
      "■Composition: 16 single handle (diameter 16 cm, height 8 cm, capacity 1.4 L), 24 (H) stock pot (diameter 24 cm, height 14 cm, capacity 5.7 L)\n■ Material: Chroma liver (stainless steel), glass\n■ Product Features\n- German luxury brand with 160 years of tradition and No. 1 brand in the world for kitchenware\n- Already in Europe, WMF means high-end kitchenware.\n- WMF is made of chromagan material, so it is durable and maintains a long-lasting subtle luster.\n- It is made of chromagan material, so it does not generate harmful ingredients.\n- By applying the 11mm thick triple bottom (chromagan-aluminum-chromium) transsum method, food can be cooked evenly by maximizing high thermal conductivity and heat retention, and food's unique taste and nutrition can be cooked in a short time.\n- It can be used on all cooking heat sources, including gas ranges, electric ranges, induction, and highlights.",
    description_jpn:
      "■구성 : 16편수(지름 16cm, 높이 8cm, 용량 1.4L), 24(H)곰솥(지름 24cm, 높이 14cm, 용량 5.7L)\n■재질 : 크로마간(스테인레스 스틸), 유리   \n■상품특징\n- 160년 전통의 독일 명품 브랜드 주방용품 세계판매 1위 브랜드\n- 이미 유럽에서는 WMF란 곧 최고급 주방용품을 의미합니다.\n- WMF는 크로마간소재로 만들어져 내구성이 강하고 은은한 광택이 오래 유지됩니다.\n- 크로마간소재로 만들어져  유해 성분이 발생하지 않습니다. \n- 11mm의 두꺼운 3중 바닥 (크로마간-알루미늄-크롬) 트랜스썸 공법을 적용하여, 높은 열전도율, 열보존률을 최대화하여 음식물을 골고루 익혀주며 빠른 시간내에 음식 고유의 맛과 영양이 살아 있는 요리가 가능합니다.\n- 가스레인지, 전기레인지, 인덕션, 하이라이트 등 모든 조리용 열원에서 사용이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/WMF/SafirPotSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2210",
    brand: "WMF",
    sku: "WMKITWMKR0245",
    product_eng: "WMF Favorite 3 types frying pan (20+24+28 cm)",
    product_jpn: "[WMF] 페이버릿 3종 후라이팬(20+24+28cm)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "420,000",
    description_eng:
      "■Composition: 20FP (diameter 20, height 5.1 cm, warranty), 24FP (diameter 24, height 5.6 cm, warranty), 28FP (diameter 28 cm, height 6.2 cm, warranty)\n■ Material: Chroma liver (stainless steel)\n■ Product Features\n- German luxury brand with 160 years of tradition and No. 1 brand in the world for kitchenware\n- Already in Europe, WMF means high-end kitchenware.\n- WMF is made of chromagan material, so it is durable and maintains a long-lasting subtle luster.\n- It is made of chromagan material, so it does not generate harmful ingredients.\n- By applying the 11mm thick triple bottom (chromagan-aluminum-chromium) transsum method, food can be cooked evenly by maximizing high thermal conductivity and heat retention, and food's unique taste and nutrition can be cooked in a short time.\n- It can be used in all cooking heat sources, including gas ranges, electric ranges, induction, and highlights, as well as dishwashers.",
    description_jpn:
      "■구성 : 20FP(지름 20, 높이 5.1cm,품질보증서),24FP(지름 24, 높이 5.6cm,품질보증서), 28FP(지름 28cm, 높이 6.2cm,품질보증서)\n■재질 : 크로마간(스테인레스 스틸)\n■상품특징\n- 160년 전통의 독일 명품 브랜드 주방용품 세계판매 1위 브랜드\n- 이미 유럽에서는 WMF란 곧 최고급 주방용품을 의미합니다.\n- WMF는 크로마간소재로 만들어져 내구성이 강하고 은은한 광택이 오래 유지됩니다.\n- 크로마간소재로 만들어져  유해 성분이 발생하지 않습니다. \n- 11mm의 두꺼운 3중 바닥 (크로마간-알루미늄-크롬) 트랜스썸 공법을 적용하여, 높은 열전도율, 열보존률을 최대화하여 음식물을 골고루 익혀주며 빠른 시간내에 음식 고유의 맛과 영양이 살아 있는 요리가 가능합니다.\n- 식기 세척기는 물론, 가스레인지, 전기레인지, 인덕션, 하이라이트 등 모든 조리용 열원에서 사용이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/WMF/Favorite3TypesPan.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2211",
    brand: "WMF",
    sku: "WMKITWMKR0246",
    product_eng:
      "WMF Inspiration double handle pot 2 types C_20 High double handle pot+24 High double handle pot",
    product_jpn: "[WMF] 인스피레이션 양수냄비 2종 C_20높은양수+24높은양수",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "370,000",
    description_eng:
      "■Composition: 20 high positive number + 24 high positive number\n■ Material: Chroma liver (stainless steel), glass\n■ Product Features\n- German luxury brand with 160 years of tradition and No. 1 brand in the world for kitchenware\n- Already in Europe, WMF means high-end kitchenware.\n- WMF is made of chromagan material, so it is durable and maintains a long-lasting subtle luster.\n- It is made of chromagan material, so it does not generate harmful ingredients.\n- By applying the 11mm thick triple bottom (chromagan-aluminum-chromium) transsum method, food can be cooked evenly by maximizing high thermal conductivity and heat retention, and food's unique taste and nutrition can be cooked in a short time.\n- It can be used on all cooking heat sources, including gas ranges, electric ranges, induction, and highlights.",
    description_jpn:
      "■구성 : 20높은양수+24높은양수\n■재질 : 크로마간(스테인레스 스틸), 유리   \n■상품특징\n- 160년 전통의 독일 명품 브랜드 주방용품 세계판매 1위 브랜드\n- 이미 유럽에서는 WMF란 곧 최고급 주방용품을 의미합니다.\n- WMF는 크로마간소재로 만들어져 내구성이 강하고 은은한 광택이 오래 유지됩니다.\n- 크로마간소재로 만들어져  유해 성분이 발생하지 않습니다. \n- 11mm의 두꺼운 3중 바닥 (크로마간-알루미늄-크롬) 트랜스썸 공법을 적용하여, 높은 열전도율, 열보존률을 최대화하여 음식물을 골고루 익혀주며 빠른 시간내에 음식 고유의 맛과 영양이 살아 있는 요리가 가능합니다.\n- 가스레인지, 전기레인지, 인덕션, 하이라이트 등 모든 조리용 열원에서 사용이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/WMF/InspirationDoubleHandlePot2.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2212",
    brand: "WMF",
    sku: "WMKITWMKR0247",
    product_eng: "WMF Inspiration low double handle pot 20 cm",
    product_jpn: "[WMF] 인스피레이션 낮은 양수냄비 20cm",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "150,000",
    description_eng:
      "■Composition: 20 low double handle pot (20 cm diameter, 9 cm height, 2.5 L capacity)\n■ Material: Chroma liver (stainless steel), glass\n■ Product Features\n- German luxury brand with 160 years of tradition and No. 1 brand in the world for kitchenware\n- Already in Europe, WMF means high-end kitchenware.\n- WMF is made of chromagan material, so it is durable and maintains a long-lasting subtle luster.\n- It is made of chromagan material, so it does not generate harmful ingredients.\n- By applying the 11mm thick triple bottom (chromagan-aluminum-chromium) transsum method, food can be cooked evenly by maximizing high thermal conductivity and heat retention, and food's unique taste and nutrition can be cooked in a short time.\n- It can be used on all cooking heat sources, including gas ranges, electric ranges, induction, and highlights.",
    description_jpn:
      "■구성 : 20 낮은 양수냄비 (지름 20cm, 높이 9cm, 용량 2.5L)\n■재질 : 크로마간(스테인레스 스틸), 유리   \n■상품특징\n- 160년 전통의 독일 명품 브랜드 주방용품 세계판매 1위 브랜드\n- 이미 유럽에서는 WMF란 곧 최고급 주방용품을 의미합니다.\n- WMF는 크로마간소재로 만들어져 내구성이 강하고 은은한 광택이 오래 유지됩니다.\n- 크로마간소재로 만들어져  유해 성분이 발생하지 않습니다. \n- 11mm의 두꺼운 3중 바닥 (크로마간-알루미늄-크롬) 트랜스썸 공법을 적용하여, 높은 열전도율, 열보존률을 최대화하여 음식물을 골고루 익혀주며 빠른 시간내에 음식 고유의 맛과 영양이 살아 있는 요리가 가능합니다.\n- 가스레인지, 전기레인지, 인덕션, 하이라이트 등 모든 조리용 열원에서 사용이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/WMF/InspirationLowDoubleHandlePot.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2213",
    brand: "WMF",
    sku: "WMKITWMKR0248",
    product_eng:
      "WMF Inspiration double handle pot Set of 4_16 Low double handle pot + 20 Low double handle pot + 20 High double handle pot + 24 High double handle pot",
    product_jpn:
      "[WMF] 인스피레이션 양수냄비 4종세트_16낮은양수+20낮은양수+20높은양수+24높은양수",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "640,000",
    description_eng:
      "■Composition: 16 low positive number + 20 low positive number + 20 high positive number + 24 high positive number\n■ Material: Chroma liver (stainless steel), glass\n■ Product Features\n- 170-year-old German luxury brand Kitchenware World's No. 1 brand\n- Already in Europe, WMF means high-end kitchenware.\n- WMF is made of chromagan material, so it is durable and maintains a long-lasting subtle luster.\n- It is made of chromagan material, so it does not generate harmful ingredients.\n- By applying the 11mm thick triple bottom (chromagan-aluminum-chromium) transsum method, food can be cooked evenly by maximizing high thermal conductivity and heat retention, and food's unique taste and nutrition can be cooked in a short time.\n- It can be used on all cooking heat sources, including gas ranges, electric ranges, induction, and highlights.",
    description_jpn:
      "■구성 : 16낮은양수+20낮은양수+20높은양수+24높은양수\n■재질 : 크로마간(스테인레스 스틸), 유리   \n■상품특징\n- 170년 전통의 독일 명품 브랜드 주방용품 세계판매 1위 브랜드\n- 이미 유럽에서는 WMF란 곧 최고급 주방용품을 의미합니다.\n- WMF는 크로마간소재로 만들어져 내구성이 강하고 은은한 광택이 오래 유지됩니다.\n- 크로마간소재로 만들어져  유해 성분이 발생하지 않습니다. \n- 11mm의 두꺼운 3중 바닥 (크로마간-알루미늄-크롬) 트랜스썸 공법을 적용하여, 높은 열전도율, 열보존률을 최대화하여 음식물을 골고루 익혀주며 빠른 시간내에 음식 고유의 맛과 영양이 살아 있는 요리가 가능합니다.\n- 가스레인지, 전기레인지, 인덕션, 하이라이트 등 모든 조리용 열원에서 사용이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/WMF/InspirationDoubleHandlePot4.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2214",
    brand: "WMF",
    sku: "WMKITWMKR0249",
    product_eng: "WMF Kitchen Minis Mini Grill Plus WMF3200000670",
    product_jpn: "[WMF] 키친미니스 미니그릴 플러스 WMF3200000670",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "159,000",
    description_eng:
      "1. Size: 38 cm long, 14.3 cm wide, and 9.3 cm high\n2. Rated voltage: 1,500 W / 220 V\n2. Material: Chromagan (Stainless Steel)\n3. Product Description\n- The 840W's small but excellent performance makes it ideal for one or two-person table setting, and it's compact and can be placed on the table and used comfortably at all times.\n- We studied the eating habits of Koreans and included an oil pan for pork belly that was three times larger than the existing oil pan.",
    description_jpn:
      "1. 사이즈 : 길이 38cm, 너비 14.3cm, 높이 9.3cm\n2. 정격전압 : 1,500W / 220V\n2. 재   질 : 크로마간(스테인레스 스틸)\n3. 제품설명 \n- 840W의 작지만 뛰어난 성능으로 1~2인용 상차림에 이상적이며 컴팩트한 사이즈로 식탁위에 두고 언제나 편하게 사용 가능합니다.\n- 한국인의 식습관을 연구해 기존 기름받이판보다 3배 더 커진 삼겹살용 기름받이판을 함께 담았습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/WMF/KitchenMinisMiniGrillPlus.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2215",
    brand: "WMF",
    sku: "WMKITWMKR0250",
    product_eng: "WMF Favourite frying pan 28 cm",
    product_jpn: "[WMF] 페이버릿 후라이팬 28cm",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "160,000",
    description_eng:
      "■Composition: 28FP (28 cm in diameter, 6.2 cm in height, warranty)\n■ Material: Chroma liver (stainless steel)\n■ Product Features\n- German luxury brand with 160 years of tradition and No. 1 brand in the world for kitchenware\n- Already in Europe, WMF means high-end kitchenware.\n- WMF is made of chromagan material, so it is durable and maintains a long-lasting subtle luster.\n- It is made of chromagan material, so it does not generate harmful ingredients.\n- By applying the 11mm thick triple bottom (chromagan-aluminum-chromium) transsum method, food can be cooked evenly by maximizing high thermal conductivity and heat retention, and food's unique taste and nutrition can be cooked in a short time.\n- It can be used in all cooking heat sources, including gas ranges, electric ranges, induction, and highlights, as well as dishwashers.",
    description_jpn:
      "■구성 : 28FP(지름 28cm, 높이 6.2cm,품질보증서)\n■재질 : 크로마간(스테인레스 스틸)\n■상품특징\n- 160년 전통의 독일 명품 브랜드 주방용품 세계판매 1위 브랜드\n- 이미 유럽에서는 WMF란 곧 최고급 주방용품을 의미합니다.\n- WMF는 크로마간소재로 만들어져 내구성이 강하고 은은한 광택이 오래 유지됩니다.\n- 크로마간소재로 만들어져  유해 성분이 발생하지 않습니다. \n- 11mm의 두꺼운 3중 바닥 (크로마간-알루미늄-크롬) 트랜스썸 공법을 적용하여, 높은 열전도율, 열보존률을 최대화하여 음식물을 골고루 익혀주며 빠른 시간내에 음식 고유의 맛과 영양이 살아 있는 요리가 가능합니다.\n- 식기 세척기는 물론, 가스레인지, 전기레인지, 인덕션, 하이라이트 등 모든 조리용 열원에서 사용이 가능합니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/WMF/FavouriteFryingPan28.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2216",
    brand: "Baswell",
    sku: "BAHOUBAKR0251",
    product_eng:
      "Baswell Multipurpose Waterproof Wireless Bathroom Vacuum Cleaner KSC-5000",
    product_jpn: "[홈쇼핑정품-바스웰] 다용도 방수 무선 욕실청소기 KSC-5000",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "128,000",
    description_eng:
      "* Perfect water resistance in water: IPx7 water resistance test obtained\n* Smooth angle adjustment: Smooth and free angle adjustment with laptop hinge\n* Samsung Ion Battery Adoption: KC Self-Safety Certification XU100722-16001A\n* Employment of Meteor Gear: Small but strong power\n* Can be used simultaneously while charging\n* Brush replacement type for multipurpose use: bathroom, veranda, living room, laundry room, window frame, car\n* Composition: Body & cradle, extension five, adapter, manual, floor brush, long brush, velcro, wet mop pad, scrubber pad, sponge pad\n* Charging time / usage time: 2 hours and 30 minutes / 2 hours\n* Body size: 108×108×350 mm\n* Body weight: approximately 730 g",
    description_jpn:
      "* 물속에서도 완벽한 방수 : IPx7 방수성능시험 취득\n* 부드러운 각도조절 : 노트북 힌지 사용으로 부드럽고 자유로운 각도조절 가능\n* 삼성 리온배터리 채택 : KC자율안전 인증 XU100722-16001A\n* 유성기어 채용 : 작지만 강한 파워를 자랑\n* 충전하면서 동시에 사용 가능\n* 브러시 교체타입으로 다목적 사용 : 욕실, 베란다, 거실, 세탁실, 창틀, 자동차 모두 가능\n* 구성 : 본체&거치대, 연장파이브, 어댑터, 설명서, 바닥용브러쉬, 롱브러쉬, 벨크로, 물걸레패드, 수세미 패드, 스펀지 패드\n* 충전시간/사용시간 : 2시간 30분 / 2시간\n* 본체크기 : 108*108*350mm\n* 본체무게 : 약 730g",
    product_image_1:
      "https://products.naganorewards.com/KR/Baswell/MultipurposeWaterproofWirelessBathroomVacuum.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2217",
    brand: "FDiary",
    sku: "FDHOUF KR0252",
    product_eng:
      "F Diary Perfume Diffuser Glass Bottle Set / Refill Liquid 250 ml + Empty Bottle 150 ml",
    product_jpn:
      "[에프다이어리] 퍼퓸 디퓨저 글라스보틀 세트 / 리필액 250ml + 공병 150ml",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "59,000",
    description_eng:
      "1) 5 special scents that will be memorable for a long time\n2) It makes the scent deeper and darker with grain fermented liquor",
    description_jpn:
      "1) 오래도록 기억에 남는 5가지 특별한 향\n2) 곡물 발효 주정으로 향을 더욱 깊고 진하게 만들어줍니다",
    product_image_1:
      "https://products.naganorewards.com/KR/FDiary/PerfumeDiffuserGlassBottleSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2218",
    brand: "Starbucks",
    sku: "STKITSTKR0253",
    product_eng:
      "Starbucks Premium Coffee 10 Pieces + SS Panama Green Siren Tumbler 355 ml",
    product_jpn:
      "[스타벅스] 프리미엄커피 10입 + SS 파나마 그린 사이렌 텀블러 355ml",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "59,000",
    description_eng:
      "■Stainless steel tumbler designed with the Starbucks logo on a curved cylindrical tumbler\n■Powder type coffee with Arabica beans of the same quality as Starbucks coffee house",
    description_jpn:
      "■굴곡진 원통형 텀블러에 스타벅스 로고로 디자인된 스테인리스 텀블러\n■스타벅스 커피 하우스와 동일한 품질의 아라비카 원두를 사용한 파우더 타입 커피",
    product_image_1:
      "https://products.naganorewards.com/KR/STARBUCKS/PremiumCoffee10.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2219",
    brand: "Starbucks",
    sku: "STKITSTKR0254",
    product_eng:
      "Starbucks JDN Cream To Go Cup Tumbler 355 ml + Premium Coffee 10 Pieces",
    product_jpn: "[스타벅스] JDN 크림 투고컵 텀블러 355ml + 프리미엄 커피 10입",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "59,000",
    description_eng:
      "■ It is a tumbler that can be used regardless of season or gender with a cream color color scheme and a simple design.\n■ Powder coffee with Arabica beans of the same quality as Starbucks coffee house",
    description_jpn:
      "■크림 컬러 배색과 심플한 디자인으로 계절과 성별에 구애받지 않고 사용할 수 있는 텀블러입니다.\n■스타벅스 커피하우스와 동일한 품질의 아라비카 원두를 사용한 파우더 커피",
    product_image_1:
      "https://products.naganorewards.com/KR/STARBUCKS/JDNCreamToGoCupTumbler.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2220",
    brand: "Starbucks",
    sku: "STKITSTKR0255",
    product_eng: "Starbucks SS Newton Navy Tumbler 355 ml + Premium Coffee 10p",
    product_jpn: "[스타벅스] SS뉴턴 네이비 텀블러 355ml + 프리미엄 커피 10입",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "59,000",
    description_eng:
      "■It is a stainless steel tumbler with a mug-shaped handle and matte black.\n■Powder type coffee using Arabica beans of the same quality as Starbucks coffee house",
    description_jpn:
      "■머그 형태의 손잡이와 매트 블랙이 돋보이는 스테인레스 텀블러입니다.\n■스타벅스 커피하우스와 동일한 품질의 아라비카 원두를 사용한 파우더 타입 커피",
    product_image_1:
      "https://products.naganorewards.com/KR/STARBUCKS/SSNewtonNavyTumbler.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2221",
    brand: "Starbucks",
    sku: "STKITSTKR0256",
    product_eng:
      "Starbucks SS Lucy White Siren Tumbler 473 ml + Premium Coffee 10p",
    product_jpn:
      "[스타벅스] SS 루시 화이트 사이렌 텀블러 473ml + 프리미엄 커피 10입",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "59,000",
    description_eng:
      "It is a best-selling item of ■ Starbucks and is a stainless steel tumbler with excellent marketability and design as much as it is loved by many people.\n■Powder type coffee using Arabica beans of the same quality as Starbucks coffee house",
    description_jpn:
      "■스타벅스의 베스트셀러 아이템이며, 많은 분들에게 사랑받는 만큼 상품성과 디자인이 뛰어난 스테인레스 텀블러입니다.\n■스타벅스 커피하우스와 동일한 품질의 아라비카 원두를 사용한 파우더 타입 커피",
    product_image_1:
      "https://products.naganorewards.com/KR/STARBUCKS/SSLucyWhiteSirenTumbler.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2222",
    brand: "Starbucks",
    sku: "STKITSTKR0257",
    product_eng:
      "Starbucks 3 kinds of refreshments (Balbam Sweet Potato Bagel Chip) Tray Set",
    product_jpn: "[스타벅스] 다과3종(알밤 고구마 베이글칩) 트레이 세트",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "35,000",
    description_eng:
      "■Composition: Princess chestnut 70 g + sweet potato 80 g + bagel chips 60 g + one among Starbucks Terry's + handle case",
    description_jpn:
      "■구성 : 공주 알밤 70g + 고구마 80g + 베이글칩 60g + 스타벅스 테리이 중 1개 + 손잡이 케이스",
    product_image_1:
      "https://products.naganorewards.com/KR/STARBUCKS/3KindsRefreshments.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2223",
    brand: "Starbucks",
    sku: "STKITSTKR0258",
    product_eng:
      "Starbucks Lucky Choco Snack Set (Teen Case Chocolate + Ferrero Rocher + Lucky Key) Shopping Bag",
    product_jpn:
      "[스타벅스] 행운 초코 간식 세트(틴케이스 초콜렛 + 페레로로쉐 + 행운 열쇠) 쇼핑백 제공",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      "■Composition: Teen Case Chocolate + Ferrero Rocher 3-column + Lucky Key\n■Teencase chocolate will be sent randomly from gold dark chocolate or silver milk chocolate.\n■Lucky keys can be attached as key rings or used as keychains.",
    description_jpn:
      "■구성 : 틴케이스 초콜렛 + 페레로로쉐3구 + 행운 열쇠\n■틴케이스 초콜렛은 골드 다크 초콜릿 or 실버 밀크 초콜릿중 랜덤 발송됩니다.\n■행운열쇠는 키링으로 달거나 열쇠고리로 사용할 수 있습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/STARBUCKS/LuckyChocoSnackSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2224",
    brand: "Starbucks",
    sku: "STKITSTKR0259",
    product_eng:
      "Starbucks Premium Coffee + Sea Friends Candy (Candy) Shopping Bags",
    product_jpn: "[스타벅스] 프리미엄 커피 + 씨프렌즈 캔디(사탕) 쇼핑백 제공",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      "■Composition: Teen case candy 50 g + Starbucks americano 10 ea\n■ Sea Friends Candy 50 g",
    description_jpn:
      "■구성 : 틴케이스 사탕 50g + 스타벅스 아메리카노 10개\n■씨프렌즈 캔디 50g\n■프리미엄 로스트 아메리카노 10개",
    product_image_1:
      "https://products.naganorewards.com/KR/STARBUCKS/PremiumCoffee.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2225",
    brand: "Starbucks",
    sku: "STKITSTKR0260",
    product_eng:
      "Starbucks 5 capsule coffees for Nespresso + 5 TOGO cups set (with paper cup)",
    product_jpn:
      "[스타벅스] 네스프레소용 캡슐커피 5입 + TOGO 컵 5개 세트 (종이컵 동봉)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      "■Composition: 5 houseblends (for Nespresso) + 5 TOGO cups (holder, lid)",
    description_jpn:
      "■구성 : 하우스블렌드 5개(네스프레소용) + TOGO컵(홀더,뚜껑) 5개",
    product_image_1:
      "https://products.naganorewards.com/KR/STARBUCKS/5CapsuleCoffeesNespresso.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2226",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0261",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener Refill 2P Set (Powdery Musk)",
    product_jpn:
      "[로베르타] 세라믹 퍼퓸 차량용 방향제 리필 2P세트(파우더리머스크)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "12,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerRefill.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2227",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0262",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener Refill 2P Set (White Lily)",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 리필 2P세트(화이트릴리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "12,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerRefill.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2228",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0263",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener Refill 2P Set (Green Hub)",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 리필 2P세트(그린허브)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "12,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerRefill.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2229",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0264",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener Refill 2P Set (Black Cherry)",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 리필 2P세트(블랙체리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "12,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerRefill.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2230",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0265",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener Refill 2P Set (Jamon Orange)",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 리필 2P세트(자몽오렌지)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "12,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerRefill.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2231",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0266",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener Refill 2P Set (Clean Cotton)",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 리필 2P세트(클린코튼)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "12,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다.",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerRefill.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2232",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0267",
    product_eng:
      "Roberta Ceramic Perfume Vehicle Air freshener genuine product + Refill 2P (Powdery Musk)",
    product_jpn:
      "[로버타] 세라믹 퍼퓸 자동차 에어프레셔너 본품+리필 2P (파우더리 머스크)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "23,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nConfiguration: main body 1P, refill ceramic 11g x 2P, clip 2P (general 1P, long type 1P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 1P,리필 세라믹 11g x 2P,클립 2P(일반1P, 롱타입1P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2233",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0268",
    product_eng:
      "Roberta Ceramic Perfume Vehicle Air freshener genuine product + Refill 2P (White Lily)",
    product_jpn:
      "[로버타] 세라믹 퍼퓸 자동차 에어프레셔너 본품+리필 2P (화이트 릴리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "23,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nConfiguration: main body 1P, refill ceramic 11g x 2P, clip 2P (general 1P, long type 1P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 1P,리필 세라믹 11g x 2P,클립 2P(일반1P, 롱타입1P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2234",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0269",
    product_eng:
      "Roberta Ceramic Perfume Vehicle Air freshener genuine product + Refill 2P (Green Hub)",
    product_jpn:
      "[로버타] 세라믹 퍼퓸 자동차 에어프레셔너 본품+리필 2P (그린 허브)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "23,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nConfiguration: main body 1P, refill ceramic 11g x 2P, clip 2P (general 1P, long type 1P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 1P,리필 세라믹 11g x 2P,클립 2P(일반1P, 롱타입1P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2235",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0270",
    product_eng:
      "Roberta Ceramic Perfume Vehicle Air freshener genuine product + Refill 2P (Black Cherry)",
    product_jpn:
      "[로버타] 세라믹 퍼퓸 자동차 에어프레셔너 본품+리필 2P (블랙 체리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "23,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nConfiguration: main body 1P, refill ceramic 11g x 2P, clip 2P (general 1P, long type 1P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 1P,리필 세라믹 11g x 2P,클립 2P(일반1P, 롱타입1P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2236",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0271",
    product_eng:
      "Roberta Ceramic Perfume Vehicle Air freshener genuine product + Refill 2P (Jamon Orange)",
    product_jpn:
      "[로버타] 세라믹 퍼퓸 자동차 에어프레셔너 본품+리필 2P (자몽 오렌지)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "23,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nConfiguration: main body 1P, refill ceramic 11g x 2P, clip 2P (general 1P, long type 1P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 1P,리필 세라믹 11g x 2P,클립 2P(일반1P, 롱타입1P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2237",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0272",
    product_eng:
      "Roberta Ceramic Perfume Vehicle Air freshener genuine product + Refill 2P (Clean Cotton)",
    product_jpn:
      "[로버타] 세라믹 퍼퓸 자동차 에어프레셔너 본품+리필 2P (클린 코튼)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "23,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nConfiguration: main body 1P, refill ceramic 11g x 2P, clip 2P (general 1P, long type 1P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 1P,리필 세라믹 11g x 2P,클립 2P(일반1P, 롱타입1P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/CarFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2238",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0273",
    product_eng:
      "Roberta Clip-type Air freshener for Aero Vehicle Set of 2 (Sweet Rose)",
    product_jpn: "[로베르타] 에어로 차량용 클립형 방향제 2종세트(스위트 로즈)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      "1. Its modern and slim design exudes fragrance with the wind of the vehicle's air outlet and makes you feel clear and refreshed when driving.\n2. Designed by world-renowned fashion designer Juliana Camerono, it is elegant and luxurious with a prestigious chrome metal container.\n3. Scent Description:\n1) Sweet Rose: It is a luxurious scent that feels warm and calm as if dawn is brightening, creates an arduous atmosphere, and combines sweet rose scent with orange blossom to create a unique feeling and a smooth finish.\n2) It is a scent that gives a cool and refreshing image by using lime, basil, and rosemary, and you can feel like you are in the middle of a cool sea in the hot summer. It is a scent steered with aroma effects in mind as well as a scent that embodies the image of the blue sea with waves.\n3) Little Forest: It offers a refreshing and fresh scent like the dew of a spring morning, and it is a scent that expresses an innocent, refreshing, subtle, fresh, and luscious scent.\nComposition: 7 ml fragrance bottle, chrome lid, clip + gift case",
    description_jpn:
      "1. 모던하고 슬림한 디자인으로 차량용 송풍구의 바람으로 향기를 뿜어내며 운전시 기분을 맑고 상쾌하게 만들어 줍니다.\n2. 세계적인 패션디자이너 줄리아나 까메리노가 디자인한 세련된 디자인으로 우아하며, 프레스티지한 크롬 메탈용기로 제작되어 고급스럽습니다. \n3. 향설명 : \n1) 스위트로즈 : 여명이 밝아오는듯한, 따뜻하면서 차분한 느낌이 전해지며, 애로틱한 분위기를 연출하며 달콤한 장미향과 오렌지 블러썸이 조화를 이루어 유니크한 느낌과 부드럽게 마무리 되는 고급스러운 향입니다.\n2) 라임, 바질, 로즈마리 등을 사용하여 시원하면서도 상쾌한 이미지를 부여한 향으로서, 무더운 여름에 시원한 바다의 가운데 있는듯한 착각을 느낄수 있습니다. 파도가 일렁이는 푸른바다의 이미지를 형상화한 향뿐아니라 아로마 효과를 염두에 두고 조향한 향입니다.\n3) 리틀포레스트 : 봄날같은 아침의 이슬과같은 싱그럽고 신선한 향취를 선사하고 있으며 청순하면서 상쾌한, 또한 은은하고 산뜻하면서 감미로운 향취를 표현한 향입니다.\n구성 : 향료병 7ml, 크롬뚜껑, 클립 + 기프트케이스",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/ClipFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2239",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0274",
    product_eng:
      "Roberta Clip-type Air freshener for Aero Vehicle Set of 2 (Aqua Fresh)",
    product_jpn:
      "[로베르타] 에어로 차량용 클립형 방향제 2종세트(아쿠아 프레쉬)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "25,000",
    description_eng:
      "1. Its modern and slim design exudes fragrance with the wind of the vehicle's air outlet and makes you feel clear and refreshed when driving.\n2. Designed by world-renowned fashion designer Juliana Camerono, it is elegant and luxurious with a prestigious chrome metal container.\n3. Scent Description:\n1) Sweet Rose: It is a luxurious scent that feels warm and calm as if dawn is brightening, creates an arduous atmosphere, and combines sweet rose scent with orange blossom to create a unique feeling and a smooth finish.\n2) It is a scent that gives a cool and refreshing image by using lime, basil, and rosemary, and you can feel like you are in the middle of a cool sea in the hot summer. It is a scent steered with aroma effects in mind as well as a scent that embodies the image of the blue sea with waves.\n3) Little Forest: It offers a refreshing and fresh scent like the dew of a spring morning, and it is a scent that expresses an innocent, refreshing, subtle, fresh, and luscious scent.\nComposition: 7 ml fragrance bottle, chrome lid, clip + gift case",
    description_jpn:
      "1. 모던하고 슬림한 디자인으로 차량용 송풍구의 바람으로 향기를 뿜어내며 운전시 기분을 맑고 상쾌하게 만들어 줍니다.\n2. 세계적인 패션디자이너 줄리아나 까메리노가 디자인한 세련된 디자인으로 우아하며, 프레스티지한 크롬 메탈용기로 제작되어 고급스럽습니다. \n3. 향설명 : \n1) 스위트로즈 : 여명이 밝아오는듯한, 따뜻하면서 차분한 느낌이 전해지며, 애로틱한 분위기를 연출하며 달콤한 장미향과 오렌지 블러썸이 조화를 이루어 유니크한 느낌과 부드럽게 마무리 되는 고급스러운 향입니다.\n2) 라임, 바질, 로즈마리 등을 사용하여 시원하면서도 상쾌한 이미지를 부여한 향으로서, 무더운 여름에 시원한 바다의 가운데 있는듯한 착각을 느낄수 있습니다. 파도가 일렁이는 푸른바다의 이미지를 형상화한 향뿐아니라 아로마 효과를 염두에 두고 조향한 향입니다.\n3) 리틀포레스트 : 봄날같은 아침의 이슬과같은 싱그럽고 신선한 향취를 선사하고 있으며 청순하면서 상쾌한, 또한 은은하고 산뜻하면서 감미로운 향취를 표현한 향입니다.\n구성 : 향료병 7ml, 크롬뚜껑, 클립 + 기프트케이스",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/ClipFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2240",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0275",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener 2P+Refill 4P (Powdery Musk)",
    product_jpn:
      "[로베르타] 세라믹 퍼퓸 차량용 방향제 2P+리필4P(파우더리머스크)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "46,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nComposition: Body 2P, Refill Ceramic 11g x 4P, Clip 4P (General 2P, Long Type 2P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 2P, 리필 세라믹 11g x 4P,클립 4P(일반2P, 롱타입2P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2241",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0276",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener 2P+Refill 4P (White Lily)",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 2P+리필4P(화이트릴리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "46,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nComposition: Body 2P, Refill Ceramic 11g x 4P, Clip 4P (General 2P, Long Type 2P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 2P, 리필 세라믹 11g x 4P,클립 4P(일반2P, 롱타입2P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2242",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0277",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener 2P+Refill 4P (Green Herb)",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 2P+리필4P(그린허브)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "46,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nComposition: Body 2P, Refill Ceramic 11g x 4P, Clip 4P (General 2P, Long Type 2P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 2P, 리필 세라믹 11g x 4P,클립 4P(일반2P, 롱타입2P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2243",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0278",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener 2P+Refill 4P (Black Cherry)",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 2P+리필4P(블랙체리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "46,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nComposition: Body 2P, Refill Ceramic 11g x 4P, Clip 4P (General 2P, Long Type 2P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 2P, 리필 세라믹 11g x 4P,클립 4P(일반2P, 롱타입2P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2244",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0279",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener 2P+Refill 4P (Jamong Orange)",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 2P+리필4P(자몽오렌지)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "46,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nComposition: Body 2P, Refill Ceramic 11g x 4P, Clip 4P (General 2P, Long Type 2P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 2P, 리필 세라믹 11g x 4P,클립 4P(일반2P, 롱타입2P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2245",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0280",
    product_eng:
      "Roberta Ceramic Perfume Car Air freshener 2P+Refill 4P (Clean Cotton)",
    product_jpn: "[로베르타] 세라믹 퍼퓸 차량용 방향제 2P+리필4P(클린코튼)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "46,000",
    description_eng:
      "1. It is made of natural clay materials that are harmless to the human body, so it is safe to use for a long time.\n2. Experience the holographic effect that is reflected and changed by light.\n3. a soft, subtle scent\n4. Excellent persistence & smell (30 days to 45 days maximum)\n5. global standards of steering and international compliance safe flavoring\n6. High-end air fresheners that are differentiated from scent and interior design\n7. It removes the smell of air conditioners or unpleasant odors in the vehicle.\n8. It is perfect for gifts with luxurious packages.\nComposition: Body 2P, Refill Ceramic 11g x 4P, Clip 4P (General 2P, Long Type 2P)\nWarranty, instruction manual",
    description_jpn:
      "1. 천연 점토 소재로 인체에 무해한 물질로 구성되어 장시간 사용하셔도 안전합니다. \n2. 빛에 따라 반사되어 변하는 홀로그램 효과를 경험해 보세요.\n3. 부드럽고 은은한 향취\n4. 우수한 지속력 & 발향력 (30일~ 최대 45일)\n5. 세계적 기준의 조향과 국제 준수 안전한 향료\n6. 향취와 인테리어까지 차별화된 고급 방향제\n7. 차량 내의 에어컨 냄세나 불쾌한 냄새 등을 없애줍니다. \n8. 고급스러운 패키지 등으로 선물용으로 손색 없습니다. \n구성 : 본체 2P, 리필 세라믹 11g x 4P,클립 4P(일반2P, 롱타입2P)\n보증서, 사용설명서",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeFreshenerSet.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2246",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0281",
    product_eng:
      "Roberta Aero Perfume Diffuser 120 ml Set of 2 NPD12029 (Rose Garden + Monaco Blue)",
    product_jpn:
      "[로베르타] 에어로 퍼퓸 디퓨져 120ml 2종세트 NPD12029(로즈가든+모나코블루)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "31,000",
    description_eng:
      "1. It is a safe and healthy product made with imported natural fragrances that are free of harmful substances.\n(Various Certification Tested Products)\n2. It contains beautiful Italian sensibilities that can be used anywhere other than bedrooms, study rooms, living rooms, bathrooms and dressing rooms.\n3. Scent Description\n1) Rose Garden: It's a romantic pinnacle with a blend of fragrant flowers, a warmth of beautiful, soft cotton wool, and an exquisite blend of furorals.\n2) Monaco Blue: It expresses the rich feeling of fresh nature and emphasizes the rich feeling of everyone's favorite furoral scent and fresh wind, and it is a luxurious scent that finishes off the subtle fruit scent.\n3) Pine tree: It symbolizes the dignity of the noble French aristocrat who expressed high-quality green furorals and vividly expresses the fascinating image of Cleopatra with long straight hair, embodies the flower rain of white petals flying over the blue grass, giving a romantic and bright feeling.\nComposition: 120 ml, stick 4P, gift case x 2 types",
    description_jpn:
      "1. 유해물질이 없는 수입 천연향료로 제작되어 안전하고 건강한 제품입니다.\n(각종 인증 테스트 완료 제품)\n2. 침실, 서재, 거실, 욕실, 드레스룸 외에 어디서나 사용할수 있는 미려한 이탈리안 감성을 담은 제품입니다.\n3. 향 설명\n1) 로즈가든 : 향기로운 꽃들의 조화로움과 아름답고 부드러운 목화솜의 따뜻함을 느낄수 있으며 후로랄이 절묘한 조화를 이루는 로맨틱한 꽂향이 입니다.\n2) 모나코블루 : 프래쉬한 자연의 풍성한 느낌을 표한하였고 누구나 좋아하는 후로랄계열의 향기와 싱그러운 바람의 풍성한 느낌을 강조해주며, 은은한 과일 향기가 마무리되는 고급스러운 향입니다.\n3) 파인트리 : 고품격 그린 후로랄을 표현한 고귀한 프랑스 귀족의 품위를 상징하고 있으며 긴 생머리를 휘날리는 매혹적인 클레오파트라의 이미지를 싱싱하게 표현, 푸른 초원위에서 흩날리는 하얀 꽃잎의 꽃비를 형상화, 로맨틱하고 화사한 느낌을 선사하는 향입니다.\n구성 : 본품 120ml, 스틱 4P, 기프트케이스 x 2종",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeDiffuser120ml.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2247",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0282",
    product_eng:
      "Roberta Aero Perfume Diffuser 120 ml Set of 2 NPD12029 (Rose Garden + Pine Tree)",
    product_jpn:
      "[로베르타] 에어로 퍼퓸 디퓨져 120ml 2종세트 NPD12029(로즈가든+파인트리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "31,000",
    description_eng:
      "1. It is a safe and healthy product made with imported natural fragrances that are free of harmful substances.\n(Various Certification Tested Products)\n2. It contains beautiful Italian sensibilities that can be used anywhere other than bedrooms, study rooms, living rooms, bathrooms and dressing rooms.\n3. Scent Description\n1) Rose Garden: It's a romantic pinnacle with a blend of fragrant flowers, a warmth of beautiful, soft cotton wool, and an exquisite blend of furorals.\n2) Monaco Blue: It expresses the rich feeling of fresh nature and emphasizes the rich feeling of everyone's favorite furoral scent and fresh wind, and it is a luxurious scent that finishes off the subtle fruit scent.\n3) Pine tree: It symbolizes the dignity of the noble French aristocrat who expressed high-quality green furorals and vividly expresses the fascinating image of Cleopatra with long straight hair, embodies the flower rain of white petals flying over the blue grass, giving a romantic and bright feeling.\nComposition: 120 ml, stick 4P, gift case x 2 types",
    description_jpn:
      "1. 유해물질이 없는 수입 천연향료로 제작되어 안전하고 건강한 제품입니다.\n(각종 인증 테스트 완료 제품)\n2. 침실, 서재, 거실, 욕실, 드레스룸 외에 어디서나 사용할수 있는 미려한 이탈리안 감성을 담은 제품입니다.\n3. 향 설명\n1) 로즈가든 : 향기로운 꽃들의 조화로움과 아름답고 부드러운 목화솜의 따뜻함을 느낄수 있으며 후로랄이 절묘한 조화를 이루는 로맨틱한 꽂향이 입니다.\n2) 모나코블루 : 프래쉬한 자연의 풍성한 느낌을 표한하였고 누구나 좋아하는 후로랄계열의 향기와 싱그러운 바람의 풍성한 느낌을 강조해주며, 은은한 과일 향기가 마무리되는 고급스러운 향입니다.\n3) 파인트리 : 고품격 그린 후로랄을 표현한 고귀한 프랑스 귀족의 품위를 상징하고 있으며 긴 생머리를 휘날리는 매혹적인 클레오파트라의 이미지를 싱싱하게 표현, 푸른 초원위에서 흩날리는 하얀 꽃잎의 꽃비를 형상화, 로맨틱하고 화사한 느낌을 선사하는 향입니다.\n구성 : 본품 120ml, 스틱 4P, 기프트케이스 x 2종",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeDiffuser120ml.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2248",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0283",
    product_eng:
      "Roberta Aero Perfume Diffuser 120 ml Set of 2 NPD12029 (Monaco Blue + Pine Tree)",
    product_jpn:
      "[로베르타] 에어로 퍼퓸 디퓨져 120ml 2종세트 NPD12029(모나코블루+파인트리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "31,000",
    description_eng:
      "1. It is a safe and healthy product made with imported natural fragrances that are free of harmful substances.\n(Various Certification Tested Products)\n2. It contains beautiful Italian sensibilities that can be used anywhere other than bedrooms, study rooms, living rooms, bathrooms and dressing rooms.\n3. Scent Description\n1) Rose Garden: It's a romantic pinnacle with a blend of fragrant flowers, a warmth of beautiful, soft cotton wool, and an exquisite blend of furorals.\n2) Monaco Blue: It expresses the rich feeling of fresh nature and emphasizes the rich feeling of everyone's favorite furoral scent and fresh wind, and it is a luxurious scent that finishes off the subtle fruit scent.\n3) Pine tree: It symbolizes the dignity of the noble French aristocrat who expressed high-quality green furorals and vividly expresses the fascinating image of Cleopatra with long straight hair, embodies the flower rain of white petals flying over the blue grass, giving a romantic and bright feeling.\nComposition: 120 ml, stick 4P, gift case x 2 types",
    description_jpn:
      "1. 유해물질이 없는 수입 천연향료로 제작되어 안전하고 건강한 제품입니다.\n(각종 인증 테스트 완료 제품)\n2. 침실, 서재, 거실, 욕실, 드레스룸 외에 어디서나 사용할수 있는 미려한 이탈리안 감성을 담은 제품입니다.\n3. 향 설명\n1) 로즈가든 : 향기로운 꽃들의 조화로움과 아름답고 부드러운 목화솜의 따뜻함을 느낄수 있으며 후로랄이 절묘한 조화를 이루는 로맨틱한 꽂향이 입니다.\n2) 모나코블루 : 프래쉬한 자연의 풍성한 느낌을 표한하였고 누구나 좋아하는 후로랄계열의 향기와 싱그러운 바람의 풍성한 느낌을 강조해주며, 은은한 과일 향기가 마무리되는 고급스러운 향입니다.\n3) 파인트리 : 고품격 그린 후로랄을 표현한 고귀한 프랑스 귀족의 품위를 상징하고 있으며 긴 생머리를 휘날리는 매혹적인 클레오파트라의 이미지를 싱싱하게 표현, 푸른 초원위에서 흩날리는 하얀 꽃잎의 꽃비를 형상화, 로맨틱하고 화사한 느낌을 선사하는 향입니다.\n구성 : 본품 120ml, 스틱 4P, 기프트케이스 x 2종",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/PerfumeDiffuser120ml.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2249",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0284",
    product_eng:
      "Roberta Clip-type Air freshener Set of 3 NLRBG7039 (Sweet Rose)",
    product_jpn:
      "[로베르타] 에어로 차량용 클립형 방향제 3종세트 NCLRBG7039(스위트로즈)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "35,000",
    description_eng:
      "1. Its modern and slim design exudes fragrance with the wind of the vehicle's air outlet and makes you feel clear and refreshed when driving.\n2. Designed by world-renowned fashion designer Juliana Camerono, it is elegant and luxurious with a prestigious chrome metal container.\n3. Scent Description:\n1) Sweet Rose: It is a luxurious scent that feels warm and calm as if dawn is brightening, creates an arduous atmosphere, and combines sweet rose scent with orange blossom to create a unique feeling and a smooth finish.\n2) Aquafresh: It is a scent that gives a cool yet refreshing image by using lime, basil, rosemary, etc., and you can feel like you are in the middle of a cool sea in the hot summer. It is a scent that is steered with an aroma effect in mind as well as a scent that embodies the image of the blue sea with waves.\n3) Little Forest: It offers a refreshing and fresh scent like the dew of a spring morning, and it is a scent that expresses an innocent, refreshing, subtle, fresh, and luscious scent.\nComposition: 7 ml fragrance bottle, chrome lid, clip + gift case\nFragrance composition: Sweet Rose, Aquafresh, Little Forest",
    description_jpn:
      "1. 모던하고 슬림한 디자인으로 차량용 송풍구의 바람으로 향기를 뿜어내며 운전시 기분을 맑고 상쾌하게 만들어 줍니다.\n2. 세계적인 패션디자이너 줄리아나 까메리노가 디자인한 세련된 디자인으로 우아하며, 프레스티지한 크롬 메탈용기로 제작되어 고급스럽습니다. \n3. 향설명 : \n1) 스위트로즈 : 여명이 밝아오는듯한, 따뜻하면서 차분한 느낌이 전해지며, 애로틱한 분위기를 연출하며 달콤한 장미향과 오렌지 블러썸이 조화를 이루어 유니크한 느낌과 부드럽게 마무리 되는 고급스러운 향입니다.\n2) 아쿠아프레쉬 : 라임, 바질, 로즈마리 등을 사용하여 시원하면서도 상쾌한 이미지를 부여한 향으로서, 무더운 여름에 시원한 바다의 가운데 있는듯한 착각을 느낄수 있습니다. 파도가 일렁이는 푸른바다의 이미지를 형상화한 향뿐아니라 아로마 효과를 염두에 두고 조향한 향입니다.\n3) 리틀포레스트 : 봄날같은 아침의 이슬과같은 싱그럽고 신선한 향취를 선사하고 있으며 청순하면서 상쾌한, 또한 은은하고 산뜻하면서 감미로운 향취를 표현한 향입니다.\n구성 : 향료병 7ml, 크롬뚜껑, 클립 + 기프트케이스\n향구성 : 스위트로즈, 아쿠아프레쉬, 리틀포레스트",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/ClipFreshenerSet3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2250",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0285",
    product_eng:
      "Roberta Clip-type Air freshener Set of 3 NLRBG7039 (Aquafresh)",
    product_jpn:
      "[로베르타] 에어로 차량용 클립형 방향제 3종세트 NCLRBG7039(아쿠아프레쉬)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "35,000",
    description_eng:
      "1. Its modern and slim design exudes fragrance with the wind of the vehicle's air outlet and makes you feel clear and refreshed when driving.\n2. Designed by world-renowned fashion designer Juliana Camerono, it is elegant and luxurious with a prestigious chrome metal container.\n3. Scent Description:\n1) Sweet Rose: It is a luxurious scent that feels warm and calm as if dawn is brightening, creates an arduous atmosphere, and combines sweet rose scent with orange blossom to create a unique feeling and a smooth finish.\n2) Aquafresh: It is a scent that gives a cool yet refreshing image by using lime, basil, rosemary, etc., and you can feel like you are in the middle of a cool sea in the hot summer. It is a scent that is steered with an aroma effect in mind as well as a scent that embodies the image of the blue sea with waves.\n3) Little Forest: It offers a refreshing and fresh scent like the dew of a spring morning, and it is a scent that expresses an innocent, refreshing, subtle, fresh, and luscious scent.\nComposition: 7 ml fragrance bottle, chrome lid, clip + gift case\nFragrance composition: Sweet Rose, Aquafresh, Little Forest",
    description_jpn:
      "1. 모던하고 슬림한 디자인으로 차량용 송풍구의 바람으로 향기를 뿜어내며 운전시 기분을 맑고 상쾌하게 만들어 줍니다.\n2. 세계적인 패션디자이너 줄리아나 까메리노가 디자인한 세련된 디자인으로 우아하며, 프레스티지한 크롬 메탈용기로 제작되어 고급스럽습니다. \n3. 향설명 : \n1) 스위트로즈 : 여명이 밝아오는듯한, 따뜻하면서 차분한 느낌이 전해지며, 애로틱한 분위기를 연출하며 달콤한 장미향과 오렌지 블러썸이 조화를 이루어 유니크한 느낌과 부드럽게 마무리 되는 고급스러운 향입니다.\n2) 아쿠아프레쉬 : 라임, 바질, 로즈마리 등을 사용하여 시원하면서도 상쾌한 이미지를 부여한 향으로서, 무더운 여름에 시원한 바다의 가운데 있는듯한 착각을 느낄수 있습니다. 파도가 일렁이는 푸른바다의 이미지를 형상화한 향뿐아니라 아로마 효과를 염두에 두고 조향한 향입니다.\n3) 리틀포레스트 : 봄날같은 아침의 이슬과같은 싱그럽고 신선한 향취를 선사하고 있으며 청순하면서 상쾌한, 또한 은은하고 산뜻하면서 감미로운 향취를 표현한 향입니다.\n구성 : 향료병 7ml, 크롬뚜껑, 클립 + 기프트케이스\n향구성 : 스위트로즈, 아쿠아프레쉬, 리틀포레스트",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/ClipFreshenerSet3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2251",
    brand: "Roberta_dicamerino",
    sku: "RODAIROKR0286",
    product_eng:
      "Roberta Clip-type Air freshener Set of 3 NLRBG7039 (Little Forest)",
    product_jpn:
      "[로베르타] 에어로 차량용 클립형 방향제 3종세트 NCLRBG7039(리틀포레스트)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "35,000",
    description_eng:
      "1. Its modern and slim design exudes fragrance with the wind of the vehicle's air outlet and makes you feel clear and refreshed when driving.\n2. Designed by world-renowned fashion designer Juliana Camerono, it is elegant and luxurious with a prestigious chrome metal container.\n3. Scent Description:\n1) Sweet Rose: It is a luxurious scent that feels warm and calm as if dawn is brightening, creates an arduous atmosphere, and combines sweet rose scent with orange blossom to create a unique feeling and a smooth finish.\n2) Aquafresh: It is a scent that gives a cool yet refreshing image by using lime, basil, rosemary, etc., and you can feel like you are in the middle of a cool sea in the hot summer. It is a scent that is steered with an aroma effect in mind as well as a scent that embodies the image of the blue sea with waves.\n3) Little Forest: It offers a refreshing and fresh scent like the dew of a spring morning, and it is a scent that expresses an innocent, refreshing, subtle, fresh, and luscious scent.\nComposition: 7 ml fragrance bottle, chrome lid, clip + gift case\nFragrance composition: Sweet Rose, Aquafresh, Little Forest",
    description_jpn:
      "1. 모던하고 슬림한 디자인으로 차량용 송풍구의 바람으로 향기를 뿜어내며 운전시 기분을 맑고 상쾌하게 만들어 줍니다.\n2. 세계적인 패션디자이너 줄리아나 까메리노가 디자인한 세련된 디자인으로 우아하며, 프레스티지한 크롬 메탈용기로 제작되어 고급스럽습니다. \n3. 향설명 : \n1) 스위트로즈 : 여명이 밝아오는듯한, 따뜻하면서 차분한 느낌이 전해지며, 애로틱한 분위기를 연출하며 달콤한 장미향과 오렌지 블러썸이 조화를 이루어 유니크한 느낌과 부드럽게 마무리 되는 고급스러운 향입니다.\n2) 아쿠아프레쉬 : 라임, 바질, 로즈마리 등을 사용하여 시원하면서도 상쾌한 이미지를 부여한 향으로서, 무더운 여름에 시원한 바다의 가운데 있는듯한 착각을 느낄수 있습니다. 파도가 일렁이는 푸른바다의 이미지를 형상화한 향뿐아니라 아로마 효과를 염두에 두고 조향한 향입니다.\n3) 리틀포레스트 : 봄날같은 아침의 이슬과같은 싱그럽고 신선한 향취를 선사하고 있으며 청순하면서 상쾌한, 또한 은은하고 산뜻하면서 감미로운 향취를 표현한 향입니다.\n구성 : 향료병 7ml, 크롬뚜껑, 클립 + 기프트케이스\n향구성 : 스위트로즈, 아쿠아프레쉬, 리틀포레스트",
    product_image_1:
      "https://products.naganorewards.com/KR/Roberta_dicamerino/ClipFreshenerSet3.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2252",
    brand: "IBLE",
    sku: "IBFURT5KR0287",
    product_eng:
      "T50 SIDE T501FE Mesh Chair Black Shell TNA501FE (Indigo Blue)",
    product_jpn:
      "[시디즈] T50 SIDE T501FE 메쉬 의자 블랙쉘 [TNA501FE](인디고블루)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "184,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 615×600×915 mm\n* Color: Indigo Blue\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 1 Chair in Korea's Schools, Libraries, and Reading Rooms\n- Glide to help secure the back legs of the chair and the right weight that doesn't push easily\nMinimize movement to help perfect concentration.\n- The S-line back that ideally supports the spine and the thick yet fluffy stand provide the best comfort even if you sit for a long time",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 615*600*915 mm\n* 색상 : 인디고블루\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 국내 학교, 도서관, 독서실 납품 1위 의자\n- 의자 뒷다리에 고정을 돕는 글라이드와 쉽게 밀리지 않는 적당한 무게감이\n움직임을 최소화해 완벽한 집중을 돕습니다.\n- 척추를 이상적으로 지지해주는 S라인 등판과 두툼하면서도 푹신한 좌판으로 오랜 시간 앉아도 최상의 편안함을 제공합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50BlackChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2253",
    brand: "IBLE",
    sku: "IBFURT5KR0288",
    product_eng: "T50 SIDE T501FE Mesh Chair Black Shell TNA501FE (Dark Gray)",
    product_jpn:
      "[시디즈] T50 SIDE T501FE 메쉬 의자 블랙쉘 [TNA501FE](다크그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "184,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 615×600×915 mm\n* Color: Dark Gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 1 Chair in Korea's Schools, Libraries, and Reading Rooms\n- Glide to help secure the back legs of the chair and the right weight that doesn't push easily\nMinimize movement to help perfect concentration.\n- The S-line back that ideally supports the spine and the thick yet fluffy stand provide the best comfort even if you sit for a long time",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 615*600*915 mm\n* 색상 : 다크그레이\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 국내 학교, 도서관, 독서실 납품 1위 의자\n- 의자 뒷다리에 고정을 돕는 글라이드와 쉽게 밀리지 않는 적당한 무게감이\n움직임을 최소화해 완벽한 집중을 돕습니다.\n- 척추를 이상적으로 지지해주는 S라인 등판과 두툼하면서도 푹신한 좌판으로 오랜 시간 앉아도 최상의 편안함을 제공합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50BlackChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2254",
    brand: "IBLE",
    sku: "IBFURT5KR0289",
    product_eng:
      "T50 SIDE T501FE Mesh Chair White Shell TNB501FE (Pebble Gray)",
    product_jpn:
      "[시디즈] T50 SIDE T501FE 메쉬 의자 화이트쉘 [TNB501FE](페블그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "184,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 615×600×915 mm\n* Color: Pebble Gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 1 Chair in Korea's Schools, Libraries, and Reading Rooms\n- Glide to help secure the back legs of the chair and the right weight that doesn't push easily\nMinimize movement to help perfect concentration.\n- The S-line back that ideally supports the spine and the thick yet fluffy stand provide the best comfort even if you sit for a long time",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 615*600*915 mm\n* 색상 : 페블그레이\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n \n- 국내 학교, 도서관, 독서실 납품 1위 의자\n- 의자 뒷다리에 고정을 돕는 글라이드와 쉽게 밀리지 않는 적당한 무게감이\n움직임을 최소화해 완벽한 집중을 돕습니다.\n- 척추를 이상적으로 지지해주는 S라인 등판과 두툼하면서도 푹신한 좌판으로 오랜 시간 앉아도 최상의 편안함을 제공합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2255",
    brand: "IBLE",
    sku: "IBFURT5KR0290",
    product_eng: "T50 SIDE T501FE Mesh Chair White Shell TNB501FE (Sand Beige)",
    product_jpn:
      "[시디즈] T50 SIDE T501FE 메쉬 의자 화이트쉘 [TNB501FE](샌드베이지)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "184,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 615×600×915 mm\n* Color: Sand Beige\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 1 Chair in Korea's Schools, Libraries, and Reading Rooms\n- Glide to help secure the back legs of the chair and the right weight that doesn't push easily\nMinimize movement to help perfect concentration.\n- The S-line back that ideally supports the spine and the thick yet fluffy stand provide the best comfort even if you sit for a long time",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 615*600*915 mm\n* 색상 : 샌드베이지\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n \n- 국내 학교, 도서관, 독서실 납품 1위 의자\n- 의자 뒷다리에 고정을 돕는 글라이드와 쉽게 밀리지 않는 적당한 무게감이\n움직임을 최소화해 완벽한 집중을 돕습니다.\n- 척추를 이상적으로 지지해주는 S라인 등판과 두툼하면서도 푹신한 좌판으로 오랜 시간 앉아도 최상의 편안함을 제공합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2256",
    brand: "IBLE",
    sku: "IBFURT5KR0291",
    product_eng:
      "T50 SIDE T503F Fabric Mesh Chair White Shell TNB503F (Light Gray)",
    product_jpn:
      "[시디즈] T50 SIDE T503F 패브릭 메쉬 의자 화이트쉘 [TNB503F](라이트그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "199,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 620x600x900–960 mm\n* Color: Light Gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 2 Chair in Library and Reading Room Delivery\n- We have revolutionized materials to design so that you don't feel uncomfortable even if you sit for a long time without complicated functions. The integrated design of various colored stalls, a clean white frame, and an S-line that flows along the back curve enhances your seating experience\n- With its diverse lineup, the T50 series perfectly supports users of different body types in a variety of postures. The compact T503F can be used comfortably when looking at simple businesses such as conference rooms or study rooms",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 620x600x900~960 mm\n* 색상 : 라이트그레이\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 도서관, 독서실 납품 2위 의자\n- 복잡한 기능 없이도, 오래도록 앉아 있어도 불편함이 없도록 소재부터 설계까지 획기적으로 만들었습니다. 다양한 컬러 좌판에 깔끔한 화이트 프레임 그리고 등판곡선을 따라 흐르는 S라인의 일체형 디자인이 착석감을 높여드립니다\n- 다양한 라인업을 가진 T50시리즈는 각기 다른 체형을 가진 사용자들의 다양한 자세를 완벽하게 서포트해줍니다. 그 중 컴팩트하게 제작된 T503F는 회의공간이나 서재 등 간단한 용무를 보실 때 편안하게 사용하실 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T503WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2257",
    brand: "IBLE",
    sku: "IBFURT5KR0292",
    product_eng:
      "T50 SIDE T503F Fabric Mesh Chair White Shell TNB503F (Dark Gray)",
    product_jpn:
      "[시디즈] T50 SIDE T503F 패브릭 메쉬 의자 화이트쉘 [TNB503F](다크그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "199,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 620x600x900–960 mm\n* Color: Dark Gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 2 Chair in Library and Reading Room Delivery\n- We have revolutionized materials to design so that you don't feel uncomfortable even if you sit for a long time without complicated functions. The integrated design of various colored stalls, a clean white frame, and an S-line that flows along the back curve enhances your seating experience\n- With its diverse lineup, the T50 series perfectly supports users of different body types in a variety of postures. The compact T503F can be used comfortably when looking at simple businesses such as conference rooms or study rooms",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 620x600x900~960 mm\n* 색상 : 다크그레이\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 도서관, 독서실 납품 2위 의자\n- 복잡한 기능 없이도, 오래도록 앉아 있어도 불편함이 없도록 소재부터 설계까지 획기적으로 만들었습니다. 다양한 컬러 좌판에 깔끔한 화이트 프레임 그리고 등판곡선을 따라 흐르는 S라인의 일체형 디자인이 착석감을 높여드립니다\n- 다양한 라인업을 가진 T50시리즈는 각기 다른 체형을 가진 사용자들의 다양한 자세를 완벽하게 서포트해줍니다. 그 중 컴팩트하게 제작된 T503F는 회의공간이나 서재 등 간단한 용무를 보실 때 편안하게 사용하실 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T503WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2258",
    brand: "IBLE",
    sku: "IBFURT5KR0293",
    product_eng:
      "T50 SIDE T503F Fabric Mesh Chair White Shell TNB503F (Indigo Blue)",
    product_jpn:
      "[시디즈] T50 SIDE T503F 패브릭 메쉬 의자 화이트쉘 [TNB503F](인디고블루)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "199,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 620x600x900–960 mm\n* Color: Indigo Blue\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 2 Chair in Library and Reading Room Delivery\n- We have revolutionized materials to design so that you don't feel uncomfortable even if you sit for a long time without complicated functions. The integrated design of various colored stalls, a clean white frame, and an S-line that flows along the back curve enhances your seating experience\n- With its diverse lineup, the T50 series perfectly supports users of different body types in a variety of postures. The compact T503F can be used comfortably when looking at simple businesses such as conference rooms or study rooms",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 620x600x900~960 mm\n* 색상 : 인디고블루\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 도서관, 독서실 납품 2위 의자\n- 복잡한 기능 없이도, 오래도록 앉아 있어도 불편함이 없도록 소재부터 설계까지 획기적으로 만들었습니다. 다양한 컬러 좌판에 깔끔한 화이트 프레임 그리고 등판곡선을 따라 흐르는 S라인의 일체형 디자인이 착석감을 높여드립니다\n- 다양한 라인업을 가진 T50시리즈는 각기 다른 체형을 가진 사용자들의 다양한 자세를 완벽하게 서포트해줍니다. 그 중 컴팩트하게 제작된 T503F는 회의공간이나 서재 등 간단한 용무를 보실 때 편안하게 사용하실 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T503WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2260",
    brand: "IBLE",
    sku: "IBFURT5KR0295",
    product_eng: "T50 SIDE T503F Fabric Mesh Chair White Shell TNB503F (Green)",
    product_jpn:
      "[시디즈] T50 SIDE T503F 패브릭 메쉬 의자 화이트쉘 [TNB503F](그린)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "199,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 620x600x900–960 mm\n* Color: Green\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- No. 2 Chair in Library and Reading Room Delivery\n- We have revolutionized materials to design so that you don't feel uncomfortable even if you sit for a long time without complicated functions. The integrated design of various colored stalls, a clean white frame, and an S-line that flows along the back curve enhances your seating experience\n- With its diverse lineup, the T50 series perfectly supports users of different body types in a variety of postures. The compact T503F can be used comfortably when looking at simple businesses such as conference rooms or study rooms",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 620x600x900~960 mm\n* 색상 : 그린\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 도서관, 독서실 납품 2위 의자\n- 복잡한 기능 없이도, 오래도록 앉아 있어도 불편함이 없도록 소재부터 설계까지 획기적으로 만들었습니다. 다양한 컬러 좌판에 깔끔한 화이트 프레임 그리고 등판곡선을 따라 흐르는 S라인의 일체형 디자인이 착석감을 높여드립니다\n- 다양한 라인업을 가진 T50시리즈는 각기 다른 체형을 가진 사용자들의 다양한 자세를 완벽하게 서포트해줍니다. 그 중 컴팩트하게 제작된 T503F는 회의공간이나 서재 등 간단한 용무를 보실 때 편안하게 사용하실 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T503WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2261",
    brand: "SIDIZ",
    sku: "SIFURTXKR0296",
    product_eng:
      "TX200HF Tab Plus Mesh Fabric Chair VTNB200HF (Self-assembly) (Dark Gray)",
    product_jpn:
      "[시디즈] TX200HF 탭 플러스 메쉬 패브릭 의자 [VTNB200HF] (셀프조립)(다크그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "214,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 64×60×113.5–128 cm\n* Color: Dark Gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The staff sink function is added to secure the backside with the backside tilted, so you can rest comfortably by leaning on the backside\n- Mesh materials are tightly composed of small holes like mesh, and they are pleasant because they are breathable, and they fit naturally in the shape of the body, which helps blood circulation. TAB PLUS has increased durability by applying more sturdy mesh materials, and you can feel comfortable for a long time\n- The simple and superfluous design and vivid color of Tab Plus go well with various spaces and allow for stylish interior design",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 64 * 60 * 113.5~128  cm  \n* 색상 : 다크그레이\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 등판이 젖혀진 상태로 고정되는 스탭 싱크 기능이 추가되어, 등판에 기대어 편하게 휴식할 수 있습니다\n- 메쉬 소재는 그물망처럼 작은 구멍으로 촘촘하게 구성된 소재를 말하며, 통기성이 좋기 때문에 땀이 차지 않아 쾌적하며 몸의 형태에 자연스럽게 맞춰져서 혈액 순환에 도움이 됩니다. TAB PLUS는 더욱 견고해진 메쉬 소재를 적용하여 내구성을 높였으며, 오랜기간 쾌적함을 느낄 수 있습니다\n- 탭 플러스의 심플하고 군더더기 없는 디자인과 선명한 컬러는 다양한 공간에 잘 어울리며스타일리쉬한 인테리어 구성이 가능합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/TX200HFChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2262",
    brand: "SIDIZ",
    sku: "SIFURTXKR0297",
    product_eng:
      "TX200HF Tab Plus Mesh Fabric Chair VTNB200HF (Self-assembly) (Ocean Blue)",
    product_jpn:
      "[시디즈] TX200HF 탭 플러스 메쉬 패브릭 의자 [VTNB200HF] (셀프조립)(오션블루)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "214,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 64×60×113.5–128 cm\n* Color: Ocean Blue\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The staff sink function is added to secure the backside with the backside tilted, so you can rest comfortably by leaning on the backside\n- Mesh materials are tightly composed of small holes like mesh, and they are pleasant because they are breathable, and they fit naturally in the shape of the body, which helps blood circulation. TAB PLUS has increased durability by applying more sturdy mesh materials, and you can feel comfortable for a long time\n- The simple and superfluous design and vivid color of Tab Plus go well with various spaces and allow for stylish interior design",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 64 * 60 * 113.5~128  cm  \n* 색상 : 오션블루\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 등판이 젖혀진 상태로 고정되는 스탭 싱크 기능이 추가되어, 등판에 기대어 편하게 휴식할 수 있습니다\n- 메쉬 소재는 그물망처럼 작은 구멍으로 촘촘하게 구성된 소재를 말하며, 통기성이 좋기 때문에 땀이 차지 않아 쾌적하며 몸의 형태에 자연스럽게 맞춰져서 혈액 순환에 도움이 됩니다. TAB PLUS는 더욱 견고해진 메쉬 소재를 적용하여 내구성을 높였으며, 오랜기간 쾌적함을 느낄 수 있습니다\n- 탭 플러스의 심플하고 군더더기 없는 디자인과 선명한 컬러는 다양한 공간에 잘 어울리며스타일리쉬한 인테리어 구성이 가능합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/TX200HFChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2263",
    brand: "SIDIZ",
    sku: "SIFURTXKR0298",
    product_eng:
      "TX200HF Tab Plus Mesh Fabric Chair VTNB200HF (Self-assembly) (Worm Sand)",
    product_jpn:
      "[시디즈] TX200HF 탭 플러스 메쉬 패브릭 의자 [VTNB200HF] (셀프조립)(웜샌드)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "214,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 64×60×113.5–128 cm\n* Color: Warm Sand\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The staff sink function is added to secure the backside with the backside tilted, so you can rest comfortably by leaning on the backside\n- Mesh materials are tightly composed of small holes like mesh, and they are pleasant because they are breathable, and they fit naturally in the shape of the body, which helps blood circulation. TAB PLUS has increased durability by applying more sturdy mesh materials, and you can feel comfortable for a long time\n- The simple and superfluous design and vivid color of Tab Plus go well with various spaces and allow for stylish interior design",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 64 * 60 * 113.5~128  cm  \n* 색상 : 웜샌드\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 등판이 젖혀진 상태로 고정되는 스탭 싱크 기능이 추가되어, 등판에 기대어 편하게 휴식할 수 있습니다\n- 메쉬 소재는 그물망처럼 작은 구멍으로 촘촘하게 구성된 소재를 말하며, 통기성이 좋기 때문에 땀이 차지 않아 쾌적하며 몸의 형태에 자연스럽게 맞춰져서 혈액 순환에 도움이 됩니다. TAB PLUS는 더욱 견고해진 메쉬 소재를 적용하여 내구성을 높였으며, 오랜기간 쾌적함을 느낄 수 있습니다\n- 탭 플러스의 심플하고 군더더기 없는 디자인과 선명한 컬러는 다양한 공간에 잘 어울리며스타일리쉬한 인테리어 구성이 가능합니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/TX200HFChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2264",
    brand: "SIDIZ",
    sku: "SIFURSIKR0299",
    product_eng:
      "Siddies T25 Mesh Rotating Chair WhiteShell TXNA250F (Ashgreen, Beige, Gray) Select 1",
    product_jpn:
      "[시디즈] T25 메쉬 회전형 의자 화이트쉘 [TXNA250F](애쉬그린,베이지,그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "299,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 65 x 59.5 x 90.5 cm to 100.5 cm\n* Color: Ash Green, Beige, Gray\n* Material: Fabric, foamed sponge, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- It stretches the body through tilting and helps improve the child's concentration by relieving accumulated fatigue through long-term learning\n- T25's Weight Activated Tilt Weight Sensitive Tilt (WAT) detects the user's weight\nIt adjusts the strength of the backside properly without any separate manipulation\n- The T25's uphill and stall stream lines are designed to take into account the shape of the human body and the movement of the user. The uphill stream lines of different thicknesses and lengths provide better adhesion and ventilation, while at the same time providing more natural and stable support for the movement of the user. The stream lines inside the stall are\nIt effectively distributes the load on the stall, so it is comfortable even when sitting for a long time\n-Depending on the seating experience desired by the user, you can choose a breathable 'mesh lamp' and a 'flex lamp' that supports various postures. You can also purchase a separate fabric cover for the 'flex lamp' to add a soft touch",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 65 x 59.5 x 90.5 ~100.5 cm  \n* 색상 :애쉬그린, 베이지, 그레이\n* 소재 : 패브릭, 발포 스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 틸팅을 통해 몸을 스트레칭 하며, 장시간 학습으로 누적된 피로를 완화시켜줄 수 있어 아이의 집중력 향상에 도움을 줍니다\n- T25의 WAT (Weight Activated Tilt 체중감응형 틸트)는 사용자의 체중을 감지하여 \n별도의 조작 없이도 등판 젖히는 강도를 적절하게 조절해줍니다\n- T25의 등판과 좌판 스트림 라인은 인체의 형상과 사용자의 움직임을 고려하여 설계되었습니다. 서로 다른 굵기와 길이의 등판 스트림 라인은 밀착감과 통기성을 좋게 하고, 동시에 사용자의 움직임을 더욱 자연스럽고 안정감있게 지지해 줍니다. 좌판 내부의 스트림 라인은 \n좌판에 가해지는 하중을 효과적으로 분산시켜 장시간 착석시에도 편안합니다\n-사용자가 원하는 착석감에 따라 통기성이 우수한 '메쉬등판', 다양한 자세를 지지하는 '플렉스 등판'을 선택할 수 있습니다. 또한 '플렉스 등판'을 위한 패브릭 커버를 별도 구매하여, 부드러운 감촉을 더할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T25WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2265",
    brand: "SIDIZ",
    sku: "SIFURSIKR0300",
    product_eng:
      "Siddies T25 Mesh Rotating Chair WhiteShell TXNA250F (Beige, Gray)",
    product_jpn:
      "[시디즈] T25 메쉬 회전형 의자 화이트쉘 [TXNA250F](베이지,그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "299,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 65 x 59.5 x 90.5 cm to 100.5 cm\n* Color: Beige, Gray\n* Material: Fabric, foamed sponge, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- It stretches the body through tilting and helps improve the child's concentration by relieving accumulated fatigue through long-term learning\n- T25's Weight Activated Tilt Weight Sensitive Tilt (WAT) detects the user's weight\nIt adjusts the strength of the backside properly without any separate manipulation\n- The T25's uphill and stall stream lines are designed to take into account the shape of the human body and the movement of the user. The uphill stream lines of different thicknesses and lengths provide better adhesion and ventilation, while at the same time providing more natural and stable support for the movement of the user. The stream lines inside the stall are\nIt effectively distributes the load on the stall, so it is comfortable even when sitting for a long time\n-Depending on the seating experience desired by the user, you can choose a breathable 'mesh lamp' and a 'flex lamp' that supports various postures. You can also purchase a separate fabric cover for the 'flex lamp' to add a soft touch",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 65 x 59.5 x 90.5 ~100.5 cm  \n* 색상 :베이지, 그레이\n* 소재 : 패브릭, 발포 스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 틸팅을 통해 몸을 스트레칭 하며, 장시간 학습으로 누적된 피로를 완화시켜줄 수 있어 아이의 집중력 향상에 도움을 줍니다\n- T25의 WAT (Weight Activated Tilt 체중감응형 틸트)는 사용자의 체중을 감지하여 \n별도의 조작 없이도 등판 젖히는 강도를 적절하게 조절해줍니다\n- T25의 등판과 좌판 스트림 라인은 인체의 형상과 사용자의 움직임을 고려하여 설계되었습니다. 서로 다른 굵기와 길이의 등판 스트림 라인은 밀착감과 통기성을 좋게 하고, 동시에 사용자의 움직임을 더욱 자연스럽고 안정감있게 지지해 줍니다. 좌판 내부의 스트림 라인은 \n좌판에 가해지는 하중을 효과적으로 분산시켜 장시간 착석시에도 편안합니다\n-사용자가 원하는 착석감에 따라 통기성이 우수한 '메쉬등판', 다양한 자세를 지지하는 '플렉스 등판'을 선택할 수 있습니다. 또한 '플렉스 등판'을 위한 패브릭 커버를 별도 구매하여, 부드러운 감촉을 더할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T25WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2266",
    brand: "SIDIZ",
    sku: "SIFURSIKR0301",
    product_eng:
      "Siddies T50 Series T500HLDA Mesh Chair (VTNE500HLDA) (Light Gray)",
    product_jpn:
      "[시디즈] T50 시리즈 T500HLDA 메쉬 의자 (VTNE500HLDA)(라이트그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "359,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67×64.5×108–122 cm\n* Color: Light Gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T50 is the most ideal support for the waist from this ergonomic point of view, and at the same time the most\nIt was developed with an S-Curve motif to have a natural and beautiful appearance\n- Many of the scientifically designed T50's features not only support your vital neck and waist, but also help you optimally customize each part according to your height and body type\n-T50 chairs are applied with a variety of high-quality mesh materials, from high-quality polyester mesh to striped mesh to double lasel mesh, which are different from low-cost mesh chairs, providing both comfort and comfort\n- The T500HLDA is designed to make it easy to replace the seat at home, so you can always use the chair for a long time as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67x64.5x108~122 cm \n* 색상 :그레이\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- T50은 이러한 인간공학적인 관점에서 허리를가장 이상적으로 지지하며, 동시에 가장\n자연스럽고 아름다운 모습을 가지기 위해 S-Curve 형태를 모티브로 개발 되었습니다\n- 과학적으로 설계된 T50의 많은 기능은 당신의 중요한 목과 허리를 든든하게 지지할 뿐만 아니라 키와 체형에 따라 손쉽게 각부분을 최적으로 맞춤화하여 사용하도록 지원합니다\n-T50 의자는 저가 메쉬 의자들과는 차원이 다른 고품질 폴리에스테르 메쉬부터 스트라이프 메쉬, 더블 라셀 메쉬까지 다양한 고급 메쉬 소재를 적용하여 편안함과 쾌적함을 동시에 제공합니다\n- T500HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50MeshChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2267",
    brand: "SIDIZ",
    sku: "SIFURSIKR0302",
    product_eng: "Siddies T50 Series T500HLDA Mesh Chair (VTNE500HLDA) (Ivory)",
    product_jpn:
      "[시디즈] T50 시리즈 T500HLDA 메쉬 의자 (VTNE500HLDA)(아이보리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "359,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67×64.5×108–122 cm\n* Color: Ivory\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T50 is the most ideal support for the waist from this ergonomic point of view, and at the same time the most\nIt was developed with an S-Curve motif to have a natural and beautiful appearance\n- Many of the scientifically designed T50's features not only support your vital neck and waist, but also help you optimally customize each part according to your height and body type\n-T50 chairs are applied with a variety of high-quality mesh materials, from high-quality polyester mesh to striped mesh to double lasel mesh, which are different from low-cost mesh chairs, providing both comfort and comfort\n- The T500HLDA is designed to make it easy to replace the seat at home, so you can always use the chair for a long time as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67x64.5x108~122 cm \n* 색상 :아이보리\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- T50은 이러한 인간공학적인 관점에서 허리를가장 이상적으로 지지하며, 동시에 가장\n자연스럽고 아름다운 모습을 가지기 위해 S-Curve 형태를 모티브로 개발 되었습니다\n- 과학적으로 설계된 T50의 많은 기능은 당신의 중요한 목과 허리를 든든하게 지지할 뿐만 아니라 키와 체형에 따라 손쉽게 각부분을 최적으로 맞춤화하여 사용하도록 지원합니다\n-T50 의자는 저가 메쉬 의자들과는 차원이 다른 고품질 폴리에스테르 메쉬부터 스트라이프 메쉬, 더블 라셀 메쉬까지 다양한 고급 메쉬 소재를 적용하여 편안함과 쾌적함을 동시에 제공합니다\n- T500HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50MeshChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2268",
    brand: "SIDIZ",
    sku: "SIFURSIKR0303",
    product_eng:
      "Siddies T50 Series T500HLDA Mesh Chair (VTNE500HLDA) (Dark Gray)",
    product_jpn:
      "[시디즈] T50 시리즈 T500HLDA 메쉬 의자 (VTNE500HLDA)(다크그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "359,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67×64.5×108–122 cm\n* Color: Dark Gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T50 is the most ideal support for the waist from this ergonomic point of view, and at the same time the most\nIt was developed with an S-Curve motif to have a natural and beautiful appearance\n- Many of the scientifically designed T50's features not only support your vital neck and waist, but also help you optimally customize each part according to your height and body type\n-T50 chairs are applied with a variety of high-quality mesh materials, from high-quality polyester mesh to striped mesh to double lasel mesh, which are different from low-cost mesh chairs, providing both comfort and comfort\n- The T500HLDA is designed to make it easy to replace the seat at home, so you can always use the chair for a long time as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67x64.5x108~122 cm \n* 색상 :다크그레이 \n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- T50은 이러한 인간공학적인 관점에서 허리를가장 이상적으로 지지하며, 동시에 가장\n자연스럽고 아름다운 모습을 가지기 위해 S-Curve 형태를 모티브로 개발 되었습니다\n- 과학적으로 설계된 T50의 많은 기능은 당신의 중요한 목과 허리를 든든하게 지지할 뿐만 아니라 키와 체형에 따라 손쉽게 각부분을 최적으로 맞춤화하여 사용하도록 지원합니다\n-T50 의자는 저가 메쉬 의자들과는 차원이 다른 고품질 폴리에스테르 메쉬부터 스트라이프 메쉬, 더블 라셀 메쉬까지 다양한 고급 메쉬 소재를 적용하여 편안함과 쾌적함을 동시에 제공합니다\n- T500HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50MeshChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2269",
    brand: "SIDIZ",
    sku: "SIFURSIKR0304",
    product_eng: "Siddies T50 Series T500HLDA Mesh Chair (VTNE500HLDA) (Green)",
    product_jpn: "[시디즈] T50 시리즈 T500HLDA 메쉬 의자 (VTNE500HLDA)(그린)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "359,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67×64.5×108–122 cm\n* Color: Green\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T50 is the most ideal support for the waist from this ergonomic point of view, and at the same time the most\nIt was developed with an S-Curve motif to have a natural and beautiful appearance\n- Many of the scientifically designed T50's features not only support your vital neck and waist, but also help you optimally customize each part according to your height and body type\n-T50 chairs are applied with a variety of high-quality mesh materials, from high-quality polyester mesh to striped mesh to double lasel mesh, which are different from low-cost mesh chairs, providing both comfort and comfort\n- The T500HLDA is designed to make it easy to replace the seat at home, so you can always use the chair for a long time as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67x64.5x108~122 cm \n* 색상 :딥그린 \n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- T50은 이러한 인간공학적인 관점에서 허리를가장 이상적으로 지지하며, 동시에 가장\n자연스럽고 아름다운 모습을 가지기 위해 S-Curve 형태를 모티브로 개발 되었습니다\n- 과학적으로 설계된 T50의 많은 기능은 당신의 중요한 목과 허리를 든든하게 지지할 뿐만 아니라 키와 체형에 따라 손쉽게 각부분을 최적으로 맞춤화하여 사용하도록 지원합니다\n-T50 의자는 저가 메쉬 의자들과는 차원이 다른 고품질 폴리에스테르 메쉬부터 스트라이프 메쉬, 더블 라셀 메쉬까지 다양한 고급 메쉬 소재를 적용하여 편안함과 쾌적함을 동시에 제공합니다\n- T500HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50MeshChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2270",
    brand: "SIDIZ",
    sku: "SIFURSIKR0305",
    product_eng:
      "Siddies T52 T500HLDA Air Mesh Chair Black Shell TXA520HLDA (Gray)",
    product_jpn:
      "[시디즈] T52 T500HLDA 에어 메쉬 의자 블랙쉘 [TXA520HLDA](그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "389,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.0×52.5×108–122 cm\n* Color: Gray\n* Material: mesh, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- AirSkin Mesh uses Hytrel® raw materials from DuPont, the world's leading chemical company\nIt is made of strong elastic yarn, so it is very stretchable and elastic.\n- The T50 AIR stall is designed to be open-frame to keep thighs out of touch. The elasticity and elasticity of the air skin mesh meets the stall structure of the open-frame to evenly distribute body pressure\nYou can feel comfortable and comfortable in various positions, such as tilting forward or leaning against your back\n- Multi-sink is applied to the T50 AIR series to adjust the tilting strength in detailed steps tailored to the user, and adjust the lumber support, headrest, and armrest to fit the user's body\nYou can use it comfortably",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.0*52.5*108~122 cm  \n* 색상 : 그레이\n* 소재 : 메쉬, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 에어스킨 메쉬는 세계 최고 화학 전문 기업인 미국 듀폰사의 Hytrel® 원료를 이용한 \n강력 탄성사로 구성되어, 신축성과 탄력성이 매우 뛰어납니다.\n- T50 AIR 좌판은 허벅지가 닿지 않도록 오픈 프레임으로 설계되었습니다. 신축성과 탄력성이 뛰어난 에어스킨 메쉬와 오픈프레임의 좌판 구조가 만나, 체압을 고르게 분산시켜주어 \n앞으로 기울이거나, 등에 기대는 등 다양한 자세에서 쾌적함과 편안함을 느낄 수 있습니다\n- T50 AIR 시리즈에는 멀티 싱크가 적용되어, 사용자에게 맞추어 세밀한 단계로 틸팅 강도 조절이 가능하며, 럼버서포트, 헤드레스트, 팔걸이등을 사용자의 몸에 맞도록 조절하여\n편안하게 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T52BlackChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2271",
    brand: "SIDIZ",
    sku: "SIFURSIKR0306",
    product_eng:
      "Siddies T52 T500HLDA Air Mesh Chair Black Shell TXA520HLDA (Black)",
    product_jpn:
      "[시디즈] T52 T500HLDA 에어 메쉬 의자 블랙쉘 [TXA520HLDA](블랙)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "389,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.0×52.5×108–122 cm\n* Color: Black\n* Material: mesh, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- AirSkin Mesh uses Hytrel® raw materials from DuPont, the world's leading chemical company\nIt is made of strong elastic yarn, so it is very stretchable and elastic.\n- The T50 AIR stall is designed to be open-frame to keep thighs out of touch. The elasticity and elasticity of the air skin mesh meets the stall structure of the open-frame to evenly distribute body pressure\nYou can feel comfortable and comfortable in various positions, such as tilting forward or leaning against your back\n- Multi-sink is applied to the T50 AIR series to adjust the tilting strength in detailed steps tailored to the user, and adjust the lumber support, headrest, and armrest to fit the user's body\nYou can use it comfortably",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.0*52.5*108~122 cm  \n* 색상 : 블랙\n* 소재 : 메쉬, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 에어스킨 메쉬는 세계 최고 화학 전문 기업인 미국 듀폰사의 Hytrel® 원료를 이용한 \n강력 탄성사로 구성되어, 신축성과 탄력성이 매우 뛰어납니다.\n- T50 AIR 좌판은 허벅지가 닿지 않도록 오픈 프레임으로 설계되었습니다. 신축성과 탄력성이 뛰어난 에어스킨 메쉬와 오픈프레임의 좌판 구조가 만나, 체압을 고르게 분산시켜주어 \n앞으로 기울이거나, 등에 기대는 등 다양한 자세에서 쾌적함과 편안함을 느낄 수 있습니다\n- T50 AIR 시리즈에는 멀티 싱크가 적용되어, 사용자에게 맞추어 세밀한 단계로 틸팅 강도 조절이 가능하며, 럼버서포트, 헤드레스트, 팔걸이등을 사용자의 몸에 맞도록 조절하여\n편안하게 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T52BlackChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2272",
    brand: "SIDIZ",
    sku: "SIFURSIKR0307",
    product_eng:
      "Siddies T52 T500HLDA Air Mesh Chair Black Shell TXA520HLDA  (Red)",
    product_jpn:
      "[시디즈] T52 T500HLDA 에어 메쉬 의자 블랙쉘 [TXA520HLDA](레드)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "389,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.0×52.5×108–122 cm\n* Color: Red\n* Material: mesh, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- AirSkin Mesh uses Hytrel® raw materials from DuPont, the world's leading chemical company\nIt is made of strong elastic yarn, so it is very stretchable and elastic.\n- The T50 AIR stall is designed to be open-frame to keep thighs out of touch. The elasticity and elasticity of the air skin mesh meets the stall structure of the open-frame to evenly distribute body pressure\nYou can feel comfortable and comfortable in various positions, such as tilting forward or leaning against your back\n- Multi-sink is applied to the T50 AIR series to adjust the tilting strength in detailed steps tailored to the user, and adjust the lumber support, headrest, and armrest to fit the user's body\nYou can use it comfortably",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.0*52.5*108~122 cm  \n* 색상 : 빨간색\n* 소재 : 메쉬, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 에어스킨 메쉬는 세계 최고 화학 전문 기업인 미국 듀폰사의 Hytrel® 원료를 이용한 \n강력 탄성사로 구성되어, 신축성과 탄력성이 매우 뛰어납니다.\n- T50 AIR 좌판은 허벅지가 닿지 않도록 오픈 프레임으로 설계되었습니다. 신축성과 탄력성이 뛰어난 에어스킨 메쉬와 오픈프레임의 좌판 구조가 만나, 체압을 고르게 분산시켜주어 \n앞으로 기울이거나, 등에 기대는 등 다양한 자세에서 쾌적함과 편안함을 느낄 수 있습니다\n- T50 AIR 시리즈에는 멀티 싱크가 적용되어, 사용자에게 맞추어 세밀한 단계로 틸팅 강도 조절이 가능하며, 럼버서포트, 헤드레스트, 팔걸이등을 사용자의 몸에 맞도록 조절하여\n편안하게 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T52BlackChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2273",
    brand: "SIDIZ",
    sku: "SIFURSIKR0308",
    product_eng:
      "Siddies T52 T500HLDA Air Mesh Chair Black Shell TXA520HLDA (Blue)",
    product_jpn:
      "[시디즈] T52 T500HLDA 에어 메쉬 의자 블랙쉘 [TXA520HLDA](블루)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "389,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.0×52.5×108–122 cm\n* Color: Blue\n* Material: mesh, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- AirSkin Mesh uses Hytrel® raw materials from DuPont, the world's leading chemical company\nIt is made of strong elastic yarn, so it is very stretchable and elastic.\n- The T50 AIR stall is designed to be open-frame to keep thighs out of touch. The elasticity and elasticity of the air skin mesh meets the stall structure of the open-frame to evenly distribute body pressure\nYou can feel comfortable and comfortable in various positions, such as tilting forward or leaning against your back\n- Multi-sink is applied to the T50 AIR series to adjust the tilting strength in detailed steps tailored to the user, and adjust the lumber support, headrest, and armrest to fit the user's body\nYou can use it comfortably",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.0*52.5*108~122 cm  \n* 색상 : 블루\n* 소재 : 메쉬, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 에어스킨 메쉬는 세계 최고 화학 전문 기업인 미국 듀폰사의 Hytrel® 원료를 이용한 \n강력 탄성사로 구성되어, 신축성과 탄력성이 매우 뛰어납니다.\n- T50 AIR 좌판은 허벅지가 닿지 않도록 오픈 프레임으로 설계되었습니다. 신축성과 탄력성이 뛰어난 에어스킨 메쉬와 오픈프레임의 좌판 구조가 만나, 체압을 고르게 분산시켜주어 \n앞으로 기울이거나, 등에 기대는 등 다양한 자세에서 쾌적함과 편안함을 느낄 수 있습니다\n- T50 AIR 시리즈에는 멀티 싱크가 적용되어, 사용자에게 맞추어 세밀한 단계로 틸팅 강도 조절이 가능하며, 럼버서포트, 헤드레스트, 팔걸이등을 사용자의 몸에 맞도록 조절하여\n편안하게 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T52BlackChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2274",
    brand: "SIDIZ",
    sku: "SIFURSIKR0309",
    product_eng:
      "Siddies T50 T500HLDA White Shell Mesh Chair VTNF500HLDA (Light Gray)",
    product_jpn:
      "[시디즈] T50 T500HLDA 화이트쉘 메쉬 의자 [VTNF500HLDA](라이트그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "369,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67×64.5×108–122 cm\n* Color: Light Gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T50 is the most ideal support for the waist from this ergonomic point of view, and at the same time the most\nIt was developed with an S-Curve motif to have a natural and beautiful appearance\n- Many of the scientifically designed T50's features not only support your vital neck and waist, but also help you optimally customize each part according to your height and body type\n-T50 chairs are applied with a variety of high-quality mesh materials, from high-quality polyester mesh to striped mesh to double lasel mesh, which are different from low-cost mesh chairs, providing both comfort and comfort\n- The T500HLDA is designed to make it easy to replace the seat at home, so you can always use the chair for a long time as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67x64.5x108~122 cm\n* 색상 : 그레이\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- T50은 이러한 인간공학적인 관점에서 허리를가장 이상적으로 지지하며, 동시에 가장\n자연스럽고 아름다운 모습을 가지기 위해 S-Curve 형태를 모티브로 개발 되었습니다\n- 과학적으로 설계된 T50의 많은 기능은 당신의 중요한 목과 허리를 든든하게 지지할 뿐만 아니라 키와 체형에 따라 손쉽게 각부분을 최적으로 맞춤화하여 사용하도록 지원합니다\n-T50 의자는 저가 메쉬 의자들과는 차원이 다른 고품질 폴리에스테르 메쉬부터 스트라이프 메쉬, 더블 라셀 메쉬까지 다양한 고급 메쉬 소재를 적용하여 편안함과 쾌적함을 동시에 제공합니다\n- T500HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50WhiteMesh.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2275",
    brand: "SIDIZ",
    sku: "SIFURSIKR0310",
    product_eng:
      "Siddies T50 T500HLDA White Shell Mesh Chair VTNF500HLDA (Ivory)",
    product_jpn:
      "[시디즈] T50 T500HLDA 화이트쉘 메쉬 의자 [VTNF500HLDA](아이보리)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "369,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67×64.5×108–122 cm\n* Color: Ivory\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T50 is the most ideal support for the waist from this ergonomic point of view, and at the same time the most\nIt was developed with an S-Curve motif to have a natural and beautiful appearance\n- Many of the scientifically designed T50's features not only support your vital neck and waist, but also help you optimally customize each part according to your height and body type\n-T50 chairs are applied with a variety of high-quality mesh materials, from high-quality polyester mesh to striped mesh to double lasel mesh, which are different from low-cost mesh chairs, providing both comfort and comfort\n- The T500HLDA is designed to make it easy to replace the seat at home, so you can always use the chair for a long time as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67x64.5x108~122 cm\n* 색상 : 아이보리\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- T50은 이러한 인간공학적인 관점에서 허리를가장 이상적으로 지지하며, 동시에 가장\n자연스럽고 아름다운 모습을 가지기 위해 S-Curve 형태를 모티브로 개발 되었습니다\n- 과학적으로 설계된 T50의 많은 기능은 당신의 중요한 목과 허리를 든든하게 지지할 뿐만 아니라 키와 체형에 따라 손쉽게 각부분을 최적으로 맞춤화하여 사용하도록 지원합니다\n-T50 의자는 저가 메쉬 의자들과는 차원이 다른 고품질 폴리에스테르 메쉬부터 스트라이프 메쉬, 더블 라셀 메쉬까지 다양한 고급 메쉬 소재를 적용하여 편안함과 쾌적함을 동시에 제공합니다\n- T500HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50WhiteMesh.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2276",
    brand: "SIDIZ",
    sku: "SIFURSIKR0311",
    product_eng:
      "Siddies T50 T500HLDA White Shell Mesh Chair VTNF500HLDA (Coral)",
    product_jpn: "[시디즈] T50 T500HLDA 화이트쉘 메쉬 의자 [VTNF500HLDA](코랄)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "369,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67×64.5×108–122 cm\n* Color: Coral\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T50 is the most ideal support for the waist from this ergonomic point of view, and at the same time the most\nIt was developed with an S-Curve motif to have a natural and beautiful appearance\n- Many of the scientifically designed T50's features not only support your vital neck and waist, but also help you optimally customize each part according to your height and body type\n-T50 chairs are applied with a variety of high-quality mesh materials, from high-quality polyester mesh to striped mesh to double lasel mesh, which are different from low-cost mesh chairs, providing both comfort and comfort\n- The T500HLDA is designed to make it easy to replace the seat at home, so you can always use the chair for a long time as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67x64.5x108~122 cm\n* 색상 : 코랄\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- T50은 이러한 인간공학적인 관점에서 허리를가장 이상적으로 지지하며, 동시에 가장\n자연스럽고 아름다운 모습을 가지기 위해 S-Curve 형태를 모티브로 개발 되었습니다\n- 과학적으로 설계된 T50의 많은 기능은 당신의 중요한 목과 허리를 든든하게 지지할 뿐만 아니라 키와 체형에 따라 손쉽게 각부분을 최적으로 맞춤화하여 사용하도록 지원합니다\n-T50 의자는 저가 메쉬 의자들과는 차원이 다른 고품질 폴리에스테르 메쉬부터 스트라이프 메쉬, 더블 라셀 메쉬까지 다양한 고급 메쉬 소재를 적용하여 편안함과 쾌적함을 동시에 제공합니다\n- T500HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50WhiteMesh.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2277",
    brand: "SIDIZ",
    sku: "SIFURSIKR0312",
    product_eng:
      "Siddies T50 T500HLDA White Shell Mesh Chair VTNF500HLDA (Green)",
    product_jpn: "[시디즈] T50 T500HLDA 화이트쉘 메쉬 의자 [VTNF500HLDA](그린)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "369,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67×64.5×108–122 cm\n* Color: Green\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- The T50 is the most ideal support for the waist from this ergonomic point of view, and at the same time the most\nIt was developed with an S-Curve motif to have a natural and beautiful appearance\n- Many of the scientifically designed T50's features not only support your vital neck and waist, but also help you optimally customize each part according to your height and body type\n-T50 chairs are applied with a variety of high-quality mesh materials, from high-quality polyester mesh to striped mesh to double lasel mesh, which are different from low-cost mesh chairs, providing both comfort and comfort\n- The T500HLDA is designed to make it easy to replace the seat at home, so you can always use the chair for a long time as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67x64.5x108~122 cm\n* 색상 : 딥그린\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- T50은 이러한 인간공학적인 관점에서 허리를가장 이상적으로 지지하며, 동시에 가장\n자연스럽고 아름다운 모습을 가지기 위해 S-Curve 형태를 모티브로 개발 되었습니다\n- 과학적으로 설계된 T50의 많은 기능은 당신의 중요한 목과 허리를 든든하게 지지할 뿐만 아니라 키와 체형에 따라 손쉽게 각부분을 최적으로 맞춤화하여 사용하도록 지원합니다\n-T50 의자는 저가 메쉬 의자들과는 차원이 다른 고품질 폴리에스테르 메쉬부터 스트라이프 메쉬, 더블 라셀 메쉬까지 다양한 고급 메쉬 소재를 적용하여 편안함과 쾌적함을 동시에 제공합니다\n- T500HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T50WhiteMesh.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2278",
    brand: "SIDIZ",
    sku: "SIFURSIKR0313",
    product_eng:
      "Siddies T52 T500HLDA Air Mesh Chair White Shell TXB520HLDA (Gray)",
    product_jpn:
      "[시디즈] T52 T500HLDA 에어 메쉬 의자 화이트쉘 [TXB520HLDA](그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "399,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.0×52.5×108–122 cm\n* Color: Gray\n* Material: mesh, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- AirSkin Mesh uses Hytrel® raw materials from DuPont, the world's leading chemical company\nIt is made of strong elastic yarn, so it is very stretchable and elastic.\n- The T50 AIR stall is designed to be open-frame to keep thighs out of touch. The elasticity and elasticity of the air skin mesh meets the stall structure of the open-frame to evenly distribute body pressure\nYou can feel comfortable and comfortable in various positions, such as tilting forward or leaning against your back\n- Multi-sink is applied to the T50 AIR series to adjust the tilting strength in detailed steps tailored to the user, and adjust the lumber support, headrest, and armrest to fit the user's body\nYou can use it comfortably",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.0*52.5*108~122 cm  \n* 색상 : 그레이\n* 소재 : 메쉬, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 에어스킨 메쉬는 세계 최고 화학 전문 기업인 미국 듀폰사의 Hytrel® 원료를 이용한 \n강력 탄성사로 구성되어, 신축성과 탄력성이 매우 뛰어납니다.\n- T50 AIR 좌판은 허벅지가 닿지 않도록 오픈 프레임으로 설계되었습니다. 신축성과 탄력성이 뛰어난 에어스킨 메쉬와 오픈프레임의 좌판 구조가 만나, 체압을 고르게 분산시켜주어 \n앞으로 기울이거나, 등에 기대는 등 다양한 자세에서 쾌적함과 편안함을 느낄 수 있습니다\n- T50 AIR 시리즈에는 멀티 싱크가 적용되어, 사용자에게 맞추어 세밀한 단계로 틸팅 강도 조절이 가능하며, 럼버서포트, 헤드레스트, 팔걸이등을 사용자의 몸에 맞도록 조절하여\n편안하게 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T52WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2279",
    brand: "SIDIZ",
    sku: "SIFURSIKR0314",
    product_eng:
      "Siddies T52 T500HLDA Air Mesh Chair White Shell TXB520HLDA (Black)",
    product_jpn:
      "[시디즈] T52 T500HLDA 에어 메쉬 의자 화이트쉘 [TXB520HLDA](블랙)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "399,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.0×52.5×108–122 cm\n* Color: Black\n* Material: mesh, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- AirSkin Mesh uses Hytrel® raw materials from DuPont, the world's leading chemical company\nIt is made of strong elastic yarn, so it is very stretchable and elastic.\n- The T50 AIR stall is designed to be open-frame to keep thighs out of touch. The elasticity and elasticity of the air skin mesh meets the stall structure of the open-frame to evenly distribute body pressure\nYou can feel comfortable and comfortable in various positions, such as tilting forward or leaning against your back\n- Multi-sink is applied to the T50 AIR series to adjust the tilting strength in detailed steps tailored to the user, and adjust the lumber support, headrest, and armrest to fit the user's body\nYou can use it comfortably",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.0*52.5*108~122 cm  \n* 색상 : 블랙\n* 소재 : 메쉬, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 에어스킨 메쉬는 세계 최고 화학 전문 기업인 미국 듀폰사의 Hytrel® 원료를 이용한 \n강력 탄성사로 구성되어, 신축성과 탄력성이 매우 뛰어납니다.\n- T50 AIR 좌판은 허벅지가 닿지 않도록 오픈 프레임으로 설계되었습니다. 신축성과 탄력성이 뛰어난 에어스킨 메쉬와 오픈프레임의 좌판 구조가 만나, 체압을 고르게 분산시켜주어 \n앞으로 기울이거나, 등에 기대는 등 다양한 자세에서 쾌적함과 편안함을 느낄 수 있습니다\n- T50 AIR 시리즈에는 멀티 싱크가 적용되어, 사용자에게 맞추어 세밀한 단계로 틸팅 강도 조절이 가능하며, 럼버서포트, 헤드레스트, 팔걸이등을 사용자의 몸에 맞도록 조절하여\n편안하게 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T52WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2280",
    brand: "SIDIZ",
    sku: "SIFURSIKR0315",
    product_eng:
      "Siddies T52 T500HLDA Air Mesh Chair White Shell TXB520HLDA (Red)",
    product_jpn:
      "[시디즈] T52 T500HLDA 에어 메쉬 의자 화이트쉘 [TXB520HLDA](레드)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "399,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.0×52.5×108–122 cm\n* Color: Red\n* Material: mesh, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- AirSkin Mesh uses Hytrel® raw materials from DuPont, the world's leading chemical company\nIt is made of strong elastic yarn, so it is very stretchable and elastic.\n- The T50 AIR stall is designed to be open-frame to keep thighs out of touch. The elasticity and elasticity of the air skin mesh meets the stall structure of the open-frame to evenly distribute body pressure\nYou can feel comfortable and comfortable in various positions, such as tilting forward or leaning against your back\n- Multi-sink is applied to the T50 AIR series to adjust the tilting strength in detailed steps tailored to the user, and adjust the lumber support, headrest, and armrest to fit the user's body\nYou can use it comfortably",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.0*52.5*108~122 cm  \n* 색상 : 빨간색\n* 소재 : 메쉬, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 에어스킨 메쉬는 세계 최고 화학 전문 기업인 미국 듀폰사의 Hytrel® 원료를 이용한 \n강력 탄성사로 구성되어, 신축성과 탄력성이 매우 뛰어납니다.\n- T50 AIR 좌판은 허벅지가 닿지 않도록 오픈 프레임으로 설계되었습니다. 신축성과 탄력성이 뛰어난 에어스킨 메쉬와 오픈프레임의 좌판 구조가 만나, 체압을 고르게 분산시켜주어 \n앞으로 기울이거나, 등에 기대는 등 다양한 자세에서 쾌적함과 편안함을 느낄 수 있습니다\n- T50 AIR 시리즈에는 멀티 싱크가 적용되어, 사용자에게 맞추어 세밀한 단계로 틸팅 강도 조절이 가능하며, 럼버서포트, 헤드레스트, 팔걸이등을 사용자의 몸에 맞도록 조절하여\n편안하게 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T52WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2281",
    brand: "SIDIZ",
    sku: "SIFURSIKR0316",
    product_eng:
      "Siddies T52 T500HLDA Air Mesh Chair White Shell TXB520HLDA  (Blue)",
    product_jpn:
      "[시디즈] T52 T500HLDA 에어 메쉬 의자 화이트쉘 [TXB520HLDA](블루)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "399,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 67.0×52.5×108–122 cm\n* Color: Blue\n* Material: mesh, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n- AirSkin Mesh uses Hytrel® raw materials from DuPont, the world's leading chemical company\nIt is made of strong elastic yarn, so it is very stretchable and elastic.\n- The T50 AIR stall is designed to be open-frame to keep thighs out of touch. The elasticity and elasticity of the air skin mesh meets the stall structure of the open-frame to evenly distribute body pressure\nYou can feel comfortable and comfortable in various positions, such as tilting forward or leaning against your back\n- Multi-sink is applied to the T50 AIR series to adjust the tilting strength in detailed steps tailored to the user, and adjust the lumber support, headrest, and armrest to fit the user's body\nYou can use it comfortably",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 67.0*52.5*108~122 cm  \n* 색상 : 블루\n* 소재 : 메쉬, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n- 에어스킨 메쉬는 세계 최고 화학 전문 기업인 미국 듀폰사의 Hytrel® 원료를 이용한 \n강력 탄성사로 구성되어, 신축성과 탄력성이 매우 뛰어납니다.\n- T50 AIR 좌판은 허벅지가 닿지 않도록 오픈 프레임으로 설계되었습니다. 신축성과 탄력성이 뛰어난 에어스킨 메쉬와 오픈프레임의 좌판 구조가 만나, 체압을 고르게 분산시켜주어 \n앞으로 기울이거나, 등에 기대는 등 다양한 자세에서 쾌적함과 편안함을 느낄 수 있습니다\n- T50 AIR 시리즈에는 멀티 싱크가 적용되어, 사용자에게 맞추어 세밀한 단계로 틸팅 강도 조절이 가능하며, 럼버서포트, 헤드레스트, 팔걸이등을 사용자의 몸에 맞도록 조절하여\n편안하게 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T52WhiteChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2282",
    brand: "SIDIZ",
    sku: "SIFURDIKR0317",
    product_eng: "Display T55 Series T550HLDA Double Lascelled Chair (Red)",
    product_jpn: "[시디즈] T55 시리즈 T550HLDA 더블라셀 의자(레드)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "399,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 65.5×59.3×113.5 cm\n* Color: Double Racer-Red\n* Material: Double lacquer, foam sponge, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n-Synchronized tilt and ergonomically designed adjustable neckrests, armrests and stalls that respond to the user's posture and body type with delicate adjustments according to the back and weight change to shape and size just for you with simple manipulation\n- For the first time in the world, it is equipped with an automatic lumbar support that moves on its own depending on the user's posture and body shape and supports the waist in an S-shape.\n-Double lasel is one of the evolved mesh materials used in hiking clothes and marathon shoes. It is breathable, comfortable, and helps blood circulation, as well as being durable, providing a higher level of elasticity for a long time\n-The T550HLDA double lasel is designed to make it easy to replace the seat at home, so the chair can always be used as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 65.5*59.3*113.5 cm  \n* 색상 : 더블경주자-레드\n* 소재 : 더블라래커,발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n-사용자의 자세와 체형에 따라 스스로 반응하며 움직이는 등판과 몸무게에 따라 섬세한 조절이 가능한 싱크로나이즈드 틸트와 인체공학적으로 설계된 조절형 목받침과 팔걸이, 좌판은 간단한 조작만으로도 당신만을 위한 형태와 크기로 변화합니다\n- 세계 최초로 사용자의 자세와 체형에 따라 등판이 스스로 움직이며 허리를 S자 형태로 받쳐주는 오토매틱 요추지지대가 장착되어 있습니다.\n-더블라셀은 진화된 메쉬 소재 중 하나로 등산복, 마라톤화 등에 사용되는 고 기능성 소재 입니다. 통기성이 좋아 땀이 차지 않고 쾌적하며 혈액 순환에 도움이 되는 것은 물론, 내구성이 강화되어 더 높은 수준의 탄성을 오랫동안 변함없이 제공합니다\n-T550HLDA 더블라셀은 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T55DoubleChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2283",
    brand: "SIDIZ",
    sku: "SIFURDIKR0318",
    product_eng: "Display T55 Series T550HLDA Double Lascelled Chair (Blue)",
    product_jpn: "[시디즈] T55 시리즈 T550HLDA 더블라셀 의자(블루)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "399,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 65.5×59.3×113.5 cm\n* Color: Double Racer-Blue\n* Material: Double lacquer, foam sponge, PP, nylon, plastic, STEEL\n\n* It will be shipped within 7 to 10 days from the date of order by production immediately.\n\n-Synchronized tilt and ergonomically designed adjustable neckrests, armrests and stalls that respond to the user's posture and body type with delicate adjustments according to the back and weight change to shape and size just for you with simple manipulation\n- For the first time in the world, it is equipped with an automatic lumbar support that moves on its own depending on the user's posture and body shape and supports the waist in an S-shape.\n-Double lasel is one of the evolved mesh materials used in hiking clothes and marathon shoes. It is breathable, comfortable, and helps blood circulation, as well as being durable, providing a higher level of elasticity for a long time\n-The T550HLDA double lasel is designed to make it easy to replace the seat at home, so the chair can always be used as new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 65.5*59.3*113.5 cm  \n* 색상 : 더블경주자-블루\n* 소재 : 더블라래커,발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 7일~10 이내 출고됩니다.\n\n-사용자의 자세와 체형에 따라 스스로 반응하며 움직이는 등판과 몸무게에 따라 섬세한 조절이 가능한 싱크로나이즈드 틸트와 인체공학적으로 설계된 조절형 목받침과 팔걸이, 좌판은 간단한 조작만으로도 당신만을 위한 형태와 크기로 변화합니다\n- 세계 최초로 사용자의 자세와 체형에 따라 등판이 스스로 움직이며 허리를 S자 형태로 받쳐주는 오토매틱 요추지지대가 장착되어 있습니다.\n-더블라셀은 진화된 메쉬 소재 중 하나로 등산복, 마라톤화 등에 사용되는 고 기능성 소재 입니다. 통기성이 좋아 땀이 차지 않고 쾌적하며 혈액 순환에 도움이 되는 것은 물론, 내구성이 강화되어 더 높은 수준의 탄성을 오랫동안 변함없이 제공합니다\n-T550HLDA 더블라셀은 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T55DoubleChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2284",
    brand: "SIDIZ",
    sku: "SIFURDIKR0319",
    product_eng: "Display T80 Series T800HLDA Mesh Chair (Gray)",
    product_jpn: "[시디즈] T80 시리즈 T800HLDA 메쉬의자(그레이)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "739,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 73.5×58.0×115.0 cm\n* Color: Gray\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within up to D+10 days from the date of order by immediate production.\n\n- Refined design lines, luxurious materials that match them, and elaborate details add dignity to the time spent sitting down\n- The 'Ultimate Sync' mechanism, which fits the body from any angle, optimizes the movement of the chair so that it can maintain a tight fit from any angle when the backrest is tilted. The T80 is the only way to achieve the optimum level of comfort that has been proven through six years of research\n- For a more comfortable smart life, the T80 series of armrests are designed around the back\n- The longer you sit in the chair, the easier it is to become contaminated. The T800HLDA is designed to make it easy to replace stalls at home, so you can always use your chair for as long as it's new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 73.5 * 58.0 * 115.0cm\n* 색상 : 그레이\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 최대 D+10일 이내 출고됩니다. \n\n- 정제된 디자인 라인과 그에 어울리는 고급스러운 소재, 정교한 디테일로 앉아서 보내는 시간 위에 품격을 더합니다\n- 어느 각도에서도 몸에 꼭 맞는 'Ultimate Sync' 매커니즘은 등판을 뒤로 젖히는 어느 각도에서도 의자가 몸에 꼭 맞는 형상을 유지할 수 있도록 의자의 움직임을 신체동작에 최적화 하였습니다. 6년간의 연구를 통해 검증된 최적의 편안함은 오직 T80을 통해서만 경험하실 수 있습니다\n- 더 편안한 스마트 라이프를 즐길 수 있도록 T80 시리즈의 팔걸이는 등판을 중심으로 설계되었습니다\n- 의자에 오래 앉을수록 오염되기 쉽습니다. T800HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T80MeshChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
  {
    id: "2285",
    brand: "SIDIZ",
    sku: "SIFURDIKR0320",
    product_eng: "Display T80 Series T800HLDA Mesh Chair (Golden Blue)",
    product_jpn: "[시디즈] T80 시리즈 T800HLDA 메쉬의자(골든블루)",
    category_1: "",
    category_2: "",
    rrp_ex_vat: "",
    rrp_with_vat: "739,000",
    description_eng:
      "* Configuration: Chair 1\n* Size: 73.5×58.0×115.0 cm\n* Color: Golden Blue\n* Material: Mesh, Fabric, Foam Sponge, PP, Nylon, Plastic, STEEL\n\n* It will be shipped within up to D+10 days from the date of order by immediate production.\n\n- Refined design lines, luxurious materials that match them, and elaborate details add dignity to the time spent sitting down\n- The 'Ultimate Sync' mechanism, which fits the body from any angle, optimizes the movement of the chair so that it can maintain a tight fit from any angle when the backrest is tilted. The T80 is the only way to achieve the optimum level of comfort that has been proven through six years of research\n- For a more comfortable smart life, the T80 series of armrests are designed around the back\n- The longer you sit in the chair, the easier it is to become contaminated. The T800HLDA is designed to make it easy to replace stalls at home, so you can always use your chair for as long as it's new",
    description_jpn:
      "* 구성 : 의자 1\n* 사이즈 : 73.5 * 58.0 * 115.0cm\n* 색상 : 골든블루\n* 소재 : 메쉬, 패브릭, 발포스폰지, PP, 나일론, 플라스틱, STEEL\n\n* 주문즉시생산으로 주문일로부터 최대 D+10일 이내 출고됩니다. \n\n- 정제된 디자인 라인과 그에 어울리는 고급스러운 소재, 정교한 디테일로 앉아서 보내는 시간 위에 품격을 더합니다\n- 어느 각도에서도 몸에 꼭 맞는 'Ultimate Sync' 매커니즘은 등판을 뒤로 젖히는 어느 각도에서도 의자가 몸에 꼭 맞는 형상을 유지할 수 있도록 의자의 움직임을 신체동작에 최적화 하였습니다. 6년간의 연구를 통해 검증된 최적의 편안함은 오직 T80을 통해서만 경험하실 수 있습니다\n- 더 편안한 스마트 라이프를 즐길 수 있도록 T80 시리즈의 팔걸이는 등판을 중심으로 설계되었습니다\n- 의자에 오래 앉을수록 오염되기 쉽습니다. T800HLDA는 가정에서도 좌판을 손쉽게 교체가 가능하도록 설계하여 의자를 늘 새것처럼 오래 사용할 수 있습니다",
    product_image_1:
      "https://products.naganorewards.com/KR/SIDIZ/T80MeshChair.jpeg",
    product_image_2: "",
    product_image_3: "",
    product_image_4: "",
    logo_image: "",
  },
];
